//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { COOKIE_NAME } from './constants';
import { BASE_URL } from './baseUrl';
import { getCookie } from './utils/cookieHelper';
export class AuthClient {
  constructor(private accessToken?: string) {}

  transformHttpRequestOptions(options: RequestInit): Promise<RequestInit> {
    // @ts-ignore
    let delegateToken = window.store?.getState().currentUserState?.data?.delegateJWT;
    this.accessToken = delegateToken ?? getCookie(COOKIE_NAME);
    if (this.accessToken) {
      if (!options.headers) {
        options.headers = {};
      }
      options.headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return Promise.resolve(options);
  }
}

export class OutpostHealthClientBase {
  constructor(private authClient: AuthClient) {}

  transformOptions(options: RequestInit): Promise<RequestInit> {
    return this.authClient
      ? this.authClient.transformHttpRequestOptions(options)
      : Promise.resolve(options);
  }

  getBaseUrl(_, customUrl): string {
    return customUrl ? customUrl : BASE_URL;
  }
}

export class AddressBooksClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all address books.
     * @param countryID The country identifier.
     */
    global(countryID: string): Promise<AddressBook[]> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/global/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGlobal(_response);
        });
    }

    protected processGlobal(response: Response): Promise<AddressBook[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressBook.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBook[]>(null as any);
    }

    /**
     * Gets all address books admin.
     * @param countryID The country identifier.
     */
    adminglobal(countryID: string): Promise<AddressBook[]> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/adminglobal/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminglobal(_response);
        });
    }

    protected processAdminglobal(response: Response): Promise<AddressBook[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressBook.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBook[]>(null as any);
    }

    /**
     * Gets the private address books.
     */
    private(): Promise<AddressBook[]> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/private";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPrivate(_response);
        });
    }

    protected processPrivate(response: Response): Promise<AddressBook[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressBook.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBook[]>(null as any);
    }

    /**
     * Gets the private address books.
     */
    addressBooksGet(addressBookID: string): Promise<AddressBook> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{addressBookID}";
        if (addressBookID === undefined || addressBookID === null)
            throw new Error("The parameter 'addressBookID' must be defined.");
        url_ = url_.replace("{addressBookID}", encodeURIComponent("" + addressBookID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressBooksGet(_response);
        });
    }

    protected processAddressBooksGet(response: Response): Promise<AddressBook> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressBook.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBook>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param addressBookID The identifier.
     */
    addressBooksDelete(addressBookID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{addressBookID}";
        if (addressBookID === undefined || addressBookID === null)
            throw new Error("The parameter 'addressBookID' must be defined.");
        url_ = url_.replace("{addressBookID}", encodeURIComponent("" + addressBookID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressBooksDelete(_response);
        });
    }

    protected processAddressBooksDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified AddressBook.
     * @param addressBook The AddressBook.
     */
    addressBooksPost(addressBook: AddressBook): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addressBook);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressBooksPost(_response);
        });
    }

    protected processAddressBooksPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified AddressBook.
     * @param addressBook The AddressBook.
     */
    addressBooksPut(addressBook: AddressBook): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addressBook);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressBooksPut(_response);
        });
    }

    protected processAddressBooksPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified AddressBookTag.
     */
    addressBookTagsPost(addressBookTag: AddressBookTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/AddressBookTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addressBookTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressBookTagsPost(_response);
        });
    }

    protected processAddressBookTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified AddressBookTag.
     * @param addressBookTag The AddressBookTag.
     */
    addressBookTagsPut(addressBookTag: AddressBookTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/AddressBookTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addressBookTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressBookTagsPut(_response);
        });
    }

    protected processAddressBookTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified AddressBookTags - Will delete all associated tags and re-add them.
     */
    many(addressBookID: string, addressBookTags: AddressBookTag[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/AddressBookTags/{addressBookID}/Many";
        if (addressBookID === undefined || addressBookID === null)
            throw new Error("The parameter 'addressBookID' must be defined.");
        url_ = url_.replace("{addressBookID}", encodeURIComponent("" + addressBookID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addressBookTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param addressBookTagID The identifier.
     */
    addressBookTagsDelete(addressBookTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/AddressBookTags/{addressBookTagID}";
        if (addressBookTagID === undefined || addressBookTagID === null)
            throw new Error("The parameter 'addressBookTagID' must be defined.");
        url_ = url_.replace("{addressBookTagID}", encodeURIComponent("" + addressBookTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressBookTagsDelete(_response);
        });
    }

    protected processAddressBookTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set the AddressBookTag as a primary tag
     */
    setPrimary(addressBookID: string, addressBookTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{addressBookID}/AddressBookTags/{addressBookTagID}/SetPrimary";
        if (addressBookID === undefined || addressBookID === null)
            throw new Error("The parameter 'addressBookID' must be defined.");
        url_ = url_.replace("{addressBookID}", encodeURIComponent("" + addressBookID));
        if (addressBookTagID === undefined || addressBookTagID === null)
            throw new Error("The parameter 'addressBookTagID' must be defined.");
        url_ = url_.replace("{addressBookTagID}", encodeURIComponent("" + addressBookTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSetPrimary(_response);
        });
    }

    protected processSetPrimary(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    favoriteAddressBookPost(userDetailID: string, associateIDOrAddressBookID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{userDetailID}/FavoriteAddressBook/{associateIDOrAddressBookID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (associateIDOrAddressBookID === undefined || associateIDOrAddressBookID === null)
            throw new Error("The parameter 'associateIDOrAddressBookID' must be defined.");
        url_ = url_.replace("{associateIDOrAddressBookID}", encodeURIComponent("" + associateIDOrAddressBookID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteAddressBookPost(_response);
        });
    }

    protected processFavoriteAddressBookPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    favoriteAddressBookDelete(userDetailID: string, associateIDOrAddressBookID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{userDetailID}/FavoriteAddressBook/{associateIDOrAddressBookID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (associateIDOrAddressBookID === undefined || associateIDOrAddressBookID === null)
            throw new Error("The parameter 'associateIDOrAddressBookID' must be defined.");
        url_ = url_.replace("{associateIDOrAddressBookID}", encodeURIComponent("" + associateIDOrAddressBookID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteAddressBookDelete(_response);
        });
    }

    protected processFavoriteAddressBookDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set the Favorite Address book detail by including FavoriteTypeEnum
     */
    favoriteAddressBookDetail(userDetailID: string, addressBookFavoriteDetail: AddressBookFavoriteDetail): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{userDetailID}/FavoriteAddressBookDetail";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addressBookFavoriteDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteAddressBookDetail(_response);
        });
    }

    protected processFavoriteAddressBookDetail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the list of FavoriteAddressBook entries that I own that are status of invited
     */
    myFavoriteAddressBookInvites(userDetailID: string): Promise<AddressBookFavorite[]> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{userDetailID}/MyFavoriteAddressBookInvites";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyFavoriteAddressBookInvites(_response);
        });
    }

    protected processMyFavoriteAddressBookInvites(response: Response): Promise<AddressBookFavorite[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressBookFavorite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBookFavorite[]>(null as any);
    }

    /**
     * Get the list of AddressBookInvites to which I have been invited
     */
    favoriteAddressBookInvites(userDetailID: string): Promise<AddressBookFavorite[]> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{userDetailID}/FavoriteAddressBookInvites";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteAddressBookInvites(_response);
        });
    }

    protected processFavoriteAddressBookInvites(response: Response): Promise<AddressBookFavorite[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressBookFavorite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBookFavorite[]>(null as any);
    }

    /**
     * Accept the AddressbookFavoriteInvite
     */
    favoriteAddressBookAcceptInvite(addressBookFavoriteID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{addressBookFavoriteID}/FavoriteAddressBookAcceptInvite";
        if (addressBookFavoriteID === undefined || addressBookFavoriteID === null)
            throw new Error("The parameter 'addressBookFavoriteID' must be defined.");
        url_ = url_.replace("{addressBookFavoriteID}", encodeURIComponent("" + addressBookFavoriteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteAddressBookAcceptInvite(_response);
        });
    }

    protected processFavoriteAddressBookAcceptInvite(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Decline the AddressbookFavoriteInvite
     */
    favoriteAddressBookAcceptDecline(addressBookFavoriteID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/{addressBookFavoriteID}/FavoriteAddressBookAcceptDecline";
        if (addressBookFavoriteID === undefined || addressBookFavoriteID === null)
            throw new Error("The parameter 'addressBookFavoriteID' must be defined.");
        url_ = url_.replace("{addressBookFavoriteID}", encodeURIComponent("" + addressBookFavoriteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteAddressBookAcceptDecline(_response);
        });
    }

    protected processFavoriteAddressBookAcceptDecline(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Search the address book
     */
    search(addressBookSearchDetails: AddressBookSearchDetails): Promise<PagedResultOfAddressBook> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addressBookSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfAddressBook> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfAddressBook.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfAddressBook>(null as any);
    }

    /**
     * Get an address book entry by associatedID
     */
    byAssociatedID(associatedID: string): Promise<AddressBook> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/ByAssociatedID/{associatedID}";
        if (associatedID === undefined || associatedID === null)
            throw new Error("The parameter 'associatedID' must be defined.");
        url_ = url_.replace("{associatedID}", encodeURIComponent("" + associatedID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByAssociatedID(_response);
        });
    }

    protected processByAssociatedID(response: Response): Promise<AddressBook> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressBook.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBook>(null as any);
    }

    /**
     * Suggest an address book entry
     */
    suggestedAddressBook(addressBook: AddressBook): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/SuggestedAddressBook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addressBook);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSuggestedAddressBook(_response);
        });
    }

    protected processSuggestedAddressBook(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get suggested address book entries
     */
    suggestedAddressBookEntries(): Promise<AddressBook[]> {
        let url_ = this.baseUrl + "/api/v1/AddressBooks/SuggestedAddressBookEntries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSuggestedAddressBookEntries(_response);
        });
    }

    protected processSuggestedAddressBookEntries(response: Response): Promise<AddressBook[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AddressBook.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBook[]>(null as any);
    }
}

export class AffiliateInvoicesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all AffiliateInvoices.
     */
    adminByAffiliateID(affiliateID: string): Promise<AffiliateInvoice[]> {
        let url_ = this.baseUrl + "/api/v1/AffiliateInvoices/AdminByAffiliateID/{affiliateID}";
        if (affiliateID === undefined || affiliateID === null)
            throw new Error("The parameter 'affiliateID' must be defined.");
        url_ = url_.replace("{affiliateID}", encodeURIComponent("" + affiliateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByAffiliateID(_response);
        });
    }

    protected processAdminByAffiliateID(response: Response): Promise<AffiliateInvoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AffiliateInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AffiliateInvoice[]>(null as any);
    }

    /**
     * Posts the specified AffiliateInvoice.
     * @param affiliateInvoice The AffiliateInvoice.
     */
    affiliateInvoicesPost(affiliateInvoice: AffiliateInvoice): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AffiliateInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(affiliateInvoice);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAffiliateInvoicesPost(_response);
        });
    }

    protected processAffiliateInvoicesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified AffiliateInvoice.
     * @param affiliateInvoice The AffiliateInvoice.
     */
    affiliateInvoicesPut(affiliateInvoice: AffiliateInvoice): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AffiliateInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(affiliateInvoice);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAffiliateInvoicesPut(_response);
        });
    }

    protected processAffiliateInvoicesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param affiliateInvoiceID The identifier.
     */
    affiliateInvoicesDelete(affiliateInvoiceID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AffiliateInvoices/{AffiliateInvoiceID}";
        if (affiliateInvoiceID === undefined || affiliateInvoiceID === null)
            throw new Error("The parameter 'affiliateInvoiceID' must be defined.");
        url_ = url_.replace("{affiliateInvoiceID}", encodeURIComponent("" + affiliateInvoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAffiliateInvoicesDelete(_response);
        });
    }

    protected processAffiliateInvoicesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AffiliatesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all Affiliates.
     */
    admin(): Promise<Affiliate[]> {
        let url_ = this.baseUrl + "/api/v1/Affiliates/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Affiliate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Affiliate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Affiliate[]>(null as any);
    }

    /**
     * Posts the specified Affiliate.
     * @param affiliate The Affiliate.
     */
    affiliatesPost(affiliate: Affiliate): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Affiliates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(affiliate);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAffiliatesPost(_response);
        });
    }

    protected processAffiliatesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Affiliate.
     * @param affiliate The Affiliate.
     */
    affiliatesPut(affiliate: Affiliate): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Affiliates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(affiliate);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAffiliatesPut(_response);
        });
    }

    protected processAffiliatesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param affiliateID The identifier.
     */
    affiliatesDelete(affiliateID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Affiliates/{affiliateID}";
        if (affiliateID === undefined || affiliateID === null)
            throw new Error("The parameter 'affiliateID' must be defined.");
        url_ = url_.replace("{affiliateID}", encodeURIComponent("" + affiliateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAffiliatesDelete(_response);
        });
    }

    protected processAffiliatesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search for affiliates
     */
    search(affiliateSearchDetails: AffiliateSearchDetails): Promise<Affiliate[]> {
        let url_ = this.baseUrl + "/api/v1/Affiliates/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(affiliateSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Affiliate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Affiliate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Affiliate[]>(null as any);
    }

    /**
     * Get Affiliate Invoices
     */
    invoices(affiliateID: string): Promise<Affiliate> {
        let url_ = this.baseUrl + "/api/v1/Affiliates/{affiliateID}/Invoices";
        if (affiliateID === undefined || affiliateID === null)
            throw new Error("The parameter 'affiliateID' must be defined.");
        url_ = url_.replace("{affiliateID}", encodeURIComponent("" + affiliateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoices(_response);
        });
    }

    protected processInvoices(response: Response): Promise<Affiliate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Affiliate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Affiliate>(null as any);
    }

    /**
     * Return Active Affiliates
     */
    active(): Promise<Affiliate[]> {
        let url_ = this.baseUrl + "/api/v1/Affiliates/Active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processActive(_response);
        });
    }

    protected processActive(response: Response): Promise<Affiliate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Affiliate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Affiliate[]>(null as any);
    }
}

export class ApiSettingsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    admin(): Promise<ApiSetting[]> {
        let url_ = this.baseUrl + "/api/v1/ApiSettings/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<ApiSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiSetting[]>(null as any);
    }

    /**
     * Gets all.
     */
    all(): Promise<ApiSetting[]> {
        let url_ = this.baseUrl + "/api/v1/ApiSettings/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ApiSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiSetting[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param apiSettingID The identifier.
     */
    apiSettingsGet(apiSettingID: string): Promise<ApiSetting> {
        let url_ = this.baseUrl + "/api/v1/ApiSettings/{ApiSettingID}";
        if (apiSettingID === undefined || apiSettingID === null)
            throw new Error("The parameter 'apiSettingID' must be defined.");
        url_ = url_.replace("{ApiSettingID}", encodeURIComponent("" + apiSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApiSettingsGet(_response);
        });
    }

    protected processApiSettingsGet(response: Response): Promise<ApiSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiSetting>(null as any);
    }

    /**
     * Posts the specified ApiSetting.
     * @param apiSetting The ApiSetting.
     */
    apiSettingsPost(apiSetting: ApiSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ApiSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApiSettingsPost(_response);
        });
    }

    protected processApiSettingsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ApiSetting.
     * @param apiSetting The ApiSetting.
     */
    apiSettingsPut(apiSetting: ApiSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ApiSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApiSettingsPut(_response);
        });
    }

    protected processApiSettingsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete the specified ApiSetting.
     * @param apiSettingID (optional) The API setting identifier.
     */
    apiSettingsDelete(apiSettingID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ApiSettings?";
        if (apiSettingID === null)
            throw new Error("The parameter 'apiSettingID' cannot be null.");
        else if (apiSettingID !== undefined)
            url_ += "apiSettingID=" + encodeURIComponent("" + apiSettingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApiSettingsDelete(_response);
        });
    }

    protected processApiSettingsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Pings this instance.
     */
    ping(): Promise<ApiPingResult[]> {
        let url_ = this.baseUrl + "/api/v1/ApiSettings/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<ApiPingResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiPingResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiPingResult[]>(null as any);
    }
}

export class AppFeaturesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    admin(): Promise<AppFeature[]> {
        let url_ = this.baseUrl + "/api/v1/AppFeatures/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<AppFeature[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFeature.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFeature[]>(null as any);
    }

    /**
     * Gets all.
     */
    all(): Promise<AppFeature[]> {
        let url_ = this.baseUrl + "/api/v1/AppFeatures/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<AppFeature[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppFeature.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFeature[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param appFeatureID The identifier.
     */
    appFeaturesGet(appFeatureID: string): Promise<AppFeature> {
        let url_ = this.baseUrl + "/api/v1/AppFeatures/{appFeatureID}";
        if (appFeatureID === undefined || appFeatureID === null)
            throw new Error("The parameter 'appFeatureID' must be defined.");
        url_ = url_.replace("{appFeatureID}", encodeURIComponent("" + appFeatureID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAppFeaturesGet(_response);
        });
    }

    protected processAppFeaturesGet(response: Response): Promise<AppFeature> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppFeature.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppFeature>(null as any);
    }

    /**
     * Posts the specified AppFeature.
     * @param appFeature The AppFeature.
     */
    appFeaturesPost(appFeature: AppFeature): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AppFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appFeature);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAppFeaturesPost(_response);
        });
    }

    protected processAppFeaturesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified AppFeature.
     * @param appFeature The AppFeature.
     */
    appFeaturesPut(appFeature: AppFeature): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/AppFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appFeature);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAppFeaturesPut(_response);
        });
    }

    protected processAppFeaturesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete the specified AppFeature.
     * @param appFeatureID (optional) The application feature identifier.
     */
    appFeaturesDelete(appFeatureID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/AppFeatures?";
        if (appFeatureID === null)
            throw new Error("The parameter 'appFeatureID' cannot be null.");
        else if (appFeatureID !== undefined)
            url_ += "AppFeatureID=" + encodeURIComponent("" + appFeatureID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAppFeaturesDelete(_response);
        });
    }

    protected processAppFeaturesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Puts the specified AppFeature.
     * @param appFeatures The AppFeatures.
     */
    appFeaturesPutMany(appFeatures: AppFeature[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/AppFeatures/AppFeaturesPutMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appFeatures);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAppFeaturesPutMany(_response);
        });
    }

    protected processAppFeaturesPutMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class AuditsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    audits(tableName: string, primaryKey: string): Promise<Audit[]> {
        let url_ = this.baseUrl + "/api/v1/Audits/{tableName}/{primaryKey}";
        if (tableName === undefined || tableName === null)
            throw new Error("The parameter 'tableName' must be defined.");
        url_ = url_.replace("{tableName}", encodeURIComponent("" + tableName));
        if (primaryKey === undefined || primaryKey === null)
            throw new Error("The parameter 'primaryKey' must be defined.");
        url_ = url_.replace("{primaryKey}", encodeURIComponent("" + primaryKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAudits(_response);
        });
    }

    protected processAudits(response: Response): Promise<Audit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Audit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Audit[]>(null as any);
    }
}

export class BanksClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all banks.
     */
    all(): Promise<Bank[]> {
        let url_ = this.baseUrl + "/api/v1/Banks/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Bank[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Bank.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Bank[]>(null as any);
    }

    /**
     * Posts the specified Bank.
     * @param bank The bank.
     */
    banksPost(bank: Bank): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Banks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bank);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBanksPost(_response);
        });
    }

    protected processBanksPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Bank.
     * @param bank The bank.
     */
    banksPut(bank: Bank): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Banks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bank);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBanksPut(_response);
        });
    }

    protected processBanksPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param items The items.
     */
    many(items: Bank[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Banks/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param bankID The identifier.
     */
    banksDelete(bankID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Banks/{bankID}";
        if (bankID === undefined || bankID === null)
            throw new Error("The parameter 'bankID' must be defined.");
        url_ = url_.replace("{bankID}", encodeURIComponent("" + bankID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBanksDelete(_response);
        });
    }

    protected processBanksDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BlackListsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all BlackLists for admin
     */
    admin(): Promise<BlackList[]> {
        let url_ = this.baseUrl + "/api/v1/BlackLists/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<BlackList[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlackList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlackList[]>(null as any);
    }

    /**
     * Gets all BlackLists.
     */
    all(): Promise<BlackList[]> {
        let url_ = this.baseUrl + "/api/v1/BlackLists/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<BlackList[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlackList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlackList[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param blackListID The identifier.
     */
    blackListsGet(blackListID: string): Promise<BlackList> {
        let url_ = this.baseUrl + "/api/v1/BlackLists/{blackListID}";
        if (blackListID === undefined || blackListID === null)
            throw new Error("The parameter 'blackListID' must be defined.");
        url_ = url_.replace("{blackListID}", encodeURIComponent("" + blackListID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlackListsGet(_response);
        });
    }

    protected processBlackListsGet(response: Response): Promise<BlackList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlackList.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BlackList>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param blackListID The identifier.
     */
    blackListsDelete(blackListID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/BlackLists/{blackListID}";
        if (blackListID === undefined || blackListID === null)
            throw new Error("The parameter 'blackListID' must be defined.");
        url_ = url_.replace("{blackListID}", encodeURIComponent("" + blackListID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlackListsDelete(_response);
        });
    }

    protected processBlackListsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified BlackList.
     * @param blackList The BlackList.
     */
    blackListsPost(blackList: BlackList): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/BlackLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(blackList);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlackListsPost(_response);
        });
    }

    protected processBlackListsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified BlackList.
     * @param blackList The BlackList.
     */
    blackListsPut(blackList: BlackList): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/BlackLists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(blackList);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlackListsPut(_response);
        });
    }

    protected processBlackListsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CampaignsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get All
     */
    all(): Promise<Campaign[]> {
        let url_ = this.baseUrl + "/api/v1/Campaigns/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Campaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Campaign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Campaign[]>(null as any);
    }

    /**
     * Get the Campaign information
     */
    search(campaignName: string): Promise<Campaign> {
        let url_ = this.baseUrl + "/api/v1/Campaigns/Search/{campaignName}";
        if (campaignName === undefined || campaignName === null)
            throw new Error("The parameter 'campaignName' must be defined.");
        url_ = url_.replace("{campaignName}", encodeURIComponent("" + campaignName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Campaign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Campaign.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Campaign>(null as any);
    }

    /**
     * Get by Campaign ID
     */
    campaignsGet(campaignID: string): Promise<Campaign> {
        let url_ = this.baseUrl + "/api/v1/Campaigns/{campaignID}";
        if (campaignID === undefined || campaignID === null)
            throw new Error("The parameter 'campaignID' must be defined.");
        url_ = url_.replace("{campaignID}", encodeURIComponent("" + campaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignsGet(_response);
        });
    }

    protected processCampaignsGet(response: Response): Promise<Campaign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Campaign.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Campaign>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param campaignID The identifier.
     */
    campaignsDelete(campaignID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Campaigns/{campaignID}";
        if (campaignID === undefined || campaignID === null)
            throw new Error("The parameter 'campaignID' must be defined.");
        url_ = url_.replace("{campaignID}", encodeURIComponent("" + campaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignsDelete(_response);
        });
    }

    protected processCampaignsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Campaign.
     * @param campaign The Campaign.
     */
    campaignsPost(campaign: Campaign): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Campaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(campaign);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignsPost(_response);
        });
    }

    protected processCampaignsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Campaign.
     * @param campaign The Campaign.
     */
    campaignsPut(campaign: Campaign): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Campaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(campaign);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignsPut(_response);
        });
    }

    protected processCampaignsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CampaignSettingsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the by Campaign identifier.
     * @param campaignID The Campaign identifier.
     */
    byCampaignID(campaignID: string): Promise<CampaignSetting[]> {
        let url_ = this.baseUrl + "/api/v1/CampaignSettings/ByCampaignID/{campaignID}";
        if (campaignID === undefined || campaignID === null)
            throw new Error("The parameter 'campaignID' must be defined.");
        url_ = url_.replace("{campaignID}", encodeURIComponent("" + campaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCampaignID(_response);
        });
    }

    protected processByCampaignID(response: Response): Promise<CampaignSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CampaignSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignSetting[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param campaignSettingID The identifier.
     */
    campaignSettingsGet(campaignSettingID: string): Promise<CampaignSetting> {
        let url_ = this.baseUrl + "/api/v1/CampaignSettings/{campaignSettingID}";
        if (campaignSettingID === undefined || campaignSettingID === null)
            throw new Error("The parameter 'campaignSettingID' must be defined.");
        url_ = url_.replace("{campaignSettingID}", encodeURIComponent("" + campaignSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignSettingsGet(_response);
        });
    }

    protected processCampaignSettingsGet(response: Response): Promise<CampaignSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignSetting>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param campaignSettingID The identifier.
     */
    campaignSettingsDelete(campaignSettingID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/CampaignSettings/{campaignSettingID}";
        if (campaignSettingID === undefined || campaignSettingID === null)
            throw new Error("The parameter 'campaignSettingID' must be defined.");
        url_ = url_.replace("{campaignSettingID}", encodeURIComponent("" + campaignSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignSettingsDelete(_response);
        });
    }

    protected processCampaignSettingsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified CampaignSetting.
     * @param campaignSetting The CampaignSetting.
     */
    campaignSettingsPost(campaignSetting: CampaignSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CampaignSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(campaignSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignSettingsPost(_response);
        });
    }

    protected processCampaignSettingsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified CampaignSetting.
     * @param campaignSetting The CampaignSetting.
     */
    campaignSettingsPut(campaignSetting: CampaignSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CampaignSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(campaignSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignSettingsPut(_response);
        });
    }

    protected processCampaignSettingsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CareFundApplicationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get all Admin
     */
    admin(): Promise<CareFundApplication[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<CareFundApplication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundApplication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundApplication[]>(null as any);
    }

    /**
     * Get all by UserDetailID
     * @param userDetailID (optional) The CareFundApplication Creator UserDetailID.
     * @param careFundCategoryEnum (optional) The CareFundApplication Category Type.
     * @param careFundStatusEnum (optional) The CareFundApplication Status.
     */
    all(userDetailID?: string | undefined, careFundCategoryEnum?: CareFundCategoryEnum | null | undefined, careFundStatusEnum?: CareFundStatusEnum | null | undefined): Promise<CareFundApplication[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications/all?";
        if (userDetailID === null)
            throw new Error("The parameter 'userDetailID' cannot be null.");
        else if (userDetailID !== undefined)
            url_ += "userDetailID=" + encodeURIComponent("" + userDetailID) + "&";
        if (careFundCategoryEnum !== undefined && careFundCategoryEnum !== null)
            url_ += "careFundCategoryEnum=" + encodeURIComponent("" + careFundCategoryEnum) + "&";
        if (careFundStatusEnum !== undefined && careFundStatusEnum !== null)
            url_ += "careFundStatusEnum=" + encodeURIComponent("" + careFundStatusEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<CareFundApplication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundApplication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundApplication[]>(null as any);
    }

    /**
     * Get all by campaignID
     * @param careFundCampaignID (optional) The CareFund CampaignID.
     * @param careFundCategoryEnum (optional) The CareFundApplication Category Type.
     * @param careFundStatusEnum (optional) The CareFundApplication Status.
     */
    allByCareFundCampaignID(careFundCampaignID?: string | undefined, careFundCategoryEnum?: CareFundCategoryEnum | null | undefined, careFundStatusEnum?: CareFundStatusEnum | null | undefined): Promise<CareFundApplication[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications/allByCareFundCampaignID?";
        if (careFundCampaignID === null)
            throw new Error("The parameter 'careFundCampaignID' cannot be null.");
        else if (careFundCampaignID !== undefined)
            url_ += "careFundCampaignID=" + encodeURIComponent("" + careFundCampaignID) + "&";
        if (careFundCategoryEnum !== undefined && careFundCategoryEnum !== null)
            url_ += "careFundCategoryEnum=" + encodeURIComponent("" + careFundCategoryEnum) + "&";
        if (careFundStatusEnum !== undefined && careFundStatusEnum !== null)
            url_ += "careFundStatusEnum=" + encodeURIComponent("" + careFundStatusEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllByCareFundCampaignID(_response);
        });
    }

    protected processAllByCareFundCampaignID(response: Response): Promise<CareFundApplication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundApplication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundApplication[]>(null as any);
    }

    /**
     * Get by CareFundApplication ID
     */
    careFundApplicationsGet(careFundApplicationID: string): Promise<CareFundApplication> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications/{careFundApplicationID}";
        if (careFundApplicationID === undefined || careFundApplicationID === null)
            throw new Error("The parameter 'careFundApplicationID' must be defined.");
        url_ = url_.replace("{careFundApplicationID}", encodeURIComponent("" + careFundApplicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundApplicationsGet(_response);
        });
    }

    protected processCareFundApplicationsGet(response: Response): Promise<CareFundApplication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundApplication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundApplication>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param careFundApplicationID The identifier.
     */
    careFundApplicationsDelete(careFundApplicationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications/{careFundApplicationID}";
        if (careFundApplicationID === undefined || careFundApplicationID === null)
            throw new Error("The parameter 'careFundApplicationID' must be defined.");
        url_ = url_.replace("{careFundApplicationID}", encodeURIComponent("" + careFundApplicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundApplicationsDelete(_response);
        });
    }

    protected processCareFundApplicationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified CareFundApplication.
     * @param careFundApplication The CareFundApplication.
     */
    careFundApplicationsPost(careFundApplication: CareFundApplication): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundApplication);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundApplicationsPost(_response);
        });
    }

    protected processCareFundApplicationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified CareFundApplication.
     * @param careFundApplication The CareFundApplication.
     */
    careFundApplicationsPut(careFundApplication: CareFundApplication): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundApplication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundApplicationsPut(_response);
        });
    }

    protected processCareFundApplicationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the CareFund Application Status
     * @param careFundApplicationID (optional) 
     * @param careFundStatusEnum (optional) 
     */
    updateStatus(careFundApplicationID?: string | undefined, careFundStatusEnum?: CareFundStatusEnum | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications/updateStatus?";
        if (careFundApplicationID === null)
            throw new Error("The parameter 'careFundApplicationID' cannot be null.");
        else if (careFundApplicationID !== undefined)
            url_ += "careFundApplicationID=" + encodeURIComponent("" + careFundApplicationID) + "&";
        if (careFundStatusEnum === null)
            throw new Error("The parameter 'careFundStatusEnum' cannot be null.");
        else if (careFundStatusEnum !== undefined)
            url_ += "careFundStatusEnum=" + encodeURIComponent("" + careFundStatusEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Disburse Funds to the specified CareFundApplications
     */
    disburseBulkFunds(careFundCampaignID: string, careFundApplicationDisburseDTOs: CareFundApplicationDisburseDTO[]): Promise<CareFundApplicationDisburseResult> {
        let url_ = this.baseUrl + "/api/v1/CareFundApplications/disburseBulkFunds/{careFundCampaignID}";
        if (careFundCampaignID === undefined || careFundCampaignID === null)
            throw new Error("The parameter 'careFundCampaignID' must be defined.");
        url_ = url_.replace("{careFundCampaignID}", encodeURIComponent("" + careFundCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundApplicationDisburseDTOs);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDisburseBulkFunds(_response);
        });
    }

    protected processDisburseBulkFunds(response: Response): Promise<CareFundApplicationDisburseResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundApplicationDisburseResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundApplicationDisburseResult>(null as any);
    }
}

export class CareFundCampaignsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get All
     */
    admin(): Promise<CareFundCampaign[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<CareFundCampaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundCampaign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundCampaign[]>(null as any);
    }

    /**
     * Get all by UserDetailID
     * @param userDetailID (optional) The CareFundCampaign Creator UserDetailID.
     * @param careFundCampaignTypeEnum (optional) The CareFundCampaign Type.
     * @param careFundCampaignStatusEnum (optional) The CareFundCampaign Status.
     */
    all(userDetailID?: string | undefined, careFundCampaignTypeEnum?: CareFundCampaignTypeEnum | null | undefined, careFundCampaignStatusEnum?: CareFundStatusEnum | null | undefined): Promise<CareFundCampaign[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/all?";
        if (userDetailID === null)
            throw new Error("The parameter 'userDetailID' cannot be null.");
        else if (userDetailID !== undefined)
            url_ += "userDetailID=" + encodeURIComponent("" + userDetailID) + "&";
        if (careFundCampaignTypeEnum !== undefined && careFundCampaignTypeEnum !== null)
            url_ += "careFundCampaignTypeEnum=" + encodeURIComponent("" + careFundCampaignTypeEnum) + "&";
        if (careFundCampaignStatusEnum !== undefined && careFundCampaignStatusEnum !== null)
            url_ += "careFundCampaignStatusEnum=" + encodeURIComponent("" + careFundCampaignStatusEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<CareFundCampaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundCampaign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundCampaign[]>(null as any);
    }

    /**
     * Get All
     * @param searchQuery (optional) 
     * @param careFundCampaignCategory (optional) 
     * @param minAmount (optional) 
     * @param maxAmount (optional) 
     * @param pagedQuery_RecordsToSkip (optional) 
     * @param pagedQuery_RecordsToTake (optional) 
     */
    allPublic(searchQuery?: string | null | undefined, careFundCampaignCategory?: string | null | undefined, minAmount?: number | undefined, maxAmount?: number | undefined, pagedQuery_RecordsToSkip?: number | undefined, pagedQuery_RecordsToTake?: number | undefined): Promise<PagedResultOfCareFundCampaign> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/allPublic?";
        if (searchQuery !== undefined && searchQuery !== null)
            url_ += "searchQuery=" + encodeURIComponent("" + searchQuery) + "&";
        if (careFundCampaignCategory !== undefined && careFundCampaignCategory !== null)
            url_ += "CareFundCampaignCategory=" + encodeURIComponent("" + careFundCampaignCategory) + "&";
        if (minAmount === null)
            throw new Error("The parameter 'minAmount' cannot be null.");
        else if (minAmount !== undefined)
            url_ += "minAmount=" + encodeURIComponent("" + minAmount) + "&";
        if (maxAmount === null)
            throw new Error("The parameter 'maxAmount' cannot be null.");
        else if (maxAmount !== undefined)
            url_ += "maxAmount=" + encodeURIComponent("" + maxAmount) + "&";
        if (pagedQuery_RecordsToSkip === null)
            throw new Error("The parameter 'pagedQuery_RecordsToSkip' cannot be null.");
        else if (pagedQuery_RecordsToSkip !== undefined)
            url_ += "pagedQuery.RecordsToSkip=" + encodeURIComponent("" + pagedQuery_RecordsToSkip) + "&";
        if (pagedQuery_RecordsToTake === null)
            throw new Error("The parameter 'pagedQuery_RecordsToTake' cannot be null.");
        else if (pagedQuery_RecordsToTake !== undefined)
            url_ += "pagedQuery.RecordsToTake=" + encodeURIComponent("" + pagedQuery_RecordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllPublic(_response);
        });
    }

    protected processAllPublic(response: Response): Promise<PagedResultOfCareFundCampaign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfCareFundCampaign.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfCareFundCampaign>(null as any);
    }

    /**
     * Get by CareFundCampaign ID
     */
    careFundCampaignsGet(campaignID: string): Promise<CareFundCampaign> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/{campaignID}";
        if (campaignID === undefined || campaignID === null)
            throw new Error("The parameter 'campaignID' must be defined.");
        url_ = url_.replace("{campaignID}", encodeURIComponent("" + campaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundCampaignsGet(_response);
        });
    }

    protected processCareFundCampaignsGet(response: Response): Promise<CareFundCampaign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundCampaign.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundCampaign>(null as any);
    }

    /**
     * Get by CampaignID
     */
    byCampaignID(campaignID: string): Promise<CareFundCampaign> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/ByCampaignID/{CampaignID}";
        if (campaignID === undefined || campaignID === null)
            throw new Error("The parameter 'campaignID' must be defined.");
        url_ = url_.replace("{campaignID}", encodeURIComponent("" + campaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCampaignID(_response);
        });
    }

    protected processByCampaignID(response: Response): Promise<CareFundCampaign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundCampaign.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundCampaign>(null as any);
    }

    /**
     * Posts the specified CareFundCampaign.
     * @param careFundCampaign The CareFundCampaign.
     */
    careFundCampaignsPost(careFundCampaign: CareFundCampaign): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundCampaign);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundCampaignsPost(_response);
        });
    }

    protected processCareFundCampaignsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified CareFundCampaign.
     * @param updateCareFundCampaignDTO The CareFundCampaign.
     */
    careFundCampaignsPut(updateCareFundCampaignDTO: UpdateCareFundCampaignDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCareFundCampaignDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundCampaignsPut(_response);
        });
    }

    protected processCareFundCampaignsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param careFundCampaignID The identifier.
     */
    careFundCampaignsDelete(careFundCampaignID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/{careFundCampaignID}";
        if (careFundCampaignID === undefined || careFundCampaignID === null)
            throw new Error("The parameter 'careFundCampaignID' must be defined.");
        url_ = url_.replace("{careFundCampaignID}", encodeURIComponent("" + careFundCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundCampaignsDelete(_response);
        });
    }

    protected processCareFundCampaignsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the campaign summary.
     * @param campaignID (optional) The LoggedInUser.
     * @param loggedInUser (optional) The LoggedInUser.
     */
    summary(campaignID?: string | null | undefined, loggedInUser?: boolean | undefined): Promise<CareFundCampaignSummary> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/summary?";
        if (campaignID !== undefined && campaignID !== null)
            url_ += "campaignID=" + encodeURIComponent("" + campaignID) + "&";
        if (loggedInUser === null)
            throw new Error("The parameter 'loggedInUser' cannot be null.");
        else if (loggedInUser !== undefined)
            url_ += "loggedInUser=" + encodeURIComponent("" + loggedInUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: Response): Promise<CareFundCampaignSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundCampaignSummary.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundCampaignSummary>(null as any);
    }

    /**
     * Gets the campaign summary.
     * @param careFundCampaignID (optional) The LoggedInUser.
     */
    metric(careFundCampaignID?: string | undefined): Promise<CareFundCampaignMetric> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/metric?";
        if (careFundCampaignID === null)
            throw new Error("The parameter 'careFundCampaignID' cannot be null.");
        else if (careFundCampaignID !== undefined)
            url_ += "careFundCampaignID=" + encodeURIComponent("" + careFundCampaignID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMetric(_response);
        });
    }

    protected processMetric(response: Response): Promise<CareFundCampaignMetric> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundCampaignMetric.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundCampaignMetric>(null as any);
    }

    /**
     * Updates the Campaign Status
     * @param careFundCampaignID (optional) 
     * @param careFundStatusEnum (optional) 
     */
    updateStatus(careFundCampaignID?: string | undefined, careFundStatusEnum?: CareFundStatusEnum | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundCampaigns/updateStatus?";
        if (careFundCampaignID === null)
            throw new Error("The parameter 'careFundCampaignID' cannot be null.");
        else if (careFundCampaignID !== undefined)
            url_ += "careFundCampaignID=" + encodeURIComponent("" + careFundCampaignID) + "&";
        if (careFundStatusEnum === null)
            throw new Error("The parameter 'careFundStatusEnum' cannot be null.");
        else if (careFundStatusEnum !== undefined)
            url_ += "careFundStatusEnum=" + encodeURIComponent("" + careFundStatusEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CareFundDisbursementsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<CareFundDisbursement[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundDisbursements/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<CareFundDisbursement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundDisbursement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundDisbursement[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param careFundDisbursementID The identifier.
     */
    careFundDisbursementsGet(careFundDisbursementID: string): Promise<CareFundDisbursement> {
        let url_ = this.baseUrl + "/api/v1/CareFundDisbursements/{careFundDisbursementID}";
        if (careFundDisbursementID === undefined || careFundDisbursementID === null)
            throw new Error("The parameter 'careFundDisbursementID' must be defined.");
        url_ = url_.replace("{careFundDisbursementID}", encodeURIComponent("" + careFundDisbursementID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDisbursementsGet(_response);
        });
    }

    protected processCareFundDisbursementsGet(response: Response): Promise<CareFundDisbursement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundDisbursement.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundDisbursement>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param careFundDisbursementID The identifier.
     */
    careFundDisbursementsDelete(careFundDisbursementID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/CareFundDisbursements/{careFundDisbursementID}";
        if (careFundDisbursementID === undefined || careFundDisbursementID === null)
            throw new Error("The parameter 'careFundDisbursementID' must be defined.");
        url_ = url_.replace("{careFundDisbursementID}", encodeURIComponent("" + careFundDisbursementID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDisbursementsDelete(_response);
        });
    }

    protected processCareFundDisbursementsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified CareFundDisbursement.
     * @param careFundDisbursement The CareFundDisbursement.
     */
    careFundDisbursementsPost(careFundDisbursement: CareFundDisbursement): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundDisbursements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundDisbursement);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDisbursementsPost(_response);
        });
    }

    protected processCareFundDisbursementsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified CareFundDisbursement.
     */
    careFundDisbursementsPut(careFundDisbursement: CareFundDisbursement): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundDisbursements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundDisbursement);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDisbursementsPut(_response);
        });
    }

    protected processCareFundDisbursementsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the total amount disbursed to an applicant.
     * @param careFundApplicantID The identifier.
     */
    amountDisbursed(careFundApplicantID: string): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/CareFundDisbursements/AmountDisbursed/{careFundApplicantID}";
        if (careFundApplicantID === undefined || careFundApplicantID === null)
            throw new Error("The parameter 'careFundApplicantID' must be defined.");
        url_ = url_.replace("{careFundApplicantID}", encodeURIComponent("" + careFundApplicantID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAmountDisbursed(_response);
        });
    }

    protected processAmountDisbursed(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CareFundDonationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<CareFundDonation[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<CareFundDonation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundDonation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundDonation[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param careFundDonationID The identifier.
     */
    careFundDonationsGet(careFundDonationID: string): Promise<CareFundDonation> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations/{careFundDonationID}";
        if (careFundDonationID === undefined || careFundDonationID === null)
            throw new Error("The parameter 'careFundDonationID' must be defined.");
        url_ = url_.replace("{careFundDonationID}", encodeURIComponent("" + careFundDonationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDonationsGet(_response);
        });
    }

    protected processCareFundDonationsGet(response: Response): Promise<CareFundDonation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundDonation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundDonation>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param careFundDonationID The identifier.
     */
    careFundDonationsDelete(careFundDonationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations/{careFundDonationID}";
        if (careFundDonationID === undefined || careFundDonationID === null)
            throw new Error("The parameter 'careFundDonationID' must be defined.");
        url_ = url_.replace("{careFundDonationID}", encodeURIComponent("" + careFundDonationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDonationsDelete(_response);
        });
    }

    protected processCareFundDonationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified CareFundDonation.
     * @param careFundDonation The CareFundDonation.
     */
    careFundDonationsPost(careFundDonation: CareFundDonation): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundDonation);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDonationsPost(_response);
        });
    }

    protected processCareFundDonationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified CareFundDonation.
     */
    careFundDonationsPut(careFundDonation: CareFundDonation): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundDonation);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDonationsPut(_response);
        });
    }

    protected processCareFundDonationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified CareFundDonation Commit.
     * @param walletCommitDetails The wallet commit details.
     */
    commitCareFundDonation(careFundDonationID: string, walletCommitDetails: WalletCommitDetails): Promise<WalletCommitResults> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations/commitCareFundDonation/{careFundDonationID}";
        if (careFundDonationID === undefined || careFundDonationID === null)
            throw new Error("The parameter 'careFundDonationID' must be defined.");
        url_ = url_.replace("{careFundDonationID}", encodeURIComponent("" + careFundDonationID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletCommitDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCommitCareFundDonation(_response);
        });
    }

    protected processCommitCareFundDonation(response: Response): Promise<WalletCommitResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCommitResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCommitResults>(null as any);
    }

    /**
     * Posts the specified CareFundDonation Invoice Payment.
     * @param invoicePayment The wallet commit details.
     */
    careFundDonationInvoicePayment(careFundDonationID: string, invoicePayment: InvoicePayment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations/CareFundDonationInvoicePayment/{careFundDonationID}";
        if (careFundDonationID === undefined || careFundDonationID === null)
            throw new Error("The parameter 'careFundDonationID' must be defined.");
        url_ = url_.replace("{careFundDonationID}", encodeURIComponent("" + careFundDonationID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoicePayment);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDonationInvoicePayment(_response);
        });
    }

    protected processCareFundDonationInvoicePayment(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified CareFundDonation Invoice Payment.
     */
    careFundDonationVirtualWallet(careFundDonationID: string): Promise<VirtualWalletResponse> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations/CareFundDonationVirtualWallet/{careFundDonationID}";
        if (careFundDonationID === undefined || careFundDonationID === null)
            throw new Error("The parameter 'careFundDonationID' must be defined.");
        url_ = url_.replace("{careFundDonationID}", encodeURIComponent("" + careFundDonationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundDonationVirtualWallet(_response);
        });
    }

    protected processCareFundDonationVirtualWallet(response: Response): Promise<VirtualWalletResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VirtualWalletResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VirtualWalletResponse>(null as any);
    }

    /**
     * Create a Donation currency exchange invoice
     * @param careFundDonationID (optional) 
     */
    createCurrencyExchangeInvoice(currencyExchangeInvoiceDetails: CreateCurrencyExchangeInvoiceDetails, careFundDonationID?: string | undefined): Promise<CurrencyExchangeResult> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations/CreateCurrencyExchangeInvoice?";
        if (careFundDonationID === null)
            throw new Error("The parameter 'careFundDonationID' cannot be null.");
        else if (careFundDonationID !== undefined)
            url_ += "careFundDonationID=" + encodeURIComponent("" + careFundDonationID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(currencyExchangeInvoiceDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateCurrencyExchangeInvoice(_response);
        });
    }

    protected processCreateCurrencyExchangeInvoice(response: Response): Promise<CurrencyExchangeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyExchangeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyExchangeResult>(null as any);
    }

    /**
     * Gets the CareFund Statistics
     */
    statistics(): Promise<CareFundStatisticsDTO> {
        let url_ = this.baseUrl + "/api/v1/CareFundDonations/statistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStatistics(_response);
        });
    }

    protected processStatistics(response: Response): Promise<CareFundStatisticsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundStatisticsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundStatisticsDTO>(null as any);
    }
}

export class CareFundMediaClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all CareFundMedia.
     */
    all(): Promise<CareFundMedia[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundMedia/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<CareFundMedia[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundMedia.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundMedia[]>(null as any);
    }

    /**
     * Gets the by CareFund Media identifier.
     * @param careFundMediaID The CareFund Media identifier.
     */
    careFundMediaGet(careFundMediaID: string): Promise<CareFundMedia> {
        let url_ = this.baseUrl + "/api/v1/CareFundMedia/{careFundMediaID}";
        if (careFundMediaID === undefined || careFundMediaID === null)
            throw new Error("The parameter 'careFundMediaID' must be defined.");
        url_ = url_.replace("{careFundMediaID}", encodeURIComponent("" + careFundMediaID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundMediaGet(_response);
        });
    }

    protected processCareFundMediaGet(response: Response): Promise<CareFundMedia> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundMedia.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundMedia>(null as any);
    }

    /**
     * Gets the short name of the by message.
     * @param shortName The short name.
     */
    byShortName(shortName: string): Promise<CareFundMedia> {
        let url_ = this.baseUrl + "/api/v1/CareFundMedia/ByShortName/{shortName}";
        if (shortName === undefined || shortName === null)
            throw new Error("The parameter 'shortName' must be defined.");
        url_ = url_.replace("{shortName}", encodeURIComponent("" + shortName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByShortName(_response);
        });
    }

    protected processByShortName(response: Response): Promise<CareFundMedia> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundMedia.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundMedia>(null as any);
    }

    /**
     * Posts the specified CareFundMedia.
     * @param media (optional) 
     * @param name (optional) 
     * @param mediaTypeEnum (optional) 
     * @param careFundTypeEnum (optional) 
     * @param isPrimary (optional) 
     */
    careFundMediaPost(media?: FileParameter | null | undefined, name?: string | null | undefined, mediaTypeEnum?: MediaTypeEnum | undefined, careFundTypeEnum?: CareFundTypeEnum | undefined, isPrimary?: boolean | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (media !== null && media !== undefined)
            content_.append("Media", media.data, media.fileName ? media.fileName : "Media");
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (mediaTypeEnum === null || mediaTypeEnum === undefined)
            throw new Error("The parameter 'mediaTypeEnum' cannot be null.");
        else
            content_.append("MediaTypeEnum", mediaTypeEnum.toString());
        if (careFundTypeEnum === null || careFundTypeEnum === undefined)
            throw new Error("The parameter 'careFundTypeEnum' cannot be null.");
        else
            content_.append("CareFundTypeEnum", careFundTypeEnum.toString());
        if (isPrimary === null || isPrimary === undefined)
            throw new Error("The parameter 'isPrimary' cannot be null.");
        else
            content_.append("IsPrimary", isPrimary.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundMediaPost(_response);
        });
    }

    protected processCareFundMediaPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified CareFundMedia.
     * @param careFundMedia The CareFundMedia.
     */
    careFundMediaPut(careFundMedia: CareFundMedia): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundMedia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundMedia);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundMediaPut(_response);
        });
    }

    protected processCareFundMediaPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Downloads the watermarked image.
     * @param file (optional) 
     */
    watermark(file?: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/CareFundMedia/watermark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWatermark(_response);
        });
    }

    protected processWatermark(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param careFundMediaID The identifier.
     */
    careFundMediaDelete(careFundMediaID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/CareFundMedia/{CareFundMediaID}";
        if (careFundMediaID === undefined || careFundMediaID === null)
            throw new Error("The parameter 'careFundMediaID' must be defined.");
        url_ = url_.replace("{CareFundMediaID}", encodeURIComponent("" + careFundMediaID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundMediaDelete(_response);
        });
    }

    protected processCareFundMediaDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CareFundTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get All
     */
    all(): Promise<CareFundTag[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<CareFundTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundTag[]>(null as any);
    }

    /**
     * Gets all by CareFundID.
     */
    byCareFundID(careFundID: string): Promise<CareFundTag[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags/ByCareFundID/{careFundID}";
        if (careFundID === undefined || careFundID === null)
            throw new Error("The parameter 'careFundID' must be defined.");
        url_ = url_.replace("{careFundID}", encodeURIComponent("" + careFundID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCareFundID(_response);
        });
    }

    protected processByCareFundID(response: Response): Promise<CareFundTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundTag[]>(null as any);
    }

    /**
     * Gets all by CareFundID and CareFundTagTypeEnum.
     * @param careFundID (optional) 
     * @param careFundTagTypeEnum (optional) 
     */
    getByCareFundIDAndTagType(careFundID?: string | undefined, careFundTagTypeEnum?: CareFundTagTypeEnum | undefined): Promise<CareFundTag[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags/GetByCareFundIDAndTagType?";
        if (careFundID === null)
            throw new Error("The parameter 'careFundID' cannot be null.");
        else if (careFundID !== undefined)
            url_ += "careFundID=" + encodeURIComponent("" + careFundID) + "&";
        if (careFundTagTypeEnum === null)
            throw new Error("The parameter 'careFundTagTypeEnum' cannot be null.");
        else if (careFundTagTypeEnum !== undefined)
            url_ += "careFundTagTypeEnum=" + encodeURIComponent("" + careFundTagTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetByCareFundIDAndTagType(_response);
        });
    }

    protected processGetByCareFundIDAndTagType(response: Response): Promise<CareFundTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundTag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param careFundTagID The identifier.
     */
    careFundTagsGet(careFundTagID: string): Promise<CareFundTag> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags/{careFundTagID}";
        if (careFundTagID === undefined || careFundTagID === null)
            throw new Error("The parameter 'careFundTagID' must be defined.");
        url_ = url_.replace("{careFundTagID}", encodeURIComponent("" + careFundTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundTagsGet(_response);
        });
    }

    protected processCareFundTagsGet(response: Response): Promise<CareFundTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CareFundTag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundTag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param careFundTagID The identifier.
     */
    careFundTagsDelete(careFundTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags/{careFundTagID}";
        if (careFundTagID === undefined || careFundTagID === null)
            throw new Error("The parameter 'careFundTagID' must be defined.");
        url_ = url_.replace("{careFundTagID}", encodeURIComponent("" + careFundTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundTagsDelete(_response);
        });
    }

    protected processCareFundTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified CareFundTag.
     * @param careFundTag The CareFundTag.
     */
    careFundTagsPost(careFundTag: CareFundTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundTagsPost(_response);
        });
    }

    protected processCareFundTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified CareFundTag.
     * @param careFundTag The CareFundTag.
     */
    careFundTagsPut(careFundTag: CareFundTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCareFundTagsPut(_response);
        });
    }

    protected processCareFundTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update many at once
     */
    many(careFundTags: CareFundTag[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(careFundTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Gets the popular tags.
     * @param count The identifier.
     * @param careFundTagTypeEnum The identifier.
     */
    popular(count: number, careFundTagTypeEnum: CareFundTagTypeEnum): Promise<CareFundTag[]> {
        let url_ = this.baseUrl + "/api/v1/CareFundTags/Popular/{careFundTagTypeEnum}/{count}";
        if (count === undefined || count === null)
            throw new Error("The parameter 'count' must be defined.");
        url_ = url_.replace("{count}", encodeURIComponent("" + count));
        if (careFundTagTypeEnum === undefined || careFundTagTypeEnum === null)
            throw new Error("The parameter 'careFundTagTypeEnum' must be defined.");
        url_ = url_.replace("{careFundTagTypeEnum}", encodeURIComponent("" + careFundTagTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPopular(_response);
        });
    }

    protected processPopular(response: Response): Promise<CareFundTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CareFundTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CareFundTag[]>(null as any);
    }
}

export class ClinicalTrialLocationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<ClinicalTrialLocation[]> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialLocations/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ClinicalTrialLocation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicalTrialLocation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialLocation[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param clinicalTrialLocationID The identifier.
     */
    clinicalTrialLocationsGet(clinicalTrialLocationID: string): Promise<ClinicalTrialLocation> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialLocations/{clinicalTrialLocationID}";
        if (clinicalTrialLocationID === undefined || clinicalTrialLocationID === null)
            throw new Error("The parameter 'clinicalTrialLocationID' must be defined.");
        url_ = url_.replace("{clinicalTrialLocationID}", encodeURIComponent("" + clinicalTrialLocationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialLocationsGet(_response);
        });
    }

    protected processClinicalTrialLocationsGet(response: Response): Promise<ClinicalTrialLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrialLocation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialLocation>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param clinicalTrialLocationID The identifier.
     */
    clinicalTrialLocationsDelete(clinicalTrialLocationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialLocations/{clinicalTrialLocationID}";
        if (clinicalTrialLocationID === undefined || clinicalTrialLocationID === null)
            throw new Error("The parameter 'clinicalTrialLocationID' must be defined.");
        url_ = url_.replace("{clinicalTrialLocationID}", encodeURIComponent("" + clinicalTrialLocationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialLocationsDelete(_response);
        });
    }

    protected processClinicalTrialLocationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ClinicalTrialLocation.
     * @param clinicalTrialLocation The ClinicalTrialLocation.
     */
    clinicalTrialLocationsPost(clinicalTrialLocation: ClinicalTrialLocation): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialLocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialLocation);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialLocationsPost(_response);
        });
    }

    protected processClinicalTrialLocationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ClinicalTrialLocation.
     * @param clinicalTrialLocation The ClinicalTrialLocation.
     */
    clinicalTrialLocationsPut(clinicalTrialLocation: ClinicalTrialLocation): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialLocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialLocation);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialLocationsPut(_response);
        });
    }

    protected processClinicalTrialLocationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ClinicalTrialsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the search setup details.
     */
    searchSetup(): Promise<ClinicalTrialSearchSetup> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials/SearchSetup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearchSetup(_response);
        });
    }

    protected processSearchSetup(response: Response): Promise<ClinicalTrialSearchSetup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrialSearchSetup.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialSearchSetup>(null as any);
    }

    /**
     * Posts the search.
     * @param clinicalTrialSearchDetails The clinical trial search details.
     */
    search(clinicalTrialSearchDetails: ClinicalTrialSearchDetails): Promise<ClinicalTrialSearchResults> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ClinicalTrialSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrialSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialSearchResults>(null as any);
    }

    /**
     * Uploads the clinical trials.
     * @param documentID The document identifier.
     */
    import(documentID: string): Promise<ClinicalTrialImportResult> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials/Import/{documentID}";
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processImport(_response);
        });
    }

    protected processImport(response: Response): Promise<ClinicalTrialImportResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrialImportResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialImportResult>(null as any);
    }

    /**
     * Signs up for clinicial trial.
     * @param pHRClinicalTrial The p hr clinical trial.
     */
    signUpForClinicalTrial(pHRClinicalTrial: PHRClinicalTrial): Promise<ClinicalTrialSignupResult> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials/SignUpForClinicalTrial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRClinicalTrial);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpForClinicalTrial(_response);
        });
    }

    protected processSignUpForClinicalTrial(response: Response): Promise<ClinicalTrialSignupResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrialSignupResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialSignupResult>(null as any);
    }

    /**
     * Gets all.
     */
    all(): Promise<ClinicalTrial[]> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ClinicalTrial[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicalTrial.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrial[]>(null as any);
    }

    /**
     * Gets the page.
     * @param recordsToSkip The records to skip.
     * @param recordsToTake The records to take.
     */
    page(recordsToSkip: number, recordsToTake: number): Promise<ClinicalTrial[]> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials/page/{recordsToSkip}/{recordsToTake}";
        if (recordsToSkip === undefined || recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' must be defined.");
        url_ = url_.replace("{recordsToSkip}", encodeURIComponent("" + recordsToSkip));
        if (recordsToTake === undefined || recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' must be defined.");
        url_ = url_.replace("{recordsToTake}", encodeURIComponent("" + recordsToTake));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPage(_response);
        });
    }

    protected processPage(response: Response): Promise<ClinicalTrial[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicalTrial.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrial[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param clinicalTrialID The identifier.
     */
    clinicalTrialsGet(clinicalTrialID: string): Promise<ClinicalTrial> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials/{clinicalTrialID}";
        if (clinicalTrialID === undefined || clinicalTrialID === null)
            throw new Error("The parameter 'clinicalTrialID' must be defined.");
        url_ = url_.replace("{clinicalTrialID}", encodeURIComponent("" + clinicalTrialID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialsGet(_response);
        });
    }

    protected processClinicalTrialsGet(response: Response): Promise<ClinicalTrial> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrial.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrial>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param clinicalTrialID The identifier.
     */
    clinicalTrialsDelete(clinicalTrialID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials/{clinicalTrialID}";
        if (clinicalTrialID === undefined || clinicalTrialID === null)
            throw new Error("The parameter 'clinicalTrialID' must be defined.");
        url_ = url_.replace("{clinicalTrialID}", encodeURIComponent("" + clinicalTrialID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialsDelete(_response);
        });
    }

    protected processClinicalTrialsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ClinicalTrial.
     * @param clinicalTrial The ClinicalTrial.
     */
    clinicalTrialsPost(clinicalTrial: ClinicalTrial): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrial);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialsPost(_response);
        });
    }

    protected processClinicalTrialsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ClinicalTrial.
     * @param clinicalTrial The ClinicalTrial.
     */
    clinicalTrialsPut(clinicalTrial: ClinicalTrial): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrial);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialsPut(_response);
        });
    }

    protected processClinicalTrialsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ClinicalTrialTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<ClinicalTrialTag[]> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialTags/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ClinicalTrialTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicalTrialTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialTag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param clinicalTrialTagID The identifier.
     */
    clinicalTrialTagsGet(clinicalTrialTagID: string): Promise<ClinicalTrialTag> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialTags/{clinicalTrialTagID}";
        if (clinicalTrialTagID === undefined || clinicalTrialTagID === null)
            throw new Error("The parameter 'clinicalTrialTagID' must be defined.");
        url_ = url_.replace("{clinicalTrialTagID}", encodeURIComponent("" + clinicalTrialTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialTagsGet(_response);
        });
    }

    protected processClinicalTrialTagsGet(response: Response): Promise<ClinicalTrialTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrialTag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialTag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param clinicalTrialTagID The identifier.
     */
    clinicalTrialTagsDelete(clinicalTrialTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialTags/{clinicalTrialTagID}";
        if (clinicalTrialTagID === undefined || clinicalTrialTagID === null)
            throw new Error("The parameter 'clinicalTrialTagID' must be defined.");
        url_ = url_.replace("{clinicalTrialTagID}", encodeURIComponent("" + clinicalTrialTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialTagsDelete(_response);
        });
    }

    protected processClinicalTrialTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ClinicalTrialTag.
     * @param clinicalTrialTag The ClinicalTrialTag.
     */
    clinicalTrialTagsPost(clinicalTrialTag: ClinicalTrialTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialTagsPost(_response);
        });
    }

    protected processClinicalTrialTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ClinicalTrialTag.
     * @param clinicalTrialTag The ClinicalTrialTag.
     */
    clinicalTrialTagsPut(clinicalTrialTag: ClinicalTrialTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ClinicalTrialTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialTagsPut(_response);
        });
    }

    protected processClinicalTrialTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ConstantsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the echo notification message data.
     */
    echoNotificationMessageData(): Promise<EchoNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/EchoNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEchoNotificationMessageData(_response);
        });
    }

    protected processEchoNotificationMessageData(response: Response): Promise<EchoNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EchoNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EchoNotificationMessageData>(null as any);
    }

    /**
     * Gets the consult notification message data.
     */
    consultNotificationMessageData(): Promise<ConsultNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/ConsultNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultNotificationMessageData(_response);
        });
    }

    protected processConsultNotificationMessageData(response: Response): Promise<ConsultNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultNotificationMessageData>(null as any);
    }

    /**
     * Gets the community notification message data.
     */
    communityNotificationMessageData(): Promise<CommunityNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/CommunityNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCommunityNotificationMessageData(_response);
        });
    }

    protected processCommunityNotificationMessageData(response: Response): Promise<CommunityNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunityNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunityNotificationMessageData>(null as any);
    }

    /**
     * Gets the ApproveDeny notification message data.
     */
    approveDenyNotificationMessageData(): Promise<ApproveDenyNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/ApproveDenyNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApproveDenyNotificationMessageData(_response);
        });
    }

    protected processApproveDenyNotificationMessageData(response: Response): Promise<ApproveDenyNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveDenyNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveDenyNotificationMessageData>(null as any);
    }

    /**
     * Gets the medication notification message data.
     */
    medicationNotificationMessageData(): Promise<MedicationNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/MedicationNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMedicationNotificationMessageData(_response);
        });
    }

    protected processMedicationNotificationMessageData(response: Response): Promise<MedicationNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationNotificationMessageData>(null as any);
    }

    /**
     * Gets the Text Message notification message data.
     */
    textMessageNotificationMessageData(): Promise<TextMessageNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/TextMessageNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTextMessageNotificationMessageData(_response);
        });
    }

    protected processTextMessageNotificationMessageData(response: Response): Promise<TextMessageNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TextMessageNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextMessageNotificationMessageData>(null as any);
    }

    /**
     * Gets the SourceReward Message notification message data.
     */
    sourceRewardNotificationMessageData(): Promise<SourceRewardNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/SourceRewardNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSourceRewardNotificationMessageData(_response);
        });
    }

    protected processSourceRewardNotificationMessageData(response: Response): Promise<SourceRewardNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourceRewardNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SourceRewardNotificationMessageData>(null as any);
    }

    /**
     * Gets the Wallet Message notification message data.
     */
    walletNotificationMessageData(): Promise<WalletNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/WalletNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletNotificationMessageData(_response);
        });
    }

    protected processWalletNotificationMessageData(response: Response): Promise<WalletNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletNotificationMessageData>(null as any);
    }

    /**
     * Gets the Wallet Message notification message data.
     */
    marketingNotificationMessageData(): Promise<MarketingNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/MarketingNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingNotificationMessageData(_response);
        });
    }

    protected processMarketingNotificationMessageData(response: Response): Promise<MarketingNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingNotificationMessageData>(null as any);
    }

    bookConsultNotificationMessageData(): Promise<BookConsultNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/BookConsultNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBookConsultNotificationMessageData(_response);
        });
    }

    protected processBookConsultNotificationMessageData(response: Response): Promise<BookConsultNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookConsultNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookConsultNotificationMessageData>(null as any);
    }

    shoppingCartNotificationMessageData(): Promise<ShoppingCartNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/ShoppingCartNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processShoppingCartNotificationMessageData(_response);
        });
    }

    protected processShoppingCartNotificationMessageData(response: Response): Promise<ShoppingCartNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShoppingCartNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartNotificationMessageData>(null as any);
    }

    learningNotificationMessageData(): Promise<LearningNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/LearningNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLearningNotificationMessageData(_response);
        });
    }

    protected processLearningNotificationMessageData(response: Response): Promise<LearningNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LearningNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LearningNotificationMessageData>(null as any);
    }

    appSettingsNotificationMessageData(): Promise<AppSettingsNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/AppSettingsNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAppSettingsNotificationMessageData(_response);
        });
    }

    protected processAppSettingsNotificationMessageData(response: Response): Promise<AppSettingsNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppSettingsNotificationMessageData>(null as any);
    }

    recordsNotificationMessageData(): Promise<RecordsNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/RecordsNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRecordsNotificationMessageData(_response);
        });
    }

    protected processRecordsNotificationMessageData(response: Response): Promise<RecordsNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordsNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecordsNotificationMessageData>(null as any);
    }

    profileNotificationMessageData(): Promise<ProfileNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/ProfileNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProfileNotificationMessageData(_response);
        });
    }

    protected processProfileNotificationMessageData(response: Response): Promise<ProfileNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileNotificationMessageData>(null as any);
    }

    giveTheGiftNotificationMessageData(): Promise<GiveTheGiftNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/GiveTheGiftNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGiveTheGiftNotificationMessageData(_response);
        });
    }

    protected processGiveTheGiftNotificationMessageData(response: Response): Promise<GiveTheGiftNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiveTheGiftNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiveTheGiftNotificationMessageData>(null as any);
    }

    supportNotificationMessageData(): Promise<SupportNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/SupportNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSupportNotificationMessageData(_response);
        });
    }

    protected processSupportNotificationMessageData(response: Response): Promise<SupportNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportNotificationMessageData>(null as any);
    }

    campaignsNotificationMessageData(): Promise<CampaignsNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/CampaignsNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCampaignsNotificationMessageData(_response);
        });
    }

    protected processCampaignsNotificationMessageData(response: Response): Promise<CampaignsNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampaignsNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CampaignsNotificationMessageData>(null as any);
    }

    mailMessageNotificationMessageData(): Promise<MailMessageNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/MailMessageNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMailMessageNotificationMessageData(_response);
        });
    }

    protected processMailMessageNotificationMessageData(response: Response): Promise<MailMessageNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailMessageNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MailMessageNotificationMessageData>(null as any);
    }

    onDemandSessionNotificationMessageData(): Promise<OnDemandSessionNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/OnDemandSessionNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOnDemandSessionNotificationMessageData(_response);
        });
    }

    protected processOnDemandSessionNotificationMessageData(response: Response): Promise<OnDemandSessionNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnDemandSessionNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnDemandSessionNotificationMessageData>(null as any);
    }

    providerAppointmentNotificationMessageData(): Promise<ProviderAppointmentNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/ProviderAppointmentNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAppointmentNotificationMessageData(_response);
        });
    }

    protected processProviderAppointmentNotificationMessageData(response: Response): Promise<ProviderAppointmentNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAppointmentNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAppointmentNotificationMessageData>(null as any);
    }

    providerCancelAppointmentNotificationMessageData(): Promise<ProviderCancelAppointmentNotificationMessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/ProviderCancelAppointmentNotificationMessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderCancelAppointmentNotificationMessageData(_response);
        });
    }

    protected processProviderCancelAppointmentNotificationMessageData(response: Response): Promise<ProviderCancelAppointmentNotificationMessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderCancelAppointmentNotificationMessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderCancelAppointmentNotificationMessageData>(null as any);
    }

    providerQueueWaitingNotificationmessageData(): Promise<ProviderQueueWaitingNotificationmessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/ProviderQueueWaitingNotificationmessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderQueueWaitingNotificationmessageData(_response);
        });
    }

    protected processProviderQueueWaitingNotificationmessageData(response: Response): Promise<ProviderQueueWaitingNotificationmessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueWaitingNotificationmessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueWaitingNotificationmessageData>(null as any);
    }

    providerQueueExpireNotificationmessageData(): Promise<ProviderQueueExpireNotificationmessageData> {
        let url_ = this.baseUrl + "/api/v1/Constants/ProviderQueueExpireNotificationmessageData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderQueueExpireNotificationmessageData(_response);
        });
    }

    protected processProviderQueueExpireNotificationmessageData(response: Response): Promise<ProviderQueueExpireNotificationmessageData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueExpireNotificationmessageData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueExpireNotificationmessageData>(null as any);
    }

    /**
     * Weights the enum.
     */
    weightEnum(): Promise<WeightEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/WeightEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWeightEnum(_response);
        });
    }

    protected processWeightEnum(response: Response): Promise<WeightEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeightEnum>(null as any);
    }

    /**
     * Heights the enum.
     */
    heightEnum(): Promise<HeightEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/HeightEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processHeightEnum(_response);
        });
    }

    protected processHeightEnum(response: Response): Promise<HeightEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeightEnum>(null as any);
    }

    /**
     * WeightHeight the enum.
     */
    weightHeightEnum(): Promise<WeightHeightEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/WeightHeightEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWeightHeightEnum(_response);
        });
    }

    protected processWeightHeightEnum(response: Response): Promise<WeightHeightEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeightHeightEnum>(null as any);
    }

    /**
     * Bloods the glucose type enum.
     */
    bloodGlucoseTypeEnum(): Promise<BloodGlucoseTypeEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/BloodGlucoseTypeEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBloodGlucoseTypeEnum(_response);
        });
    }

    protected processBloodGlucoseTypeEnum(response: Response): Promise<BloodGlucoseTypeEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseTypeEnum>(null as any);
    }

    /**
     * Gets the temperature type enum.
     */
    temperatureTypeEnum(): Promise<TemperatureTypeEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/TemperatureTypeEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTemperatureTypeEnum(_response);
        });
    }

    protected processTemperatureTypeEnum(response: Response): Promise<TemperatureTypeEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemperatureTypeEnum>(null as any);
    }

    /**
     * Gets the authorize net public dto.
     */
    authorizeNetPublic(): Promise<AuthorizeNetPublicDTO> {
        let url_ = this.baseUrl + "/api/v1/Constants/AuthorizeNetPublic";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAuthorizeNetPublic(_response);
        });
    }

    protected processAuthorizeNetPublic(response: Response): Promise<AuthorizeNetPublicDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizeNetPublicDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthorizeNetPublicDTO>(null as any);
    }

    /**
     * Gets the authorize net private dto.
     */
    authorizeNetPrivate(): Promise<AuthorizeNetPrivateDTO> {
        let url_ = this.baseUrl + "/api/v1/Constants/AuthorizeNetPrivate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAuthorizeNetPrivate(_response);
        });
    }

    protected processAuthorizeNetPrivate(response: Response): Promise<AuthorizeNetPrivateDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizeNetPrivateDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthorizeNetPrivateDTO>(null as any);
    }

    /**
     * Gets the authorize net ur ls dto.
     */
    authorizeNetURLsDTO(): Promise<AuthorizeNetURLsDTO> {
        let url_ = this.baseUrl + "/api/v1/Constants/AuthorizeNetURLsDTO";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAuthorizeNetURLsDTO(_response);
        });
    }

    protected processAuthorizeNetURLsDTO(response: Response): Promise<AuthorizeNetURLsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizeNetURLsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthorizeNetURLsDTO>(null as any);
    }

    /**
     * Gets the ActionMessage entity
     * @param actionMessageEnum (optional) The action message enum.
     */
    actionMessage(actionMessageEnum?: ActionMessageEnum | undefined): Promise<ActionMessage> {
        let url_ = this.baseUrl + "/api/v1/Constants/ActionMessage?";
        if (actionMessageEnum === null)
            throw new Error("The parameter 'actionMessageEnum' cannot be null.");
        else if (actionMessageEnum !== undefined)
            url_ += "actionMessageEnum=" + encodeURIComponent("" + actionMessageEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processActionMessage(_response);
        });
    }

    protected processActionMessage(response: Response): Promise<ActionMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionMessage>(null as any);
    }

    /**
     * Gets the ActionMessagePayloadTypeEnum entity
     * @param actionMessagePayloadTypeEnum (optional) The action message payload type enum.
     */
    actionMessagePayloadTypeEnum(actionMessagePayloadTypeEnum?: ActionMessagePayloadTypeEnum | undefined): Promise<ActionMessage> {
        let url_ = this.baseUrl + "/api/v1/Constants/ActionMessagePayloadTypeEnum?";
        if (actionMessagePayloadTypeEnum === null)
            throw new Error("The parameter 'actionMessagePayloadTypeEnum' cannot be null.");
        else if (actionMessagePayloadTypeEnum !== undefined)
            url_ += "actionMessagePayloadTypeEnum=" + encodeURIComponent("" + actionMessagePayloadTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processActionMessagePayloadTypeEnum(_response);
        });
    }

    protected processActionMessagePayloadTypeEnum(response: Response): Promise<ActionMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActionMessage>(null as any);
    }

    /**
     * Get the StoreItemTypeEnum
     */
    storeItemTypeEnum(): Promise<StoreItemTypeEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/StoreItemTypeEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemTypeEnum(_response);
        });
    }

    protected processStoreItemTypeEnum(response: Response): Promise<StoreItemTypeEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemTypeEnum>(null as any);
    }

    /**
     * Get the MailActionMessage
     */
    mailActionMessage(): Promise<MailActionMessage> {
        let url_ = this.baseUrl + "/api/v1/Constants/MailActionMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMailActionMessage(_response);
        });
    }

    protected processMailActionMessage(response: Response): Promise<MailActionMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailActionMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MailActionMessage>(null as any);
    }

    /**
     * Get the ConsultActionMessage
     */
    consultActionMessage(): Promise<ConsultActionMessage> {
        let url_ = this.baseUrl + "/api/v1/Constants/ConsultActionMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultActionMessage(_response);
        });
    }

    protected processConsultActionMessage(response: Response): Promise<ConsultActionMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultActionMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultActionMessage>(null as any);
    }

    /**
     * Gets the ProviderQueueActionMessage
     */
    providerQueueActionMessage(): Promise<ProviderQueueActionMessage> {
        let url_ = this.baseUrl + "/api/v1/Constants/ProviderQueueActionMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderQueueActionMessage(_response);
        });
    }

    protected processProviderQueueActionMessage(response: Response): Promise<ProviderQueueActionMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueActionMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueActionMessage>(null as any);
    }

    /**
     * Get the ConsultActionMessage
     */
    patientPrescriptionActionMessage(): Promise<PatientPrescriptionActionMessage> {
        let url_ = this.baseUrl + "/api/v1/Constants/PatientPrescriptionActionMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientPrescriptionActionMessage(_response);
        });
    }

    protected processPatientPrescriptionActionMessage(response: Response): Promise<PatientPrescriptionActionMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPrescriptionActionMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientPrescriptionActionMessage>(null as any);
    }

    /**
     * Gets the ApproveDenyRequestActionMessage
     */
    approveDenyRequestActionMessage(): Promise<ApproveDenyRequestActionMessage> {
        let url_ = this.baseUrl + "/api/v1/Constants/ApproveDenyRequestActionMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApproveDenyRequestActionMessage(_response);
        });
    }

    protected processApproveDenyRequestActionMessage(response: Response): Promise<ApproveDenyRequestActionMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveDenyRequestActionMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveDenyRequestActionMessage>(null as any);
    }

    /**
     * Get the RolesEnum
     */
    rolesEnum(): Promise<RolesEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/RolesEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRolesEnum(_response);
        });
    }

    protected processRolesEnum(response: Response): Promise<RolesEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolesEnum>(null as any);
    }

    /**
     * Gets the invoice store item display details dto.
     */
    consultInvoiceStoreItemDisplayDetails(): Promise<ConsultInvoiceStoreItemDisplayDetails> {
        let url_ = this.baseUrl + "/api/v1/Constants/ConsultInvoiceStoreItemDisplayDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultInvoiceStoreItemDisplayDetails(_response);
        });
    }

    protected processConsultInvoiceStoreItemDisplayDetails(response: Response): Promise<ConsultInvoiceStoreItemDisplayDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultInvoiceStoreItemDisplayDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultInvoiceStoreItemDisplayDetails>(null as any);
    }

    /**
     * Gets the patient prescription medication invoice store item display details.
     */
    patientPrescriptionMedicationInvoiceStoreItemDisplayDetails(): Promise<PatientPrescriptionMedicationInvoiceStoreItemDisplayDetails> {
        let url_ = this.baseUrl + "/api/v1/Constants/PatientPrescriptionMedicationInvoiceStoreItemDisplayDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientPrescriptionMedicationInvoiceStoreItemDisplayDetails(_response);
        });
    }

    protected processPatientPrescriptionMedicationInvoiceStoreItemDisplayDetails(response: Response): Promise<PatientPrescriptionMedicationInvoiceStoreItemDisplayDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPrescriptionMedicationInvoiceStoreItemDisplayDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientPrescriptionMedicationInvoiceStoreItemDisplayDetails>(null as any);
    }

    /**
     * Gets the patient prescription invoice store item display details.
     */
    patientPrescriptionInvoiceStoreItemDisplayDetails(): Promise<PatientPrescriptionInvoiceStoreItemDisplayDetails> {
        let url_ = this.baseUrl + "/api/v1/Constants/PatientPrescriptionInvoiceStoreItemDisplayDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientPrescriptionInvoiceStoreItemDisplayDetails(_response);
        });
    }

    protected processPatientPrescriptionInvoiceStoreItemDisplayDetails(response: Response): Promise<PatientPrescriptionInvoiceStoreItemDisplayDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPrescriptionInvoiceStoreItemDisplayDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientPrescriptionInvoiceStoreItemDisplayDetails>(null as any);
    }

    /**
     * Gets the patient patient order invoice store item display details.
     */
    patientOrderInvoiceStoreItemDisplayDetails(): Promise<PatientOrderInvoiceStoreItemDisplayDetails> {
        let url_ = this.baseUrl + "/api/v1/Constants/PatientOrderInvoiceStoreItemDisplayDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientOrderInvoiceStoreItemDisplayDetails(_response);
        });
    }

    protected processPatientOrderInvoiceStoreItemDisplayDetails(response: Response): Promise<PatientOrderInvoiceStoreItemDisplayDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOrderInvoiceStoreItemDisplayDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientOrderInvoiceStoreItemDisplayDetails>(null as any);
    }

    /**
     * Gets the patient patient order invoice store item display details.
     */
    patientOrderOrderItemInvoiceStoreItemDisplayDetails(): Promise<PatientOrderOrderItemInvoiceStoreItemDisplayDetails> {
        let url_ = this.baseUrl + "/api/v1/Constants/PatientOrderOrderItemInvoiceStoreItemDisplayDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientOrderOrderItemInvoiceStoreItemDisplayDetails(_response);
        });
    }

    protected processPatientOrderOrderItemInvoiceStoreItemDisplayDetails(response: Response): Promise<PatientOrderOrderItemInvoiceStoreItemDisplayDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOrderOrderItemInvoiceStoreItemDisplayDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientOrderOrderItemInvoiceStoreItemDisplayDetails>(null as any);
    }

    /**
     * Gets the NotificationMessageDataTypeEnums
     */
    notificationMessageDataTypeEnums(): Promise<NotificationMessageDataTypeEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/NotificationMessageDataTypeEnums";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNotificationMessageDataTypeEnums(_response);
        });
    }

    protected processNotificationMessageDataTypeEnums(response: Response): Promise<NotificationMessageDataTypeEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationMessageDataTypeEnum>(null as any);
    }

    /**
     * Gets the marketing event enum
     */
    marketingEventEnum(): Promise<MarketingEventEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/MarketingEventEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingEventEnum(_response);
        });
    }

    protected processMarketingEventEnum(response: Response): Promise<MarketingEventEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingEventEnum>(null as any);
    }

    /**
     * Gets the ConsultationTypeFlowEnum
     */
    consultationTypeFlowEnum(): Promise<ConsultationTypeFlowEnum> {
        let url_ = this.baseUrl + "/api/v1/Constants/ConsultationTypeFlowEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultationTypeFlowEnum(_response);
        });
    }

    protected processConsultationTypeFlowEnum(response: Response): Promise<ConsultationTypeFlowEnum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultationTypeFlowEnum>(null as any);
    }

    /**
     * Gets the ConsultProviderSearchResultsSummary
     */
    consultProviderSearchResultsSummary(): Promise<ConsultProviderSearchResultsSummary> {
        let url_ = this.baseUrl + "/api/v1/Constants/ConsultProviderSearchResultsSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultProviderSearchResultsSummary(_response);
        });
    }

    protected processConsultProviderSearchResultsSummary(response: Response): Promise<ConsultProviderSearchResultsSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultProviderSearchResultsSummary.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultProviderSearchResultsSummary>(null as any);
    }

    /**
     * Get host
     */
    host(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Constants/Host";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processHost(_response);
        });
    }

    protected processHost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ConsultBookingClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get the list of Consultation Types (Care Types) Tags
     */
    consultationTypeTags(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/ConsultBooking/ConsultationTypeTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultationTypeTags(_response);
        });
    }

    protected processConsultationTypeTags(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    patientDependantsByPatientID(patientID: string): Promise<UserDetailRelationship[]> {
        let url_ = this.baseUrl + "/api/v1/ConsultBooking/PatientDependantsByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientDependantsByPatientID(_response);
        });
    }

    protected processPatientDependantsByPatientID(response: Response): Promise<UserDetailRelationship[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailRelationship.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailRelationship[]>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    patientCareTeamByPatientID(patientID: string): Promise<PatientCareTeam[]> {
        let url_ = this.baseUrl + "/api/v1/ConsultBooking/PatientCareTeamByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientCareTeamByPatientID(_response);
        });
    }

    protected processPatientCareTeamByPatientID(response: Response): Promise<PatientCareTeam[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCareTeam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientCareTeam[]>(null as any);
    }

    /**
     * Search for available walkin providers
     */
    availableWalkInProvidersByCountryWalkInType(walkinProviderSearchDetails: WalkinProviderSearchDetails): Promise<PagedResultOfProvider> {
        let url_ = this.baseUrl + "/api/v1/ConsultBooking/AvailableWalkInProvidersByCountryWalkInType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walkinProviderSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableWalkInProvidersByCountryWalkInType(_response);
        });
    }

    protected processAvailableWalkInProvidersByCountryWalkInType(response: Response): Promise<PagedResultOfProvider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProvider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfProvider>(null as any);
    }

    /**
     * Gets the provider card.
     * @param providerID The provider identifier.
     * @param countryID (optional) The country identifier.
     */
    providerCardByProviderID(providerID: string, countryID?: string | null | undefined): Promise<Provider> {
        let url_ = this.baseUrl + "/api/v1/ConsultBooking/ProviderCardByProviderID/{providerID}?";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (countryID !== undefined && countryID !== null)
            url_ += "countryID=" + encodeURIComponent("" + countryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderCardByProviderID(_response);
        });
    }

    protected processProviderCardByProviderID(response: Response): Promise<Provider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Provider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider>(null as any);
    }
}

export class ConsultChatsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param consultChatID The identifier.
     */
    consultChatsGet(consultChatID: string): Promise<ConsultChat> {
        let url_ = this.baseUrl + "/api/v1/ConsultChats/{consultChatID}";
        if (consultChatID === undefined || consultChatID === null)
            throw new Error("The parameter 'consultChatID' must be defined.");
        url_ = url_.replace("{consultChatID}", encodeURIComponent("" + consultChatID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultChatsGet(_response);
        });
    }

    protected processConsultChatsGet(response: Response): Promise<ConsultChat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultChat.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultChat>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param consultChatID The identifier.
     */
    consultChatsDelete(consultChatID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ConsultChats/{consultChatID}";
        if (consultChatID === undefined || consultChatID === null)
            throw new Error("The parameter 'consultChatID' must be defined.");
        url_ = url_.replace("{consultChatID}", encodeURIComponent("" + consultChatID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultChatsDelete(_response);
        });
    }

    protected processConsultChatsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ConsultChat.
     * @param consultChat The ConsultChat.
     */
    consultChatsPost(consultChat: ConsultChat): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ConsultChats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultChat);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultChatsPost(_response);
        });
    }

    protected processConsultChatsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ConsultChat.
     * @param consultChat The ConsultChat.
     */
    consultChatsPut(consultChat: ConsultChat): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ConsultChats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultChat);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultChatsPut(_response);
        });
    }

    protected processConsultChatsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the consult chat file detail by consult identifier.
     * @param patientID The patient identifier.
     * @param consultID The consult identifier.
     */
    fileDetailByConsultID(patientID: string, consultID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/ConsultChats/{patientID}/FileDetailByConsultID/{consultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (consultID === undefined || consultID === null)
            throw new Error("The parameter 'consultID' must be defined.");
        url_ = url_.replace("{consultID}", encodeURIComponent("" + consultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFileDetailByConsultID(_response);
        });
    }

    protected processFileDetailByConsultID(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Gets the consult chat file detail by PHR consult identifier.
     * @param patientID The patient identifier.
     * @param phrConsultID The PHR consult identifier.
     */
    fileDetailByPHRConsultID(patientID: string, phrConsultID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/ConsultChats/{patientID}/FileDetailByPHRConsultID/{phrConsultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrConsultID === undefined || phrConsultID === null)
            throw new Error("The parameter 'phrConsultID' must be defined.");
        url_ = url_.replace("{phrConsultID}", encodeURIComponent("" + phrConsultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFileDetailByPHRConsultID(_response);
        });
    }

    protected processFileDetailByPHRConsultID(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Downloads the chat by consult identifier.
     * @param patientID The patient identifier.
     * @param consultID The consult identifier.
     */
    downloadByConsultID(patientID: string, consultID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ConsultChats/{patientID}/DownloadByConsultID/{consultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (consultID === undefined || consultID === null)
            throw new Error("The parameter 'consultID' must be defined.");
        url_ = url_.replace("{consultID}", encodeURIComponent("" + consultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadByConsultID(_response);
        });
    }

    protected processDownloadByConsultID(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Downloads the chat by PHR consult identifier.
     * @param patientID The patient identifier.
     * @param phrConsultID The PHR consult identifier.
     */
    downloadByPHRConsultID(patientID: string, phrConsultID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ConsultChats/{patientID}/DownloadByPHRConsultID/{phrConsultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrConsultID === undefined || phrConsultID === null)
            throw new Error("The parameter 'phrConsultID' must be defined.");
        url_ = url_.replace("{phrConsultID}", encodeURIComponent("" + phrConsultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadByPHRConsultID(_response);
        });
    }

    protected processDownloadByPHRConsultID(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ConsultsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets patients that are PatientReady, Inprogress or PatientCompleted statuses.
     * @param providerID The provider identifier.
     * @param sortByClinic (optional) if set to true [sort by clinic].
     */
    waitingRoomPatients(providerID: string, sortByClinic?: boolean | undefined): Promise<Consult[]> {
        let url_ = this.baseUrl + "/api/v1/Consults/WaitingRoomPatients/{ProviderID}?";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{ProviderID}", encodeURIComponent("" + providerID));
        if (sortByClinic === null)
            throw new Error("The parameter 'sortByClinic' cannot be null.");
        else if (sortByClinic !== undefined)
            url_ += "SortByClinic=" + encodeURIComponent("" + sortByClinic) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWaitingRoomPatients(_response);
        });
    }

    protected processWaitingRoomPatients(response: Response): Promise<Consult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consult[]>(null as any);
    }

    /**
     * Gets the count of patients in the waiting room for the provider
     * @param providerID The provider identifier.
     */
    waitingRoomPatientCount(providerID: string): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/Consults/WaitingRoomPatientCount/{ProviderID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{ProviderID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWaitingRoomPatientCount(_response);
        });
    }

    protected processWaitingRoomPatientCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param userDetailID The identifier.
     * @deprecated
     */
    byPatientUserDetailID(userDetailID: string): Promise<Consult[]> {
        let url_ = this.baseUrl + "/api/v1/Consults/ByPatientUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientUserDetailID(_response);
        });
    }

    protected processByPatientUserDetailID(response: Response): Promise<Consult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consult[]>(null as any);
    }

    /**
     * Returns the active consult by UserDetailID
     * @param userDetailID The user detail identifier.
     */
    activeConsultByUserDetailID(userDetailID: string): Promise<Consult> {
        let url_ = this.baseUrl + "/api/v1/Consults/ActiveConsultByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processActiveConsultByUserDetailID(_response);
        });
    }

    protected processActiveConsultByUserDetailID(response: Response): Promise<Consult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Consult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consult>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param consultID The identifier.
     */
    consultsGet(consultID: string): Promise<Consult> {
        let url_ = this.baseUrl + "/api/v1/Consults/{consultID}";
        if (consultID === undefined || consultID === null)
            throw new Error("The parameter 'consultID' must be defined.");
        url_ = url_.replace("{consultID}", encodeURIComponent("" + consultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultsGet(_response);
        });
    }

    protected processConsultsGet(response: Response): Promise<Consult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Consult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consult>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param consultID The identifier.
     */
    consultsDelete(consultID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Consults/{consultID}";
        if (consultID === undefined || consultID === null)
            throw new Error("The parameter 'consultID' must be defined.");
        url_ = url_.replace("{consultID}", encodeURIComponent("" + consultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultsDelete(_response);
        });
    }

    protected processConsultsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Consult.
     * @param consult The Consult.
     */
    consultsPost(consult: Consult): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Consults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consult);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultsPost(_response);
        });
    }

    protected processConsultsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Consult.
     * @param consult The Consult.
     */
    consultsPut(consult: Consult): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Consults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consult);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultsPut(_response);
        });
    }

    protected processConsultsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Cancel a Consult
     * @param cancelConsult The cancel consult.
     */
    cancel(cancelConsult: CancelConsultDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Consults/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cancelConsult);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Accepts the consult store item.
     * @param consultStoreItemDetails The consult store item details.
     */
    acceptConsultStoreItem(consultStoreItemDetails: ConsultStoreItemDetails): Promise<ConsultStoreItemResult> {
        let url_ = this.baseUrl + "/api/v1/Consults/AcceptConsultStoreItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultStoreItemDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAcceptConsultStoreItem(_response);
        });
    }

    protected processAcceptConsultStoreItem(response: Response): Promise<ConsultStoreItemResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultStoreItemResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultStoreItemResult>(null as any);
    }

    /**
     * Declines the consult store item.
     * @param consultStoreItemDetails The consult store item details.
     */
    declineConsultStoreItem(consultStoreItemDetails: ConsultStoreItemDetails): Promise<ConsultStoreItemResult> {
        let url_ = this.baseUrl + "/api/v1/Consults/DeclineConsultStoreItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultStoreItemDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDeclineConsultStoreItem(_response);
        });
    }

    protected processDeclineConsultStoreItem(response: Response): Promise<ConsultStoreItemResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultStoreItemResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultStoreItemResult>(null as any);
    }

    /**
     * Updates the consult store item.
     * @param consultStoreItem The consult store item.
     */
    consultStoreItemPut(consultStoreItem: ConsultStoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Consults/ConsultStoreItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultStoreItemPut(_response);
        });
    }

    protected processConsultStoreItemPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete the consult store item.
     */
    consultStoreItemDelete(consultStoreItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Consults/ConsultStoreItem/{consultStoreItemID}";
        if (consultStoreItemID === undefined || consultStoreItemID === null)
            throw new Error("The parameter 'consultStoreItemID' must be defined.");
        url_ = url_.replace("{consultStoreItemID}", encodeURIComponent("" + consultStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultStoreItemDelete(_response);
        });
    }

    protected processConsultStoreItemDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates the demo consult.
     * @param demoConsultDetails The demo consult details.
     */
    createDemoConsult(demoConsultDetails: DemoConsultDetails): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Consults/CreateDemoConsult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(demoConsultDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateDemoConsult(_response);
        });
    }

    protected processCreateDemoConsult(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Reinitializes the consult.
     * @param consultID The consult identifier.
     */
    reinitializeConsult(consultID: string): Promise<Consult> {
        let url_ = this.baseUrl + "/api/v1/Consults/ReinitializeConsult/{consultID}";
        if (consultID === undefined || consultID === null)
            throw new Error("The parameter 'consultID' must be defined.");
        url_ = url_.replace("{consultID}", encodeURIComponent("" + consultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReinitializeConsult(_response);
        });
    }

    protected processReinitializeConsult(response: Response): Promise<Consult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Consult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consult>(null as any);
    }

    /**
     * Gets the emergency consult details.
     * @param countryID The country identifier.
     */
    emergencyConsultDetails(countryID: string): Promise<EmergencyConsultDetails> {
        let url_ = this.baseUrl + "/api/v1/Consults/EmergencyConsultDetails/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEmergencyConsultDetails(_response);
        });
    }

    protected processEmergencyConsultDetails(response: Response): Promise<EmergencyConsultDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmergencyConsultDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmergencyConsultDetails>(null as any);
    }

    /**
     * Creates the emergency consult.
     * @param patientID The patient identifier.
     */
    createEmergencyConsult(patientID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Consults/CreateEmergencyConsult/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateEmergencyConsult(_response);
        });
    }

    protected processCreateEmergencyConsult(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the subscription details by user detail identifier.
     * @param userDetailID The user detail identifier.
     */
    subscriptionConsultDetails(userDetailID: string): Promise<SubscriptionConsultDetail[]> {
        let url_ = this.baseUrl + "/api/v1/Consults/SubscriptionConsultDetails/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionConsultDetails(_response);
        });
    }

    protected processSubscriptionConsultDetails(response: Response): Promise<SubscriptionConsultDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionConsultDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionConsultDetail[]>(null as any);
    }

    /**
     * Get Appointment information by InviteCodeID
     */
    appointmentDetailsByInviteCodeID(inviteCodeID: string): Promise<ProviderAppointment> {
        let url_ = this.baseUrl + "/api/v1/Consults/AppointmentDetailsByInviteCodeID/{inviteCodeID}";
        if (inviteCodeID === undefined || inviteCodeID === null)
            throw new Error("The parameter 'inviteCodeID' must be defined.");
        url_ = url_.replace("{inviteCodeID}", encodeURIComponent("" + inviteCodeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAppointmentDetailsByInviteCodeID(_response);
        });
    }

    protected processAppointmentDetailsByInviteCodeID(response: Response): Promise<ProviderAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAppointment>(null as any);
    }

    /**
     * Converts the time zones.
     */
    convertConsults(countryID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Consults/ConvertConsults/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConvertConsults(_response);
        });
    }

    protected processConvertConsults(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Sends a PDF of the entire Consult to the fax defined by the providers MyEMRFaxPhoneNumber
     */
    sendToMyEMR(sendToMyEMRDetails: SendToMyEMRDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Consults/SendToMyEMR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendToMyEMRDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendToMyEMR(_response);
        });
    }

    protected processSendToMyEMR(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Consult Search
     */
    search(consultSearchDetails: ConsultSearchDetails): Promise<Consult[]> {
        let url_ = this.baseUrl + "/api/v1/Consults/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Consult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consult[]>(null as any);
    }

    /**
     * Create an associated Home Care Consult for Video Visit by a Walk-in Doctor configured for home care walk ins
     */
    associatedHomeCareConsult(originalConsultID: string, providerID: string): Promise<Consult> {
        let url_ = this.baseUrl + "/api/v1/Consults/AssociatedHomeCareConsult/{originalConsultID}/{providerID}";
        if (originalConsultID === undefined || originalConsultID === null)
            throw new Error("The parameter 'originalConsultID' must be defined.");
        url_ = url_.replace("{originalConsultID}", encodeURIComponent("" + originalConsultID));
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAssociatedHomeCareConsult(_response);
        });
    }

    protected processAssociatedHomeCareConsult(response: Response): Promise<Consult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Consult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consult>(null as any);
    }

    /**
     * Reopen a consult and send the appropriate notifications
     */
    reopen(consultID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Consults/{consultID}/Reopen";
        if (consultID === undefined || consultID === null)
            throw new Error("The parameter 'consultID' must be defined.");
        url_ = url_.replace("{consultID}", encodeURIComponent("" + consultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReopen(_response);
        });
    }

    protected processReopen(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Reassign this consult to another provider and book it
     */
    reassign(consultID: string, providerAppointmentID: string): Promise<BookProviderAppointmentResults> {
        let url_ = this.baseUrl + "/api/v1/Consults/{consultID}/Reassign/{providerAppointmentID}";
        if (consultID === undefined || consultID === null)
            throw new Error("The parameter 'consultID' must be defined.");
        url_ = url_.replace("{consultID}", encodeURIComponent("" + consultID));
        if (providerAppointmentID === undefined || providerAppointmentID === null)
            throw new Error("The parameter 'providerAppointmentID' must be defined.");
        url_ = url_.replace("{providerAppointmentID}", encodeURIComponent("" + providerAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReassign(_response);
        });
    }

    protected processReassign(response: Response): Promise<BookProviderAppointmentResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookProviderAppointmentResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookProviderAppointmentResults>(null as any);
    }

    /**
     * Return "active" consults that are using the ProviderStoreItemID
     */
    consultsUsingProviderStoreItemID(providerStoreItemID: string): Promise<Consult[]> {
        let url_ = this.baseUrl + "/api/v1/Consults/ConsultsUsingProviderStoreItemID/{providerStoreItemID}";
        if (providerStoreItemID === undefined || providerStoreItemID === null)
            throw new Error("The parameter 'providerStoreItemID' must be defined.");
        url_ = url_.replace("{providerStoreItemID}", encodeURIComponent("" + providerStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultsUsingProviderStoreItemID(_response);
        });
    }

    protected processConsultsUsingProviderStoreItemID(response: Response): Promise<Consult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Consult[]>(null as any);
    }
}

export class CoralpayClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Invokes the specified invoice identifier.
     * @param invoiceID The invoice identifier.
     */
    invoke(invoiceID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Coralpay/invoke/{invoiceID}";
        if (invoiceID === undefined || invoiceID === null)
            throw new Error("The parameter 'invoiceID' must be defined.");
        url_ = url_.replace("{invoiceID}", encodeURIComponent("" + invoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoke(_response);
        });
    }

    protected processInvoke(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Transactions the status callback.
     * @param encryptedTransactionStatus The encrypted transaction status.
     */
    transactionStatusCallback(encryptedTransactionStatus: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Coralpay/transactionStatusCallback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(encryptedTransactionStatus);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTransactionStatusCallback(_response);
        });
    }

    protected processTransactionStatusCallback(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Statuses the query.
     * @param invoiceId (optional) The invoice identifier.
     */
    statusQuery(invoiceId?: string | undefined): Promise<TransactionStatusDTO> {
        let url_ = this.baseUrl + "/api/v1/Coralpay/statusQuery?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStatusQuery(_response);
        });
    }

    protected processStatusQuery(response: Response): Promise<TransactionStatusDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionStatusDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionStatusDTO>(null as any);
    }
}

export class CouponsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all Coupons - ADMIN
     */
    admin(): Promise<Coupon[]> {
        let url_ = this.baseUrl + "/api/v1/Coupons/Admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Coupon[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Coupon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Coupon[]>(null as any);
    }

    /**
     * Gets all Coupons by storeid - ADMIN
     */
    adminByStoreID(storeID: string): Promise<Coupon[]> {
        let url_ = this.baseUrl + "/api/v1/Coupons/AdminByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByStoreID(_response);
        });
    }

    protected processAdminByStoreID(response: Response): Promise<Coupon[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Coupon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Coupon[]>(null as any);
    }

    /**
     * Gets all Coupons.
     */
    all(): Promise<Coupon[]> {
        let url_ = this.baseUrl + "/api/v1/Coupons/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Coupon[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Coupon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Coupon[]>(null as any);
    }

    /**
     * Gets all StoreCoupons.
     */
    byStoreID(storeID: string): Promise<Coupon[]> {
        let url_ = this.baseUrl + "/api/v1/Coupons/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<Coupon[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Coupon.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Coupon[]>(null as any);
    }

    /**
     * Gets The Coupon.
     */
    couponsGet(couponID: string): Promise<Coupon> {
        let url_ = this.baseUrl + "/api/v1/Coupons/{couponID}";
        if (couponID === undefined || couponID === null)
            throw new Error("The parameter 'couponID' must be defined.");
        url_ = url_.replace("{couponID}", encodeURIComponent("" + couponID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCouponsGet(_response);
        });
    }

    protected processCouponsGet(response: Response): Promise<Coupon> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Coupon.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Coupon>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param couponID The identifier.
     */
    couponsDelete(couponID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Coupons/{couponID}";
        if (couponID === undefined || couponID === null)
            throw new Error("The parameter 'couponID' must be defined.");
        url_ = url_.replace("{couponID}", encodeURIComponent("" + couponID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCouponsDelete(_response);
        });
    }

    protected processCouponsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Coupon.
     * @param coupon The Coupon.
     */
    couponsPost(coupon: Coupon): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Coupons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coupon);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCouponsPost(_response);
        });
    }

    protected processCouponsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Coupon.
     * @param coupon The Coupon.
     */
    couponsPut(coupon: Coupon): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Coupons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coupon);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCouponsPut(_response);
        });
    }

    protected processCouponsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DashboardClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the dashboard.
     */
    patientDashboard(): Promise<PatientDashboardDTO> {
        let url_ = this.baseUrl + "/api/v1/Dashboard/PatientDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientDashboard(_response);
        });
    }

    protected processPatientDashboard(response: Response): Promise<PatientDashboardDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientDashboardDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientDashboardDTO>(null as any);
    }
}

export class DepartmentsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Department[]> {
        let url_ = this.baseUrl + "/api/v1/Departments/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Department[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Department.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param departmentID The identifier.
     */
    departmentsGet(departmentID: string): Promise<Department> {
        let url_ = this.baseUrl + "/api/v1/Departments/{departmentID}";
        if (departmentID === undefined || departmentID === null)
            throw new Error("The parameter 'departmentID' must be defined.");
        url_ = url_.replace("{departmentID}", encodeURIComponent("" + departmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDepartmentsGet(_response);
        });
    }

    protected processDepartmentsGet(response: Response): Promise<Department> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Department.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param departmentID The identifier.
     */
    departmentsDelete(departmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Departments/{departmentID}";
        if (departmentID === undefined || departmentID === null)
            throw new Error("The parameter 'departmentID' must be defined.");
        url_ = url_.replace("{departmentID}", encodeURIComponent("" + departmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDepartmentsDelete(_response);
        });
    }

    protected processDepartmentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Department.
     * @param department The Department.
     */
    departmentsPost(department: Department): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Departments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(department);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDepartmentsPost(_response);
        });
    }

    protected processDepartmentsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Department.
     */
    departmentsPut(department: Department): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Departments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(department);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDepartmentsPut(_response);
        });
    }

    protected processDepartmentsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiscussionBlockedDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionBlockedDetail[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionBlockedDetails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionBlockedDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionBlockedDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionBlockedDetail[]>(null as any);
    }

    /**
     * Gets the by discussion identifier.
     * @param discussionID The discussion identifier.
     */
    byDiscussionID(discussionID: string): Promise<DiscussionBlockedDetail[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionBlockedDetails/ByDiscussionID/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionID(_response);
        });
    }

    protected processByDiscussionID(response: Response): Promise<DiscussionBlockedDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionBlockedDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionBlockedDetail[]>(null as any);
    }

    /**
     * Gets the by userdetail.
     * @param userDetailID The discussion identifier.
     */
    byUserDetailID(userDetailID: string): Promise<DiscussionBlockedDetail[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionBlockedDetails/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<DiscussionBlockedDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionBlockedDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionBlockedDetail[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionBlockedDetailID The identifier.
     */
    discussionBlockedDetails(discussionBlockedDetailID: string): Promise<DiscussionBlockedDetail> {
        let url_ = this.baseUrl + "/api/v1/DiscussionBlockedDetails/{discussionBlockedDetailID}";
        if (discussionBlockedDetailID === undefined || discussionBlockedDetailID === null)
            throw new Error("The parameter 'discussionBlockedDetailID' must be defined.");
        url_ = url_.replace("{discussionBlockedDetailID}", encodeURIComponent("" + discussionBlockedDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionBlockedDetails(_response);
        });
    }

    protected processDiscussionBlockedDetails(response: Response): Promise<DiscussionBlockedDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionBlockedDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionBlockedDetail>(null as any);
    }

    /**
     * Blocks the specified DiscussionBlockedDetail.
     * @param discussionBlockedDetail The DiscussionBlockedDetail.
     */
    block(discussionBlockedDetail: DiscussionBlockedDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionBlockedDetails/Block";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionBlockedDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlock(_response);
        });
    }

    protected processBlock(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Unblocks the specified DiscussionBlockedDetail.
     * @param discussionBlockedDetail The DiscussionBlockedDetail.
     */
    unBlock(discussionBlockedDetail: DiscussionBlockedDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionBlockedDetails/UnBlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionBlockedDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUnBlock(_response);
        });
    }

    protected processUnBlock(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiscussionCategoryClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionCategory[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionCategory[]>(null as any);
    }

    /**
     * Gets all discussionCategory.
     */
    allDiscussionCategory(): Promise<DiscussionCategory[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory/allDiscussionCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllDiscussionCategory(_response);
        });
    }

    protected processAllDiscussionCategory(response: Response): Promise<DiscussionCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionCategory[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<DiscussionCategory[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<DiscussionCategory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionCategory[]>(null as any);
    }

    discussionCategoryGet(discussionCategoryID: string): Promise<DiscussionCategory> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory/{discussionCategoryID}";
        if (discussionCategoryID === undefined || discussionCategoryID === null)
            throw new Error("The parameter 'discussionCategoryID' must be defined.");
        url_ = url_.replace("{discussionCategoryID}", encodeURIComponent("" + discussionCategoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionCategoryGet(_response);
        });
    }

    protected processDiscussionCategoryGet(response: Response): Promise<DiscussionCategory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionCategory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionCategory>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionCategoryID The identifier.
     */
    discussionCategoryDelete(discussionCategoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory/{discussionCategoryID}";
        if (discussionCategoryID === undefined || discussionCategoryID === null)
            throw new Error("The parameter 'discussionCategoryID' must be defined.");
        url_ = url_.replace("{discussionCategoryID}", encodeURIComponent("" + discussionCategoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionCategoryDelete(_response);
        });
    }

    protected processDiscussionCategoryDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assign the userDetailID to be moderators of the discussionCategory list
     */
    assignmoderator(discussionCategory: string[], userDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory/assignmoderator/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionCategory);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAssignmoderator(_response);
        });
    }

    protected processAssignmoderator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove the userDetailID as moderator of the discussionCategory list
     */
    removemoderator(discussionCategory: string[], userDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory/removemoderator/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionCategory);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRemovemoderator(_response);
        });
    }

    protected processRemovemoderator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified discussionCategory.
     * @param discussionCategory The discussionCategory.
     */
    discussionCategoryPost(discussionCategory: DiscussionCategory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionCategory);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionCategoryPost(_response);
        });
    }

    protected processDiscussionCategoryPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified discussionCategory setting.
     * @param discussionCategory The discussionCategory setting.
     */
    discussionCategoryPut(discussionCategory: DiscussionCategory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionCategory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionCategoryPut(_response);
        });
    }

    protected processDiscussionCategoryPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiscussionFollowersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier by discussionID
     * @param discussionID The identifier.
     */
    byDiscussionID(discussionID: string): Promise<DiscussionFollower[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionFollowers/ByDiscussionID/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionID(_response);
        });
    }

    protected processByDiscussionID(response: Response): Promise<DiscussionFollower[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionFollower.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionFollower[]>(null as any);
    }

    /**
     * Gets the specified identifier by userDetailID
     * @param userDetailID The identifier.
     */
    byUserDetailID(userDetailID: string): Promise<DiscussionFollower[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionFollowers/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<DiscussionFollower[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionFollower.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionFollower[]>(null as any);
    }

    /**
     * Posts the specified DiscussionFollower.
     * @param discussionFollower The DiscussionFollower.
     */
    discussionFollowersPost(discussionFollower: DiscussionFollower): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionFollowers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionFollower);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionFollowersPost(_response);
        });
    }

    protected processDiscussionFollowersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionFollowerID The identifier.
     */
    discussionFollowersDelete(discussionFollowerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionFollowers/{discussionFollowerID}";
        if (discussionFollowerID === undefined || discussionFollowerID === null)
            throw new Error("The parameter 'discussionFollowerID' must be defined.");
        url_ = url_.replace("{discussionFollowerID}", encodeURIComponent("" + discussionFollowerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionFollowersDelete(_response);
        });
    }

    protected processDiscussionFollowersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DiscussionImagesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionImage[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionImages/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionImage[]>(null as any);
    }

    /**
     * Get the images by sort key {male, female}
     */
    many(sort: string): Promise<DiscussionImage[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionImages/sortby/many/{sort}";
        if (sort === undefined || sort === null)
            throw new Error("The parameter 'sort' must be defined.");
        url_ = url_.replace("{sort}", encodeURIComponent("" + sort));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<DiscussionImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionImage[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionImageID The identifier.
     */
    discussionImagesGet(discussionImageID: string): Promise<DiscussionImage> {
        let url_ = this.baseUrl + "/api/v1/DiscussionImages/{discussionImageID}";
        if (discussionImageID === undefined || discussionImageID === null)
            throw new Error("The parameter 'discussionImageID' must be defined.");
        url_ = url_.replace("{discussionImageID}", encodeURIComponent("" + discussionImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionImagesGet(_response);
        });
    }

    protected processDiscussionImagesGet(response: Response): Promise<DiscussionImage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionImage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionImage>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionImageID The identifier.
     */
    discussionImagesDelete(discussionImageID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionImages/{discussionImageID}";
        if (discussionImageID === undefined || discussionImageID === null)
            throw new Error("The parameter 'discussionImageID' must be defined.");
        url_ = url_.replace("{discussionImageID}", encodeURIComponent("" + discussionImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionImagesDelete(_response);
        });
    }

    protected processDiscussionImagesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * uploads the specified DiscussionImage.
     * @param fileDetail The DiscussionImage.
     */
    upload(fileDetail: FileDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionImages/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * uploads the specified DiscussionImage.
     * @param imageDetailID The DiscussionImage.
     */
    generate(imageDetailID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionImages/generate/{imageDetailID}";
        if (imageDetailID === undefined || imageDetailID === null)
            throw new Error("The parameter 'imageDetailID' must be defined.");
        url_ = url_.replace("{imageDetailID}", encodeURIComponent("" + imageDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGenerate(_response);
        });
    }

    protected processGenerate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * uploads the specified DiscussionImage.
     * @param discussionImage The DiscussionImage.
     */
    discussionImagesPost(discussionImage: DiscussionImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionImagesPost(_response);
        });
    }

    protected processDiscussionImagesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * upload the specified DiscussionImages.
     * @param discussionImages The DiscussionImage.
     */
    uploadMany(discussionImages: DiscussionImage[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionImages/uploadMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionImages);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUploadMany(_response);
        });
    }

    protected processUploadMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class DiscussionItemBannedWordsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all DiscussionItemBannedWord for admin
     */
    admin(): Promise<DiscussionItemBannedWord[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBannedWords/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<DiscussionItemBannedWord[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemBannedWord.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemBannedWord[]>(null as any);
    }

    /**
     * Gets all DiscussionItemBannedWords.
     */
    all(): Promise<DiscussionItemBannedWord[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBannedWords/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionItemBannedWord[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemBannedWord.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemBannedWord[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionItemBannedWordID The identifier.
     */
    discussionItemBannedWordsGet(discussionItemBannedWordID: string): Promise<DiscussionItemBannedWord> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBannedWords/{discussionItemBannedWordID}";
        if (discussionItemBannedWordID === undefined || discussionItemBannedWordID === null)
            throw new Error("The parameter 'discussionItemBannedWordID' must be defined.");
        url_ = url_.replace("{discussionItemBannedWordID}", encodeURIComponent("" + discussionItemBannedWordID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemBannedWordsGet(_response);
        });
    }

    protected processDiscussionItemBannedWordsGet(response: Response): Promise<DiscussionItemBannedWord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionItemBannedWord.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemBannedWord>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionItemBannedWordID The identifier.
     */
    discussionItemBannedWordsDelete(discussionItemBannedWordID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBannedWords/{discussionItemBannedWordID}";
        if (discussionItemBannedWordID === undefined || discussionItemBannedWordID === null)
            throw new Error("The parameter 'discussionItemBannedWordID' must be defined.");
        url_ = url_.replace("{discussionItemBannedWordID}", encodeURIComponent("" + discussionItemBannedWordID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemBannedWordsDelete(_response);
        });
    }

    protected processDiscussionItemBannedWordsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified DiscussionItemBannedWord.
     * @param discussionItemBannedWord The DiscussionItemBannedWord.
     */
    discussionItemBannedWordsPost(discussionItemBannedWord: DiscussionItemBannedWord): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBannedWords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemBannedWord);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemBannedWordsPost(_response);
        });
    }

    protected processDiscussionItemBannedWordsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified DiscussionItemBannedWord.
     * @param discussionItemBannedWords The DiscussionItemBannedWord.
     */
    discussionItemBannedWordsPut(discussionItemBannedWords: DiscussionItemBannedWord): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBannedWords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemBannedWords);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemBannedWordsPut(_response);
        });
    }

    protected processDiscussionItemBannedWordsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param items The items.
     */
    many(items: DiscussionItemBannedWord[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBannedWords/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Posts the bulk.
     * @param bannedWords The items.
     */
    bulk(bannedWords: string[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBannedWords/Bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bannedWords);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBulk(_response);
        });
    }

    protected processBulk(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class DiscussionItemBlockedDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionItemBlockedDetail[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBlockedDetails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionItemBlockedDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemBlockedDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemBlockedDetail[]>(null as any);
    }

    /**
     * Gets the by discussion identifier.
     * @param discussionItemID The discussion identifier.
     */
    byDiscussionItemID(discussionItemID: string): Promise<DiscussionItemBlockedDetail[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBlockedDetails/ByDiscussionItemID/{discussionItemID}";
        if (discussionItemID === undefined || discussionItemID === null)
            throw new Error("The parameter 'discussionItemID' must be defined.");
        url_ = url_.replace("{discussionItemID}", encodeURIComponent("" + discussionItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionItemID(_response);
        });
    }

    protected processByDiscussionItemID(response: Response): Promise<DiscussionItemBlockedDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemBlockedDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemBlockedDetail[]>(null as any);
    }

    /**
     * Gets the by userDetailID.
     * @param userDetailID The discussion identifier.
     */
    byUserDetailID(userDetailID: string): Promise<DiscussionItemBlockedDetail[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBlockedDetails/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<DiscussionItemBlockedDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemBlockedDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemBlockedDetail[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionItemBlockedDetailID The identifier.
     */
    discussionItemBlockedDetails(discussionItemBlockedDetailID: string): Promise<DiscussionItemBlockedDetail> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBlockedDetails/{discussionItemBlockedDetailID}";
        if (discussionItemBlockedDetailID === undefined || discussionItemBlockedDetailID === null)
            throw new Error("The parameter 'discussionItemBlockedDetailID' must be defined.");
        url_ = url_.replace("{discussionItemBlockedDetailID}", encodeURIComponent("" + discussionItemBlockedDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemBlockedDetails(_response);
        });
    }

    protected processDiscussionItemBlockedDetails(response: Response): Promise<DiscussionItemBlockedDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionItemBlockedDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemBlockedDetail>(null as any);
    }

    /**
     * Blocks the specified DiscussionItemBlockedDetail.
     * @param discussionItemBlockedDetail The DiscussionItemBlockedDetail.
     */
    block(discussionItemBlockedDetail: DiscussionItemBlockedDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBlockedDetails/Block";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemBlockedDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlock(_response);
        });
    }

    protected processBlock(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * UnBlocks the specified DiscussionItemBlockedDetail.
     * @param discussionItemBlockedDetail The DiscussionItemBlockedDetail.
     */
    unBlock(discussionItemBlockedDetail: DiscussionItemBlockedDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemBlockedDetails/UnBlock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemBlockedDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUnBlock(_response);
        });
    }

    protected processUnBlock(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiscussionItemFollowersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier by discussionItemID
     * @param discussionItemID The identifier.
     */
    byDiscussionItemID(discussionItemID: string): Promise<DiscussionItemFollower[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemFollowers/ByDiscussionItemID/{discussionItemID}";
        if (discussionItemID === undefined || discussionItemID === null)
            throw new Error("The parameter 'discussionItemID' must be defined.");
        url_ = url_.replace("{discussionItemID}", encodeURIComponent("" + discussionItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionItemID(_response);
        });
    }

    protected processByDiscussionItemID(response: Response): Promise<DiscussionItemFollower[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemFollower.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemFollower[]>(null as any);
    }

    /**
     * Gets the specified identifier by userDetailID
     * @param userDetailID The identifier.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    byUserDetailID(userDetailID: string, recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<PagedResultOfDiscussionItemFollower> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemFollowers/ByUserDetailID/{userDetailID}?";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<PagedResultOfDiscussionItemFollower> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfDiscussionItemFollower.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfDiscussionItemFollower>(null as any);
    }

    /**
     * Posts the specified DiscussionItemFollower.
     * @param discussionItemFollower The DiscussionItemFollower.
     */
    discussionItemFollowersPost(discussionItemFollower: DiscussionItemFollower): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemFollowers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemFollower);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemFollowersPost(_response);
        });
    }

    protected processDiscussionItemFollowersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionItemFollowerID The identifier.
     */
    discussionItemFollowersDelete(discussionItemFollowerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemFollowers/{discussionItemFollowerID}";
        if (discussionItemFollowerID === undefined || discussionItemFollowerID === null)
            throw new Error("The parameter 'discussionItemFollowerID' must be defined.");
        url_ = url_.replace("{discussionItemFollowerID}", encodeURIComponent("" + discussionItemFollowerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemFollowersDelete(_response);
        });
    }

    protected processDiscussionItemFollowersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DiscussionItemLikesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier by discussionItemID
     * @param discussionItemID The identifier.
     */
    byDiscussionItemID(discussionItemID: string): Promise<DiscussionItemLike[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemLikes/ByDiscussionItemID/{discussionItemID}";
        if (discussionItemID === undefined || discussionItemID === null)
            throw new Error("The parameter 'discussionItemID' must be defined.");
        url_ = url_.replace("{discussionItemID}", encodeURIComponent("" + discussionItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionItemID(_response);
        });
    }

    protected processByDiscussionItemID(response: Response): Promise<DiscussionItemLike[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemLike.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemLike[]>(null as any);
    }

    /**
     * Gets the specified identifier by userDetailID
     * @param userDetailID The identifier.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    byUserDetailID(userDetailID: string, recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<PagedResultOfDiscussionItemLike> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemLikes/ByUserDetailID/{userDetailID}?";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<PagedResultOfDiscussionItemLike> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfDiscussionItemLike.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfDiscussionItemLike>(null as any);
    }

    /**
     * Posts the specified DiscussionItemLike.
     * @param discussionItemLike The DiscussionItemLike.
     */
    discussionItemLikesPost(discussionItemLike: DiscussionItemLike): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemLikes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemLike);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemLikesPost(_response);
        });
    }

    protected processDiscussionItemLikesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionItemLikeID The identifier.
     */
    discussionItemLikesDelete(discussionItemLikeID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemLikes/{discussionItemLikeID}";
        if (discussionItemLikeID === undefined || discussionItemLikeID === null)
            throw new Error("The parameter 'discussionItemLikeID' must be defined.");
        url_ = url_.replace("{discussionItemLikeID}", encodeURIComponent("" + discussionItemLikeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemLikesDelete(_response);
        });
    }

    protected processDiscussionItemLikesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DiscussionItemReportsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionItemReport[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemReports/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionItemReport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemReport[]>(null as any);
    }

    /**
     * Gets the specified identifier by discussionItemID
     * @param discussionItemID The identifier.
     */
    byDiscussionItemID(discussionItemID: string): Promise<DiscussionItemReport[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemReports/ByDiscussionItemID/{discussionItemID}";
        if (discussionItemID === undefined || discussionItemID === null)
            throw new Error("The parameter 'discussionItemID' must be defined.");
        url_ = url_.replace("{discussionItemID}", encodeURIComponent("" + discussionItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionItemID(_response);
        });
    }

    protected processByDiscussionItemID(response: Response): Promise<DiscussionItemReport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemReport[]>(null as any);
    }

    /**
     * Gets the specified identifier by userDetailID
     * @param userDetailID The identifier.
     */
    byUserDetailID(userDetailID: string): Promise<DiscussionItemReport[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemReports/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<DiscussionItemReport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemReport[]>(null as any);
    }

    /**
     * Gets the item reports summary.
    The discussion identifier.
     */
    summary(discussionID: string): Promise<DiscussionItemReportSummary[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemReports/summary/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: Response): Promise<DiscussionItemReportSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemReportSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemReportSummary[]>(null as any);
    }

    /**
     * Posts the specified DiscussionItemReport.
     * @param discussionItemReport The DiscussionItemReport.
     */
    discussionItemReportsPost(discussionItemReport: DiscussionItemReport): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemReport);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemReportsPost(_response);
        });
    }

    protected processDiscussionItemReportsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionItemReportID The identifier.
     */
    discussionItemReportsDelete(discussionItemReportID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemReports/{discussionItemReportID}";
        if (discussionItemReportID === undefined || discussionItemReportID === null)
            throw new Error("The parameter 'discussionItemReportID' must be defined.");
        url_ = url_.replace("{discussionItemReportID}", encodeURIComponent("" + discussionItemReportID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemReportsDelete(_response);
        });
    }

    protected processDiscussionItemReportsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DiscussionItemsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param discussionItemID The identifier.
     */
    discussionItemsGet(discussionItemID: string): Promise<DiscussionItem> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems/{discussionItemID}";
        if (discussionItemID === undefined || discussionItemID === null)
            throw new Error("The parameter 'discussionItemID' must be defined.");
        url_ = url_.replace("{discussionItemID}", encodeURIComponent("" + discussionItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemsGet(_response);
        });
    }

    protected processDiscussionItemsGet(response: Response): Promise<DiscussionItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItem>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionItemID The identifier.
     */
    discussionItemsDelete(discussionItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems/{discussionItemID}";
        if (discussionItemID === undefined || discussionItemID === null)
            throw new Error("The parameter 'discussionItemID' must be defined.");
        url_ = url_.replace("{discussionItemID}", encodeURIComponent("" + discussionItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemsDelete(_response);
        });
    }

    protected processDiscussionItemsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the popular.
     * @param discussionID The discussion identifier.
     * @param count The count.
     */
    popular(discussionID: string, count: number): Promise<DiscussionItem[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems/Popular/{discussionID}/{count}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        if (count === undefined || count === null)
            throw new Error("The parameter 'count' must be defined.");
        url_ = url_.replace("{count}", encodeURIComponent("" + count));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPopular(_response);
        });
    }

    protected processPopular(response: Response): Promise<DiscussionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItem[]>(null as any);
    }

    /**
     * Gets discussionItems Paginated.
    The Discussion.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    getDiscussionItems(recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<GetDiscussionItemsDto> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems/getDiscussionItems?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetDiscussionItems(_response);
        });
    }

    protected processGetDiscussionItems(response: Response): Promise<GetDiscussionItemsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDiscussionItemsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDiscussionItemsDto>(null as any);
    }

    /**
     * Discussions the search.
      SearchScopeAllTopics = "AllTopics";
      SearchScopeCurrentTopic = "CurrentTopic";
      SearchScopeCurrentDiscussion = "CurrentDiscussion";
     * @param discussionSearchDetails The discussion search details.
     */
    search(discussionSearchDetails: DiscussionSearchDetails): Promise<DiscussionSearchResults> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<DiscussionSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionSearchResults>(null as any);
    }

    /**
     * Posts the specified DiscussionItem.
     * @param discussionItem The Discussion.
     */
    discussionItemsPost(discussionItem: DiscussionItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemsPost(_response);
        });
    }

    protected processDiscussionItemsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Discussion.
     * @param discussionItem The Discussion.
     */
    discussionItemsPut(discussionItem: DiscussionItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemsPut(_response);
        });
    }

    protected processDiscussionItemsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the item summary.
    The discussion identifier.
    The discussion identifier.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    summary(discussionID: string, recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<PagedResultOfDiscussionItem> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems/summary/{discussionID}?";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: Response): Promise<PagedResultOfDiscussionItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfDiscussionItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfDiscussionItem>(null as any);
    }

    /**
     * Gets the specified identifier by userDetailID
     * @param userDetailID The identifier.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     * @param post (optional) The identifier.
     * @param comment (optional) The identifier.
     * @param like (optional) The identifier.
     * @param bookmark (optional) The identifier.
     */
    activityByUserDetailID(userDetailID: string, recordsToSkip?: number | undefined, recordsToTake?: number | undefined, post?: boolean | undefined, comment?: boolean | undefined, like?: boolean | undefined, bookmark?: boolean | undefined): Promise<PagedResultOfDiscussionItem> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItems/ActivityByUserDetailID/{userDetailID}?";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        if (post === null)
            throw new Error("The parameter 'post' cannot be null.");
        else if (post !== undefined)
            url_ += "post=" + encodeURIComponent("" + post) + "&";
        if (comment === null)
            throw new Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (like === null)
            throw new Error("The parameter 'like' cannot be null.");
        else if (like !== undefined)
            url_ += "like=" + encodeURIComponent("" + like) + "&";
        if (bookmark === null)
            throw new Error("The parameter 'bookmark' cannot be null.");
        else if (bookmark !== undefined)
            url_ += "bookmark=" + encodeURIComponent("" + bookmark) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processActivityByUserDetailID(_response);
        });
    }

    protected processActivityByUserDetailID(response: Response): Promise<PagedResultOfDiscussionItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfDiscussionItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfDiscussionItem>(null as any);
    }
}

export class DiscussionItemTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionItemTag[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemTags/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionItemTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemTag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionItemTagID The identifier.
     */
    discussionItemTagsGet(discussionItemTagID: string): Promise<DiscussionItemTag> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemTags/{discussionItemTagID}";
        if (discussionItemTagID === undefined || discussionItemTagID === null)
            throw new Error("The parameter 'discussionItemTagID' must be defined.");
        url_ = url_.replace("{discussionItemTagID}", encodeURIComponent("" + discussionItemTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemTagsGet(_response);
        });
    }

    protected processDiscussionItemTagsGet(response: Response): Promise<DiscussionItemTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionItemTag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemTag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionItemTagID The identifier.
     */
    discussionItemTagsDelete(discussionItemTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemTags/{discussionItemTagID}";
        if (discussionItemTagID === undefined || discussionItemTagID === null)
            throw new Error("The parameter 'discussionItemTagID' must be defined.");
        url_ = url_.replace("{discussionItemTagID}", encodeURIComponent("" + discussionItemTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemTagsDelete(_response);
        });
    }

    protected processDiscussionItemTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionItemID The identifier.
     */
    discussionItemID(discussionItemID: string): Promise<DiscussionItemTag[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemTags/discussionItemID/{discussionItemID}";
        if (discussionItemID === undefined || discussionItemID === null)
            throw new Error("The parameter 'discussionItemID' must be defined.");
        url_ = url_.replace("{discussionItemID}", encodeURIComponent("" + discussionItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemID(_response);
        });
    }

    protected processDiscussionItemID(response: Response): Promise<DiscussionItemTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItemTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItemTag[]>(null as any);
    }

    /**
     * Posts the specified DiscussionItemTag.
     * @param discussionItemTag The DiscussionItemTag.
     */
    discussionItemTagsPost(discussionItemTag: DiscussionItemTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemTagsPost(_response);
        });
    }

    protected processDiscussionItemTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified DiscussionItemTag.
     * @param discussionItemTag The DiscussionItemTag.
     */
    discussionItemTagsPut(discussionItemTag: DiscussionItemTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionItemTagsPut(_response);
        });
    }

    protected processDiscussionItemTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts many DiscussionItemTags.
     * @param discussionItemID The DiscussionID.
     * @param discussionItemTags The DiscussionItemTags.
     */
    tags(discussionItemID: string, discussionItemTags: string[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemTags/{discussionItemID}/Tags";
        if (discussionItemID === undefined || discussionItemID === null)
            throw new Error("The parameter 'discussionItemID' must be defined.");
        url_ = url_.replace("{discussionItemID}", encodeURIComponent("" + discussionItemID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionItemTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTags(_response);
        });
    }

    protected processTags(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param count The count.
     */
    trending(count: number): Promise<TrendingTag[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionItemTags/Trending/{count}";
        if (count === undefined || count === null)
            throw new Error("The parameter 'count' must be defined.");
        url_ = url_.replace("{count}", encodeURIComponent("" + count));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTrending(_response);
        });
    }

    protected processTrending(response: Response): Promise<TrendingTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrendingTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrendingTag[]>(null as any);
    }
}

export class DiscussionModeratorsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionModerator[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionModerators/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionModerator[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionModerator.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionModerator[]>(null as any);
    }

    /**
     * Gets the by discussion identifier.
     * @param discussionID The discussion identifier.
     */
    byDiscussionID(discussionID: string): Promise<DiscussionModerator[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionModerators/ByDiscussionID/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionID(_response);
        });
    }

    protected processByDiscussionID(response: Response): Promise<DiscussionModerator[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionModerator.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionModerator[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionModeratorID The identifier.
     */
    discussionModeratorsGet(discussionModeratorID: string): Promise<DiscussionModerator> {
        let url_ = this.baseUrl + "/api/v1/DiscussionModerators/{discussionModeratorID}";
        if (discussionModeratorID === undefined || discussionModeratorID === null)
            throw new Error("The parameter 'discussionModeratorID' must be defined.");
        url_ = url_.replace("{discussionModeratorID}", encodeURIComponent("" + discussionModeratorID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionModeratorsGet(_response);
        });
    }

    protected processDiscussionModeratorsGet(response: Response): Promise<DiscussionModerator> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionModerator.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionModerator>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionModeratorID The identifier.
     */
    discussionModeratorsDelete(discussionModeratorID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionModerators/{discussionModeratorID}";
        if (discussionModeratorID === undefined || discussionModeratorID === null)
            throw new Error("The parameter 'discussionModeratorID' must be defined.");
        url_ = url_.replace("{discussionModeratorID}", encodeURIComponent("" + discussionModeratorID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionModeratorsDelete(_response);
        });
    }

    protected processDiscussionModeratorsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified DiscussionModerator.
     * @param discussionModerator The DiscussionModerator.
     */
    discussionModeratorsPost(discussionModerator: DiscussionModerator): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionModerators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionModerator);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionModeratorsPost(_response);
        });
    }

    protected processDiscussionModeratorsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified DiscussionModerator.
     * @param discussionModerator The DiscussionModerator.
     */
    discussionModeratorsPut(discussionModerator: DiscussionModerator): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionModerators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionModerator);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionModeratorsPut(_response);
        });
    }

    protected processDiscussionModeratorsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiscussionReportsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionReport[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionReports/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionReport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionReport[]>(null as any);
    }

    /**
     * Gets the specified identifier by discussionID
     * @param discussionID The identifier.
     */
    byDiscussionID(discussionID: string): Promise<DiscussionReport[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionReports/ByDiscussionID/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionID(_response);
        });
    }

    protected processByDiscussionID(response: Response): Promise<DiscussionReport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionReport[]>(null as any);
    }

    /**
     * Gets the specified identifier by userDetailID
     * @param userDetailID The identifier.
     */
    byUserDetailID(userDetailID: string): Promise<DiscussionReport[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionReports/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<DiscussionReport[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionReport.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionReport[]>(null as any);
    }

    /**
     * Gets the reports summary.
     */
    summary(): Promise<DiscussionReportSummary[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionReports/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: Response): Promise<DiscussionReportSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionReportSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionReportSummary[]>(null as any);
    }

    /**
     * Posts the specified DiscussionReport.
     * @param discussionReport The DiscussionReport.
     */
    discussionReportsPost(discussionReport: DiscussionReport): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionReport);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionReportsPost(_response);
        });
    }

    protected processDiscussionReportsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionReportID The identifier.
     */
    discussionReportsDelete(discussionReportID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionReports/{discussionReportID}";
        if (discussionReportID === undefined || discussionReportID === null)
            throw new Error("The parameter 'discussionReportID' must be defined.");
        url_ = url_.replace("{discussionReportID}", encodeURIComponent("" + discussionReportID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionReportsDelete(_response);
        });
    }

    protected processDiscussionReportsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DiscussionRolesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionRole[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionRoles/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionRole[]>(null as any);
    }

    /**
     * Gets the by discussion identifier.
     * @param discussionID The discussion identifier.
     */
    byDiscussionID(discussionID: string): Promise<DiscussionRole[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionRoles/ByDiscussionID/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionID(_response);
        });
    }

    protected processByDiscussionID(response: Response): Promise<DiscussionRole[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionRole.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionRole[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionRoleID The identifier.
     */
    discussionRolesGet(discussionRoleID: string): Promise<DiscussionRole> {
        let url_ = this.baseUrl + "/api/v1/DiscussionRoles/{discussionRoleID}";
        if (discussionRoleID === undefined || discussionRoleID === null)
            throw new Error("The parameter 'discussionRoleID' must be defined.");
        url_ = url_.replace("{discussionRoleID}", encodeURIComponent("" + discussionRoleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionRolesGet(_response);
        });
    }

    protected processDiscussionRolesGet(response: Response): Promise<DiscussionRole> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionRole.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionRole>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionRoleID The identifier.
     */
    discussionRolesDelete(discussionRoleID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionRoles/{discussionRoleID}";
        if (discussionRoleID === undefined || discussionRoleID === null)
            throw new Error("The parameter 'discussionRoleID' must be defined.");
        url_ = url_.replace("{discussionRoleID}", encodeURIComponent("" + discussionRoleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionRolesDelete(_response);
        });
    }

    protected processDiscussionRolesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified DiscussionRole.
     * @param discussionRole The DiscussionRole.
     */
    discussionRolesPost(discussionRole: DiscussionRole): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionRole);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionRolesPost(_response);
        });
    }

    protected processDiscussionRolesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified DiscussionRole.
     * @param discussionRole The DiscussionRole.
     */
    discussionRolesPut(discussionRole: DiscussionRole): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionRole);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionRolesPut(_response);
        });
    }

    protected processDiscussionRolesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiscussionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all discussions.
     */
    allDiscussions(): Promise<Discussion[]> {
        let url_ = this.baseUrl + "/api/v1/Discussions/allDiscussions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllDiscussions(_response);
        });
    }

    protected processAllDiscussions(response: Response): Promise<Discussion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Discussion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Discussion[]>(null as any);
    }

    /**
     * Gets random discussion username.
     */
    discussionUsername(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Discussions/discussionUsername";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionUsername(_response);
        });
    }

    protected processDiscussionUsername(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets discussions discussionIDs.
     * @param discussionIDs The Discussion.
     */
    getDiscussions(discussionIDs: string[]): Promise<Discussion[]> {
        let url_ = this.baseUrl + "/api/v1/Discussions/getDiscussions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionIDs);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetDiscussions(_response);
        });
    }

    protected processGetDiscussions(response: Response): Promise<Discussion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Discussion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Discussion[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<Discussion[]> {
        let url_ = this.baseUrl + "/api/v1/Discussions/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Discussion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Discussion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Discussion[]>(null as any);
    }

    /**
     * Gets the popular.
     * @param count The count.
     */
    popular(count: number): Promise<DiscussionItem[]> {
        let url_ = this.baseUrl + "/api/v1/Discussions/Popular/{count}";
        if (count === undefined || count === null)
            throw new Error("The parameter 'count' must be defined.");
        url_ = url_.replace("{count}", encodeURIComponent("" + count));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPopular(_response);
        });
    }

    protected processPopular(response: Response): Promise<DiscussionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionItem[]>(null as any);
    }

    /**
     * Gets the topic summary.
     */
    summary(): Promise<DiscussionTopicSummary[]> {
        let url_ = this.baseUrl + "/api/v1/Discussions/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: Response): Promise<DiscussionTopicSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionTopicSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionTopicSummary[]>(null as any);
    }

    /**
     * Get a summary for the moderator
     */
    moderatorSummary(discussionID: string): Promise<DiscussionModeratorSummary> {
        let url_ = this.baseUrl + "/api/v1/Discussions/ModeratorSummary/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModeratorSummary(_response);
        });
    }

    protected processModeratorSummary(response: Response): Promise<DiscussionModeratorSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionModeratorSummary.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionModeratorSummary>(null as any);
    }

    discussionsGet(discussionID: string, includeChildren?: boolean | undefined): Promise<Discussion> {
        let url_ = this.baseUrl + "/api/v1/Discussions/{discussionID}?";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        if (includeChildren === null)
            throw new Error("The parameter 'includeChildren' cannot be null.");
        else if (includeChildren !== undefined)
            url_ += "includeChildren=" + encodeURIComponent("" + includeChildren) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionsGet(_response);
        });
    }

    protected processDiscussionsGet(response: Response): Promise<Discussion> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Discussion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Discussion>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionID The identifier.
     */
    discussionsDelete(discussionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Discussions/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionsDelete(_response);
        });
    }

    protected processDiscussionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assign the userDetailID to be moderators of the discussion list
     */
    assignmoderator(discussions: string[], userDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Discussions/assignmoderator/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussions);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAssignmoderator(_response);
        });
    }

    protected processAssignmoderator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove the userDetailID as moderator of the discussion list
     */
    removemoderator(discussions: string[], userDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Discussions/removemoderator/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussions);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRemovemoderator(_response);
        });
    }

    protected processRemovemoderator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified discussion.
     * @param discussion The discussion.
     */
    discussionsPost(discussion: Discussion): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Discussions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussion);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionsPost(_response);
        });
    }

    protected processDiscussionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified discussion setting.
     * @param discussion The discussion setting.
     */
    discussionsPut(discussion: Discussion): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Discussions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussion);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionsPut(_response);
        });
    }

    protected processDiscussionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DiscussionTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionTag[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionTags/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionTag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionTagID The identifier.
     */
    discussionTagsGet(discussionTagID: string): Promise<DiscussionTag> {
        let url_ = this.baseUrl + "/api/v1/DiscussionTags/{discussionTagID}";
        if (discussionTagID === undefined || discussionTagID === null)
            throw new Error("The parameter 'discussionTagID' must be defined.");
        url_ = url_.replace("{discussionTagID}", encodeURIComponent("" + discussionTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionTagsGet(_response);
        });
    }

    protected processDiscussionTagsGet(response: Response): Promise<DiscussionTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionTag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionTag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionTagID The identifier.
     */
    discussionTagsDelete(discussionTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionTags/{discussionTagID}";
        if (discussionTagID === undefined || discussionTagID === null)
            throw new Error("The parameter 'discussionTagID' must be defined.");
        url_ = url_.replace("{discussionTagID}", encodeURIComponent("" + discussionTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionTagsDelete(_response);
        });
    }

    protected processDiscussionTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionID The identifier.
     */
    discussionID(discussionID: string): Promise<DiscussionTag[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionTags/discussionID/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionID(_response);
        });
    }

    protected processDiscussionID(response: Response): Promise<DiscussionTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionTag[]>(null as any);
    }

    /**
     * Posts the specified DiscussionTag.
     * @param discussionTag The DiscussionTag.
     */
    discussionTagsPost(discussionTag: DiscussionTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionTagsPost(_response);
        });
    }

    protected processDiscussionTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified DiscussionTag.
     * @param discussionTag The DiscussionTag.
     */
    discussionTagsPut(discussionTag: DiscussionTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionTagsPut(_response);
        });
    }

    protected processDiscussionTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts many DiscussionTags.
     * @param discussionID The DiscussionID.
     * @param discussionTags The DiscussionTags.
     */
    tags(discussionID: string, discussionTags: string[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionTags/{discussionID}/Tags";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTags(_response);
        });
    }

    protected processTags(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class DiscussionUserDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<DiscussionUserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionUserDetails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<DiscussionUserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionUserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionUserDetail[]>(null as any);
    }

    /**
     * Gets the by discussion identifier.
     * @param discussionID The discussion identifier.
     */
    byDiscussionID(discussionID: string): Promise<DiscussionUserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/DiscussionUserDetails/ByDiscussionID/{discussionID}";
        if (discussionID === undefined || discussionID === null)
            throw new Error("The parameter 'discussionID' must be defined.");
        url_ = url_.replace("{discussionID}", encodeURIComponent("" + discussionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByDiscussionID(_response);
        });
    }

    protected processByDiscussionID(response: Response): Promise<DiscussionUserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiscussionUserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionUserDetail[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param discussionUserDetailID The identifier.
     */
    discussionUserDetailsGet(discussionUserDetailID: string): Promise<DiscussionUserDetail> {
        let url_ = this.baseUrl + "/api/v1/DiscussionUserDetails/{discussionUserDetailID}";
        if (discussionUserDetailID === undefined || discussionUserDetailID === null)
            throw new Error("The parameter 'discussionUserDetailID' must be defined.");
        url_ = url_.replace("{discussionUserDetailID}", encodeURIComponent("" + discussionUserDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionUserDetailsGet(_response);
        });
    }

    protected processDiscussionUserDetailsGet(response: Response): Promise<DiscussionUserDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscussionUserDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionUserDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param discussionUserDetailID The identifier.
     */
    discussionUserDetailsDelete(discussionUserDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/DiscussionUserDetails/{discussionUserDetailID}";
        if (discussionUserDetailID === undefined || discussionUserDetailID === null)
            throw new Error("The parameter 'discussionUserDetailID' must be defined.");
        url_ = url_.replace("{discussionUserDetailID}", encodeURIComponent("" + discussionUserDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionUserDetailsDelete(_response);
        });
    }

    protected processDiscussionUserDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified DiscussionTag.
     * @param discussionTag The DiscussionTag.
     */
    discussionUserDetailsPost(discussionTag: DiscussionUserDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionUserDetailsPost(_response);
        });
    }

    protected processDiscussionUserDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified DiscussionTag.
     * @param discussionUserDetail The DiscussionTag.
     */
    discussionUserDetailsPut(discussionUserDetail: DiscussionUserDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/DiscussionUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discussionUserDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDiscussionUserDetailsPut(_response);
        });
    }

    protected processDiscussionUserDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DocumentsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Uploads the file.
     * @param fileDetail The form file.
     */
    upload(fileDetail: FileDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Documents/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Downloads the file.
     * @param documentID The document identifier.
     */
    download(documentID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Documents/download/{documentID}";
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download the File Detail for the document
     */
    downloadFileDetail(documentID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/Documents/DownloadFileDetail/{documentID}";
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadFileDetail(_response);
        });
    }

    protected processDownloadFileDetail(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Gets all.
     */
    all(): Promise<Document[]> {
        let url_ = this.baseUrl + "/api/v1/Documents/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Document[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Document.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Document[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param documentID The identifier.
     */
    documentsGet(documentID: string): Promise<Document> {
        let url_ = this.baseUrl + "/api/v1/Documents/{documentID}";
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDocumentsGet(_response);
        });
    }

    protected processDocumentsGet(response: Response): Promise<Document> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Document.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Document>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param documentID The identifier.
     */
    documentsDelete(documentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Documents/{documentID}";
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDocumentsDelete(_response);
        });
    }

    protected processDocumentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified document.
     * @param document The document.
     */
    documentsPost(document: Document): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(document);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDocumentsPost(_response);
        });
    }

    protected processDocumentsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified document.
     * @param document The document.
     */
    documentsPut(document: Document): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(document);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDocumentsPut(_response);
        });
    }

    protected processDocumentsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EmailTokensClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<EmailToken[]> {
        let url_ = this.baseUrl + "/api/v1/EmailTokens/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<EmailToken[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailToken.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailToken[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param emailTokenID The identifier.
     */
    emailTokensGet(emailTokenID: string): Promise<EmailToken> {
        let url_ = this.baseUrl + "/api/v1/EmailTokens/{emailTokenID}";
        if (emailTokenID === undefined || emailTokenID === null)
            throw new Error("The parameter 'emailTokenID' must be defined.");
        url_ = url_.replace("{emailTokenID}", encodeURIComponent("" + emailTokenID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEmailTokensGet(_response);
        });
    }

    protected processEmailTokensGet(response: Response): Promise<EmailToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailToken.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailToken>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param emailTokenID The identifier.
     */
    emailTokensDelete(emailTokenID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/EmailTokens/{emailTokenID}";
        if (emailTokenID === undefined || emailTokenID === null)
            throw new Error("The parameter 'emailTokenID' must be defined.");
        url_ = url_.replace("{emailTokenID}", encodeURIComponent("" + emailTokenID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEmailTokensDelete(_response);
        });
    }

    protected processEmailTokensDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified email token.
     * @param emailToken The email token.
     */
    emailTokensPost(emailToken: EmailToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/EmailTokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailToken);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEmailTokensPost(_response);
        });
    }

    protected processEmailTokensPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified email token.
     * @param emailToken The email token.
     */
    emailTokensPut(emailToken: EmailToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/EmailTokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailToken);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEmailTokensPut(_response);
        });
    }

    protected processEmailTokensPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ErrorLogsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get by Date
     * @param startDate (optional) The start date.
     * @param endDate (optional) The end date.
     */
    dateRange(startDate?: Date | undefined, endDate?: Date | undefined): Promise<ErrorLog[]> {
        let url_ = this.baseUrl + "/api/v1/ErrorLogs/DateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDateRange(_response);
        });
    }

    protected processDateRange(response: Response): Promise<ErrorLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErrorLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorLog[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param errorLogID The identifier.
     */
    errorLogsGet(errorLogID: string): Promise<ErrorLog> {
        let url_ = this.baseUrl + "/api/v1/ErrorLogs/{errorLogID}";
        if (errorLogID === undefined || errorLogID === null)
            throw new Error("The parameter 'errorLogID' must be defined.");
        url_ = url_.replace("{errorLogID}", encodeURIComponent("" + errorLogID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processErrorLogsGet(_response);
        });
    }

    protected processErrorLogsGet(response: Response): Promise<ErrorLog> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorLog.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorLog>(null as any);
    }

    /**
     * Deletes the specified pk.
     * @param errorLogID The pk.
     */
    errorLogsDelete(errorLogID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ErrorLogs/{errorLogID}";
        if (errorLogID === undefined || errorLogID === null)
            throw new Error("The parameter 'errorLogID' must be defined.");
        url_ = url_.replace("{errorLogID}", encodeURIComponent("" + errorLogID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processErrorLogsDelete(_response);
        });
    }

    protected processErrorLogsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified error log.
     * @param errorLog The error log.
     */
    errorLogsPost(errorLog: ErrorLog): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ErrorLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(errorLog);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processErrorLogsPost(_response);
        });
    }

    protected processErrorLogsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified error log.
     * @param errorLog The error log.
     */
    errorLogsPut(errorLog: ErrorLog): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ErrorLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(errorLog);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processErrorLogsPut(_response);
        });
    }

    protected processErrorLogsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Log an Error - authenticate using APIKEY
     * @param errorLog The error log.
     */
    logError(apiKey: string, errorLog: ErrorLog): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ErrorLogs/LogError/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(errorLog);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLogError(_response);
        });
    }

    protected processLogError(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class EStoresClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all enabled EStores
     */
    storesByCountry(countryID: string): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/EStores/StoresByCountry/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoresByCountry(_response);
        });
    }

    protected processStoresByCountry(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Gets all enabled EStore Items
     */
    storeItemsByStoreID(storeID: string): Promise<StoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/EStores/StoreItemsByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemsByStoreID(_response);
        });
    }

    protected processStoreItemsByStoreID(response: Response): Promise<StoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItem[]>(null as any);
    }

    /**
     * Get
     */
    eStoreOrdersByStoreID(storeID: string): Promise<Order[]> {
        let url_ = this.baseUrl + "/api/v1/EStores/EStoreOrdersByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEStoreOrdersByStoreID(_response);
        });
    }

    protected processEStoreOrdersByStoreID(response: Response): Promise<Order[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Order.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order[]>(null as any);
    }
}

export class FaxesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param faxID The identifier.
     */
    faxesGet(faxID: string): Promise<Fax> {
        let url_ = this.baseUrl + "/api/v1/Faxes/{faxID}";
        if (faxID === undefined || faxID === null)
            throw new Error("The parameter 'faxID' must be defined.");
        url_ = url_.replace("{faxID}", encodeURIComponent("" + faxID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFaxesGet(_response);
        });
    }

    protected processFaxesGet(response: Response): Promise<Fax> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Fax.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Fax>(null as any);
    }

    /**
     * Sends the fax
     * @param fax The fax.
     */
    faxesPost(fax: Fax): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Faxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fax);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFaxesPost(_response);
        });
    }

    protected processFaxesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update Fax
     */
    faxesPut(fax: Fax): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Faxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fax);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFaxesPut(_response);
        });
    }

    protected processFaxesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Sends the fax
     * @param transactionIDType (optional) 
     * @param transactionID (optional) 
     * @param phoneNumber (optional) 
     * @param messageType (optional) 
     * @param messageSize (optional) 
     * @param remoteCSID (optional) 
     * @param pages (optional) 
     * @param status (optional) 
     * @param recordingDuration (optional) 
     * @param receiveTime (optional) 
     * @param callerID (optional) 
     */
    inbound(transactionIDType?: string | null | undefined, transactionID?: number | undefined, phoneNumber?: string | null | undefined, messageType?: number | undefined, messageSize?: number | undefined, remoteCSID?: string | null | undefined, pages?: number | undefined, status?: number | undefined, recordingDuration?: number | undefined, receiveTime?: string | null | undefined, callerID?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Faxes/Inbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (transactionIDType !== null && transactionIDType !== undefined)
            content_.append("TransactionIDType", transactionIDType.toString());
        if (transactionID === null || transactionID === undefined)
            throw new Error("The parameter 'transactionID' cannot be null.");
        else
            content_.append("TransactionID", transactionID.toString());
        if (phoneNumber !== null && phoneNumber !== undefined)
            content_.append("PhoneNumber", phoneNumber.toString());
        if (messageType === null || messageType === undefined)
            throw new Error("The parameter 'messageType' cannot be null.");
        else
            content_.append("MessageType", messageType.toString());
        if (messageSize === null || messageSize === undefined)
            throw new Error("The parameter 'messageSize' cannot be null.");
        else
            content_.append("MessageSize", messageSize.toString());
        if (remoteCSID !== null && remoteCSID !== undefined)
            content_.append("RemoteCSID", remoteCSID.toString());
        if (pages === null || pages === undefined)
            throw new Error("The parameter 'pages' cannot be null.");
        else
            content_.append("Pages", pages.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (recordingDuration === null || recordingDuration === undefined)
            throw new Error("The parameter 'recordingDuration' cannot be null.");
        else
            content_.append("RecordingDuration", recordingDuration.toString());
        if (receiveTime !== null && receiveTime !== undefined)
            content_.append("ReceiveTime", receiveTime.toString());
        if (callerID !== null && callerID !== undefined)
            content_.append("CallerID", callerID.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInbound(_response);
        });
    }

    protected processInbound(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sends the fax
     * @param completionTime (optional) 
     * @param contact (optional) 
     * @param costPerUnit (optional) 
     * @param deleteAfterUsage (optional) 
     * @param destinationFax (optional) 
     * @param duration (optional) 
     * @param jobID (optional) 
     * @param messageID (optional) 
     * @param mode (optional) 
     * @param numOfTransactions (optional) 
     * @param pageHeader (optional) 
     * @param pageOrientation (optional) 
     * @param pageResolution (optional) 
     * @param pageSize (optional) 
     * @param pagesSent (optional) 
     * @param pagesSubmitted (optional) 
     * @param parentTransactionID (optional) 
     * @param postponeTime (optional) 
     * @param priority (optional) 
     * @param remoteCSID (optional) 
     * @param renderingQuality (optional) 
     * @param replyEmail (optional) 
     * @param retriesInterval (optional) 
     * @param retriesToPerform (optional) 
     * @param senderCSID (optional) 
     * @param status (optional) 
     * @param subject (optional) 
     * @param submitTime (optional) 
     * @param trialsPerformed (optional) 
     * @param units (optional) 
     * @param userData (optional) 
     * @param userID (optional) 
     * @param transactionID (optional) 
     */
    outbound(completionTime?: string | null | undefined, contact?: string | null | undefined, costPerUnit?: number | undefined, deleteAfterUsage?: string | null | undefined, destinationFax?: string | null | undefined, duration?: number | undefined, jobID?: string | null | undefined, messageID?: string | null | undefined, mode?: string | null | undefined, numOfTransactions?: number | undefined, pageHeader?: string | null | undefined, pageOrientation?: string | null | undefined, pageResolution?: string | null | undefined, pageSize?: string | null | undefined, pagesSent?: number | undefined, pagesSubmitted?: number | undefined, parentTransactionID?: number | undefined, postponeTime?: string | null | undefined, priority?: number | undefined, remoteCSID?: string | null | undefined, renderingQuality?: string | null | undefined, replyEmail?: string | null | undefined, retriesInterval?: number | undefined, retriesToPerform?: number | undefined, senderCSID?: string | null | undefined, status?: number | undefined, subject?: string | null | undefined, submitTime?: string | null | undefined, trialsPerformed?: number | undefined, units?: number | undefined, userData?: string | null | undefined, userID?: string | null | undefined, transactionID?: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/Faxes/Outbound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (completionTime !== null && completionTime !== undefined)
            content_.append("CompletionTime", completionTime.toString());
        if (contact !== null && contact !== undefined)
            content_.append("Contact", contact.toString());
        if (costPerUnit === null || costPerUnit === undefined)
            throw new Error("The parameter 'costPerUnit' cannot be null.");
        else
            content_.append("CostPerUnit", costPerUnit.toString());
        if (deleteAfterUsage !== null && deleteAfterUsage !== undefined)
            content_.append("DeleteAfterUsage", deleteAfterUsage.toString());
        if (destinationFax !== null && destinationFax !== undefined)
            content_.append("DestinationFax", destinationFax.toString());
        if (duration === null || duration === undefined)
            throw new Error("The parameter 'duration' cannot be null.");
        else
            content_.append("Duration", duration.toString());
        if (jobID !== null && jobID !== undefined)
            content_.append("JobID", jobID.toString());
        if (messageID !== null && messageID !== undefined)
            content_.append("MessageID", messageID.toString());
        if (mode !== null && mode !== undefined)
            content_.append("Mode", mode.toString());
        if (numOfTransactions === null || numOfTransactions === undefined)
            throw new Error("The parameter 'numOfTransactions' cannot be null.");
        else
            content_.append("NumOfTransactions", numOfTransactions.toString());
        if (pageHeader !== null && pageHeader !== undefined)
            content_.append("PageHeader", pageHeader.toString());
        if (pageOrientation !== null && pageOrientation !== undefined)
            content_.append("PageOrientation", pageOrientation.toString());
        if (pageResolution !== null && pageResolution !== undefined)
            content_.append("PageResolution", pageResolution.toString());
        if (pageSize !== null && pageSize !== undefined)
            content_.append("PageSize", pageSize.toString());
        if (pagesSent === null || pagesSent === undefined)
            throw new Error("The parameter 'pagesSent' cannot be null.");
        else
            content_.append("PagesSent", pagesSent.toString());
        if (pagesSubmitted === null || pagesSubmitted === undefined)
            throw new Error("The parameter 'pagesSubmitted' cannot be null.");
        else
            content_.append("PagesSubmitted", pagesSubmitted.toString());
        if (parentTransactionID === null || parentTransactionID === undefined)
            throw new Error("The parameter 'parentTransactionID' cannot be null.");
        else
            content_.append("ParentTransactionID", parentTransactionID.toString());
        if (postponeTime !== null && postponeTime !== undefined)
            content_.append("PostponeTime", postponeTime.toString());
        if (priority === null || priority === undefined)
            throw new Error("The parameter 'priority' cannot be null.");
        else
            content_.append("Priority", priority.toString());
        if (remoteCSID !== null && remoteCSID !== undefined)
            content_.append("RemoteCSID", remoteCSID.toString());
        if (renderingQuality !== null && renderingQuality !== undefined)
            content_.append("RenderingQuality", renderingQuality.toString());
        if (replyEmail !== null && replyEmail !== undefined)
            content_.append("ReplyEmail", replyEmail.toString());
        if (retriesInterval === null || retriesInterval === undefined)
            throw new Error("The parameter 'retriesInterval' cannot be null.");
        else
            content_.append("RetriesInterval", retriesInterval.toString());
        if (retriesToPerform === null || retriesToPerform === undefined)
            throw new Error("The parameter 'retriesToPerform' cannot be null.");
        else
            content_.append("RetriesToPerform", retriesToPerform.toString());
        if (senderCSID !== null && senderCSID !== undefined)
            content_.append("SenderCSID", senderCSID.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (subject !== null && subject !== undefined)
            content_.append("Subject", subject.toString());
        if (submitTime !== null && submitTime !== undefined)
            content_.append("SubmitTime", submitTime.toString());
        if (trialsPerformed === null || trialsPerformed === undefined)
            throw new Error("The parameter 'trialsPerformed' cannot be null.");
        else
            content_.append("TrialsPerformed", trialsPerformed.toString());
        if (units === null || units === undefined)
            throw new Error("The parameter 'units' cannot be null.");
        else
            content_.append("Units", units.toString());
        if (userData !== null && userData !== undefined)
            content_.append("UserData", userData.toString());
        if (userID !== null && userID !== undefined)
            content_.append("UserID", userID.toString());
        if (transactionID === null || transactionID === undefined)
            throw new Error("The parameter 'transactionID' cannot be null.");
        else
            content_.append("TransactionID", transactionID.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOutbound(_response);
        });
    }

    protected processOutbound(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get by Date
     * @param startDate (optional) The start date.
     * @param endDate (optional) The end date.
     */
    dateRange(startDate?: Date | undefined, endDate?: Date | undefined): Promise<Fax[]> {
        let url_ = this.baseUrl + "/api/v1/Faxes/DateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDateRange(_response);
        });
    }

    protected processDateRange(response: Response): Promise<Fax[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Fax.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Fax[]>(null as any);
    }

    /**
     * Gets all new unread email Count.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    incoming(recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<PagedResultOfFax> {
        let url_ = this.baseUrl + "/api/v1/Faxes/Incoming?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processIncoming(_response);
        });
    }

    protected processIncoming(response: Response): Promise<PagedResultOfFax> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfFax.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfFax>(null as any);
    }

    /**
     * Gets all new unread email Count.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    forwarded(recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<PagedResultOfFax> {
        let url_ = this.baseUrl + "/api/v1/Faxes/Forwarded?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processForwarded(_response);
        });
    }

    protected processForwarded(response: Response): Promise<PagedResultOfFax> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfFax.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfFax>(null as any);
    }

    /**
     * Gets all new unread email Count.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    deleted(recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<PagedResultOfFax> {
        let url_ = this.baseUrl + "/api/v1/Faxes/Deleted?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDeleted(_response);
        });
    }

    protected processDeleted(response: Response): Promise<PagedResultOfFax> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfFax.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfFax>(null as any);
    }

    /**
     * Download the File Detail for the Fax Attachment
     */
    download(faxAttachmentID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Faxes/download/{faxAttachmentID}";
        if (faxAttachmentID === undefined || faxAttachmentID === null)
            throw new Error("The parameter 'faxAttachmentID' must be defined.");
        url_ = url_.replace("{faxAttachmentID}", encodeURIComponent("" + faxAttachmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download the File Detail for the Fax Attachment as a file detail
     */
    downloadAsFileDetail(faxAttachmentID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/Faxes/downloadAsFileDetail/{faxAttachmentID}";
        if (faxAttachmentID === undefined || faxAttachmentID === null)
            throw new Error("The parameter 'faxAttachmentID' must be defined.");
        url_ = url_.replace("{faxAttachmentID}", encodeURIComponent("" + faxAttachmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadAsFileDetail(_response);
        });
    }

    protected processDownloadAsFileDetail(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Sends the file detail as fax.
     * @param sendFaxDetails The send fax details.
     */
    sendFileDetailFax(sendFaxDetails: SendFaxDetails): Promise<SendFaxResult> {
        let url_ = this.baseUrl + "/api/v1/Faxes/SendFileDetailFax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendFaxDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendFileDetailFax(_response);
        });
    }

    protected processSendFileDetailFax(response: Response): Promise<SendFaxResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendFaxResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendFaxResult>(null as any);
    }

    /**
     * Get fax details owned by the UserDetailID and optionally the FaxSource (Prescription, Lab, referral etc)
     */
    faxDetails(faxDetails: FaxDetails): Promise<Fax[]> {
        let url_ = this.baseUrl + "/api/v1/Faxes/FaxDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(faxDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFaxDetails(_response);
        });
    }

    protected processFaxDetails(response: Response): Promise<Fax[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Fax.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Fax[]>(null as any);
    }

    /**
     * Resend fax
     */
    resend(faxID: string): Promise<SendFaxResult> {
        let url_ = this.baseUrl + "/api/v1/Faxes/Resend/{faxID}";
        if (faxID === undefined || faxID === null)
            throw new Error("The parameter 'faxID' must be defined.");
        url_ = url_.replace("{faxID}", encodeURIComponent("" + faxID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processResend(_response);
        });
    }

    protected processResend(response: Response): Promise<SendFaxResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendFaxResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendFaxResult>(null as any);
    }
}

export class FeedbacksClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified start date.
     * @param startDate (optional) The start date.
     * @param endDate (optional) The end date.
     */
    dateRange(startDate?: Date | undefined, endDate?: Date | undefined): Promise<Feedback[]> {
        let url_ = this.baseUrl + "/api/v1/Feedbacks/DateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDateRange(_response);
        });
    }

    protected processDateRange(response: Response): Promise<Feedback[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Feedback.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Feedback[]>(null as any);
    }

    /**
     * Gets all.
     */
    all(): Promise<Feedback[]> {
        let url_ = this.baseUrl + "/api/v1/Feedbacks/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Feedback[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Feedback.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Feedback[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param feedbackID The identifier.
     */
    feedbacksGet(feedbackID: string): Promise<Feedback> {
        let url_ = this.baseUrl + "/api/v1/Feedbacks/{FeedbackID}";
        if (feedbackID === undefined || feedbackID === null)
            throw new Error("The parameter 'feedbackID' must be defined.");
        url_ = url_.replace("{FeedbackID}", encodeURIComponent("" + feedbackID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFeedbacksGet(_response);
        });
    }

    protected processFeedbacksGet(response: Response): Promise<Feedback> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Feedback.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Feedback>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param feedbackID The identifier.
     */
    feedbacksDelete(feedbackID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Feedbacks/{FeedbackID}";
        if (feedbackID === undefined || feedbackID === null)
            throw new Error("The parameter 'feedbackID' must be defined.");
        url_ = url_.replace("{FeedbackID}", encodeURIComponent("" + feedbackID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFeedbacksDelete(_response);
        });
    }

    protected processFeedbacksDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Feedback.
     * @param feedback The Feedback.
     */
    feedbacksPost(feedback: Feedback): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Feedbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedback);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFeedbacksPost(_response);
        });
    }

    protected processFeedbacksPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Feedback.
     * @param feedback The feedback.
     */
    feedbacksPut(feedback: Feedback): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Feedbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedback);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFeedbacksPut(_response);
        });
    }

    protected processFeedbacksPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets all.
     */
    processFeedbacks(): Promise<ProcessFeedbackResult> {
        let url_ = this.baseUrl + "/api/v1/Feedbacks/ProcessFeedbacks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProcessFeedbacks(_response);
        });
    }

    protected processProcessFeedbacks(response: Response): Promise<ProcessFeedbackResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessFeedbackResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessFeedbackResult>(null as any);
    }
}

export class FileDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param fileDetailID The identifier.
     */
    fileDetailsGet(fileDetailID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/FileDetails/{fileDetailID}";
        if (fileDetailID === undefined || fileDetailID === null)
            throw new Error("The parameter 'fileDetailID' must be defined.");
        url_ = url_.replace("{fileDetailID}", encodeURIComponent("" + fileDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFileDetailsGet(_response);
        });
    }

    protected processFileDetailsGet(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param fileDetailID The identifier.
     */
    fileDetailsDelete(fileDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/FileDetails/{fileDetailID}";
        if (fileDetailID === undefined || fileDetailID === null)
            throw new Error("The parameter 'fileDetailID' must be defined.");
        url_ = url_.replace("{fileDetailID}", encodeURIComponent("" + fileDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFileDetailsDelete(_response);
        });
    }

    protected processFileDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified file.
     * @param file The file.
     */
    fileDetailsPost(file: FileDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FileDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFileDetailsPost(_response);
        });
    }

    protected processFileDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified file.
     * @param file The file.
     */
    fileDetailsPut(file: FileDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FileDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFileDetailsPut(_response);
        });
    }

    protected processFileDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Downloads the original.
     * @param fileDetailID The file detail identifier.
     */
    original(fileDetailID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/FileDetails/{fileDetailID}/Original";
        if (fileDetailID === undefined || fileDetailID === null)
            throw new Error("The parameter 'fileDetailID' must be defined.");
        url_ = url_.replace("{fileDetailID}", encodeURIComponent("" + fileDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOriginal(_response);
        });
    }

    protected processOriginal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Upload a image resource
     */
    uploadResource(fileDetail: FileDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FileDetails/UploadResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUploadResource(_response);
        });
    }

    protected processUploadResource(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class FormQuestionChoicesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all Forms.
     */
    admin(): Promise<FormQuestionChoice[]> {
        let url_ = this.baseUrl + "/api/v1/FormQuestionChoices/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<FormQuestionChoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormQuestionChoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestionChoice[]>(null as any);
    }

    /**
     * Gets the FormQuestionChoice by FormQuestionChoice identifier.
     * @param formQuestionChoiceID The form question identifier.
     */
    formQuestionChoicesGet(formQuestionChoiceID: string): Promise<FormQuestionChoice> {
        let url_ = this.baseUrl + "/api/v1/FormQuestionChoices/{formQuestionChoiceID}";
        if (formQuestionChoiceID === undefined || formQuestionChoiceID === null)
            throw new Error("The parameter 'formQuestionChoiceID' must be defined.");
        url_ = url_.replace("{formQuestionChoiceID}", encodeURIComponent("" + formQuestionChoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormQuestionChoicesGet(_response);
        });
    }

    protected processFormQuestionChoicesGet(response: Response): Promise<FormQuestionChoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormQuestionChoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestionChoice>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param formQuestionChoiceID The identifier.
     */
    formQuestionChoicesDelete(formQuestionChoiceID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/FormQuestionChoices/{formQuestionChoiceID}";
        if (formQuestionChoiceID === undefined || formQuestionChoiceID === null)
            throw new Error("The parameter 'formQuestionChoiceID' must be defined.");
        url_ = url_.replace("{formQuestionChoiceID}", encodeURIComponent("" + formQuestionChoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormQuestionChoicesDelete(_response);
        });
    }

    protected processFormQuestionChoicesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the questions for the supplied FormQuestion
     */
    adminByFormQuestionID(formQuestionID: string): Promise<FormQuestionChoice[]> {
        let url_ = this.baseUrl + "/api/v1/FormQuestionChoices/AdminByFormQuestionID/{formQuestionID}";
        if (formQuestionID === undefined || formQuestionID === null)
            throw new Error("The parameter 'formQuestionID' must be defined.");
        url_ = url_.replace("{formQuestionID}", encodeURIComponent("" + formQuestionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByFormQuestionID(_response);
        });
    }

    protected processAdminByFormQuestionID(response: Response): Promise<FormQuestionChoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormQuestionChoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestionChoice[]>(null as any);
    }

    /**
     * Get the questions for the supplied FormQuestion
     */
    byFormQuestionID(formQuestionID: string): Promise<FormQuestionChoice[]> {
        let url_ = this.baseUrl + "/api/v1/FormQuestionChoices/ByFormQuestionID/{formQuestionID}";
        if (formQuestionID === undefined || formQuestionID === null)
            throw new Error("The parameter 'formQuestionID' must be defined.");
        url_ = url_.replace("{formQuestionID}", encodeURIComponent("" + formQuestionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByFormQuestionID(_response);
        });
    }

    protected processByFormQuestionID(response: Response): Promise<FormQuestionChoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormQuestionChoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestionChoice[]>(null as any);
    }

    /**
     * Posts the specified FormQuestionChoice.
     * @param formQuestionChoice The form question.
     */
    formQuestionChoicesPost(formQuestionChoice: FormQuestionChoice): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FormQuestionChoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formQuestionChoice);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormQuestionChoicesPost(_response);
        });
    }

    protected processFormQuestionChoicesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified FormQuestionChoice.
     * @param formQuestionChoice The form question choice.
     */
    formQuestionChoicesPut(formQuestionChoice: FormQuestionChoice): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FormQuestionChoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formQuestionChoice);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormQuestionChoicesPut(_response);
        });
    }

    protected processFormQuestionChoicesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class FormQuestionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all Forms.
     */
    admin(): Promise<FormQuestion[]> {
        let url_ = this.baseUrl + "/api/v1/FormQuestions/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<FormQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormQuestion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestion[]>(null as any);
    }

    /**
     * Gets the formQuestion by formQuestion identifier.
     * @param formQuestionID The form question identifier.
     */
    formQuestionsGet(formQuestionID: string): Promise<FormQuestion> {
        let url_ = this.baseUrl + "/api/v1/FormQuestions/{formQuestionID}";
        if (formQuestionID === undefined || formQuestionID === null)
            throw new Error("The parameter 'formQuestionID' must be defined.");
        url_ = url_.replace("{formQuestionID}", encodeURIComponent("" + formQuestionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormQuestionsGet(_response);
        });
    }

    protected processFormQuestionsGet(response: Response): Promise<FormQuestion> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormQuestion.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestion>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param formQuestionID The identifier.
     */
    formQuestionsDelete(formQuestionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/FormQuestions/{formQuestionID}";
        if (formQuestionID === undefined || formQuestionID === null)
            throw new Error("The parameter 'formQuestionID' must be defined.");
        url_ = url_.replace("{formQuestionID}", encodeURIComponent("" + formQuestionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormQuestionsDelete(_response);
        });
    }

    protected processFormQuestionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the questions for the supplied Form
     */
    adminByFormID(formID: string): Promise<FormQuestion[]> {
        let url_ = this.baseUrl + "/api/v1/FormQuestions/AdminByFormID/{formID}";
        if (formID === undefined || formID === null)
            throw new Error("The parameter 'formID' must be defined.");
        url_ = url_.replace("{formID}", encodeURIComponent("" + formID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByFormID(_response);
        });
    }

    protected processAdminByFormID(response: Response): Promise<FormQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormQuestion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestion[]>(null as any);
    }

    /**
     * Get the questions for the supplied Form
     */
    byFormID(formID: string): Promise<FormQuestion[]> {
        let url_ = this.baseUrl + "/api/v1/FormQuestions/ByFormID/{formID}";
        if (formID === undefined || formID === null)
            throw new Error("The parameter 'formID' must be defined.");
        url_ = url_.replace("{formID}", encodeURIComponent("" + formID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByFormID(_response);
        });
    }

    protected processByFormID(response: Response): Promise<FormQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormQuestion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormQuestion[]>(null as any);
    }

    /**
     * Posts the specified FormQuestion.
     * @param formQuestion The form question.
     */
    formQuestionsPost(formQuestion: FormQuestion): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FormQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formQuestion);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormQuestionsPost(_response);
        });
    }

    protected processFormQuestionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified FormQuestion.
     * @param formQuestion The form question.
     */
    formQuestionsPut(formQuestion: FormQuestion): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FormQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formQuestion);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormQuestionsPut(_response);
        });
    }

    protected processFormQuestionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class FormsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all Forms.
     */
    admin(): Promise<Form[]> {
        let url_ = this.baseUrl + "/api/v1/Forms/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Form[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Form.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Form[]>(null as any);
    }

    /**
     * Get all available forms
     */
    all(): Promise<Form[]> {
        let url_ = this.baseUrl + "/api/v1/Forms/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Form[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Form.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Form[]>(null as any);
    }

    /**
     * Gets the form by form identifier.
     * @param formID The form identifier.
     */
    formsGet(formID: string): Promise<Form> {
        let url_ = this.baseUrl + "/api/v1/Forms/{formID}";
        if (formID === undefined || formID === null)
            throw new Error("The parameter 'formID' must be defined.");
        url_ = url_.replace("{formID}", encodeURIComponent("" + formID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormsGet(_response);
        });
    }

    protected processFormsGet(response: Response): Promise<Form> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Form.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Form>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param formID The identifier.
     */
    formsDelete(formID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Forms/{formID}";
        if (formID === undefined || formID === null)
            throw new Error("The parameter 'formID' must be defined.");
        url_ = url_.replace("{formID}", encodeURIComponent("" + formID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormsDelete(_response);
        });
    }

    protected processFormsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the form by form identifier.
     */
    byShortName(shortName: string): Promise<Form> {
        let url_ = this.baseUrl + "/api/v1/Forms/ByShortName/{shortName}";
        if (shortName === undefined || shortName === null)
            throw new Error("The parameter 'shortName' must be defined.");
        url_ = url_.replace("{shortName}", encodeURIComponent("" + shortName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByShortName(_response);
        });
    }

    protected processByShortName(response: Response): Promise<Form> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Form.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Form>(null as any);
    }

    /**
     * Posts the specified Form.
     * @param form The Form.
     */
    formsPost(form: Form): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Forms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormsPost(_response);
        });
    }

    protected processFormsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Form.
     * @param form The Form.
     */
    formsPut(form: Form): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Forms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFormsPut(_response);
        });
    }

    protected processFormsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class FrequentlyAskedQuestionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets admin FrequentlyAskedQuestions.
     */
    adminByCountry(countryID: string): Promise<FrequentlyAskedQuestion[]> {
        let url_ = this.baseUrl + "/api/v1/FrequentlyAskedQuestions/AdminByCountry/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByCountry(_response);
        });
    }

    protected processAdminByCountry(response: Response): Promise<FrequentlyAskedQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FrequentlyAskedQuestion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrequentlyAskedQuestion[]>(null as any);
    }

    /**
     * Gets all FrequentlyAskedQuestions.
     * @param frequentlyAskedQuestionCategory (optional) 
     */
    byCountry(countryID: string, frequentlyAskedQuestionCategory?: string | null | undefined): Promise<FrequentlyAskedQuestion[]> {
        let url_ = this.baseUrl + "/api/v1/FrequentlyAskedQuestions/ByCountry/{countryID}?";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        if (frequentlyAskedQuestionCategory !== undefined && frequentlyAskedQuestionCategory !== null)
            url_ += "frequentlyAskedQuestionCategory=" + encodeURIComponent("" + frequentlyAskedQuestionCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCountry(_response);
        });
    }

    protected processByCountry(response: Response): Promise<FrequentlyAskedQuestion[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FrequentlyAskedQuestion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrequentlyAskedQuestion[]>(null as any);
    }

    /**
     * Posts the specified FrequentlyAskedQuestion.
     * @param frequentlyAskedQuestion The FrequentlyAskedQuestion.
     */
    frequentlyAskedQuestionsPost(frequentlyAskedQuestion: FrequentlyAskedQuestion): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FrequentlyAskedQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(frequentlyAskedQuestion);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFrequentlyAskedQuestionsPost(_response);
        });
    }

    protected processFrequentlyAskedQuestionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified FrequentlyAskedQuestion.
     * @param frequentlyAskedQuestion The FrequentlyAskedQuestion.
     */
    frequentlyAskedQuestionsPut(frequentlyAskedQuestion: FrequentlyAskedQuestion): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/FrequentlyAskedQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(frequentlyAskedQuestion);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFrequentlyAskedQuestionsPut(_response);
        });
    }

    protected processFrequentlyAskedQuestionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param frequentlyAskedQuestionID The identifier.
     */
    frequentlyAskedQuestionsDelete(frequentlyAskedQuestionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/FrequentlyAskedQuestions/{frequentlyAskedQuestionID}";
        if (frequentlyAskedQuestionID === undefined || frequentlyAskedQuestionID === null)
            throw new Error("The parameter 'frequentlyAskedQuestionID' must be defined.");
        url_ = url_.replace("{frequentlyAskedQuestionID}", encodeURIComponent("" + frequentlyAskedQuestionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFrequentlyAskedQuestionsDelete(_response);
        });
    }

    protected processFrequentlyAskedQuestionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search for a Question
     */
    search(frequentlyAskedQuestionsSearchDetails: FrequentlyAskedQuestionsSearchDetails): Promise<FrequentlyAskedQuestionsSearchResults> {
        let url_ = this.baseUrl + "/api/v1/FrequentlyAskedQuestions/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(frequentlyAskedQuestionsSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<FrequentlyAskedQuestionsSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FrequentlyAskedQuestionsSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrequentlyAskedQuestionsSearchResults>(null as any);
    }
}

export class GenerateDocumentsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Generates the note.
     * @param patientID The patient identifier.
     * @param phrNoteID The PHR note identifier.
     */
    generateNote(patientID: string, phrNoteID: string): Promise<GenerateDocumentResult> {
        let url_ = this.baseUrl + "/api/v1/GenerateDocuments/{patientID}/GenerateNote/{phrNoteID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrNoteID === undefined || phrNoteID === null)
            throw new Error("The parameter 'phrNoteID' must be defined.");
        url_ = url_.replace("{phrNoteID}", encodeURIComponent("" + phrNoteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGenerateNote(_response);
        });
    }

    protected processGenerateNote(response: Response): Promise<GenerateDocumentResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateDocumentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateDocumentResult>(null as any);
    }

    /**
     * Downloads the note asynchronous.
     * @param patientID The patient identifier.
     * @param phrNoteID The PHR note identifier.
     */
    downloadNote(patientID: string, phrNoteID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/GenerateDocuments/{patientID}/DownloadNote/{phrNoteID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrNoteID === undefined || phrNoteID === null)
            throw new Error("The parameter 'phrNoteID' must be defined.");
        url_ = url_.replace("{phrNoteID}", encodeURIComponent("" + phrNoteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadNote(_response);
        });
    }

    protected processDownloadNote(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Downloads the note file detail asynchronous.
     * @param patientID The patient identifier.
     * @param phrNoteID The PHR note identifier.
     */
    noteFileDetail(patientID: string, phrNoteID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/GenerateDocuments/{patientID}/NoteFileDetail/{phrNoteID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrNoteID === undefined || phrNoteID === null)
            throw new Error("The parameter 'phrNoteID' must be defined.");
        url_ = url_.replace("{phrNoteID}", encodeURIComponent("" + phrNoteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNoteFileDetail(_response);
        });
    }

    protected processNoteFileDetail(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Render HTML
     */
    generatePDF(html: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/GenerateDocuments/GeneratePDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(html);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGeneratePDF(_response);
        });
    }

    protected processGeneratePDF(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }
}

export class GLAccountGroupsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<GLAccountGroup[]> {
        let url_ = this.baseUrl + "/api/v1/GLAccountGroups/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<GLAccountGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GLAccountGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLAccountGroup[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param gLAccountGroupID The identifier.
     */
    gLAccountGroupsGet(gLAccountGroupID: string): Promise<GLAccountGroup> {
        let url_ = this.baseUrl + "/api/v1/GLAccountGroups/{gLAccountGroupID}";
        if (gLAccountGroupID === undefined || gLAccountGroupID === null)
            throw new Error("The parameter 'gLAccountGroupID' must be defined.");
        url_ = url_.replace("{gLAccountGroupID}", encodeURIComponent("" + gLAccountGroupID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountGroupsGet(_response);
        });
    }

    protected processGLAccountGroupsGet(response: Response): Promise<GLAccountGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLAccountGroup.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLAccountGroup>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param gLAccountGroupID The identifier.
     */
    gLAccountGroupsDelete(gLAccountGroupID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/GLAccountGroups/{gLAccountGroupID}";
        if (gLAccountGroupID === undefined || gLAccountGroupID === null)
            throw new Error("The parameter 'gLAccountGroupID' must be defined.");
        url_ = url_.replace("{gLAccountGroupID}", encodeURIComponent("" + gLAccountGroupID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountGroupsDelete(_response);
        });
    }

    protected processGLAccountGroupsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified GLAccountGroup.
     * @param gLAccountGroup The GLAccountGroup.
     */
    gLAccountGroupsPost(gLAccountGroup: GLAccountGroup): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLAccountGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLAccountGroup);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountGroupsPost(_response);
        });
    }

    protected processGLAccountGroupsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified GLAccountGroup.
     * @param gLAccountGroup The GLAccountGroup.
     */
    gLAccountGroupsPut(gLAccountGroup: GLAccountGroup): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLAccountGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLAccountGroup);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountGroupsPut(_response);
        });
    }

    protected processGLAccountGroupsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class GLAccountsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<GLAccount[]> {
        let url_ = this.baseUrl + "/api/v1/GLAccounts/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<GLAccount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GLAccount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLAccount[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param gLAccountID The identifier.
     */
    gLAccountsGet(gLAccountID: string): Promise<GLAccount> {
        let url_ = this.baseUrl + "/api/v1/GLAccounts/{gLAccountID}";
        if (gLAccountID === undefined || gLAccountID === null)
            throw new Error("The parameter 'gLAccountID' must be defined.");
        url_ = url_.replace("{gLAccountID}", encodeURIComponent("" + gLAccountID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountsGet(_response);
        });
    }

    protected processGLAccountsGet(response: Response): Promise<GLAccount> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLAccount.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLAccount>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param gLAccountID The identifier.
     */
    gLAccountsDelete(gLAccountID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/GLAccounts/{gLAccountID}";
        if (gLAccountID === undefined || gLAccountID === null)
            throw new Error("The parameter 'gLAccountID' must be defined.");
        url_ = url_.replace("{gLAccountID}", encodeURIComponent("" + gLAccountID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountsDelete(_response);
        });
    }

    protected processGLAccountsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified GLAccount.
     * @param gLAccount The GLAccount.
     */
    gLAccountsPost(gLAccount: GLAccount): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLAccount);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountsPost(_response);
        });
    }

    protected processGLAccountsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified GLAccount.
     * @param gLAccount The GLAccount.
     */
    gLAccountsPut(gLAccount: GLAccount): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLAccount);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountsPut(_response);
        });
    }

    protected processGLAccountsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class GLTransactionAccountsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param gLTransactionAccountID The identifier.
     */
    gLTransactionAccountsGet(gLTransactionAccountID: string): Promise<GLTransactionAccount> {
        let url_ = this.baseUrl + "/api/v1/GLTransactionAccounts/{gLTransactionAccountID}";
        if (gLTransactionAccountID === undefined || gLTransactionAccountID === null)
            throw new Error("The parameter 'gLTransactionAccountID' must be defined.");
        url_ = url_.replace("{gLTransactionAccountID}", encodeURIComponent("" + gLTransactionAccountID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLTransactionAccountsGet(_response);
        });
    }

    protected processGLTransactionAccountsGet(response: Response): Promise<GLTransactionAccount> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLTransactionAccount.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLTransactionAccount>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param gLTransactionAccountID The identifier.
     */
    gLTransactionAccountsDelete(gLTransactionAccountID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/GLTransactionAccounts/{gLTransactionAccountID}";
        if (gLTransactionAccountID === undefined || gLTransactionAccountID === null)
            throw new Error("The parameter 'gLTransactionAccountID' must be defined.");
        url_ = url_.replace("{gLTransactionAccountID}", encodeURIComponent("" + gLTransactionAccountID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLTransactionAccountsDelete(_response);
        });
    }

    protected processGLTransactionAccountsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified GLTransactionAccount.
     * @param gLTransactionAccount The GLTransactionAccount.
     */
    gLTransactionAccountsPost(gLTransactionAccount: GLTransactionAccount): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLTransactionAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLTransactionAccount);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLTransactionAccountsPost(_response);
        });
    }

    protected processGLTransactionAccountsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified GLTransactionAccount.
     * @param gLTransactionAccount The GLTransactionAccount.
     */
    gLTransactionAccountsPut(gLTransactionAccount: GLTransactionAccount): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLTransactionAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLTransactionAccount);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLTransactionAccountsPut(_response);
        });
    }

    protected processGLTransactionAccountsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Statement Summaries
     * @param currentOnly (optional) 
     */
    gLAccountSummaries(currentOnly?: boolean | undefined): Promise<GLSummary[]> {
        let url_ = this.baseUrl + "/api/v1/GLTransactionAccounts/GLAccountSummaries?";
        if (currentOnly === null)
            throw new Error("The parameter 'currentOnly' cannot be null.");
        else if (currentOnly !== undefined)
            url_ += "currentOnly=" + encodeURIComponent("" + currentOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLAccountSummaries(_response);
        });
    }

    protected processGLAccountSummaries(response: Response): Promise<GLSummary[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GLSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLSummary[]>(null as any);
    }
}

export class GLTransactionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param gLTransactionID The identifier.
     */
    gLTransactionsGet(gLTransactionID: string): Promise<GLTransaction> {
        let url_ = this.baseUrl + "/api/v1/GLTransactions/{gLTransactionID}";
        if (gLTransactionID === undefined || gLTransactionID === null)
            throw new Error("The parameter 'gLTransactionID' must be defined.");
        url_ = url_.replace("{gLTransactionID}", encodeURIComponent("" + gLTransactionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLTransactionsGet(_response);
        });
    }

    protected processGLTransactionsGet(response: Response): Promise<GLTransaction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLTransaction.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLTransaction>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param gLTransactionID The identifier.
     */
    gLTransactionsDelete(gLTransactionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/GLTransactions/{gLTransactionID}";
        if (gLTransactionID === undefined || gLTransactionID === null)
            throw new Error("The parameter 'gLTransactionID' must be defined.");
        url_ = url_.replace("{gLTransactionID}", encodeURIComponent("" + gLTransactionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLTransactionsDelete(_response);
        });
    }

    protected processGLTransactionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by invoice identifier.
     * @param invoiceID The invoice identifier.
     */
    byInvoiceID(invoiceID: string): Promise<GLTransaction> {
        let url_ = this.baseUrl + "/api/v1/GLTransactions/ByInvoiceID/{invoiceID}";
        if (invoiceID === undefined || invoiceID === null)
            throw new Error("The parameter 'invoiceID' must be defined.");
        url_ = url_.replace("{invoiceID}", encodeURIComponent("" + invoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByInvoiceID(_response);
        });
    }

    protected processByInvoiceID(response: Response): Promise<GLTransaction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLTransaction.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLTransaction>(null as any);
    }

    /**
     * Posts the specified GLTransaction.
     * @param gLTransaction The GLTransaction.
     */
    gLTransactionsPost(gLTransaction: GLTransaction): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLTransaction);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLTransactionsPost(_response);
        });
    }

    protected processGLTransactionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified GLTransaction.
     * @param gLTransaction The GLTransaction.
     */
    gLTransactionsPut(gLTransaction: GLTransaction): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLTransaction);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLTransactionsPut(_response);
        });
    }

    protected processGLTransactionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class GLUserDetailTransactionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param gLUserDetailTransactionID The identifier.
     */
    gLUserDetailTransactionsGet(gLUserDetailTransactionID: string): Promise<GLUserDetailTransaction> {
        let url_ = this.baseUrl + "/api/v1/GLUserDetailTransactions/{gLUserDetailTransactionID}";
        if (gLUserDetailTransactionID === undefined || gLUserDetailTransactionID === null)
            throw new Error("The parameter 'gLUserDetailTransactionID' must be defined.");
        url_ = url_.replace("{gLUserDetailTransactionID}", encodeURIComponent("" + gLUserDetailTransactionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLUserDetailTransactionsGet(_response);
        });
    }

    protected processGLUserDetailTransactionsGet(response: Response): Promise<GLUserDetailTransaction> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GLUserDetailTransaction.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GLUserDetailTransaction>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param gLUserDetailTransactionID The identifier.
     */
    gLUserDetailTransactionsDelete(gLUserDetailTransactionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/GLUserDetailTransactions/{gLUserDetailTransactionID}";
        if (gLUserDetailTransactionID === undefined || gLUserDetailTransactionID === null)
            throw new Error("The parameter 'gLUserDetailTransactionID' must be defined.");
        url_ = url_.replace("{gLUserDetailTransactionID}", encodeURIComponent("" + gLUserDetailTransactionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLUserDetailTransactionsDelete(_response);
        });
    }

    protected processGLUserDetailTransactionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified GLUserDetailTransaction.
     * @param gLUserDetailTransaction The GLUserDetailTransaction.
     */
    gLUserDetailTransactionsPost(gLUserDetailTransaction: GLUserDetailTransaction): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLUserDetailTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLUserDetailTransaction);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLUserDetailTransactionsPost(_response);
        });
    }

    protected processGLUserDetailTransactionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified GLUserDetailTransaction.
     * @param gLUserDetailTransaction The GLUserDetailTransaction.
     */
    gLUserDetailTransactionsPut(gLUserDetailTransaction: GLUserDetailTransaction): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/GLUserDetailTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gLUserDetailTransaction);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGLUserDetailTransactionsPut(_response);
        });
    }

    protected processGLUserDetailTransactionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class IdentityClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Lock a user out of the system by their lifetimeID
     */
    lockUserByUniqueLifetimeID(uniqueLifetimeID: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Identity/LockUserByUniqueLifetimeID/{uniqueLifetimeID}";
        if (uniqueLifetimeID === undefined || uniqueLifetimeID === null)
            throw new Error("The parameter 'uniqueLifetimeID' must be defined.");
        url_ = url_.replace("{uniqueLifetimeID}", encodeURIComponent("" + uniqueLifetimeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLockUserByUniqueLifetimeID(_response);
        });
    }

    protected processLockUserByUniqueLifetimeID(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Lock a user by their email
     */
    lockUserByEmail(email: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Identity/LockUserByEmail/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLockUserByEmail(_response);
        });
    }

    protected processLockUserByEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * unlock the user by uniqueLifetimeID
     */
    unlockUserByUniqueLifetimeID(uniqueLifetimeID: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Identity/UnlockUserByUniqueLifetimeID/{uniqueLifetimeID}";
        if (uniqueLifetimeID === undefined || uniqueLifetimeID === null)
            throw new Error("The parameter 'uniqueLifetimeID' must be defined.");
        url_ = url_.replace("{uniqueLifetimeID}", encodeURIComponent("" + uniqueLifetimeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUnlockUserByUniqueLifetimeID(_response);
        });
    }

    protected processUnlockUserByUniqueLifetimeID(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Unlocks the user by email.
     * @param email The email.
     */
    unlockUserByEmail(email: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Identity/UnlockUserByEmail/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUnlockUserByEmail(_response);
        });
    }

    protected processUnlockUserByEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Determines whether [is user locked] [the specified email].
     * @param email The email.
     * @return true if [is user locked] [the specified email]; otherwise, false.
     */
    isUserLockedByEmail(email: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Identity/IsUserLockedByEmail/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processIsUserLockedByEmail(_response);
        });
    }

    protected processIsUserLockedByEmail(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isUserLockedByUniqueLifetimeID(uniqueLifetimeID: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Identity/IsUserLockedByUniqueLifetimeID/{uniqueLifetimeID}";
        if (uniqueLifetimeID === undefined || uniqueLifetimeID === null)
            throw new Error("The parameter 'uniqueLifetimeID' must be defined.");
        url_ = url_.replace("{uniqueLifetimeID}", encodeURIComponent("" + uniqueLifetimeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processIsUserLockedByUniqueLifetimeID(_response);
        });
    }

    protected processIsUserLockedByUniqueLifetimeID(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets all roles.
     */
    allRoles(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Identity/AllRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllRoles(_response);
        });
    }

    protected processAllRoles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ImageDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Uploads the specified file information.
     * @param fileDetail The file information.
     */
    upload(fileDetail: FileDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Downloads the original.
     * @param imageID The image detail identifier.
     */
    original(imageID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails/{imageID}/Original";
        if (imageID === undefined || imageID === null)
            throw new Error("The parameter 'imageID' must be defined.");
        url_ = url_.replace("{imageID}", encodeURIComponent("" + imageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOriginal(_response);
        });
    }

    protected processOriginal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Downloads the thumbnail.
     * @param imageID The image detail identifier.
     * @param token (optional) The token.
     */
    thumbnailAsSrcWithToken(imageID: string, token?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails/{imageID}/ThumbnailAsSrcWithToken?";
        if (imageID === undefined || imageID === null)
            throw new Error("The parameter 'imageID' must be defined.");
        url_ = url_.replace("{imageID}", encodeURIComponent("" + imageID));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThumbnailAsSrcWithToken(_response);
        });
    }

    protected processThumbnailAsSrcWithToken(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Downloads the thumbnail.
     * @param imageID The image detail identifier.
     */
    thumbnailAsSrc(imageID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails/{imageID}/ThumbnailAsSrc";
        if (imageID === undefined || imageID === null)
            throw new Error("The parameter 'imageID' must be defined.");
        url_ = url_.replace("{imageID}", encodeURIComponent("" + imageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThumbnailAsSrc(_response);
        });
    }

    protected processThumbnailAsSrc(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Downloads the thumbnail.
     * @param imageID The image detail identifier.
     */
    thumbnail(imageID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails/{imageID}/Thumbnail";
        if (imageID === undefined || imageID === null)
            throw new Error("The parameter 'imageID' must be defined.");
        url_ = url_.replace("{imageID}", encodeURIComponent("" + imageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThumbnail(_response);
        });
    }

    protected processThumbnail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Downloads the medium.
     * @param imageID The image detail identifier.
     */
    medium(imageID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails/{imageID}/Medium";
        if (imageID === undefined || imageID === null)
            throw new Error("The parameter 'imageID' must be defined.");
        url_ = url_.replace("{imageID}", encodeURIComponent("" + imageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMedium(_response);
        });
    }

    protected processMedium(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param imageDetailID The identifier.
     */
    imageDetailsGet(imageDetailID: string): Promise<ImageDetail> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails/{imageDetailID}";
        if (imageDetailID === undefined || imageDetailID === null)
            throw new Error("The parameter 'imageDetailID' must be defined.");
        url_ = url_.replace("{imageDetailID}", encodeURIComponent("" + imageDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processImageDetailsGet(_response);
        });
    }

    protected processImageDetailsGet(response: Response): Promise<ImageDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param imageDetailID The identifier.
     */
    imageDetailsDelete(imageDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails/{imageDetailID}";
        if (imageDetailID === undefined || imageDetailID === null)
            throw new Error("The parameter 'imageDetailID' must be defined.");
        url_ = url_.replace("{imageDetailID}", encodeURIComponent("" + imageDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processImageDetailsDelete(_response);
        });
    }

    protected processImageDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified image.
     * @param imageDetail The image.
     */
    imageDetailsPost(imageDetail: ImageDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imageDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processImageDetailsPost(_response);
        });
    }

    protected processImageDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified image.
     * @param imageDetail The image.
     */
    imageDetailsPut(imageDetail: ImageDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ImageDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imageDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processImageDetailsPut(_response);
        });
    }

    protected processImageDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class InsuranceProvidersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<InsuranceProvider[]> {
        let url_ = this.baseUrl + "/api/v1/InsuranceProviders/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<InsuranceProvider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InsuranceProvider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceProvider[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param insuranceProviderID The identifier.
     */
    insuranceProvidersGet(insuranceProviderID: string): Promise<InsuranceProvider> {
        let url_ = this.baseUrl + "/api/v1/InsuranceProviders/{InsuranceProviderID}";
        if (insuranceProviderID === undefined || insuranceProviderID === null)
            throw new Error("The parameter 'insuranceProviderID' must be defined.");
        url_ = url_.replace("{InsuranceProviderID}", encodeURIComponent("" + insuranceProviderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInsuranceProvidersGet(_response);
        });
    }

    protected processInsuranceProvidersGet(response: Response): Promise<InsuranceProvider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsuranceProvider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceProvider>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param insuranceProviderID The identifier.
     */
    insuranceProvidersDelete(insuranceProviderID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InsuranceProviders/{InsuranceProviderID}";
        if (insuranceProviderID === undefined || insuranceProviderID === null)
            throw new Error("The parameter 'insuranceProviderID' must be defined.");
        url_ = url_.replace("{InsuranceProviderID}", encodeURIComponent("" + insuranceProviderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInsuranceProvidersDelete(_response);
        });
    }

    protected processInsuranceProvidersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by country identifier.
     * @param countryID The country identifier.
     */
    byCountryID(countryID: string): Promise<InsuranceProvider[]> {
        let url_ = this.baseUrl + "/api/v1/InsuranceProviders/ByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCountryID(_response);
        });
    }

    protected processByCountryID(response: Response): Promise<InsuranceProvider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InsuranceProvider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsuranceProvider[]>(null as any);
    }

    /**
     * Posts the specified InsuranceProvider.
     * @param insuranceProvider The InsuranceProvider.
     */
    insuranceProvidersPost(insuranceProvider: InsuranceProvider): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/InsuranceProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceProvider);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInsuranceProvidersPost(_response);
        });
    }

    protected processInsuranceProvidersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified InsuranceProvider.
     * @param insuranceProvider The insurance provider.
     */
    insuranceProvidersPut(insuranceProvider: InsuranceProvider): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/InsuranceProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insuranceProvider);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInsuranceProvidersPut(_response);
        });
    }

    protected processInsuranceProvidersPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class InventoryClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Upload a file
     */
    upload(fileDetail: FileDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Inventory/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Start the process
     */
    submitInventoryLoader(inventoryLoaderDetails: InventoryLoaderDetails): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Inventory/SubmitInventoryLoader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inventoryLoaderDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubmitInventoryLoader(_response);
        });
    }

    protected processSubmitInventoryLoader(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class InvoicePaymentBatchesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Will open a new batch or return an existing open batch
     * @param userDetailID (optional) 
     */
    openBatch(userDetailID?: string | undefined): Promise<InvoicePaymentBatch> {
        let url_ = this.baseUrl + "/api/v1/InvoicePaymentBatches/OpenBatch?";
        if (userDetailID === null)
            throw new Error("The parameter 'userDetailID' cannot be null.");
        else if (userDetailID !== undefined)
            url_ += "userDetailID=" + encodeURIComponent("" + userDetailID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOpenBatch(_response);
        });
    }

    protected processOpenBatch(response: Response): Promise<InvoicePaymentBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicePaymentBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicePaymentBatch>(null as any);
    }

    /**
     * Will close an open batch
     * @param userDetailID (optional) 
     */
    closeBatch(userDetailID?: string | undefined): Promise<InvoicePaymentBatch> {
        let url_ = this.baseUrl + "/api/v1/InvoicePaymentBatches/CloseBatch?";
        if (userDetailID === null)
            throw new Error("The parameter 'userDetailID' cannot be null.");
        else if (userDetailID !== undefined)
            url_ += "userDetailID=" + encodeURIComponent("" + userDetailID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCloseBatch(_response);
        });
    }

    protected processCloseBatch(response: Response): Promise<InvoicePaymentBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicePaymentBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicePaymentBatch>(null as any);
    }

    /**
     * Search batches
     */
    search(invoicePaymentBatchSearchDetails: InvoicePaymentBatchSearchDetails): Promise<InvoicePaymentBatch[]> {
        let url_ = this.baseUrl + "/api/v1/InvoicePaymentBatches/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoicePaymentBatchSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<InvoicePaymentBatch[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoicePaymentBatch.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicePaymentBatch[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param invoicePaymentBatchID The identifier.
     */
    byInvoicePaymentBatchID(invoicePaymentBatchID: string): Promise<InvoicePaymentBatch> {
        let url_ = this.baseUrl + "/api/v1/InvoicePaymentBatches/ByInvoicePaymentBatchID/{invoicePaymentBatchID}";
        if (invoicePaymentBatchID === undefined || invoicePaymentBatchID === null)
            throw new Error("The parameter 'invoicePaymentBatchID' must be defined.");
        url_ = url_.replace("{invoicePaymentBatchID}", encodeURIComponent("" + invoicePaymentBatchID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByInvoicePaymentBatchID(_response);
        });
    }

    protected processByInvoicePaymentBatchID(response: Response): Promise<InvoicePaymentBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicePaymentBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicePaymentBatch>(null as any);
    }

    /**
     * Gets the specified batch by batchnumber.
     * @param invoicePaymentBatchNumber The identifier.
     */
    byInvoicePaymentBatchNumber(invoicePaymentBatchNumber: number): Promise<InvoicePaymentBatch> {
        let url_ = this.baseUrl + "/api/v1/InvoicePaymentBatches/ByInvoicePaymentBatchNumber/{invoicePaymentBatchNumber}";
        if (invoicePaymentBatchNumber === undefined || invoicePaymentBatchNumber === null)
            throw new Error("The parameter 'invoicePaymentBatchNumber' must be defined.");
        url_ = url_.replace("{invoicePaymentBatchNumber}", encodeURIComponent("" + invoicePaymentBatchNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByInvoicePaymentBatchNumber(_response);
        });
    }

    protected processByInvoicePaymentBatchNumber(response: Response): Promise<InvoicePaymentBatch> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicePaymentBatch.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicePaymentBatch>(null as any);
    }
}

export class InvoicePaymentsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param invoicePaymentID The identifier.
     */
    invoicePaymentsGet(invoicePaymentID: string): Promise<InvoicePayment> {
        let url_ = this.baseUrl + "/api/v1/InvoicePayments/{invoicePaymentID}";
        if (invoicePaymentID === undefined || invoicePaymentID === null)
            throw new Error("The parameter 'invoicePaymentID' must be defined.");
        url_ = url_.replace("{invoicePaymentID}", encodeURIComponent("" + invoicePaymentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoicePaymentsGet(_response);
        });
    }

    protected processInvoicePaymentsGet(response: Response): Promise<InvoicePayment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoicePayment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoicePayment>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param invoicePaymentID The identifier.
     */
    invoicePaymentsDelete(invoicePaymentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InvoicePayments/{invoicePaymentID}";
        if (invoicePaymentID === undefined || invoicePaymentID === null)
            throw new Error("The parameter 'invoicePaymentID' must be defined.");
        url_ = url_.replace("{invoicePaymentID}", encodeURIComponent("" + invoicePaymentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoicePaymentsDelete(_response);
        });
    }

    protected processInvoicePaymentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified InvoicePayment setting.
     * @param invoicePayment The InvoicePayment.
     */
    invoicePaymentsPost(invoicePayment: InvoicePayment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/InvoicePayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoicePayment);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoicePaymentsPost(_response);
        });
    }

    protected processInvoicePaymentsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified InvoicePayment
     * @param invoicePayment The InvoicePayment
     */
    invoicePaymentsPut(invoicePayment: InvoicePayment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/InvoicePayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoicePayment);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoicePaymentsPut(_response);
        });
    }

    protected processInvoicePaymentsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Recurring payments for the user
     */
    recurringPayments(userDetailID: string, includeCancelled: boolean): Promise<RecurringPayment[]> {
        let url_ = this.baseUrl + "/api/v1/InvoicePayments/RecurringPayments/{userDetailID}/{includeCancelled}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (includeCancelled === undefined || includeCancelled === null)
            throw new Error("The parameter 'includeCancelled' must be defined.");
        url_ = url_.replace("{includeCancelled}", encodeURIComponent("" + includeCancelled));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRecurringPayments(_response);
        });
    }

    protected processRecurringPayments(response: Response): Promise<RecurringPayment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecurringPayment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecurringPayment[]>(null as any);
    }

    /**
     * Deletes the recurring Payment
     * @param recurringPaymentID The identifier.
     */
    recurringPayment(recurringPaymentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InvoicePayments/RecurringPayment/{recurringPaymentID}";
        if (recurringPaymentID === undefined || recurringPaymentID === null)
            throw new Error("The parameter 'recurringPaymentID' must be defined.");
        url_ = url_.replace("{recurringPaymentID}", encodeURIComponent("" + recurringPaymentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRecurringPayment(_response);
        });
    }

    protected processRecurringPayment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Recurring Patients for a particular userDetailID
     */
    recurringPatients(userDetailID: string): Promise<RecurringPatientDTO[]> {
        let url_ = this.baseUrl + "/api/v1/InvoicePayments/RecurringPatients/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRecurringPatients(_response);
        });
    }

    protected processRecurringPatients(response: Response): Promise<RecurringPatientDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecurringPatientDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecurringPatientDTO[]>(null as any);
    }
}

export class InvoicesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Downloads the specified document identifier.
     * @param invoiceID The invoice identifier.
     */
    downloadInvoice(invoiceID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Invoices/DownloadInvoice/{invoiceID}";
        if (invoiceID === undefined || invoiceID === null)
            throw new Error("The parameter 'invoiceID' must be defined.");
        url_ = url_.replace("{invoiceID}", encodeURIComponent("" + invoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadInvoice(_response);
        });
    }

    protected processDownloadInvoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Downloads the specified Invoice File Detail
     * @param invoiceID The invoice identifier.
     */
    invoiceFileDetail(invoiceID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/Invoices/InvoiceFileDetail/{invoiceID}";
        if (invoiceID === undefined || invoiceID === null)
            throw new Error("The parameter 'invoiceID' must be defined.");
        url_ = url_.replace("{invoiceID}", encodeURIComponent("" + invoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoiceFileDetail(_response);
        });
    }

    protected processInvoiceFileDetail(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Gets the by invoice no.
     * @param invoiceNo The invoice no.
     */
    byInvoiceNo(invoiceNo: number): Promise<Invoice> {
        let url_ = this.baseUrl + "/api/v1/Invoices/ByInvoiceNo/{invoiceNo}";
        if (invoiceNo === undefined || invoiceNo === null)
            throw new Error("The parameter 'invoiceNo' must be defined.");
        url_ = url_.replace("{invoiceNo}", encodeURIComponent("" + invoiceNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByInvoiceNo(_response);
        });
    }

    protected processByInvoiceNo(response: Response): Promise<Invoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Invoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param invoiceID The identifier.
     * @param includeAll (optional) if set to true [include all].
     * @param isDonation (optional) if set to true [include all].
     */
    invoicesGet(invoiceID: string, includeAll?: boolean | undefined, isDonation?: boolean | undefined): Promise<Invoice> {
        let url_ = this.baseUrl + "/api/v1/Invoices/{invoiceID}?";
        if (invoiceID === undefined || invoiceID === null)
            throw new Error("The parameter 'invoiceID' must be defined.");
        url_ = url_.replace("{invoiceID}", encodeURIComponent("" + invoiceID));
        if (includeAll === null)
            throw new Error("The parameter 'includeAll' cannot be null.");
        else if (includeAll !== undefined)
            url_ += "includeAll=" + encodeURIComponent("" + includeAll) + "&";
        if (isDonation === null)
            throw new Error("The parameter 'isDonation' cannot be null.");
        else if (isDonation !== undefined)
            url_ += "isDonation=" + encodeURIComponent("" + isDonation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoicesGet(_response);
        });
    }

    protected processInvoicesGet(response: Response): Promise<Invoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Invoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param invoiceID The identifier.
     */
    invoicesDelete(invoiceID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Invoices/{invoiceID}";
        if (invoiceID === undefined || invoiceID === null)
            throw new Error("The parameter 'invoiceID' must be defined.");
        url_ = url_.replace("{invoiceID}", encodeURIComponent("" + invoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoicesDelete(_response);
        });
    }

    protected processInvoicesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Commits the invoice to the GL
     * @param invoiceID The invoice identifier.
     */
    commit(invoiceID: string): Promise<InvoiceCommitResult> {
        let url_ = this.baseUrl + "/api/v1/Invoices/Commit/{invoiceID}";
        if (invoiceID === undefined || invoiceID === null)
            throw new Error("The parameter 'invoiceID' must be defined.");
        url_ = url_.replace("{invoiceID}", encodeURIComponent("" + invoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCommit(_response);
        });
    }

    protected processCommit(response: Response): Promise<InvoiceCommitResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceCommitResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceCommitResult>(null as any);
    }

    /**
     * Refunds the Invoice
     * @param invoiceID The invoice identifier.
     */
    refund(invoiceID: string): Promise<InvoiceRefundResult> {
        let url_ = this.baseUrl + "/api/v1/Invoices/Refund/{invoiceID}";
        if (invoiceID === undefined || invoiceID === null)
            throw new Error("The parameter 'invoiceID' must be defined.");
        url_ = url_.replace("{invoiceID}", encodeURIComponent("" + invoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRefund(_response);
        });
    }

    protected processRefund(response: Response): Promise<InvoiceRefundResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceRefundResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceRefundResult>(null as any);
    }

    /**
     * Posts the specified Invoice setting.
     * @param invoice The Invoice.
     */
    invoicesPost(invoice: Invoice): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoicesPost(_response);
        });
    }

    protected processInvoicesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Invoice
     * @param invoice The Invoice
     */
    invoicesPut(invoice: Invoice): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoice);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoicesPut(_response);
        });
    }

    protected processInvoicesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets all.
     * @param userDetailID The user detail identifier.
     */
    byUserDetailID(userDetailID: string): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/v1/Invoices/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    /**
     * Gets all.
     * @param userDetailID The user detail identifier.
     */
    draftByUserDetailID(userDetailID: string): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/v1/Invoices/DraftByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDraftByUserDetailID(_response);
        });
    }

    protected processDraftByUserDetailID(response: Response): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    /**
     * Create a currency exchange invoice
     */
    createCurrencyExchangeInvoice(currencyExchangeInvoiceDetails: CreateCurrencyExchangeInvoiceDetails): Promise<CurrencyExchangeResult> {
        let url_ = this.baseUrl + "/api/v1/Invoices/CreateCurrencyExchangeInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(currencyExchangeInvoiceDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateCurrencyExchangeInvoice(_response);
        });
    }

    protected processCreateCurrencyExchangeInvoice(response: Response): Promise<CurrencyExchangeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyExchangeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyExchangeResult>(null as any);
    }

    /**
     * Get the shopping cart by userDetailID and StoreID
     */
    shoppingCartByUserDetailIDAndStoreID(userDetailID: string, storeID: string): Promise<Invoice> {
        let url_ = this.baseUrl + "/api/v1/Invoices/ShoppingCartByUserDetailIDAndStoreID/{userDetailID}/{storeID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processShoppingCartByUserDetailIDAndStoreID(_response);
        });
    }

    protected processShoppingCartByUserDetailIDAndStoreID(response: Response): Promise<Invoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Invoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice>(null as any);
    }

    /**
     * Take a Neo Payment
     */
    neoPayment(neoPaymentDetail: NeoPaymentDetail): Promise<NeoPaymentResult> {
        let url_ = this.baseUrl + "/api/v1/Invoices/NeoPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(neoPaymentDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNeoPayment(_response);
        });
    }

    protected processNeoPayment(response: Response): Promise<NeoPaymentResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NeoPaymentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NeoPaymentResult>(null as any);
    }

    /**
     * Create a PaymentLinkInvoice
     */
    createPaymentLinkInvoice(storeItemID: string): Promise<Invoice> {
        let url_ = this.baseUrl + "/api/v1/Invoices/CreatePaymentLinkInvoice/{storeItemID}";
        if (storeItemID === undefined || storeItemID === null)
            throw new Error("The parameter 'storeItemID' must be defined.");
        url_ = url_.replace("{storeItemID}", encodeURIComponent("" + storeItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreatePaymentLinkInvoice(_response);
        });
    }

    protected processCreatePaymentLinkInvoice(response: Response): Promise<Invoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Invoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice>(null as any);
    }

    /**
     * Get payment Link invoices by store
     */
    paymentLinkInvoices(storeID: string): Promise<PaymentLinkDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Invoices/PaymentLinkInvoices/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPaymentLinkInvoices(_response);
        });
    }

    protected processPaymentLinkInvoices(response: Response): Promise<PaymentLinkDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentLinkDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentLinkDTO[]>(null as any);
    }
}

export class InvoiceStoreItemsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param invoiceStoreItemID The identifier.
     */
    invoiceStoreItemsGet(invoiceStoreItemID: string): Promise<InvoiceStoreItem> {
        let url_ = this.baseUrl + "/api/v1/InvoiceStoreItems/{invoiceStoreItemID}";
        if (invoiceStoreItemID === undefined || invoiceStoreItemID === null)
            throw new Error("The parameter 'invoiceStoreItemID' must be defined.");
        url_ = url_.replace("{invoiceStoreItemID}", encodeURIComponent("" + invoiceStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoiceStoreItemsGet(_response);
        });
    }

    protected processInvoiceStoreItemsGet(response: Response): Promise<InvoiceStoreItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceStoreItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceStoreItem>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param invoiceStoreItemID The identifier.
     */
    invoiceStoreItemsDelete(invoiceStoreItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InvoiceStoreItems/{invoiceStoreItemID}";
        if (invoiceStoreItemID === undefined || invoiceStoreItemID === null)
            throw new Error("The parameter 'invoiceStoreItemID' must be defined.");
        url_ = url_.replace("{invoiceStoreItemID}", encodeURIComponent("" + invoiceStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoiceStoreItemsDelete(_response);
        });
    }

    protected processInvoiceStoreItemsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified InvoiceStoreItem setting.
     * @param invoiceStoreItem The InvoiceStoreItem.
     */
    invoiceStoreItemsPost(invoiceStoreItem: InvoiceStoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/InvoiceStoreItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoiceStoreItemsPost(_response);
        });
    }

    protected processInvoiceStoreItemsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified InvoiceStoreItem
     * @param invoiceStoreItem The InvoiceStoreItem
     */
    invoiceStoreItemsPut(invoiceStoreItem: InvoiceStoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/InvoiceStoreItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvoiceStoreItemsPut(_response);
        });
    }

    protected processInvoiceStoreItemsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified InvoiceStoreItem to the pending invoice
     * @param invoiceStoreItem The InvoiceStoreItem
     */
    moveToPending(invoiceStoreItem: InvoiceStoreItem): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InvoiceStoreItems/MoveToPending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMoveToPending(_response);
        });
    }

    protected processMoveToPending(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Puts the specified InvoiceStoreItem to the shopping cart invoice
     * @param invoiceStoreItem The InvoiceStoreItem
     */
    moveToShoppingCart(invoiceStoreItem: InvoiceStoreItem): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/InvoiceStoreItems/MoveToShoppingCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMoveToShoppingCart(_response);
        });
    }

    protected processMoveToShoppingCart(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the Quantity on the InvoiceStoreItem record easily
     */
    quantity(invoiceStoreItemQuantityDetail: InvoiceStoreItemQuantityDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/InvoiceStoreItems/Quantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(invoiceStoreItemQuantityDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processQuantity(_response);
        });
    }

    protected processQuantity(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ItemImagesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<ItemImage[]> {
        let url_ = this.baseUrl + "/api/v1/ItemImages/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ItemImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemImage[]>(null as any);
    }

    /**
     * Get the images for the itemID
     */
    byItemID(itemID: string): Promise<ItemImage[]> {
        let url_ = this.baseUrl + "/api/v1/ItemImages/ByItemID/{itemID}";
        if (itemID === undefined || itemID === null)
            throw new Error("The parameter 'itemID' must be defined.");
        url_ = url_.replace("{itemID}", encodeURIComponent("" + itemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByItemID(_response);
        });
    }

    protected processByItemID(response: Response): Promise<ItemImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemImage[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param itemImageID The identifier.
     */
    itemImagesGet(itemImageID: string): Promise<ItemImage> {
        let url_ = this.baseUrl + "/api/v1/ItemImages/{itemImageID}";
        if (itemImageID === undefined || itemImageID === null)
            throw new Error("The parameter 'itemImageID' must be defined.");
        url_ = url_.replace("{itemImageID}", encodeURIComponent("" + itemImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemImagesGet(_response);
        });
    }

    protected processItemImagesGet(response: Response): Promise<ItemImage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemImage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemImage>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param itemImageID The identifier.
     */
    itemImagesDelete(itemImageID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ItemImages/{itemImageID}";
        if (itemImageID === undefined || itemImageID === null)
            throw new Error("The parameter 'itemImageID' must be defined.");
        url_ = url_.replace("{itemImageID}", encodeURIComponent("" + itemImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemImagesDelete(_response);
        });
    }

    protected processItemImagesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ItemImage.
     * @param itemImage The ItemImage.
     */
    itemImagesPost(itemImage: ItemImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ItemImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemImagesPost(_response);
        });
    }

    protected processItemImagesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ItemImage.
     */
    itemImagesPut(itemImage: ItemImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ItemImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemImagesPut(_response);
        });
    }

    protected processItemImagesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param itemImages The ItemImages.
     */
    many(itemImages: ItemImage[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ItemImages/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemImages);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ItemPropertiesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<ItemProperty[]> {
        let url_ = this.baseUrl + "/api/v1/ItemProperties/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ItemProperty[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemProperty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemProperty[]>(null as any);
    }

    /**
     * Get the Properties for the itemID
     */
    byItemID(itemID: string): Promise<ItemProperty[]> {
        let url_ = this.baseUrl + "/api/v1/ItemProperties/ByItemID/{itemID}";
        if (itemID === undefined || itemID === null)
            throw new Error("The parameter 'itemID' must be defined.");
        url_ = url_.replace("{itemID}", encodeURIComponent("" + itemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByItemID(_response);
        });
    }

    protected processByItemID(response: Response): Promise<ItemProperty[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemProperty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemProperty[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param itemPropertyID The identifier.
     */
    itemPropertiesGet(itemPropertyID: string): Promise<ItemProperty> {
        let url_ = this.baseUrl + "/api/v1/ItemProperties/{itemPropertyID}";
        if (itemPropertyID === undefined || itemPropertyID === null)
            throw new Error("The parameter 'itemPropertyID' must be defined.");
        url_ = url_.replace("{itemPropertyID}", encodeURIComponent("" + itemPropertyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemPropertiesGet(_response);
        });
    }

    protected processItemPropertiesGet(response: Response): Promise<ItemProperty> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemProperty.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ItemProperty>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param itemPropertyID The identifier.
     */
    itemPropertiesDelete(itemPropertyID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ItemProperties/{itemPropertyID}";
        if (itemPropertyID === undefined || itemPropertyID === null)
            throw new Error("The parameter 'itemPropertyID' must be defined.");
        url_ = url_.replace("{itemPropertyID}", encodeURIComponent("" + itemPropertyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemPropertiesDelete(_response);
        });
    }

    protected processItemPropertiesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ItemProperty.
     * @param itemProperty The ItemProperty.
     */
    itemPropertiesPost(itemProperty: ItemProperty): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ItemProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemProperty);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemPropertiesPost(_response);
        });
    }

    protected processItemPropertiesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ItemProperty.
     */
    itemPropertiesPut(itemProperty: ItemProperty): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ItemProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemProperty);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemPropertiesPut(_response);
        });
    }

    protected processItemPropertiesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param itemProperties The ItemProperties.
     */
    many(itemProperties: ItemProperty[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ItemProperties/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemProperties);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ItemsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/v1/Items/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Item.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Item[]>(null as any);
    }

    /**
     * Gets all.
     * @param itemTypeEnum The item type enum.
     */
    allByItemTypeEnum(itemTypeEnum: ItemTypeEnum): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/v1/Items/AllByItemTypeEnum/{itemTypeEnum}";
        if (itemTypeEnum === undefined || itemTypeEnum === null)
            throw new Error("The parameter 'itemTypeEnum' must be defined.");
        url_ = url_.replace("{itemTypeEnum}", encodeURIComponent("" + itemTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllByItemTypeEnum(_response);
        });
    }

    protected processAllByItemTypeEnum(response: Response): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Item.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Item[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param itemID The identifier.
     */
    itemsGet(itemID: string): Promise<Item> {
        let url_ = this.baseUrl + "/api/v1/Items/{itemID}";
        if (itemID === undefined || itemID === null)
            throw new Error("The parameter 'itemID' must be defined.");
        url_ = url_.replace("{itemID}", encodeURIComponent("" + itemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemsGet(_response);
        });
    }

    protected processItemsGet(response: Response): Promise<Item> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Item.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Item>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param itemID The identifier.
     */
    itemsDelete(itemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Items/{itemID}";
        if (itemID === undefined || itemID === null)
            throw new Error("The parameter 'itemID' must be defined.");
        url_ = url_.replace("{itemID}", encodeURIComponent("" + itemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemsDelete(_response);
        });
    }

    protected processItemsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified item.
     * @param item The item.
     */
    itemsPost(item: Item): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemsPost(_response);
        });
    }

    protected processItemsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified item.
     */
    itemsPut(item: Item): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemsPut(_response);
        });
    }

    protected processItemsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param items The items.
     */
    many(items: Item[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Items/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class KPIClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<KPIDTO[]> {
        let url_ = this.baseUrl + "/api/v1/KPI/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<KPIDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KPIDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KPIDTO[]>(null as any);
    }

    /**
     * Get the list of KPI's by date
     */
    admin(kPIDateSearchDetails: KPIDateSearchDetails): Promise<KPIDateDTO[]> {
        let url_ = this.baseUrl + "/api/v1/KPI/admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(kPIDateSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<KPIDateDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KPIDateDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KPIDateDTO[]>(null as any);
    }
}

export class LivestreamsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all livestreams
     * @param name (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    all(name?: string | null | undefined, startDate?: Date | undefined, endDate?: Date | undefined): Promise<Livestream[]> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/all?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Livestream[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Livestream.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Livestream[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<Livestream[]> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Livestream[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Livestream.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Livestream[]>(null as any);
    }

    /**
     * Get livestream
     */
    livestreamsGet(livestreamID: string): Promise<Livestream> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/{LivestreamID}";
        if (livestreamID === undefined || livestreamID === null)
            throw new Error("The parameter 'livestreamID' must be defined.");
        url_ = url_.replace("{LivestreamID}", encodeURIComponent("" + livestreamID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLivestreamsGet(_response);
        });
    }

    protected processLivestreamsGet(response: Response): Promise<Livestream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Livestream.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Livestream>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param livestreamID The identifier.
     */
    livestreamsDelete(livestreamID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/{LivestreamID}";
        if (livestreamID === undefined || livestreamID === null)
            throw new Error("The parameter 'livestreamID' must be defined.");
        url_ = url_.replace("{LivestreamID}", encodeURIComponent("" + livestreamID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLivestreamsDelete(_response);
        });
    }

    protected processLivestreamsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create Livestream Room
     */
    createRoom(createRoomDTO: CreateRoomDTO): Promise<CreateRoomResponseDTO> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/createRoom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRoomDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateRoom(_response);
        });
    }

    protected processCreateRoom(response: Response): Promise<CreateRoomResponseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRoomResponseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateRoomResponseDTO>(null as any);
    }

    /**
     * Puts the specified Livestream setting.
     * @param updateRoomDTO The Livestream setting.
     */
    livestreamsPut(updateRoomDTO: CreateRoomDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Livestreams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRoomDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLivestreamsPut(_response);
        });
    }

    protected processLivestreamsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Create Owner Token
     * @param livestreamID (optional) 
     */
    createOwnerToken(livestreamID?: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/CreateOwnerToken?";
        if (livestreamID === null)
            throw new Error("The parameter 'livestreamID' cannot be null.");
        else if (livestreamID !== undefined)
            url_ += "livestreamID=" + encodeURIComponent("" + livestreamID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateOwnerToken(_response);
        });
    }

    protected processCreateOwnerToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * End Livestream Room
     */
    endRoom(endRoomDTO: EndRoomDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/endRoom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(endRoomDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEndRoom(_response);
        });
    }

    protected processEndRoom(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get livestreams by RoomID
     */
    byRoomName(roomName: string): Promise<Livestream> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/ByRoomName/{roomName}";
        if (roomName === undefined || roomName === null)
            throw new Error("The parameter 'roomName' must be defined.");
        url_ = url_.replace("{roomName}", encodeURIComponent("" + roomName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByRoomName(_response);
        });
    }

    protected processByRoomName(response: Response): Promise<Livestream> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Livestream.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Livestream>(null as any);
    }

    /**
     * Get livestreams created by userdetail
     * @param name (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    byUserDetailID(userDetailID: string, name?: string | null | undefined, startDate?: Date | undefined, endDate?: Date | undefined): Promise<Livestream[]> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/ByUserDetailID/{userDetailID}?";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<Livestream[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Livestream.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Livestream[]>(null as any);
    }

    /**
     * Search Livestream
     */
    searchLivestreams(searchLivestreamDetails: SearchLivestreamDetails): Promise<Livestream[]> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/SearchLivestreams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchLivestreamDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearchLivestreams(_response);
        });
    }

    protected processSearchLivestreams(response: Response): Promise<Livestream[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Livestream.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Livestream[]>(null as any);
    }

    /**
     * Webhooks from Daily
     */
    dailyWebhook(eventData: any): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/DailyWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDailyWebhook(_response);
        });
    }

    protected processDailyWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get Recordings from Daily
     */
    recordings(): Promise<Livestream[]> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/Recordings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRecordings(_response);
        });
    }

    protected processRecordings(response: Response): Promise<Livestream[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Livestream.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Livestream[]>(null as any);
    }

    /**
     * Get Recording by LivestreamID from Daily
     */
    recording(roomTitle: string): Promise<LiveStreamRecording> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/Recording/{roomTitle}";
        if (roomTitle === undefined || roomTitle === null)
            throw new Error("The parameter 'roomTitle' must be defined.");
        url_ = url_.replace("{roomTitle}", encodeURIComponent("" + roomTitle));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRecording(_response);
        });
    }

    protected processRecording(response: Response): Promise<LiveStreamRecording> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiveStreamRecording.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiveStreamRecording>(null as any);
    }

    /**
     * Get Recording by LivestreamID from Daily
     */
    accessLink(roomTitle: string): Promise<LiveRecordingLink> {
        let url_ = this.baseUrl + "/api/v1/Livestreams/Recording/{roomTitle}/access-link";
        if (roomTitle === undefined || roomTitle === null)
            throw new Error("The parameter 'roomTitle' must be defined.");
        url_ = url_.replace("{roomTitle}", encodeURIComponent("" + roomTitle));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAccessLink(_response);
        });
    }

    protected processAccessLink(response: Response): Promise<LiveRecordingLink> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiveRecordingLink.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiveRecordingLink>(null as any);
    }
}

export class LocumsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all Locums.
     * @param countryID (optional) 
     */
    admin(countryID?: string | undefined): Promise<Locum[]> {
        let url_ = this.baseUrl + "/api/v1/Locums/Admin?";
        if (countryID === null)
            throw new Error("The parameter 'countryID' cannot be null.");
        else if (countryID !== undefined)
            url_ += "countryID=" + encodeURIComponent("" + countryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Locum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Locum.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Locum[]>(null as any);
    }

    /**
     * Search for Locums in a Country
     */
    search(locumSearchDetails: LocumSearchDetails): Promise<PagedResultOfLocum> {
        let url_ = this.baseUrl + "/api/v1/Locums/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locumSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfLocum> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfLocum.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfLocum>(null as any);
    }

    /**
     * Posts the specified Locum.
     * @param locum The Locum.
     */
    locumsPost(locum: Locum): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Locums";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locum);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLocumsPost(_response);
        });
    }

    protected processLocumsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Locum.
     * @param locum The Locum.
     */
    locumsPut(locum: Locum): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Locums";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locum);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLocumsPut(_response);
        });
    }

    protected processLocumsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param locumID The identifier.
     */
    locumsDelete(locumID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Locums/{locumID}";
        if (locumID === undefined || locumID === null)
            throw new Error("The parameter 'locumID' must be defined.");
        url_ = url_.replace("{locumID}", encodeURIComponent("" + locumID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLocumsDelete(_response);
        });
    }

    protected processLocumsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Apply For locums
     */
    apply(locumApplicationDetails: LocumApplicationDetails): Promise<LocumApplicationResult> {
        let url_ = this.baseUrl + "/api/v1/Locums/Apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(locumApplicationDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApply(_response);
        });
    }

    protected processApply(response: Response): Promise<LocumApplicationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocumApplicationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocumApplicationResult>(null as any);
    }

    /**
     * Get the locums that I own and also include applications
     */
    myLocums(userDetailID: string): Promise<Locum[]> {
        let url_ = this.baseUrl + "/api/v1/Locums/MyLocums/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyLocums(_response);
        });
    }

    protected processMyLocums(response: Response): Promise<Locum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Locum.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Locum[]>(null as any);
    }

    /**
     * Get the locum applications that I applied for
     */
    myLocumsApplications(userDetailID: string): Promise<LocumApplication[]> {
        let url_ = this.baseUrl + "/api/v1/Locums/MyLocumsApplications/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyLocumsApplications(_response);
        });
    }

    protected processMyLocumsApplications(response: Response): Promise<LocumApplication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocumApplication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocumApplication[]>(null as any);
    }
}

export class MailMessagesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Retrieves the address book for the current user
     */
    addressBook(): Promise<MailMessageAddress[]> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/AddressBook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressBook(_response);
        });
    }

    protected processAddressBook(response: Response): Promise<MailMessageAddress[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailMessageAddress.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MailMessageAddress[]>(null as any);
    }

    /**
     * Gets all new unread email Count.
     */
    unReadCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/UnReadCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUnReadCount(_response);
        });
    }

    protected processUnReadCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets all Mail
     */
    allMail(folderName: string): Promise<MailMessage[]> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/AllMail/{folderName}";
        if (folderName === undefined || folderName === null)
            throw new Error("The parameter 'folderName' must be defined.");
        url_ = url_.replace("{folderName}", encodeURIComponent("" + folderName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllMail(_response);
        });
    }

    protected processAllMail(response: Response): Promise<MailMessage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MailMessage[]>(null as any);
    }

    /**
     * Gets all Mail
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    allGroupedMails(recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<PagedResultOfMailMessageGroup> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/AllGroupedMails?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllGroupedMails(_response);
        });
    }

    protected processAllGroupedMails(response: Response): Promise<PagedResultOfMailMessageGroup> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfMailMessageGroup.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfMailMessageGroup>(null as any);
    }

    /**
     * Gets Grouped Mails
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    allGroupMails(recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/AllGroupMails?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllGroupMails(_response);
        });
    }

    protected processAllGroupMails(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets Grouped Mails
     * @param userDetailID The UserDetail.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    allMails(userDetailID: string, recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/AllMails/{userDetailID}?";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllMails(_response);
        });
    }

    protected processAllMails(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Mark the mail message as being read or not
     * @param read (optional) 
     */
    markRead(mailMessageID: string, read?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/MarkRead/{mailMessageID}?";
        if (mailMessageID === undefined || mailMessageID === null)
            throw new Error("The parameter 'mailMessageID' must be defined.");
        url_ = url_.replace("{mailMessageID}", encodeURIComponent("" + mailMessageID));
        if (read === null)
            throw new Error("The parameter 'read' cannot be null.");
        else if (read !== undefined)
            url_ += "read=" + encodeURIComponent("" + read) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarkRead(_response);
        });
    }

    protected processMarkRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param mailMessageID The identifier.
     */
    mailMessagesGet(mailMessageID: string): Promise<MailMessage> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/{mailMessageID}";
        if (mailMessageID === undefined || mailMessageID === null)
            throw new Error("The parameter 'mailMessageID' must be defined.");
        url_ = url_.replace("{mailMessageID}", encodeURIComponent("" + mailMessageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMailMessagesGet(_response);
        });
    }

    protected processMailMessagesGet(response: Response): Promise<MailMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MailMessage>(null as any);
    }

    /**
     * Sends the MailMessage
     * @param mailMessage The MailMessage.
     */
    mailMessagesPost(mailMessage: MailMessage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MailMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mailMessage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMailMessagesPost(_response);
        });
    }

    protected processMailMessagesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Sends the MailMessage
     * @param mailMessage The MailMessage.
     */
    message(mailMessage: MailMessage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/Message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mailMessage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMessage(_response);
        });
    }

    protected processMessage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Sends the MailMessage
     * @param mailMessage The MailMessage.
     */
    notification(mailMessage: MailMessage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/Notification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mailMessage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNotification(_response);
        });
    }

    protected processNotification(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Moves the message to folder specified
     * @param mailMessageID The mail message identifier.
     * @param folderName Name of the folder.
     */
    move(mailMessageID: string, folderName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MailMessages/Move/{mailMessageID}/{folderName}";
        if (mailMessageID === undefined || mailMessageID === null)
            throw new Error("The parameter 'mailMessageID' must be defined.");
        url_ = url_.replace("{mailMessageID}", encodeURIComponent("" + mailMessageID));
        if (folderName === undefined || folderName === null)
            throw new Error("The parameter 'folderName' must be defined.");
        url_ = url_.replace("{folderName}", encodeURIComponent("" + folderName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMove(_response);
        });
    }

    protected processMove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MarketingCampaignPropertiesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<MarketingCampaignProperty[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignProperties/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<MarketingCampaignProperty[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaignProperty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignProperty[]>(null as any);
    }

    /**
     * Get the Properties for the MarketingCampaignID
     */
    byMarketingCampaignID(marketingCampaignID: string): Promise<MarketingCampaignProperty[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignProperties/ByMarketingCampaignID/{marketingCampaignID}";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByMarketingCampaignID(_response);
        });
    }

    protected processByMarketingCampaignID(response: Response): Promise<MarketingCampaignProperty[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaignProperty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignProperty[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param marketingCampaignPropertyID The identifier.
     */
    marketingCampaignPropertiesGet(marketingCampaignPropertyID: string): Promise<MarketingCampaignProperty> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignProperties/{marketingCampaignPropertyID}";
        if (marketingCampaignPropertyID === undefined || marketingCampaignPropertyID === null)
            throw new Error("The parameter 'marketingCampaignPropertyID' must be defined.");
        url_ = url_.replace("{marketingCampaignPropertyID}", encodeURIComponent("" + marketingCampaignPropertyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignPropertiesGet(_response);
        });
    }

    protected processMarketingCampaignPropertiesGet(response: Response): Promise<MarketingCampaignProperty> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignProperty.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignProperty>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param marketingCampaignPropertyID The identifier.
     */
    marketingCampaignPropertiesDelete(marketingCampaignPropertyID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignProperties/{marketingCampaignPropertyID}";
        if (marketingCampaignPropertyID === undefined || marketingCampaignPropertyID === null)
            throw new Error("The parameter 'marketingCampaignPropertyID' must be defined.");
        url_ = url_.replace("{marketingCampaignPropertyID}", encodeURIComponent("" + marketingCampaignPropertyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignPropertiesDelete(_response);
        });
    }

    protected processMarketingCampaignPropertiesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified MarketingCampaignProperty.
     * @param marketingCampaignProperty The MarketingCampaignProperty.
     */
    marketingCampaignPropertiesPost(marketingCampaignProperty: MarketingCampaignProperty): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignProperty);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignPropertiesPost(_response);
        });
    }

    protected processMarketingCampaignPropertiesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified MarketingCampaignProperty.
     */
    marketingCampaignPropertiesPut(marketingCampaignProperty: MarketingCampaignProperty): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignProperty);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignPropertiesPut(_response);
        });
    }

    protected processMarketingCampaignPropertiesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param marketingCampaignProperties The MarketingCampaignProperties.
     */
    many(marketingCampaignProperties: MarketingCampaignProperty[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignProperties/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignProperties);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class MarketingCampaignsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all referral campaigns.
     */
    active(countryID: string): Promise<MarketingCampaign[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/Active/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processActive(_response);
        });
    }

    protected processActive(response: Response): Promise<MarketingCampaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaign[]>(null as any);
    }

    /**
     * Gets the by marketing campaign identifier.
     * @param marketingCampaignID The marketing campaign identifier.
     */
    marketingCampaignsGet(marketingCampaignID: string): Promise<MarketingCampaign> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/{marketingCampaignID}";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignsGet(_response);
        });
    }

    protected processMarketingCampaignsGet(response: Response): Promise<MarketingCampaign> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaign.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaign>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param marketingCampaignID The marketing campaign identifier.
     */
    marketingCampaignsDelete(marketingCampaignID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/{marketingCampaignID}";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignsDelete(_response);
        });
    }

    protected processMarketingCampaignsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets my rewards.
     * @param acknowledged (optional) if set to true [acknowledged].
     */
    myRewards(acknowledged?: boolean | undefined): Promise<MarketingCampaignUserDetailReward[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/MyRewards?";
        if (acknowledged === null)
            throw new Error("The parameter 'acknowledged' cannot be null.");
        else if (acknowledged !== undefined)
            url_ += "acknowledged=" + encodeURIComponent("" + acknowledged) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyRewards(_response);
        });
    }

    protected processMyRewards(response: Response): Promise<MarketingCampaignUserDetailReward[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaignUserDetailReward.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignUserDetailReward[]>(null as any);
    }

    /**
     * Gets my summary.
     */
    mySummary(): Promise<MarketingCampaignRewardSummaryResults> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/MySummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMySummary(_response);
        });
    }

    protected processMySummary(response: Response): Promise<MarketingCampaignRewardSummaryResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignRewardSummaryResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignRewardSummaryResults>(null as any);
    }

    /**
     * Gets my summary with a date
     */
    mySummaryByDetailDate(marketingCampaignMySummaryDetails: MarketingCampaignMySummaryDetails): Promise<MarketingCampaignRewardSummaryResults> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/MySummaryByDetailDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignMySummaryDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMySummaryByDetailDate(_response);
        });
    }

    protected processMySummaryByDetailDate(response: Response): Promise<MarketingCampaignRewardSummaryResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignRewardSummaryResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignRewardSummaryResults>(null as any);
    }

    /**
     * Acknowledges the reward.
     * @param marketingCampaignUserDetailRewardID The marketing campaign user detail reward identifier.
     */
    acknowledgeReward(marketingCampaignUserDetailRewardID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/AcknowledgeReward/{marketingCampaignUserDetailRewardID}";
        if (marketingCampaignUserDetailRewardID === undefined || marketingCampaignUserDetailRewardID === null)
            throw new Error("The parameter 'marketingCampaignUserDetailRewardID' must be defined.");
        url_ = url_.replace("{marketingCampaignUserDetailRewardID}", encodeURIComponent("" + marketingCampaignUserDetailRewardID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAcknowledgeReward(_response);
        });
    }

    protected processAcknowledgeReward(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upserts userdetail to email marketing.
     * @param userDetailID The user detail identifier.
     */
    upsertToEmailMarketing(userDetailID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/UpsertToEmailMarketing/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpsertToEmailMarketing(_response);
        });
    }

    protected processUpsertToEmailMarketing(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the last acknowledged count.
     * @param marketingCampaignID The marketing campaign identifier.
     */
    lastAcknowledgedCount(marketingCampaignID: string): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/LastAcknowledgedCount/{marketingCampaignID}";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLastAcknowledgedCount(_response);
        });
    }

    protected processLastAcknowledgedCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Sets the last acknowledged date.
     * @param marketingCampaignID The marketing campaign identifier.
     */
    lastAcknowledgedDate(marketingCampaignID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/LastAcknowledgedDate/{marketingCampaignID}";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLastAcknowledgedDate(_response);
        });
    }

    protected processLastAcknowledgedDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the Marketing Campaign QR Code Image
     */
    qrcode(marketingCampaignID: string, userDetailID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/{marketingCampaignID}/qrcode/{userDetailID}";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processQrcode(_response);
        });
    }

    protected processQrcode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets all.
     */
    adminAll(): Promise<MarketingCampaign[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/AdminAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminAll(_response);
        });
    }

    protected processAdminAll(response: Response): Promise<MarketingCampaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaign[]>(null as any);
    }

    /**
     * Posts the specified ReferralCampaign.
     * @param referralCampaign The ReferralCampaign.
     */
    marketingCampaignsPost(referralCampaign: MarketingCampaign): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referralCampaign);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignsPost(_response);
        });
    }

    protected processMarketingCampaignsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ReferralCampaign.
     * @param referralCampaign The referral campaign.
     */
    marketingCampaignsPut(referralCampaign: MarketingCampaign): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referralCampaign);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignsPut(_response);
        });
    }

    protected processMarketingCampaignsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the current user referral code.
     * @param marketingCampaignID The marketing campaign identifier.
     */
    referralCode(marketingCampaignID: string): Promise<MarketingCampaignUserDetail> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/{marketingCampaignID}/referralCode";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReferralCode(_response);
        });
    }

    protected processReferralCode(response: Response): Promise<MarketingCampaignUserDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignUserDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignUserDetail>(null as any);
    }

    /**
     * Validates the referral code.
     * @param referralCode The referral code.
     */
    validateReferralCode(referralCode: string): Promise<MarketingCampaignValidationResult> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/ValidateReferralCode/{referralCode}";
        if (referralCode === undefined || referralCode === null)
            throw new Error("The parameter 'referralCode' must be defined.");
        url_ = url_.replace("{referralCode}", encodeURIComponent("" + referralCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processValidateReferralCode(_response);
        });
    }

    protected processValidateReferralCode(response: Response): Promise<MarketingCampaignValidationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignValidationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignValidationResult>(null as any);
    }

    /**
     * Inserts the event tracking.
     * @param eventTrackingDetail The event tracking detail.
     */
    eventTracking(eventTrackingDetail: EventTrackingDetail): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/EventTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventTrackingDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEventTracking(_response);
        });
    }

    protected processEventTracking(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Inserts the event tracking.
     * @param eventTrackingDetail The event tracking detail.
     */
    externalEventTracking(eventTrackingDetail: EventTrackingDetail): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/ExternalEventTracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventTrackingDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processExternalEventTracking(_response);
        });
    }

    protected processExternalEventTracking(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the marketing campaignReport
     */
    report(marketingCampaignID: string): Promise<MarketingCampaignReport> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/{marketingCampaignID}/Report";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReport(_response);
        });
    }

    protected processReport(response: Response): Promise<MarketingCampaignReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignReport.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignReport>(null as any);
    }

    /**
     * Get the marketing campaignReport
     */
    addPatients(marketingCampaignID: string, numberOfPatients: number, rewardAmount: number): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/AddPatients/{marketingCampaignID}/{numberOfPatients}/{rewardAmount}";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        if (numberOfPatients === undefined || numberOfPatients === null)
            throw new Error("The parameter 'numberOfPatients' must be defined.");
        url_ = url_.replace("{numberOfPatients}", encodeURIComponent("" + numberOfPatients));
        if (rewardAmount === undefined || rewardAmount === null)
            throw new Error("The parameter 'rewardAmount' must be defined.");
        url_ = url_.replace("{rewardAmount}", encodeURIComponent("" + rewardAmount));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddPatients(_response);
        });
    }

    protected processAddPatients(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get the marketing campaigns for the user by userDetailID
     */
    byUserDetailID(userDetailID: string): Promise<MarketingCampaign[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<MarketingCampaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaign[]>(null as any);
    }

    /**
     * Insert marketing campaign users by email
     */
    addPatientsEmailAddresses(marketingCampaignAddPatientsDetails: MarketingCampaignAddPatientsDetails): Promise<MarketingCampaignAddPatientsResults> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaigns/AddPatientsEmailAddresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignAddPatientsDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddPatientsEmailAddresses(_response);
        });
    }

    protected processAddPatientsEmailAddresses(response: Response): Promise<MarketingCampaignAddPatientsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignAddPatientsResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignAddPatientsResults>(null as any);
    }
}

export class MarketingCampaignUserDetailRewardsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<MarketingCampaignUserDetailReward[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetailRewards/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<MarketingCampaignUserDetailReward[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaignUserDetailReward.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignUserDetailReward[]>(null as any);
    }

    /**
     * Get the UserDetailRewards for the MarketingCampaignID
     */
    byMarketingCampaignUserDetailID(marketingCampaignUserDetailID: string): Promise<MarketingCampaignUserDetailReward[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetailRewards/ByMarketingCampaignUserDetailID/{marketingCampaignUserDetailID}";
        if (marketingCampaignUserDetailID === undefined || marketingCampaignUserDetailID === null)
            throw new Error("The parameter 'marketingCampaignUserDetailID' must be defined.");
        url_ = url_.replace("{marketingCampaignUserDetailID}", encodeURIComponent("" + marketingCampaignUserDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByMarketingCampaignUserDetailID(_response);
        });
    }

    protected processByMarketingCampaignUserDetailID(response: Response): Promise<MarketingCampaignUserDetailReward[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaignUserDetailReward.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignUserDetailReward[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param marketingCampaignUserDetailRewardID The identifier.
     */
    marketingCampaignUserDetailRewardsGet(marketingCampaignUserDetailRewardID: string): Promise<MarketingCampaignUserDetailReward> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetailRewards/{marketingCampaignUserDetailRewardID}";
        if (marketingCampaignUserDetailRewardID === undefined || marketingCampaignUserDetailRewardID === null)
            throw new Error("The parameter 'marketingCampaignUserDetailRewardID' must be defined.");
        url_ = url_.replace("{marketingCampaignUserDetailRewardID}", encodeURIComponent("" + marketingCampaignUserDetailRewardID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignUserDetailRewardsGet(_response);
        });
    }

    protected processMarketingCampaignUserDetailRewardsGet(response: Response): Promise<MarketingCampaignUserDetailReward> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignUserDetailReward.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignUserDetailReward>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param marketingCampaignUserDetailRewardID The identifier.
     */
    marketingCampaignUserDetailRewardsDelete(marketingCampaignUserDetailRewardID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetailRewards/{marketingCampaignUserDetailRewardID}";
        if (marketingCampaignUserDetailRewardID === undefined || marketingCampaignUserDetailRewardID === null)
            throw new Error("The parameter 'marketingCampaignUserDetailRewardID' must be defined.");
        url_ = url_.replace("{marketingCampaignUserDetailRewardID}", encodeURIComponent("" + marketingCampaignUserDetailRewardID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignUserDetailRewardsDelete(_response);
        });
    }

    protected processMarketingCampaignUserDetailRewardsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified MarketingCampaignUserDetailReward.
     * @param marketingCampaignUserDetailReward The MarketingCampaignUserDetailReward.
     */
    marketingCampaignUserDetailRewardsPost(marketingCampaignUserDetailReward: MarketingCampaignUserDetailReward): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetailRewards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignUserDetailReward);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignUserDetailRewardsPost(_response);
        });
    }

    protected processMarketingCampaignUserDetailRewardsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified MarketingCampaignUserDetailReward.
     */
    marketingCampaignUserDetailRewardsPut(marketingCampaignUserDetailReward: MarketingCampaignUserDetailReward): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetailRewards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignUserDetailReward);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignUserDetailRewardsPut(_response);
        });
    }

    protected processMarketingCampaignUserDetailRewardsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param marketingCampaignUserDetailRewards The MarketingCampaignUserDetailRewards.
     */
    many(marketingCampaignUserDetailRewards: MarketingCampaignUserDetailReward[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetailRewards/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignUserDetailRewards);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class MarketingCampaignUserDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<MarketingCampaignUserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<MarketingCampaignUserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaignUserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignUserDetail[]>(null as any);
    }

    /**
     * Get the UserDetails for the MarketingCampaignID
     */
    byMarketingCampaignID(marketingCampaignID: string): Promise<MarketingCampaignUserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetails/ByMarketingCampaignID/{marketingCampaignID}";
        if (marketingCampaignID === undefined || marketingCampaignID === null)
            throw new Error("The parameter 'marketingCampaignID' must be defined.");
        url_ = url_.replace("{marketingCampaignID}", encodeURIComponent("" + marketingCampaignID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByMarketingCampaignID(_response);
        });
    }

    protected processByMarketingCampaignID(response: Response): Promise<MarketingCampaignUserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaignUserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignUserDetail[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param marketingCampaignUserDetailID The identifier.
     */
    marketingCampaignUserDetailsGet(marketingCampaignUserDetailID: string): Promise<MarketingCampaignUserDetail> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetails/{marketingCampaignUserDetailID}";
        if (marketingCampaignUserDetailID === undefined || marketingCampaignUserDetailID === null)
            throw new Error("The parameter 'marketingCampaignUserDetailID' must be defined.");
        url_ = url_.replace("{marketingCampaignUserDetailID}", encodeURIComponent("" + marketingCampaignUserDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignUserDetailsGet(_response);
        });
    }

    protected processMarketingCampaignUserDetailsGet(response: Response): Promise<MarketingCampaignUserDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingCampaignUserDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaignUserDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param marketingCampaignUserDetailID The identifier.
     */
    marketingCampaignUserDetailsDelete(marketingCampaignUserDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetails/{marketingCampaignUserDetailID}";
        if (marketingCampaignUserDetailID === undefined || marketingCampaignUserDetailID === null)
            throw new Error("The parameter 'marketingCampaignUserDetailID' must be defined.");
        url_ = url_.replace("{marketingCampaignUserDetailID}", encodeURIComponent("" + marketingCampaignUserDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignUserDetailsDelete(_response);
        });
    }

    protected processMarketingCampaignUserDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified MarketingCampaignUserDetail.
     * @param marketingCampaignUserDetail The MarketingCampaignUserDetail.
     */
    marketingCampaignUserDetailsPost(marketingCampaignUserDetail: MarketingCampaignUserDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignUserDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignUserDetailsPost(_response);
        });
    }

    protected processMarketingCampaignUserDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified MarketingCampaignUserDetail.
     */
    marketingCampaignUserDetailsPut(marketingCampaignUserDetail: MarketingCampaignUserDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignUserDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaignUserDetailsPut(_response);
        });
    }

    protected processMarketingCampaignUserDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param marketingCampaignUserDetails The MarketingCampaignUserDetails.
     */
    many(marketingCampaignUserDetails: MarketingCampaignUserDetail[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/MarketingCampaignUserDetails/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(marketingCampaignUserDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class MedicationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all Medications.
     */
    admin(countryID: string): Promise<Medication[]> {
        let url_ = this.baseUrl + "/api/v1/Medications/Admin/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Medication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Medication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medication[]>(null as any);
    }

    /**
     * Gets all enabled medications by country identifier.
     * @param countryID The country identifier.
     * @param storeID (optional) 
     * @param addressBookID (optional) 
     */
    byCountryID(countryID: string, storeID?: string | null | undefined, addressBookID?: string | null | undefined): Promise<Medication[]> {
        let url_ = this.baseUrl + "/api/v1/Medications/ByCountryID/{countryID}?";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        if (storeID !== undefined && storeID !== null)
            url_ += "storeID=" + encodeURIComponent("" + storeID) + "&";
        if (addressBookID !== undefined && addressBookID !== null)
            url_ += "addressBookID=" + encodeURIComponent("" + addressBookID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCountryID(_response);
        });
    }

    protected processByCountryID(response: Response): Promise<Medication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Medication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medication[]>(null as any);
    }

    /**
     * Gets all enabled medications.
     */
    medicationsGet(medicationID: string): Promise<Medication> {
        let url_ = this.baseUrl + "/api/v1/Medications/{medicationID}";
        if (medicationID === undefined || medicationID === null)
            throw new Error("The parameter 'medicationID' must be defined.");
        url_ = url_.replace("{medicationID}", encodeURIComponent("" + medicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMedicationsGet(_response);
        });
    }

    protected processMedicationsGet(response: Response): Promise<Medication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Medication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medication>(null as any);
    }

    /**
     * Searches the specified medication search details.
     * @param medicationSearchDetails The medication search details.
     */
    search(medicationSearchDetails: MedicationSearchDetails): Promise<PagedResultOfMedication> {
        let url_ = this.baseUrl + "/api/v1/Medications/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfMedication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfMedication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfMedication>(null as any);
    }

    /**
     * Posts the specified Medication.
     * @param medication The Medication.
     */
    medicationsPost(medication: Medication): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Medications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medication);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMedicationsPost(_response);
        });
    }

    protected processMedicationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Medication.
     * @param medication The Medication.
     */
    medicationsPut(medication: Medication): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Medications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMedicationsPut(_response);
        });
    }

    protected processMedicationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified Medication.
     * @param medication The Medication.
     */
    many(medication: Medication[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Medications/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medication);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param medicationID The identifier.
     */
    medicationsDelete(medicationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Medications/{MedicationID}";
        if (medicationID === undefined || medicationID === null)
            throw new Error("The parameter 'medicationID' must be defined.");
        url_ = url_.replace("{MedicationID}", encodeURIComponent("" + medicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMedicationsDelete(_response);
        });
    }

    protected processMedicationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MessageTemplatesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all MessageTemplates.
     */
    all(): Promise<MessageTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/MessageTemplates/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<MessageTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageTemplate[]>(null as any);
    }

    /**
     * Gets the by message template identifier.
     * @param messageTemplateID The message template identifier.
     */
    messageTemplatesGet(messageTemplateID: string): Promise<MessageTemplate> {
        let url_ = this.baseUrl + "/api/v1/MessageTemplates/{messageTemplateID}";
        if (messageTemplateID === undefined || messageTemplateID === null)
            throw new Error("The parameter 'messageTemplateID' must be defined.");
        url_ = url_.replace("{messageTemplateID}", encodeURIComponent("" + messageTemplateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMessageTemplatesGet(_response);
        });
    }

    protected processMessageTemplatesGet(response: Response): Promise<MessageTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageTemplate>(null as any);
    }

    /**
     * Gets the short name of the by message.
     * @param shortName The short name.
     */
    byShortName(shortName: string): Promise<MessageTemplate> {
        let url_ = this.baseUrl + "/api/v1/MessageTemplates/ByShortName/{shortName}";
        if (shortName === undefined || shortName === null)
            throw new Error("The parameter 'shortName' must be defined.");
        url_ = url_.replace("{shortName}", encodeURIComponent("" + shortName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByShortName(_response);
        });
    }

    protected processByShortName(response: Response): Promise<MessageTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageTemplate>(null as any);
    }

    /**
     * Posts the specified MessageTemplate.
     * @param messageTemplate The MessageTemplate.
     */
    messageTemplatesPost(messageTemplate: MessageTemplate): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MessageTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageTemplate);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMessageTemplatesPost(_response);
        });
    }

    protected processMessageTemplatesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified MessageTemplate.
     * @param messageTemplate The MessageTemplate.
     */
    messageTemplatesPut(messageTemplate: MessageTemplate): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/MessageTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messageTemplate);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMessageTemplatesPut(_response);
        });
    }

    protected processMessageTemplatesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param messageTemplateID The identifier.
     */
    messageTemplatesDelete(messageTemplateID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/MessageTemplates/{MessageTemplateID}";
        if (messageTemplateID === undefined || messageTemplateID === null)
            throw new Error("The parameter 'messageTemplateID' must be defined.");
        url_ = url_.replace("{MessageTemplateID}", encodeURIComponent("" + messageTemplateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMessageTemplatesDelete(_response);
        });
    }

    protected processMessageTemplatesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MidraClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the balance.
     * @param midraRequest The midra request.
     */
    getBalance(midraRequest: MidraRequest): Promise<MidraResponse> {
        let url_ = this.baseUrl + "/api/v1/Midra/GetBalance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(midraRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetBalance(_response);
        });
    }

    protected processGetBalance(response: Response): Promise<MidraResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MidraResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MidraResponse>(null as any);
    }

    /**
     * Wallets the deposit.
     * @param midraRequest The midra request.
     */
    walletDeposit(midraRequest: MidraRequest): Promise<MidraResponse> {
        let url_ = this.baseUrl + "/api/v1/Midra/WalletDeposit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(midraRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletDeposit(_response);
        });
    }

    protected processWalletDeposit(response: Response): Promise<MidraResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MidraResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MidraResponse>(null as any);
    }

    /**
     * Views the invoice.
     * @param midraRequest The midra request.
     */
    viewInvoice(midraRequest: MidraRequest): Promise<MidraResponse> {
        let url_ = this.baseUrl + "/api/v1/Midra/ViewInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(midraRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processViewInvoice(_response);
        });
    }

    protected processViewInvoice(response: Response): Promise<MidraResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MidraResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MidraResponse>(null as any);
    }

    /**
     * Pays the invoice.
     * @param midraRequest The midra request.
     */
    payInvoice(midraRequest: MidraRequest): Promise<MidraResponse> {
        let url_ = this.baseUrl + "/api/v1/Midra/PayInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(midraRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayInvoice(_response);
        });
    }

    protected processPayInvoice(response: Response): Promise<MidraResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MidraResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MidraResponse>(null as any);
    }

    /**
     * Pays the invoice with wallet.
     * @param midraRequest The midra request.
     */
    payInvoiceWithWallet(midraRequest: MidraRequest): Promise<MidraResponse> {
        let url_ = this.baseUrl + "/api/v1/Midra/PayInvoiceWithWallet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(midraRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayInvoiceWithWallet(_response);
        });
    }

    protected processPayInvoiceWithWallet(response: Response): Promise<MidraResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MidraResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MidraResponse>(null as any);
    }

    /**
     * Gets the banks.
     * @param midraRequest The midra request.
     */
    getBanks(midraRequest: MidraRequest): Promise<MidraListResponse> {
        let url_ = this.baseUrl + "/api/v1/Midra/GetBanks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(midraRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetBanks(_response);
        });
    }

    protected processGetBanks(response: Response): Promise<MidraListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MidraListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MidraListResponse>(null as any);
    }
}

export class ModuleResourceDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the module ResourceDetail.
     * @param moduleResourceID The module resource identifier.
     */
    byModuleResourceID(moduleResourceID: string): Promise<ModuleResourceDetail[]> {
        let url_ = this.baseUrl + "/api/v1/ModuleResourceDetails/ByModuleResourceID/{moduleResourceID}";
        if (moduleResourceID === undefined || moduleResourceID === null)
            throw new Error("The parameter 'moduleResourceID' must be defined.");
        url_ = url_.replace("{moduleResourceID}", encodeURIComponent("" + moduleResourceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByModuleResourceID(_response);
        });
    }

    protected processByModuleResourceID(response: Response): Promise<ModuleResourceDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModuleResourceDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleResourceDetail[]>(null as any);
    }

    /**
     * Gets the module ResourceDetail.
     * @param moduleResourceDetailID The module ResourceDetail identifier.
     */
    moduleResourceDetailsGet(moduleResourceDetailID: string): Promise<ModuleResourceDetail> {
        let url_ = this.baseUrl + "/api/v1/ModuleResourceDetails/{moduleResourceDetailID}";
        if (moduleResourceDetailID === undefined || moduleResourceDetailID === null)
            throw new Error("The parameter 'moduleResourceDetailID' must be defined.");
        url_ = url_.replace("{moduleResourceDetailID}", encodeURIComponent("" + moduleResourceDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResourceDetailsGet(_response);
        });
    }

    protected processModuleResourceDetailsGet(response: Response): Promise<ModuleResourceDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleResourceDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleResourceDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param moduleResourceDetailID The identifier.
     */
    moduleResourceDetailsDelete(moduleResourceDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ModuleResourceDetails/{moduleResourceDetailID}";
        if (moduleResourceDetailID === undefined || moduleResourceDetailID === null)
            throw new Error("The parameter 'moduleResourceDetailID' must be defined.");
        url_ = url_.replace("{moduleResourceDetailID}", encodeURIComponent("" + moduleResourceDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResourceDetailsDelete(_response);
        });
    }

    protected processModuleResourceDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ModuleResourceDetail.
     * @param moduleResourceDetail The ModuleResourceDetail.
     */
    moduleResourceDetailsPost(moduleResourceDetail: ModuleResourceDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ModuleResourceDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleResourceDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResourceDetailsPost(_response);
        });
    }

    protected processModuleResourceDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ModuleResourceDetail setting.
     * @param moduleResourceDetail The module ResourceDetail.
     */
    moduleResourceDetailsPut(moduleResourceDetail: ModuleResourceDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ModuleResourceDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleResourceDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResourceDetailsPut(_response);
        });
    }

    protected processModuleResourceDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getModuleResourceDetail(resourceID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ModuleResourceDetails/GetModuleResourceDetail/{resourceID}";
        if (resourceID === undefined || resourceID === null)
            throw new Error("The parameter 'resourceID' must be defined.");
        url_ = url_.replace("{resourceID}", encodeURIComponent("" + resourceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetModuleResourceDetail(_response);
        });
    }

    protected processGetModuleResourceDetail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ModuleResourcesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the module resource.
     * @param moduleID The module identifier.
     */
    byModuleID(moduleID: string): Promise<ModuleResource[]> {
        let url_ = this.baseUrl + "/api/v1/ModuleResources/ByModuleID/{moduleID}";
        if (moduleID === undefined || moduleID === null)
            throw new Error("The parameter 'moduleID' must be defined.");
        url_ = url_.replace("{moduleID}", encodeURIComponent("" + moduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByModuleID(_response);
        });
    }

    protected processByModuleID(response: Response): Promise<ModuleResource[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModuleResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleResource[]>(null as any);
    }

    /**
     * Gets the module resource.
     * @param moduleResourceID The module resource identifier.
     */
    moduleResourcesGet(moduleResourceID: string): Promise<ModuleResource> {
        let url_ = this.baseUrl + "/api/v1/ModuleResources/{moduleResourceID}";
        if (moduleResourceID === undefined || moduleResourceID === null)
            throw new Error("The parameter 'moduleResourceID' must be defined.");
        url_ = url_.replace("{moduleResourceID}", encodeURIComponent("" + moduleResourceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResourcesGet(_response);
        });
    }

    protected processModuleResourcesGet(response: Response): Promise<ModuleResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleResource.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleResource>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param moduleResourceID The identifier.
     */
    moduleResourcesDelete(moduleResourceID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ModuleResources/{moduleResourceID}";
        if (moduleResourceID === undefined || moduleResourceID === null)
            throw new Error("The parameter 'moduleResourceID' must be defined.");
        url_ = url_.replace("{moduleResourceID}", encodeURIComponent("" + moduleResourceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResourcesDelete(_response);
        });
    }

    protected processModuleResourcesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ModuleResource.
     * @param moduleResource The ModuleResource.
     */
    moduleResourcesPost(moduleResource: ModuleResource): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ModuleResources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleResource);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResourcesPost(_response);
        });
    }

    protected processModuleResourcesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ModuleResource setting.
     * @param moduleResource The module resource.
     */
    moduleResourcesPut(moduleResource: ModuleResource): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ModuleResources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moduleResource);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResourcesPut(_response);
        });
    }

    protected processModuleResourcesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ModulesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Module[]> {
        let url_ = this.baseUrl + "/api/v1/Modules/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    /**
     * Gets all modules for current user.
     */
    menuModules(): Promise<Module[]> {
        let url_ = this.baseUrl + "/api/v1/Modules/MenuModules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMenuModules(_response);
        });
    }

    protected processMenuModules(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<Module[]> {
        let url_ = this.baseUrl + "/api/v1/Modules/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    /**
     * Gets a list of modules by RoleName
     * @param roleName Name of the role.
     */
    modulesByRoleName(roleName: string): Promise<Module[]> {
        let url_ = this.baseUrl + "/api/v1/Modules/ModulesByRoleName/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModulesByRoleName(_response);
        });
    }

    protected processModulesByRoleName(response: Response): Promise<Module[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Module.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module[]>(null as any);
    }

    modulesGet(moduleID: string): Promise<Module> {
        let url_ = this.baseUrl + "/api/v1/Modules/{moduleID}";
        if (moduleID === undefined || moduleID === null)
            throw new Error("The parameter 'moduleID' must be defined.");
        url_ = url_.replace("{moduleID}", encodeURIComponent("" + moduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModulesGet(_response);
        });
    }

    protected processModulesGet(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Module.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(null as any);
    }

    /**
     * Posts the specified Module.
     * @param module The Module.
     */
    modulesPost(module: Module): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(module);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModulesPost(_response);
        });
    }

    protected processModulesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Module setting.
     * @param module The Module setting.
     */
    modulesPut(module: Module): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(module);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModulesPut(_response);
        });
    }

    protected processModulesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param moduleID The identifier.
     */
    modulesDelete(moduleID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Modules/{ModuleID}";
        if (moduleID === undefined || moduleID === null)
            throw new Error("The parameter 'moduleID' must be defined.");
        url_ = url_.replace("{ModuleID}", encodeURIComponent("" + moduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModulesDelete(_response);
        });
    }

    protected processModulesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the module resource by module resource identifier.
     * @param moduleID The module identifier.
     * @param moduleResourceID The module resource identifier.
     */
    moduleResources(moduleID: string, moduleResourceID: string): Promise<ModuleResource> {
        let url_ = this.baseUrl + "/api/v1/Modules/{moduleID}/ModuleResources/{moduleResourceID}";
        if (moduleID === undefined || moduleID === null)
            throw new Error("The parameter 'moduleID' must be defined.");
        url_ = url_.replace("{moduleID}", encodeURIComponent("" + moduleID));
        if (moduleResourceID === undefined || moduleResourceID === null)
            throw new Error("The parameter 'moduleResourceID' must be defined.");
        url_ = url_.replace("{moduleResourceID}", encodeURIComponent("" + moduleResourceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processModuleResources(_response);
        });
    }

    protected processModuleResources(response: Response): Promise<ModuleResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleResource.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleResource>(null as any);
    }

    /**
     * Get the resource libray
     */
    resourceLibrary(): Promise<ResourceLibraryDTO> {
        let url_ = this.baseUrl + "/api/v1/Modules/ResourceLibrary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processResourceLibrary(_response);
        });
    }

    protected processResourceLibrary(response: Response): Promise<ResourceLibraryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceLibraryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceLibraryDTO>(null as any);
    }
}

export class NotificationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Register a device for Patient notifications
     * @deprecated
     */
    registerDevice(deviceRegistration: NotificationDeviceRegistration): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Notifications/RegisterDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceRegistration);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRegisterDevice(_response);
        });
    }

    protected processRegisterDevice(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Send a Notification to a Patient
     */
    sendPatientNotification(notificationMessage: NotificationMessage): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Notifications/SendPatientNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationMessage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendPatientNotification(_response);
        });
    }

    protected processSendPatientNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Send a Notification to a Provider
     */
    sendProviderNotification(notificationMessage: NotificationMessage): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Notifications/SendProviderNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationMessage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendProviderNotification(_response);
        });
    }

    protected processSendProviderNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param notificationID The identifier.
     */
    notifications(notificationID: string): Promise<Notification> {
        let url_ = this.baseUrl + "/api/v1/Notifications/{notificationID}";
        if (notificationID === undefined || notificationID === null)
            throw new Error("The parameter 'notificationID' must be defined.");
        url_ = url_.replace("{notificationID}", encodeURIComponent("" + notificationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNotifications(_response);
        });
    }

    protected processNotifications(response: Response): Promise<Notification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Notification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification>(null as any);
    }

    /**
     * Get Notifications by UserDetailID
     */
    byUserDetailID(userDetailID: string): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/v1/Notifications/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }

    /**
     * Send Approve / deny notification
     */
    sendApproveDenyRequest(approveDenyNotificationMessageData: ApproveDenyNotificationMessageData): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Notifications/SendApproveDenyRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(approveDenyNotificationMessageData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendApproveDenyRequest(_response);
        });
    }

    protected processSendApproveDenyRequest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Approve / deny the notification
     */
    approveDenyResponse(approveDenyResponse: ApproveDenyResponse): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Notifications/ApproveDenyResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(approveDenyResponse);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApproveDenyResponse(_response);
        });
    }

    protected processApproveDenyResponse(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get any outstanding notifications for the patient
     */
    outstandingNotifications(userDetailID: string): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/v1/Notifications/OutstandingNotifications/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOutstandingNotifications(_response);
        });
    }

    protected processOutstandingNotifications(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }

    /**
     * Get any outstanding response (target) notifications for this user
     */
    outstandingResponseNotifications(userDetailID: string): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/v1/Notifications/OutstandingResponseNotifications/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOutstandingResponseNotifications(_response);
        });
    }

    protected processOutstandingResponseNotifications(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }

    /**
     * Search the SMS's
     */
    search(notificationSearchDetails: NotificationSearchDetails): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/v1/Notifications/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(null as any);
    }
}

export class OrganizationImagesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<OrganizationImage[]> {
        let url_ = this.baseUrl + "/api/v1/OrganizationImages/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<OrganizationImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationImage[]>(null as any);
    }

    /**
     * Get the images for the OrganizationID
     */
    byOrganizationID(organizationID: string): Promise<OrganizationImage[]> {
        let url_ = this.baseUrl + "/api/v1/OrganizationImages/ByOrganizationID/{organizationID}";
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByOrganizationID(_response);
        });
    }

    protected processByOrganizationID(response: Response): Promise<OrganizationImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationImage[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param organizationImageID The identifier.
     */
    organizationImagesGet(organizationImageID: string): Promise<OrganizationImage> {
        let url_ = this.baseUrl + "/api/v1/OrganizationImages/{organizationImageID}";
        if (organizationImageID === undefined || organizationImageID === null)
            throw new Error("The parameter 'organizationImageID' must be defined.");
        url_ = url_.replace("{organizationImageID}", encodeURIComponent("" + organizationImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrganizationImagesGet(_response);
        });
    }

    protected processOrganizationImagesGet(response: Response): Promise<OrganizationImage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationImage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationImage>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param organizationImageID The identifier.
     */
    organizationImagesDelete(organizationImageID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/OrganizationImages/{organizationImageID}";
        if (organizationImageID === undefined || organizationImageID === null)
            throw new Error("The parameter 'organizationImageID' must be defined.");
        url_ = url_.replace("{organizationImageID}", encodeURIComponent("" + organizationImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrganizationImagesDelete(_response);
        });
    }

    protected processOrganizationImagesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified OrganizationImage.
     * @param organizationImage The OrganizationImage.
     */
    organizationImagesPost(organizationImage: OrganizationImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/OrganizationImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organizationImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrganizationImagesPost(_response);
        });
    }

    protected processOrganizationImagesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified OrganizationImage.
     */
    organizationImagesPut(organizationImage: OrganizationImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/OrganizationImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organizationImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrganizationImagesPut(_response);
        });
    }

    protected processOrganizationImagesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param organizationImages The OrganizationImages.
     */
    many(organizationImages: OrganizationImage[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/OrganizationImages/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organizationImages);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class OrganizationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Organization[]> {
        let url_ = this.baseUrl + "/api/v1/Organizations/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Organization[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organization[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param organizationID The identifier.
     */
    organizationsGet(organizationID: string): Promise<Organization> {
        let url_ = this.baseUrl + "/api/v1/Organizations/{organizationID}";
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrganizationsGet(_response);
        });
    }

    protected processOrganizationsGet(response: Response): Promise<Organization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Organization.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organization>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param organizationID The identifier.
     */
    organizationsDelete(organizationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Organizations/{organizationID}";
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrganizationsDelete(_response);
        });
    }

    protected processOrganizationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by country identifier asynchronous.
     * @param countryID The country identifier.
     */
    byCountryID(countryID: string): Promise<Organization[]> {
        let url_ = this.baseUrl + "/api/v1/Organizations/ByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCountryID(_response);
        });
    }

    protected processByCountryID(response: Response): Promise<Organization[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Organization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Organization[]>(null as any);
    }

    /**
     * Posts the specified Organization.
     * @param organization The Organization.
     */
    organizationsPost(organization: Organization): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrganizationsPost(_response);
        });
    }

    protected processOrganizationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Organization.
     * @param organization The organization.
     */
    organizationsPut(organization: Organization): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organization);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrganizationsPut(_response);
        });
    }

    protected processOrganizationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * PublicTag Availability Check
     */
    adminIsPublicTagAvailable(organizationID: string, publicTag: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Organizations/AdminIsPublicTagAvailable/{organizationID}/{publicTag}";
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        if (publicTag === undefined || publicTag === null)
            throw new Error("The parameter 'publicTag' must be defined.");
        url_ = url_.replace("{publicTag}", encodeURIComponent("" + publicTag));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminIsPublicTagAvailable(_response);
        });
    }

    protected processAdminIsPublicTagAvailable(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get the Organization's profile image
     */
    profileImage(organizationID: string, imageDetailID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Organizations/{organizationID}/ProfileImage/{imageDetailID}";
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        if (imageDetailID === undefined || imageDetailID === null)
            throw new Error("The parameter 'imageDetailID' must be defined.");
        url_ = url_.replace("{imageDetailID}", encodeURIComponent("" + imageDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProfileImage(_response);
        });
    }

    protected processProfileImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PartnersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get All
     */
    all(): Promise<Partner[]> {
        let url_ = this.baseUrl + "/api/v1/Partners/All";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Partner[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Partner.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Partner[]>(null as any);
    }

    /**
     * Get the Partner information
     */
    search(partnerSearchDetails: PartnerSearchDetails): Promise<Partner> {
        let url_ = this.baseUrl + "/api/v1/Partners/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partnerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Partner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Partner.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Partner>(null as any);
    }

    /**
     * Get by Partner ID
     */
    partnersGet(partnerID: string): Promise<Partner> {
        let url_ = this.baseUrl + "/api/v1/Partners/{partnerID}";
        if (partnerID === undefined || partnerID === null)
            throw new Error("The parameter 'partnerID' must be defined.");
        url_ = url_.replace("{partnerID}", encodeURIComponent("" + partnerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPartnersGet(_response);
        });
    }

    protected processPartnersGet(response: Response): Promise<Partner> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Partner.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Partner>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param partnerID The identifier.
     */
    partnersDelete(partnerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Partners/{partnerID}";
        if (partnerID === undefined || partnerID === null)
            throw new Error("The parameter 'partnerID' must be defined.");
        url_ = url_.replace("{partnerID}", encodeURIComponent("" + partnerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPartnersDelete(_response);
        });
    }

    protected processPartnersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Partner.
     * @param partner The Partner.
     */
    partnersPost(partner: Partner): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Partners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partner);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPartnersPost(_response);
        });
    }

    protected processPartnersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Partner.
     * @param partner The Partner.
     */
    partnersPut(partner: Partner): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Partners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partner);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPartnersPut(_response);
        });
    }

    protected processPartnersPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PartnerSettingsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the by Partner identifier.
     * @param partnerID The Partner identifier.
     */
    byPartnerID(partnerID: string): Promise<PartnerSetting[]> {
        let url_ = this.baseUrl + "/api/v1/PartnerSettings/ByPartnerID/{partnerID}";
        if (partnerID === undefined || partnerID === null)
            throw new Error("The parameter 'partnerID' must be defined.");
        url_ = url_.replace("{partnerID}", encodeURIComponent("" + partnerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPartnerID(_response);
        });
    }

    protected processByPartnerID(response: Response): Promise<PartnerSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerSetting[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param partnerSettingID The identifier.
     */
    partnerSettingsGet(partnerSettingID: string): Promise<PartnerSetting> {
        let url_ = this.baseUrl + "/api/v1/PartnerSettings/{partnerSettingID}";
        if (partnerSettingID === undefined || partnerSettingID === null)
            throw new Error("The parameter 'partnerSettingID' must be defined.");
        url_ = url_.replace("{partnerSettingID}", encodeURIComponent("" + partnerSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPartnerSettingsGet(_response);
        });
    }

    protected processPartnerSettingsGet(response: Response): Promise<PartnerSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartnerSetting>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param partnerSettingID The identifier.
     */
    partnerSettingsDelete(partnerSettingID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PartnerSettings/{partnerSettingID}";
        if (partnerSettingID === undefined || partnerSettingID === null)
            throw new Error("The parameter 'partnerSettingID' must be defined.");
        url_ = url_.replace("{partnerSettingID}", encodeURIComponent("" + partnerSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPartnerSettingsDelete(_response);
        });
    }

    protected processPartnerSettingsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified PartnerSetting.
     * @param partnerSetting The PartnerSetting.
     */
    partnerSettingsPost(partnerSetting: PartnerSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PartnerSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partnerSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPartnerSettingsPost(_response);
        });
    }

    protected processPartnerSettingsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PartnerSetting.
     * @param partnerSetting The PartnerSetting.
     */
    partnerSettingsPut(partnerSetting: PartnerSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PartnerSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partnerSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPartnerSettingsPut(_response);
        });
    }

    protected processPartnerSettingsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PasswordResetClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Sends the email code.
     * @param details The details.
     * @param apiKey The API key.
     */
    sendEmailCode(details: ResetPasswordEmailDetails, apiKey: string): Promise<ResetPasswordEmailResult> {
        let url_ = this.baseUrl + "/api/v1/PasswordReset/SendEmailCode/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendEmailCode(_response);
        });
    }

    protected processSendEmailCode(response: Response): Promise<ResetPasswordEmailResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordEmailResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetPasswordEmailResult>(null as any);
    }

    /**
     * Validates the email code.
     * @param details The details.
     * @param apiKey The API key.
     */
    validateEmailCode(details: ResetPasswordEmailValidate, apiKey: string): Promise<ResetPasswordEmailValidateResult> {
        let url_ = this.baseUrl + "/api/v1/PasswordReset/ValidateEmailCode/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processValidateEmailCode(_response);
        });
    }

    protected processValidateEmailCode(response: Response): Promise<ResetPasswordEmailValidateResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordEmailValidateResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetPasswordEmailValidateResult>(null as any);
    }

    /**
     * Resets the password.
     * @param details The details.
     * @param apiKey The API key.
     */
    resetPassword(details: ResetPasswordDetails, apiKey: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PasswordReset/ResetPassword/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PatientBanksClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<PatientBank[]> {
        let url_ = this.baseUrl + "/api/v1/PatientBanks/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<PatientBank[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientBank.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientBank[]>(null as any);
    }

    /**
     * Gets all.
     */
    byPatientID(patientID: string): Promise<PatientBank[]> {
        let url_ = this.baseUrl + "/api/v1/PatientBanks/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PatientBank[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientBank.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientBank[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param patientBankID The identifier.
     */
    patientBanksGet(patientBankID: string): Promise<PatientBank> {
        let url_ = this.baseUrl + "/api/v1/PatientBanks/{patientBankID}";
        if (patientBankID === undefined || patientBankID === null)
            throw new Error("The parameter 'patientBankID' must be defined.");
        url_ = url_.replace("{patientBankID}", encodeURIComponent("" + patientBankID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientBanksGet(_response);
        });
    }

    protected processPatientBanksGet(response: Response): Promise<PatientBank> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientBank.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientBank>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientBankID The identifier.
     */
    patientBanksDelete(patientBankID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientBanks/{patientBankID}";
        if (patientBankID === undefined || patientBankID === null)
            throw new Error("The parameter 'patientBankID' must be defined.");
        url_ = url_.replace("{patientBankID}", encodeURIComponent("" + patientBankID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientBanksDelete(_response);
        });
    }

    protected processPatientBanksDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified PatientBank.
     * @param patientBank The PatientBank.
     */
    patientBanksPost(patientBank: PatientBank): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientBanks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientBank);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientBanksPost(_response);
        });
    }

    protected processPatientBanksPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientBank.
     * @param patientBank The PatientBank.
     */
    patientBanksPut(patientBank: PatientBank): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientBanks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientBank);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientBanksPut(_response);
        });
    }

    protected processPatientBanksPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PatientCareTeamsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientCareTeam The identifier.
     */
    patientCareTeamsGet(patientCareTeam: string): Promise<PatientCareTeam> {
        let url_ = this.baseUrl + "/api/v1/PatientCareTeams/{patientCareTeam}";
        if (patientCareTeam === undefined || patientCareTeam === null)
            throw new Error("The parameter 'patientCareTeam' must be defined.");
        url_ = url_.replace("{patientCareTeam}", encodeURIComponent("" + patientCareTeam));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientCareTeamsGet(_response);
        });
    }

    protected processPatientCareTeamsGet(response: Response): Promise<PatientCareTeam> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientCareTeam.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientCareTeam>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientCareTeam The identifier.
     */
    patientCareTeamsDelete(patientCareTeam: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientCareTeams/{patientCareTeam}";
        if (patientCareTeam === undefined || patientCareTeam === null)
            throw new Error("The parameter 'patientCareTeam' must be defined.");
        url_ = url_.replace("{patientCareTeam}", encodeURIComponent("" + patientCareTeam));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientCareTeamsDelete(_response);
        });
    }

    protected processPatientCareTeamsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PatientCareTeam[]> {
        let url_ = this.baseUrl + "/api/v1/PatientCareTeams/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PatientCareTeam[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCareTeam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientCareTeam[]>(null as any);
    }

    /**
     * Posts the specified PatientCareTeam.
     * @param patientCareTeam The PHRCareTeam.
     */
    patientCareTeamsPost(patientCareTeam: PatientCareTeam): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientCareTeams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientCareTeam);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientCareTeamsPost(_response);
        });
    }

    protected processPatientCareTeamsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientCareTeam.
     * @param patientCareTeam The PatientCareTeam.
     */
    patientCareTeamsPut(patientCareTeam: PatientCareTeam): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientCareTeams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientCareTeam);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientCareTeamsPut(_response);
        });
    }

    protected processPatientCareTeamsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the patient care team dt os.
     * @param patientID (optional) The patient identifier.
     * @param countryID (optional) Optionally add Country for next Available Date (on Booking flow)
     */
    patientCareTeamDTO(patientID?: string | undefined, countryID?: string | null | undefined): Promise<PatientCareTeamDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PatientCareTeams/PatientCareTeamDTO?";
        if (patientID === null)
            throw new Error("The parameter 'patientID' cannot be null.");
        else if (patientID !== undefined)
            url_ += "patientID=" + encodeURIComponent("" + patientID) + "&";
        if (countryID !== undefined && countryID !== null)
            url_ += "countryID=" + encodeURIComponent("" + countryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientCareTeamDTO(_response);
        });
    }

    protected processPatientCareTeamDTO(response: Response): Promise<PatientCareTeamDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCareTeamDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientCareTeamDTO[]>(null as any);
    }
}

export class PatientFavoritesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientFavoriteID The identifier.
     */
    patientFavoritesGet(patientFavoriteID: string): Promise<PatientFavorite> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientFavoriteID}";
        if (patientFavoriteID === undefined || patientFavoriteID === null)
            throw new Error("The parameter 'patientFavoriteID' must be defined.");
        url_ = url_.replace("{patientFavoriteID}", encodeURIComponent("" + patientFavoriteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientFavoritesGet(_response);
        });
    }

    protected processPatientFavoritesGet(response: Response): Promise<PatientFavorite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFavorite.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientFavorite>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientFavoriteID The identifier.
     */
    patientFavoritesDelete(patientFavoriteID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientFavoriteID}";
        if (patientFavoriteID === undefined || patientFavoriteID === null)
            throw new Error("The parameter 'patientFavoriteID' must be defined.");
        url_ = url_.replace("{patientFavoriteID}", encodeURIComponent("" + patientFavoriteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientFavoritesDelete(_response);
        });
    }

    protected processPatientFavoritesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PatientFavorite[]> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PatientFavorite[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientFavorite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientFavorite[]>(null as any);
    }

    /**
     * Posts the specified PatientFavorite.
     * @param patientFavorite The PatientFavorite.
     */
    patientFavoritesPost(patientFavorite: PatientFavorite): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientFavorite);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientFavoritesPost(_response);
        });
    }

    protected processPatientFavoritesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientFavorite.
     * @param patientFavorite The PatientFavorite.
     */
    patientFavoritesPut(patientFavorite: PatientFavorite): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientFavorite);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientFavoritesPut(_response);
        });
    }

    protected processPatientFavoritesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Adds the favorite provider.
     * @param patientID The patient identifier.
     * @param providerID The provider identifier.
     */
    favoriteProviderPost(patientID: string, providerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/FavoriteProvider/{providerID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteProviderPost(_response);
        });
    }

    protected processFavoriteProviderPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes the favorite provider.
     * @param patientID The patient identifier.
     * @param providerID The provider identifier.
     */
    favoriteProviderDelete(patientID: string, providerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/FavoriteProvider/{providerID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteProviderDelete(_response);
        });
    }

    protected processFavoriteProviderDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Adds the preferred provider.
     * @param patientID The patient identifier.
     * @param providerID The provider identifier.
     */
    preferredProviderPost(patientID: string, providerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredProvider/{providerID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredProviderPost(_response);
        });
    }

    protected processPreferredProviderPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes the Preferred provider.
     * @param patientID The patient identifier.
     * @param providerID The provider identifier.
     */
    preferredProviderDelete(patientID: string, providerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredProvider/{providerID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredProviderDelete(_response);
        });
    }

    protected processPreferredProviderDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the preferred provider
     */
    preferredProviderGet(patientID: string): Promise<PatientFavorite> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredProvider";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredProviderGet(_response);
        });
    }

    protected processPreferredProviderGet(response: Response): Promise<PatientFavorite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFavorite.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientFavorite>(null as any);
    }

    /**
     * Adds the preferred Pharmacy
     */
    preferredPharmacyPost(patientID: string, storeID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredPharmacy/{storeID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredPharmacyPost(_response);
        });
    }

    protected processPreferredPharmacyPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete Preferred Pharmacy
     */
    preferredPharmacyDelete(patientID: string, storeID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredPharmacy/{storeID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredPharmacyDelete(_response);
        });
    }

    protected processPreferredPharmacyDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the preferred Pharmacy
     */
    preferredPharmacyGet(patientID: string): Promise<PatientFavorite> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredPharmacy";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredPharmacyGet(_response);
        });
    }

    protected processPreferredPharmacyGet(response: Response): Promise<PatientFavorite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFavorite.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientFavorite>(null as any);
    }

    /**
     * Adds the preferred Lab
     */
    preferredLabPost(patientID: string, storeID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredLab/{storeID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredLabPost(_response);
        });
    }

    protected processPreferredLabPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete Preferred Lab
     */
    preferredLabDelete(patientID: string, storeID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredLab/{storeID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredLabDelete(_response);
        });
    }

    protected processPreferredLabDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the preferred Lab
     */
    preferredLabGet(patientID: string): Promise<PatientFavorite> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredLab";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredLabGet(_response);
        });
    }

    protected processPreferredLabGet(response: Response): Promise<PatientFavorite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFavorite.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientFavorite>(null as any);
    }

    /**
     * Adds the preferred Organization
     */
    preferredOrganizationPost(patientID: string, organizationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredOrganization/{organizationID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredOrganizationPost(_response);
        });
    }

    protected processPreferredOrganizationPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete Preferred organization
     */
    preferredOrganizationDelete(patientID: string, organizationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredOrganization/{organizationID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredOrganizationDelete(_response);
        });
    }

    protected processPreferredOrganizationDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the preferred Lab
     */
    preferredOrganizationGet(patientID: string): Promise<PatientFavorite> {
        let url_ = this.baseUrl + "/api/v1/PatientFavorites/{patientID}/PreferredOrganization";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreferredOrganizationGet(_response);
        });
    }

    protected processPreferredOrganizationGet(response: Response): Promise<PatientFavorite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientFavorite.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientFavorite>(null as any);
    }
}

export class PatientInsurancesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientInsuranceID The identifier.
     */
    patientInsurancesGet(patientInsuranceID: string): Promise<PatientInsurance> {
        let url_ = this.baseUrl + "/api/v1/PatientInsurances/{patientInsuranceID}";
        if (patientInsuranceID === undefined || patientInsuranceID === null)
            throw new Error("The parameter 'patientInsuranceID' must be defined.");
        url_ = url_.replace("{patientInsuranceID}", encodeURIComponent("" + patientInsuranceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientInsurancesGet(_response);
        });
    }

    protected processPatientInsurancesGet(response: Response): Promise<PatientInsurance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientInsurance.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientInsurance>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientInsuranceID The identifier.
     */
    patientInsurancesDelete(patientInsuranceID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientInsurances/{patientInsuranceID}";
        if (patientInsuranceID === undefined || patientInsuranceID === null)
            throw new Error("The parameter 'patientInsuranceID' must be defined.");
        url_ = url_.replace("{patientInsuranceID}", encodeURIComponent("" + patientInsuranceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientInsurancesDelete(_response);
        });
    }

    protected processPatientInsurancesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PatientInsurance[]> {
        let url_ = this.baseUrl + "/api/v1/PatientInsurances/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PatientInsurance[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientInsurance.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientInsurance[]>(null as any);
    }

    /**
     * Verifies the specified phrHealthCondition.
     * @param patientInsuranceID The patient insurance identifier.
     */
    verify(patientInsuranceID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientInsurances/{PatientInsuranceID}/Verify";
        if (patientInsuranceID === undefined || patientInsuranceID === null)
            throw new Error("The parameter 'patientInsuranceID' must be defined.");
        url_ = url_.replace("{patientInsuranceID}", encodeURIComponent("" + patientInsuranceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrHealthCondition.
     * @param patientInsuranceID The patient insurance identifier.
     * @param insuranceNumber The insurance number.
     */
    verifyInsuranceNumber(patientInsuranceID: string, insuranceNumber: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientInsurances/{patientInsuranceID}/VerifyInsuranceNumber/{insuranceNumber}";
        if (patientInsuranceID === undefined || patientInsuranceID === null)
            throw new Error("The parameter 'patientInsuranceID' must be defined.");
        url_ = url_.replace("{patientInsuranceID}", encodeURIComponent("" + patientInsuranceID));
        if (insuranceNumber === undefined || insuranceNumber === null)
            throw new Error("The parameter 'insuranceNumber' must be defined.");
        url_ = url_.replace("{insuranceNumber}", encodeURIComponent("" + insuranceNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerifyInsuranceNumber(_response);
        });
    }

    protected processVerifyInsuranceNumber(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified PatientInsurance.
     * @param patientInsurance The PatientInsurance.
     */
    patientInsurancesPost(patientInsurance: PatientInsurance): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientInsurances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientInsurance);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientInsurancesPost(_response);
        });
    }

    protected processPatientInsurancesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientInsurance.
     * @param patientInsurance The PatientInsurance.
     */
    patientInsurancesPut(patientInsurance: PatientInsurance): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientInsurances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientInsurance);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientInsurancesPut(_response);
        });
    }

    protected processPatientInsurancesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID (optional) The patient identifier.
     * @param countryID (optional) The country identifier.
     */
    publicInsuranceProviderRecord(patientID?: string | undefined, countryID?: string | undefined): Promise<PatientInsurance> {
        let url_ = this.baseUrl + "/api/v1/PatientInsurances/PublicInsuranceProviderRecord?";
        if (patientID === null)
            throw new Error("The parameter 'patientID' cannot be null.");
        else if (patientID !== undefined)
            url_ += "patientID=" + encodeURIComponent("" + patientID) + "&";
        if (countryID === null)
            throw new Error("The parameter 'countryID' cannot be null.");
        else if (countryID !== undefined)
            url_ += "countryID=" + encodeURIComponent("" + countryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPublicInsuranceProviderRecord(_response);
        });
    }

    protected processPublicInsuranceProviderRecord(response: Response): Promise<PatientInsurance> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientInsurance.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientInsurance>(null as any);
    }
}

export class PatientNotificationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the by patient notification identifier.
     * @param patientNotificationID The patient notification identifier.
     */
    patientNotificationsGet(patientNotificationID: string): Promise<PatientNotification> {
        let url_ = this.baseUrl + "/api/v1/PatientNotifications/{patientNotificationID}";
        if (patientNotificationID === undefined || patientNotificationID === null)
            throw new Error("The parameter 'patientNotificationID' must be defined.");
        url_ = url_.replace("{patientNotificationID}", encodeURIComponent("" + patientNotificationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientNotificationsGet(_response);
        });
    }

    protected processPatientNotificationsGet(response: Response): Promise<PatientNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientNotification>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientNotificationID The identifier.
     */
    patientNotificationsDelete(patientNotificationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientNotifications/{patientNotificationID}";
        if (patientNotificationID === undefined || patientNotificationID === null)
            throw new Error("The parameter 'patientNotificationID' must be defined.");
        url_ = url_.replace("{patientNotificationID}", encodeURIComponent("" + patientNotificationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientNotificationsDelete(_response);
        });
    }

    protected processPatientNotificationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PatientNotification[]> {
        let url_ = this.baseUrl + "/api/v1/PatientNotifications/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PatientNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientNotification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientNotification[]>(null as any);
    }

    /**
     * Posts the specified PatientNotification.
     * @param patientNotification The PatientNotification.
     */
    patientNotificationsPost(patientNotification: PatientNotification): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientNotification);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientNotificationsPost(_response);
        });
    }

    protected processPatientNotificationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientNotification.
     * @param patientNotification The PatientNotification.
     */
    patientNotificationsPut(patientNotification: PatientNotification): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientNotifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientNotification);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientNotificationsPut(_response);
        });
    }

    protected processPatientNotificationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PatientOrdersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientOrderID The patient Order identifier.
     */
    patientOrdersGet(patientOrderID: string): Promise<PatientOrder> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/{patientOrderID}";
        if (patientOrderID === undefined || patientOrderID === null)
            throw new Error("The parameter 'patientOrderID' must be defined.");
        url_ = url_.replace("{patientOrderID}", encodeURIComponent("" + patientOrderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientOrdersGet(_response);
        });
    }

    protected processPatientOrdersGet(response: Response): Promise<PatientOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOrder.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientOrder>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientOrderID The identifier.
     */
    patientOrdersDelete(patientOrderID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/{patientOrderID}";
        if (patientOrderID === undefined || patientOrderID === null)
            throw new Error("The parameter 'patientOrderID' must be defined.");
        url_ = url_.replace("{patientOrderID}", encodeURIComponent("" + patientOrderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientOrdersDelete(_response);
        });
    }

    protected processPatientOrdersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientOrderDetails The patient order details.
     */
    search(patientOrderDetails: PatientOrderSearchDetails): Promise<PatientOrderSearchResults> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientOrderDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PatientOrderSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOrderSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientOrderSearchResults>(null as any);
    }

    /**
     * Gets the Patient Order by qr code.
     * @param qrCode The qr code.
     */
    byQRCode(qrCode: number): Promise<PatientOrder> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/ByQRCode/{qrCode}";
        if (qrCode === undefined || qrCode === null)
            throw new Error("The parameter 'qrCode' must be defined.");
        url_ = url_.replace("{qrCode}", encodeURIComponent("" + qrCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByQRCode(_response);
        });
    }

    protected processByQRCode(response: Response): Promise<PatientOrder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOrder.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientOrder>(null as any);
    }

    /**
     * Posts the specified patient order.
     * @param patientOrder The patient order.
     */
    patientOrdersPost(patientOrder: PatientOrder): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientOrder);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientOrdersPost(_response);
        });
    }

    protected processPatientOrdersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientOrder.
     * @param patientOrder The PatientOrder.
     */
    patientOrdersPut(patientOrder: PatientOrder): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientOrder);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientOrdersPut(_response);
        });
    }

    protected processPatientOrdersPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Finalizes the specified patient order finalize details.
     * @param patientOrderFinalizeDetails The patient order finalize details.
     */
    finalize(patientOrderFinalizeDetails: PatientOrderFinalizeDetails): Promise<PatientOrderFinalizeResults> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/Finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientOrderFinalizeDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFinalize(_response);
        });
    }

    protected processFinalize(response: Response): Promise<PatientOrderFinalizeResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientOrderFinalizeResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientOrderFinalizeResults>(null as any);
    }

    /**
     * Resends the specified patient order
     * @param patientOrderID The patient order identifier.
     */
    resend(patientOrderID: string): Promise<SendDeliveryOptionsResult> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/Resend/{patientOrderID}";
        if (patientOrderID === undefined || patientOrderID === null)
            throw new Error("The parameter 'patientOrderID' must be defined.");
        url_ = url_.replace("{patientOrderID}", encodeURIComponent("" + patientOrderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processResend(_response);
        });
    }

    protected processResend(response: Response): Promise<SendDeliveryOptionsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDeliveryOptionsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendDeliveryOptionsResult>(null as any);
    }

    /**
     * Call when to regenerate the patientOrder
     */
    regenerate(patientOrderID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/Regenerate/{patientOrderID}";
        if (patientOrderID === undefined || patientOrderID === null)
            throw new Error("The parameter 'patientOrderID' must be defined.");
        url_ = url_.replace("{patientOrderID}", encodeURIComponent("" + patientOrderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRegenerate(_response);
        });
    }

    protected processRegenerate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a patient order from an Invoice
     */
    createFromInvoice(details: CreatePatientOrderFromInvoiceDetails): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/CreateFromInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateFromInvoice(_response);
        });
    }

    protected processCreateFromInvoice(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get patientOrderReport
     */
    patientOrderReport(details: PatientOrderReportDetails): Promise<PatientOrder[]> {
        let url_ = this.baseUrl + "/api/v1/PatientOrders/PatientOrderReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientOrderReport(_response);
        });
    }

    protected processPatientOrderReport(response: Response): Promise<PatientOrder[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientOrder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientOrder[]>(null as any);
    }
}

export class PatientPrescriptionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientPrescriptionID The identifier.
     */
    patientPrescriptionsGet(patientPrescriptionID: string): Promise<PatientPrescription> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions/{patientPrescriptionID}";
        if (patientPrescriptionID === undefined || patientPrescriptionID === null)
            throw new Error("The parameter 'patientPrescriptionID' must be defined.");
        url_ = url_.replace("{patientPrescriptionID}", encodeURIComponent("" + patientPrescriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientPrescriptionsGet(_response);
        });
    }

    protected processPatientPrescriptionsGet(response: Response): Promise<PatientPrescription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPrescription.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientPrescription>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientPrescriptionID The identifier.
     */
    patientPrescriptionsDelete(patientPrescriptionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions/{patientPrescriptionID}";
        if (patientPrescriptionID === undefined || patientPrescriptionID === null)
            throw new Error("The parameter 'patientPrescriptionID' must be defined.");
        url_ = url_.replace("{patientPrescriptionID}", encodeURIComponent("" + patientPrescriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientPrescriptionsDelete(_response);
        });
    }

    protected processPatientPrescriptionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all users prescriptions.
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     */
    admin(recordsToSkip?: number | undefined, recordsToTake?: number | undefined): Promise<PagedResultOfPatientPrescription> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions/Admin?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<PagedResultOfPatientPrescription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatientPrescription.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatientPrescription>(null as any);
    }

    /**
     * Gets the search.
     * @param patientPrescriptionDetails The patient prescription details.
     */
    search(patientPrescriptionDetails: PatientPrescriptionSearchDetails): Promise<PatientPrescriptionSearchResults> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientPrescriptionDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PatientPrescriptionSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPrescriptionSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientPrescriptionSearchResults>(null as any);
    }

    /**
     * Gets the Patient Prescription by qr code.
     * @param qrCode The qr code.
     */
    byQRCode(qrCode: number): Promise<PatientPrescription> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions/ByQRCode/{qrCode}";
        if (qrCode === undefined || qrCode === null)
            throw new Error("The parameter 'qrCode' must be defined.");
        url_ = url_.replace("{qrCode}", encodeURIComponent("" + qrCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByQRCode(_response);
        });
    }

    protected processByQRCode(response: Response): Promise<PatientPrescription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPrescription.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientPrescription>(null as any);
    }

    /**
     * Posts the specified PatientPrescription.
     * @param patientPrescription The PatientPrescription.
     */
    patientPrescriptionsPost(patientPrescription: PatientPrescription): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientPrescription);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientPrescriptionsPost(_response);
        });
    }

    protected processPatientPrescriptionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientPrescription.
     * @param patientPrescription The PatientPrescription.
     */
    patientPrescriptionsPut(patientPrescription: PatientPrescription): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientPrescription);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientPrescriptionsPut(_response);
        });
    }

    protected processPatientPrescriptionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Finalizes the specified patient prescription.
     * @param patientPrescriptionFinalizeDetails The patient prescription finalize details.
     */
    finalize(patientPrescriptionFinalizeDetails: PatientPrescriptionFinalizeDetails): Promise<PatientPrescriptionFinalizeResults> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions/Finalize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientPrescriptionFinalizeDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFinalize(_response);
        });
    }

    protected processFinalize(response: Response): Promise<PatientPrescriptionFinalizeResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientPrescriptionFinalizeResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientPrescriptionFinalizeResults>(null as any);
    }

    /**
     * Refills the medications.
     * @param details The details.
     */
    refill(details: PatientPrescriptionRefillDetails): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions/Refill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRefill(_response);
        });
    }

    protected processRefill(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Resends the specified patient prescription
     * @param patientPrescriptionID The patient prescription identifier.
     */
    resend(patientPrescriptionID: string): Promise<SendDeliveryOptionsResult> {
        let url_ = this.baseUrl + "/api/v1/PatientPrescriptions/Resend/{patientPrescriptionID}";
        if (patientPrescriptionID === undefined || patientPrescriptionID === null)
            throw new Error("The parameter 'patientPrescriptionID' must be defined.");
        url_ = url_.replace("{patientPrescriptionID}", encodeURIComponent("" + patientPrescriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processResend(_response);
        });
    }

    protected processResend(response: Response): Promise<SendDeliveryOptionsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendDeliveryOptionsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendDeliveryOptionsResult>(null as any);
    }
}

export class PatientsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all (Admin Only)
     */
    allGet(): Promise<Patient[]> {
        let url_ = this.baseUrl + "/api/v1/Patients/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllGet(_response);
        });
    }

    protected processAllGet(response: Response): Promise<Patient[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Patient.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Patient[]>(null as any);
    }

    /**
     * Gets all Patients, paginated (Admin Only)
     */
    allPost(details: PatientsDetail): Promise<PagedResultOfPatient> {
        let url_ = this.baseUrl + "/api/v1/Patients/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllPost(_response);
        });
    }

    protected processAllPost(response: Response): Promise<PagedResultOfPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatient>(null as any);
    }

    /**
     * Gets all Patients, paginated (Admin Only)
     */
    all2(details: PatientsDetail): Promise<PagedResult2OfPatient> {
        let url_ = this.baseUrl + "/api/v1/Patients/all2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll2(_response);
        });
    }

    protected processAll2(response: Response): Promise<PagedResult2OfPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResult2OfPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResult2OfPatient>(null as any);
    }

    /**
     * Gets all Discussion Patients, paginated (Admin Only)
     */
    allDiscussion(details: PatientsDetail): Promise<PagedResultOfPatient> {
        let url_ = this.baseUrl + "/api/v1/Patients/allDiscussion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllDiscussion(_response);
        });
    }

    protected processAllDiscussion(response: Response): Promise<PagedResultOfPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatient>(null as any);
    }

    /**
     * Bans Patient access to Discussions.
     * @param banAccessToDiscussions The DiscussionBlockedDetail.
     */
    banAccessToDiscussion(banAccessToDiscussions: BanAccessToDiscussionsDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Patients/BanAccessToDiscussion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(banAccessToDiscussions);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBanAccessToDiscussion(_response);
        });
    }

    protected processBanAccessToDiscussion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The identifier.
     */
    patientsGet(patientID: string): Promise<Patient> {
        let url_ = this.baseUrl + "/api/v1/Patients/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientsGet(_response);
        });
    }

    protected processPatientsGet(response: Response): Promise<Patient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Patient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Patient>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The identifier.
     */
    patientsDelete(patientID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Patients/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientsDelete(_response);
        });
    }

    protected processPatientsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patients by care team provider.
     * @param providerPatientsSearchDetails The provider patients search details.
     */
    providerPatientSearch(providerPatientsSearchDetails: ProviderPatientsSearchDetails): Promise<PagedResultOfPatient> {
        let url_ = this.baseUrl + "/api/v1/Patients/ProviderPatientSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerPatientsSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderPatientSearch(_response);
        });
    }

    protected processProviderPatientSearch(response: Response): Promise<PagedResultOfPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatient>(null as any);
    }

    /**
     * Providers the patient search.
     * @param patientSearchDetails The patient search details.
     */
    providersPatientSearch(patientSearchDetails: PatientSearchDetails): Promise<PagedResultOfPatient> {
        let url_ = this.baseUrl + "/api/v1/Patients/ProvidersPatientSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvidersPatientSearch(_response);
        });
    }

    protected processProvidersPatientSearch(response: Response): Promise<PagedResultOfPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatient>(null as any);
    }

    /**
     * Gets the patient by UserDetailID
     * @param userDetailID The identifier.
     */
    byUserDetailID(userDetailID: string): Promise<Patient> {
        let url_ = this.baseUrl + "/api/v1/Patients/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<Patient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Patient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Patient>(null as any);
    }

    /**
     * Find a patient by the email address (Admin Only)
     * @param emailAddress The email address.
     */
    byEmailAddress(emailAddress: string): Promise<Patient> {
        let url_ = this.baseUrl + "/api/v1/Patients/ByEmailAddress/{emailAddress}";
        if (emailAddress === undefined || emailAddress === null)
            throw new Error("The parameter 'emailAddress' must be defined.");
        url_ = url_.replace("{emailAddress}", encodeURIComponent("" + emailAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByEmailAddress(_response);
        });
    }

    protected processByEmailAddress(response: Response): Promise<Patient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Patient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Patient>(null as any);
    }

    /**
     * Determines whether [is insurance provider required] [the specified user detail identifier].
     * @param userDetailID The user detail identifier.
     * @param countryID (optional) The country identifier.
     * @return true if [is insurance provider required] [the specified user detail identifier]; otherwise, false.
     */
    insuranceProviderRequired(userDetailID: string, countryID?: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Patients/InsuranceProviderRequired/{userDetailID}?";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (countryID === null)
            throw new Error("The parameter 'countryID' cannot be null.");
        else if (countryID !== undefined)
            url_ += "countryID=" + encodeURIComponent("" + countryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInsuranceProviderRequired(_response);
        });
    }

    protected processInsuranceProviderRequired(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Posts the specified patient.
     * @param patient The patient.
     */
    patientsPost(patient: Patient): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Patients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patient);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientsPost(_response);
        });
    }

    protected processPatientsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified patient.
     * @param patient The patient.
     */
    patientsPut(patient: Patient): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Patients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patient);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientsPut(_response);
        });
    }

    protected processPatientsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Specific endpoint for patients to update thier email address
     * @param changeEmailAddressAdminDetails The change email address admin details.
     */
    changeEmailAddress(changeEmailAddressAdminDetails: ChangeEmailAddressAdminDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Patients/ChangeEmailAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeEmailAddressAdminDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processChangeEmailAddress(_response);
        });
    }

    protected processChangeEmailAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create Required Public Insurance
     * @param requiredPublicInsuranceDTO The required public insurance dto.
     */
    createRequiredPublicInsurance(requiredPublicInsuranceDTO: RequiredPublicInsuranceDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Patients/CreateRequiredPublicInsurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requiredPublicInsuranceDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateRequiredPublicInsurance(_response);
        });
    }

    protected processCreateRequiredPublicInsurance(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the PHR.
     * @param patientID The identifier.
     */
    pHR(patientID: string): Promise<PHRPatient> {
        let url_ = this.baseUrl + "/api/v1/Patients/{patientID}/PHR";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHR(_response);
        });
    }

    protected processPHR(response: Response): Promise<PHRPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRPatient>(null as any);
    }

    /**
     * Gets the PHR summary.
     * @param patientID The identifier.
     */
    pHRSummaryDTO(patientID: string): Promise<PHRSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Patients/{patientID}/PHRSummaryDTO";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSummaryDTO(_response);
        });
    }

    protected processPHRSummaryDTO(response: Response): Promise<PHRSummaryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRSummaryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRSummaryDTO[]>(null as any);
    }

    /**
     * Validates the patient's cell phone number.
     * @param details The cell phone details.
     */
    validateSMSCode(details: CellPhoneValidateDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Patients/ValidateSMSCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processValidateSMSCode(_response);
        });
    }

    protected processValidateSMSCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified patient identifier.
     * @param patientID The patient identifier.
     */
    verify(patientID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Patients/{patientID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Changes the patient country.
     * @param patientID The patient identifier.
     * @param newCountryID (optional) The new country identifier.
     */
    changeCountry(patientID: string, newCountryID?: string | undefined): Promise<Country> {
        let url_ = this.baseUrl + "/api/v1/Patients/{patientID}/ChangeCountry?";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (newCountryID === null)
            throw new Error("The parameter 'newCountryID' cannot be null.");
        else if (newCountryID !== undefined)
            url_ += "newCountryID=" + encodeURIComponent("" + newCountryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processChangeCountry(_response);
        });
    }

    protected processChangeCountry(response: Response): Promise<Country> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Country.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country>(null as any);
    }

    /**
     * Converts the time zones.
     */
    convertTimeZones(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Patients/ConvertTimeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConvertTimeZones(_response);
        });
    }

    protected processConvertTimeZones(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get a list of recent Patients
     */
    providerRecentPatients(recentPatientDetails: RecentPatientDetails): Promise<PagedResultOfRecentPatientDTO> {
        let url_ = this.baseUrl + "/api/v1/Patients/ProviderRecentPatients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recentPatientDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderRecentPatients(_response);
        });
    }

    protected processProviderRecentPatients(response: Response): Promise<PagedResultOfRecentPatientDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfRecentPatientDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfRecentPatientDTO>(null as any);
    }

    /**
     * Get the Family Provider from the AddressBook.
     */
    familyProviderAddressBook(patientID: string): Promise<AddressBook> {
        let url_ = this.baseUrl + "/api/v1/Patients/{patientID}/FamilyProviderAddressBook";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFamilyProviderAddressBook(_response);
        });
    }

    protected processFamilyProviderAddressBook(response: Response): Promise<AddressBook> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressBook.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBook>(null as any);
    }

    /**
     * Get a list of patients who have requested availability notification
     */
    providerAvailabilityNotificationPatients(details: ProviderPatientNotificationDetails): Promise<PagedResultOfPatientNotification> {
        let url_ = this.baseUrl + "/api/v1/Patients/ProviderAvailabilityNotificationPatients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAvailabilityNotificationPatients(_response);
        });
    }

    protected processProviderAvailabilityNotificationPatients(response: Response): Promise<PagedResultOfPatientNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatientNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatientNotification>(null as any);
    }

    /**
     * Get the Patient's recent History
     */
    patientRecentHistory(patientRecentHistoryDetails: PatientRecentHistoryDetails): Promise<PatientRecentHistoryDTO> {
        let url_ = this.baseUrl + "/api/v1/Patients/PatientRecentHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientRecentHistoryDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientRecentHistory(_response);
        });
    }

    protected processPatientRecentHistory(response: Response): Promise<PatientRecentHistoryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientRecentHistoryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientRecentHistoryDTO>(null as any);
    }

    /**
     * Generate the Covid Vaccine QR Code
     */
    covidVaccineQRCode(patientID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/Patients/CovidVaccineQRCode/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCovidVaccineQRCode(_response);
        });
    }

    protected processCovidVaccineQRCode(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Download the Covid Vaccine QR Code
     */
    downloadCovidVaccineQRCode(patientID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Patients/DownloadCovidVaccineQRCode/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadCovidVaccineQRCode(_response);
        });
    }

    protected processDownloadCovidVaccineQRCode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Generate the Covid Vaccine QR Code
     */
    covidTestQRCode(patientID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/Patients/CovidTestQRCode/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCovidTestQRCode(_response);
        });
    }

    protected processCovidTestQRCode(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Download the Covid Vaccine QR Code
     */
    downloadCovidTestQRCode(patientID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Patients/DownloadCovidTestQRCode/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadCovidTestQRCode(_response);
        });
    }

    protected processDownloadCovidTestQRCode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Add incentive funds to wallet
     */
    addFundsToWallet(patientID: string, amount: number, currencyEnum: CurrencyEnum): Promise<AddFundsToWalletResponse> {
        let url_ = this.baseUrl + "/api/v1/Patients/AddFundsToWallet/{patientID}/{amount}/{currencyEnum}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (amount === undefined || amount === null)
            throw new Error("The parameter 'amount' must be defined.");
        url_ = url_.replace("{amount}", encodeURIComponent("" + amount));
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddFundsToWallet(_response);
        });
    }

    protected processAddFundsToWallet(response: Response): Promise<AddFundsToWalletResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddFundsToWalletResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddFundsToWalletResponse>(null as any);
    }

    /**
     * Patient Signups
     */
    patientSignups(patientSignupsDetails: PatientSignupDTODetails): Promise<PatientSignupsDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Patients/PatientSignups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientSignupsDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientSignups(_response);
        });
    }

    protected processPatientSignups(response: Response): Promise<PatientSignupsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientSignupsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientSignupsDTO[]>(null as any);
    }

    /**
     * Patient Signups Paged
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     * @param appTypeEnum (optional) 
     */
    patientSignupsPaged(recordsToSkip?: number | undefined, recordsToTake?: number | undefined, appTypeEnum?: AppTypeEnum | undefined): Promise<PagedResultOfPatientSignupsDTO> {
        let url_ = this.baseUrl + "/api/v1/Patients/PatientSignupsPaged?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        if (appTypeEnum === null)
            throw new Error("The parameter 'appTypeEnum' cannot be null.");
        else if (appTypeEnum !== undefined)
            url_ += "AppTypeEnum=" + encodeURIComponent("" + appTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientSignupsPaged(_response);
        });
    }

    protected processPatientSignupsPaged(response: Response): Promise<PagedResultOfPatientSignupsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatientSignupsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatientSignupsDTO>(null as any);
    }

    /**
     * Patient Signups Count
     * @param appTypeEnum (optional) 
     */
    patientSignupsCount(appTypeEnum?: AppTypeEnum | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/Patients/PatientSignupsCount?";
        if (appTypeEnum === null)
            throw new Error("The parameter 'appTypeEnum' cannot be null.");
        else if (appTypeEnum !== undefined)
            url_ += "AppTypeEnum=" + encodeURIComponent("" + appTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientSignupsCount(_response);
        });
    }

    protected processPatientSignupsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PaymentProcessorsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<PaymentProcessor[]> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<PaymentProcessor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentProcessor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProcessor[]>(null as any);
    }

    /**
     * Gets the Administrative list of All
     */
    admin(): Promise<PaymentProcessor[]> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<PaymentProcessor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentProcessor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProcessor[]>(null as any);
    }

    /**
     * Get Payment processor by CountryID
     * @param countryID The country identifier.
     */
    byCountryID(countryID: string): Promise<PaymentProcessor[]> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/ByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCountryID(_response);
        });
    }

    protected processByCountryID(response: Response): Promise<PaymentProcessor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentProcessor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProcessor[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param paymentProcessorID The identifier.
     */
    paymentProcessorsGet(paymentProcessorID: string): Promise<PaymentProcessor> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/{paymentProcessorID}";
        if (paymentProcessorID === undefined || paymentProcessorID === null)
            throw new Error("The parameter 'paymentProcessorID' must be defined.");
        url_ = url_.replace("{paymentProcessorID}", encodeURIComponent("" + paymentProcessorID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPaymentProcessorsGet(_response);
        });
    }

    protected processPaymentProcessorsGet(response: Response): Promise<PaymentProcessor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentProcessor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProcessor>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param paymentProcessorID The identifier.
     */
    paymentProcessorsDelete(paymentProcessorID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/{paymentProcessorID}";
        if (paymentProcessorID === undefined || paymentProcessorID === null)
            throw new Error("The parameter 'paymentProcessorID' must be defined.");
        url_ = url_.replace("{paymentProcessorID}", encodeURIComponent("" + paymentProcessorID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPaymentProcessorsDelete(_response);
        });
    }

    protected processPaymentProcessorsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the payment processor by Name
     * @param name The name.
     */
    byName(name: string): Promise<PaymentProcessor> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/ByName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByName(_response);
        });
    }

    protected processByName(response: Response): Promise<PaymentProcessor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentProcessor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProcessor>(null as any);
    }

    /**
     * Get the payment processor by StoreID
     * @param storeID The store identifier.
     */
    byStoreID(storeID: string): Promise<PaymentProcessor> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<PaymentProcessor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentProcessor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProcessor>(null as any);
    }

    /**
     * Gets a paymentprocessor by name and country
     * @param name The name.
     * @param countryID The country identifier.
     */
    byNameAndCountryID(name: string, countryID: string): Promise<PaymentProcessor> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/ByNameAndCountryID/{name}/{countryID}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByNameAndCountryID(_response);
        });
    }

    protected processByNameAndCountryID(response: Response): Promise<PaymentProcessor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentProcessor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProcessor>(null as any);
    }

    /**
     * Posts the specified PaymentProcessor setting.
     * @param paymentProcessor The PaymentProcessor.
     */
    paymentProcessorsPost(paymentProcessor: PaymentProcessor): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentProcessor);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPaymentProcessorsPost(_response);
        });
    }

    protected processPaymentProcessorsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PaymentProcessor
     * @param paymentProcessor The PaymentProcessor
     */
    paymentProcessorsPut(paymentProcessor: PaymentProcessor): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentProcessor);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPaymentProcessorsPut(_response);
        });
    }

    protected processPaymentProcessorsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the payment processor session token.
     * @param paymentProcessorID The payment processor identifier.
     * @param amount (optional) The amount.
     */
    sessionToken(paymentProcessorID: string, amount?: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/SessionToken/{paymentProcessorID}?";
        if (paymentProcessorID === undefined || paymentProcessorID === null)
            throw new Error("The parameter 'paymentProcessorID' must be defined.");
        url_ = url_.replace("{paymentProcessorID}", encodeURIComponent("" + paymentProcessorID));
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSessionToken(_response);
        });
    }

    protected processSessionToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Webhooks from Paystack
     */
    paystackWebhook(eventData: any): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/PaystackWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPaystackWebhook(_response);
        });
    }

    protected processPaystackWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the currency Exchange
     */
    currencyExchange(currencyExchangeDetails: CurrencyExchangeDetails): Promise<CurrencyExchangeResult> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/CurrencyExchange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(currencyExchangeDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCurrencyExchange(_response);
        });
    }

    protected processCurrencyExchange(response: Response): Promise<CurrencyExchangeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyExchangeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyExchangeResult>(null as any);
    }

    /**
     * Gets a paymentprocessor by paymentProcessorTypeEnum and country
     * @param paymentProcessorTypeEnum The name.
     * @param countryID The country identifier.
     */
    byTypeAndCountryID(paymentProcessorTypeEnum: PaymentProcessorTypeEnum, countryID: string): Promise<PaymentProcessor> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/ByTypeAndCountryID/{paymentProcessorTypeEnum}/{countryID}";
        if (paymentProcessorTypeEnum === undefined || paymentProcessorTypeEnum === null)
            throw new Error("The parameter 'paymentProcessorTypeEnum' must be defined.");
        url_ = url_.replace("{paymentProcessorTypeEnum}", encodeURIComponent("" + paymentProcessorTypeEnum));
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByTypeAndCountryID(_response);
        });
    }

    protected processByTypeAndCountryID(response: Response): Promise<PaymentProcessor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentProcessor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProcessor>(null as any);
    }

    /**
     * Webhooks from Paystack
     */
    flutterwaveWebhook(eventData: any): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/FlutterwaveWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFlutterwaveWebhook(_response);
        });
    }

    protected processFlutterwaveWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Payment Intent for Stripe
     */
    stripePaymentIntent(paymentIntentRequest: PaymentIntentRequest): Promise<PaymentIntentResponse> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/StripePaymentIntent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentIntentRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStripePaymentIntent(_response);
        });
    }

    protected processStripePaymentIntent(response: Response): Promise<PaymentIntentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentIntentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentIntentResponse>(null as any);
    }

    /**
     * Webhooks from Stripe
     */
    stripeWebhook(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/StripeWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStripeWebhook(_response);
        });
    }

    protected processStripeWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Search webhook Logs
     */
    searchWebHookLogs(searchWebHookLogDetails: SearchWebHookLogDetails): Promise<WebhookLog[]> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/SearchWebHookLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchWebHookLogDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearchWebHookLogs(_response);
        });
    }

    protected processSearchWebHookLogs(response: Response): Promise<WebhookLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebhookLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebhookLog[]>(null as any);
    }

    /**
     * Process Tagpay webhook
     */
    tagpayWebhook(eventData: any): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/TagpayWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagpayWebhook(_response);
        });
    }

    protected processTagpayWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Process FintavaPay webhook
     */
    fintavaPayWebhook(eventData: any): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/FintavaPayWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFintavaPayWebhook(_response);
        });
    }

    protected processFintavaPayWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Posts the specified CareFundDonation Virtual Wallet Requery.
     */
    bankTransferRequery(virtualWalletID: string): Promise<WalletCommitResults> {
        let url_ = this.baseUrl + "/api/v1/PaymentProcessors/BankTransferRequery/{VirtualWalletID}";
        if (virtualWalletID === undefined || virtualWalletID === null)
            throw new Error("The parameter 'virtualWalletID' must be defined.");
        url_ = url_.replace("{VirtualWalletID}", encodeURIComponent("" + virtualWalletID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBankTransferRequery(_response);
        });
    }

    protected processBankTransferRequery(response: Response): Promise<WalletCommitResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCommitResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCommitResults>(null as any);
    }
}

export class PayoutRunResultsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     */
    outstanding(): Promise<PayoutRunResult[]> {
        let url_ = this.baseUrl + "/api/v1/PayoutRunResults/Outstanding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOutstanding(_response);
        });
    }

    protected processOutstanding(response: Response): Promise<PayoutRunResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayoutRunResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayoutRunResult[]>(null as any);
    }

    /**
     * Update the payout result
     */
    payoutRunResults(payoutRunResult: PayoutRunResult): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PayoutRunResults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payoutRunResult);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayoutRunResults(_response);
        });
    }

    protected processPayoutRunResults(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update the payout result
     */
    updateZeroPayoutStatus(payoutRunResultID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PayoutRunResults/UpdateZeroPayoutStatus/{payoutRunResultID}";
        if (payoutRunResultID === undefined || payoutRunResultID === null)
            throw new Error("The parameter 'payoutRunResultID' must be defined.");
        url_ = url_.replace("{payoutRunResultID}", encodeURIComponent("" + payoutRunResultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpdateZeroPayoutStatus(_response);
        });
    }

    protected processUpdateZeroPayoutStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the list of banks supported by the walletProvider in the country
     */
    bankList(currencyEnum: CurrencyEnum): Promise<BankListResponse> {
        let url_ = this.baseUrl + "/api/v1/PayoutRunResults/BankList/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBankList(_response);
        });
    }

    protected processBankList(response: Response): Promise<BankListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankListResponse>(null as any);
    }

    /**
     * Get bank account details
     */
    getBankAccountDetails(currencyEnum: CurrencyEnum, code: string, accountNumber: string): Promise<BankAccountDetailsResponse> {
        let url_ = this.baseUrl + "/api/v1/PayoutRunResults/GetBankAccountDetails/{currencyEnum}/{code}/{accountNumber}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetBankAccountDetails(_response);
        });
    }

    protected processGetBankAccountDetails(response: Response): Promise<BankAccountDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAccountDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountDetailsResponse>(null as any);
    }

    /**
     * Bank Transfer to pay the payout
     */
    bankTransfer(payoutRunResultBankTransferRequest: PayoutRunResultBankTransferRequest): Promise<BankTransferResponse> {
        let url_ = this.baseUrl + "/api/v1/PayoutRunResults/BankTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payoutRunResultBankTransferRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBankTransfer(_response);
        });
    }

    protected processBankTransfer(response: Response): Promise<BankTransferResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankTransferResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankTransferResponse>(null as any);
    }
}

export class PayoutRunsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param payoutID The identifier.
     */
    byPayoutID(payoutID: string): Promise<PayoutRun[]> {
        let url_ = this.baseUrl + "/api/v1/PayoutRuns/ByPayoutID/{payoutID}";
        if (payoutID === undefined || payoutID === null)
            throw new Error("The parameter 'payoutID' must be defined.");
        url_ = url_.replace("{payoutID}", encodeURIComponent("" + payoutID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPayoutID(_response);
        });
    }

    protected processByPayoutID(response: Response): Promise<PayoutRun[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayoutRun.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayoutRun[]>(null as any);
    }
}

export class PayoutsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Payout[]> {
        let url_ = this.baseUrl + "/api/v1/Payouts/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Payout[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Payout.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Payout[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param payoutID The identifier.
     */
    payoutsGet(payoutID: string): Promise<Payout> {
        let url_ = this.baseUrl + "/api/v1/Payouts/{payoutID}";
        if (payoutID === undefined || payoutID === null)
            throw new Error("The parameter 'payoutID' must be defined.");
        url_ = url_.replace("{payoutID}", encodeURIComponent("" + payoutID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayoutsGet(_response);
        });
    }

    protected processPayoutsGet(response: Response): Promise<Payout> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Payout.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Payout>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param payoutID The identifier.
     */
    payoutsDelete(payoutID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Payouts/{payoutID}";
        if (payoutID === undefined || payoutID === null)
            throw new Error("The parameter 'payoutID' must be defined.");
        url_ = url_.replace("{payoutID}", encodeURIComponent("" + payoutID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayoutsDelete(_response);
        });
    }

    protected processPayoutsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Payout.
     * @param payout The Payout.
     */
    payoutsPost(payout: Payout): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Payouts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payout);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayoutsPost(_response);
        });
    }

    protected processPayoutsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Payout.
     */
    payoutsPut(payout: Payout): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Payouts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payout);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayoutsPut(_response);
        });
    }

    protected processPayoutsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Process Payout Cycle for all payouts
     */
    processPayoutCycle(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Payouts/ProcessPayoutCycle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProcessPayoutCycle(_response);
        });
    }

    protected processProcessPayoutCycle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Process Payout Cycle for single PayoutID
     */
    processPayoutCycleByPayoutID(payoutID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Payouts/ProcessPayoutCycleByPayoutID/{payoutID}";
        if (payoutID === undefined || payoutID === null)
            throw new Error("The parameter 'payoutID' must be defined.");
        url_ = url_.replace("{payoutID}", encodeURIComponent("" + payoutID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProcessPayoutCycleByPayoutID(_response);
        });
    }

    protected processProcessPayoutCycleByPayoutID(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the payouts that are ready
     */
    readyPayouts(): Promise<Payout[]> {
        let url_ = this.baseUrl + "/api/v1/Payouts/ReadyPayouts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReadyPayouts(_response);
        });
    }

    protected processReadyPayouts(response: Response): Promise<Payout[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Payout.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Payout[]>(null as any);
    }

    /**
     * Get all the currencies used by the provider / store / organization
     */
    payoutCurrencies(payoutCurrenciesDetails: PayoutCurrenciesDetails): Promise<PayoutCurrenciesResult> {
        let url_ = this.baseUrl + "/api/v1/Payouts/PayoutCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payoutCurrenciesDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayoutCurrencies(_response);
        });
    }

    protected processPayoutCurrencies(response: Response): Promise<PayoutCurrenciesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayoutCurrenciesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayoutCurrenciesResult>(null as any);
    }

    /**
     * Get the payouts by specified ID
     */
    payoutsByID(payoutCurrenciesDetails: PayoutCurrenciesDetails, includeRuns: boolean): Promise<Payout[]> {
        let url_ = this.baseUrl + "/api/v1/Payouts/PayoutsByID/{includeRuns}";
        if (includeRuns === undefined || includeRuns === null)
            throw new Error("The parameter 'includeRuns' must be defined.");
        url_ = url_.replace("{includeRuns}", encodeURIComponent("" + includeRuns));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payoutCurrenciesDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPayoutsByID(_response);
        });
    }

    protected processPayoutsByID(response: Response): Promise<Payout[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Payout.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Payout[]>(null as any);
    }
}

export class PingsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Record a  ping for the current user
     */
    ping(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Pings/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set a ping for a particular userdetailid
     */
    pingWithUserDetailID(userDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Pings/PingWithUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPingWithUserDetailID(_response);
        });
    }

    protected processPingWithUserDetailID(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Record a  ping for the current user including location
     */
    pingWithLocation(latitude: number, longitude: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Pings/PingWithLocation/{latitude}/{longitude}";
        if (latitude === undefined || latitude === null)
            throw new Error("The parameter 'latitude' must be defined.");
        url_ = url_.replace("{latitude}", encodeURIComponent("" + latitude));
        if (longitude === undefined || longitude === null)
            throw new Error("The parameter 'longitude' must be defined.");
        url_ = url_.replace("{longitude}", encodeURIComponent("" + longitude));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPingWithLocation(_response);
        });
    }

    protected processPingWithLocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the last ping known to this user
     */
    lastPing(): Promise<Ping> {
        let url_ = this.baseUrl + "/api/v1/Pings/LastPing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLastPing(_response);
        });
    }

    protected processLastPing(response: Response): Promise<Ping> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ping.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ping>(null as any);
    }

    /**
     * Get the last ping known for a user
     */
    lastPingByUserDetailID(userDetailID: string): Promise<Ping> {
        let url_ = this.baseUrl + "/api/v1/Pings/LastPingByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLastPingByUserDetailID(_response);
        });
    }

    protected processLastPingByUserDetailID(response: Response): Promise<Ping> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ping.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ping>(null as any);
    }

    /**
     * Get the current list of people who are online now
     */
    whoIsOnLine(): Promise<PingDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Pings/WhoIsOnLine";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWhoIsOnLine(_response);
        });
    }

    protected processWhoIsOnLine(response: Response): Promise<PingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PingDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PingDTO[]>(null as any);
    }

    /**
     * Get the last ping known for a user
     */
    lastPingByUserDetailIDs(lastPingRequest: LastPingRequest): Promise<Ping[]> {
        let url_ = this.baseUrl + "/api/v1/Pings/LastPingByUserDetailIDs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lastPingRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLastPingByUserDetailIDs(_response);
        });
    }

    protected processLastPingByUserDetailIDs(response: Response): Promise<Ping[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ping[]>(null as any);
    }

    /**
     * Get the last ping known for a user
     */
    pingsByUserDetailID(userDetailID: string): Promise<Ping[]> {
        let url_ = this.baseUrl + "/api/v1/Pings/PingsByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPingsByUserDetailID(_response);
        });
    }

    protected processPingsByUserDetailID(response: Response): Promise<Ping[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ping[]>(null as any);
    }
}

export class ProviderAchievementsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets by status.
     */
    status(status: LicenseVerificationStatusEnum): Promise<ProviderAchievement[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderAchievements/Status/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: Response): Promise<ProviderAchievement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderAchievement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAchievement[]>(null as any);
    }

    /**
     * Gets all.
     */
    byProviderID(providerID: string): Promise<ProviderAchievement[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderAchievements/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<ProviderAchievement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderAchievement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAchievement[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerAchievementID The identifier.
     */
    providerAchievementsGet(providerAchievementID: string): Promise<ProviderAchievement> {
        let url_ = this.baseUrl + "/api/v1/ProviderAchievements/{providerAchievementID}";
        if (providerAchievementID === undefined || providerAchievementID === null)
            throw new Error("The parameter 'providerAchievementID' must be defined.");
        url_ = url_.replace("{providerAchievementID}", encodeURIComponent("" + providerAchievementID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAchievementsGet(_response);
        });
    }

    protected processProviderAchievementsGet(response: Response): Promise<ProviderAchievement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAchievement.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAchievement>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerAchievementID The identifier.
     */
    providerAchievementsDelete(providerAchievementID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderAchievements/{providerAchievementID}";
        if (providerAchievementID === undefined || providerAchievementID === null)
            throw new Error("The parameter 'providerAchievementID' must be defined.");
        url_ = url_.replace("{providerAchievementID}", encodeURIComponent("" + providerAchievementID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAchievementsDelete(_response);
        });
    }

    protected processProviderAchievementsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderAchievement.
     * @param providerAchievement The ProviderAchievement.
     */
    providerAchievementsPost(providerAchievement: ProviderAchievement): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderAchievements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerAchievement);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAchievementsPost(_response);
        });
    }

    protected processProviderAchievementsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderAchievement.
     * @param providerAchievement The ProviderAchievement.
     */
    providerAchievementsPut(providerAchievement: ProviderAchievement): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderAchievements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerAchievement);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAchievementsPut(_response);
        });
    }

    protected processProviderAchievementsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified ProviderAchievement.
     * @param userdetailID (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param dateAchieved (optional) 
     * @param expiryDate (optional) 
     * @param document (optional) 
     */
    sendEmailDocument(userdetailID?: string | undefined, name?: string | null | undefined, description?: string | null | undefined, dateAchieved?: Date | null | undefined, expiryDate?: Date | null | undefined, document?: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderAchievements/SendEmailDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userdetailID === null || userdetailID === undefined)
            throw new Error("The parameter 'userdetailID' cannot be null.");
        else
            content_.append("UserdetailID", userdetailID.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (dateAchieved !== null && dateAchieved !== undefined)
            content_.append("DateAchieved", dateAchieved.toJSON());
        if (expiryDate !== null && expiryDate !== undefined)
            content_.append("ExpiryDate", expiryDate.toJSON());
        if (document !== null && document !== undefined)
            content_.append("Document", document.data, document.fileName ? document.fileName : "Document");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendEmailDocument(_response);
        });
    }

    protected processSendEmailDocument(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified ProviderAchievement.
     * @param providerAchievementID (optional) 
     * @param providerID (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param dateAchieved (optional) 
     * @param expiryDate (optional) 
     * @param document (optional) 
     * @param licenseVerificationStatusEnum (optional) 
     */
    reviewEmailDocument(providerAchievementID?: string | undefined, providerID?: string | undefined, name?: string | null | undefined, description?: string | null | undefined, dateAchieved?: Date | null | undefined, expiryDate?: Date | null | undefined, document?: FileParameter | null | undefined, licenseVerificationStatusEnum?: LicenseVerificationStatusEnum | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderAchievements/ReviewEmailDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (providerAchievementID === null || providerAchievementID === undefined)
            throw new Error("The parameter 'providerAchievementID' cannot be null.");
        else
            content_.append("ProviderAchievementID", providerAchievementID.toString());
        if (providerID === null || providerID === undefined)
            throw new Error("The parameter 'providerID' cannot be null.");
        else
            content_.append("ProviderID", providerID.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (dateAchieved !== null && dateAchieved !== undefined)
            content_.append("DateAchieved", dateAchieved.toJSON());
        if (expiryDate !== null && expiryDate !== undefined)
            content_.append("ExpiryDate", expiryDate.toJSON());
        if (document !== null && document !== undefined)
            content_.append("Document", document.data, document.fileName ? document.fileName : "Document");
        if (licenseVerificationStatusEnum === null || licenseVerificationStatusEnum === undefined)
            throw new Error("The parameter 'licenseVerificationStatusEnum' cannot be null.");
        else
            content_.append("LicenseVerificationStatusEnum", licenseVerificationStatusEnum.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReviewEmailDocument(_response);
        });
    }

    protected processReviewEmailDocument(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ProviderAppointmentsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Search for a provider's available appointments
     * @param providerAppointmentSearchDetails The provider appointment search details.
     */
    search(providerAppointmentSearchDetails: ProviderAppointmentSearchDetails): Promise<ProviderAppointmentSearchResults> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerAppointmentSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ProviderAppointmentSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAppointmentSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAppointmentSearchResults>(null as any);
    }

    /**
     * Book an appointment
     * @param bookProviderAppointmentDetails The book provider appointment details.
     */
    bookProviderAppointment(bookProviderAppointmentDetails: BookProviderAppointmentDetails): Promise<BookProviderAppointmentResults> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/BookProviderAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookProviderAppointmentDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBookProviderAppointment(_response);
        });
    }

    protected processBookProviderAppointment(response: Response): Promise<BookProviderAppointmentResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookProviderAppointmentResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookProviderAppointmentResults>(null as any);
    }

    /**
     * Return Appointments when queried by the Patient's UserDetailID
     * @param details The details.
     */
    patientAppointmentsSearch(details: AppointmentSearchDetails): Promise<PatientAppointmentSearchResults> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/PatientAppointmentsSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientAppointmentsSearch(_response);
        });
    }

    protected processPatientAppointmentsSearch(response: Response): Promise<PatientAppointmentSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAppointmentSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientAppointmentSearchResults>(null as any);
    }

    /**
     * Return Appointments when queried by the Patient's UserDetailID
     * @param details The details.
     */
    patientAppointmentsCalendarDTO(details: AppointmentSearchDetails): Promise<PatientAppointmentSearchDTOResults> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/PatientAppointmentsCalendarDTO";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientAppointmentsCalendarDTO(_response);
        });
    }

    protected processPatientAppointmentsCalendarDTO(response: Response): Promise<PatientAppointmentSearchDTOResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAppointmentSearchDTOResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientAppointmentSearchDTOResults>(null as any);
    }

    /**
     * Return Appointments when queried by the Provider's UserDetailID
     * @param details The details.
     */
    providerAppointmentsSearch(details: AppointmentSearchDetails): Promise<AppointmentSearchResults> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/ProviderAppointmentsSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAppointmentsSearch(_response);
        });
    }

    protected processProviderAppointmentsSearch(response: Response): Promise<AppointmentSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentSearchResults>(null as any);
    }

    /**
     * Gets the Provider Appointment by qr code.
     * @param qrCode The qr code.
     */
    byQRCode(qrCode: number): Promise<ProviderAppointment> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/ByQRCode/{qrCode}";
        if (qrCode === undefined || qrCode === null)
            throw new Error("The parameter 'qrCode' must be defined.");
        url_ = url_.replace("{qrCode}", encodeURIComponent("" + qrCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByQRCode(_response);
        });
    }

    protected processByQRCode(response: Response): Promise<ProviderAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAppointment>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerAppointmentID The identifier.
     */
    providerAppointmentsGet(providerAppointmentID: string): Promise<ProviderAppointment> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/{providerAppointmentID}";
        if (providerAppointmentID === undefined || providerAppointmentID === null)
            throw new Error("The parameter 'providerAppointmentID' must be defined.");
        url_ = url_.replace("{providerAppointmentID}", encodeURIComponent("" + providerAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAppointmentsGet(_response);
        });
    }

    protected processProviderAppointmentsGet(response: Response): Promise<ProviderAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAppointment>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerAppointmentID The identifier.
     */
    providerAppointmentsDelete(providerAppointmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/{providerAppointmentID}";
        if (providerAppointmentID === undefined || providerAppointmentID === null)
            throw new Error("The parameter 'providerAppointmentID' must be defined.");
        url_ = url_.replace("{providerAppointmentID}", encodeURIComponent("" + providerAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAppointmentsDelete(_response);
        });
    }

    protected processProviderAppointmentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderAppointment.
     * @param providerAppointment The ProviderAppointment.
     */
    providerAppointmentsPost(providerAppointment: ProviderAppointment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerAppointment);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAppointmentsPost(_response);
        });
    }

    protected processProviderAppointmentsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderAppointment.
     * @param providerAppointment The ProviderAppointment.
     */
    providerAppointmentsPut(providerAppointment: ProviderAppointment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerAppointment);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderAppointmentsPut(_response);
        });
    }

    protected processProviderAppointmentsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Releases the reservation.
     * @param providerAppointmentID The provider appointment identifier.
     */
    releaseProviderAppointment(providerAppointmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/{providerAppointmentID}/ReleaseProviderAppointment";
        if (providerAppointmentID === undefined || providerAppointmentID === null)
            throw new Error("The parameter 'providerAppointmentID' must be defined.");
        url_ = url_.replace("{providerAppointmentID}", encodeURIComponent("" + providerAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReleaseProviderAppointment(_response);
        });
    }

    protected processReleaseProviderAppointment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reserves the provider appointment.
     * @param providerAppointmentID The provider appointment identifier.
     */
    reserveProviderAppointment(providerAppointmentID: string): Promise<ProviderAppointment> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/{providerAppointmentID}/ReserveProviderAppointment";
        if (providerAppointmentID === undefined || providerAppointmentID === null)
            throw new Error("The parameter 'providerAppointmentID' must be defined.");
        url_ = url_.replace("{providerAppointmentID}", encodeURIComponent("" + providerAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReserveProviderAppointment(_response);
        });
    }

    protected processReserveProviderAppointment(response: Response): Promise<ProviderAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAppointment>(null as any);
    }

    /**
     * Gets the next available appointment.
     * @param nextAvailableAppointmentDetails The next available appointment details.
     */
    nextAvailableAppointment(nextAvailableAppointmentDetails: NextAvailableAppointmentDetails): Promise<ProviderAppointment> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/NextAvailableAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nextAvailableAppointmentDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNextAvailableAppointment(_response);
        });
    }

    protected processNextAvailableAppointment(response: Response): Promise<ProviderAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAppointment>(null as any);
    }

    /**
     * Reserves the provider appointment.
     * @param providerAppointmentID The provider appointment identifier.
     */
    reserveProviderAppointmentByProvider(providerAppointmentID: string): Promise<ProviderAppointment> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/ReserveProviderAppointmentByProvider/{providerAppointmentID}";
        if (providerAppointmentID === undefined || providerAppointmentID === null)
            throw new Error("The parameter 'providerAppointmentID' must be defined.");
        url_ = url_.replace("{providerAppointmentID}", encodeURIComponent("" + providerAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReserveProviderAppointmentByProvider(_response);
        });
    }

    protected processReserveProviderAppointmentByProvider(response: Response): Promise<ProviderAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderAppointment>(null as any);
    }

    /**
     * Releases the reservation.
     * @param providerAppointmentID The provider appointment identifier.
     */
    releaseProviderAppointmentByProvider(providerAppointmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/ReleaseProviderAppointmentByProvider/{providerAppointmentID}";
        if (providerAppointmentID === undefined || providerAppointmentID === null)
            throw new Error("The parameter 'providerAppointmentID' must be defined.");
        url_ = url_.replace("{providerAppointmentID}", encodeURIComponent("" + providerAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReleaseProviderAppointmentByProvider(_response);
        });
    }

    protected processReleaseProviderAppointmentByProvider(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Admin - Process Daily Appointments Reminder for this country
     */
    notifyDailyAppointmentsReminder(countryID: string): Promise<NotifyDailyAppointmentRemindersResponse> {
        let url_ = this.baseUrl + "/api/v1/ProviderAppointments/NotifyDailyAppointmentsReminder/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNotifyDailyAppointmentsReminder(_response);
        });
    }

    protected processNotifyDailyAppointmentsReminder(response: Response): Promise<NotifyDailyAppointmentRemindersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotifyDailyAppointmentRemindersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotifyDailyAppointmentRemindersResponse>(null as any);
    }
}

export class ProviderBanksClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    byProviderID(providerID: string): Promise<ProviderBank[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderBanks/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<ProviderBank[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderBank.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderBank[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerBankID The identifier.
     */
    providerBanksGet(providerBankID: string): Promise<ProviderBank> {
        let url_ = this.baseUrl + "/api/v1/ProviderBanks/{providerBankID}";
        if (providerBankID === undefined || providerBankID === null)
            throw new Error("The parameter 'providerBankID' must be defined.");
        url_ = url_.replace("{providerBankID}", encodeURIComponent("" + providerBankID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderBanksGet(_response);
        });
    }

    protected processProviderBanksGet(response: Response): Promise<ProviderBank> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderBank.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderBank>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerBankID The identifier.
     */
    providerBanksDelete(providerBankID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderBanks/{providerBankID}";
        if (providerBankID === undefined || providerBankID === null)
            throw new Error("The parameter 'providerBankID' must be defined.");
        url_ = url_.replace("{providerBankID}", encodeURIComponent("" + providerBankID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderBanksDelete(_response);
        });
    }

    protected processProviderBanksDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderBank.
     * @param providerBank The ProviderBank.
     */
    providerBanksPost(providerBank: ProviderBank): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderBanks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerBank);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderBanksPost(_response);
        });
    }

    protected processProviderBanksPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderBank.
     * @param providerBank The ProviderBank.
     */
    providerBanksPut(providerBank: ProviderBank): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderBanks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerBank);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderBanksPut(_response);
        });
    }

    protected processProviderBanksPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ProviderDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<ProviderDetail[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<ProviderDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderDetail[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerDetailID The identifier.
     */
    providerDetailsGet(providerDetailID: string): Promise<ProviderDetail> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails/{providerDetailID}";
        if (providerDetailID === undefined || providerDetailID === null)
            throw new Error("The parameter 'providerDetailID' must be defined.");
        url_ = url_.replace("{providerDetailID}", encodeURIComponent("" + providerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderDetailsGet(_response);
        });
    }

    protected processProviderDetailsGet(response: Response): Promise<ProviderDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerDetailID The identifier.
     */
    providerDetailsDelete(providerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails/{providerDetailID}";
        if (providerDetailID === undefined || providerDetailID === null)
            throw new Error("The parameter 'providerDetailID' must be defined.");
        url_ = url_.replace("{providerDetailID}", encodeURIComponent("" + providerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderDetailsDelete(_response);
        });
    }

    protected processProviderDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderDetail.
     * @param providerDetail The ProviderDetail.
     */
    providerDetailsPost(providerDetail: ProviderDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderDetailsPost(_response);
        });
    }

    protected processProviderDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderDetail.
     * @param providerDetail The ProviderDetail.
     */
    providerDetailsPut(providerDetail: ProviderDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderDetailsPut(_response);
        });
    }

    protected processProviderDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param providerDetails The providerDetails.
     */
    manyPost(providerDetails: ProviderDetail[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPost(_response);
        });
    }

    protected processManyPost(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Puts the many.
     * @param providerDetails The providerDetails.
     */
    manyPut(providerDetails: ProviderDetail[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPut(_response);
        });
    }

    protected processManyPut(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Webhooks from Dub Co
     */
    dubCoWebhook(eventData: any): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails/DubCoWebhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDubCoWebhook(_response);
        });
    }

    protected processDubCoWebhook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the Marketing Campaign Details for the Provider UserDetailID
     */
    marketingCampaign(userdetailID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ProviderDetails/marketingCampaign/{userdetailID}";
        if (userdetailID === undefined || userdetailID === null)
            throw new Error("The parameter 'userdetailID' must be defined.");
        url_ = url_.replace("{userdetailID}", encodeURIComponent("" + userdetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMarketingCampaign(_response);
        });
    }

    protected processMarketingCampaign(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProviderHubsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    byProviderDetailID(providerDetailID: string): Promise<ProviderHub[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderHubs/ByProviderDetailID/{ProviderDetailID}";
        if (providerDetailID === undefined || providerDetailID === null)
            throw new Error("The parameter 'providerDetailID' must be defined.");
        url_ = url_.replace("{providerDetailID}", encodeURIComponent("" + providerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderDetailID(_response);
        });
    }

    protected processByProviderDetailID(response: Response): Promise<ProviderHub[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderHub.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderHub[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<ProviderHub[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderHubs/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<ProviderHub[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderHub.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderHub[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerHubID The identifier.
     */
    providerHubsGet(providerHubID: string): Promise<ProviderHub> {
        let url_ = this.baseUrl + "/api/v1/ProviderHubs/{providerHubID}";
        if (providerHubID === undefined || providerHubID === null)
            throw new Error("The parameter 'providerHubID' must be defined.");
        url_ = url_.replace("{providerHubID}", encodeURIComponent("" + providerHubID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderHubsGet(_response);
        });
    }

    protected processProviderHubsGet(response: Response): Promise<ProviderHub> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderHub.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderHub>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerHubID The identifier.
     */
    providerHubsDelete(providerHubID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderHubs/{providerHubID}";
        if (providerHubID === undefined || providerHubID === null)
            throw new Error("The parameter 'providerHubID' must be defined.");
        url_ = url_.replace("{providerHubID}", encodeURIComponent("" + providerHubID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderHubsDelete(_response);
        });
    }

    protected processProviderHubsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderHub.
     * @param providerDetail The ProviderHub.
     */
    providerHubsPost(providerDetail: ProviderHub): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderHubs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderHubsPost(_response);
        });
    }

    protected processProviderHubsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderHub.
     * @param providerDetail The ProviderHub.
     */
    providerHubsPut(providerDetail: ProviderHub): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderHubs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderHubsPut(_response);
        });
    }

    protected processProviderHubsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param providerDetails The providerDetails.
     */
    manyPost(providerDetails: ProviderHub[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderHubs/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPost(_response);
        });
    }

    protected processManyPost(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Puts the many.
     * @param providerDetails The providerDetails.
     */
    manyPut(providerDetails: ProviderHub[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderHubs/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPut(_response);
        });
    }

    protected processManyPut(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ProviderImagesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<ProviderImage[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderImages/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ProviderImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderImage[]>(null as any);
    }

    /**
     * Get the images for the ProviderID
     */
    byProviderID(providerID: string): Promise<ProviderImage[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderImages/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<ProviderImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderImage[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerImageID The identifier.
     */
    providerImagesGet(providerImageID: string): Promise<ProviderImage> {
        let url_ = this.baseUrl + "/api/v1/ProviderImages/{providerImageID}";
        if (providerImageID === undefined || providerImageID === null)
            throw new Error("The parameter 'providerImageID' must be defined.");
        url_ = url_.replace("{providerImageID}", encodeURIComponent("" + providerImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderImagesGet(_response);
        });
    }

    protected processProviderImagesGet(response: Response): Promise<ProviderImage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderImage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderImage>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerImageID The identifier.
     */
    providerImagesDelete(providerImageID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderImages/{providerImageID}";
        if (providerImageID === undefined || providerImageID === null)
            throw new Error("The parameter 'providerImageID' must be defined.");
        url_ = url_.replace("{providerImageID}", encodeURIComponent("" + providerImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderImagesDelete(_response);
        });
    }

    protected processProviderImagesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderImage.
     * @param providerImage The ProviderImage.
     */
    providerImagesPost(providerImage: ProviderImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderImagesPost(_response);
        });
    }

    protected processProviderImagesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderImage.
     */
    providerImagesPut(providerImage: ProviderImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderImagesPut(_response);
        });
    }

    protected processProviderImagesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param providerImages The ProviderImages.
     */
    many(providerImages: ProviderImage[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderImages/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerImages);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get the Provider's profile image
     */
    providerImage(providerID: string, imageDetailID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ProviderImages/{providerID}/ProviderImage/{imageDetailID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (imageDetailID === undefined || imageDetailID === null)
            throw new Error("The parameter 'imageDetailID' must be defined.");
        url_ = url_.replace("{imageDetailID}", encodeURIComponent("" + imageDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderImage(_response);
        });
    }

    protected processProviderImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProviderOnboardingClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get the Onboarding Provider's details by UserDetailID
     */
    byUserDetailID(userDetailID: string): Promise<ProviderOnboardingDTO> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<ProviderOnboardingDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderOnboardingDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderOnboardingDTO>(null as any);
    }

    /**
     * Get the provinder Onboarding by ProviderOnboardingID
     */
    providerOnboardingGet(providerOnboardingID: string): Promise<ProviderOnboarding> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/{providerOnboardingID}";
        if (providerOnboardingID === undefined || providerOnboardingID === null)
            throw new Error("The parameter 'providerOnboardingID' must be defined.");
        url_ = url_.replace("{providerOnboardingID}", encodeURIComponent("" + providerOnboardingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderOnboardingGet(_response);
        });
    }

    protected processProviderOnboardingGet(response: Response): Promise<ProviderOnboarding> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderOnboarding.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderOnboarding>(null as any);
    }

    /**
     * Insert the ProviderOnboarding data
     */
    providerOnboardingPost(providerOnboarding: ProviderOnboarding): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerOnboarding);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderOnboardingPost(_response);
        });
    }

    protected processProviderOnboardingPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update the ProviderOnboarding data
     */
    providerOnboardingPut(providerOnboarding: ProviderOnboarding): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerOnboarding);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderOnboardingPut(_response);
        });
    }

    protected processProviderOnboardingPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the list of tags for ProviderTypes
     */
    providerTypeTags(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/ProviderTypeTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderTypeTags(_response);
        });
    }

    protected processProviderTypeTags(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Get the list of tags for Specialties
     */
    providerSpecialtiesTags(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/ProviderSpecialtiesTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSpecialtiesTags(_response);
        });
    }

    protected processProviderSpecialtiesTags(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Get the list of tags for License
     */
    licenseTags(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/LicenseTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLicenseTags(_response);
        });
    }

    protected processLicenseTags(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Get the list of tags for FaciltyRole
     */
    facilityRoleTags(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/FacilityRoleTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFacilityRoleTags(_response);
        });
    }

    protected processFacilityRoleTags(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Get the list of tags for Specialization
     */
    facilitySpecializationTags(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/FacilitySpecializationTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFacilitySpecializationTags(_response);
        });
    }

    protected processFacilitySpecializationTags(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Get the list of tags for Number of Bed Tags
     */
    facilityNumberOfBedTags(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/FacilityNumberOfBedTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFacilityNumberOfBedTags(_response);
        });
    }

    protected processFacilityNumberOfBedTags(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Get the list of tags for LicenseCountryTagss
     */
    licenseCountryTags(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/LicenseCountryTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLicenseCountryTags(_response);
        });
    }

    protected processLicenseCountryTags(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Upload the license
     */
    uploadLicense(fileDetail: FileDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/UploadLicense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUploadLicense(_response);
        });
    }

    protected processUploadLicense(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Downloads the file.
     * @param documentID The document identifier.
     */
    downloadLicense(documentID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/DownloadLicense/{documentID}";
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadLicense(_response);
        });
    }

    protected processDownloadLicense(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Download the File Detail for the document
     */
    downloadLicenseFileDetail(documentID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/DownloadLicenseFileDetail/{documentID}";
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadLicenseFileDetail(_response);
        });
    }

    protected processDownloadLicenseFileDetail(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Get the Available Provider Onboarding records that are ready / in progress
     */
    availableOnboarding(): Promise<ProviderOnboarding[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderOnboarding/AvailableOnboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableOnboarding(_response);
        });
    }

    protected processAvailableOnboarding(response: Response): Promise<ProviderOnboarding[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderOnboarding.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderOnboarding[]>(null as any);
    }
}

export class ProviderPublicationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<ProviderPublication[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderPublications/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<ProviderPublication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderPublication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderPublication[]>(null as any);
    }

    /**
     * Gets all.
     */
    byProviderDetailID(providerDetailID: string): Promise<ProviderPublication[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderPublications/ByProviderDetailID/{ProviderDetailID}";
        if (providerDetailID === undefined || providerDetailID === null)
            throw new Error("The parameter 'providerDetailID' must be defined.");
        url_ = url_.replace("{providerDetailID}", encodeURIComponent("" + providerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderDetailID(_response);
        });
    }

    protected processByProviderDetailID(response: Response): Promise<ProviderPublication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderPublication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderPublication[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerPublicationID The identifier.
     */
    providerPublicationsGet(providerPublicationID: string): Promise<ProviderPublication> {
        let url_ = this.baseUrl + "/api/v1/ProviderPublications/{providerPublicationID}";
        if (providerPublicationID === undefined || providerPublicationID === null)
            throw new Error("The parameter 'providerPublicationID' must be defined.");
        url_ = url_.replace("{providerPublicationID}", encodeURIComponent("" + providerPublicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderPublicationsGet(_response);
        });
    }

    protected processProviderPublicationsGet(response: Response): Promise<ProviderPublication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderPublication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderPublication>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerPublicationID The identifier.
     */
    providerPublicationsDelete(providerPublicationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderPublications/{providerPublicationID}";
        if (providerPublicationID === undefined || providerPublicationID === null)
            throw new Error("The parameter 'providerPublicationID' must be defined.");
        url_ = url_.replace("{providerPublicationID}", encodeURIComponent("" + providerPublicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderPublicationsDelete(_response);
        });
    }

    protected processProviderPublicationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderPublication.
     * @param providerDetail The ProviderPublication.
     */
    providerPublicationsPost(providerDetail: ProviderPublication): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderPublications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderPublicationsPost(_response);
        });
    }

    protected processProviderPublicationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderPublication.
     * @param providerDetail The ProviderPublication.
     */
    providerPublicationsPut(providerDetail: ProviderPublication): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderPublications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderPublicationsPut(_response);
        });
    }

    protected processProviderPublicationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param providerDetails The providerDetails.
     */
    manyPost(providerDetails: ProviderPublication[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderPublications/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPost(_response);
        });
    }

    protected processManyPost(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Puts the many.
     * @param providerDetails The providerDetails.
     */
    manyPut(providerDetails: ProviderPublication[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderPublications/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPut(_response);
        });
    }

    protected processManyPut(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ProviderQueuesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Enable the provider Queue for this provider
     */
    enable(providerID: string, allowSMS: boolean): Promise<ProviderQueueResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/{providerID}/Enable/{allowSMS}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (allowSMS === undefined || allowSMS === null)
            throw new Error("The parameter 'allowSMS' must be defined.");
        url_ = url_.replace("{allowSMS}", encodeURIComponent("" + allowSMS));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEnable(_response);
        });
    }

    protected processEnable(response: Response): Promise<ProviderQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueResult>(null as any);
    }

    /**
     * Disable the provider Queue for this provider
     */
    disable(providerID: string): Promise<ProviderQueueResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/{providerID}/Disable";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDisable(_response);
        });
    }

    protected processDisable(response: Response): Promise<ProviderQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueResult>(null as any);
    }

    /**
     * Disable the provider Queue for this provider
     */
    status(providerID: string): Promise<ProviderQueueResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/{providerID}/Status";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: Response): Promise<ProviderQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueResult>(null as any);
    }

    /**
     * Disable sending SMS to the provider for ProviderQueue
     */
    noSMS(providerID: string): Promise<ProviderQueueResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/{providerID}/NoSMS";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNoSMS(_response);
        });
    }

    protected processNoSMS(response: Response): Promise<ProviderQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueResult>(null as any);
    }

    /**
     * Enable sending SMS to the provider for ProviderQueue
     */
    sMS(providerID: string): Promise<ProviderQueueResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/{providerID}/SMS";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSMS(_response);
        });
    }

    protected processSMS(response: Response): Promise<ProviderQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueResult>(null as any);
    }

    /**
     * Decline a proposed Consult
     */
    decline(providerID: string, providerQueueID: string): Promise<ProviderQueueResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/{providerID}/Decline/{providerQueueID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (providerQueueID === undefined || providerQueueID === null)
            throw new Error("The parameter 'providerQueueID' must be defined.");
        url_ = url_.replace("{providerQueueID}", encodeURIComponent("" + providerQueueID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDecline(_response);
        });
    }

    protected processDecline(response: Response): Promise<ProviderQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueResult>(null as any);
    }

    /**
     * Decline a proposed Consult
     */
    accept(providerID: string, providerQueueID: string): Promise<ProviderQueueResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/{providerID}/Accept/{providerQueueID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (providerQueueID === undefined || providerQueueID === null)
            throw new Error("The parameter 'providerQueueID' must be defined.");
        url_ = url_.replace("{providerQueueID}", encodeURIComponent("" + providerQueueID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: Response): Promise<ProviderQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderQueueResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueueResult>(null as any);
    }

    /**
     * Check to see if there is an active provider Queue record for this provider
     */
    currentProviderQueue(providerID: string): Promise<CurrentProviderQueueResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/{providerID}/CurrentProviderQueue";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCurrentProviderQueue(_response);
        });
    }

    protected processCurrentProviderQueue(response: Response): Promise<CurrentProviderQueueResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentProviderQueueResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentProviderQueueResult>(null as any);
    }

    /**
     * Get the last weeks of provider Queue entries
     */
    admin(): Promise<ProviderQueue[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/Admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<ProviderQueue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderQueue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueue[]>(null as any);
    }

    /**
     * Get the last weeks of provider queue entries for a provider
     */
    adminByProviderID(providerID: string): Promise<ProviderQueue[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderQueues/AdminByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByProviderID(_response);
        });
    }

    protected processAdminByProviderID(response: Response): Promise<ProviderQueue[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderQueue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderQueue[]>(null as any);
    }
}

export class ProviderRegistrationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Return the provider registrations by providerid
     */
    byProviderID(providerID: string): Promise<ProviderRegistration[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderRegistrations/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<ProviderRegistration[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderRegistration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderRegistration[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerRegistrationID The identifier.
     */
    providerRegistrationsGet(providerRegistrationID: string): Promise<ProviderRegistration> {
        let url_ = this.baseUrl + "/api/v1/ProviderRegistrations/{providerRegistrationID}";
        if (providerRegistrationID === undefined || providerRegistrationID === null)
            throw new Error("The parameter 'providerRegistrationID' must be defined.");
        url_ = url_.replace("{providerRegistrationID}", encodeURIComponent("" + providerRegistrationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderRegistrationsGet(_response);
        });
    }

    protected processProviderRegistrationsGet(response: Response): Promise<ProviderRegistration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderRegistration.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderRegistration>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerRegistrationID The identifier.
     */
    providerRegistrationsDelete(providerRegistrationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderRegistrations/{providerRegistrationID}";
        if (providerRegistrationID === undefined || providerRegistrationID === null)
            throw new Error("The parameter 'providerRegistrationID' must be defined.");
        url_ = url_.replace("{providerRegistrationID}", encodeURIComponent("" + providerRegistrationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderRegistrationsDelete(_response);
        });
    }

    protected processProviderRegistrationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderRegistration.
     * @param providerRegistration The ProviderRegistration.
     */
    providerRegistrationsPost(providerRegistration: ProviderRegistration): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderRegistrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerRegistration);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderRegistrationsPost(_response);
        });
    }

    protected processProviderRegistrationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderRegistration.
     * @param providerRegistration The ProviderRegistration.
     */
    providerRegistrationsPut(providerRegistration: ProviderRegistration): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderRegistrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerRegistration);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderRegistrationsPut(_response);
        });
    }

    protected processProviderRegistrationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Adds / updates / deletes provider registrations
     */
    many(providerRegistrations: ProviderRegistration[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderRegistrations/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerRegistrations);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ProviderSchedulesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    search(providerScheduleSearchDetails: ProviderScheduleSearchDetails): Promise<ProviderSchedule[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderSchedules/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerScheduleSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<ProviderSchedule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderSchedule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderSchedule[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerScheduleID The identifier.
     */
    providerSchedulesGet(providerScheduleID: string): Promise<ProviderSchedule> {
        let url_ = this.baseUrl + "/api/v1/ProviderSchedules/{providerScheduleID}";
        if (providerScheduleID === undefined || providerScheduleID === null)
            throw new Error("The parameter 'providerScheduleID' must be defined.");
        url_ = url_.replace("{providerScheduleID}", encodeURIComponent("" + providerScheduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSchedulesGet(_response);
        });
    }

    protected processProviderSchedulesGet(response: Response): Promise<ProviderSchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderSchedule.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderSchedule>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerScheduleID The identifier.
     */
    providerSchedulesDelete(providerScheduleID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderSchedules/{providerScheduleID}";
        if (providerScheduleID === undefined || providerScheduleID === null)
            throw new Error("The parameter 'providerScheduleID' must be defined.");
        url_ = url_.replace("{providerScheduleID}", encodeURIComponent("" + providerScheduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSchedulesDelete(_response);
        });
    }

    protected processProviderSchedulesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderSchedule.
     * @param providerSchedule The ProviderSchedule.
     */
    providerSchedulesPost(providerSchedule: ProviderSchedule): Promise<CreateProviderScheduleResult> {
        let url_ = this.baseUrl + "/api/v1/ProviderSchedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSchedule);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSchedulesPost(_response);
        });
    }

    protected processProviderSchedulesPost(response: Response): Promise<CreateProviderScheduleResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateProviderScheduleResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateProviderScheduleResult>(null as any);
    }

    /**
     * Deletes the specified identifier recurring.
     * @param providerScheduleID The identifier.
     */
    providerSchedulesDeleteRecurring(providerScheduleID: string): Promise<ProviderScheduleDeleteRecurringResults> {
        let url_ = this.baseUrl + "/api/v1/ProviderSchedules/{providerScheduleID}/ProviderSchedulesDeleteRecurring";
        if (providerScheduleID === undefined || providerScheduleID === null)
            throw new Error("The parameter 'providerScheduleID' must be defined.");
        url_ = url_.replace("{providerScheduleID}", encodeURIComponent("" + providerScheduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSchedulesDeleteRecurring(_response);
        });
    }

    protected processProviderSchedulesDeleteRecurring(response: Response): Promise<ProviderScheduleDeleteRecurringResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderScheduleDeleteRecurringResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderScheduleDeleteRecurringResults>(null as any);
    }

    /**
     * Return "active" consults that are using the ProviderStoreItemID
     */
    providerSchedulesUsingProviderStoreItemID(providerStoreItemID: string): Promise<ProviderSchedule[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderSchedules/ProviderSchedulesUsingProviderStoreItemID/{providerStoreItemID}";
        if (providerStoreItemID === undefined || providerStoreItemID === null)
            throw new Error("The parameter 'providerStoreItemID' must be defined.");
        url_ = url_.replace("{providerStoreItemID}", encodeURIComponent("" + providerStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSchedulesUsingProviderStoreItemID(_response);
        });
    }

    protected processProviderSchedulesUsingProviderStoreItemID(response: Response): Promise<ProviderSchedule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderSchedule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderSchedule[]>(null as any);
    }
}

export class ProvidersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Provider[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    /**
     * Gets all providers, paginated (Admin Only)
     */
    all2(details: ProvidersDetail): Promise<PagedResult2OfProvider> {
        let url_ = this.baseUrl + "/api/v1/Providers/all2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll2(_response);
        });
    }

    protected processAll2(response: Response): Promise<PagedResult2OfProvider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResult2OfProvider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResult2OfProvider>(null as any);
    }

    /**
     * Gets all Discussion Providers, paginated (Admin Only)
     */
    allDiscussion(details: ProvidersDetail): Promise<PagedResultOfProvider> {
        let url_ = this.baseUrl + "/api/v1/Providers/allDiscussion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllDiscussion(_response);
        });
    }

    protected processAllDiscussion(response: Response): Promise<PagedResultOfProvider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProvider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfProvider>(null as any);
    }

    /**
     * Bans Provider access to Discussions.
     * @param banAccessToDiscussions The DiscussionBlockedDetail.
     */
    banAccessToDiscussion(banAccessToDiscussions: BanAccessToDiscussionsDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Providers/BanAccessToDiscussion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(banAccessToDiscussions);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBanAccessToDiscussion(_response);
        });
    }

    protected processBanAccessToDiscussion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Searches the specified provider search details.
     * @param providerSearchDetails The provider search details.
     */
    search(providerSearchDetails: ProviderSearchDetails): Promise<PagedResultOfProvider> {
        let url_ = this.baseUrl + "/api/v1/Providers/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfProvider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProvider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfProvider>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerID The identifier.
     */
    providersGet(providerID: string): Promise<Provider> {
        let url_ = this.baseUrl + "/api/v1/Providers/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvidersGet(_response);
        });
    }

    protected processProvidersGet(response: Response): Promise<Provider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Provider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerID The identifier.
     */
    providersDelete(providerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Providers/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvidersDelete(_response);
        });
    }

    protected processProvidersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the provider card for the type of consultationtypeflow enum
     * @param providerID The provider identifier.
     * @param countryID The country identifier.
     */
    cardByConsultationTypeFlowEnum(providerID: string, countryID: string, consultationTypeFlowEnum: ConsultationTypeFlowEnum): Promise<Provider> {
        let url_ = this.baseUrl + "/api/v1/Providers/{providerID}/CardByConsultationTypeFlowEnum/{countryID}/{consultationTypeFlowEnum}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        if (consultationTypeFlowEnum === undefined || consultationTypeFlowEnum === null)
            throw new Error("The parameter 'consultationTypeFlowEnum' must be defined.");
        url_ = url_.replace("{consultationTypeFlowEnum}", encodeURIComponent("" + consultationTypeFlowEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCardByConsultationTypeFlowEnum(_response);
        });
    }

    protected processCardByConsultationTypeFlowEnum(response: Response): Promise<Provider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Provider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider>(null as any);
    }

    /**
     * Gets the provider card.
     * @param providerID The provider identifier.
     * @param countryID (optional) The country identifier.
     */
    card(providerID: string, countryID?: string | null | undefined): Promise<Provider> {
        let url_ = this.baseUrl + "/api/v1/Providers/{providerID}/Card?";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (countryID !== undefined && countryID !== null)
            url_ += "countryID=" + encodeURIComponent("" + countryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCard(_response);
        });
    }

    protected processCard(response: Response): Promise<Provider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Provider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider>(null as any);
    }

    /**
     * Gets the provider card.
     * @param providerID The provider identifier.
     * @param countryID (optional) The country identifier.
     */
    cardAdmin(providerID: string, countryID?: string | null | undefined): Promise<Provider> {
        let url_ = this.baseUrl + "/api/v1/Providers/{providerID}/CardAdmin?";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (countryID !== undefined && countryID !== null)
            url_ += "countryID=" + encodeURIComponent("" + countryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCardAdmin(_response);
        });
    }

    protected processCardAdmin(response: Response): Promise<Provider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Provider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider>(null as any);
    }

    /**
     * Gets the by user detail identifier.
     * @param userDetailID The identifier.
     */
    byUserDetailID(userDetailID: string): Promise<Provider> {
        let url_ = this.baseUrl + "/api/v1/Providers/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<Provider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Provider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider>(null as any);
    }

    /**
     * Gets the by store identifier.
     * @param storeID The store identifier.
     */
    adminByStoreID(storeID: string): Promise<Provider[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/AdminByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByStoreID(_response);
        });
    }

    protected processAdminByStoreID(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    /**
     * Gets the by item identifier.
     * @param itemID The item identifier.
     */
    adminByItemID(itemID: string): Promise<Provider[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/AdminByItemID/{itemID}";
        if (itemID === undefined || itemID === null)
            throw new Error("The parameter 'itemID' must be defined.");
        url_ = url_.replace("{itemID}", encodeURIComponent("" + itemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByItemID(_response);
        });
    }

    protected processAdminByItemID(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    /**
     * Gets the by organization identifier.
     * @param organizationID The organization identifier.
     */
    adminByOrganizationID(organizationID: string): Promise<Provider[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/AdminByOrganizationID/{organizationID}";
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByOrganizationID(_response);
        });
    }

    protected processAdminByOrganizationID(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    /**
     * Gets the by department identifier.
     * @param departmentID The department identifier.
     */
    adminByDepartmentID(departmentID: string): Promise<Provider[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/AdminByDepartmentID/{departmentID}";
        if (departmentID === undefined || departmentID === null)
            throw new Error("The parameter 'departmentID' must be defined.");
        url_ = url_.replace("{departmentID}", encodeURIComponent("" + departmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByDepartmentID(_response);
        });
    }

    protected processAdminByDepartmentID(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    /**
     * Find a provider by the email address (Admin Only)
     * @param emailAddress The email address.
     */
    byEmailAddress(emailAddress: string): Promise<Provider> {
        let url_ = this.baseUrl + "/api/v1/Providers/ByEmailAddress/{emailAddress}";
        if (emailAddress === undefined || emailAddress === null)
            throw new Error("The parameter 'emailAddress' must be defined.");
        url_ = url_.replace("{emailAddress}", encodeURIComponent("" + emailAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByEmailAddress(_response);
        });
    }

    protected processByEmailAddress(response: Response): Promise<Provider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Provider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider>(null as any);
    }

    /**
     * Approve the provider.
     * @param providerID The identifier.
     */
    approveProvider(providerID: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Providers/ApproveProvider/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processApproveProvider(_response);
        });
    }

    protected processApproveProvider(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the provider by store item identifier.
     * @param storeItemID The store item identifier.
     * @param providerID (optional) The provider identifier.
     */
    byStoreItemID(storeItemID: string, providerID?: string | null | undefined): Promise<ProviderDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/ByStoreItemID/{storeItemID}?";
        if (storeItemID === undefined || storeItemID === null)
            throw new Error("The parameter 'storeItemID' must be defined.");
        url_ = url_.replace("{storeItemID}", encodeURIComponent("" + storeItemID));
        if (providerID !== undefined && providerID !== null)
            url_ += "providerID=" + encodeURIComponent("" + providerID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreItemID(_response);
        });
    }

    protected processByStoreItemID(response: Response): Promise<ProviderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderDTO[]>(null as any);
    }

    /**
     * Gets the provider by store identifier.
     * @param storeID The store identifier.
     */
    byStoreID(storeID: string): Promise<Provider[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    /**
     * Posts the specified provider.
     * @param provider The provider.
     */
    providersPost(provider: Provider): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Providers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(provider);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvidersPost(_response);
        });
    }

    protected processProvidersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified provider.
     * @param provider The provider.
     */
    providersPut(provider: Provider): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Providers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(provider);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvidersPut(_response);
        });
    }

    protected processProvidersPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the favorite providers.
     * @param patientID The patient identifier.
     */
    favoriteProviders(patientID: string): Promise<ProviderDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/FavoriteProviders/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFavoriteProviders(_response);
        });
    }

    protected processFavoriteProviders(response: Response): Promise<ProviderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderDTO[]>(null as any);
    }

    /**
     * Converts the time zones.
     */
    convertTimeZones(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Providers/ConvertTimeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConvertTimeZones(_response);
        });
    }

    protected processConvertTimeZones(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * PublicTag Availability Check
     */
    adminIsPublicTagAvailable(providerID: string, publicTag: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Providers/AdminIsPublicTagAvailable/{providerID}/{publicTag}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (publicTag === undefined || publicTag === null)
            throw new Error("The parameter 'publicTag' must be defined.");
        url_ = url_.replace("{publicTag}", encodeURIComponent("" + publicTag));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminIsPublicTagAvailable(_response);
        });
    }

    protected processAdminIsPublicTagAvailable(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get the Provider's profile image
     */
    profileImage(providerID: string, imageDetailID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Providers/{providerID}/ProfileImage/{imageDetailID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (imageDetailID === undefined || imageDetailID === null)
            throw new Error("The parameter 'imageDetailID' must be defined.");
        url_ = url_.replace("{imageDetailID}", encodeURIComponent("" + imageDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProfileImage(_response);
        });
    }

    protected processProfileImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the Provider's profile image
     */
    profileThumbnailImageAsSrc(providerID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Providers/{providerID}/ProfileThumbnailImageAsSrc";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProfileThumbnailImageAsSrc(_response);
        });
    }

    protected processProfileThumbnailImageAsSrc(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the provider by the ProviderOnboardingID
     */
    byProviderOnboardingID(providerOnboardingID: string): Promise<Provider> {
        let url_ = this.baseUrl + "/api/v1/Providers/ByProviderOnboardingID/{providerOnboardingID}";
        if (providerOnboardingID === undefined || providerOnboardingID === null)
            throw new Error("The parameter 'providerOnboardingID' must be defined.");
        url_ = url_.replace("{providerOnboardingID}", encodeURIComponent("" + providerOnboardingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderOnboardingID(_response);
        });
    }

    protected processByProviderOnboardingID(response: Response): Promise<Provider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Provider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider>(null as any);
    }

    /**
     * Provider Signups
     */
    providerSignups(providerSignupsDetails: ProviderSignupDTODetails): Promise<ProviderSignupsDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Providers/ProviderSignups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSignupsDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSignups(_response);
        });
    }

    protected processProviderSignups(response: Response): Promise<ProviderSignupsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderSignupsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderSignupsDTO[]>(null as any);
    }

    /**
     * Provider Signups Paged
     * @param recordsToSkip (optional) 
     * @param recordsToTake (optional) 
     * @param appTypeEnum (optional) 
     */
    providerSignupsPaged(recordsToSkip?: number | undefined, recordsToTake?: number | undefined, appTypeEnum?: AppTypeEnum | undefined): Promise<PagedResultOfProviderSignupsDTO> {
        let url_ = this.baseUrl + "/api/v1/Providers/ProviderSignupsPaged?";
        if (recordsToSkip === null)
            throw new Error("The parameter 'recordsToSkip' cannot be null.");
        else if (recordsToSkip !== undefined)
            url_ += "RecordsToSkip=" + encodeURIComponent("" + recordsToSkip) + "&";
        if (recordsToTake === null)
            throw new Error("The parameter 'recordsToTake' cannot be null.");
        else if (recordsToTake !== undefined)
            url_ += "RecordsToTake=" + encodeURIComponent("" + recordsToTake) + "&";
        if (appTypeEnum === null)
            throw new Error("The parameter 'appTypeEnum' cannot be null.");
        else if (appTypeEnum !== undefined)
            url_ += "AppTypeEnum=" + encodeURIComponent("" + appTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSignupsPaged(_response);
        });
    }

    protected processProviderSignupsPaged(response: Response): Promise<PagedResultOfProviderSignupsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProviderSignupsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfProviderSignupsDTO>(null as any);
    }

    /**
     * Provider Signups Count
     * @param appTypeEnum (optional) 
     */
    providerSignupsCount(appTypeEnum?: AppTypeEnum | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/Providers/ProviderSignupsCount?";
        if (appTypeEnum === null)
            throw new Error("The parameter 'appTypeEnum' cannot be null.");
        else if (appTypeEnum !== undefined)
            url_ += "AppTypeEnum=" + encodeURIComponent("" + appTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSignupsCount(_response);
        });
    }

    protected processProviderSignupsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets the Providers WalkInAvailability
     */
    walkInAvailabilityGet(providerID: string): Promise<ProviderWalkInAvailabilityResult> {
        let url_ = this.baseUrl + "/api/v1/Providers/WalkInAvailability/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalkInAvailabilityGet(_response);
        });
    }

    protected processWalkInAvailabilityGet(response: Response): Promise<ProviderWalkInAvailabilityResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderWalkInAvailabilityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderWalkInAvailabilityResult>(null as any);
    }

    /**
     * Sets the Walkin Availability for the provider
     */
    walkInAvailabilityPut(providerWalkInAvailabilityDetail: ProviderWalkInAvailabilityDetail): Promise<ProviderWalkInAvailabilityResult> {
        let url_ = this.baseUrl + "/api/v1/Providers/WalkInAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerWalkInAvailabilityDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalkInAvailabilityPut(_response);
        });
    }

    protected processWalkInAvailabilityPut(response: Response): Promise<ProviderWalkInAvailabilityResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderWalkInAvailabilityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderWalkInAvailabilityResult>(null as any);
    }

    /**
     * Assign the testPatient to the provider
     */
    assignTestPatientToProvider(providerID: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Providers/AssignTestPatientToProvider/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAssignTestPatientToProvider(_response);
        });
    }

    protected processAssignTestPatientToProvider(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get the store that is associated to the Merchant Provider
     */
    myMerchantProviderStore(): Promise<Store> {
        let url_ = this.baseUrl + "/api/v1/Providers/MyMerchantProviderStore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyMerchantProviderStore(_response);
        });
    }

    protected processMyMerchantProviderStore(response: Response): Promise<Store> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Store.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store>(null as any);
    }
}

export class ProviderSettingsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the by provider identifier.
     * @param providerID The provider identifier.
     */
    byProviderID(providerID: string): Promise<ProviderSetting[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderSettings/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<ProviderSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderSetting[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerSettingID The identifier.
     */
    providerSettingsGet(providerSettingID: string): Promise<ProviderSetting> {
        let url_ = this.baseUrl + "/api/v1/ProviderSettings/{providerSettingID}";
        if (providerSettingID === undefined || providerSettingID === null)
            throw new Error("The parameter 'providerSettingID' must be defined.");
        url_ = url_.replace("{providerSettingID}", encodeURIComponent("" + providerSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSettingsGet(_response);
        });
    }

    protected processProviderSettingsGet(response: Response): Promise<ProviderSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderSetting>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerSettingID The identifier.
     */
    providerSettingsDelete(providerSettingID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderSettings/{providerSettingID}";
        if (providerSettingID === undefined || providerSettingID === null)
            throw new Error("The parameter 'providerSettingID' must be defined.");
        url_ = url_.replace("{providerSettingID}", encodeURIComponent("" + providerSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSettingsDelete(_response);
        });
    }

    protected processProviderSettingsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderSetting.
     * @param providerSetting The ProviderSetting.
     */
    providerSettingsPost(providerSetting: ProviderSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSettingsPost(_response);
        });
    }

    protected processProviderSettingsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderSetting.
     * @param providerSetting The ProviderSetting.
     */
    providerSettingsPut(providerSetting: ProviderSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSettingsPut(_response);
        });
    }

    protected processProviderSettingsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ProviderSpecialtiesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    byProviderID(providerID: string): Promise<ProviderSpecialty[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderSpecialties/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<ProviderSpecialty[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderSpecialty.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderSpecialty[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerSpecialtyID The identifier.
     */
    providerSpecialtiesGet(providerSpecialtyID: string): Promise<ProviderSpecialty> {
        let url_ = this.baseUrl + "/api/v1/ProviderSpecialties/{providerSpecialtyID}";
        if (providerSpecialtyID === undefined || providerSpecialtyID === null)
            throw new Error("The parameter 'providerSpecialtyID' must be defined.");
        url_ = url_.replace("{providerSpecialtyID}", encodeURIComponent("" + providerSpecialtyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSpecialtiesGet(_response);
        });
    }

    protected processProviderSpecialtiesGet(response: Response): Promise<ProviderSpecialty> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderSpecialty.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderSpecialty>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerSpecialtyID The identifier.
     */
    providerSpecialtiesDelete(providerSpecialtyID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderSpecialties/{providerSpecialtyID}";
        if (providerSpecialtyID === undefined || providerSpecialtyID === null)
            throw new Error("The parameter 'providerSpecialtyID' must be defined.");
        url_ = url_.replace("{providerSpecialtyID}", encodeURIComponent("" + providerSpecialtyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSpecialtiesDelete(_response);
        });
    }

    protected processProviderSpecialtiesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderSpecialty.
     * @param providerSpecialty The ProviderSpecialty.
     */
    providerSpecialtiesPost(providerSpecialty: ProviderSpecialty): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderSpecialties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSpecialty);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSpecialtiesPost(_response);
        });
    }

    protected processProviderSpecialtiesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderSpecialty.
     * @param providerSpecialty The ProviderSpecialty.
     */
    providerSpecialtiesPut(providerSpecialty: ProviderSpecialty): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderSpecialties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSpecialty);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderSpecialtiesPut(_response);
        });
    }

    protected processProviderSpecialtiesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update many at once
     */
    many(providerSpecialties: ProviderSpecialty[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderSpecialties/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSpecialties);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ProviderStoreItemsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all by store identifier.
     * @param storeID The store identifier.
     */
    byStoreID(storeID: string): Promise<ProviderStoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<ProviderStoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderStoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderStoreItem[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerStoreItemID The identifier.
     */
    providerStoreItemsGet(providerStoreItemID: string): Promise<ProviderStoreItem> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/{providerStoreItemID}";
        if (providerStoreItemID === undefined || providerStoreItemID === null)
            throw new Error("The parameter 'providerStoreItemID' must be defined.");
        url_ = url_.replace("{providerStoreItemID}", encodeURIComponent("" + providerStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderStoreItemsGet(_response);
        });
    }

    protected processProviderStoreItemsGet(response: Response): Promise<ProviderStoreItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderStoreItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderStoreItem>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerStoreItemID The identifier.
     */
    providerStoreItemsDelete(providerStoreItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/{providerStoreItemID}";
        if (providerStoreItemID === undefined || providerStoreItemID === null)
            throw new Error("The parameter 'providerStoreItemID' must be defined.");
        url_ = url_.replace("{providerStoreItemID}", encodeURIComponent("" + providerStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderStoreItemsDelete(_response);
        });
    }

    protected processProviderStoreItemsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by provider identifier.
     * @param providerID The provider identifier.
     */
    byProviderID(providerID: string): Promise<ProviderStoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<ProviderStoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderStoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderStoreItem[]>(null as any);
    }

    /**
     * Gets the by provider identifier.
     * @param providerID The provider identifier.
     */
    adminByProviderID(providerID: string): Promise<ProviderStoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/AdminByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByProviderID(_response);
        });
    }

    protected processAdminByProviderID(response: Response): Promise<ProviderStoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderStoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderStoreItem[]>(null as any);
    }

    /**
     * Gets the by item identifier.
     * @param itemID The item identifier.
     */
    adminByItemID(itemID: string): Promise<ProviderStoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/AdminByItemID/{itemID}";
        if (itemID === undefined || itemID === null)
            throw new Error("The parameter 'itemID' must be defined.");
        url_ = url_.replace("{itemID}", encodeURIComponent("" + itemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByItemID(_response);
        });
    }

    protected processAdminByItemID(response: Response): Promise<ProviderStoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderStoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderStoreItem[]>(null as any);
    }

    /**
     * Gets the by item identifier.
     * @param storeItemID The store item identifier.
     */
    adminByStoreItemID(storeItemID: string): Promise<ProviderStoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/AdminByStoreItemID/{storeItemID}";
        if (storeItemID === undefined || storeItemID === null)
            throw new Error("The parameter 'storeItemID' must be defined.");
        url_ = url_.replace("{storeItemID}", encodeURIComponent("" + storeItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByStoreItemID(_response);
        });
    }

    protected processAdminByStoreItemID(response: Response): Promise<ProviderStoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderStoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderStoreItem[]>(null as any);
    }

    /**
     * Gets the unique store item minutes by provider identifier.
     * @param providerID The provider identifier.
     */
    uniqueStoreItemMinutesByProviderID(providerID: string): Promise<number[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/UniqueStoreItemMinutesByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUniqueStoreItemMinutesByProviderID(_response);
        });
    }

    protected processUniqueStoreItemMinutesByProviderID(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Posts the specified ProviderStoreItem.
     * @param providerStoreItem The ProviderStoreItem.
     */
    providerStoreItemsPost(providerStoreItem: ProviderStoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderStoreItemsPost(_response);
        });
    }

    protected processProviderStoreItemsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderStoreItem.
     * @param providerStoreItem The ProviderStoreItem.
     */
    providerStoreItemsPut(providerStoreItem: ProviderStoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderStoreItemsPut(_response);
        });
    }

    protected processProviderStoreItemsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Enable a ProviderStoreItem
     */
    enable(providerStoreItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/{providerStoreItemID}/Enable";
        if (providerStoreItemID === undefined || providerStoreItemID === null)
            throw new Error("The parameter 'providerStoreItemID' must be defined.");
        url_ = url_.replace("{providerStoreItemID}", encodeURIComponent("" + providerStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processEnable(_response);
        });
    }

    protected processEnable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Disable a ProviderStoreItem
     */
    disable(providerStoreItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/{providerStoreItemID}/Disable";
        if (providerStoreItemID === undefined || providerStoreItemID === null)
            throw new Error("The parameter 'providerStoreItemID' must be defined.");
        url_ = url_.replace("{providerStoreItemID}", encodeURIComponent("" + providerStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDisable(_response);
        });
    }

    protected processDisable(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets by the providerID and the StoreItemID.
     * @param providerID The provider identifier.
     */
    byProviderIDAndStoreItemID(providerID: string, storeItemID: string): Promise<ProviderStoreItem> {
        let url_ = this.baseUrl + "/api/v1/ProviderStoreItems/ByProviderIDAndStoreItemID/{providerID}/{storeItemID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        if (storeItemID === undefined || storeItemID === null)
            throw new Error("The parameter 'storeItemID' must be defined.");
        url_ = url_.replace("{storeItemID}", encodeURIComponent("" + storeItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderIDAndStoreItemID(_response);
        });
    }

    protected processByProviderIDAndStoreItemID(response: Response): Promise<ProviderStoreItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderStoreItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderStoreItem>(null as any);
    }
}

export class ProviderTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    byProviderID(providerID: string): Promise<ProviderTag[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderTags/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<ProviderTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProviderTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderTag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param providerTagID The identifier.
     */
    providerTagsGet(providerTagID: string): Promise<ProviderTag> {
        let url_ = this.baseUrl + "/api/v1/ProviderTags/{providerTagID}";
        if (providerTagID === undefined || providerTagID === null)
            throw new Error("The parameter 'providerTagID' must be defined.");
        url_ = url_.replace("{providerTagID}", encodeURIComponent("" + providerTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderTagsGet(_response);
        });
    }

    protected processProviderTagsGet(response: Response): Promise<ProviderTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProviderTag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderTag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param providerTagID The identifier.
     */
    providerTagsDelete(providerTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ProviderTags/{providerTagID}";
        if (providerTagID === undefined || providerTagID === null)
            throw new Error("The parameter 'providerTagID' must be defined.");
        url_ = url_.replace("{providerTagID}", encodeURIComponent("" + providerTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderTagsDelete(_response);
        });
    }

    protected processProviderTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProviderTag.
     * @param providerTag The ProviderTag.
     */
    providerTagsPost(providerTag: ProviderTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderTagsPost(_response);
        });
    }

    protected processProviderTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProviderTag.
     * @param providerTag The ProviderTag.
     */
    providerTagsPut(providerTag: ProviderTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ProviderTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderTagsPut(_response);
        });
    }

    protected processProviderTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update many at once
     */
    many(providerTags: ProviderTag[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ProviderTags/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class QualityOfServicesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the by identifier.
     * @param qualityOfServiceID The quality of service identifier.
     */
    qualityOfServicesGet(qualityOfServiceID: string): Promise<QualityOfService> {
        let url_ = this.baseUrl + "/api/v1/QualityOfServices/{qualityOfServiceID}";
        if (qualityOfServiceID === undefined || qualityOfServiceID === null)
            throw new Error("The parameter 'qualityOfServiceID' must be defined.");
        url_ = url_.replace("{qualityOfServiceID}", encodeURIComponent("" + qualityOfServiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processQualityOfServicesGet(_response);
        });
    }

    protected processQualityOfServicesGet(response: Response): Promise<QualityOfService> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualityOfService.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualityOfService>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param qualityOfServiceID The quality of service identifier.
     */
    qualityOfServicesDelete(qualityOfServiceID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/QualityOfServices/{qualityOfServiceID}";
        if (qualityOfServiceID === undefined || qualityOfServiceID === null)
            throw new Error("The parameter 'qualityOfServiceID' must be defined.");
        url_ = url_.replace("{qualityOfServiceID}", encodeURIComponent("" + qualityOfServiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processQualityOfServicesDelete(_response);
        });
    }

    protected processQualityOfServicesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified QualityOfService.
     * @param qualityOfService The QualityOfService.
     */
    qualityOfServicesPost(qualityOfService: QualityOfService): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/QualityOfServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qualityOfService);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processQualityOfServicesPost(_response);
        });
    }

    protected processQualityOfServicesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified QualityOfService.
     * @param qualityOfService The quality of service.
     */
    qualityOfServicesPut(qualityOfService: QualityOfService): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/QualityOfServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(qualityOfService);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processQualityOfServicesPut(_response);
        });
    }

    protected processQualityOfServicesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get by primary key
     */
    byPrimaryKeyID(primaryKeyID: string): Promise<QualityOfService[]> {
        let url_ = this.baseUrl + "/api/v1/QualityOfServices/ByPrimaryKeyID/{primaryKeyID}";
        if (primaryKeyID === undefined || primaryKeyID === null)
            throw new Error("The parameter 'primaryKeyID' must be defined.");
        url_ = url_.replace("{primaryKeyID}", encodeURIComponent("" + primaryKeyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPrimaryKeyID(_response);
        });
    }

    protected processByPrimaryKeyID(response: Response): Promise<QualityOfService[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualityOfService.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualityOfService[]>(null as any);
    }
}

export class ReceptionistsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Searches the specified patient search details.
     * @param patientSearchDetails The patient search details.
     */
    search(patientSearchDetails: PatientSearchDetails): Promise<PagedResultOfPatient> {
        let url_ = this.baseUrl + "/api/v1/Receptionists/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatient>(null as any);
    }

    /**
     * Gets the receptionist providers.
     * @param providerSearchDetails The provider search details.
     */
    receptionistProviders(providerSearchDetails: ProviderSearchDetails): Promise<PagedResultOfProvider> {
        let url_ = this.baseUrl + "/api/v1/Receptionists/ReceptionistProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReceptionistProviders(_response);
        });
    }

    protected processReceptionistProviders(response: Response): Promise<PagedResultOfProvider> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfProvider.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfProvider>(null as any);
    }

    /**
     * Signs up patient.
     * @param internalSignUpPatient The internal sign up patient.
     */
    signUpPatient(internalSignUpPatient: InternalSignUpPatient): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Receptionists/SignUpPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(internalSignUpPatient);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpPatient(_response);
        });
    }

    protected processSignUpPatient(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Receptionist Patient Search when associated with a subscription
     */
    subscriptionPatientSearch(patientSubscriptionSearchDetails: PatientSubscriptionSearchDetails): Promise<PagedResultOfPatient> {
        let url_ = this.baseUrl + "/api/v1/Receptionists/SubscriptionPatientSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientSubscriptionSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionPatientSearch(_response);
        });
    }

    protected processSubscriptionPatientSearch(response: Response): Promise<PagedResultOfPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPatient>(null as any);
    }
}

export class ReferralCenterInvitesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param referralCenterInviteID The identifier.
     */
    referralCenterInvitesGet(referralCenterInviteID: string): Promise<ReferralCenterInvite> {
        let url_ = this.baseUrl + "/api/v1/ReferralCenterInvites/{referralCenterInviteID}";
        if (referralCenterInviteID === undefined || referralCenterInviteID === null)
            throw new Error("The parameter 'referralCenterInviteID' must be defined.");
        url_ = url_.replace("{referralCenterInviteID}", encodeURIComponent("" + referralCenterInviteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReferralCenterInvitesGet(_response);
        });
    }

    protected processReferralCenterInvitesGet(response: Response): Promise<ReferralCenterInvite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferralCenterInvite.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferralCenterInvite>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param referralCenterInviteID The identifier.
     */
    referralCenterInvitesDelete(referralCenterInviteID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/ReferralCenterInvites/{referralCenterInviteID}";
        if (referralCenterInviteID === undefined || referralCenterInviteID === null)
            throw new Error("The parameter 'referralCenterInviteID' must be defined.");
        url_ = url_.replace("{referralCenterInviteID}", encodeURIComponent("" + referralCenterInviteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReferralCenterInvitesDelete(_response);
        });
    }

    protected processReferralCenterInvitesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ReferralCenterInvite.
     * @param referralCenterInvites The ReferralCenterInvite.
     */
    referralCenterInvitesPost(referralCenterInvites: ReferralCenterInvite[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ReferralCenterInvites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referralCenterInvites);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReferralCenterInvitesPost(_response);
        });
    }

    protected processReferralCenterInvitesPost(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Puts the specified ReferralCenterInvite.
     * @param referralCenterInvite The ReferralCenterInvite.
     */
    referralCenterInvitesPut(referralCenterInvite: ReferralCenterInvite): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/ReferralCenterInvites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referralCenterInvite);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReferralCenterInvitesPut(_response);
        });
    }

    protected processReferralCenterInvitesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Post a single Referral Center Invite
     * @param referralCenterInvite The ReferralCenterInvite.
     */
    invite(referralCenterInvite: ReferralCenterInvite): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/ReferralCenterInvites/Invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referralCenterInvite);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processInvite(_response);
        });
    }

    protected processInvite(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Get the paged list of the provider's referrals
     */
    byProviderID(referralCenterInviteDetails: ReferralCenterInviteDetails): Promise<PagedResultOfReferralCenterInvite> {
        let url_ = this.baseUrl + "/api/v1/ReferralCenterInvites/byProviderID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referralCenterInviteDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<PagedResultOfReferralCenterInvite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfReferralCenterInvite.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfReferralCenterInvite>(null as any);
    }
}

export class RestrictedEmailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<RestrictedEmail[]> {
        let url_ = this.baseUrl + "/api/v1/RestrictedEmails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<RestrictedEmail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RestrictedEmail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestrictedEmail[]>(null as any);
    }

    /**
     * Get the tenanant
     * @param restrictedEmailID The restricted email identifier.
     */
    restrictedEmailsGet(restrictedEmailID: string): Promise<RestrictedEmail> {
        let url_ = this.baseUrl + "/api/v1/RestrictedEmails/{RestrictedEmailID}";
        if (restrictedEmailID === undefined || restrictedEmailID === null)
            throw new Error("The parameter 'restrictedEmailID' must be defined.");
        url_ = url_.replace("{RestrictedEmailID}", encodeURIComponent("" + restrictedEmailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRestrictedEmailsGet(_response);
        });
    }

    protected processRestrictedEmailsGet(response: Response): Promise<RestrictedEmail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RestrictedEmail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestrictedEmail>(null as any);
    }

    /**
     * Posts the specified restricted email.
     * @param restrictedEmail The restricted email.
     */
    restrictedEmailsPost(restrictedEmail: RestrictedEmail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/RestrictedEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(restrictedEmail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRestrictedEmailsPost(_response);
        });
    }

    protected processRestrictedEmailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified restricted email.
     * @param restrictedEmail The restricted email.
     */
    restrictedEmailsPut(restrictedEmail: RestrictedEmail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/RestrictedEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(restrictedEmail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRestrictedEmailsPut(_response);
        });
    }

    protected processRestrictedEmailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified restricted email identifier.
     * @param restrictedEmailID The restricted email identifier.
     */
    restrictedEmailsDelete(restrictedEmailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/RestrictedEmails/{restrictedEmailID}";
        if (restrictedEmailID === undefined || restrictedEmailID === null)
            throw new Error("The parameter 'restrictedEmailID' must be defined.");
        url_ = url_.replace("{restrictedEmailID}", encodeURIComponent("" + restrictedEmailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRestrictedEmailsDelete(_response);
        });
    }

    protected processRestrictedEmailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SearchClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the consult countries for which there are providers configured
     */
    consultCountries(): Promise<Country[]> {
        let url_ = this.baseUrl + "/api/v1/Search/ConsultCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultCountries(_response);
        });
    }

    protected processConsultCountries(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(null as any);
    }

    /**
     * Gets the consult specialities.
     * @param countryID The country identifier.
     */
    consultSpecialties(countryID: string): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/Search/ConsultSpecialties/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultSpecialties(_response);
        });
    }

    protected processConsultSpecialties(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Gets the Symptoms.
     * @param countryID The country identifier.
     */
    consultSymptoms(countryID: string): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/Search/ConsultSymptoms/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultSymptoms(_response);
        });
    }

    protected processConsultSymptoms(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Gets the Symptoms by Country and CareType
     * @param countryID The country identifier.
     */
    consultSymptomsByCareType(countryID: string, careTypeTagID: string): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/Search/ConsultSymptomsByCareType/{countryID}/{careTypeTagID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        if (careTypeTagID === undefined || careTypeTagID === null)
            throw new Error("The parameter 'careTypeTagID' must be defined.");
        url_ = url_.replace("{careTypeTagID}", encodeURIComponent("" + careTypeTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultSymptomsByCareType(_response);
        });
    }

    protected processConsultSymptomsByCareType(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Gets the ProvinceStates associated with any providers / stores.
     * @param countryID The country identifier.
     */
    provinceStates(countryID: string): Promise<ProvinceState[]> {
        let url_ = this.baseUrl + "/api/v1/Search/ProvinceStates/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvinceStates(_response);
        });
    }

    protected processProvinceStates(response: Response): Promise<ProvinceState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceState.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProvinceState[]>(null as any);
    }

    /**
     * Get CityTowns associated with any stores, providers or organizations
     */
    cityTowns(provinceStateID: string): Promise<CityTown[]> {
        let url_ = this.baseUrl + "/api/v1/Search/CityTowns/{provinceStateID}";
        if (provinceStateID === undefined || provinceStateID === null)
            throw new Error("The parameter 'provinceStateID' must be defined.");
        url_ = url_.replace("{provinceStateID}", encodeURIComponent("" + provinceStateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCityTowns(_response);
        });
    }

    protected processCityTowns(response: Response): Promise<CityTown[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityTown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityTown[]>(null as any);
    }

    /**
     * Gets the consult provider search results asynchronous.
     * @param consultProviderSearchDetails The consult provider search details.
     */
    consultSearch(consultProviderSearchDetails: ConsultProviderSearchDetails): Promise<ConsultProviderSearchResults> {
        let url_ = this.baseUrl + "/api/v1/Search/ConsultSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultProviderSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultSearch(_response);
        });
    }

    protected processConsultSearch(response: Response): Promise<ConsultProviderSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultProviderSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultProviderSearchResults>(null as any);
    }

    /**
     * Gets the consult provider search results asynchronous.
     * @param consultProviderSearchDetails The consult provider search details.
     */
    consultSearch2(consultProviderSearchDetails: ConsultProviderSearchDetails): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Search/ConsultSearch2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultProviderSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultSearch2(_response);
        });
    }

    protected processConsultSearch2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Consults the provider browse results asynchronous.
     * @param consultProviderSearchDetails The consult provider search details.
     */
    consultBrowse(consultProviderSearchDetails: ConsultProviderSearchDetails): Promise<ConsultProviderSearchResults> {
        let url_ = this.baseUrl + "/api/v1/Search/ConsultBrowse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultProviderSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultBrowse(_response);
        });
    }

    protected processConsultBrowse(response: Response): Promise<ConsultProviderSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConsultProviderSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultProviderSearchResults>(null as any);
    }

    /**
     * Consults the provider browse results asynchronous.
     * @param consultProviderSearchDetails The consult provider search details.
     */
    consultBrowse2(consultProviderSearchDetails: ConsultProviderSearchDetails): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Search/ConsultBrowse2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultProviderSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConsultBrowse2(_response);
        });
    }

    protected processConsultBrowse2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Process Searches
     */
    processSearches(): Promise<ProcessSearchResult> {
        let url_ = this.baseUrl + "/api/v1/Search/ProcessSearches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProcessSearches(_response);
        });
    }

    protected processProcessSearches(response: Response): Promise<ProcessSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProcessSearchResult>(null as any);
    }

    /**
     * Search for an entity by it's public tag
     * @param publicTag (optional) 
     * @param countryID (optional) 
     */
    searchByPublicTag(publicTag?: string | null | undefined, countryID?: string | null | undefined): Promise<PublicTagResult> {
        let url_ = this.baseUrl + "/api/v1/Search/SearchByPublicTag?";
        if (publicTag !== undefined && publicTag !== null)
            url_ += "PublicTag=" + encodeURIComponent("" + publicTag) + "&";
        if (countryID !== undefined && countryID !== null)
            url_ += "CountryID=" + encodeURIComponent("" + countryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearchByPublicTag(_response);
        });
    }

    protected processSearchByPublicTag(response: Response): Promise<PublicTagResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicTagResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicTagResult>(null as any);
    }

    /**
     * Get available ConsultTypes by StoreID
     */
    availableConsultTypesByStoreID(storeID: string): Promise<ConsultTypeEnum[]> {
        let url_ = this.baseUrl + "/api/v1/Search/AvailableConsultTypesByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableConsultTypesByStoreID(_response);
        });
    }

    protected processAvailableConsultTypesByStoreID(response: Response): Promise<ConsultTypeEnum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConsultTypeEnum[]>(null as any);
    }

    /**
     * Search The SearchLog
     */
    searchSearches(searchLogDetails: SearchLogDetails): Promise<SearchLog[]> {
        let url_ = this.baseUrl + "/api/v1/Search/SearchSearches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchLogDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearchSearches(_response);
        });
    }

    protected processSearchSearches(response: Response): Promise<SearchLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchLog[]>(null as any);
    }
}

export class SecurityAuditsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get by Date
     * @param startDate (optional) The start date.
     * @param endDate (optional) The end date.
     */
    dateRange(startDate?: Date | undefined, endDate?: Date | undefined): Promise<SecurityAudit[]> {
        let url_ = this.baseUrl + "/api/v1/SecurityAudits/DateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDateRange(_response);
        });
    }

    protected processDateRange(response: Response): Promise<SecurityAudit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SecurityAudit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecurityAudit[]>(null as any);
    }

    /**
     * Gets the search.
     * @param securityAuditSearchDetails The security audit search details.
     */
    search(securityAuditSearchDetails: SecurityAuditSearchDetails): Promise<SecurityAudit[]> {
        let url_ = this.baseUrl + "/api/v1/SecurityAudits/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(securityAuditSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SecurityAudit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SecurityAudit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecurityAudit[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param securityAuditID The identifier.
     */
    securityAudits(securityAuditID: string): Promise<SecurityAudit> {
        let url_ = this.baseUrl + "/api/v1/SecurityAudits/{securityAuditID}";
        if (securityAuditID === undefined || securityAuditID === null)
            throw new Error("The parameter 'securityAuditID' must be defined.");
        url_ = url_.replace("{securityAuditID}", encodeURIComponent("" + securityAuditID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSecurityAudits(_response);
        });
    }

    protected processSecurityAudits(response: Response): Promise<SecurityAudit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SecurityAudit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SecurityAudit>(null as any);
    }

    /**
     * Update many Security Audit records (TenantAdmin only)
     */
    many(securityAudits: SecurityAudit[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/SecurityAudits/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(securityAudits);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class SecurityClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Signs the in.
     * @param details The details.
     */
    signIn(details: UserSignInDetails): Promise<UserSignInResult> {
        let url_ = this.baseUrl + "/api/v1/Security/SignIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignIn(_response);
        });
    }

    protected processSignIn(response: Response): Promise<UserSignInResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSignInResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSignInResult>(null as any);
    }

    /**
     * Authenticates the Signed in user.
     * @param userDetailID (optional) The user detail identifier.
     * @param host (optional) Name of the host.
     */
    authenticateUser(userDetailID?: string | undefined, host?: string | null | undefined): Promise<UserSignInResult> {
        let url_ = this.baseUrl + "/api/v1/Security/AuthenticateUser?";
        if (userDetailID === null)
            throw new Error("The parameter 'userDetailID' cannot be null.");
        else if (userDetailID !== undefined)
            url_ += "userDetailID=" + encodeURIComponent("" + userDetailID) + "&";
        if (host !== undefined && host !== null)
            url_ += "host=" + encodeURIComponent("" + host) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAuthenticateUser(_response);
        });
    }

    protected processAuthenticateUser(response: Response): Promise<UserSignInResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSignInResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSignInResult>(null as any);
    }

    /**
     * Sign in as a dependant's PatientID (Current User = DependantOwner, PatientID = Dependant)
     * @param patientID The patient identifier.
     */
    signInAsDependantByPatientID(patientID: string): Promise<UserSignInResult> {
        let url_ = this.baseUrl + "/api/v1/Security/SignInAsDependantByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignInAsDependantByPatientID(_response);
        });
    }

    protected processSignInAsDependantByPatientID(response: Response): Promise<UserSignInResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSignInResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSignInResult>(null as any);
    }

    /**
     * Signin as a dependant of this patient.
     * @param userDetailRelationship The Dependant relationship
     */
    signInAsDependant(userDetailRelationship: UserDetailRelationship): Promise<UserSignInResult> {
        let url_ = this.baseUrl + "/api/v1/Security/SignInAsDependant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailRelationship);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignInAsDependant(_response);
        });
    }

    protected processSignInAsDependant(response: Response): Promise<UserSignInResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSignInResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSignInResult>(null as any);
    }

    /**
     * Check to see if the password meets the minimum criteria.
     * @param password (optional) The password.
     */
    isValidPasswordStrength(password?: string | null | undefined): Promise<IdentityError[]> {
        let url_ = this.baseUrl + "/api/v1/Security/IsValidPasswordStrength?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processIsValidPasswordStrength(_response);
        });
    }

    protected processIsValidPasswordStrength(response: Response): Promise<IdentityError[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IdentityError.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityError[]>(null as any);
    }

    /**
     * Gets all roles.
     */
    allRoles(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Security/AllRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllRoles(_response);
        });
    }

    protected processAllRoles(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Sets the user roles.
     * @param userDetailID The user detail identifier.
     * @param roleNames The role names.
     */
    roles(userDetailID: string, roleNames: string[]): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/User/{userDetailID}/Roles";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleNames);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRoles(_response);
        });
    }

    protected processRoles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add a role to a user
     * @param userDetailID The user detail identifier.
     * @param roleName Name of the role.
     */
    rolePost(userDetailID: string, roleName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/User/{userDetailID}/Role";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleName);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRolePost(_response);
        });
    }

    protected processRolePost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove a role from a user
     * @param userDetailID The user detail identifier.
     * @param roleName Name of the role.
     */
    roleDelete(userDetailID: string, roleName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/User/{userDetailID}/Role";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleName);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRoleDelete(_response);
        });
    }

    protected processRoleDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Users the exists.
     * @param details The details.
     */
    userExists(details: UserExistsDetails): Promise<UserExistsResult> {
        let url_ = this.baseUrl + "/api/v1/Security/UserExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserExists(_response);
        });
    }

    protected processUserExists(response: Response): Promise<UserExistsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserExistsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserExistsResult>(null as any);
    }

    /**
     * Users the exists.
     * @param details The details.
     */
    userExists2(details: UserExistsDetails): Promise<UserExistsResult2> {
        let url_ = this.baseUrl + "/api/v1/Security/UserExists2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserExists2(_response);
        });
    }

    protected processUserExists2(response: Response): Promise<UserExistsResult2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserExistsResult2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserExistsResult2>(null as any);
    }

    /**
     * Sends the email code.
     * @param details The email details.
     * @param apiKey The API key.
     */
    sendEmailCode(details: SignUpEmailDetails, apiKey: string): Promise<SignUpEmailDetailsResults> {
        let url_ = this.baseUrl + "/api/v1/Security/SendEmailCode/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendEmailCode(_response);
        });
    }

    protected processSendEmailCode(response: Response): Promise<SignUpEmailDetailsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignUpEmailDetailsResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignUpEmailDetailsResults>(null as any);
    }

    /**
     * Sends the sms code API
     * @param details The sms details.
     * @param apiKey The API key.
     */
    sendSMSCodes(details: SignUpSMSDetails, apiKey: string): Promise<SignUpSMSDetailsResults> {
        let url_ = this.baseUrl + "/api/v1/Security/SendSMSCodes/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendSMSCodes(_response);
        });
    }

    protected processSendSMSCodes(response: Response): Promise<SignUpSMSDetailsResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignUpSMSDetailsResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignUpSMSDetailsResults>(null as any);
    }

    /**
     * Sends the email code.
     * @param details The email details.
     */
    sendSMSCode(details: VerifyPhoneDetails): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Security/SendSMSCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendSMSCode(_response);
        });
    }

    protected processSendSMSCode(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Validates the email code.
     * @param details The details.
     * @param apiKey The API key.
     */
    validateEmailCode(details: SignUpEmailValidate, apiKey: string): Promise<SignUpEmailValidateResult> {
        let url_ = this.baseUrl + "/api/v1/Security/ValidateEmailCode/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processValidateEmailCode(_response);
        });
    }

    protected processValidateEmailCode(response: Response): Promise<SignUpEmailValidateResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignUpEmailValidateResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignUpEmailValidateResult>(null as any);
    }

    /**
     * Validates the sms code.
     * @param details The details.
     * @param apiKey The API key.
     */
    validateSMSCode(details: SignUpSMSValidate, apiKey: string): Promise<SignUpSMSValidateResult> {
        let url_ = this.baseUrl + "/api/v1/Security/ValidateSMSCode/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processValidateSMSCode(_response);
        });
    }

    protected processValidateSMSCode(response: Response): Promise<SignUpSMSValidateResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignUpSMSValidateResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignUpSMSValidateResult>(null as any);
    }

    /**
     * Signs up care provider.
     * @param details The details.
     * @param apiKey The API key.
     */
    signUpProvider(details: SignUpProvider, apiKey: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/SignUpProvider/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpProvider(_response);
        });
    }

    protected processSignUpProvider(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    providerRecruit(details: SignUpProvider2, apiKey: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/ProviderRecruit/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProviderRecruit(_response);
        });
    }

    protected processProviderRecruit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(details: UpdateProviderDto, apiKey: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/ProviderRecruit/update/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Signs up care provider.
     * @param details The details.
     */
    signUpProviderAdmin(details: SignUpProvider): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Security/SignUpProviderAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpProviderAdmin(_response);
        });
    }

    protected processSignUpProviderAdmin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Signs up patient.
     * @param details The details.
     * @param apiKey The API key.
     */
    signUpPatient(details: SignUpPatient, apiKey: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/SignUpPatient/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpPatient(_response);
        });
    }

    protected processSignUpPatient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Refresh the UserSignInResult
     */
    refreshToken(): Promise<UserSignInResult> {
        let url_ = this.baseUrl + "/api/v1/Security/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: Response): Promise<UserSignInResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSignInResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSignInResult>(null as any);
    }

    /**
     * Creates the patient identities.
     * @param createIdentitiesDetails The create identities details.
     */
    createPatientIdentities(createIdentitiesDetails: CreateIdentitiesDetails): Promise<CreateIdentitiesResult> {
        let url_ = this.baseUrl + "/api/v1/Security/CreatePatientIdentities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createIdentitiesDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreatePatientIdentities(_response);
        });
    }

    protected processCreatePatientIdentities(response: Response): Promise<CreateIdentitiesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateIdentitiesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateIdentitiesResult>(null as any);
    }

    /**
     * Creates the provider identities.
     * @param createIdentitiesDetails The create identities details.
     */
    createProviderIdentities(createIdentitiesDetails: CreateIdentitiesDetails): Promise<CreateIdentitiesResult> {
        let url_ = this.baseUrl + "/api/v1/Security/CreateProviderIdentities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createIdentitiesDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateProviderIdentities(_response);
        });
    }

    protected processCreateProviderIdentities(response: Response): Promise<CreateIdentitiesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateIdentitiesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateIdentitiesResult>(null as any);
    }

    /**
     * Authenticate Change Password
     * @param changePasswordDetails The change password details.
     */
    changePassword(changePasswordDetails: ChangePasswordDetails): Promise<ChangePasswordResult> {
        let url_ = this.baseUrl + "/api/v1/Security/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changePasswordDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<ChangePasswordResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangePasswordResult>(null as any);
    }

    /**
     * Administrator only Reset the password.
     * @param resetPasswordAdminDetails The reset password admin details.
     */
    adminResetPassword(resetPasswordAdminDetails: ResetPasswordAdminDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/AdminResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordAdminDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminResetPassword(_response);
        });
    }

    protected processAdminResetPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Administrator only Change Email
     * @param changeEmailAddressAdminDetails The change email address admin details.
     */
    adminChangeEmailAddress(changeEmailAddressAdminDetails: ChangeEmailAddressAdminDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/AdminChangeEmailAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeEmailAddressAdminDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminChangeEmailAddress(_response);
        });
    }

    protected processAdminChangeEmailAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Administrator only ExternalID
     */
    adminChangeExternalID(changeExternalIDAdminDetails: ChangeExternalIDAdminDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/AdminChangeExternalID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeExternalIDAdminDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminChangeExternalID(_response);
        });
    }

    protected processAdminChangeExternalID(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Assign a provider type to the provider
     * @param assignProviderTypeDetails The assign provider type details.
     */
    assignProviderType(assignProviderTypeDetails: AssignProviderTypeDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/AssignProviderType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignProviderTypeDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAssignProviderType(_response);
        });
    }

    protected processAssignProviderType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delegates the asynchronous.
     * @param userDetailID The user detail identifier.
     */
    delegate(userDetailID: string): Promise<UserSignInResult> {
        let url_ = this.baseUrl + "/api/v1/Security/Delegate/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDelegate(_response);
        });
    }

    protected processDelegate(response: Response): Promise<UserSignInResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSignInResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSignInResult>(null as any);
    }

    /**
     * Tasks the list delegate asynchronous.
     * @param userDetailID The user detail identifier.
     * @param host (optional) 
     */
    taskListDelegate(userDetailID: string, host?: string | null | undefined): Promise<UserSignInResult> {
        let url_ = this.baseUrl + "/api/v1/Security/TaskListDelegate/{userDetailID}?";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (host !== undefined && host !== null)
            url_ += "host=" + encodeURIComponent("" + host) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskListDelegate(_response);
        });
    }

    protected processTaskListDelegate(response: Response): Promise<UserSignInResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSignInResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSignInResult>(null as any);
    }

    /**
     * Check to see if the user has set a wallet pin
     * @return true if [has wallet pin asynchronous]; otherwise, false.
     */
    hasWalletPIN(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Security/HasWalletPIN";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processHasWalletPIN(_response);
        });
    }

    protected processHasWalletPIN(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Updates the users wallet pin
     * @param details The details.
     */
    walletPIN(details: ChangeWalletPINDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/WalletPIN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletPIN(_response);
        });
    }

    protected processWalletPIN(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the WebViewID
     */
    webViewID(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Security/WebViewID";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWebViewID(_response);
        });
    }

    protected processWebViewID(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the WebView Detail
     */
    userDetailWebView(userDetailWebViewID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Security/UserDetailWebView/{userDetailWebViewID}";
        if (userDetailWebViewID === undefined || userDetailWebViewID === null)
            throw new Error("The parameter 'userDetailWebViewID' must be defined.");
        url_ = url_.replace("{userDetailWebViewID}", encodeURIComponent("" + userDetailWebViewID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailWebView(_response);
        });
    }

    protected processUserDetailWebView(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update the user Detail (admin)
     */
    userDetailAdmin(userDetail: UserDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Security/UserDetailAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailAdmin(_response);
        });
    }

    protected processUserDetailAdmin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Send a one time password
     */
    sendOneTimePassword(details: OneTimePasswordDetails): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Security/SendOneTimePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendOneTimePassword(_response);
        });
    }

    protected processSendOneTimePassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Validates the email code.
     * @param details The details.
     */
    validateOneTimePassword(details: OneTimePasswordValidate): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Security/ValidateOneTimePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processValidateOneTimePassword(_response);
        });
    }

    protected processValidateOneTimePassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get the Sign In Phone Number
     */
    signInPhoneNumberGet(userDetailID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Security/{userDetailID}/SignInPhoneNumber";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignInPhoneNumberGet(_response);
        });
    }

    protected processSignInPhoneNumberGet(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Put the Sign In Phone Number - use a phone number of "-" to remove it
     */
    signInPhoneNumberPut(userDetailID: string, phoneNumber: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Security/{userDetailID}/SignInPhoneNumber/{phoneNumber}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignInPhoneNumberPut(_response);
        });
    }

    protected processSignInPhoneNumberPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SessionClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Create session data
     */
    sessionPost(session: Session): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(session);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSessionPost(_response);
        });
    }

    protected processSessionPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the session by sessionid
     * @param sessionID (optional) 
     */
    sessionGet(sessionID?: string | undefined): Promise<Session> {
        let url_ = this.baseUrl + "/api/v1/Session?";
        if (sessionID === null)
            throw new Error("The parameter 'sessionID' cannot be null.");
        else if (sessionID !== undefined)
            url_ += "sessionID=" + encodeURIComponent("" + sessionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSessionGet(_response);
        });
    }

    protected processSessionGet(response: Response): Promise<Session> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Session.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Session>(null as any);
    }
}

export class ShoppingCartsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all current.
     * @param userDetailID The user detail identifier.
     */
    all(userDetailID: string): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/api/v1/ShoppingCarts/Current/All/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    /**
     * Get the invoice that is of type ShoppingCart the current owner.
     */
    current(shoppingCartDetails: ShoppingCartDetails): Promise<Invoice> {
        let url_ = this.baseUrl + "/api/v1/ShoppingCarts/Current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shoppingCartDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCurrent(_response);
        });
    }

    protected processCurrent(response: Response): Promise<Invoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Invoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice>(null as any);
    }

    /**
     * Get the invoice that is of type ShoppingCart the current owner.
     */
    pending(shoppingCartDetails: ShoppingCartDetails): Promise<Invoice> {
        let url_ = this.baseUrl + "/api/v1/ShoppingCarts/Pending";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shoppingCartDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPending(_response);
        });
    }

    protected processPending(response: Response): Promise<Invoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Invoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice>(null as any);
    }

    /**
     * Gets the shopping cart item count.
     */
    itemCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/ShoppingCarts/ItemCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processItemCount(_response);
        });
    }

    protected processItemCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SignUpDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param signUpDetailID The identifier.
     * @param apiKey The API key.
     */
    signUpDetailsGet(signUpDetailID: string, apiKey: string): Promise<SignUpDetail> {
        let url_ = this.baseUrl + "/api/v1/SignUpDetails/{signUpDetailID}/{apiKey}";
        if (signUpDetailID === undefined || signUpDetailID === null)
            throw new Error("The parameter 'signUpDetailID' must be defined.");
        url_ = url_.replace("{signUpDetailID}", encodeURIComponent("" + signUpDetailID));
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpDetailsGet(_response);
        });
    }

    protected processSignUpDetailsGet(response: Response): Promise<SignUpDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignUpDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignUpDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param apiKey The API key.
     */
    signUpDetailsDelete(signUpDetailID: string, apiKey: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SignUpDetails/{signUpDetailID}/{apiKey}";
        if (signUpDetailID === undefined || signUpDetailID === null)
            throw new Error("The parameter 'signUpDetailID' must be defined.");
        url_ = url_.replace("{signUpDetailID}", encodeURIComponent("" + signUpDetailID));
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpDetailsDelete(_response);
        });
    }

    protected processSignUpDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified sign up detail.
     * @param signUpDetail The sign up detail.
     * @param apiKey The API key.
     */
    signUpDetailsPost(signUpDetail: SignUpDetail, apiKey: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SignUpDetails/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signUpDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpDetailsPost(_response);
        });
    }

    protected processSignUpDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified sign up detail.
     * @param signUpDetail The sign up detail.
     * @param apiKey The API key.
     */
    signUpDetailsPut(signUpDetail: SignUpDetail, apiKey: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SignUpDetails/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signUpDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpDetailsPut(_response);
        });
    }

    protected processSignUpDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SMSsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the sm ss read to send.
     */
    readyToSend(): Promise<SMS[]> {
        let url_ = this.baseUrl + "/api/v1/SMSs/ReadyToSend";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReadyToSend(_response);
        });
    }

    protected processReadyToSend(response: Response): Promise<SMS[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMS.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SMS[]>(null as any);
    }

    /**
     * Gets the by user detail identifier.
     * @param userDetailID The user detail identifier.
     */
    byUserDetailID(userDetailID: string): Promise<SMS[]> {
        let url_ = this.baseUrl + "/api/v1/SMSs/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<SMS[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMS.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SMS[]>(null as any);
    }

    /**
     * Sends the SMS.
     * @param smsID The SMS identifier.
     */
    sendMessage(smsID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SMSs/SendMessage/{smsID}";
        if (smsID === undefined || smsID === null)
            throw new Error("The parameter 'smsID' must be defined.");
        url_ = url_.replace("{smsID}", encodeURIComponent("" + smsID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sends the SMS now.
     * @param sms The SMS.
     */
    sendMessageNow(sms: SMS): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SMSs/SendMessageNow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sms);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSendMessageNow(_response);
        });
    }

    protected processSendMessageNow(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param smsID The SMS identifier.
     */
    sMSsGet(smsID: string): Promise<SMS> {
        let url_ = this.baseUrl + "/api/v1/SMSs/{smsID}";
        if (smsID === undefined || smsID === null)
            throw new Error("The parameter 'smsID' must be defined.");
        url_ = url_.replace("{smsID}", encodeURIComponent("" + smsID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSMSsGet(_response);
        });
    }

    protected processSMSsGet(response: Response): Promise<SMS> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SMS.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SMS>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param smsID The SMS identifier.
     */
    sMSsDelete(smsID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SMSs/{smsID}";
        if (smsID === undefined || smsID === null)
            throw new Error("The parameter 'smsID' must be defined.");
        url_ = url_.replace("{smsID}", encodeURIComponent("" + smsID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSMSsDelete(_response);
        });
    }

    protected processSMSsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Receives the SMS.
     * @param messageSid (optional) 
     * @param smsSid (optional) 
     * @param body (optional) 
     * @param messageStatus (optional) 
     * @param optOutType (optional) 
     * @param messagingServiceSid (optional) 
     * @param numMedia (optional) 
     * @param referralNumMedia (optional) 
     * @param accountSid (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param fromCity (optional) 
     * @param fromState (optional) 
     * @param fromZip (optional) 
     * @param fromCountry (optional) 
     * @param toCity (optional) 
     * @param toState (optional) 
     * @param toZip (optional) 
     * @param toCountry (optional) 
     */
    receiveOnCall(messageSid?: string | null | undefined, smsSid?: string | null | undefined, body?: string | null | undefined, messageStatus?: string | null | undefined, optOutType?: string | null | undefined, messagingServiceSid?: string | null | undefined, numMedia?: number | undefined, referralNumMedia?: number | undefined, accountSid?: string | null | undefined, from?: string | null | undefined, to?: string | null | undefined, fromCity?: string | null | undefined, fromState?: string | null | undefined, fromZip?: string | null | undefined, fromCountry?: string | null | undefined, toCity?: string | null | undefined, toState?: string | null | undefined, toZip?: string | null | undefined, toCountry?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/SMSs/ReceiveOnCall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (messageSid !== null && messageSid !== undefined)
            content_.append("MessageSid", messageSid.toString());
        if (smsSid !== null && smsSid !== undefined)
            content_.append("SmsSid", smsSid.toString());
        if (body !== null && body !== undefined)
            content_.append("Body", body.toString());
        if (messageStatus !== null && messageStatus !== undefined)
            content_.append("MessageStatus", messageStatus.toString());
        if (optOutType !== null && optOutType !== undefined)
            content_.append("OptOutType", optOutType.toString());
        if (messagingServiceSid !== null && messagingServiceSid !== undefined)
            content_.append("MessagingServiceSid", messagingServiceSid.toString());
        if (numMedia === null || numMedia === undefined)
            throw new Error("The parameter 'numMedia' cannot be null.");
        else
            content_.append("NumMedia", numMedia.toString());
        if (referralNumMedia === null || referralNumMedia === undefined)
            throw new Error("The parameter 'referralNumMedia' cannot be null.");
        else
            content_.append("ReferralNumMedia", referralNumMedia.toString());
        if (accountSid !== null && accountSid !== undefined)
            content_.append("AccountSid", accountSid.toString());
        if (from !== null && from !== undefined)
            content_.append("From", from.toString());
        if (to !== null && to !== undefined)
            content_.append("To", to.toString());
        if (fromCity !== null && fromCity !== undefined)
            content_.append("FromCity", fromCity.toString());
        if (fromState !== null && fromState !== undefined)
            content_.append("FromState", fromState.toString());
        if (fromZip !== null && fromZip !== undefined)
            content_.append("FromZip", fromZip.toString());
        if (fromCountry !== null && fromCountry !== undefined)
            content_.append("FromCountry", fromCountry.toString());
        if (toCity !== null && toCity !== undefined)
            content_.append("ToCity", toCity.toString());
        if (toState !== null && toState !== undefined)
            content_.append("ToState", toState.toString());
        if (toZip !== null && toZip !== undefined)
            content_.append("ToZip", toZip.toString());
        if (toCountry !== null && toCountry !== undefined)
            content_.append("ToCountry", toCountry.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReceiveOnCall(_response);
        });
    }

    protected processReceiveOnCall(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Posts the specified email token.
     * @param sMS The email token.
     */
    sMSsPost(sMS: SMS): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SMSs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sMS);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSMSsPost(_response);
        });
    }

    protected processSMSsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified email token.
     * @param sMS The email token.
     */
    sMSsPut(sMS: SMS): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SMSs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sMS);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSMSsPut(_response);
        });
    }

    protected processSMSsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Search the SMS's
     */
    search(sMSSearchDetails: SMSSearchDetails): Promise<SMS[]> {
        let url_ = this.baseUrl + "/api/v1/SMSs/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sMSSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SMS[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SMS.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SMS[]>(null as any);
    }
}

export class StatementsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all Statements - ADMIN
     */
    admin(): Promise<Statement[]> {
        let url_ = this.baseUrl + "/api/v1/Statements/Admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Statement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Statement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Statement[]>(null as any);
    }

    /**
     * Gets all Statements by statement - ADMIN
     */
    adminByStatementID(statementID: string): Promise<Statement[]> {
        let url_ = this.baseUrl + "/api/v1/Statements/AdminByStatementID/{statementID}";
        if (statementID === undefined || statementID === null)
            throw new Error("The parameter 'statementID' must be defined.");
        url_ = url_.replace("{statementID}", encodeURIComponent("" + statementID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByStatementID(_response);
        });
    }

    protected processAdminByStatementID(response: Response): Promise<Statement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Statement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Statement[]>(null as any);
    }

    /**
     * Gets The Statement.
     */
    statements(statementID: string): Promise<Statement> {
        let url_ = this.baseUrl + "/api/v1/Statements/{statementID}";
        if (statementID === undefined || statementID === null)
            throw new Error("The parameter 'statementID' must be defined.");
        url_ = url_.replace("{StatementID}", encodeURIComponent("" + statementID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStatements(_response);
        });
    }

    protected processStatements(response: Response): Promise<Statement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Statement.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Statement>(null as any);
    }

    /**
     * Gets the statementDTO by StatementID
     */
    byStatementID(statementID: string): Promise<StatementDTO> {
        let url_ = this.baseUrl + "/api/v1/Statements/ByStatementID/{statementID}";
        if (statementID === undefined || statementID === null)
            throw new Error("The parameter 'statementID' must be defined.");
        url_ = url_.replace("{statementID}", encodeURIComponent("" + statementID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStatementID(_response);
        });
    }

    protected processByStatementID(response: Response): Promise<StatementDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatementDTO>(null as any);
    }

    /**
     * Get Statements - Populate ProviderID, or StoreID, or OrganizationID and Start and End Date for statement dates
     */
    search(statementDetails: StatementSearchDetails): Promise<Statement[]> {
        let url_ = this.baseUrl + "/api/v1/Statements/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statementDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Statement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Statement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Statement[]>(null as any);
    }

    /**
     * Get Statements - Populate ProviderID, or StoreID, or OrganizationID
     */
    allByID(statementsAllByIDDetails: StatementsAllByIDDetails): Promise<Statement[]> {
        let url_ = this.baseUrl + "/api/v1/Statements/AllByID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statementsAllByIDDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllByID(_response);
        });
    }

    protected processAllByID(response: Response): Promise<Statement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Statement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Statement[]>(null as any);
    }

    /**
     * Calculates the current statement but does not generate it (persist it)
    Populate ProviderID, or StoreID, or OrganizationID
     */
    currentStatement(statementDetails: StatementGenerateDetails): Promise<StatementDTO> {
        let url_ = this.baseUrl + "/api/v1/Statements/CurrentStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statementDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCurrentStatement(_response);
        });
    }

    protected processCurrentStatement(response: Response): Promise<StatementDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatementDTO>(null as any);
    }

    /**
     * Generate a new statement
    Populate ProviderID, or StoreID, or OrganizationID
     */
    generateStatement(statementDetails: StatementGenerateDetails): Promise<StatementDTO> {
        let url_ = this.baseUrl + "/api/v1/Statements/GenerateStatement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statementDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGenerateStatement(_response);
        });
    }

    protected processGenerateStatement(response: Response): Promise<StatementDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatementDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatementDTO>(null as any);
    }

    /**
     * Downloads the specified document identifier.
     * @param statementID The Statement identifier.
     * @param regenerateStatement (optional) 
     */
    downloadStatement(statementID: string, regenerateStatement?: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Statements/downloadStatement/{statementID}?";
        if (statementID === undefined || statementID === null)
            throw new Error("The parameter 'statementID' must be defined.");
        url_ = url_.replace("{statementID}", encodeURIComponent("" + statementID));
        if (regenerateStatement === null)
            throw new Error("The parameter 'regenerateStatement' cannot be null.");
        else if (regenerateStatement !== undefined)
            url_ += "regenerateStatement=" + encodeURIComponent("" + regenerateStatement) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadStatement(_response);
        });
    }

    protected processDownloadStatement(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Downloads the specified Statement File Detail
     * @param statementID The Statement identifier.
     * @param regenerateStatement (optional) 
     */
    statementFileDetail(statementID: string, regenerateStatement?: boolean | undefined): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/Statements/statementFileDetail/{statementID}?";
        if (statementID === undefined || statementID === null)
            throw new Error("The parameter 'statementID' must be defined.");
        url_ = url_.replace("{statementID}", encodeURIComponent("" + statementID));
        if (regenerateStatement === null)
            throw new Error("The parameter 'regenerateStatement' cannot be null.");
        else if (regenerateStatement !== undefined)
            url_ += "regenerateStatement=" + encodeURIComponent("" + regenerateStatement) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStatementFileDetail(_response);
        });
    }

    protected processStatementFileDetail(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }
}

export class StoreAppointmentsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Search for a store's available appointments
     * @param storeAppointmentSearchDetails The store appointment search details.
     */
    search(storeAppointmentSearchDetails: StoreAppointmentSearchDetails): Promise<StoreAppointmentSearchResults> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeAppointmentSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<StoreAppointmentSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreAppointmentSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreAppointmentSearchResults>(null as any);
    }

    /**
     * Book an appointment
     * @param bookStoreAppointmentDetails The book store appointment details.
     */
    bookStoreAppointment(bookStoreAppointmentDetails: BookStoreAppointmentDetails): Promise<BookStoreAppointmentResults> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/BookStoreAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookStoreAppointmentDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBookStoreAppointment(_response);
        });
    }

    protected processBookStoreAppointment(response: Response): Promise<BookStoreAppointmentResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookStoreAppointmentResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookStoreAppointmentResults>(null as any);
    }

    /**
     * Return Appointments when queried by the Patient's UserDetailID
     * @param details The details.
     */
    patientAppointmentsSearch(details: AppointmentSearchDetails): Promise<PatientAppointmentSearchResults> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/PatientAppointmentsSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientAppointmentsSearch(_response);
        });
    }

    protected processPatientAppointmentsSearch(response: Response): Promise<PatientAppointmentSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAppointmentSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientAppointmentSearchResults>(null as any);
    }

    /**
     * Return Appointments when queried by the Patient's UserDetailID
     * @param details The details.
     */
    patientAppointmentsCalendarDTO(details: AppointmentSearchDetails): Promise<PatientAppointmentSearchDTOResults> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/PatientAppointmentsCalendarDTO";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientAppointmentsCalendarDTO(_response);
        });
    }

    protected processPatientAppointmentsCalendarDTO(response: Response): Promise<PatientAppointmentSearchDTOResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientAppointmentSearchDTOResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientAppointmentSearchDTOResults>(null as any);
    }

    /**
     * Return Appointments when queried by the Store's UserDetailID
     * @param details The details.
     */
    storeAppointmentsSearch(details: AppointmentSearchDetails): Promise<AppointmentSearchResults> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/StoreAppointmentsSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreAppointmentsSearch(_response);
        });
    }

    protected processStoreAppointmentsSearch(response: Response): Promise<AppointmentSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppointmentSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentSearchResults>(null as any);
    }

    /**
     * Gets the Store Appointment by qr code.
     * @param qrCode The qr code.
     */
    byQRCode(qrCode: number): Promise<StoreAppointment> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/ByQRCode/{qrCode}";
        if (qrCode === undefined || qrCode === null)
            throw new Error("The parameter 'qrCode' must be defined.");
        url_ = url_.replace("{qrCode}", encodeURIComponent("" + qrCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByQRCode(_response);
        });
    }

    protected processByQRCode(response: Response): Promise<StoreAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreAppointment>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param storeAppointmentID The identifier.
     */
    storeAppointmentsGet(storeAppointmentID: string): Promise<StoreAppointment> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/{storeAppointmentID}";
        if (storeAppointmentID === undefined || storeAppointmentID === null)
            throw new Error("The parameter 'storeAppointmentID' must be defined.");
        url_ = url_.replace("{storeAppointmentID}", encodeURIComponent("" + storeAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreAppointmentsGet(_response);
        });
    }

    protected processStoreAppointmentsGet(response: Response): Promise<StoreAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreAppointment>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeAppointmentID The identifier.
     */
    storeAppointmentsDelete(storeAppointmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/{storeAppointmentID}";
        if (storeAppointmentID === undefined || storeAppointmentID === null)
            throw new Error("The parameter 'storeAppointmentID' must be defined.");
        url_ = url_.replace("{storeAppointmentID}", encodeURIComponent("" + storeAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreAppointmentsDelete(_response);
        });
    }

    protected processStoreAppointmentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified StoreAppointment.
     * @param storeAppointment The StoreAppointment.
     */
    storeAppointmentsPost(storeAppointment: StoreAppointment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeAppointment);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreAppointmentsPost(_response);
        });
    }

    protected processStoreAppointmentsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified StoreAppointment.
     * @param storeAppointment The StoreAppointment.
     */
    storeAppointmentsPut(storeAppointment: StoreAppointment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeAppointment);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreAppointmentsPut(_response);
        });
    }

    protected processStoreAppointmentsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Releases the reservation.
     * @param storeAppointmentID The store appointment identifier.
     */
    releaseStoreAppointment(storeAppointmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/{storeAppointmentID}/ReleaseStoreAppointment";
        if (storeAppointmentID === undefined || storeAppointmentID === null)
            throw new Error("The parameter 'storeAppointmentID' must be defined.");
        url_ = url_.replace("{storeAppointmentID}", encodeURIComponent("" + storeAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReleaseStoreAppointment(_response);
        });
    }

    protected processReleaseStoreAppointment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reserves the store appointment.
     * @param storeAppointmentID The store appointment identifier.
     */
    reserveStoreAppointment(storeAppointmentID: string): Promise<StoreAppointment> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/{storeAppointmentID}/ReserveStoreAppointment";
        if (storeAppointmentID === undefined || storeAppointmentID === null)
            throw new Error("The parameter 'storeAppointmentID' must be defined.");
        url_ = url_.replace("{storeAppointmentID}", encodeURIComponent("" + storeAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReserveStoreAppointment(_response);
        });
    }

    protected processReserveStoreAppointment(response: Response): Promise<StoreAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreAppointment>(null as any);
    }

    /**
     * Gets the next available appointment.
     * @param nextAvailableAppointmentDetails The next available appointment details.
     */
    nextAvailableAppointment(nextAvailableAppointmentDetails: NextAvailableAppointmentDetails): Promise<StoreAppointment> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/NextAvailableAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nextAvailableAppointmentDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processNextAvailableAppointment(_response);
        });
    }

    protected processNextAvailableAppointment(response: Response): Promise<StoreAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreAppointment>(null as any);
    }

    /**
     * Reserves the store appointment.
     * @param storeAppointmentID The store appointment identifier.
     */
    reserveStoreAppointmentByStore(storeAppointmentID: string): Promise<StoreAppointment> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/ReserveStoreAppointmentByStore/{storeAppointmentID}";
        if (storeAppointmentID === undefined || storeAppointmentID === null)
            throw new Error("The parameter 'storeAppointmentID' must be defined.");
        url_ = url_.replace("{storeAppointmentID}", encodeURIComponent("" + storeAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReserveStoreAppointmentByStore(_response);
        });
    }

    protected processReserveStoreAppointmentByStore(response: Response): Promise<StoreAppointment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreAppointment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreAppointment>(null as any);
    }

    /**
     * Releases the reservation.
     * @param storeAppointmentID The store appointment identifier.
     */
    releaseStoreAppointmentByStore(storeAppointmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreAppointments/ReleaseStoreAppointmentByStore/{storeAppointmentID}";
        if (storeAppointmentID === undefined || storeAppointmentID === null)
            throw new Error("The parameter 'storeAppointmentID' must be defined.");
        url_ = url_.replace("{storeAppointmentID}", encodeURIComponent("" + storeAppointmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReleaseStoreAppointmentByStore(_response);
        });
    }

    protected processReleaseStoreAppointmentByStore(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StoreImagesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<StoreImage[]> {
        let url_ = this.baseUrl + "/api/v1/StoreImages/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<StoreImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreImage[]>(null as any);
    }

    /**
     * Get the images for the StoreID
     */
    byStoreID(storeID: string): Promise<StoreImage[]> {
        let url_ = this.baseUrl + "/api/v1/StoreImages/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<StoreImage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreImage[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param storeImageID The identifier.
     */
    storeImagesGet(storeImageID: string): Promise<StoreImage> {
        let url_ = this.baseUrl + "/api/v1/StoreImages/{storeImageID}";
        if (storeImageID === undefined || storeImageID === null)
            throw new Error("The parameter 'storeImageID' must be defined.");
        url_ = url_.replace("{storeImageID}", encodeURIComponent("" + storeImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreImagesGet(_response);
        });
    }

    protected processStoreImagesGet(response: Response): Promise<StoreImage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreImage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreImage>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeImageID The identifier.
     */
    storeImagesDelete(storeImageID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreImages/{storeImageID}";
        if (storeImageID === undefined || storeImageID === null)
            throw new Error("The parameter 'storeImageID' must be defined.");
        url_ = url_.replace("{storeImageID}", encodeURIComponent("" + storeImageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreImagesDelete(_response);
        });
    }

    protected processStoreImagesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified StoreImage.
     * @param storeImage The StoreImage.
     */
    storeImagesPost(storeImage: StoreImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreImagesPost(_response);
        });
    }

    protected processStoreImagesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified StoreImage.
     */
    storeImagesPut(storeImage: StoreImage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeImage);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreImagesPut(_response);
        });
    }

    protected processStoreImagesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param storeImages The StoreImages.
     */
    many(storeImages: StoreImage[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/StoreImages/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeImages);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class StoreItemFormsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<StoreItemForm[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItemForms/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<StoreItemForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItemForm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemForm[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param storeItemFormID The identifier.
     */
    storeItemFormsGet(storeItemFormID: string): Promise<StoreItemForm> {
        let url_ = this.baseUrl + "/api/v1/StoreItemForms/{StoreItemFormID}";
        if (storeItemFormID === undefined || storeItemFormID === null)
            throw new Error("The parameter 'storeItemFormID' must be defined.");
        url_ = url_.replace("{StoreItemFormID}", encodeURIComponent("" + storeItemFormID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemFormsGet(_response);
        });
    }

    protected processStoreItemFormsGet(response: Response): Promise<StoreItemForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreItemForm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemForm>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeItemFormID The identifier.
     */
    storeItemFormsDelete(storeItemFormID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreItemForms/{StoreItemFormID}";
        if (storeItemFormID === undefined || storeItemFormID === null)
            throw new Error("The parameter 'storeItemFormID' must be defined.");
        url_ = url_.replace("{StoreItemFormID}", encodeURIComponent("" + storeItemFormID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemFormsDelete(_response);
        });
    }

    protected processStoreItemFormsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by store identifier.
     * @param storeID The store identifier.
     */
    byStoreID(storeID: string): Promise<StoreItemForm[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItemForms/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<StoreItemForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItemForm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemForm[]>(null as any);
    }

    /**
     * Gets the by store item identifier.
     * @param storeItemID The store item identifier.
     */
    byStoreItemID(storeItemID: string): Promise<StoreItemForm[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItemForms/ByStoreItemID/{storeItemID}";
        if (storeItemID === undefined || storeItemID === null)
            throw new Error("The parameter 'storeItemID' must be defined.");
        url_ = url_.replace("{storeItemID}", encodeURIComponent("" + storeItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreItemID(_response);
        });
    }

    protected processByStoreItemID(response: Response): Promise<StoreItemForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItemForm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemForm[]>(null as any);
    }

    /**
     * Posts the specified StoreForm.
     * @param storeForm The StoreForm.
     */
    storeItemFormsPost(storeForm: StoreItemForm): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreItemForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeForm);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemFormsPost(_response);
        });
    }

    protected processStoreItemFormsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified StoreForm.
     * @param storeItemForm The StoreForm.
     */
    storeItemFormsPut(storeItemForm: StoreItemForm): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreItemForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItemForm);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemFormsPut(_response);
        });
    }

    protected processStoreItemFormsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class StoreItemsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param storeItemID The identifier.
     */
    storeItemsGet(storeItemID: string): Promise<StoreItem> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/{storeItemID}";
        if (storeItemID === undefined || storeItemID === null)
            throw new Error("The parameter 'storeItemID' must be defined.");
        url_ = url_.replace("{storeItemID}", encodeURIComponent("" + storeItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemsGet(_response);
        });
    }

    protected processStoreItemsGet(response: Response): Promise<StoreItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItem>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeItemID The identifier.
     */
    storeItemsDelete(storeItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/{storeItemID}";
        if (storeItemID === undefined || storeItemID === null)
            throw new Error("The parameter 'storeItemID' must be defined.");
        url_ = url_.replace("{storeItemID}", encodeURIComponent("" + storeItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemsDelete(_response);
        });
    }

    protected processStoreItemsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all by store identifier.
     * @param storeID The store identifier.
     */
    sessionCheckedInByStoreID(storeID: string): Promise<StoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/SessionCheckedInByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSessionCheckedInByStoreID(_response);
        });
    }

    protected processSessionCheckedInByStoreID(response: Response): Promise<StoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItem[]>(null as any);
    }

    /**
     * Get all store identifier.
     * @param storeID The store identifier.
     */
    availableAppointmentStoreItemsByStoreID(storeID: string): Promise<StoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/AvailableAppointmentStoreItemsByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableAppointmentStoreItemsByStoreID(_response);
        });
    }

    protected processAvailableAppointmentStoreItemsByStoreID(response: Response): Promise<StoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItem[]>(null as any);
    }

    /**
     * Gets the store items by Store ID Sorted by Item Name
     * @param storeID The store identifier.
     */
    byStoreID(storeID: string): Promise<StoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<StoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItem[]>(null as any);
    }

    /**
     * Get Store Items from store that match storeItemTypeEnum
     */
    byStoreItemTypeEnum(storeID: string, storeItemTypeEnum: StoreItemTypeEnum): Promise<StoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/ByStoreItemTypeEnum/{storeID}/{storeItemTypeEnum}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        if (storeItemTypeEnum === undefined || storeItemTypeEnum === null)
            throw new Error("The parameter 'storeItemTypeEnum' must be defined.");
        url_ = url_.replace("{storeItemTypeEnum}", encodeURIComponent("" + storeItemTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreItemTypeEnum(_response);
        });
    }

    protected processByStoreItemTypeEnum(response: Response): Promise<StoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItem[]>(null as any);
    }

    /**
     * Gets the store items by Store ID Sorted by Item Name
     * @param storeID The store identifier.
     */
    adminByStoreID(storeID: string): Promise<StoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/AdminByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByStoreID(_response);
        });
    }

    protected processAdminByStoreID(response: Response): Promise<StoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItem[]>(null as any);
    }

    /**
     * Posts the specified StoreItem.
     * @param storeItem The StoreItem.
     */
    storeItemsPost(storeItem: StoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemsPost(_response);
        });
    }

    protected processStoreItemsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified StoreItem.
     * @param storeItem The StoreItem.
     */
    storeItemsPut(storeItem: StoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemsPut(_response);
        });
    }

    protected processStoreItemsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified StoreItem.
     * @param storeItems The store items.
     */
    many(storeItems: StoreItem[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItems);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Updates multipe items
     * @param storeItems The store items.
     */
    upsert(storeItems: StoreItem[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItems);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Posts the xref.
     * @param storeItemXref The store item xref.
     */
    storeItemXrefPost(storeItemXref: StoreItemXref): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/StoreItemXref";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItemXref);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemXrefPost(_response);
        });
    }

    protected processStoreItemXrefPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified StoreItem
     * @param storeItemXref The store item xref.
     */
    storeItemXrefPut(storeItemXref: StoreItemXref): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/StoreItemXref";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItemXref);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemXrefPut(_response);
        });
    }

    protected processStoreItemXrefPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeItemXrefID The store item xref identifier.
     */
    storeItemXrefDelete(storeItemXrefID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/StoreItemXref/{storeItemXrefID}";
        if (storeItemXrefID === undefined || storeItemXrefID === null)
            throw new Error("The parameter 'storeItemXrefID' must be defined.");
        url_ = url_.replace("{storeItemXrefID}", encodeURIComponent("" + storeItemXrefID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemXrefDelete(_response);
        });
    }

    protected processStoreItemXrefDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search for Store Items
     */
    search(storeItemSearchDetails: StoreItemSearchDetails): Promise<PagedResultOfStoreItem> {
        let url_ = this.baseUrl + "/api/v1/StoreItems/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItemSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfStoreItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfStoreItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfStoreItem>(null as any);
    }
}

export class StoreItemTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<StoreItemTag[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItemTags/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<StoreItemTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItemTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemTag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param storeItemTagID The identifier.
     */
    storeItemTagsGet(storeItemTagID: string): Promise<StoreItemTag> {
        let url_ = this.baseUrl + "/api/v1/StoreItemTags/{StoreItemTagID}";
        if (storeItemTagID === undefined || storeItemTagID === null)
            throw new Error("The parameter 'storeItemTagID' must be defined.");
        url_ = url_.replace("{StoreItemTagID}", encodeURIComponent("" + storeItemTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemTagsGet(_response);
        });
    }

    protected processStoreItemTagsGet(response: Response): Promise<StoreItemTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreItemTag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemTag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeItemTagID The identifier.
     */
    storeItemTagsDelete(storeItemTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreItemTags/{StoreItemTagID}";
        if (storeItemTagID === undefined || storeItemTagID === null)
            throw new Error("The parameter 'storeItemTagID' must be defined.");
        url_ = url_.replace("{StoreItemTagID}", encodeURIComponent("" + storeItemTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemTagsDelete(_response);
        });
    }

    protected processStoreItemTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by store identifier.
     * @param storeID The store identifier.
     */
    byStoreID(storeID: string): Promise<StoreItemTag[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItemTags/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<StoreItemTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItemTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemTag[]>(null as any);
    }

    /**
     * Gets the by store item identifier.
     * @param storeItemID The store item identifier.
     */
    byStoreItemID(storeItemID: string): Promise<StoreItemTag[]> {
        let url_ = this.baseUrl + "/api/v1/StoreItemTags/ByStoreItemID/{storeItemID}";
        if (storeItemID === undefined || storeItemID === null)
            throw new Error("The parameter 'storeItemID' must be defined.");
        url_ = url_.replace("{storeItemID}", encodeURIComponent("" + storeItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreItemID(_response);
        });
    }

    protected processByStoreItemID(response: Response): Promise<StoreItemTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreItemTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreItemTag[]>(null as any);
    }

    /**
     * Posts the specified StoreTag.
     * @param storeTag The StoreTag.
     */
    storeItemTagsPost(storeTag: StoreItemTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreItemTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemTagsPost(_response);
        });
    }

    protected processStoreItemTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified StoreTag.
     * @param storeItemTag The StoreTag.
     */
    storeItemTagsPut(storeItemTag: StoreItemTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreItemTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeItemTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreItemTagsPut(_response);
        });
    }

    protected processStoreItemTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class StoreRoomsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all StoreRooms - ADMIN
     */
    adminByStoreID(storeID: string): Promise<StoreRoom[]> {
        let url_ = this.baseUrl + "/api/v1/StoreRooms/AdminByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminByStoreID(_response);
        });
    }

    protected processAdminByStoreID(response: Response): Promise<StoreRoom[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreRoom.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreRoom[]>(null as any);
    }

    /**
     * Gets all StoreRooms.
     */
    byStoreID(storeID: string): Promise<StoreRoom[]> {
        let url_ = this.baseUrl + "/api/v1/StoreRooms/ByStoreID/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByStoreID(_response);
        });
    }

    protected processByStoreID(response: Response): Promise<StoreRoom[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreRoom.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreRoom[]>(null as any);
    }

    /**
     * Gets The StoreRoom.
     */
    storeRoomsGet(storeRoomID: string): Promise<StoreRoom> {
        let url_ = this.baseUrl + "/api/v1/StoreRooms/{storeRoomID}";
        if (storeRoomID === undefined || storeRoomID === null)
            throw new Error("The parameter 'storeRoomID' must be defined.");
        url_ = url_.replace("{storeRoomID}", encodeURIComponent("" + storeRoomID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreRoomsGet(_response);
        });
    }

    protected processStoreRoomsGet(response: Response): Promise<StoreRoom> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreRoom.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreRoom>(null as any);
    }

    /**
     * Posts the specified StoreRoom.
     * @param storeRoom The StoreRoom.
     */
    storeRoomsPost(storeRoom: StoreRoom): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreRooms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeRoom);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreRoomsPost(_response);
        });
    }

    protected processStoreRoomsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified StoreRoom.
     * @param storeRoom The StoreRoom.
     */
    storeRoomsPut(storeRoom: StoreRoom): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/StoreRooms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeRoom);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreRoomsPut(_response);
        });
    }

    protected processStoreRoomsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeRoomID The identifier.
     */
    storeRoomsDelete(storeRoomID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreRooms/{StoreRoomID}";
        if (storeRoomID === undefined || storeRoomID === null)
            throw new Error("The parameter 'storeRoomID' must be defined.");
        url_ = url_.replace("{StoreRoomID}", encodeURIComponent("" + storeRoomID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreRoomsDelete(_response);
        });
    }

    protected processStoreRoomsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StoreSchedulesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    search(storeScheduleSearchDetails: StoreScheduleSearchDetails): Promise<StoreSchedule[]> {
        let url_ = this.baseUrl + "/api/v1/StoreSchedules/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeScheduleSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<StoreSchedule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreSchedule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreSchedule[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param storeScheduleID The identifier.
     */
    storeSchedulesGet(storeScheduleID: string): Promise<StoreSchedule> {
        let url_ = this.baseUrl + "/api/v1/StoreSchedules/{storeScheduleID}";
        if (storeScheduleID === undefined || storeScheduleID === null)
            throw new Error("The parameter 'storeScheduleID' must be defined.");
        url_ = url_.replace("{storeScheduleID}", encodeURIComponent("" + storeScheduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreSchedulesGet(_response);
        });
    }

    protected processStoreSchedulesGet(response: Response): Promise<StoreSchedule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreSchedule.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreSchedule>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeScheduleID The identifier.
     */
    storeSchedulesDelete(storeScheduleID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/StoreSchedules/{storeScheduleID}";
        if (storeScheduleID === undefined || storeScheduleID === null)
            throw new Error("The parameter 'storeScheduleID' must be defined.");
        url_ = url_.replace("{storeScheduleID}", encodeURIComponent("" + storeScheduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreSchedulesDelete(_response);
        });
    }

    protected processStoreSchedulesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified StoreSchedule.
     * @param storeSchedule The StoreSchedule.
     */
    storeSchedulesPost(storeSchedule: StoreSchedule): Promise<CreateStoreScheduleResult> {
        let url_ = this.baseUrl + "/api/v1/StoreSchedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeSchedule);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreSchedulesPost(_response);
        });
    }

    protected processStoreSchedulesPost(response: Response): Promise<CreateStoreScheduleResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateStoreScheduleResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateStoreScheduleResult>(null as any);
    }

    /**
     * Deletes the specified identifier recurring.
     * @param storeScheduleID The identifier.
     */
    storeSchedulesDeleteRecurring(storeScheduleID: string): Promise<StoreScheduleDeleteRecurringResults> {
        let url_ = this.baseUrl + "/api/v1/StoreSchedules/{storeScheduleID}/StoreSchedulesDeleteRecurring";
        if (storeScheduleID === undefined || storeScheduleID === null)
            throw new Error("The parameter 'storeScheduleID' must be defined.");
        url_ = url_.replace("{storeScheduleID}", encodeURIComponent("" + storeScheduleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreSchedulesDeleteRecurring(_response);
        });
    }

    protected processStoreSchedulesDeleteRecurring(response: Response): Promise<StoreScheduleDeleteRecurringResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreScheduleDeleteRecurringResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoreScheduleDeleteRecurringResults>(null as any);
    }
}

export class StoresClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all enabled Stores
     */
    all(): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Gets all the Stores
     */
    admin(): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Get stores that have available appointments by countryID
     * @param countryID The country identifier.
     */
    availableAppointmentStoresByCountryID(countryID: string): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/AvailableAppointmentStoresByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableAppointmentStoresByCountryID(_response);
        });
    }

    protected processAvailableAppointmentStoresByCountryID(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Get stores that have available appointments by OrganizationID
     * @param organizationID The organization identifier.
     */
    availableAppointmentStoresByOrganizationID(organizationID: string): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/AvailableAppointmentStoresByOrganizationID/{organizationID}";
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableAppointmentStoresByOrganizationID(_response);
        });
    }

    protected processAvailableAppointmentStoresByOrganizationID(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Gets the available providers by country identifier.
     * @param countryID The country identifier.
     */
    availableProvidersByCountryID(countryID: string): Promise<Provider[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/AvailableProvidersByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableProvidersByCountryID(_response);
        });
    }

    protected processAvailableProvidersByCountryID(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    /**
     * Gets the available providers by organization identifier.
     * @param organizationID (optional) The organization identifier.
     */
    availableProvidersByOrganizationID(countryID: string, organizationID?: string | undefined): Promise<Provider[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/AvailableProvidersByOrganizationID/{countryID}?";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        if (organizationID === null)
            throw new Error("The parameter 'organizationID' cannot be null.");
        else if (organizationID !== undefined)
            url_ += "organizationID=" + encodeURIComponent("" + organizationID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableProvidersByOrganizationID(_response);
        });
    }

    protected processAvailableProvidersByOrganizationID(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    /**
     * Get all stores for the country and include the availablity Enum
     * @param countryID The country identifier.
     * @param tagID (optional) The tag identifier.
     * @param providerID (optional) The provider identifier.
     */
    storeAvailabilityByCountryID(countryID: string, tagID?: string | null | undefined, providerID?: string | null | undefined): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/StoreAvailabilityByCountryID/{countryID}?";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        if (tagID !== undefined && tagID !== null)
            url_ += "tagID=" + encodeURIComponent("" + tagID) + "&";
        if (providerID !== undefined && providerID !== null)
            url_ += "providerID=" + encodeURIComponent("" + providerID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreAvailabilityByCountryID(_response);
        });
    }

    protected processStoreAvailabilityByCountryID(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Get all stores for the organization and include the availablity Enum
     * @param organizationID The organization identifier.
     * @param tagID (optional) The tag identifier.
     * @param providerID (optional) The provider identifier.
     */
    storeAvailabilityByOrganizationID(organizationID: string, tagID?: string | null | undefined, providerID?: string | null | undefined): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/StoreAvailabilityByOrganizationID/{organizationID}?";
        if (organizationID === undefined || organizationID === null)
            throw new Error("The parameter 'organizationID' must be defined.");
        url_ = url_.replace("{organizationID}", encodeURIComponent("" + organizationID));
        if (tagID !== undefined && tagID !== null)
            url_ += "tagID=" + encodeURIComponent("" + tagID) + "&";
        if (providerID !== undefined && providerID !== null)
            url_ += "providerID=" + encodeURIComponent("" + providerID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoreAvailabilityByOrganizationID(_response);
        });
    }

    protected processStoreAvailabilityByOrganizationID(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Searches the store availability.
     * @param storeAvailabilityDetails The store availability details.
     */
    searchStoreAvailability(storeAvailabilityDetails: SearchStoreAvailabilityDetails): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/SearchStoreAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeAvailabilityDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearchStoreAvailability(_response);
        });
    }

    protected processSearchStoreAvailability(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Searches the stores.
     * @param searchStoreDetails The search store details.
     */
    search(searchStoreDetails: SearchStoreDetails): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchStoreDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Gets the Stores by provider is associated with identifier.
     * @param providerID The provider identifier.
     */
    byProviderID(providerID: string): Promise<Store[]> {
        let url_ = this.baseUrl + "/api/v1/Stores/ByProviderID/{providerID}";
        if (providerID === undefined || providerID === null)
            throw new Error("The parameter 'providerID' must be defined.");
        url_ = url_.replace("{providerID}", encodeURIComponent("" + providerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProviderID(_response);
        });
    }

    protected processByProviderID(response: Response): Promise<Store[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Store.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param storeID The identifier.
     */
    storesGet(storeID: string): Promise<Store> {
        let url_ = this.baseUrl + "/api/v1/Stores/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoresGet(_response);
        });
    }

    protected processStoresGet(response: Response): Promise<Store> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Store.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param storeID The identifier.
     */
    storesDelete(storeID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Stores/{storeID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoresDelete(_response);
        });
    }

    protected processStoresDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Store.
     * @param store The Store.
     */
    storesPost(store: Store): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Stores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(store);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoresPost(_response);
        });
    }

    protected processStoresPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Store.
     * @param store The Store.
     */
    storesPut(store: Store): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Stores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(store);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processStoresPut(_response);
        });
    }

    protected processStoresPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the wallet store by country identifier.
     * @param countryID The country identifier.
     */
    walletStoreByCountryID(countryID: string): Promise<Store> {
        let url_ = this.baseUrl + "/api/v1/Stores/WalletStoreByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletStoreByCountryID(_response);
        });
    }

    protected processWalletStoreByCountryID(response: Response): Promise<Store> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Store.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store>(null as any);
    }

    /**
     * Gets the subscription store by country identifier.
     * @param countryID The country identifier.
     */
    subscriptionStoreByCountryID(countryID: string): Promise<Store> {
        let url_ = this.baseUrl + "/api/v1/Stores/SubscriptionStoreByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionStoreByCountryID(_response);
        });
    }

    protected processSubscriptionStoreByCountryID(response: Response): Promise<Store> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Store.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store>(null as any);
    }

    /**
     * Converts the time zones.
     */
    convertTimeZones(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Stores/ConvertTimeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConvertTimeZones(_response);
        });
    }

    protected processConvertTimeZones(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * PublicTag Availability Check
     */
    adminIsPublicTagAvailable(storeID: string, publicTag: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/Stores/AdminIsPublicTagAvailable/{storeID}/{publicTag}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        if (publicTag === undefined || publicTag === null)
            throw new Error("The parameter 'publicTag' must be defined.");
        url_ = url_.replace("{publicTag}", encodeURIComponent("" + publicTag));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminIsPublicTagAvailable(_response);
        });
    }

    protected processAdminIsPublicTagAvailable(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get the Store's profile image
     */
    profileImage(storeID: string, imageDetailID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Stores/{storeID}/ProfileImage/{imageDetailID}";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        if (imageDetailID === undefined || imageDetailID === null)
            throw new Error("The parameter 'imageDetailID' must be defined.");
        url_ = url_.replace("{imageDetailID}", encodeURIComponent("" + imageDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProfileImage(_response);
        });
    }

    protected processProfileImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Return the default store for that storetype in the country
     */
    countryDefault(countryDefaultStoreDetails: CountryDefaultStoreDetails): Promise<Store> {
        let url_ = this.baseUrl + "/api/v1/Stores/CountryDefault";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(countryDefaultStoreDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCountryDefault(_response);
        });
    }

    protected processCountryDefault(response: Response): Promise<Store> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Store.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Store>(null as any);
    }

    /**
     * Returns the store's addressbook entry
     */
    addressbook(storeID: string): Promise<AddressBook> {
        let url_ = this.baseUrl + "/api/v1/Stores/{storeID}/Addressbook";
        if (storeID === undefined || storeID === null)
            throw new Error("The parameter 'storeID' must be defined.");
        url_ = url_.replace("{storeID}", encodeURIComponent("" + storeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddressbook(_response);
        });
    }

    protected processAddressbook(response: Response): Promise<AddressBook> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressBook.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressBook>(null as any);
    }
}

export class SubscriptionInvoicesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param subscriptionInvoiceID The identifier.
     */
    subscriptionInvoices(subscriptionInvoiceID: string): Promise<SubscriptionInvoice> {
        let url_ = this.baseUrl + "/api/v1/SubscriptionInvoices/{subscriptionInvoiceID}";
        if (subscriptionInvoiceID === undefined || subscriptionInvoiceID === null)
            throw new Error("The parameter 'subscriptionInvoiceID' must be defined.");
        url_ = url_.replace("{subscriptionInvoiceID}", encodeURIComponent("" + subscriptionInvoiceID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionInvoices(_response);
        });
    }

    protected processSubscriptionInvoices(response: Response): Promise<SubscriptionInvoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionInvoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionInvoice>(null as any);
    }

    /**
     * Gets the Invoice Subscriptions by SubscriptionID
     */
    bySubscriptionID(subscriptionID: string): Promise<SubscriptionInvoice[]> {
        let url_ = this.baseUrl + "/api/v1/SubscriptionInvoices/BySubscriptionID/{subscriptionID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBySubscriptionID(_response);
        });
    }

    protected processBySubscriptionID(response: Response): Promise<SubscriptionInvoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionInvoice[]>(null as any);
    }

    /**
     * Gets the Invoice Subscriptions by UserDetailID
     */
    byUserDetailID(userDetailID: string): Promise<SubscriptionInvoice[]> {
        let url_ = this.baseUrl + "/api/v1/SubscriptionInvoices/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<SubscriptionInvoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionInvoice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionInvoice[]>(null as any);
    }
}

export class SubscriptionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Subscription[]> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Subscription[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Subscription.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subscription[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param subscriptionID The identifier.
     */
    subscriptionsGet(subscriptionID: string): Promise<Subscription> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{subscriptionID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionsGet(_response);
        });
    }

    protected processSubscriptionsGet(response: Response): Promise<Subscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Subscription.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subscription>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param subscriptionID The identifier.
     */
    subscriptionsDelete(subscriptionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{subscriptionID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionsDelete(_response);
        });
    }

    protected processSubscriptionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param subscriptionID The identifier.
     */
    admin(subscriptionID: string): Promise<Subscription> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/Admin/{subscriptionID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Subscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Subscription.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Subscription>(null as any);
    }

    /**
     * Get all of the available subscriptions roles
     */
    allSubscriptionRightsAvailable(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/AllSubscriptionRightsAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllSubscriptionRightsAvailable(_response);
        });
    }

    protected processAllSubscriptionRightsAvailable(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * add user to a subscription using the SubscriptionUserID and SubscriptionPIN
     * @param subscriptionAddUserDetails The subscription add user details.
     */
    addUserToSubscription(subscriptionAddUserDetails: SubscriptionAddUserDetails): Promise<SubscriptionAddUserResults> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/AddUserToSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionAddUserDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddUserToSubscription(_response);
        });
    }

    protected processAddUserToSubscription(response: Response): Promise<SubscriptionAddUserResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionAddUserResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionAddUserResults>(null as any);
    }

    /**
     * Remove User from Subscription
     */
    removeUserFromSubscription(subscriptionID: string, userDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/RemoveUserFromSubscription/{subscriptionID}/{userDetailID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRemoveUserFromSubscription(_response);
        });
    }

    protected processRemoveUserFromSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Subscription.
     * @param subscription The Subscription.
     */
    subscriptionsPost(subscription: Subscription): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionsPost(_response);
        });
    }

    protected processSubscriptionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Subscription.
     * @param subscription The Subscription.
     */
    subscriptionsPut(subscription: Subscription): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionsPut(_response);
        });
    }

    protected processSubscriptionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Creates the Subscription Invoice
     */
    createInvoice(createSubscriptionInvoiceDetails: CreateSubscriptionInvoiceDetails): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createSubscriptionInvoiceDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateInvoice(_response);
        });
    }

    protected processCreateInvoice(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Commits the subscription
     * @param subscriptionCommitDetails The subscription commit details.
     */
    commit(subscriptionCommitDetails: SubscriptionCommitDetails): Promise<SubscriptionCommitResults> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/Commit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionCommitDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCommit(_response);
        });
    }

    protected processCommit(response: Response): Promise<SubscriptionCommitResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionCommitResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionCommitResults>(null as any);
    }

    /**
     * Gets the subscription user details asynchronous.
     * @param subscriptionID The subscription identifier.
     */
    subscriptionUserDetails(subscriptionID: string): Promise<SubscriptionUserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{subscriptionID}/SubscriptionUserDetails";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionUserDetails(_response);
        });
    }

    protected processSubscriptionUserDetails(response: Response): Promise<SubscriptionUserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionUserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionUserDetail[]>(null as any);
    }

    /**
     * Gets the subscription user detail store items asynchronous.
     * @param subscriptionID The subscription identifier.
     * @param userDetailID The user detail identifier.
     */
    subscriptionUserDetailStoreItems(subscriptionID: string, userDetailID: string): Promise<SubscriptionUserDetailStoreItem[]> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{subscriptionID}/{userDetailID}/SubscriptionUserDetailStoreItems";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionUserDetailStoreItems(_response);
        });
    }

    protected processSubscriptionUserDetailStoreItems(response: Response): Promise<SubscriptionUserDetailStoreItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionUserDetailStoreItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionUserDetailStoreItem[]>(null as any);
    }

    /**
     * Updates the subscription user detail store item.
     * @param subscriptionUserDetailStoreItem The subscription user detail store item.
     */
    subscriptionUserDetailStoreItem(subscriptionUserDetailStoreItem: SubscriptionUserDetailStoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/SubscriptionUserDetailStoreItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionUserDetailStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionUserDetailStoreItem(_response);
        });
    }

    protected processSubscriptionUserDetailStoreItem(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified Subscription.
     * @param subscriptionID The subscription identifier.
     * @param numberOfUserIDs The number of user i ds.
     */
    addSubscriptionUserIDs(subscriptionID: string, numberOfUserIDs: number): Promise<CreateIdentitiesResult> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/AddSubscriptionUserIDs/{subscriptionID}/{numberOfUserIDs}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        if (numberOfUserIDs === undefined || numberOfUserIDs === null)
            throw new Error("The parameter 'numberOfUserIDs' must be defined.");
        url_ = url_.replace("{numberOfUserIDs}", encodeURIComponent("" + numberOfUserIDs));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAddSubscriptionUserIDs(_response);
        });
    }

    protected processAddSubscriptionUserIDs(response: Response): Promise<CreateIdentitiesResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateIdentitiesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateIdentitiesResult>(null as any);
    }

    /**
     * Sets the subscription onboarded.
     * @param subscriptionID The subscription identifier.
     */
    subscriptionOnboarded(subscriptionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/SubscriptionOnboarded/{subscriptionID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionOnboarded(_response);
        });
    }

    protected processSubscriptionOnboarded(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the Available subscriptions to purchase
     */
    availableByCountry(availableSubscriptionDetails: AvailableSubscriptionDetails): Promise<PagedResultOfSubscription> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/AvailableByCountry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(availableSubscriptionDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableByCountry(_response);
        });
    }

    protected processAvailableByCountry(response: Response): Promise<PagedResultOfSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfSubscription.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfSubscription>(null as any);
    }

    /**
     * Get a list of subscriptions that the userDetailID is subscribed to
     */
    subscribedByUserDetail(subscribedSubscriptionDetails: SubscribedSubscriptionDetails): Promise<PagedResultOfSubscriptionUserDetail> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/SubscribedByUserDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscribedSubscriptionDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscribedByUserDetail(_response);
        });
    }

    protected processSubscribedByUserDetail(response: Response): Promise<PagedResultOfSubscriptionUserDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfSubscriptionUserDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfSubscriptionUserDetail>(null as any);
    }

    /**
     * Cancel a Subscription for a user
     */
    cancelSubscription(cancelSubscribedSubscriptionDetails: CancelSubscribedSubscriptionDetails): Promise<CancelSubscribedSubscriptionResult> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/CancelSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cancelSubscribedSubscriptionDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCancelSubscription(_response);
        });
    }

    protected processCancelSubscription(response: Response): Promise<CancelSubscribedSubscriptionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelSubscribedSubscriptionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancelSubscribedSubscriptionResult>(null as any);
    }

    /**
     * Return the list of events for the subscription and user
     */
    subscriptionEvents(subscriptionID: string, userDetailID: string): Promise<SubscriptionEventDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/SubscriptionEvents/{subscriptionID}/{userDetailID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{subscriptionID}", encodeURIComponent("" + subscriptionID));
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionEvents(_response);
        });
    }

    protected processSubscriptionEvents(response: Response): Promise<SubscriptionEventDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionEventDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionEventDTO[]>(null as any);
    }
}

export class SubscriptionStoreItemsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param subscriptionStoreItemID The identifier.
     */
    subscriptionStoreItemsGet(subscriptionStoreItemID: string): Promise<SubscriptionStoreItem> {
        let url_ = this.baseUrl + "/api/v1/SubscriptionStoreItems/{subscriptionStoreItemID}";
        if (subscriptionStoreItemID === undefined || subscriptionStoreItemID === null)
            throw new Error("The parameter 'subscriptionStoreItemID' must be defined.");
        url_ = url_.replace("{subscriptionStoreItemID}", encodeURIComponent("" + subscriptionStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionStoreItemsGet(_response);
        });
    }

    protected processSubscriptionStoreItemsGet(response: Response): Promise<SubscriptionStoreItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionStoreItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionStoreItem>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param subscriptionStoreItemID The identifier.
     */
    subscriptionStoreItemsDelete(subscriptionStoreItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SubscriptionStoreItems/{subscriptionStoreItemID}";
        if (subscriptionStoreItemID === undefined || subscriptionStoreItemID === null)
            throw new Error("The parameter 'subscriptionStoreItemID' must be defined.");
        url_ = url_.replace("{subscriptionStoreItemID}", encodeURIComponent("" + subscriptionStoreItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionStoreItemsDelete(_response);
        });
    }

    protected processSubscriptionStoreItemsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Subscription.
     */
    subscriptionStoreItemsPost(subscriptionStoreItem: SubscriptionStoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SubscriptionStoreItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionStoreItemsPost(_response);
        });
    }

    protected processSubscriptionStoreItemsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Subscription.
     */
    subscriptionStoreItemsPut(subscriptionStoreItem: SubscriptionStoreItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SubscriptionStoreItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptionStoreItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSubscriptionStoreItemsPut(_response);
        });
    }

    protected processSubscriptionStoreItemsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SupportClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Sends an email to the SupportEmailAddress with user supplied details.
     * @param supportRequestDetails The users support request details.
     * @return SupportRequestResult
     */
    supportRequest(supportRequestDetails: SupportRequestDetails): Promise<SupportRequestResult> {
        let url_ = this.baseUrl + "/api/v1/Support/SupportRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supportRequestDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSupportRequest(_response);
        });
    }

    protected processSupportRequest(response: Response): Promise<SupportRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupportRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportRequestResult>(null as any);
    }
}

export class SurveyDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<SurveyDetail[]> {
        let url_ = this.baseUrl + "/api/v1/SurveyDetails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<SurveyDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyDetail[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param surveyDetailID The identifier.
     */
    surveyDetailsGet(surveyDetailID: string): Promise<SurveyDetail> {
        let url_ = this.baseUrl + "/api/v1/SurveyDetails/{surveyDetailID}";
        if (surveyDetailID === undefined || surveyDetailID === null)
            throw new Error("The parameter 'surveyDetailID' must be defined.");
        url_ = url_.replace("{surveyDetailID}", encodeURIComponent("" + surveyDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurveyDetailsGet(_response);
        });
    }

    protected processSurveyDetailsGet(response: Response): Promise<SurveyDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param surveyDetailID The identifier.
     */
    surveyDetailsDelete(surveyDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SurveyDetails/{surveyDetailID}";
        if (surveyDetailID === undefined || surveyDetailID === null)
            throw new Error("The parameter 'surveyDetailID' must be defined.");
        url_ = url_.replace("{surveyDetailID}", encodeURIComponent("" + surveyDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurveyDetailsDelete(_response);
        });
    }

    protected processSurveyDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param surveyID The identifier.
     */
    survey(surveyID: string): Promise<SurveyDetail> {
        let url_ = this.baseUrl + "/api/v1/SurveyDetails/Survey/{surveyID}";
        if (surveyID === undefined || surveyID === null)
            throw new Error("The parameter 'surveyID' must be defined.");
        url_ = url_.replace("{surveyID}", encodeURIComponent("" + surveyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurvey(_response);
        });
    }

    protected processSurvey(response: Response): Promise<SurveyDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyDetail>(null as any);
    }

    /**
     * Posts the specified SurveyDetail.
     * @param surveyDetail The SurveyDetail.
     */
    surveyDetailsPost(surveyDetail: SurveyDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SurveyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurveyDetailsPost(_response);
        });
    }

    protected processSurveyDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified SurveyDetail.
     * @param surveyDetail The SurveyDetail.
     */
    surveyDetailsPut(surveyDetail: SurveyDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SurveyDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurveyDetailsPut(_response);
        });
    }

    protected processSurveyDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SurveysClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Survey[]> {
        let url_ = this.baseUrl + "/api/v1/Surveys/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Survey[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Survey.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Survey[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param surveyID The identifier.
     */
    surveysGet(surveyID: string): Promise<Survey> {
        let url_ = this.baseUrl + "/api/v1/Surveys/{surveyID}";
        if (surveyID === undefined || surveyID === null)
            throw new Error("The parameter 'surveyID' must be defined.");
        url_ = url_.replace("{surveyID}", encodeURIComponent("" + surveyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurveysGet(_response);
        });
    }

    protected processSurveysGet(response: Response): Promise<Survey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Survey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Survey>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param surveyID The identifier.
     */
    surveysDelete(surveyID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Surveys/{surveyID}";
        if (surveyID === undefined || surveyID === null)
            throw new Error("The parameter 'surveyID' must be defined.");
        url_ = url_.replace("{surveyID}", encodeURIComponent("" + surveyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurveysDelete(_response);
        });
    }

    protected processSurveysDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified survey.
     * @param survey The survey.
     */
    surveysPost(survey: Survey): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Surveys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(survey);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurveysPost(_response);
        });
    }

    protected processSurveysPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified survey.
     * @param survey The survey.
     */
    surveysPut(survey: Survey): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Surveys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(survey);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSurveysPut(_response);
        });
    }

    protected processSurveysPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SystemMessagesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<SystemMessage[]> {
        let url_ = this.baseUrl + "/api/v1/SystemMessages/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<SystemMessage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemMessage[]>(null as any);
    }

    /**
     * Gets the active System Messages
     */
    active(): Promise<SystemMessage[]> {
        let url_ = this.baseUrl + "/api/v1/SystemMessages/Active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processActive(_response);
        });
    }

    protected processActive(response: Response): Promise<SystemMessage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemMessage[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param systemMessageID The identifier.
     */
    systemMessagesGet(systemMessageID: string): Promise<SystemMessage> {
        let url_ = this.baseUrl + "/api/v1/SystemMessages/{systemMessageID}";
        if (systemMessageID === undefined || systemMessageID === null)
            throw new Error("The parameter 'systemMessageID' must be defined.");
        url_ = url_.replace("{systemMessageID}", encodeURIComponent("" + systemMessageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSystemMessagesGet(_response);
        });
    }

    protected processSystemMessagesGet(response: Response): Promise<SystemMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemMessage>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param systemMessageID The identifier.
     */
    systemMessagesDelete(systemMessageID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SystemMessages/{systemMessageID}";
        if (systemMessageID === undefined || systemMessageID === null)
            throw new Error("The parameter 'systemMessageID' must be defined.");
        url_ = url_.replace("{systemMessageID}", encodeURIComponent("" + systemMessageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSystemMessagesDelete(_response);
        });
    }

    protected processSystemMessagesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified system Message.
     * @param systemMessage The system Message.
     */
    systemMessagesPost(systemMessage: SystemMessage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SystemMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(systemMessage);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSystemMessagesPost(_response);
        });
    }

    protected processSystemMessagesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified system Message.
     * @param systemMessage The system Message.
     */
    systemMessagesPut(systemMessage: SystemMessage): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SystemMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(systemMessage);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSystemMessagesPut(_response);
        });
    }

    protected processSystemMessagesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SystemSettingsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<SystemSetting[]> {
        let url_ = this.baseUrl + "/api/v1/SystemSettings/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<SystemSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemSetting[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param systemSettingID The identifier.
     */
    systemSettingsGet(systemSettingID: string): Promise<SystemSetting> {
        let url_ = this.baseUrl + "/api/v1/SystemSettings/{systemSettingID}";
        if (systemSettingID === undefined || systemSettingID === null)
            throw new Error("The parameter 'systemSettingID' must be defined.");
        url_ = url_.replace("{systemSettingID}", encodeURIComponent("" + systemSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSystemSettingsGet(_response);
        });
    }

    protected processSystemSettingsGet(response: Response): Promise<SystemSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemSetting>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param systemSettingID The identifier.
     */
    systemSettingsDelete(systemSettingID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/SystemSettings/{systemSettingID}";
        if (systemSettingID === undefined || systemSettingID === null)
            throw new Error("The parameter 'systemSettingID' must be defined.");
        url_ = url_.replace("{systemSettingID}", encodeURIComponent("" + systemSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSystemSettingsDelete(_response);
        });
    }

    protected processSystemSettingsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the Setting by Name
     */
    name(name: string): Promise<SystemSettingResult> {
        let url_ = this.baseUrl + "/api/v1/SystemSettings/name/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processName(_response);
        });
    }

    protected processName(response: Response): Promise<SystemSettingResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSettingResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemSettingResult>(null as any);
    }

    /**
     * Posts the specified system setting.
     * @param systemSetting The system setting.
     */
    systemSettingsPost(systemSetting: SystemSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SystemSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(systemSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSystemSettingsPost(_response);
        });
    }

    protected processSystemSettingsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified system setting.
     * @param systemSetting The system setting.
     */
    systemSettingsPut(systemSetting: SystemSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/SystemSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(systemSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSystemSettingsPut(_response);
        });
    }

    protected processSystemSettingsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/Tags/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Gets all the tags that match the type
     * @param tagTypeEnum The tag type enum.
     */
    allByTagType(tagTypeEnum: TagTypeEnum): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/Tags/AllByTagType/{tagTypeEnum}";
        if (tagTypeEnum === undefined || tagTypeEnum === null)
            throw new Error("The parameter 'tagTypeEnum' must be defined.");
        url_ = url_.replace("{tagTypeEnum}", encodeURIComponent("" + tagTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllByTagType(_response);
        });
    }

    protected processAllByTagType(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Search for tags
     */
    search(tagSearchDetails: TagSearchDetails): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/v1/Tags/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param tagID The identifier.
     */
    tagsGet(tagID: string): Promise<Tag> {
        let url_ = this.baseUrl + "/api/v1/Tags/{tagID}";
        if (tagID === undefined || tagID === null)
            throw new Error("The parameter 'tagID' must be defined.");
        url_ = url_.replace("{tagID}", encodeURIComponent("" + tagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagsGet(_response);
        });
    }

    protected processTagsGet(response: Response): Promise<Tag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Tag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param tagID The identifier.
     */
    tagsDelete(tagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Tags/{tagID}";
        if (tagID === undefined || tagID === null)
            throw new Error("The parameter 'tagID' must be defined.");
        url_ = url_.replace("{tagID}", encodeURIComponent("" + tagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagsDelete(_response);
        });
    }

    protected processTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the tag xrefs.
     * @param tagID The tag identifier.
     */
    tagXrefs(tagID: string): Promise<Tag> {
        let url_ = this.baseUrl + "/api/v1/Tags/{tagID}/TagXrefs";
        if (tagID === undefined || tagID === null)
            throw new Error("The parameter 'tagID' must be defined.");
        url_ = url_.replace("{tagID}", encodeURIComponent("" + tagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagXrefs(_response);
        });
    }

    protected processTagXrefs(response: Response): Promise<Tag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Tag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag>(null as any);
    }

    /**
     * Posts the specified Tag setting.
     * @param tag The Tag.
     */
    tagsPost(tag: Tag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagsPost(_response);
        });
    }

    protected processTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Tag
     * @param tag The Tag
     */
    tagsPut(tag: Tag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagsPut(_response);
        });
    }

    protected processTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the xref.
     * @param tagXref The tag xref.
     */
    tagXrefPost(tagXref: TagXref): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Tags/TagXref";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagXref);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagXrefPost(_response);
        });
    }

    protected processTagXrefPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Tag
     * @param tagXref The tag xref.
     */
    tagXrefPut(tagXref: TagXref): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Tags/TagXref";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagXref);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagXrefPut(_response);
        });
    }

    protected processTagXrefPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param tagXrefID The tag xref identifier.
     */
    tagXrefDelete(tagXrefID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Tags/TagXref/{tagXrefID}";
        if (tagXrefID === undefined || tagXrefID === null)
            throw new Error("The parameter 'tagXrefID' must be defined.");
        url_ = url_.replace("{tagXrefID}", encodeURIComponent("" + tagXrefID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagXrefDelete(_response);
        });
    }

    protected processTagXrefDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TaskItemsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all the TaskItems that match the type
     * @param userDetailID The user detail identifier.
     */
    byUserDetailID(userDetailID: string): Promise<TaskItem[]> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<TaskItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItem[]>(null as any);
    }

    /**
     * Searches the specified task item search details.
     * @param taskItemSearchDetails The task item search details.
     */
    search(taskItemSearchDetails: TaskItemSearchDetails): Promise<PagedResultOfTaskItem> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskItemSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfTaskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfTaskItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfTaskItem>(null as any);
    }

    /**
     * Gets the out of process ready tasks.
     */
    outOfProcessReady(): Promise<TaskItem[]> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/OutOfProcessReady";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOutOfProcessReady(_response);
        });
    }

    protected processOutOfProcessReady(response: Response): Promise<TaskItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItem[]>(null as any);
    }

    /**
     * Processes the task item.
     * @param taskItemID The task item identifier.
     */
    process(taskItemID: string): Promise<TaskItem> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/Process/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProcess(_response);
        });
    }

    protected processProcess(response: Response): Promise<TaskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItem>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param taskItemID The identifier.
     */
    taskItemsGet(taskItemID: string): Promise<TaskItem> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemsGet(_response);
        });
    }

    protected processTaskItemsGet(response: Response): Promise<TaskItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItem>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param taskItemID The identifier.
     */
    taskItemsDelete(taskItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemsDelete(_response);
        });
    }

    protected processTaskItemsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified TaskItem setting.
     * @param taskItem The TaskItem.
     */
    taskItemsPost(taskItem: TaskItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TaskItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemsPost(_response);
        });
    }

    protected processTaskItemsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified TaskItem
     * @param taskItem The TaskItem
     */
    taskItemsPut(taskItem: TaskItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TaskItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemsPut(_response);
        });
    }

    protected processTaskItemsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Mark the task item as finished Successfully
     */
    finished(taskItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/Finished/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processFinished(_response);
        });
    }

    protected processFinished(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark the task item as CompletedWaiting
     */
    completedWaiting(taskItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/CompletedWaiting/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCompletedWaiting(_response);
        });
    }

    protected processCompletedWaiting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark the task item as CompletedSuccessfully
     */
    completed(taskItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/Completed/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCompleted(_response);
        });
    }

    protected processCompleted(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark the task item as Ready
     */
    ready(taskItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/Ready/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReady(_response);
        });
    }

    protected processReady(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark the task item as Accepted
     */
    accepted(taskItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/Accepted/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAccepted(_response);
        });
    }

    protected processAccepted(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mark the task item as Processing
     */
    processing(taskItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/Processing/{taskItemID}";
        if (taskItemID === undefined || taskItemID === null)
            throw new Error("The parameter 'taskItemID' must be defined.");
        url_ = url_.replace("{taskItemID}", encodeURIComponent("" + taskItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProcessing(_response);
        });
    }

    protected processProcessing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the TaskItemAttachment including the file detail
     */
    download(taskItemAttachmentID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/TaskItemAttachment/{taskItemAttachmentID}/Download";
        if (taskItemAttachmentID === undefined || taskItemAttachmentID === null)
            throw new Error("The parameter 'taskItemAttachmentID' must be defined.");
        url_ = url_.replace("{taskItemAttachmentID}", encodeURIComponent("" + taskItemAttachmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the TaskItemAttachment including the file detail
     */
    taskItemAttachmentGet(taskItemAttachmentID: string): Promise<TaskItemAttachment> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/TaskItemAttachment/{taskItemAttachmentID}";
        if (taskItemAttachmentID === undefined || taskItemAttachmentID === null)
            throw new Error("The parameter 'taskItemAttachmentID' must be defined.");
        url_ = url_.replace("{taskItemAttachmentID}", encodeURIComponent("" + taskItemAttachmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemAttachmentGet(_response);
        });
    }

    protected processTaskItemAttachmentGet(response: Response): Promise<TaskItemAttachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemAttachment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemAttachment>(null as any);
    }

    /**
     * Delete a TaskItemAttachment
     */
    taskItemAttachmentDelete(taskItemAttachmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/TaskItemAttachment/{taskItemAttachmentID}";
        if (taskItemAttachmentID === undefined || taskItemAttachmentID === null)
            throw new Error("The parameter 'taskItemAttachmentID' must be defined.");
        url_ = url_.replace("{taskItemAttachmentID}", encodeURIComponent("" + taskItemAttachmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemAttachmentDelete(_response);
        });
    }

    protected processTaskItemAttachmentDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Insert a new TaskItemAttachment with FileDetails
     */
    taskItemAttachmentPost(taskItemAttachment: TaskItemAttachment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/TaskItemAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskItemAttachment);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemAttachmentPost(_response);
        });
    }

    protected processTaskItemAttachmentPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update TaskItemAttachement Details - not the file
     */
    taskItemAttachmentPut(taskItemAttachment: TaskItemAttachment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TaskItems/TaskItemAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskItemAttachment);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemAttachmentPut(_response);
        });
    }

    protected processTaskItemAttachmentPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TaskItemsTemplatesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all the TaskItems that match the type
     * @param taskItemTemplateTypeEnum The task item template type enum.
     */
    taskItemsTemplates(taskItemTemplateTypeEnum: TaskItemTemplateTypeEnum): Promise<TaskItemTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/TaskItemsTemplates/{taskItemTemplateTypeEnum}";
        if (taskItemTemplateTypeEnum === undefined || taskItemTemplateTypeEnum === null)
            throw new Error("The parameter 'taskItemTemplateTypeEnum' must be defined.");
        url_ = url_.replace("{taskItemTemplateTypeEnum}", encodeURIComponent("" + taskItemTemplateTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaskItemsTemplates(_response);
        });
    }

    protected processTaskItemsTemplates(response: Response): Promise<TaskItemTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskItemTemplate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemTemplate[]>(null as any);
    }
}

export class TaxDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<TaxDetail[]> {
        let url_ = this.baseUrl + "/api/v1/TaxDetails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<TaxDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxDetail[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param taxDetailID The identifier.
     */
    taxDetailsGet(taxDetailID: string): Promise<TaxDetail> {
        let url_ = this.baseUrl + "/api/v1/TaxDetails/{taxDetailID}";
        if (taxDetailID === undefined || taxDetailID === null)
            throw new Error("The parameter 'taxDetailID' must be defined.");
        url_ = url_.replace("{taxDetailID}", encodeURIComponent("" + taxDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaxDetailsGet(_response);
        });
    }

    protected processTaxDetailsGet(response: Response): Promise<TaxDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param taxDetailID The identifier.
     */
    taxDetailsDelete(taxDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TaxDetails/{taxDetailID}";
        if (taxDetailID === undefined || taxDetailID === null)
            throw new Error("The parameter 'taxDetailID' must be defined.");
        url_ = url_.replace("{taxDetailID}", encodeURIComponent("" + taxDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaxDetailsDelete(_response);
        });
    }

    protected processTaxDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified TaxDetail.
     * @param taxDetail The TaxDetail.
     */
    taxDetailsPost(taxDetail: TaxDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TaxDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taxDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaxDetailsPost(_response);
        });
    }

    protected processTaxDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified TaxDetail.
     * @param taxDetail The TaxDetail.
     */
    taxDetailsPut(taxDetail: TaxDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TaxDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taxDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaxDetailsPut(_response);
        });
    }

    protected processTaxDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TaxesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Tax[]> {
        let url_ = this.baseUrl + "/api/v1/Taxes/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Tax[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tax.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tax[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param taxID The identifier.
     */
    taxesGet(taxID: string): Promise<Tax> {
        let url_ = this.baseUrl + "/api/v1/Taxes/{taxID}";
        if (taxID === undefined || taxID === null)
            throw new Error("The parameter 'taxID' must be defined.");
        url_ = url_.replace("{taxID}", encodeURIComponent("" + taxID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaxesGet(_response);
        });
    }

    protected processTaxesGet(response: Response): Promise<Tax> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Tax.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tax>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param taxID The identifier.
     */
    taxesDelete(taxID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Taxes/{taxID}";
        if (taxID === undefined || taxID === null)
            throw new Error("The parameter 'taxID' must be defined.");
        url_ = url_.replace("{taxID}", encodeURIComponent("" + taxID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaxesDelete(_response);
        });
    }

    protected processTaxesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified tax.
     * @param tax The tax.
     */
    taxesPost(tax: Tax): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Taxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tax);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaxesPost(_response);
        });
    }

    protected processTaxesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified tax.
     * @param tax The tax.
     */
    taxesPut(tax: Tax): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Taxes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tax);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTaxesPut(_response);
        });
    }

    protected processTaxesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TenantNumbersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<TenantNumber[]> {
        let url_ = this.baseUrl + "/api/v1/TenantNumbers/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<TenantNumber[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantNumber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantNumber[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param tenantNumberID The identifier.
     */
    tenantNumbersGet(tenantNumberID: string): Promise<TenantNumber> {
        let url_ = this.baseUrl + "/api/v1/TenantNumbers/{TenantNumberID}";
        if (tenantNumberID === undefined || tenantNumberID === null)
            throw new Error("The parameter 'tenantNumberID' must be defined.");
        url_ = url_.replace("{TenantNumberID}", encodeURIComponent("" + tenantNumberID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTenantNumbersGet(_response);
        });
    }

    protected processTenantNumbersGet(response: Response): Promise<TenantNumber> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantNumber.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantNumber>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param tenantNumberID The identifier.
     */
    tenantNumbersDelete(tenantNumberID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TenantNumbers/{TenantNumberID}";
        if (tenantNumberID === undefined || tenantNumberID === null)
            throw new Error("The parameter 'tenantNumberID' must be defined.");
        url_ = url_.replace("{TenantNumberID}", encodeURIComponent("" + tenantNumberID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTenantNumbersDelete(_response);
        });
    }

    protected processTenantNumbersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified TenantNumber.
     * @param tenantNumber The TenantNumber.
     */
    tenantNumbersPost(tenantNumber: TenantNumber): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TenantNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantNumber);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTenantNumbersPost(_response);
        });
    }

    protected processTenantNumbersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified TenantNumber.
     * @param tenantNumber The TenantNumber.
     */
    tenantNumbersPut(tenantNumber: TenantNumber): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TenantNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantNumber);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTenantNumbersPut(_response);
        });
    }

    protected processTenantNumbersPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TenantsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Tenant[]> {
        let url_ = this.baseUrl + "/api/v1/Tenants/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Tenant[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tenant.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tenant[]>(null as any);
    }

    /**
     * Get the tenanant
     * @param tenantID The tenant identifier.
     */
    tenantsGet(tenantID: string): Promise<Tenant> {
        let url_ = this.baseUrl + "/api/v1/Tenants/{tenantID}";
        if (tenantID === undefined || tenantID === null)
            throw new Error("The parameter 'tenantID' must be defined.");
        url_ = url_.replace("{tenantID}", encodeURIComponent("" + tenantID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTenantsGet(_response);
        });
    }

    protected processTenantsGet(response: Response): Promise<Tenant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Tenant.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tenant>(null as any);
    }

    /**
     * Post a tenant
     * @param tenant The tenant.
     */
    tenantsPost(tenant: Tenant): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenant);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTenantsPost(_response);
        });
    }

    protected processTenantsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified tenant.
     * @param tenant The tenant.
     */
    tenantsPut(tenant: Tenant): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenant);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTenantsPut(_response);
        });
    }

    protected processTenantsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TestClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the hello.
     */
    hello(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Test/Hello";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processHello(_response);
        });
    }

    protected processHello(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the validation exception.
     */
    throwValidationException(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Test/ThrowValidationException";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThrowValidationException(_response);
        });
    }

    protected processThrowValidationException(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the database update exception.
     */
    throwDbUpdateException(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Test/ThrowDbUpdateException";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThrowDbUpdateException(_response);
        });
    }

    protected processThrowDbUpdateException(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the application exception.
     */
    throwApplicationException(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Test/ThrowApplicationException";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThrowApplicationException(_response);
        });
    }

    protected processThrowApplicationException(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the not found exception.
     */
    throwNotFoundException(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Test/ThrowNotFoundException";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThrowNotFoundException(_response);
        });
    }

    protected processThrowNotFoundException(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the unauthorized exception.
     */
    throwUnauthorizedException(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Test/ThrowUnauthorizedException";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThrowUnauthorizedException(_response);
        });
    }

    protected processThrowUnauthorizedException(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the security exception.
     */
    throwSecurityException(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Test/ThrowSecurityException";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processThrowSecurityException(_response);
        });
    }

    protected processThrowSecurityException(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the headers.
     */
    headers(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Test/Headers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processHeaders(_response);
        });
    }

    protected processHeaders(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class TestDatasClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<TestData[]> {
        let url_ = this.baseUrl + "/api/v1/TestDatas/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<TestData[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TestData.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestData[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param testDataID The identifier.
     */
    testDatas(testDataID: string): Promise<TestData> {
        let url_ = this.baseUrl + "/api/v1/TestDatas/{testDataID}";
        if (testDataID === undefined || testDataID === null)
            throw new Error("The parameter 'testDataID' must be defined.");
        url_ = url_.replace("{testDataID}", encodeURIComponent("" + testDataID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTestDatas(_response);
        });
    }

    protected processTestDatas(response: Response): Promise<TestData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestData.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestData>(null as any);
    }

    /**
     * Gets the test hello.
     */
    hello(): Promise<TestCommandEntity[]> {
        let url_ = this.baseUrl + "/api/v1/TestDatas/Hello";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processHello(_response);
        });
    }

    protected processHello(response: Response): Promise<TestCommandEntity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TestCommandEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestCommandEntity[]>(null as any);
    }
}

export class TimeZonesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    allWindows(): Promise<TimeZone[]> {
        let url_ = this.baseUrl + "/api/v1/TimeZones/allWindows";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllWindows(_response);
        });
    }

    protected processAllWindows(response: Response): Promise<TimeZone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeZone.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeZone[]>(null as any);
    }

    /**
     * Gets all iana Time Zones
     */
    all(): Promise<TimeZone[]> {
        let url_ = this.baseUrl + "/api/v1/TimeZones/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<TimeZone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeZone.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeZone[]>(null as any);
    }

    /**
     * Lookup a timezone based on IANA
     * @param details The details.
     */
    iANALookup(details: IANALookupDetails): Promise<TimeZone> {
        let url_ = this.baseUrl + "/api/v1/TimeZones/IANALookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processIANALookup(_response);
        });
    }

    protected processIANALookup(response: Response): Promise<TimeZone> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeZone.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeZone>(null as any);
    }

    /**
     * Posts the specified time zone country.
     * @param timeZoneCountry The time zone country.
     */
    timeZonesPost(timeZoneCountry: TimeZoneCountry): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TimeZones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeZoneCountry);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTimeZonesPost(_response);
        });
    }

    protected processTimeZonesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified time zone country.
     * @param timeZoneCountry The time zone country.
     */
    timeZonesPut(timeZoneCountry: TimeZoneCountry): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TimeZones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeZoneCountry);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTimeZonesPut(_response);
        });
    }

    protected processTimeZonesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified time zone country identifier.
     * @param timeZoneCountryID The time zone country identifier.
     */
    timeZonesDelete(timeZoneCountryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/TimeZones/{timeZoneCountryID}";
        if (timeZoneCountryID === undefined || timeZoneCountryID === null)
            throw new Error("The parameter 'timeZoneCountryID' must be defined.");
        url_ = url_.replace("{timeZoneCountryID}", encodeURIComponent("" + timeZoneCountryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTimeZonesDelete(_response);
        });
    }

    protected processTimeZonesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserDetailAffiliatesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get the user's Affiliates
     */
    byUserDetailID(userDetailID: string): Promise<UserDetailAffiliate[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetailAffiliates/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<UserDetailAffiliate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailAffiliate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailAffiliate[]>(null as any);
    }

    /**
     * Posts the specified UserDetailAffiliate.
     * @param userDetailAffiliate The UserDetailAffiliate.
     */
    userDetailAffiliatesPost(userDetailAffiliate: UserDetailAffiliate): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetailAffiliates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailAffiliate);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailAffiliatesPost(_response);
        });
    }

    protected processUserDetailAffiliatesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified UserDetailAffiliate.
     * @param userDetailAffiliate The UserDetailAffiliate.
     */
    userDetailAffiliatesPut(userDetailAffiliate: UserDetailAffiliate): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetailAffiliates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailAffiliate);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailAffiliatesPut(_response);
        });
    }

    protected processUserDetailAffiliatesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param userDetailAffiliateID The identifier.
     */
    userDetailAffiliatesDelete(userDetailAffiliateID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/UserDetailAffiliates/{userDetailAffiliateID}";
        if (userDetailAffiliateID === undefined || userDetailAffiliateID === null)
            throw new Error("The parameter 'userDetailAffiliateID' must be defined.");
        url_ = url_.replace("{userDetailAffiliateID}", encodeURIComponent("" + userDetailAffiliateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailAffiliatesDelete(_response);
        });
    }

    protected processUserDetailAffiliatesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get the Affiliates users
     */
    byAffiliateID(affiliateID: string): Promise<UserDetailAffiliate[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetailAffiliates/ByAffiliateID/{affiliateID}";
        if (affiliateID === undefined || affiliateID === null)
            throw new Error("The parameter 'affiliateID' must be defined.");
        url_ = url_.replace("{affiliateID}", encodeURIComponent("" + affiliateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByAffiliateID(_response);
        });
    }

    protected processByAffiliateID(response: Response): Promise<UserDetailAffiliate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailAffiliate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailAffiliate[]>(null as any);
    }
}

export class UserDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<UserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<UserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail[]>(null as any);
    }

    /**
     * Return all users with security roles populated (Expensive call)
     */
    allWithRoles(): Promise<UserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/AllWithRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllWithRoles(_response);
        });
    }

    protected processAllWithRoles(response: Response): Promise<UserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail[]>(null as any);
    }

    /**
     * Gets the current user's UserDetail.
     */
    currentUser(): Promise<UserDetail> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCurrentUser(_response);
        });
    }

    protected processCurrentUser(response: Response): Promise<UserDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail>(null as any);
    }

    /**
     * Gets the by role.
     * @param roleName Name of the role.
     */
    byRoleName(roleName: string): Promise<UserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/ByRoleName/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByRoleName(_response);
        });
    }

    protected processByRoleName(response: Response): Promise<UserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail[]>(null as any);
    }

    /**
     * Gets the users without the role.
     * @param role Name of the role.
     */
    allWithoutRole(role: string): Promise<UserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/AllWithoutRole/{role}";
        if (role === undefined || role === null)
            throw new Error("The parameter 'role' must be defined.");
        url_ = url_.replace("{role}", encodeURIComponent("" + role));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAllWithoutRole(_response);
        });
    }

    protected processAllWithoutRole(response: Response): Promise<UserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail[]>(null as any);
    }

    /**
     * Gets the with roles.
     * @param userDetailID The user detail identifier.
     */
    withRoles(userDetailID: string): Promise<UserDetail> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/WithRoles/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWithRoles(_response);
        });
    }

    protected processWithRoles(response: Response): Promise<UserDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail>(null as any);
    }

    /**
     * Get a list of all available to use Users in the system (May be large)
     */
    available(): Promise<UserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/Available";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailable(_response);
        });
    }

    protected processAvailable(response: Response): Promise<UserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail[]>(null as any);
    }

    /**
     * Searches the specified user detail search details.
     * @param userDetailSearchDetails The user detail search details.
     */
    search(userDetailSearchDetails: UserDetailSearchDetails): Promise<UserDetail[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<UserDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail[]>(null as any);
    }

    /**
     * Gets a UserDetail by UserDetailID
     * @param userDetailID The user detail identifier.
     */
    userDetailsGet(userDetailID: string): Promise<UserDetail> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailsGet(_response);
        });
    }

    protected processUserDetailsGet(response: Response): Promise<UserDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param userDetailID The identifier.
     */
    userDetailsDelete(userDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailsDelete(_response);
        });
    }

    protected processUserDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified user.
     * @param userDetail The user.
     */
    userDetailsPost(userDetail: UserDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailsPost(_response);
        });
    }

    protected processUserDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified user.
     * @param userDetail The user.
     */
    userDetailsPut(userDetail: UserDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailsPut(_response);
        });
    }

    protected processUserDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * UnDeletes the specified identifier.
     * @param userDetailID The identifier.
     */
    undelete(userDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/Undelete/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUndelete(_response);
        });
    }

    protected processUndelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the user detail settings.
     */
    userDetailSettingsGet(): Promise<UserDetailSetting[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailSettingsGet(_response);
        });
    }

    protected processUserDetailSettingsGet(response: Response): Promise<UserDetailSetting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailSetting.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailSetting[]>(null as any);
    }

    /**
     * Updates the user detailsettings.
     * @param userDetailSettings The user detail settings.
     */
    userDetailSettingsPut(userDetailSettings: UserDetailSetting[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailSettings);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailSettingsPut(_response);
        });
    }

    protected processUserDetailSettingsPut(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Gets the name of the user detail setting by.
     * @param userDetailSettingSearch The user detail setting search.
     */
    userDetailSettingSearch(userDetailSettingSearch: UserDetailSettingSearchDetails): Promise<UserDetailSetting> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailSettingSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailSettingSearch);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailSettingSearch(_response);
        });
    }

    protected processUserDetailSettingSearch(response: Response): Promise<UserDetailSetting> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailSetting.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailSetting>(null as any);
    }

    /**
     * Inserts the user detail settings.
     * @param userDetailSetting The user detail setting.
     */
    userDetailSettingPost(userDetailSetting: UserDetailSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailSettingPost(_response);
        });
    }

    protected processUserDetailSettingPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the user detailsettings.
     * @param userDetailSetting The user detail setting.
     */
    userDetailSettingPut(userDetailSetting: UserDetailSetting): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailSetting);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailSettingPut(_response);
        });
    }

    protected processUserDetailSettingPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the user bvn.
     * @param userDetailBvnDTO The user detail bvn details.
     */
    userDetailBVN(userDetailBvnDTO: UserDetailBvnDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailBVN";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailBvnDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailBVN(_response);
        });
    }

    protected processUserDetailBVN(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the user detail settings.
     * @param userDetailSettingID The user detail setting identifier.
     */
    userDetailSettingDelete(userDetailSettingID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailSetting/{userDetailSettingID}";
        if (userDetailSettingID === undefined || userDetailSettingID === null)
            throw new Error("The parameter 'userDetailSettingID' must be defined.");
        url_ = url_.replace("{userDetailSettingID}", encodeURIComponent("" + userDetailSettingID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailSettingDelete(_response);
        });
    }

    protected processUserDetailSettingDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified user detail relationship.
     * @param userDetailRelationship The user detail relationship.
     */
    userDetailRelationshipPost(userDetailRelationship: UserDetailRelationship): Promise<UserDetailRelationshipDetails> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailRelationship);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailRelationshipPost(_response);
        });
    }

    protected processUserDetailRelationshipPost(response: Response): Promise<UserDetailRelationshipDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailRelationshipDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailRelationshipDetails>(null as any);
    }

    /**
     * Updates the user detail relationship.
     * @param userDetailRelationship The user detail relationship.
     */
    userDetailRelationshipPut(userDetailRelationship: UserDetailRelationship): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailRelationship);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailRelationshipPut(_response);
        });
    }

    protected processUserDetailRelationshipPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified user detail relationship.
     * @param userDetailRelationship The user detail relationship.
     */
    adminUserDetailRelationship(userDetailRelationship: UserDetailRelationship): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/AdminUserDetailRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailRelationship);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminUserDetailRelationship(_response);
        });
    }

    protected processAdminUserDetailRelationship(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the user detail relationship.
     * @param userDetailRelationshipID The user detail relationship identifier.
     */
    userDetailRelationshipDelete(userDetailRelationshipID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailRelationship/{userDetailRelationshipID}";
        if (userDetailRelationshipID === undefined || userDetailRelationshipID === null)
            throw new Error("The parameter 'userDetailRelationshipID' must be defined.");
        url_ = url_.replace("{userDetailRelationshipID}", encodeURIComponent("" + userDetailRelationshipID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailRelationshipDelete(_response);
        });
    }

    protected processUserDetailRelationshipDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the user detail relationships.
     */
    userDetailRelationships(): Promise<UserDetailRelationship[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailRelationships";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailRelationships(_response);
        });
    }

    protected processUserDetailRelationships(response: Response): Promise<UserDetailRelationship[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailRelationship.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailRelationship[]>(null as any);
    }

    /**
     * Gets the user detail sponsors.
     */
    userDetailSponsors(): Promise<UserDetailRelationship[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailSponsors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailSponsors(_response);
        });
    }

    protected processUserDetailSponsors(response: Response): Promise<UserDetailRelationship[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailRelationship.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailRelationship[]>(null as any);
    }

    /**
     * Accepts the user detail relationship.
     * @param userDetailRelationshipDetails The user detail relationship details.
     */
    acceptUserDetailRelationship(userDetailRelationshipDetails: UserDetailRelationshipDetails): Promise<UserDetailRelationshipResult> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailRelationship/AcceptUserDetailRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailRelationshipDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAcceptUserDetailRelationship(_response);
        });
    }

    protected processAcceptUserDetailRelationship(response: Response): Promise<UserDetailRelationshipResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailRelationshipResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailRelationshipResult>(null as any);
    }

    /**
     * Declines the user detail relationship.
     * @param userDetailRelationshipDetails The user detail relationship details.
     */
    declineUserDetailRelationship(userDetailRelationshipDetails: UserDetailRelationshipDetails): Promise<UserDetailRelationshipResult> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailRelationship/DeclineUserDetailRelationship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailRelationshipDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDeclineUserDetailRelationship(_response);
        });
    }

    protected processDeclineUserDetailRelationship(response: Response): Promise<UserDetailRelationshipResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailRelationshipResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailRelationshipResult>(null as any);
    }

    /**
     * Gets the available user detail relationships.
     */
    availableUserDetailRelationships(): Promise<UserDetailRelationshipDTO[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UserDetailRelationship/AvailableUserDetailRelationships";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAvailableUserDetailRelationships(_response);
        });
    }

    protected processAvailableUserDetailRelationships(response: Response): Promise<UserDetailRelationshipDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailRelationshipDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailRelationshipDTO[]>(null as any);
    }

    /**
     * Updates the user detail relationship.
     * @param userDetailRelationship The user detail relationship.
     */
    updateUserDetailRelationshipHealthAccess(userDetailRelationship: UserDetailRelationshipDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/UpdateUserDetailRelationshipHealthAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailRelationship);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpdateUserDetailRelationshipHealthAccess(_response);
        });
    }

    protected processUpdateUserDetailRelationshipHealthAccess(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Signs up patient.
     * @param internalSignUpPatient The internal sign up patient.
     */
    signUpPatient(internalSignUpPatient: InternalSignUpPatient): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/SignUpPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(internalSignUpPatient);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSignUpPatient(_response);
        });
    }

    protected processSignUpPatient(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Convert Dependents
     */
    convertPatientDependants(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/UserDetails/ConvertPatientDependants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processConvertPatientDependants(_response);
        });
    }

    protected processConvertPatientDependants(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserDetailTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<UserDetailTag[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetailTags/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<UserDetailTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailTag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param userDetailTagID The identifier.
     */
    userDetailTagsGet(userDetailTagID: string): Promise<UserDetailTag> {
        let url_ = this.baseUrl + "/api/v1/UserDetailTags/{userDetailTagID}";
        if (userDetailTagID === undefined || userDetailTagID === null)
            throw new Error("The parameter 'userDetailTagID' must be defined.");
        url_ = url_.replace("{userDetailTagID}", encodeURIComponent("" + userDetailTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailTagsGet(_response);
        });
    }

    protected processUserDetailTagsGet(response: Response): Promise<UserDetailTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailTag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailTag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param userDetailTagID The identifier.
     */
    userDetailTagsDelete(userDetailTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/UserDetailTags/{userDetailTagID}";
        if (userDetailTagID === undefined || userDetailTagID === null)
            throw new Error("The parameter 'userDetailTagID' must be defined.");
        url_ = url_.replace("{userDetailTagID}", encodeURIComponent("" + userDetailTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailTagsDelete(_response);
        });
    }

    protected processUserDetailTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param userDetailID The identifier.
     */
    byUserDetailID(userDetailID: string): Promise<UserDetailTag[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetailTags/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<UserDetailTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailTag[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param userDetailID The identifier.
     * @param tagTypeEnum The identifier.
     */
    tagType(userDetailID: string, tagTypeEnum: TagTypeEnum): Promise<UserDetailTag[]> {
        let url_ = this.baseUrl + "/api/v1/UserDetailTags/ByUserDetailID/{userDetailID}/TagType/{tagTypeEnum}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (tagTypeEnum === undefined || tagTypeEnum === null)
            throw new Error("The parameter 'tagTypeEnum' must be defined.");
        url_ = url_.replace("{tagTypeEnum}", encodeURIComponent("" + tagTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTagType(_response);
        });
    }

    protected processTagType(response: Response): Promise<UserDetailTag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailTag.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDetailTag[]>(null as any);
    }

    /**
     * Posts the specified UserDetailTag.
     * @param userDetailTag The UserDetailTag.
     */
    userDetailTagsPost(userDetailTag: UserDetailTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetailTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailTagsPost(_response);
        });
    }

    protected processUserDetailTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified UserDetailTag.
     * @param userDetailTag The UserDetailTag.
     */
    userDetailTagsPut(userDetailTag: UserDetailTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/UserDetailTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userDetailTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUserDetailTagsPut(_response);
        });
    }

    protected processUserDetailTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class VerificationClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get the list of banks supported by the verification service in the country
     */
    bankList(currencyEnum: CurrencyEnum): Promise<BankListResponse> {
        let url_ = this.baseUrl + "/api/v1/Verification/BankList/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBankList(_response);
        });
    }

    protected processBankList(response: Response): Promise<BankListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankListResponse>(null as any);
    }

    /**
     * Get BVN details
     */
    lookupBVN(currencyEnum: CurrencyEnum, bvn: string): Promise<BVNLookupResponse> {
        let url_ = this.baseUrl + "/api/v1/Verification/LookupBVN/{currencyEnum}/{bvn}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (bvn === undefined || bvn === null)
            throw new Error("The parameter 'bvn' must be defined.");
        url_ = url_.replace("{bvn}", encodeURIComponent("" + bvn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processLookupBVN(_response);
        });
    }

    protected processLookupBVN(response: Response): Promise<BVNLookupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BVNLookupResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BVNLookupResponse>(null as any);
    }

    /**
     * Verify BVN with Selfie
     */
    verifyBVNSelfie(currencyEnum: CurrencyEnum, bVNSelfieRequest: UserDetailBvnDTO): Promise<BVNSelfieResponse> {
        let url_ = this.baseUrl + "/api/v1/Verification/VerifyBVNSelfie/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bVNSelfieRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerifyBVNSelfie(_response);
        });
    }

    protected processVerifyBVNSelfie(response: Response): Promise<BVNSelfieResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BVNSelfieResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BVNSelfieResponse>(null as any);
    }

    /**
     * Verify BVN with Selfie FHIR
     */
    verifyBvnSelfieFhir(bVNSelfieRequest: UserDetailBvnFHIRDTO): Promise<BVNSelfieFHIRResponse> {
        let url_ = this.baseUrl + "/api/v1/Verification/verify-bvn-selfie-fhir";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bVNSelfieRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerifyBvnSelfieFhir(_response);
        });
    }

    protected processVerifyBvnSelfieFhir(response: Response): Promise<BVNSelfieFHIRResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BVNSelfieFHIRResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BVNSelfieFHIRResponse>(null as any);
    }

    /**
     * Get the balance for the wallet.
     * @return An IActionResult containing the merchant balance.
     */
    getWalletBalance(currencyEnum: CurrencyEnum): Promise<WalletBalanceResponse> {
        let url_ = this.baseUrl + "/api/v1/Verification/GetWalletBalance/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetWalletBalance(_response);
        });
    }

    protected processGetWalletBalance(response: Response): Promise<WalletBalanceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletBalanceResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletBalanceResponse>(null as any);
    }

    /**
     * Get the verification by userdetail - Admin only
     */
    byUserDetailID(userDetailID: string): Promise<Verification[]> {
        let url_ = this.baseUrl + "/api/v1/Verification/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<Verification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Verification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Verification[]>(null as any);
    }

    /**
     * Search verification
     */
    searchVerifications(searchVerificationDetails: SearchVerificationDetails): Promise<Verification[]> {
        let url_ = this.baseUrl + "/api/v1/Verification/SearchVerifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchVerificationDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearchVerifications(_response);
        });
    }

    protected processSearchVerifications(response: Response): Promise<Verification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Verification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Verification[]>(null as any);
    }
}

export class VersionClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the API version.
     */
    aPIVersion(): Promise<string> {
        let url_ = this.baseUrl + "/api/Version/APIVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAPIVersion(_response);
        });
    }

    protected processAPIVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Do Not Use
     */
    getErrorResult(): Promise<ErrorResult> {
        let url_ = this.baseUrl + "/api/Version/GetErrorResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetErrorResult(_response);
        });
    }

    protected processGetErrorResult(response: Response): Promise<ErrorResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ErrorResult>(null as any);
    }
}

export class VideoDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<VideoDetail[]> {
        let url_ = this.baseUrl + "/api/v1/VideoDetails/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<VideoDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VideoDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoDetail[]>(null as any);
    }

    /**
     * Uploads the specified file information.
     * @param video (optional) 
     */
    upload(video?: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/VideoDetails/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (video !== null && video !== undefined)
            content_.append("video", video.data, video.fileName ? video.fileName : "video");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Downloads the original.
     * @param videoID The video detail identifier.
     */
    original(videoID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/VideoDetails/{videoID}/Original";
        if (videoID === undefined || videoID === null)
            throw new Error("The parameter 'videoID' must be defined.");
        url_ = url_.replace("{videoID}", encodeURIComponent("" + videoID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOriginal(_response);
        });
    }

    protected processOriginal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param videoDetailID The identifier.
     */
    videoDetailsGet(videoDetailID: string): Promise<VideoDetail> {
        let url_ = this.baseUrl + "/api/v1/VideoDetails/{videoDetailID}";
        if (videoDetailID === undefined || videoDetailID === null)
            throw new Error("The parameter 'videoDetailID' must be defined.");
        url_ = url_.replace("{videoDetailID}", encodeURIComponent("" + videoDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVideoDetailsGet(_response);
        });
    }

    protected processVideoDetailsGet(response: Response): Promise<VideoDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoDetail>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param videoDetailID The identifier.
     */
    videoDetailsDelete(videoDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/VideoDetails/{videoDetailID}";
        if (videoDetailID === undefined || videoDetailID === null)
            throw new Error("The parameter 'videoDetailID' must be defined.");
        url_ = url_.replace("{videoDetailID}", encodeURIComponent("" + videoDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVideoDetailsDelete(_response);
        });
    }

    protected processVideoDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Puts the specified video.
     * @param videoDetail The video.
     */
    videoDetailsPut(videoDetail: VideoDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/VideoDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(videoDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVideoDetailsPut(_response);
        });
    }

    protected processVideoDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class WalletAPIClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get any wallet KYC requirements
     */
    walletKYCRequirements(userDetailID: string): Promise<WalletKYCRequirementsEnum[]> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/WalletKYCRequirements/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletKYCRequirements(_response);
        });
    }

    protected processWalletKYCRequirements(response: Response): Promise<WalletKYCRequirementsEnum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletKYCRequirementsEnum[]>(null as any);
    }

    /**
     * Get Customers by wallet currency
     */
    customers(currencyEnum: CurrencyEnum): Promise<CustomersResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/Customers/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCustomers(_response);
        });
    }

    protected processCustomers(response: Response): Promise<CustomersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomersResponse>(null as any);
    }

    /**
     * Get Customer by CustmerID
     */
    customerId(currencyEnum: CurrencyEnum, customerID: string): Promise<CustomerResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/Customer/{currencyEnum}/customerId/{customerID}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (customerID === undefined || customerID === null)
            throw new Error("The parameter 'customerID' must be defined.");
        url_ = url_.replace("{customerID}", encodeURIComponent("" + customerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCustomerId(_response);
        });
    }

    protected processCustomerId(response: Response): Promise<CustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerResponse>(null as any);
    }

    /**
     * Get Customer by phoneNumber
     */
    phone(currencyEnum: CurrencyEnum, phoneNumber: string): Promise<CustomerResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/Customer/{currencyEnum}/Phone/{phoneNumber}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPhone(_response);
        });
    }

    protected processPhone(response: Response): Promise<CustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerResponse>(null as any);
    }

    /**
     * Update the freeze status of a wallet.
     */
    updateWalletFreezeStatus(currencyEnum: CurrencyEnum, freezeRequest: FreezeRequest): Promise<FreezeResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/UpdateWalletFreezeStatus/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(freezeRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpdateWalletFreezeStatus(_response);
        });
    }

    protected processUpdateWalletFreezeStatus(response: Response): Promise<FreezeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FreezeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreezeResponse>(null as any);
    }

    /**
     * Get the transactions for a customer.
     */
    getCustomerTransactions(currencyEnum: CurrencyEnum, walletTransactionRequest: WalletTransactionRequest): Promise<WalletTransactionResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/GetCustomerTransactions/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletTransactionRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetCustomerTransactions(_response);
        });
    }

    protected processGetCustomerTransactions(response: Response): Promise<WalletTransactionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransactionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletTransactionResponse>(null as any);
    }

    /**
     * Get transaction by Transaction ID
     */
    transactionId(currencyEnum: CurrencyEnum, transactionID: string): Promise<TransactionResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/Transaction/{currencyEnum}/transactionId/{transactionID}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (transactionID === undefined || transactionID === null)
            throw new Error("The parameter 'transactionID' must be defined.");
        url_ = url_.replace("{transactionID}", encodeURIComponent("" + transactionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTransactionId(_response);
        });
    }

    protected processTransactionId(response: Response): Promise<TransactionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionResponse>(null as any);
    }

    /**
     * Get transaction by reference
     */
    reference(currencyEnum: CurrencyEnum, reference: string): Promise<TransactionResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/Transaction/{currencyEnum}/reference/{reference}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (reference === undefined || reference === null)
            throw new Error("The parameter 'reference' must be defined.");
        url_ = url_.replace("{reference}", encodeURIComponent("" + reference));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processReference(_response);
        });
    }

    protected processReference(response: Response): Promise<TransactionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionResponse>(null as any);
    }

    /**
     * Get the transactions for a merchant.
     */
    getMerchantTransactions(currencyEnum: CurrencyEnum, merchantTransactionRequest: MerchantTransactionRequest): Promise<MerchantTransactionResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/GetMerchantTransactions/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(merchantTransactionRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetMerchantTransactions(_response);
        });
    }

    protected processGetMerchantTransactions(response: Response): Promise<MerchantTransactionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MerchantTransactionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MerchantTransactionResponse>(null as any);
    }

    /**
     * Get the balance for a merchant.
     * @return An IActionResult containing the merchant balance.
     */
    getMerchantBalance(currencyEnum: CurrencyEnum): Promise<WalletBalanceResponse2> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/GetMerchantBalance/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetMerchantBalance(_response);
        });
    }

    protected processGetMerchantBalance(response: Response): Promise<WalletBalanceResponse2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletBalanceResponse2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletBalanceResponse2>(null as any);
    }

    /**
     * Get the list of banks supported by the walletProvider in the country
     */
    bankList(currencyEnum: CurrencyEnum): Promise<BankListResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/BankList/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBankList(_response);
        });
    }

    protected processBankList(response: Response): Promise<BankListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankListResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankListResponse>(null as any);
    }

    /**
     * Get bank account details
     */
    getBankAccountDetails(currencyEnum: CurrencyEnum, code: string, accountNumber: string): Promise<BankAccountDetailsResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/GetBankAccountDetails/{currencyEnum}/{code}/{accountNumber}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetBankAccountDetails(_response);
        });
    }

    protected processGetBankAccountDetails(response: Response): Promise<BankAccountDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankAccountDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountDetailsResponse>(null as any);
    }

    /**
     * Get the details of a wallet.
     * @return An IActionResult containing the wallet details.
     */
    getWalletDetails(currencyEnum: CurrencyEnum, accountNumber: string): Promise<WalletDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/GetWalletDetails/{accountNumber}/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (accountNumber === undefined || accountNumber === null)
            throw new Error("The parameter 'accountNumber' must be defined.");
        url_ = url_.replace("{accountNumber}", encodeURIComponent("" + accountNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetWalletDetails(_response);
        });
    }

    protected processGetWalletDetails(response: Response): Promise<WalletDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletDetailResponse>(null as any);
    }

    /**
     * Get the balance of a customer's wallet.
     * @return An WalletBalanceResponse containing the customer's wallet balance.
     */
    getCustomerWalletBalance(currencyEnum: CurrencyEnum, walletid: string): Promise<WalletBalanceResponse2> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/GetCustomerWalletBalance/{walletid}/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (walletid === undefined || walletid === null)
            throw new Error("The parameter 'walletid' must be defined.");
        url_ = url_.replace("{walletid}", encodeURIComponent("" + walletid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetCustomerWalletBalance(_response);
        });
    }

    protected processGetCustomerWalletBalance(response: Response): Promise<WalletBalanceResponse2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletBalanceResponse2.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletBalanceResponse2>(null as any);
    }

    /**
     * Generates a virtual wallet.
     * @return An VirtualWalletResponse containing the virtual wallet details.
     */
    generateVirtualWallet(currencyEnum: CurrencyEnum, virtualWalletRequest: VirtualWalletRequest): Promise<VirtualWalletResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/GenerateVirtualWallet/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(virtualWalletRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGenerateVirtualWallet(_response);
        });
    }

    protected processGenerateVirtualWallet(response: Response): Promise<VirtualWalletResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VirtualWalletResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VirtualWalletResponse>(null as any);
    }

    /**
     * Get the virtual wallet details.
     * @return An VirtualWalletDetailResponse containing the virtual wallet details.
     */
    getVirtualWalletDetails(walletid: string, currencyEnum: CurrencyEnum): Promise<VirtualWalletDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletAPI/GetVirtualWalletDetails/{walletid}/{currencyEnum}";
        if (walletid === undefined || walletid === null)
            throw new Error("The parameter 'walletid' must be defined.");
        url_ = url_.replace("{walletid}", encodeURIComponent("" + walletid));
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetVirtualWalletDetails(_response);
        });
    }

    protected processGetVirtualWalletDetails(response: Response): Promise<VirtualWalletDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VirtualWalletDetailResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VirtualWalletDetailResponse>(null as any);
    }
}

export class WalletCardsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Generate cards
     */
    generateCards(numberOfCards: number): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/GenerateCards/{numberOfCards}";
        if (numberOfCards === undefined || numberOfCards === null)
            throw new Error("The parameter 'numberOfCards' must be defined.");
        url_ = url_.replace("{numberOfCards}", encodeURIComponent("" + numberOfCards));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGenerateCards(_response);
        });
    }

    protected processGenerateCards(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Validate the Card Pin
     */
    validatePin(walletCardPinValidateDetails: WalletCardPinValidateDetails): Promise<WalletCardPinValidateResults> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/ValidatePin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletCardPinValidateDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processValidatePin(_response);
        });
    }

    protected processValidatePin(response: Response): Promise<WalletCardPinValidateResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCardPinValidateResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCardPinValidateResults>(null as any);
    }

    /**
     * Create walletcards for all wallets that don't have a card
     */
    createWalletCardsForUserDetailsAdmin(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/CreateWalletCardsForUserDetailsAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateWalletCardsForUserDetailsAdmin(_response);
        });
    }

    protected processCreateWalletCardsForUserDetailsAdmin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reset the wallet card PIN
     */
    resetWalletCardPin(resetWalletCardPinDetails: ResetWalletCardPinDetails): Promise<ResetWalletCardPinResults> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/ResetWalletCardPin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetWalletCardPinDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processResetWalletCardPin(_response);
        });
    }

    protected processResetWalletCardPin(response: Response): Promise<ResetWalletCardPinResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetWalletCardPinResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetWalletCardPinResults>(null as any);
    }

    /**
     * Change the wallet card PIN
     */
    changeWalletCardPin(changeWalletCardPinDetails: ChangeWalletCardPinDetails): Promise<ChangeWalletCardPinResults> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/ChangeWalletCardPin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeWalletCardPinDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processChangeWalletCardPin(_response);
        });
    }

    protected processChangeWalletCardPin(response: Response): Promise<ChangeWalletCardPinResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeWalletCardPinResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeWalletCardPinResults>(null as any);
    }

    /**
     * Reset the wallet card PIN
     */
    changeWalletCardPinAdmin(changeWalletCardPinDetails: ChangeWalletCardPinDetails): Promise<ChangeWalletCardPinResults> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/ChangeWalletCardPinAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changeWalletCardPinDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processChangeWalletCardPinAdmin(_response);
        });
    }

    protected processChangeWalletCardPinAdmin(response: Response): Promise<ChangeWalletCardPinResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeWalletCardPinResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeWalletCardPinResults>(null as any);
    }

    /**
     * Assign Wallet card to user
     */
    assignWalletCard(walletCardDetails: WalletCardDetails): Promise<WalletCardResults> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/AssignWalletCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletCardDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAssignWalletCard(_response);
        });
    }

    protected processAssignWalletCard(response: Response): Promise<WalletCardResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCardResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCardResults>(null as any);
    }

    /**
     * Remove Wallet from user
     */
    deactivateWalletCard(walletCardDetails: WalletCardDetails): Promise<WalletCardResults> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/DeactivateWalletCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletCardDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDeactivateWalletCard(_response);
        });
    }

    protected processDeactivateWalletCard(response: Response): Promise<WalletCardResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCardResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCardResults>(null as any);
    }

    /**
     * Get by WalletID
     */
    byUserDetailID(userDetailID: string): Promise<WalletCard[]> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/ByUserDetailID/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailID(_response);
        });
    }

    protected processByUserDetailID(response: Response): Promise<WalletCard[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletCard.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCard[]>(null as any);
    }

    /**
     * Get available cards by type
     */
    getAvailableCards(numberOfCards: number, cardTypeEnum: CardTypeEnum): Promise<WalletCard[]> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/GetAvailableCards/{numberOfCards}/{cardTypeEnum}";
        if (numberOfCards === undefined || numberOfCards === null)
            throw new Error("The parameter 'numberOfCards' must be defined.");
        url_ = url_.replace("{numberOfCards}", encodeURIComponent("" + numberOfCards));
        if (cardTypeEnum === undefined || cardTypeEnum === null)
            throw new Error("The parameter 'cardTypeEnum' must be defined.");
        url_ = url_.replace("{cardTypeEnum}", encodeURIComponent("" + cardTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetAvailableCards(_response);
        });
    }

    protected processGetAvailableCards(response: Response): Promise<WalletCard[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletCard.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCard[]>(null as any);
    }

    /**
     * Update the wallet card (admin)
     */
    walletCards(walletCard: WalletCard): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/WalletCards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletCard);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletCards(_response);
        });
    }

    protected processWalletCards(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Search for card
     */
    search(walletCardSearchDetails: WalletCardSearchDetails): Promise<WalletCardSearchResults> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletCardSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<WalletCardSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCardSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCardSearchResults>(null as any);
    }

    /**
     * Used by AdminFacilityOnboarding - Search for Patients
     */
    patientSearch(walletCardPatientSearchDetails: WalletCardPatientSearchDetails): Promise<WalletCardPatientSearchResults> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/PatientSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletCardPatientSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientSearch(_response);
        });
    }

    protected processPatientSearch(response: Response): Promise<WalletCardPatientSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCardPatientSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCardPatientSearchResults>(null as any);
    }

    /**
     * Signup a patient with a walletcardID - returns UserDetailID
     */
    patientSignup(internalSignUpPatient: InternalSignUpPatient): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/PatientSignup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(internalSignUpPatient);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPatientSignup(_response);
        });
    }

    protected processPatientSignup(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Check to see if the card is already used by a user
     */
    checkIfUsed(cardNumber: number): Promise<WalletCardCheckedResult> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/CheckIfUsed/{cardNumber}";
        if (cardNumber === undefined || cardNumber === null)
            throw new Error("The parameter 'cardNumber' must be defined.");
        url_ = url_.replace("{cardNumber}", encodeURIComponent("" + cardNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCheckIfUsed(_response);
        });
    }

    protected processCheckIfUsed(response: Response): Promise<WalletCardCheckedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCardCheckedResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCardCheckedResult>(null as any);
    }

    /**
     * Get my wallet cards
     */
    myActiveWalletCard(): Promise<WalletCard> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/MyActiveWalletCard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyActiveWalletCard(_response);
        });
    }

    protected processMyActiveWalletCard(response: Response): Promise<WalletCard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCard.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCard>(null as any);
    }

    /**
     * Get my wallet cards
     */
    myActiveWalletCards(): Promise<WalletCard[]> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/MyActiveWalletCards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyActiveWalletCards(_response);
        });
    }

    protected processMyActiveWalletCards(response: Response): Promise<WalletCard[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletCard.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCard[]>(null as any);
    }

    qrcode(walletCardID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/WalletCards/qrcode/{walletCardID}";
        if (walletCardID === undefined || walletCardID === null)
            throw new Error("The parameter 'walletCardID' must be defined.");
        url_ = url_.replace("{walletCardID}", encodeURIComponent("" + walletCardID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processQrcode(_response);
        });
    }

    protected processQrcode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class WalletDumpsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<WalletDump[]> {
        let url_ = this.baseUrl + "/api/v1/WalletDumps/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<WalletDump[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletDump.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletDump[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param walletDumpID The identifier.
     */
    walletDumpsGet(walletDumpID: string): Promise<WalletDump> {
        let url_ = this.baseUrl + "/api/v1/WalletDumps/{walletDumpID}";
        if (walletDumpID === undefined || walletDumpID === null)
            throw new Error("The parameter 'walletDumpID' must be defined.");
        url_ = url_.replace("{walletDumpID}", encodeURIComponent("" + walletDumpID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletDumpsGet(_response);
        });
    }

    protected processWalletDumpsGet(response: Response): Promise<WalletDump> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletDump.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletDump>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param walletDumpID The identifier.
     */
    walletDumpsDelete(walletDumpID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/WalletDumps/{walletDumpID}";
        if (walletDumpID === undefined || walletDumpID === null)
            throw new Error("The parameter 'walletDumpID' must be defined.");
        url_ = url_.replace("{walletDumpID}", encodeURIComponent("" + walletDumpID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletDumpsDelete(_response);
        });
    }

    protected processWalletDumpsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified WalletDump.
     * @param walletDump The WalletDump.
     */
    walletDumpsPost(walletDump: WalletDump): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/WalletDumps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletDump);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletDumpsPost(_response);
        });
    }

    protected processWalletDumpsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified WalletDump.
     * @param walletDump The WalletDump.
     */
    walletDumpsPut(walletDump: WalletDump): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/WalletDumps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletDump);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletDumpsPut(_response);
        });
    }

    protected processWalletDumpsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class WalletsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the current user's wallet by Currency
     * @param currencyEnum The currency enum.
     */
    myWalletByCurrencyEnum(currencyEnum: CurrencyEnum): Promise<Wallet[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/MyWalletByCurrencyEnum/{currencyEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyWalletByCurrencyEnum(_response);
        });
    }

    protected processMyWalletByCurrencyEnum(response: Response): Promise<Wallet[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Wallet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Wallet[]>(null as any);
    }

    /**
     * Gets the current user's wallet
     * @param currencyEnum The currency enum.
     */
    myWallet(currencyEnum: CurrencyEnum, walletTypeEnum: WalletTypeEnum): Promise<Wallet> {
        let url_ = this.baseUrl + "/api/v1/Wallets/MyWallet/{currencyEnum}/{walletTypeEnum}";
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (walletTypeEnum === undefined || walletTypeEnum === null)
            throw new Error("The parameter 'walletTypeEnum' must be defined.");
        url_ = url_.replace("{walletTypeEnum}", encodeURIComponent("" + walletTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyWallet(_response);
        });
    }

    protected processMyWallet(response: Response): Promise<Wallet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Wallet.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Wallet>(null as any);
    }

    /**
     * Gets the current user's wallets
     */
    myWallets(): Promise<Wallet[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/MyWallets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyWallets(_response);
        });
    }

    protected processMyWallets(response: Response): Promise<Wallet[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Wallet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Wallet[]>(null as any);
    }

    /**
     * Gets the current user's wallets and their aggregates in base currencies
     */
    myWalletsAggregates(): Promise<WalletsAggregatesDTO> {
        let url_ = this.baseUrl + "/api/v1/Wallets/MyWalletsAggregates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMyWalletsAggregates(_response);
        });
    }

    protected processMyWalletsAggregates(response: Response): Promise<WalletsAggregatesDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletsAggregatesDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletsAggregatesDTO>(null as any);
    }

    /**
     * Creates the outpost health account.
     * @param walletPINDetails The wallet pin details.
     */
    createAccount(walletPINDetails: ChangeWalletPINDetails): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Wallets/CreateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletPINDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateAccount(_response);
        });
    }

    protected processCreateAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Transfer funds between Current user's wallet accounts
     */
    transferFunds(walletTransferFundsDetails: WalletTransferFundsDetails): Promise<WalletTransferFundsResult> {
        let url_ = this.baseUrl + "/api/v1/Wallets/TransferFunds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletTransferFundsDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTransferFunds(_response);
        });
    }

    protected processTransferFunds(response: Response): Promise<WalletTransferFundsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletTransferFundsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletTransferFundsResult>(null as any);
    }

    /**
     * Withdraw funds between Current user's wallet accounts
     */
    withdrawFunds(walletWithdrawFundsDetails: WalletWithdrawFundsDetails): Promise<WalletWithdrawFundsResult> {
        let url_ = this.baseUrl + "/api/v1/Wallets/WithdrawFunds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletWithdrawFundsDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWithdrawFunds(_response);
        });
    }

    protected processWithdrawFunds(response: Response): Promise<WalletWithdrawFundsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletWithdrawFundsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletWithdrawFundsResult>(null as any);
    }

    /**
     * Add amount to wallet.  Returns an InvoiceID to be paid
     * @param walletDetail The wallet detail.
     */
    createInvoice(walletDetail: WalletDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Wallets/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateInvoice(_response);
        });
    }

    protected processCreateInvoice(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Commit the Invoice and apply funds to wallet
     * @param walletCommitDetails The wallet commit details.
     */
    commit(walletCommitDetails: WalletCommitDetails): Promise<WalletCommitResults> {
        let url_ = this.baseUrl + "/api/v1/Wallets/Commit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletCommitDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCommit(_response);
        });
    }

    protected processCommit(response: Response): Promise<WalletCommitResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletCommitResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletCommitResults>(null as any);
    }

    /**
     * Refund the invoice and remove funds from wallet
     * @param walletRefundDetails The wallet refund details.
     */
    refund(walletRefundDetails: WalletRefundDetails): Promise<WalletRefundResults> {
        let url_ = this.baseUrl + "/api/v1/Wallets/Refund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletRefundDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRefund(_response);
        });
    }

    protected processRefund(response: Response): Promise<WalletRefundResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletRefundResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletRefundResults>(null as any);
    }

    /**
     * Gets the wallet payee details.
     * @param fromUserDetailID From user detail identifier.
     */
    walletPayeeDetails(fromUserDetailID: string): Promise<WalletPayeeDetailDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/WalletPayeeDetails/{fromUserDetailID}";
        if (fromUserDetailID === undefined || fromUserDetailID === null)
            throw new Error("The parameter 'fromUserDetailID' must be defined.");
        url_ = url_.replace("{fromUserDetailID}", encodeURIComponent("" + fromUserDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletPayeeDetails(_response);
        });
    }

    protected processWalletPayeeDetails(response: Response): Promise<WalletPayeeDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletPayeeDetailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletPayeeDetailDTO[]>(null as any);
    }

    /**
     * Gets the wallet details for the current user.
     * @param walletID The wallet identifier.
     */
    walletDetails(walletID: string): Promise<WalletDetail[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/{walletID}/WalletDetails";
        if (walletID === undefined || walletID === null)
            throw new Error("The parameter 'walletID' must be defined.");
        url_ = url_.replace("{walletID}", encodeURIComponent("" + walletID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletDetails(_response);
        });
    }

    protected processWalletDetails(response: Response): Promise<WalletDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletDetail[]>(null as any);
    }

    /**
     * Gets the wallet details for the current user.
     * @param walletID The wallet identifier.
     */
    walletDetailsAdmin(walletID: string, userDetailID: string): Promise<WalletDetail[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/{walletID}/WalletDetailsAdmin/{userDetailID}";
        if (walletID === undefined || walletID === null)
            throw new Error("The parameter 'walletID' must be defined.");
        url_ = url_.replace("{walletID}", encodeURIComponent("" + walletID));
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletDetailsAdmin(_response);
        });
    }

    protected processWalletDetailsAdmin(response: Response): Promise<WalletDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletDetail[]>(null as any);
    }

    /**
     * Gets the wallet payee details by patientDependant ID
     */
    walletPayeeDetailsByUserDetailRelationship(patientID: string, userDetailRelationshipID: string): Promise<WalletPayeeDetailDTO[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/WalletPayeeDetailsByUserDetailRelationship/{patientID}/{userDetailRelationshipID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (userDetailRelationshipID === undefined || userDetailRelationshipID === null)
            throw new Error("The parameter 'userDetailRelationshipID' must be defined.");
        url_ = url_.replace("{userDetailRelationshipID}", encodeURIComponent("" + userDetailRelationshipID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletPayeeDetailsByUserDetailRelationship(_response);
        });
    }

    protected processWalletPayeeDetailsByUserDetailRelationship(response: Response): Promise<WalletPayeeDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WalletPayeeDetailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletPayeeDetailDTO[]>(null as any);
    }

    /**
     * Admin Get wallet balance
     */
    adminWalletBalance(userDetailID: string, currencyEnum: CurrencyEnum, walletTypeEnum: WalletTypeEnum): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/Wallets/AdminWalletBalance/{userDetailID}/{currencyEnum}/{walletTypeEnum}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (walletTypeEnum === undefined || walletTypeEnum === null)
            throw new Error("The parameter 'walletTypeEnum' must be defined.");
        url_ = url_.replace("{walletTypeEnum}", encodeURIComponent("" + walletTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminWalletBalance(_response);
        });
    }

    protected processAdminWalletBalance(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get a ping to the service
     */
    walletClientPing(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Wallets/WalletClientPing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletClientPing(_response);
        });
    }

    protected processWalletClientPing(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the wallets by UserDetailID (Admin)
     */
    byUserDetailIDAdmin(userDetailID: string): Promise<Wallet[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/ByUserDetailIDAdmin/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByUserDetailIDAdmin(_response);
        });
    }

    protected processByUserDetailIDAdmin(response: Response): Promise<Wallet[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Wallet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Wallet[]>(null as any);
    }

    /**
     * Gets the current user's wallet
     * @param currencyEnum The currency enum.
     */
    wallet(userDetailID: string, currencyEnum: CurrencyEnum, walletTypeEnum: WalletTypeEnum): Promise<Wallet> {
        let url_ = this.baseUrl + "/api/v1/Wallets/Wallet/{userDetailID}/{currencyEnum}/{walletTypeEnum}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        if (currencyEnum === undefined || currencyEnum === null)
            throw new Error("The parameter 'currencyEnum' must be defined.");
        url_ = url_.replace("{currencyEnum}", encodeURIComponent("" + currencyEnum));
        if (walletTypeEnum === undefined || walletTypeEnum === null)
            throw new Error("The parameter 'walletTypeEnum' must be defined.");
        url_ = url_.replace("{walletTypeEnum}", encodeURIComponent("" + walletTypeEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWallet(_response);
        });
    }

    protected processWallet(response: Response): Promise<Wallet> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Wallet.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Wallet>(null as any);
    }

    /**
     * Adjust wallet
     */
    adjustWalletAdmin(walletID: string, adjustAmount: number): Promise<WalletAdjustmentResult> {
        let url_ = this.baseUrl + "/api/v1/Wallets/AdjustWalletAdmin/{walletID}/{adjustAmount}";
        if (walletID === undefined || walletID === null)
            throw new Error("The parameter 'walletID' must be defined.");
        url_ = url_.replace("{walletID}", encodeURIComponent("" + walletID));
        if (adjustAmount === undefined || adjustAmount === null)
            throw new Error("The parameter 'adjustAmount' must be defined.");
        url_ = url_.replace("{adjustAmount}", encodeURIComponent("" + adjustAmount));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdjustWalletAdmin(_response);
        });
    }

    protected processAdjustWalletAdmin(response: Response): Promise<WalletAdjustmentResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletAdjustmentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletAdjustmentResult>(null as any);
    }

    /**
     * Get the list of users who have wallets and their balances
     */
    adminWalletUsers(walletUserSearchDetails: WalletUserSearchDetails): Promise<Wallet[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/AdminWalletUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walletUserSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdminWalletUsers(_response);
        });
    }

    protected processAdminWalletUsers(response: Response): Promise<Wallet[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Wallet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Wallet[]>(null as any);
    }

    /**
     * Get any wallet KYC requirements
     */
    walletKYCRequirements(userDetailID: string): Promise<WalletKYCRequirementsEnum[]> {
        let url_ = this.baseUrl + "/api/v1/Wallets/WalletKYCRequirements/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processWalletKYCRequirements(_response);
        });
    }

    protected processWalletKYCRequirements(response: Response): Promise<WalletKYCRequirementsEnum[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletKYCRequirementsEnum[]>(null as any);
    }
}

export class WebflowCMSClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the blog items.
     * @param take (optional) The take.
     * @param skip (optional) The number of items to skip.
     */
    blogItems(take?: number | null | undefined, skip?: number | null | undefined): Promise<WebflowItem[]> {
        let url_ = this.baseUrl + "/api/v1/WebflowCMS/BlogItems?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlogItems(_response);
        });
    }

    protected processBlogItems(response: Response): Promise<WebflowItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebflowItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebflowItem[]>(null as any);
    }

    /**
     * Gets the blog items.
     * @param take (optional) The take.
     * @param skip (optional) The number of items to skip.
     */
    blogItemsPaged(take?: number | null | undefined, skip?: number | null | undefined): Promise<WebflowBlogItemsDTO> {
        let url_ = this.baseUrl + "/api/v1/WebflowCMS/BlogItemsPaged?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlogItemsPaged(_response);
        });
    }

    protected processBlogItemsPaged(response: Response): Promise<WebflowBlogItemsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebflowBlogItemsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebflowBlogItemsDTO>(null as any);
    }

    /**
     * Gets the blog item by item identifier.
     * @param itemID The item identifier.
     */
    blogItemsByItemID(itemID: string): Promise<WebflowItem> {
        let url_ = this.baseUrl + "/api/v1/WebflowCMS/BlogItemsByItemID/{itemID}";
        if (itemID === undefined || itemID === null)
            throw new Error("The parameter 'itemID' must be defined.");
        url_ = url_.replace("{itemID}", encodeURIComponent("" + itemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processBlogItemsByItemID(_response);
        });
    }

    protected processBlogItemsByItemID(response: Response): Promise<WebflowItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebflowItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebflowItem>(null as any);
    }

    /**
     * Gets the authors.
     */
    authors(): Promise<WebflowAuthor[]> {
        let url_ = this.baseUrl + "/api/v1/WebflowCMS/Authors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAuthors(_response);
        });
    }

    protected processAuthors(response: Response): Promise<WebflowAuthor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WebflowAuthor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebflowAuthor[]>(null as any);
    }

    /**
     * Gets the author by author identifier.
     * @param authorID The author identifier.
     */
    authorsByAuthorID(authorID: string): Promise<WebflowAuthor> {
        let url_ = this.baseUrl + "/api/v1/WebflowCMS/AuthorsByAuthorID/{authorID}";
        if (authorID === undefined || authorID === null)
            throw new Error("The parameter 'authorID' must be defined.");
        url_ = url_.replace("{authorID}", encodeURIComponent("" + authorID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAuthorsByAuthorID(_response);
        });
    }

    protected processAuthorsByAuthorID(response: Response): Promise<WebflowAuthor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebflowAuthor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebflowAuthor>(null as any);
    }
}

export class CityTownsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    byProvinceStateID(provinceStateID: string): Promise<CityTown[]> {
        let url_ = this.baseUrl + "/api/v1/Types/CityTowns/ByProvinceStateID/{provinceStateID}";
        if (provinceStateID === undefined || provinceStateID === null)
            throw new Error("The parameter 'provinceStateID' must be defined.");
        url_ = url_.replace("{provinceStateID}", encodeURIComponent("" + provinceStateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProvinceStateID(_response);
        });
    }

    protected processByProvinceStateID(response: Response): Promise<CityTown[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityTown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityTown[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<CityTown[]> {
        let url_ = this.baseUrl + "/api/v1/Types/CityTowns/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<CityTown[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityTown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityTown[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param cityTownID The identifier.
     */
    cityTownsGet(cityTownID: string): Promise<CityTown> {
        let url_ = this.baseUrl + "/api/v1/Types/CityTowns/{cityTownID}";
        if (cityTownID === undefined || cityTownID === null)
            throw new Error("The parameter 'cityTownID' must be defined.");
        url_ = url_.replace("{cityTownID}", encodeURIComponent("" + cityTownID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCityTownsGet(_response);
        });
    }

    protected processCityTownsGet(response: Response): Promise<CityTown> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityTown.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityTown>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param cityTownID The identifier.
     */
    cityTownsDelete(cityTownID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/CityTowns/{cityTownID}";
        if (cityTownID === undefined || cityTownID === null)
            throw new Error("The parameter 'cityTownID' must be defined.");
        url_ = url_.replace("{cityTownID}", encodeURIComponent("" + cityTownID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCityTownsDelete(_response);
        });
    }

    protected processCityTownsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified CityTown.
     * @param cityTown The CityTown.
     */
    cityTownsPost(cityTown: CityTown): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/CityTowns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cityTown);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCityTownsPost(_response);
        });
    }

    protected processCityTownsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified CityTown.
     * @param cityTown The CityTown.
     */
    cityTownsPut(cityTown: CityTown): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/CityTowns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cityTown);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCityTownsPut(_response);
        });
    }

    protected processCityTownsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param cityTowns The city towns.
     */
    manyPost(cityTowns: CityTown[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Types/CityTowns/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cityTowns);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPost(_response);
        });
    }

    protected processManyPost(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Puts the many.
     * @param cityTowns The city towns.
     */
    manyPut(cityTowns: CityTown[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Types/CityTowns/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cityTowns);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPut(_response);
        });
    }

    protected processManyPut(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ClinicalTrialPhaseTypesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<ClinicalTrialPhaseType[]> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialPhaseTypes/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ClinicalTrialPhaseType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicalTrialPhaseType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialPhaseType[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param clinicalTrialPhaseTypeID The identifier.
     */
    clinicalTrialPhaseTypesGet(clinicalTrialPhaseTypeID: string): Promise<ClinicalTrialPhaseType> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialPhaseTypes/{clinicalTrialPhaseTypeID}";
        if (clinicalTrialPhaseTypeID === undefined || clinicalTrialPhaseTypeID === null)
            throw new Error("The parameter 'clinicalTrialPhaseTypeID' must be defined.");
        url_ = url_.replace("{clinicalTrialPhaseTypeID}", encodeURIComponent("" + clinicalTrialPhaseTypeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialPhaseTypesGet(_response);
        });
    }

    protected processClinicalTrialPhaseTypesGet(response: Response): Promise<ClinicalTrialPhaseType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrialPhaseType.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialPhaseType>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param clinicalTrialPhaseTypeID The identifier.
     */
    clinicalTrialPhaseTypesDelete(clinicalTrialPhaseTypeID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialPhaseTypes/{clinicalTrialPhaseTypeID}";
        if (clinicalTrialPhaseTypeID === undefined || clinicalTrialPhaseTypeID === null)
            throw new Error("The parameter 'clinicalTrialPhaseTypeID' must be defined.");
        url_ = url_.replace("{clinicalTrialPhaseTypeID}", encodeURIComponent("" + clinicalTrialPhaseTypeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialPhaseTypesDelete(_response);
        });
    }

    protected processClinicalTrialPhaseTypesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ClinicalTrialPhase type.
     * @param clinicalTrialPhaseType Type of the ClinicalTrialPhase.
     */
    clinicalTrialPhaseTypesPost(clinicalTrialPhaseType: ClinicalTrialPhaseType): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialPhaseTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialPhaseType);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialPhaseTypesPost(_response);
        });
    }

    protected processClinicalTrialPhaseTypesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ClinicalTrialPhase type.
     * @param clinicalTrialPhaseType Type of the ClinicalTrialPhase.
     */
    clinicalTrialPhaseTypesPut(clinicalTrialPhaseType: ClinicalTrialPhaseType): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialPhaseTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialPhaseType);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialPhaseTypesPut(_response);
        });
    }

    protected processClinicalTrialPhaseTypesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ClinicalTrialStatusTypesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<ClinicalTrialStatusType[]> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialStatusTypes/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<ClinicalTrialStatusType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClinicalTrialStatusType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialStatusType[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param clinicalTrialStatusTypeID The identifier.
     */
    clinicalTrialStatusTypesGet(clinicalTrialStatusTypeID: string): Promise<ClinicalTrialStatusType> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialStatusTypes/{clinicalTrialStatusTypeID}";
        if (clinicalTrialStatusTypeID === undefined || clinicalTrialStatusTypeID === null)
            throw new Error("The parameter 'clinicalTrialStatusTypeID' must be defined.");
        url_ = url_.replace("{clinicalTrialStatusTypeID}", encodeURIComponent("" + clinicalTrialStatusTypeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialStatusTypesGet(_response);
        });
    }

    protected processClinicalTrialStatusTypesGet(response: Response): Promise<ClinicalTrialStatusType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClinicalTrialStatusType.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClinicalTrialStatusType>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param clinicalTrialStatusTypeID The identifier.
     */
    clinicalTrialStatusTypesDelete(clinicalTrialStatusTypeID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialStatusTypes/{clinicalTrialStatusTypeID}";
        if (clinicalTrialStatusTypeID === undefined || clinicalTrialStatusTypeID === null)
            throw new Error("The parameter 'clinicalTrialStatusTypeID' must be defined.");
        url_ = url_.replace("{clinicalTrialStatusTypeID}", encodeURIComponent("" + clinicalTrialStatusTypeID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialStatusTypesDelete(_response);
        });
    }

    protected processClinicalTrialStatusTypesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ClinicalTrialStatus type.
     * @param clinicalTrialStatusType Type of the ClinicalTrialStatus.
     */
    clinicalTrialStatusTypesPost(clinicalTrialStatusType: ClinicalTrialStatusType): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialStatusTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialStatusType);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialStatusTypesPost(_response);
        });
    }

    protected processClinicalTrialStatusTypesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ClinicalTrialStatus type.
     * @param clinicalTrialStatusType Type of the ClinicalTrialStatus.
     */
    clinicalTrialStatusTypesPut(clinicalTrialStatusType: ClinicalTrialStatusType): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/ClinicalTrialStatusTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clinicalTrialStatusType);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processClinicalTrialStatusTypesPut(_response);
        });
    }

    protected processClinicalTrialStatusTypesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CountriesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Country[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Countries/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(null as any);
    }

    /**
     * Get the country by Code
     */
    byCode(countryCode: string): Promise<Country> {
        let url_ = this.baseUrl + "/api/v1/Types/Countries/ByCode/{countryCode}";
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined.");
        url_ = url_.replace("{countryCode}", encodeURIComponent("" + countryCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCode(_response);
        });
    }

    protected processByCode(response: Response): Promise<Country> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Country.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<Country[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Countries/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param countryID The identifier.
     */
    countriesGet(countryID: string): Promise<Country> {
        let url_ = this.baseUrl + "/api/v1/Types/Countries/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCountriesGet(_response);
        });
    }

    protected processCountriesGet(response: Response): Promise<Country> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Country.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param countryID The identifier.
     */
    countriesDelete(countryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/Countries/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCountriesDelete(_response);
        });
    }

    protected processCountriesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified country.
     * @param country The country.
     */
    countriesPost(country: Country): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/Countries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(country);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCountriesPost(_response);
        });
    }

    protected processCountriesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified country.
     * @param country The country.
     */
    countriesPut(country: Country): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/Countries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(country);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCountriesPut(_response);
        });
    }

    protected processCountriesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class GovernmentZonesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    byProvinceStateID(provinceStateID: string): Promise<GovernmentZone[]> {
        let url_ = this.baseUrl + "/api/v1/Types/GovernmentZones/ByProvinceStateID/{provinceStateID}";
        if (provinceStateID === undefined || provinceStateID === null)
            throw new Error("The parameter 'provinceStateID' must be defined.");
        url_ = url_.replace("{provinceStateID}", encodeURIComponent("" + provinceStateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByProvinceStateID(_response);
        });
    }

    protected processByProvinceStateID(response: Response): Promise<GovernmentZone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GovernmentZone.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GovernmentZone[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<GovernmentZone[]> {
        let url_ = this.baseUrl + "/api/v1/Types/GovernmentZones/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<GovernmentZone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GovernmentZone.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GovernmentZone[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param governmentZoneID The identifier.
     */
    governmentZonesGet(governmentZoneID: string): Promise<GovernmentZone> {
        let url_ = this.baseUrl + "/api/v1/Types/GovernmentZones/{governmentZoneID}";
        if (governmentZoneID === undefined || governmentZoneID === null)
            throw new Error("The parameter 'governmentZoneID' must be defined.");
        url_ = url_.replace("{governmentZoneID}", encodeURIComponent("" + governmentZoneID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGovernmentZonesGet(_response);
        });
    }

    protected processGovernmentZonesGet(response: Response): Promise<GovernmentZone> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GovernmentZone.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GovernmentZone>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param governmentZoneID The identifier.
     */
    governmentZonesDelete(governmentZoneID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/GovernmentZones/{governmentZoneID}";
        if (governmentZoneID === undefined || governmentZoneID === null)
            throw new Error("The parameter 'governmentZoneID' must be defined.");
        url_ = url_.replace("{governmentZoneID}", encodeURIComponent("" + governmentZoneID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGovernmentZonesDelete(_response);
        });
    }

    protected processGovernmentZonesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified GovernmentZone.
     * @param governmentZone The GovernmentZone.
     */
    governmentZonesPost(governmentZone: GovernmentZone): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/GovernmentZones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(governmentZone);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGovernmentZonesPost(_response);
        });
    }

    protected processGovernmentZonesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified GovernmentZone.
     * @param governmentZone The GovernmentZone.
     */
    governmentZonesPut(governmentZone: GovernmentZone): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/GovernmentZones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(governmentZone);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGovernmentZonesPut(_response);
        });
    }

    protected processGovernmentZonesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param governmentZones The city towns.
     */
    manyPost(governmentZones: GovernmentZone[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Types/GovernmentZones/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(governmentZones);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPost(_response);
        });
    }

    protected processManyPost(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Puts the many.
     * @param governmentZones The city towns.
     */
    manyPut(governmentZones: GovernmentZone[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Types/GovernmentZones/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(governmentZones);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPut(_response);
        });
    }

    protected processManyPut(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class LanguagesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<Language[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Languages/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Language[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Language.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Language[]>(null as any);
    }
}

export class OrderItemsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Posts the specified Order Item.
     * @param orderItem The Order Item.
     */
    orderItemsPost(orderItem: OrderItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/OrderItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrderItemsPost(_response);
        });
    }

    protected processOrderItemsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Order.
     * @param orderItem The Order.
     */
    orderItemsPut(orderItem: OrderItem): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/OrderItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderItem);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrderItemsPut(_response);
        });
    }

    protected processOrderItemsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts all the specified Order Items.
     */
    many(orderItems: OrderItem[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Types/OrderItems/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderItems);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param orderItemID The identifier.
     */
    orderItemsDelete(orderItemID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/OrderItems/{orderItemID}";
        if (orderItemID === undefined || orderItemID === null)
            throw new Error("The parameter 'orderItemID' must be defined.");
        url_ = url_.replace("{orderItemID}", encodeURIComponent("" + orderItemID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrderItemsDelete(_response);
        });
    }

    protected processOrderItemsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrdersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<Order[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Orders/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<Order[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Order.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order[]>(null as any);
    }

    /**
     * Gets all orders.
     */
    all(): Promise<Order[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Orders/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<Order[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Order.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param orderID The identifier.
     */
    ordersGet(orderID: string): Promise<Order> {
        let url_ = this.baseUrl + "/api/v1/Types/Orders/{OrderID}";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{OrderID}", encodeURIComponent("" + orderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrdersGet(_response);
        });
    }

    protected processOrdersGet(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param orderID The identifier.
     */
    ordersDelete(orderID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/Orders/{OrderID}";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{OrderID}", encodeURIComponent("" + orderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrdersDelete(_response);
        });
    }

    protected processOrdersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified Order.
     * @param order The Order.
     */
    ordersPost(order: Order): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/Orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(order);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrdersPost(_response);
        });
    }

    protected processOrdersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified Order.
     * @param order The Order.
     */
    ordersPut(order: Order): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/Orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(order);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processOrdersPut(_response);
        });
    }

    protected processOrdersPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets all enabled Orders and Order Items by country identifier.
     * @param countryID The country identifier.
     * @param storeID (optional) Optional Store To Get prices for
     * @param addressBookID (optional) 
     */
    byOrderIDAndCountryID(orderID: string, countryID: string, storeID?: string | null | undefined, addressBookID?: string | null | undefined): Promise<Order> {
        let url_ = this.baseUrl + "/api/v1/Types/Orders/ByOrderIDAndCountryID/{orderID}/{countryID}?";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        if (storeID !== undefined && storeID !== null)
            url_ += "storeID=" + encodeURIComponent("" + storeID) + "&";
        if (addressBookID !== undefined && addressBookID !== null)
            url_ += "addressBookID=" + encodeURIComponent("" + addressBookID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByOrderIDAndCountryID(_response);
        });
    }

    protected processByOrderIDAndCountryID(response: Response): Promise<Order> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Order.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Order>(null as any);
    }
}

export class ProvinceStatesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    byCountryID(countryID: string): Promise<ProvinceState[]> {
        let url_ = this.baseUrl + "/api/v1/Types/ProvinceStates/ByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCountryID(_response);
        });
    }

    protected processByCountryID(response: Response): Promise<ProvinceState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceState.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProvinceState[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<ProvinceState[]> {
        let url_ = this.baseUrl + "/api/v1/Types/ProvinceStates/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<ProvinceState[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceState.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProvinceState[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param provinceStateID The identifier.
     */
    provinceStatesGet(provinceStateID: string): Promise<ProvinceState> {
        let url_ = this.baseUrl + "/api/v1/Types/ProvinceStates/{ProvinceStateID}";
        if (provinceStateID === undefined || provinceStateID === null)
            throw new Error("The parameter 'provinceStateID' must be defined.");
        url_ = url_.replace("{ProvinceStateID}", encodeURIComponent("" + provinceStateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvinceStatesGet(_response);
        });
    }

    protected processProvinceStatesGet(response: Response): Promise<ProvinceState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProvinceState.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProvinceState>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param provinceStateID The identifier.
     */
    provinceStatesDelete(provinceStateID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/ProvinceStates/{ProvinceStateID}";
        if (provinceStateID === undefined || provinceStateID === null)
            throw new Error("The parameter 'provinceStateID' must be defined.");
        url_ = url_.replace("{ProvinceStateID}", encodeURIComponent("" + provinceStateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvinceStatesDelete(_response);
        });
    }

    protected processProvinceStatesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified ProvinceState.
     * @param provinceState The ProvinceState.
     */
    provinceStatesPost(provinceState: ProvinceState): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/ProvinceStates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(provinceState);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvinceStatesPost(_response);
        });
    }

    protected processProvinceStatesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified ProvinceState.
     * @param provinceState The ProvinceState.
     */
    provinceStatesPut(provinceState: ProvinceState): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/ProvinceStates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(provinceState);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processProvinceStatesPut(_response);
        });
    }

    protected processProvinceStatesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TermsAndConditionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    all(): Promise<TermsAndCondition[]> {
        let url_ = this.baseUrl + "/api/v1/Types/TermsAndConditions/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<TermsAndCondition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TermsAndCondition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TermsAndCondition[]>(null as any);
    }

    /**
     * Gets the name of the by.
     * @param name The name.
     */
    byName(name: string, apiKey: string): Promise<TermsAndCondition> {
        let url_ = this.baseUrl + "/api/v1/Types/TermsAndConditions/ByName/{name}/{apiKey}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByName(_response);
        });
    }

    protected processByName(response: Response): Promise<TermsAndCondition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermsAndCondition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TermsAndCondition>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param termsAndConditionID The identifier.
     */
    termsAndConditionsGet(termsAndConditionID: string): Promise<TermsAndCondition> {
        let url_ = this.baseUrl + "/api/v1/Types/TermsAndConditions/{termsAndConditionID}";
        if (termsAndConditionID === undefined || termsAndConditionID === null)
            throw new Error("The parameter 'termsAndConditionID' must be defined.");
        url_ = url_.replace("{termsAndConditionID}", encodeURIComponent("" + termsAndConditionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTermsAndConditionsGet(_response);
        });
    }

    protected processTermsAndConditionsGet(response: Response): Promise<TermsAndCondition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermsAndCondition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TermsAndCondition>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param termsAndConditionID The identifier.
     */
    termsAndConditionsDelete(termsAndConditionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/TermsAndConditions/{termsAndConditionID}";
        if (termsAndConditionID === undefined || termsAndConditionID === null)
            throw new Error("The parameter 'termsAndConditionID' must be defined.");
        url_ = url_.replace("{termsAndConditionID}", encodeURIComponent("" + termsAndConditionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTermsAndConditionsDelete(_response);
        });
    }

    protected processTermsAndConditionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified TermsAndCondition.
     * @param termsAndCondition The TermsAndCondition.
     */
    termsAndConditionsPost(termsAndCondition: TermsAndCondition): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/TermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(termsAndCondition);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTermsAndConditionsPost(_response);
        });
    }

    protected processTermsAndConditionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified TermsAndCondition.
     * @param termsAndCondition The TermsAndCondition.
     */
    termsAndConditionsPut(termsAndCondition: TermsAndCondition): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/TermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(termsAndCondition);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTermsAndConditionsPut(_response);
        });
    }

    protected processTermsAndConditionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Generate a contract for an onboarding
     */
    generateContract(generateContractDetail: GenerateContractDetails): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/Types/TermsAndConditions/GenerateContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(generateContractDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGenerateContract(_response);
        });
    }

    protected processGenerateContract(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }
}

export class UniversitiesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets all.
     */
    byCountryID(countryID: string): Promise<University[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Universities/ByCountryID/{countryID}";
        if (countryID === undefined || countryID === null)
            throw new Error("The parameter 'countryID' must be defined.");
        url_ = url_.replace("{countryID}", encodeURIComponent("" + countryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByCountryID(_response);
        });
    }

    protected processByCountryID(response: Response): Promise<University[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(University.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<University[]>(null as any);
    }

    /**
     * Gets the admin all.
     */
    admin(): Promise<University[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Universities/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processAdmin(_response);
        });
    }

    protected processAdmin(response: Response): Promise<University[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(University.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<University[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param universityID The identifier.
     */
    universitiesGet(universityID: string): Promise<University> {
        let url_ = this.baseUrl + "/api/v1/Types/Universities/{universityID}";
        if (universityID === undefined || universityID === null)
            throw new Error("The parameter 'universityID' must be defined.");
        url_ = url_.replace("{universityID}", encodeURIComponent("" + universityID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUniversitiesGet(_response);
        });
    }

    protected processUniversitiesGet(response: Response): Promise<University> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = University.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<University>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param universityID The identifier.
     */
    universitiesDelete(universityID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/Types/Universities/{universityID}";
        if (universityID === undefined || universityID === null)
            throw new Error("The parameter 'universityID' must be defined.");
        url_ = url_.replace("{universityID}", encodeURIComponent("" + universityID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUniversitiesDelete(_response);
        });
    }

    protected processUniversitiesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified University.
     * @param university The University.
     */
    universitiesPost(university: University): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/Universities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(university);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUniversitiesPost(_response);
        });
    }

    protected processUniversitiesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified University.
     * @param university The University.
     */
    universitiesPut(university: University): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/Types/Universities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(university);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUniversitiesPut(_response);
        });
    }

    protected processUniversitiesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param universities The universities.
     */
    manyPost(universities: University[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Universities/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(universities);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPost(_response);
        });
    }

    protected processManyPost(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Puts the many.
     * @param universities The universities.
     */
    manyPut(universities: University[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Types/Universities/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(universities);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processManyPut(_response);
        });
    }

    protected processManyPut(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class TagsEngineClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Creates a tag
     */
    create(payload: CreateTagPayload): Promise<TagModel> {
        let url_ = this.baseUrl + "/api/v1/TagsEngine/Tags/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TagModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagModel>(null as any);
    }

    /**
     * Create tags in bulk
     */
    createBulk(payload: CreateTagsPayload): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TagsEngine/Tags/CreateBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCreateBulk(_response);
        });
    }

    protected processCreateBulk(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Tags paginated
     * @param searchKey (optional) 
     * @param tagType (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    getAll(searchKey?: string | null | undefined, tagType?: TagTypeEnums | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Promise<PaginatedOfTagModel> {
        let url_ = this.baseUrl + "/api/v1/TagsEngine/Tags/GetAll?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (tagType === null)
            throw new Error("The parameter 'tagType' cannot be null.");
        else if (tagType !== undefined)
            url_ += "TagType=" + encodeURIComponent("" + tagType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PaginatedOfTagModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedOfTagModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedOfTagModel>(null as any);
    }

    /**
     * Get Tags by Id
     * @param includeRelatedTags (optional) 
     */
    tags(tagId: string, includeRelatedTags?: boolean | undefined): Promise<TagSearchModel> {
        let url_ = this.baseUrl + "/api/v1/TagsEngine/Tags/{tagId}?";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (includeRelatedTags === null)
            throw new Error("The parameter 'includeRelatedTags' cannot be null.");
        else if (includeRelatedTags !== undefined)
            url_ += "includeRelatedTags=" + encodeURIComponent("" + includeRelatedTags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processTags(_response);
        });
    }

    protected processTags(response: Response): Promise<TagSearchModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagSearchModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagSearchModel>(null as any);
    }

    /**
     * Upload tags data from a customized excel workbook
     * @param dataFile (optional) 
     */
    upload(dataFile?: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/TagsEngine/Tags/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dataFile !== null && dataFile !== undefined)
            content_.append("DataFile", dataFile.data, dataFile.fileName ? dataFile.fileName : "DataFile");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Tag Categories paginated
     * @param searchKey (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     */
    getAllCategories(searchKey?: string | null | undefined, pageNumber?: number | undefined, pageSize?: number | undefined): Promise<PaginatedOfTagCategoryModel> {
        let url_ = this.baseUrl + "/api/v1/TagsEngine/Categories/GetAllCategories?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processGetAllCategories(_response);
        });
    }

    protected processGetAllCategories(response: Response): Promise<PaginatedOfTagCategoryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedOfTagCategoryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedOfTagCategoryModel>(null as any);
    }

    /**
     * Get Tag Category by Id
     */
    categories(categoryId: string): Promise<TagCategoryModel> {
        let url_ = this.baseUrl + "/api/v1/TagsEngine/Categories/{categoryId}";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processCategories(_response);
        });
    }

    protected processCategories(response: Response): Promise<TagCategoryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagCategoryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagCategoryModel>(null as any);
    }
}

export class PHRAdvancedCareDirectivesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRAdvancedCareDirectiveID The identifier.
     */
    pHRAdvancedCareDirectivesGet(patientID: string, pHRAdvancedCareDirectiveID: string): Promise<PHRAdvancedCareDirective> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAdvancedCareDirectives/{patientID}/{pHRAdvancedCareDirectiveID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRAdvancedCareDirectiveID === undefined || pHRAdvancedCareDirectiveID === null)
            throw new Error("The parameter 'pHRAdvancedCareDirectiveID' must be defined.");
        url_ = url_.replace("{pHRAdvancedCareDirectiveID}", encodeURIComponent("" + pHRAdvancedCareDirectiveID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRAdvancedCareDirectivesGet(_response);
        });
    }

    protected processPHRAdvancedCareDirectivesGet(response: Response): Promise<PHRAdvancedCareDirective> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRAdvancedCareDirective.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRAdvancedCareDirective>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRAdvancedCareDirectiveID The identifier.
     */
    pHRAdvancedCareDirectivesDelete(patientID: string, pHRAdvancedCareDirectiveID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAdvancedCareDirectives/{patientID}/{pHRAdvancedCareDirectiveID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRAdvancedCareDirectiveID === undefined || pHRAdvancedCareDirectiveID === null)
            throw new Error("The parameter 'pHRAdvancedCareDirectiveID' must be defined.");
        url_ = url_.replace("{pHRAdvancedCareDirectiveID}", encodeURIComponent("" + pHRAdvancedCareDirectiveID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRAdvancedCareDirectivesDelete(_response);
        });
    }

    protected processPHRAdvancedCareDirectivesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phradvancedcaredirective.
     * @param patientID The patient identifier.
     * @param pHRAdvancedCareDirectiveID The p hr advanced care directive identifier.
     */
    verify(patientID: string, pHRAdvancedCareDirectiveID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAdvancedCareDirectives/{patientID}/{pHRAdvancedCareDirectiveID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRAdvancedCareDirectiveID === undefined || pHRAdvancedCareDirectiveID === null)
            throw new Error("The parameter 'pHRAdvancedCareDirectiveID' must be defined.");
        url_ = url_.replace("{pHRAdvancedCareDirectiveID}", encodeURIComponent("" + pHRAdvancedCareDirectiveID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRAdvancedCareDirective[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAdvancedCareDirectives/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRAdvancedCareDirective[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRAdvancedCareDirective.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRAdvancedCareDirective[]>(null as any);
    }

    /**
     * Posts the specified PHRAdvancedCareDirective.
     * @param pHRAdvancedCareDirective The PHRAdvancedCareDirective.
     */
    pHRAdvancedCareDirectivesPost(pHRAdvancedCareDirective: PHRAdvancedCareDirective): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAdvancedCareDirectives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRAdvancedCareDirective);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRAdvancedCareDirectivesPost(_response);
        });
    }

    protected processPHRAdvancedCareDirectivesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRAdvancedCareDirective.
     * @param pHRAdvancedCareDirective The PHRAdvancedCareDirective.
     */
    pHRAdvancedCareDirectivesPut(pHRAdvancedCareDirective: PHRAdvancedCareDirective): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAdvancedCareDirectives";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRAdvancedCareDirective);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRAdvancedCareDirectivesPut(_response);
        });
    }

    protected processPHRAdvancedCareDirectivesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRAllergiesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRAllergyID The identifier.
     */
    pHRAllergiesGet(patientID: string, pHRAllergyID: string): Promise<PHRAllergy> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAllergies/{patientID}/{pHRAllergyID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRAllergyID === undefined || pHRAllergyID === null)
            throw new Error("The parameter 'pHRAllergyID' must be defined.");
        url_ = url_.replace("{pHRAllergyID}", encodeURIComponent("" + pHRAllergyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRAllergiesGet(_response);
        });
    }

    protected processPHRAllergiesGet(response: Response): Promise<PHRAllergy> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRAllergy.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRAllergy>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRAllergyID The identifier.
     */
    pHRAllergiesDelete(patientID: string, pHRAllergyID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAllergies/{patientID}/{pHRAllergyID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRAllergyID === undefined || pHRAllergyID === null)
            throw new Error("The parameter 'pHRAllergyID' must be defined.");
        url_ = url_.replace("{pHRAllergyID}", encodeURIComponent("" + pHRAllergyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRAllergiesDelete(_response);
        });
    }

    protected processPHRAllergiesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrAllergy.
     * @param patientID The patient identifier.
     * @param pHRAllergyID The PHRAllergyID.
     */
    verify(patientID: string, pHRAllergyID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAllergies/{patientID}/{pHRAllergyID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRAllergyID === undefined || pHRAllergyID === null)
            throw new Error("The parameter 'pHRAllergyID' must be defined.");
        url_ = url_.replace("{pHRAllergyID}", encodeURIComponent("" + pHRAllergyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRAllergy[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAllergies/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRAllergy[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRAllergy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRAllergy[]>(null as any);
    }

    /**
     * Posts the specified PHRAllergy.
     * @param pHRAllergy The PHRAllergy.
     */
    pHRAllergiesPost(pHRAllergy: PHRAllergy): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAllergies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRAllergy);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRAllergiesPost(_response);
        });
    }

    protected processPHRAllergiesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRAllergy.
     * @param pHRAllergy The PHRAllergy.
     */
    pHRAllergiesPut(pHRAllergy: PHRAllergy): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRAllergies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRAllergy);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRAllergiesPut(_response);
        });
    }

    protected processPHRAllergiesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRCarePlansClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRCarePlanID The identifier.
     */
    pHRCarePlansGet(patientID: string, pHRCarePlanID: string): Promise<PHRCarePlan> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRCarePlans/{patientID}/{pHRCarePlanID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRCarePlanID === undefined || pHRCarePlanID === null)
            throw new Error("The parameter 'pHRCarePlanID' must be defined.");
        url_ = url_.replace("{pHRCarePlanID}", encodeURIComponent("" + pHRCarePlanID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRCarePlansGet(_response);
        });
    }

    protected processPHRCarePlansGet(response: Response): Promise<PHRCarePlan> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRCarePlan.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRCarePlan>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRCarePlanID The identifier.
     */
    pHRCarePlansDelete(patientID: string, pHRCarePlanID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRCarePlans/{patientID}/{pHRCarePlanID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRCarePlanID === undefined || pHRCarePlanID === null)
            throw new Error("The parameter 'pHRCarePlanID' must be defined.");
        url_ = url_.replace("{pHRCarePlanID}", encodeURIComponent("" + pHRCarePlanID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRCarePlansDelete(_response);
        });
    }

    protected processPHRCarePlansDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrCarePlan.
     * @param patientID The patient identifier.
     * @param pHRCarePlanID The PHRCarePlanID.
     */
    verify(patientID: string, pHRCarePlanID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRCarePlans/{patientID}/{pHRCarePlanID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRCarePlanID === undefined || pHRCarePlanID === null)
            throw new Error("The parameter 'pHRCarePlanID' must be defined.");
        url_ = url_.replace("{pHRCarePlanID}", encodeURIComponent("" + pHRCarePlanID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRCarePlan[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRCarePlans/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRCarePlan[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRCarePlan.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRCarePlan[]>(null as any);
    }

    /**
     * Posts the specified PHRCarePlan.
     * @param pHRCarePlan The PHRCarePlan.
     */
    pHRCarePlansPost(pHRCarePlan: PHRCarePlan): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRCarePlans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRCarePlan);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRCarePlansPost(_response);
        });
    }

    protected processPHRCarePlansPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRCarePlan.
     * @param pHRCarePlan The PHRCarePlan.
     */
    pHRCarePlansPut(pHRCarePlan: PHRCarePlan): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRCarePlans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRCarePlan);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRCarePlansPut(_response);
        });
    }

    protected processPHRCarePlansPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRClinicalTrialsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRClinicalTrialID The identifier.
     */
    pHRClinicalTrialsGet(patientID: string, pHRClinicalTrialID: string): Promise<PHRClinicalTrial> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRClinicalTrials/{patientID}/{pHRClinicalTrialID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRClinicalTrialID === undefined || pHRClinicalTrialID === null)
            throw new Error("The parameter 'pHRClinicalTrialID' must be defined.");
        url_ = url_.replace("{pHRClinicalTrialID}", encodeURIComponent("" + pHRClinicalTrialID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRClinicalTrialsGet(_response);
        });
    }

    protected processPHRClinicalTrialsGet(response: Response): Promise<PHRClinicalTrial> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRClinicalTrial.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRClinicalTrial>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRClinicalTrialID The identifier.
     */
    pHRClinicalTrialsDelete(patientID: string, pHRClinicalTrialID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRClinicalTrials/{patientID}/{pHRClinicalTrialID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRClinicalTrialID === undefined || pHRClinicalTrialID === null)
            throw new Error("The parameter 'pHRClinicalTrialID' must be defined.");
        url_ = url_.replace("{pHRClinicalTrialID}", encodeURIComponent("" + pHRClinicalTrialID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRClinicalTrialsDelete(_response);
        });
    }

    protected processPHRClinicalTrialsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrClinicalTrial.
     * @param patientID The patient identifier.
     * @param pHRClinicalTrialID The PHRClinicalTrialID.
     */
    verify(patientID: string, pHRClinicalTrialID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRClinicalTrials/{patientID}/{pHRClinicalTrialID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRClinicalTrialID === undefined || pHRClinicalTrialID === null)
            throw new Error("The parameter 'pHRClinicalTrialID' must be defined.");
        url_ = url_.replace("{pHRClinicalTrialID}", encodeURIComponent("" + pHRClinicalTrialID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by clinical trial identifier.
     * @param patientID The patient identifier.
     * @param clinicalTrialID The identifier.
     */
    byClinicalTrialID(patientID: string, clinicalTrialID: string): Promise<PHRClinicalTrial> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRClinicalTrials/{patientID}/ByClinicalTrialID/{clinicalTrialID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (clinicalTrialID === undefined || clinicalTrialID === null)
            throw new Error("The parameter 'clinicalTrialID' must be defined.");
        url_ = url_.replace("{clinicalTrialID}", encodeURIComponent("" + clinicalTrialID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByClinicalTrialID(_response);
        });
    }

    protected processByClinicalTrialID(response: Response): Promise<PHRClinicalTrial> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRClinicalTrial.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRClinicalTrial>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRClinicalTrial[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRClinicalTrials/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRClinicalTrial[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRClinicalTrial.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRClinicalTrial[]>(null as any);
    }

    /**
     * Posts the specified PatientClinicalTrial.
     * @param pHRClinicalTrial The PHRClinicalTrial.
     */
    pHRClinicalTrialsPost(pHRClinicalTrial: PHRClinicalTrial): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRClinicalTrials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRClinicalTrial);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRClinicalTrialsPost(_response);
        });
    }

    protected processPHRClinicalTrialsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientClinicalTrial.
     * @param pHRClinicalTrial The PHRClinicalTrial.
     */
    pHRClinicalTrialsPut(pHRClinicalTrial: PHRClinicalTrial): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRClinicalTrials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRClinicalTrial);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRClinicalTrialsPut(_response);
        });
    }

    protected processPHRClinicalTrialsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRConsultsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRConsultID The identifier.
     */
    pHRConsultsGet(patientID: string, pHRConsultID: string): Promise<PHRConsult> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults/{patientID}/{pHRConsultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRConsultID === undefined || pHRConsultID === null)
            throw new Error("The parameter 'pHRConsultID' must be defined.");
        url_ = url_.replace("{pHRConsultID}", encodeURIComponent("" + pHRConsultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultsGet(_response);
        });
    }

    protected processPHRConsultsGet(response: Response): Promise<PHRConsult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRConsult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRConsult>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRConsultID The identifier.
     */
    pHRConsultsDelete(patientID: string, pHRConsultID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults/{patientID}/{pHRConsultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRConsultID === undefined || pHRConsultID === null)
            throw new Error("The parameter 'pHRConsultID' must be defined.");
        url_ = url_.replace("{pHRConsultID}", encodeURIComponent("" + pHRConsultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultsDelete(_response);
        });
    }

    protected processPHRConsultsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by consult identifier.
     * @param patientID The patient identifier.
     * @param consultID The consult identifier.
     */
    byConsultID(patientID: string, consultID: string): Promise<PHRConsult> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults/{patientID}/ByConsultID/{consultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (consultID === undefined || consultID === null)
            throw new Error("The parameter 'consultID' must be defined.");
        url_ = url_.replace("{consultID}", encodeURIComponent("" + consultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByConsultID(_response);
        });
    }

    protected processByConsultID(response: Response): Promise<PHRConsult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRConsult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRConsult>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRConsult[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRConsult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRConsult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRConsult[]>(null as any);
    }

    /**
     * Gets the by preceptor user detail identifier.
     * @param userDetailID The user detail identifier.
     */
    byPreceptor(userDetailID: string): Promise<PHRConsult[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults/ByPreceptor/{userDetailID}";
        if (userDetailID === undefined || userDetailID === null)
            throw new Error("The parameter 'userDetailID' must be defined.");
        url_ = url_.replace("{userDetailID}", encodeURIComponent("" + userDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPreceptor(_response);
        });
    }

    protected processByPreceptor(response: Response): Promise<PHRConsult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRConsult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRConsult[]>(null as any);
    }

    /**
     * Gets the previous consults.
     * @param pHRPreviousConsultsDetails The p hr previous consults details.
     */
    previousConsults(pHRPreviousConsultsDetails: PHRPreviousConsultDetails): Promise<PHRConsultDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults/PreviousConsults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRPreviousConsultsDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPreviousConsults(_response);
        });
    }

    protected processPreviousConsults(response: Response): Promise<PHRConsultDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRConsultDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRConsultDTO[]>(null as any);
    }

    /**
     * Posts the specified p hr consult.
     * @param pHRConsult The p hr consult.
     */
    pHRConsultsPost(pHRConsult: PHRConsult): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRConsult);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultsPost(_response);
        });
    }

    protected processPHRConsultsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRConsult.
     * @param pHRConsult The PHRConsult.
     */
    pHRConsultsPut(pHRConsult: PHRConsult): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRConsult);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultsPut(_response);
        });
    }

    protected processPHRConsultsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the PHR consult search.
     * @param pHRConsultSearchDetails The p hr consult search details.
     */
    search(pHRConsultSearchDetails: PHRConsultSearchDetails): Promise<PHRConsultSearchResults> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRConsultSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<PHRConsultSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRConsultSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRConsultSearchResults>(null as any);
    }

    /**
     * Gets the historical by preceptor asynchronous.
     * @param pHRConsultSearchDetails The p hr consult search details.
     */
    historicalPHRConsultsSearch(pHRConsultSearchDetails: PHRConsultSearchDetails): Promise<PHRConsultSearchResults> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsults/HistoricalPHRConsultsSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRConsultSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processHistoricalPHRConsultsSearch(_response);
        });
    }

    protected processHistoricalPHRConsultsSearch(response: Response): Promise<PHRConsultSearchResults> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRConsultSearchResults.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRConsultSearchResults>(null as any);
    }
}

export class PHRConsultTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRConsultTagID The identifier.
     */
    pHRConsultTagsGet(patientID: string, pHRConsultTagID: string): Promise<PHRConsultTag> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsultTags/{patientID}/{pHRConsultTagID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRConsultTagID === undefined || pHRConsultTagID === null)
            throw new Error("The parameter 'pHRConsultTagID' must be defined.");
        url_ = url_.replace("{pHRConsultTagID}", encodeURIComponent("" + pHRConsultTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultTagsGet(_response);
        });
    }

    protected processPHRConsultTagsGet(response: Response): Promise<PHRConsultTag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRConsultTag.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRConsultTag>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRConsultTagID The identifier.
     */
    pHRConsultTagsDelete(patientID: string, pHRConsultTagID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsultTags/{patientID}/{pHRConsultTagID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRConsultTagID === undefined || pHRConsultTagID === null)
            throw new Error("The parameter 'pHRConsultTagID' must be defined.");
        url_ = url_.replace("{pHRConsultTagID}", encodeURIComponent("" + pHRConsultTagID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultTagsDelete(_response);
        });
    }

    protected processPHRConsultTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified PHRConsultTag.
     * @param patientID The patient identifier.
     * @param pHRConsultTag The PHRConsultTag.
     */
    pHRConsultTagsPost(patientID: string, pHRConsultTag: PHRConsultTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsultTags/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRConsultTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultTagsPost(_response);
        });
    }

    protected processPHRConsultTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRConsultTag.
     * @param patientID The patient identifier.
     * @param pHRConsultTag The PHRConsultTag.
     */
    pHRConsultTagsPut(patientID: string, pHRConsultTag: PHRConsultTag): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsultTags/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRConsultTag);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultTagsPut(_response);
        });
    }

    protected processPHRConsultTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param patientID The patient identifier.
     * @param phrConsultID The PHR consult identifier.
     * @param pHRConsultTags The PHRConsultTags.
     */
    many(patientID: string, phrConsultID: string, pHRConsultTags: PHRConsultTag[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRConsultTags/{patientID}/{phrConsultID}/Many";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrConsultID === undefined || phrConsultID === null)
            throw new Error("The parameter 'phrConsultID' must be defined.");
        url_ = url_.replace("{phrConsultID}", encodeURIComponent("" + phrConsultID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRConsultTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class PHRDocumentsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRDocumentID The identifier.
     */
    pHRDocumentsGet(patientID: string, pHRDocumentID: string): Promise<PHRDocument> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/{pHRDocumentID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRDocumentID === undefined || pHRDocumentID === null)
            throw new Error("The parameter 'pHRDocumentID' must be defined.");
        url_ = url_.replace("{pHRDocumentID}", encodeURIComponent("" + pHRDocumentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRDocumentsGet(_response);
        });
    }

    protected processPHRDocumentsGet(response: Response): Promise<PHRDocument> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRDocument.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRDocument>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRDocumentID The identifier.
     */
    pHRDocumentsDelete(patientID: string, pHRDocumentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/{pHRDocumentID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRDocumentID === undefined || pHRDocumentID === null)
            throw new Error("The parameter 'pHRDocumentID' must be defined.");
        url_ = url_.replace("{pHRDocumentID}", encodeURIComponent("" + pHRDocumentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRDocumentsDelete(_response);
        });
    }

    protected processPHRDocumentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRDocument[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRDocument.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRDocument[]>(null as any);
    }

    /**
     * Uploads the PHR document.
     * @param pHRDocumentUploadDetails The p hr document upload details.
     */
    uploadPHRDocument(pHRDocumentUploadDetails: PHRDocumentUploadDetails): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/uploadPHRDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRDocumentUploadDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processUploadPHRDocument(_response);
        });
    }

    protected processUploadPHRDocument(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Downloads the file.
     * @param patientID The patient identifier.
     * @param documentID The document identifier.
     */
    download(patientID: string, documentID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/download/{documentID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Return File Content Result for the Document
     * @param patientID The patient identifier.
     * @param documentID The document identifier.
     */
    downloadFileDetail(patientID: string, documentID: string): Promise<FileDetail> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/DownloadFileDetail/{documentID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDownloadFileDetail(_response);
        });
    }

    protected processDownloadFileDetail(response: Response): Promise<FileDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDetail>(null as any);
    }

    /**
     * Posts the specified PHRDocument.
     * @param pHRDocument The PHRDocument.
     */
    pHRDocumentsPost(pHRDocument: PHRDocument): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRDocument);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRDocumentsPost(_response);
        });
    }

    protected processPHRDocumentsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRDocument.
     * @param pHRDocument The PHRDocument.
     */
    pHRDocumentsPut(pHRDocument: PHRDocument): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRDocument);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRDocumentsPut(_response);
        });
    }

    protected processPHRDocumentsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Return File Content Result for the Document
     * @param patientID The patient identifier.
     * @param phrConsultID The document identifier.
     */
    byPHRConsultID(patientID: string, phrConsultID: string): Promise<PHRDocument[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/ByPHRConsultID/{phrConsultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrConsultID === undefined || phrConsultID === null)
            throw new Error("The parameter 'phrConsultID' must be defined.");
        url_ = url_.replace("{phrConsultID}", encodeURIComponent("" + phrConsultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPHRConsultID(_response);
        });
    }

    protected processByPHRConsultID(response: Response): Promise<PHRDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRDocument.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRDocument[]>(null as any);
    }

    /**
     * Return File Content Result for AssociatedID
     * @param patientID The patient identifier.
     */
    byAssociatedID(patientID: string, associatedID: string): Promise<PHRDocument[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/ByAssociatedID/{associatedID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (associatedID === undefined || associatedID === null)
            throw new Error("The parameter 'associatedID' must be defined.");
        url_ = url_.replace("{associatedID}", encodeURIComponent("" + associatedID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByAssociatedID(_response);
        });
    }

    protected processByAssociatedID(response: Response): Promise<PHRDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRDocument.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRDocument[]>(null as any);
    }

    /**
     * Return File Content Result for the Document
     * @param patientID The patient identifier.
     * @param phrHealthJournalID The Health Journal ID.
     */
    byPHRHealthJournalID(patientID: string, phrHealthJournalID: string): Promise<PHRDocument[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/ByPHRHealthJournalID/{phrHealthJournalID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrHealthJournalID === undefined || phrHealthJournalID === null)
            throw new Error("The parameter 'phrHealthJournalID' must be defined.");
        url_ = url_.replace("{phrHealthJournalID}", encodeURIComponent("" + phrHealthJournalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPHRHealthJournalID(_response);
        });
    }

    protected processByPHRHealthJournalID(response: Response): Promise<PHRDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRDocument.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRDocument[]>(null as any);
    }

    /**
     * Mark a PHRDocument as viewed by the patient
     */
    viewed(patientID: string, documentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/Viewed/{documentID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (documentID === undefined || documentID === null)
            throw new Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processViewed(_response);
        });
    }

    protected processViewed(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Downloads the document as src
     */
    documentAsSrc(patientID: string, phrDocumentID: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRDocuments/{patientID}/DocumentAsSrc/{phrDocumentID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrDocumentID === undefined || phrDocumentID === null)
            throw new Error("The parameter 'phrDocumentID' must be defined.");
        url_ = url_.replace("{phrDocumentID}", encodeURIComponent("" + phrDocumentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processDocumentAsSrc(_response);
        });
    }

    protected processDocumentAsSrc(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PHRFamilyHistoriesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRFamilyHistoryID The identifier.
     */
    pHRFamilyHistoriesGet(patientID: string, pHRFamilyHistoryID: string): Promise<PHRFamilyHistory> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFamilyHistories/{patientID}/{pHRFamilyHistoryID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFamilyHistoryID === undefined || pHRFamilyHistoryID === null)
            throw new Error("The parameter 'pHRFamilyHistoryID' must be defined.");
        url_ = url_.replace("{pHRFamilyHistoryID}", encodeURIComponent("" + pHRFamilyHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFamilyHistoriesGet(_response);
        });
    }

    protected processPHRFamilyHistoriesGet(response: Response): Promise<PHRFamilyHistory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRFamilyHistory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRFamilyHistory>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRFamilyHistoryID The identifier.
     */
    pHRFamilyHistoriesDelete(patientID: string, pHRFamilyHistoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFamilyHistories/{patientID}/{pHRFamilyHistoryID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFamilyHistoryID === undefined || pHRFamilyHistoryID === null)
            throw new Error("The parameter 'pHRFamilyHistoryID' must be defined.");
        url_ = url_.replace("{pHRFamilyHistoryID}", encodeURIComponent("" + pHRFamilyHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFamilyHistoriesDelete(_response);
        });
    }

    protected processPHRFamilyHistoriesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrFamilyHistory.
     * @param patientID The patient identifier.
     * @param pHRFamilyHistoryID The PHRFamilyHistoryID.
     */
    verify(patientID: string, pHRFamilyHistoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFamilyHistories/{patientID}/{pHRFamilyHistoryID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFamilyHistoryID === undefined || pHRFamilyHistoryID === null)
            throw new Error("The parameter 'pHRFamilyHistoryID' must be defined.");
        url_ = url_.replace("{pHRFamilyHistoryID}", encodeURIComponent("" + pHRFamilyHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRFamilyHistory[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFamilyHistories/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRFamilyHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRFamilyHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRFamilyHistory[]>(null as any);
    }

    /**
     * Posts the specified PHRFamilyHistory.
     * @param pHRFamilyHistory The PHRFamilyHistory.
     */
    pHRFamilyHistoriesPost(pHRFamilyHistory: PHRFamilyHistory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFamilyHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRFamilyHistory);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFamilyHistoriesPost(_response);
        });
    }

    protected processPHRFamilyHistoriesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRFamilyHistory.
     * @param pHRFamilyHistory The PHRFamilyHistory.
     */
    pHRFamilyHistoriesPut(pHRFamilyHistory: PHRFamilyHistory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFamilyHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRFamilyHistory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFamilyHistoriesPut(_response);
        });
    }

    protected processPHRFamilyHistoriesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRFormsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRFormID The identifier.
     */
    pHRFormsGet(patientID: string, pHRFormID: string): Promise<PHRForm> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms/{patientID}/{pHRFormID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFormID === undefined || pHRFormID === null)
            throw new Error("The parameter 'pHRFormID' must be defined.");
        url_ = url_.replace("{pHRFormID}", encodeURIComponent("" + pHRFormID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFormsGet(_response);
        });
    }

    protected processPHRFormsGet(response: Response): Promise<PHRForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRForm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRForm>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRFormID The identifier.
     */
    pHRFormsDelete(patientID: string, pHRFormID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms/{patientID}/{pHRFormID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFormID === undefined || pHRFormID === null)
            throw new Error("The parameter 'pHRFormID' must be defined.");
        url_ = url_.replace("{pHRFormID}", encodeURIComponent("" + pHRFormID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFormsDelete(_response);
        });
    }

    protected processPHRFormsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by clinical trial identifier.
     * @param patientID The patient identifier.
     * @param formID The identifier.
     */
    byFormID(patientID: string, formID: string): Promise<PHRForm> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms/{patientID}/ByFormID/{FormID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (formID === undefined || formID === null)
            throw new Error("The parameter 'formID' must be defined.");
        url_ = url_.replace("{FormID}", encodeURIComponent("" + formID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByFormID(_response);
        });
    }

    protected processByFormID(response: Response): Promise<PHRForm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRForm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRForm>(null as any);
    }

    /**
     * Gets the by PHRConsultID
     * @param patientID The patient identifier.
     * @param phrConsultID The identifier.
     */
    pHRConsultID(patientID: string, phrConsultID: string): Promise<PHRForm[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms/{patientID}/PHRConsultID/{phrConsultID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrConsultID === undefined || phrConsultID === null)
            throw new Error("The parameter 'phrConsultID' must be defined.");
        url_ = url_.replace("{phrConsultID}", encodeURIComponent("" + phrConsultID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRConsultID(_response);
        });
    }

    protected processPHRConsultID(response: Response): Promise<PHRForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRForm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRForm[]>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRForm[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRForm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRForm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRForm[]>(null as any);
    }

    /**
     * Posts the specified PatientForm.
     * @param pHRForm The PHRForm.
     */
    pHRFormsPost(pHRForm: PHRForm): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRForm);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFormsPost(_response);
        });
    }

    protected processPHRFormsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PatientForm.
     * @param pHRForm The PHRForm.
     */
    pHRFormsPut(pHRForm: PHRForm): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRForm);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFormsPut(_response);
        });
    }

    protected processPHRFormsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Evaluate the score on the form
     */
    scoreForm(patientID: string, phrFormID: string): Promise<ScoreFormResult> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms/ScoreForm/{patientID}/{phrFormID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrFormID === undefined || phrFormID === null)
            throw new Error("The parameter 'phrFormID' must be defined.");
        url_ = url_.replace("{phrFormID}", encodeURIComponent("" + phrFormID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processScoreForm(_response);
        });
    }

    protected processScoreForm(response: Response): Promise<ScoreFormResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScoreFormResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScoreFormResult>(null as any);
    }

    /**
     * Verifies the specified phrForm.
     * @param patientID The patient identifier.
     * @param pHRFormID The PHRFormID.
     */
    verify(patientID: string, pHRFormID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRForms/{patientID}/{pHRFormID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFormID === undefined || pHRFormID === null)
            throw new Error("The parameter 'pHRFormID' must be defined.");
        url_ = url_.replace("{pHRFormID}", encodeURIComponent("" + pHRFormID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PHRFunctionalsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRFunctionalID The identifier.
     */
    pHRFunctionalsGet(patientID: string, pHRFunctionalID: string): Promise<PHRFunctional> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFunctionals/{patientID}/{pHRFunctionalID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFunctionalID === undefined || pHRFunctionalID === null)
            throw new Error("The parameter 'pHRFunctionalID' must be defined.");
        url_ = url_.replace("{pHRFunctionalID}", encodeURIComponent("" + pHRFunctionalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFunctionalsGet(_response);
        });
    }

    protected processPHRFunctionalsGet(response: Response): Promise<PHRFunctional> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRFunctional.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRFunctional>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRFunctionalID The identifier.
     */
    pHRFunctionalsDelete(patientID: string, pHRFunctionalID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFunctionals/{patientID}/{pHRFunctionalID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFunctionalID === undefined || pHRFunctionalID === null)
            throw new Error("The parameter 'pHRFunctionalID' must be defined.");
        url_ = url_.replace("{pHRFunctionalID}", encodeURIComponent("" + pHRFunctionalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFunctionalsDelete(_response);
        });
    }

    protected processPHRFunctionalsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrFunctional.
     * @param patientID The patient identifier.
     * @param pHRFunctionalID The PHRFunctionalID.
     */
    verify(patientID: string, pHRFunctionalID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFunctionals/{patientID}/{pHRFunctionalID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRFunctionalID === undefined || pHRFunctionalID === null)
            throw new Error("The parameter 'pHRFunctionalID' must be defined.");
        url_ = url_.replace("{pHRFunctionalID}", encodeURIComponent("" + pHRFunctionalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRFunctional[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFunctionals/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRFunctional[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRFunctional.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRFunctional[]>(null as any);
    }

    /**
     * Posts the specified PHRFunctional.
     * @param pHRFunctional The PHRFunctional.
     */
    pHRFunctionalsPost(pHRFunctional: PHRFunctional): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFunctionals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRFunctional);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFunctionalsPost(_response);
        });
    }

    protected processPHRFunctionalsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRFunctional.
     * @param pHRFunctional The PHRFunctional.
     */
    pHRFunctionalsPut(pHRFunctional: PHRFunctional): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRFunctionals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRFunctional);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRFunctionalsPut(_response);
        });
    }

    protected processPHRFunctionalsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRHealthConditionsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHealthConditionID The identifier.
     */
    pHRHealthConditionsGet(patientID: string, pHRHealthConditionID: string): Promise<PHRHealthCondition> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditions/{patientID}/{pHRHealthConditionID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthConditionID === undefined || pHRHealthConditionID === null)
            throw new Error("The parameter 'pHRHealthConditionID' must be defined.");
        url_ = url_.replace("{pHRHealthConditionID}", encodeURIComponent("" + pHRHealthConditionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthConditionsGet(_response);
        });
    }

    protected processPHRHealthConditionsGet(response: Response): Promise<PHRHealthCondition> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRHealthCondition.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHealthCondition>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHealthConditionID The identifier.
     */
    pHRHealthConditionsDelete(patientID: string, pHRHealthConditionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditions/{patientID}/{pHRHealthConditionID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthConditionID === undefined || pHRHealthConditionID === null)
            throw new Error("The parameter 'pHRHealthConditionID' must be defined.");
        url_ = url_.replace("{pHRHealthConditionID}", encodeURIComponent("" + pHRHealthConditionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthConditionsDelete(_response);
        });
    }

    protected processPHRHealthConditionsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRHealthCondition[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditions/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRHealthCondition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRHealthCondition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHealthCondition[]>(null as any);
    }

    /**
     * Verifies the specified phrHealthCondition.
     * @param patientID The patient identifier.
     * @param pHRHealthConditionID The PHRHealthConditionID.
     */
    verify(patientID: string, pHRHealthConditionID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditions/{patientID}/{pHRHealthConditionID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthConditionID === undefined || pHRHealthConditionID === null)
            throw new Error("The parameter 'pHRHealthConditionID' must be defined.");
        url_ = url_.replace("{pHRHealthConditionID}", encodeURIComponent("" + pHRHealthConditionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified PHRHealthCondition.
     * @param pHRHealthCondition The PHRHealthCondition.
     */
    pHRHealthConditionsPost(pHRHealthCondition: PHRHealthCondition): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthCondition);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthConditionsPost(_response);
        });
    }

    protected processPHRHealthConditionsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRHealthCondition.
     * @param pHRHealthCondition The PHRHealthCondition.
     */
    pHRHealthConditionsPut(pHRHealthCondition: PHRHealthCondition): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthCondition);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthConditionsPut(_response);
        });
    }

    protected processPHRHealthConditionsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRHealthConditionTagsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHealthConditionTagsID The identifier.
     */
    pHRHealthConditionTagsGet(patientID: string, pHRHealthConditionTagsID: string): Promise<PHRHealthConditionTags> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditionTags/{patientID}/{pHRHealthConditionTagsID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthConditionTagsID === undefined || pHRHealthConditionTagsID === null)
            throw new Error("The parameter 'pHRHealthConditionTagsID' must be defined.");
        url_ = url_.replace("{pHRHealthConditionTagsID}", encodeURIComponent("" + pHRHealthConditionTagsID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthConditionTagsGet(_response);
        });
    }

    protected processPHRHealthConditionTagsGet(response: Response): Promise<PHRHealthConditionTags> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRHealthConditionTags.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHealthConditionTags>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHealthConditionTagsID The identifier.
     */
    pHRHealthConditionTagsDelete(patientID: string, pHRHealthConditionTagsID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditionTags/{patientID}/{pHRHealthConditionTagsID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthConditionTagsID === undefined || pHRHealthConditionTagsID === null)
            throw new Error("The parameter 'pHRHealthConditionTagsID' must be defined.");
        url_ = url_.replace("{pHRHealthConditionTagsID}", encodeURIComponent("" + pHRHealthConditionTagsID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthConditionTagsDelete(_response);
        });
    }

    protected processPHRHealthConditionTagsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRHealthConditionTags[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditionTags/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRHealthConditionTags[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRHealthConditionTags.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHealthConditionTags[]>(null as any);
    }

    /**
     * Verifies the specified phrHealthCondition.
     * @param patientID The patient identifier.
     * @param pHRHealthConditionTagsID The PHRHealthConditionID.
     */
    verify(patientID: string, pHRHealthConditionTagsID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditionTags/{patientID}/{pHRHealthConditionTagsID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthConditionTagsID === undefined || pHRHealthConditionTagsID === null)
            throw new Error("The parameter 'pHRHealthConditionTagsID' must be defined.");
        url_ = url_.replace("{pHRHealthConditionTagsID}", encodeURIComponent("" + pHRHealthConditionTagsID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified PHRHealthConditionTags.
     * @param pHRHealthConditionTags The PHRHealthConditionTags.
     */
    pHRHealthConditionTagsPost(pHRHealthConditionTags: PHRHealthConditionTags): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditionTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthConditionTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthConditionTagsPost(_response);
        });
    }

    protected processPHRHealthConditionTagsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRHealthConditionTags.
     * @param pHRHealthConditionTags The PHRHealthConditionTags.
     */
    pHRHealthConditionTagsPut(pHRHealthConditionTags: PHRHealthConditionTags): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditionTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthConditionTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthConditionTagsPut(_response);
        });
    }

    protected processPHRHealthConditionTagsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the many.
     * @param patientID The patient identifier.
     * @param pHRHealthConditionTags The PHRConsultTags.
     */
    many(patientID: string, pHRHealthConditionTags: PHRHealthConditionTags[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthConditionTags/{patientID}/Many";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthConditionTags);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class PHRHealthGoalsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHealthGoalID The identifier.
     */
    pHRHealthGoalsGet(patientID: string, pHRHealthGoalID: string): Promise<PHRHealthGoal> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthGoals/{patientID}/{pHRHealthGoalID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthGoalID === undefined || pHRHealthGoalID === null)
            throw new Error("The parameter 'pHRHealthGoalID' must be defined.");
        url_ = url_.replace("{pHRHealthGoalID}", encodeURIComponent("" + pHRHealthGoalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthGoalsGet(_response);
        });
    }

    protected processPHRHealthGoalsGet(response: Response): Promise<PHRHealthGoal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRHealthGoal.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHealthGoal>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHealthGoalID The identifier.
     */
    pHRHealthGoalsDelete(patientID: string, pHRHealthGoalID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthGoals/{patientID}/{pHRHealthGoalID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthGoalID === undefined || pHRHealthGoalID === null)
            throw new Error("The parameter 'pHRHealthGoalID' must be defined.");
        url_ = url_.replace("{pHRHealthGoalID}", encodeURIComponent("" + pHRHealthGoalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthGoalsDelete(_response);
        });
    }

    protected processPHRHealthGoalsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrHealthGoal.
     * @param patientID The patient identifier.
     * @param pHRHealthGoalID The PHRHealthGoalID.
     */
    verify(patientID: string, pHRHealthGoalID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthGoals/{patientID}/{pHRHealthGoalID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthGoalID === undefined || pHRHealthGoalID === null)
            throw new Error("The parameter 'pHRHealthGoalID' must be defined.");
        url_ = url_.replace("{pHRHealthGoalID}", encodeURIComponent("" + pHRHealthGoalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRHealthGoal[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthGoals/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRHealthGoal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRHealthGoal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHealthGoal[]>(null as any);
    }

    /**
     * Posts the specified PHRHealthGoal.
     * @param pHRHealthGoal The PHRHealthGoal.
     */
    pHRHealthGoalsPost(pHRHealthGoal: PHRHealthGoal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthGoals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthGoal);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthGoalsPost(_response);
        });
    }

    protected processPHRHealthGoalsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRHealthGoal.
     * @param pHRHealthGoal The PHRHealthGoal.
     */
    pHRHealthGoalsPut(pHRHealthGoal: PHRHealthGoal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthGoals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthGoal);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthGoalsPut(_response);
        });
    }

    protected processPHRHealthGoalsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRHealthJournalsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHealthJournalID The identifier.
     */
    pHRHealthJournalsGet(patientID: string, pHRHealthJournalID: string): Promise<PHRHealthJournal> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthJournals/{patientID}/{pHRHealthJournalID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthJournalID === undefined || pHRHealthJournalID === null)
            throw new Error("The parameter 'pHRHealthJournalID' must be defined.");
        url_ = url_.replace("{pHRHealthJournalID}", encodeURIComponent("" + pHRHealthJournalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthJournalsGet(_response);
        });
    }

    protected processPHRHealthJournalsGet(response: Response): Promise<PHRHealthJournal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRHealthJournal.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHealthJournal>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHealthJournalID The identifier.
     */
    pHRHealthJournalsDelete(patientID: string, pHRHealthJournalID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthJournals/{patientID}/{pHRHealthJournalID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHealthJournalID === undefined || pHRHealthJournalID === null)
            throw new Error("The parameter 'pHRHealthJournalID' must be defined.");
        url_ = url_.replace("{pHRHealthJournalID}", encodeURIComponent("" + pHRHealthJournalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthJournalsDelete(_response);
        });
    }

    protected processPHRHealthJournalsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRHealthJournal[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthJournals/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRHealthJournal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRHealthJournal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHealthJournal[]>(null as any);
    }

    /**
     * Posts the specified PHRHealthJournal.
     * @param pHRHealthJournal The PHRHealthJournal.
     */
    pHRHealthJournalsPost(pHRHealthJournal: PHRHealthJournal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthJournals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthJournal);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthJournalsPost(_response);
        });
    }

    protected processPHRHealthJournalsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRHealthJournal.
     * @param pHRHealthJournal The PHRHealthJournal.
     */
    pHRHealthJournalsPut(pHRHealthJournal: PHRHealthJournal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHealthJournals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHealthJournal);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHealthJournalsPut(_response);
        });
    }

    protected processPHRHealthJournalsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRHospitalVisitsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHospitalVisitID The identifier.
     */
    pHRHospitalVisitsGet(patientID: string, pHRHospitalVisitID: string): Promise<PHRHospitalVisit> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHospitalVisits/{patientID}/{pHRHospitalVisitID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHospitalVisitID === undefined || pHRHospitalVisitID === null)
            throw new Error("The parameter 'pHRHospitalVisitID' must be defined.");
        url_ = url_.replace("{pHRHospitalVisitID}", encodeURIComponent("" + pHRHospitalVisitID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHospitalVisitsGet(_response);
        });
    }

    protected processPHRHospitalVisitsGet(response: Response): Promise<PHRHospitalVisit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRHospitalVisit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHospitalVisit>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRHospitalVisitID The identifier.
     */
    pHRHospitalVisitsDelete(patientID: string, pHRHospitalVisitID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHospitalVisits/{patientID}/{pHRHospitalVisitID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHospitalVisitID === undefined || pHRHospitalVisitID === null)
            throw new Error("The parameter 'pHRHospitalVisitID' must be defined.");
        url_ = url_.replace("{pHRHospitalVisitID}", encodeURIComponent("" + pHRHospitalVisitID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHospitalVisitsDelete(_response);
        });
    }

    protected processPHRHospitalVisitsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrHospitalVisit.
     * @param patientID The patient identifier.
     * @param pHRHospitalVisitID The PHRHospitalVisitID.
     */
    verify(patientID: string, pHRHospitalVisitID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHospitalVisits/{patientID}/{pHRHospitalVisitID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRHospitalVisitID === undefined || pHRHospitalVisitID === null)
            throw new Error("The parameter 'pHRHospitalVisitID' must be defined.");
        url_ = url_.replace("{pHRHospitalVisitID}", encodeURIComponent("" + pHRHospitalVisitID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRHospitalVisit[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHospitalVisits/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRHospitalVisit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRHospitalVisit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRHospitalVisit[]>(null as any);
    }

    /**
     * Posts the specified PHRHospitalVisit.
     * @param pHRHospitalVisit The PHRHospitalVisit.
     */
    pHRHospitalVisitsPost(pHRHospitalVisit: PHRHospitalVisit): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHospitalVisits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHospitalVisit);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHospitalVisitsPost(_response);
        });
    }

    protected processPHRHospitalVisitsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRHospitalVisit.
     * @param pHRHospitalVisit The PHRHospitalVisit.
     */
    pHRHospitalVisitsPut(pHRHospitalVisit: PHRHospitalVisit): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRHospitalVisits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRHospitalVisit);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRHospitalVisitsPut(_response);
        });
    }

    protected processPHRHospitalVisitsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRMedicalEquipmentsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRMedicalEquipmentID The identifier.
     */
    pHRMedicalEquipmentsGet(patientID: string, pHRMedicalEquipmentID: string): Promise<PHRMedicalEquipment> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalEquipments/{patientID}/{pHRMedicalEquipmentID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicalEquipmentID === undefined || pHRMedicalEquipmentID === null)
            throw new Error("The parameter 'pHRMedicalEquipmentID' must be defined.");
        url_ = url_.replace("{pHRMedicalEquipmentID}", encodeURIComponent("" + pHRMedicalEquipmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicalEquipmentsGet(_response);
        });
    }

    protected processPHRMedicalEquipmentsGet(response: Response): Promise<PHRMedicalEquipment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRMedicalEquipment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRMedicalEquipment>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRMedicalEquipmentID The identifier.
     */
    pHRMedicalEquipmentsDelete(patientID: string, pHRMedicalEquipmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalEquipments/{patientID}/{pHRMedicalEquipmentID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicalEquipmentID === undefined || pHRMedicalEquipmentID === null)
            throw new Error("The parameter 'pHRMedicalEquipmentID' must be defined.");
        url_ = url_.replace("{pHRMedicalEquipmentID}", encodeURIComponent("" + pHRMedicalEquipmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicalEquipmentsDelete(_response);
        });
    }

    protected processPHRMedicalEquipmentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrMedicalEquipment.
     * @param patientID The patient identifier.
     * @param pHRMedicalEquipmentID The PHRMedicalEquipmentID.
     */
    verify(patientID: string, pHRMedicalEquipmentID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalEquipments/{patientID}/{pHRMedicalEquipmentID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicalEquipmentID === undefined || pHRMedicalEquipmentID === null)
            throw new Error("The parameter 'pHRMedicalEquipmentID' must be defined.");
        url_ = url_.replace("{pHRMedicalEquipmentID}", encodeURIComponent("" + pHRMedicalEquipmentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRMedicalEquipment[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalEquipments/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRMedicalEquipment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRMedicalEquipment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRMedicalEquipment[]>(null as any);
    }

    /**
     * Posts the specified PHRMedicalEquipment.
     * @param pHRMedicalEquipment The PHRMedicalEquipment.
     */
    pHRMedicalEquipmentsPost(pHRMedicalEquipment: PHRMedicalEquipment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalEquipments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRMedicalEquipment);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicalEquipmentsPost(_response);
        });
    }

    protected processPHRMedicalEquipmentsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRMedicalEquipment.
     * @param pHRMedicalEquipment The PHRMedicalEquipment.
     */
    pHRMedicalEquipmentsPut(pHRMedicalEquipment: PHRMedicalEquipment): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalEquipments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRMedicalEquipment);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicalEquipmentsPut(_response);
        });
    }

    protected processPHRMedicalEquipmentsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRMedicalHistoriesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRMedicalHistoryID The identifier.
     */
    pHRMedicalHistoriesGet(patientID: string, pHRMedicalHistoryID: string): Promise<PHRMedicalHistory> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalHistories/{patientID}/{pHRMedicalHistoryID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicalHistoryID === undefined || pHRMedicalHistoryID === null)
            throw new Error("The parameter 'pHRMedicalHistoryID' must be defined.");
        url_ = url_.replace("{pHRMedicalHistoryID}", encodeURIComponent("" + pHRMedicalHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicalHistoriesGet(_response);
        });
    }

    protected processPHRMedicalHistoriesGet(response: Response): Promise<PHRMedicalHistory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRMedicalHistory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRMedicalHistory>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRMedicalHistoryID The identifier.
     */
    pHRMedicalHistoriesDelete(patientID: string, pHRMedicalHistoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalHistories/{patientID}/{pHRMedicalHistoryID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicalHistoryID === undefined || pHRMedicalHistoryID === null)
            throw new Error("The parameter 'pHRMedicalHistoryID' must be defined.");
        url_ = url_.replace("{pHRMedicalHistoryID}", encodeURIComponent("" + pHRMedicalHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicalHistoriesDelete(_response);
        });
    }

    protected processPHRMedicalHistoriesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrMedicalHistory.
     * @param patientID The patient identifier.
     * @param pHRMedicalHistoryID The PHRMedicalHistoryID.
     */
    verify(patientID: string, pHRMedicalHistoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalHistories/{patientID}/{pHRMedicalHistoryID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicalHistoryID === undefined || pHRMedicalHistoryID === null)
            throw new Error("The parameter 'pHRMedicalHistoryID' must be defined.");
        url_ = url_.replace("{pHRMedicalHistoryID}", encodeURIComponent("" + pHRMedicalHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRMedicalHistory[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalHistories/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRMedicalHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRMedicalHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRMedicalHistory[]>(null as any);
    }

    /**
     * Posts the specified PHRMedicalHistory.
     * @param pHRMedicalHistory The PHRMedicalHistory.
     */
    pHRMedicalHistoriesPost(pHRMedicalHistory: PHRMedicalHistory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRMedicalHistory);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicalHistoriesPost(_response);
        });
    }

    protected processPHRMedicalHistoriesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRMedicalHistory.
     * @param pHRMedicalHistory The PHRMedicalHistory.
     */
    pHRMedicalHistoriesPut(pHRMedicalHistory: PHRMedicalHistory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicalHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRMedicalHistory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicalHistoriesPut(_response);
        });
    }

    protected processPHRMedicalHistoriesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRMedicationRemindersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRMedicationReminderID The identifier.
     */
    pHRMedicationRemindersGet(patientID: string, pHRMedicationReminderID: string): Promise<PHRMedicationReminder> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicationReminders/{patientID}/{pHRMedicationReminderID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicationReminderID === undefined || pHRMedicationReminderID === null)
            throw new Error("The parameter 'pHRMedicationReminderID' must be defined.");
        url_ = url_.replace("{pHRMedicationReminderID}", encodeURIComponent("" + pHRMedicationReminderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicationRemindersGet(_response);
        });
    }

    protected processPHRMedicationRemindersGet(response: Response): Promise<PHRMedicationReminder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRMedicationReminder.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRMedicationReminder>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRMedicationReminderID The identifier.
     */
    pHRMedicationRemindersDelete(patientID: string, pHRMedicationReminderID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicationReminders/{patientID}/{pHRMedicationReminderID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicationReminderID === undefined || pHRMedicationReminderID === null)
            throw new Error("The parameter 'pHRMedicationReminderID' must be defined.");
        url_ = url_.replace("{pHRMedicationReminderID}", encodeURIComponent("" + pHRMedicationReminderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicationRemindersDelete(_response);
        });
    }

    protected processPHRMedicationRemindersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Posts the specified PHRMedicationReminders.
     * @param patientID The patient identifier.
     * @param pHRMedicationReminder The patient health record medication.
     */
    pHRMedicationRemindersPost(patientID: string, pHRMedicationReminder: PHRMedicationReminder): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicationReminders/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRMedicationReminder);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicationRemindersPost(_response);
        });
    }

    protected processPHRMedicationRemindersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRMedicationReminders.
     * @param patientID The patient identifier.
     * @param pHRMedicationReminder The patient health record medication.
     */
    pHRMedicationRemindersPut(patientID: string, pHRMedicationReminder: PHRMedicationReminder): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedicationReminders/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRMedicationReminder);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicationRemindersPut(_response);
        });
    }

    protected processPHRMedicationRemindersPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRMedicationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRMedicationID The identifier.
     */
    pHRMedicationsGet(patientID: string, pHRMedicationID: string): Promise<PHRMedication> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedications/{patientID}/{pHRMedicationID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicationID === undefined || pHRMedicationID === null)
            throw new Error("The parameter 'pHRMedicationID' must be defined.");
        url_ = url_.replace("{pHRMedicationID}", encodeURIComponent("" + pHRMedicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicationsGet(_response);
        });
    }

    protected processPHRMedicationsGet(response: Response): Promise<PHRMedication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRMedication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRMedication>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRMedicationID The identifier.
     */
    pHRMedicationsDelete(patientID: string, pHRMedicationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedications/{patientID}/{pHRMedicationID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicationID === undefined || pHRMedicationID === null)
            throw new Error("The parameter 'pHRMedicationID' must be defined.");
        url_ = url_.replace("{pHRMedicationID}", encodeURIComponent("" + pHRMedicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicationsDelete(_response);
        });
    }

    protected processPHRMedicationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrMedication.
     * @param patientID The patient identifier.
     * @param pHRMedicationID The PHRMedicationID.
     */
    verify(patientID: string, pHRMedicationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedications/{patientID}/{pHRMedicationID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRMedicationID === undefined || pHRMedicationID === null)
            throw new Error("The parameter 'pHRMedicationID' must be defined.");
        url_ = url_.replace("{pHRMedicationID}", encodeURIComponent("" + pHRMedicationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRMedication[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedications/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRMedication[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRMedication.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRMedication[]>(null as any);
    }

    /**
     * Posts the specified PHRMedications.
     * @param pHRMedication The patient health record medication.
     */
    pHRMedicationsPost(pHRMedication: PHRMedication): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRMedication);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicationsPost(_response);
        });
    }

    protected processPHRMedicationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRMedications.
     * @param pHRMedication The patient health record medication.
     */
    pHRMedicationsPut(pHRMedication: PHRMedication): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRMedications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRMedication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRMedicationsPut(_response);
        });
    }

    protected processPHRMedicationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRNotesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRNoteID The identifier.
     */
    pHRNotesGet(patientID: string, pHRNoteID: string): Promise<PHRNote> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRNotes/{patientID}/{pHRNoteID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRNoteID === undefined || pHRNoteID === null)
            throw new Error("The parameter 'pHRNoteID' must be defined.");
        url_ = url_.replace("{pHRNoteID}", encodeURIComponent("" + pHRNoteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRNotesGet(_response);
        });
    }

    protected processPHRNotesGet(response: Response): Promise<PHRNote> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRNote.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRNote>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRNoteID The identifier.
     */
    pHRNotesDelete(patientID: string, pHRNoteID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRNotes/{patientID}/{pHRNoteID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRNoteID === undefined || pHRNoteID === null)
            throw new Error("The parameter 'pHRNoteID' must be defined.");
        url_ = url_.replace("{pHRNoteID}", encodeURIComponent("" + pHRNoteID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRNotesDelete(_response);
        });
    }

    protected processPHRNotesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRNote[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRNotes/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRNote[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRNote.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRNote[]>(null as any);
    }

    /**
     * Posts the specified PHRNote.
     * @param pHRNote The PHRNote.
     */
    pHRNotesPost(pHRNote: PHRNote): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRNote);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRNotesPost(_response);
        });
    }

    protected processPHRNotesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRNote.
     * @param pHRNote The PHRNote.
     */
    pHRNotesPut(pHRNote: PHRNote): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRNote);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRNotesPut(_response);
        });
    }

    protected processPHRNotesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHROrderDetailsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param patientOrderID The patient Order identifier.
     */
    byPatientOrderID(patientID: string, patientOrderID: string): Promise<PHROrderDetail[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHROrderDetails/{patientID}/ByPatientOrderID/{patientOrderID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (patientOrderID === undefined || patientOrderID === null)
            throw new Error("The parameter 'patientOrderID' must be defined.");
        url_ = url_.replace("{patientOrderID}", encodeURIComponent("" + patientOrderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientOrderID(_response);
        });
    }

    protected processByPatientOrderID(response: Response): Promise<PHROrderDetail[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHROrderDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHROrderDetail[]>(null as any);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param phrOrderDetailID The PHR Order detail identifier.
     */
    pHROrderDetailsGet(patientID: string, phrOrderDetailID: string): Promise<PHROrderDetail> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHROrderDetails/{patientID}/{phrOrderDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrOrderDetailID === undefined || phrOrderDetailID === null)
            throw new Error("The parameter 'phrOrderDetailID' must be defined.");
        url_ = url_.replace("{phrOrderDetailID}", encodeURIComponent("" + phrOrderDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHROrderDetailsGet(_response);
        });
    }

    protected processPHROrderDetailsGet(response: Response): Promise<PHROrderDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHROrderDetail.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHROrderDetail>(null as any);
    }

    /**
     * Posts the specified PHROrderDetail.
     * @param pHROrderDetail The PHROrderDetail.
     */
    pHROrderDetailsPost(pHROrderDetail: PHROrderDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHROrderDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHROrderDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHROrderDetailsPost(_response);
        });
    }

    protected processPHROrderDetailsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHROrderDetail.
     * @param pHROrderDetail The PHROrderDetail.
     */
    pHROrderDetailsPut(pHROrderDetail: PHROrderDetail): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHROrderDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHROrderDetail);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHROrderDetailsPut(_response);
        });
    }

    protected processPHROrderDetailsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Posts the specified PHROrderDetail.
     * @param pHROrderDetails The p hr Order details.
     */
    many(pHROrderDetails: PHROrderDetail[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHROrderDetails/Many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHROrderDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHROrderDetailID The identifier.
     */
    pHROrderDetailsDelete(patientID: string, pHROrderDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHROrderDetails/{patientID}/{pHROrderDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHROrderDetailID === undefined || pHROrderDetailID === null)
            throw new Error("The parameter 'pHROrderDetailID' must be defined.");
        url_ = url_.replace("{pHROrderDetailID}", encodeURIComponent("" + pHROrderDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHROrderDetailsDelete(_response);
        });
    }

    protected processPHROrderDetailsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PHRPatientsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the PHR summary dto.
     * @param patientID The patient identifier.
     */
    pHRSummaryDTO(patientID: string): Promise<PHRSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPatients/{patientID}/PHRSummaryDTO";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSummaryDTO(_response);
        });
    }

    protected processPHRSummaryDTO(response: Response): Promise<PHRSummaryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRSummaryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRSummaryDTO[]>(null as any);
    }

    /**
     * Gets the full PHR for that patient
     * @param patientID The patient identifier.
     */
    pHR(patientID: string): Promise<PHRPatient> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPatients/{patientID}/PHR";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHR(_response);
        });
    }

    protected processPHR(response: Response): Promise<PHRPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRPatient>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    pHRPatientsGet(patientID: string): Promise<PHRPatient> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPatients/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRPatientsGet(_response);
        });
    }

    protected processPHRPatientsGet(response: Response): Promise<PHRPatient> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRPatient.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRPatient>(null as any);
    }

    /**
     * Puts the specified p hr patient.
     * @param pHRPatient The p hr patient.
     */
    pHRPatientsPut(pHRPatient: PHRPatient): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPatients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRPatient);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRPatientsPut(_response);
        });
    }

    protected processPHRPatientsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRPregnanciesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRPregnancyID The identifier.
     */
    pHRPregnanciesGet(patientID: string, pHRPregnancyID: string): Promise<PHRPregnancy> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPregnancies/{patientID}/{pHRPregnancyID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRPregnancyID === undefined || pHRPregnancyID === null)
            throw new Error("The parameter 'pHRPregnancyID' must be defined.");
        url_ = url_.replace("{pHRPregnancyID}", encodeURIComponent("" + pHRPregnancyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRPregnanciesGet(_response);
        });
    }

    protected processPHRPregnanciesGet(response: Response): Promise<PHRPregnancy> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRPregnancy.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRPregnancy>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRPregnancyID The identifier.
     */
    pHRPregnanciesDelete(patientID: string, pHRPregnancyID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPregnancies/{patientID}/{pHRPregnancyID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRPregnancyID === undefined || pHRPregnancyID === null)
            throw new Error("The parameter 'pHRPregnancyID' must be defined.");
        url_ = url_.replace("{pHRPregnancyID}", encodeURIComponent("" + pHRPregnancyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRPregnanciesDelete(_response);
        });
    }

    protected processPHRPregnanciesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrPregnancy.
     * @param patientID The patient identifier.
     * @param pHRPregnancyID The PHRPregnancyID.
     */
    verify(patientID: string, pHRPregnancyID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPregnancies/{patientID}/{pHRPregnancyID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRPregnancyID === undefined || pHRPregnancyID === null)
            throw new Error("The parameter 'pHRPregnancyID' must be defined.");
        url_ = url_.replace("{pHRPregnancyID}", encodeURIComponent("" + pHRPregnancyID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRPregnancy[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPregnancies/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRPregnancy[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRPregnancy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRPregnancy[]>(null as any);
    }

    /**
     * Posts the specified PHRPregnancy.
     * @param pHRPregnancy The PHRPregnancy.
     */
    pHRPregnanciesPost(pHRPregnancy: PHRPregnancy): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPregnancies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRPregnancy);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRPregnanciesPost(_response);
        });
    }

    protected processPHRPregnanciesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRPregnancy.
     * @param pHRPregnancy The PHRPregnancy.
     */
    pHRPregnanciesPut(pHRPregnancy: PHRPregnancy): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRPregnancies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRPregnancy);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRPregnanciesPut(_response);
        });
    }

    protected processPHRPregnanciesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRSocialHistoriesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRSocialHistoryID The identifier.
     */
    pHRSocialHistoriesGet(patientID: string, pHRSocialHistoryID: string): Promise<PHRSocialHistory> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSocialHistories/{patientID}/{pHRSocialHistoryID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRSocialHistoryID === undefined || pHRSocialHistoryID === null)
            throw new Error("The parameter 'pHRSocialHistoryID' must be defined.");
        url_ = url_.replace("{pHRSocialHistoryID}", encodeURIComponent("" + pHRSocialHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSocialHistoriesGet(_response);
        });
    }

    protected processPHRSocialHistoriesGet(response: Response): Promise<PHRSocialHistory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRSocialHistory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRSocialHistory>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRSocialHistoryID The identifier.
     */
    pHRSocialHistoriesDelete(patientID: string, pHRSocialHistoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSocialHistories/{patientID}/{pHRSocialHistoryID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRSocialHistoryID === undefined || pHRSocialHistoryID === null)
            throw new Error("The parameter 'pHRSocialHistoryID' must be defined.");
        url_ = url_.replace("{pHRSocialHistoryID}", encodeURIComponent("" + pHRSocialHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSocialHistoriesDelete(_response);
        });
    }

    protected processPHRSocialHistoriesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrSocialHistory.
     * @param patientID The patient identifier.
     * @param pHRSocialHistoryID The PHRSocialHistoryID.
     */
    verify(patientID: string, pHRSocialHistoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSocialHistories/{patientID}/{pHRSocialHistoryID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRSocialHistoryID === undefined || pHRSocialHistoryID === null)
            throw new Error("The parameter 'pHRSocialHistoryID' must be defined.");
        url_ = url_.replace("{pHRSocialHistoryID}", encodeURIComponent("" + pHRSocialHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRSocialHistory[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSocialHistories/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRSocialHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRSocialHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRSocialHistory[]>(null as any);
    }

    /**
     * Posts the specified PHRSocialHistory.
     * @param pHRSocialHistory The PHRSocialHistory.
     */
    pHRSocialHistoriesPost(pHRSocialHistory: PHRSocialHistory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSocialHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRSocialHistory);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSocialHistoriesPost(_response);
        });
    }

    protected processPHRSocialHistoriesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRSocialHistory.
     * @param pHRSocialHistory The PHRSocialHistory.
     */
    pHRSocialHistoriesPut(pHRSocialHistory: PHRSocialHistory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSocialHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRSocialHistory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSocialHistoriesPut(_response);
        });
    }

    protected processPHRSocialHistoriesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRSurgeryHistoriesClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRSurgeryHistoryID The identifier.
     */
    pHRSurgeryHistoriesGet(patientID: string, pHRSurgeryHistoryID: string): Promise<PHRSurgeryHistory> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSurgeryHistories/{patientID}/{pHRSurgeryHistoryID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRSurgeryHistoryID === undefined || pHRSurgeryHistoryID === null)
            throw new Error("The parameter 'pHRSurgeryHistoryID' must be defined.");
        url_ = url_.replace("{pHRSurgeryHistoryID}", encodeURIComponent("" + pHRSurgeryHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSurgeryHistoriesGet(_response);
        });
    }

    protected processPHRSurgeryHistoriesGet(response: Response): Promise<PHRSurgeryHistory> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRSurgeryHistory.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRSurgeryHistory>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRSurgeryHistoryID The identifier.
     */
    pHRSurgeryHistoriesDelete(patientID: string, pHRSurgeryHistoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSurgeryHistories/{patientID}/{pHRSurgeryHistoryID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRSurgeryHistoryID === undefined || pHRSurgeryHistoryID === null)
            throw new Error("The parameter 'pHRSurgeryHistoryID' must be defined.");
        url_ = url_.replace("{pHRSurgeryHistoryID}", encodeURIComponent("" + pHRSurgeryHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSurgeryHistoriesDelete(_response);
        });
    }

    protected processPHRSurgeryHistoriesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrSurgeryHistory.
     * @param patientID The patient identifier.
     * @param pHRSurgeryHistoryID The PHRSurgeryHistoryID.
     */
    verify(patientID: string, pHRSurgeryHistoryID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSurgeryHistories/{patientID}/{pHRSurgeryHistoryID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRSurgeryHistoryID === undefined || pHRSurgeryHistoryID === null)
            throw new Error("The parameter 'pHRSurgeryHistoryID' must be defined.");
        url_ = url_.replace("{pHRSurgeryHistoryID}", encodeURIComponent("" + pHRSurgeryHistoryID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRSurgeryHistory[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSurgeryHistories/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRSurgeryHistory[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRSurgeryHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRSurgeryHistory[]>(null as any);
    }

    /**
     * Posts the specified PHRSurgeryHistory.
     * @param pHRSurgeryHistory The PHRSurgeryHistory.
     */
    pHRSurgeryHistoriesPost(pHRSurgeryHistory: PHRSurgeryHistory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSurgeryHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRSurgeryHistory);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSurgeryHistoriesPost(_response);
        });
    }

    protected processPHRSurgeryHistoriesPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRSurgeryHistory.
     * @param pHRSurgeryHistory The PHRSurgeryHistory.
     */
    pHRSurgeryHistoriesPut(pHRSurgeryHistory: PHRSurgeryHistory): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRSurgeryHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRSurgeryHistory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRSurgeryHistoriesPut(_response);
        });
    }

    protected processPHRSurgeryHistoriesPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRTrackersClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified patient identifier.
     * @param patientID The patient identifier.
     * @param pHRTrackerID The p hr tracker identifier.
     */
    pHRTrackersGet(patientID: string, pHRTrackerID: string): Promise<PHRTracker> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/{pHRTrackerID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRTrackerID === undefined || pHRTrackerID === null)
            throw new Error("The parameter 'pHRTrackerID' must be defined.");
        url_ = url_.replace("{pHRTrackerID}", encodeURIComponent("" + pHRTrackerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackersGet(_response);
        });
    }

    protected processPHRTrackersGet(response: Response): Promise<PHRTracker> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTracker.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTracker>(null as any);
    }

    /**
     * Deletes the specified patient identifier.
     * @param patientID The patient identifier.
     * @param pHRTrackerID The p hr tracker identifier.
     */
    pHRTrackersDelete(patientID: string, pHRTrackerID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/{pHRTrackerID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRTrackerID === undefined || pHRTrackerID === null)
            throw new Error("The parameter 'pHRTrackerID' must be defined.");
        url_ = url_.replace("{pHRTrackerID}", encodeURIComponent("" + pHRTrackerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackersDelete(_response);
        });
    }

    protected processPHRTrackersDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRTracker[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRTracker[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTracker.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTracker[]>(null as any);
    }

    /**
     * Posts the specified p hr tracker.
     * @param pHRTracker The p hr tracker.
     */
    pHRTrackersPost(pHRTracker: PHRTracker): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTracker);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackersPost(_response);
        });
    }

    protected processPHRTrackersPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified p hr tracker.
     * @param pHRTracker The p hr tracker.
     */
    pHRTrackersPut(pHRTracker: PHRTracker): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTracker);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackersPut(_response);
        });
    }

    protected processPHRTrackersPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the patient PHR tracker blood pressure by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerBloodPressureByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerBloodPressureDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodPressureByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodPressureByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerBloodPressureByPHRTrackerDetailID(response: Response): Promise<PHRTrackerBloodPressureDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerBloodPressureDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerBloodPressureDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker blood pressure.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerBloodPressureSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerBloodPressureDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerBloodPressureSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodPressureSearch(_response);
        });
    }

    protected processPHRTrackerBloodPressureSearch(response: Response): Promise<PHRTrackerBloodPressureDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerBloodPressureDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerBloodPressureDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker blood pressure.
     * @param patientID The patient identifier.
     * @param pHRTrackerBloodPressure The p hr tracker blood pressure.
     */
    pHRTrackerBloodPressurePost(patientID: string, pHRTrackerBloodPressure: PHRTrackerBloodPressureDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodPressure";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerBloodPressure);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodPressurePost(_response);
        });
    }

    protected processPHRTrackerBloodPressurePost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker blood pressure.
     * @param patientID The patient identifier.
     * @param pHRTrackerBloodPressure The p hr tracker blood pressure.
     */
    pHRTrackerBloodPressurePut(patientID: string, pHRTrackerBloodPressure: PHRTrackerBloodPressureDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodPressure";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerBloodPressure);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodPressurePut(_response);
        });
    }

    protected processPHRTrackerBloodPressurePut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker blood pressure.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerBloodPressureDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodPressure/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodPressureDelete(_response);
        });
    }

    protected processPHRTrackerBloodPressureDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker temperature by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerTemperatureByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerTemperatureDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTemperatureByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTemperatureByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerTemperatureByPHRTrackerDetailID(response: Response): Promise<PHRTrackerTemperatureDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerTemperatureDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerTemperatureDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker temperature.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerTemperatureSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerTemperatureDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerTemperatureSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTemperatureSearch(_response);
        });
    }

    protected processPHRTrackerTemperatureSearch(response: Response): Promise<PHRTrackerTemperatureDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerTemperatureDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerTemperatureDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker temperature.
     * @param patientID The patient identifier.
     * @param pHRTrackerTemperature The p hr tracker temperature.
     */
    pHRTrackerTemperaturePost(patientID: string, pHRTrackerTemperature: PHRTrackerTemperatureDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTemperature";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerTemperature);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTemperaturePost(_response);
        });
    }

    protected processPHRTrackerTemperaturePost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker temperature.
     * @param patientID The patient identifier.
     * @param pHRTrackerTemperature The p hr tracker temperature.
     */
    pHRTrackerTemperaturePut(patientID: string, pHRTrackerTemperature: PHRTrackerTemperatureDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTemperature";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerTemperature);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTemperaturePut(_response);
        });
    }

    protected processPHRTrackerTemperaturePut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker temperature.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerTemperatureDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTemperature/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTemperatureDelete(_response);
        });
    }

    protected processPHRTrackerTemperatureDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker blood oxygen by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerBloodOxygenByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerBloodOxygenDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodOxygenByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodOxygenByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerBloodOxygenByPHRTrackerDetailID(response: Response): Promise<PHRTrackerBloodOxygenDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerBloodOxygenDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerBloodOxygenDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker blood oxygen.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerBloodOxygenSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerBloodOxygenDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerBloodOxygenSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodOxygenSearch(_response);
        });
    }

    protected processPHRTrackerBloodOxygenSearch(response: Response): Promise<PHRTrackerBloodOxygenDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerBloodOxygenDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerBloodOxygenDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker blood oxygen.
     * @param patientID The patient identifier.
     * @param pHRTrackerBloodOxygen The p hr tracker blood oxygen.
     */
    pHRTrackerBloodOxygenPost(patientID: string, pHRTrackerBloodOxygen: PHRTrackerBloodOxygenDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodOxygen";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerBloodOxygen);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodOxygenPost(_response);
        });
    }

    protected processPHRTrackerBloodOxygenPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker blood oxygen.
     * @param patientID The patient identifier.
     * @param pHRTrackerBloodOxygen The p hr tracker blood oxygen.
     */
    pHRTrackerBloodOxygenPut(patientID: string, pHRTrackerBloodOxygen: PHRTrackerBloodOxygenDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodOxygen";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerBloodOxygen);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodOxygenPut(_response);
        });
    }

    protected processPHRTrackerBloodOxygenPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker blood oxygen.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerBloodOxygenDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodOxygen/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodOxygenDelete(_response);
        });
    }

    protected processPHRTrackerBloodOxygenDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker blood glucose by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerBloodGlucoseByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerBloodGlucoseDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodGlucoseByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodGlucoseByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerBloodGlucoseByPHRTrackerDetailID(response: Response): Promise<PHRTrackerBloodGlucoseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerBloodGlucoseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerBloodGlucoseDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker blood glucose.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerBloodGlucoseSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerBloodGlucoseDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerBloodGlucoseSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodGlucoseSearch(_response);
        });
    }

    protected processPHRTrackerBloodGlucoseSearch(response: Response): Promise<PHRTrackerBloodGlucoseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerBloodGlucoseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerBloodGlucoseDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker blood glucose.
     * @param patientID The patient identifier.
     * @param pHRTrackerBloodGlucose The p hr tracker blood glucose.
     */
    pHRTrackerBloodGlucosePost(patientID: string, pHRTrackerBloodGlucose: PHRTrackerBloodGlucoseDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodGlucose";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerBloodGlucose);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodGlucosePost(_response);
        });
    }

    protected processPHRTrackerBloodGlucosePost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker blood glucose.
     * @param patientID The patient identifier.
     * @param pHRTrackerBloodGlucose The p hr tracker blood glucose.
     */
    pHRTrackerBloodGlucosePut(patientID: string, pHRTrackerBloodGlucose: PHRTrackerBloodGlucoseDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodGlucose";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerBloodGlucose);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodGlucosePut(_response);
        });
    }

    protected processPHRTrackerBloodGlucosePut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker blood glucose.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerBloodGlucoseDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerBloodGlucose/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerBloodGlucoseDelete(_response);
        });
    }

    protected processPHRTrackerBloodGlucoseDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker pulse by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerPulseByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerPulseDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerPulseByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerPulseByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerPulseByPHRTrackerDetailID(response: Response): Promise<PHRTrackerPulseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerPulseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerPulseDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker pulse.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerPulseSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerPulseDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerPulseSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerPulseSearch(_response);
        });
    }

    protected processPHRTrackerPulseSearch(response: Response): Promise<PHRTrackerPulseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerPulseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerPulseDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker pulse.
     * @param patientID The patient identifier.
     * @param pHRTrackerPulse The p hr tracker pulse.
     */
    pHRTrackerPulsePost(patientID: string, pHRTrackerPulse: PHRTrackerPulseDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerPulse";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerPulse);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerPulsePost(_response);
        });
    }

    protected processPHRTrackerPulsePost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker pulse.
     * @param patientID The patient identifier.
     * @param pHRTrackerPulse The p hr tracker pulse.
     */
    pHRTrackerPulsePut(patientID: string, pHRTrackerPulse: PHRTrackerPulseDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerPulse";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerPulse);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerPulsePut(_response);
        });
    }

    protected processPHRTrackerPulsePut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker pulse.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerPulseDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerPulse/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerPulseDelete(_response);
        });
    }

    protected processPHRTrackerPulseDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker respiratory by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerRespiratoryByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerRespiratoryDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerRespiratoryByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRespiratoryByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerRespiratoryByPHRTrackerDetailID(response: Response): Promise<PHRTrackerRespiratoryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerRespiratoryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerRespiratoryDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker respiratory.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerRespiratorySearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerRespiratoryDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerRespiratorySearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRespiratorySearch(_response);
        });
    }

    protected processPHRTrackerRespiratorySearch(response: Response): Promise<PHRTrackerRespiratoryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerRespiratoryDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerRespiratoryDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker respiratory.
     * @param patientID The patient identifier.
     * @param pHRTrackerRespiratory The p hr tracker respiratory.
     */
    pHRTrackerRespiratoryPost(patientID: string, pHRTrackerRespiratory: PHRTrackerRespiratoryDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerRespiratory";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerRespiratory);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRespiratoryPost(_response);
        });
    }

    protected processPHRTrackerRespiratoryPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker respiratory.
     * @param patientID The patient identifier.
     * @param pHRTrackerRespiratory The p hr tracker respiratory.
     */
    pHRTrackerRespiratoryPut(patientID: string, pHRTrackerRespiratory: PHRTrackerRespiratoryDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerRespiratory";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerRespiratory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRespiratoryPut(_response);
        });
    }

    protected processPHRTrackerRespiratoryPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker respiratory.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerRespiratoryDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerRespiratory/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRespiratoryDelete(_response);
        });
    }

    protected processPHRTrackerRespiratoryDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker step counter by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerStepCounterByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerStepCounterDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerStepCounterByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStepCounterByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerStepCounterByPHRTrackerDetailID(response: Response): Promise<PHRTrackerStepCounterDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerStepCounterDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerStepCounterDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker step counter.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerStepCounterSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerStepCounterDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerStepCounterSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStepCounterSearch(_response);
        });
    }

    protected processPHRTrackerStepCounterSearch(response: Response): Promise<PHRTrackerStepCounterDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerStepCounterDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerStepCounterDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker step counter.
     * @param patientID The patient identifier.
     * @param pHRTrackerStepCounterDTO The p hr tracker step counter dto.
     */
    pHRTrackerStepCounterPost(patientID: string, pHRTrackerStepCounterDTO: PHRTrackerStepCounterDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerStepCounter";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerStepCounterDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStepCounterPost(_response);
        });
    }

    protected processPHRTrackerStepCounterPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker step counter.
     * @param patientID The patient identifier.
     * @param pHRTrackerStepCounterDTO The p hr tracker step counter dto.
     */
    pHRTrackerStepCounterPut(patientID: string, pHRTrackerStepCounterDTO: PHRTrackerStepCounterDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerStepCounter";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerStepCounterDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStepCounterPut(_response);
        });
    }

    protected processPHRTrackerStepCounterPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker step counter.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerStepCounterDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerStepCounter/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStepCounterDelete(_response);
        });
    }

    protected processPHRTrackerStepCounterDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker hemoglobin by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerHemoglobinByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerHemoglobinDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHemoglobinByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHemoglobinByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerHemoglobinByPHRTrackerDetailID(response: Response): Promise<PHRTrackerHemoglobinDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerHemoglobinDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerHemoglobinDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker hemoglobin.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerHemoglobinSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerHemoglobinDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerHemoglobinSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHemoglobinSearch(_response);
        });
    }

    protected processPHRTrackerHemoglobinSearch(response: Response): Promise<PHRTrackerHemoglobinDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerHemoglobinDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerHemoglobinDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker hemoglobin.
     * @param patientID The patient identifier.
     * @param pHRTrackerHemoglobinDTO The p hr tracker hemoglobin dto.
     */
    pHRTrackerHemoglobinPost(patientID: string, pHRTrackerHemoglobinDTO: PHRTrackerHemoglobinDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHemoglobin";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerHemoglobinDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHemoglobinPost(_response);
        });
    }

    protected processPHRTrackerHemoglobinPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker hemoglobin.
     * @param patientID The patient identifier.
     * @param pHRTrackerHemoglobinDTO The p hr tracker hemoglobin dto.
     */
    pHRTrackerHemoglobinPut(patientID: string, pHRTrackerHemoglobinDTO: PHRTrackerHemoglobinDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHemoglobin";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerHemoglobinDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHemoglobinPut(_response);
        });
    }

    protected processPHRTrackerHemoglobinPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker hemoglobin.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerHemoglobinDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHemoglobin/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHemoglobinDelete(_response);
        });
    }

    protected processPHRTrackerHemoglobinDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker cholesterol by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerCholesterolByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerCholesterolDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerCholesterolByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCholesterolByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerCholesterolByPHRTrackerDetailID(response: Response): Promise<PHRTrackerCholesterolDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerCholesterolDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerCholesterolDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker cholesterol.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerCholesterolSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerCholesterolDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerCholesterolSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCholesterolSearch(_response);
        });
    }

    protected processPHRTrackerCholesterolSearch(response: Response): Promise<PHRTrackerCholesterolDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerCholesterolDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerCholesterolDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker cholesterol.
     * @param patientID The patient identifier.
     * @param pHRTrackerCholesterolDTO The p hr tracker cholesterol dto.
     */
    pHRTrackerCholesterolPost(patientID: string, pHRTrackerCholesterolDTO: PHRTrackerCholesterolDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerCholesterol";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerCholesterolDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCholesterolPost(_response);
        });
    }

    protected processPHRTrackerCholesterolPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker cholesterol.
     * @param patientID The patient identifier.
     * @param pHRTrackerCholesterolDTO The p hr tracker cholesterol dto.
     */
    pHRTrackerCholesterolPut(patientID: string, pHRTrackerCholesterolDTO: PHRTrackerCholesterolDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerCholesterol";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerCholesterolDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCholesterolPut(_response);
        });
    }

    protected processPHRTrackerCholesterolPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker cholesterol.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerCholesterolDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerCholesterol/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCholesterolDelete(_response);
        });
    }

    protected processPHRTrackerCholesterolDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker uric acid by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerUricAcidByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerUricAcidDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerUricAcidByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerUricAcidByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerUricAcidByPHRTrackerDetailID(response: Response): Promise<PHRTrackerUricAcidDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerUricAcidDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerUricAcidDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker uric acid.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerUricAcidSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerUricAcidDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerUricAcidSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerUricAcidSearch(_response);
        });
    }

    protected processPHRTrackerUricAcidSearch(response: Response): Promise<PHRTrackerUricAcidDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerUricAcidDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerUricAcidDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker uric acid.
     * @param patientID The patient identifier.
     * @param pHRTrackerUricAcidDTO The p hr tracker uric acid dto.
     */
    pHRTrackerUricAcidPost(patientID: string, pHRTrackerUricAcidDTO: PHRTrackerUricAcidDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerUricAcid";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerUricAcidDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerUricAcidPost(_response);
        });
    }

    protected processPHRTrackerUricAcidPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker uric acid.
     * @param patientID The patient identifier.
     * @param pHRTrackerUricAcidDTO The p hr tracker uric acid dto.
     */
    pHRTrackerUricAcidPut(patientID: string, pHRTrackerUricAcidDTO: PHRTrackerUricAcidDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerUricAcid";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerUricAcidDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerUricAcidPut(_response);
        });
    }

    protected processPHRTrackerUricAcidPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker uric acid.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerUricAcidDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerUricAcid/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerUricAcidDelete(_response);
        });
    }

    protected processPHRTrackerUricAcidDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker HCV by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerHCVByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerHCVDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHCVByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHCVByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerHCVByPHRTrackerDetailID(response: Response): Promise<PHRTrackerHCVDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerHCVDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerHCVDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker HCV.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerHCVSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerHCVDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerHCVSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHCVSearch(_response);
        });
    }

    protected processPHRTrackerHCVSearch(response: Response): Promise<PHRTrackerHCVDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerHCVDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerHCVDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker HCV.
     * @param patientID The patient identifier.
     * @param pHRTrackerHCVDTO The p hr tracker hcvdto.
     */
    pHRTrackerHCVPost(patientID: string, pHRTrackerHCVDTO: PHRTrackerHCVDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHCV";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerHCVDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHCVPost(_response);
        });
    }

    protected processPHRTrackerHCVPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker HCV.
     * @param patientID The patient identifier.
     * @param pHRTrackerHCVDTO The p hr tracker hcvdto.
     */
    pHRTrackerHCVPut(patientID: string, pHRTrackerHCVDTO: PHRTrackerHCVDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHCV";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerHCVDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHCVPut(_response);
        });
    }

    protected processPHRTrackerHCVPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker HCV.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerHCVDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHCV/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHCVDelete(_response);
        });
    }

    protected processPHRTrackerHCVDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker fetal doppler by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerFetalDopplerByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerFetalDopplerDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerFetalDopplerByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerFetalDopplerByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerFetalDopplerByPHRTrackerDetailID(response: Response): Promise<PHRTrackerFetalDopplerDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerFetalDopplerDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerFetalDopplerDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker fetal doppler.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerFetalDopplerSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerFetalDopplerDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerFetalDopplerSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerFetalDopplerSearch(_response);
        });
    }

    protected processPHRTrackerFetalDopplerSearch(response: Response): Promise<PHRTrackerFetalDopplerDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerFetalDopplerDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerFetalDopplerDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker fetal doppler.
     * @param patientID The patient identifier.
     * @param pHRTrackerFetalDopplerDTO The p hr tracker fetal doppler dto.
     */
    pHRTrackerFetalDopplerPost(patientID: string, pHRTrackerFetalDopplerDTO: PHRTrackerFetalDopplerDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerFetalDoppler";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerFetalDopplerDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerFetalDopplerPost(_response);
        });
    }

    protected processPHRTrackerFetalDopplerPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker fetal doppler.
     * @param patientID The patient identifier.
     * @param pHRTrackerFetalDopplerDTO The p hr tracker fetal doppler dto.
     */
    pHRTrackerFetalDopplerPut(patientID: string, pHRTrackerFetalDopplerDTO: PHRTrackerFetalDopplerDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerFetalDoppler";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerFetalDopplerDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerFetalDopplerPut(_response);
        });
    }

    protected processPHRTrackerFetalDopplerPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker fetal doppler.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerFetalDopplerDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerFetalDoppler/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerFetalDopplerDelete(_response);
        });
    }

    protected processPHRTrackerFetalDopplerDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker rapid pregnancy by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerRapidPregnancyByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerRapidPregnancyDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerRapidPregnancyByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRapidPregnancyByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerRapidPregnancyByPHRTrackerDetailID(response: Response): Promise<PHRTrackerRapidPregnancyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerRapidPregnancyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerRapidPregnancyDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker rapid pregnancy.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerRapidPregnancySearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerRapidPregnancyDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerRapidPregnancySearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRapidPregnancySearch(_response);
        });
    }

    protected processPHRTrackerRapidPregnancySearch(response: Response): Promise<PHRTrackerRapidPregnancyDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerRapidPregnancyDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerRapidPregnancyDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker rapid pregnancy.
     * @param patientID The patient identifier.
     * @param pHRTrackerRapidPregnancyDTO The p hr tracker rapid pregnancy dto.
     */
    pHRTrackerRapidPregnancyPost(patientID: string, pHRTrackerRapidPregnancyDTO: PHRTrackerRapidPregnancyDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerRapidPregnancy";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerRapidPregnancyDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRapidPregnancyPost(_response);
        });
    }

    protected processPHRTrackerRapidPregnancyPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker rapid pregnancy.
     * @param patientID The patient identifier.
     * @param pHRTrackerRapidPregnancyDTO The p hr tracker rapid pregnancy dto.
     */
    pHRTrackerRapidPregnancyPut(patientID: string, pHRTrackerRapidPregnancyDTO: PHRTrackerRapidPregnancyDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerRapidPregnancy";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerRapidPregnancyDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRapidPregnancyPut(_response);
        });
    }

    protected processPHRTrackerRapidPregnancyPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker rapid pregnancy.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerRapidPregnancyDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerRapidPregnancy/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerRapidPregnancyDelete(_response);
        });
    }

    protected processPHRTrackerRapidPregnancyDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker hiv by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerHIVByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerHIVDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHIVByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHIVByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerHIVByPHRTrackerDetailID(response: Response): Promise<PHRTrackerHIVDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerHIVDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerHIVDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker hiv.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerHIVSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerHIVDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerHIVSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHIVSearch(_response);
        });
    }

    protected processPHRTrackerHIVSearch(response: Response): Promise<PHRTrackerHIVDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerHIVDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerHIVDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker hiv.
     * @param patientID The patient identifier.
     * @param pHRTrackerHIVDTO The p hr tracker hivdto.
     */
    pHRTrackerHIVPost(patientID: string, pHRTrackerHIVDTO: PHRTrackerHIVDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHIV";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerHIVDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHIVPost(_response);
        });
    }

    protected processPHRTrackerHIVPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker hiv.
     * @param patientID The patient identifier.
     * @param pHRTrackerHIVDTO The p hr tracker hivdto.
     */
    pHRTrackerHIVPut(patientID: string, pHRTrackerHIVDTO: PHRTrackerHIVDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHIV";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerHIVDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHIVPut(_response);
        });
    }

    protected processPHRTrackerHIVPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker hiv.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerHIVDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHIV/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHIVDelete(_response);
        });
    }

    protected processPHRTrackerHIVDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker troponin by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerTroponinByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerTroponinDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTroponinByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTroponinByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerTroponinByPHRTrackerDetailID(response: Response): Promise<PHRTrackerTroponinDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerTroponinDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerTroponinDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker troponin.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerTroponinSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerTroponinDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerTroponinSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTroponinSearch(_response);
        });
    }

    protected processPHRTrackerTroponinSearch(response: Response): Promise<PHRTrackerTroponinDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerTroponinDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerTroponinDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker troponin.
     * @param patientID The patient identifier.
     * @param pHRTrackerTroponinDTO The p hr tracker troponin dto.
     */
    pHRTrackerTroponinPost(patientID: string, pHRTrackerTroponinDTO: PHRTrackerTroponinDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTroponin";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerTroponinDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTroponinPost(_response);
        });
    }

    protected processPHRTrackerTroponinPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker troponin.
     * @param patientID The patient identifier.
     * @param pHRTrackerTroponinDTO The p hr tracker troponin dto.
     */
    pHRTrackerTroponinPut(patientID: string, pHRTrackerTroponinDTO: PHRTrackerTroponinDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTroponin";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerTroponinDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTroponinPut(_response);
        });
    }

    protected processPHRTrackerTroponinPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker troponin.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerTroponinDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTroponin/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTroponinDelete(_response);
        });
    }

    protected processPHRTrackerTroponinDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker syphilis by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerSyphilisByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerSyphilisDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerSyphilisByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSyphilisByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerSyphilisByPHRTrackerDetailID(response: Response): Promise<PHRTrackerSyphilisDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerSyphilisDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerSyphilisDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker syphilis.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerSyphilisSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerSyphilisDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerSyphilisSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSyphilisSearch(_response);
        });
    }

    protected processPHRTrackerSyphilisSearch(response: Response): Promise<PHRTrackerSyphilisDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerSyphilisDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerSyphilisDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker syphilis.
     * @param patientID The patient identifier.
     * @param pHRTrackerSyphilisDTO The p hr tracker syphilis dto.
     */
    pHRTrackerSyphilisPost(patientID: string, pHRTrackerSyphilisDTO: PHRTrackerSyphilisDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerSyphilis";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSyphilisDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSyphilisPost(_response);
        });
    }

    protected processPHRTrackerSyphilisPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker syphilis.
     * @param patientID The patient identifier.
     * @param pHRTrackerSyphilisDTO The p hr tracker syphilis dto.
     */
    pHRTrackerSyphilisPut(patientID: string, pHRTrackerSyphilisDTO: PHRTrackerSyphilisDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerSyphilis";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSyphilisDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSyphilisPut(_response);
        });
    }

    protected processPHRTrackerSyphilisPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker syphilis.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerSyphilisDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerSyphilis/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSyphilisDelete(_response);
        });
    }

    protected processPHRTrackerSyphilisDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker chinkungunia by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerChinkunguniaByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerChinkunguniaDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerChinkunguniaByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerChinkunguniaByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerChinkunguniaByPHRTrackerDetailID(response: Response): Promise<PHRTrackerChinkunguniaDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerChinkunguniaDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerChinkunguniaDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker chinkungunia.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerChinkunguniaSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerChinkunguniaDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerChinkunguniaSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerChinkunguniaSearch(_response);
        });
    }

    protected processPHRTrackerChinkunguniaSearch(response: Response): Promise<PHRTrackerChinkunguniaDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerChinkunguniaDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerChinkunguniaDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker chinkungunia.
     * @param patientID The patient identifier.
     * @param pHRTrackerChinkunguniaDTO The p hr tracker chinkungunia dto.
     */
    pHRTrackerChinkunguniaPost(patientID: string, pHRTrackerChinkunguniaDTO: PHRTrackerChinkunguniaDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerChinkungunia";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerChinkunguniaDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerChinkunguniaPost(_response);
        });
    }

    protected processPHRTrackerChinkunguniaPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker chinkungunia.
     * @param patientID The patient identifier.
     * @param pHRTrackerChinkunguniaDTO The p hr tracker chinkungunia dto.
     */
    pHRTrackerChinkunguniaPut(patientID: string, pHRTrackerChinkunguniaDTO: PHRTrackerChinkunguniaDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerChinkungunia";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerChinkunguniaDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerChinkunguniaPut(_response);
        });
    }

    protected processPHRTrackerChinkunguniaPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker chinkungunia.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerChinkunguniaDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerChinkungunia/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerChinkunguniaDelete(_response);
        });
    }

    protected processPHRTrackerChinkunguniaDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker malaria by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerMalariaByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerMalariaDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerMalariaByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMalariaByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerMalariaByPHRTrackerDetailID(response: Response): Promise<PHRTrackerMalariaDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerMalariaDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerMalariaDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker malaria.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerMalariaSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerMalariaDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerMalariaSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMalariaSearch(_response);
        });
    }

    protected processPHRTrackerMalariaSearch(response: Response): Promise<PHRTrackerMalariaDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerMalariaDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerMalariaDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker malaria.
     * @param patientID The patient identifier.
     * @param pHRTrackerMalariaDTO The p hr tracker malaria dto.
     */
    pHRTrackerMalariaPost(patientID: string, pHRTrackerMalariaDTO: PHRTrackerMalariaDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerMalaria";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerMalariaDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMalariaPost(_response);
        });
    }

    protected processPHRTrackerMalariaPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker malaria.
     * @param patientID The patient identifier.
     * @param pHRTrackerMalariaDTO The p hr tracker malaria dto.
     */
    pHRTrackerMalariaPut(patientID: string, pHRTrackerMalariaDTO: PHRTrackerMalariaDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerMalaria";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerMalariaDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMalariaPut(_response);
        });
    }

    protected processPHRTrackerMalariaPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker malaria.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerMalariaDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerMalaria/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMalariaDelete(_response);
        });
    }

    protected processPHRTrackerMalariaDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker typhoid by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerTyphoidByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerTyphoidDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTyphoidByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTyphoidByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerTyphoidByPHRTrackerDetailID(response: Response): Promise<PHRTrackerTyphoidDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerTyphoidDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerTyphoidDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker typhoid.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerTyphoidSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerTyphoidDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerTyphoidSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTyphoidSearch(_response);
        });
    }

    protected processPHRTrackerTyphoidSearch(response: Response): Promise<PHRTrackerTyphoidDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerTyphoidDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerTyphoidDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker typhoid.
     * @param patientID The patient identifier.
     * @param pHRTrackerTyphoidDTO The p hr tracker typhoid dto.
     */
    pHRTrackerTyphoidPost(patientID: string, pHRTrackerTyphoidDTO: PHRTrackerTyphoidDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTyphoid";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerTyphoidDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTyphoidPost(_response);
        });
    }

    protected processPHRTrackerTyphoidPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker typhoid.
     * @param patientID The patient identifier.
     * @param pHRTrackerTyphoidDTO The p hr tracker typhoid dto.
     */
    pHRTrackerTyphoidPut(patientID: string, pHRTrackerTyphoidDTO: PHRTrackerTyphoidDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTyphoid";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerTyphoidDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTyphoidPut(_response);
        });
    }

    protected processPHRTrackerTyphoidPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker typhoid.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerTyphoidDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerTyphoid/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerTyphoidDelete(_response);
        });
    }

    protected processPHRTrackerTyphoidDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker dengue by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerDengueByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerDengueDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerDengueByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerDengueByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerDengueByPHRTrackerDetailID(response: Response): Promise<PHRTrackerDengueDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerDengueDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerDengueDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker dengue.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerDengueSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerDengueDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerDengueSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerDengueSearch(_response);
        });
    }

    protected processPHRTrackerDengueSearch(response: Response): Promise<PHRTrackerDengueDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerDengueDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerDengueDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker dengue.
     * @param patientID The patient identifier.
     * @param pHRTrackerDengueDTO The p hr tracker dengue dto.
     */
    pHRTrackerDenguePost(patientID: string, pHRTrackerDengueDTO: PHRTrackerDengueDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerDengue";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerDengueDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerDenguePost(_response);
        });
    }

    protected processPHRTrackerDenguePost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker dengue.
     * @param patientID The patient identifier.
     * @param pHRTrackerDengueDTO The p hr tracker dengue dto.
     */
    pHRTrackerDenguePut(patientID: string, pHRTrackerDengueDTO: PHRTrackerDengueDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerDengue";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerDengueDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerDenguePut(_response);
        });
    }

    protected processPHRTrackerDenguePut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker dengue.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerDengueDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerDengue/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerDengueDelete(_response);
        });
    }

    protected processPHRTrackerDengueDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker waist circumference by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerWaistCircumferenceByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerWaistCircumferenceDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerWaistCircumferenceByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWaistCircumferenceByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerWaistCircumferenceByPHRTrackerDetailID(response: Response): Promise<PHRTrackerWaistCircumferenceDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerWaistCircumferenceDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerWaistCircumferenceDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker waist circumference.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerWaistCircumferenceSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerWaistCircumferenceDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerWaistCircumferenceSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWaistCircumferenceSearch(_response);
        });
    }

    protected processPHRTrackerWaistCircumferenceSearch(response: Response): Promise<PHRTrackerWaistCircumferenceDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerWaistCircumferenceDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerWaistCircumferenceDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker waist circumference.
     * @param patientID The patient identifier.
     * @param pHRTrackerWaistCircumferenceDTO The p hr tracker waist circumference dto.
     */
    pHRTrackerWaistCircumferencePost(patientID: string, pHRTrackerWaistCircumferenceDTO: PHRTrackerWaistCircumferenceDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerWaistCircumference";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerWaistCircumferenceDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWaistCircumferencePost(_response);
        });
    }

    protected processPHRTrackerWaistCircumferencePost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker waist circumference.
     * @param patientID The patient identifier.
     * @param pHRTrackerWaistCircumferenceDTO The p hr tracker waist circumference dto.
     */
    pHRTrackerWaistCircumferencePut(patientID: string, pHRTrackerWaistCircumferenceDTO: PHRTrackerWaistCircumferenceDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerWaistCircumference";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerWaistCircumferenceDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWaistCircumferencePut(_response);
        });
    }

    protected processPHRTrackerWaistCircumferencePut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker waist circumference.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerWaistCircumferenceDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerWaistCircumference/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWaistCircumferenceDelete(_response);
        });
    }

    protected processPHRTrackerWaistCircumferenceDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker head circumference by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerHeadCircumferenceByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerHeadCircumferenceDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHeadCircumferenceByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHeadCircumferenceByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerHeadCircumferenceByPHRTrackerDetailID(response: Response): Promise<PHRTrackerHeadCircumferenceDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerHeadCircumferenceDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerHeadCircumferenceDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker head circumference.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerHeadCircumferenceSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerHeadCircumferenceDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerHeadCircumferenceSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHeadCircumferenceSearch(_response);
        });
    }

    protected processPHRTrackerHeadCircumferenceSearch(response: Response): Promise<PHRTrackerHeadCircumferenceDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerHeadCircumferenceDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerHeadCircumferenceDTO[]>(null as any);
    }

    /**
     * Inserts the PHR tracker head circumference.
     * @param patientID The patient identifier.
     * @param pHRTrackerHeadCircumferenceDTO The p hr tracker head circumference dto.
     */
    pHRTrackerHeadCircumferencePost(patientID: string, pHRTrackerHeadCircumferenceDTO: PHRTrackerHeadCircumferenceDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHeadCircumference";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerHeadCircumferenceDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHeadCircumferencePost(_response);
        });
    }

    protected processPHRTrackerHeadCircumferencePost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the PHR tracker head circumference.
     * @param patientID The patient identifier.
     * @param pHRTrackerHeadCircumferenceDTO The p hr tracker head circumference dto.
     */
    pHRTrackerHeadCircumferencePut(patientID: string, pHRTrackerHeadCircumferenceDTO: PHRTrackerHeadCircumferenceDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHeadCircumference";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerHeadCircumferenceDTO);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHeadCircumferencePut(_response);
        });
    }

    protected processPHRTrackerHeadCircumferencePut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the PHR tracker head circumference.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerHeadCircumferenceDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerHeadCircumference/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerHeadCircumferenceDelete(_response);
        });
    }

    protected processPHRTrackerHeadCircumferenceDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Inserts the PHR vitals.
     * @param patientID The patient identifier.
     * @param phrVitals The PHR vitals.
     */
    pHRVitals(patientID: string, phrVitals: PHRVitalsDTO): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRVitals";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(phrVitals);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRVitals(_response);
        });
    }

    protected processPHRVitals(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Gets the most recent vitals.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    recentPHRVitals(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRVitalsDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/RecentPHRVitals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processRecentPHRVitals(_response);
        });
    }

    protected processRecentPHRVitals(response: Response): Promise<PHRVitalsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRVitalsDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRVitalsDTO>(null as any);
    }

    /**
     * Gets the patient PHR tracker Length by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerLengthByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerLengthDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerLengthByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerLengthByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerLengthByPHRTrackerDetailID(response: Response): Promise<PHRTrackerLengthDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerLengthDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerLengthDTO>(null as any);
    }

    /**
     * Gets the Length of the patient PHR tracker.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerLengthSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerLengthDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerLengthSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerLengthSearch(_response);
        });
    }

    protected processPHRTrackerLengthSearch(response: Response): Promise<PHRTrackerLengthDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerLengthDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerLengthDTO[]>(null as any);
    }

    /**
     * Inserts the Length of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerLength Length of the p hr tracker.
     */
    pHRTrackerLengthPost(patientID: string, pHRTrackerLength: PHRTrackerLengthDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerLength";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerLength);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerLengthPost(_response);
        });
    }

    protected processPHRTrackerLengthPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the Length of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerLength Length of the p hr tracker.
     */
    pHRTrackerLengthPut(patientID: string, pHRTrackerLength: PHRTrackerLengthDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerLength";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerLength);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerLengthPut(_response);
        });
    }

    protected processPHRTrackerLengthPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the Length of the PHR tracker.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerLengthDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerLength/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerLengthDelete(_response);
        });
    }

    protected processPHRTrackerLengthDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker weight height by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerWeightHeightByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerWeightHeightDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerWeightHeightByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWeightHeightByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerWeightHeightByPHRTrackerDetailID(response: Response): Promise<PHRTrackerWeightHeightDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerWeightHeightDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerWeightHeightDTO>(null as any);
    }

    /**
     * Gets the WeightHeight of the patient PHR tracker.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerWeightHeightSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerWeightHeightDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerWeightHeightSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWeightHeightSearch(_response);
        });
    }

    protected processPHRTrackerWeightHeightSearch(response: Response): Promise<PHRTrackerWeightHeightDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerWeightHeightDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerWeightHeightDTO[]>(null as any);
    }

    /**
     * Inserts the WeightHeight of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerWeightHeight WeightHeight of the p hr tracker.
     */
    pHRTrackerWeightHeightPost(patientID: string, pHRTrackerWeightHeight: PHRTrackerWeightHeightDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerWeightHeight";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerWeightHeight);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWeightHeightPost(_response);
        });
    }

    protected processPHRTrackerWeightHeightPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the WeightHeight of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerWeightHeight WeightHeight of the p hr tracker.
     */
    pHRTrackerWeightHeightPut(patientID: string, pHRTrackerWeightHeight: PHRTrackerWeightHeightDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerWeightHeight";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerWeightHeight);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWeightHeightPut(_response);
        });
    }

    protected processPHRTrackerWeightHeightPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the WeightHeight of the PHR tracker.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerWeightHeightDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerWeightHeight/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerWeightHeightDelete(_response);
        });
    }

    protected processPHRTrackerWeightHeightDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker Mood by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerMoodByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerMoodDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerMoodByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMoodByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerMoodByPHRTrackerDetailID(response: Response): Promise<PHRTrackerMoodDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerMoodDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerMoodDTO>(null as any);
    }

    /**
     * Gets the Mood of the patient PHR tracker.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerMoodSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerMoodDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerMoodSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMoodSearch(_response);
        });
    }

    protected processPHRTrackerMoodSearch(response: Response): Promise<PHRTrackerMoodDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerMoodDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerMoodDTO[]>(null as any);
    }

    /**
     * Inserts the Mood of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerMood Mood of the p hr tracker.
     */
    pHRTrackerMoodPost(patientID: string, pHRTrackerMood: PHRTrackerMoodDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerMood";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerMood);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMoodPost(_response);
        });
    }

    protected processPHRTrackerMoodPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the Mood of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerMood Mood of the p hr tracker.
     */
    pHRTrackerMoodPut(patientID: string, pHRTrackerMood: PHRTrackerMoodDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerMood";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerMood);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMoodPut(_response);
        });
    }

    protected processPHRTrackerMoodPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the Mood of the PHR tracker.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerMoodDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerMood/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerMoodDelete(_response);
        });
    }

    protected processPHRTrackerMoodDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker Stress by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerStressByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerStressDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerStressByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStressByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerStressByPHRTrackerDetailID(response: Response): Promise<PHRTrackerStressDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerStressDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerStressDTO>(null as any);
    }

    /**
     * Gets the Stress of the patient PHR tracker.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerStressSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerStressDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerStressSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStressSearch(_response);
        });
    }

    protected processPHRTrackerStressSearch(response: Response): Promise<PHRTrackerStressDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerStressDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerStressDTO[]>(null as any);
    }

    /**
     * Inserts the Stress of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerStress Stress of the p hr tracker.
     */
    pHRTrackerStressPost(patientID: string, pHRTrackerStress: PHRTrackerStressDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerStress";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerStress);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStressPost(_response);
        });
    }

    protected processPHRTrackerStressPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the Stress of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerStress Stress of the p hr tracker.
     */
    pHRTrackerStressPut(patientID: string, pHRTrackerStress: PHRTrackerStressDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerStress";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerStress);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStressPut(_response);
        });
    }

    protected processPHRTrackerStressPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the Stress of the PHR tracker.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerStressDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerStress/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerStressDelete(_response);
        });
    }

    protected processPHRTrackerStressDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker Anxiety by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerAnxietyByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerAnxietyDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerAnxietyByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerAnxietyByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerAnxietyByPHRTrackerDetailID(response: Response): Promise<PHRTrackerAnxietyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerAnxietyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerAnxietyDTO>(null as any);
    }

    /**
     * Gets the Anxiety of the patient PHR tracker.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerAnxietySearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerAnxietyDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerAnxietySearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerAnxietySearch(_response);
        });
    }

    protected processPHRTrackerAnxietySearch(response: Response): Promise<PHRTrackerAnxietyDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerAnxietyDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerAnxietyDTO[]>(null as any);
    }

    /**
     * Inserts the Anxiety of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerAnxiety Anxiety of the p hr tracker.
     */
    pHRTrackerAnxietyPost(patientID: string, pHRTrackerAnxiety: PHRTrackerAnxietyDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerAnxiety";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerAnxiety);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerAnxietyPost(_response);
        });
    }

    protected processPHRTrackerAnxietyPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the Anxiety of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerAnxiety Anxiety of the p hr tracker.
     */
    pHRTrackerAnxietyPut(patientID: string, pHRTrackerAnxiety: PHRTrackerAnxietyDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerAnxiety";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerAnxiety);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerAnxietyPut(_response);
        });
    }

    protected processPHRTrackerAnxietyPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the Anxiety of the PHR tracker.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerAnxietyDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerAnxiety/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerAnxietyDelete(_response);
        });
    }

    protected processPHRTrackerAnxietyDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker Exercise by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerExerciseByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerExerciseDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerExerciseByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerExerciseByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerExerciseByPHRTrackerDetailID(response: Response): Promise<PHRTrackerExerciseDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerExerciseDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerExerciseDTO>(null as any);
    }

    /**
     * Gets the Exercise of the patient PHR tracker.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerExerciseSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerExerciseDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerExerciseSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerExerciseSearch(_response);
        });
    }

    protected processPHRTrackerExerciseSearch(response: Response): Promise<PHRTrackerExerciseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerExerciseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerExerciseDTO[]>(null as any);
    }

    /**
     * Inserts the Exercise of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerExercise Exercise of the p hr tracker.
     */
    pHRTrackerExercisePost(patientID: string, pHRTrackerExercise: PHRTrackerExerciseDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerExercise";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerExercise);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerExercisePost(_response);
        });
    }

    protected processPHRTrackerExercisePost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the Exercise of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerExercise Exercise of the p hr tracker.
     */
    pHRTrackerExercisePut(patientID: string, pHRTrackerExercise: PHRTrackerExerciseDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerExercise";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerExercise);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerExercisePut(_response);
        });
    }

    protected processPHRTrackerExercisePut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the Exercise of the PHR tracker.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerExerciseDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerExercise/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerExerciseDelete(_response);
        });
    }

    protected processPHRTrackerExerciseDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker Sleep by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerSleepByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerSleepDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerSleepByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSleepByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerSleepByPHRTrackerDetailID(response: Response): Promise<PHRTrackerSleepDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerSleepDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerSleepDTO>(null as any);
    }

    /**
     * Gets the Sleep of the patient PHR tracker.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerSleepSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerSleepDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerSleepSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSleepSearch(_response);
        });
    }

    protected processPHRTrackerSleepSearch(response: Response): Promise<PHRTrackerSleepDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerSleepDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerSleepDTO[]>(null as any);
    }

    /**
     * Inserts the Sleep of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerSleep Sleep of the p hr tracker.
     */
    pHRTrackerSleepPost(patientID: string, pHRTrackerSleep: PHRTrackerSleepDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerSleep";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSleep);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSleepPost(_response);
        });
    }

    protected processPHRTrackerSleepPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the Sleep of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerSleep Sleep of the p hr tracker.
     */
    pHRTrackerSleepPut(patientID: string, pHRTrackerSleep: PHRTrackerSleepDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerSleep";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSleep);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSleepPut(_response);
        });
    }

    protected processPHRTrackerSleepPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the Sleep of the PHR tracker.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerSleepDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerSleep/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerSleepDelete(_response);
        });
    }

    protected processPHRTrackerSleepDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the patient PHR tracker Covid by PHR tracker detail identifier.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerCovidByPHRTrackerDetailID(patientID: string, phrTrackerDetailID: string): Promise<PHRTrackerCovidDTO> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerCovidByPHRTrackerDetailID/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCovidByPHRTrackerDetailID(_response);
        });
    }

    protected processPHRTrackerCovidByPHRTrackerDetailID(response: Response): Promise<PHRTrackerCovidDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRTrackerCovidDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerCovidDTO>(null as any);
    }

    /**
     * Gets the Covid of the patient PHR tracker.
     * @param pHRTrackerSearchDetails The p hr tracker search details.
     */
    pHRTrackerCovidSearch(pHRTrackerSearchDetails: PHRTrackerSearchDetails): Promise<PHRTrackerCovidDTO[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/PHRTrackerCovidSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerSearchDetails);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCovidSearch(_response);
        });
    }

    protected processPHRTrackerCovidSearch(response: Response): Promise<PHRTrackerCovidDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRTrackerCovidDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRTrackerCovidDTO[]>(null as any);
    }

    /**
     * Inserts the Covid of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerCovid Covid of the p hr tracker.
     */
    pHRTrackerCovidPost(patientID: string, pHRTrackerCovid: PHRTrackerCovidDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerCovid";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerCovid);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCovidPost(_response);
        });
    }

    protected processPHRTrackerCovidPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the Covid of the PHR tracker.
     * @param patientID The patient identifier.
     * @param pHRTrackerCovid Covid of the p hr tracker.
     */
    pHRTrackerCovidPut(patientID: string, pHRTrackerCovid: PHRTrackerCovidDTO): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerCovid";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRTrackerCovid);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCovidPut(_response);
        });
    }

    protected processPHRTrackerCovidPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deletes the Covid of the PHR tracker.
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    pHRTrackerCovidDelete(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/PHRTrackerCovid/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRTrackerCovidDelete(_response);
        });
    }

    protected processPHRTrackerCovidDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified PHRTracker
     * @param patientID The patient identifier.
     * @param phrTrackerDetailID The PHR tracker detail identifier.
     */
    verify(patientID: string, phrTrackerDetailID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRTrackers/{patientID}/Verify/{phrTrackerDetailID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (phrTrackerDetailID === undefined || phrTrackerDetailID === null)
            throw new Error("The parameter 'phrTrackerDetailID' must be defined.");
        url_ = url_.replace("{phrTrackerDetailID}", encodeURIComponent("" + phrTrackerDetailID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PHRVaccinationsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRVaccinationID The identifier.
     */
    pHRVaccinationsGet(patientID: string, pHRVaccinationID: string): Promise<PHRVaccination> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRVaccinations/{patientID}/{pHRVaccinationID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRVaccinationID === undefined || pHRVaccinationID === null)
            throw new Error("The parameter 'pHRVaccinationID' must be defined.");
        url_ = url_.replace("{pHRVaccinationID}", encodeURIComponent("" + pHRVaccinationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRVaccinationsGet(_response);
        });
    }

    protected processPHRVaccinationsGet(response: Response): Promise<PHRVaccination> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRVaccination.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRVaccination>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRVaccinationID The identifier.
     */
    pHRVaccinationsDelete(patientID: string, pHRVaccinationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRVaccinations/{patientID}/{pHRVaccinationID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRVaccinationID === undefined || pHRVaccinationID === null)
            throw new Error("The parameter 'pHRVaccinationID' must be defined.");
        url_ = url_.replace("{pHRVaccinationID}", encodeURIComponent("" + pHRVaccinationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRVaccinationsDelete(_response);
        });
    }

    protected processPHRVaccinationsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrVaccination.
     * @param patientID The patient identifier.
     * @param pHRVaccinationID The PHRVaccinationID.
     */
    verify(patientID: string, pHRVaccinationID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRVaccinations/{patientID}/{pHRVaccinationID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRVaccinationID === undefined || pHRVaccinationID === null)
            throw new Error("The parameter 'pHRVaccinationID' must be defined.");
        url_ = url_.replace("{pHRVaccinationID}", encodeURIComponent("" + pHRVaccinationID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRVaccination[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRVaccinations/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRVaccination[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRVaccination.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRVaccination[]>(null as any);
    }

    /**
     * Posts the specified PHRVaccination.
     * @param pHRVaccination The PHRVaccination.
     */
    pHRVaccinationsPost(pHRVaccination: PHRVaccination): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRVaccinations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRVaccination);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRVaccinationsPost(_response);
        });
    }

    protected processPHRVaccinationsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRVaccination.
     * @param pHRVaccination The PHRVaccination.
     */
    pHRVaccinationsPut(pHRVaccination: PHRVaccination): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRVaccinations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRVaccination);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRVaccinationsPut(_response);
        });
    }

    protected processPHRVaccinationsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PHRWomenHealthsClient extends OutpostHealthClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Gets the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRWomenHealthID The identifier.
     */
    pHRWomenHealthsGet(patientID: string, pHRWomenHealthID: string): Promise<PHRWomenHealth> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRWomenHealths/{patientID}/{pHRWomenHealthID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRWomenHealthID === undefined || pHRWomenHealthID === null)
            throw new Error("The parameter 'pHRWomenHealthID' must be defined.");
        url_ = url_.replace("{pHRWomenHealthID}", encodeURIComponent("" + pHRWomenHealthID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRWomenHealthsGet(_response);
        });
    }

    protected processPHRWomenHealthsGet(response: Response): Promise<PHRWomenHealth> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PHRWomenHealth.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRWomenHealth>(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param patientID The patient identifier.
     * @param pHRWomenHealthID The identifier.
     */
    pHRWomenHealthsDelete(patientID: string, pHRWomenHealthID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRWomenHealths/{patientID}/{pHRWomenHealthID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRWomenHealthID === undefined || pHRWomenHealthID === null)
            throw new Error("The parameter 'pHRWomenHealthID' must be defined.");
        url_ = url_.replace("{pHRWomenHealthID}", encodeURIComponent("" + pHRWomenHealthID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRWomenHealthsDelete(_response);
        });
    }

    protected processPHRWomenHealthsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verifies the specified phrWomenHealth.
     * @param patientID The patient identifier.
     * @param pHRWomenHealthID The PHRWomenHealthID.
     */
    verify(patientID: string, pHRWomenHealthID: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRWomenHealths/{patientID}/{pHRWomenHealthID}/Verify";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        if (pHRWomenHealthID === undefined || pHRWomenHealthID === null)
            throw new Error("The parameter 'pHRWomenHealthID' must be defined.");
        url_ = url_.replace("{pHRWomenHealthID}", encodeURIComponent("" + pHRWomenHealthID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the by patient identifier.
     * @param patientID The patient identifier.
     */
    byPatientID(patientID: string): Promise<PHRWomenHealth[]> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRWomenHealths/ByPatientID/{patientID}";
        if (patientID === undefined || patientID === null)
            throw new Error("The parameter 'patientID' must be defined.");
        url_ = url_.replace("{patientID}", encodeURIComponent("" + patientID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processByPatientID(_response);
        });
    }

    protected processByPatientID(response: Response): Promise<PHRWomenHealth[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PHRWomenHealth.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PHRWomenHealth[]>(null as any);
    }

    /**
     * Posts the specified PHRWomenHealth.
     * @param pHRWomenHealth The PHRWomenHealth.
     */
    pHRWomenHealthsPost(pHRWomenHealth: PHRWomenHealth): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRWomenHealths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRWomenHealth);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRWomenHealthsPost(_response);
        });
    }

    protected processPHRWomenHealthsPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Puts the specified PHRWomenHealth.
     * @param pHRWomenHealth The PHRWomenHealth.
     */
    pHRWomenHealthsPut(pHRWomenHealth: PHRWomenHealth): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/PHRs/PHRWomenHealths";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(pHRWomenHealth);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        
        let abortKey = this.baseUrl + url_ + options_.method;
        if(options_.method === 'GET') {
            if(window.signalStore[abortKey]) {
                window.signalStore[abortKey].abort();
            }
            let abortController = new AbortController();
            window.signalStore[abortKey] = abortController;
            options_.signal = abortController.signal;
        }

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            delete window.signalStore[abortKey];
            return this.processPHRWomenHealthsPut(_response);
        });
    }

    protected processPHRWomenHealthsPut(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export abstract class EntityBase implements IEntityBase {
    isDeleted?: boolean | undefined;
    isAdded?: boolean | undefined;
    createdDate?: Date;
    createdBy?: string;
    updatedDate?: Date | undefined;
    updatedBy?: string | undefined;
    upsertDate?: Date;

    constructor(data?: IEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDeleted = _data["isDeleted"];
            this.isAdded = _data["isAdded"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.upsertDate = _data["upsertDate"] ? new Date(_data["upsertDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["isAdded"] = this.isAdded;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["upsertDate"] = this.upsertDate ? this.upsertDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEntityBase {
    isDeleted?: boolean | undefined;
    isAdded?: boolean | undefined;
    createdDate?: Date;
    createdBy?: string;
    updatedDate?: Date | undefined;
    updatedBy?: string | undefined;
    upsertDate?: Date;
}

export class AddressBook extends EntityBase implements IAddressBook {
    country?: Country | undefined;
    provinceState?: ProvinceState | undefined;
    cityTown?: CityTown | undefined;
    addressBookTags?: AddressBookTag[] | undefined;
    isFavorite?: boolean;
    organizationImageDetailID?: string | undefined;
    sortName?: string | undefined;
    fullName?: string | undefined;
    imageDetailID?: string | undefined;
    addressBookFavoriteInviteStatusEnum?: AddressBookFavoriteInviteStatusEnum;
    distance?: number | undefined;
    addressBookID!: string;
    addressBookTypeEnum!: AddressBookTypeEnum;
    addressBookFolderEnum!: AddressBookFolderEnum;
    countryID!: string;
    enabled!: boolean;
    userDetailID!: string;
    name?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    cityTownID?: string | undefined;
    province?: string | undefined;
    provinceStateID?: string | undefined;
    postCode?: string | undefined;
    homePhoneNumber?: string | undefined;
    officePhoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    faxPhoneNumber?: string | undefined;
    rank?: number | undefined;
    associatedID?: string | undefined;
    organizationName?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    deliveryEnabled!: boolean;
    displaySortOrder!: number;

    constructor(data?: IAddressBook) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            this.cityTown = _data["cityTown"] ? CityTown.fromJS(_data["cityTown"]) : <any>undefined;
            if (Array.isArray(_data["addressBookTags"])) {
                this.addressBookTags = [] as any;
                for (let item of _data["addressBookTags"])
                    this.addressBookTags!.push(AddressBookTag.fromJS(item));
            }
            this.isFavorite = _data["isFavorite"];
            this.organizationImageDetailID = _data["organizationImageDetailID"];
            this.sortName = _data["sortName"];
            this.fullName = _data["fullName"];
            this.imageDetailID = _data["imageDetailID"];
            this.addressBookFavoriteInviteStatusEnum = _data["addressBookFavoriteInviteStatusEnum"];
            this.distance = _data["distance"];
            this.addressBookID = _data["addressBookID"];
            this.addressBookTypeEnum = _data["addressBookTypeEnum"];
            this.addressBookFolderEnum = _data["addressBookFolderEnum"];
            this.countryID = _data["countryID"];
            this.enabled = _data["enabled"];
            this.userDetailID = _data["userDetailID"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.cityTownID = _data["cityTownID"];
            this.province = _data["province"];
            this.provinceStateID = _data["provinceStateID"];
            this.postCode = _data["postCode"];
            this.homePhoneNumber = _data["homePhoneNumber"];
            this.officePhoneNumber = _data["officePhoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.faxPhoneNumber = _data["faxPhoneNumber"];
            this.rank = _data["rank"];
            this.associatedID = _data["associatedID"];
            this.organizationName = _data["organizationName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.deliveryEnabled = _data["deliveryEnabled"];
            this.displaySortOrder = _data["displaySortOrder"];
        }
    }

    static fromJS(data: any): AddressBook {
        data = typeof data === 'object' ? data : {};
        let result = new AddressBook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        data["cityTown"] = this.cityTown ? this.cityTown.toJSON() : <any>undefined;
        if (Array.isArray(this.addressBookTags)) {
            data["addressBookTags"] = [];
            for (let item of this.addressBookTags)
                data["addressBookTags"].push(item.toJSON());
        }
        data["isFavorite"] = this.isFavorite;
        data["organizationImageDetailID"] = this.organizationImageDetailID;
        data["sortName"] = this.sortName;
        data["fullName"] = this.fullName;
        data["imageDetailID"] = this.imageDetailID;
        data["addressBookFavoriteInviteStatusEnum"] = this.addressBookFavoriteInviteStatusEnum;
        data["distance"] = this.distance;
        data["addressBookID"] = this.addressBookID;
        data["addressBookTypeEnum"] = this.addressBookTypeEnum;
        data["addressBookFolderEnum"] = this.addressBookFolderEnum;
        data["countryID"] = this.countryID;
        data["enabled"] = this.enabled;
        data["userDetailID"] = this.userDetailID;
        data["name"] = this.name;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["cityTownID"] = this.cityTownID;
        data["province"] = this.province;
        data["provinceStateID"] = this.provinceStateID;
        data["postCode"] = this.postCode;
        data["homePhoneNumber"] = this.homePhoneNumber;
        data["officePhoneNumber"] = this.officePhoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["faxPhoneNumber"] = this.faxPhoneNumber;
        data["rank"] = this.rank;
        data["associatedID"] = this.associatedID;
        data["organizationName"] = this.organizationName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["deliveryEnabled"] = this.deliveryEnabled;
        data["displaySortOrder"] = this.displaySortOrder;
        super.toJSON(data);
        return data;
    }
}

export interface IAddressBook extends IEntityBase {
    country?: Country | undefined;
    provinceState?: ProvinceState | undefined;
    cityTown?: CityTown | undefined;
    addressBookTags?: AddressBookTag[] | undefined;
    isFavorite?: boolean;
    organizationImageDetailID?: string | undefined;
    sortName?: string | undefined;
    fullName?: string | undefined;
    imageDetailID?: string | undefined;
    addressBookFavoriteInviteStatusEnum?: AddressBookFavoriteInviteStatusEnum;
    distance?: number | undefined;
    addressBookID: string;
    addressBookTypeEnum: AddressBookTypeEnum;
    addressBookFolderEnum: AddressBookFolderEnum;
    countryID: string;
    enabled: boolean;
    userDetailID: string;
    name?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    cityTownID?: string | undefined;
    province?: string | undefined;
    provinceStateID?: string | undefined;
    postCode?: string | undefined;
    homePhoneNumber?: string | undefined;
    officePhoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    faxPhoneNumber?: string | undefined;
    rank?: number | undefined;
    associatedID?: string | undefined;
    organizationName?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    deliveryEnabled: boolean;
    displaySortOrder: number;
}

export class Country extends EntityBase implements ICountry {
    currencyEnum?: CurrencyEnum;
    formattedSupportNumber?: string | undefined;
    countryID!: string;
    name!: string;
    code!: string;
    currencyName!: string;
    currencySymbol!: string;
    currencyCode!: string;
    taxLabel!: string;
    enabled!: boolean;
    cultureName!: string;
    insuranceProviderRequired!: boolean;
    emergencyNumber?: string | undefined;
    provinceStateLabel?: string | undefined;
    bannerURL?: string | undefined;
    mentalEmergencyNumber?: string | undefined;
    supportNumber?: string | undefined;
    whatsAppNumber?: string | undefined;
    measurementTypeEnum!: MeasurementTypeEnum;
    latitude?: number | undefined;
    longitude?: number | undefined;
    externalWalletAPISettingID?: string | undefined;

    constructor(data?: ICountry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currencyEnum = _data["currencyEnum"];
            this.formattedSupportNumber = _data["formattedSupportNumber"];
            this.countryID = _data["countryID"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.currencyName = _data["currencyName"];
            this.currencySymbol = _data["currencySymbol"];
            this.currencyCode = _data["currencyCode"];
            this.taxLabel = _data["taxLabel"];
            this.enabled = _data["enabled"];
            this.cultureName = _data["cultureName"];
            this.insuranceProviderRequired = _data["insuranceProviderRequired"];
            this.emergencyNumber = _data["emergencyNumber"];
            this.provinceStateLabel = _data["provinceStateLabel"];
            this.bannerURL = _data["bannerURL"];
            this.mentalEmergencyNumber = _data["mentalEmergencyNumber"];
            this.supportNumber = _data["supportNumber"];
            this.whatsAppNumber = _data["whatsAppNumber"];
            this.measurementTypeEnum = _data["measurementTypeEnum"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.externalWalletAPISettingID = _data["externalWalletAPISettingID"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyEnum"] = this.currencyEnum;
        data["formattedSupportNumber"] = this.formattedSupportNumber;
        data["countryID"] = this.countryID;
        data["name"] = this.name;
        data["code"] = this.code;
        data["currencyName"] = this.currencyName;
        data["currencySymbol"] = this.currencySymbol;
        data["currencyCode"] = this.currencyCode;
        data["taxLabel"] = this.taxLabel;
        data["enabled"] = this.enabled;
        data["cultureName"] = this.cultureName;
        data["insuranceProviderRequired"] = this.insuranceProviderRequired;
        data["emergencyNumber"] = this.emergencyNumber;
        data["provinceStateLabel"] = this.provinceStateLabel;
        data["bannerURL"] = this.bannerURL;
        data["mentalEmergencyNumber"] = this.mentalEmergencyNumber;
        data["supportNumber"] = this.supportNumber;
        data["whatsAppNumber"] = this.whatsAppNumber;
        data["measurementTypeEnum"] = this.measurementTypeEnum;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["externalWalletAPISettingID"] = this.externalWalletAPISettingID;
        super.toJSON(data);
        return data;
    }
}

export interface ICountry extends IEntityBase {
    currencyEnum?: CurrencyEnum;
    formattedSupportNumber?: string | undefined;
    countryID: string;
    name: string;
    code: string;
    currencyName: string;
    currencySymbol: string;
    currencyCode: string;
    taxLabel: string;
    enabled: boolean;
    cultureName: string;
    insuranceProviderRequired: boolean;
    emergencyNumber?: string | undefined;
    provinceStateLabel?: string | undefined;
    bannerURL?: string | undefined;
    mentalEmergencyNumber?: string | undefined;
    supportNumber?: string | undefined;
    whatsAppNumber?: string | undefined;
    measurementTypeEnum: MeasurementTypeEnum;
    latitude?: number | undefined;
    longitude?: number | undefined;
    externalWalletAPISettingID?: string | undefined;
}

export enum CurrencyEnum {
    NotSet = "NotSet",
    CAD = "CAD",
    NGN = "NGN",
    USD = "USD",
    PHP = "PHP",
    GHS = "GHS",
    LRD = "LRD",
    GBP = "GBP",
    EUR = "EUR",
    KES = "KES",
    ZAR = "ZAR",
    TTD = "TTD",
    SLL = "SLL",
    BBD = "BBD",
    AFN = "AFN",
    ALL = "ALL",
    DZD = "DZD",
    AOA = "AOA",
    XCD = "XCD",
    ARS = "ARS",
    AMD = "AMD",
    AWG = "AWG",
    AUD = "AUD",
    AZN = "AZN",
    BSD = "BSD",
    BHD = "BHD",
    BDT = "BDT",
    BYN = "BYN",
    BZD = "BZD",
    XOF = "XOF",
    BMD = "BMD",
    BTN = "BTN",
    BOB = "BOB",
    BAM = "BAM",
    BWP = "BWP",
    NOK = "NOK",
    BRL = "BRL",
    BND = "BND",
    BGN = "BGN",
    BIF = "BIF",
    KHR = "KHR",
    XAF = "XAF",
    CVE = "CVE",
    KYD = "KYD",
    CLP = "CLP",
    CNY = "CNY",
    COP = "COP",
    KMF = "KMF",
    CDF = "CDF",
    NZD = "NZD",
    CRC = "CRC",
    HRK = "HRK",
    CUP = "CUP",
    ANG = "ANG",
    CZK = "CZK",
    DKK = "DKK",
    DJF = "DJF",
    DOP = "DOP",
    EGP = "EGP",
    ERN = "ERN",
    SZL = "SZL",
    ETB = "ETB",
    FKP = "FKP",
    FJD = "FJD",
    XPF = "XPF",
    GMD = "GMD",
    GEL = "GEL",
    GIP = "GIP",
    GTQ = "GTQ",
    GNF = "GNF",
    GYD = "GYD",
    HTG = "HTG",
    HNL = "HNL",
    HKD = "HKD",
    HUF = "HUF",
    ISK = "ISK",
    INR = "INR",
    IDR = "IDR",
    IRR = "IRR",
    IQD = "IQD",
    ILS = "ILS",
    JMD = "JMD",
    JPY = "JPY",
    JOD = "JOD",
    KZT = "KZT",
    KPW = "KPW",
    KRW = "KRW",
    KWD = "KWD",
    KGS = "KGS",
    LAK = "LAK",
    LBP = "LBP",
    LSL = "LSL",
    LYD = "LYD",
    CHF = "CHF",
    MOP = "MOP",
    MKD = "MKD",
    MGA = "MGA",
    MWK = "MWK",
    MYR = "MYR",
    MVR = "MVR",
    MRU = "MRU",
    MUR = "MUR",
    MXN = "MXN",
    MDL = "MDL",
    MNT = "MNT",
    MAD = "MAD",
    MZN = "MZN",
    MMK = "MMK",
    NAD = "NAD",
    NPR = "NPR",
    NIO = "NIO",
    OMR = "OMR",
    PKR = "PKR",
    PAB = "PAB",
    PGK = "PGK",
    PYG = "PYG",
    PEN = "PEN",
    PLN = "PLN",
    QAR = "QAR",
    RON = "RON",
    RUB = "RUB",
    RWF = "RWF",
    SHP = "SHP",
    WST = "WST",
    STN = "STN",
    SAR = "SAR",
    RSD = "RSD",
    SCR = "SCR",
    SGD = "SGD",
    SBD = "SBD",
    SOS = "SOS",
    SSP = "SSP",
    LKR = "LKR",
    SDG = "SDG",
    SRD = "SRD",
    SEK = "SEK",
    SYP = "SYP",
    TWD = "TWD",
    TJS = "TJS",
    TZS = "TZS",
    THB = "THB",
    TOP = "TOP",
    TND = "TND",
    TRY = "TRY",
    TMT = "TMT",
    UGX = "UGX",
    UAH = "UAH",
    AED = "AED",
    UYU = "UYU",
    UZS = "UZS",
    VUV = "VUV",
    VES = "VES",
    VND = "VND",
    YER = "YER",
    ZMW = "ZMW",
    ZWL = "ZWL",
}

export enum MeasurementTypeEnum {
    Metric = "Metric",
    Imperial = "Imperial",
}

export class ProvinceState extends EntityBase implements IProvinceState {
    provinceStateID!: string;
    name!: string;
    code!: string;
    countryID!: string;
    country?: Country | undefined;
    cityTowns?: CityTown[] | undefined;
    governmentZones?: GovernmentZone[] | undefined;

    constructor(data?: IProvinceState) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.provinceStateID = _data["provinceStateID"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.countryID = _data["countryID"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["cityTowns"])) {
                this.cityTowns = [] as any;
                for (let item of _data["cityTowns"])
                    this.cityTowns!.push(CityTown.fromJS(item));
            }
            if (Array.isArray(_data["governmentZones"])) {
                this.governmentZones = [] as any;
                for (let item of _data["governmentZones"])
                    this.governmentZones!.push(GovernmentZone.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProvinceState {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provinceStateID"] = this.provinceStateID;
        data["name"] = this.name;
        data["code"] = this.code;
        data["countryID"] = this.countryID;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.cityTowns)) {
            data["cityTowns"] = [];
            for (let item of this.cityTowns)
                data["cityTowns"].push(item.toJSON());
        }
        if (Array.isArray(this.governmentZones)) {
            data["governmentZones"] = [];
            for (let item of this.governmentZones)
                data["governmentZones"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProvinceState extends IEntityBase {
    provinceStateID: string;
    name: string;
    code: string;
    countryID: string;
    country?: Country | undefined;
    cityTowns?: CityTown[] | undefined;
    governmentZones?: GovernmentZone[] | undefined;
}

export class CityTown extends EntityBase implements ICityTown {
    provinceState?: ProvinceState | undefined;
    cityTownID!: string;
    name!: string;
    description!: string;
    provinceStateID!: string;
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: ICityTown) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            this.cityTownID = _data["cityTownID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.provinceStateID = _data["provinceStateID"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): CityTown {
        data = typeof data === 'object' ? data : {};
        let result = new CityTown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        data["cityTownID"] = this.cityTownID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["provinceStateID"] = this.provinceStateID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        super.toJSON(data);
        return data;
    }
}

export interface ICityTown extends IEntityBase {
    provinceState?: ProvinceState | undefined;
    cityTownID: string;
    name: string;
    description: string;
    provinceStateID: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class GovernmentZone extends EntityBase implements IGovernmentZone {
    governmentZoneID!: string;
    name!: string;
    description!: string;
    provinceStateID!: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    storeItemID?: string | undefined;
    provinceState?: ProvinceState | undefined;
    storeItem?: StoreItem | undefined;

    constructor(data?: IGovernmentZone) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.governmentZoneID = _data["governmentZoneID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.provinceStateID = _data["provinceStateID"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.storeItemID = _data["storeItemID"];
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GovernmentZone {
        data = typeof data === 'object' ? data : {};
        let result = new GovernmentZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["governmentZoneID"] = this.governmentZoneID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["provinceStateID"] = this.provinceStateID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["storeItemID"] = this.storeItemID;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGovernmentZone extends IEntityBase {
    governmentZoneID: string;
    name: string;
    description: string;
    provinceStateID: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    storeItemID?: string | undefined;
    provinceState?: ProvinceState | undefined;
    storeItem?: StoreItem | undefined;
}

export class StoreItem extends EntityBase implements IStoreItem {
    storeItemID!: string;
    storeID!: string;
    itemID!: string;
    storeItemTypeEnum!: StoreItemTypeEnum;
    enabled!: boolean;
    taxID!: string;
    glAccountID!: string;
    costAmount!: number;
    retailAmount!: number;
    currencyEnum!: CurrencyEnum;
    quantity!: number;
    isPhysical!: boolean;
    minimumQuantity!: number;
    maximumQuantity!: number;
    showOnInvoice!: boolean;
    refundable!: boolean;
    minutes?: number | undefined;
    warningMinutes?: number | undefined;
    externalNumber?: string | undefined;
    displaySortOrder?: number | undefined;
    insuranceProviderTypeEnum!: InsuranceProviderTypeEnum;
    followupFromStoreItemID?: string | undefined;
    followupMinimumHours?: number | undefined;
    followupMaximumHours?: number | undefined;
    followupCount!: number;
    recurringStoreItemID?: string | undefined;
    costPercent?: number | undefined;
    eStore!: boolean;
    taskItemTypeName?: string | undefined;
    item?: Item | undefined;
    tax?: Tax | undefined;
    store?: Store | undefined;
    providerStoreItems?: ProviderStoreItem[] | undefined;
    storeItemTags?: StoreItemTag[] | undefined;
    storeItemForms?: StoreItemForm[] | undefined;
    storeItemXrefs?: StoreItemXref[] | undefined;
    followupFromStoreItem?: StoreItem | undefined;
    isSubscription?: boolean;
    subscriptionDescription?: string | undefined;
    publicInsuranceProviderDescription?: string | undefined;
    glAccount?: GLAccount | undefined;

    constructor(data?: IStoreItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeItemID = _data["storeItemID"];
            this.storeID = _data["storeID"];
            this.itemID = _data["itemID"];
            this.storeItemTypeEnum = _data["storeItemTypeEnum"];
            this.enabled = _data["enabled"];
            this.taxID = _data["taxID"];
            this.glAccountID = _data["glAccountID"];
            this.costAmount = _data["costAmount"];
            this.retailAmount = _data["retailAmount"];
            this.currencyEnum = _data["currencyEnum"];
            this.quantity = _data["quantity"];
            this.isPhysical = _data["isPhysical"];
            this.minimumQuantity = _data["minimumQuantity"];
            this.maximumQuantity = _data["maximumQuantity"];
            this.showOnInvoice = _data["showOnInvoice"];
            this.refundable = _data["refundable"];
            this.minutes = _data["minutes"];
            this.warningMinutes = _data["warningMinutes"];
            this.externalNumber = _data["externalNumber"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.insuranceProviderTypeEnum = _data["insuranceProviderTypeEnum"];
            this.followupFromStoreItemID = _data["followupFromStoreItemID"];
            this.followupMinimumHours = _data["followupMinimumHours"];
            this.followupMaximumHours = _data["followupMaximumHours"];
            this.followupCount = _data["followupCount"];
            this.recurringStoreItemID = _data["recurringStoreItemID"];
            this.costPercent = _data["costPercent"];
            this.eStore = _data["eStore"];
            this.taskItemTypeName = _data["taskItemTypeName"];
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>undefined;
            this.tax = _data["tax"] ? Tax.fromJS(_data["tax"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            if (Array.isArray(_data["providerStoreItems"])) {
                this.providerStoreItems = [] as any;
                for (let item of _data["providerStoreItems"])
                    this.providerStoreItems!.push(ProviderStoreItem.fromJS(item));
            }
            if (Array.isArray(_data["storeItemTags"])) {
                this.storeItemTags = [] as any;
                for (let item of _data["storeItemTags"])
                    this.storeItemTags!.push(StoreItemTag.fromJS(item));
            }
            if (Array.isArray(_data["storeItemForms"])) {
                this.storeItemForms = [] as any;
                for (let item of _data["storeItemForms"])
                    this.storeItemForms!.push(StoreItemForm.fromJS(item));
            }
            if (Array.isArray(_data["storeItemXrefs"])) {
                this.storeItemXrefs = [] as any;
                for (let item of _data["storeItemXrefs"])
                    this.storeItemXrefs!.push(StoreItemXref.fromJS(item));
            }
            this.followupFromStoreItem = _data["followupFromStoreItem"] ? StoreItem.fromJS(_data["followupFromStoreItem"]) : <any>undefined;
            this.isSubscription = _data["isSubscription"];
            this.subscriptionDescription = _data["subscriptionDescription"];
            this.publicInsuranceProviderDescription = _data["publicInsuranceProviderDescription"];
            this.glAccount = _data["glAccount"] ? GLAccount.fromJS(_data["glAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new StoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeItemID"] = this.storeItemID;
        data["storeID"] = this.storeID;
        data["itemID"] = this.itemID;
        data["storeItemTypeEnum"] = this.storeItemTypeEnum;
        data["enabled"] = this.enabled;
        data["taxID"] = this.taxID;
        data["glAccountID"] = this.glAccountID;
        data["costAmount"] = this.costAmount;
        data["retailAmount"] = this.retailAmount;
        data["currencyEnum"] = this.currencyEnum;
        data["quantity"] = this.quantity;
        data["isPhysical"] = this.isPhysical;
        data["minimumQuantity"] = this.minimumQuantity;
        data["maximumQuantity"] = this.maximumQuantity;
        data["showOnInvoice"] = this.showOnInvoice;
        data["refundable"] = this.refundable;
        data["minutes"] = this.minutes;
        data["warningMinutes"] = this.warningMinutes;
        data["externalNumber"] = this.externalNumber;
        data["displaySortOrder"] = this.displaySortOrder;
        data["insuranceProviderTypeEnum"] = this.insuranceProviderTypeEnum;
        data["followupFromStoreItemID"] = this.followupFromStoreItemID;
        data["followupMinimumHours"] = this.followupMinimumHours;
        data["followupMaximumHours"] = this.followupMaximumHours;
        data["followupCount"] = this.followupCount;
        data["recurringStoreItemID"] = this.recurringStoreItemID;
        data["costPercent"] = this.costPercent;
        data["eStore"] = this.eStore;
        data["taskItemTypeName"] = this.taskItemTypeName;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (Array.isArray(this.providerStoreItems)) {
            data["providerStoreItems"] = [];
            for (let item of this.providerStoreItems)
                data["providerStoreItems"].push(item.toJSON());
        }
        if (Array.isArray(this.storeItemTags)) {
            data["storeItemTags"] = [];
            for (let item of this.storeItemTags)
                data["storeItemTags"].push(item.toJSON());
        }
        if (Array.isArray(this.storeItemForms)) {
            data["storeItemForms"] = [];
            for (let item of this.storeItemForms)
                data["storeItemForms"].push(item.toJSON());
        }
        if (Array.isArray(this.storeItemXrefs)) {
            data["storeItemXrefs"] = [];
            for (let item of this.storeItemXrefs)
                data["storeItemXrefs"].push(item.toJSON());
        }
        data["followupFromStoreItem"] = this.followupFromStoreItem ? this.followupFromStoreItem.toJSON() : <any>undefined;
        data["isSubscription"] = this.isSubscription;
        data["subscriptionDescription"] = this.subscriptionDescription;
        data["publicInsuranceProviderDescription"] = this.publicInsuranceProviderDescription;
        data["glAccount"] = this.glAccount ? this.glAccount.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreItem extends IEntityBase {
    storeItemID: string;
    storeID: string;
    itemID: string;
    storeItemTypeEnum: StoreItemTypeEnum;
    enabled: boolean;
    taxID: string;
    glAccountID: string;
    costAmount: number;
    retailAmount: number;
    currencyEnum: CurrencyEnum;
    quantity: number;
    isPhysical: boolean;
    minimumQuantity: number;
    maximumQuantity: number;
    showOnInvoice: boolean;
    refundable: boolean;
    minutes?: number | undefined;
    warningMinutes?: number | undefined;
    externalNumber?: string | undefined;
    displaySortOrder?: number | undefined;
    insuranceProviderTypeEnum: InsuranceProviderTypeEnum;
    followupFromStoreItemID?: string | undefined;
    followupMinimumHours?: number | undefined;
    followupMaximumHours?: number | undefined;
    followupCount: number;
    recurringStoreItemID?: string | undefined;
    costPercent?: number | undefined;
    eStore: boolean;
    taskItemTypeName?: string | undefined;
    item?: Item | undefined;
    tax?: Tax | undefined;
    store?: Store | undefined;
    providerStoreItems?: ProviderStoreItem[] | undefined;
    storeItemTags?: StoreItemTag[] | undefined;
    storeItemForms?: StoreItemForm[] | undefined;
    storeItemXrefs?: StoreItemXref[] | undefined;
    followupFromStoreItem?: StoreItem | undefined;
    isSubscription?: boolean;
    subscriptionDescription?: string | undefined;
    publicInsuranceProviderDescription?: string | undefined;
    glAccount?: GLAccount | undefined;
}

export enum StoreItemTypeEnum {
    VideoConsult = "Video Consult",
    AddOnAdditionalPatient = "AddOnAdditionalPatient",
    AddOnAdditionalProvider = "AddOnAdditionalProvider",
    AddOnAdditionalMessaging = "AddOnAdditionalMessaging",
    AddOnReferall = "AddOnReferall",
    ServiceCharge = "ServiceCharge",
    Medication = "Medication",
    InPersonConsult = "In Person Consultation",
    PatientOrder = "PatientOrder",
    Prescription = "Prescription",
    OrderService = "OrderService",
    SubscriptionItem = "SubscriptionItem",
    CustomItem = "CustomItem",
    OrderItem = "OrderItem",
    CurrencyExchange = "CurrencyExchange",
    BundleHeader = "BundleHeader",
    NeoPayment = "NeoPayment",
    PaymentLinkService = "PaymentLinkService",
}

export enum InsuranceProviderTypeEnum {
    NotSet = "NotSet",
    Public = "Public",
    Private = "Private",
}

export class Item extends EntityBase implements IItem {
    itemID!: string;
    itemTypeEnum!: ItemTypeEnum;
    name!: string;
    shortName!: string;
    description!: string;
    imageURL?: string | undefined;
    itemImages?: ItemImage[] | undefined;
    itemProperties?: ItemProperty[] | undefined;

    constructor(data?: IItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itemID = _data["itemID"];
            this.itemTypeEnum = _data["itemTypeEnum"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.imageURL = _data["imageURL"];
            if (Array.isArray(_data["itemImages"])) {
                this.itemImages = [] as any;
                for (let item of _data["itemImages"])
                    this.itemImages!.push(ItemImage.fromJS(item));
            }
            if (Array.isArray(_data["itemProperties"])) {
                this.itemProperties = [] as any;
                for (let item of _data["itemProperties"])
                    this.itemProperties!.push(ItemProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemID"] = this.itemID;
        data["itemTypeEnum"] = this.itemTypeEnum;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["imageURL"] = this.imageURL;
        if (Array.isArray(this.itemImages)) {
            data["itemImages"] = [];
            for (let item of this.itemImages)
                data["itemImages"].push(item.toJSON());
        }
        if (Array.isArray(this.itemProperties)) {
            data["itemProperties"] = [];
            for (let item of this.itemProperties)
                data["itemProperties"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IItem extends IEntityBase {
    itemID: string;
    itemTypeEnum: ItemTypeEnum;
    name: string;
    shortName: string;
    description: string;
    imageURL?: string | undefined;
    itemImages?: ItemImage[] | undefined;
    itemProperties?: ItemProperty[] | undefined;
}

export enum ItemTypeEnum {
    Service = "Service",
    Subscription = "Subscription",
    Prescription = "Prescription",
    Wallet = "Wallet",
    ServiceAddOn = "ServiceAddOn",
    Item = "Item",
    Order = "Order",
    Medication = "Medication",
    OrderItem = "OrderItem",
    Recurring = "Recurring",
    CurrencyExchange = "CurrencyExchange",
}

export class ItemImage extends EntityBase implements IItemImage {
    itemImageID!: string;
    itemID!: string;
    imageURL!: string;
    displaySortOrder!: number;
    description!: string;

    constructor(data?: IItemImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itemImageID = _data["itemImageID"];
            this.itemID = _data["itemID"];
            this.imageURL = _data["imageURL"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ItemImage {
        data = typeof data === 'object' ? data : {};
        let result = new ItemImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemImageID"] = this.itemImageID;
        data["itemID"] = this.itemID;
        data["imageURL"] = this.imageURL;
        data["displaySortOrder"] = this.displaySortOrder;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IItemImage extends IEntityBase {
    itemImageID: string;
    itemID: string;
    imageURL: string;
    displaySortOrder: number;
    description: string;
}

export class ItemProperty extends EntityBase implements IItemProperty {
    itemPropertyID!: string;
    itemID!: string;
    itemPropertType!: string;
    displaySortOrder!: number;
    name!: string;
    title!: string;
    value?: string | undefined;

    constructor(data?: IItemProperty) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itemPropertyID = _data["itemPropertyID"];
            this.itemID = _data["itemID"];
            this.itemPropertType = _data["itemPropertType"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ItemProperty {
        data = typeof data === 'object' ? data : {};
        let result = new ItemProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemPropertyID"] = this.itemPropertyID;
        data["itemID"] = this.itemID;
        data["itemPropertType"] = this.itemPropertType;
        data["displaySortOrder"] = this.displaySortOrder;
        data["name"] = this.name;
        data["title"] = this.title;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IItemProperty extends IEntityBase {
    itemPropertyID: string;
    itemID: string;
    itemPropertType: string;
    displaySortOrder: number;
    name: string;
    title: string;
    value?: string | undefined;
}

export class Tax extends EntityBase implements ITax {
    taxID!: string;
    countryID!: string;
    description!: string;
    name!: string;
    includeOnStatement!: boolean;
    country?: Country | undefined;
    taxDetails?: TaxDetail[] | undefined;

    constructor(data?: ITax) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taxID = _data["taxID"];
            this.countryID = _data["countryID"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.includeOnStatement = _data["includeOnStatement"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["taxDetails"])) {
                this.taxDetails = [] as any;
                for (let item of _data["taxDetails"])
                    this.taxDetails!.push(TaxDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Tax {
        data = typeof data === 'object' ? data : {};
        let result = new Tax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxID"] = this.taxID;
        data["countryID"] = this.countryID;
        data["description"] = this.description;
        data["name"] = this.name;
        data["includeOnStatement"] = this.includeOnStatement;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.taxDetails)) {
            data["taxDetails"] = [];
            for (let item of this.taxDetails)
                data["taxDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITax extends IEntityBase {
    taxID: string;
    countryID: string;
    description: string;
    name: string;
    includeOnStatement: boolean;
    country?: Country | undefined;
    taxDetails?: TaxDetail[] | undefined;
}

export class TaxDetail extends EntityBase implements ITaxDetail {
    taxDetailID!: string;
    taxID!: string;
    glAccountID!: string;
    description!: string;
    percent!: number;

    constructor(data?: ITaxDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taxDetailID = _data["taxDetailID"];
            this.taxID = _data["taxID"];
            this.glAccountID = _data["glAccountID"];
            this.description = _data["description"];
            this.percent = _data["percent"];
        }
    }

    static fromJS(data: any): TaxDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TaxDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxDetailID"] = this.taxDetailID;
        data["taxID"] = this.taxID;
        data["glAccountID"] = this.glAccountID;
        data["description"] = this.description;
        data["percent"] = this.percent;
        super.toJSON(data);
        return data;
    }
}

export interface ITaxDetail extends IEntityBase {
    taxDetailID: string;
    taxID: string;
    glAccountID: string;
    description: string;
    percent: number;
}

export class Store extends EntityBase implements IStore {
    storeID!: string;
    storeTypeEnum!: StoreTypeEnum;
    name!: string;
    description!: string;
    tagID?: string | undefined;
    organizationID?: string | undefined;
    countryID!: string;
    imageDetailID?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    cityTownID?: string | undefined;
    provinceStateID?: string | undefined;
    postCode?: string | undefined;
    contactPhoneNumber?: string | undefined;
    faxPhoneNumber?: string | undefined;
    enabled!: boolean;
    timeZone!: string;
    iconTag?: string | undefined;
    displaySortOrder?: number | undefined;
    speciality?: boolean | undefined;
    paymentProcessorID?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    externalURL?: string | undefined;
    qrCode!: number;
    merchantActive!: boolean;
    publicPage!: boolean;
    publicTag?: string | undefined;
    externalID?: string | undefined;
    serviceDescription?: string | undefined;
    allowNegativeQuantities!: boolean;
    deliveryEnabled!: boolean;
    landmarks?: string | undefined;
    impressions!: number;
    rating!: number;
    ratingCount!: number;
    scheduleAvailabilityDate?: Date | undefined;
    countryDefault!: boolean;
    notificationEmailAddress?: string | undefined;
    eStore!: boolean;
    country?: Country | undefined;
    imageDetail?: ImageDetail | undefined;
    storeItems?: StoreItem[] | undefined;
    paymentProcessor?: PaymentProcessor | undefined;
    organization?: Organization | undefined;
    provinceState?: ProvinceState | undefined;
    storeImages?: StoreImage[] | undefined;
    province?: string | undefined;
    cityTown?: CityTown | undefined;
    storeSchedules?: StoreSchedule[] | undefined;
    city?: string | undefined;
    storeAvailabilityTypeEnum?: StoreAvailabilityTypeEnum;
    storeRooms?: StoreRoom[] | undefined;
    fullAddress?: string | undefined;
    supportsStoreItemTypes?: StoreItemTypeEnum[] | undefined;
    imageDetailBase64?: string | undefined;

    constructor(data?: IStore) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeID = _data["storeID"];
            this.storeTypeEnum = _data["storeTypeEnum"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.tagID = _data["tagID"];
            this.organizationID = _data["organizationID"];
            this.countryID = _data["countryID"];
            this.imageDetailID = _data["imageDetailID"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.cityTownID = _data["cityTownID"];
            this.provinceStateID = _data["provinceStateID"];
            this.postCode = _data["postCode"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.faxPhoneNumber = _data["faxPhoneNumber"];
            this.enabled = _data["enabled"];
            this.timeZone = _data["timeZone"];
            this.iconTag = _data["iconTag"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.speciality = _data["speciality"];
            this.paymentProcessorID = _data["paymentProcessorID"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.externalURL = _data["externalURL"];
            this.qrCode = _data["qrCode"];
            this.merchantActive = _data["merchantActive"];
            this.publicPage = _data["publicPage"];
            this.publicTag = _data["publicTag"];
            this.externalID = _data["externalID"];
            this.serviceDescription = _data["serviceDescription"];
            this.allowNegativeQuantities = _data["allowNegativeQuantities"];
            this.deliveryEnabled = _data["deliveryEnabled"];
            this.landmarks = _data["landmarks"];
            this.impressions = _data["impressions"];
            this.rating = _data["rating"];
            this.ratingCount = _data["ratingCount"];
            this.scheduleAvailabilityDate = _data["scheduleAvailabilityDate"] ? new Date(_data["scheduleAvailabilityDate"].toString()) : <any>undefined;
            this.countryDefault = _data["countryDefault"];
            this.notificationEmailAddress = _data["notificationEmailAddress"];
            this.eStore = _data["eStore"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.imageDetail = _data["imageDetail"] ? ImageDetail.fromJS(_data["imageDetail"]) : <any>undefined;
            if (Array.isArray(_data["storeItems"])) {
                this.storeItems = [] as any;
                for (let item of _data["storeItems"])
                    this.storeItems!.push(StoreItem.fromJS(item));
            }
            this.paymentProcessor = _data["paymentProcessor"] ? PaymentProcessor.fromJS(_data["paymentProcessor"]) : <any>undefined;
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            if (Array.isArray(_data["storeImages"])) {
                this.storeImages = [] as any;
                for (let item of _data["storeImages"])
                    this.storeImages!.push(StoreImage.fromJS(item));
            }
            this.province = _data["province"];
            this.cityTown = _data["cityTown"] ? CityTown.fromJS(_data["cityTown"]) : <any>undefined;
            if (Array.isArray(_data["storeSchedules"])) {
                this.storeSchedules = [] as any;
                for (let item of _data["storeSchedules"])
                    this.storeSchedules!.push(StoreSchedule.fromJS(item));
            }
            this.city = _data["city"];
            this.storeAvailabilityTypeEnum = _data["storeAvailabilityTypeEnum"];
            if (Array.isArray(_data["storeRooms"])) {
                this.storeRooms = [] as any;
                for (let item of _data["storeRooms"])
                    this.storeRooms!.push(StoreRoom.fromJS(item));
            }
            this.fullAddress = _data["fullAddress"];
            if (Array.isArray(_data["supportsStoreItemTypes"])) {
                this.supportsStoreItemTypes = [] as any;
                for (let item of _data["supportsStoreItemTypes"])
                    this.supportsStoreItemTypes!.push(item);
            }
            this.imageDetailBase64 = _data["imageDetailBase64"];
        }
    }

    static fromJS(data: any): Store {
        data = typeof data === 'object' ? data : {};
        let result = new Store();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeID"] = this.storeID;
        data["storeTypeEnum"] = this.storeTypeEnum;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tagID"] = this.tagID;
        data["organizationID"] = this.organizationID;
        data["countryID"] = this.countryID;
        data["imageDetailID"] = this.imageDetailID;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["cityTownID"] = this.cityTownID;
        data["provinceStateID"] = this.provinceStateID;
        data["postCode"] = this.postCode;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["faxPhoneNumber"] = this.faxPhoneNumber;
        data["enabled"] = this.enabled;
        data["timeZone"] = this.timeZone;
        data["iconTag"] = this.iconTag;
        data["displaySortOrder"] = this.displaySortOrder;
        data["speciality"] = this.speciality;
        data["paymentProcessorID"] = this.paymentProcessorID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["externalURL"] = this.externalURL;
        data["qrCode"] = this.qrCode;
        data["merchantActive"] = this.merchantActive;
        data["publicPage"] = this.publicPage;
        data["publicTag"] = this.publicTag;
        data["externalID"] = this.externalID;
        data["serviceDescription"] = this.serviceDescription;
        data["allowNegativeQuantities"] = this.allowNegativeQuantities;
        data["deliveryEnabled"] = this.deliveryEnabled;
        data["landmarks"] = this.landmarks;
        data["impressions"] = this.impressions;
        data["rating"] = this.rating;
        data["ratingCount"] = this.ratingCount;
        data["scheduleAvailabilityDate"] = this.scheduleAvailabilityDate ? this.scheduleAvailabilityDate.toISOString() : <any>undefined;
        data["countryDefault"] = this.countryDefault;
        data["notificationEmailAddress"] = this.notificationEmailAddress;
        data["eStore"] = this.eStore;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["imageDetail"] = this.imageDetail ? this.imageDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.storeItems)) {
            data["storeItems"] = [];
            for (let item of this.storeItems)
                data["storeItems"].push(item.toJSON());
        }
        data["paymentProcessor"] = this.paymentProcessor ? this.paymentProcessor.toJSON() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        if (Array.isArray(this.storeImages)) {
            data["storeImages"] = [];
            for (let item of this.storeImages)
                data["storeImages"].push(item.toJSON());
        }
        data["province"] = this.province;
        data["cityTown"] = this.cityTown ? this.cityTown.toJSON() : <any>undefined;
        if (Array.isArray(this.storeSchedules)) {
            data["storeSchedules"] = [];
            for (let item of this.storeSchedules)
                data["storeSchedules"].push(item.toJSON());
        }
        data["city"] = this.city;
        data["storeAvailabilityTypeEnum"] = this.storeAvailabilityTypeEnum;
        if (Array.isArray(this.storeRooms)) {
            data["storeRooms"] = [];
            for (let item of this.storeRooms)
                data["storeRooms"].push(item.toJSON());
        }
        data["fullAddress"] = this.fullAddress;
        if (Array.isArray(this.supportsStoreItemTypes)) {
            data["supportsStoreItemTypes"] = [];
            for (let item of this.supportsStoreItemTypes)
                data["supportsStoreItemTypes"].push(item);
        }
        data["imageDetailBase64"] = this.imageDetailBase64;
        super.toJSON(data);
        return data;
    }
}

export interface IStore extends IEntityBase {
    storeID: string;
    storeTypeEnum: StoreTypeEnum;
    name: string;
    description: string;
    tagID?: string | undefined;
    organizationID?: string | undefined;
    countryID: string;
    imageDetailID?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    cityTownID?: string | undefined;
    provinceStateID?: string | undefined;
    postCode?: string | undefined;
    contactPhoneNumber?: string | undefined;
    faxPhoneNumber?: string | undefined;
    enabled: boolean;
    timeZone: string;
    iconTag?: string | undefined;
    displaySortOrder?: number | undefined;
    speciality?: boolean | undefined;
    paymentProcessorID?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    externalURL?: string | undefined;
    qrCode: number;
    merchantActive: boolean;
    publicPage: boolean;
    publicTag?: string | undefined;
    externalID?: string | undefined;
    serviceDescription?: string | undefined;
    allowNegativeQuantities: boolean;
    deliveryEnabled: boolean;
    landmarks?: string | undefined;
    impressions: number;
    rating: number;
    ratingCount: number;
    scheduleAvailabilityDate?: Date | undefined;
    countryDefault: boolean;
    notificationEmailAddress?: string | undefined;
    eStore: boolean;
    country?: Country | undefined;
    imageDetail?: ImageDetail | undefined;
    storeItems?: StoreItem[] | undefined;
    paymentProcessor?: PaymentProcessor | undefined;
    organization?: Organization | undefined;
    provinceState?: ProvinceState | undefined;
    storeImages?: StoreImage[] | undefined;
    province?: string | undefined;
    cityTown?: CityTown | undefined;
    storeSchedules?: StoreSchedule[] | undefined;
    city?: string | undefined;
    storeAvailabilityTypeEnum?: StoreAvailabilityTypeEnum;
    storeRooms?: StoreRoom[] | undefined;
    fullAddress?: string | undefined;
    supportsStoreItemTypes?: StoreItemTypeEnum[] | undefined;
    imageDetailBase64?: string | undefined;
}

export enum StoreTypeEnum {
    Clinic = "Clinic",
    Pharmacy = "Pharmacy",
    Wallet = "Wallet",
    Lab = "Lab",
    Subscription = "Subscription",
}

export class ImageDetail extends EntityBase implements IImageDetail {
    imageDetailID!: string;
    name!: string;
    thumbnailFileDetailID!: string;
    mediumFileDetailID!: string;
    originalFileDetailID!: string;
    thumbnailFileDetail?: FileDetail | undefined;
    mediumFileDetail?: FileDetail | undefined;
    originalFileDetail?: FileDetail | undefined;
    discussionImage?: DiscussionImage | undefined;

    constructor(data?: IImageDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageDetailID = _data["imageDetailID"];
            this.name = _data["name"];
            this.thumbnailFileDetailID = _data["thumbnailFileDetailID"];
            this.mediumFileDetailID = _data["mediumFileDetailID"];
            this.originalFileDetailID = _data["originalFileDetailID"];
            this.thumbnailFileDetail = _data["thumbnailFileDetail"] ? FileDetail.fromJS(_data["thumbnailFileDetail"]) : <any>undefined;
            this.mediumFileDetail = _data["mediumFileDetail"] ? FileDetail.fromJS(_data["mediumFileDetail"]) : <any>undefined;
            this.originalFileDetail = _data["originalFileDetail"] ? FileDetail.fromJS(_data["originalFileDetail"]) : <any>undefined;
            this.discussionImage = _data["discussionImage"] ? DiscussionImage.fromJS(_data["discussionImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImageDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageDetailID"] = this.imageDetailID;
        data["name"] = this.name;
        data["thumbnailFileDetailID"] = this.thumbnailFileDetailID;
        data["mediumFileDetailID"] = this.mediumFileDetailID;
        data["originalFileDetailID"] = this.originalFileDetailID;
        data["thumbnailFileDetail"] = this.thumbnailFileDetail ? this.thumbnailFileDetail.toJSON() : <any>undefined;
        data["mediumFileDetail"] = this.mediumFileDetail ? this.mediumFileDetail.toJSON() : <any>undefined;
        data["originalFileDetail"] = this.originalFileDetail ? this.originalFileDetail.toJSON() : <any>undefined;
        data["discussionImage"] = this.discussionImage ? this.discussionImage.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IImageDetail extends IEntityBase {
    imageDetailID: string;
    name: string;
    thumbnailFileDetailID: string;
    mediumFileDetailID: string;
    originalFileDetailID: string;
    thumbnailFileDetail?: FileDetail | undefined;
    mediumFileDetail?: FileDetail | undefined;
    originalFileDetail?: FileDetail | undefined;
    discussionImage?: DiscussionImage | undefined;
}

export class FileDetail extends EntityBase implements IFileDetail {
    bytes?: string | undefined;
    fileDetailID!: string;
    container!: string;
    name!: string;
    contentType!: string;
    size!: number;

    constructor(data?: IFileDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bytes = _data["bytes"];
            this.fileDetailID = _data["fileDetailID"];
            this.container = _data["container"];
            this.name = _data["name"];
            this.contentType = _data["contentType"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): FileDetail {
        data = typeof data === 'object' ? data : {};
        let result = new FileDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bytes"] = this.bytes;
        data["fileDetailID"] = this.fileDetailID;
        data["container"] = this.container;
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        super.toJSON(data);
        return data;
    }
}

export interface IFileDetail extends IEntityBase {
    bytes?: string | undefined;
    fileDetailID: string;
    container: string;
    name: string;
    contentType: string;
    size: number;
}

export class DiscussionImage extends EntityBase implements IDiscussionImage {
    imageDetail?: ImageDetail | undefined;
    discussionImageID!: string;
    imageDetailID!: string;
    imageURL?: string | undefined;
    sort?: string | undefined;
    data?: string | undefined;
    displaySortOrder!: number;
    description!: string;

    constructor(data?: IDiscussionImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageDetail = _data["imageDetail"] ? ImageDetail.fromJS(_data["imageDetail"]) : <any>undefined;
            this.discussionImageID = _data["discussionImageID"];
            this.imageDetailID = _data["imageDetailID"];
            this.imageURL = _data["imageURL"];
            this.sort = _data["sort"];
            this.data = _data["data"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DiscussionImage {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageDetail"] = this.imageDetail ? this.imageDetail.toJSON() : <any>undefined;
        data["discussionImageID"] = this.discussionImageID;
        data["imageDetailID"] = this.imageDetailID;
        data["imageURL"] = this.imageURL;
        data["sort"] = this.sort;
        data["data"] = this.data;
        data["displaySortOrder"] = this.displaySortOrder;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionImage extends IEntityBase {
    imageDetail?: ImageDetail | undefined;
    discussionImageID: string;
    imageDetailID: string;
    imageURL?: string | undefined;
    sort?: string | undefined;
    data?: string | undefined;
    displaySortOrder: number;
    description: string;
}

export class PaymentProcessor extends EntityBase implements IPaymentProcessor {
    paymentProcessorID!: string;
    name!: string;
    description!: string;
    enabled!: boolean;
    glAccountID!: string;
    withdrawal!: boolean;
    countryID!: string;
    currencyEnum!: CurrencyEnum;
    decimalPlace!: number;
    publicKey?: string | undefined;
    secretKey?: string | undefined;
    baseAPIUrl?: string | undefined;
    paymentProcessorTypeName!: string;
    paymentProcessorTypeEnum!: PaymentProcessorTypeEnum;
    statementDescription?: string | undefined;
    supportsRecurringPayments!: boolean;
    recurringPaymentProcessingTypeEnum!: RecurringPaymentProcessingTypeEnum;
    webhookEnabled!: boolean;
    country?: Country | undefined;

    constructor(data?: IPaymentProcessor) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentProcessorID = _data["paymentProcessorID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.glAccountID = _data["glAccountID"];
            this.withdrawal = _data["withdrawal"];
            this.countryID = _data["countryID"];
            this.currencyEnum = _data["currencyEnum"];
            this.decimalPlace = _data["decimalPlace"];
            this.publicKey = _data["publicKey"];
            this.secretKey = _data["secretKey"];
            this.baseAPIUrl = _data["baseAPIUrl"];
            this.paymentProcessorTypeName = _data["paymentProcessorTypeName"];
            this.paymentProcessorTypeEnum = _data["paymentProcessorTypeEnum"];
            this.statementDescription = _data["statementDescription"];
            this.supportsRecurringPayments = _data["supportsRecurringPayments"];
            this.recurringPaymentProcessingTypeEnum = _data["recurringPaymentProcessingTypeEnum"];
            this.webhookEnabled = _data["webhookEnabled"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentProcessor {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProcessor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProcessorID"] = this.paymentProcessorID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["glAccountID"] = this.glAccountID;
        data["withdrawal"] = this.withdrawal;
        data["countryID"] = this.countryID;
        data["currencyEnum"] = this.currencyEnum;
        data["decimalPlace"] = this.decimalPlace;
        data["publicKey"] = this.publicKey;
        data["secretKey"] = this.secretKey;
        data["baseAPIUrl"] = this.baseAPIUrl;
        data["paymentProcessorTypeName"] = this.paymentProcessorTypeName;
        data["paymentProcessorTypeEnum"] = this.paymentProcessorTypeEnum;
        data["statementDescription"] = this.statementDescription;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        data["recurringPaymentProcessingTypeEnum"] = this.recurringPaymentProcessingTypeEnum;
        data["webhookEnabled"] = this.webhookEnabled;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentProcessor extends IEntityBase {
    paymentProcessorID: string;
    name: string;
    description: string;
    enabled: boolean;
    glAccountID: string;
    withdrawal: boolean;
    countryID: string;
    currencyEnum: CurrencyEnum;
    decimalPlace: number;
    publicKey?: string | undefined;
    secretKey?: string | undefined;
    baseAPIUrl?: string | undefined;
    paymentProcessorTypeName: string;
    paymentProcessorTypeEnum: PaymentProcessorTypeEnum;
    statementDescription?: string | undefined;
    supportsRecurringPayments: boolean;
    recurringPaymentProcessingTypeEnum: RecurringPaymentProcessingTypeEnum;
    webhookEnabled: boolean;
    country?: Country | undefined;
}

export enum PaymentProcessorTypeEnum {
    ZeroPaymentProcessor = "ZeroPaymentProcessor",
    Wallet = "Wallet",
    PaymentProcessor = "PaymentProcessor",
    MarketingCampaignWalletPaymentProcessor = "MarketingCampaignWalletPaymentProcessor",
    CurrencyExchange = "CurrencyExchange",
}

export enum RecurringPaymentProcessingTypeEnum {
    NotSet = "NotSet",
    Managed = "Managed",
    System = "System",
}

export class Organization extends EntityBase implements IOrganization {
    organizationID!: string;
    organizationTypeEnum!: OrganizationTypeEnum;
    countryID!: string;
    name!: string;
    shortName!: string;
    description!: string;
    imageDetailID?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    cityTownID?: string | undefined;
    provinceStateID?: string | undefined;
    postCode?: string | undefined;
    publicPage!: boolean;
    publicTag?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    serviceDescription?: string | undefined;
    landmarks?: string | undefined;
    impressions!: number;
    rating!: number;
    ratingCount!: number;
    departments?: Department[] | undefined;
    stores?: Store[] | undefined;
    organizationImages?: OrganizationImage[] | undefined;
    country?: Country | undefined;
    provinceState?: ProvinceState | undefined;
    cityTown?: CityTown | undefined;
    imageDetailBase64?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    fullAddress?: string | undefined;

    constructor(data?: IOrganization) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationID = _data["organizationID"];
            this.organizationTypeEnum = _data["organizationTypeEnum"];
            this.countryID = _data["countryID"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.imageDetailID = _data["imageDetailID"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.cityTownID = _data["cityTownID"];
            this.provinceStateID = _data["provinceStateID"];
            this.postCode = _data["postCode"];
            this.publicPage = _data["publicPage"];
            this.publicTag = _data["publicTag"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.serviceDescription = _data["serviceDescription"];
            this.landmarks = _data["landmarks"];
            this.impressions = _data["impressions"];
            this.rating = _data["rating"];
            this.ratingCount = _data["ratingCount"];
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(Department.fromJS(item));
            }
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores!.push(Store.fromJS(item));
            }
            if (Array.isArray(_data["organizationImages"])) {
                this.organizationImages = [] as any;
                for (let item of _data["organizationImages"])
                    this.organizationImages!.push(OrganizationImage.fromJS(item));
            }
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            this.cityTown = _data["cityTown"] ? CityTown.fromJS(_data["cityTown"]) : <any>undefined;
            this.imageDetailBase64 = _data["imageDetailBase64"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.fullAddress = _data["fullAddress"];
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationID"] = this.organizationID;
        data["organizationTypeEnum"] = this.organizationTypeEnum;
        data["countryID"] = this.countryID;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["imageDetailID"] = this.imageDetailID;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["cityTownID"] = this.cityTownID;
        data["provinceStateID"] = this.provinceStateID;
        data["postCode"] = this.postCode;
        data["publicPage"] = this.publicPage;
        data["publicTag"] = this.publicTag;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["serviceDescription"] = this.serviceDescription;
        data["landmarks"] = this.landmarks;
        data["impressions"] = this.impressions;
        data["rating"] = this.rating;
        data["ratingCount"] = this.ratingCount;
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item.toJSON());
        }
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationImages)) {
            data["organizationImages"] = [];
            for (let item of this.organizationImages)
                data["organizationImages"].push(item.toJSON());
        }
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        data["cityTown"] = this.cityTown ? this.cityTown.toJSON() : <any>undefined;
        data["imageDetailBase64"] = this.imageDetailBase64;
        data["city"] = this.city;
        data["province"] = this.province;
        data["fullAddress"] = this.fullAddress;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganization extends IEntityBase {
    organizationID: string;
    organizationTypeEnum: OrganizationTypeEnum;
    countryID: string;
    name: string;
    shortName: string;
    description: string;
    imageDetailID?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    cityTownID?: string | undefined;
    provinceStateID?: string | undefined;
    postCode?: string | undefined;
    publicPage: boolean;
    publicTag?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    serviceDescription?: string | undefined;
    landmarks?: string | undefined;
    impressions: number;
    rating: number;
    ratingCount: number;
    departments?: Department[] | undefined;
    stores?: Store[] | undefined;
    organizationImages?: OrganizationImage[] | undefined;
    country?: Country | undefined;
    provinceState?: ProvinceState | undefined;
    cityTown?: CityTown | undefined;
    imageDetailBase64?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    fullAddress?: string | undefined;
}

export enum OrganizationTypeEnum {
    Global = "Global",
    Clinic = "Clinic",
    Hospital = "Hospital",
}

export class Department extends EntityBase implements IDepartment {
    organization?: Organization | undefined;
    stores?: Store[] | undefined;
    departmentID!: string;
    organizationID!: string;
    name!: string;
    shortName!: string;
    description!: string;

    constructor(data?: IDepartment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores!.push(Store.fromJS(item));
            }
            this.departmentID = _data["departmentID"];
            this.organizationID = _data["organizationID"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        data["departmentID"] = this.departmentID;
        data["organizationID"] = this.organizationID;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IDepartment extends IEntityBase {
    organization?: Organization | undefined;
    stores?: Store[] | undefined;
    departmentID: string;
    organizationID: string;
    name: string;
    shortName: string;
    description: string;
}

export class OrganizationImage extends EntityBase implements IOrganizationImage {
    organizationImageID!: string;
    organizationID!: string;
    imageURL!: string;
    organizationImageEnum!: OrganizationImageEnum;
    displaySortOrder!: number;
    description!: string;
    organization?: Organization | undefined;

    constructor(data?: IOrganizationImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationImageID = _data["organizationImageID"];
            this.organizationID = _data["organizationID"];
            this.imageURL = _data["imageURL"];
            this.organizationImageEnum = _data["organizationImageEnum"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.description = _data["description"];
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationImage {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationImageID"] = this.organizationImageID;
        data["organizationID"] = this.organizationID;
        data["imageURL"] = this.imageURL;
        data["organizationImageEnum"] = this.organizationImageEnum;
        data["displaySortOrder"] = this.displaySortOrder;
        data["description"] = this.description;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IOrganizationImage extends IEntityBase {
    organizationImageID: string;
    organizationID: string;
    imageURL: string;
    organizationImageEnum: OrganizationImageEnum;
    displaySortOrder: number;
    description: string;
    organization?: Organization | undefined;
}

export enum OrganizationImageEnum {
    Banner = "Banner",
    Gallery = "Gallery",
}

export class StoreImage extends EntityBase implements IStoreImage {
    storeImageID!: string;
    storeID!: string;
    imageURL!: string;
    storeImageEnum!: StoreImageEnum;
    displaySortOrder!: number;
    description!: string;
    store?: Store | undefined;

    constructor(data?: IStoreImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeImageID = _data["storeImageID"];
            this.storeID = _data["storeID"];
            this.imageURL = _data["imageURL"];
            this.storeImageEnum = _data["storeImageEnum"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.description = _data["description"];
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreImage {
        data = typeof data === 'object' ? data : {};
        let result = new StoreImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeImageID"] = this.storeImageID;
        data["storeID"] = this.storeID;
        data["imageURL"] = this.imageURL;
        data["storeImageEnum"] = this.storeImageEnum;
        data["displaySortOrder"] = this.displaySortOrder;
        data["description"] = this.description;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreImage extends IEntityBase {
    storeImageID: string;
    storeID: string;
    imageURL: string;
    storeImageEnum: StoreImageEnum;
    displaySortOrder: number;
    description: string;
    store?: Store | undefined;
}

export enum StoreImageEnum {
    Banner = "Banner",
    Gallery = "Gallery",
}

export class StoreSchedule extends EntityBase implements IStoreSchedule {
    storeScheduleID!: string;
    storeID!: string;
    startDate!: Date;
    endDate!: Date;
    recurringID?: string | undefined;
    recurring?: boolean;
    recurringDays?: RecurringDayEnum[] | undefined;
    recurringStartTime?: string | undefined;
    recurringEndTime?: string | undefined;
    recurringStartDate?: Date | undefined;
    recurringEndDate?: Date | undefined;
    store?: Store | undefined;
    storeScheduleStoreItems?: StoreScheduleStoreItem[] | undefined;
    storeAppointments?: StoreAppointment[] | undefined;
    scheduleID?: string;

    constructor(data?: IStoreSchedule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeScheduleID = _data["storeScheduleID"];
            this.storeID = _data["storeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.recurringID = _data["recurringID"];
            this.recurring = _data["recurring"];
            if (Array.isArray(_data["recurringDays"])) {
                this.recurringDays = [] as any;
                for (let item of _data["recurringDays"])
                    this.recurringDays!.push(item);
            }
            this.recurringStartTime = _data["recurringStartTime"];
            this.recurringEndTime = _data["recurringEndTime"];
            this.recurringStartDate = _data["recurringStartDate"] ? new Date(_data["recurringStartDate"].toString()) : <any>undefined;
            this.recurringEndDate = _data["recurringEndDate"] ? new Date(_data["recurringEndDate"].toString()) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            if (Array.isArray(_data["storeScheduleStoreItems"])) {
                this.storeScheduleStoreItems = [] as any;
                for (let item of _data["storeScheduleStoreItems"])
                    this.storeScheduleStoreItems!.push(StoreScheduleStoreItem.fromJS(item));
            }
            if (Array.isArray(_data["storeAppointments"])) {
                this.storeAppointments = [] as any;
                for (let item of _data["storeAppointments"])
                    this.storeAppointments!.push(StoreAppointment.fromJS(item));
            }
            this.scheduleID = _data["scheduleID"];
        }
    }

    static fromJS(data: any): StoreSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new StoreSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeScheduleID"] = this.storeScheduleID;
        data["storeID"] = this.storeID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["recurringID"] = this.recurringID;
        data["recurring"] = this.recurring;
        if (Array.isArray(this.recurringDays)) {
            data["recurringDays"] = [];
            for (let item of this.recurringDays)
                data["recurringDays"].push(item);
        }
        data["recurringStartTime"] = this.recurringStartTime;
        data["recurringEndTime"] = this.recurringEndTime;
        data["recurringStartDate"] = this.recurringStartDate ? this.recurringStartDate.toISOString() : <any>undefined;
        data["recurringEndDate"] = this.recurringEndDate ? this.recurringEndDate.toISOString() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (Array.isArray(this.storeScheduleStoreItems)) {
            data["storeScheduleStoreItems"] = [];
            for (let item of this.storeScheduleStoreItems)
                data["storeScheduleStoreItems"].push(item.toJSON());
        }
        if (Array.isArray(this.storeAppointments)) {
            data["storeAppointments"] = [];
            for (let item of this.storeAppointments)
                data["storeAppointments"].push(item.toJSON());
        }
        data["scheduleID"] = this.scheduleID;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreSchedule extends IEntityBase {
    storeScheduleID: string;
    storeID: string;
    startDate: Date;
    endDate: Date;
    recurringID?: string | undefined;
    recurring?: boolean;
    recurringDays?: RecurringDayEnum[] | undefined;
    recurringStartTime?: string | undefined;
    recurringEndTime?: string | undefined;
    recurringStartDate?: Date | undefined;
    recurringEndDate?: Date | undefined;
    store?: Store | undefined;
    storeScheduleStoreItems?: StoreScheduleStoreItem[] | undefined;
    storeAppointments?: StoreAppointment[] | undefined;
    scheduleID?: string;
}

export enum RecurringDayEnum {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class StoreScheduleStoreItem extends EntityBase implements IStoreScheduleStoreItem {
    storeScheduleStoreItemID!: string;
    storeScheduleID!: string;
    storeItemID!: string;
    storeItem?: StoreItem | undefined;
    scheduleStoreItemID?: string;

    constructor(data?: IStoreScheduleStoreItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeScheduleStoreItemID = _data["storeScheduleStoreItemID"];
            this.storeScheduleID = _data["storeScheduleID"];
            this.storeItemID = _data["storeItemID"];
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.scheduleStoreItemID = _data["scheduleStoreItemID"];
        }
    }

    static fromJS(data: any): StoreScheduleStoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new StoreScheduleStoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeScheduleStoreItemID"] = this.storeScheduleStoreItemID;
        data["storeScheduleID"] = this.storeScheduleID;
        data["storeItemID"] = this.storeItemID;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["scheduleStoreItemID"] = this.scheduleStoreItemID;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreScheduleStoreItem extends IEntityBase {
    storeScheduleStoreItemID: string;
    storeScheduleID: string;
    storeItemID: string;
    storeItem?: StoreItem | undefined;
    scheduleStoreItemID?: string;
}

export class StoreAppointment extends EntityBase implements IStoreAppointment {
    storeAppointmentID!: string;
    storeID!: string;
    storeScheduleID!: string;
    providerID?: string | undefined;
    appointmentTypeEnum!: AppointmentTypeEnum;
    consultID?: string | undefined;
    startDate!: Date;
    endDate!: Date;
    appointmentLengthInMinutes!: number;
    reservationUserDetailID?: string | undefined;
    reservationExpireDate?: Date | undefined;
    timestamp?: string | undefined;
    qrCode!: number;
    storeSchedule?: StoreSchedule | undefined;
    consult?: Consult | undefined;
    store?: Store | undefined;
    provider?: Provider | undefined;
    appointmentID?: string;

    constructor(data?: IStoreAppointment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeAppointmentID = _data["storeAppointmentID"];
            this.storeID = _data["storeID"];
            this.storeScheduleID = _data["storeScheduleID"];
            this.providerID = _data["providerID"];
            this.appointmentTypeEnum = _data["appointmentTypeEnum"];
            this.consultID = _data["consultID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.appointmentLengthInMinutes = _data["appointmentLengthInMinutes"];
            this.reservationUserDetailID = _data["reservationUserDetailID"];
            this.reservationExpireDate = _data["reservationExpireDate"] ? new Date(_data["reservationExpireDate"].toString()) : <any>undefined;
            this.timestamp = _data["timestamp"];
            this.qrCode = _data["qrCode"];
            this.storeSchedule = _data["storeSchedule"] ? StoreSchedule.fromJS(_data["storeSchedule"]) : <any>undefined;
            this.consult = _data["consult"] ? Consult.fromJS(_data["consult"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.appointmentID = _data["appointmentID"];
        }
    }

    static fromJS(data: any): StoreAppointment {
        data = typeof data === 'object' ? data : {};
        let result = new StoreAppointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeAppointmentID"] = this.storeAppointmentID;
        data["storeID"] = this.storeID;
        data["storeScheduleID"] = this.storeScheduleID;
        data["providerID"] = this.providerID;
        data["appointmentTypeEnum"] = this.appointmentTypeEnum;
        data["consultID"] = this.consultID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["appointmentLengthInMinutes"] = this.appointmentLengthInMinutes;
        data["reservationUserDetailID"] = this.reservationUserDetailID;
        data["reservationExpireDate"] = this.reservationExpireDate ? this.reservationExpireDate.toISOString() : <any>undefined;
        data["timestamp"] = this.timestamp;
        data["qrCode"] = this.qrCode;
        data["storeSchedule"] = this.storeSchedule ? this.storeSchedule.toJSON() : <any>undefined;
        data["consult"] = this.consult ? this.consult.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["appointmentID"] = this.appointmentID;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreAppointment extends IEntityBase {
    storeAppointmentID: string;
    storeID: string;
    storeScheduleID: string;
    providerID?: string | undefined;
    appointmentTypeEnum: AppointmentTypeEnum;
    consultID?: string | undefined;
    startDate: Date;
    endDate: Date;
    appointmentLengthInMinutes: number;
    reservationUserDetailID?: string | undefined;
    reservationExpireDate?: Date | undefined;
    timestamp?: string | undefined;
    qrCode: number;
    storeSchedule?: StoreSchedule | undefined;
    consult?: Consult | undefined;
    store?: Store | undefined;
    provider?: Provider | undefined;
    appointmentID?: string;
}

export enum AppointmentTypeEnum {
    NotAvailable = "NotAvailable",
    Consult = "Consult",
}

export class Consult extends EntityBase implements IConsult {
    providerAppointments?: ProviderAppointment[] | undefined;
    phrConsult?: PHRConsult | undefined;
    positionInWaitingRoom?: number;
    providerName?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientName?: string | undefined;
    patientImageDetailID?: string;
    providerAppointmentIDToBook?: string | undefined;
    patient?: Patient | undefined;
    consultSMSs?: ConsultSMS[] | undefined;
    consultStoreItems?: ConsultStoreItem[] | undefined;
    consultChats?: ConsultChat[] | undefined;
    consultTags?: ConsultTag[] | undefined;
    country?: Country | undefined;
    invoice?: Invoice | undefined;
    careTypeTag?: Tag | undefined;
    patientReadyDate?: Date | undefined;
    phrDocumentIDs?: string[] | undefined;
    providerQueue?: ProviderQueue | undefined;
    consultID!: string;
    consultTypeEnum!: ConsultTypeEnum;
    consultStatusEnum!: ConsultStatusEnum;
    invoiceID?: string | undefined;
    description?: string | undefined;
    patientID!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    totalAmount?: number | undefined;
    apiKey?: number | undefined;
    sessionID?: string | undefined;
    patientToken?: string | undefined;
    providerToken?: string | undefined;
    deviceToken?: string | undefined;
    sessionStartDate?: Date | undefined;
    sessionEndDate?: Date | undefined;
    currencyEnum!: CurrencyEnum;
    countryID!: string;
    cancelReason?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    bookedByEnum?: BookedByEnum | undefined;
    bookedByUserDetailID?: string | undefined;
    symptomDurationInDays?: number | undefined;
    qrCode!: number;
    providerQueueID?: string | undefined;
    sendToFamilyProvider!: boolean;
    followupConsultID?: string | undefined;
    followupUsedCount!: number;
    careTypeTagID?: string | undefined;
    associatedConsultID?: string | undefined;

    constructor(data?: IConsult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["providerAppointments"])) {
                this.providerAppointments = [] as any;
                for (let item of _data["providerAppointments"])
                    this.providerAppointments!.push(ProviderAppointment.fromJS(item));
            }
            this.phrConsult = _data["phrConsult"] ? PHRConsult.fromJS(_data["phrConsult"]) : <any>undefined;
            this.positionInWaitingRoom = _data["positionInWaitingRoom"];
            this.providerName = _data["providerName"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientName = _data["patientName"];
            this.patientImageDetailID = _data["patientImageDetailID"];
            this.providerAppointmentIDToBook = _data["providerAppointmentIDToBook"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["consultSMSs"])) {
                this.consultSMSs = [] as any;
                for (let item of _data["consultSMSs"])
                    this.consultSMSs!.push(ConsultSMS.fromJS(item));
            }
            if (Array.isArray(_data["consultStoreItems"])) {
                this.consultStoreItems = [] as any;
                for (let item of _data["consultStoreItems"])
                    this.consultStoreItems!.push(ConsultStoreItem.fromJS(item));
            }
            if (Array.isArray(_data["consultChats"])) {
                this.consultChats = [] as any;
                for (let item of _data["consultChats"])
                    this.consultChats!.push(ConsultChat.fromJS(item));
            }
            if (Array.isArray(_data["consultTags"])) {
                this.consultTags = [] as any;
                for (let item of _data["consultTags"])
                    this.consultTags!.push(ConsultTag.fromJS(item));
            }
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.careTypeTag = _data["careTypeTag"] ? Tag.fromJS(_data["careTypeTag"]) : <any>undefined;
            this.patientReadyDate = _data["patientReadyDate"] ? new Date(_data["patientReadyDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["phrDocumentIDs"])) {
                this.phrDocumentIDs = [] as any;
                for (let item of _data["phrDocumentIDs"])
                    this.phrDocumentIDs!.push(item);
            }
            this.providerQueue = _data["providerQueue"] ? ProviderQueue.fromJS(_data["providerQueue"]) : <any>undefined;
            this.consultID = _data["consultID"];
            this.consultTypeEnum = _data["consultTypeEnum"];
            this.consultStatusEnum = _data["consultStatusEnum"];
            this.invoiceID = _data["invoiceID"];
            this.description = _data["description"];
            this.patientID = _data["patientID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.totalAmount = _data["totalAmount"];
            this.apiKey = _data["apiKey"];
            this.sessionID = _data["sessionID"];
            this.patientToken = _data["patientToken"];
            this.providerToken = _data["providerToken"];
            this.deviceToken = _data["deviceToken"];
            this.sessionStartDate = _data["sessionStartDate"] ? new Date(_data["sessionStartDate"].toString()) : <any>undefined;
            this.sessionEndDate = _data["sessionEndDate"] ? new Date(_data["sessionEndDate"].toString()) : <any>undefined;
            this.currencyEnum = _data["currencyEnum"];
            this.countryID = _data["countryID"];
            this.cancelReason = _data["cancelReason"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.bookedByEnum = _data["bookedByEnum"];
            this.bookedByUserDetailID = _data["bookedByUserDetailID"];
            this.symptomDurationInDays = _data["symptomDurationInDays"];
            this.qrCode = _data["qrCode"];
            this.providerQueueID = _data["providerQueueID"];
            this.sendToFamilyProvider = _data["sendToFamilyProvider"];
            this.followupConsultID = _data["followupConsultID"];
            this.followupUsedCount = _data["followupUsedCount"];
            this.careTypeTagID = _data["careTypeTagID"];
            this.associatedConsultID = _data["associatedConsultID"];
        }
    }

    static fromJS(data: any): Consult {
        data = typeof data === 'object' ? data : {};
        let result = new Consult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providerAppointments)) {
            data["providerAppointments"] = [];
            for (let item of this.providerAppointments)
                data["providerAppointments"].push(item.toJSON());
        }
        data["phrConsult"] = this.phrConsult ? this.phrConsult.toJSON() : <any>undefined;
        data["positionInWaitingRoom"] = this.positionInWaitingRoom;
        data["providerName"] = this.providerName;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientName"] = this.patientName;
        data["patientImageDetailID"] = this.patientImageDetailID;
        data["providerAppointmentIDToBook"] = this.providerAppointmentIDToBook;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.consultSMSs)) {
            data["consultSMSs"] = [];
            for (let item of this.consultSMSs)
                data["consultSMSs"].push(item.toJSON());
        }
        if (Array.isArray(this.consultStoreItems)) {
            data["consultStoreItems"] = [];
            for (let item of this.consultStoreItems)
                data["consultStoreItems"].push(item.toJSON());
        }
        if (Array.isArray(this.consultChats)) {
            data["consultChats"] = [];
            for (let item of this.consultChats)
                data["consultChats"].push(item.toJSON());
        }
        if (Array.isArray(this.consultTags)) {
            data["consultTags"] = [];
            for (let item of this.consultTags)
                data["consultTags"].push(item.toJSON());
        }
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["careTypeTag"] = this.careTypeTag ? this.careTypeTag.toJSON() : <any>undefined;
        data["patientReadyDate"] = this.patientReadyDate ? this.patientReadyDate.toISOString() : <any>undefined;
        if (Array.isArray(this.phrDocumentIDs)) {
            data["phrDocumentIDs"] = [];
            for (let item of this.phrDocumentIDs)
                data["phrDocumentIDs"].push(item);
        }
        data["providerQueue"] = this.providerQueue ? this.providerQueue.toJSON() : <any>undefined;
        data["consultID"] = this.consultID;
        data["consultTypeEnum"] = this.consultTypeEnum;
        data["consultStatusEnum"] = this.consultStatusEnum;
        data["invoiceID"] = this.invoiceID;
        data["description"] = this.description;
        data["patientID"] = this.patientID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        data["apiKey"] = this.apiKey;
        data["sessionID"] = this.sessionID;
        data["patientToken"] = this.patientToken;
        data["providerToken"] = this.providerToken;
        data["deviceToken"] = this.deviceToken;
        data["sessionStartDate"] = this.sessionStartDate ? this.sessionStartDate.toISOString() : <any>undefined;
        data["sessionEndDate"] = this.sessionEndDate ? this.sessionEndDate.toISOString() : <any>undefined;
        data["currencyEnum"] = this.currencyEnum;
        data["countryID"] = this.countryID;
        data["cancelReason"] = this.cancelReason;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["bookedByEnum"] = this.bookedByEnum;
        data["bookedByUserDetailID"] = this.bookedByUserDetailID;
        data["symptomDurationInDays"] = this.symptomDurationInDays;
        data["qrCode"] = this.qrCode;
        data["providerQueueID"] = this.providerQueueID;
        data["sendToFamilyProvider"] = this.sendToFamilyProvider;
        data["followupConsultID"] = this.followupConsultID;
        data["followupUsedCount"] = this.followupUsedCount;
        data["careTypeTagID"] = this.careTypeTagID;
        data["associatedConsultID"] = this.associatedConsultID;
        super.toJSON(data);
        return data;
    }
}

export interface IConsult extends IEntityBase {
    providerAppointments?: ProviderAppointment[] | undefined;
    phrConsult?: PHRConsult | undefined;
    positionInWaitingRoom?: number;
    providerName?: string | undefined;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientName?: string | undefined;
    patientImageDetailID?: string;
    providerAppointmentIDToBook?: string | undefined;
    patient?: Patient | undefined;
    consultSMSs?: ConsultSMS[] | undefined;
    consultStoreItems?: ConsultStoreItem[] | undefined;
    consultChats?: ConsultChat[] | undefined;
    consultTags?: ConsultTag[] | undefined;
    country?: Country | undefined;
    invoice?: Invoice | undefined;
    careTypeTag?: Tag | undefined;
    patientReadyDate?: Date | undefined;
    phrDocumentIDs?: string[] | undefined;
    providerQueue?: ProviderQueue | undefined;
    consultID: string;
    consultTypeEnum: ConsultTypeEnum;
    consultStatusEnum: ConsultStatusEnum;
    invoiceID?: string | undefined;
    description?: string | undefined;
    patientID: string;
    startDate: Date;
    endDate?: Date | undefined;
    totalAmount?: number | undefined;
    apiKey?: number | undefined;
    sessionID?: string | undefined;
    patientToken?: string | undefined;
    providerToken?: string | undefined;
    deviceToken?: string | undefined;
    sessionStartDate?: Date | undefined;
    sessionEndDate?: Date | undefined;
    currencyEnum: CurrencyEnum;
    countryID: string;
    cancelReason?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    bookedByEnum?: BookedByEnum | undefined;
    bookedByUserDetailID?: string | undefined;
    symptomDurationInDays?: number | undefined;
    qrCode: number;
    providerQueueID?: string | undefined;
    sendToFamilyProvider: boolean;
    followupConsultID?: string | undefined;
    followupUsedCount: number;
    careTypeTagID?: string | undefined;
    associatedConsultID?: string | undefined;
}

export class ProviderAppointment extends EntityBase implements IProviderAppointment {
    providerAppointmentID!: string;
    providerID!: string;
    providerScheduleID!: string;
    appointmentTypeEnum!: AppointmentTypeEnum;
    consultID?: string | undefined;
    startDate!: Date;
    endDate!: Date;
    appointmentLengthInMinutes!: number;
    reservationUserDetailID?: string | undefined;
    reservationExpireDate?: Date | undefined;
    timestamp?: string | undefined;
    qrCode!: number;
    providerSchedule?: ProviderSchedule | undefined;
    consult?: Consult | undefined;
    provider?: Provider | undefined;
    appointmentID?: string;

    constructor(data?: IProviderAppointment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerAppointmentID = _data["providerAppointmentID"];
            this.providerID = _data["providerID"];
            this.providerScheduleID = _data["providerScheduleID"];
            this.appointmentTypeEnum = _data["appointmentTypeEnum"];
            this.consultID = _data["consultID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.appointmentLengthInMinutes = _data["appointmentLengthInMinutes"];
            this.reservationUserDetailID = _data["reservationUserDetailID"];
            this.reservationExpireDate = _data["reservationExpireDate"] ? new Date(_data["reservationExpireDate"].toString()) : <any>undefined;
            this.timestamp = _data["timestamp"];
            this.qrCode = _data["qrCode"];
            this.providerSchedule = _data["providerSchedule"] ? ProviderSchedule.fromJS(_data["providerSchedule"]) : <any>undefined;
            this.consult = _data["consult"] ? Consult.fromJS(_data["consult"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.appointmentID = _data["appointmentID"];
        }
    }

    static fromJS(data: any): ProviderAppointment {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderAppointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerAppointmentID"] = this.providerAppointmentID;
        data["providerID"] = this.providerID;
        data["providerScheduleID"] = this.providerScheduleID;
        data["appointmentTypeEnum"] = this.appointmentTypeEnum;
        data["consultID"] = this.consultID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["appointmentLengthInMinutes"] = this.appointmentLengthInMinutes;
        data["reservationUserDetailID"] = this.reservationUserDetailID;
        data["reservationExpireDate"] = this.reservationExpireDate ? this.reservationExpireDate.toISOString() : <any>undefined;
        data["timestamp"] = this.timestamp;
        data["qrCode"] = this.qrCode;
        data["providerSchedule"] = this.providerSchedule ? this.providerSchedule.toJSON() : <any>undefined;
        data["consult"] = this.consult ? this.consult.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["appointmentID"] = this.appointmentID;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderAppointment extends IEntityBase {
    providerAppointmentID: string;
    providerID: string;
    providerScheduleID: string;
    appointmentTypeEnum: AppointmentTypeEnum;
    consultID?: string | undefined;
    startDate: Date;
    endDate: Date;
    appointmentLengthInMinutes: number;
    reservationUserDetailID?: string | undefined;
    reservationExpireDate?: Date | undefined;
    timestamp?: string | undefined;
    qrCode: number;
    providerSchedule?: ProviderSchedule | undefined;
    consult?: Consult | undefined;
    provider?: Provider | undefined;
    appointmentID?: string;
}

export class ProviderSchedule extends EntityBase implements IProviderSchedule {
    providerScheduleID!: string;
    providerID!: string;
    startDate!: Date;
    endDate!: Date;
    checkedIn!: boolean;
    recurringID?: string | undefined;
    recurring?: boolean;
    recurringDays?: RecurringDayEnum[] | undefined;
    recurringStartTime?: string | undefined;
    recurringEndTime?: string | undefined;
    recurringStartDate?: Date | undefined;
    recurringEndDate?: Date | undefined;
    provider?: Provider | undefined;
    providerScheduleStoreItems?: ProviderScheduleStoreItem[] | undefined;
    providerAppointments?: ProviderAppointment[] | undefined;
    scheduleID?: string;

    constructor(data?: IProviderSchedule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerScheduleID = _data["providerScheduleID"];
            this.providerID = _data["providerID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.checkedIn = _data["checkedIn"];
            this.recurringID = _data["recurringID"];
            this.recurring = _data["recurring"];
            if (Array.isArray(_data["recurringDays"])) {
                this.recurringDays = [] as any;
                for (let item of _data["recurringDays"])
                    this.recurringDays!.push(item);
            }
            this.recurringStartTime = _data["recurringStartTime"];
            this.recurringEndTime = _data["recurringEndTime"];
            this.recurringStartDate = _data["recurringStartDate"] ? new Date(_data["recurringStartDate"].toString()) : <any>undefined;
            this.recurringEndDate = _data["recurringEndDate"] ? new Date(_data["recurringEndDate"].toString()) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            if (Array.isArray(_data["providerScheduleStoreItems"])) {
                this.providerScheduleStoreItems = [] as any;
                for (let item of _data["providerScheduleStoreItems"])
                    this.providerScheduleStoreItems!.push(ProviderScheduleStoreItem.fromJS(item));
            }
            if (Array.isArray(_data["providerAppointments"])) {
                this.providerAppointments = [] as any;
                for (let item of _data["providerAppointments"])
                    this.providerAppointments!.push(ProviderAppointment.fromJS(item));
            }
            this.scheduleID = _data["scheduleID"];
        }
    }

    static fromJS(data: any): ProviderSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerScheduleID"] = this.providerScheduleID;
        data["providerID"] = this.providerID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["checkedIn"] = this.checkedIn;
        data["recurringID"] = this.recurringID;
        data["recurring"] = this.recurring;
        if (Array.isArray(this.recurringDays)) {
            data["recurringDays"] = [];
            for (let item of this.recurringDays)
                data["recurringDays"].push(item);
        }
        data["recurringStartTime"] = this.recurringStartTime;
        data["recurringEndTime"] = this.recurringEndTime;
        data["recurringStartDate"] = this.recurringStartDate ? this.recurringStartDate.toISOString() : <any>undefined;
        data["recurringEndDate"] = this.recurringEndDate ? this.recurringEndDate.toISOString() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        if (Array.isArray(this.providerScheduleStoreItems)) {
            data["providerScheduleStoreItems"] = [];
            for (let item of this.providerScheduleStoreItems)
                data["providerScheduleStoreItems"].push(item.toJSON());
        }
        if (Array.isArray(this.providerAppointments)) {
            data["providerAppointments"] = [];
            for (let item of this.providerAppointments)
                data["providerAppointments"].push(item.toJSON());
        }
        data["scheduleID"] = this.scheduleID;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderSchedule extends IEntityBase {
    providerScheduleID: string;
    providerID: string;
    startDate: Date;
    endDate: Date;
    checkedIn: boolean;
    recurringID?: string | undefined;
    recurring?: boolean;
    recurringDays?: RecurringDayEnum[] | undefined;
    recurringStartTime?: string | undefined;
    recurringEndTime?: string | undefined;
    recurringStartDate?: Date | undefined;
    recurringEndDate?: Date | undefined;
    provider?: Provider | undefined;
    providerScheduleStoreItems?: ProviderScheduleStoreItem[] | undefined;
    providerAppointments?: ProviderAppointment[] | undefined;
    scheduleID?: string;
}

export class Provider extends EntityBase implements IProvider {
    providerID!: string;
    userDetailID!: string;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    emailAddress!: string;
    imageDetailID?: string | undefined;
    discussionsUserName?: string | undefined;
    discussionsImageDetailID?: string | undefined;
    hasAgreedDiscussionTC!: boolean;
    genderEnum!: GenderEnum;
    countryID!: string;
    providerTypeEnum!: ProviderTypeEnum;
    providerTypeTagID?: string | undefined;
    approved!: boolean;
    approvedByUserDetailID?: string | undefined;
    approvedDate?: Date | undefined;
    resumeDocumentID?: string | undefined;
    signatureImageDetailID?: string | undefined;
    primaryLanguageID?: string | undefined;
    secondaryLanguageID?: string | undefined;
    externalID?: string | undefined;
    timeZone!: string;
    homePhoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    officePhoneNumber?: string | undefined;
    faxPhoneNumber?: string | undefined;
    aboutMe?: string | undefined;
    professionalStatement?: string | undefined;
    minimumPatientAge?: number | undefined;
    maximumPatientAge?: number | undefined;
    yearsOfExperienceDate?: Date | undefined;
    anyOtherDetails?: string | undefined;
    degreeName?: string | undefined;
    hasAgreedToTC!: boolean;
    hasReadPCP!: boolean;
    hasAgreedToCodeOfConduct!: boolean;
    contactTypeEnum?: ContactTypeEnum | undefined;
    glAccountID?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    publicPage!: boolean;
    publicTag?: string | undefined;
    myEMRFaxNumber?: string | undefined;
    myEMRName?: string | undefined;
    cityTownID?: string | undefined;
    provinceStateID?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    postCode?: string | undefined;
    appointmentSlotMinutes?: number | undefined;
    cardViews!: number;
    scheduleAvailabilityDate?: Date | undefined;
    serviceDescription?: string | undefined;
    walkInStatusEnum!: WalkInStatusEnum;
    providerOnboardingID?: string | undefined;
    vip!: boolean;
    vipNotes?: string | undefined;
    abusive!: boolean;
    abusiveNotes?: string | undefined;
    landmarks?: string | undefined;
    invoiceDescription?: string | undefined;
    impressions!: number;
    rating!: number;
    ratingCount!: number;
    rewardPoints!: number;
    bvn?: string | undefined;
    birthDate?: Date | undefined;
    appTypeEnum!: AppTypeEnum;
    hasCareFundTC!: boolean;
    approvedByUserDetail?: UserDetail | undefined;
    userDetail?: UserDetail | undefined;
    country?: Country | undefined;
    resumeDocument?: Document | undefined;
    signatureImageDetail?: ImageDetail | undefined;
    providerStoreItems?: ProviderStoreItem[] | undefined;
    discussionImageDetail?: ImageDetail | undefined;
    providerSchedules?: ProviderSchedule[] | undefined;
    providerTypeTag?: Tag | undefined;
    cityTown?: CityTown | undefined;
    providerImages?: ProviderImage[] | undefined;
    city?: string | undefined;
    provinceState?: ProvinceState | undefined;
    province?: string | undefined;
    primaryLanguage?: Language | undefined;
    secondaryLanguage?: Language | undefined;
    providerSettings?: ProviderSetting[] | undefined;
    providerAchievements?: ProviderAchievement[] | undefined;
    providerRegistrations?: ProviderRegistration[] | undefined;
    providerTags?: ProviderTag[] | undefined;
    providerSpecialties?: ProviderSpecialty[] | undefined;
    fullName?: string | undefined;
    formattedCellPhoneNumber?: string | undefined;
    formattedHomePhoneNumber?: string | undefined;
    formattedOfficePhoneNumber?: string | undefined;
    formattedFaxPhoneNumber?: string | undefined;
    primaryPhone?: string | undefined;
    primaryProviderSpecialtyTag?: Tag | undefined;
    providerQueues?: ProviderQueue[] | undefined;
    yearsOfExperience?: number | undefined;
    isFavorite?: boolean;
    publicURL?: string | undefined;
    isDiscussionBanned?: boolean;
    providerOnboarding?: ProviderOnboarding | undefined;

    constructor(data?: IProvider) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerID = _data["providerID"];
            this.userDetailID = _data["userDetailID"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.emailAddress = _data["emailAddress"];
            this.imageDetailID = _data["imageDetailID"];
            this.discussionsUserName = _data["discussionsUserName"];
            this.discussionsImageDetailID = _data["discussionsImageDetailID"];
            this.hasAgreedDiscussionTC = _data["hasAgreedDiscussionTC"];
            this.genderEnum = _data["genderEnum"];
            this.countryID = _data["countryID"];
            this.providerTypeEnum = _data["providerTypeEnum"];
            this.providerTypeTagID = _data["providerTypeTagID"];
            this.approved = _data["approved"];
            this.approvedByUserDetailID = _data["approvedByUserDetailID"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.resumeDocumentID = _data["resumeDocumentID"];
            this.signatureImageDetailID = _data["signatureImageDetailID"];
            this.primaryLanguageID = _data["primaryLanguageID"];
            this.secondaryLanguageID = _data["secondaryLanguageID"];
            this.externalID = _data["externalID"];
            this.timeZone = _data["timeZone"];
            this.homePhoneNumber = _data["homePhoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.officePhoneNumber = _data["officePhoneNumber"];
            this.faxPhoneNumber = _data["faxPhoneNumber"];
            this.aboutMe = _data["aboutMe"];
            this.professionalStatement = _data["professionalStatement"];
            this.minimumPatientAge = _data["minimumPatientAge"];
            this.maximumPatientAge = _data["maximumPatientAge"];
            this.yearsOfExperienceDate = _data["yearsOfExperienceDate"] ? new Date(_data["yearsOfExperienceDate"].toString()) : <any>undefined;
            this.anyOtherDetails = _data["anyOtherDetails"];
            this.degreeName = _data["degreeName"];
            this.hasAgreedToTC = _data["hasAgreedToTC"];
            this.hasReadPCP = _data["hasReadPCP"];
            this.hasAgreedToCodeOfConduct = _data["hasAgreedToCodeOfConduct"];
            this.contactTypeEnum = _data["contactTypeEnum"];
            this.glAccountID = _data["glAccountID"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.publicPage = _data["publicPage"];
            this.publicTag = _data["publicTag"];
            this.myEMRFaxNumber = _data["myEMRFaxNumber"];
            this.myEMRName = _data["myEMRName"];
            this.cityTownID = _data["cityTownID"];
            this.provinceStateID = _data["provinceStateID"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.postCode = _data["postCode"];
            this.appointmentSlotMinutes = _data["appointmentSlotMinutes"];
            this.cardViews = _data["cardViews"];
            this.scheduleAvailabilityDate = _data["scheduleAvailabilityDate"] ? new Date(_data["scheduleAvailabilityDate"].toString()) : <any>undefined;
            this.serviceDescription = _data["serviceDescription"];
            this.walkInStatusEnum = _data["walkInStatusEnum"];
            this.providerOnboardingID = _data["providerOnboardingID"];
            this.vip = _data["vip"];
            this.vipNotes = _data["vipNotes"];
            this.abusive = _data["abusive"];
            this.abusiveNotes = _data["abusiveNotes"];
            this.landmarks = _data["landmarks"];
            this.invoiceDescription = _data["invoiceDescription"];
            this.impressions = _data["impressions"];
            this.rating = _data["rating"];
            this.ratingCount = _data["ratingCount"];
            this.rewardPoints = _data["rewardPoints"];
            this.bvn = _data["bvn"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.appTypeEnum = _data["appTypeEnum"];
            this.hasCareFundTC = _data["hasCareFundTC"];
            this.approvedByUserDetail = _data["approvedByUserDetail"] ? UserDetail.fromJS(_data["approvedByUserDetail"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.resumeDocument = _data["resumeDocument"] ? Document.fromJS(_data["resumeDocument"]) : <any>undefined;
            this.signatureImageDetail = _data["signatureImageDetail"] ? ImageDetail.fromJS(_data["signatureImageDetail"]) : <any>undefined;
            if (Array.isArray(_data["providerStoreItems"])) {
                this.providerStoreItems = [] as any;
                for (let item of _data["providerStoreItems"])
                    this.providerStoreItems!.push(ProviderStoreItem.fromJS(item));
            }
            this.discussionImageDetail = _data["discussionImageDetail"] ? ImageDetail.fromJS(_data["discussionImageDetail"]) : <any>undefined;
            if (Array.isArray(_data["providerSchedules"])) {
                this.providerSchedules = [] as any;
                for (let item of _data["providerSchedules"])
                    this.providerSchedules!.push(ProviderSchedule.fromJS(item));
            }
            this.providerTypeTag = _data["providerTypeTag"] ? Tag.fromJS(_data["providerTypeTag"]) : <any>undefined;
            this.cityTown = _data["cityTown"] ? CityTown.fromJS(_data["cityTown"]) : <any>undefined;
            if (Array.isArray(_data["providerImages"])) {
                this.providerImages = [] as any;
                for (let item of _data["providerImages"])
                    this.providerImages!.push(ProviderImage.fromJS(item));
            }
            this.city = _data["city"];
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            this.province = _data["province"];
            this.primaryLanguage = _data["primaryLanguage"] ? Language.fromJS(_data["primaryLanguage"]) : <any>undefined;
            this.secondaryLanguage = _data["secondaryLanguage"] ? Language.fromJS(_data["secondaryLanguage"]) : <any>undefined;
            if (Array.isArray(_data["providerSettings"])) {
                this.providerSettings = [] as any;
                for (let item of _data["providerSettings"])
                    this.providerSettings!.push(ProviderSetting.fromJS(item));
            }
            if (Array.isArray(_data["providerAchievements"])) {
                this.providerAchievements = [] as any;
                for (let item of _data["providerAchievements"])
                    this.providerAchievements!.push(ProviderAchievement.fromJS(item));
            }
            if (Array.isArray(_data["providerRegistrations"])) {
                this.providerRegistrations = [] as any;
                for (let item of _data["providerRegistrations"])
                    this.providerRegistrations!.push(ProviderRegistration.fromJS(item));
            }
            if (Array.isArray(_data["providerTags"])) {
                this.providerTags = [] as any;
                for (let item of _data["providerTags"])
                    this.providerTags!.push(ProviderTag.fromJS(item));
            }
            if (Array.isArray(_data["providerSpecialties"])) {
                this.providerSpecialties = [] as any;
                for (let item of _data["providerSpecialties"])
                    this.providerSpecialties!.push(ProviderSpecialty.fromJS(item));
            }
            this.fullName = _data["fullName"];
            this.formattedCellPhoneNumber = _data["formattedCellPhoneNumber"];
            this.formattedHomePhoneNumber = _data["formattedHomePhoneNumber"];
            this.formattedOfficePhoneNumber = _data["formattedOfficePhoneNumber"];
            this.formattedFaxPhoneNumber = _data["formattedFaxPhoneNumber"];
            this.primaryPhone = _data["primaryPhone"];
            this.primaryProviderSpecialtyTag = _data["primaryProviderSpecialtyTag"] ? Tag.fromJS(_data["primaryProviderSpecialtyTag"]) : <any>undefined;
            if (Array.isArray(_data["providerQueues"])) {
                this.providerQueues = [] as any;
                for (let item of _data["providerQueues"])
                    this.providerQueues!.push(ProviderQueue.fromJS(item));
            }
            this.yearsOfExperience = _data["yearsOfExperience"];
            this.isFavorite = _data["isFavorite"];
            this.publicURL = _data["publicURL"];
            this.isDiscussionBanned = _data["isDiscussionBanned"];
            this.providerOnboarding = _data["providerOnboarding"] ? ProviderOnboarding.fromJS(_data["providerOnboarding"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Provider {
        data = typeof data === 'object' ? data : {};
        let result = new Provider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["userDetailID"] = this.userDetailID;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["emailAddress"] = this.emailAddress;
        data["imageDetailID"] = this.imageDetailID;
        data["discussionsUserName"] = this.discussionsUserName;
        data["discussionsImageDetailID"] = this.discussionsImageDetailID;
        data["hasAgreedDiscussionTC"] = this.hasAgreedDiscussionTC;
        data["genderEnum"] = this.genderEnum;
        data["countryID"] = this.countryID;
        data["providerTypeEnum"] = this.providerTypeEnum;
        data["providerTypeTagID"] = this.providerTypeTagID;
        data["approved"] = this.approved;
        data["approvedByUserDetailID"] = this.approvedByUserDetailID;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["resumeDocumentID"] = this.resumeDocumentID;
        data["signatureImageDetailID"] = this.signatureImageDetailID;
        data["primaryLanguageID"] = this.primaryLanguageID;
        data["secondaryLanguageID"] = this.secondaryLanguageID;
        data["externalID"] = this.externalID;
        data["timeZone"] = this.timeZone;
        data["homePhoneNumber"] = this.homePhoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["officePhoneNumber"] = this.officePhoneNumber;
        data["faxPhoneNumber"] = this.faxPhoneNumber;
        data["aboutMe"] = this.aboutMe;
        data["professionalStatement"] = this.professionalStatement;
        data["minimumPatientAge"] = this.minimumPatientAge;
        data["maximumPatientAge"] = this.maximumPatientAge;
        data["yearsOfExperienceDate"] = this.yearsOfExperienceDate ? this.yearsOfExperienceDate.toISOString() : <any>undefined;
        data["anyOtherDetails"] = this.anyOtherDetails;
        data["degreeName"] = this.degreeName;
        data["hasAgreedToTC"] = this.hasAgreedToTC;
        data["hasReadPCP"] = this.hasReadPCP;
        data["hasAgreedToCodeOfConduct"] = this.hasAgreedToCodeOfConduct;
        data["contactTypeEnum"] = this.contactTypeEnum;
        data["glAccountID"] = this.glAccountID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["publicPage"] = this.publicPage;
        data["publicTag"] = this.publicTag;
        data["myEMRFaxNumber"] = this.myEMRFaxNumber;
        data["myEMRName"] = this.myEMRName;
        data["cityTownID"] = this.cityTownID;
        data["provinceStateID"] = this.provinceStateID;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["postCode"] = this.postCode;
        data["appointmentSlotMinutes"] = this.appointmentSlotMinutes;
        data["cardViews"] = this.cardViews;
        data["scheduleAvailabilityDate"] = this.scheduleAvailabilityDate ? this.scheduleAvailabilityDate.toISOString() : <any>undefined;
        data["serviceDescription"] = this.serviceDescription;
        data["walkInStatusEnum"] = this.walkInStatusEnum;
        data["providerOnboardingID"] = this.providerOnboardingID;
        data["vip"] = this.vip;
        data["vipNotes"] = this.vipNotes;
        data["abusive"] = this.abusive;
        data["abusiveNotes"] = this.abusiveNotes;
        data["landmarks"] = this.landmarks;
        data["invoiceDescription"] = this.invoiceDescription;
        data["impressions"] = this.impressions;
        data["rating"] = this.rating;
        data["ratingCount"] = this.ratingCount;
        data["rewardPoints"] = this.rewardPoints;
        data["bvn"] = this.bvn;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["appTypeEnum"] = this.appTypeEnum;
        data["hasCareFundTC"] = this.hasCareFundTC;
        data["approvedByUserDetail"] = this.approvedByUserDetail ? this.approvedByUserDetail.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["resumeDocument"] = this.resumeDocument ? this.resumeDocument.toJSON() : <any>undefined;
        data["signatureImageDetail"] = this.signatureImageDetail ? this.signatureImageDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.providerStoreItems)) {
            data["providerStoreItems"] = [];
            for (let item of this.providerStoreItems)
                data["providerStoreItems"].push(item.toJSON());
        }
        data["discussionImageDetail"] = this.discussionImageDetail ? this.discussionImageDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.providerSchedules)) {
            data["providerSchedules"] = [];
            for (let item of this.providerSchedules)
                data["providerSchedules"].push(item.toJSON());
        }
        data["providerTypeTag"] = this.providerTypeTag ? this.providerTypeTag.toJSON() : <any>undefined;
        data["cityTown"] = this.cityTown ? this.cityTown.toJSON() : <any>undefined;
        if (Array.isArray(this.providerImages)) {
            data["providerImages"] = [];
            for (let item of this.providerImages)
                data["providerImages"].push(item.toJSON());
        }
        data["city"] = this.city;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        data["province"] = this.province;
        data["primaryLanguage"] = this.primaryLanguage ? this.primaryLanguage.toJSON() : <any>undefined;
        data["secondaryLanguage"] = this.secondaryLanguage ? this.secondaryLanguage.toJSON() : <any>undefined;
        if (Array.isArray(this.providerSettings)) {
            data["providerSettings"] = [];
            for (let item of this.providerSettings)
                data["providerSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.providerAchievements)) {
            data["providerAchievements"] = [];
            for (let item of this.providerAchievements)
                data["providerAchievements"].push(item.toJSON());
        }
        if (Array.isArray(this.providerRegistrations)) {
            data["providerRegistrations"] = [];
            for (let item of this.providerRegistrations)
                data["providerRegistrations"].push(item.toJSON());
        }
        if (Array.isArray(this.providerTags)) {
            data["providerTags"] = [];
            for (let item of this.providerTags)
                data["providerTags"].push(item.toJSON());
        }
        if (Array.isArray(this.providerSpecialties)) {
            data["providerSpecialties"] = [];
            for (let item of this.providerSpecialties)
                data["providerSpecialties"].push(item.toJSON());
        }
        data["fullName"] = this.fullName;
        data["formattedCellPhoneNumber"] = this.formattedCellPhoneNumber;
        data["formattedHomePhoneNumber"] = this.formattedHomePhoneNumber;
        data["formattedOfficePhoneNumber"] = this.formattedOfficePhoneNumber;
        data["formattedFaxPhoneNumber"] = this.formattedFaxPhoneNumber;
        data["primaryPhone"] = this.primaryPhone;
        data["primaryProviderSpecialtyTag"] = this.primaryProviderSpecialtyTag ? this.primaryProviderSpecialtyTag.toJSON() : <any>undefined;
        if (Array.isArray(this.providerQueues)) {
            data["providerQueues"] = [];
            for (let item of this.providerQueues)
                data["providerQueues"].push(item.toJSON());
        }
        data["yearsOfExperience"] = this.yearsOfExperience;
        data["isFavorite"] = this.isFavorite;
        data["publicURL"] = this.publicURL;
        data["isDiscussionBanned"] = this.isDiscussionBanned;
        data["providerOnboarding"] = this.providerOnboarding ? this.providerOnboarding.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProvider extends IEntityBase {
    providerID: string;
    userDetailID: string;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    emailAddress: string;
    imageDetailID?: string | undefined;
    discussionsUserName?: string | undefined;
    discussionsImageDetailID?: string | undefined;
    hasAgreedDiscussionTC: boolean;
    genderEnum: GenderEnum;
    countryID: string;
    providerTypeEnum: ProviderTypeEnum;
    providerTypeTagID?: string | undefined;
    approved: boolean;
    approvedByUserDetailID?: string | undefined;
    approvedDate?: Date | undefined;
    resumeDocumentID?: string | undefined;
    signatureImageDetailID?: string | undefined;
    primaryLanguageID?: string | undefined;
    secondaryLanguageID?: string | undefined;
    externalID?: string | undefined;
    timeZone: string;
    homePhoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    officePhoneNumber?: string | undefined;
    faxPhoneNumber?: string | undefined;
    aboutMe?: string | undefined;
    professionalStatement?: string | undefined;
    minimumPatientAge?: number | undefined;
    maximumPatientAge?: number | undefined;
    yearsOfExperienceDate?: Date | undefined;
    anyOtherDetails?: string | undefined;
    degreeName?: string | undefined;
    hasAgreedToTC: boolean;
    hasReadPCP: boolean;
    hasAgreedToCodeOfConduct: boolean;
    contactTypeEnum?: ContactTypeEnum | undefined;
    glAccountID?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    publicPage: boolean;
    publicTag?: string | undefined;
    myEMRFaxNumber?: string | undefined;
    myEMRName?: string | undefined;
    cityTownID?: string | undefined;
    provinceStateID?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    postCode?: string | undefined;
    appointmentSlotMinutes?: number | undefined;
    cardViews: number;
    scheduleAvailabilityDate?: Date | undefined;
    serviceDescription?: string | undefined;
    walkInStatusEnum: WalkInStatusEnum;
    providerOnboardingID?: string | undefined;
    vip: boolean;
    vipNotes?: string | undefined;
    abusive: boolean;
    abusiveNotes?: string | undefined;
    landmarks?: string | undefined;
    invoiceDescription?: string | undefined;
    impressions: number;
    rating: number;
    ratingCount: number;
    rewardPoints: number;
    bvn?: string | undefined;
    birthDate?: Date | undefined;
    appTypeEnum: AppTypeEnum;
    hasCareFundTC: boolean;
    approvedByUserDetail?: UserDetail | undefined;
    userDetail?: UserDetail | undefined;
    country?: Country | undefined;
    resumeDocument?: Document | undefined;
    signatureImageDetail?: ImageDetail | undefined;
    providerStoreItems?: ProviderStoreItem[] | undefined;
    discussionImageDetail?: ImageDetail | undefined;
    providerSchedules?: ProviderSchedule[] | undefined;
    providerTypeTag?: Tag | undefined;
    cityTown?: CityTown | undefined;
    providerImages?: ProviderImage[] | undefined;
    city?: string | undefined;
    provinceState?: ProvinceState | undefined;
    province?: string | undefined;
    primaryLanguage?: Language | undefined;
    secondaryLanguage?: Language | undefined;
    providerSettings?: ProviderSetting[] | undefined;
    providerAchievements?: ProviderAchievement[] | undefined;
    providerRegistrations?: ProviderRegistration[] | undefined;
    providerTags?: ProviderTag[] | undefined;
    providerSpecialties?: ProviderSpecialty[] | undefined;
    fullName?: string | undefined;
    formattedCellPhoneNumber?: string | undefined;
    formattedHomePhoneNumber?: string | undefined;
    formattedOfficePhoneNumber?: string | undefined;
    formattedFaxPhoneNumber?: string | undefined;
    primaryPhone?: string | undefined;
    primaryProviderSpecialtyTag?: Tag | undefined;
    providerQueues?: ProviderQueue[] | undefined;
    yearsOfExperience?: number | undefined;
    isFavorite?: boolean;
    publicURL?: string | undefined;
    isDiscussionBanned?: boolean;
    providerOnboarding?: ProviderOnboarding | undefined;
}

export enum GenderEnum {
    Male = "Male",
    Female = "Female",
    NotDisclosed = "Not Disclosed",
    Other = "Other",
}

export enum ProviderTypeEnum {
    Physician = "Physician",
    Pharmacist = "Pharmacist",
    HealthCareNavigator = "Health Care Navigator",
    Receptionist = "Receptionist",
    NursePractitioner = "Nurse Practitioner",
    LabTechnician = "LabTechnician",
    MedicalAssistant = "MedicalAssistant",
    MerchantProvider = "MerchantProvider",
    Counsellor = "Counsellor",
    RegisteredNurse = "RegisteredNurse",
}

export enum ContactTypeEnum {
    Email = "Email",
    HomePhone = "HomePhone",
    CellPhone = "CellPhone",
}

export enum WalkInStatusEnum {
    NotAvailable = "NotAvailable",
    Available = "Available",
    NotConfiguredForWalkIn = "NotConfiguredForWalkIn",
}

export enum AppTypeEnum {
    NotSet = "NotSet",
    HealthRecord = "HealthRecord",
    Community = "Community",
    CareFund = "CareFund",
    NeoID = "NeoID",
    ProviderRecruitment = "ProviderRecruitment",
}

export class UserDetail extends EntityBase implements IUserDetail {
    userDetailID!: string;
    identityID!: string;
    uniqueLifetimeSeed!: number;
    uniqueLifetimeID!: number;
    available!: boolean;
    profileInitialized!: boolean;
    temporaryPIN!: number;
    ussdLockoutDate?: Date | undefined;
    externalID?: string | undefined;
    lastPingDate!: Date;
    deleted!: boolean;
    resetPasswordEnum!: ResetPasswordEnum;
    originalHost?: string | undefined;
    salesPersonUserDetailID?: string | undefined;
    userDetailSettings?: UserDetailSetting[] | undefined;
    userDetailModules?: UserDetailModule[] | undefined;
    userDetailRelationships?: UserDetailRelationship[] | undefined;
    roles?: string[] | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    provider?: Provider | undefined;
    patient?: Patient | undefined;
    salesPersonUserDetail?: UserDetail | undefined;
    salesPersonName?: string | undefined;

    constructor(data?: IUserDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.identityID = _data["identityID"];
            this.uniqueLifetimeSeed = _data["uniqueLifetimeSeed"];
            this.uniqueLifetimeID = _data["uniqueLifetimeID"];
            this.available = _data["available"];
            this.profileInitialized = _data["profileInitialized"];
            this.temporaryPIN = _data["temporaryPIN"];
            this.ussdLockoutDate = _data["ussdLockoutDate"] ? new Date(_data["ussdLockoutDate"].toString()) : <any>undefined;
            this.externalID = _data["externalID"];
            this.lastPingDate = _data["lastPingDate"] ? new Date(_data["lastPingDate"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.resetPasswordEnum = _data["resetPasswordEnum"];
            this.originalHost = _data["originalHost"];
            this.salesPersonUserDetailID = _data["salesPersonUserDetailID"];
            if (Array.isArray(_data["userDetailSettings"])) {
                this.userDetailSettings = [] as any;
                for (let item of _data["userDetailSettings"])
                    this.userDetailSettings!.push(UserDetailSetting.fromJS(item));
            }
            if (Array.isArray(_data["userDetailModules"])) {
                this.userDetailModules = [] as any;
                for (let item of _data["userDetailModules"])
                    this.userDetailModules!.push(UserDetailModule.fromJS(item));
            }
            if (Array.isArray(_data["userDetailRelationships"])) {
                this.userDetailRelationships = [] as any;
                for (let item of _data["userDetailRelationships"])
                    this.userDetailRelationships!.push(UserDetailRelationship.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.salesPersonUserDetail = _data["salesPersonUserDetail"] ? UserDetail.fromJS(_data["salesPersonUserDetail"]) : <any>undefined;
            this.salesPersonName = _data["salesPersonName"];
        }
    }

    static fromJS(data: any): UserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["identityID"] = this.identityID;
        data["uniqueLifetimeSeed"] = this.uniqueLifetimeSeed;
        data["uniqueLifetimeID"] = this.uniqueLifetimeID;
        data["available"] = this.available;
        data["profileInitialized"] = this.profileInitialized;
        data["temporaryPIN"] = this.temporaryPIN;
        data["ussdLockoutDate"] = this.ussdLockoutDate ? this.ussdLockoutDate.toISOString() : <any>undefined;
        data["externalID"] = this.externalID;
        data["lastPingDate"] = this.lastPingDate ? this.lastPingDate.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["resetPasswordEnum"] = this.resetPasswordEnum;
        data["originalHost"] = this.originalHost;
        data["salesPersonUserDetailID"] = this.salesPersonUserDetailID;
        if (Array.isArray(this.userDetailSettings)) {
            data["userDetailSettings"] = [];
            for (let item of this.userDetailSettings)
                data["userDetailSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.userDetailModules)) {
            data["userDetailModules"] = [];
            for (let item of this.userDetailModules)
                data["userDetailModules"].push(item.toJSON());
        }
        if (Array.isArray(this.userDetailRelationships)) {
            data["userDetailRelationships"] = [];
            for (let item of this.userDetailRelationships)
                data["userDetailRelationships"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["salesPersonUserDetail"] = this.salesPersonUserDetail ? this.salesPersonUserDetail.toJSON() : <any>undefined;
        data["salesPersonName"] = this.salesPersonName;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDetail extends IEntityBase {
    userDetailID: string;
    identityID: string;
    uniqueLifetimeSeed: number;
    uniqueLifetimeID: number;
    available: boolean;
    profileInitialized: boolean;
    temporaryPIN: number;
    ussdLockoutDate?: Date | undefined;
    externalID?: string | undefined;
    lastPingDate: Date;
    deleted: boolean;
    resetPasswordEnum: ResetPasswordEnum;
    originalHost?: string | undefined;
    salesPersonUserDetailID?: string | undefined;
    userDetailSettings?: UserDetailSetting[] | undefined;
    userDetailModules?: UserDetailModule[] | undefined;
    userDetailRelationships?: UserDetailRelationship[] | undefined;
    roles?: string[] | undefined;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    provider?: Provider | undefined;
    patient?: Patient | undefined;
    salesPersonUserDetail?: UserDetail | undefined;
    salesPersonName?: string | undefined;
}

export enum ResetPasswordEnum {
    NotSet = "NotSet",
    NewAccount = "NewAccount",
}

export class UserDetailSetting extends EntityBase implements IUserDetailSetting {
    userDetailSettingID!: string;
    userDetailID!: string;
    userDetailSettingEnum!: UserDetailSettingEnum;
    description?: string | undefined;
    value!: string;
    userDetail?: UserDetail | undefined;

    constructor(data?: IUserDetailSetting) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailSettingID = _data["userDetailSettingID"];
            this.userDetailID = _data["userDetailID"];
            this.userDetailSettingEnum = _data["userDetailSettingEnum"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDetailSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailSettingID"] = this.userDetailSettingID;
        data["userDetailID"] = this.userDetailID;
        data["userDetailSettingEnum"] = this.userDetailSettingEnum;
        data["description"] = this.description;
        data["value"] = this.value;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDetailSetting extends IEntityBase {
    userDetailSettingID: string;
    userDetailID: string;
    userDetailSettingEnum: UserDetailSettingEnum;
    description?: string | undefined;
    value: string;
    userDetail?: UserDetail | undefined;
}

export enum UserDetailSettingEnum {
    Weight = "Weight",
    Height = "Height",
    BloodGlucose = "Blood Glucose",
    Temperature = "Temperature",
    PatientDashboardTour = "PatientDashboardTour",
    PatientMedicationTour = "PatientMedicationTour",
    ProviderDashboardTour = "ProviderDashboardTour",
    ProviderClinicTour = "ProviderClinicTour",
    OutpostWalletAccountNumber = "OutpostWalletAccountNumber",
    OutpostWalletPassword = "OutpostWalletPassword",
    WeightHeight = "WeightHeight",
}

export class UserDetailModule extends EntityBase implements IUserDetailModule {
    userDetailModuleID!: string;
    userDetailID!: string;
    moduleID!: string;
    startDate!: Date;
    module?: Module | undefined;

    constructor(data?: IUserDetailModule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailModuleID = _data["userDetailModuleID"];
            this.userDetailID = _data["userDetailID"];
            this.moduleID = _data["moduleID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDetailModule {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailModuleID"] = this.userDetailModuleID;
        data["userDetailID"] = this.userDetailID;
        data["moduleID"] = this.moduleID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDetailModule extends IEntityBase {
    userDetailModuleID: string;
    userDetailID: string;
    moduleID: string;
    startDate: Date;
    module?: Module | undefined;
}

export class Module extends EntityBase implements IModule {
    moduleID!: string;
    name!: string;
    description!: string;
    enabled!: boolean;
    displaySortOrder!: number;
    roleName!: string;
    menuImageURL!: string;
    imageURL!: string;
    themeName!: string;
    moduleResources?: ModuleResource[] | undefined;

    constructor(data?: IModule) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.moduleID = _data["moduleID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.roleName = _data["roleName"];
            this.menuImageURL = _data["menuImageURL"];
            this.imageURL = _data["imageURL"];
            this.themeName = _data["themeName"];
            if (Array.isArray(_data["moduleResources"])) {
                this.moduleResources = [] as any;
                for (let item of _data["moduleResources"])
                    this.moduleResources!.push(ModuleResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleID"] = this.moduleID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["displaySortOrder"] = this.displaySortOrder;
        data["roleName"] = this.roleName;
        data["menuImageURL"] = this.menuImageURL;
        data["imageURL"] = this.imageURL;
        data["themeName"] = this.themeName;
        if (Array.isArray(this.moduleResources)) {
            data["moduleResources"] = [];
            for (let item of this.moduleResources)
                data["moduleResources"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IModule extends IEntityBase {
    moduleID: string;
    name: string;
    description: string;
    enabled: boolean;
    displaySortOrder: number;
    roleName: string;
    menuImageURL: string;
    imageURL: string;
    themeName: string;
    moduleResources?: ModuleResource[] | undefined;
}

export class ModuleResource extends EntityBase implements IModuleResource {
    moduleResourceID!: string;
    moduleID!: string;
    moduleResourceTypeEnum!: ModuleResourceTypeEnum;
    name!: string;
    description!: string;
    bioImageURL?: string | undefined;
    bioTitle?: string | undefined;
    bio?: string | undefined;
    displaySortOrder!: number;
    bannerImageURL?: string | undefined;
    imageURL?: string | undefined;
    contentURL?: string | undefined;
    moduleResourceDetails?: ModuleResourceDetail[] | undefined;

    constructor(data?: IModuleResource) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.moduleResourceID = _data["moduleResourceID"];
            this.moduleID = _data["moduleID"];
            this.moduleResourceTypeEnum = _data["moduleResourceTypeEnum"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.bioImageURL = _data["bioImageURL"];
            this.bioTitle = _data["bioTitle"];
            this.bio = _data["bio"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.bannerImageURL = _data["bannerImageURL"];
            this.imageURL = _data["imageURL"];
            this.contentURL = _data["contentURL"];
            if (Array.isArray(_data["moduleResourceDetails"])) {
                this.moduleResourceDetails = [] as any;
                for (let item of _data["moduleResourceDetails"])
                    this.moduleResourceDetails!.push(ModuleResourceDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModuleResource {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleResourceID"] = this.moduleResourceID;
        data["moduleID"] = this.moduleID;
        data["moduleResourceTypeEnum"] = this.moduleResourceTypeEnum;
        data["name"] = this.name;
        data["description"] = this.description;
        data["bioImageURL"] = this.bioImageURL;
        data["bioTitle"] = this.bioTitle;
        data["bio"] = this.bio;
        data["displaySortOrder"] = this.displaySortOrder;
        data["bannerImageURL"] = this.bannerImageURL;
        data["imageURL"] = this.imageURL;
        data["contentURL"] = this.contentURL;
        if (Array.isArray(this.moduleResourceDetails)) {
            data["moduleResourceDetails"] = [];
            for (let item of this.moduleResourceDetails)
                data["moduleResourceDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IModuleResource extends IEntityBase {
    moduleResourceID: string;
    moduleID: string;
    moduleResourceTypeEnum: ModuleResourceTypeEnum;
    name: string;
    description: string;
    bioImageURL?: string | undefined;
    bioTitle?: string | undefined;
    bio?: string | undefined;
    displaySortOrder: number;
    bannerImageURL?: string | undefined;
    imageURL?: string | undefined;
    contentURL?: string | undefined;
    moduleResourceDetails?: ModuleResourceDetail[] | undefined;
}

export enum ModuleResourceTypeEnum {
    Resource = "Resource",
    Community = "Community",
}

export class ModuleResourceDetail extends EntityBase implements IModuleResourceDetail {
    moduleResourceDetailID!: string;
    moduleResourceID!: string;
    moduleResourceDetailTypeEnum!: ModuleResourceDetailTypeEnum;
    name!: string;
    description!: string;
    displaySortOrder!: number;
    week?: number | undefined;
    contentURL?: string | undefined;
    content?: string | undefined;
    imageURL?: string | undefined;

    constructor(data?: IModuleResourceDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.moduleResourceDetailID = _data["moduleResourceDetailID"];
            this.moduleResourceID = _data["moduleResourceID"];
            this.moduleResourceDetailTypeEnum = _data["moduleResourceDetailTypeEnum"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.week = _data["week"];
            this.contentURL = _data["contentURL"];
            this.content = _data["content"];
            this.imageURL = _data["imageURL"];
        }
    }

    static fromJS(data: any): ModuleResourceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleResourceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleResourceDetailID"] = this.moduleResourceDetailID;
        data["moduleResourceID"] = this.moduleResourceID;
        data["moduleResourceDetailTypeEnum"] = this.moduleResourceDetailTypeEnum;
        data["name"] = this.name;
        data["description"] = this.description;
        data["displaySortOrder"] = this.displaySortOrder;
        data["week"] = this.week;
        data["contentURL"] = this.contentURL;
        data["content"] = this.content;
        data["imageURL"] = this.imageURL;
        super.toJSON(data);
        return data;
    }
}

export interface IModuleResourceDetail extends IEntityBase {
    moduleResourceDetailID: string;
    moduleResourceID: string;
    moduleResourceDetailTypeEnum: ModuleResourceDetailTypeEnum;
    name: string;
    description: string;
    displaySortOrder: number;
    week?: number | undefined;
    contentURL?: string | undefined;
    content?: string | undefined;
    imageURL?: string | undefined;
}

export enum ModuleResourceDetailTypeEnum {
    Video = "Video",
    Audio = "Audio",
    Content = "Content",
    PDF = "PDF",
}

export class UserDetailRelationship extends EntityBase implements IUserDetailRelationship {
    userDetailRelationshipID!: string;
    userDetailID!: string;
    toUserDetailID?: string | undefined;
    name?: string | undefined;
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;
    token?: string | undefined;
    sent!: boolean;
    sentDate?: Date | undefined;
    acceptedTries!: number;
    acceptedDate?: Date | undefined;
    rejectedDate?: Date | undefined;
    taskItemID?: string | undefined;
    message?: string | undefined;
    dependant!: boolean;
    healthRecords!: boolean;
    wallet!: boolean;
    relationshipTypeEnum!: RelationshipTypeEnum;
    primaryCareGiver!: boolean;
    userDetail?: UserDetail | undefined;
    toUserDetail?: UserDetail | undefined;
    toUserImageDetailID?: string | undefined;
    toUserName?: string | undefined;

    constructor(data?: IUserDetailRelationship) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailRelationshipID = _data["userDetailRelationshipID"];
            this.userDetailID = _data["userDetailID"];
            this.toUserDetailID = _data["toUserDetailID"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.smsNumber = _data["smsNumber"];
            this.token = _data["token"];
            this.sent = _data["sent"];
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.acceptedTries = _data["acceptedTries"];
            this.acceptedDate = _data["acceptedDate"] ? new Date(_data["acceptedDate"].toString()) : <any>undefined;
            this.rejectedDate = _data["rejectedDate"] ? new Date(_data["rejectedDate"].toString()) : <any>undefined;
            this.taskItemID = _data["taskItemID"];
            this.message = _data["message"];
            this.dependant = _data["dependant"];
            this.healthRecords = _data["healthRecords"];
            this.wallet = _data["wallet"];
            this.relationshipTypeEnum = _data["relationshipTypeEnum"];
            this.primaryCareGiver = _data["primaryCareGiver"];
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.toUserDetail = _data["toUserDetail"] ? UserDetail.fromJS(_data["toUserDetail"]) : <any>undefined;
            this.toUserImageDetailID = _data["toUserImageDetailID"];
            this.toUserName = _data["toUserName"];
        }
    }

    static fromJS(data: any): UserDetailRelationship {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailRelationship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailRelationshipID"] = this.userDetailRelationshipID;
        data["userDetailID"] = this.userDetailID;
        data["toUserDetailID"] = this.toUserDetailID;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["smsNumber"] = this.smsNumber;
        data["token"] = this.token;
        data["sent"] = this.sent;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["acceptedTries"] = this.acceptedTries;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toISOString() : <any>undefined;
        data["rejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : <any>undefined;
        data["taskItemID"] = this.taskItemID;
        data["message"] = this.message;
        data["dependant"] = this.dependant;
        data["healthRecords"] = this.healthRecords;
        data["wallet"] = this.wallet;
        data["relationshipTypeEnum"] = this.relationshipTypeEnum;
        data["primaryCareGiver"] = this.primaryCareGiver;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["toUserDetail"] = this.toUserDetail ? this.toUserDetail.toJSON() : <any>undefined;
        data["toUserImageDetailID"] = this.toUserImageDetailID;
        data["toUserName"] = this.toUserName;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDetailRelationship extends IEntityBase {
    userDetailRelationshipID: string;
    userDetailID: string;
    toUserDetailID?: string | undefined;
    name?: string | undefined;
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;
    token?: string | undefined;
    sent: boolean;
    sentDate?: Date | undefined;
    acceptedTries: number;
    acceptedDate?: Date | undefined;
    rejectedDate?: Date | undefined;
    taskItemID?: string | undefined;
    message?: string | undefined;
    dependant: boolean;
    healthRecords: boolean;
    wallet: boolean;
    relationshipTypeEnum: RelationshipTypeEnum;
    primaryCareGiver: boolean;
    userDetail?: UserDetail | undefined;
    toUserDetail?: UserDetail | undefined;
    toUserImageDetailID?: string | undefined;
    toUserName?: string | undefined;
}

export enum RelationshipTypeEnum {
    Unknown = "Not Provided",
    Spouse = "Spouse",
    Partner = "Partner",
    Mother = "Mother",
    Father = "Father",
    Son = "Son",
    Daughter = "Daughter",
    Aunt = "Aunt",
    Uncle = "Uncle",
    Niece = "Niece",
    Nephew = "Nephew",
    Grandmother = "Grandmother",
    Grandfather = "Grandfather",
    Granddaughter = "Granddaughter",
    Grandson = "Grandson",
    Other = "Other",
}

export class Patient extends EntityBase implements IPatient {
    patientID!: string;
    userDetailID!: string;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    emailAddress!: string;
    doNotEmail!: boolean;
    imageDetailID?: string | undefined;
    birthDate?: Date | undefined;
    discussionsUserName?: string | undefined;
    discussionsImageDetailID?: string | undefined;
    hasAgreedDiscussionTC!: boolean;
    genderEnum!: GenderEnum;
    primaryLanguageID?: string | undefined;
    secondaryLanguageID?: string | undefined;
    externalID?: string | undefined;
    homePhoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    cellPhoneNumberVerified!: boolean;
    doNotSMS!: boolean;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    cityTownID?: string | undefined;
    province?: string | undefined;
    provinceStateID?: string | undefined;
    postCode?: string | undefined;
    countryID!: string;
    emergencyContactName?: string | undefined;
    emergencyContactHomePhoneNumber?: string | undefined;
    emergencyContactCellPhoneNumber?: string | undefined;
    emergencyContactRelationship?: string | undefined;
    organDonor!: boolean;
    maritalStatusEnum?: MaritalStatusEnum | undefined;
    hasAgreedToTC!: boolean;
    hasReadPCP!: boolean;
    aboutMe?: string | undefined;
    timeZone!: string;
    otherGenderText?: string | undefined;
    contactTypeEnum?: ContactTypeEnum | undefined;
    onboardPercentComplete?: number | undefined;
    doNotContact!: boolean;
    deceased!: boolean;
    latitude?: number | undefined;
    longitude?: number | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    familyDoctorAssociatedID?: string | undefined;
    vip!: boolean;
    vipNotes?: string | undefined;
    abusive!: boolean;
    abusiveNotes?: string | undefined;
    landmarks?: string | undefined;
    rewardPoints!: number;
    bvn?: string | undefined;
    appTypeEnum!: AppTypeEnum;
    hasCareFundTC!: boolean;
    country?: Country | undefined;
    imageDetail?: ImageDetail | undefined;
    discussionImageDetail?: ImageDetail | undefined;
    userDetail?: UserDetail | undefined;
    provinceState?: ProvinceState | undefined;
    cityTown?: CityTown | undefined;
    formattedCellPhoneNumber?: string | undefined;
    formattedHomePhoneNumber?: string | undefined;
    formattedEmergencyContactHomePhoneNumber?: string | undefined;
    formattedEmergencyContactCellPhoneNumber?: string | undefined;
    primaryLanguage?: Language | undefined;
    secondaryLanguage?: Language | undefined;
    fullName?: string | undefined;
    isDependant?: boolean;
    birthDateString?: string | undefined;
    isDiscussionBanned?: boolean;
    patientAccesses?: PatientAccess[] | undefined;
    patientCareTeams?: PatientCareTeam[] | undefined;
    patientDependants?: PatientDependant[] | undefined;
    patientInsurances?: PatientInsurance[] | undefined;
    patientFavorites?: PatientFavorite[] | undefined;
    patientNotifications?: PatientNotification[] | undefined;
    patientPrescriptions?: PatientPrescription[] | undefined;
    patientOrders?: PatientOrder[] | undefined;

    constructor(data?: IPatient) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientID = _data["patientID"];
            this.userDetailID = _data["userDetailID"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.emailAddress = _data["emailAddress"];
            this.doNotEmail = _data["doNotEmail"];
            this.imageDetailID = _data["imageDetailID"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.discussionsUserName = _data["discussionsUserName"];
            this.discussionsImageDetailID = _data["discussionsImageDetailID"];
            this.hasAgreedDiscussionTC = _data["hasAgreedDiscussionTC"];
            this.genderEnum = _data["genderEnum"];
            this.primaryLanguageID = _data["primaryLanguageID"];
            this.secondaryLanguageID = _data["secondaryLanguageID"];
            this.externalID = _data["externalID"];
            this.homePhoneNumber = _data["homePhoneNumber"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.cellPhoneNumberVerified = _data["cellPhoneNumberVerified"];
            this.doNotSMS = _data["doNotSMS"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.cityTownID = _data["cityTownID"];
            this.province = _data["province"];
            this.provinceStateID = _data["provinceStateID"];
            this.postCode = _data["postCode"];
            this.countryID = _data["countryID"];
            this.emergencyContactName = _data["emergencyContactName"];
            this.emergencyContactHomePhoneNumber = _data["emergencyContactHomePhoneNumber"];
            this.emergencyContactCellPhoneNumber = _data["emergencyContactCellPhoneNumber"];
            this.emergencyContactRelationship = _data["emergencyContactRelationship"];
            this.organDonor = _data["organDonor"];
            this.maritalStatusEnum = _data["maritalStatusEnum"];
            this.hasAgreedToTC = _data["hasAgreedToTC"];
            this.hasReadPCP = _data["hasReadPCP"];
            this.aboutMe = _data["aboutMe"];
            this.timeZone = _data["timeZone"];
            this.otherGenderText = _data["otherGenderText"];
            this.contactTypeEnum = _data["contactTypeEnum"];
            this.onboardPercentComplete = _data["onboardPercentComplete"];
            this.doNotContact = _data["doNotContact"];
            this.deceased = _data["deceased"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.familyDoctorAssociatedID = _data["familyDoctorAssociatedID"];
            this.vip = _data["vip"];
            this.vipNotes = _data["vipNotes"];
            this.abusive = _data["abusive"];
            this.abusiveNotes = _data["abusiveNotes"];
            this.landmarks = _data["landmarks"];
            this.rewardPoints = _data["rewardPoints"];
            this.bvn = _data["bvn"];
            this.appTypeEnum = _data["appTypeEnum"];
            this.hasCareFundTC = _data["hasCareFundTC"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.imageDetail = _data["imageDetail"] ? ImageDetail.fromJS(_data["imageDetail"]) : <any>undefined;
            this.discussionImageDetail = _data["discussionImageDetail"] ? ImageDetail.fromJS(_data["discussionImageDetail"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            this.cityTown = _data["cityTown"] ? CityTown.fromJS(_data["cityTown"]) : <any>undefined;
            this.formattedCellPhoneNumber = _data["formattedCellPhoneNumber"];
            this.formattedHomePhoneNumber = _data["formattedHomePhoneNumber"];
            this.formattedEmergencyContactHomePhoneNumber = _data["formattedEmergencyContactHomePhoneNumber"];
            this.formattedEmergencyContactCellPhoneNumber = _data["formattedEmergencyContactCellPhoneNumber"];
            this.primaryLanguage = _data["primaryLanguage"] ? Language.fromJS(_data["primaryLanguage"]) : <any>undefined;
            this.secondaryLanguage = _data["secondaryLanguage"] ? Language.fromJS(_data["secondaryLanguage"]) : <any>undefined;
            this.fullName = _data["fullName"];
            this.isDependant = _data["isDependant"];
            this.birthDateString = _data["birthDateString"];
            this.isDiscussionBanned = _data["isDiscussionBanned"];
            if (Array.isArray(_data["patientAccesses"])) {
                this.patientAccesses = [] as any;
                for (let item of _data["patientAccesses"])
                    this.patientAccesses!.push(PatientAccess.fromJS(item));
            }
            if (Array.isArray(_data["patientCareTeams"])) {
                this.patientCareTeams = [] as any;
                for (let item of _data["patientCareTeams"])
                    this.patientCareTeams!.push(PatientCareTeam.fromJS(item));
            }
            if (Array.isArray(_data["patientDependants"])) {
                this.patientDependants = [] as any;
                for (let item of _data["patientDependants"])
                    this.patientDependants!.push(PatientDependant.fromJS(item));
            }
            if (Array.isArray(_data["patientInsurances"])) {
                this.patientInsurances = [] as any;
                for (let item of _data["patientInsurances"])
                    this.patientInsurances!.push(PatientInsurance.fromJS(item));
            }
            if (Array.isArray(_data["patientFavorites"])) {
                this.patientFavorites = [] as any;
                for (let item of _data["patientFavorites"])
                    this.patientFavorites!.push(PatientFavorite.fromJS(item));
            }
            if (Array.isArray(_data["patientNotifications"])) {
                this.patientNotifications = [] as any;
                for (let item of _data["patientNotifications"])
                    this.patientNotifications!.push(PatientNotification.fromJS(item));
            }
            if (Array.isArray(_data["patientPrescriptions"])) {
                this.patientPrescriptions = [] as any;
                for (let item of _data["patientPrescriptions"])
                    this.patientPrescriptions!.push(PatientPrescription.fromJS(item));
            }
            if (Array.isArray(_data["patientOrders"])) {
                this.patientOrders = [] as any;
                for (let item of _data["patientOrders"])
                    this.patientOrders!.push(PatientOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Patient {
        data = typeof data === 'object' ? data : {};
        let result = new Patient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["userDetailID"] = this.userDetailID;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["emailAddress"] = this.emailAddress;
        data["doNotEmail"] = this.doNotEmail;
        data["imageDetailID"] = this.imageDetailID;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["discussionsUserName"] = this.discussionsUserName;
        data["discussionsImageDetailID"] = this.discussionsImageDetailID;
        data["hasAgreedDiscussionTC"] = this.hasAgreedDiscussionTC;
        data["genderEnum"] = this.genderEnum;
        data["primaryLanguageID"] = this.primaryLanguageID;
        data["secondaryLanguageID"] = this.secondaryLanguageID;
        data["externalID"] = this.externalID;
        data["homePhoneNumber"] = this.homePhoneNumber;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["cellPhoneNumberVerified"] = this.cellPhoneNumberVerified;
        data["doNotSMS"] = this.doNotSMS;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["cityTownID"] = this.cityTownID;
        data["province"] = this.province;
        data["provinceStateID"] = this.provinceStateID;
        data["postCode"] = this.postCode;
        data["countryID"] = this.countryID;
        data["emergencyContactName"] = this.emergencyContactName;
        data["emergencyContactHomePhoneNumber"] = this.emergencyContactHomePhoneNumber;
        data["emergencyContactCellPhoneNumber"] = this.emergencyContactCellPhoneNumber;
        data["emergencyContactRelationship"] = this.emergencyContactRelationship;
        data["organDonor"] = this.organDonor;
        data["maritalStatusEnum"] = this.maritalStatusEnum;
        data["hasAgreedToTC"] = this.hasAgreedToTC;
        data["hasReadPCP"] = this.hasReadPCP;
        data["aboutMe"] = this.aboutMe;
        data["timeZone"] = this.timeZone;
        data["otherGenderText"] = this.otherGenderText;
        data["contactTypeEnum"] = this.contactTypeEnum;
        data["onboardPercentComplete"] = this.onboardPercentComplete;
        data["doNotContact"] = this.doNotContact;
        data["deceased"] = this.deceased;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["familyDoctorAssociatedID"] = this.familyDoctorAssociatedID;
        data["vip"] = this.vip;
        data["vipNotes"] = this.vipNotes;
        data["abusive"] = this.abusive;
        data["abusiveNotes"] = this.abusiveNotes;
        data["landmarks"] = this.landmarks;
        data["rewardPoints"] = this.rewardPoints;
        data["bvn"] = this.bvn;
        data["appTypeEnum"] = this.appTypeEnum;
        data["hasCareFundTC"] = this.hasCareFundTC;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["imageDetail"] = this.imageDetail ? this.imageDetail.toJSON() : <any>undefined;
        data["discussionImageDetail"] = this.discussionImageDetail ? this.discussionImageDetail.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        data["cityTown"] = this.cityTown ? this.cityTown.toJSON() : <any>undefined;
        data["formattedCellPhoneNumber"] = this.formattedCellPhoneNumber;
        data["formattedHomePhoneNumber"] = this.formattedHomePhoneNumber;
        data["formattedEmergencyContactHomePhoneNumber"] = this.formattedEmergencyContactHomePhoneNumber;
        data["formattedEmergencyContactCellPhoneNumber"] = this.formattedEmergencyContactCellPhoneNumber;
        data["primaryLanguage"] = this.primaryLanguage ? this.primaryLanguage.toJSON() : <any>undefined;
        data["secondaryLanguage"] = this.secondaryLanguage ? this.secondaryLanguage.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["isDependant"] = this.isDependant;
        data["birthDateString"] = this.birthDateString;
        data["isDiscussionBanned"] = this.isDiscussionBanned;
        if (Array.isArray(this.patientAccesses)) {
            data["patientAccesses"] = [];
            for (let item of this.patientAccesses)
                data["patientAccesses"].push(item.toJSON());
        }
        if (Array.isArray(this.patientCareTeams)) {
            data["patientCareTeams"] = [];
            for (let item of this.patientCareTeams)
                data["patientCareTeams"].push(item.toJSON());
        }
        if (Array.isArray(this.patientDependants)) {
            data["patientDependants"] = [];
            for (let item of this.patientDependants)
                data["patientDependants"].push(item.toJSON());
        }
        if (Array.isArray(this.patientInsurances)) {
            data["patientInsurances"] = [];
            for (let item of this.patientInsurances)
                data["patientInsurances"].push(item.toJSON());
        }
        if (Array.isArray(this.patientFavorites)) {
            data["patientFavorites"] = [];
            for (let item of this.patientFavorites)
                data["patientFavorites"].push(item.toJSON());
        }
        if (Array.isArray(this.patientNotifications)) {
            data["patientNotifications"] = [];
            for (let item of this.patientNotifications)
                data["patientNotifications"].push(item.toJSON());
        }
        if (Array.isArray(this.patientPrescriptions)) {
            data["patientPrescriptions"] = [];
            for (let item of this.patientPrescriptions)
                data["patientPrescriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.patientOrders)) {
            data["patientOrders"] = [];
            for (let item of this.patientOrders)
                data["patientOrders"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPatient extends IEntityBase {
    patientID: string;
    userDetailID: string;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    emailAddress: string;
    doNotEmail: boolean;
    imageDetailID?: string | undefined;
    birthDate?: Date | undefined;
    discussionsUserName?: string | undefined;
    discussionsImageDetailID?: string | undefined;
    hasAgreedDiscussionTC: boolean;
    genderEnum: GenderEnum;
    primaryLanguageID?: string | undefined;
    secondaryLanguageID?: string | undefined;
    externalID?: string | undefined;
    homePhoneNumber?: string | undefined;
    cellPhoneNumber?: string | undefined;
    cellPhoneNumberVerified: boolean;
    doNotSMS: boolean;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    cityTownID?: string | undefined;
    province?: string | undefined;
    provinceStateID?: string | undefined;
    postCode?: string | undefined;
    countryID: string;
    emergencyContactName?: string | undefined;
    emergencyContactHomePhoneNumber?: string | undefined;
    emergencyContactCellPhoneNumber?: string | undefined;
    emergencyContactRelationship?: string | undefined;
    organDonor: boolean;
    maritalStatusEnum?: MaritalStatusEnum | undefined;
    hasAgreedToTC: boolean;
    hasReadPCP: boolean;
    aboutMe?: string | undefined;
    timeZone: string;
    otherGenderText?: string | undefined;
    contactTypeEnum?: ContactTypeEnum | undefined;
    onboardPercentComplete?: number | undefined;
    doNotContact: boolean;
    deceased: boolean;
    latitude?: number | undefined;
    longitude?: number | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    familyDoctorAssociatedID?: string | undefined;
    vip: boolean;
    vipNotes?: string | undefined;
    abusive: boolean;
    abusiveNotes?: string | undefined;
    landmarks?: string | undefined;
    rewardPoints: number;
    bvn?: string | undefined;
    appTypeEnum: AppTypeEnum;
    hasCareFundTC: boolean;
    country?: Country | undefined;
    imageDetail?: ImageDetail | undefined;
    discussionImageDetail?: ImageDetail | undefined;
    userDetail?: UserDetail | undefined;
    provinceState?: ProvinceState | undefined;
    cityTown?: CityTown | undefined;
    formattedCellPhoneNumber?: string | undefined;
    formattedHomePhoneNumber?: string | undefined;
    formattedEmergencyContactHomePhoneNumber?: string | undefined;
    formattedEmergencyContactCellPhoneNumber?: string | undefined;
    primaryLanguage?: Language | undefined;
    secondaryLanguage?: Language | undefined;
    fullName?: string | undefined;
    isDependant?: boolean;
    birthDateString?: string | undefined;
    isDiscussionBanned?: boolean;
    patientAccesses?: PatientAccess[] | undefined;
    patientCareTeams?: PatientCareTeam[] | undefined;
    patientDependants?: PatientDependant[] | undefined;
    patientInsurances?: PatientInsurance[] | undefined;
    patientFavorites?: PatientFavorite[] | undefined;
    patientNotifications?: PatientNotification[] | undefined;
    patientPrescriptions?: PatientPrescription[] | undefined;
    patientOrders?: PatientOrder[] | undefined;
}

export enum MaritalStatusEnum {
    Married = "Married",
    Single = "Single",
    CommonLaw = "Common Law",
    Other = "Other",
}

export class Language implements ILanguage {
    languageID?: string | undefined;
    name?: string | undefined;
    cultureInfo?: string | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageID = _data["languageID"];
            this.name = _data["name"];
            this.cultureInfo = _data["cultureInfo"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageID"] = this.languageID;
        data["name"] = this.name;
        data["cultureInfo"] = this.cultureInfo;
        return data;
    }
}

export interface ILanguage {
    languageID?: string | undefined;
    name?: string | undefined;
    cultureInfo?: string | undefined;
}

export class PatientAccess extends EntityBase implements IPatientAccess {
    patientAccessID!: string;
    patientID!: string;
    userDetailID!: string;
    patientAccessEnum!: PatientAccessEnum;
    reason?: string | undefined;
    successful!: boolean;
    patient?: Patient | undefined;
    userDetail?: UserDetail | undefined;

    constructor(data?: IPatientAccess) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientAccessID = _data["patientAccessID"];
            this.patientID = _data["patientID"];
            this.userDetailID = _data["userDetailID"];
            this.patientAccessEnum = _data["patientAccessEnum"];
            this.reason = _data["reason"];
            this.successful = _data["successful"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientAccess {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientAccessID"] = this.patientAccessID;
        data["patientID"] = this.patientID;
        data["userDetailID"] = this.userDetailID;
        data["patientAccessEnum"] = this.patientAccessEnum;
        data["reason"] = this.reason;
        data["successful"] = this.successful;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientAccess extends IEntityBase {
    patientAccessID: string;
    patientID: string;
    userDetailID: string;
    patientAccessEnum: PatientAccessEnum;
    reason?: string | undefined;
    successful: boolean;
    patient?: Patient | undefined;
    userDetail?: UserDetail | undefined;
}

export enum PatientAccessEnum {
    NoAccess = "NoAccess",
    PHR = "PHR",
    PHRSummary = "PHRSummary",
    PHRConsult = "PHRConsult",
    PHRAllergy = "PHRAllergy",
    PHRSocialHistory = "PHRSocialHistory",
    PHRSurgeryHistory = "PHRSurgeryHistory",
    PHRVaccination = "PHRVaccination",
    PHRPatient = "PHRPatient",
    PHRWomenHealth = "PHRWomenHealth",
    PHRCareTeam = "PHRCareTeam",
    PHRMedication = "PHRMedication",
    PHRMedicalHistory = "PHRMedicalHistory",
    PHRMedicalEquipment = "PHRMedicalEquipment",
    PHRInsurance = "PHRInsurance",
    PHRHospitalVisit = "PHRHospitalVisit",
    PHRHealthCondition = "PHRHealthCondition",
    PHRHealthGoal = "PHRHealthGoal",
    PHRFunctional = "PHRFunctional",
    PHRAdvancedCareDirective = "PHRAdvancedCareDirective",
    PHRFamilyHistory = "PHRFamilyHistory",
    PHRCarePlan = "PHRCarePlan",
    PHRPregnancy = "PHRPregnancy",
    PHRDocument = "PHRDocument",
    PHRDependant = "PHRDependant",
    PHRClinicalTrial = "PHRClinicalTrial",
    PHRTracker = "PHRTracker",
    PHRHealthJournal = "PHRHealthJournal",
    PHRNotes = "PHRNotes",
    PHRAccesses = "PHRAccesses",
    PHROrderDetail = "PHROrderDetail",
    PHRForms = "PHRForms",
    PHRTests = "PHRTests",
    PHRCovid = "PHRCovid",
    PHRHealthConditionTags = "PHRHealthConditionTags",
}

export class PatientCareTeam extends EntityBase implements IPatientCareTeam {
    patientCareTeamID!: string;
    patientID!: string;
    userDetailID!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    patientCareTeamTypeEnum!: PatientCareTeamTypeEnum;
    patientAccessEnum?: PatientAccessEnum | undefined;
    notes?: string | undefined;
    userDetail?: UserDetail | undefined;
    patient?: Patient | undefined;
    memberName?: string | undefined;
    imageDetailID?: string | undefined;

    constructor(data?: IPatientCareTeam) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientCareTeamID = _data["patientCareTeamID"];
            this.patientID = _data["patientID"];
            this.userDetailID = _data["userDetailID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.patientCareTeamTypeEnum = _data["patientCareTeamTypeEnum"];
            this.patientAccessEnum = _data["patientAccessEnum"];
            this.notes = _data["notes"];
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.memberName = _data["memberName"];
            this.imageDetailID = _data["imageDetailID"];
        }
    }

    static fromJS(data: any): PatientCareTeam {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCareTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientCareTeamID"] = this.patientCareTeamID;
        data["patientID"] = this.patientID;
        data["userDetailID"] = this.userDetailID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["patientCareTeamTypeEnum"] = this.patientCareTeamTypeEnum;
        data["patientAccessEnum"] = this.patientAccessEnum;
        data["notes"] = this.notes;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["imageDetailID"] = this.imageDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientCareTeam extends IEntityBase {
    patientCareTeamID: string;
    patientID: string;
    userDetailID: string;
    startDate: Date;
    endDate?: Date | undefined;
    patientCareTeamTypeEnum: PatientCareTeamTypeEnum;
    patientAccessEnum?: PatientAccessEnum | undefined;
    notes?: string | undefined;
    userDetail?: UserDetail | undefined;
    patient?: Patient | undefined;
    memberName?: string | undefined;
    imageDetailID?: string | undefined;
}

export enum PatientCareTeamTypeEnum {
    Self = "Self",
    Provider = "Provider",
    Patient = "Patient",
    Guest = "Guest",
}

export class PatientDependant extends EntityBase implements IPatientDependant {
    patientDependantID!: string;
    patientID!: string;
    dependantPatientID!: string;
    relationshipTypeEnum!: RelationshipTypeEnum;
    notes?: string | undefined;
    patient?: Patient | undefined;
    dependantPatient?: Patient | undefined;
    internalSignUpPatient?: InternalSignUpPatient | undefined;

    constructor(data?: IPatientDependant) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientDependantID = _data["patientDependantID"];
            this.patientID = _data["patientID"];
            this.dependantPatientID = _data["dependantPatientID"];
            this.relationshipTypeEnum = _data["relationshipTypeEnum"];
            this.notes = _data["notes"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.dependantPatient = _data["dependantPatient"] ? Patient.fromJS(_data["dependantPatient"]) : <any>undefined;
            this.internalSignUpPatient = _data["internalSignUpPatient"] ? InternalSignUpPatient.fromJS(_data["internalSignUpPatient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientDependant {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDependant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientDependantID"] = this.patientDependantID;
        data["patientID"] = this.patientID;
        data["dependantPatientID"] = this.dependantPatientID;
        data["relationshipTypeEnum"] = this.relationshipTypeEnum;
        data["notes"] = this.notes;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["dependantPatient"] = this.dependantPatient ? this.dependantPatient.toJSON() : <any>undefined;
        data["internalSignUpPatient"] = this.internalSignUpPatient ? this.internalSignUpPatient.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientDependant extends IEntityBase {
    patientDependantID: string;
    patientID: string;
    dependantPatientID: string;
    relationshipTypeEnum: RelationshipTypeEnum;
    notes?: string | undefined;
    patient?: Patient | undefined;
    dependantPatient?: Patient | undefined;
    internalSignUpPatient?: InternalSignUpPatient | undefined;
}

export class InternalSignUpPatient implements IInternalSignUpPatient {
    emailOrUniqueLifetimeID?: string | undefined;
    passwordOrPIN?: string | undefined;
    genderEnum?: GenderEnum;
    countryID?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    timeZone?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    languageID?: string | undefined;
    language?: Language | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    birthDateString?: string | undefined;
    providerUserDetailIDs?: string[] | undefined;
    imageDetailID?: string | undefined;
    host?: string | undefined;
    dependant?: boolean;
    healthRecords?: boolean;
    wallet?: boolean;
    relationshipTypeEnum?: RelationshipTypeEnum;
    smsNumber?: string | undefined;
    walletCardID?: string | undefined;
    walletPIN?: number | undefined;
    affiliateID?: string | undefined;
    salesPersonUserDetailID?: string | undefined;
    sendWelcomeEmails?: boolean;
    createWallet?: boolean;
    originalHost?: string | undefined;
    bvn?: string | undefined;
    appTypeEnum?: AppTypeEnum;

    constructor(data?: IInternalSignUpPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOrUniqueLifetimeID = _data["emailOrUniqueLifetimeID"];
            this.passwordOrPIN = _data["passwordOrPIN"];
            this.genderEnum = _data["genderEnum"];
            this.countryID = _data["countryID"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.timeZone = _data["timeZone"];
            this.hasAgreedToTC = _data["hasAgreedToTC"];
            this.hasReadPCP = _data["hasReadPCP"];
            this.languageID = _data["languageID"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.subscriptionUserID = _data["subscriptionUserID"];
            this.subscriptionPIN = _data["subscriptionPIN"];
            this.birthDateString = _data["birthDateString"];
            if (Array.isArray(_data["providerUserDetailIDs"])) {
                this.providerUserDetailIDs = [] as any;
                for (let item of _data["providerUserDetailIDs"])
                    this.providerUserDetailIDs!.push(item);
            }
            this.imageDetailID = _data["imageDetailID"];
            this.host = _data["host"];
            this.dependant = _data["dependant"];
            this.healthRecords = _data["healthRecords"];
            this.wallet = _data["wallet"];
            this.relationshipTypeEnum = _data["relationshipTypeEnum"];
            this.smsNumber = _data["smsNumber"];
            this.walletCardID = _data["walletCardID"];
            this.walletPIN = _data["walletPIN"];
            this.affiliateID = _data["affiliateID"];
            this.salesPersonUserDetailID = _data["salesPersonUserDetailID"];
            this.sendWelcomeEmails = _data["sendWelcomeEmails"];
            this.createWallet = _data["createWallet"];
            this.originalHost = _data["originalHost"];
            this.bvn = _data["bvn"];
            this.appTypeEnum = _data["appTypeEnum"];
        }
    }

    static fromJS(data: any): InternalSignUpPatient {
        data = typeof data === 'object' ? data : {};
        let result = new InternalSignUpPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOrUniqueLifetimeID"] = this.emailOrUniqueLifetimeID;
        data["passwordOrPIN"] = this.passwordOrPIN;
        data["genderEnum"] = this.genderEnum;
        data["countryID"] = this.countryID;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["timeZone"] = this.timeZone;
        data["hasAgreedToTC"] = this.hasAgreedToTC;
        data["hasReadPCP"] = this.hasReadPCP;
        data["languageID"] = this.languageID;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["subscriptionUserID"] = this.subscriptionUserID;
        data["subscriptionPIN"] = this.subscriptionPIN;
        data["birthDateString"] = this.birthDateString;
        if (Array.isArray(this.providerUserDetailIDs)) {
            data["providerUserDetailIDs"] = [];
            for (let item of this.providerUserDetailIDs)
                data["providerUserDetailIDs"].push(item);
        }
        data["imageDetailID"] = this.imageDetailID;
        data["host"] = this.host;
        data["dependant"] = this.dependant;
        data["healthRecords"] = this.healthRecords;
        data["wallet"] = this.wallet;
        data["relationshipTypeEnum"] = this.relationshipTypeEnum;
        data["smsNumber"] = this.smsNumber;
        data["walletCardID"] = this.walletCardID;
        data["walletPIN"] = this.walletPIN;
        data["affiliateID"] = this.affiliateID;
        data["salesPersonUserDetailID"] = this.salesPersonUserDetailID;
        data["sendWelcomeEmails"] = this.sendWelcomeEmails;
        data["createWallet"] = this.createWallet;
        data["originalHost"] = this.originalHost;
        data["bvn"] = this.bvn;
        data["appTypeEnum"] = this.appTypeEnum;
        return data;
    }
}

export interface IInternalSignUpPatient {
    emailOrUniqueLifetimeID?: string | undefined;
    passwordOrPIN?: string | undefined;
    genderEnum?: GenderEnum;
    countryID?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    timeZone?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    languageID?: string | undefined;
    language?: Language | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    birthDateString?: string | undefined;
    providerUserDetailIDs?: string[] | undefined;
    imageDetailID?: string | undefined;
    host?: string | undefined;
    dependant?: boolean;
    healthRecords?: boolean;
    wallet?: boolean;
    relationshipTypeEnum?: RelationshipTypeEnum;
    smsNumber?: string | undefined;
    walletCardID?: string | undefined;
    walletPIN?: number | undefined;
    affiliateID?: string | undefined;
    salesPersonUserDetailID?: string | undefined;
    sendWelcomeEmails?: boolean;
    createWallet?: boolean;
    originalHost?: string | undefined;
    bvn?: string | undefined;
    appTypeEnum?: AppTypeEnum;
}

export class PatientInsurance extends EntityBase implements IPatientInsurance {
    patientInsuranceID!: string;
    patientID!: string;
    insuranceProviderID!: string;
    insuranceNumber!: string;
    expiryDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    isPrimary!: boolean;
    patient?: Patient | undefined;
    verifiedByUserDetail?: UserDetail | undefined;
    verifiedByProviderName?: string | undefined;
    insuranceProvider?: InsuranceProvider | undefined;
    createdByUserDetail?: UserDetail | undefined;
    updatedByUserDetail?: UserDetail | undefined;
    createdByName?: string | undefined;
    updatedByName?: string | undefined;

    constructor(data?: IPatientInsurance) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientInsuranceID = _data["patientInsuranceID"];
            this.patientID = _data["patientID"];
            this.insuranceProviderID = _data["insuranceProviderID"];
            this.insuranceNumber = _data["insuranceNumber"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.isPrimary = _data["isPrimary"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.verifiedByUserDetail = _data["verifiedByUserDetail"] ? UserDetail.fromJS(_data["verifiedByUserDetail"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
            this.insuranceProvider = _data["insuranceProvider"] ? InsuranceProvider.fromJS(_data["insuranceProvider"]) : <any>undefined;
            this.createdByUserDetail = _data["createdByUserDetail"] ? UserDetail.fromJS(_data["createdByUserDetail"]) : <any>undefined;
            this.updatedByUserDetail = _data["updatedByUserDetail"] ? UserDetail.fromJS(_data["updatedByUserDetail"]) : <any>undefined;
            this.createdByName = _data["createdByName"];
            this.updatedByName = _data["updatedByName"];
        }
    }

    static fromJS(data: any): PatientInsurance {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInsurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientInsuranceID"] = this.patientInsuranceID;
        data["patientID"] = this.patientID;
        data["insuranceProviderID"] = this.insuranceProviderID;
        data["insuranceNumber"] = this.insuranceNumber;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["isPrimary"] = this.isPrimary;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["verifiedByUserDetail"] = this.verifiedByUserDetail ? this.verifiedByUserDetail.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        data["insuranceProvider"] = this.insuranceProvider ? this.insuranceProvider.toJSON() : <any>undefined;
        data["createdByUserDetail"] = this.createdByUserDetail ? this.createdByUserDetail.toJSON() : <any>undefined;
        data["updatedByUserDetail"] = this.updatedByUserDetail ? this.updatedByUserDetail.toJSON() : <any>undefined;
        data["createdByName"] = this.createdByName;
        data["updatedByName"] = this.updatedByName;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientInsurance extends IEntityBase {
    patientInsuranceID: string;
    patientID: string;
    insuranceProviderID: string;
    insuranceNumber: string;
    expiryDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    isPrimary: boolean;
    patient?: Patient | undefined;
    verifiedByUserDetail?: UserDetail | undefined;
    verifiedByProviderName?: string | undefined;
    insuranceProvider?: InsuranceProvider | undefined;
    createdByUserDetail?: UserDetail | undefined;
    updatedByUserDetail?: UserDetail | undefined;
    createdByName?: string | undefined;
    updatedByName?: string | undefined;
}

export class InsuranceProvider extends EntityBase implements IInsuranceProvider {
    insuranceProviderID!: string;
    name!: string;
    shortName!: string;
    description!: string;
    insuranceProviderTypeEnum!: InsuranceProviderTypeEnum;
    countryID!: string;
    provinceStateID?: string | undefined;
    imageURL?: string | undefined;
    insuranceNumberLabel?: string | undefined;
    insuranceProviderTypeName!: string;
    enabled!: boolean;
    country?: Country | undefined;
    provinceState?: ProvinceState | undefined;

    constructor(data?: IInsuranceProvider) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insuranceProviderID = _data["insuranceProviderID"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.insuranceProviderTypeEnum = _data["insuranceProviderTypeEnum"];
            this.countryID = _data["countryID"];
            this.provinceStateID = _data["provinceStateID"];
            this.imageURL = _data["imageURL"];
            this.insuranceNumberLabel = _data["insuranceNumberLabel"];
            this.insuranceProviderTypeName = _data["insuranceProviderTypeName"];
            this.enabled = _data["enabled"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InsuranceProvider {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceProviderID"] = this.insuranceProviderID;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["insuranceProviderTypeEnum"] = this.insuranceProviderTypeEnum;
        data["countryID"] = this.countryID;
        data["provinceStateID"] = this.provinceStateID;
        data["imageURL"] = this.imageURL;
        data["insuranceNumberLabel"] = this.insuranceNumberLabel;
        data["insuranceProviderTypeName"] = this.insuranceProviderTypeName;
        data["enabled"] = this.enabled;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInsuranceProvider extends IEntityBase {
    insuranceProviderID: string;
    name: string;
    shortName: string;
    description: string;
    insuranceProviderTypeEnum: InsuranceProviderTypeEnum;
    countryID: string;
    provinceStateID?: string | undefined;
    imageURL?: string | undefined;
    insuranceNumberLabel?: string | undefined;
    insuranceProviderTypeName: string;
    enabled: boolean;
    country?: Country | undefined;
    provinceState?: ProvinceState | undefined;
}

export class PatientFavorite extends EntityBase implements IPatientFavorite {
    patientFavoriteID!: string;
    patientID!: string;
    patientFavoriteTypeEnum!: PatientFavoriteTypeEnum;
    associatedID!: string;
    preferred!: boolean;
    patient?: Patient | undefined;
    provider?: Provider | undefined;
    store?: Store | undefined;
    organization?: Organization | undefined;
    addressBook?: AddressBook | undefined;

    constructor(data?: IPatientFavorite) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientFavoriteID = _data["patientFavoriteID"];
            this.patientID = _data["patientID"];
            this.patientFavoriteTypeEnum = _data["patientFavoriteTypeEnum"];
            this.associatedID = _data["associatedID"];
            this.preferred = _data["preferred"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.addressBook = _data["addressBook"] ? AddressBook.fromJS(_data["addressBook"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientFavorite {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFavorite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientFavoriteID"] = this.patientFavoriteID;
        data["patientID"] = this.patientID;
        data["patientFavoriteTypeEnum"] = this.patientFavoriteTypeEnum;
        data["associatedID"] = this.associatedID;
        data["preferred"] = this.preferred;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["addressBook"] = this.addressBook ? this.addressBook.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientFavorite extends IEntityBase {
    patientFavoriteID: string;
    patientID: string;
    patientFavoriteTypeEnum: PatientFavoriteTypeEnum;
    associatedID: string;
    preferred: boolean;
    patient?: Patient | undefined;
    provider?: Provider | undefined;
    store?: Store | undefined;
    organization?: Organization | undefined;
    addressBook?: AddressBook | undefined;
}

export enum PatientFavoriteTypeEnum {
    Provider = "Provider",
    Pharmacy = "Pharmacy",
    Clinic = "Clinic",
    Lab = "Lab",
    Organization = "Organization",
    PreferredProvider = "PreferredProvider",
    PreferredPharmacy = "PreferredPharmacy",
    PreferredClinic = "PreferredClinic",
    PreferredLab = "PreferredLab",
    PreferredOrganization = "PreferredOrganization",
}

export class PatientNotification extends EntityBase implements IPatientNotification {
    patientNotificationID!: string;
    patientID!: string;
    patientNotificationTypeEnum!: PatientNotificationTypeEnum;
    notificationTypeEnum!: NotificationTypeEnum;
    lastSentDate?: Date | undefined;
    enabled!: boolean;
    providerID?: string | undefined;
    storeID?: string | undefined;
    storeItemID?: string | undefined;
    patient?: Patient | undefined;
    store?: Store | undefined;
    storeItem?: StoreItem | undefined;
    provider?: Provider | undefined;

    constructor(data?: IPatientNotification) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientNotificationID = _data["patientNotificationID"];
            this.patientID = _data["patientID"];
            this.patientNotificationTypeEnum = _data["patientNotificationTypeEnum"];
            this.notificationTypeEnum = _data["notificationTypeEnum"];
            this.lastSentDate = _data["lastSentDate"] ? new Date(_data["lastSentDate"].toString()) : <any>undefined;
            this.enabled = _data["enabled"];
            this.providerID = _data["providerID"];
            this.storeID = _data["storeID"];
            this.storeItemID = _data["storeItemID"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientNotification {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientNotificationID"] = this.patientNotificationID;
        data["patientID"] = this.patientID;
        data["patientNotificationTypeEnum"] = this.patientNotificationTypeEnum;
        data["notificationTypeEnum"] = this.notificationTypeEnum;
        data["lastSentDate"] = this.lastSentDate ? this.lastSentDate.toISOString() : <any>undefined;
        data["enabled"] = this.enabled;
        data["providerID"] = this.providerID;
        data["storeID"] = this.storeID;
        data["storeItemID"] = this.storeItemID;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientNotification extends IEntityBase {
    patientNotificationID: string;
    patientID: string;
    patientNotificationTypeEnum: PatientNotificationTypeEnum;
    notificationTypeEnum: NotificationTypeEnum;
    lastSentDate?: Date | undefined;
    enabled: boolean;
    providerID?: string | undefined;
    storeID?: string | undefined;
    storeItemID?: string | undefined;
    patient?: Patient | undefined;
    store?: Store | undefined;
    storeItem?: StoreItem | undefined;
    provider?: Provider | undefined;
}

export enum PatientNotificationTypeEnum {
    ProviderSchedule = "ProviderSchedule",
    StoreSchedule = "StoreSchedule",
}

export enum NotificationTypeEnum {
    NotSet = "NotSet",
    ByEmail = "ByEmail",
    BySMS = "BySMS",
    ByEmailAndSMS = "ByEmailAndSMS",
}

export class PatientPrescription extends EntityBase implements IPatientPrescription {
    patientPrescriptionID!: string;
    patientID!: string;
    prescriptionDate!: Date;
    prescriptionStatusEnum!: PrescriptionStatusEnum;
    providerID?: string | undefined;
    phrDocumentID?: string | undefined;
    notes?: string | undefined;
    addSignature!: boolean;
    generateDocumentStateEnum!: GenerateDocumentStateEnum;
    sendToEnum!: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient!: boolean;
    qrCode!: number;
    phrConsultID?: string | undefined;
    storeID?: string | undefined;
    invoiceID?: string | undefined;
    totalAmount?: number | undefined;
    declinedDate?: Date | undefined;
    declinedReason?: string | undefined;
    faxID?: string | undefined;
    customerName?: string | undefined;
    customerEmailAddress?: string | undefined;
    customerAddressLine1?: string | undefined;
    customerAddressLine2?: string | undefined;
    customerCity?: string | undefined;
    customerCityTownID?: string | undefined;
    customerProvince?: string | undefined;
    customerProvinceStateID?: string | undefined;
    customerPostCode?: string | undefined;
    customerCountry?: string | undefined;
    customerPhone?: string | undefined;
    countryID!: string;
    taskItemID?: string | undefined;
    patient?: Patient | undefined;
    provider?: Provider | undefined;
    store?: Store | undefined;
    createdByUserDetail?: UserDetail | undefined;
    updatedByUserDetail?: UserDetail | undefined;
    phrMedications?: PHRMedication[] | undefined;
    itemNumber?: number;
    faxSourceEnum?: FaxSourceEnum;
    country?: Country | undefined;
    invoice?: Invoice | undefined;
    deliveryItemTaskItemTypeName?: string | undefined;
    customerProvinceState?: ProvinceState | undefined;
    customerCityTown?: CityTown | undefined;
    taskItem?: TaskItem | undefined;

    constructor(data?: IPatientPrescription) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientPrescriptionID = _data["patientPrescriptionID"];
            this.patientID = _data["patientID"];
            this.prescriptionDate = _data["prescriptionDate"] ? new Date(_data["prescriptionDate"].toString()) : <any>undefined;
            this.prescriptionStatusEnum = _data["prescriptionStatusEnum"];
            this.providerID = _data["providerID"];
            this.phrDocumentID = _data["phrDocumentID"];
            this.notes = _data["notes"];
            this.addSignature = _data["addSignature"];
            this.generateDocumentStateEnum = _data["generateDocumentStateEnum"];
            this.sendToEnum = _data["sendToEnum"];
            this.sendToID = _data["sendToID"];
            this.sendSubject = _data["sendSubject"];
            this.sendMessage = _data["sendMessage"];
            this.sendCopyToPatient = _data["sendCopyToPatient"];
            this.qrCode = _data["qrCode"];
            this.phrConsultID = _data["phrConsultID"];
            this.storeID = _data["storeID"];
            this.invoiceID = _data["invoiceID"];
            this.totalAmount = _data["totalAmount"];
            this.declinedDate = _data["declinedDate"] ? new Date(_data["declinedDate"].toString()) : <any>undefined;
            this.declinedReason = _data["declinedReason"];
            this.faxID = _data["faxID"];
            this.customerName = _data["customerName"];
            this.customerEmailAddress = _data["customerEmailAddress"];
            this.customerAddressLine1 = _data["customerAddressLine1"];
            this.customerAddressLine2 = _data["customerAddressLine2"];
            this.customerCity = _data["customerCity"];
            this.customerCityTownID = _data["customerCityTownID"];
            this.customerProvince = _data["customerProvince"];
            this.customerProvinceStateID = _data["customerProvinceStateID"];
            this.customerPostCode = _data["customerPostCode"];
            this.customerCountry = _data["customerCountry"];
            this.customerPhone = _data["customerPhone"];
            this.countryID = _data["countryID"];
            this.taskItemID = _data["taskItemID"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.createdByUserDetail = _data["createdByUserDetail"] ? UserDetail.fromJS(_data["createdByUserDetail"]) : <any>undefined;
            this.updatedByUserDetail = _data["updatedByUserDetail"] ? UserDetail.fromJS(_data["updatedByUserDetail"]) : <any>undefined;
            if (Array.isArray(_data["phrMedications"])) {
                this.phrMedications = [] as any;
                for (let item of _data["phrMedications"])
                    this.phrMedications!.push(PHRMedication.fromJS(item));
            }
            this.itemNumber = _data["itemNumber"];
            this.faxSourceEnum = _data["faxSourceEnum"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.deliveryItemTaskItemTypeName = _data["deliveryItemTaskItemTypeName"];
            this.customerProvinceState = _data["customerProvinceState"] ? ProvinceState.fromJS(_data["customerProvinceState"]) : <any>undefined;
            this.customerCityTown = _data["customerCityTown"] ? CityTown.fromJS(_data["customerCityTown"]) : <any>undefined;
            this.taskItem = _data["taskItem"] ? TaskItem.fromJS(_data["taskItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientPrescription {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPrescriptionID"] = this.patientPrescriptionID;
        data["patientID"] = this.patientID;
        data["prescriptionDate"] = this.prescriptionDate ? this.prescriptionDate.toISOString() : <any>undefined;
        data["prescriptionStatusEnum"] = this.prescriptionStatusEnum;
        data["providerID"] = this.providerID;
        data["phrDocumentID"] = this.phrDocumentID;
        data["notes"] = this.notes;
        data["addSignature"] = this.addSignature;
        data["generateDocumentStateEnum"] = this.generateDocumentStateEnum;
        data["sendToEnum"] = this.sendToEnum;
        data["sendToID"] = this.sendToID;
        data["sendSubject"] = this.sendSubject;
        data["sendMessage"] = this.sendMessage;
        data["sendCopyToPatient"] = this.sendCopyToPatient;
        data["qrCode"] = this.qrCode;
        data["phrConsultID"] = this.phrConsultID;
        data["storeID"] = this.storeID;
        data["invoiceID"] = this.invoiceID;
        data["totalAmount"] = this.totalAmount;
        data["declinedDate"] = this.declinedDate ? this.declinedDate.toISOString() : <any>undefined;
        data["declinedReason"] = this.declinedReason;
        data["faxID"] = this.faxID;
        data["customerName"] = this.customerName;
        data["customerEmailAddress"] = this.customerEmailAddress;
        data["customerAddressLine1"] = this.customerAddressLine1;
        data["customerAddressLine2"] = this.customerAddressLine2;
        data["customerCity"] = this.customerCity;
        data["customerCityTownID"] = this.customerCityTownID;
        data["customerProvince"] = this.customerProvince;
        data["customerProvinceStateID"] = this.customerProvinceStateID;
        data["customerPostCode"] = this.customerPostCode;
        data["customerCountry"] = this.customerCountry;
        data["customerPhone"] = this.customerPhone;
        data["countryID"] = this.countryID;
        data["taskItemID"] = this.taskItemID;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["createdByUserDetail"] = this.createdByUserDetail ? this.createdByUserDetail.toJSON() : <any>undefined;
        data["updatedByUserDetail"] = this.updatedByUserDetail ? this.updatedByUserDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.phrMedications)) {
            data["phrMedications"] = [];
            for (let item of this.phrMedications)
                data["phrMedications"].push(item.toJSON());
        }
        data["itemNumber"] = this.itemNumber;
        data["faxSourceEnum"] = this.faxSourceEnum;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["deliveryItemTaskItemTypeName"] = this.deliveryItemTaskItemTypeName;
        data["customerProvinceState"] = this.customerProvinceState ? this.customerProvinceState.toJSON() : <any>undefined;
        data["customerCityTown"] = this.customerCityTown ? this.customerCityTown.toJSON() : <any>undefined;
        data["taskItem"] = this.taskItem ? this.taskItem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientPrescription extends IEntityBase {
    patientPrescriptionID: string;
    patientID: string;
    prescriptionDate: Date;
    prescriptionStatusEnum: PrescriptionStatusEnum;
    providerID?: string | undefined;
    phrDocumentID?: string | undefined;
    notes?: string | undefined;
    addSignature: boolean;
    generateDocumentStateEnum: GenerateDocumentStateEnum;
    sendToEnum: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient: boolean;
    qrCode: number;
    phrConsultID?: string | undefined;
    storeID?: string | undefined;
    invoiceID?: string | undefined;
    totalAmount?: number | undefined;
    declinedDate?: Date | undefined;
    declinedReason?: string | undefined;
    faxID?: string | undefined;
    customerName?: string | undefined;
    customerEmailAddress?: string | undefined;
    customerAddressLine1?: string | undefined;
    customerAddressLine2?: string | undefined;
    customerCity?: string | undefined;
    customerCityTownID?: string | undefined;
    customerProvince?: string | undefined;
    customerProvinceStateID?: string | undefined;
    customerPostCode?: string | undefined;
    customerCountry?: string | undefined;
    customerPhone?: string | undefined;
    countryID: string;
    taskItemID?: string | undefined;
    patient?: Patient | undefined;
    provider?: Provider | undefined;
    store?: Store | undefined;
    createdByUserDetail?: UserDetail | undefined;
    updatedByUserDetail?: UserDetail | undefined;
    phrMedications?: PHRMedication[] | undefined;
    itemNumber?: number;
    faxSourceEnum?: FaxSourceEnum;
    country?: Country | undefined;
    invoice?: Invoice | undefined;
    deliveryItemTaskItemTypeName?: string | undefined;
    customerProvinceState?: ProvinceState | undefined;
    customerCityTown?: CityTown | undefined;
    taskItem?: TaskItem | undefined;
}

export enum PrescriptionStatusEnum {
    Draft = "Draft",
    Pending = "Pending",
    Processing = "Processing",
    Completed = "Completed",
    Declined = "Declined",
}

export enum GenerateDocumentStateEnum {
    NotSet = "NotSet",
    Generated = "Generated",
    Sent = "Sent",
}

export enum SendToEnum {
    DoNotSend = "DoNotSend",
    UserDetail = "UserDetail",
    Store = "Store",
    Fax = "Fax",
    ExternalEmail = "ExternalEmail",
    AddressBookFax = "AddressBookFax",
}

export abstract class PHRBase extends EntityBase implements IPHRBase {
    createdByName?: string | undefined;
    updatedByName?: string | undefined;

    constructor(data?: IPHRBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.createdByName = _data["createdByName"];
            this.updatedByName = _data["updatedByName"];
        }
    }

    static fromJS(data: any): PHRBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PHRBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdByName"] = this.createdByName;
        data["updatedByName"] = this.updatedByName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRBase extends IEntityBase {
    createdByName?: string | undefined;
    updatedByName?: string | undefined;
}

export class PHRMedication extends PHRBase implements IPHRMedication {
    phrMedicationID!: string;
    patientID!: string;
    medicationID?: string | undefined;
    prescriptionStatusEnum!: PrescriptionStatusEnum;
    name!: string;
    dosage?: string | undefined;
    form?: string | undefined;
    quantity?: string | undefined;
    quantityPerDose?: string | undefined;
    packageQuantity?: number | undefined;
    prn?: boolean | undefined;
    frequency?: string | undefined;
    methodOfIntake?: string | undefined;
    timeOfDay?: string | undefined;
    refills?: number | undefined;
    startDate!: Date;
    endDate?: Date | undefined;
    reminder?: boolean | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    durationInDays?: number | undefined;
    durationTypeEnum?: DurationTypeEnum | undefined;
    durationCount?: number | undefined;
    patientPrescriptionID?: string | undefined;
    instructions?: string | undefined;
    dispensingInstructions?: string | undefined;
    storeItemID?: string | undefined;
    totalAmount?: number | undefined;
    refillForPHRMedicationID?: string | undefined;
    discontinuedDate?: Date | undefined;
    discontinuedUserDetailID?: string | undefined;
    discontinuedReason?: string | undefined;
    isHeadMedication!: boolean;
    declinedDate?: Date | undefined;
    declinedReason?: string | undefined;
    prnReason?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    phrMedicationReminders?: PHRMedicationReminder[] | undefined;
    verifiedByProviderName?: string | undefined;
    discontinuedProviderName?: string | undefined;
    prescriptionProviderName?: string | undefined;
    prescriptionDate?: Date;
    qrCode?: number;

    constructor(data?: IPHRMedication) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrMedicationID = _data["phrMedicationID"];
            this.patientID = _data["patientID"];
            this.medicationID = _data["medicationID"];
            this.prescriptionStatusEnum = _data["prescriptionStatusEnum"];
            this.name = _data["name"];
            this.dosage = _data["dosage"];
            this.form = _data["form"];
            this.quantity = _data["quantity"];
            this.quantityPerDose = _data["quantityPerDose"];
            this.packageQuantity = _data["packageQuantity"];
            this.prn = _data["prn"];
            this.frequency = _data["frequency"];
            this.methodOfIntake = _data["methodOfIntake"];
            this.timeOfDay = _data["timeOfDay"];
            this.refills = _data["refills"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.reminder = _data["reminder"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.durationInDays = _data["durationInDays"];
            this.durationTypeEnum = _data["durationTypeEnum"];
            this.durationCount = _data["durationCount"];
            this.patientPrescriptionID = _data["patientPrescriptionID"];
            this.instructions = _data["instructions"];
            this.dispensingInstructions = _data["dispensingInstructions"];
            this.storeItemID = _data["storeItemID"];
            this.totalAmount = _data["totalAmount"];
            this.refillForPHRMedicationID = _data["refillForPHRMedicationID"];
            this.discontinuedDate = _data["discontinuedDate"] ? new Date(_data["discontinuedDate"].toString()) : <any>undefined;
            this.discontinuedUserDetailID = _data["discontinuedUserDetailID"];
            this.discontinuedReason = _data["discontinuedReason"];
            this.isHeadMedication = _data["isHeadMedication"];
            this.declinedDate = _data["declinedDate"] ? new Date(_data["declinedDate"].toString()) : <any>undefined;
            this.declinedReason = _data["declinedReason"];
            this.prnReason = _data["prnReason"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            if (Array.isArray(_data["phrMedicationReminders"])) {
                this.phrMedicationReminders = [] as any;
                for (let item of _data["phrMedicationReminders"])
                    this.phrMedicationReminders!.push(PHRMedicationReminder.fromJS(item));
            }
            this.verifiedByProviderName = _data["verifiedByProviderName"];
            this.discontinuedProviderName = _data["discontinuedProviderName"];
            this.prescriptionProviderName = _data["prescriptionProviderName"];
            this.prescriptionDate = _data["prescriptionDate"] ? new Date(_data["prescriptionDate"].toString()) : <any>undefined;
            this.qrCode = _data["qrCode"];
        }
    }

    static fromJS(data: any): PHRMedication {
        data = typeof data === 'object' ? data : {};
        let result = new PHRMedication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrMedicationID"] = this.phrMedicationID;
        data["patientID"] = this.patientID;
        data["medicationID"] = this.medicationID;
        data["prescriptionStatusEnum"] = this.prescriptionStatusEnum;
        data["name"] = this.name;
        data["dosage"] = this.dosage;
        data["form"] = this.form;
        data["quantity"] = this.quantity;
        data["quantityPerDose"] = this.quantityPerDose;
        data["packageQuantity"] = this.packageQuantity;
        data["prn"] = this.prn;
        data["frequency"] = this.frequency;
        data["methodOfIntake"] = this.methodOfIntake;
        data["timeOfDay"] = this.timeOfDay;
        data["refills"] = this.refills;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["reminder"] = this.reminder;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["durationInDays"] = this.durationInDays;
        data["durationTypeEnum"] = this.durationTypeEnum;
        data["durationCount"] = this.durationCount;
        data["patientPrescriptionID"] = this.patientPrescriptionID;
        data["instructions"] = this.instructions;
        data["dispensingInstructions"] = this.dispensingInstructions;
        data["storeItemID"] = this.storeItemID;
        data["totalAmount"] = this.totalAmount;
        data["refillForPHRMedicationID"] = this.refillForPHRMedicationID;
        data["discontinuedDate"] = this.discontinuedDate ? this.discontinuedDate.toISOString() : <any>undefined;
        data["discontinuedUserDetailID"] = this.discontinuedUserDetailID;
        data["discontinuedReason"] = this.discontinuedReason;
        data["isHeadMedication"] = this.isHeadMedication;
        data["declinedDate"] = this.declinedDate ? this.declinedDate.toISOString() : <any>undefined;
        data["declinedReason"] = this.declinedReason;
        data["prnReason"] = this.prnReason;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        if (Array.isArray(this.phrMedicationReminders)) {
            data["phrMedicationReminders"] = [];
            for (let item of this.phrMedicationReminders)
                data["phrMedicationReminders"].push(item.toJSON());
        }
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        data["discontinuedProviderName"] = this.discontinuedProviderName;
        data["prescriptionProviderName"] = this.prescriptionProviderName;
        data["prescriptionDate"] = this.prescriptionDate ? this.prescriptionDate.toISOString() : <any>undefined;
        data["qrCode"] = this.qrCode;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRMedication extends IPHRBase {
    phrMedicationID: string;
    patientID: string;
    medicationID?: string | undefined;
    prescriptionStatusEnum: PrescriptionStatusEnum;
    name: string;
    dosage?: string | undefined;
    form?: string | undefined;
    quantity?: string | undefined;
    quantityPerDose?: string | undefined;
    packageQuantity?: number | undefined;
    prn?: boolean | undefined;
    frequency?: string | undefined;
    methodOfIntake?: string | undefined;
    timeOfDay?: string | undefined;
    refills?: number | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    reminder?: boolean | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    durationInDays?: number | undefined;
    durationTypeEnum?: DurationTypeEnum | undefined;
    durationCount?: number | undefined;
    patientPrescriptionID?: string | undefined;
    instructions?: string | undefined;
    dispensingInstructions?: string | undefined;
    storeItemID?: string | undefined;
    totalAmount?: number | undefined;
    refillForPHRMedicationID?: string | undefined;
    discontinuedDate?: Date | undefined;
    discontinuedUserDetailID?: string | undefined;
    discontinuedReason?: string | undefined;
    isHeadMedication: boolean;
    declinedDate?: Date | undefined;
    declinedReason?: string | undefined;
    prnReason?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    phrMedicationReminders?: PHRMedicationReminder[] | undefined;
    verifiedByProviderName?: string | undefined;
    discontinuedProviderName?: string | undefined;
    prescriptionProviderName?: string | undefined;
    prescriptionDate?: Date;
    qrCode?: number;
}

export enum DurationTypeEnum {
    Days = "Days",
    Weeks = "Weeks",
    Months = "Months",
    Years = "Years",
}

export class PHRPatient extends PHRBase implements IPHRPatient {
    patientID!: string;
    bloodTypeEnum?: BloodTypeEnum | undefined;
    birthDate?: Date | undefined;
    bloodNotes?: string | undefined;
    adopted!: boolean;
    epiPen?: boolean | undefined;
    covidVaccinated?: boolean | undefined;
    covidVaccinationReason?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrAdvancedCareDirectives?: PHRAdvancedCareDirective[] | undefined;
    phrAllergies?: PHRAllergy[] | undefined;
    phrCarePlans?: PHRCarePlan[] | undefined;
    phrClinicalTrials?: PHRClinicalTrial[] | undefined;
    phrConsults?: PHRConsult[] | undefined;
    phrDocuments?: PHRDocument[] | undefined;
    phrFamilyHistories?: PHRFamilyHistory[] | undefined;
    phrFunctionals?: PHRFunctional[] | undefined;
    phrHealthConditions?: PHRHealthCondition[] | undefined;
    phrHealthConditionTags?: PHRHealthConditionTags[] | undefined;
    phrHealthGoals?: PHRHealthGoal[] | undefined;
    phrHealthJournals?: PHRHealthJournal[] | undefined;
    phrHospitalVisits?: PHRHospitalVisit[] | undefined;
    phrMedicalEquipments?: PHRMedicalEquipment[] | undefined;
    phrMedicalHistories?: PHRMedicalHistory[] | undefined;
    phrMedications?: PHRMedication[] | undefined;
    phrNotes?: PHRNote[] | undefined;
    phrPregnancies?: PHRPregnancy[] | undefined;
    phrOrderDetails?: PHROrderDetail[] | undefined;
    phrSocialHistories?: PHRSocialHistory[] | undefined;
    phrSurgeryHistories?: PHRSurgeryHistory[] | undefined;
    phrTrackers?: PHRTracker[] | undefined;
    phrVaccinations?: PHRVaccination[] | undefined;
    phrWomenHealths?: PHRWomenHealth[] | undefined;
    phrForm?: PHRForm[] | undefined;
    phrTrackerDetails?: PHRTrackerDetail[] | undefined;

    constructor(data?: IPHRPatient) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientID = _data["patientID"];
            this.bloodTypeEnum = _data["bloodTypeEnum"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.bloodNotes = _data["bloodNotes"];
            this.adopted = _data["adopted"];
            this.epiPen = _data["epiPen"];
            this.covidVaccinated = _data["covidVaccinated"];
            this.covidVaccinationReason = _data["covidVaccinationReason"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            if (Array.isArray(_data["phrAdvancedCareDirectives"])) {
                this.phrAdvancedCareDirectives = [] as any;
                for (let item of _data["phrAdvancedCareDirectives"])
                    this.phrAdvancedCareDirectives!.push(PHRAdvancedCareDirective.fromJS(item));
            }
            if (Array.isArray(_data["phrAllergies"])) {
                this.phrAllergies = [] as any;
                for (let item of _data["phrAllergies"])
                    this.phrAllergies!.push(PHRAllergy.fromJS(item));
            }
            if (Array.isArray(_data["phrCarePlans"])) {
                this.phrCarePlans = [] as any;
                for (let item of _data["phrCarePlans"])
                    this.phrCarePlans!.push(PHRCarePlan.fromJS(item));
            }
            if (Array.isArray(_data["phrClinicalTrials"])) {
                this.phrClinicalTrials = [] as any;
                for (let item of _data["phrClinicalTrials"])
                    this.phrClinicalTrials!.push(PHRClinicalTrial.fromJS(item));
            }
            if (Array.isArray(_data["phrConsults"])) {
                this.phrConsults = [] as any;
                for (let item of _data["phrConsults"])
                    this.phrConsults!.push(PHRConsult.fromJS(item));
            }
            if (Array.isArray(_data["phrDocuments"])) {
                this.phrDocuments = [] as any;
                for (let item of _data["phrDocuments"])
                    this.phrDocuments!.push(PHRDocument.fromJS(item));
            }
            if (Array.isArray(_data["phrFamilyHistories"])) {
                this.phrFamilyHistories = [] as any;
                for (let item of _data["phrFamilyHistories"])
                    this.phrFamilyHistories!.push(PHRFamilyHistory.fromJS(item));
            }
            if (Array.isArray(_data["phrFunctionals"])) {
                this.phrFunctionals = [] as any;
                for (let item of _data["phrFunctionals"])
                    this.phrFunctionals!.push(PHRFunctional.fromJS(item));
            }
            if (Array.isArray(_data["phrHealthConditions"])) {
                this.phrHealthConditions = [] as any;
                for (let item of _data["phrHealthConditions"])
                    this.phrHealthConditions!.push(PHRHealthCondition.fromJS(item));
            }
            if (Array.isArray(_data["phrHealthConditionTags"])) {
                this.phrHealthConditionTags = [] as any;
                for (let item of _data["phrHealthConditionTags"])
                    this.phrHealthConditionTags!.push(PHRHealthConditionTags.fromJS(item));
            }
            if (Array.isArray(_data["phrHealthGoals"])) {
                this.phrHealthGoals = [] as any;
                for (let item of _data["phrHealthGoals"])
                    this.phrHealthGoals!.push(PHRHealthGoal.fromJS(item));
            }
            if (Array.isArray(_data["phrHealthJournals"])) {
                this.phrHealthJournals = [] as any;
                for (let item of _data["phrHealthJournals"])
                    this.phrHealthJournals!.push(PHRHealthJournal.fromJS(item));
            }
            if (Array.isArray(_data["phrHospitalVisits"])) {
                this.phrHospitalVisits = [] as any;
                for (let item of _data["phrHospitalVisits"])
                    this.phrHospitalVisits!.push(PHRHospitalVisit.fromJS(item));
            }
            if (Array.isArray(_data["phrMedicalEquipments"])) {
                this.phrMedicalEquipments = [] as any;
                for (let item of _data["phrMedicalEquipments"])
                    this.phrMedicalEquipments!.push(PHRMedicalEquipment.fromJS(item));
            }
            if (Array.isArray(_data["phrMedicalHistories"])) {
                this.phrMedicalHistories = [] as any;
                for (let item of _data["phrMedicalHistories"])
                    this.phrMedicalHistories!.push(PHRMedicalHistory.fromJS(item));
            }
            if (Array.isArray(_data["phrMedications"])) {
                this.phrMedications = [] as any;
                for (let item of _data["phrMedications"])
                    this.phrMedications!.push(PHRMedication.fromJS(item));
            }
            if (Array.isArray(_data["phrNotes"])) {
                this.phrNotes = [] as any;
                for (let item of _data["phrNotes"])
                    this.phrNotes!.push(PHRNote.fromJS(item));
            }
            if (Array.isArray(_data["phrPregnancies"])) {
                this.phrPregnancies = [] as any;
                for (let item of _data["phrPregnancies"])
                    this.phrPregnancies!.push(PHRPregnancy.fromJS(item));
            }
            if (Array.isArray(_data["phrOrderDetails"])) {
                this.phrOrderDetails = [] as any;
                for (let item of _data["phrOrderDetails"])
                    this.phrOrderDetails!.push(PHROrderDetail.fromJS(item));
            }
            if (Array.isArray(_data["phrSocialHistories"])) {
                this.phrSocialHistories = [] as any;
                for (let item of _data["phrSocialHistories"])
                    this.phrSocialHistories!.push(PHRSocialHistory.fromJS(item));
            }
            if (Array.isArray(_data["phrSurgeryHistories"])) {
                this.phrSurgeryHistories = [] as any;
                for (let item of _data["phrSurgeryHistories"])
                    this.phrSurgeryHistories!.push(PHRSurgeryHistory.fromJS(item));
            }
            if (Array.isArray(_data["phrTrackers"])) {
                this.phrTrackers = [] as any;
                for (let item of _data["phrTrackers"])
                    this.phrTrackers!.push(PHRTracker.fromJS(item));
            }
            if (Array.isArray(_data["phrVaccinations"])) {
                this.phrVaccinations = [] as any;
                for (let item of _data["phrVaccinations"])
                    this.phrVaccinations!.push(PHRVaccination.fromJS(item));
            }
            if (Array.isArray(_data["phrWomenHealths"])) {
                this.phrWomenHealths = [] as any;
                for (let item of _data["phrWomenHealths"])
                    this.phrWomenHealths!.push(PHRWomenHealth.fromJS(item));
            }
            if (Array.isArray(_data["phrForm"])) {
                this.phrForm = [] as any;
                for (let item of _data["phrForm"])
                    this.phrForm!.push(PHRForm.fromJS(item));
            }
            if (Array.isArray(_data["phrTrackerDetails"])) {
                this.phrTrackerDetails = [] as any;
                for (let item of _data["phrTrackerDetails"])
                    this.phrTrackerDetails!.push(PHRTrackerDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PHRPatient {
        data = typeof data === 'object' ? data : {};
        let result = new PHRPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["bloodTypeEnum"] = this.bloodTypeEnum;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["bloodNotes"] = this.bloodNotes;
        data["adopted"] = this.adopted;
        data["epiPen"] = this.epiPen;
        data["covidVaccinated"] = this.covidVaccinated;
        data["covidVaccinationReason"] = this.covidVaccinationReason;
        data["phrAccessRequested"] = this.phrAccessRequested;
        if (Array.isArray(this.phrAdvancedCareDirectives)) {
            data["phrAdvancedCareDirectives"] = [];
            for (let item of this.phrAdvancedCareDirectives)
                data["phrAdvancedCareDirectives"].push(item.toJSON());
        }
        if (Array.isArray(this.phrAllergies)) {
            data["phrAllergies"] = [];
            for (let item of this.phrAllergies)
                data["phrAllergies"].push(item.toJSON());
        }
        if (Array.isArray(this.phrCarePlans)) {
            data["phrCarePlans"] = [];
            for (let item of this.phrCarePlans)
                data["phrCarePlans"].push(item.toJSON());
        }
        if (Array.isArray(this.phrClinicalTrials)) {
            data["phrClinicalTrials"] = [];
            for (let item of this.phrClinicalTrials)
                data["phrClinicalTrials"].push(item.toJSON());
        }
        if (Array.isArray(this.phrConsults)) {
            data["phrConsults"] = [];
            for (let item of this.phrConsults)
                data["phrConsults"].push(item.toJSON());
        }
        if (Array.isArray(this.phrDocuments)) {
            data["phrDocuments"] = [];
            for (let item of this.phrDocuments)
                data["phrDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.phrFamilyHistories)) {
            data["phrFamilyHistories"] = [];
            for (let item of this.phrFamilyHistories)
                data["phrFamilyHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.phrFunctionals)) {
            data["phrFunctionals"] = [];
            for (let item of this.phrFunctionals)
                data["phrFunctionals"].push(item.toJSON());
        }
        if (Array.isArray(this.phrHealthConditions)) {
            data["phrHealthConditions"] = [];
            for (let item of this.phrHealthConditions)
                data["phrHealthConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.phrHealthConditionTags)) {
            data["phrHealthConditionTags"] = [];
            for (let item of this.phrHealthConditionTags)
                data["phrHealthConditionTags"].push(item.toJSON());
        }
        if (Array.isArray(this.phrHealthGoals)) {
            data["phrHealthGoals"] = [];
            for (let item of this.phrHealthGoals)
                data["phrHealthGoals"].push(item.toJSON());
        }
        if (Array.isArray(this.phrHealthJournals)) {
            data["phrHealthJournals"] = [];
            for (let item of this.phrHealthJournals)
                data["phrHealthJournals"].push(item.toJSON());
        }
        if (Array.isArray(this.phrHospitalVisits)) {
            data["phrHospitalVisits"] = [];
            for (let item of this.phrHospitalVisits)
                data["phrHospitalVisits"].push(item.toJSON());
        }
        if (Array.isArray(this.phrMedicalEquipments)) {
            data["phrMedicalEquipments"] = [];
            for (let item of this.phrMedicalEquipments)
                data["phrMedicalEquipments"].push(item.toJSON());
        }
        if (Array.isArray(this.phrMedicalHistories)) {
            data["phrMedicalHistories"] = [];
            for (let item of this.phrMedicalHistories)
                data["phrMedicalHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.phrMedications)) {
            data["phrMedications"] = [];
            for (let item of this.phrMedications)
                data["phrMedications"].push(item.toJSON());
        }
        if (Array.isArray(this.phrNotes)) {
            data["phrNotes"] = [];
            for (let item of this.phrNotes)
                data["phrNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.phrPregnancies)) {
            data["phrPregnancies"] = [];
            for (let item of this.phrPregnancies)
                data["phrPregnancies"].push(item.toJSON());
        }
        if (Array.isArray(this.phrOrderDetails)) {
            data["phrOrderDetails"] = [];
            for (let item of this.phrOrderDetails)
                data["phrOrderDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.phrSocialHistories)) {
            data["phrSocialHistories"] = [];
            for (let item of this.phrSocialHistories)
                data["phrSocialHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.phrSurgeryHistories)) {
            data["phrSurgeryHistories"] = [];
            for (let item of this.phrSurgeryHistories)
                data["phrSurgeryHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.phrTrackers)) {
            data["phrTrackers"] = [];
            for (let item of this.phrTrackers)
                data["phrTrackers"].push(item.toJSON());
        }
        if (Array.isArray(this.phrVaccinations)) {
            data["phrVaccinations"] = [];
            for (let item of this.phrVaccinations)
                data["phrVaccinations"].push(item.toJSON());
        }
        if (Array.isArray(this.phrWomenHealths)) {
            data["phrWomenHealths"] = [];
            for (let item of this.phrWomenHealths)
                data["phrWomenHealths"].push(item.toJSON());
        }
        if (Array.isArray(this.phrForm)) {
            data["phrForm"] = [];
            for (let item of this.phrForm)
                data["phrForm"].push(item.toJSON());
        }
        if (Array.isArray(this.phrTrackerDetails)) {
            data["phrTrackerDetails"] = [];
            for (let item of this.phrTrackerDetails)
                data["phrTrackerDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPHRPatient extends IPHRBase {
    patientID: string;
    bloodTypeEnum?: BloodTypeEnum | undefined;
    birthDate?: Date | undefined;
    bloodNotes?: string | undefined;
    adopted: boolean;
    epiPen?: boolean | undefined;
    covidVaccinated?: boolean | undefined;
    covidVaccinationReason?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrAdvancedCareDirectives?: PHRAdvancedCareDirective[] | undefined;
    phrAllergies?: PHRAllergy[] | undefined;
    phrCarePlans?: PHRCarePlan[] | undefined;
    phrClinicalTrials?: PHRClinicalTrial[] | undefined;
    phrConsults?: PHRConsult[] | undefined;
    phrDocuments?: PHRDocument[] | undefined;
    phrFamilyHistories?: PHRFamilyHistory[] | undefined;
    phrFunctionals?: PHRFunctional[] | undefined;
    phrHealthConditions?: PHRHealthCondition[] | undefined;
    phrHealthConditionTags?: PHRHealthConditionTags[] | undefined;
    phrHealthGoals?: PHRHealthGoal[] | undefined;
    phrHealthJournals?: PHRHealthJournal[] | undefined;
    phrHospitalVisits?: PHRHospitalVisit[] | undefined;
    phrMedicalEquipments?: PHRMedicalEquipment[] | undefined;
    phrMedicalHistories?: PHRMedicalHistory[] | undefined;
    phrMedications?: PHRMedication[] | undefined;
    phrNotes?: PHRNote[] | undefined;
    phrPregnancies?: PHRPregnancy[] | undefined;
    phrOrderDetails?: PHROrderDetail[] | undefined;
    phrSocialHistories?: PHRSocialHistory[] | undefined;
    phrSurgeryHistories?: PHRSurgeryHistory[] | undefined;
    phrTrackers?: PHRTracker[] | undefined;
    phrVaccinations?: PHRVaccination[] | undefined;
    phrWomenHealths?: PHRWomenHealth[] | undefined;
    phrForm?: PHRForm[] | undefined;
    phrTrackerDetails?: PHRTrackerDetail[] | undefined;
}

export enum BloodTypeEnum {
    Unknown = "Unknown",
    AB_Negative = "AB_Negative",
    AB_Positive = "AB_Positive",
    B_Negative = "B_Negative",
    B_Positive = "B_Positive",
    A_Negative = "A_Negative",
    A_Positive = "A_Positive",
    O_Negative = "O_Negative",
    O_Positive = "O_Positive",
}

export class PHRAdvancedCareDirective extends PHRBase implements IPHRAdvancedCareDirective {
    phrAdvancedCareDirectiveID!: string;
    patientID!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    completedDate?: Date | undefined;
    acceptedTC!: boolean;
    fileDetailID?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRAdvancedCareDirective) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrAdvancedCareDirectiveID = _data["phrAdvancedCareDirectiveID"];
            this.patientID = _data["patientID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.acceptedTC = _data["acceptedTC"];
            this.fileDetailID = _data["fileDetailID"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRAdvancedCareDirective {
        data = typeof data === 'object' ? data : {};
        let result = new PHRAdvancedCareDirective();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrAdvancedCareDirectiveID"] = this.phrAdvancedCareDirectiveID;
        data["patientID"] = this.patientID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["acceptedTC"] = this.acceptedTC;
        data["fileDetailID"] = this.fileDetailID;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRAdvancedCareDirective extends IPHRBase {
    phrAdvancedCareDirectiveID: string;
    patientID: string;
    startDate: Date;
    endDate?: Date | undefined;
    completedDate?: Date | undefined;
    acceptedTC: boolean;
    fileDetailID?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;
}

export class PHRAllergy extends PHRBase implements IPHRAllergy {
    phrAllergyID!: string;
    patientID!: string;
    allergyTagID?: string | undefined;
    otherName?: string | undefined;
    allergySeverityEnum!: AllergySeverityEnum;
    notes?: string | undefined;
    otherReaction?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrAllergyTags?: PHRAllergyTag[] | undefined;
    allergyTag?: Tag | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRAllergy) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrAllergyID = _data["phrAllergyID"];
            this.patientID = _data["patientID"];
            this.allergyTagID = _data["allergyTagID"];
            this.otherName = _data["otherName"];
            this.allergySeverityEnum = _data["allergySeverityEnum"];
            this.notes = _data["notes"];
            this.otherReaction = _data["otherReaction"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.phrAccessRequested = _data["phrAccessRequested"];
            if (Array.isArray(_data["phrAllergyTags"])) {
                this.phrAllergyTags = [] as any;
                for (let item of _data["phrAllergyTags"])
                    this.phrAllergyTags!.push(PHRAllergyTag.fromJS(item));
            }
            this.allergyTag = _data["allergyTag"] ? Tag.fromJS(_data["allergyTag"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRAllergy {
        data = typeof data === 'object' ? data : {};
        let result = new PHRAllergy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrAllergyID"] = this.phrAllergyID;
        data["patientID"] = this.patientID;
        data["allergyTagID"] = this.allergyTagID;
        data["otherName"] = this.otherName;
        data["allergySeverityEnum"] = this.allergySeverityEnum;
        data["notes"] = this.notes;
        data["otherReaction"] = this.otherReaction;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["phrAccessRequested"] = this.phrAccessRequested;
        if (Array.isArray(this.phrAllergyTags)) {
            data["phrAllergyTags"] = [];
            for (let item of this.phrAllergyTags)
                data["phrAllergyTags"].push(item.toJSON());
        }
        data["allergyTag"] = this.allergyTag ? this.allergyTag.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRAllergy extends IPHRBase {
    phrAllergyID: string;
    patientID: string;
    allergyTagID?: string | undefined;
    otherName?: string | undefined;
    allergySeverityEnum: AllergySeverityEnum;
    notes?: string | undefined;
    otherReaction?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrAllergyTags?: PHRAllergyTag[] | undefined;
    allergyTag?: Tag | undefined;
    verifiedByProviderName?: string | undefined;
}

export enum AllergySeverityEnum {
    Mild = "Mild",
    Moderate = "Moderate",
    Severe = "Severe",
}

export class PHRAllergyTag extends PHRBase implements IPHRAllergyTag {
    phrAllergyTagID!: string;
    phrAllergyID!: string;
    tagID!: string;
    phrAccessRequested?: PatientAccessEnum;
    phrAllergy?: PHRAllergy | undefined;
    tag?: Tag | undefined;
    patientID?: string;

    constructor(data?: IPHRAllergyTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrAllergyTagID = _data["phrAllergyTagID"];
            this.phrAllergyID = _data["phrAllergyID"];
            this.tagID = _data["tagID"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrAllergy = _data["phrAllergy"] ? PHRAllergy.fromJS(_data["phrAllergy"]) : <any>undefined;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.patientID = _data["patientID"];
        }
    }

    static fromJS(data: any): PHRAllergyTag {
        data = typeof data === 'object' ? data : {};
        let result = new PHRAllergyTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrAllergyTagID"] = this.phrAllergyTagID;
        data["phrAllergyID"] = this.phrAllergyID;
        data["tagID"] = this.tagID;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrAllergy"] = this.phrAllergy ? this.phrAllergy.toJSON() : <any>undefined;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["patientID"] = this.patientID;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRAllergyTag extends IPHRBase {
    phrAllergyTagID: string;
    phrAllergyID: string;
    tagID: string;
    phrAccessRequested?: PatientAccessEnum;
    phrAllergy?: PHRAllergy | undefined;
    tag?: Tag | undefined;
    patientID?: string;
}

export class Tag extends EntityBase implements ITag {
    tagID!: string;
    tagTypeEnum!: TagTypeEnum;
    name!: string;
    description!: string;
    externalID?: string | undefined;
    rank!: number;
    imageURL?: string | undefined;
    color?: string | undefined;
    showInCountryIDs?: string | undefined;
    tagXrefs?: TagXref[] | undefined;

    constructor(data?: ITag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagID = _data["tagID"];
            this.tagTypeEnum = _data["tagTypeEnum"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.externalID = _data["externalID"];
            this.rank = _data["rank"];
            this.imageURL = _data["imageURL"];
            this.color = _data["color"];
            this.showInCountryIDs = _data["showInCountryIDs"];
            if (Array.isArray(_data["tagXrefs"])) {
                this.tagXrefs = [] as any;
                for (let item of _data["tagXrefs"])
                    this.tagXrefs!.push(TagXref.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagID"] = this.tagID;
        data["tagTypeEnum"] = this.tagTypeEnum;
        data["name"] = this.name;
        data["description"] = this.description;
        data["externalID"] = this.externalID;
        data["rank"] = this.rank;
        data["imageURL"] = this.imageURL;
        data["color"] = this.color;
        data["showInCountryIDs"] = this.showInCountryIDs;
        if (Array.isArray(this.tagXrefs)) {
            data["tagXrefs"] = [];
            for (let item of this.tagXrefs)
                data["tagXrefs"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITag extends IEntityBase {
    tagID: string;
    tagTypeEnum: TagTypeEnum;
    name: string;
    description: string;
    externalID?: string | undefined;
    rank: number;
    imageURL?: string | undefined;
    color?: string | undefined;
    showInCountryIDs?: string | undefined;
    tagXrefs?: TagXref[] | undefined;
}

export enum TagTypeEnum {
    Condition = "Condition",
    Specialties = "Specialties",
    Diagnosis = "Diagnosis",
    SymptomLevel1 = "SymptomLevel1",
    SymptomLevel2 = "SymptomLevel2",
    SymptomLevel3 = "SymptomLevel3",
    CareType = "CareType",
    Allergy = "Allergy",
    AllergyReaction = "AllergyReaction",
    ProviderType = "ProviderType",
    MoodTracker = "MoodTracker",
    MoodTrackerValues = "MoodTrackerValues",
    StressTracker = "StressTracker",
    StressTrackerValues = "StressTrackerValues",
    AnxietyTracker = "AnxietyTracker",
    AnxietyTrackerValues = "AnxietyTrackerValues",
    SpokenLanguage = "SpokenLanguage",
    DocumentType = "DocumentType",
    FacilityRole = "FacilityRole",
    FacilitySpecialization = "FacilitySpecialization",
    License = "License",
    NumberOfBeds = "NumberOfBeds",
    LicenseCountry = "LicenseCountry",
    VaccineManufacturer = "VaccineManufacturer",
    CovidTestType = "CovidTestType",
    CovidTestBrandType = "CovidTestBrandType",
    HomeCareService = "HomeCareService",
    SleepTracker = "SleepTracker",
    SupportType = "SupportType",
    Discussions = "Discussions",
    DiscussionItems = "DiscussionItems",
    Livestreams = "Livestreams",
    Others = "Others",
    CareFund = "CareFund",
}

export class TagXref extends EntityBase implements ITagXref {
    tagXrefID!: string;
    tagID!: string;
    toTagID!: string;
    tag?: Tag | undefined;
    toTag?: Tag | undefined;

    constructor(data?: ITagXref) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tagXrefID = _data["tagXrefID"];
            this.tagID = _data["tagID"];
            this.toTagID = _data["toTagID"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.toTag = _data["toTag"] ? Tag.fromJS(_data["toTag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TagXref {
        data = typeof data === 'object' ? data : {};
        let result = new TagXref();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagXrefID"] = this.tagXrefID;
        data["tagID"] = this.tagID;
        data["toTagID"] = this.toTagID;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["toTag"] = this.toTag ? this.toTag.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITagXref extends IEntityBase {
    tagXrefID: string;
    tagID: string;
    toTagID: string;
    tag?: Tag | undefined;
    toTag?: Tag | undefined;
}

export class PHRCarePlan extends PHRBase implements IPHRCarePlan {
    phrCarePlanID!: string;
    patientID!: string;
    followUp!: string;
    dueDate!: Date;
    completedDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRCarePlan) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrCarePlanID = _data["phrCarePlanID"];
            this.patientID = _data["patientID"];
            this.followUp = _data["followUp"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRCarePlan {
        data = typeof data === 'object' ? data : {};
        let result = new PHRCarePlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrCarePlanID"] = this.phrCarePlanID;
        data["patientID"] = this.patientID;
        data["followUp"] = this.followUp;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRCarePlan extends IPHRBase {
    phrCarePlanID: string;
    patientID: string;
    followUp: string;
    dueDate: Date;
    completedDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;
}

export class PHRClinicalTrial extends PHRBase implements IPHRClinicalTrial {
    phrClinicalTrialID!: string;
    patientID!: string;
    clinicalTrialID!: string;
    patientRequestedDate!: Date;
    preferredStudyLocation?: string | undefined;
    diagnosis?: string | undefined;
    additionalDetails?: string | undefined;
    consent!: boolean;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRClinicalTrial) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrClinicalTrialID = _data["phrClinicalTrialID"];
            this.patientID = _data["patientID"];
            this.clinicalTrialID = _data["clinicalTrialID"];
            this.patientRequestedDate = _data["patientRequestedDate"] ? new Date(_data["patientRequestedDate"].toString()) : <any>undefined;
            this.preferredStudyLocation = _data["preferredStudyLocation"];
            this.diagnosis = _data["diagnosis"];
            this.additionalDetails = _data["additionalDetails"];
            this.consent = _data["consent"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRClinicalTrial {
        data = typeof data === 'object' ? data : {};
        let result = new PHRClinicalTrial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrClinicalTrialID"] = this.phrClinicalTrialID;
        data["patientID"] = this.patientID;
        data["clinicalTrialID"] = this.clinicalTrialID;
        data["patientRequestedDate"] = this.patientRequestedDate ? this.patientRequestedDate.toISOString() : <any>undefined;
        data["preferredStudyLocation"] = this.preferredStudyLocation;
        data["diagnosis"] = this.diagnosis;
        data["additionalDetails"] = this.additionalDetails;
        data["consent"] = this.consent;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRClinicalTrial extends IPHRBase {
    phrClinicalTrialID: string;
    patientID: string;
    clinicalTrialID: string;
    patientRequestedDate: Date;
    preferredStudyLocation?: string | undefined;
    diagnosis?: string | undefined;
    additionalDetails?: string | undefined;
    consent: boolean;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;
}

export class PHRConsult extends PHRBase implements IPHRConsult {
    phrConsultID!: string;
    patientID!: string;
    providerID?: string | undefined;
    consultID?: string | undefined;
    countryID?: string | undefined;
    complaint?: string | undefined;
    subjective?: string | undefined;
    objective?: string | undefined;
    diagnosis?: string | undefined;
    plan?: string | undefined;
    nurseNote?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    isAttested!: boolean;
    attestation?: string | undefined;
    attestationUserDetailID?: string | undefined;
    attestationDate?: Date | undefined;
    consultDate?: Date | undefined;
    isCancelled!: boolean;
    storeID!: string;
    patientCountryID?: string | undefined;
    sentToMyEMRDate?: Date | undefined;
    sentToMyFamilyProviderDate?: Date | undefined;
    billingCode?: string | undefined;
    historyOfPresentingComplaints?: string | undefined;
    patientFollowupInDays?: number | undefined;
    symptomDurationInDays?: number | undefined;
    careTypeTagID?: string | undefined;
    phrConsultTypeEnum!: PHRConsultTypeEnum;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    patient?: Patient | undefined;
    phrConsultTags?: PHRConsultTag[] | undefined;
    country?: Country | undefined;
    attestationProvider?: Provider | undefined;
    phrDocuments?: PHRDocument[] | undefined;
    phrNotes?: PHRNote[] | undefined;
    careTypeTag?: Tag | undefined;
    providerName?: string | undefined;
    verifiedByProviderName?: string | undefined;
    consult?: Consult | undefined;
    provider?: Provider | undefined;
    attestationUserDetail?: UserDetail | undefined;
    store?: Store | undefined;

    constructor(data?: IPHRConsult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrConsultID = _data["phrConsultID"];
            this.patientID = _data["patientID"];
            this.providerID = _data["providerID"];
            this.consultID = _data["consultID"];
            this.countryID = _data["countryID"];
            this.complaint = _data["complaint"];
            this.subjective = _data["subjective"];
            this.objective = _data["objective"];
            this.diagnosis = _data["diagnosis"];
            this.plan = _data["plan"];
            this.nurseNote = _data["nurseNote"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.isAttested = _data["isAttested"];
            this.attestation = _data["attestation"];
            this.attestationUserDetailID = _data["attestationUserDetailID"];
            this.attestationDate = _data["attestationDate"] ? new Date(_data["attestationDate"].toString()) : <any>undefined;
            this.consultDate = _data["consultDate"] ? new Date(_data["consultDate"].toString()) : <any>undefined;
            this.isCancelled = _data["isCancelled"];
            this.storeID = _data["storeID"];
            this.patientCountryID = _data["patientCountryID"];
            this.sentToMyEMRDate = _data["sentToMyEMRDate"] ? new Date(_data["sentToMyEMRDate"].toString()) : <any>undefined;
            this.sentToMyFamilyProviderDate = _data["sentToMyFamilyProviderDate"] ? new Date(_data["sentToMyFamilyProviderDate"].toString()) : <any>undefined;
            this.billingCode = _data["billingCode"];
            this.historyOfPresentingComplaints = _data["historyOfPresentingComplaints"];
            this.patientFollowupInDays = _data["patientFollowupInDays"];
            this.symptomDurationInDays = _data["symptomDurationInDays"];
            this.careTypeTagID = _data["careTypeTagID"];
            this.phrConsultTypeEnum = _data["phrConsultTypeEnum"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            if (Array.isArray(_data["phrConsultTags"])) {
                this.phrConsultTags = [] as any;
                for (let item of _data["phrConsultTags"])
                    this.phrConsultTags!.push(PHRConsultTag.fromJS(item));
            }
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.attestationProvider = _data["attestationProvider"] ? Provider.fromJS(_data["attestationProvider"]) : <any>undefined;
            if (Array.isArray(_data["phrDocuments"])) {
                this.phrDocuments = [] as any;
                for (let item of _data["phrDocuments"])
                    this.phrDocuments!.push(PHRDocument.fromJS(item));
            }
            if (Array.isArray(_data["phrNotes"])) {
                this.phrNotes = [] as any;
                for (let item of _data["phrNotes"])
                    this.phrNotes!.push(PHRNote.fromJS(item));
            }
            this.careTypeTag = _data["careTypeTag"] ? Tag.fromJS(_data["careTypeTag"]) : <any>undefined;
            this.providerName = _data["providerName"];
            this.verifiedByProviderName = _data["verifiedByProviderName"];
            this.consult = _data["consult"] ? Consult.fromJS(_data["consult"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.attestationUserDetail = _data["attestationUserDetail"] ? UserDetail.fromJS(_data["attestationUserDetail"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PHRConsult {
        data = typeof data === 'object' ? data : {};
        let result = new PHRConsult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrConsultID"] = this.phrConsultID;
        data["patientID"] = this.patientID;
        data["providerID"] = this.providerID;
        data["consultID"] = this.consultID;
        data["countryID"] = this.countryID;
        data["complaint"] = this.complaint;
        data["subjective"] = this.subjective;
        data["objective"] = this.objective;
        data["diagnosis"] = this.diagnosis;
        data["plan"] = this.plan;
        data["nurseNote"] = this.nurseNote;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["isAttested"] = this.isAttested;
        data["attestation"] = this.attestation;
        data["attestationUserDetailID"] = this.attestationUserDetailID;
        data["attestationDate"] = this.attestationDate ? this.attestationDate.toISOString() : <any>undefined;
        data["consultDate"] = this.consultDate ? this.consultDate.toISOString() : <any>undefined;
        data["isCancelled"] = this.isCancelled;
        data["storeID"] = this.storeID;
        data["patientCountryID"] = this.patientCountryID;
        data["sentToMyEMRDate"] = this.sentToMyEMRDate ? this.sentToMyEMRDate.toISOString() : <any>undefined;
        data["sentToMyFamilyProviderDate"] = this.sentToMyFamilyProviderDate ? this.sentToMyFamilyProviderDate.toISOString() : <any>undefined;
        data["billingCode"] = this.billingCode;
        data["historyOfPresentingComplaints"] = this.historyOfPresentingComplaints;
        data["patientFollowupInDays"] = this.patientFollowupInDays;
        data["symptomDurationInDays"] = this.symptomDurationInDays;
        data["careTypeTagID"] = this.careTypeTagID;
        data["phrConsultTypeEnum"] = this.phrConsultTypeEnum;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        if (Array.isArray(this.phrConsultTags)) {
            data["phrConsultTags"] = [];
            for (let item of this.phrConsultTags)
                data["phrConsultTags"].push(item.toJSON());
        }
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["attestationProvider"] = this.attestationProvider ? this.attestationProvider.toJSON() : <any>undefined;
        if (Array.isArray(this.phrDocuments)) {
            data["phrDocuments"] = [];
            for (let item of this.phrDocuments)
                data["phrDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.phrNotes)) {
            data["phrNotes"] = [];
            for (let item of this.phrNotes)
                data["phrNotes"].push(item.toJSON());
        }
        data["careTypeTag"] = this.careTypeTag ? this.careTypeTag.toJSON() : <any>undefined;
        data["providerName"] = this.providerName;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        data["consult"] = this.consult ? this.consult.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["attestationUserDetail"] = this.attestationUserDetail ? this.attestationUserDetail.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRConsult extends IPHRBase {
    phrConsultID: string;
    patientID: string;
    providerID?: string | undefined;
    consultID?: string | undefined;
    countryID?: string | undefined;
    complaint?: string | undefined;
    subjective?: string | undefined;
    objective?: string | undefined;
    diagnosis?: string | undefined;
    plan?: string | undefined;
    nurseNote?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    isAttested: boolean;
    attestation?: string | undefined;
    attestationUserDetailID?: string | undefined;
    attestationDate?: Date | undefined;
    consultDate?: Date | undefined;
    isCancelled: boolean;
    storeID: string;
    patientCountryID?: string | undefined;
    sentToMyEMRDate?: Date | undefined;
    sentToMyFamilyProviderDate?: Date | undefined;
    billingCode?: string | undefined;
    historyOfPresentingComplaints?: string | undefined;
    patientFollowupInDays?: number | undefined;
    symptomDurationInDays?: number | undefined;
    careTypeTagID?: string | undefined;
    phrConsultTypeEnum: PHRConsultTypeEnum;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    patient?: Patient | undefined;
    phrConsultTags?: PHRConsultTag[] | undefined;
    country?: Country | undefined;
    attestationProvider?: Provider | undefined;
    phrDocuments?: PHRDocument[] | undefined;
    phrNotes?: PHRNote[] | undefined;
    careTypeTag?: Tag | undefined;
    providerName?: string | undefined;
    verifiedByProviderName?: string | undefined;
    consult?: Consult | undefined;
    provider?: Provider | undefined;
    attestationUserDetail?: UserDetail | undefined;
    store?: Store | undefined;
}

export enum PHRConsultTypeEnum {
    SOAPNote = "SOAPNote",
    NurseNote = "NurseNote",
}

export class PHRConsultTag extends PHRBase implements IPHRConsultTag {
    phrConsultTagID!: string;
    phrConsultID!: string;
    consultTagTypeEnum!: ConsultTagTypeEnum;
    tagID!: string;
    phrAccessRequested?: PatientAccessEnum;
    phrConsult?: PHRConsult | undefined;
    tag?: Tag | undefined;
    patientID?: string;

    constructor(data?: IPHRConsultTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrConsultTagID = _data["phrConsultTagID"];
            this.phrConsultID = _data["phrConsultID"];
            this.consultTagTypeEnum = _data["consultTagTypeEnum"];
            this.tagID = _data["tagID"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrConsult = _data["phrConsult"] ? PHRConsult.fromJS(_data["phrConsult"]) : <any>undefined;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.patientID = _data["patientID"];
        }
    }

    static fromJS(data: any): PHRConsultTag {
        data = typeof data === 'object' ? data : {};
        let result = new PHRConsultTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrConsultTagID"] = this.phrConsultTagID;
        data["phrConsultID"] = this.phrConsultID;
        data["consultTagTypeEnum"] = this.consultTagTypeEnum;
        data["tagID"] = this.tagID;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrConsult"] = this.phrConsult ? this.phrConsult.toJSON() : <any>undefined;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["patientID"] = this.patientID;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRConsultTag extends IPHRBase {
    phrConsultTagID: string;
    phrConsultID: string;
    consultTagTypeEnum: ConsultTagTypeEnum;
    tagID: string;
    phrAccessRequested?: PatientAccessEnum;
    phrConsult?: PHRConsult | undefined;
    tag?: Tag | undefined;
    patientID?: string;
}

export enum ConsultTagTypeEnum {
    NotSet = "NotSet",
    Complaint = "Complaint",
    Subjective = "Subjective",
    Objective = "Objective",
    Plan = "Plan",
    Diagnosis = "Diagnosis",
    HomeCare = "HomeCare",
}

export class PHRDocument extends PHRBase implements IPHRDocument {
    phrDocumentID!: string;
    patientID!: string;
    notes?: string | undefined;
    phrDocumentCategoryEnum!: PHRDocumentCategoryEnum;
    fileDetailID!: string;
    phrConsultID?: string | undefined;
    phrHealthJournalID?: string | undefined;
    associatedID?: string | undefined;
    viewed!: boolean;
    documentTypeTagID?: string | undefined;
    documentDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    fileDetail?: FileDetail | undefined;
    phrConsult?: PHRConsult | undefined;
    documentTypeTag?: Tag | undefined;
    upsertDate?: Date;

    constructor(data?: IPHRDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrDocumentID = _data["phrDocumentID"];
            this.patientID = _data["patientID"];
            this.notes = _data["notes"];
            this.phrDocumentCategoryEnum = _data["phrDocumentCategoryEnum"];
            this.fileDetailID = _data["fileDetailID"];
            this.phrConsultID = _data["phrConsultID"];
            this.phrHealthJournalID = _data["phrHealthJournalID"];
            this.associatedID = _data["associatedID"];
            this.viewed = _data["viewed"];
            this.documentTypeTagID = _data["documentTypeTagID"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.fileDetail = _data["fileDetail"] ? FileDetail.fromJS(_data["fileDetail"]) : <any>undefined;
            this.phrConsult = _data["phrConsult"] ? PHRConsult.fromJS(_data["phrConsult"]) : <any>undefined;
            this.documentTypeTag = _data["documentTypeTag"] ? Tag.fromJS(_data["documentTypeTag"]) : <any>undefined;
            this.upsertDate = _data["upsertDate"] ? new Date(_data["upsertDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PHRDocument {
        data = typeof data === 'object' ? data : {};
        let result = new PHRDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrDocumentID"] = this.phrDocumentID;
        data["patientID"] = this.patientID;
        data["notes"] = this.notes;
        data["phrDocumentCategoryEnum"] = this.phrDocumentCategoryEnum;
        data["fileDetailID"] = this.fileDetailID;
        data["phrConsultID"] = this.phrConsultID;
        data["phrHealthJournalID"] = this.phrHealthJournalID;
        data["associatedID"] = this.associatedID;
        data["viewed"] = this.viewed;
        data["documentTypeTagID"] = this.documentTypeTagID;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["fileDetail"] = this.fileDetail ? this.fileDetail.toJSON() : <any>undefined;
        data["phrConsult"] = this.phrConsult ? this.phrConsult.toJSON() : <any>undefined;
        data["documentTypeTag"] = this.documentTypeTag ? this.documentTypeTag.toJSON() : <any>undefined;
        data["upsertDate"] = this.upsertDate ? this.upsertDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRDocument extends IPHRBase {
    phrDocumentID: string;
    patientID: string;
    notes?: string | undefined;
    phrDocumentCategoryEnum: PHRDocumentCategoryEnum;
    fileDetailID: string;
    phrConsultID?: string | undefined;
    phrHealthJournalID?: string | undefined;
    associatedID?: string | undefined;
    viewed: boolean;
    documentTypeTagID?: string | undefined;
    documentDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    fileDetail?: FileDetail | undefined;
    phrConsult?: PHRConsult | undefined;
    documentTypeTag?: Tag | undefined;
    upsertDate?: Date;
}

export enum PHRDocumentCategoryEnum {
    Other = "Document",
    Mail = "Mail",
    LabResult = "Lab Result",
    MedicalReport = "Medical Report",
    SickNote = "Note",
    PrescriptionNote = "Prescription",
    DisabilityForm = "Disability Form",
    Orders = "Orders",
    Archive = "Archive",
    CovidTest = "Covid Test",
}

export class PHRNote extends PHRBase implements IPHRNote {
    phrNoteID!: string;
    patientID!: string;
    noteTypeEnum!: NoteTypeEnum;
    visibilityEnum!: VisibilityEnum;
    notes?: string | undefined;
    addSignature!: boolean;
    generateDocumentStateEnum!: GenerateDocumentStateEnum;
    sendToEnum!: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient!: boolean;
    providerID?: string | undefined;
    faxID?: string | undefined;
    phrDocumentID?: string | undefined;
    phrConsultID?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    sendToUserDetail?: UserDetail | undefined;
    sendToName?: string | undefined;
    phrConsult?: PHRConsult | undefined;
    phrDocument?: PHRDocument | undefined;
    patient?: Patient | undefined;
    provider?: Provider | undefined;
    itemNumber?: number;
    faxSourceEnum?: FaxSourceEnum;
    deliveryItemTaskItemTypeName?: string | undefined;
    taskItemID?: string | undefined;

    constructor(data?: IPHRNote) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrNoteID = _data["phrNoteID"];
            this.patientID = _data["patientID"];
            this.noteTypeEnum = _data["noteTypeEnum"];
            this.visibilityEnum = _data["visibilityEnum"];
            this.notes = _data["notes"];
            this.addSignature = _data["addSignature"];
            this.generateDocumentStateEnum = _data["generateDocumentStateEnum"];
            this.sendToEnum = _data["sendToEnum"];
            this.sendToID = _data["sendToID"];
            this.sendSubject = _data["sendSubject"];
            this.sendMessage = _data["sendMessage"];
            this.sendCopyToPatient = _data["sendCopyToPatient"];
            this.providerID = _data["providerID"];
            this.faxID = _data["faxID"];
            this.phrDocumentID = _data["phrDocumentID"];
            this.phrConsultID = _data["phrConsultID"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.sendToUserDetail = _data["sendToUserDetail"] ? UserDetail.fromJS(_data["sendToUserDetail"]) : <any>undefined;
            this.sendToName = _data["sendToName"];
            this.phrConsult = _data["phrConsult"] ? PHRConsult.fromJS(_data["phrConsult"]) : <any>undefined;
            this.phrDocument = _data["phrDocument"] ? PHRDocument.fromJS(_data["phrDocument"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.itemNumber = _data["itemNumber"];
            this.faxSourceEnum = _data["faxSourceEnum"];
            this.deliveryItemTaskItemTypeName = _data["deliveryItemTaskItemTypeName"];
            this.taskItemID = _data["taskItemID"];
        }
    }

    static fromJS(data: any): PHRNote {
        data = typeof data === 'object' ? data : {};
        let result = new PHRNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrNoteID"] = this.phrNoteID;
        data["patientID"] = this.patientID;
        data["noteTypeEnum"] = this.noteTypeEnum;
        data["visibilityEnum"] = this.visibilityEnum;
        data["notes"] = this.notes;
        data["addSignature"] = this.addSignature;
        data["generateDocumentStateEnum"] = this.generateDocumentStateEnum;
        data["sendToEnum"] = this.sendToEnum;
        data["sendToID"] = this.sendToID;
        data["sendSubject"] = this.sendSubject;
        data["sendMessage"] = this.sendMessage;
        data["sendCopyToPatient"] = this.sendCopyToPatient;
        data["providerID"] = this.providerID;
        data["faxID"] = this.faxID;
        data["phrDocumentID"] = this.phrDocumentID;
        data["phrConsultID"] = this.phrConsultID;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["sendToUserDetail"] = this.sendToUserDetail ? this.sendToUserDetail.toJSON() : <any>undefined;
        data["sendToName"] = this.sendToName;
        data["phrConsult"] = this.phrConsult ? this.phrConsult.toJSON() : <any>undefined;
        data["phrDocument"] = this.phrDocument ? this.phrDocument.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["itemNumber"] = this.itemNumber;
        data["faxSourceEnum"] = this.faxSourceEnum;
        data["deliveryItemTaskItemTypeName"] = this.deliveryItemTaskItemTypeName;
        data["taskItemID"] = this.taskItemID;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRNote extends IPHRBase {
    phrNoteID: string;
    patientID: string;
    noteTypeEnum: NoteTypeEnum;
    visibilityEnum: VisibilityEnum;
    notes?: string | undefined;
    addSignature: boolean;
    generateDocumentStateEnum: GenerateDocumentStateEnum;
    sendToEnum: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient: boolean;
    providerID?: string | undefined;
    faxID?: string | undefined;
    phrDocumentID?: string | undefined;
    phrConsultID?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    sendToUserDetail?: UserDetail | undefined;
    sendToName?: string | undefined;
    phrConsult?: PHRConsult | undefined;
    phrDocument?: PHRDocument | undefined;
    patient?: Patient | undefined;
    provider?: Provider | undefined;
    itemNumber?: number;
    faxSourceEnum?: FaxSourceEnum;
    deliveryItemTaskItemTypeName?: string | undefined;
    taskItemID?: string | undefined;
}

export enum NoteTypeEnum {
    General = "General",
    SickNote = "Sick Note",
    Referral = "Referral",
    Disability = "Disability",
    MedicalReport = "Medical Report",
}

export enum VisibilityEnum {
    PatientAndProvider = "Patient and Provider",
    PatientOnly = "Patient Only",
    ProviderOnly = "Provider Only",
}

export enum FaxSourceEnum {
    PatientOrder = "PatientOrder",
    PatientPrescription = "PatientPrescription",
    PatientNotes = "PatientNotes",
    PHRConsult = "PHRConsult",
}

export class PHRFamilyHistory extends PHRBase implements IPHRFamilyHistory {
    phrFamilyHistoryID!: string;
    patientID!: string;
    condition!: string;
    relationshipTypeEnum!: RelationshipTypeEnum;
    fathersSide!: boolean;
    mothersSide!: boolean;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRFamilyHistory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrFamilyHistoryID = _data["phrFamilyHistoryID"];
            this.patientID = _data["patientID"];
            this.condition = _data["condition"];
            this.relationshipTypeEnum = _data["relationshipTypeEnum"];
            this.fathersSide = _data["fathersSide"];
            this.mothersSide = _data["mothersSide"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRFamilyHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PHRFamilyHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrFamilyHistoryID"] = this.phrFamilyHistoryID;
        data["patientID"] = this.patientID;
        data["condition"] = this.condition;
        data["relationshipTypeEnum"] = this.relationshipTypeEnum;
        data["fathersSide"] = this.fathersSide;
        data["mothersSide"] = this.mothersSide;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRFamilyHistory extends IPHRBase {
    phrFamilyHistoryID: string;
    patientID: string;
    condition: string;
    relationshipTypeEnum: RelationshipTypeEnum;
    fathersSide: boolean;
    mothersSide: boolean;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;
}

export class PHRFunctional extends PHRBase implements IPHRFunctional {
    phrFunctionalID!: string;
    patientID!: string;
    anyImportantSelfCareNeeds!: boolean;
    name!: string;
    ambulatoryAbility?: string | undefined;
    mentalStatus?: string | undefined;
    adLs?: string | undefined;
    communicationAbility?: string | undefined;
    perception?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRFunctional) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrFunctionalID = _data["phrFunctionalID"];
            this.patientID = _data["patientID"];
            this.anyImportantSelfCareNeeds = _data["anyImportantSelfCareNeeds"];
            this.name = _data["name"];
            this.ambulatoryAbility = _data["ambulatoryAbility"];
            this.mentalStatus = _data["mentalStatus"];
            this.adLs = _data["adLs"];
            this.communicationAbility = _data["communicationAbility"];
            this.perception = _data["perception"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRFunctional {
        data = typeof data === 'object' ? data : {};
        let result = new PHRFunctional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrFunctionalID"] = this.phrFunctionalID;
        data["patientID"] = this.patientID;
        data["anyImportantSelfCareNeeds"] = this.anyImportantSelfCareNeeds;
        data["name"] = this.name;
        data["ambulatoryAbility"] = this.ambulatoryAbility;
        data["mentalStatus"] = this.mentalStatus;
        data["adLs"] = this.adLs;
        data["communicationAbility"] = this.communicationAbility;
        data["perception"] = this.perception;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRFunctional extends IPHRBase {
    phrFunctionalID: string;
    patientID: string;
    anyImportantSelfCareNeeds: boolean;
    name: string;
    ambulatoryAbility?: string | undefined;
    mentalStatus?: string | undefined;
    adLs?: string | undefined;
    communicationAbility?: string | undefined;
    perception?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    verifiedByProviderName?: string | undefined;
}

export class PHRHealthCondition extends PHRBase implements IPHRHealthCondition {
    phrHealthConditionID!: string;
    patientID!: string;
    name?: string | undefined;
    tagID?: string | undefined;
    diagnosedStartDate!: Date;
    diagnosedEndDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRHealthCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrHealthConditionID = _data["phrHealthConditionID"];
            this.patientID = _data["patientID"];
            this.name = _data["name"];
            this.tagID = _data["tagID"];
            this.diagnosedStartDate = _data["diagnosedStartDate"] ? new Date(_data["diagnosedStartDate"].toString()) : <any>undefined;
            this.diagnosedEndDate = _data["diagnosedEndDate"] ? new Date(_data["diagnosedEndDate"].toString()) : <any>undefined;
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRHealthCondition {
        data = typeof data === 'object' ? data : {};
        let result = new PHRHealthCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrHealthConditionID"] = this.phrHealthConditionID;
        data["patientID"] = this.patientID;
        data["name"] = this.name;
        data["tagID"] = this.tagID;
        data["diagnosedStartDate"] = this.diagnosedStartDate ? this.diagnosedStartDate.toISOString() : <any>undefined;
        data["diagnosedEndDate"] = this.diagnosedEndDate ? this.diagnosedEndDate.toISOString() : <any>undefined;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRHealthCondition extends IPHRBase {
    phrHealthConditionID: string;
    patientID: string;
    name?: string | undefined;
    tagID?: string | undefined;
    diagnosedStartDate: Date;
    diagnosedEndDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRHealthConditionTags extends PHRBase implements IPHRHealthConditionTags {
    phrHealthConditionTagsID!: string;
    patientID!: string;
    name?: string | undefined;
    shortName?: string | undefined;
    tagID?: string | undefined;
    diagnosedStartDate!: Date;
    diagnosedEndDate?: Date | undefined;
    data?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRHealthConditionTags) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrHealthConditionTagsID = _data["phrHealthConditionTagsID"];
            this.patientID = _data["patientID"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.tagID = _data["tagID"];
            this.diagnosedStartDate = _data["diagnosedStartDate"] ? new Date(_data["diagnosedStartDate"].toString()) : <any>undefined;
            this.diagnosedEndDate = _data["diagnosedEndDate"] ? new Date(_data["diagnosedEndDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRHealthConditionTags {
        data = typeof data === 'object' ? data : {};
        let result = new PHRHealthConditionTags();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrHealthConditionTagsID"] = this.phrHealthConditionTagsID;
        data["patientID"] = this.patientID;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["tagID"] = this.tagID;
        data["diagnosedStartDate"] = this.diagnosedStartDate ? this.diagnosedStartDate.toISOString() : <any>undefined;
        data["diagnosedEndDate"] = this.diagnosedEndDate ? this.diagnosedEndDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRHealthConditionTags extends IPHRBase {
    phrHealthConditionTagsID: string;
    patientID: string;
    name?: string | undefined;
    shortName?: string | undefined;
    tagID?: string | undefined;
    diagnosedStartDate: Date;
    diagnosedEndDate?: Date | undefined;
    data?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRHealthGoal extends PHRBase implements IPHRHealthGoal {
    phrHealthGoalID!: string;
    patientID!: string;
    healthGoalDate!: Date;
    healthGoalAchievedDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRHealthGoal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrHealthGoalID = _data["phrHealthGoalID"];
            this.patientID = _data["patientID"];
            this.healthGoalDate = _data["healthGoalDate"] ? new Date(_data["healthGoalDate"].toString()) : <any>undefined;
            this.healthGoalAchievedDate = _data["healthGoalAchievedDate"] ? new Date(_data["healthGoalAchievedDate"].toString()) : <any>undefined;
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRHealthGoal {
        data = typeof data === 'object' ? data : {};
        let result = new PHRHealthGoal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrHealthGoalID"] = this.phrHealthGoalID;
        data["patientID"] = this.patientID;
        data["healthGoalDate"] = this.healthGoalDate ? this.healthGoalDate.toISOString() : <any>undefined;
        data["healthGoalAchievedDate"] = this.healthGoalAchievedDate ? this.healthGoalAchievedDate.toISOString() : <any>undefined;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRHealthGoal extends IPHRBase {
    phrHealthGoalID: string;
    patientID: string;
    healthGoalDate: Date;
    healthGoalAchievedDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRHealthJournal extends PHRBase implements IPHRHealthJournal {
    phrHealthJournalID!: string;
    patientID!: string;
    title!: string;
    notes?: string | undefined;
    journalDate!: Date;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    phrDocuments?: PHRDocument[] | undefined;
    phrDocumentIDs?: string[] | undefined;

    constructor(data?: IPHRHealthJournal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrHealthJournalID = _data["phrHealthJournalID"];
            this.patientID = _data["patientID"];
            this.title = _data["title"];
            this.notes = _data["notes"];
            this.journalDate = _data["journalDate"] ? new Date(_data["journalDate"].toString()) : <any>undefined;
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            if (Array.isArray(_data["phrDocuments"])) {
                this.phrDocuments = [] as any;
                for (let item of _data["phrDocuments"])
                    this.phrDocuments!.push(PHRDocument.fromJS(item));
            }
            if (Array.isArray(_data["phrDocumentIDs"])) {
                this.phrDocumentIDs = [] as any;
                for (let item of _data["phrDocumentIDs"])
                    this.phrDocumentIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): PHRHealthJournal {
        data = typeof data === 'object' ? data : {};
        let result = new PHRHealthJournal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrHealthJournalID"] = this.phrHealthJournalID;
        data["patientID"] = this.patientID;
        data["title"] = this.title;
        data["notes"] = this.notes;
        data["journalDate"] = this.journalDate ? this.journalDate.toISOString() : <any>undefined;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        if (Array.isArray(this.phrDocuments)) {
            data["phrDocuments"] = [];
            for (let item of this.phrDocuments)
                data["phrDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.phrDocumentIDs)) {
            data["phrDocumentIDs"] = [];
            for (let item of this.phrDocumentIDs)
                data["phrDocumentIDs"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPHRHealthJournal extends IPHRBase {
    phrHealthJournalID: string;
    patientID: string;
    title: string;
    notes?: string | undefined;
    journalDate: Date;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    phrDocuments?: PHRDocument[] | undefined;
    phrDocumentIDs?: string[] | undefined;
}

export class PHRHospitalVisit extends PHRBase implements IPHRHospitalVisit {
    phrHospitalVisitID!: string;
    patientID!: string;
    name!: string;
    admissionDate!: Date;
    dischargeDate?: Date | undefined;
    reason!: string;
    location?: string | undefined;
    treatingProvider?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRHospitalVisit) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrHospitalVisitID = _data["phrHospitalVisitID"];
            this.patientID = _data["patientID"];
            this.name = _data["name"];
            this.admissionDate = _data["admissionDate"] ? new Date(_data["admissionDate"].toString()) : <any>undefined;
            this.dischargeDate = _data["dischargeDate"] ? new Date(_data["dischargeDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.location = _data["location"];
            this.treatingProvider = _data["treatingProvider"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRHospitalVisit {
        data = typeof data === 'object' ? data : {};
        let result = new PHRHospitalVisit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrHospitalVisitID"] = this.phrHospitalVisitID;
        data["patientID"] = this.patientID;
        data["name"] = this.name;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["location"] = this.location;
        data["treatingProvider"] = this.treatingProvider;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRHospitalVisit extends IPHRBase {
    phrHospitalVisitID: string;
    patientID: string;
    name: string;
    admissionDate: Date;
    dischargeDate?: Date | undefined;
    reason: string;
    location?: string | undefined;
    treatingProvider?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRMedicalEquipment extends PHRBase implements IPHRMedicalEquipment {
    phrMedicalEquipmentID!: string;
    patientID!: string;
    name!: string;
    reasonForUse!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRMedicalEquipment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrMedicalEquipmentID = _data["phrMedicalEquipmentID"];
            this.patientID = _data["patientID"];
            this.name = _data["name"];
            this.reasonForUse = _data["reasonForUse"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRMedicalEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new PHRMedicalEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrMedicalEquipmentID"] = this.phrMedicalEquipmentID;
        data["patientID"] = this.patientID;
        data["name"] = this.name;
        data["reasonForUse"] = this.reasonForUse;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRMedicalEquipment extends IPHRBase {
    phrMedicalEquipmentID: string;
    patientID: string;
    name: string;
    reasonForUse: string;
    startDate: Date;
    endDate?: Date | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRMedicalHistory extends PHRBase implements IPHRMedicalHistory {
    phrMedicalHistoryID!: string;
    patientID!: string;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRMedicalHistory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrMedicalHistoryID = _data["phrMedicalHistoryID"];
            this.patientID = _data["patientID"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRMedicalHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PHRMedicalHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrMedicalHistoryID"] = this.phrMedicalHistoryID;
        data["patientID"] = this.patientID;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRMedicalHistory extends IPHRBase {
    phrMedicalHistoryID: string;
    patientID: string;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRPregnancy extends PHRBase implements IPHRPregnancy {
    phrPregnancyID!: string;
    patientID!: string;
    pregnancyDate!: Date;
    pregnancyOutcome?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRPregnancy) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrPregnancyID = _data["phrPregnancyID"];
            this.patientID = _data["patientID"];
            this.pregnancyDate = _data["pregnancyDate"] ? new Date(_data["pregnancyDate"].toString()) : <any>undefined;
            this.pregnancyOutcome = _data["pregnancyOutcome"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRPregnancy {
        data = typeof data === 'object' ? data : {};
        let result = new PHRPregnancy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrPregnancyID"] = this.phrPregnancyID;
        data["patientID"] = this.patientID;
        data["pregnancyDate"] = this.pregnancyDate ? this.pregnancyDate.toISOString() : <any>undefined;
        data["pregnancyOutcome"] = this.pregnancyOutcome;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRPregnancy extends IPHRBase {
    phrPregnancyID: string;
    patientID: string;
    pregnancyDate: Date;
    pregnancyOutcome?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHROrderDetail extends PHRBase implements IPHROrderDetail {
    phrOrderDetailID!: string;
    patientID!: string;
    patientOrderID!: string;
    key?: string | undefined;
    value?: string | undefined;
    orderItemID?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;

    constructor(data?: IPHROrderDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrOrderDetailID = _data["phrOrderDetailID"];
            this.patientID = _data["patientID"];
            this.patientOrderID = _data["patientOrderID"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.orderItemID = _data["orderItemID"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PHROrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PHROrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrOrderDetailID"] = this.phrOrderDetailID;
        data["patientID"] = this.patientID;
        data["patientOrderID"] = this.patientOrderID;
        data["key"] = this.key;
        data["value"] = this.value;
        data["orderItemID"] = this.orderItemID;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPHROrderDetail extends IPHRBase {
    phrOrderDetailID: string;
    patientID: string;
    patientOrderID: string;
    key?: string | undefined;
    value?: string | undefined;
    orderItemID?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
}

export class PHRSocialHistory extends PHRBase implements IPHRSocialHistory {
    phrSocialHistoryID!: string;
    patientID!: string;
    occupation?: string | undefined;
    hobbies?: string | undefined;
    religion?: string | undefined;
    smoked!: boolean;
    smoking!: boolean;
    smokingStartDate?: Date | undefined;
    smokingEndDate?: Date | undefined;
    smokingQuantity?: string | undefined;
    drinking!: boolean;
    drinkingStartDate?: Date | undefined;
    drinkingEndDate?: Date | undefined;
    drinkingFrequency?: string | undefined;
    drinkingNotes?: string | undefined;
    drugs!: boolean;
    drugNotes?: string | undefined;
    usedCannabis!: boolean;
    cannabis!: boolean;
    cannabisStartDate?: Date | undefined;
    cannabisEndDate?: Date | undefined;
    cannabisReason?: string | undefined;
    cannabisCondition?: string | undefined;
    cannabisConsumptionMethod?: string | undefined;
    cannabisNotes?: string | undefined;
    exercise!: boolean;
    exerciseFrequency?: string | undefined;
    dietaryPreferences?: string | undefined;
    dietaryNotes?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRSocialHistory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrSocialHistoryID = _data["phrSocialHistoryID"];
            this.patientID = _data["patientID"];
            this.occupation = _data["occupation"];
            this.hobbies = _data["hobbies"];
            this.religion = _data["religion"];
            this.smoked = _data["smoked"];
            this.smoking = _data["smoking"];
            this.smokingStartDate = _data["smokingStartDate"] ? new Date(_data["smokingStartDate"].toString()) : <any>undefined;
            this.smokingEndDate = _data["smokingEndDate"] ? new Date(_data["smokingEndDate"].toString()) : <any>undefined;
            this.smokingQuantity = _data["smokingQuantity"];
            this.drinking = _data["drinking"];
            this.drinkingStartDate = _data["drinkingStartDate"] ? new Date(_data["drinkingStartDate"].toString()) : <any>undefined;
            this.drinkingEndDate = _data["drinkingEndDate"] ? new Date(_data["drinkingEndDate"].toString()) : <any>undefined;
            this.drinkingFrequency = _data["drinkingFrequency"];
            this.drinkingNotes = _data["drinkingNotes"];
            this.drugs = _data["drugs"];
            this.drugNotes = _data["drugNotes"];
            this.usedCannabis = _data["usedCannabis"];
            this.cannabis = _data["cannabis"];
            this.cannabisStartDate = _data["cannabisStartDate"] ? new Date(_data["cannabisStartDate"].toString()) : <any>undefined;
            this.cannabisEndDate = _data["cannabisEndDate"] ? new Date(_data["cannabisEndDate"].toString()) : <any>undefined;
            this.cannabisReason = _data["cannabisReason"];
            this.cannabisCondition = _data["cannabisCondition"];
            this.cannabisConsumptionMethod = _data["cannabisConsumptionMethod"];
            this.cannabisNotes = _data["cannabisNotes"];
            this.exercise = _data["exercise"];
            this.exerciseFrequency = _data["exerciseFrequency"];
            this.dietaryPreferences = _data["dietaryPreferences"];
            this.dietaryNotes = _data["dietaryNotes"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRSocialHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PHRSocialHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrSocialHistoryID"] = this.phrSocialHistoryID;
        data["patientID"] = this.patientID;
        data["occupation"] = this.occupation;
        data["hobbies"] = this.hobbies;
        data["religion"] = this.religion;
        data["smoked"] = this.smoked;
        data["smoking"] = this.smoking;
        data["smokingStartDate"] = this.smokingStartDate ? this.smokingStartDate.toISOString() : <any>undefined;
        data["smokingEndDate"] = this.smokingEndDate ? this.smokingEndDate.toISOString() : <any>undefined;
        data["smokingQuantity"] = this.smokingQuantity;
        data["drinking"] = this.drinking;
        data["drinkingStartDate"] = this.drinkingStartDate ? this.drinkingStartDate.toISOString() : <any>undefined;
        data["drinkingEndDate"] = this.drinkingEndDate ? this.drinkingEndDate.toISOString() : <any>undefined;
        data["drinkingFrequency"] = this.drinkingFrequency;
        data["drinkingNotes"] = this.drinkingNotes;
        data["drugs"] = this.drugs;
        data["drugNotes"] = this.drugNotes;
        data["usedCannabis"] = this.usedCannabis;
        data["cannabis"] = this.cannabis;
        data["cannabisStartDate"] = this.cannabisStartDate ? this.cannabisStartDate.toISOString() : <any>undefined;
        data["cannabisEndDate"] = this.cannabisEndDate ? this.cannabisEndDate.toISOString() : <any>undefined;
        data["cannabisReason"] = this.cannabisReason;
        data["cannabisCondition"] = this.cannabisCondition;
        data["cannabisConsumptionMethod"] = this.cannabisConsumptionMethod;
        data["cannabisNotes"] = this.cannabisNotes;
        data["exercise"] = this.exercise;
        data["exerciseFrequency"] = this.exerciseFrequency;
        data["dietaryPreferences"] = this.dietaryPreferences;
        data["dietaryNotes"] = this.dietaryNotes;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRSocialHistory extends IPHRBase {
    phrSocialHistoryID: string;
    patientID: string;
    occupation?: string | undefined;
    hobbies?: string | undefined;
    religion?: string | undefined;
    smoked: boolean;
    smoking: boolean;
    smokingStartDate?: Date | undefined;
    smokingEndDate?: Date | undefined;
    smokingQuantity?: string | undefined;
    drinking: boolean;
    drinkingStartDate?: Date | undefined;
    drinkingEndDate?: Date | undefined;
    drinkingFrequency?: string | undefined;
    drinkingNotes?: string | undefined;
    drugs: boolean;
    drugNotes?: string | undefined;
    usedCannabis: boolean;
    cannabis: boolean;
    cannabisStartDate?: Date | undefined;
    cannabisEndDate?: Date | undefined;
    cannabisReason?: string | undefined;
    cannabisCondition?: string | undefined;
    cannabisConsumptionMethod?: string | undefined;
    cannabisNotes?: string | undefined;
    exercise: boolean;
    exerciseFrequency?: string | undefined;
    dietaryPreferences?: string | undefined;
    dietaryNotes?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRSurgeryHistory extends PHRBase implements IPHRSurgeryHistory {
    phrSurgeryHistoryID!: string;
    patientID!: string;
    name!: string;
    surgeryDate!: Date;
    implants?: string | undefined;
    reason?: string | undefined;
    location?: string | undefined;
    surgeonName?: string | undefined;
    mobileSync!: boolean;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRSurgeryHistory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrSurgeryHistoryID = _data["phrSurgeryHistoryID"];
            this.patientID = _data["patientID"];
            this.name = _data["name"];
            this.surgeryDate = _data["surgeryDate"] ? new Date(_data["surgeryDate"].toString()) : <any>undefined;
            this.implants = _data["implants"];
            this.reason = _data["reason"];
            this.location = _data["location"];
            this.surgeonName = _data["surgeonName"];
            this.mobileSync = _data["mobileSync"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRSurgeryHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PHRSurgeryHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrSurgeryHistoryID"] = this.phrSurgeryHistoryID;
        data["patientID"] = this.patientID;
        data["name"] = this.name;
        data["surgeryDate"] = this.surgeryDate ? this.surgeryDate.toISOString() : <any>undefined;
        data["implants"] = this.implants;
        data["reason"] = this.reason;
        data["location"] = this.location;
        data["surgeonName"] = this.surgeonName;
        data["mobileSync"] = this.mobileSync;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRSurgeryHistory extends IPHRBase {
    phrSurgeryHistoryID: string;
    patientID: string;
    name: string;
    surgeryDate: Date;
    implants?: string | undefined;
    reason?: string | undefined;
    location?: string | undefined;
    surgeonName?: string | undefined;
    mobileSync: boolean;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRTracker extends PHRBase implements IPHRTracker {
    phrTrackerID!: string;
    patientID!: string;
    trackerTypeEnum!: TrackerTypeEnum;
    name!: string;
    description!: string;
    enabled!: boolean;
    showOnDashboard!: boolean;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    phrTrackerDetails?: PHRTrackerDetail[] | undefined;
    trackerCategoryEnum?: TrackerCategoryEnum;

    constructor(data?: IPHRTracker) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrTrackerID = _data["phrTrackerID"];
            this.patientID = _data["patientID"];
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.showOnDashboard = _data["showOnDashboard"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            if (Array.isArray(_data["phrTrackerDetails"])) {
                this.phrTrackerDetails = [] as any;
                for (let item of _data["phrTrackerDetails"])
                    this.phrTrackerDetails!.push(PHRTrackerDetail.fromJS(item));
            }
            this.trackerCategoryEnum = _data["trackerCategoryEnum"];
        }
    }

    static fromJS(data: any): PHRTracker {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTracker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrTrackerID"] = this.phrTrackerID;
        data["patientID"] = this.patientID;
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["showOnDashboard"] = this.showOnDashboard;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        if (Array.isArray(this.phrTrackerDetails)) {
            data["phrTrackerDetails"] = [];
            for (let item of this.phrTrackerDetails)
                data["phrTrackerDetails"].push(item.toJSON());
        }
        data["trackerCategoryEnum"] = this.trackerCategoryEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTracker extends IPHRBase {
    phrTrackerID: string;
    patientID: string;
    trackerTypeEnum: TrackerTypeEnum;
    name: string;
    description: string;
    enabled: boolean;
    showOnDashboard: boolean;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    phrTrackerDetails?: PHRTrackerDetail[] | undefined;
    trackerCategoryEnum?: TrackerCategoryEnum;
}

export enum TrackerTypeEnum {
    BloodPressure = "BloodPressure",
    Pulse = "Pulse",
    BloodGlucose = "BloodGlucose",
    BloodOxygen = "BloodOxygen",
    Temperature = "Temperature",
    Respiratory = "Respiratory",
    StepCounter = "StepCounter",
    Hemoglobin = "Hemoglobin",
    Cholesterol = "Cholesterol",
    UricAcid = "UricAcid",
    HCV = "HCV",
    FetalDoppler = "FetalDoppler",
    RapidPregnancy = "RapidPregnancy",
    HIV = "HIV",
    Syphilis = "Syphilis",
    Malaria = "Malaria",
    Dengue = "Dengue",
    Chikungunya = "Chikungunya",
    Troponin = "Troponin",
    Typhoid = "Typhoid",
    WaistCircumference = "WaistCircumference",
    HeadCircumference = "HeadCircumference",
    Length = "Length",
    WeightHeight = "WeightHeight",
    Mood = "Mood",
    Stress = "Stress",
    Anxiety = "Anxiety",
    Exercise = "Exercise",
    Sleep = "Sleep",
    Covid = "Covid",
}

export class PHRTrackerDetail extends PHRBase implements IPHRTrackerDetail {
    phrTrackerDetailID!: string;
    phrTrackerID!: string;
    trackerValue1Name!: string;
    trackerValue1TypeEnum!: TrackerValue1TypeEnum;
    trackerValue1?: string | undefined;
    trackerValue2Name?: string | undefined;
    trackerValue2TypeEnum?: TrackerValue2TypeEnum | undefined;
    trackerValue2?: string | undefined;
    trackerValue3Name?: string | undefined;
    trackerValue3TypeEnum?: TrackerValue3TypeEnum | undefined;
    trackerValue3?: string | undefined;
    trackerValue4Name?: string | undefined;
    trackerValue4TypeEnum?: TrackerValue4TypeEnum | undefined;
    trackerValue4?: string | undefined;
    trackerValue5Name?: string | undefined;
    trackerValue5TypeEnum?: TrackerValue5TypeEnum | undefined;
    trackerValue5?: string | undefined;
    trackerValue6Name?: string | undefined;
    trackerValue6TypeEnum?: TrackerValue6TypeEnum | undefined;
    trackerValue6?: string | undefined;
    trackerValue7Name?: string | undefined;
    trackerValue7TypeEnum?: TrackerValue7TypeEnum | undefined;
    trackerValue7?: string | undefined;
    trackerValue8Name?: string | undefined;
    trackerValue8TypeEnum?: TrackerValue8TypeEnum | undefined;
    trackerValue8?: string | undefined;
    trackerValue9Name?: string | undefined;
    trackerValue9TypeEnum?: TrackerValue9TypeEnum | undefined;
    trackerValue9?: string | undefined;
    trackerValue10Name?: string | undefined;
    trackerValue10TypeEnum?: TrackerValue10TypeEnum | undefined;
    trackerValue10?: string | undefined;
    trackerValue11Name?: string | undefined;
    trackerValue11TypeEnum?: TrackerValue11TypeEnum | undefined;
    trackerValue11?: string | undefined;
    trackerValue12Name?: string | undefined;
    trackerValue12TypeEnum?: TrackerValue12TypeEnum | undefined;
    trackerValue12?: string | undefined;
    trackerValue13Name?: string | undefined;
    trackerValue13TypeEnum?: TrackerValue13TypeEnum | undefined;
    trackerValue13?: string | undefined;
    trackerValue14Name?: string | undefined;
    trackerValue14TypeEnum?: TrackerValue14TypeEnum | undefined;
    trackerValue14?: string | undefined;
    trackerValue15Name?: string | undefined;
    trackerValue15TypeEnum?: TrackerValue15TypeEnum | undefined;
    trackerValue15?: string | undefined;
    trackerValue16Name?: string | undefined;
    trackerValue16TypeEnum?: TrackerValue16TypeEnum | undefined;
    trackerValue16?: string | undefined;
    trackerValue17Name?: string | undefined;
    trackerValue17TypeEnum?: TrackerValue17TypeEnum | undefined;
    trackerValue17?: string | undefined;
    trackerValue18Name?: string | undefined;
    trackerValue18TypeEnum?: TrackerValue18TypeEnum | undefined;
    trackerValue18?: string | undefined;
    trackerValue19Name?: string | undefined;
    trackerValue19TypeEnum?: TrackerValue19TypeEnum | undefined;
    trackerValue19?: string | undefined;
    trackerValue20Name?: string | undefined;
    trackerValue20TypeEnum?: TrackerValue20TypeEnum | undefined;
    trackerValue20?: string | undefined;
    trackerDate!: Date;
    trackerSourceEnum!: TrackerSourceEnum;
    notes?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrConsultID?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrTracker?: PHRTracker | undefined;
    phrTrackerDetailTags?: PHRTrackerDetailTag[] | undefined;
    patientID?: string;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRTrackerDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrTrackerDetailID = _data["phrTrackerDetailID"];
            this.phrTrackerID = _data["phrTrackerID"];
            this.trackerValue1Name = _data["trackerValue1Name"];
            this.trackerValue1TypeEnum = _data["trackerValue1TypeEnum"];
            this.trackerValue1 = _data["trackerValue1"];
            this.trackerValue2Name = _data["trackerValue2Name"];
            this.trackerValue2TypeEnum = _data["trackerValue2TypeEnum"];
            this.trackerValue2 = _data["trackerValue2"];
            this.trackerValue3Name = _data["trackerValue3Name"];
            this.trackerValue3TypeEnum = _data["trackerValue3TypeEnum"];
            this.trackerValue3 = _data["trackerValue3"];
            this.trackerValue4Name = _data["trackerValue4Name"];
            this.trackerValue4TypeEnum = _data["trackerValue4TypeEnum"];
            this.trackerValue4 = _data["trackerValue4"];
            this.trackerValue5Name = _data["trackerValue5Name"];
            this.trackerValue5TypeEnum = _data["trackerValue5TypeEnum"];
            this.trackerValue5 = _data["trackerValue5"];
            this.trackerValue6Name = _data["trackerValue6Name"];
            this.trackerValue6TypeEnum = _data["trackerValue6TypeEnum"];
            this.trackerValue6 = _data["trackerValue6"];
            this.trackerValue7Name = _data["trackerValue7Name"];
            this.trackerValue7TypeEnum = _data["trackerValue7TypeEnum"];
            this.trackerValue7 = _data["trackerValue7"];
            this.trackerValue8Name = _data["trackerValue8Name"];
            this.trackerValue8TypeEnum = _data["trackerValue8TypeEnum"];
            this.trackerValue8 = _data["trackerValue8"];
            this.trackerValue9Name = _data["trackerValue9Name"];
            this.trackerValue9TypeEnum = _data["trackerValue9TypeEnum"];
            this.trackerValue9 = _data["trackerValue9"];
            this.trackerValue10Name = _data["trackerValue10Name"];
            this.trackerValue10TypeEnum = _data["trackerValue10TypeEnum"];
            this.trackerValue10 = _data["trackerValue10"];
            this.trackerValue11Name = _data["trackerValue11Name"];
            this.trackerValue11TypeEnum = _data["trackerValue11TypeEnum"];
            this.trackerValue11 = _data["trackerValue11"];
            this.trackerValue12Name = _data["trackerValue12Name"];
            this.trackerValue12TypeEnum = _data["trackerValue12TypeEnum"];
            this.trackerValue12 = _data["trackerValue12"];
            this.trackerValue13Name = _data["trackerValue13Name"];
            this.trackerValue13TypeEnum = _data["trackerValue13TypeEnum"];
            this.trackerValue13 = _data["trackerValue13"];
            this.trackerValue14Name = _data["trackerValue14Name"];
            this.trackerValue14TypeEnum = _data["trackerValue14TypeEnum"];
            this.trackerValue14 = _data["trackerValue14"];
            this.trackerValue15Name = _data["trackerValue15Name"];
            this.trackerValue15TypeEnum = _data["trackerValue15TypeEnum"];
            this.trackerValue15 = _data["trackerValue15"];
            this.trackerValue16Name = _data["trackerValue16Name"];
            this.trackerValue16TypeEnum = _data["trackerValue16TypeEnum"];
            this.trackerValue16 = _data["trackerValue16"];
            this.trackerValue17Name = _data["trackerValue17Name"];
            this.trackerValue17TypeEnum = _data["trackerValue17TypeEnum"];
            this.trackerValue17 = _data["trackerValue17"];
            this.trackerValue18Name = _data["trackerValue18Name"];
            this.trackerValue18TypeEnum = _data["trackerValue18TypeEnum"];
            this.trackerValue18 = _data["trackerValue18"];
            this.trackerValue19Name = _data["trackerValue19Name"];
            this.trackerValue19TypeEnum = _data["trackerValue19TypeEnum"];
            this.trackerValue19 = _data["trackerValue19"];
            this.trackerValue20Name = _data["trackerValue20Name"];
            this.trackerValue20TypeEnum = _data["trackerValue20TypeEnum"];
            this.trackerValue20 = _data["trackerValue20"];
            this.trackerDate = _data["trackerDate"] ? new Date(_data["trackerDate"].toString()) : <any>undefined;
            this.trackerSourceEnum = _data["trackerSourceEnum"];
            this.notes = _data["notes"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.phrConsultID = _data["phrConsultID"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrTracker = _data["phrTracker"] ? PHRTracker.fromJS(_data["phrTracker"]) : <any>undefined;
            if (Array.isArray(_data["phrTrackerDetailTags"])) {
                this.phrTrackerDetailTags = [] as any;
                for (let item of _data["phrTrackerDetailTags"])
                    this.phrTrackerDetailTags!.push(PHRTrackerDetailTag.fromJS(item));
            }
            this.patientID = _data["patientID"];
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRTrackerDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrTrackerDetailID"] = this.phrTrackerDetailID;
        data["phrTrackerID"] = this.phrTrackerID;
        data["trackerValue1Name"] = this.trackerValue1Name;
        data["trackerValue1TypeEnum"] = this.trackerValue1TypeEnum;
        data["trackerValue1"] = this.trackerValue1;
        data["trackerValue2Name"] = this.trackerValue2Name;
        data["trackerValue2TypeEnum"] = this.trackerValue2TypeEnum;
        data["trackerValue2"] = this.trackerValue2;
        data["trackerValue3Name"] = this.trackerValue3Name;
        data["trackerValue3TypeEnum"] = this.trackerValue3TypeEnum;
        data["trackerValue3"] = this.trackerValue3;
        data["trackerValue4Name"] = this.trackerValue4Name;
        data["trackerValue4TypeEnum"] = this.trackerValue4TypeEnum;
        data["trackerValue4"] = this.trackerValue4;
        data["trackerValue5Name"] = this.trackerValue5Name;
        data["trackerValue5TypeEnum"] = this.trackerValue5TypeEnum;
        data["trackerValue5"] = this.trackerValue5;
        data["trackerValue6Name"] = this.trackerValue6Name;
        data["trackerValue6TypeEnum"] = this.trackerValue6TypeEnum;
        data["trackerValue6"] = this.trackerValue6;
        data["trackerValue7Name"] = this.trackerValue7Name;
        data["trackerValue7TypeEnum"] = this.trackerValue7TypeEnum;
        data["trackerValue7"] = this.trackerValue7;
        data["trackerValue8Name"] = this.trackerValue8Name;
        data["trackerValue8TypeEnum"] = this.trackerValue8TypeEnum;
        data["trackerValue8"] = this.trackerValue8;
        data["trackerValue9Name"] = this.trackerValue9Name;
        data["trackerValue9TypeEnum"] = this.trackerValue9TypeEnum;
        data["trackerValue9"] = this.trackerValue9;
        data["trackerValue10Name"] = this.trackerValue10Name;
        data["trackerValue10TypeEnum"] = this.trackerValue10TypeEnum;
        data["trackerValue10"] = this.trackerValue10;
        data["trackerValue11Name"] = this.trackerValue11Name;
        data["trackerValue11TypeEnum"] = this.trackerValue11TypeEnum;
        data["trackerValue11"] = this.trackerValue11;
        data["trackerValue12Name"] = this.trackerValue12Name;
        data["trackerValue12TypeEnum"] = this.trackerValue12TypeEnum;
        data["trackerValue12"] = this.trackerValue12;
        data["trackerValue13Name"] = this.trackerValue13Name;
        data["trackerValue13TypeEnum"] = this.trackerValue13TypeEnum;
        data["trackerValue13"] = this.trackerValue13;
        data["trackerValue14Name"] = this.trackerValue14Name;
        data["trackerValue14TypeEnum"] = this.trackerValue14TypeEnum;
        data["trackerValue14"] = this.trackerValue14;
        data["trackerValue15Name"] = this.trackerValue15Name;
        data["trackerValue15TypeEnum"] = this.trackerValue15TypeEnum;
        data["trackerValue15"] = this.trackerValue15;
        data["trackerValue16Name"] = this.trackerValue16Name;
        data["trackerValue16TypeEnum"] = this.trackerValue16TypeEnum;
        data["trackerValue16"] = this.trackerValue16;
        data["trackerValue17Name"] = this.trackerValue17Name;
        data["trackerValue17TypeEnum"] = this.trackerValue17TypeEnum;
        data["trackerValue17"] = this.trackerValue17;
        data["trackerValue18Name"] = this.trackerValue18Name;
        data["trackerValue18TypeEnum"] = this.trackerValue18TypeEnum;
        data["trackerValue18"] = this.trackerValue18;
        data["trackerValue19Name"] = this.trackerValue19Name;
        data["trackerValue19TypeEnum"] = this.trackerValue19TypeEnum;
        data["trackerValue19"] = this.trackerValue19;
        data["trackerValue20Name"] = this.trackerValue20Name;
        data["trackerValue20TypeEnum"] = this.trackerValue20TypeEnum;
        data["trackerValue20"] = this.trackerValue20;
        data["trackerDate"] = this.trackerDate ? this.trackerDate.toISOString() : <any>undefined;
        data["trackerSourceEnum"] = this.trackerSourceEnum;
        data["notes"] = this.notes;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["phrConsultID"] = this.phrConsultID;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrTracker"] = this.phrTracker ? this.phrTracker.toJSON() : <any>undefined;
        if (Array.isArray(this.phrTrackerDetailTags)) {
            data["phrTrackerDetailTags"] = [];
            for (let item of this.phrTrackerDetailTags)
                data["phrTrackerDetailTags"].push(item.toJSON());
        }
        data["patientID"] = this.patientID;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerDetail extends IPHRBase {
    phrTrackerDetailID: string;
    phrTrackerID: string;
    trackerValue1Name: string;
    trackerValue1TypeEnum: TrackerValue1TypeEnum;
    trackerValue1?: string | undefined;
    trackerValue2Name?: string | undefined;
    trackerValue2TypeEnum?: TrackerValue2TypeEnum | undefined;
    trackerValue2?: string | undefined;
    trackerValue3Name?: string | undefined;
    trackerValue3TypeEnum?: TrackerValue3TypeEnum | undefined;
    trackerValue3?: string | undefined;
    trackerValue4Name?: string | undefined;
    trackerValue4TypeEnum?: TrackerValue4TypeEnum | undefined;
    trackerValue4?: string | undefined;
    trackerValue5Name?: string | undefined;
    trackerValue5TypeEnum?: TrackerValue5TypeEnum | undefined;
    trackerValue5?: string | undefined;
    trackerValue6Name?: string | undefined;
    trackerValue6TypeEnum?: TrackerValue6TypeEnum | undefined;
    trackerValue6?: string | undefined;
    trackerValue7Name?: string | undefined;
    trackerValue7TypeEnum?: TrackerValue7TypeEnum | undefined;
    trackerValue7?: string | undefined;
    trackerValue8Name?: string | undefined;
    trackerValue8TypeEnum?: TrackerValue8TypeEnum | undefined;
    trackerValue8?: string | undefined;
    trackerValue9Name?: string | undefined;
    trackerValue9TypeEnum?: TrackerValue9TypeEnum | undefined;
    trackerValue9?: string | undefined;
    trackerValue10Name?: string | undefined;
    trackerValue10TypeEnum?: TrackerValue10TypeEnum | undefined;
    trackerValue10?: string | undefined;
    trackerValue11Name?: string | undefined;
    trackerValue11TypeEnum?: TrackerValue11TypeEnum | undefined;
    trackerValue11?: string | undefined;
    trackerValue12Name?: string | undefined;
    trackerValue12TypeEnum?: TrackerValue12TypeEnum | undefined;
    trackerValue12?: string | undefined;
    trackerValue13Name?: string | undefined;
    trackerValue13TypeEnum?: TrackerValue13TypeEnum | undefined;
    trackerValue13?: string | undefined;
    trackerValue14Name?: string | undefined;
    trackerValue14TypeEnum?: TrackerValue14TypeEnum | undefined;
    trackerValue14?: string | undefined;
    trackerValue15Name?: string | undefined;
    trackerValue15TypeEnum?: TrackerValue15TypeEnum | undefined;
    trackerValue15?: string | undefined;
    trackerValue16Name?: string | undefined;
    trackerValue16TypeEnum?: TrackerValue16TypeEnum | undefined;
    trackerValue16?: string | undefined;
    trackerValue17Name?: string | undefined;
    trackerValue17TypeEnum?: TrackerValue17TypeEnum | undefined;
    trackerValue17?: string | undefined;
    trackerValue18Name?: string | undefined;
    trackerValue18TypeEnum?: TrackerValue18TypeEnum | undefined;
    trackerValue18?: string | undefined;
    trackerValue19Name?: string | undefined;
    trackerValue19TypeEnum?: TrackerValue19TypeEnum | undefined;
    trackerValue19?: string | undefined;
    trackerValue20Name?: string | undefined;
    trackerValue20TypeEnum?: TrackerValue20TypeEnum | undefined;
    trackerValue20?: string | undefined;
    trackerDate: Date;
    trackerSourceEnum: TrackerSourceEnum;
    notes?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrConsultID?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrTracker?: PHRTracker | undefined;
    phrTrackerDetailTags?: PHRTrackerDetailTag[] | undefined;
    patientID?: string;
    verifiedByProviderName?: string | undefined;
}

export enum TrackerValue1TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue2TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue3TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue4TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue5TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue6TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue7TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue8TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue9TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue10TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue11TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue12TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue13TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue14TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue15TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue16TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue17TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue18TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue19TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerValue20TypeEnum {
    NotSet = "NotSet",
    NumberValue = "NumberValue",
    StringValue = "StringValue",
    DateValue = "DateValue",
    MoneyValue = "MoneyValue",
    PositiveNegativeInvalid = "PositiveNegativeInvalid",
    Boolean = "Boolean",
    Guid = "Guid",
}

export enum TrackerSourceEnum {
    Manual = "Manual",
    Device = "Device",
}

export class PHRTrackerDetailTag extends PHRBase implements IPHRTrackerDetailTag {
    phrTrackerDetailTagID!: string;
    phrTrackerDetailID!: string;
    tagID!: string;
    phrAccessRequested?: PatientAccessEnum;
    phrTrackerDetail?: PHRTrackerDetail | undefined;
    patientID?: string;
    tag?: Tag | undefined;

    constructor(data?: IPHRTrackerDetailTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrTrackerDetailTagID = _data["phrTrackerDetailTagID"];
            this.phrTrackerDetailID = _data["phrTrackerDetailID"];
            this.tagID = _data["tagID"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrTrackerDetail = _data["phrTrackerDetail"] ? PHRTrackerDetail.fromJS(_data["phrTrackerDetail"]) : <any>undefined;
            this.patientID = _data["patientID"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PHRTrackerDetailTag {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerDetailTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrTrackerDetailTagID"] = this.phrTrackerDetailTagID;
        data["phrTrackerDetailID"] = this.phrTrackerDetailID;
        data["tagID"] = this.tagID;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrTrackerDetail"] = this.phrTrackerDetail ? this.phrTrackerDetail.toJSON() : <any>undefined;
        data["patientID"] = this.patientID;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerDetailTag extends IPHRBase {
    phrTrackerDetailTagID: string;
    phrTrackerDetailID: string;
    tagID: string;
    phrAccessRequested?: PatientAccessEnum;
    phrTrackerDetail?: PHRTrackerDetail | undefined;
    patientID?: string;
    tag?: Tag | undefined;
}

export enum TrackerCategoryEnum {
    Vitals = "Vital Signs Monitoring",
    MentalAndWellBeing = "Mental Health and Well-Being Trackers",
    Physical = "Physical Health Trackers",
    Tests = "Tests",
}

export class PHRVaccination extends PHRBase implements IPHRVaccination {
    phrVaccinationID!: string;
    patientID!: string;
    name?: string | undefined;
    vaccinationDate!: Date;
    vaccineTypeEnum!: VaccineTypeEnum;
    manufacturerName?: string | undefined;
    manufacturerTagID?: string | undefined;
    location?: string | undefined;
    lotNumber?: string | undefined;
    frontPHRDocumentID?: string | undefined;
    backPHRDocumentID?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    manufacturerTag?: Tag | undefined;
    verifiedByProviderName?: string | undefined;
    frontPHRDocument?: PHRDocument | undefined;
    backPHRDocument?: PHRDocument | undefined;

    constructor(data?: IPHRVaccination) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrVaccinationID = _data["phrVaccinationID"];
            this.patientID = _data["patientID"];
            this.name = _data["name"];
            this.vaccinationDate = _data["vaccinationDate"] ? new Date(_data["vaccinationDate"].toString()) : <any>undefined;
            this.vaccineTypeEnum = _data["vaccineTypeEnum"];
            this.manufacturerName = _data["manufacturerName"];
            this.manufacturerTagID = _data["manufacturerTagID"];
            this.location = _data["location"];
            this.lotNumber = _data["lotNumber"];
            this.frontPHRDocumentID = _data["frontPHRDocumentID"];
            this.backPHRDocumentID = _data["backPHRDocumentID"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.manufacturerTag = _data["manufacturerTag"] ? Tag.fromJS(_data["manufacturerTag"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
            this.frontPHRDocument = _data["frontPHRDocument"] ? PHRDocument.fromJS(_data["frontPHRDocument"]) : <any>undefined;
            this.backPHRDocument = _data["backPHRDocument"] ? PHRDocument.fromJS(_data["backPHRDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PHRVaccination {
        data = typeof data === 'object' ? data : {};
        let result = new PHRVaccination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrVaccinationID"] = this.phrVaccinationID;
        data["patientID"] = this.patientID;
        data["name"] = this.name;
        data["vaccinationDate"] = this.vaccinationDate ? this.vaccinationDate.toISOString() : <any>undefined;
        data["vaccineTypeEnum"] = this.vaccineTypeEnum;
        data["manufacturerName"] = this.manufacturerName;
        data["manufacturerTagID"] = this.manufacturerTagID;
        data["location"] = this.location;
        data["lotNumber"] = this.lotNumber;
        data["frontPHRDocumentID"] = this.frontPHRDocumentID;
        data["backPHRDocumentID"] = this.backPHRDocumentID;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["manufacturerTag"] = this.manufacturerTag ? this.manufacturerTag.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        data["frontPHRDocument"] = this.frontPHRDocument ? this.frontPHRDocument.toJSON() : <any>undefined;
        data["backPHRDocument"] = this.backPHRDocument ? this.backPHRDocument.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRVaccination extends IPHRBase {
    phrVaccinationID: string;
    patientID: string;
    name?: string | undefined;
    vaccinationDate: Date;
    vaccineTypeEnum: VaccineTypeEnum;
    manufacturerName?: string | undefined;
    manufacturerTagID?: string | undefined;
    location?: string | undefined;
    lotNumber?: string | undefined;
    frontPHRDocumentID?: string | undefined;
    backPHRDocumentID?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    manufacturerTag?: Tag | undefined;
    verifiedByProviderName?: string | undefined;
    frontPHRDocument?: PHRDocument | undefined;
    backPHRDocument?: PHRDocument | undefined;
}

export enum VaccineTypeEnum {
    NotSet = "NotSet",
    Covid = "Covid",
    Other = "Other",
}

export class PHRWomenHealth extends PHRBase implements IPHRWomenHealth {
    phrWomenHealthID!: string;
    patientID!: string;
    hasFamilyHistoryBreastDisease!: boolean;
    familyHistoryBreastDiseaseNotes?: string | undefined;
    hadPreviousMammograms!: boolean;
    previousMammogramsNotes?: string | undefined;
    gynecologicalConditions?: string | undefined;
    cycleFirstAge?: number | undefined;
    cycleAverageDuration?: number | undefined;
    cycleFrequency?: number | undefined;
    cyclePainLevel?: string | undefined;
    cycleFlow?: string | undefined;
    papSmearTestDate?: Date | undefined;
    papSmearResults?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRWomenHealth) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrWomenHealthID = _data["phrWomenHealthID"];
            this.patientID = _data["patientID"];
            this.hasFamilyHistoryBreastDisease = _data["hasFamilyHistoryBreastDisease"];
            this.familyHistoryBreastDiseaseNotes = _data["familyHistoryBreastDiseaseNotes"];
            this.hadPreviousMammograms = _data["hadPreviousMammograms"];
            this.previousMammogramsNotes = _data["previousMammogramsNotes"];
            this.gynecologicalConditions = _data["gynecologicalConditions"];
            this.cycleFirstAge = _data["cycleFirstAge"];
            this.cycleAverageDuration = _data["cycleAverageDuration"];
            this.cycleFrequency = _data["cycleFrequency"];
            this.cyclePainLevel = _data["cyclePainLevel"];
            this.cycleFlow = _data["cycleFlow"];
            this.papSmearTestDate = _data["papSmearTestDate"] ? new Date(_data["papSmearTestDate"].toString()) : <any>undefined;
            this.papSmearResults = _data["papSmearResults"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrPatient = _data["phrPatient"] ? PHRPatient.fromJS(_data["phrPatient"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRWomenHealth {
        data = typeof data === 'object' ? data : {};
        let result = new PHRWomenHealth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrWomenHealthID"] = this.phrWomenHealthID;
        data["patientID"] = this.patientID;
        data["hasFamilyHistoryBreastDisease"] = this.hasFamilyHistoryBreastDisease;
        data["familyHistoryBreastDiseaseNotes"] = this.familyHistoryBreastDiseaseNotes;
        data["hadPreviousMammograms"] = this.hadPreviousMammograms;
        data["previousMammogramsNotes"] = this.previousMammogramsNotes;
        data["gynecologicalConditions"] = this.gynecologicalConditions;
        data["cycleFirstAge"] = this.cycleFirstAge;
        data["cycleAverageDuration"] = this.cycleAverageDuration;
        data["cycleFrequency"] = this.cycleFrequency;
        data["cyclePainLevel"] = this.cyclePainLevel;
        data["cycleFlow"] = this.cycleFlow;
        data["papSmearTestDate"] = this.papSmearTestDate ? this.papSmearTestDate.toISOString() : <any>undefined;
        data["papSmearResults"] = this.papSmearResults;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrPatient"] = this.phrPatient ? this.phrPatient.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRWomenHealth extends IPHRBase {
    phrWomenHealthID: string;
    patientID: string;
    hasFamilyHistoryBreastDisease: boolean;
    familyHistoryBreastDiseaseNotes?: string | undefined;
    hadPreviousMammograms: boolean;
    previousMammogramsNotes?: string | undefined;
    gynecologicalConditions?: string | undefined;
    cycleFirstAge?: number | undefined;
    cycleAverageDuration?: number | undefined;
    cycleFrequency?: number | undefined;
    cyclePainLevel?: string | undefined;
    cycleFlow?: string | undefined;
    papSmearTestDate?: Date | undefined;
    papSmearResults?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrPatient?: PHRPatient | undefined;
    verifiedByProviderName?: string | undefined;
}

export class PHRForm extends PHRBase implements IPHRForm {
    phrFormID!: string;
    patientID!: string;
    formID!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    formStatusEnum!: FormStatusEnum;
    assignedByUserDetailID?: string | undefined;
    totalScore?: number | undefined;
    scoreNotes?: string | undefined;
    notes?: string | undefined;
    feedbackID?: string | undefined;
    phrConsultID?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrFormQuestions?: PHRFormQuestion[] | undefined;
    verifiedByProviderName?: string | undefined;

    constructor(data?: IPHRForm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrFormID = _data["phrFormID"];
            this.patientID = _data["patientID"];
            this.formID = _data["formID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.formStatusEnum = _data["formStatusEnum"];
            this.assignedByUserDetailID = _data["assignedByUserDetailID"];
            this.totalScore = _data["totalScore"];
            this.scoreNotes = _data["scoreNotes"];
            this.notes = _data["notes"];
            this.feedbackID = _data["feedbackID"];
            this.phrConsultID = _data["phrConsultID"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.phrAccessRequested = _data["phrAccessRequested"];
            if (Array.isArray(_data["phrFormQuestions"])) {
                this.phrFormQuestions = [] as any;
                for (let item of _data["phrFormQuestions"])
                    this.phrFormQuestions!.push(PHRFormQuestion.fromJS(item));
            }
            this.verifiedByProviderName = _data["verifiedByProviderName"];
        }
    }

    static fromJS(data: any): PHRForm {
        data = typeof data === 'object' ? data : {};
        let result = new PHRForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrFormID"] = this.phrFormID;
        data["patientID"] = this.patientID;
        data["formID"] = this.formID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["formStatusEnum"] = this.formStatusEnum;
        data["assignedByUserDetailID"] = this.assignedByUserDetailID;
        data["totalScore"] = this.totalScore;
        data["scoreNotes"] = this.scoreNotes;
        data["notes"] = this.notes;
        data["feedbackID"] = this.feedbackID;
        data["phrConsultID"] = this.phrConsultID;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["phrAccessRequested"] = this.phrAccessRequested;
        if (Array.isArray(this.phrFormQuestions)) {
            data["phrFormQuestions"] = [];
            for (let item of this.phrFormQuestions)
                data["phrFormQuestions"].push(item.toJSON());
        }
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRForm extends IPHRBase {
    phrFormID: string;
    patientID: string;
    formID: string;
    startDate: Date;
    endDate?: Date | undefined;
    formStatusEnum: FormStatusEnum;
    assignedByUserDetailID?: string | undefined;
    totalScore?: number | undefined;
    scoreNotes?: string | undefined;
    notes?: string | undefined;
    feedbackID?: string | undefined;
    phrConsultID?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrFormQuestions?: PHRFormQuestion[] | undefined;
    verifiedByProviderName?: string | undefined;
}

export enum FormStatusEnum {
    NotStarted = "NotStarted",
    Started = "Started",
    InProgress = "InProgress",
    Complete = "Complete",
    Scored = "Scored",
}

export class PHRFormQuestion extends PHRBase implements IPHRFormQuestion {
    phrFormQuestionID!: string;
    phrFormID!: string;
    formQuestionID!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    value?: string | undefined;
    score?: number | undefined;
    feedbackID?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrFormQuestionChoices?: PHRFormQuestionChoice[] | undefined;
    phrForm?: PHRForm | undefined;
    patientID?: string;

    constructor(data?: IPHRFormQuestion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrFormQuestionID = _data["phrFormQuestionID"];
            this.phrFormID = _data["phrFormID"];
            this.formQuestionID = _data["formQuestionID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.value = _data["value"];
            this.score = _data["score"];
            this.feedbackID = _data["feedbackID"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            if (Array.isArray(_data["phrFormQuestionChoices"])) {
                this.phrFormQuestionChoices = [] as any;
                for (let item of _data["phrFormQuestionChoices"])
                    this.phrFormQuestionChoices!.push(PHRFormQuestionChoice.fromJS(item));
            }
            this.phrForm = _data["phrForm"] ? PHRForm.fromJS(_data["phrForm"]) : <any>undefined;
            this.patientID = _data["patientID"];
        }
    }

    static fromJS(data: any): PHRFormQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new PHRFormQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrFormQuestionID"] = this.phrFormQuestionID;
        data["phrFormID"] = this.phrFormID;
        data["formQuestionID"] = this.formQuestionID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["score"] = this.score;
        data["feedbackID"] = this.feedbackID;
        data["phrAccessRequested"] = this.phrAccessRequested;
        if (Array.isArray(this.phrFormQuestionChoices)) {
            data["phrFormQuestionChoices"] = [];
            for (let item of this.phrFormQuestionChoices)
                data["phrFormQuestionChoices"].push(item.toJSON());
        }
        data["phrForm"] = this.phrForm ? this.phrForm.toJSON() : <any>undefined;
        data["patientID"] = this.patientID;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRFormQuestion extends IPHRBase {
    phrFormQuestionID: string;
    phrFormID: string;
    formQuestionID: string;
    startDate: Date;
    endDate?: Date | undefined;
    value?: string | undefined;
    score?: number | undefined;
    feedbackID?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrFormQuestionChoices?: PHRFormQuestionChoice[] | undefined;
    phrForm?: PHRForm | undefined;
    patientID?: string;
}

export class PHRFormQuestionChoice extends PHRBase implements IPHRFormQuestionChoice {
    phrFormQuestionChoiceID!: string;
    phrFormQuestionID!: string;
    formQuestionChoiceID!: string;
    phrAccessRequested?: PatientAccessEnum;
    phrFormQuestion?: PHRFormQuestion | undefined;
    patientID?: string;

    constructor(data?: IPHRFormQuestionChoice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrFormQuestionChoiceID = _data["phrFormQuestionChoiceID"];
            this.phrFormQuestionID = _data["phrFormQuestionID"];
            this.formQuestionChoiceID = _data["formQuestionChoiceID"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrFormQuestion = _data["phrFormQuestion"] ? PHRFormQuestion.fromJS(_data["phrFormQuestion"]) : <any>undefined;
            this.patientID = _data["patientID"];
        }
    }

    static fromJS(data: any): PHRFormQuestionChoice {
        data = typeof data === 'object' ? data : {};
        let result = new PHRFormQuestionChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrFormQuestionChoiceID"] = this.phrFormQuestionChoiceID;
        data["phrFormQuestionID"] = this.phrFormQuestionID;
        data["formQuestionChoiceID"] = this.formQuestionChoiceID;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrFormQuestion"] = this.phrFormQuestion ? this.phrFormQuestion.toJSON() : <any>undefined;
        data["patientID"] = this.patientID;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRFormQuestionChoice extends IPHRBase {
    phrFormQuestionChoiceID: string;
    phrFormQuestionID: string;
    formQuestionChoiceID: string;
    phrAccessRequested?: PatientAccessEnum;
    phrFormQuestion?: PHRFormQuestion | undefined;
    patientID?: string;
}

export class PHRMedicationReminder extends PHRBase implements IPHRMedicationReminder {
    phrMedicationReminderID!: string;
    phrMedicationID!: string;
    name!: string;
    enabled!: boolean;
    timeOfDay24!: string;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrMedication?: PHRMedication | undefined;
    patientID?: string;

    constructor(data?: IPHRMedicationReminder) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phrMedicationReminderID = _data["phrMedicationReminderID"];
            this.phrMedicationID = _data["phrMedicationID"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.timeOfDay24 = _data["timeOfDay24"];
            this.notes = _data["notes"];
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrMedication = _data["phrMedication"] ? PHRMedication.fromJS(_data["phrMedication"]) : <any>undefined;
            this.patientID = _data["patientID"];
        }
    }

    static fromJS(data: any): PHRMedicationReminder {
        data = typeof data === 'object' ? data : {};
        let result = new PHRMedicationReminder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrMedicationReminderID"] = this.phrMedicationReminderID;
        data["phrMedicationID"] = this.phrMedicationID;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["timeOfDay24"] = this.timeOfDay24;
        data["notes"] = this.notes;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrMedication"] = this.phrMedication ? this.phrMedication.toJSON() : <any>undefined;
        data["patientID"] = this.patientID;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRMedicationReminder extends IPHRBase {
    phrMedicationReminderID: string;
    phrMedicationID: string;
    name: string;
    enabled: boolean;
    timeOfDay24: string;
    notes?: string | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrMedication?: PHRMedication | undefined;
    patientID?: string;
}

export class Invoice extends EntityBase implements IInvoice {
    invoiceID!: string;
    invoiceNo!: number;
    userDetailID!: string;
    invoiceTypeEnum!: InvoiceTypeEnum;
    invoiceStatusEnum!: InvoiceStatusEnum;
    refundedInvoiceID?: string | undefined;
    invoiceDate!: Date;
    currencyEnum!: CurrencyEnum;
    comments?: string | undefined;
    taxTotalAmount!: number;
    totalAmount!: number;
    totalPayment!: number;
    fileDetailID?: string | undefined;
    companyName?: string | undefined;
    companyEmailAddress?: string | undefined;
    companyAddressLine1?: string | undefined;
    companyAddressLine2?: string | undefined;
    companyCity?: string | undefined;
    companyProvince?: string | undefined;
    companyPostCode?: string | undefined;
    companyCountry?: string | undefined;
    companyPhone?: string | undefined;
    customerName?: string | undefined;
    customerEmailAddress?: string | undefined;
    customerAddressLine1?: string | undefined;
    customerAddressLine2?: string | undefined;
    customerCity?: string | undefined;
    customerProvince?: string | undefined;
    customerPostCode?: string | undefined;
    customerCountry?: string | undefined;
    customerPhone?: string | undefined;
    taxLabel!: string;
    couponCode?: string | undefined;
    couponID?: string | undefined;
    couponAmount?: number | undefined;
    recurringPaymentID?: string | undefined;
    currencyExchangeInvoiceID?: string | undefined;
    currencyExchangeToCurrencyEnum?: CurrencyEnum | undefined;
    currencyExchangeToAmount?: number | undefined;
    currencyExchangeRate?: number | undefined;
    glTransaction?: GLTransaction | undefined;
    refundedGLTransaction?: GLTransaction | undefined;
    invoiceStoreItems?: InvoiceStoreItem[] | undefined;
    invoicePayments?: InvoicePayment[] | undefined;
    coupon?: Coupon | undefined;

    constructor(data?: IInvoice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceID = _data["invoiceID"];
            this.invoiceNo = _data["invoiceNo"];
            this.userDetailID = _data["userDetailID"];
            this.invoiceTypeEnum = _data["invoiceTypeEnum"];
            this.invoiceStatusEnum = _data["invoiceStatusEnum"];
            this.refundedInvoiceID = _data["refundedInvoiceID"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.currencyEnum = _data["currencyEnum"];
            this.comments = _data["comments"];
            this.taxTotalAmount = _data["taxTotalAmount"];
            this.totalAmount = _data["totalAmount"];
            this.totalPayment = _data["totalPayment"];
            this.fileDetailID = _data["fileDetailID"];
            this.companyName = _data["companyName"];
            this.companyEmailAddress = _data["companyEmailAddress"];
            this.companyAddressLine1 = _data["companyAddressLine1"];
            this.companyAddressLine2 = _data["companyAddressLine2"];
            this.companyCity = _data["companyCity"];
            this.companyProvince = _data["companyProvince"];
            this.companyPostCode = _data["companyPostCode"];
            this.companyCountry = _data["companyCountry"];
            this.companyPhone = _data["companyPhone"];
            this.customerName = _data["customerName"];
            this.customerEmailAddress = _data["customerEmailAddress"];
            this.customerAddressLine1 = _data["customerAddressLine1"];
            this.customerAddressLine2 = _data["customerAddressLine2"];
            this.customerCity = _data["customerCity"];
            this.customerProvince = _data["customerProvince"];
            this.customerPostCode = _data["customerPostCode"];
            this.customerCountry = _data["customerCountry"];
            this.customerPhone = _data["customerPhone"];
            this.taxLabel = _data["taxLabel"];
            this.couponCode = _data["couponCode"];
            this.couponID = _data["couponID"];
            this.couponAmount = _data["couponAmount"];
            this.recurringPaymentID = _data["recurringPaymentID"];
            this.currencyExchangeInvoiceID = _data["currencyExchangeInvoiceID"];
            this.currencyExchangeToCurrencyEnum = _data["currencyExchangeToCurrencyEnum"];
            this.currencyExchangeToAmount = _data["currencyExchangeToAmount"];
            this.currencyExchangeRate = _data["currencyExchangeRate"];
            this.glTransaction = _data["glTransaction"] ? GLTransaction.fromJS(_data["glTransaction"]) : <any>undefined;
            this.refundedGLTransaction = _data["refundedGLTransaction"] ? GLTransaction.fromJS(_data["refundedGLTransaction"]) : <any>undefined;
            if (Array.isArray(_data["invoiceStoreItems"])) {
                this.invoiceStoreItems = [] as any;
                for (let item of _data["invoiceStoreItems"])
                    this.invoiceStoreItems!.push(InvoiceStoreItem.fromJS(item));
            }
            if (Array.isArray(_data["invoicePayments"])) {
                this.invoicePayments = [] as any;
                for (let item of _data["invoicePayments"])
                    this.invoicePayments!.push(InvoicePayment.fromJS(item));
            }
            this.coupon = _data["coupon"] ? Coupon.fromJS(_data["coupon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceID"] = this.invoiceID;
        data["invoiceNo"] = this.invoiceNo;
        data["userDetailID"] = this.userDetailID;
        data["invoiceTypeEnum"] = this.invoiceTypeEnum;
        data["invoiceStatusEnum"] = this.invoiceStatusEnum;
        data["refundedInvoiceID"] = this.refundedInvoiceID;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["currencyEnum"] = this.currencyEnum;
        data["comments"] = this.comments;
        data["taxTotalAmount"] = this.taxTotalAmount;
        data["totalAmount"] = this.totalAmount;
        data["totalPayment"] = this.totalPayment;
        data["fileDetailID"] = this.fileDetailID;
        data["companyName"] = this.companyName;
        data["companyEmailAddress"] = this.companyEmailAddress;
        data["companyAddressLine1"] = this.companyAddressLine1;
        data["companyAddressLine2"] = this.companyAddressLine2;
        data["companyCity"] = this.companyCity;
        data["companyProvince"] = this.companyProvince;
        data["companyPostCode"] = this.companyPostCode;
        data["companyCountry"] = this.companyCountry;
        data["companyPhone"] = this.companyPhone;
        data["customerName"] = this.customerName;
        data["customerEmailAddress"] = this.customerEmailAddress;
        data["customerAddressLine1"] = this.customerAddressLine1;
        data["customerAddressLine2"] = this.customerAddressLine2;
        data["customerCity"] = this.customerCity;
        data["customerProvince"] = this.customerProvince;
        data["customerPostCode"] = this.customerPostCode;
        data["customerCountry"] = this.customerCountry;
        data["customerPhone"] = this.customerPhone;
        data["taxLabel"] = this.taxLabel;
        data["couponCode"] = this.couponCode;
        data["couponID"] = this.couponID;
        data["couponAmount"] = this.couponAmount;
        data["recurringPaymentID"] = this.recurringPaymentID;
        data["currencyExchangeInvoiceID"] = this.currencyExchangeInvoiceID;
        data["currencyExchangeToCurrencyEnum"] = this.currencyExchangeToCurrencyEnum;
        data["currencyExchangeToAmount"] = this.currencyExchangeToAmount;
        data["currencyExchangeRate"] = this.currencyExchangeRate;
        data["glTransaction"] = this.glTransaction ? this.glTransaction.toJSON() : <any>undefined;
        data["refundedGLTransaction"] = this.refundedGLTransaction ? this.refundedGLTransaction.toJSON() : <any>undefined;
        if (Array.isArray(this.invoiceStoreItems)) {
            data["invoiceStoreItems"] = [];
            for (let item of this.invoiceStoreItems)
                data["invoiceStoreItems"].push(item.toJSON());
        }
        if (Array.isArray(this.invoicePayments)) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoice extends IEntityBase {
    invoiceID: string;
    invoiceNo: number;
    userDetailID: string;
    invoiceTypeEnum: InvoiceTypeEnum;
    invoiceStatusEnum: InvoiceStatusEnum;
    refundedInvoiceID?: string | undefined;
    invoiceDate: Date;
    currencyEnum: CurrencyEnum;
    comments?: string | undefined;
    taxTotalAmount: number;
    totalAmount: number;
    totalPayment: number;
    fileDetailID?: string | undefined;
    companyName?: string | undefined;
    companyEmailAddress?: string | undefined;
    companyAddressLine1?: string | undefined;
    companyAddressLine2?: string | undefined;
    companyCity?: string | undefined;
    companyProvince?: string | undefined;
    companyPostCode?: string | undefined;
    companyCountry?: string | undefined;
    companyPhone?: string | undefined;
    customerName?: string | undefined;
    customerEmailAddress?: string | undefined;
    customerAddressLine1?: string | undefined;
    customerAddressLine2?: string | undefined;
    customerCity?: string | undefined;
    customerProvince?: string | undefined;
    customerPostCode?: string | undefined;
    customerCountry?: string | undefined;
    customerPhone?: string | undefined;
    taxLabel: string;
    couponCode?: string | undefined;
    couponID?: string | undefined;
    couponAmount?: number | undefined;
    recurringPaymentID?: string | undefined;
    currencyExchangeInvoiceID?: string | undefined;
    currencyExchangeToCurrencyEnum?: CurrencyEnum | undefined;
    currencyExchangeToAmount?: number | undefined;
    currencyExchangeRate?: number | undefined;
    glTransaction?: GLTransaction | undefined;
    refundedGLTransaction?: GLTransaction | undefined;
    invoiceStoreItems?: InvoiceStoreItem[] | undefined;
    invoicePayments?: InvoicePayment[] | undefined;
    coupon?: Coupon | undefined;
}

export enum InvoiceTypeEnum {
    SaleInvoice = "SaleInvoice",
    Refund = "Refund",
    ShoppingCart = "ShoppingCart",
    Pending = "Pending",
    RecurringPayment = "RecurringPayment",
    CurrencyExchange = "CurrencyExchange",
    Donation = "Donation",
}

export enum InvoiceStatusEnum {
    Draft = "Draft",
    Paid = "Paid",
    Committed = "Committed",
    Cancelled = "Cancelled",
}

export class GLTransaction extends EntityBase implements IGLTransaction {
    glTransactionID!: string;
    glTransactionTypeEnum!: GLTransactionTypeEnum;
    transactionDate!: Date;
    invoiceID?: string | undefined;
    amount!: number;
    description!: string;
    otherDetails?: string | undefined;
    glTransactionAccounts?: GLTransactionAccount[] | undefined;
    glUserDetailTransactions?: GLUserDetailTransaction[] | undefined;

    constructor(data?: IGLTransaction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.glTransactionID = _data["glTransactionID"];
            this.glTransactionTypeEnum = _data["glTransactionTypeEnum"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.invoiceID = _data["invoiceID"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.otherDetails = _data["otherDetails"];
            if (Array.isArray(_data["glTransactionAccounts"])) {
                this.glTransactionAccounts = [] as any;
                for (let item of _data["glTransactionAccounts"])
                    this.glTransactionAccounts!.push(GLTransactionAccount.fromJS(item));
            }
            if (Array.isArray(_data["glUserDetailTransactions"])) {
                this.glUserDetailTransactions = [] as any;
                for (let item of _data["glUserDetailTransactions"])
                    this.glUserDetailTransactions!.push(GLUserDetailTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GLTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new GLTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["glTransactionID"] = this.glTransactionID;
        data["glTransactionTypeEnum"] = this.glTransactionTypeEnum;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["invoiceID"] = this.invoiceID;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["otherDetails"] = this.otherDetails;
        if (Array.isArray(this.glTransactionAccounts)) {
            data["glTransactionAccounts"] = [];
            for (let item of this.glTransactionAccounts)
                data["glTransactionAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.glUserDetailTransactions)) {
            data["glUserDetailTransactions"] = [];
            for (let item of this.glUserDetailTransactions)
                data["glUserDetailTransactions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGLTransaction extends IEntityBase {
    glTransactionID: string;
    glTransactionTypeEnum: GLTransactionTypeEnum;
    transactionDate: Date;
    invoiceID?: string | undefined;
    amount: number;
    description: string;
    otherDetails?: string | undefined;
    glTransactionAccounts?: GLTransactionAccount[] | undefined;
    glUserDetailTransactions?: GLUserDetailTransaction[] | undefined;
}

export enum GLTransactionTypeEnum {
    SaleInvoice = "SaleInvoice",
    Refund = "Refund",
}

export class GLTransactionAccount extends EntityBase implements IGLTransactionAccount {
    glTransactionAccountID!: string;
    glTransactionID!: string;
    glAccountID!: string;
    amount!: number;
    exportedDate?: Date | undefined;
    statementID?: string | undefined;
    glAccount?: GLAccount | undefined;
    glTransaction?: GLTransaction | undefined;

    constructor(data?: IGLTransactionAccount) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.glTransactionAccountID = _data["glTransactionAccountID"];
            this.glTransactionID = _data["glTransactionID"];
            this.glAccountID = _data["glAccountID"];
            this.amount = _data["amount"];
            this.exportedDate = _data["exportedDate"] ? new Date(_data["exportedDate"].toString()) : <any>undefined;
            this.statementID = _data["statementID"];
            this.glAccount = _data["glAccount"] ? GLAccount.fromJS(_data["glAccount"]) : <any>undefined;
            this.glTransaction = _data["glTransaction"] ? GLTransaction.fromJS(_data["glTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GLTransactionAccount {
        data = typeof data === 'object' ? data : {};
        let result = new GLTransactionAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["glTransactionAccountID"] = this.glTransactionAccountID;
        data["glTransactionID"] = this.glTransactionID;
        data["glAccountID"] = this.glAccountID;
        data["amount"] = this.amount;
        data["exportedDate"] = this.exportedDate ? this.exportedDate.toISOString() : <any>undefined;
        data["statementID"] = this.statementID;
        data["glAccount"] = this.glAccount ? this.glAccount.toJSON() : <any>undefined;
        data["glTransaction"] = this.glTransaction ? this.glTransaction.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGLTransactionAccount extends IEntityBase {
    glTransactionAccountID: string;
    glTransactionID: string;
    glAccountID: string;
    amount: number;
    exportedDate?: Date | undefined;
    statementID?: string | undefined;
    glAccount?: GLAccount | undefined;
    glTransaction?: GLTransaction | undefined;
}

export class GLAccount extends EntityBase implements IGLAccount {
    glAccountID!: string;
    glAccountGroupID?: string | undefined;
    glAccountTypeEnum!: GLAccountTypeEnum;
    name!: string;
    currencyEnum!: CurrencyEnum;
    description!: string;
    externalID?: string | undefined;
    userDetailID?: string | undefined;
    glAccountGroup?: GLAccountGroup | undefined;

    constructor(data?: IGLAccount) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.glAccountID = _data["glAccountID"];
            this.glAccountGroupID = _data["glAccountGroupID"];
            this.glAccountTypeEnum = _data["glAccountTypeEnum"];
            this.name = _data["name"];
            this.currencyEnum = _data["currencyEnum"];
            this.description = _data["description"];
            this.externalID = _data["externalID"];
            this.userDetailID = _data["userDetailID"];
            this.glAccountGroup = _data["glAccountGroup"] ? GLAccountGroup.fromJS(_data["glAccountGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GLAccount {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["glAccountID"] = this.glAccountID;
        data["glAccountGroupID"] = this.glAccountGroupID;
        data["glAccountTypeEnum"] = this.glAccountTypeEnum;
        data["name"] = this.name;
        data["currencyEnum"] = this.currencyEnum;
        data["description"] = this.description;
        data["externalID"] = this.externalID;
        data["userDetailID"] = this.userDetailID;
        data["glAccountGroup"] = this.glAccountGroup ? this.glAccountGroup.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGLAccount extends IEntityBase {
    glAccountID: string;
    glAccountGroupID?: string | undefined;
    glAccountTypeEnum: GLAccountTypeEnum;
    name: string;
    currencyEnum: CurrencyEnum;
    description: string;
    externalID?: string | undefined;
    userDetailID?: string | undefined;
    glAccountGroup?: GLAccountGroup | undefined;
}

export enum GLAccountTypeEnum {
    Notset = "Notset",
    Asset = "Asset",
    Capital = "Capital",
    Expense = "Expense",
    Liability = "Liability",
    Revenue = "Revenue",
}

export class GLAccountGroup extends EntityBase implements IGLAccountGroup {
    glAccountGroupID!: string;
    name!: string;
    description!: string;

    constructor(data?: IGLAccountGroup) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.glAccountGroupID = _data["glAccountGroupID"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GLAccountGroup {
        data = typeof data === 'object' ? data : {};
        let result = new GLAccountGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["glAccountGroupID"] = this.glAccountGroupID;
        data["name"] = this.name;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IGLAccountGroup extends IEntityBase {
    glAccountGroupID: string;
    name: string;
    description: string;
}

export class GLUserDetailTransaction extends EntityBase implements IGLUserDetailTransaction {
    glUserDetailTransactionID!: string;
    glTransactionID!: string;
    userDetailID!: string;

    constructor(data?: IGLUserDetailTransaction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.glUserDetailTransactionID = _data["glUserDetailTransactionID"];
            this.glTransactionID = _data["glTransactionID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): GLUserDetailTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new GLUserDetailTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["glUserDetailTransactionID"] = this.glUserDetailTransactionID;
        data["glTransactionID"] = this.glTransactionID;
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IGLUserDetailTransaction extends IEntityBase {
    glUserDetailTransactionID: string;
    glTransactionID: string;
    userDetailID: string;
}

export class InvoiceStoreItem extends EntityBase implements IInvoiceStoreItem {
    invoiceStoreItemID!: string;
    invoiceID!: string;
    storeItemID!: string;
    taxID!: string;
    glAccountID!: string;
    quantity!: number;
    costAmount!: number;
    retailAmount!: number;
    taxAmount!: number;
    providerStoreItemID?: string | undefined;
    negatingStoreItemID?: string | undefined;
    isRefund!: boolean;
    subscriptionID?: string | undefined;
    taskItemID?: string | undefined;
    displayDetails?: string | undefined;
    refunded!: boolean;
    associatedID?: string | undefined;
    parentInvoiceStoreItemID?: string | undefined;
    declinedDate?: Date | undefined;
    declinedReason?: string | undefined;
    overrideItemName?: string | undefined;
    overrideItemDescription?: string | undefined;
    couponCode?: string | undefined;
    couponID?: string | undefined;
    couponAmount?: number | undefined;
    glAccount?: GLAccount | undefined;
    storeItem?: StoreItem | undefined;
    tax?: Tax | undefined;
    providerStoreItem?: ProviderStoreItem | undefined;
    invoice?: Invoice | undefined;
    itemTotalAmount?: number;
    itemTotalRetailAmount?: number;
    itemTotalCostAmount?: number;

    constructor(data?: IInvoiceStoreItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoiceStoreItemID = _data["invoiceStoreItemID"];
            this.invoiceID = _data["invoiceID"];
            this.storeItemID = _data["storeItemID"];
            this.taxID = _data["taxID"];
            this.glAccountID = _data["glAccountID"];
            this.quantity = _data["quantity"];
            this.costAmount = _data["costAmount"];
            this.retailAmount = _data["retailAmount"];
            this.taxAmount = _data["taxAmount"];
            this.providerStoreItemID = _data["providerStoreItemID"];
            this.negatingStoreItemID = _data["negatingStoreItemID"];
            this.isRefund = _data["isRefund"];
            this.subscriptionID = _data["subscriptionID"];
            this.taskItemID = _data["taskItemID"];
            this.displayDetails = _data["displayDetails"];
            this.refunded = _data["refunded"];
            this.associatedID = _data["associatedID"];
            this.parentInvoiceStoreItemID = _data["parentInvoiceStoreItemID"];
            this.declinedDate = _data["declinedDate"] ? new Date(_data["declinedDate"].toString()) : <any>undefined;
            this.declinedReason = _data["declinedReason"];
            this.overrideItemName = _data["overrideItemName"];
            this.overrideItemDescription = _data["overrideItemDescription"];
            this.couponCode = _data["couponCode"];
            this.couponID = _data["couponID"];
            this.couponAmount = _data["couponAmount"];
            this.glAccount = _data["glAccount"] ? GLAccount.fromJS(_data["glAccount"]) : <any>undefined;
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.tax = _data["tax"] ? Tax.fromJS(_data["tax"]) : <any>undefined;
            this.providerStoreItem = _data["providerStoreItem"] ? ProviderStoreItem.fromJS(_data["providerStoreItem"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.itemTotalAmount = _data["itemTotalAmount"];
            this.itemTotalRetailAmount = _data["itemTotalRetailAmount"];
            this.itemTotalCostAmount = _data["itemTotalCostAmount"];
        }
    }

    static fromJS(data: any): InvoiceStoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceStoreItemID"] = this.invoiceStoreItemID;
        data["invoiceID"] = this.invoiceID;
        data["storeItemID"] = this.storeItemID;
        data["taxID"] = this.taxID;
        data["glAccountID"] = this.glAccountID;
        data["quantity"] = this.quantity;
        data["costAmount"] = this.costAmount;
        data["retailAmount"] = this.retailAmount;
        data["taxAmount"] = this.taxAmount;
        data["providerStoreItemID"] = this.providerStoreItemID;
        data["negatingStoreItemID"] = this.negatingStoreItemID;
        data["isRefund"] = this.isRefund;
        data["subscriptionID"] = this.subscriptionID;
        data["taskItemID"] = this.taskItemID;
        data["displayDetails"] = this.displayDetails;
        data["refunded"] = this.refunded;
        data["associatedID"] = this.associatedID;
        data["parentInvoiceStoreItemID"] = this.parentInvoiceStoreItemID;
        data["declinedDate"] = this.declinedDate ? this.declinedDate.toISOString() : <any>undefined;
        data["declinedReason"] = this.declinedReason;
        data["overrideItemName"] = this.overrideItemName;
        data["overrideItemDescription"] = this.overrideItemDescription;
        data["couponCode"] = this.couponCode;
        data["couponID"] = this.couponID;
        data["couponAmount"] = this.couponAmount;
        data["glAccount"] = this.glAccount ? this.glAccount.toJSON() : <any>undefined;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        data["providerStoreItem"] = this.providerStoreItem ? this.providerStoreItem.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["itemTotalAmount"] = this.itemTotalAmount;
        data["itemTotalRetailAmount"] = this.itemTotalRetailAmount;
        data["itemTotalCostAmount"] = this.itemTotalCostAmount;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoiceStoreItem extends IEntityBase {
    invoiceStoreItemID: string;
    invoiceID: string;
    storeItemID: string;
    taxID: string;
    glAccountID: string;
    quantity: number;
    costAmount: number;
    retailAmount: number;
    taxAmount: number;
    providerStoreItemID?: string | undefined;
    negatingStoreItemID?: string | undefined;
    isRefund: boolean;
    subscriptionID?: string | undefined;
    taskItemID?: string | undefined;
    displayDetails?: string | undefined;
    refunded: boolean;
    associatedID?: string | undefined;
    parentInvoiceStoreItemID?: string | undefined;
    declinedDate?: Date | undefined;
    declinedReason?: string | undefined;
    overrideItemName?: string | undefined;
    overrideItemDescription?: string | undefined;
    couponCode?: string | undefined;
    couponID?: string | undefined;
    couponAmount?: number | undefined;
    glAccount?: GLAccount | undefined;
    storeItem?: StoreItem | undefined;
    tax?: Tax | undefined;
    providerStoreItem?: ProviderStoreItem | undefined;
    invoice?: Invoice | undefined;
    itemTotalAmount?: number;
    itemTotalRetailAmount?: number;
    itemTotalCostAmount?: number;
}

export class ProviderStoreItem extends EntityBase implements IProviderStoreItem {
    providerStoreItemID!: string;
    providerID!: string;
    storeItemID!: string;
    taxID!: string;
    glAccountID!: string;
    costAmount!: number;
    retailAmount!: number;
    minutes?: number | undefined;
    warningMinutes?: number | undefined;
    enabled!: boolean;
    allowWalkIn!: boolean;
    walkInTypeEnum!: WalkInTypeEnum;
    storeItem?: StoreItem | undefined;
    provider?: Provider | undefined;
    nextAvailableAppointmentDate?: Date | undefined;
    glAccount?: GLAccount | undefined;

    constructor(data?: IProviderStoreItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerStoreItemID = _data["providerStoreItemID"];
            this.providerID = _data["providerID"];
            this.storeItemID = _data["storeItemID"];
            this.taxID = _data["taxID"];
            this.glAccountID = _data["glAccountID"];
            this.costAmount = _data["costAmount"];
            this.retailAmount = _data["retailAmount"];
            this.minutes = _data["minutes"];
            this.warningMinutes = _data["warningMinutes"];
            this.enabled = _data["enabled"];
            this.allowWalkIn = _data["allowWalkIn"];
            this.walkInTypeEnum = _data["walkInTypeEnum"];
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.nextAvailableAppointmentDate = _data["nextAvailableAppointmentDate"] ? new Date(_data["nextAvailableAppointmentDate"].toString()) : <any>undefined;
            this.glAccount = _data["glAccount"] ? GLAccount.fromJS(_data["glAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderStoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderStoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerStoreItemID"] = this.providerStoreItemID;
        data["providerID"] = this.providerID;
        data["storeItemID"] = this.storeItemID;
        data["taxID"] = this.taxID;
        data["glAccountID"] = this.glAccountID;
        data["costAmount"] = this.costAmount;
        data["retailAmount"] = this.retailAmount;
        data["minutes"] = this.minutes;
        data["warningMinutes"] = this.warningMinutes;
        data["enabled"] = this.enabled;
        data["allowWalkIn"] = this.allowWalkIn;
        data["walkInTypeEnum"] = this.walkInTypeEnum;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["nextAvailableAppointmentDate"] = this.nextAvailableAppointmentDate ? this.nextAvailableAppointmentDate.toISOString() : <any>undefined;
        data["glAccount"] = this.glAccount ? this.glAccount.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderStoreItem extends IEntityBase {
    providerStoreItemID: string;
    providerID: string;
    storeItemID: string;
    taxID: string;
    glAccountID: string;
    costAmount: number;
    retailAmount: number;
    minutes?: number | undefined;
    warningMinutes?: number | undefined;
    enabled: boolean;
    allowWalkIn: boolean;
    walkInTypeEnum: WalkInTypeEnum;
    storeItem?: StoreItem | undefined;
    provider?: Provider | undefined;
    nextAvailableAppointmentDate?: Date | undefined;
    glAccount?: GLAccount | undefined;
}

export enum WalkInTypeEnum {
    NotSet = "NotSet",
    UrgentCare = "UrgentCare",
    CovidTest = "CovidTest",
    HomeCare = "HomeCare",
    ElderCare = "ElderCare",
}

export class InvoicePayment extends EntityBase implements IInvoicePayment {
    invoicePaymentID!: string;
    invoiceID!: string;
    paymentTypeEnum!: PaymentTypeEnum;
    paymentAmount!: number;
    currencyEnum!: CurrencyEnum;
    referenceNumber!: string;
    lastFourDigits?: string | undefined;
    cardType?: string | undefined;
    chequeNumber?: string | undefined;
    paymentProcessorID?: string | undefined;
    token?: string | undefined;
    chargeSuccess?: boolean | undefined;
    chargeMessage?: string | undefined;
    chargeID?: string | undefined;
    chargeResponseMessage?: string | undefined;
    validated!: boolean;
    validationCode?: string | undefined;
    cancelled!: boolean;
    validateResponseMessage?: string | undefined;
    walletID?: string | undefined;
    doNotCommitToGL?: boolean | undefined;
    recurring?: boolean | undefined;
    recurringPlanID?: string | undefined;
    webhook?: boolean | undefined;
    timestamp?: string | undefined;
    qrCode!: number;
    invoicePaymentBatchID?: string | undefined;
    paymentProcessor?: PaymentProcessor | undefined;
    keepCardOnFile?: boolean;
    recurringFrequency?: FrequencyEnum | undefined;
    recurringCount?: number | undefined;
    recurringStoreItemID?: string | undefined;
    recurringEmailAddress?: string | undefined;

    constructor(data?: IInvoicePayment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoicePaymentID = _data["invoicePaymentID"];
            this.invoiceID = _data["invoiceID"];
            this.paymentTypeEnum = _data["paymentTypeEnum"];
            this.paymentAmount = _data["paymentAmount"];
            this.currencyEnum = _data["currencyEnum"];
            this.referenceNumber = _data["referenceNumber"];
            this.lastFourDigits = _data["lastFourDigits"];
            this.cardType = _data["cardType"];
            this.chequeNumber = _data["chequeNumber"];
            this.paymentProcessorID = _data["paymentProcessorID"];
            this.token = _data["token"];
            this.chargeSuccess = _data["chargeSuccess"];
            this.chargeMessage = _data["chargeMessage"];
            this.chargeID = _data["chargeID"];
            this.chargeResponseMessage = _data["chargeResponseMessage"];
            this.validated = _data["validated"];
            this.validationCode = _data["validationCode"];
            this.cancelled = _data["cancelled"];
            this.validateResponseMessage = _data["validateResponseMessage"];
            this.walletID = _data["walletID"];
            this.doNotCommitToGL = _data["doNotCommitToGL"];
            this.recurring = _data["recurring"];
            this.recurringPlanID = _data["recurringPlanID"];
            this.webhook = _data["webhook"];
            this.timestamp = _data["timestamp"];
            this.qrCode = _data["qrCode"];
            this.invoicePaymentBatchID = _data["invoicePaymentBatchID"];
            this.paymentProcessor = _data["paymentProcessor"] ? PaymentProcessor.fromJS(_data["paymentProcessor"]) : <any>undefined;
            this.keepCardOnFile = _data["keepCardOnFile"];
            this.recurringFrequency = _data["recurringFrequency"];
            this.recurringCount = _data["recurringCount"];
            this.recurringStoreItemID = _data["recurringStoreItemID"];
            this.recurringEmailAddress = _data["recurringEmailAddress"];
        }
    }

    static fromJS(data: any): InvoicePayment {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoicePaymentID"] = this.invoicePaymentID;
        data["invoiceID"] = this.invoiceID;
        data["paymentTypeEnum"] = this.paymentTypeEnum;
        data["paymentAmount"] = this.paymentAmount;
        data["currencyEnum"] = this.currencyEnum;
        data["referenceNumber"] = this.referenceNumber;
        data["lastFourDigits"] = this.lastFourDigits;
        data["cardType"] = this.cardType;
        data["chequeNumber"] = this.chequeNumber;
        data["paymentProcessorID"] = this.paymentProcessorID;
        data["token"] = this.token;
        data["chargeSuccess"] = this.chargeSuccess;
        data["chargeMessage"] = this.chargeMessage;
        data["chargeID"] = this.chargeID;
        data["chargeResponseMessage"] = this.chargeResponseMessage;
        data["validated"] = this.validated;
        data["validationCode"] = this.validationCode;
        data["cancelled"] = this.cancelled;
        data["validateResponseMessage"] = this.validateResponseMessage;
        data["walletID"] = this.walletID;
        data["doNotCommitToGL"] = this.doNotCommitToGL;
        data["recurring"] = this.recurring;
        data["recurringPlanID"] = this.recurringPlanID;
        data["webhook"] = this.webhook;
        data["timestamp"] = this.timestamp;
        data["qrCode"] = this.qrCode;
        data["invoicePaymentBatchID"] = this.invoicePaymentBatchID;
        data["paymentProcessor"] = this.paymentProcessor ? this.paymentProcessor.toJSON() : <any>undefined;
        data["keepCardOnFile"] = this.keepCardOnFile;
        data["recurringFrequency"] = this.recurringFrequency;
        data["recurringCount"] = this.recurringCount;
        data["recurringStoreItemID"] = this.recurringStoreItemID;
        data["recurringEmailAddress"] = this.recurringEmailAddress;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicePayment extends IEntityBase {
    invoicePaymentID: string;
    invoiceID: string;
    paymentTypeEnum: PaymentTypeEnum;
    paymentAmount: number;
    currencyEnum: CurrencyEnum;
    referenceNumber: string;
    lastFourDigits?: string | undefined;
    cardType?: string | undefined;
    chequeNumber?: string | undefined;
    paymentProcessorID?: string | undefined;
    token?: string | undefined;
    chargeSuccess?: boolean | undefined;
    chargeMessage?: string | undefined;
    chargeID?: string | undefined;
    chargeResponseMessage?: string | undefined;
    validated: boolean;
    validationCode?: string | undefined;
    cancelled: boolean;
    validateResponseMessage?: string | undefined;
    walletID?: string | undefined;
    doNotCommitToGL?: boolean | undefined;
    recurring?: boolean | undefined;
    recurringPlanID?: string | undefined;
    webhook?: boolean | undefined;
    timestamp?: string | undefined;
    qrCode: number;
    invoicePaymentBatchID?: string | undefined;
    paymentProcessor?: PaymentProcessor | undefined;
    keepCardOnFile?: boolean;
    recurringFrequency?: FrequencyEnum | undefined;
    recurringCount?: number | undefined;
    recurringStoreItemID?: string | undefined;
    recurringEmailAddress?: string | undefined;
}

export enum PaymentTypeEnum {
    PaymentProcessor = "PaymentProcessor",
    Wallet = "Wallet",
    Cheque = "Cheque",
    RecurringPayment = "RecurringPayment",
    NeoPayment = "NeoPayment",
}

export enum FrequencyEnum {
    NotSet = "NotSet",
    Monthly = "Monthly",
    Yearly = "Yearly",
    Weekly = "Weekly",
    Daily = "Daily",
}

export class Coupon extends EntityBase implements ICoupon {
    store?: Store | undefined;
    storeItem?: StoreItem | undefined;
    couponID!: string;
    name!: string;
    description!: string;
    couponCode!: string;
    couponTypeEnum!: CouponTypeEnum;
    reusable!: boolean;
    reusableCount!: number;
    usedCount!: number;
    retailDiscountPercent?: number | undefined;
    retailDiscountAmount?: number | undefined;
    costDiscountPercent?: number | undefined;
    costDiscountAmount?: number | undefined;
    totalDiscountPercent?: number | undefined;
    totalDiscountAmount?: number | undefined;
    totalGLAccountID?: string | undefined;
    startDate!: Date;
    endDate!: Date;
    enabled!: boolean;
    storeID?: string | undefined;
    storeItemID?: string | undefined;

    constructor(data?: ICoupon) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.couponID = _data["couponID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.couponCode = _data["couponCode"];
            this.couponTypeEnum = _data["couponTypeEnum"];
            this.reusable = _data["reusable"];
            this.reusableCount = _data["reusableCount"];
            this.usedCount = _data["usedCount"];
            this.retailDiscountPercent = _data["retailDiscountPercent"];
            this.retailDiscountAmount = _data["retailDiscountAmount"];
            this.costDiscountPercent = _data["costDiscountPercent"];
            this.costDiscountAmount = _data["costDiscountAmount"];
            this.totalDiscountPercent = _data["totalDiscountPercent"];
            this.totalDiscountAmount = _data["totalDiscountAmount"];
            this.totalGLAccountID = _data["totalGLAccountID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.enabled = _data["enabled"];
            this.storeID = _data["storeID"];
            this.storeItemID = _data["storeItemID"];
        }
    }

    static fromJS(data: any): Coupon {
        data = typeof data === 'object' ? data : {};
        let result = new Coupon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["couponID"] = this.couponID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["couponCode"] = this.couponCode;
        data["couponTypeEnum"] = this.couponTypeEnum;
        data["reusable"] = this.reusable;
        data["reusableCount"] = this.reusableCount;
        data["usedCount"] = this.usedCount;
        data["retailDiscountPercent"] = this.retailDiscountPercent;
        data["retailDiscountAmount"] = this.retailDiscountAmount;
        data["costDiscountPercent"] = this.costDiscountPercent;
        data["costDiscountAmount"] = this.costDiscountAmount;
        data["totalDiscountPercent"] = this.totalDiscountPercent;
        data["totalDiscountAmount"] = this.totalDiscountAmount;
        data["totalGLAccountID"] = this.totalGLAccountID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["enabled"] = this.enabled;
        data["storeID"] = this.storeID;
        data["storeItemID"] = this.storeItemID;
        super.toJSON(data);
        return data;
    }
}

export interface ICoupon extends IEntityBase {
    store?: Store | undefined;
    storeItem?: StoreItem | undefined;
    couponID: string;
    name: string;
    description: string;
    couponCode: string;
    couponTypeEnum: CouponTypeEnum;
    reusable: boolean;
    reusableCount: number;
    usedCount: number;
    retailDiscountPercent?: number | undefined;
    retailDiscountAmount?: number | undefined;
    costDiscountPercent?: number | undefined;
    costDiscountAmount?: number | undefined;
    totalDiscountPercent?: number | undefined;
    totalDiscountAmount?: number | undefined;
    totalGLAccountID?: string | undefined;
    startDate: Date;
    endDate: Date;
    enabled: boolean;
    storeID?: string | undefined;
    storeItemID?: string | undefined;
}

export enum CouponTypeEnum {
    NotSet = "NotSet",
    StoreDefault = "StoreDefault",
    NeoCard = "NeoCard",
}

export class TaskItem extends EntityBase implements ITaskItem {
    taskItemID!: string;
    taskItemTypeEnum!: TaskItemTypeEnum;
    userDetailID?: string | undefined;
    storeID?: string | undefined;
    taskItemPriorityEnum!: TaskItemPriorityEnum;
    name!: string;
    description?: string | undefined;
    taskItemTypeName?: string | undefined;
    taskStartDate!: Date;
    taskEndDate?: Date | undefined;
    nextTaskItemID?: string | undefined;
    taskItemStatusEnum!: TaskItemStatusEnum;
    taskItemStatusMessage?: string | undefined;
    detail?: string | undefined;
    result?: string | undefined;
    message?: string | undefined;
    timestamp?: string | undefined;
    acceptedByUserDetailID?: string | undefined;
    acceptedDate?: Date | undefined;
    dueDate?: Date | undefined;
    patientID?: string | undefined;
    taskNotes?: string | undefined;
    host?: string | undefined;
    taskItemAttachments?: TaskItemAttachment[] | undefined;
    nextTaskItem?: TaskItem | undefined;

    constructor(data?: ITaskItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskItemID = _data["taskItemID"];
            this.taskItemTypeEnum = _data["taskItemTypeEnum"];
            this.userDetailID = _data["userDetailID"];
            this.storeID = _data["storeID"];
            this.taskItemPriorityEnum = _data["taskItemPriorityEnum"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.taskItemTypeName = _data["taskItemTypeName"];
            this.taskStartDate = _data["taskStartDate"] ? new Date(_data["taskStartDate"].toString()) : <any>undefined;
            this.taskEndDate = _data["taskEndDate"] ? new Date(_data["taskEndDate"].toString()) : <any>undefined;
            this.nextTaskItemID = _data["nextTaskItemID"];
            this.taskItemStatusEnum = _data["taskItemStatusEnum"];
            this.taskItemStatusMessage = _data["taskItemStatusMessage"];
            this.detail = _data["detail"];
            this.result = _data["result"];
            this.message = _data["message"];
            this.timestamp = _data["timestamp"];
            this.acceptedByUserDetailID = _data["acceptedByUserDetailID"];
            this.acceptedDate = _data["acceptedDate"] ? new Date(_data["acceptedDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.patientID = _data["patientID"];
            this.taskNotes = _data["taskNotes"];
            this.host = _data["host"];
            if (Array.isArray(_data["taskItemAttachments"])) {
                this.taskItemAttachments = [] as any;
                for (let item of _data["taskItemAttachments"])
                    this.taskItemAttachments!.push(TaskItemAttachment.fromJS(item));
            }
            this.nextTaskItem = _data["nextTaskItem"] ? TaskItem.fromJS(_data["nextTaskItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskItem {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskItemID"] = this.taskItemID;
        data["taskItemTypeEnum"] = this.taskItemTypeEnum;
        data["userDetailID"] = this.userDetailID;
        data["storeID"] = this.storeID;
        data["taskItemPriorityEnum"] = this.taskItemPriorityEnum;
        data["name"] = this.name;
        data["description"] = this.description;
        data["taskItemTypeName"] = this.taskItemTypeName;
        data["taskStartDate"] = this.taskStartDate ? this.taskStartDate.toISOString() : <any>undefined;
        data["taskEndDate"] = this.taskEndDate ? this.taskEndDate.toISOString() : <any>undefined;
        data["nextTaskItemID"] = this.nextTaskItemID;
        data["taskItemStatusEnum"] = this.taskItemStatusEnum;
        data["taskItemStatusMessage"] = this.taskItemStatusMessage;
        data["detail"] = this.detail;
        data["result"] = this.result;
        data["message"] = this.message;
        data["timestamp"] = this.timestamp;
        data["acceptedByUserDetailID"] = this.acceptedByUserDetailID;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["patientID"] = this.patientID;
        data["taskNotes"] = this.taskNotes;
        data["host"] = this.host;
        if (Array.isArray(this.taskItemAttachments)) {
            data["taskItemAttachments"] = [];
            for (let item of this.taskItemAttachments)
                data["taskItemAttachments"].push(item.toJSON());
        }
        data["nextTaskItem"] = this.nextTaskItem ? this.nextTaskItem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITaskItem extends IEntityBase {
    taskItemID: string;
    taskItemTypeEnum: TaskItemTypeEnum;
    userDetailID?: string | undefined;
    storeID?: string | undefined;
    taskItemPriorityEnum: TaskItemPriorityEnum;
    name: string;
    description?: string | undefined;
    taskItemTypeName?: string | undefined;
    taskStartDate: Date;
    taskEndDate?: Date | undefined;
    nextTaskItemID?: string | undefined;
    taskItemStatusEnum: TaskItemStatusEnum;
    taskItemStatusMessage?: string | undefined;
    detail?: string | undefined;
    result?: string | undefined;
    message?: string | undefined;
    timestamp?: string | undefined;
    acceptedByUserDetailID?: string | undefined;
    acceptedDate?: Date | undefined;
    dueDate?: Date | undefined;
    patientID?: string | undefined;
    taskNotes?: string | undefined;
    host?: string | undefined;
    taskItemAttachments?: TaskItemAttachment[] | undefined;
    nextTaskItem?: TaskItem | undefined;
}

export enum TaskItemTypeEnum {
    InProcess = "InProcess",
    OutOfProcess = "OutOfProcess",
    ToDo = "ToDo",
    ServiceBus = "ServiceBus",
    PatientOrder = "PatientOrder",
    PatientPrescription = "PatientPrescription",
    PayoutCycle = "PayoutCycle",
}

export enum TaskItemPriorityEnum {
    High = "High",
    Normal = "Normal",
    Low = "Low",
}

export enum TaskItemStatusEnum {
    Draft = "Draft",
    Ready = "Ready",
    Processing = "Processing",
    FinishedSuccessfully = "FinishedSuccessfully",
    FinishedFailed = "FinishedFailed",
    Cancelling = "Cancelling",
    CancelledSuccessfully = "CancelledSuccessfully",
    CancelledFailed = "CancelledFailed",
    Accepted = "Accepted",
    InProgress = "InProgress",
    Paused = "Paused",
    CompletedWaiting = "CompletedWaiting",
    Completed = "Completed",
    PendingResults = "PendingResults",
    FinalizedResults = "FinalizedResults",
}

export class TaskItemAttachment extends EntityBase implements ITaskItemAttachment {
    taskItemAttachmentID!: string;
    taskItemID!: string;
    fileDetailID!: string;
    taskItemAttachmentTypeEnum!: TaskItemAttachmentTypeEnum;
    phrDocumentCategoryEnum?: PHRDocumentCategoryEnum | undefined;
    documentTypeTagID?: string | undefined;
    taskItem?: TaskItem | undefined;
    fileDetail?: FileDetail | undefined;

    constructor(data?: ITaskItemAttachment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskItemAttachmentID = _data["taskItemAttachmentID"];
            this.taskItemID = _data["taskItemID"];
            this.fileDetailID = _data["fileDetailID"];
            this.taskItemAttachmentTypeEnum = _data["taskItemAttachmentTypeEnum"];
            this.phrDocumentCategoryEnum = _data["phrDocumentCategoryEnum"];
            this.documentTypeTagID = _data["documentTypeTagID"];
            this.taskItem = _data["taskItem"] ? TaskItem.fromJS(_data["taskItem"]) : <any>undefined;
            this.fileDetail = _data["fileDetail"] ? FileDetail.fromJS(_data["fileDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskItemAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskItemAttachmentID"] = this.taskItemAttachmentID;
        data["taskItemID"] = this.taskItemID;
        data["fileDetailID"] = this.fileDetailID;
        data["taskItemAttachmentTypeEnum"] = this.taskItemAttachmentTypeEnum;
        data["phrDocumentCategoryEnum"] = this.phrDocumentCategoryEnum;
        data["documentTypeTagID"] = this.documentTypeTagID;
        data["taskItem"] = this.taskItem ? this.taskItem.toJSON() : <any>undefined;
        data["fileDetail"] = this.fileDetail ? this.fileDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITaskItemAttachment extends IEntityBase {
    taskItemAttachmentID: string;
    taskItemID: string;
    fileDetailID: string;
    taskItemAttachmentTypeEnum: TaskItemAttachmentTypeEnum;
    phrDocumentCategoryEnum?: PHRDocumentCategoryEnum | undefined;
    documentTypeTagID?: string | undefined;
    taskItem?: TaskItem | undefined;
    fileDetail?: FileDetail | undefined;
}

export enum TaskItemAttachmentTypeEnum {
    Request = "Request",
    Response = "Response",
}

export class PatientOrder extends EntityBase implements IPatientOrder {
    patientOrderID!: string;
    patientID!: string;
    orderID!: string;
    orderDate!: Date;
    orderStatusEnum!: OrderStatusEnum;
    generateDocumentStateEnum!: GenerateDocumentStateEnum;
    sendToEnum!: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient!: boolean;
    addSignature!: boolean;
    qrCode!: number;
    phrConsultID?: string | undefined;
    providerID?: string | undefined;
    storeID?: string | undefined;
    invoiceID?: string | undefined;
    phrDocumentID?: string | undefined;
    totalAmount!: number;
    faxID?: string | undefined;
    customerName?: string | undefined;
    customerEmailAddress?: string | undefined;
    customerAddressLine1?: string | undefined;
    customerAddressLine2?: string | undefined;
    customerCity?: string | undefined;
    customerCityTownID?: string | undefined;
    customerProvince?: string | undefined;
    customerProvinceStateID?: string | undefined;
    customerPostCode?: string | undefined;
    customerCountry?: string | undefined;
    customerPhone?: string | undefined;
    taskItemID?: string | undefined;
    testDetails?: string | undefined;
    reasonForExam?: string | undefined;
    patientOrderQuestionID?: string | undefined;
    patient?: Patient | undefined;
    order?: Order | undefined;
    patientOrderItems?: PatientOrderItem[] | undefined;
    provider?: Provider | undefined;
    store?: Store | undefined;
    createdByUserDetail?: UserDetail | undefined;
    updatedByUserDetail?: UserDetail | undefined;
    itemNumber?: number;
    invoice?: Invoice | undefined;
    deliveryItemTaskItemTypeName?: string | undefined;
    customerProvinceState?: ProvinceState | undefined;
    customerCityTown?: CityTown | undefined;
    taskItem?: TaskItem | undefined;
    phrDocument?: PHRDocument | undefined;
    patientOrderQuestion?: PatientOrderQuestion | undefined;

    constructor(data?: IPatientOrder) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientOrderID = _data["patientOrderID"];
            this.patientID = _data["patientID"];
            this.orderID = _data["orderID"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.orderStatusEnum = _data["orderStatusEnum"];
            this.generateDocumentStateEnum = _data["generateDocumentStateEnum"];
            this.sendToEnum = _data["sendToEnum"];
            this.sendToID = _data["sendToID"];
            this.sendSubject = _data["sendSubject"];
            this.sendMessage = _data["sendMessage"];
            this.sendCopyToPatient = _data["sendCopyToPatient"];
            this.addSignature = _data["addSignature"];
            this.qrCode = _data["qrCode"];
            this.phrConsultID = _data["phrConsultID"];
            this.providerID = _data["providerID"];
            this.storeID = _data["storeID"];
            this.invoiceID = _data["invoiceID"];
            this.phrDocumentID = _data["phrDocumentID"];
            this.totalAmount = _data["totalAmount"];
            this.faxID = _data["faxID"];
            this.customerName = _data["customerName"];
            this.customerEmailAddress = _data["customerEmailAddress"];
            this.customerAddressLine1 = _data["customerAddressLine1"];
            this.customerAddressLine2 = _data["customerAddressLine2"];
            this.customerCity = _data["customerCity"];
            this.customerCityTownID = _data["customerCityTownID"];
            this.customerProvince = _data["customerProvince"];
            this.customerProvinceStateID = _data["customerProvinceStateID"];
            this.customerPostCode = _data["customerPostCode"];
            this.customerCountry = _data["customerCountry"];
            this.customerPhone = _data["customerPhone"];
            this.taskItemID = _data["taskItemID"];
            this.testDetails = _data["testDetails"];
            this.reasonForExam = _data["reasonForExam"];
            this.patientOrderQuestionID = _data["patientOrderQuestionID"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            if (Array.isArray(_data["patientOrderItems"])) {
                this.patientOrderItems = [] as any;
                for (let item of _data["patientOrderItems"])
                    this.patientOrderItems!.push(PatientOrderItem.fromJS(item));
            }
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.createdByUserDetail = _data["createdByUserDetail"] ? UserDetail.fromJS(_data["createdByUserDetail"]) : <any>undefined;
            this.updatedByUserDetail = _data["updatedByUserDetail"] ? UserDetail.fromJS(_data["updatedByUserDetail"]) : <any>undefined;
            this.itemNumber = _data["itemNumber"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.deliveryItemTaskItemTypeName = _data["deliveryItemTaskItemTypeName"];
            this.customerProvinceState = _data["customerProvinceState"] ? ProvinceState.fromJS(_data["customerProvinceState"]) : <any>undefined;
            this.customerCityTown = _data["customerCityTown"] ? CityTown.fromJS(_data["customerCityTown"]) : <any>undefined;
            this.taskItem = _data["taskItem"] ? TaskItem.fromJS(_data["taskItem"]) : <any>undefined;
            this.phrDocument = _data["phrDocument"] ? PHRDocument.fromJS(_data["phrDocument"]) : <any>undefined;
            this.patientOrderQuestion = _data["patientOrderQuestion"] ? PatientOrderQuestion.fromJS(_data["patientOrderQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientOrder {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientOrderID"] = this.patientOrderID;
        data["patientID"] = this.patientID;
        data["orderID"] = this.orderID;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["orderStatusEnum"] = this.orderStatusEnum;
        data["generateDocumentStateEnum"] = this.generateDocumentStateEnum;
        data["sendToEnum"] = this.sendToEnum;
        data["sendToID"] = this.sendToID;
        data["sendSubject"] = this.sendSubject;
        data["sendMessage"] = this.sendMessage;
        data["sendCopyToPatient"] = this.sendCopyToPatient;
        data["addSignature"] = this.addSignature;
        data["qrCode"] = this.qrCode;
        data["phrConsultID"] = this.phrConsultID;
        data["providerID"] = this.providerID;
        data["storeID"] = this.storeID;
        data["invoiceID"] = this.invoiceID;
        data["phrDocumentID"] = this.phrDocumentID;
        data["totalAmount"] = this.totalAmount;
        data["faxID"] = this.faxID;
        data["customerName"] = this.customerName;
        data["customerEmailAddress"] = this.customerEmailAddress;
        data["customerAddressLine1"] = this.customerAddressLine1;
        data["customerAddressLine2"] = this.customerAddressLine2;
        data["customerCity"] = this.customerCity;
        data["customerCityTownID"] = this.customerCityTownID;
        data["customerProvince"] = this.customerProvince;
        data["customerProvinceStateID"] = this.customerProvinceStateID;
        data["customerPostCode"] = this.customerPostCode;
        data["customerCountry"] = this.customerCountry;
        data["customerPhone"] = this.customerPhone;
        data["taskItemID"] = this.taskItemID;
        data["testDetails"] = this.testDetails;
        data["reasonForExam"] = this.reasonForExam;
        data["patientOrderQuestionID"] = this.patientOrderQuestionID;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        if (Array.isArray(this.patientOrderItems)) {
            data["patientOrderItems"] = [];
            for (let item of this.patientOrderItems)
                data["patientOrderItems"].push(item.toJSON());
        }
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["createdByUserDetail"] = this.createdByUserDetail ? this.createdByUserDetail.toJSON() : <any>undefined;
        data["updatedByUserDetail"] = this.updatedByUserDetail ? this.updatedByUserDetail.toJSON() : <any>undefined;
        data["itemNumber"] = this.itemNumber;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["deliveryItemTaskItemTypeName"] = this.deliveryItemTaskItemTypeName;
        data["customerProvinceState"] = this.customerProvinceState ? this.customerProvinceState.toJSON() : <any>undefined;
        data["customerCityTown"] = this.customerCityTown ? this.customerCityTown.toJSON() : <any>undefined;
        data["taskItem"] = this.taskItem ? this.taskItem.toJSON() : <any>undefined;
        data["phrDocument"] = this.phrDocument ? this.phrDocument.toJSON() : <any>undefined;
        data["patientOrderQuestion"] = this.patientOrderQuestion ? this.patientOrderQuestion.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientOrder extends IEntityBase {
    patientOrderID: string;
    patientID: string;
    orderID: string;
    orderDate: Date;
    orderStatusEnum: OrderStatusEnum;
    generateDocumentStateEnum: GenerateDocumentStateEnum;
    sendToEnum: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient: boolean;
    addSignature: boolean;
    qrCode: number;
    phrConsultID?: string | undefined;
    providerID?: string | undefined;
    storeID?: string | undefined;
    invoiceID?: string | undefined;
    phrDocumentID?: string | undefined;
    totalAmount: number;
    faxID?: string | undefined;
    customerName?: string | undefined;
    customerEmailAddress?: string | undefined;
    customerAddressLine1?: string | undefined;
    customerAddressLine2?: string | undefined;
    customerCity?: string | undefined;
    customerCityTownID?: string | undefined;
    customerProvince?: string | undefined;
    customerProvinceStateID?: string | undefined;
    customerPostCode?: string | undefined;
    customerCountry?: string | undefined;
    customerPhone?: string | undefined;
    taskItemID?: string | undefined;
    testDetails?: string | undefined;
    reasonForExam?: string | undefined;
    patientOrderQuestionID?: string | undefined;
    patient?: Patient | undefined;
    order?: Order | undefined;
    patientOrderItems?: PatientOrderItem[] | undefined;
    provider?: Provider | undefined;
    store?: Store | undefined;
    createdByUserDetail?: UserDetail | undefined;
    updatedByUserDetail?: UserDetail | undefined;
    itemNumber?: number;
    invoice?: Invoice | undefined;
    deliveryItemTaskItemTypeName?: string | undefined;
    customerProvinceState?: ProvinceState | undefined;
    customerCityTown?: CityTown | undefined;
    taskItem?: TaskItem | undefined;
    phrDocument?: PHRDocument | undefined;
    patientOrderQuestion?: PatientOrderQuestion | undefined;
}

export enum OrderStatusEnum {
    Draft = "Draft",
    Pending = "Pending",
    Processing = "Processing",
    Completed = "Completed",
}

export class Order extends EntityBase implements IOrder {
    orderID!: string;
    name!: string;
    orderEnum!: OrderEnum;
    description!: string;
    typeName?: string | undefined;
    enabled!: boolean;
    displaySortOrder!: number;
    pdfPageTypeName!: string;
    eStore!: boolean;
    orderItems?: OrderItem[] | undefined;

    constructor(data?: IOrder) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderID = _data["orderID"];
            this.name = _data["name"];
            this.orderEnum = _data["orderEnum"];
            this.description = _data["description"];
            this.typeName = _data["typeName"];
            this.enabled = _data["enabled"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.pdfPageTypeName = _data["pdfPageTypeName"];
            this.eStore = _data["eStore"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["name"] = this.name;
        data["orderEnum"] = this.orderEnum;
        data["description"] = this.description;
        data["typeName"] = this.typeName;
        data["enabled"] = this.enabled;
        data["displaySortOrder"] = this.displaySortOrder;
        data["pdfPageTypeName"] = this.pdfPageTypeName;
        data["eStore"] = this.eStore;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IOrder extends IEntityBase {
    orderID: string;
    name: string;
    orderEnum: OrderEnum;
    description: string;
    typeName?: string | undefined;
    enabled: boolean;
    displaySortOrder: number;
    pdfPageTypeName: string;
    eStore: boolean;
    orderItems?: OrderItem[] | undefined;
}

export enum OrderEnum {
    ChemicalOrder = "ChemicalOrder",
    XrayOrder = "XrayOrder",
    CTOrder = "CTOrder",
    MammogramOrder = "MammogramOrder",
    UltrasoundOrder = "UltrasoundOrder",
    MRIOrder = "MRIOrder",
    NuclearMedicine = "NuclearMedicine",
    Other = "Other",
    EStoreCategory = "EStoreCategory",
}

export class OrderItem extends EntityBase implements IOrderItem {
    orderItemID!: string;
    orderID!: string;
    itemID!: string;
    displaySortOrder!: number;
    enabled!: boolean;
    item?: Item | undefined;
    retailAmount?: number;
    quantity?: number;
    imageDetailID?: string;
    currencyEnum?: CurrencyEnum;
    storeID?: string | undefined;
    addressBookID?: string | undefined;

    constructor(data?: IOrderItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderItemID = _data["orderItemID"];
            this.orderID = _data["orderID"];
            this.itemID = _data["itemID"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.enabled = _data["enabled"];
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>undefined;
            this.retailAmount = _data["retailAmount"];
            this.quantity = _data["quantity"];
            this.imageDetailID = _data["imageDetailID"];
            this.currencyEnum = _data["currencyEnum"];
            this.storeID = _data["storeID"];
            this.addressBookID = _data["addressBookID"];
        }
    }

    static fromJS(data: any): OrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderItemID"] = this.orderItemID;
        data["orderID"] = this.orderID;
        data["itemID"] = this.itemID;
        data["displaySortOrder"] = this.displaySortOrder;
        data["enabled"] = this.enabled;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["retailAmount"] = this.retailAmount;
        data["quantity"] = this.quantity;
        data["imageDetailID"] = this.imageDetailID;
        data["currencyEnum"] = this.currencyEnum;
        data["storeID"] = this.storeID;
        data["addressBookID"] = this.addressBookID;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderItem extends IEntityBase {
    orderItemID: string;
    orderID: string;
    itemID: string;
    displaySortOrder: number;
    enabled: boolean;
    item?: Item | undefined;
    retailAmount?: number;
    quantity?: number;
    imageDetailID?: string;
    currencyEnum?: CurrencyEnum;
    storeID?: string | undefined;
    addressBookID?: string | undefined;
}

export class PatientOrderItem extends EntityBase implements IPatientOrderItem {
    patientOrderItemID!: string;
    patientOrderID!: string;
    orderItemID?: string | undefined;
    totalAmount?: number | undefined;
    storeItemID?: string | undefined;
    testDescription?: string | undefined;
    additionalInformation?: string | undefined;
    orderItem?: OrderItem | undefined;
    patientOrder?: PatientOrder | undefined;

    constructor(data?: IPatientOrderItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientOrderItemID = _data["patientOrderItemID"];
            this.patientOrderID = _data["patientOrderID"];
            this.orderItemID = _data["orderItemID"];
            this.totalAmount = _data["totalAmount"];
            this.storeItemID = _data["storeItemID"];
            this.testDescription = _data["testDescription"];
            this.additionalInformation = _data["additionalInformation"];
            this.orderItem = _data["orderItem"] ? OrderItem.fromJS(_data["orderItem"]) : <any>undefined;
            this.patientOrder = _data["patientOrder"] ? PatientOrder.fromJS(_data["patientOrder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientOrderItemID"] = this.patientOrderItemID;
        data["patientOrderID"] = this.patientOrderID;
        data["orderItemID"] = this.orderItemID;
        data["totalAmount"] = this.totalAmount;
        data["storeItemID"] = this.storeItemID;
        data["testDescription"] = this.testDescription;
        data["additionalInformation"] = this.additionalInformation;
        data["orderItem"] = this.orderItem ? this.orderItem.toJSON() : <any>undefined;
        data["patientOrder"] = this.patientOrder ? this.patientOrder.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientOrderItem extends IEntityBase {
    patientOrderItemID: string;
    patientOrderID: string;
    orderItemID?: string | undefined;
    totalAmount?: number | undefined;
    storeItemID?: string | undefined;
    testDescription?: string | undefined;
    additionalInformation?: string | undefined;
    orderItem?: OrderItem | undefined;
    patientOrder?: PatientOrder | undefined;
}

export class PatientOrderQuestion extends EntityBase implements IPatientOrderQuestion {
    patientOrderQuestionID!: string;
    cardiacPacemaker?: boolean | undefined;
    deepBrainImplant?: boolean | undefined;
    externalPacerWires?: boolean | undefined;
    tissueExpander?: boolean | undefined;
    contrastAllergies?: boolean | undefined;
    surgicallyImplantedDevices?: boolean | undefined;
    surgicallyImplantedDeviceDescription?: string | undefined;
    informedToPresentImplantCard?: boolean | undefined;
    metallicForeignBodyFromEye?: boolean | undefined;
    orbitXrayOrdered?: boolean | undefined;
    locationOfProcedure?: string | undefined;
    claustrophobic?: boolean | undefined;
    familyHistoryOfBreastCancer?: boolean | undefined;
    ageAtDiagnosis?: number | undefined;
    hormoneReplacementTherapy?: boolean | undefined;
    hormoneReplacementDuration?: string | undefined;
    hormoneReplacementDate?: Date | undefined;
    hormoneReplacementLocation?: string | undefined;
    hormoneReplacementResults?: string | undefined;
    previousSurgery?: boolean | undefined;
    previousSurgeryDate?: Date | undefined;
    previousSurgeryDetails?: string | undefined;
    lastClinicalExamDate?: Date | undefined;
    lastClinicalExamDetails?: string | undefined;
    pregnant?: boolean | undefined;
    pregnantDate?: Date | undefined;
    pregnantDetails?: string | undefined;

    constructor(data?: IPatientOrderQuestion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientOrderQuestionID = _data["patientOrderQuestionID"];
            this.cardiacPacemaker = _data["cardiacPacemaker"];
            this.deepBrainImplant = _data["deepBrainImplant"];
            this.externalPacerWires = _data["externalPacerWires"];
            this.tissueExpander = _data["tissueExpander"];
            this.contrastAllergies = _data["contrastAllergies"];
            this.surgicallyImplantedDevices = _data["surgicallyImplantedDevices"];
            this.surgicallyImplantedDeviceDescription = _data["surgicallyImplantedDeviceDescription"];
            this.informedToPresentImplantCard = _data["informedToPresentImplantCard"];
            this.metallicForeignBodyFromEye = _data["metallicForeignBodyFromEye"];
            this.orbitXrayOrdered = _data["orbitXrayOrdered"];
            this.locationOfProcedure = _data["locationOfProcedure"];
            this.claustrophobic = _data["claustrophobic"];
            this.familyHistoryOfBreastCancer = _data["familyHistoryOfBreastCancer"];
            this.ageAtDiagnosis = _data["ageAtDiagnosis"];
            this.hormoneReplacementTherapy = _data["hormoneReplacementTherapy"];
            this.hormoneReplacementDuration = _data["hormoneReplacementDuration"];
            this.hormoneReplacementDate = _data["hormoneReplacementDate"] ? new Date(_data["hormoneReplacementDate"].toString()) : <any>undefined;
            this.hormoneReplacementLocation = _data["hormoneReplacementLocation"];
            this.hormoneReplacementResults = _data["hormoneReplacementResults"];
            this.previousSurgery = _data["previousSurgery"];
            this.previousSurgeryDate = _data["previousSurgeryDate"] ? new Date(_data["previousSurgeryDate"].toString()) : <any>undefined;
            this.previousSurgeryDetails = _data["previousSurgeryDetails"];
            this.lastClinicalExamDate = _data["lastClinicalExamDate"] ? new Date(_data["lastClinicalExamDate"].toString()) : <any>undefined;
            this.lastClinicalExamDetails = _data["lastClinicalExamDetails"];
            this.pregnant = _data["pregnant"];
            this.pregnantDate = _data["pregnantDate"] ? new Date(_data["pregnantDate"].toString()) : <any>undefined;
            this.pregnantDetails = _data["pregnantDetails"];
        }
    }

    static fromJS(data: any): PatientOrderQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientOrderQuestionID"] = this.patientOrderQuestionID;
        data["cardiacPacemaker"] = this.cardiacPacemaker;
        data["deepBrainImplant"] = this.deepBrainImplant;
        data["externalPacerWires"] = this.externalPacerWires;
        data["tissueExpander"] = this.tissueExpander;
        data["contrastAllergies"] = this.contrastAllergies;
        data["surgicallyImplantedDevices"] = this.surgicallyImplantedDevices;
        data["surgicallyImplantedDeviceDescription"] = this.surgicallyImplantedDeviceDescription;
        data["informedToPresentImplantCard"] = this.informedToPresentImplantCard;
        data["metallicForeignBodyFromEye"] = this.metallicForeignBodyFromEye;
        data["orbitXrayOrdered"] = this.orbitXrayOrdered;
        data["locationOfProcedure"] = this.locationOfProcedure;
        data["claustrophobic"] = this.claustrophobic;
        data["familyHistoryOfBreastCancer"] = this.familyHistoryOfBreastCancer;
        data["ageAtDiagnosis"] = this.ageAtDiagnosis;
        data["hormoneReplacementTherapy"] = this.hormoneReplacementTherapy;
        data["hormoneReplacementDuration"] = this.hormoneReplacementDuration;
        data["hormoneReplacementDate"] = this.hormoneReplacementDate ? this.hormoneReplacementDate.toISOString() : <any>undefined;
        data["hormoneReplacementLocation"] = this.hormoneReplacementLocation;
        data["hormoneReplacementResults"] = this.hormoneReplacementResults;
        data["previousSurgery"] = this.previousSurgery;
        data["previousSurgeryDate"] = this.previousSurgeryDate ? this.previousSurgeryDate.toISOString() : <any>undefined;
        data["previousSurgeryDetails"] = this.previousSurgeryDetails;
        data["lastClinicalExamDate"] = this.lastClinicalExamDate ? this.lastClinicalExamDate.toISOString() : <any>undefined;
        data["lastClinicalExamDetails"] = this.lastClinicalExamDetails;
        data["pregnant"] = this.pregnant;
        data["pregnantDate"] = this.pregnantDate ? this.pregnantDate.toISOString() : <any>undefined;
        data["pregnantDetails"] = this.pregnantDetails;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientOrderQuestion extends IEntityBase {
    patientOrderQuestionID: string;
    cardiacPacemaker?: boolean | undefined;
    deepBrainImplant?: boolean | undefined;
    externalPacerWires?: boolean | undefined;
    tissueExpander?: boolean | undefined;
    contrastAllergies?: boolean | undefined;
    surgicallyImplantedDevices?: boolean | undefined;
    surgicallyImplantedDeviceDescription?: string | undefined;
    informedToPresentImplantCard?: boolean | undefined;
    metallicForeignBodyFromEye?: boolean | undefined;
    orbitXrayOrdered?: boolean | undefined;
    locationOfProcedure?: string | undefined;
    claustrophobic?: boolean | undefined;
    familyHistoryOfBreastCancer?: boolean | undefined;
    ageAtDiagnosis?: number | undefined;
    hormoneReplacementTherapy?: boolean | undefined;
    hormoneReplacementDuration?: string | undefined;
    hormoneReplacementDate?: Date | undefined;
    hormoneReplacementLocation?: string | undefined;
    hormoneReplacementResults?: string | undefined;
    previousSurgery?: boolean | undefined;
    previousSurgeryDate?: Date | undefined;
    previousSurgeryDetails?: string | undefined;
    lastClinicalExamDate?: Date | undefined;
    lastClinicalExamDetails?: string | undefined;
    pregnant?: boolean | undefined;
    pregnantDate?: Date | undefined;
    pregnantDetails?: string | undefined;
}

export class Document extends EntityBase implements IDocument {
    fileDetail?: FileDetail | undefined;
    documentTypeTag?: Tag | undefined;
    documentID!: string;
    fileDetailID!: string;
    documentTypeTagID?: string | undefined;

    constructor(data?: IDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileDetail = _data["fileDetail"] ? FileDetail.fromJS(_data["fileDetail"]) : <any>undefined;
            this.documentTypeTag = _data["documentTypeTag"] ? Tag.fromJS(_data["documentTypeTag"]) : <any>undefined;
            this.documentID = _data["documentID"];
            this.fileDetailID = _data["fileDetailID"];
            this.documentTypeTagID = _data["documentTypeTagID"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileDetail"] = this.fileDetail ? this.fileDetail.toJSON() : <any>undefined;
        data["documentTypeTag"] = this.documentTypeTag ? this.documentTypeTag.toJSON() : <any>undefined;
        data["documentID"] = this.documentID;
        data["fileDetailID"] = this.fileDetailID;
        data["documentTypeTagID"] = this.documentTypeTagID;
        super.toJSON(data);
        return data;
    }
}

export interface IDocument extends IEntityBase {
    fileDetail?: FileDetail | undefined;
    documentTypeTag?: Tag | undefined;
    documentID: string;
    fileDetailID: string;
    documentTypeTagID?: string | undefined;
}

export class ProviderImage extends EntityBase implements IProviderImage {
    providerImageID!: string;
    providerID!: string;
    providerImageEnum!: ProviderImageEnum;
    displaySortOrder!: number;
    imageDetailID!: string;
    description!: string;
    provider?: Provider | undefined;

    constructor(data?: IProviderImage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerImageID = _data["providerImageID"];
            this.providerID = _data["providerID"];
            this.providerImageEnum = _data["providerImageEnum"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.imageDetailID = _data["imageDetailID"];
            this.description = _data["description"];
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderImage {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerImageID"] = this.providerImageID;
        data["providerID"] = this.providerID;
        data["providerImageEnum"] = this.providerImageEnum;
        data["displaySortOrder"] = this.displaySortOrder;
        data["imageDetailID"] = this.imageDetailID;
        data["description"] = this.description;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderImage extends IEntityBase {
    providerImageID: string;
    providerID: string;
    providerImageEnum: ProviderImageEnum;
    displaySortOrder: number;
    imageDetailID: string;
    description: string;
    provider?: Provider | undefined;
}

export enum ProviderImageEnum {
    Banner = "Banner",
    Gallery = "Gallery",
}

export class ProviderSetting extends EntityBase implements IProviderSetting {
    providerSettingID!: string;
    providerID!: string;
    providerSettingEnum!: ProviderSettingEnum;
    description?: string | undefined;
    value!: string;

    constructor(data?: IProviderSetting) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerSettingID = _data["providerSettingID"];
            this.providerID = _data["providerID"];
            this.providerSettingEnum = _data["providerSettingEnum"];
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProviderSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerSettingID"] = this.providerSettingID;
        data["providerID"] = this.providerID;
        data["providerSettingEnum"] = this.providerSettingEnum;
        data["description"] = this.description;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderSetting extends IEntityBase {
    providerSettingID: string;
    providerID: string;
    providerSettingEnum: ProviderSettingEnum;
    description?: string | undefined;
    value: string;
}

export enum ProviderSettingEnum {
    PrescriptionCountry = "PrescriptionCountry",
    RecordConsults = "RecordConsults",
    SendAppointmentEmails = "SendAppointmentEmails",
    SendAppointmentSMSs = "SendAppointmentSMSs",
    ResidentProvider = "ResidentProvider",
    PreceptorProvider = "PreceptorProvider",
    Organization = "Organization",
    Department = "Department",
    ReceptionistForProvider = "ReceptionistForProvider",
    ReceptionistForDepartment = "ReceptionistForDepartment",
    ReceptionistForOrganization = "ReceptionistForOrganization",
    ReferralCode = "ReferralCode",
    ProviderQueue = "ProviderQueue",
    ReceptionistForStore = "ReceptionistForStore",
    StoreManager = "StoreManager",
    StoreManagerInventoryGLAccountID = "StoreManagerInventoryGLAccountID",
    StoreManagerTaxID = "StoreManagerTaxID",
    InventoryManagerStoreID = "InventoryManagerStoreID",
    OrganizationManager = "OrganizationManager",
    ProviderQueueSMS = "ProviderQueueSMS",
    Subscription = "Subscription",
    NeoPaymentMessageName = "NeoPaymentMessageName",
}

export class ProviderAchievement extends EntityBase implements IProviderAchievement {
    providerAchievementID!: string;
    providerID!: string;
    name!: string;
    description?: string | undefined;
    documentID?: string;
    dateAchieved?: Date | undefined;
    expiryDate?: Date | undefined;
    licenseVerificationStatusEnum?: LicenseVerificationStatusEnum;
    document?: Document | undefined;

    constructor(data?: IProviderAchievement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerAchievementID = _data["providerAchievementID"];
            this.providerID = _data["providerID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.documentID = _data["documentID"];
            this.dateAchieved = _data["dateAchieved"] ? new Date(_data["dateAchieved"].toString()) : <any>undefined;
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.licenseVerificationStatusEnum = _data["licenseVerificationStatusEnum"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderAchievement {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderAchievement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerAchievementID"] = this.providerAchievementID;
        data["providerID"] = this.providerID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["documentID"] = this.documentID;
        data["dateAchieved"] = this.dateAchieved ? this.dateAchieved.toISOString() : <any>undefined;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["licenseVerificationStatusEnum"] = this.licenseVerificationStatusEnum;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderAchievement extends IEntityBase {
    providerAchievementID: string;
    providerID: string;
    name: string;
    description?: string | undefined;
    documentID?: string;
    dateAchieved?: Date | undefined;
    expiryDate?: Date | undefined;
    licenseVerificationStatusEnum?: LicenseVerificationStatusEnum;
    document?: Document | undefined;
}

export enum LicenseVerificationStatusEnum {
    NotSet = "NotSet",
    Pending = "Pending",
    Approved = "Approved",
    Denied = "Denied",
    Expired = "Expired",
}

export class ProviderRegistration extends EntityBase implements IProviderRegistration {
    providerRegistrationID!: string;
    providerID!: string;
    licenseTagID?: string | undefined;
    licenseOther?: string | undefined;
    licensedStates?: string | undefined;
    licenseYearIssued?: number | undefined;
    licenseNumber?: string | undefined;
    licenseCountryTagID?: string | undefined;
    documentID?: string | undefined;
    licenseTag?: Tag | undefined;
    licenseCountryTag?: Tag | undefined;

    constructor(data?: IProviderRegistration) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerRegistrationID = _data["providerRegistrationID"];
            this.providerID = _data["providerID"];
            this.licenseTagID = _data["licenseTagID"];
            this.licenseOther = _data["licenseOther"];
            this.licensedStates = _data["licensedStates"];
            this.licenseYearIssued = _data["licenseYearIssued"];
            this.licenseNumber = _data["licenseNumber"];
            this.licenseCountryTagID = _data["licenseCountryTagID"];
            this.documentID = _data["documentID"];
            this.licenseTag = _data["licenseTag"] ? Tag.fromJS(_data["licenseTag"]) : <any>undefined;
            this.licenseCountryTag = _data["licenseCountryTag"] ? Tag.fromJS(_data["licenseCountryTag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerRegistrationID"] = this.providerRegistrationID;
        data["providerID"] = this.providerID;
        data["licenseTagID"] = this.licenseTagID;
        data["licenseOther"] = this.licenseOther;
        data["licensedStates"] = this.licensedStates;
        data["licenseYearIssued"] = this.licenseYearIssued;
        data["licenseNumber"] = this.licenseNumber;
        data["licenseCountryTagID"] = this.licenseCountryTagID;
        data["documentID"] = this.documentID;
        data["licenseTag"] = this.licenseTag ? this.licenseTag.toJSON() : <any>undefined;
        data["licenseCountryTag"] = this.licenseCountryTag ? this.licenseCountryTag.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderRegistration extends IEntityBase {
    providerRegistrationID: string;
    providerID: string;
    licenseTagID?: string | undefined;
    licenseOther?: string | undefined;
    licensedStates?: string | undefined;
    licenseYearIssued?: number | undefined;
    licenseNumber?: string | undefined;
    licenseCountryTagID?: string | undefined;
    documentID?: string | undefined;
    licenseTag?: Tag | undefined;
    licenseCountryTag?: Tag | undefined;
}

export class ProviderTag extends EntityBase implements IProviderTag {
    providerTagID!: string;
    providerID!: string;
    tagID!: string;
    isPrimary!: boolean;
    displaySortOrder!: number;
    tag?: Tag | undefined;
    provider?: Provider | undefined;

    constructor(data?: IProviderTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerTagID = _data["providerTagID"];
            this.providerID = _data["providerID"];
            this.tagID = _data["tagID"];
            this.isPrimary = _data["isPrimary"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderTag {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerTagID"] = this.providerTagID;
        data["providerID"] = this.providerID;
        data["tagID"] = this.tagID;
        data["isPrimary"] = this.isPrimary;
        data["displaySortOrder"] = this.displaySortOrder;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderTag extends IEntityBase {
    providerTagID: string;
    providerID: string;
    tagID: string;
    isPrimary: boolean;
    displaySortOrder: number;
    tag?: Tag | undefined;
    provider?: Provider | undefined;
}

export class ProviderSpecialty extends EntityBase implements IProviderSpecialty {
    providerSpecialtyID!: string;
    name!: string;
    providerID!: string;
    tagID!: string;
    isPrimary!: boolean;
    displaySortOrder!: number;
    provider?: Provider | undefined;

    constructor(data?: IProviderSpecialty) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerSpecialtyID = _data["providerSpecialtyID"];
            this.name = _data["name"];
            this.providerID = _data["providerID"];
            this.tagID = _data["tagID"];
            this.isPrimary = _data["isPrimary"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderSpecialty {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSpecialty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerSpecialtyID"] = this.providerSpecialtyID;
        data["name"] = this.name;
        data["providerID"] = this.providerID;
        data["tagID"] = this.tagID;
        data["isPrimary"] = this.isPrimary;
        data["displaySortOrder"] = this.displaySortOrder;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderSpecialty extends IEntityBase {
    providerSpecialtyID: string;
    name: string;
    providerID: string;
    tagID: string;
    isPrimary: boolean;
    displaySortOrder: number;
    provider?: Provider | undefined;
}

export class ProviderQueue extends EntityBase implements IProviderQueue {
    providerQueueID!: string;
    providerID!: string;
    smsNumber!: string;
    providerQueueStatusEnum!: ProviderQueueStatusEnum;
    associatedID!: string;
    sentSMSID?: string | undefined;
    sentDate!: Date;
    receivedSMSID?: string | undefined;
    receivedDate?: Date | undefined;
    timeoutTaskItemID!: string;
    timeoutSMSID?: string | undefined;
    timeoutDate?: Date | undefined;
    sentSMS?: SMS | undefined;
    receivedSMS?: SMS | undefined;
    provider?: Provider | undefined;

    constructor(data?: IProviderQueue) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerQueueID = _data["providerQueueID"];
            this.providerID = _data["providerID"];
            this.smsNumber = _data["smsNumber"];
            this.providerQueueStatusEnum = _data["providerQueueStatusEnum"];
            this.associatedID = _data["associatedID"];
            this.sentSMSID = _data["sentSMSID"];
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.receivedSMSID = _data["receivedSMSID"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.timeoutTaskItemID = _data["timeoutTaskItemID"];
            this.timeoutSMSID = _data["timeoutSMSID"];
            this.timeoutDate = _data["timeoutDate"] ? new Date(_data["timeoutDate"].toString()) : <any>undefined;
            this.sentSMS = _data["sentSMS"] ? SMS.fromJS(_data["sentSMS"]) : <any>undefined;
            this.receivedSMS = _data["receivedSMS"] ? SMS.fromJS(_data["receivedSMS"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderQueue {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerQueueID"] = this.providerQueueID;
        data["providerID"] = this.providerID;
        data["smsNumber"] = this.smsNumber;
        data["providerQueueStatusEnum"] = this.providerQueueStatusEnum;
        data["associatedID"] = this.associatedID;
        data["sentSMSID"] = this.sentSMSID;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["receivedSMSID"] = this.receivedSMSID;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["timeoutTaskItemID"] = this.timeoutTaskItemID;
        data["timeoutSMSID"] = this.timeoutSMSID;
        data["timeoutDate"] = this.timeoutDate ? this.timeoutDate.toISOString() : <any>undefined;
        data["sentSMS"] = this.sentSMS ? this.sentSMS.toJSON() : <any>undefined;
        data["receivedSMS"] = this.receivedSMS ? this.receivedSMS.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderQueue extends IEntityBase {
    providerQueueID: string;
    providerID: string;
    smsNumber: string;
    providerQueueStatusEnum: ProviderQueueStatusEnum;
    associatedID: string;
    sentSMSID?: string | undefined;
    sentDate: Date;
    receivedSMSID?: string | undefined;
    receivedDate?: Date | undefined;
    timeoutTaskItemID: string;
    timeoutSMSID?: string | undefined;
    timeoutDate?: Date | undefined;
    sentSMS?: SMS | undefined;
    receivedSMS?: SMS | undefined;
    provider?: Provider | undefined;
}

export enum ProviderQueueStatusEnum {
    NotSent = "NotSent",
    Sent = "Sent",
    Accepted = "Accepted",
    Declined = "Declined",
    TimedOut = "TimedOut",
}

export class SMS extends EntityBase implements ISMS {
    smsid!: string;
    userDetailID!: string;
    smsNumber!: string;
    smsStatusEnum!: SMSStatusEnum;
    sendDate!: Date;
    sentDate?: Date | undefined;
    message!: string;
    errorMessage?: string | undefined;

    constructor(data?: ISMS) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.smsid = _data["smsid"];
            this.userDetailID = _data["userDetailID"];
            this.smsNumber = _data["smsNumber"];
            this.smsStatusEnum = _data["smsStatusEnum"];
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): SMS {
        data = typeof data === 'object' ? data : {};
        let result = new SMS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsid"] = this.smsid;
        data["userDetailID"] = this.userDetailID;
        data["smsNumber"] = this.smsNumber;
        data["smsStatusEnum"] = this.smsStatusEnum;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["errorMessage"] = this.errorMessage;
        super.toJSON(data);
        return data;
    }
}

export interface ISMS extends IEntityBase {
    smsid: string;
    userDetailID: string;
    smsNumber: string;
    smsStatusEnum: SMSStatusEnum;
    sendDate: Date;
    sentDate?: Date | undefined;
    message: string;
    errorMessage?: string | undefined;
}

export enum SMSStatusEnum {
    Queued = "Queued",
    Sending = "Sending",
    Sent = "Sent",
    Failed = "Failed",
    Delivered = "Delivered",
    UnDelivered = "UnDelivered",
    Receiving = "Receiving",
    Received = "Received",
    Accepted = "Accepted",
    Scheduled = "Scheduled",
    Read = "Read",
    PartiallyDelivered = "PartiallyDelivered",
    Unknown = "Unknown",
    SendNow = "SendNow",
    Cancelled = "Cancelled",
}

export class ProviderOnboarding extends EntityBase implements IProviderOnboarding {
    providerOnboardingID!: string;
    accountTypeEnum!: AccountTypeEnum;
    onboardingStateEnum!: OnboardingStateEnum;
    facilityName?: string | undefined;
    facilityRoleTagID?: string | undefined;
    facilitySpecializationTagID?: string | undefined;
    facilityNumberOfEmployees?: number | undefined;
    facilityLicenseType?: string | undefined;
    facilityLicenseYearIssued?: number | undefined;
    facilityLicenseNumber?: string | undefined;
    facilityLicenseCountryID?: string | undefined;
    facilityNumberOfBedTagID?: string | undefined;
    countryID!: string;
    addressLine1?: string | undefined;
    provinceStateID?: string | undefined;
    cityTownID?: string | undefined;
    contactPhoneNumber?: string | undefined;
    profitPercentageRate?: number | undefined;
    contractDetails?: string | undefined;
    contractFileDetailID?: string | undefined;
    providerFullName?: string | undefined;
    userDetailID?: string;
    contractFileDetail?: FileDetail | undefined;

    constructor(data?: IProviderOnboarding) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerOnboardingID = _data["providerOnboardingID"];
            this.accountTypeEnum = _data["accountTypeEnum"];
            this.onboardingStateEnum = _data["onboardingStateEnum"];
            this.facilityName = _data["facilityName"];
            this.facilityRoleTagID = _data["facilityRoleTagID"];
            this.facilitySpecializationTagID = _data["facilitySpecializationTagID"];
            this.facilityNumberOfEmployees = _data["facilityNumberOfEmployees"];
            this.facilityLicenseType = _data["facilityLicenseType"];
            this.facilityLicenseYearIssued = _data["facilityLicenseYearIssued"];
            this.facilityLicenseNumber = _data["facilityLicenseNumber"];
            this.facilityLicenseCountryID = _data["facilityLicenseCountryID"];
            this.facilityNumberOfBedTagID = _data["facilityNumberOfBedTagID"];
            this.countryID = _data["countryID"];
            this.addressLine1 = _data["addressLine1"];
            this.provinceStateID = _data["provinceStateID"];
            this.cityTownID = _data["cityTownID"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.profitPercentageRate = _data["profitPercentageRate"];
            this.contractDetails = _data["contractDetails"];
            this.contractFileDetailID = _data["contractFileDetailID"];
            this.providerFullName = _data["providerFullName"];
            this.userDetailID = _data["userDetailID"];
            this.contractFileDetail = _data["contractFileDetail"] ? FileDetail.fromJS(_data["contractFileDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderOnboarding {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderOnboarding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerOnboardingID"] = this.providerOnboardingID;
        data["accountTypeEnum"] = this.accountTypeEnum;
        data["onboardingStateEnum"] = this.onboardingStateEnum;
        data["facilityName"] = this.facilityName;
        data["facilityRoleTagID"] = this.facilityRoleTagID;
        data["facilitySpecializationTagID"] = this.facilitySpecializationTagID;
        data["facilityNumberOfEmployees"] = this.facilityNumberOfEmployees;
        data["facilityLicenseType"] = this.facilityLicenseType;
        data["facilityLicenseYearIssued"] = this.facilityLicenseYearIssued;
        data["facilityLicenseNumber"] = this.facilityLicenseNumber;
        data["facilityLicenseCountryID"] = this.facilityLicenseCountryID;
        data["facilityNumberOfBedTagID"] = this.facilityNumberOfBedTagID;
        data["countryID"] = this.countryID;
        data["addressLine1"] = this.addressLine1;
        data["provinceStateID"] = this.provinceStateID;
        data["cityTownID"] = this.cityTownID;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["profitPercentageRate"] = this.profitPercentageRate;
        data["contractDetails"] = this.contractDetails;
        data["contractFileDetailID"] = this.contractFileDetailID;
        data["providerFullName"] = this.providerFullName;
        data["userDetailID"] = this.userDetailID;
        data["contractFileDetail"] = this.contractFileDetail ? this.contractFileDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderOnboarding extends IEntityBase {
    providerOnboardingID: string;
    accountTypeEnum: AccountTypeEnum;
    onboardingStateEnum: OnboardingStateEnum;
    facilityName?: string | undefined;
    facilityRoleTagID?: string | undefined;
    facilitySpecializationTagID?: string | undefined;
    facilityNumberOfEmployees?: number | undefined;
    facilityLicenseType?: string | undefined;
    facilityLicenseYearIssued?: number | undefined;
    facilityLicenseNumber?: string | undefined;
    facilityLicenseCountryID?: string | undefined;
    facilityNumberOfBedTagID?: string | undefined;
    countryID: string;
    addressLine1?: string | undefined;
    provinceStateID?: string | undefined;
    cityTownID?: string | undefined;
    contactPhoneNumber?: string | undefined;
    profitPercentageRate?: number | undefined;
    contractDetails?: string | undefined;
    contractFileDetailID?: string | undefined;
    providerFullName?: string | undefined;
    userDetailID?: string;
    contractFileDetail?: FileDetail | undefined;
}

export enum AccountTypeEnum {
    Provider = "Provider",
    Clinic = "Clinic",
    DiagnosticsFacility = "DiagnosticsFacility",
    Pharmacy = "Pharmacy",
    Hospital = "Hospital",
    Other = "Other",
}

export enum OnboardingStateEnum {
    New = "New",
    Draft = "Draft",
    UnderReview = "UnderReview",
    Approved = "Approved",
    Declined = "Declined",
}

export class ProviderScheduleStoreItem extends EntityBase implements IProviderScheduleStoreItem {
    providerScheduleStoreItemID!: string;
    providerScheduleID!: string;
    storeItemID!: string;
    storeItem?: StoreItem | undefined;

    constructor(data?: IProviderScheduleStoreItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerScheduleStoreItemID = _data["providerScheduleStoreItemID"];
            this.providerScheduleID = _data["providerScheduleID"];
            this.storeItemID = _data["storeItemID"];
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderScheduleStoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderScheduleStoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerScheduleStoreItemID"] = this.providerScheduleStoreItemID;
        data["providerScheduleID"] = this.providerScheduleID;
        data["storeItemID"] = this.storeItemID;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderScheduleStoreItem extends IEntityBase {
    providerScheduleStoreItemID: string;
    providerScheduleID: string;
    storeItemID: string;
    storeItem?: StoreItem | undefined;
}

export class ConsultSMS extends EntityBase implements IConsultSMS {
    sms?: SMS | undefined;
    consultSMSID!: string;
    consultID!: string;
    smsid!: string;

    constructor(data?: IConsultSMS) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sms = _data["sms"] ? SMS.fromJS(_data["sms"]) : <any>undefined;
            this.consultSMSID = _data["consultSMSID"];
            this.consultID = _data["consultID"];
            this.smsid = _data["smsid"];
        }
    }

    static fromJS(data: any): ConsultSMS {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultSMS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sms"] = this.sms ? this.sms.toJSON() : <any>undefined;
        data["consultSMSID"] = this.consultSMSID;
        data["consultID"] = this.consultID;
        data["smsid"] = this.smsid;
        super.toJSON(data);
        return data;
    }
}

export interface IConsultSMS extends IEntityBase {
    sms?: SMS | undefined;
    consultSMSID: string;
    consultID: string;
    smsid: string;
}

export class ConsultStoreItem extends EntityBase implements IConsultStoreItem {
    consult?: Consult | undefined;
    storeItem?: StoreItem | undefined;
    provider?: Provider | undefined;
    notificationID?: string;
    consultStoreItemID!: string;
    consultID!: string;
    storeItemID!: string;
    consultStoreItemTypeEnum!: ConsultStoreItemTypeEnum;
    providerID?: string | undefined;
    userDetailID?: string | undefined;
    token?: string | undefined;
    data?: string | undefined;
    name?: string | undefined;
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;
    sent!: boolean;
    sentDate?: Date | undefined;
    acceptedDate?: Date | undefined;
    rejectedDate?: Date | undefined;
    inviteCodeID?: string | undefined;
    pin?: number | undefined;
    pinAttempts?: number | undefined;
    storeID?: string | undefined;

    constructor(data?: IConsultStoreItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.consult = _data["consult"] ? Consult.fromJS(_data["consult"]) : <any>undefined;
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.notificationID = _data["notificationID"];
            this.consultStoreItemID = _data["consultStoreItemID"];
            this.consultID = _data["consultID"];
            this.storeItemID = _data["storeItemID"];
            this.consultStoreItemTypeEnum = _data["consultStoreItemTypeEnum"];
            this.providerID = _data["providerID"];
            this.userDetailID = _data["userDetailID"];
            this.token = _data["token"];
            this.data = _data["data"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.smsNumber = _data["smsNumber"];
            this.sent = _data["sent"];
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.acceptedDate = _data["acceptedDate"] ? new Date(_data["acceptedDate"].toString()) : <any>undefined;
            this.rejectedDate = _data["rejectedDate"] ? new Date(_data["rejectedDate"].toString()) : <any>undefined;
            this.inviteCodeID = _data["inviteCodeID"];
            this.pin = _data["pin"];
            this.pinAttempts = _data["pinAttempts"];
            this.storeID = _data["storeID"];
        }
    }

    static fromJS(data: any): ConsultStoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultStoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consult"] = this.consult ? this.consult.toJSON() : <any>undefined;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["notificationID"] = this.notificationID;
        data["consultStoreItemID"] = this.consultStoreItemID;
        data["consultID"] = this.consultID;
        data["storeItemID"] = this.storeItemID;
        data["consultStoreItemTypeEnum"] = this.consultStoreItemTypeEnum;
        data["providerID"] = this.providerID;
        data["userDetailID"] = this.userDetailID;
        data["token"] = this.token;
        data["data"] = this.data;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["smsNumber"] = this.smsNumber;
        data["sent"] = this.sent;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["acceptedDate"] = this.acceptedDate ? this.acceptedDate.toISOString() : <any>undefined;
        data["rejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : <any>undefined;
        data["inviteCodeID"] = this.inviteCodeID;
        data["pin"] = this.pin;
        data["pinAttempts"] = this.pinAttempts;
        data["storeID"] = this.storeID;
        super.toJSON(data);
        return data;
    }
}

export interface IConsultStoreItem extends IEntityBase {
    consult?: Consult | undefined;
    storeItem?: StoreItem | undefined;
    provider?: Provider | undefined;
    notificationID?: string;
    consultStoreItemID: string;
    consultID: string;
    storeItemID: string;
    consultStoreItemTypeEnum: ConsultStoreItemTypeEnum;
    providerID?: string | undefined;
    userDetailID?: string | undefined;
    token?: string | undefined;
    data?: string | undefined;
    name?: string | undefined;
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;
    sent: boolean;
    sentDate?: Date | undefined;
    acceptedDate?: Date | undefined;
    rejectedDate?: Date | undefined;
    inviteCodeID?: string | undefined;
    pin?: number | undefined;
    pinAttempts?: number | undefined;
    storeID?: string | undefined;
}

export enum ConsultStoreItemTypeEnum {
    Primary = "Primary",
    AdditionalProvider = "AdditionalProvider",
    AdditionalPatient = "AdditionalPatient",
}

export class ConsultChat extends EntityBase implements IConsultChat {
    userDetail?: UserDetail | undefined;
    consultChatID!: string;
    consultID!: string;
    userDetailID!: string;
    message!: string;
    messageDate!: Date;

    constructor(data?: IConsultChat) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.consultChatID = _data["consultChatID"];
            this.consultID = _data["consultID"];
            this.userDetailID = _data["userDetailID"];
            this.message = _data["message"];
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultChat {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultChat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["consultChatID"] = this.consultChatID;
        data["consultID"] = this.consultID;
        data["userDetailID"] = this.userDetailID;
        data["message"] = this.message;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IConsultChat extends IEntityBase {
    userDetail?: UserDetail | undefined;
    consultChatID: string;
    consultID: string;
    userDetailID: string;
    message: string;
    messageDate: Date;
}

export class ConsultTag extends EntityBase implements IConsultTag {
    tag?: Tag | undefined;
    consultTagID!: string;
    consultID!: string;
    consultTagTypeEnum!: ConsultTagTypeEnum;
    tagID!: string;

    constructor(data?: IConsultTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.consultTagID = _data["consultTagID"];
            this.consultID = _data["consultID"];
            this.consultTagTypeEnum = _data["consultTagTypeEnum"];
            this.tagID = _data["tagID"];
        }
    }

    static fromJS(data: any): ConsultTag {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["consultTagID"] = this.consultTagID;
        data["consultID"] = this.consultID;
        data["consultTagTypeEnum"] = this.consultTagTypeEnum;
        data["tagID"] = this.tagID;
        super.toJSON(data);
        return data;
    }
}

export interface IConsultTag extends IEntityBase {
    tag?: Tag | undefined;
    consultTagID: string;
    consultID: string;
    consultTagTypeEnum: ConsultTagTypeEnum;
    tagID: string;
}

export enum ConsultTypeEnum {
    Video = "Video",
    Audio = "Audio",
    Chat = "Chat",
    InPerson = "In Person",
    ProviderInitiated = "Provider Initiated",
}

export enum ConsultStatusEnum {
    New = "New",
    PatientReady = "PatientReady",
    ProviderReady = "ProviderReady",
    ConsultReady = "ConsultReady",
    InProgress = "InProgress",
    PatientCompleted = "PatientCompleted",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Scheduled = "Scheduled",
    NoShow = "No Show",
}

export enum BookedByEnum {
    Patient = "Patient",
    Provider = "Provider",
    Receptionist = "Receptionist",
}

export enum StoreAvailabilityTypeEnum {
    NoAvailability = "NoAvailability",
    Appointment = "Appointment",
    AppointmentAndWalkIn = "AppointmentAndWalkIn",
    WalkIn = "WalkIn",
}

export class StoreRoom extends EntityBase implements IStoreRoom {
    storeRoomID!: string;
    storeID!: string;
    storeRoomTypeEnum!: StoreRoomTypeEnum;
    name!: string;
    description!: string;
    externalID?: string | undefined;
    enabled!: boolean;
    store?: Store | undefined;

    constructor(data?: IStoreRoom) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeRoomID = _data["storeRoomID"];
            this.storeID = _data["storeID"];
            this.storeRoomTypeEnum = _data["storeRoomTypeEnum"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.externalID = _data["externalID"];
            this.enabled = _data["enabled"];
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreRoom {
        data = typeof data === 'object' ? data : {};
        let result = new StoreRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeRoomID"] = this.storeRoomID;
        data["storeID"] = this.storeID;
        data["storeRoomTypeEnum"] = this.storeRoomTypeEnum;
        data["name"] = this.name;
        data["description"] = this.description;
        data["externalID"] = this.externalID;
        data["enabled"] = this.enabled;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreRoom extends IEntityBase {
    storeRoomID: string;
    storeID: string;
    storeRoomTypeEnum: StoreRoomTypeEnum;
    name: string;
    description: string;
    externalID?: string | undefined;
    enabled: boolean;
    store?: Store | undefined;
}

export enum StoreRoomTypeEnum {
    Normal = "Normal",
}

export class StoreItemTag extends EntityBase implements IStoreItemTag {
    storeItemTagID!: string;
    storeItemID!: string;
    tagID!: string;
    storeItem?: StoreItem | undefined;
    tag?: Tag | undefined;

    constructor(data?: IStoreItemTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeItemTagID = _data["storeItemTagID"];
            this.storeItemID = _data["storeItemID"];
            this.tagID = _data["tagID"];
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreItemTag {
        data = typeof data === 'object' ? data : {};
        let result = new StoreItemTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeItemTagID"] = this.storeItemTagID;
        data["storeItemID"] = this.storeItemID;
        data["tagID"] = this.tagID;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreItemTag extends IEntityBase {
    storeItemTagID: string;
    storeItemID: string;
    tagID: string;
    storeItem?: StoreItem | undefined;
    tag?: Tag | undefined;
}

export class StoreItemForm extends EntityBase implements IStoreItemForm {
    storeItemFormID!: string;
    storeItemID!: string;
    formID!: string;
    required!: boolean;
    storeItem?: StoreItem | undefined;
    form?: Form | undefined;
    formName?: string | undefined;
    formShortName?: string | undefined;

    constructor(data?: IStoreItemForm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeItemFormID = _data["storeItemFormID"];
            this.storeItemID = _data["storeItemID"];
            this.formID = _data["formID"];
            this.required = _data["required"];
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.form = _data["form"] ? Form.fromJS(_data["form"]) : <any>undefined;
            this.formName = _data["formName"];
            this.formShortName = _data["formShortName"];
        }
    }

    static fromJS(data: any): StoreItemForm {
        data = typeof data === 'object' ? data : {};
        let result = new StoreItemForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeItemFormID"] = this.storeItemFormID;
        data["storeItemID"] = this.storeItemID;
        data["formID"] = this.formID;
        data["required"] = this.required;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        data["formName"] = this.formName;
        data["formShortName"] = this.formShortName;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreItemForm extends IEntityBase {
    storeItemFormID: string;
    storeItemID: string;
    formID: string;
    required: boolean;
    storeItem?: StoreItem | undefined;
    form?: Form | undefined;
    formName?: string | undefined;
    formShortName?: string | undefined;
}

export class Form extends EntityBase implements IForm {
    formQuestions?: FormQuestion[] | undefined;
    formID!: string;
    name!: string;
    shortName!: string;
    description!: string;
    category?: string | undefined;
    enabled!: boolean;
    formTypeEnum!: FormTypeEnum;
    displaySortOrder!: number;
    theme?: string | undefined;
    passScore?: number | undefined;
    isPHR!: boolean;
    notes?: string | undefined;
    scoreFormTypeName?: string | undefined;

    constructor(data?: IForm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["formQuestions"])) {
                this.formQuestions = [] as any;
                for (let item of _data["formQuestions"])
                    this.formQuestions!.push(FormQuestion.fromJS(item));
            }
            this.formID = _data["formID"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.category = _data["category"];
            this.enabled = _data["enabled"];
            this.formTypeEnum = _data["formTypeEnum"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.theme = _data["theme"];
            this.passScore = _data["passScore"];
            this.isPHR = _data["isPHR"];
            this.notes = _data["notes"];
            this.scoreFormTypeName = _data["scoreFormTypeName"];
        }
    }

    static fromJS(data: any): Form {
        data = typeof data === 'object' ? data : {};
        let result = new Form();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formQuestions)) {
            data["formQuestions"] = [];
            for (let item of this.formQuestions)
                data["formQuestions"].push(item.toJSON());
        }
        data["formID"] = this.formID;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["category"] = this.category;
        data["enabled"] = this.enabled;
        data["formTypeEnum"] = this.formTypeEnum;
        data["displaySortOrder"] = this.displaySortOrder;
        data["theme"] = this.theme;
        data["passScore"] = this.passScore;
        data["isPHR"] = this.isPHR;
        data["notes"] = this.notes;
        data["scoreFormTypeName"] = this.scoreFormTypeName;
        super.toJSON(data);
        return data;
    }
}

export interface IForm extends IEntityBase {
    formQuestions?: FormQuestion[] | undefined;
    formID: string;
    name: string;
    shortName: string;
    description: string;
    category?: string | undefined;
    enabled: boolean;
    formTypeEnum: FormTypeEnum;
    displaySortOrder: number;
    theme?: string | undefined;
    passScore?: number | undefined;
    isPHR: boolean;
    notes?: string | undefined;
    scoreFormTypeName?: string | undefined;
}

export class FormQuestion extends EntityBase implements IFormQuestion {
    formQuestionChoices?: FormQuestionChoice[] | undefined;
    formQuestionID!: string;
    formID!: string;
    name!: string;
    nameStyle?: string | undefined;
    description?: string | undefined;
    descriptionStyle?: string | undefined;
    formQuestionTypeEnum!: FormQuestionTypeEnum;
    buttonText?: string | undefined;
    enabled!: boolean;
    imageURL?: string | undefined;
    resourceURL?: string | undefined;
    displaySortOrder!: number;
    correctValue?: string | undefined;
    correctAnswerText?: string | undefined;
    incorrectAnswerText?: string | undefined;
    required!: boolean;
    multipleSelection?: boolean | undefined;
    multipleRandomize?: boolean | undefined;
    multipleOtherOption?: boolean | undefined;
    multipleVerticalAlignment?: boolean | undefined;
    multipleShowChoiceLabels?: boolean | undefined;
    scaleStart?: number | undefined;
    scaleIncrement?: number | undefined;
    scaleStop?: number | undefined;
    scaleLeftLabel?: string | undefined;
    scaleMiddleLabel?: string | undefined;
    scaleRightLabel?: string | undefined;
    ratingSteps?: number | undefined;
    ratingShapeEnum?: RatingShapeEnum | undefined;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IFormQuestion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["formQuestionChoices"])) {
                this.formQuestionChoices = [] as any;
                for (let item of _data["formQuestionChoices"])
                    this.formQuestionChoices!.push(FormQuestionChoice.fromJS(item));
            }
            this.formQuestionID = _data["formQuestionID"];
            this.formID = _data["formID"];
            this.name = _data["name"];
            this.nameStyle = _data["nameStyle"];
            this.description = _data["description"];
            this.descriptionStyle = _data["descriptionStyle"];
            this.formQuestionTypeEnum = _data["formQuestionTypeEnum"];
            this.buttonText = _data["buttonText"];
            this.enabled = _data["enabled"];
            this.imageURL = _data["imageURL"];
            this.resourceURL = _data["resourceURL"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.correctValue = _data["correctValue"];
            this.correctAnswerText = _data["correctAnswerText"];
            this.incorrectAnswerText = _data["incorrectAnswerText"];
            this.required = _data["required"];
            this.multipleSelection = _data["multipleSelection"];
            this.multipleRandomize = _data["multipleRandomize"];
            this.multipleOtherOption = _data["multipleOtherOption"];
            this.multipleVerticalAlignment = _data["multipleVerticalAlignment"];
            this.multipleShowChoiceLabels = _data["multipleShowChoiceLabels"];
            this.scaleStart = _data["scaleStart"];
            this.scaleIncrement = _data["scaleIncrement"];
            this.scaleStop = _data["scaleStop"];
            this.scaleLeftLabel = _data["scaleLeftLabel"];
            this.scaleMiddleLabel = _data["scaleMiddleLabel"];
            this.scaleRightLabel = _data["scaleRightLabel"];
            this.ratingSteps = _data["ratingSteps"];
            this.ratingShapeEnum = _data["ratingShapeEnum"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): FormQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formQuestionChoices)) {
            data["formQuestionChoices"] = [];
            for (let item of this.formQuestionChoices)
                data["formQuestionChoices"].push(item.toJSON());
        }
        data["formQuestionID"] = this.formQuestionID;
        data["formID"] = this.formID;
        data["name"] = this.name;
        data["nameStyle"] = this.nameStyle;
        data["description"] = this.description;
        data["descriptionStyle"] = this.descriptionStyle;
        data["formQuestionTypeEnum"] = this.formQuestionTypeEnum;
        data["buttonText"] = this.buttonText;
        data["enabled"] = this.enabled;
        data["imageURL"] = this.imageURL;
        data["resourceURL"] = this.resourceURL;
        data["displaySortOrder"] = this.displaySortOrder;
        data["correctValue"] = this.correctValue;
        data["correctAnswerText"] = this.correctAnswerText;
        data["incorrectAnswerText"] = this.incorrectAnswerText;
        data["required"] = this.required;
        data["multipleSelection"] = this.multipleSelection;
        data["multipleRandomize"] = this.multipleRandomize;
        data["multipleOtherOption"] = this.multipleOtherOption;
        data["multipleVerticalAlignment"] = this.multipleVerticalAlignment;
        data["multipleShowChoiceLabels"] = this.multipleShowChoiceLabels;
        data["scaleStart"] = this.scaleStart;
        data["scaleIncrement"] = this.scaleIncrement;
        data["scaleStop"] = this.scaleStop;
        data["scaleLeftLabel"] = this.scaleLeftLabel;
        data["scaleMiddleLabel"] = this.scaleMiddleLabel;
        data["scaleRightLabel"] = this.scaleRightLabel;
        data["ratingSteps"] = this.ratingSteps;
        data["ratingShapeEnum"] = this.ratingShapeEnum;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["notes"] = this.notes;
        super.toJSON(data);
        return data;
    }
}

export interface IFormQuestion extends IEntityBase {
    formQuestionChoices?: FormQuestionChoice[] | undefined;
    formQuestionID: string;
    formID: string;
    name: string;
    nameStyle?: string | undefined;
    description?: string | undefined;
    descriptionStyle?: string | undefined;
    formQuestionTypeEnum: FormQuestionTypeEnum;
    buttonText?: string | undefined;
    enabled: boolean;
    imageURL?: string | undefined;
    resourceURL?: string | undefined;
    displaySortOrder: number;
    correctValue?: string | undefined;
    correctAnswerText?: string | undefined;
    incorrectAnswerText?: string | undefined;
    required: boolean;
    multipleSelection?: boolean | undefined;
    multipleRandomize?: boolean | undefined;
    multipleOtherOption?: boolean | undefined;
    multipleVerticalAlignment?: boolean | undefined;
    multipleShowChoiceLabels?: boolean | undefined;
    scaleStart?: number | undefined;
    scaleIncrement?: number | undefined;
    scaleStop?: number | undefined;
    scaleLeftLabel?: string | undefined;
    scaleMiddleLabel?: string | undefined;
    scaleRightLabel?: string | undefined;
    ratingSteps?: number | undefined;
    ratingShapeEnum?: RatingShapeEnum | undefined;
    minValue?: string | undefined;
    maxValue?: string | undefined;
    notes?: string | undefined;
}

export class FormQuestionChoice extends EntityBase implements IFormQuestionChoice {
    tag?: Tag | undefined;
    formQuestionChoiceID!: string;
    formQuestionID!: string;
    choiceLabel!: string;
    choiceValue?: string | undefined;
    correctValue?: string | undefined;
    score?: number | undefined;
    tagID?: string | undefined;
    displaySortOrder!: number;
    enabled!: boolean;
    imageURL?: string | undefined;
    resourceURL?: string | undefined;
    notes?: string | undefined;
    genderEnum?: GenderEnum | undefined;

    constructor(data?: IFormQuestionChoice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.formQuestionChoiceID = _data["formQuestionChoiceID"];
            this.formQuestionID = _data["formQuestionID"];
            this.choiceLabel = _data["choiceLabel"];
            this.choiceValue = _data["choiceValue"];
            this.correctValue = _data["correctValue"];
            this.score = _data["score"];
            this.tagID = _data["tagID"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.enabled = _data["enabled"];
            this.imageURL = _data["imageURL"];
            this.resourceURL = _data["resourceURL"];
            this.notes = _data["notes"];
            this.genderEnum = _data["genderEnum"];
        }
    }

    static fromJS(data: any): FormQuestionChoice {
        data = typeof data === 'object' ? data : {};
        let result = new FormQuestionChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["formQuestionChoiceID"] = this.formQuestionChoiceID;
        data["formQuestionID"] = this.formQuestionID;
        data["choiceLabel"] = this.choiceLabel;
        data["choiceValue"] = this.choiceValue;
        data["correctValue"] = this.correctValue;
        data["score"] = this.score;
        data["tagID"] = this.tagID;
        data["displaySortOrder"] = this.displaySortOrder;
        data["enabled"] = this.enabled;
        data["imageURL"] = this.imageURL;
        data["resourceURL"] = this.resourceURL;
        data["notes"] = this.notes;
        data["genderEnum"] = this.genderEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IFormQuestionChoice extends IEntityBase {
    tag?: Tag | undefined;
    formQuestionChoiceID: string;
    formQuestionID: string;
    choiceLabel: string;
    choiceValue?: string | undefined;
    correctValue?: string | undefined;
    score?: number | undefined;
    tagID?: string | undefined;
    displaySortOrder: number;
    enabled: boolean;
    imageURL?: string | undefined;
    resourceURL?: string | undefined;
    notes?: string | undefined;
    genderEnum?: GenderEnum | undefined;
}

export enum FormQuestionTypeEnum {
    Welcome = "Welcome",
    ThankYou = "ThankYou",
    MultipleChoice = "MultipleChoice",
    PhoneNumber = "PhoneNumber",
    ShortText = "ShortText",
    LongText = "LongText",
    Statement = "Statement",
    PictureChoice = "PictureChoice",
    YesNo = "YesNo",
    Email = "Email",
    OpinionScale = "OpinionScale",
    Rating = "Rating",
    Date = "Date",
    Number = "Number",
    DropDown = "DropDown",
}

export enum RatingShapeEnum {
    Stars = "Stars",
    Hearts = "Hearts",
    Users = "Users",
    ThumbsUp = "ThumbsUp",
    Crowns = "Crowns",
    Cats = "Cats",
    Dogs = "Dogs",
    Circles = "Circles",
    Flags = "Flags",
    Droplets = "Droplets",
    Ticks = "Ticks",
    Lightbulbs = "Lightbulbs",
    Trophies = "Trophies",
    Clouds = "Clouds",
    Thunderbolts = "Thunderbolts",
    Pencils = "Pencils",
    Skulls = "Skulls",
}

export enum FormTypeEnum {
    ResearchSurvey = "ResearchSurvey",
    Request = "Request",
    Registration = "Registration",
    Poll = "Poll",
    Feedback = "Feedback",
    Contact = "Contact",
    Quiz = "Quiz",
    CheckList = "CheckList",
    Application = "Application",
    Other = "Other",
}

export class StoreItemXref extends EntityBase implements IStoreItemXref {
    storeItemXrefID!: string;
    storeItemID!: string;
    toStoreItemID!: string;
    minimumMinutes?: number | undefined;
    maximumMinutes?: number | undefined;
    storeItem?: StoreItem | undefined;
    toStoreItem?: StoreItem | undefined;

    constructor(data?: IStoreItemXref) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeItemXrefID = _data["storeItemXrefID"];
            this.storeItemID = _data["storeItemID"];
            this.toStoreItemID = _data["toStoreItemID"];
            this.minimumMinutes = _data["minimumMinutes"];
            this.maximumMinutes = _data["maximumMinutes"];
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.toStoreItem = _data["toStoreItem"] ? StoreItem.fromJS(_data["toStoreItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreItemXref {
        data = typeof data === 'object' ? data : {};
        let result = new StoreItemXref();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeItemXrefID"] = this.storeItemXrefID;
        data["storeItemID"] = this.storeItemID;
        data["toStoreItemID"] = this.toStoreItemID;
        data["minimumMinutes"] = this.minimumMinutes;
        data["maximumMinutes"] = this.maximumMinutes;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["toStoreItem"] = this.toStoreItem ? this.toStoreItem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStoreItemXref extends IEntityBase {
    storeItemXrefID: string;
    storeItemID: string;
    toStoreItemID: string;
    minimumMinutes?: number | undefined;
    maximumMinutes?: number | undefined;
    storeItem?: StoreItem | undefined;
    toStoreItem?: StoreItem | undefined;
}

export class AddressBookTag extends EntityBase implements IAddressBookTag {
    tag?: Tag | undefined;
    addressBookTagID!: string;
    addressBookID!: string;
    tagID!: string;
    isPrimary!: boolean;
    displaySortOrder!: number;

    constructor(data?: IAddressBookTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.addressBookTagID = _data["addressBookTagID"];
            this.addressBookID = _data["addressBookID"];
            this.tagID = _data["tagID"];
            this.isPrimary = _data["isPrimary"];
            this.displaySortOrder = _data["displaySortOrder"];
        }
    }

    static fromJS(data: any): AddressBookTag {
        data = typeof data === 'object' ? data : {};
        let result = new AddressBookTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["addressBookTagID"] = this.addressBookTagID;
        data["addressBookID"] = this.addressBookID;
        data["tagID"] = this.tagID;
        data["isPrimary"] = this.isPrimary;
        data["displaySortOrder"] = this.displaySortOrder;
        super.toJSON(data);
        return data;
    }
}

export interface IAddressBookTag extends IEntityBase {
    tag?: Tag | undefined;
    addressBookTagID: string;
    addressBookID: string;
    tagID: string;
    isPrimary: boolean;
    displaySortOrder: number;
}

export enum AddressBookFavoriteInviteStatusEnum {
    NotSet = "NotSet",
    Invited = "Invited",
    Accepted = "Accepted",
    Declined = "Declined",
}

export enum AddressBookTypeEnum {
    Global = "Global",
    Private = "Private",
    Suggested = "Suggested",
}

export enum AddressBookFolderEnum {
    Provider = "Provider",
    Pharmacy = "Pharmacy",
    Clinic = "Clinic",
    Lab = "Lab",
    Organization = "Organization",
    Other = "Other",
    Patient = "Patient",
    PersonalNetwork = "PersonalNetwork",
    ClinicStaff = "ClinicStaff",
}

export class AddressBookFavoriteDetail implements IAddressBookFavoriteDetail {
    associateIDOrAddressBookID?: string;
    favoriteTypeEnum?: FavoriteTypeEnum;
    addressBookFavoriteInviteStatusEnum?: AddressBookFavoriteInviteStatusEnum;

    constructor(data?: IAddressBookFavoriteDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.associateIDOrAddressBookID = _data["associateIDOrAddressBookID"];
            this.favoriteTypeEnum = _data["favoriteTypeEnum"];
            this.addressBookFavoriteInviteStatusEnum = _data["addressBookFavoriteInviteStatusEnum"];
        }
    }

    static fromJS(data: any): AddressBookFavoriteDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AddressBookFavoriteDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["associateIDOrAddressBookID"] = this.associateIDOrAddressBookID;
        data["favoriteTypeEnum"] = this.favoriteTypeEnum;
        data["addressBookFavoriteInviteStatusEnum"] = this.addressBookFavoriteInviteStatusEnum;
        return data;
    }
}

export interface IAddressBookFavoriteDetail {
    associateIDOrAddressBookID?: string;
    favoriteTypeEnum?: FavoriteTypeEnum;
    addressBookFavoriteInviteStatusEnum?: AddressBookFavoriteInviteStatusEnum;
}

export enum FavoriteTypeEnum {
    NotSet = "NotSet",
    PersonalNetwork = "PersonalNetwork",
    ClinicStaff = "ClinicStaff",
}

export class AddressBookFavorite extends EntityBase implements IAddressBookFavorite {
    addressBook?: AddressBook | undefined;
    addressBookFavoriteID!: string;
    userDetailID!: string;
    associatedID!: string;
    favoriteTypeEnum!: FavoriteTypeEnum;
    addressBookFavoriteInviteStatusEnum!: AddressBookFavoriteInviteStatusEnum;

    constructor(data?: IAddressBookFavorite) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.addressBook = _data["addressBook"] ? AddressBook.fromJS(_data["addressBook"]) : <any>undefined;
            this.addressBookFavoriteID = _data["addressBookFavoriteID"];
            this.userDetailID = _data["userDetailID"];
            this.associatedID = _data["associatedID"];
            this.favoriteTypeEnum = _data["favoriteTypeEnum"];
            this.addressBookFavoriteInviteStatusEnum = _data["addressBookFavoriteInviteStatusEnum"];
        }
    }

    static fromJS(data: any): AddressBookFavorite {
        data = typeof data === 'object' ? data : {};
        let result = new AddressBookFavorite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressBook"] = this.addressBook ? this.addressBook.toJSON() : <any>undefined;
        data["addressBookFavoriteID"] = this.addressBookFavoriteID;
        data["userDetailID"] = this.userDetailID;
        data["associatedID"] = this.associatedID;
        data["favoriteTypeEnum"] = this.favoriteTypeEnum;
        data["addressBookFavoriteInviteStatusEnum"] = this.addressBookFavoriteInviteStatusEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IAddressBookFavorite extends IEntityBase {
    addressBook?: AddressBook | undefined;
    addressBookFavoriteID: string;
    userDetailID: string;
    associatedID: string;
    favoriteTypeEnum: FavoriteTypeEnum;
    addressBookFavoriteInviteStatusEnum: AddressBookFavoriteInviteStatusEnum;
}

export class PagedResultOfAddressBook implements IPagedResultOfAddressBook {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: AddressBook[] | undefined;

    constructor(data?: IPagedResultOfAddressBook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AddressBook.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfAddressBook {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfAddressBook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfAddressBook {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: AddressBook[] | undefined;
}

export class PagedQuery implements IPagedQuery {
    recordsToSkip?: number;
    recordsToTake?: number;

    constructor(data?: IPagedQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
        }
    }

    static fromJS(data: any): PagedQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PagedQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        return data;
    }
}

export interface IPagedQuery {
    recordsToSkip?: number;
    recordsToTake?: number;
}

export class AddressBookSearchDetails extends PagedQuery implements IAddressBookSearchDetails {
    currentUserDetailID?: string;
    countryID?: string | undefined;
    addressBookFolderEnum?: AddressBookFolderEnum | undefined;
    addressBookTypeEnum?: AddressBookTypeEnum | undefined;
    addressBookSortByEnum?: AddressBookSortByEnum;
    searchText?: string | undefined;
    specialtyTagID?: string | undefined;
    provinceStateID?: string | undefined;
    currentLatitude?: number | undefined;
    currentLongitude?: number | undefined;
    userDetailID?: string | undefined;
    addressBookFolderEnums?: AddressBookFolderEnum[] | undefined;

    constructor(data?: IAddressBookSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentUserDetailID = _data["currentUserDetailID"];
            this.countryID = _data["countryID"];
            this.addressBookFolderEnum = _data["addressBookFolderEnum"];
            this.addressBookTypeEnum = _data["addressBookTypeEnum"];
            this.addressBookSortByEnum = _data["addressBookSortByEnum"];
            this.searchText = _data["searchText"];
            this.specialtyTagID = _data["specialtyTagID"];
            this.provinceStateID = _data["provinceStateID"];
            this.currentLatitude = _data["currentLatitude"];
            this.currentLongitude = _data["currentLongitude"];
            this.userDetailID = _data["userDetailID"];
            if (Array.isArray(_data["addressBookFolderEnums"])) {
                this.addressBookFolderEnums = [] as any;
                for (let item of _data["addressBookFolderEnums"])
                    this.addressBookFolderEnums!.push(item);
            }
        }
    }

    static fromJS(data: any): AddressBookSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AddressBookSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentUserDetailID"] = this.currentUserDetailID;
        data["countryID"] = this.countryID;
        data["addressBookFolderEnum"] = this.addressBookFolderEnum;
        data["addressBookTypeEnum"] = this.addressBookTypeEnum;
        data["addressBookSortByEnum"] = this.addressBookSortByEnum;
        data["searchText"] = this.searchText;
        data["specialtyTagID"] = this.specialtyTagID;
        data["provinceStateID"] = this.provinceStateID;
        data["currentLatitude"] = this.currentLatitude;
        data["currentLongitude"] = this.currentLongitude;
        data["userDetailID"] = this.userDetailID;
        if (Array.isArray(this.addressBookFolderEnums)) {
            data["addressBookFolderEnums"] = [];
            for (let item of this.addressBookFolderEnums)
                data["addressBookFolderEnums"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAddressBookSearchDetails extends IPagedQuery {
    currentUserDetailID?: string;
    countryID?: string | undefined;
    addressBookFolderEnum?: AddressBookFolderEnum | undefined;
    addressBookTypeEnum?: AddressBookTypeEnum | undefined;
    addressBookSortByEnum?: AddressBookSortByEnum;
    searchText?: string | undefined;
    specialtyTagID?: string | undefined;
    provinceStateID?: string | undefined;
    currentLatitude?: number | undefined;
    currentLongitude?: number | undefined;
    userDetailID?: string | undefined;
    addressBookFolderEnums?: AddressBookFolderEnum[] | undefined;
}

export enum AddressBookSortByEnum {
    All = "All",
    Favourite = "Favourite",
    Gender = "Gender",
    AaZz = "AaZz",
    ZzAa = "ZzAa",
    Speciality = "Speciality",
    Distance = "Distance",
}

export class AffiliateInvoice extends EntityBase implements IAffiliateInvoice {
    invoice?: Invoice | undefined;
    affiliateInvoiceID!: string;
    affiliateID!: string;
    invoiceID!: string;
    affiliateAmount!: number;

    constructor(data?: IAffiliateInvoice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.affiliateInvoiceID = _data["affiliateInvoiceID"];
            this.affiliateID = _data["affiliateID"];
            this.invoiceID = _data["invoiceID"];
            this.affiliateAmount = _data["affiliateAmount"];
        }
    }

    static fromJS(data: any): AffiliateInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliateInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["affiliateInvoiceID"] = this.affiliateInvoiceID;
        data["affiliateID"] = this.affiliateID;
        data["invoiceID"] = this.invoiceID;
        data["affiliateAmount"] = this.affiliateAmount;
        super.toJSON(data);
        return data;
    }
}

export interface IAffiliateInvoice extends IEntityBase {
    invoice?: Invoice | undefined;
    affiliateInvoiceID: string;
    affiliateID: string;
    invoiceID: string;
    affiliateAmount: number;
}

export class Affiliate extends EntityBase implements IAffiliate {
    provider?: Provider | undefined;
    store?: Store | undefined;
    organization?: Organization | undefined;
    glAccount?: GLAccount | undefined;
    affiliateInvoices?: AffiliateInvoice[] | undefined;
    affiliateID!: string;
    name!: string;
    description!: string;
    enabled!: boolean;
    glAccountID!: string;
    startDate!: Date;
    endDate!: Date;
    percent!: number;
    providerID?: string | undefined;
    storeID?: string | undefined;
    organizationID?: string | undefined;

    constructor(data?: IAffiliate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            this.glAccount = _data["glAccount"] ? GLAccount.fromJS(_data["glAccount"]) : <any>undefined;
            if (Array.isArray(_data["affiliateInvoices"])) {
                this.affiliateInvoices = [] as any;
                for (let item of _data["affiliateInvoices"])
                    this.affiliateInvoices!.push(AffiliateInvoice.fromJS(item));
            }
            this.affiliateID = _data["affiliateID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.glAccountID = _data["glAccountID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.percent = _data["percent"];
            this.providerID = _data["providerID"];
            this.storeID = _data["storeID"];
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): Affiliate {
        data = typeof data === 'object' ? data : {};
        let result = new Affiliate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["glAccount"] = this.glAccount ? this.glAccount.toJSON() : <any>undefined;
        if (Array.isArray(this.affiliateInvoices)) {
            data["affiliateInvoices"] = [];
            for (let item of this.affiliateInvoices)
                data["affiliateInvoices"].push(item.toJSON());
        }
        data["affiliateID"] = this.affiliateID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["glAccountID"] = this.glAccountID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["percent"] = this.percent;
        data["providerID"] = this.providerID;
        data["storeID"] = this.storeID;
        data["organizationID"] = this.organizationID;
        super.toJSON(data);
        return data;
    }
}

export interface IAffiliate extends IEntityBase {
    provider?: Provider | undefined;
    store?: Store | undefined;
    organization?: Organization | undefined;
    glAccount?: GLAccount | undefined;
    affiliateInvoices?: AffiliateInvoice[] | undefined;
    affiliateID: string;
    name: string;
    description: string;
    enabled: boolean;
    glAccountID: string;
    startDate: Date;
    endDate: Date;
    percent: number;
    providerID?: string | undefined;
    storeID?: string | undefined;
    organizationID?: string | undefined;
}

export class AffiliateSearchDetails implements IAffiliateSearchDetails {
    providerID?: string | undefined;
    organizationID?: string | undefined;
    storeID?: string | undefined;

    constructor(data?: IAffiliateSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.organizationID = _data["organizationID"];
            this.storeID = _data["storeID"];
        }
    }

    static fromJS(data: any): AffiliateSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AffiliateSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["organizationID"] = this.organizationID;
        data["storeID"] = this.storeID;
        return data;
    }
}

export interface IAffiliateSearchDetails {
    providerID?: string | undefined;
    organizationID?: string | undefined;
    storeID?: string | undefined;
}

export class ApiSetting extends EntityBase implements IApiSetting {
    apiSettingID!: string;
    name!: string;
    enabled!: boolean;
    baseURL!: string;
    authToken?: string | undefined;
    apiProviderTypeName!: string;
    data?: string | undefined;

    constructor(data?: IApiSetting) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.apiSettingID = _data["apiSettingID"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            this.baseURL = _data["baseURL"];
            this.authToken = _data["authToken"];
            this.apiProviderTypeName = _data["apiProviderTypeName"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ApiSetting {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiSettingID"] = this.apiSettingID;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        data["baseURL"] = this.baseURL;
        data["authToken"] = this.authToken;
        data["apiProviderTypeName"] = this.apiProviderTypeName;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IApiSetting extends IEntityBase {
    apiSettingID: string;
    name: string;
    enabled: boolean;
    baseURL: string;
    authToken?: string | undefined;
    apiProviderTypeName: string;
    data?: string | undefined;
}

export class ApiPingResult implements IApiPingResult {
    apiName?: string | undefined;
    timeSpan?: string;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IApiPingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiName = _data["apiName"];
            this.timeSpan = _data["timeSpan"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApiPingResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiName"] = this.apiName;
        data["timeSpan"] = this.timeSpan;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IApiPingResult {
    apiName?: string | undefined;
    timeSpan?: string;
    success?: boolean;
    message?: string | undefined;
}

export class AppFeature extends EntityBase implements IAppFeature {
    appFeatureID!: string;
    name!: string;
    description!: string;
    enabled!: boolean;
    roles?: string | undefined;

    constructor(data?: IAppFeature) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.appFeatureID = _data["appFeatureID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.roles = _data["roles"];
        }
    }

    static fromJS(data: any): AppFeature {
        data = typeof data === 'object' ? data : {};
        let result = new AppFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appFeatureID"] = this.appFeatureID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["roles"] = this.roles;
        super.toJSON(data);
        return data;
    }
}

export interface IAppFeature extends IEntityBase {
    appFeatureID: string;
    name: string;
    description: string;
    enabled: boolean;
    roles?: string | undefined;
}

export class Audit implements IAudit {
    auditID!: string;
    auditDate!: Date;
    transactionID!: string;
    tableName!: string;
    state!: number;
    userDetailID!: string;
    primaryKey!: string;
    columnName!: string;
    originalValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IAudit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditID = _data["auditID"];
            this.auditDate = _data["auditDate"] ? new Date(_data["auditDate"].toString()) : <any>undefined;
            this.transactionID = _data["transactionID"];
            this.tableName = _data["tableName"];
            this.state = _data["state"];
            this.userDetailID = _data["userDetailID"];
            this.primaryKey = _data["primaryKey"];
            this.columnName = _data["columnName"];
            this.originalValue = _data["originalValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): Audit {
        data = typeof data === 'object' ? data : {};
        let result = new Audit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditID"] = this.auditID;
        data["auditDate"] = this.auditDate ? this.auditDate.toISOString() : <any>undefined;
        data["transactionID"] = this.transactionID;
        data["tableName"] = this.tableName;
        data["state"] = this.state;
        data["userDetailID"] = this.userDetailID;
        data["primaryKey"] = this.primaryKey;
        data["columnName"] = this.columnName;
        data["originalValue"] = this.originalValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IAudit {
    auditID: string;
    auditDate: Date;
    transactionID: string;
    tableName: string;
    state: number;
    userDetailID: string;
    primaryKey: string;
    columnName: string;
    originalValue?: string | undefined;
    newValue?: string | undefined;
}

export class Bank extends EntityBase implements IBank {
    paymentProcessor?: PaymentProcessor | undefined;
    country?: Country | undefined;
    bankID!: string;
    name!: string;
    description!: string;
    enabled!: boolean;
    paymentProcessorID!: string;
    countryID!: string;
    bankCode!: string;
    ussdPrefix?: string | undefined;
    logoURL?: string | undefined;
    ussdOnly!: boolean;

    constructor(data?: IBank) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentProcessor = _data["paymentProcessor"] ? PaymentProcessor.fromJS(_data["paymentProcessor"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.bankID = _data["bankID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.paymentProcessorID = _data["paymentProcessorID"];
            this.countryID = _data["countryID"];
            this.bankCode = _data["bankCode"];
            this.ussdPrefix = _data["ussdPrefix"];
            this.logoURL = _data["logoURL"];
            this.ussdOnly = _data["ussdOnly"];
        }
    }

    static fromJS(data: any): Bank {
        data = typeof data === 'object' ? data : {};
        let result = new Bank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProcessor"] = this.paymentProcessor ? this.paymentProcessor.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["bankID"] = this.bankID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["paymentProcessorID"] = this.paymentProcessorID;
        data["countryID"] = this.countryID;
        data["bankCode"] = this.bankCode;
        data["ussdPrefix"] = this.ussdPrefix;
        data["logoURL"] = this.logoURL;
        data["ussdOnly"] = this.ussdOnly;
        super.toJSON(data);
        return data;
    }
}

export interface IBank extends IEntityBase {
    paymentProcessor?: PaymentProcessor | undefined;
    country?: Country | undefined;
    bankID: string;
    name: string;
    description: string;
    enabled: boolean;
    paymentProcessorID: string;
    countryID: string;
    bankCode: string;
    ussdPrefix?: string | undefined;
    logoURL?: string | undefined;
    ussdOnly: boolean;
}

export class BlackList extends EntityBase implements IBlackList {
    blackListID!: string;
    userDetailID!: string;
    blackListTypeEnum!: BlackListTypeEnum;
    enabled!: boolean;
    reason!: string;
    blackListForID?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IBlackList) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.blackListID = _data["blackListID"];
            this.userDetailID = _data["userDetailID"];
            this.blackListTypeEnum = _data["blackListTypeEnum"];
            this.enabled = _data["enabled"];
            this.reason = _data["reason"];
            this.blackListForID = _data["blackListForID"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): BlackList {
        data = typeof data === 'object' ? data : {};
        let result = new BlackList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blackListID"] = this.blackListID;
        data["userDetailID"] = this.userDetailID;
        data["blackListTypeEnum"] = this.blackListTypeEnum;
        data["enabled"] = this.enabled;
        data["reason"] = this.reason;
        data["blackListForID"] = this.blackListForID;
        data["ipAddress"] = this.ipAddress;
        super.toJSON(data);
        return data;
    }
}

export interface IBlackList extends IEntityBase {
    blackListID: string;
    userDetailID: string;
    blackListTypeEnum: BlackListTypeEnum;
    enabled: boolean;
    reason: string;
    blackListForID?: string | undefined;
    ipAddress?: string | undefined;
}

export enum BlackListTypeEnum {
    Platform = "Platform",
    Organization = "Organization",
    Clinic = "Clinic",
    Provider = "Provider",
    DiscussionGroups = "DiscussionGroups",
    Discussion = "Discussion",
}

export class Campaign extends EntityBase implements ICampaign {
    campaignSettings?: CampaignSetting[] | undefined;
    campaignID!: string;
    name!: string;
    enabled!: boolean;

    constructor(data?: ICampaign) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["campaignSettings"])) {
                this.campaignSettings = [] as any;
                for (let item of _data["campaignSettings"])
                    this.campaignSettings!.push(CampaignSetting.fromJS(item));
            }
            this.campaignID = _data["campaignID"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): Campaign {
        data = typeof data === 'object' ? data : {};
        let result = new Campaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.campaignSettings)) {
            data["campaignSettings"] = [];
            for (let item of this.campaignSettings)
                data["campaignSettings"].push(item.toJSON());
        }
        data["campaignID"] = this.campaignID;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data;
    }
}

export interface ICampaign extends IEntityBase {
    campaignSettings?: CampaignSetting[] | undefined;
    campaignID: string;
    name: string;
    enabled: boolean;
}

export class CampaignSetting extends EntityBase implements ICampaignSetting {
    campaignSettingID!: string;
    campaignID!: string;
    campaignSettingName!: string;
    description?: string | undefined;
    value!: string;

    constructor(data?: ICampaignSetting) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.campaignSettingID = _data["campaignSettingID"];
            this.campaignID = _data["campaignID"];
            this.campaignSettingName = _data["campaignSettingName"];
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CampaignSetting {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignSettingID"] = this.campaignSettingID;
        data["campaignID"] = this.campaignID;
        data["campaignSettingName"] = this.campaignSettingName;
        data["description"] = this.description;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface ICampaignSetting extends IEntityBase {
    campaignSettingID: string;
    campaignID: string;
    campaignSettingName: string;
    description?: string | undefined;
    value: string;
}

export class CareFundApplication extends EntityBase implements ICareFundApplication {
    careFundApplicationTags?: CareFundTag[] | undefined;
    userDetail?: UserDetail | undefined;
    careFundMedia?: CareFundMedia[] | undefined;
    careFundCampaign?: CareFundCampaign | undefined;
    careFundApplicationMediaIDs?: string[] | undefined;
    careFundDisbursements?: CareFundDisbursement[] | undefined;
    careFundApplicationID!: string;
    careFundCampaignID?: string | undefined;
    name!: string;
    title?: string | undefined;
    description?: string | undefined;
    userDetailID!: string;
    healthConditionTags?: string | undefined;
    imageDetailID?: string | undefined;
    videoDetailID?: string | undefined;
    careFundCategoryEnum?: CareFundCategoryEnum | undefined;
    careFundStatusEnum!: CareFundStatusEnum;
    careFundConfigData?: string | undefined;
    applicationScore?: number;
    rank?: number | undefined;
    careFundTags?: string | undefined;
    requestedAmount!: number;
    approvedAmount!: number;
    approvalDate?: Date | undefined;
    currencyEnum!: CurrencyEnum;
    hasAgreedCareFundTC?: boolean;
    hasAcceptedCareFundPrivacyTC?: boolean;
    enabled!: boolean;
    data?: string | undefined;
    message?: string | undefined;

    constructor(data?: ICareFundApplication) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["careFundApplicationTags"])) {
                this.careFundApplicationTags = [] as any;
                for (let item of _data["careFundApplicationTags"])
                    this.careFundApplicationTags!.push(CareFundTag.fromJS(item));
            }
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            if (Array.isArray(_data["careFundMedia"])) {
                this.careFundMedia = [] as any;
                for (let item of _data["careFundMedia"])
                    this.careFundMedia!.push(CareFundMedia.fromJS(item));
            }
            this.careFundCampaign = _data["careFundCampaign"] ? CareFundCampaign.fromJS(_data["careFundCampaign"]) : <any>undefined;
            if (Array.isArray(_data["careFundApplicationMediaIDs"])) {
                this.careFundApplicationMediaIDs = [] as any;
                for (let item of _data["careFundApplicationMediaIDs"])
                    this.careFundApplicationMediaIDs!.push(item);
            }
            if (Array.isArray(_data["careFundDisbursements"])) {
                this.careFundDisbursements = [] as any;
                for (let item of _data["careFundDisbursements"])
                    this.careFundDisbursements!.push(CareFundDisbursement.fromJS(item));
            }
            this.careFundApplicationID = _data["careFundApplicationID"];
            this.careFundCampaignID = _data["careFundCampaignID"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.userDetailID = _data["userDetailID"];
            this.healthConditionTags = _data["healthConditionTags"];
            this.imageDetailID = _data["imageDetailID"];
            this.videoDetailID = _data["videoDetailID"];
            this.careFundCategoryEnum = _data["careFundCategoryEnum"];
            this.careFundStatusEnum = _data["careFundStatusEnum"];
            this.careFundConfigData = _data["careFundConfigData"];
            this.applicationScore = _data["applicationScore"];
            this.rank = _data["rank"];
            this.careFundTags = _data["careFundTags"];
            this.requestedAmount = _data["requestedAmount"];
            this.approvedAmount = _data["approvedAmount"];
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : <any>undefined;
            this.currencyEnum = _data["currencyEnum"];
            this.hasAgreedCareFundTC = _data["hasAgreedCareFundTC"];
            this.hasAcceptedCareFundPrivacyTC = _data["hasAcceptedCareFundPrivacyTC"];
            this.enabled = _data["enabled"];
            this.data = _data["data"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CareFundApplication {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.careFundApplicationTags)) {
            data["careFundApplicationTags"] = [];
            for (let item of this.careFundApplicationTags)
                data["careFundApplicationTags"].push(item.toJSON());
        }
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.careFundMedia)) {
            data["careFundMedia"] = [];
            for (let item of this.careFundMedia)
                data["careFundMedia"].push(item.toJSON());
        }
        data["careFundCampaign"] = this.careFundCampaign ? this.careFundCampaign.toJSON() : <any>undefined;
        if (Array.isArray(this.careFundApplicationMediaIDs)) {
            data["careFundApplicationMediaIDs"] = [];
            for (let item of this.careFundApplicationMediaIDs)
                data["careFundApplicationMediaIDs"].push(item);
        }
        if (Array.isArray(this.careFundDisbursements)) {
            data["careFundDisbursements"] = [];
            for (let item of this.careFundDisbursements)
                data["careFundDisbursements"].push(item.toJSON());
        }
        data["careFundApplicationID"] = this.careFundApplicationID;
        data["careFundCampaignID"] = this.careFundCampaignID;
        data["name"] = this.name;
        data["title"] = this.title;
        data["description"] = this.description;
        data["userDetailID"] = this.userDetailID;
        data["healthConditionTags"] = this.healthConditionTags;
        data["imageDetailID"] = this.imageDetailID;
        data["videoDetailID"] = this.videoDetailID;
        data["careFundCategoryEnum"] = this.careFundCategoryEnum;
        data["careFundStatusEnum"] = this.careFundStatusEnum;
        data["careFundConfigData"] = this.careFundConfigData;
        data["applicationScore"] = this.applicationScore;
        data["rank"] = this.rank;
        data["careFundTags"] = this.careFundTags;
        data["requestedAmount"] = this.requestedAmount;
        data["approvedAmount"] = this.approvedAmount;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["currencyEnum"] = this.currencyEnum;
        data["hasAgreedCareFundTC"] = this.hasAgreedCareFundTC;
        data["hasAcceptedCareFundPrivacyTC"] = this.hasAcceptedCareFundPrivacyTC;
        data["enabled"] = this.enabled;
        data["data"] = this.data;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface ICareFundApplication extends IEntityBase {
    careFundApplicationTags?: CareFundTag[] | undefined;
    userDetail?: UserDetail | undefined;
    careFundMedia?: CareFundMedia[] | undefined;
    careFundCampaign?: CareFundCampaign | undefined;
    careFundApplicationMediaIDs?: string[] | undefined;
    careFundDisbursements?: CareFundDisbursement[] | undefined;
    careFundApplicationID: string;
    careFundCampaignID?: string | undefined;
    name: string;
    title?: string | undefined;
    description?: string | undefined;
    userDetailID: string;
    healthConditionTags?: string | undefined;
    imageDetailID?: string | undefined;
    videoDetailID?: string | undefined;
    careFundCategoryEnum?: CareFundCategoryEnum | undefined;
    careFundStatusEnum: CareFundStatusEnum;
    careFundConfigData?: string | undefined;
    applicationScore?: number;
    rank?: number | undefined;
    careFundTags?: string | undefined;
    requestedAmount: number;
    approvedAmount: number;
    approvalDate?: Date | undefined;
    currencyEnum: CurrencyEnum;
    hasAgreedCareFundTC?: boolean;
    hasAcceptedCareFundPrivacyTC?: boolean;
    enabled: boolean;
    data?: string | undefined;
    message?: string | undefined;
}

export class CareFundTag extends EntityBase implements ICareFundTag {
    tag?: Tag | undefined;
    careFundTagID!: string;
    careFundID!: string;
    careFundTagTypeEnum!: CareFundTagTypeEnum;
    tagID!: string;
    isPrimary!: boolean;
    displaySortOrder!: number;
    data?: string | undefined;

    constructor(data?: ICareFundTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.careFundTagID = _data["careFundTagID"];
            this.careFundID = _data["careFundID"];
            this.careFundTagTypeEnum = _data["careFundTagTypeEnum"];
            this.tagID = _data["tagID"];
            this.isPrimary = _data["isPrimary"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CareFundTag {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["careFundTagID"] = this.careFundTagID;
        data["careFundID"] = this.careFundID;
        data["careFundTagTypeEnum"] = this.careFundTagTypeEnum;
        data["tagID"] = this.tagID;
        data["isPrimary"] = this.isPrimary;
        data["displaySortOrder"] = this.displaySortOrder;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface ICareFundTag extends IEntityBase {
    tag?: Tag | undefined;
    careFundTagID: string;
    careFundID: string;
    careFundTagTypeEnum: CareFundTagTypeEnum;
    tagID: string;
    isPrimary: boolean;
    displaySortOrder: number;
    data?: string | undefined;
}

export enum CareFundTagTypeEnum {
    NotSet = "NotSet",
    Campaign = "Campaign",
    Application = "Application",
    HealthCondition = "HealthCondition",
}

export class CareFundMedia extends EntityBase implements ICareFundMedia {
    fileDetail?: FileDetail | undefined;
    careFundMediaID!: string;
    associatedID?: string;
    name!: string;
    description?: string | undefined;
    originalMediaID?: string;
    watermarkMediaID?: string;
    originalImageURL?: string | undefined;
    watermarkImageURL?: string | undefined;
    displaySortOrder?: number | undefined;
    careFundTypeEnum!: CareFundTypeEnum;
    mediaTypeEnum!: MediaTypeEnum;
    isPrimary!: boolean;
    data?: string | undefined;

    constructor(data?: ICareFundMedia) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileDetail = _data["fileDetail"] ? FileDetail.fromJS(_data["fileDetail"]) : <any>undefined;
            this.careFundMediaID = _data["careFundMediaID"];
            this.associatedID = _data["associatedID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.originalMediaID = _data["originalMediaID"];
            this.watermarkMediaID = _data["watermarkMediaID"];
            this.originalImageURL = _data["originalImageURL"];
            this.watermarkImageURL = _data["watermarkImageURL"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.careFundTypeEnum = _data["careFundTypeEnum"];
            this.mediaTypeEnum = _data["mediaTypeEnum"];
            this.isPrimary = _data["isPrimary"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CareFundMedia {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileDetail"] = this.fileDetail ? this.fileDetail.toJSON() : <any>undefined;
        data["careFundMediaID"] = this.careFundMediaID;
        data["associatedID"] = this.associatedID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["originalMediaID"] = this.originalMediaID;
        data["watermarkMediaID"] = this.watermarkMediaID;
        data["originalImageURL"] = this.originalImageURL;
        data["watermarkImageURL"] = this.watermarkImageURL;
        data["displaySortOrder"] = this.displaySortOrder;
        data["careFundTypeEnum"] = this.careFundTypeEnum;
        data["mediaTypeEnum"] = this.mediaTypeEnum;
        data["isPrimary"] = this.isPrimary;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface ICareFundMedia extends IEntityBase {
    fileDetail?: FileDetail | undefined;
    careFundMediaID: string;
    associatedID?: string;
    name: string;
    description?: string | undefined;
    originalMediaID?: string;
    watermarkMediaID?: string;
    originalImageURL?: string | undefined;
    watermarkImageURL?: string | undefined;
    displaySortOrder?: number | undefined;
    careFundTypeEnum: CareFundTypeEnum;
    mediaTypeEnum: MediaTypeEnum;
    isPrimary: boolean;
    data?: string | undefined;
}

export enum CareFundTypeEnum {
    NotSet = "NotSet",
    Campaign = "Campaign",
    Application = "Application",
    Others = "Others",
}

export enum MediaTypeEnum {
    NotSet = "NotSet",
    Image = "Image",
    Video = "Video",
    PDF = "PDF",
}

export class CareFundCampaign extends EntityBase implements ICareFundCampaign {
    careFundCampaignTags?: CareFundTag[] | undefined;
    creatorUserDetail?: UserDetail | undefined;
    beneficiaryUserDetail?: UserDetail | undefined;
    careFundApplications?: CareFundApplication[] | undefined;
    careFundDonations?: CareFundDonation[] | undefined;
    campaignDonors?: number | undefined;
    campaignApplicants?: number | undefined;
    careFundCampaignID!: string;
    name!: string;
    title?: string | undefined;
    campaignID?: string | undefined;
    description?: string | undefined;
    careFundOrganization?: boolean | undefined;
    campaignCreatorUserDetailID?: string;
    campaignBeneficiaryUserDetailID?: string | undefined;
    campaignHealthConditionTags?: string | undefined;
    campaignImageDetailID?: string | undefined;
    campaignVideoDetailID?: string | undefined;
    careFundCampaignTypeEnum?: CareFundCampaignTypeEnum | undefined;
    careFundCategoryEnum?: CareFundCategoryEnum | undefined;
    careFundCampaignStatusEnum?: CareFundStatusEnum;
    careFundCampaignConfigData?: string | undefined;
    careFundTags?: string | undefined;
    goalAmount!: number;
    raisedAmount!: number;
    currencyEnum!: CurrencyEnum;
    startDate?: Date;
    endDate?: Date;
    hasAgreedCampaignTC?: boolean;
    hasAcceptedCampaignPrivacyTC?: boolean;
    campaignUrl?: string | undefined;
    campaignViews?: number;
    enabled!: boolean;
    data?: string | undefined;
    message?: string | undefined;

    constructor(data?: ICareFundCampaign) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["careFundCampaignTags"])) {
                this.careFundCampaignTags = [] as any;
                for (let item of _data["careFundCampaignTags"])
                    this.careFundCampaignTags!.push(CareFundTag.fromJS(item));
            }
            this.creatorUserDetail = _data["creatorUserDetail"] ? UserDetail.fromJS(_data["creatorUserDetail"]) : <any>undefined;
            this.beneficiaryUserDetail = _data["beneficiaryUserDetail"] ? UserDetail.fromJS(_data["beneficiaryUserDetail"]) : <any>undefined;
            if (Array.isArray(_data["careFundApplications"])) {
                this.careFundApplications = [] as any;
                for (let item of _data["careFundApplications"])
                    this.careFundApplications!.push(CareFundApplication.fromJS(item));
            }
            if (Array.isArray(_data["careFundDonations"])) {
                this.careFundDonations = [] as any;
                for (let item of _data["careFundDonations"])
                    this.careFundDonations!.push(CareFundDonation.fromJS(item));
            }
            this.campaignDonors = _data["campaignDonors"];
            this.campaignApplicants = _data["campaignApplicants"];
            this.careFundCampaignID = _data["careFundCampaignID"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.campaignID = _data["campaignID"];
            this.description = _data["description"];
            this.careFundOrganization = _data["careFundOrganization"];
            this.campaignCreatorUserDetailID = _data["campaignCreatorUserDetailID"];
            this.campaignBeneficiaryUserDetailID = _data["campaignBeneficiaryUserDetailID"];
            this.campaignHealthConditionTags = _data["campaignHealthConditionTags"];
            this.campaignImageDetailID = _data["campaignImageDetailID"];
            this.campaignVideoDetailID = _data["campaignVideoDetailID"];
            this.careFundCampaignTypeEnum = _data["careFundCampaignTypeEnum"];
            this.careFundCategoryEnum = _data["careFundCategoryEnum"];
            this.careFundCampaignStatusEnum = _data["careFundCampaignStatusEnum"];
            this.careFundCampaignConfigData = _data["careFundCampaignConfigData"];
            this.careFundTags = _data["careFundTags"];
            this.goalAmount = _data["goalAmount"];
            this.raisedAmount = _data["raisedAmount"];
            this.currencyEnum = _data["currencyEnum"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.hasAgreedCampaignTC = _data["hasAgreedCampaignTC"];
            this.hasAcceptedCampaignPrivacyTC = _data["hasAcceptedCampaignPrivacyTC"];
            this.campaignUrl = _data["campaignUrl"];
            this.campaignViews = _data["campaignViews"];
            this.enabled = _data["enabled"];
            this.data = _data["data"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CareFundCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.careFundCampaignTags)) {
            data["careFundCampaignTags"] = [];
            for (let item of this.careFundCampaignTags)
                data["careFundCampaignTags"].push(item.toJSON());
        }
        data["creatorUserDetail"] = this.creatorUserDetail ? this.creatorUserDetail.toJSON() : <any>undefined;
        data["beneficiaryUserDetail"] = this.beneficiaryUserDetail ? this.beneficiaryUserDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.careFundApplications)) {
            data["careFundApplications"] = [];
            for (let item of this.careFundApplications)
                data["careFundApplications"].push(item.toJSON());
        }
        if (Array.isArray(this.careFundDonations)) {
            data["careFundDonations"] = [];
            for (let item of this.careFundDonations)
                data["careFundDonations"].push(item.toJSON());
        }
        data["campaignDonors"] = this.campaignDonors;
        data["campaignApplicants"] = this.campaignApplicants;
        data["careFundCampaignID"] = this.careFundCampaignID;
        data["name"] = this.name;
        data["title"] = this.title;
        data["campaignID"] = this.campaignID;
        data["description"] = this.description;
        data["careFundOrganization"] = this.careFundOrganization;
        data["campaignCreatorUserDetailID"] = this.campaignCreatorUserDetailID;
        data["campaignBeneficiaryUserDetailID"] = this.campaignBeneficiaryUserDetailID;
        data["campaignHealthConditionTags"] = this.campaignHealthConditionTags;
        data["campaignImageDetailID"] = this.campaignImageDetailID;
        data["campaignVideoDetailID"] = this.campaignVideoDetailID;
        data["careFundCampaignTypeEnum"] = this.careFundCampaignTypeEnum;
        data["careFundCategoryEnum"] = this.careFundCategoryEnum;
        data["careFundCampaignStatusEnum"] = this.careFundCampaignStatusEnum;
        data["careFundCampaignConfigData"] = this.careFundCampaignConfigData;
        data["careFundTags"] = this.careFundTags;
        data["goalAmount"] = this.goalAmount;
        data["raisedAmount"] = this.raisedAmount;
        data["currencyEnum"] = this.currencyEnum;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["hasAgreedCampaignTC"] = this.hasAgreedCampaignTC;
        data["hasAcceptedCampaignPrivacyTC"] = this.hasAcceptedCampaignPrivacyTC;
        data["campaignUrl"] = this.campaignUrl;
        data["campaignViews"] = this.campaignViews;
        data["enabled"] = this.enabled;
        data["data"] = this.data;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface ICareFundCampaign extends IEntityBase {
    careFundCampaignTags?: CareFundTag[] | undefined;
    creatorUserDetail?: UserDetail | undefined;
    beneficiaryUserDetail?: UserDetail | undefined;
    careFundApplications?: CareFundApplication[] | undefined;
    careFundDonations?: CareFundDonation[] | undefined;
    campaignDonors?: number | undefined;
    campaignApplicants?: number | undefined;
    careFundCampaignID: string;
    name: string;
    title?: string | undefined;
    campaignID?: string | undefined;
    description?: string | undefined;
    careFundOrganization?: boolean | undefined;
    campaignCreatorUserDetailID?: string;
    campaignBeneficiaryUserDetailID?: string | undefined;
    campaignHealthConditionTags?: string | undefined;
    campaignImageDetailID?: string | undefined;
    campaignVideoDetailID?: string | undefined;
    careFundCampaignTypeEnum?: CareFundCampaignTypeEnum | undefined;
    careFundCategoryEnum?: CareFundCategoryEnum | undefined;
    careFundCampaignStatusEnum?: CareFundStatusEnum;
    careFundCampaignConfigData?: string | undefined;
    careFundTags?: string | undefined;
    goalAmount: number;
    raisedAmount: number;
    currencyEnum: CurrencyEnum;
    startDate?: Date;
    endDate?: Date;
    hasAgreedCampaignTC?: boolean;
    hasAcceptedCampaignPrivacyTC?: boolean;
    campaignUrl?: string | undefined;
    campaignViews?: number;
    enabled: boolean;
    data?: string | undefined;
    message?: string | undefined;
}

export class CareFundDonation extends EntityBase implements ICareFundDonation {
    careFundCampaign?: CareFundCampaign | undefined;
    invoice?: Invoice | undefined;
    totalPayment?: number | undefined;
    careFundDonorUserDetail?: UserDetail | undefined;
    careFundDonationID!: string;
    careFundCampaignID!: string;
    invoiceID?: string | undefined;
    careFundDonorUserDetailID?: string | undefined;
    name!: string;
    description?: string | undefined;
    amount!: number;
    isAnonymous!: boolean;
    donationStatusEnum!: InvoiceStatusEnum;
    data?: string | undefined;
    emailAddress?: string | undefined;
    currencyEnum?: CurrencyEnum;
    countryCode?: string | undefined;

    constructor(data?: ICareFundDonation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.careFundCampaign = _data["careFundCampaign"] ? CareFundCampaign.fromJS(_data["careFundCampaign"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.totalPayment = _data["totalPayment"];
            this.careFundDonorUserDetail = _data["careFundDonorUserDetail"] ? UserDetail.fromJS(_data["careFundDonorUserDetail"]) : <any>undefined;
            this.careFundDonationID = _data["careFundDonationID"];
            this.careFundCampaignID = _data["careFundCampaignID"];
            this.invoiceID = _data["invoiceID"];
            this.careFundDonorUserDetailID = _data["careFundDonorUserDetailID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.isAnonymous = _data["isAnonymous"];
            this.donationStatusEnum = _data["donationStatusEnum"];
            this.data = _data["data"];
            this.emailAddress = _data["emailAddress"];
            this.currencyEnum = _data["currencyEnum"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): CareFundDonation {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundDonation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careFundCampaign"] = this.careFundCampaign ? this.careFundCampaign.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["totalPayment"] = this.totalPayment;
        data["careFundDonorUserDetail"] = this.careFundDonorUserDetail ? this.careFundDonorUserDetail.toJSON() : <any>undefined;
        data["careFundDonationID"] = this.careFundDonationID;
        data["careFundCampaignID"] = this.careFundCampaignID;
        data["invoiceID"] = this.invoiceID;
        data["careFundDonorUserDetailID"] = this.careFundDonorUserDetailID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["isAnonymous"] = this.isAnonymous;
        data["donationStatusEnum"] = this.donationStatusEnum;
        data["data"] = this.data;
        data["emailAddress"] = this.emailAddress;
        data["currencyEnum"] = this.currencyEnum;
        data["countryCode"] = this.countryCode;
        super.toJSON(data);
        return data;
    }
}

export interface ICareFundDonation extends IEntityBase {
    careFundCampaign?: CareFundCampaign | undefined;
    invoice?: Invoice | undefined;
    totalPayment?: number | undefined;
    careFundDonorUserDetail?: UserDetail | undefined;
    careFundDonationID: string;
    careFundCampaignID: string;
    invoiceID?: string | undefined;
    careFundDonorUserDetailID?: string | undefined;
    name: string;
    description?: string | undefined;
    amount: number;
    isAnonymous: boolean;
    donationStatusEnum: InvoiceStatusEnum;
    data?: string | undefined;
    emailAddress?: string | undefined;
    currencyEnum?: CurrencyEnum;
    countryCode?: string | undefined;
}

export enum CareFundCampaignTypeEnum {
    NotSet = "NotSet",
    Global = "Global",
    Individual = "Individual",
}

export enum CareFundCategoryEnum {
    NotSet = "NotSet",
    Medical = "Medical",
    Mental = "Mental",
}

export enum CareFundStatusEnum {
    NotSet = "NotSet",
    Under_Review = "Under_Review",
    Awaiting_Approval = "Awaiting_Approval",
    Approved = "Approved",
    Denied = "Denied",
    Ended = "Ended",
    Disbursed = "Disbursed",
    Rejected = "Rejected",
    Failed = "Failed",
}

export class CareFundDisbursement extends EntityBase implements ICareFundDisbursement {
    careFundApplication?: CareFundApplication | undefined;
    invoice?: Invoice | undefined;
    careFundDisbursementID!: string;
    careFundApplicationID!: string;
    invoiceID?: string | undefined;
    description?: string | undefined;
    amount!: number;
    disbursementStatusEnum!: InvoiceStatusEnum;
    data?: string | undefined;

    constructor(data?: ICareFundDisbursement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.careFundApplication = _data["careFundApplication"] ? CareFundApplication.fromJS(_data["careFundApplication"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.careFundDisbursementID = _data["careFundDisbursementID"];
            this.careFundApplicationID = _data["careFundApplicationID"];
            this.invoiceID = _data["invoiceID"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.disbursementStatusEnum = _data["disbursementStatusEnum"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CareFundDisbursement {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundDisbursement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careFundApplication"] = this.careFundApplication ? this.careFundApplication.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["careFundDisbursementID"] = this.careFundDisbursementID;
        data["careFundApplicationID"] = this.careFundApplicationID;
        data["invoiceID"] = this.invoiceID;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["disbursementStatusEnum"] = this.disbursementStatusEnum;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface ICareFundDisbursement extends IEntityBase {
    careFundApplication?: CareFundApplication | undefined;
    invoice?: Invoice | undefined;
    careFundDisbursementID: string;
    careFundApplicationID: string;
    invoiceID?: string | undefined;
    description?: string | undefined;
    amount: number;
    disbursementStatusEnum: InvoiceStatusEnum;
    data?: string | undefined;
}

export class CareFundApplicationDisburseResult implements ICareFundApplicationDisburseResult {
    careFundCampaignID?: string;
    message?: string | undefined;

    constructor(data?: ICareFundApplicationDisburseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careFundCampaignID = _data["careFundCampaignID"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CareFundApplicationDisburseResult {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundApplicationDisburseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careFundCampaignID"] = this.careFundCampaignID;
        data["message"] = this.message;
        return data;
    }
}

export interface ICareFundApplicationDisburseResult {
    careFundCampaignID?: string;
    message?: string | undefined;
}

export class CareFundApplicationDisburseDTO implements ICareFundApplicationDisburseDTO {
    careFundApplicationID?: string;
    amount?: number;

    constructor(data?: ICareFundApplicationDisburseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careFundApplicationID = _data["careFundApplicationID"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CareFundApplicationDisburseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundApplicationDisburseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careFundApplicationID"] = this.careFundApplicationID;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ICareFundApplicationDisburseDTO {
    careFundApplicationID?: string;
    amount?: number;
}

export class PagedResultOfCareFundCampaign implements IPagedResultOfCareFundCampaign {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: CareFundCampaign[] | undefined;

    constructor(data?: IPagedResultOfCareFundCampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CareFundCampaign.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfCareFundCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCareFundCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfCareFundCampaign {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: CareFundCampaign[] | undefined;
}

export class UpdateCareFundCampaignDTO implements IUpdateCareFundCampaignDTO {
    careFundCampaignID!: string;
    goalAmount!: number;

    constructor(data?: IUpdateCareFundCampaignDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careFundCampaignID = _data["careFundCampaignID"];
            this.goalAmount = _data["goalAmount"];
        }
    }

    static fromJS(data: any): UpdateCareFundCampaignDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCareFundCampaignDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careFundCampaignID"] = this.careFundCampaignID;
        data["goalAmount"] = this.goalAmount;
        return data;
    }
}

export interface IUpdateCareFundCampaignDTO {
    careFundCampaignID: string;
    goalAmount: number;
}

export class CareFundCampaignSummary implements ICareFundCampaignSummary {
    totalCampaigns?: number;
    totalDonations?: number;
    totalApplications?: number;
    totalRaised?: number;
    totalDisbursed?: number;
    totalAmountReceived?: number;

    constructor(data?: ICareFundCampaignSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCampaigns = _data["totalCampaigns"];
            this.totalDonations = _data["totalDonations"];
            this.totalApplications = _data["totalApplications"];
            this.totalRaised = _data["totalRaised"];
            this.totalDisbursed = _data["totalDisbursed"];
            this.totalAmountReceived = _data["totalAmountReceived"];
        }
    }

    static fromJS(data: any): CareFundCampaignSummary {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundCampaignSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCampaigns"] = this.totalCampaigns;
        data["totalDonations"] = this.totalDonations;
        data["totalApplications"] = this.totalApplications;
        data["totalRaised"] = this.totalRaised;
        data["totalDisbursed"] = this.totalDisbursed;
        data["totalAmountReceived"] = this.totalAmountReceived;
        return data;
    }
}

export interface ICareFundCampaignSummary {
    totalCampaigns?: number;
    totalDonations?: number;
    totalApplications?: number;
    totalRaised?: number;
    totalDisbursed?: number;
    totalAmountReceived?: number;
}

export class CareFundCampaignMetric implements ICareFundCampaignMetric {
    totalDonations?: number;
    totalApplications?: number;
    totalRaised?: number;
    totalDisbursed?: number;
    balance?: number;

    constructor(data?: ICareFundCampaignMetric) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDonations = _data["totalDonations"];
            this.totalApplications = _data["totalApplications"];
            this.totalRaised = _data["totalRaised"];
            this.totalDisbursed = _data["totalDisbursed"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): CareFundCampaignMetric {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundCampaignMetric();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDonations"] = this.totalDonations;
        data["totalApplications"] = this.totalApplications;
        data["totalRaised"] = this.totalRaised;
        data["totalDisbursed"] = this.totalDisbursed;
        data["balance"] = this.balance;
        return data;
    }
}

export interface ICareFundCampaignMetric {
    totalDonations?: number;
    totalApplications?: number;
    totalRaised?: number;
    totalDisbursed?: number;
    balance?: number;
}

export class WalletCommitResults implements IWalletCommitResults {
    message?: string | undefined;
    success?: boolean;

    constructor(data?: IWalletCommitResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): WalletCommitResults {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCommitResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        return data;
    }
}

export interface IWalletCommitResults {
    message?: string | undefined;
    success?: boolean;
}

export class WalletCommitDetails implements IWalletCommitDetails {
    walletTypeEnum?: WalletTypeEnum | undefined;
    currencyEnum?: CurrencyEnum | undefined;
    invoiceID?: string;
    walletID?: string;

    constructor(data?: IWalletCommitDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walletTypeEnum = _data["walletTypeEnum"];
            this.currencyEnum = _data["currencyEnum"];
            this.invoiceID = _data["invoiceID"];
            this.walletID = _data["walletID"];
        }
    }

    static fromJS(data: any): WalletCommitDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCommitDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletTypeEnum"] = this.walletTypeEnum;
        data["currencyEnum"] = this.currencyEnum;
        data["invoiceID"] = this.invoiceID;
        data["walletID"] = this.walletID;
        return data;
    }
}

export interface IWalletCommitDetails {
    walletTypeEnum?: WalletTypeEnum | undefined;
    currencyEnum?: CurrencyEnum | undefined;
    invoiceID?: string;
    walletID?: string;
}

export enum WalletTypeEnum {
    Spending = "Spending",
    Savings = "Savings",
    Campaign = "Campaign",
    CareFund = "CareFund",
}

export class VirtualWalletResponse implements IVirtualWalletResponse {
    data?: Data | undefined;
    status?: number;
    message?: string | undefined;

    constructor(data?: IVirtualWalletResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Data.fromJS(_data["data"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): VirtualWalletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualWalletResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IVirtualWalletResponse {
    data?: Data | undefined;
    status?: number;
    message?: string | undefined;
}

export class Data implements IData {
    customerName?: string | undefined;
    merchantReference?: string | undefined;
    expireTimeInMin?: number;
    description?: string | undefined;
    amount?: number;
    phone?: string | undefined;
    email?: string | undefined;
    virtualAcctName?: string | undefined;
    virtualAcctNo?: string | undefined;
    merchant?: Merchant | undefined;
    reference?: any | undefined;
    metadata?: any | undefined;
    webhookUrl?: any | undefined;
    bank?: string | undefined;
    redirectUrl?: string | undefined;
    jobId?: any | undefined;
    sessionId?: any | undefined;
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    requestTime?: Date;
    status?: string | undefined;
    paymentStatus?: string | undefined;

    constructor(data?: IData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.merchantReference = _data["merchantReference"];
            this.expireTimeInMin = _data["expireTimeInMin"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.virtualAcctName = _data["virtualAcctName"];
            this.virtualAcctNo = _data["virtualAcctNo"];
            this.merchant = _data["merchant"] ? Merchant.fromJS(_data["merchant"]) : <any>undefined;
            this.reference = _data["reference"];
            this.metadata = _data["metadata"];
            this.webhookUrl = _data["webhookUrl"];
            this.bank = _data["bank"];
            this.redirectUrl = _data["redirectUrl"];
            this.jobId = _data["jobId"];
            this.sessionId = _data["sessionId"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.requestTime = _data["requestTime"] ? new Date(_data["requestTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): Data {
        data = typeof data === 'object' ? data : {};
        let result = new Data();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["merchantReference"] = this.merchantReference;
        data["expireTimeInMin"] = this.expireTimeInMin;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["virtualAcctName"] = this.virtualAcctName;
        data["virtualAcctNo"] = this.virtualAcctNo;
        data["merchant"] = this.merchant ? this.merchant.toJSON() : <any>undefined;
        data["reference"] = this.reference;
        data["metadata"] = this.metadata;
        data["webhookUrl"] = this.webhookUrl;
        data["bank"] = this.bank;
        data["redirectUrl"] = this.redirectUrl;
        data["jobId"] = this.jobId;
        data["sessionId"] = this.sessionId;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["requestTime"] = this.requestTime ? this.requestTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IData {
    customerName?: string | undefined;
    merchantReference?: string | undefined;
    expireTimeInMin?: number;
    description?: string | undefined;
    amount?: number;
    phone?: string | undefined;
    email?: string | undefined;
    virtualAcctName?: string | undefined;
    virtualAcctNo?: string | undefined;
    merchant?: Merchant | undefined;
    reference?: any | undefined;
    metadata?: any | undefined;
    webhookUrl?: any | undefined;
    bank?: string | undefined;
    redirectUrl?: string | undefined;
    jobId?: any | undefined;
    sessionId?: any | undefined;
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    requestTime?: Date;
    status?: string | undefined;
    paymentStatus?: string | undefined;
}

export class Merchant implements IMerchant {
    id?: string | undefined;

    constructor(data?: IMerchant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Merchant {
        data = typeof data === 'object' ? data : {};
        let result = new Merchant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IMerchant {
    id?: string | undefined;
}

export class CurrencyExchangeResult implements ICurrencyExchangeResult {
    fromCurrencyEnum?: CurrencyEnum;
    fromAmount?: number;
    toCurrencyEnum?: CurrencyEnum;
    toAmount?: number;
    rate?: number;
    rateDate?: Date;
    currencyExchangeInvoiceID?: string | undefined;

    constructor(data?: ICurrencyExchangeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromCurrencyEnum = _data["fromCurrencyEnum"];
            this.fromAmount = _data["fromAmount"];
            this.toCurrencyEnum = _data["toCurrencyEnum"];
            this.toAmount = _data["toAmount"];
            this.rate = _data["rate"];
            this.rateDate = _data["rateDate"] ? new Date(_data["rateDate"].toString()) : <any>undefined;
            this.currencyExchangeInvoiceID = _data["currencyExchangeInvoiceID"];
        }
    }

    static fromJS(data: any): CurrencyExchangeResult {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyExchangeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromCurrencyEnum"] = this.fromCurrencyEnum;
        data["fromAmount"] = this.fromAmount;
        data["toCurrencyEnum"] = this.toCurrencyEnum;
        data["toAmount"] = this.toAmount;
        data["rate"] = this.rate;
        data["rateDate"] = this.rateDate ? this.rateDate.toISOString() : <any>undefined;
        data["currencyExchangeInvoiceID"] = this.currencyExchangeInvoiceID;
        return data;
    }
}

export interface ICurrencyExchangeResult {
    fromCurrencyEnum?: CurrencyEnum;
    fromAmount?: number;
    toCurrencyEnum?: CurrencyEnum;
    toAmount?: number;
    rate?: number;
    rateDate?: Date;
    currencyExchangeInvoiceID?: string | undefined;
}

export class CreateCurrencyExchangeInvoiceDetails implements ICreateCurrencyExchangeInvoiceDetails {
    originalInvoiceID?: string;
    toCurrencyEnum?: CurrencyEnum;
    isDonation?: boolean;

    constructor(data?: ICreateCurrencyExchangeInvoiceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalInvoiceID = _data["originalInvoiceID"];
            this.toCurrencyEnum = _data["toCurrencyEnum"];
            this.isDonation = _data["isDonation"];
        }
    }

    static fromJS(data: any): CreateCurrencyExchangeInvoiceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCurrencyExchangeInvoiceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalInvoiceID"] = this.originalInvoiceID;
        data["toCurrencyEnum"] = this.toCurrencyEnum;
        data["isDonation"] = this.isDonation;
        return data;
    }
}

export interface ICreateCurrencyExchangeInvoiceDetails {
    originalInvoiceID?: string;
    toCurrencyEnum?: CurrencyEnum;
    isDonation?: boolean;
}

export class CareFundStatisticsDTO implements ICareFundStatisticsDTO {
    totalDonationsAmount?: number;
    totalDisbursementsAmount?: number;
    totalCampaigns?: number;
    totalDonors?: number;
    totalApplications?: number;
    latestDonations?: LatestCareFundDonationDTO[] | undefined;

    constructor(data?: ICareFundStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalDonationsAmount = _data["totalDonationsAmount"];
            this.totalDisbursementsAmount = _data["totalDisbursementsAmount"];
            this.totalCampaigns = _data["totalCampaigns"];
            this.totalDonors = _data["totalDonors"];
            this.totalApplications = _data["totalApplications"];
            if (Array.isArray(_data["latestDonations"])) {
                this.latestDonations = [] as any;
                for (let item of _data["latestDonations"])
                    this.latestDonations!.push(LatestCareFundDonationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CareFundStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CareFundStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalDonationsAmount"] = this.totalDonationsAmount;
        data["totalDisbursementsAmount"] = this.totalDisbursementsAmount;
        data["totalCampaigns"] = this.totalCampaigns;
        data["totalDonors"] = this.totalDonors;
        data["totalApplications"] = this.totalApplications;
        if (Array.isArray(this.latestDonations)) {
            data["latestDonations"] = [];
            for (let item of this.latestDonations)
                data["latestDonations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICareFundStatisticsDTO {
    totalDonationsAmount?: number;
    totalDisbursementsAmount?: number;
    totalCampaigns?: number;
    totalDonors?: number;
    totalApplications?: number;
    latestDonations?: LatestCareFundDonationDTO[] | undefined;
}

export class LatestCareFundDonationDTO implements ILatestCareFundDonationDTO {
    careFundDonationId?: string;
    donorName?: string | undefined;
    amount?: number | undefined;
    date?: string | undefined;
    currency?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: ILatestCareFundDonationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careFundDonationId = _data["careFundDonationId"];
            this.donorName = _data["donorName"];
            this.amount = _data["amount"];
            this.date = _data["date"];
            this.currency = _data["currency"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): LatestCareFundDonationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LatestCareFundDonationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careFundDonationId"] = this.careFundDonationId;
        data["donorName"] = this.donorName;
        data["amount"] = this.amount;
        data["date"] = this.date;
        data["currency"] = this.currency;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface ILatestCareFundDonationDTO {
    careFundDonationId?: string;
    donorName?: string | undefined;
    amount?: number | undefined;
    date?: string | undefined;
    currency?: string | undefined;
    countryCode?: string | undefined;
}

export class ClinicalTrialLocation extends EntityBase implements IClinicalTrialLocation {
    clinicalTrialLocationID!: string;
    clinicalTrialID!: string;
    name!: string;

    constructor(data?: IClinicalTrialLocation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clinicalTrialLocationID = _data["clinicalTrialLocationID"];
            this.clinicalTrialID = _data["clinicalTrialID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClinicalTrialLocation {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicalTrialLocationID"] = this.clinicalTrialLocationID;
        data["clinicalTrialID"] = this.clinicalTrialID;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IClinicalTrialLocation extends IEntityBase {
    clinicalTrialLocationID: string;
    clinicalTrialID: string;
    name: string;
}

export class ClinicalTrialSearchSetup implements IClinicalTrialSearchSetup {
    clinicalTrialPhaseTypes?: ClinicalTrialPhaseType[] | undefined;
    clinicalTrialStatusTypes?: ClinicalTrialStatusType[] | undefined;

    constructor(data?: IClinicalTrialSearchSetup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clinicalTrialPhaseTypes"])) {
                this.clinicalTrialPhaseTypes = [] as any;
                for (let item of _data["clinicalTrialPhaseTypes"])
                    this.clinicalTrialPhaseTypes!.push(ClinicalTrialPhaseType.fromJS(item));
            }
            if (Array.isArray(_data["clinicalTrialStatusTypes"])) {
                this.clinicalTrialStatusTypes = [] as any;
                for (let item of _data["clinicalTrialStatusTypes"])
                    this.clinicalTrialStatusTypes!.push(ClinicalTrialStatusType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClinicalTrialSearchSetup {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialSearchSetup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clinicalTrialPhaseTypes)) {
            data["clinicalTrialPhaseTypes"] = [];
            for (let item of this.clinicalTrialPhaseTypes)
                data["clinicalTrialPhaseTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicalTrialStatusTypes)) {
            data["clinicalTrialStatusTypes"] = [];
            for (let item of this.clinicalTrialStatusTypes)
                data["clinicalTrialStatusTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClinicalTrialSearchSetup {
    clinicalTrialPhaseTypes?: ClinicalTrialPhaseType[] | undefined;
    clinicalTrialStatusTypes?: ClinicalTrialStatusType[] | undefined;
}

export class ClinicalTrialPhaseType extends EntityBase implements IClinicalTrialPhaseType {
    clinicalTrialPhaseTypeID!: string;
    name!: string;
    description!: string;

    constructor(data?: IClinicalTrialPhaseType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clinicalTrialPhaseTypeID = _data["clinicalTrialPhaseTypeID"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ClinicalTrialPhaseType {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialPhaseType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicalTrialPhaseTypeID"] = this.clinicalTrialPhaseTypeID;
        data["name"] = this.name;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IClinicalTrialPhaseType extends IEntityBase {
    clinicalTrialPhaseTypeID: string;
    name: string;
    description: string;
}

export class ClinicalTrialStatusType extends EntityBase implements IClinicalTrialStatusType {
    clinicalTrialStatusTypeID!: string;
    name!: string;
    description!: string;

    constructor(data?: IClinicalTrialStatusType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clinicalTrialStatusTypeID = _data["clinicalTrialStatusTypeID"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ClinicalTrialStatusType {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialStatusType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicalTrialStatusTypeID"] = this.clinicalTrialStatusTypeID;
        data["name"] = this.name;
        data["description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface IClinicalTrialStatusType extends IEntityBase {
    clinicalTrialStatusTypeID: string;
    name: string;
    description: string;
}

export class ClinicalTrialSearchResults implements IClinicalTrialSearchResults {
    clinicalTrials?: ClinicalTrial[] | undefined;

    constructor(data?: IClinicalTrialSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clinicalTrials"])) {
                this.clinicalTrials = [] as any;
                for (let item of _data["clinicalTrials"])
                    this.clinicalTrials!.push(ClinicalTrial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClinicalTrialSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clinicalTrials)) {
            data["clinicalTrials"] = [];
            for (let item of this.clinicalTrials)
                data["clinicalTrials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClinicalTrialSearchResults {
    clinicalTrials?: ClinicalTrial[] | undefined;
}

export class ClinicalTrial extends EntityBase implements IClinicalTrial {
    clinicalTrialStatusType?: ClinicalTrialStatusType | undefined;
    clinicalTrialPhaseType?: ClinicalTrialPhaseType | undefined;
    clinicalTrialTags?: ClinicalTrialTag[] | undefined;
    clinicalTrialLocations?: ClinicalTrialLocation[] | undefined;
    clinicalTrialInterventions?: ClinicalTrialIntervention[] | undefined;
    clinicalTrialID!: string;
    name!: string;
    summary!: string;
    description!: string;
    startDate!: Date;
    endDate!: Date;
    clinicalTrialStatusTypeID!: string;
    clinicalTrialPhaseTypeID!: string;
    url!: string;
    externalID?: string | undefined;
    gender?: string | undefined;
    minimumAge?: string | undefined;
    maximumAge?: string | undefined;

    constructor(data?: IClinicalTrial) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clinicalTrialStatusType = _data["clinicalTrialStatusType"] ? ClinicalTrialStatusType.fromJS(_data["clinicalTrialStatusType"]) : <any>undefined;
            this.clinicalTrialPhaseType = _data["clinicalTrialPhaseType"] ? ClinicalTrialPhaseType.fromJS(_data["clinicalTrialPhaseType"]) : <any>undefined;
            if (Array.isArray(_data["clinicalTrialTags"])) {
                this.clinicalTrialTags = [] as any;
                for (let item of _data["clinicalTrialTags"])
                    this.clinicalTrialTags!.push(ClinicalTrialTag.fromJS(item));
            }
            if (Array.isArray(_data["clinicalTrialLocations"])) {
                this.clinicalTrialLocations = [] as any;
                for (let item of _data["clinicalTrialLocations"])
                    this.clinicalTrialLocations!.push(ClinicalTrialLocation.fromJS(item));
            }
            if (Array.isArray(_data["clinicalTrialInterventions"])) {
                this.clinicalTrialInterventions = [] as any;
                for (let item of _data["clinicalTrialInterventions"])
                    this.clinicalTrialInterventions!.push(ClinicalTrialIntervention.fromJS(item));
            }
            this.clinicalTrialID = _data["clinicalTrialID"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.clinicalTrialStatusTypeID = _data["clinicalTrialStatusTypeID"];
            this.clinicalTrialPhaseTypeID = _data["clinicalTrialPhaseTypeID"];
            this.url = _data["url"];
            this.externalID = _data["externalID"];
            this.gender = _data["gender"];
            this.minimumAge = _data["minimumAge"];
            this.maximumAge = _data["maximumAge"];
        }
    }

    static fromJS(data: any): ClinicalTrial {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicalTrialStatusType"] = this.clinicalTrialStatusType ? this.clinicalTrialStatusType.toJSON() : <any>undefined;
        data["clinicalTrialPhaseType"] = this.clinicalTrialPhaseType ? this.clinicalTrialPhaseType.toJSON() : <any>undefined;
        if (Array.isArray(this.clinicalTrialTags)) {
            data["clinicalTrialTags"] = [];
            for (let item of this.clinicalTrialTags)
                data["clinicalTrialTags"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicalTrialLocations)) {
            data["clinicalTrialLocations"] = [];
            for (let item of this.clinicalTrialLocations)
                data["clinicalTrialLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicalTrialInterventions)) {
            data["clinicalTrialInterventions"] = [];
            for (let item of this.clinicalTrialInterventions)
                data["clinicalTrialInterventions"].push(item.toJSON());
        }
        data["clinicalTrialID"] = this.clinicalTrialID;
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["clinicalTrialStatusTypeID"] = this.clinicalTrialStatusTypeID;
        data["clinicalTrialPhaseTypeID"] = this.clinicalTrialPhaseTypeID;
        data["url"] = this.url;
        data["externalID"] = this.externalID;
        data["gender"] = this.gender;
        data["minimumAge"] = this.minimumAge;
        data["maximumAge"] = this.maximumAge;
        super.toJSON(data);
        return data;
    }
}

export interface IClinicalTrial extends IEntityBase {
    clinicalTrialStatusType?: ClinicalTrialStatusType | undefined;
    clinicalTrialPhaseType?: ClinicalTrialPhaseType | undefined;
    clinicalTrialTags?: ClinicalTrialTag[] | undefined;
    clinicalTrialLocations?: ClinicalTrialLocation[] | undefined;
    clinicalTrialInterventions?: ClinicalTrialIntervention[] | undefined;
    clinicalTrialID: string;
    name: string;
    summary: string;
    description: string;
    startDate: Date;
    endDate: Date;
    clinicalTrialStatusTypeID: string;
    clinicalTrialPhaseTypeID: string;
    url: string;
    externalID?: string | undefined;
    gender?: string | undefined;
    minimumAge?: string | undefined;
    maximumAge?: string | undefined;
}

export class ClinicalTrialTag extends EntityBase implements IClinicalTrialTag {
    tag?: Tag | undefined;
    clinicalTrialTagID!: string;
    clinicalTrialID!: string;
    tagID!: string;

    constructor(data?: IClinicalTrialTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.clinicalTrialTagID = _data["clinicalTrialTagID"];
            this.clinicalTrialID = _data["clinicalTrialID"];
            this.tagID = _data["tagID"];
        }
    }

    static fromJS(data: any): ClinicalTrialTag {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["clinicalTrialTagID"] = this.clinicalTrialTagID;
        data["clinicalTrialID"] = this.clinicalTrialID;
        data["tagID"] = this.tagID;
        super.toJSON(data);
        return data;
    }
}

export interface IClinicalTrialTag extends IEntityBase {
    tag?: Tag | undefined;
    clinicalTrialTagID: string;
    clinicalTrialID: string;
    tagID: string;
}

export class ClinicalTrialIntervention extends EntityBase implements IClinicalTrialIntervention {
    clinicalTrialInterventionID!: string;
    clinicalTrialID!: string;
    interventionType!: string;
    name!: string;

    constructor(data?: IClinicalTrialIntervention) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clinicalTrialInterventionID = _data["clinicalTrialInterventionID"];
            this.clinicalTrialID = _data["clinicalTrialID"];
            this.interventionType = _data["interventionType"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClinicalTrialIntervention {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialIntervention();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clinicalTrialInterventionID"] = this.clinicalTrialInterventionID;
        data["clinicalTrialID"] = this.clinicalTrialID;
        data["interventionType"] = this.interventionType;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IClinicalTrialIntervention extends IEntityBase {
    clinicalTrialInterventionID: string;
    clinicalTrialID: string;
    interventionType: string;
    name: string;
}

export class ClinicalTrialSearchDetails implements IClinicalTrialSearchDetails {
    searchText?: string | undefined;
    location?: string | undefined;
    tags?: string[] | undefined;
    clinicalTrialStatusTypes?: string[] | undefined;
    clinicalTrialPhaseTypes?: string[] | undefined;
    recordsToSkip?: number;
    recordsToTake?: number;

    constructor(data?: IClinicalTrialSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.location = _data["location"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["clinicalTrialStatusTypes"])) {
                this.clinicalTrialStatusTypes = [] as any;
                for (let item of _data["clinicalTrialStatusTypes"])
                    this.clinicalTrialStatusTypes!.push(item);
            }
            if (Array.isArray(_data["clinicalTrialPhaseTypes"])) {
                this.clinicalTrialPhaseTypes = [] as any;
                for (let item of _data["clinicalTrialPhaseTypes"])
                    this.clinicalTrialPhaseTypes!.push(item);
            }
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
        }
    }

    static fromJS(data: any): ClinicalTrialSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["location"] = this.location;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.clinicalTrialStatusTypes)) {
            data["clinicalTrialStatusTypes"] = [];
            for (let item of this.clinicalTrialStatusTypes)
                data["clinicalTrialStatusTypes"].push(item);
        }
        if (Array.isArray(this.clinicalTrialPhaseTypes)) {
            data["clinicalTrialPhaseTypes"] = [];
            for (let item of this.clinicalTrialPhaseTypes)
                data["clinicalTrialPhaseTypes"].push(item);
        }
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        return data;
    }
}

export interface IClinicalTrialSearchDetails {
    searchText?: string | undefined;
    location?: string | undefined;
    tags?: string[] | undefined;
    clinicalTrialStatusTypes?: string[] | undefined;
    clinicalTrialPhaseTypes?: string[] | undefined;
    recordsToSkip?: number;
    recordsToTake?: number;
}

export class ClinicalTrialImportResult implements IClinicalTrialImportResult {
    fileName?: string | undefined;
    trialImported?: number;
    errorMessage?: string | undefined;

    constructor(data?: IClinicalTrialImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.trialImported = _data["trialImported"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ClinicalTrialImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["trialImported"] = this.trialImported;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IClinicalTrialImportResult {
    fileName?: string | undefined;
    trialImported?: number;
    errorMessage?: string | undefined;
}

export class ClinicalTrialSignupResult implements IClinicalTrialSignupResult {
    result?: string | undefined;

    constructor(data?: IClinicalTrialSignupResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): ClinicalTrialSignupResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClinicalTrialSignupResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data;
    }
}

export interface IClinicalTrialSignupResult {
    result?: string | undefined;
}

export abstract class NotificationMessageDataBase implements INotificationMessageDataBase {
    link?: string | undefined;
    notificationMessageDataType?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    notificationID?: string;
    expiryDate?: Date;

    constructor(data?: INotificationMessageDataBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["Link"];
            this.notificationMessageDataType = _data["NotificationMessageDataType"];
            this.title = _data["Title"];
            this.message = _data["Message"];
            this.notificationID = _data["NotificationID"];
            this.expiryDate = _data["ExpiryDate"] ? new Date(_data["ExpiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationMessageDataBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'NotificationMessageDataBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Link"] = this.link;
        data["NotificationMessageDataType"] = this.notificationMessageDataType;
        data["Title"] = this.title;
        data["Message"] = this.message;
        data["NotificationID"] = this.notificationID;
        data["ExpiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotificationMessageDataBase {
    link?: string | undefined;
    notificationMessageDataType?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    notificationID?: string;
    expiryDate?: Date;
}

export class EchoNotificationMessageData extends NotificationMessageDataBase implements IEchoNotificationMessageData {

    constructor(data?: IEchoNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EchoNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new EchoNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEchoNotificationMessageData extends INotificationMessageDataBase {
}

export class ConsultNotificationMessageData extends NotificationMessageDataBase implements IConsultNotificationMessageData {

    constructor(data?: IConsultNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ConsultNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IConsultNotificationMessageData extends INotificationMessageDataBase {
}

export class CommunityNotificationMessageData extends NotificationMessageDataBase implements ICommunityNotificationMessageData {

    constructor(data?: ICommunityNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CommunityNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new CommunityNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICommunityNotificationMessageData extends INotificationMessageDataBase {
}

export class ApproveDenyNotificationMessageData extends NotificationMessageDataBase implements IApproveDenyNotificationMessageData {
    toUserDetailID?: string;

    constructor(data?: IApproveDenyNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.toUserDetailID = _data["toUserDetailID"];
        }
    }

    static fromJS(data: any): ApproveDenyNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveDenyNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toUserDetailID"] = this.toUserDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IApproveDenyNotificationMessageData extends INotificationMessageDataBase {
    toUserDetailID?: string;
}

export class MedicationNotificationMessageData extends NotificationMessageDataBase implements IMedicationNotificationMessageData {
    messageDate?: Date;
    from?: string | undefined;
    medicationName?: string | undefined;

    constructor(data?: IMedicationNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : <any>undefined;
            this.from = _data["from"];
            this.medicationName = _data["medicationName"];
        }
    }

    static fromJS(data: any): MedicationNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["from"] = this.from;
        data["medicationName"] = this.medicationName;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationNotificationMessageData extends INotificationMessageDataBase {
    messageDate?: Date;
    from?: string | undefined;
    medicationName?: string | undefined;
}

export class TextMessageNotificationMessageData extends NotificationMessageDataBase implements ITextMessageNotificationMessageData {

    constructor(data?: ITextMessageNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TextMessageNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new TextMessageNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITextMessageNotificationMessageData extends INotificationMessageDataBase {
}

export class SourceRewardNotificationMessageData extends NotificationMessageDataBase implements ISourceRewardNotificationMessageData {

    constructor(data?: ISourceRewardNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SourceRewardNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new SourceRewardNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISourceRewardNotificationMessageData extends INotificationMessageDataBase {
}

export class WalletNotificationMessageData extends NotificationMessageDataBase implements IWalletNotificationMessageData {

    constructor(data?: IWalletNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): WalletNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new WalletNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IWalletNotificationMessageData extends INotificationMessageDataBase {
}

export class MarketingNotificationMessageData extends NotificationMessageDataBase implements IMarketingNotificationMessageData {

    constructor(data?: IMarketingNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MarketingNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMarketingNotificationMessageData extends INotificationMessageDataBase {
}

export class BookConsultNotificationMessageData extends NotificationMessageDataBase implements IBookConsultNotificationMessageData {

    constructor(data?: IBookConsultNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BookConsultNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new BookConsultNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IBookConsultNotificationMessageData extends INotificationMessageDataBase {
}

export class ShoppingCartNotificationMessageData extends NotificationMessageDataBase implements IShoppingCartNotificationMessageData {

    constructor(data?: IShoppingCartNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ShoppingCartNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IShoppingCartNotificationMessageData extends INotificationMessageDataBase {
}

export class LearningNotificationMessageData extends NotificationMessageDataBase implements ILearningNotificationMessageData {

    constructor(data?: ILearningNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LearningNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new LearningNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILearningNotificationMessageData extends INotificationMessageDataBase {
}

export class AppSettingsNotificationMessageData extends NotificationMessageDataBase implements IAppSettingsNotificationMessageData {

    constructor(data?: IAppSettingsNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AppSettingsNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAppSettingsNotificationMessageData extends INotificationMessageDataBase {
}

export class RecordsNotificationMessageData extends NotificationMessageDataBase implements IRecordsNotificationMessageData {

    constructor(data?: IRecordsNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RecordsNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new RecordsNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRecordsNotificationMessageData extends INotificationMessageDataBase {
}

export class ProfileNotificationMessageData extends NotificationMessageDataBase implements IProfileNotificationMessageData {

    constructor(data?: IProfileNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ProfileNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProfileNotificationMessageData extends INotificationMessageDataBase {
}

export class GiveTheGiftNotificationMessageData extends NotificationMessageDataBase implements IGiveTheGiftNotificationMessageData {

    constructor(data?: IGiveTheGiftNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GiveTheGiftNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new GiveTheGiftNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGiveTheGiftNotificationMessageData extends INotificationMessageDataBase {
}

export class SupportNotificationMessageData extends NotificationMessageDataBase implements ISupportNotificationMessageData {

    constructor(data?: ISupportNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SupportNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new SupportNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISupportNotificationMessageData extends INotificationMessageDataBase {
}

export class CampaignsNotificationMessageData extends NotificationMessageDataBase implements ICampaignsNotificationMessageData {

    constructor(data?: ICampaignsNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CampaignsNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignsNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICampaignsNotificationMessageData extends INotificationMessageDataBase {
}

export class MailMessageNotificationMessageData extends NotificationMessageDataBase implements IMailMessageNotificationMessageData {

    constructor(data?: IMailMessageNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MailMessageNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new MailMessageNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMailMessageNotificationMessageData extends INotificationMessageDataBase {
}

export class OnDemandSessionNotificationMessageData extends NotificationMessageDataBase implements IOnDemandSessionNotificationMessageData {

    constructor(data?: IOnDemandSessionNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): OnDemandSessionNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new OnDemandSessionNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IOnDemandSessionNotificationMessageData extends INotificationMessageDataBase {
}

export class ProviderAppointmentNotificationMessageData extends NotificationMessageDataBase implements IProviderAppointmentNotificationMessageData {

    constructor(data?: IProviderAppointmentNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ProviderAppointmentNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderAppointmentNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProviderAppointmentNotificationMessageData extends INotificationMessageDataBase {
}

export class ProviderCancelAppointmentNotificationMessageData extends NotificationMessageDataBase implements IProviderCancelAppointmentNotificationMessageData {

    constructor(data?: IProviderCancelAppointmentNotificationMessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ProviderCancelAppointmentNotificationMessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderCancelAppointmentNotificationMessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProviderCancelAppointmentNotificationMessageData extends INotificationMessageDataBase {
}

export class ProviderQueueWaitingNotificationmessageData extends NotificationMessageDataBase implements IProviderQueueWaitingNotificationmessageData {

    constructor(data?: IProviderQueueWaitingNotificationmessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ProviderQueueWaitingNotificationmessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderQueueWaitingNotificationmessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProviderQueueWaitingNotificationmessageData extends INotificationMessageDataBase {
}

export class ProviderQueueExpireNotificationmessageData extends NotificationMessageDataBase implements IProviderQueueExpireNotificationmessageData {

    constructor(data?: IProviderQueueExpireNotificationmessageData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ProviderQueueExpireNotificationmessageData {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderQueueExpireNotificationmessageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProviderQueueExpireNotificationmessageData extends INotificationMessageDataBase {
}

export enum WeightEnum {
    Kg = "Kg",
    Lbs = "Lbs",
}

export enum HeightEnum {
    Cm = "Cm",
    In = "In",
}

export enum WeightHeightEnum {
    Metric = "Metric",
    Imperial = "Imperial",
}

export enum BloodGlucoseTypeEnum {
    MmolL = "mmol/L",
    MgdL = "mg/dL",
}

export enum TemperatureTypeEnum {
    Celsius = "Celsius",
    Fahrenheit = "Fahrenheit",
}

export class AuthorizeNetPublicDTO implements IAuthorizeNetPublicDTO {
    apiLoginID?: string | undefined;
    publicKey?: string | undefined;

    constructor(data?: IAuthorizeNetPublicDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiLoginID = _data["apiLoginID"];
            this.publicKey = _data["publicKey"];
        }
    }

    static fromJS(data: any): AuthorizeNetPublicDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetPublicDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiLoginID"] = this.apiLoginID;
        data["publicKey"] = this.publicKey;
        return data;
    }
}

export interface IAuthorizeNetPublicDTO {
    apiLoginID?: string | undefined;
    publicKey?: string | undefined;
}

export class AuthorizeNetPrivateDTO implements IAuthorizeNetPrivateDTO {
    apiLoginID?: string | undefined;
    transactionKey?: string | undefined;

    constructor(data?: IAuthorizeNetPrivateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiLoginID = _data["apiLoginID"];
            this.transactionKey = _data["transactionKey"];
        }
    }

    static fromJS(data: any): AuthorizeNetPrivateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetPrivateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiLoginID"] = this.apiLoginID;
        data["transactionKey"] = this.transactionKey;
        return data;
    }
}

export interface IAuthorizeNetPrivateDTO {
    apiLoginID?: string | undefined;
    transactionKey?: string | undefined;
}

export class AuthorizeNetURLsDTO implements IAuthorizeNetURLsDTO {
    baseURL?: string | undefined;
    xmlBaseURL?: string | undefined;
    uiurl?: string | undefined;

    constructor(data?: IAuthorizeNetURLsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseURL = _data["baseURL"];
            this.xmlBaseURL = _data["xmlBaseURL"];
            this.uiurl = _data["uiurl"];
        }
    }

    static fromJS(data: any): AuthorizeNetURLsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizeNetURLsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseURL"] = this.baseURL;
        data["xmlBaseURL"] = this.xmlBaseURL;
        data["uiurl"] = this.uiurl;
        return data;
    }
}

export interface IAuthorizeNetURLsDTO {
    baseURL?: string | undefined;
    xmlBaseURL?: string | undefined;
    uiurl?: string | undefined;
}

export class ActionMessage implements IActionMessage {
    userDetailID?: string;
    toUserDetailID?: string;
    messageDate?: Date;
    actionMessageEnum?: string | undefined;
    actionMessagePayloadTypeEnum?: string | undefined;
    message?: string | undefined;

    constructor(data?: IActionMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.toUserDetailID = _data["toUserDetailID"];
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : <any>undefined;
            this.actionMessageEnum = _data["actionMessageEnum"];
            this.actionMessagePayloadTypeEnum = _data["actionMessagePayloadTypeEnum"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ActionMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ActionMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["toUserDetailID"] = this.toUserDetailID;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["actionMessageEnum"] = this.actionMessageEnum;
        data["actionMessagePayloadTypeEnum"] = this.actionMessagePayloadTypeEnum;
        data["message"] = this.message;
        return data;
    }
}

export interface IActionMessage {
    userDetailID?: string;
    toUserDetailID?: string;
    messageDate?: Date;
    actionMessageEnum?: string | undefined;
    actionMessagePayloadTypeEnum?: string | undefined;
    message?: string | undefined;
}

export enum ActionMessageEnum {
    Ping = "Ping",
    Consult = "Consult",
    Mail = "Mail",
    SystemMessage = "SystemMessage",
    UserDetailRelationship = "UserDetailRelationship",
    USSDInvoicePayment = "USSDInvoicePayment",
    ShoppingCart = "ShoppingCart",
    MarketingCampaignUserDetailReward = "MarketingCampaignUserDetailReward",
    PatientPrescriptionProvider = "PatientPrescriptionProvider",
    PatientPrescriptionPatient = "PatientPrescriptionPatient",
    PatientPrescriptionPharmacist = "PatientPrescriptionPharmacist",
    FaxSent = "FaxSent",
    FaxReceived = "FaxReceived",
    FaxStatusUpdate = "FaxStatusUpdate",
    ProviderQueuePatientWaiting = "ProviderQueuePatientWaiting",
    ProviderQueuePatientTimeout = "ProviderQueuePatientTimeout",
    ApproveDeny = "ApproveDeny",
    ApproveDenyRequest = "ApproveDenyRequest",
    DiscussionItemDetail = "DiscussionItemDetail",
}

export enum ActionMessagePayloadTypeEnum {
    NotSet = "NotSet",
    ConsultStoreItem = "ConsultStoreItem",
    PatientReady = "PatientReady",
    ProviderReady = "ProviderReady",
    MoveToPhone = "MoveToPhone",
}

export class MailActionMessage implements IMailActionMessage {
    mailMessageID?: string;

    constructor(data?: IMailActionMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailMessageID = _data["mailMessageID"];
        }
    }

    static fromJS(data: any): MailActionMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MailActionMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailMessageID"] = this.mailMessageID;
        return data;
    }
}

export interface IMailActionMessage {
    mailMessageID?: string;
}

export class ConsultActionMessage implements IConsultActionMessage {
    consultID?: string;
    consultStatusEnum?: ConsultStatusEnum;

    constructor(data?: IConsultActionMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultID = _data["consultID"];
            this.consultStatusEnum = _data["consultStatusEnum"];
        }
    }

    static fromJS(data: any): ConsultActionMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultActionMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultID"] = this.consultID;
        data["consultStatusEnum"] = this.consultStatusEnum;
        return data;
    }
}

export interface IConsultActionMessage {
    consultID?: string;
    consultStatusEnum?: ConsultStatusEnum;
}

export class ProviderQueueActionMessage implements IProviderQueueActionMessage {
    providerQueueID?: string;
    consultID?: string;
    consultStatusEnum?: ConsultStatusEnum;

    constructor(data?: IProviderQueueActionMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerQueueID = _data["providerQueueID"];
            this.consultID = _data["consultID"];
            this.consultStatusEnum = _data["consultStatusEnum"];
        }
    }

    static fromJS(data: any): ProviderQueueActionMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderQueueActionMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerQueueID"] = this.providerQueueID;
        data["consultID"] = this.consultID;
        data["consultStatusEnum"] = this.consultStatusEnum;
        return data;
    }
}

export interface IProviderQueueActionMessage {
    providerQueueID?: string;
    consultID?: string;
    consultStatusEnum?: ConsultStatusEnum;
}

export class PatientPrescriptionActionMessage implements IPatientPrescriptionActionMessage {
    patientPrescriptionID?: string;
    prescriptionStatusEnum?: PrescriptionStatusEnum;

    constructor(data?: IPatientPrescriptionActionMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPrescriptionID = _data["patientPrescriptionID"];
            this.prescriptionStatusEnum = _data["prescriptionStatusEnum"];
        }
    }

    static fromJS(data: any): PatientPrescriptionActionMessage {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionActionMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPrescriptionID"] = this.patientPrescriptionID;
        data["prescriptionStatusEnum"] = this.prescriptionStatusEnum;
        return data;
    }
}

export interface IPatientPrescriptionActionMessage {
    patientPrescriptionID?: string;
    prescriptionStatusEnum?: PrescriptionStatusEnum;
}

export class ApproveDenyRequestActionMessage implements IApproveDenyRequestActionMessage {
    message?: string | undefined;
    notificationID?: string;
    title?: string | undefined;
    toUserDetailID?: string;
    expiryDate?: Date;
    notificationMessageDataType?: string | undefined;
    link?: string | undefined;

    constructor(data?: IApproveDenyRequestActionMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.notificationID = _data["notificationID"];
            this.title = _data["title"];
            this.toUserDetailID = _data["toUserDetailID"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.notificationMessageDataType = _data["notificationMessageDataType"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): ApproveDenyRequestActionMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveDenyRequestActionMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["notificationID"] = this.notificationID;
        data["title"] = this.title;
        data["toUserDetailID"] = this.toUserDetailID;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["notificationMessageDataType"] = this.notificationMessageDataType;
        data["link"] = this.link;
        return data;
    }
}

export interface IApproveDenyRequestActionMessage {
    message?: string | undefined;
    notificationID?: string;
    title?: string | undefined;
    toUserDetailID?: string;
    expiryDate?: Date;
    notificationMessageDataType?: string | undefined;
    link?: string | undefined;
}

export enum RolesEnum {
    TenantAdministrator = "TenantAdministrator",
    SystemAdministrator = "SystemAdministrator",
    ServiceAccount = "ServiceAccount",
    Provider = "Provider",
    Patient = "Patient",
    NotInitializedPatient = "NotInitializedPatient",
    Anonymous = "Anonymous",
    Moderator = "Moderator",
    PatientSearchRight = "PatientSearchRight",
    SubscriptionOwner = "SubscriptionOwner",
    NotApprovedProvider = "NotApprovedProvider",
    Pharmacist = "Pharmacist",
    HealthcareNavigator = "HealthcareNavigator",
    Receptionist = "Receptionist",
    MedicalAssistant = "MedicalAssistant",
    VidaSubscriptionRight = "VidaSubscriptionRight",
    AthenaSubscriptionRight = "AthenaSubscriptionRight",
    ZeusSubscriptionRight = "ZeusSubscriptionRight",
    TravelCareSubscriptionRight = "TravelCareSubscriptionRight",
    CareSpacesRight = "CareSpacesRight",
    ClinicalTrialRight = "ClinicalTrialRight",
    CommunityForumRight = "CommunityForumRight",
    EducationRight = "EducationRight",
    ResearchRight = "ResearchRight",
    TimeLineRight = "TimeLineRight",
    JournalRight = "JournalRight",
    MessagesRight = "MessagesRight",
    WalletRight = "WalletRight",
    RelationshipRight = "RelationshipRight",
    BlogRight = "BlogRight",
    UBTHRight = "UBTHRight",
    LagosRight = "LagosRight",
    EdoRight = "EdoRight",
    PublicNoticeRight = "PublicNoticeRight",
    SupportRight = "SupportRight",
    VitalsRight = "VitalsRight",
    FaxAdministratorRight = "FaxAdministratorRight",
    AddressBookAdministratorRight = "AddressBookAdministratorRight",
    MerchantProvider = "MerchantProvider",
    StoreManager = "StoreManager",
    AdminProviderOnboarding = "AdminProviderOnboarding",
    AdminMonitoring = "AdminMonitoring",
    AdminFacilityOnboarding = "AdminFacilityOnboarding",
    AdminSettings = "AdminSettings",
    HomeCareAdministrator = "HomeCareAdministrator",
    HomeCareNurse = "HomeCareNurse",
    FacilityReceptionist = "FacilityReceptionist",
    Nurse = "Nurse",
    FacilityAdministrator = "FacilityAdministrator",
    WalletCardAdministrator = "WalletCardAdministrator",
    ByPassOTPCheckRight = "ByPassOTPCheckRight",
    WalletCardAdministratorBookAppointmentRight = "WalletCardAdministratorBookAppointmentRight",
    MarketingCampaignPartner = "MarketingCampaignPartner",
    AffiliateAdministrator = "AffiliateAdministrator",
    NeoPaymentMerchant = "NeoPaymentMerchant",
    CommunityAdmin = "CommunityAdmin",
    CommunityAdvocate = "CommunityAdvocate",
    SuperPatient = "SuperPatient",
}

export class ConsultInvoiceStoreItemDisplayDetails implements IConsultInvoiceStoreItemDisplayDetails {
    consultPhysicianName?: string | undefined;
    consultStoreName?: string | undefined;
    consultDate?: Date | undefined;
    bookedByEnum?: BookedByEnum;
    itemName?: string | undefined;

    constructor(data?: IConsultInvoiceStoreItemDisplayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultPhysicianName = _data["consultPhysicianName"];
            this.consultStoreName = _data["consultStoreName"];
            this.consultDate = _data["consultDate"] ? new Date(_data["consultDate"].toString()) : <any>undefined;
            this.bookedByEnum = _data["bookedByEnum"];
            this.itemName = _data["itemName"];
        }
    }

    static fromJS(data: any): ConsultInvoiceStoreItemDisplayDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInvoiceStoreItemDisplayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultPhysicianName"] = this.consultPhysicianName;
        data["consultStoreName"] = this.consultStoreName;
        data["consultDate"] = this.consultDate ? this.consultDate.toISOString() : <any>undefined;
        data["bookedByEnum"] = this.bookedByEnum;
        data["itemName"] = this.itemName;
        return data;
    }
}

export interface IConsultInvoiceStoreItemDisplayDetails {
    consultPhysicianName?: string | undefined;
    consultStoreName?: string | undefined;
    consultDate?: Date | undefined;
    bookedByEnum?: BookedByEnum;
    itemName?: string | undefined;
}

export class PatientPrescriptionMedicationInvoiceStoreItemDisplayDetails implements IPatientPrescriptionMedicationInvoiceStoreItemDisplayDetails {
    medicationName?: string | undefined;
    storeName?: string | undefined;
    amount?: number;

    constructor(data?: IPatientPrescriptionMedicationInvoiceStoreItemDisplayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicationName = _data["medicationName"];
            this.storeName = _data["storeName"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PatientPrescriptionMedicationInvoiceStoreItemDisplayDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionMedicationInvoiceStoreItemDisplayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationName"] = this.medicationName;
        data["storeName"] = this.storeName;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPatientPrescriptionMedicationInvoiceStoreItemDisplayDetails {
    medicationName?: string | undefined;
    storeName?: string | undefined;
    amount?: number;
}

export class PatientPrescriptionInvoiceStoreItemDisplayDetails implements IPatientPrescriptionInvoiceStoreItemDisplayDetails {
    patientFullName?: string | undefined;
    providerFullName?: string | undefined;
    consultDate?: Date;
    qrCode?: number;

    constructor(data?: IPatientPrescriptionInvoiceStoreItemDisplayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientFullName = _data["patientFullName"];
            this.providerFullName = _data["providerFullName"];
            this.consultDate = _data["consultDate"] ? new Date(_data["consultDate"].toString()) : <any>undefined;
            this.qrCode = _data["qrCode"];
        }
    }

    static fromJS(data: any): PatientPrescriptionInvoiceStoreItemDisplayDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionInvoiceStoreItemDisplayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientFullName"] = this.patientFullName;
        data["providerFullName"] = this.providerFullName;
        data["consultDate"] = this.consultDate ? this.consultDate.toISOString() : <any>undefined;
        data["qrCode"] = this.qrCode;
        return data;
    }
}

export interface IPatientPrescriptionInvoiceStoreItemDisplayDetails {
    patientFullName?: string | undefined;
    providerFullName?: string | undefined;
    consultDate?: Date;
    qrCode?: number;
}

export class PatientOrderInvoiceStoreItemDisplayDetails implements IPatientOrderInvoiceStoreItemDisplayDetails {
    patientFullName?: string | undefined;
    providerFullName?: string | undefined;
    consultDate?: Date;
    qrCode?: number;

    constructor(data?: IPatientOrderInvoiceStoreItemDisplayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientFullName = _data["patientFullName"];
            this.providerFullName = _data["providerFullName"];
            this.consultDate = _data["consultDate"] ? new Date(_data["consultDate"].toString()) : <any>undefined;
            this.qrCode = _data["qrCode"];
        }
    }

    static fromJS(data: any): PatientOrderInvoiceStoreItemDisplayDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderInvoiceStoreItemDisplayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientFullName"] = this.patientFullName;
        data["providerFullName"] = this.providerFullName;
        data["consultDate"] = this.consultDate ? this.consultDate.toISOString() : <any>undefined;
        data["qrCode"] = this.qrCode;
        return data;
    }
}

export interface IPatientOrderInvoiceStoreItemDisplayDetails {
    patientFullName?: string | undefined;
    providerFullName?: string | undefined;
    consultDate?: Date;
    qrCode?: number;
}

export class PatientOrderOrderItemInvoiceStoreItemDisplayDetails implements IPatientOrderOrderItemInvoiceStoreItemDisplayDetails {
    testName?: string | undefined;
    storeName?: string | undefined;
    amount?: number;

    constructor(data?: IPatientOrderOrderItemInvoiceStoreItemDisplayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testName = _data["testName"];
            this.storeName = _data["storeName"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PatientOrderOrderItemInvoiceStoreItemDisplayDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderOrderItemInvoiceStoreItemDisplayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testName"] = this.testName;
        data["storeName"] = this.storeName;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPatientOrderOrderItemInvoiceStoreItemDisplayDetails {
    testName?: string | undefined;
    storeName?: string | undefined;
    amount?: number;
}

export enum NotificationMessageDataTypeEnum {
    TextMessageNotificationMessageData = "TextMessageNotificationMessageData",
    ApproveDenyNotificationMessageData = "ApproveDenyNotificationMessageData",
    ConsultNotificationMessageData = "ConsultNotificationMessageData",
    EchoNotificationMessageData = "EchoNotificationMessageData",
    MailMessageNotificationMessageData = "MailMessageNotificationMessageData",
    MarketingNotificationMessageData = "MarketingNotificationMessageData",
    MedicationNotificationMessageData = "MedicationNotificationMessageData",
    OnDemandSessionNotificationMessageData = "OnDemandSessionNotificationMessageData",
    ProviderAppointmentNotificationMessageData = "ProviderAppointmentNotificationMessageData",
    ProviderCancelAppointmentNotificationMessageData = "ProviderCancelAppointmentNotificationMessageData",
    ProviderQueueWaitingNotificationmessageData = "ProviderQueueWaitingNotificationmessageData",
    ProviderQueueExpireNotificationmessageData = "ProviderQueueExpireNotificationmessageData",
    SourceRewardNotificationMessageData = "SourceRewardNotificationMessageData",
    WalletNotificationMessageData = "WalletNotificationMessageData",
    CampaignsNotificationMessageData = "CampaignsNotificationMessageData",
    SupportNotificationMessageData = "SupportNotificationMessageData",
    GiveTheGiftNotificationMessageData = "GiveTheGiftNotificationMessageData",
    ProfileNotificationMessageData = "ProfileNotificationMessageData",
    RecordsNotificationMessageData = "RecordsNotificationMessageData",
    AppSettingsNotificationMessageData = "AppSettingsNotificationMessageData",
    LearningNotificationMessageData = "LearningNotificationMessageData",
    ShoppingCartNotificationMessageData = "ShoppingCartNotificationMessageData",
    BookConsultNotificationMessageData = "BookConsultNotificationMessageData",
    CommunityNotificationMessageData = "CommunityNotificationMessageData",
}

export enum MarketingEventEnum {
    EmergeCardClicked = "emerg_card_clicked",
    EmergConsultBooked = "EmergConsultBooked",
}

export enum ConsultationTypeFlowEnum {
    UrgentCare = "UrgentCare",
    PrimaryCare = "PrimaryCare",
    HomeCare = "HomeCare",
    MentalHealthCare = "MentalHealthCare",
    CovidCare = "CovidCare",
    ElderCare = "ElderCare",
    NurseCare = "NurseCare",
}

export class ConsultProviderSearchResultsSummary implements IConsultProviderSearchResultsSummary {
    providerCount?: number;
    clinicCount?: number;
    labsCount?: number;
    pharmaciesCount?: number;
    specialitiesCount?: number;
    organizationsCount?: number;
    runTime?: string;
    message?: string | undefined;
    providerSummaries?: ConsultProviderSearchProviderSummary[] | undefined;
    specialtySummaries?: ConsultProviderSearchProviderSummary[] | undefined;
    clinicSummaries?: ConsultProviderSearchStoreSummary[] | undefined;
    labSummaries?: ConsultProviderSearchStoreSummary[] | undefined;
    pharmacySummaries?: ConsultProviderSearchStoreSummary[] | undefined;
    organizationSummaries?: ConsultProviderSearchOrganizationSummary[] | undefined;

    constructor(data?: IConsultProviderSearchResultsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerCount = _data["providerCount"];
            this.clinicCount = _data["clinicCount"];
            this.labsCount = _data["labsCount"];
            this.pharmaciesCount = _data["pharmaciesCount"];
            this.specialitiesCount = _data["specialitiesCount"];
            this.organizationsCount = _data["organizationsCount"];
            this.runTime = _data["runTime"];
            this.message = _data["message"];
            if (Array.isArray(_data["providerSummaries"])) {
                this.providerSummaries = [] as any;
                for (let item of _data["providerSummaries"])
                    this.providerSummaries!.push(ConsultProviderSearchProviderSummary.fromJS(item));
            }
            if (Array.isArray(_data["specialtySummaries"])) {
                this.specialtySummaries = [] as any;
                for (let item of _data["specialtySummaries"])
                    this.specialtySummaries!.push(ConsultProviderSearchProviderSummary.fromJS(item));
            }
            if (Array.isArray(_data["clinicSummaries"])) {
                this.clinicSummaries = [] as any;
                for (let item of _data["clinicSummaries"])
                    this.clinicSummaries!.push(ConsultProviderSearchStoreSummary.fromJS(item));
            }
            if (Array.isArray(_data["labSummaries"])) {
                this.labSummaries = [] as any;
                for (let item of _data["labSummaries"])
                    this.labSummaries!.push(ConsultProviderSearchStoreSummary.fromJS(item));
            }
            if (Array.isArray(_data["pharmacySummaries"])) {
                this.pharmacySummaries = [] as any;
                for (let item of _data["pharmacySummaries"])
                    this.pharmacySummaries!.push(ConsultProviderSearchStoreSummary.fromJS(item));
            }
            if (Array.isArray(_data["organizationSummaries"])) {
                this.organizationSummaries = [] as any;
                for (let item of _data["organizationSummaries"])
                    this.organizationSummaries!.push(ConsultProviderSearchOrganizationSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsultProviderSearchResultsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchResultsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerCount"] = this.providerCount;
        data["clinicCount"] = this.clinicCount;
        data["labsCount"] = this.labsCount;
        data["pharmaciesCount"] = this.pharmaciesCount;
        data["specialitiesCount"] = this.specialitiesCount;
        data["organizationsCount"] = this.organizationsCount;
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        if (Array.isArray(this.providerSummaries)) {
            data["providerSummaries"] = [];
            for (let item of this.providerSummaries)
                data["providerSummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.specialtySummaries)) {
            data["specialtySummaries"] = [];
            for (let item of this.specialtySummaries)
                data["specialtySummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.clinicSummaries)) {
            data["clinicSummaries"] = [];
            for (let item of this.clinicSummaries)
                data["clinicSummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.labSummaries)) {
            data["labSummaries"] = [];
            for (let item of this.labSummaries)
                data["labSummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.pharmacySummaries)) {
            data["pharmacySummaries"] = [];
            for (let item of this.pharmacySummaries)
                data["pharmacySummaries"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationSummaries)) {
            data["organizationSummaries"] = [];
            for (let item of this.organizationSummaries)
                data["organizationSummaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConsultProviderSearchResultsSummary {
    providerCount?: number;
    clinicCount?: number;
    labsCount?: number;
    pharmaciesCount?: number;
    specialitiesCount?: number;
    organizationsCount?: number;
    runTime?: string;
    message?: string | undefined;
    providerSummaries?: ConsultProviderSearchProviderSummary[] | undefined;
    specialtySummaries?: ConsultProviderSearchProviderSummary[] | undefined;
    clinicSummaries?: ConsultProviderSearchStoreSummary[] | undefined;
    labSummaries?: ConsultProviderSearchStoreSummary[] | undefined;
    pharmacySummaries?: ConsultProviderSearchStoreSummary[] | undefined;
    organizationSummaries?: ConsultProviderSearchOrganizationSummary[] | undefined;
}

export class ConsultProviderSearchProviderSummary implements IConsultProviderSearchProviderSummary {
    providerID?: string;

    constructor(data?: IConsultProviderSearchProviderSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
        }
    }

    static fromJS(data: any): ConsultProviderSearchProviderSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchProviderSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        return data;
    }
}

export interface IConsultProviderSearchProviderSummary {
    providerID?: string;
}

export class ConsultProviderSearchStoreSummary implements IConsultProviderSearchStoreSummary {
    storeID?: string;

    constructor(data?: IConsultProviderSearchStoreSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeID = _data["storeID"];
        }
    }

    static fromJS(data: any): ConsultProviderSearchStoreSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchStoreSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeID"] = this.storeID;
        return data;
    }
}

export interface IConsultProviderSearchStoreSummary {
    storeID?: string;
}

export class ConsultProviderSearchOrganizationSummary implements IConsultProviderSearchOrganizationSummary {
    organizationID?: string;

    constructor(data?: IConsultProviderSearchOrganizationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): ConsultProviderSearchOrganizationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchOrganizationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IConsultProviderSearchOrganizationSummary {
    organizationID?: string;
}

export class PagedResultOfProvider implements IPagedResultOfProvider {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Provider[] | undefined;

    constructor(data?: IPagedResultOfProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Provider.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfProvider {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfProvider {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Provider[] | undefined;
}

export class WalkinProviderSearchDetails extends PagedQuery implements IWalkinProviderSearchDetails {
    countryID?: string;
    walkInTypeEnum?: WalkInTypeEnum;
    languageID?: string | undefined;
    genderEnum?: GenderEnum | undefined;

    constructor(data?: IWalkinProviderSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryID = _data["countryID"];
            this.walkInTypeEnum = _data["walkInTypeEnum"];
            this.languageID = _data["languageID"];
            this.genderEnum = _data["genderEnum"];
        }
    }

    static fromJS(data: any): WalkinProviderSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalkinProviderSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["walkInTypeEnum"] = this.walkInTypeEnum;
        data["languageID"] = this.languageID;
        data["genderEnum"] = this.genderEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IWalkinProviderSearchDetails extends IPagedQuery {
    countryID?: string;
    walkInTypeEnum?: WalkInTypeEnum;
    languageID?: string | undefined;
    genderEnum?: GenderEnum | undefined;
}

export class CancelConsultDTO implements ICancelConsultDTO {
    consultID?: string;
    cancelReason?: string | undefined;

    constructor(data?: ICancelConsultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultID = _data["consultID"];
            this.cancelReason = _data["cancelReason"];
        }
    }

    static fromJS(data: any): CancelConsultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CancelConsultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultID"] = this.consultID;
        data["cancelReason"] = this.cancelReason;
        return data;
    }
}

export interface ICancelConsultDTO {
    consultID?: string;
    cancelReason?: string | undefined;
}

export class ConsultStoreItemResult implements IConsultStoreItemResult {
    success?: boolean;
    message?: string | undefined;
    consultID?: string;

    constructor(data?: IConsultStoreItemResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.consultID = _data["consultID"];
        }
    }

    static fromJS(data: any): ConsultStoreItemResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultStoreItemResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["consultID"] = this.consultID;
        return data;
    }
}

export interface IConsultStoreItemResult {
    success?: boolean;
    message?: string | undefined;
    consultID?: string;
}

export class ConsultStoreItemDetails implements IConsultStoreItemDetails {
    inviteCodeID?: string;
    pin?: number;

    constructor(data?: IConsultStoreItemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviteCodeID = _data["inviteCodeID"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): ConsultStoreItemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultStoreItemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteCodeID"] = this.inviteCodeID;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IConsultStoreItemDetails {
    inviteCodeID?: string;
    pin?: number;
}

export class DemoConsultDetails implements IDemoConsultDetails {
    countryID?: string;
    currencyEnum?: CurrencyEnum;
    patientID?: string;
    storeItemID?: string;

    constructor(data?: IDemoConsultDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryID = _data["countryID"];
            this.currencyEnum = _data["currencyEnum"];
            this.patientID = _data["patientID"];
            this.storeItemID = _data["storeItemID"];
        }
    }

    static fromJS(data: any): DemoConsultDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DemoConsultDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["currencyEnum"] = this.currencyEnum;
        data["patientID"] = this.patientID;
        data["storeItemID"] = this.storeItemID;
        return data;
    }
}

export interface IDemoConsultDetails {
    countryID?: string;
    currencyEnum?: CurrencyEnum;
    patientID?: string;
    storeItemID?: string;
}

export class EmergencyConsultDetails implements IEmergencyConsultDetails {
    countryID?: string;
    storeAvailabilityTypeEnum?: StoreAvailabilityTypeEnum;
    storeID?: string;
    storeItemID?: string;
    consultProviderSearchStoreResult?: ConsultProviderSearchStoreResult | undefined;
    careTypeTags?: Tag[] | undefined;
    storeItemTypeEnum?: StoreItemTypeEnum;

    constructor(data?: IEmergencyConsultDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryID = _data["countryID"];
            this.storeAvailabilityTypeEnum = _data["storeAvailabilityTypeEnum"];
            this.storeID = _data["storeID"];
            this.storeItemID = _data["storeItemID"];
            this.consultProviderSearchStoreResult = _data["consultProviderSearchStoreResult"] ? ConsultProviderSearchStoreResult.fromJS(_data["consultProviderSearchStoreResult"]) : <any>undefined;
            if (Array.isArray(_data["careTypeTags"])) {
                this.careTypeTags = [] as any;
                for (let item of _data["careTypeTags"])
                    this.careTypeTags!.push(Tag.fromJS(item));
            }
            this.storeItemTypeEnum = _data["storeItemTypeEnum"];
        }
    }

    static fromJS(data: any): EmergencyConsultDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyConsultDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["storeAvailabilityTypeEnum"] = this.storeAvailabilityTypeEnum;
        data["storeID"] = this.storeID;
        data["storeItemID"] = this.storeItemID;
        data["consultProviderSearchStoreResult"] = this.consultProviderSearchStoreResult ? this.consultProviderSearchStoreResult.toJSON() : <any>undefined;
        if (Array.isArray(this.careTypeTags)) {
            data["careTypeTags"] = [];
            for (let item of this.careTypeTags)
                data["careTypeTags"].push(item.toJSON());
        }
        data["storeItemTypeEnum"] = this.storeItemTypeEnum;
        return data;
    }
}

export interface IEmergencyConsultDetails {
    countryID?: string;
    storeAvailabilityTypeEnum?: StoreAvailabilityTypeEnum;
    storeID?: string;
    storeItemID?: string;
    consultProviderSearchStoreResult?: ConsultProviderSearchStoreResult | undefined;
    careTypeTags?: Tag[] | undefined;
    storeItemTypeEnum?: StoreItemTypeEnum;
}

export class ConsultProviderSearchStoreResult implements IConsultProviderSearchStoreResult {
    storeID?: string;
    storeTypeEnum?: StoreTypeEnum;
    imageDetailID?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    cityTown?: CityTown | undefined;
    country?: Country | undefined;
    provinceState?: ProvinceState | undefined;
    postCode?: string | undefined;
    organizationID?: string | undefined;
    organizationName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    faxPhoneNumber?: string | undefined;
    fullAddress?: string | undefined;
    storeItemTags?: Tag[] | undefined;
    displaySortOrder?: number | undefined;
    supportsStoreItemTypes?: StoreItemTypeEnum[] | undefined;
    publicTag?: string | undefined;
    storeImages?: StoreImage[] | undefined;
    rating?: number;
    ratingCount?: number;
    latitude?: number | undefined;
    longitude?: number | undefined;
    distance?: number | undefined;

    constructor(data?: IConsultProviderSearchStoreResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeID = _data["storeID"];
            this.storeTypeEnum = _data["storeTypeEnum"];
            this.imageDetailID = _data["imageDetailID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.cityTown = _data["cityTown"] ? CityTown.fromJS(_data["cityTown"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            this.postCode = _data["postCode"];
            this.organizationID = _data["organizationID"];
            this.organizationName = _data["organizationName"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.faxPhoneNumber = _data["faxPhoneNumber"];
            this.fullAddress = _data["fullAddress"];
            if (Array.isArray(_data["storeItemTags"])) {
                this.storeItemTags = [] as any;
                for (let item of _data["storeItemTags"])
                    this.storeItemTags!.push(Tag.fromJS(item));
            }
            this.displaySortOrder = _data["displaySortOrder"];
            if (Array.isArray(_data["supportsStoreItemTypes"])) {
                this.supportsStoreItemTypes = [] as any;
                for (let item of _data["supportsStoreItemTypes"])
                    this.supportsStoreItemTypes!.push(item);
            }
            this.publicTag = _data["publicTag"];
            if (Array.isArray(_data["storeImages"])) {
                this.storeImages = [] as any;
                for (let item of _data["storeImages"])
                    this.storeImages!.push(StoreImage.fromJS(item));
            }
            this.rating = _data["rating"];
            this.ratingCount = _data["ratingCount"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.distance = _data["distance"];
        }
    }

    static fromJS(data: any): ConsultProviderSearchStoreResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchStoreResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeID"] = this.storeID;
        data["storeTypeEnum"] = this.storeTypeEnum;
        data["imageDetailID"] = this.imageDetailID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["cityTown"] = this.cityTown ? this.cityTown.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        data["postCode"] = this.postCode;
        data["organizationID"] = this.organizationID;
        data["organizationName"] = this.organizationName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["faxPhoneNumber"] = this.faxPhoneNumber;
        data["fullAddress"] = this.fullAddress;
        if (Array.isArray(this.storeItemTags)) {
            data["storeItemTags"] = [];
            for (let item of this.storeItemTags)
                data["storeItemTags"].push(item.toJSON());
        }
        data["displaySortOrder"] = this.displaySortOrder;
        if (Array.isArray(this.supportsStoreItemTypes)) {
            data["supportsStoreItemTypes"] = [];
            for (let item of this.supportsStoreItemTypes)
                data["supportsStoreItemTypes"].push(item);
        }
        data["publicTag"] = this.publicTag;
        if (Array.isArray(this.storeImages)) {
            data["storeImages"] = [];
            for (let item of this.storeImages)
                data["storeImages"].push(item.toJSON());
        }
        data["rating"] = this.rating;
        data["ratingCount"] = this.ratingCount;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["distance"] = this.distance;
        return data;
    }
}

export interface IConsultProviderSearchStoreResult {
    storeID?: string;
    storeTypeEnum?: StoreTypeEnum;
    imageDetailID?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    cityTown?: CityTown | undefined;
    country?: Country | undefined;
    provinceState?: ProvinceState | undefined;
    postCode?: string | undefined;
    organizationID?: string | undefined;
    organizationName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    faxPhoneNumber?: string | undefined;
    fullAddress?: string | undefined;
    storeItemTags?: Tag[] | undefined;
    displaySortOrder?: number | undefined;
    supportsStoreItemTypes?: StoreItemTypeEnum[] | undefined;
    publicTag?: string | undefined;
    storeImages?: StoreImage[] | undefined;
    rating?: number;
    ratingCount?: number;
    latitude?: number | undefined;
    longitude?: number | undefined;
    distance?: number | undefined;
}

export class SubscriptionConsultDetail implements ISubscriptionConsultDetail {
    subscriptionID?: string;
    subscriptionShortName?: string | undefined;
    welcomeTitle?: string | undefined;
    welcomeImageURL?: string | undefined;
    welcomeMessage?: string | undefined;
    countryID?: string;
    details?: SubscriptionConsultStoreDetail[] | undefined;
    onBoarded?: boolean;

    constructor(data?: ISubscriptionConsultDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionID = _data["subscriptionID"];
            this.subscriptionShortName = _data["subscriptionShortName"];
            this.welcomeTitle = _data["welcomeTitle"];
            this.welcomeImageURL = _data["welcomeImageURL"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.countryID = _data["countryID"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(SubscriptionConsultStoreDetail.fromJS(item));
            }
            this.onBoarded = _data["onBoarded"];
        }
    }

    static fromJS(data: any): SubscriptionConsultDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionConsultDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionID"] = this.subscriptionID;
        data["subscriptionShortName"] = this.subscriptionShortName;
        data["welcomeTitle"] = this.welcomeTitle;
        data["welcomeImageURL"] = this.welcomeImageURL;
        data["welcomeMessage"] = this.welcomeMessage;
        data["countryID"] = this.countryID;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["onBoarded"] = this.onBoarded;
        return data;
    }
}

export interface ISubscriptionConsultDetail {
    subscriptionID?: string;
    subscriptionShortName?: string | undefined;
    welcomeTitle?: string | undefined;
    welcomeImageURL?: string | undefined;
    welcomeMessage?: string | undefined;
    countryID?: string;
    details?: SubscriptionConsultStoreDetail[] | undefined;
    onBoarded?: boolean;
}

export class SubscriptionConsultStoreDetail implements ISubscriptionConsultStoreDetail {
    storeAvailabilityTypeEnum?: StoreAvailabilityTypeEnum;
    consultProviderSearchStoreResult?: ConsultProviderSearchStoreResult | undefined;

    constructor(data?: ISubscriptionConsultStoreDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeAvailabilityTypeEnum = _data["storeAvailabilityTypeEnum"];
            this.consultProviderSearchStoreResult = _data["consultProviderSearchStoreResult"] ? ConsultProviderSearchStoreResult.fromJS(_data["consultProviderSearchStoreResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionConsultStoreDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionConsultStoreDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeAvailabilityTypeEnum"] = this.storeAvailabilityTypeEnum;
        data["consultProviderSearchStoreResult"] = this.consultProviderSearchStoreResult ? this.consultProviderSearchStoreResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubscriptionConsultStoreDetail {
    storeAvailabilityTypeEnum?: StoreAvailabilityTypeEnum;
    consultProviderSearchStoreResult?: ConsultProviderSearchStoreResult | undefined;
}

export class SendToMyEMRDetails implements ISendToMyEMRDetails {
    providerID!: string;
    patientID!: string;
    phrConsultID!: string;

    constructor(data?: ISendToMyEMRDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.patientID = _data["patientID"];
            this.phrConsultID = _data["phrConsultID"];
        }
    }

    static fromJS(data: any): SendToMyEMRDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SendToMyEMRDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["patientID"] = this.patientID;
        data["phrConsultID"] = this.phrConsultID;
        return data;
    }
}

export interface ISendToMyEMRDetails {
    providerID: string;
    patientID: string;
    phrConsultID: string;
}

export class ConsultSearchDetails implements IConsultSearchDetails {
    startDate?: Date;
    endDate?: Date;
    providerID?: string | undefined;
    patientID?: string | undefined;

    constructor(data?: IConsultSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.providerID = _data["providerID"];
            this.patientID = _data["patientID"];
        }
    }

    static fromJS(data: any): ConsultSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["providerID"] = this.providerID;
        data["patientID"] = this.patientID;
        return data;
    }
}

export interface IConsultSearchDetails {
    startDate?: Date;
    endDate?: Date;
    providerID?: string | undefined;
    patientID?: string | undefined;
}

export class BookProviderAppointmentResults implements IBookProviderAppointmentResults {
    success?: boolean;
    bookedDate?: Date;
    providerAppointmentID?: string;

    constructor(data?: IBookProviderAppointmentResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.bookedDate = _data["bookedDate"] ? new Date(_data["bookedDate"].toString()) : <any>undefined;
            this.providerAppointmentID = _data["providerAppointmentID"];
        }
    }

    static fromJS(data: any): BookProviderAppointmentResults {
        data = typeof data === 'object' ? data : {};
        let result = new BookProviderAppointmentResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["bookedDate"] = this.bookedDate ? this.bookedDate.toISOString() : <any>undefined;
        data["providerAppointmentID"] = this.providerAppointmentID;
        return data;
    }
}

export interface IBookProviderAppointmentResults {
    success?: boolean;
    bookedDate?: Date;
    providerAppointmentID?: string;
}

export class TransactionStatusDTO implements ITransactionStatusDTO {
    isSuccess?: boolean;
    isCompleted?: boolean;
    message?: string | undefined;

    constructor(data?: ITransactionStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.isCompleted = _data["isCompleted"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TransactionStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["isCompleted"] = this.isCompleted;
        data["message"] = this.message;
        return data;
    }
}

export interface ITransactionStatusDTO {
    isSuccess?: boolean;
    isCompleted?: boolean;
    message?: string | undefined;
}

export class PatientDashboardDTO implements IPatientDashboardDTO {
    healthRecordPercentComplete?: number;
    upcomingAppointments?: UpcomingAppointmentDTO[] | undefined;
    healthAlerts?: HealthAlertDTO | undefined;
    myWallet?: MyWalletDTO | undefined;
    mySavingsWallet?: MyWalletDTO | undefined;
    phrVitals?: PHRVitalsDTO | undefined;
    userDetailRelationships?: UserDetailRelationshipDTO[] | undefined;

    constructor(data?: IPatientDashboardDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRecordPercentComplete = _data["healthRecordPercentComplete"];
            if (Array.isArray(_data["upcomingAppointments"])) {
                this.upcomingAppointments = [] as any;
                for (let item of _data["upcomingAppointments"])
                    this.upcomingAppointments!.push(UpcomingAppointmentDTO.fromJS(item));
            }
            this.healthAlerts = _data["healthAlerts"] ? HealthAlertDTO.fromJS(_data["healthAlerts"]) : <any>undefined;
            this.myWallet = _data["myWallet"] ? MyWalletDTO.fromJS(_data["myWallet"]) : <any>undefined;
            this.mySavingsWallet = _data["mySavingsWallet"] ? MyWalletDTO.fromJS(_data["mySavingsWallet"]) : <any>undefined;
            this.phrVitals = _data["phrVitals"] ? PHRVitalsDTO.fromJS(_data["phrVitals"]) : <any>undefined;
            if (Array.isArray(_data["userDetailRelationships"])) {
                this.userDetailRelationships = [] as any;
                for (let item of _data["userDetailRelationships"])
                    this.userDetailRelationships!.push(UserDetailRelationshipDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientDashboardDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDashboardDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRecordPercentComplete"] = this.healthRecordPercentComplete;
        if (Array.isArray(this.upcomingAppointments)) {
            data["upcomingAppointments"] = [];
            for (let item of this.upcomingAppointments)
                data["upcomingAppointments"].push(item.toJSON());
        }
        data["healthAlerts"] = this.healthAlerts ? this.healthAlerts.toJSON() : <any>undefined;
        data["myWallet"] = this.myWallet ? this.myWallet.toJSON() : <any>undefined;
        data["mySavingsWallet"] = this.mySavingsWallet ? this.mySavingsWallet.toJSON() : <any>undefined;
        data["phrVitals"] = this.phrVitals ? this.phrVitals.toJSON() : <any>undefined;
        if (Array.isArray(this.userDetailRelationships)) {
            data["userDetailRelationships"] = [];
            for (let item of this.userDetailRelationships)
                data["userDetailRelationships"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientDashboardDTO {
    healthRecordPercentComplete?: number;
    upcomingAppointments?: UpcomingAppointmentDTO[] | undefined;
    healthAlerts?: HealthAlertDTO | undefined;
    myWallet?: MyWalletDTO | undefined;
    mySavingsWallet?: MyWalletDTO | undefined;
    phrVitals?: PHRVitalsDTO | undefined;
    userDetailRelationships?: UserDetailRelationshipDTO[] | undefined;
}

export class UpcomingAppointmentDTO implements IUpcomingAppointmentDTO {
    providerAppointmentID?: string;
    consultID?: string | undefined;
    providerID?: string;
    providerImageDetailID?: string | undefined;
    providerFullName?: string | undefined;
    storeName?: string | undefined;
    storeAddress?: string | undefined;
    appointmentDate?: Date;
    consultTypeEnum?: ConsultTypeEnum;
    patientFullName?: string | undefined;

    constructor(data?: IUpcomingAppointmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerAppointmentID = _data["providerAppointmentID"];
            this.consultID = _data["consultID"];
            this.providerID = _data["providerID"];
            this.providerImageDetailID = _data["providerImageDetailID"];
            this.providerFullName = _data["providerFullName"];
            this.storeName = _data["storeName"];
            this.storeAddress = _data["storeAddress"];
            this.appointmentDate = _data["appointmentDate"] ? new Date(_data["appointmentDate"].toString()) : <any>undefined;
            this.consultTypeEnum = _data["consultTypeEnum"];
            this.patientFullName = _data["patientFullName"];
        }
    }

    static fromJS(data: any): UpcomingAppointmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingAppointmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerAppointmentID"] = this.providerAppointmentID;
        data["consultID"] = this.consultID;
        data["providerID"] = this.providerID;
        data["providerImageDetailID"] = this.providerImageDetailID;
        data["providerFullName"] = this.providerFullName;
        data["storeName"] = this.storeName;
        data["storeAddress"] = this.storeAddress;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["consultTypeEnum"] = this.consultTypeEnum;
        data["patientFullName"] = this.patientFullName;
        return data;
    }
}

export interface IUpcomingAppointmentDTO {
    providerAppointmentID?: string;
    consultID?: string | undefined;
    providerID?: string;
    providerImageDetailID?: string | undefined;
    providerFullName?: string | undefined;
    storeName?: string | undefined;
    storeAddress?: string | undefined;
    appointmentDate?: Date;
    consultTypeEnum?: ConsultTypeEnum;
    patientFullName?: string | undefined;
}

export class HealthAlertDTO implements IHealthAlertDTO {
    mailUnreadCount?: number;
    clinicalCartItemCount?: number;
    patientInstructionCount?: number;
    myGoalsCount?: number;
    medicationReminderCount?: number;

    constructor(data?: IHealthAlertDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailUnreadCount = _data["mailUnreadCount"];
            this.clinicalCartItemCount = _data["clinicalCartItemCount"];
            this.patientInstructionCount = _data["patientInstructionCount"];
            this.myGoalsCount = _data["myGoalsCount"];
            this.medicationReminderCount = _data["medicationReminderCount"];
        }
    }

    static fromJS(data: any): HealthAlertDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HealthAlertDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailUnreadCount"] = this.mailUnreadCount;
        data["clinicalCartItemCount"] = this.clinicalCartItemCount;
        data["patientInstructionCount"] = this.patientInstructionCount;
        data["myGoalsCount"] = this.myGoalsCount;
        data["medicationReminderCount"] = this.medicationReminderCount;
        return data;
    }
}

export interface IHealthAlertDTO {
    mailUnreadCount?: number;
    clinicalCartItemCount?: number;
    patientInstructionCount?: number;
    myGoalsCount?: number;
    medicationReminderCount?: number;
}

export class MyWalletDTO implements IMyWalletDTO {
    currencyEnum?: CurrencyEnum;
    amount?: number;

    constructor(data?: IMyWalletDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyEnum = _data["currencyEnum"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MyWalletDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MyWalletDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyEnum"] = this.currencyEnum;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IMyWalletDTO {
    currencyEnum?: CurrencyEnum;
    amount?: number;
}

export class PHRVitalsDTO implements IPHRVitalsDTO {
    bloodGlucose?: PHRTrackerBloodGlucoseDTO | undefined;
    bloodOxygen?: PHRTrackerBloodOxygenDTO | undefined;
    pulse?: PHRTrackerPulseDTO | undefined;
    bloodPressure?: PHRTrackerBloodPressureDTO | undefined;
    temperature?: PHRTrackerTemperatureDTO | undefined;
    respiratory?: PHRTrackerRespiratoryDTO | undefined;
    headCircumference?: PHRTrackerHeadCircumferenceDTO | undefined;
    weightHeight?: PHRTrackerWeightHeightDTO | undefined;
    length?: PHRTrackerLengthDTO | undefined;

    constructor(data?: IPHRVitalsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bloodGlucose = _data["bloodGlucose"] ? PHRTrackerBloodGlucoseDTO.fromJS(_data["bloodGlucose"]) : <any>undefined;
            this.bloodOxygen = _data["bloodOxygen"] ? PHRTrackerBloodOxygenDTO.fromJS(_data["bloodOxygen"]) : <any>undefined;
            this.pulse = _data["pulse"] ? PHRTrackerPulseDTO.fromJS(_data["pulse"]) : <any>undefined;
            this.bloodPressure = _data["bloodPressure"] ? PHRTrackerBloodPressureDTO.fromJS(_data["bloodPressure"]) : <any>undefined;
            this.temperature = _data["temperature"] ? PHRTrackerTemperatureDTO.fromJS(_data["temperature"]) : <any>undefined;
            this.respiratory = _data["respiratory"] ? PHRTrackerRespiratoryDTO.fromJS(_data["respiratory"]) : <any>undefined;
            this.headCircumference = _data["headCircumference"] ? PHRTrackerHeadCircumferenceDTO.fromJS(_data["headCircumference"]) : <any>undefined;
            this.weightHeight = _data["weightHeight"] ? PHRTrackerWeightHeightDTO.fromJS(_data["weightHeight"]) : <any>undefined;
            this.length = _data["length"] ? PHRTrackerLengthDTO.fromJS(_data["length"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PHRVitalsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRVitalsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bloodGlucose"] = this.bloodGlucose ? this.bloodGlucose.toJSON() : <any>undefined;
        data["bloodOxygen"] = this.bloodOxygen ? this.bloodOxygen.toJSON() : <any>undefined;
        data["pulse"] = this.pulse ? this.pulse.toJSON() : <any>undefined;
        data["bloodPressure"] = this.bloodPressure ? this.bloodPressure.toJSON() : <any>undefined;
        data["temperature"] = this.temperature ? this.temperature.toJSON() : <any>undefined;
        data["respiratory"] = this.respiratory ? this.respiratory.toJSON() : <any>undefined;
        data["headCircumference"] = this.headCircumference ? this.headCircumference.toJSON() : <any>undefined;
        data["weightHeight"] = this.weightHeight ? this.weightHeight.toJSON() : <any>undefined;
        data["length"] = this.length ? this.length.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPHRVitalsDTO {
    bloodGlucose?: PHRTrackerBloodGlucoseDTO | undefined;
    bloodOxygen?: PHRTrackerBloodOxygenDTO | undefined;
    pulse?: PHRTrackerPulseDTO | undefined;
    bloodPressure?: PHRTrackerBloodPressureDTO | undefined;
    temperature?: PHRTrackerTemperatureDTO | undefined;
    respiratory?: PHRTrackerRespiratoryDTO | undefined;
    headCircumference?: PHRTrackerHeadCircumferenceDTO | undefined;
    weightHeight?: PHRTrackerWeightHeightDTO | undefined;
    length?: PHRTrackerLengthDTO | undefined;
}

export abstract class PHRTrackerBase implements IPHRTrackerBase {
    patientID?: string;
    phrTrackerDetailID?: string;
    trackerDate?: Date;
    trackerSourceEnum?: TrackerSourceEnum;
    createdDate?: Date;
    createdBy?: string;
    tags?: Tag[] | undefined;
    updatedDate?: Date | undefined;
    updatedBy?: string | undefined;
    createdByName?: string | undefined;
    updatedByName?: string | undefined;
    notes?: string | undefined;
    upsertDate?: Date;
    verifiedByUserDetail?: UserDetail | undefined;
    verifiedByProviderName?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrConsultID?: string | undefined;

    constructor(data?: IPHRTrackerBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            this.phrTrackerDetailID = _data["phrTrackerDetailID"];
            this.trackerDate = _data["trackerDate"] ? new Date(_data["trackerDate"].toString()) : <any>undefined;
            this.trackerSourceEnum = _data["trackerSourceEnum"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.createdByName = _data["createdByName"];
            this.updatedByName = _data["updatedByName"];
            this.notes = _data["notes"];
            this.upsertDate = _data["upsertDate"] ? new Date(_data["upsertDate"].toString()) : <any>undefined;
            this.verifiedByUserDetail = _data["verifiedByUserDetail"] ? UserDetail.fromJS(_data["verifiedByUserDetail"]) : <any>undefined;
            this.verifiedByProviderName = _data["verifiedByProviderName"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
            this.phrAccessRequested = _data["phrAccessRequested"];
            this.phrConsultID = _data["phrConsultID"];
        }
    }

    static fromJS(data: any): PHRTrackerBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PHRTrackerBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["phrTrackerDetailID"] = this.phrTrackerDetailID;
        data["trackerDate"] = this.trackerDate ? this.trackerDate.toISOString() : <any>undefined;
        data["trackerSourceEnum"] = this.trackerSourceEnum;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["createdByName"] = this.createdByName;
        data["updatedByName"] = this.updatedByName;
        data["notes"] = this.notes;
        data["upsertDate"] = this.upsertDate ? this.upsertDate.toISOString() : <any>undefined;
        data["verifiedByUserDetail"] = this.verifiedByUserDetail ? this.verifiedByUserDetail.toJSON() : <any>undefined;
        data["verifiedByProviderName"] = this.verifiedByProviderName;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        data["phrAccessRequested"] = this.phrAccessRequested;
        data["phrConsultID"] = this.phrConsultID;
        return data;
    }
}

export interface IPHRTrackerBase {
    patientID?: string;
    phrTrackerDetailID?: string;
    trackerDate?: Date;
    trackerSourceEnum?: TrackerSourceEnum;
    createdDate?: Date;
    createdBy?: string;
    tags?: Tag[] | undefined;
    updatedDate?: Date | undefined;
    updatedBy?: string | undefined;
    createdByName?: string | undefined;
    updatedByName?: string | undefined;
    notes?: string | undefined;
    upsertDate?: Date;
    verifiedByUserDetail?: UserDetail | undefined;
    verifiedByProviderName?: string | undefined;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
    phrAccessRequested?: PatientAccessEnum;
    phrConsultID?: string | undefined;
}

export class PHRTrackerBloodGlucoseDTO extends PHRTrackerBase implements IPHRTrackerBloodGlucoseDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    bloodGlucose?: number;

    constructor(data?: IPHRTrackerBloodGlucoseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.bloodGlucose = _data["bloodGlucose"];
        }
    }

    static fromJS(data: any): PHRTrackerBloodGlucoseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerBloodGlucoseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["bloodGlucose"] = this.bloodGlucose;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerBloodGlucoseDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    bloodGlucose?: number;
}

export class PHRTrackerBloodOxygenDTO extends PHRTrackerBase implements IPHRTrackerBloodOxygenDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    bloodOxygen?: number;

    constructor(data?: IPHRTrackerBloodOxygenDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.bloodOxygen = _data["bloodOxygen"];
        }
    }

    static fromJS(data: any): PHRTrackerBloodOxygenDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerBloodOxygenDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["bloodOxygen"] = this.bloodOxygen;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerBloodOxygenDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    bloodOxygen?: number;
}

export class PHRTrackerPulseDTO extends PHRTrackerBase implements IPHRTrackerPulseDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    pulse?: number;

    constructor(data?: IPHRTrackerPulseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.pulse = _data["pulse"];
        }
    }

    static fromJS(data: any): PHRTrackerPulseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerPulseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["pulse"] = this.pulse;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerPulseDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    pulse?: number;
}

export class PHRTrackerBloodPressureDTO extends PHRTrackerBase implements IPHRTrackerBloodPressureDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    systolic?: number;
    diastolic?: number;
    pulse?: number;

    constructor(data?: IPHRTrackerBloodPressureDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.systolic = _data["systolic"];
            this.diastolic = _data["diastolic"];
            this.pulse = _data["pulse"];
        }
    }

    static fromJS(data: any): PHRTrackerBloodPressureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerBloodPressureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["systolic"] = this.systolic;
        data["diastolic"] = this.diastolic;
        data["pulse"] = this.pulse;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerBloodPressureDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    systolic?: number;
    diastolic?: number;
    pulse?: number;
}

export class PHRTrackerTemperatureDTO extends PHRTrackerBase implements IPHRTrackerTemperatureDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    temperature?: number;

    constructor(data?: IPHRTrackerTemperatureDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.temperature = _data["temperature"];
        }
    }

    static fromJS(data: any): PHRTrackerTemperatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerTemperatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["temperature"] = this.temperature;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerTemperatureDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    temperature?: number;
}

export class PHRTrackerRespiratoryDTO extends PHRTrackerBase implements IPHRTrackerRespiratoryDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    respiratory?: number;

    constructor(data?: IPHRTrackerRespiratoryDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.respiratory = _data["respiratory"];
        }
    }

    static fromJS(data: any): PHRTrackerRespiratoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerRespiratoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["respiratory"] = this.respiratory;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerRespiratoryDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    respiratory?: number;
}

export class PHRTrackerHeadCircumferenceDTO extends PHRTrackerBase implements IPHRTrackerHeadCircumferenceDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    headCircumference?: number;

    constructor(data?: IPHRTrackerHeadCircumferenceDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.headCircumference = _data["headCircumference"];
        }
    }

    static fromJS(data: any): PHRTrackerHeadCircumferenceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerHeadCircumferenceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["headCircumference"] = this.headCircumference;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerHeadCircumferenceDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    headCircumference?: number;
}

export class PHRTrackerWeightHeightDTO extends PHRTrackerBase implements IPHRTrackerWeightHeightDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    weight?: number | undefined;
    height?: number | undefined;

    constructor(data?: IPHRTrackerWeightHeightDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.weight = _data["weight"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): PHRTrackerWeightHeightDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerWeightHeightDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["weight"] = this.weight;
        data["height"] = this.height;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerWeightHeightDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    weight?: number | undefined;
    height?: number | undefined;
}

export class PHRTrackerLengthDTO extends PHRTrackerBase implements IPHRTrackerLengthDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    length?: number;

    constructor(data?: IPHRTrackerLengthDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.length = _data["length"];
        }
    }

    static fromJS(data: any): PHRTrackerLengthDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerLengthDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["length"] = this.length;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerLengthDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    length?: number;
}

export class UserDetailRelationshipDTO implements IUserDetailRelationshipDTO {
    userDetailRelationshipID?: string;
    fromName?: string | undefined;
    createdDate?: Date;
    message?: string | undefined;
    healthRecords?: boolean;

    constructor(data?: IUserDetailRelationshipDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailRelationshipID = _data["userDetailRelationshipID"];
            this.fromName = _data["fromName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.healthRecords = _data["healthRecords"];
        }
    }

    static fromJS(data: any): UserDetailRelationshipDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailRelationshipDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailRelationshipID"] = this.userDetailRelationshipID;
        data["fromName"] = this.fromName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["healthRecords"] = this.healthRecords;
        return data;
    }
}

export interface IUserDetailRelationshipDTO {
    userDetailRelationshipID?: string;
    fromName?: string | undefined;
    createdDate?: Date;
    message?: string | undefined;
    healthRecords?: boolean;
}

export class DiscussionBlockedDetail extends EntityBase implements IDiscussionBlockedDetail {
    userDetail?: UserDetail | undefined;
    discussionBlockedDetailID!: string;
    discussionID!: string;
    userDetailID!: string;
    enabled?: boolean;
    reason?: string | undefined;
    blockCounts?: number;
    data?: string | undefined;

    constructor(data?: IDiscussionBlockedDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.discussionBlockedDetailID = _data["discussionBlockedDetailID"];
            this.discussionID = _data["discussionID"];
            this.userDetailID = _data["userDetailID"];
            this.enabled = _data["enabled"];
            this.reason = _data["reason"];
            this.blockCounts = _data["blockCounts"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DiscussionBlockedDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionBlockedDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["discussionBlockedDetailID"] = this.discussionBlockedDetailID;
        data["discussionID"] = this.discussionID;
        data["userDetailID"] = this.userDetailID;
        data["enabled"] = this.enabled;
        data["reason"] = this.reason;
        data["blockCounts"] = this.blockCounts;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionBlockedDetail extends IEntityBase {
    userDetail?: UserDetail | undefined;
    discussionBlockedDetailID: string;
    discussionID: string;
    userDetailID: string;
    enabled?: boolean;
    reason?: string | undefined;
    blockCounts?: number;
    data?: string | undefined;
}

export class DiscussionCategory extends EntityBase implements IDiscussionCategory {
    discussions?: Discussion[] | undefined;
    discussionCategoryID!: string;
    name!: string;
    description!: string;
    enabled!: boolean;
    moderatorUserDetailID?: string | undefined;
    discussionCount!: number;
    pinned!: boolean;
    color?: string | undefined;
    data?: string | undefined;

    constructor(data?: IDiscussionCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["discussions"])) {
                this.discussions = [] as any;
                for (let item of _data["discussions"])
                    this.discussions!.push(Discussion.fromJS(item));
            }
            this.discussionCategoryID = _data["discussionCategoryID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.moderatorUserDetailID = _data["moderatorUserDetailID"];
            this.discussionCount = _data["discussionCount"];
            this.pinned = _data["pinned"];
            this.color = _data["color"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DiscussionCategory {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discussions)) {
            data["discussions"] = [];
            for (let item of this.discussions)
                data["discussions"].push(item.toJSON());
        }
        data["discussionCategoryID"] = this.discussionCategoryID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["moderatorUserDetailID"] = this.moderatorUserDetailID;
        data["discussionCount"] = this.discussionCount;
        data["pinned"] = this.pinned;
        data["color"] = this.color;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionCategory extends IEntityBase {
    discussions?: Discussion[] | undefined;
    discussionCategoryID: string;
    name: string;
    description: string;
    enabled: boolean;
    moderatorUserDetailID?: string | undefined;
    discussionCount: number;
    pinned: boolean;
    color?: string | undefined;
    data?: string | undefined;
}

export class Discussion extends EntityBase implements IDiscussion {
    discussionItems?: DiscussionItem[] | undefined;
    discussionRoles?: DiscussionRole[] | undefined;
    discussionFollowers?: DiscussionFollower[] | undefined;
    discussionUserDetails?: DiscussionUserDetail[] | undefined;
    discussionBlockedDetails?: DiscussionBlockedDetail[] | undefined;
    newDiscussionItemCount?: number;
    newDiscussionItemReplyCount?: number;
    isPrivate?: boolean;
    isFollowing?: boolean | undefined;
    tags?: string[] | undefined;
    followersCount?: number | undefined;
    discussionID!: string;
    name!: string;
    description!: string;
    enabled!: boolean;
    moderatorUserDetailID?: string | undefined;
    postCount!: number;
    color?: string | undefined;
    discussionCategoryID!: string;

    constructor(data?: IDiscussion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["discussionItems"])) {
                this.discussionItems = [] as any;
                for (let item of _data["discussionItems"])
                    this.discussionItems!.push(DiscussionItem.fromJS(item));
            }
            if (Array.isArray(_data["discussionRoles"])) {
                this.discussionRoles = [] as any;
                for (let item of _data["discussionRoles"])
                    this.discussionRoles!.push(DiscussionRole.fromJS(item));
            }
            if (Array.isArray(_data["discussionFollowers"])) {
                this.discussionFollowers = [] as any;
                for (let item of _data["discussionFollowers"])
                    this.discussionFollowers!.push(DiscussionFollower.fromJS(item));
            }
            if (Array.isArray(_data["discussionUserDetails"])) {
                this.discussionUserDetails = [] as any;
                for (let item of _data["discussionUserDetails"])
                    this.discussionUserDetails!.push(DiscussionUserDetail.fromJS(item));
            }
            if (Array.isArray(_data["discussionBlockedDetails"])) {
                this.discussionBlockedDetails = [] as any;
                for (let item of _data["discussionBlockedDetails"])
                    this.discussionBlockedDetails!.push(DiscussionBlockedDetail.fromJS(item));
            }
            this.newDiscussionItemCount = _data["newDiscussionItemCount"];
            this.newDiscussionItemReplyCount = _data["newDiscussionItemReplyCount"];
            this.isPrivate = _data["isPrivate"];
            this.isFollowing = _data["isFollowing"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.followersCount = _data["followersCount"];
            this.discussionID = _data["discussionID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.moderatorUserDetailID = _data["moderatorUserDetailID"];
            this.postCount = _data["postCount"];
            this.color = _data["color"];
            this.discussionCategoryID = _data["discussionCategoryID"];
        }
    }

    static fromJS(data: any): Discussion {
        data = typeof data === 'object' ? data : {};
        let result = new Discussion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discussionItems)) {
            data["discussionItems"] = [];
            for (let item of this.discussionItems)
                data["discussionItems"].push(item.toJSON());
        }
        if (Array.isArray(this.discussionRoles)) {
            data["discussionRoles"] = [];
            for (let item of this.discussionRoles)
                data["discussionRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.discussionFollowers)) {
            data["discussionFollowers"] = [];
            for (let item of this.discussionFollowers)
                data["discussionFollowers"].push(item.toJSON());
        }
        if (Array.isArray(this.discussionUserDetails)) {
            data["discussionUserDetails"] = [];
            for (let item of this.discussionUserDetails)
                data["discussionUserDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.discussionBlockedDetails)) {
            data["discussionBlockedDetails"] = [];
            for (let item of this.discussionBlockedDetails)
                data["discussionBlockedDetails"].push(item.toJSON());
        }
        data["newDiscussionItemCount"] = this.newDiscussionItemCount;
        data["newDiscussionItemReplyCount"] = this.newDiscussionItemReplyCount;
        data["isPrivate"] = this.isPrivate;
        data["isFollowing"] = this.isFollowing;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["followersCount"] = this.followersCount;
        data["discussionID"] = this.discussionID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["moderatorUserDetailID"] = this.moderatorUserDetailID;
        data["postCount"] = this.postCount;
        data["color"] = this.color;
        data["discussionCategoryID"] = this.discussionCategoryID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussion extends IEntityBase {
    discussionItems?: DiscussionItem[] | undefined;
    discussionRoles?: DiscussionRole[] | undefined;
    discussionFollowers?: DiscussionFollower[] | undefined;
    discussionUserDetails?: DiscussionUserDetail[] | undefined;
    discussionBlockedDetails?: DiscussionBlockedDetail[] | undefined;
    newDiscussionItemCount?: number;
    newDiscussionItemReplyCount?: number;
    isPrivate?: boolean;
    isFollowing?: boolean | undefined;
    tags?: string[] | undefined;
    followersCount?: number | undefined;
    discussionID: string;
    name: string;
    description: string;
    enabled: boolean;
    moderatorUserDetailID?: string | undefined;
    postCount: number;
    color?: string | undefined;
    discussionCategoryID: string;
}

export class DiscussionItem extends EntityBase implements IDiscussionItem {
    discussionItemTags?: DiscussionItemTag[] | undefined;
    discussionItemFollowers?: DiscussionItemFollower[] | undefined;
    discussionItemLikes?: DiscussionItemLike[] | undefined;
    discussionItemBlockedDetails?: DiscussionItemBlockedDetail[] | undefined;
    discussion?: Discussion | undefined;
    discussionsImageDetail?: ImageDetail | undefined;
    discussionItemSurvey?: Survey | undefined;
    userDetail?: UserDetail | undefined;
    following?: boolean | undefined;
    like?: boolean | undefined;
    tags?: string[] | undefined;
    followersCount?: number | undefined;
    anonymous?: boolean;
    likesCount?: number | undefined;
    discussionName?: string | undefined;
    replyDiscussionItems?: DiscussionItem[] | undefined;
    providerVerification?: boolean | undefined;
    patientVerification?: boolean | undefined;
    providerType?: string | undefined;
    providerSpecialty?: string | undefined;
    providerPublicTag?: string | undefined;
    discussionItemCountry?: string | undefined;
    discussionImageUrl?: string | undefined;
    discussionItemID!: string;
    discussionID!: string;
    title?: string | undefined;
    value?: string | undefined;
    replyDiscussionItemID?: string | undefined;
    userDetailID!: string;
    discussionsUserName?: string | undefined;
    discussionsImageDetailID?: string | undefined;
    pinned!: boolean;
    replyCount!: number;
    providerReplyCount!: number;
    replyProviderUserDetailID?: string | undefined;
    discussionItemSlug?: string | undefined;
    discussionItemRole?: string | undefined;
    discussionItemImageUrls?: string | undefined;
    discussionItemGif?: string | undefined;
    discussionItemSurveyID?: string | undefined;

    constructor(data?: IDiscussionItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["discussionItemTags"])) {
                this.discussionItemTags = [] as any;
                for (let item of _data["discussionItemTags"])
                    this.discussionItemTags!.push(DiscussionItemTag.fromJS(item));
            }
            if (Array.isArray(_data["discussionItemFollowers"])) {
                this.discussionItemFollowers = [] as any;
                for (let item of _data["discussionItemFollowers"])
                    this.discussionItemFollowers!.push(DiscussionItemFollower.fromJS(item));
            }
            if (Array.isArray(_data["discussionItemLikes"])) {
                this.discussionItemLikes = [] as any;
                for (let item of _data["discussionItemLikes"])
                    this.discussionItemLikes!.push(DiscussionItemLike.fromJS(item));
            }
            if (Array.isArray(_data["discussionItemBlockedDetails"])) {
                this.discussionItemBlockedDetails = [] as any;
                for (let item of _data["discussionItemBlockedDetails"])
                    this.discussionItemBlockedDetails!.push(DiscussionItemBlockedDetail.fromJS(item));
            }
            this.discussion = _data["discussion"] ? Discussion.fromJS(_data["discussion"]) : <any>undefined;
            this.discussionsImageDetail = _data["discussionsImageDetail"] ? ImageDetail.fromJS(_data["discussionsImageDetail"]) : <any>undefined;
            this.discussionItemSurvey = _data["discussionItemSurvey"] ? Survey.fromJS(_data["discussionItemSurvey"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.following = _data["following"];
            this.like = _data["like"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.followersCount = _data["followersCount"];
            this.anonymous = _data["anonymous"];
            this.likesCount = _data["likesCount"];
            this.discussionName = _data["discussionName"];
            if (Array.isArray(_data["replyDiscussionItems"])) {
                this.replyDiscussionItems = [] as any;
                for (let item of _data["replyDiscussionItems"])
                    this.replyDiscussionItems!.push(DiscussionItem.fromJS(item));
            }
            this.providerVerification = _data["providerVerification"];
            this.patientVerification = _data["patientVerification"];
            this.providerType = _data["providerType"];
            this.providerSpecialty = _data["providerSpecialty"];
            this.providerPublicTag = _data["providerPublicTag"];
            this.discussionItemCountry = _data["discussionItemCountry"];
            this.discussionImageUrl = _data["discussionImageUrl"];
            this.discussionItemID = _data["discussionItemID"];
            this.discussionID = _data["discussionID"];
            this.title = _data["title"];
            this.value = _data["value"];
            this.replyDiscussionItemID = _data["replyDiscussionItemID"];
            this.userDetailID = _data["userDetailID"];
            this.discussionsUserName = _data["discussionsUserName"];
            this.discussionsImageDetailID = _data["discussionsImageDetailID"];
            this.pinned = _data["pinned"];
            this.replyCount = _data["replyCount"];
            this.providerReplyCount = _data["providerReplyCount"];
            this.replyProviderUserDetailID = _data["replyProviderUserDetailID"];
            this.discussionItemSlug = _data["discussionItemSlug"];
            this.discussionItemRole = _data["discussionItemRole"];
            this.discussionItemImageUrls = _data["discussionItemImageUrls"];
            this.discussionItemGif = _data["discussionItemGif"];
            this.discussionItemSurveyID = _data["discussionItemSurveyID"];
        }
    }

    static fromJS(data: any): DiscussionItem {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discussionItemTags)) {
            data["discussionItemTags"] = [];
            for (let item of this.discussionItemTags)
                data["discussionItemTags"].push(item.toJSON());
        }
        if (Array.isArray(this.discussionItemFollowers)) {
            data["discussionItemFollowers"] = [];
            for (let item of this.discussionItemFollowers)
                data["discussionItemFollowers"].push(item.toJSON());
        }
        if (Array.isArray(this.discussionItemLikes)) {
            data["discussionItemLikes"] = [];
            for (let item of this.discussionItemLikes)
                data["discussionItemLikes"].push(item.toJSON());
        }
        if (Array.isArray(this.discussionItemBlockedDetails)) {
            data["discussionItemBlockedDetails"] = [];
            for (let item of this.discussionItemBlockedDetails)
                data["discussionItemBlockedDetails"].push(item.toJSON());
        }
        data["discussion"] = this.discussion ? this.discussion.toJSON() : <any>undefined;
        data["discussionsImageDetail"] = this.discussionsImageDetail ? this.discussionsImageDetail.toJSON() : <any>undefined;
        data["discussionItemSurvey"] = this.discussionItemSurvey ? this.discussionItemSurvey.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["following"] = this.following;
        data["like"] = this.like;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["followersCount"] = this.followersCount;
        data["anonymous"] = this.anonymous;
        data["likesCount"] = this.likesCount;
        data["discussionName"] = this.discussionName;
        if (Array.isArray(this.replyDiscussionItems)) {
            data["replyDiscussionItems"] = [];
            for (let item of this.replyDiscussionItems)
                data["replyDiscussionItems"].push(item.toJSON());
        }
        data["providerVerification"] = this.providerVerification;
        data["patientVerification"] = this.patientVerification;
        data["providerType"] = this.providerType;
        data["providerSpecialty"] = this.providerSpecialty;
        data["providerPublicTag"] = this.providerPublicTag;
        data["discussionItemCountry"] = this.discussionItemCountry;
        data["discussionImageUrl"] = this.discussionImageUrl;
        data["discussionItemID"] = this.discussionItemID;
        data["discussionID"] = this.discussionID;
        data["title"] = this.title;
        data["value"] = this.value;
        data["replyDiscussionItemID"] = this.replyDiscussionItemID;
        data["userDetailID"] = this.userDetailID;
        data["discussionsUserName"] = this.discussionsUserName;
        data["discussionsImageDetailID"] = this.discussionsImageDetailID;
        data["pinned"] = this.pinned;
        data["replyCount"] = this.replyCount;
        data["providerReplyCount"] = this.providerReplyCount;
        data["replyProviderUserDetailID"] = this.replyProviderUserDetailID;
        data["discussionItemSlug"] = this.discussionItemSlug;
        data["discussionItemRole"] = this.discussionItemRole;
        data["discussionItemImageUrls"] = this.discussionItemImageUrls;
        data["discussionItemGif"] = this.discussionItemGif;
        data["discussionItemSurveyID"] = this.discussionItemSurveyID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionItem extends IEntityBase {
    discussionItemTags?: DiscussionItemTag[] | undefined;
    discussionItemFollowers?: DiscussionItemFollower[] | undefined;
    discussionItemLikes?: DiscussionItemLike[] | undefined;
    discussionItemBlockedDetails?: DiscussionItemBlockedDetail[] | undefined;
    discussion?: Discussion | undefined;
    discussionsImageDetail?: ImageDetail | undefined;
    discussionItemSurvey?: Survey | undefined;
    userDetail?: UserDetail | undefined;
    following?: boolean | undefined;
    like?: boolean | undefined;
    tags?: string[] | undefined;
    followersCount?: number | undefined;
    anonymous?: boolean;
    likesCount?: number | undefined;
    discussionName?: string | undefined;
    replyDiscussionItems?: DiscussionItem[] | undefined;
    providerVerification?: boolean | undefined;
    patientVerification?: boolean | undefined;
    providerType?: string | undefined;
    providerSpecialty?: string | undefined;
    providerPublicTag?: string | undefined;
    discussionItemCountry?: string | undefined;
    discussionImageUrl?: string | undefined;
    discussionItemID: string;
    discussionID: string;
    title?: string | undefined;
    value?: string | undefined;
    replyDiscussionItemID?: string | undefined;
    userDetailID: string;
    discussionsUserName?: string | undefined;
    discussionsImageDetailID?: string | undefined;
    pinned: boolean;
    replyCount: number;
    providerReplyCount: number;
    replyProviderUserDetailID?: string | undefined;
    discussionItemSlug?: string | undefined;
    discussionItemRole?: string | undefined;
    discussionItemImageUrls?: string | undefined;
    discussionItemGif?: string | undefined;
    discussionItemSurveyID?: string | undefined;
}

export class DiscussionItemTag extends EntityBase implements IDiscussionItemTag {
    tag?: Tag | undefined;
    discussionItem?: DiscussionItem | undefined;
    discussionItemTagID!: string;
    discussionItemID!: string;
    tagID!: string;

    constructor(data?: IDiscussionItemTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.discussionItem = _data["discussionItem"] ? DiscussionItem.fromJS(_data["discussionItem"]) : <any>undefined;
            this.discussionItemTagID = _data["discussionItemTagID"];
            this.discussionItemID = _data["discussionItemID"];
            this.tagID = _data["tagID"];
        }
    }

    static fromJS(data: any): DiscussionItemTag {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionItemTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["discussionItem"] = this.discussionItem ? this.discussionItem.toJSON() : <any>undefined;
        data["discussionItemTagID"] = this.discussionItemTagID;
        data["discussionItemID"] = this.discussionItemID;
        data["tagID"] = this.tagID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionItemTag extends IEntityBase {
    tag?: Tag | undefined;
    discussionItem?: DiscussionItem | undefined;
    discussionItemTagID: string;
    discussionItemID: string;
    tagID: string;
}

export class DiscussionItemFollower extends EntityBase implements IDiscussionItemFollower {
    discussionItem?: DiscussionItem | undefined;
    userDetail?: UserDetail | undefined;
    discussionItemFollowerID!: string;
    discussionItemID!: string;
    userDetailID!: string;

    constructor(data?: IDiscussionItemFollower) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.discussionItem = _data["discussionItem"] ? DiscussionItem.fromJS(_data["discussionItem"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.discussionItemFollowerID = _data["discussionItemFollowerID"];
            this.discussionItemID = _data["discussionItemID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): DiscussionItemFollower {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionItemFollower();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussionItem"] = this.discussionItem ? this.discussionItem.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["discussionItemFollowerID"] = this.discussionItemFollowerID;
        data["discussionItemID"] = this.discussionItemID;
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionItemFollower extends IEntityBase {
    discussionItem?: DiscussionItem | undefined;
    userDetail?: UserDetail | undefined;
    discussionItemFollowerID: string;
    discussionItemID: string;
    userDetailID: string;
}

export class DiscussionItemLike extends EntityBase implements IDiscussionItemLike {
    discussionItemLikeID!: string;
    discussionItemID!: string;
    userDetailID!: string;

    constructor(data?: IDiscussionItemLike) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.discussionItemLikeID = _data["discussionItemLikeID"];
            this.discussionItemID = _data["discussionItemID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): DiscussionItemLike {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionItemLike();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussionItemLikeID"] = this.discussionItemLikeID;
        data["discussionItemID"] = this.discussionItemID;
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionItemLike extends IEntityBase {
    discussionItemLikeID: string;
    discussionItemID: string;
    userDetailID: string;
}

export class DiscussionItemBlockedDetail extends EntityBase implements IDiscussionItemBlockedDetail {
    userDetail?: UserDetail | undefined;
    discussionItemBlockedDetailID!: string;
    discussionItemID!: string;
    userDetailID!: string;
    enabled?: boolean;
    reason?: string | undefined;
    blockCounts?: number;
    data?: string | undefined;

    constructor(data?: IDiscussionItemBlockedDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.discussionItemBlockedDetailID = _data["discussionItemBlockedDetailID"];
            this.discussionItemID = _data["discussionItemID"];
            this.userDetailID = _data["userDetailID"];
            this.enabled = _data["enabled"];
            this.reason = _data["reason"];
            this.blockCounts = _data["blockCounts"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DiscussionItemBlockedDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionItemBlockedDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["discussionItemBlockedDetailID"] = this.discussionItemBlockedDetailID;
        data["discussionItemID"] = this.discussionItemID;
        data["userDetailID"] = this.userDetailID;
        data["enabled"] = this.enabled;
        data["reason"] = this.reason;
        data["blockCounts"] = this.blockCounts;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionItemBlockedDetail extends IEntityBase {
    userDetail?: UserDetail | undefined;
    discussionItemBlockedDetailID: string;
    discussionItemID: string;
    userDetailID: string;
    enabled?: boolean;
    reason?: string | undefined;
    blockCounts?: number;
    data?: string | undefined;
}

export class Survey extends EntityBase implements ISurvey {
    surveyID!: string;
    userDetailID!: string;
    name!: string;
    description!: string;
    enabled?: boolean;
    data?: string | undefined;
    message?: string | undefined;
    imageURL?: string | undefined;
    surveyTypeEnum?: SurveyTypeEnum;
    surveyStatusEnum?: SurveyStatusEnum;
    isAnonymous?: boolean;
    isPrivate?: boolean;
    responseCount?: number;
    responseLimit?: number;
    tags?: string | undefined;
    surveyCategoryEnum?: SurveyCategoryEnum;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    countryID?: string | undefined;
    country?: Country | undefined;
    userDetail?: UserDetail | undefined;
    surveyDetails?: SurveyDetail[] | undefined;

    constructor(data?: ISurvey) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.surveyID = _data["surveyID"];
            this.userDetailID = _data["userDetailID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.data = _data["data"];
            this.message = _data["message"];
            this.imageURL = _data["imageURL"];
            this.surveyTypeEnum = _data["surveyTypeEnum"];
            this.surveyStatusEnum = _data["surveyStatusEnum"];
            this.isAnonymous = _data["isAnonymous"];
            this.isPrivate = _data["isPrivate"];
            this.responseCount = _data["responseCount"];
            this.responseLimit = _data["responseLimit"];
            this.tags = _data["tags"];
            this.surveyCategoryEnum = _data["surveyCategoryEnum"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.countryID = _data["countryID"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            if (Array.isArray(_data["surveyDetails"])) {
                this.surveyDetails = [] as any;
                for (let item of _data["surveyDetails"])
                    this.surveyDetails!.push(SurveyDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Survey {
        data = typeof data === 'object' ? data : {};
        let result = new Survey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyID"] = this.surveyID;
        data["userDetailID"] = this.userDetailID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["data"] = this.data;
        data["message"] = this.message;
        data["imageURL"] = this.imageURL;
        data["surveyTypeEnum"] = this.surveyTypeEnum;
        data["surveyStatusEnum"] = this.surveyStatusEnum;
        data["isAnonymous"] = this.isAnonymous;
        data["isPrivate"] = this.isPrivate;
        data["responseCount"] = this.responseCount;
        data["responseLimit"] = this.responseLimit;
        data["tags"] = this.tags;
        data["surveyCategoryEnum"] = this.surveyCategoryEnum;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["countryID"] = this.countryID;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyDetails)) {
            data["surveyDetails"] = [];
            for (let item of this.surveyDetails)
                data["surveyDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISurvey extends IEntityBase {
    surveyID: string;
    userDetailID: string;
    name: string;
    description: string;
    enabled?: boolean;
    data?: string | undefined;
    message?: string | undefined;
    imageURL?: string | undefined;
    surveyTypeEnum?: SurveyTypeEnum;
    surveyStatusEnum?: SurveyStatusEnum;
    isAnonymous?: boolean;
    isPrivate?: boolean;
    responseCount?: number;
    responseLimit?: number;
    tags?: string | undefined;
    surveyCategoryEnum?: SurveyCategoryEnum;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    countryID?: string | undefined;
    country?: Country | undefined;
    userDetail?: UserDetail | undefined;
    surveyDetails?: SurveyDetail[] | undefined;
}

export enum SurveyTypeEnum {
    NotSet = "NotSet",
    Quiz = "Quiz",
    Poll = "Poll",
    Survey = "Survey",
}

export enum SurveyStatusEnum {
    NotSet = "NotSet",
    Active = "Active",
    Draft = "Draft",
    Published = "Published",
    Inactive = "Inactive",
    Closed = "Closed",
}

export enum SurveyCategoryEnum {
    NotSet = "NotSet",
    General = "General",
    Health = "Health",
    Discussion = "Discussion",
    CareFund = "CareFund",
}

export class SurveyDetail extends EntityBase implements ISurveyDetail {
    surveyDetailID!: string;
    surveyID!: string;
    userDetailID?: string | undefined;
    description?: string | undefined;
    data?: string | undefined;
    isPrivate?: boolean;
    isAnonymous?: boolean;
    isEnabled?: boolean;
    isRequired?: boolean;
    order?: number;

    constructor(data?: ISurveyDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.surveyDetailID = _data["surveyDetailID"];
            this.surveyID = _data["surveyID"];
            this.userDetailID = _data["userDetailID"];
            this.description = _data["description"];
            this.data = _data["data"];
            this.isPrivate = _data["isPrivate"];
            this.isAnonymous = _data["isAnonymous"];
            this.isEnabled = _data["isEnabled"];
            this.isRequired = _data["isRequired"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SurveyDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyDetailID"] = this.surveyDetailID;
        data["surveyID"] = this.surveyID;
        data["userDetailID"] = this.userDetailID;
        data["description"] = this.description;
        data["data"] = this.data;
        data["isPrivate"] = this.isPrivate;
        data["isAnonymous"] = this.isAnonymous;
        data["isEnabled"] = this.isEnabled;
        data["isRequired"] = this.isRequired;
        data["order"] = this.order;
        super.toJSON(data);
        return data;
    }
}

export interface ISurveyDetail extends IEntityBase {
    surveyDetailID: string;
    surveyID: string;
    userDetailID?: string | undefined;
    description?: string | undefined;
    data?: string | undefined;
    isPrivate?: boolean;
    isAnonymous?: boolean;
    isEnabled?: boolean;
    isRequired?: boolean;
    order?: number;
}

export class DiscussionRole extends EntityBase implements IDiscussionRole {
    discussionRoleID!: string;
    discussionID!: string;
    roleName!: string;

    constructor(data?: IDiscussionRole) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.discussionRoleID = _data["discussionRoleID"];
            this.discussionID = _data["discussionID"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): DiscussionRole {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussionRoleID"] = this.discussionRoleID;
        data["discussionID"] = this.discussionID;
        data["roleName"] = this.roleName;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionRole extends IEntityBase {
    discussionRoleID: string;
    discussionID: string;
    roleName: string;
}

export class DiscussionFollower extends EntityBase implements IDiscussionFollower {
    discussion?: Discussion | undefined;
    userDetail?: UserDetail | undefined;
    discussionFollowerID!: string;
    discussionID!: string;
    userDetailID!: string;

    constructor(data?: IDiscussionFollower) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.discussion = _data["discussion"] ? Discussion.fromJS(_data["discussion"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.discussionFollowerID = _data["discussionFollowerID"];
            this.discussionID = _data["discussionID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): DiscussionFollower {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionFollower();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussion"] = this.discussion ? this.discussion.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["discussionFollowerID"] = this.discussionFollowerID;
        data["discussionID"] = this.discussionID;
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionFollower extends IEntityBase {
    discussion?: Discussion | undefined;
    userDetail?: UserDetail | undefined;
    discussionFollowerID: string;
    discussionID: string;
    userDetailID: string;
}

export class DiscussionUserDetail extends EntityBase implements IDiscussionUserDetail {
    userDetail?: UserDetail | undefined;
    discussionUserDetailID!: string;
    discussionID!: string;
    userDetailID!: string;

    constructor(data?: IDiscussionUserDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.discussionUserDetailID = _data["discussionUserDetailID"];
            this.discussionID = _data["discussionID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): DiscussionUserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionUserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["discussionUserDetailID"] = this.discussionUserDetailID;
        data["discussionID"] = this.discussionID;
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionUserDetail extends IEntityBase {
    userDetail?: UserDetail | undefined;
    discussionUserDetailID: string;
    discussionID: string;
    userDetailID: string;
}

export class DiscussionItemBannedWord extends EntityBase implements IDiscussionItemBannedWord {
    discussionItemBannedWordID!: string;
    bannedWord!: string;
    discussionItemBannedWordTypeEnum?: DiscussionItemBannedWordTypeEnum;
    enabled!: boolean;
    description!: string;
    relatedWords?: string | undefined;
    reason?: string | undefined;
    data?: string | undefined;

    constructor(data?: IDiscussionItemBannedWord) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.discussionItemBannedWordID = _data["discussionItemBannedWordID"];
            this.bannedWord = _data["bannedWord"];
            this.discussionItemBannedWordTypeEnum = _data["discussionItemBannedWordTypeEnum"];
            this.enabled = _data["enabled"];
            this.description = _data["description"];
            this.relatedWords = _data["relatedWords"];
            this.reason = _data["reason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DiscussionItemBannedWord {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionItemBannedWord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussionItemBannedWordID"] = this.discussionItemBannedWordID;
        data["bannedWord"] = this.bannedWord;
        data["discussionItemBannedWordTypeEnum"] = this.discussionItemBannedWordTypeEnum;
        data["enabled"] = this.enabled;
        data["description"] = this.description;
        data["relatedWords"] = this.relatedWords;
        data["reason"] = this.reason;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionItemBannedWord extends IEntityBase {
    discussionItemBannedWordID: string;
    bannedWord: string;
    discussionItemBannedWordTypeEnum?: DiscussionItemBannedWordTypeEnum;
    enabled: boolean;
    description: string;
    relatedWords?: string | undefined;
    reason?: string | undefined;
    data?: string | undefined;
}

export enum DiscussionItemBannedWordTypeEnum {
    Sexual = "Sexual",
    Offensive = "Offensive",
    Profanity = "Profanity",
    HateSpeech = "HateSpeech",
    Spam = "Spam",
    Illegal = "Illegal",
    Others = "Others",
}

export class PagedResultOfDiscussionItemFollower implements IPagedResultOfDiscussionItemFollower {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: DiscussionItemFollower[] | undefined;

    constructor(data?: IPagedResultOfDiscussionItemFollower) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiscussionItemFollower.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfDiscussionItemFollower {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfDiscussionItemFollower();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfDiscussionItemFollower {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: DiscussionItemFollower[] | undefined;
}

export class PagedResultOfDiscussionItemLike implements IPagedResultOfDiscussionItemLike {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: DiscussionItemLike[] | undefined;

    constructor(data?: IPagedResultOfDiscussionItemLike) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiscussionItemLike.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfDiscussionItemLike {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfDiscussionItemLike();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfDiscussionItemLike {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: DiscussionItemLike[] | undefined;
}

export class DiscussionItemReport extends EntityBase implements IDiscussionItemReport {
    discussionItemReportID!: string;
    discussionItemID!: string;
    userDetailID!: string;
    reason!: string;
    data?: string | undefined;

    constructor(data?: IDiscussionItemReport) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.discussionItemReportID = _data["discussionItemReportID"];
            this.discussionItemID = _data["discussionItemID"];
            this.userDetailID = _data["userDetailID"];
            this.reason = _data["reason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DiscussionItemReport {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionItemReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussionItemReportID"] = this.discussionItemReportID;
        data["discussionItemID"] = this.discussionItemID;
        data["userDetailID"] = this.userDetailID;
        data["reason"] = this.reason;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionItemReport extends IEntityBase {
    discussionItemReportID: string;
    discussionItemID: string;
    userDetailID: string;
    reason: string;
    data?: string | undefined;
}

export class DiscussionItemReportSummary implements IDiscussionItemReportSummary {
    discussionItemReports?: DiscussionItemReport[] | undefined;
    reportsCount?: number;

    constructor(data?: IDiscussionItemReportSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["discussionItemReports"])) {
                this.discussionItemReports = [] as any;
                for (let item of _data["discussionItemReports"])
                    this.discussionItemReports!.push(DiscussionItemReport.fromJS(item));
            }
            this.reportsCount = _data["reportsCount"];
        }
    }

    static fromJS(data: any): DiscussionItemReportSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionItemReportSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discussionItemReports)) {
            data["discussionItemReports"] = [];
            for (let item of this.discussionItemReports)
                data["discussionItemReports"].push(item.toJSON());
        }
        data["reportsCount"] = this.reportsCount;
        return data;
    }
}

export interface IDiscussionItemReportSummary {
    discussionItemReports?: DiscussionItemReport[] | undefined;
    reportsCount?: number;
}

export class GetDiscussionItemsDto implements IGetDiscussionItemsDto {
    discussionItems?: DiscussionItem[] | undefined;
    totalCount?: number | undefined;
    recordsToSkip?: number | undefined;
    recordsToTake?: number | undefined;

    constructor(data?: IGetDiscussionItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["discussionItems"])) {
                this.discussionItems = [] as any;
                for (let item of _data["discussionItems"])
                    this.discussionItems!.push(DiscussionItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
        }
    }

    static fromJS(data: any): GetDiscussionItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiscussionItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discussionItems)) {
            data["discussionItems"] = [];
            for (let item of this.discussionItems)
                data["discussionItems"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        return data;
    }
}

export interface IGetDiscussionItemsDto {
    discussionItems?: DiscussionItem[] | undefined;
    totalCount?: number | undefined;
    recordsToSkip?: number | undefined;
    recordsToTake?: number | undefined;
}

export class DiscussionSearchResults implements IDiscussionSearchResults {
    discussionItems?: DiscussionItem[] | undefined;
    text?: string | undefined;
    scope?: string | undefined;
    resultCount?: number;

    constructor(data?: IDiscussionSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["discussionItems"])) {
                this.discussionItems = [] as any;
                for (let item of _data["discussionItems"])
                    this.discussionItems!.push(DiscussionItem.fromJS(item));
            }
            this.text = _data["text"];
            this.scope = _data["scope"];
            this.resultCount = _data["resultCount"];
        }
    }

    static fromJS(data: any): DiscussionSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discussionItems)) {
            data["discussionItems"] = [];
            for (let item of this.discussionItems)
                data["discussionItems"].push(item.toJSON());
        }
        data["text"] = this.text;
        data["scope"] = this.scope;
        data["resultCount"] = this.resultCount;
        return data;
    }
}

export interface IDiscussionSearchResults {
    discussionItems?: DiscussionItem[] | undefined;
    text?: string | undefined;
    scope?: string | undefined;
    resultCount?: number;
}

export class DiscussionSearchDetails implements IDiscussionSearchDetails {
    text?: string | undefined;
    scope?: string | undefined;
    id?: string;

    constructor(data?: IDiscussionSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.scope = _data["scope"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiscussionSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["scope"] = this.scope;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiscussionSearchDetails {
    text?: string | undefined;
    scope?: string | undefined;
    id?: string;
}

export class PagedResultOfDiscussionItem implements IPagedResultOfDiscussionItem {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: DiscussionItem[] | undefined;

    constructor(data?: IPagedResultOfDiscussionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiscussionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfDiscussionItem {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfDiscussionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfDiscussionItem {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: DiscussionItem[] | undefined;
}

export class TrendingTag implements ITrendingTag {
    discussionItemTagID?: string;
    discussionItemTagName?: string | undefined;
    discussionItems?: DiscussionItem[] | undefined;
    discussionItemsCount?: number;

    constructor(data?: ITrendingTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discussionItemTagID = _data["discussionItemTagID"];
            this.discussionItemTagName = _data["discussionItemTagName"];
            if (Array.isArray(_data["discussionItems"])) {
                this.discussionItems = [] as any;
                for (let item of _data["discussionItems"])
                    this.discussionItems!.push(DiscussionItem.fromJS(item));
            }
            this.discussionItemsCount = _data["discussionItemsCount"];
        }
    }

    static fromJS(data: any): TrendingTag {
        data = typeof data === 'object' ? data : {};
        let result = new TrendingTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussionItemTagID"] = this.discussionItemTagID;
        data["discussionItemTagName"] = this.discussionItemTagName;
        if (Array.isArray(this.discussionItems)) {
            data["discussionItems"] = [];
            for (let item of this.discussionItems)
                data["discussionItems"].push(item.toJSON());
        }
        data["discussionItemsCount"] = this.discussionItemsCount;
        return data;
    }
}

export interface ITrendingTag {
    discussionItemTagID?: string;
    discussionItemTagName?: string | undefined;
    discussionItems?: DiscussionItem[] | undefined;
    discussionItemsCount?: number;
}

export class DiscussionModerator extends EntityBase implements IDiscussionModerator {
    userDetail?: UserDetail | undefined;
    discussionModeratorID!: string;
    discussionID!: string;
    userDetailID!: string;

    constructor(data?: IDiscussionModerator) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.discussionModeratorID = _data["discussionModeratorID"];
            this.discussionID = _data["discussionID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): DiscussionModerator {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionModerator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["discussionModeratorID"] = this.discussionModeratorID;
        data["discussionID"] = this.discussionID;
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionModerator extends IEntityBase {
    userDetail?: UserDetail | undefined;
    discussionModeratorID: string;
    discussionID: string;
    userDetailID: string;
}

export class DiscussionReport extends EntityBase implements IDiscussionReport {
    discussionReportID!: string;
    discussionID!: string;
    userDetailID!: string;
    reason!: string;
    data?: string | undefined;

    constructor(data?: IDiscussionReport) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.discussionReportID = _data["discussionReportID"];
            this.discussionID = _data["discussionID"];
            this.userDetailID = _data["userDetailID"];
            this.reason = _data["reason"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DiscussionReport {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussionReportID"] = this.discussionReportID;
        data["discussionID"] = this.discussionID;
        data["userDetailID"] = this.userDetailID;
        data["reason"] = this.reason;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionReport extends IEntityBase {
    discussionReportID: string;
    discussionID: string;
    userDetailID: string;
    reason: string;
    data?: string | undefined;
}

export class DiscussionReportSummary implements IDiscussionReportSummary {
    discussionReports?: DiscussionReport[] | undefined;
    reportsCount?: number;

    constructor(data?: IDiscussionReportSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["discussionReports"])) {
                this.discussionReports = [] as any;
                for (let item of _data["discussionReports"])
                    this.discussionReports!.push(DiscussionReport.fromJS(item));
            }
            this.reportsCount = _data["reportsCount"];
        }
    }

    static fromJS(data: any): DiscussionReportSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionReportSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discussionReports)) {
            data["discussionReports"] = [];
            for (let item of this.discussionReports)
                data["discussionReports"].push(item.toJSON());
        }
        data["reportsCount"] = this.reportsCount;
        return data;
    }
}

export interface IDiscussionReportSummary {
    discussionReports?: DiscussionReport[] | undefined;
    reportsCount?: number;
}

export class DiscussionTopicSummary implements IDiscussionTopicSummary {
    discussion?: Discussion | undefined;
    discussionCount?: number;
    replyCount?: number;

    constructor(data?: IDiscussionTopicSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discussion = _data["discussion"] ? Discussion.fromJS(_data["discussion"]) : <any>undefined;
            this.discussionCount = _data["discussionCount"];
            this.replyCount = _data["replyCount"];
        }
    }

    static fromJS(data: any): DiscussionTopicSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionTopicSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discussion"] = this.discussion ? this.discussion.toJSON() : <any>undefined;
        data["discussionCount"] = this.discussionCount;
        data["replyCount"] = this.replyCount;
        return data;
    }
}

export interface IDiscussionTopicSummary {
    discussion?: Discussion | undefined;
    discussionCount?: number;
    replyCount?: number;
}

export class DiscussionModeratorSummary implements IDiscussionModeratorSummary {
    lastSigninDate?: Date;
    discussions?: Discussion[] | undefined;
    discussionItems?: DiscussionItem[] | undefined;

    constructor(data?: IDiscussionModeratorSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastSigninDate = _data["lastSigninDate"] ? new Date(_data["lastSigninDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["discussions"])) {
                this.discussions = [] as any;
                for (let item of _data["discussions"])
                    this.discussions!.push(Discussion.fromJS(item));
            }
            if (Array.isArray(_data["discussionItems"])) {
                this.discussionItems = [] as any;
                for (let item of _data["discussionItems"])
                    this.discussionItems!.push(DiscussionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiscussionModeratorSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionModeratorSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastSigninDate"] = this.lastSigninDate ? this.lastSigninDate.toISOString() : <any>undefined;
        if (Array.isArray(this.discussions)) {
            data["discussions"] = [];
            for (let item of this.discussions)
                data["discussions"].push(item.toJSON());
        }
        if (Array.isArray(this.discussionItems)) {
            data["discussionItems"] = [];
            for (let item of this.discussionItems)
                data["discussionItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDiscussionModeratorSummary {
    lastSigninDate?: Date;
    discussions?: Discussion[] | undefined;
    discussionItems?: DiscussionItem[] | undefined;
}

export class DiscussionTag extends EntityBase implements IDiscussionTag {
    tag?: Tag | undefined;
    discussion?: Discussion | undefined;
    discussionTagID!: string;
    discussionID!: string;
    tagID!: string;

    constructor(data?: IDiscussionTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.discussion = _data["discussion"] ? Discussion.fromJS(_data["discussion"]) : <any>undefined;
            this.discussionTagID = _data["discussionTagID"];
            this.discussionID = _data["discussionID"];
            this.tagID = _data["tagID"];
        }
    }

    static fromJS(data: any): DiscussionTag {
        data = typeof data === 'object' ? data : {};
        let result = new DiscussionTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["discussion"] = this.discussion ? this.discussion.toJSON() : <any>undefined;
        data["discussionTagID"] = this.discussionTagID;
        data["discussionID"] = this.discussionID;
        data["tagID"] = this.tagID;
        super.toJSON(data);
        return data;
    }
}

export interface IDiscussionTag extends IEntityBase {
    tag?: Tag | undefined;
    discussion?: Discussion | undefined;
    discussionTagID: string;
    discussionID: string;
    tagID: string;
}

export class EmailToken extends EntityBase implements IEmailToken {
    emailTokenID!: string;
    email?: string | undefined;
    smsNumber?: string | undefined;
    token!: string;
    expireDate!: Date;

    constructor(data?: IEmailToken) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.emailTokenID = _data["emailTokenID"];
            this.email = _data["email"];
            this.smsNumber = _data["smsNumber"];
            this.token = _data["token"];
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailToken {
        data = typeof data === 'object' ? data : {};
        let result = new EmailToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailTokenID"] = this.emailTokenID;
        data["email"] = this.email;
        data["smsNumber"] = this.smsNumber;
        data["token"] = this.token;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailToken extends IEntityBase {
    emailTokenID: string;
    email?: string | undefined;
    smsNumber?: string | undefined;
    token: string;
    expireDate: Date;
}

export class ErrorLog extends EntityBase implements IErrorLog {
    errorLogID!: string;
    logDate!: Date;
    machineName?: string | undefined;
    identity?: string | undefined;
    ipAddress?: string | undefined;
    environment?: string | undefined;
    uri?: string | undefined;
    exceptionType?: string | undefined;
    message?: string | undefined;
    fullMessage?: string | undefined;

    constructor(data?: IErrorLog) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorLogID = _data["errorLogID"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : <any>undefined;
            this.machineName = _data["machineName"];
            this.identity = _data["identity"];
            this.ipAddress = _data["ipAddress"];
            this.environment = _data["environment"];
            this.uri = _data["uri"];
            this.exceptionType = _data["exceptionType"];
            this.message = _data["message"];
            this.fullMessage = _data["fullMessage"];
        }
    }

    static fromJS(data: any): ErrorLog {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorLogID"] = this.errorLogID;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : <any>undefined;
        data["machineName"] = this.machineName;
        data["identity"] = this.identity;
        data["ipAddress"] = this.ipAddress;
        data["environment"] = this.environment;
        data["uri"] = this.uri;
        data["exceptionType"] = this.exceptionType;
        data["message"] = this.message;
        data["fullMessage"] = this.fullMessage;
        super.toJSON(data);
        return data;
    }
}

export interface IErrorLog extends IEntityBase {
    errorLogID: string;
    logDate: Date;
    machineName?: string | undefined;
    identity?: string | undefined;
    ipAddress?: string | undefined;
    environment?: string | undefined;
    uri?: string | undefined;
    exceptionType?: string | undefined;
    message?: string | undefined;
    fullMessage?: string | undefined;
}

export class Fax extends EntityBase implements IFax {
    faxAttachments?: FaxAttachment[] | undefined;
    faxID!: string;
    fromFaxNumber?: string | undefined;
    toFaxNumber?: string | undefined;
    fromHeader?: string | undefined;
    fromName?: string | undefined;
    toName?: string | undefined;
    subject?: string | undefined;
    comments?: string | undefined;
    faxStatusEnum!: FaxStatusEnum;
    faxStatusMessage?: string | undefined;
    faxDirectionEnum!: FaxDirectionEnum;
    faxSourceEnum!: FaxSourceEnum;
    faxSourceID?: string | undefined;
    data?: string | undefined;
    userDetailID?: string | undefined;
    externalFaxID?: string | undefined;
    pages?: number | undefined;
    receivedDate?: Date | undefined;
    queuedDate?: Date | undefined;
    statusDate?: Date | undefined;
    assignedToUserDetailID?: string | undefined;
    assignedDate?: Date | undefined;

    constructor(data?: IFax) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["faxAttachments"])) {
                this.faxAttachments = [] as any;
                for (let item of _data["faxAttachments"])
                    this.faxAttachments!.push(FaxAttachment.fromJS(item));
            }
            this.faxID = _data["faxID"];
            this.fromFaxNumber = _data["fromFaxNumber"];
            this.toFaxNumber = _data["toFaxNumber"];
            this.fromHeader = _data["fromHeader"];
            this.fromName = _data["fromName"];
            this.toName = _data["toName"];
            this.subject = _data["subject"];
            this.comments = _data["comments"];
            this.faxStatusEnum = _data["faxStatusEnum"];
            this.faxStatusMessage = _data["faxStatusMessage"];
            this.faxDirectionEnum = _data["faxDirectionEnum"];
            this.faxSourceEnum = _data["faxSourceEnum"];
            this.faxSourceID = _data["faxSourceID"];
            this.data = _data["data"];
            this.userDetailID = _data["userDetailID"];
            this.externalFaxID = _data["externalFaxID"];
            this.pages = _data["pages"];
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.queuedDate = _data["queuedDate"] ? new Date(_data["queuedDate"].toString()) : <any>undefined;
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : <any>undefined;
            this.assignedToUserDetailID = _data["assignedToUserDetailID"];
            this.assignedDate = _data["assignedDate"] ? new Date(_data["assignedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Fax {
        data = typeof data === 'object' ? data : {};
        let result = new Fax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.faxAttachments)) {
            data["faxAttachments"] = [];
            for (let item of this.faxAttachments)
                data["faxAttachments"].push(item.toJSON());
        }
        data["faxID"] = this.faxID;
        data["fromFaxNumber"] = this.fromFaxNumber;
        data["toFaxNumber"] = this.toFaxNumber;
        data["fromHeader"] = this.fromHeader;
        data["fromName"] = this.fromName;
        data["toName"] = this.toName;
        data["subject"] = this.subject;
        data["comments"] = this.comments;
        data["faxStatusEnum"] = this.faxStatusEnum;
        data["faxStatusMessage"] = this.faxStatusMessage;
        data["faxDirectionEnum"] = this.faxDirectionEnum;
        data["faxSourceEnum"] = this.faxSourceEnum;
        data["faxSourceID"] = this.faxSourceID;
        data["data"] = this.data;
        data["userDetailID"] = this.userDetailID;
        data["externalFaxID"] = this.externalFaxID;
        data["pages"] = this.pages;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["queuedDate"] = this.queuedDate ? this.queuedDate.toISOString() : <any>undefined;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["assignedToUserDetailID"] = this.assignedToUserDetailID;
        data["assignedDate"] = this.assignedDate ? this.assignedDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFax extends IEntityBase {
    faxAttachments?: FaxAttachment[] | undefined;
    faxID: string;
    fromFaxNumber?: string | undefined;
    toFaxNumber?: string | undefined;
    fromHeader?: string | undefined;
    fromName?: string | undefined;
    toName?: string | undefined;
    subject?: string | undefined;
    comments?: string | undefined;
    faxStatusEnum: FaxStatusEnum;
    faxStatusMessage?: string | undefined;
    faxDirectionEnum: FaxDirectionEnum;
    faxSourceEnum: FaxSourceEnum;
    faxSourceID?: string | undefined;
    data?: string | undefined;
    userDetailID?: string | undefined;
    externalFaxID?: string | undefined;
    pages?: number | undefined;
    receivedDate?: Date | undefined;
    queuedDate?: Date | undefined;
    statusDate?: Date | undefined;
    assignedToUserDetailID?: string | undefined;
    assignedDate?: Date | undefined;
}

export class FaxAttachment extends EntityBase implements IFaxAttachment {
    fileDetail?: FileDetail | undefined;
    faxAttachmentID!: string;
    faxID!: string;
    fileDetailID!: string;

    constructor(data?: IFaxAttachment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileDetail = _data["fileDetail"] ? FileDetail.fromJS(_data["fileDetail"]) : <any>undefined;
            this.faxAttachmentID = _data["faxAttachmentID"];
            this.faxID = _data["faxID"];
            this.fileDetailID = _data["fileDetailID"];
        }
    }

    static fromJS(data: any): FaxAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new FaxAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileDetail"] = this.fileDetail ? this.fileDetail.toJSON() : <any>undefined;
        data["faxAttachmentID"] = this.faxAttachmentID;
        data["faxID"] = this.faxID;
        data["fileDetailID"] = this.fileDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IFaxAttachment extends IEntityBase {
    fileDetail?: FileDetail | undefined;
    faxAttachmentID: string;
    faxID: string;
    fileDetailID: string;
}

export enum FaxStatusEnum {
    Queued = "Queued",
    Processing = "Processing",
    Sending = "Sending",
    Delivered = "Delivered",
    Receiving = "Receiving",
    Received = "Received",
    NoAnswer = "NoAnswer",
    Busy = "Busy",
    Failed = "Failed",
    Canceled = "Canceled",
    Deleted = "Deleted",
    Resend = "Resend",
}

export enum FaxDirectionEnum {
    Outbound = "Outbound",
    Inbound = "Inbound",
}

export class PagedResultOfFax implements IPagedResultOfFax {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Fax[] | undefined;

    constructor(data?: IPagedResultOfFax) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Fax.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfFax {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfFax();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfFax {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Fax[] | undefined;
}

export class SendFaxResult implements ISendFaxResult {
    faxID?: string;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: ISendFaxResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.faxID = _data["faxID"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendFaxResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendFaxResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faxID"] = this.faxID;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ISendFaxResult {
    faxID?: string;
    success?: boolean;
    message?: string | undefined;
}

export class SendFaxDetails implements ISendFaxDetails {
    fileDetailID?: string | undefined;
    fileDetail?: FileDetail | undefined;
    addressBookID?: string | undefined;
    faxPhoneNumber?: string | undefined;
    fromName?: string | undefined;
    toName?: string | undefined;
    subject?: string | undefined;
    comments?: string | undefined;
    providerAddress?: string | undefined;
    faxSourceEnum?: FaxSourceEnum;
    faxSourceID?: string;

    constructor(data?: ISendFaxDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileDetailID = _data["fileDetailID"];
            this.fileDetail = _data["fileDetail"] ? FileDetail.fromJS(_data["fileDetail"]) : <any>undefined;
            this.addressBookID = _data["addressBookID"];
            this.faxPhoneNumber = _data["faxPhoneNumber"];
            this.fromName = _data["fromName"];
            this.toName = _data["toName"];
            this.subject = _data["subject"];
            this.comments = _data["comments"];
            this.providerAddress = _data["providerAddress"];
            this.faxSourceEnum = _data["faxSourceEnum"];
            this.faxSourceID = _data["faxSourceID"];
        }
    }

    static fromJS(data: any): SendFaxDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SendFaxDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileDetailID"] = this.fileDetailID;
        data["fileDetail"] = this.fileDetail ? this.fileDetail.toJSON() : <any>undefined;
        data["addressBookID"] = this.addressBookID;
        data["faxPhoneNumber"] = this.faxPhoneNumber;
        data["fromName"] = this.fromName;
        data["toName"] = this.toName;
        data["subject"] = this.subject;
        data["comments"] = this.comments;
        data["providerAddress"] = this.providerAddress;
        data["faxSourceEnum"] = this.faxSourceEnum;
        data["faxSourceID"] = this.faxSourceID;
        return data;
    }
}

export interface ISendFaxDetails {
    fileDetailID?: string | undefined;
    fileDetail?: FileDetail | undefined;
    addressBookID?: string | undefined;
    faxPhoneNumber?: string | undefined;
    fromName?: string | undefined;
    toName?: string | undefined;
    subject?: string | undefined;
    comments?: string | undefined;
    providerAddress?: string | undefined;
    faxSourceEnum?: FaxSourceEnum;
    faxSourceID?: string;
}

export class FaxDetails implements IFaxDetails {
    userDetailID?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    faxSourceEnum?: FaxSourceEnum | undefined;
    faxSourceID?: string | undefined;

    constructor(data?: IFaxDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.faxSourceEnum = _data["faxSourceEnum"];
            this.faxSourceID = _data["faxSourceID"];
        }
    }

    static fromJS(data: any): FaxDetails {
        data = typeof data === 'object' ? data : {};
        let result = new FaxDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["faxSourceEnum"] = this.faxSourceEnum;
        data["faxSourceID"] = this.faxSourceID;
        return data;
    }
}

export interface IFaxDetails {
    userDetailID?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    faxSourceEnum?: FaxSourceEnum | undefined;
    faxSourceID?: string | undefined;
}

export class Feedback extends EntityBase implements IFeedback {
    feedbackID!: string;
    feedbackTypeEnum!: FeedbackTypeEnum;
    userDetailID!: string;
    foreignKeyID?: string | undefined;
    rating!: number;
    notes?: string | undefined;

    constructor(data?: IFeedback) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.feedbackID = _data["feedbackID"];
            this.feedbackTypeEnum = _data["feedbackTypeEnum"];
            this.userDetailID = _data["userDetailID"];
            this.foreignKeyID = _data["foreignKeyID"];
            this.rating = _data["rating"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): Feedback {
        data = typeof data === 'object' ? data : {};
        let result = new Feedback();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feedbackID"] = this.feedbackID;
        data["feedbackTypeEnum"] = this.feedbackTypeEnum;
        data["userDetailID"] = this.userDetailID;
        data["foreignKeyID"] = this.foreignKeyID;
        data["rating"] = this.rating;
        data["notes"] = this.notes;
        super.toJSON(data);
        return data;
    }
}

export interface IFeedback extends IEntityBase {
    feedbackID: string;
    feedbackTypeEnum: FeedbackTypeEnum;
    userDetailID: string;
    foreignKeyID?: string | undefined;
    rating: number;
    notes?: string | undefined;
}

export enum FeedbackTypeEnum {
    Consult = "Consult",
    Provider = "Provider",
    Store = "Store",
    Organization = "Organization",
}

export class ProcessFeedbackResult implements IProcessFeedbackResult {
    success?: boolean;
    message?: string | undefined;
    feedbacksProcessed?: number;
    providersUpdated?: number;
    storesUpdated?: number;
    organizationsUpdated?: number;

    constructor(data?: IProcessFeedbackResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.feedbacksProcessed = _data["feedbacksProcessed"];
            this.providersUpdated = _data["providersUpdated"];
            this.storesUpdated = _data["storesUpdated"];
            this.organizationsUpdated = _data["organizationsUpdated"];
        }
    }

    static fromJS(data: any): ProcessFeedbackResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessFeedbackResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["feedbacksProcessed"] = this.feedbacksProcessed;
        data["providersUpdated"] = this.providersUpdated;
        data["storesUpdated"] = this.storesUpdated;
        data["organizationsUpdated"] = this.organizationsUpdated;
        return data;
    }
}

export interface IProcessFeedbackResult {
    success?: boolean;
    message?: string | undefined;
    feedbacksProcessed?: number;
    providersUpdated?: number;
    storesUpdated?: number;
    organizationsUpdated?: number;
}

export class FrequentlyAskedQuestion extends EntityBase implements IFrequentlyAskedQuestion {
    frequentlyAskedQuestionID!: string;
    countryID!: string;
    question!: string;
    answer!: string;
    enabled!: boolean;
    displaySortOrder!: number;
    roleName?: string | undefined;
    frequentlyAskedQuestionCategory?: string | undefined;
    htmlAnchor?: string | undefined;
    targetText?: string | undefined;
    targetURL?: string | undefined;
    moduleResourceDetailID?: string | undefined;
    moduleResourceDetailTypeEnum?: ModuleResourceDetailTypeEnum | undefined;

    constructor(data?: IFrequentlyAskedQuestion) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.frequentlyAskedQuestionID = _data["frequentlyAskedQuestionID"];
            this.countryID = _data["countryID"];
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.enabled = _data["enabled"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.roleName = _data["roleName"];
            this.frequentlyAskedQuestionCategory = _data["frequentlyAskedQuestionCategory"];
            this.htmlAnchor = _data["htmlAnchor"];
            this.targetText = _data["targetText"];
            this.targetURL = _data["targetURL"];
            this.moduleResourceDetailID = _data["moduleResourceDetailID"];
            this.moduleResourceDetailTypeEnum = _data["moduleResourceDetailTypeEnum"];
        }
    }

    static fromJS(data: any): FrequentlyAskedQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new FrequentlyAskedQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frequentlyAskedQuestionID"] = this.frequentlyAskedQuestionID;
        data["countryID"] = this.countryID;
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["enabled"] = this.enabled;
        data["displaySortOrder"] = this.displaySortOrder;
        data["roleName"] = this.roleName;
        data["frequentlyAskedQuestionCategory"] = this.frequentlyAskedQuestionCategory;
        data["htmlAnchor"] = this.htmlAnchor;
        data["targetText"] = this.targetText;
        data["targetURL"] = this.targetURL;
        data["moduleResourceDetailID"] = this.moduleResourceDetailID;
        data["moduleResourceDetailTypeEnum"] = this.moduleResourceDetailTypeEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IFrequentlyAskedQuestion extends IEntityBase {
    frequentlyAskedQuestionID: string;
    countryID: string;
    question: string;
    answer: string;
    enabled: boolean;
    displaySortOrder: number;
    roleName?: string | undefined;
    frequentlyAskedQuestionCategory?: string | undefined;
    htmlAnchor?: string | undefined;
    targetText?: string | undefined;
    targetURL?: string | undefined;
    moduleResourceDetailID?: string | undefined;
    moduleResourceDetailTypeEnum?: ModuleResourceDetailTypeEnum | undefined;
}

export class FrequentlyAskedQuestionsSearchResults extends PagedQuery implements IFrequentlyAskedQuestionsSearchResults {
    frequentlyAskedQuestions?: PagedResultOfFrequentlyAskedQuestion | undefined;

    constructor(data?: IFrequentlyAskedQuestionsSearchResults) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.frequentlyAskedQuestions = _data["frequentlyAskedQuestions"] ? PagedResultOfFrequentlyAskedQuestion.fromJS(_data["frequentlyAskedQuestions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FrequentlyAskedQuestionsSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new FrequentlyAskedQuestionsSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frequentlyAskedQuestions"] = this.frequentlyAskedQuestions ? this.frequentlyAskedQuestions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFrequentlyAskedQuestionsSearchResults extends IPagedQuery {
    frequentlyAskedQuestions?: PagedResultOfFrequentlyAskedQuestion | undefined;
}

export class PagedResultOfFrequentlyAskedQuestion implements IPagedResultOfFrequentlyAskedQuestion {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: FrequentlyAskedQuestion[] | undefined;

    constructor(data?: IPagedResultOfFrequentlyAskedQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FrequentlyAskedQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfFrequentlyAskedQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfFrequentlyAskedQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfFrequentlyAskedQuestion {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: FrequentlyAskedQuestion[] | undefined;
}

export class FrequentlyAskedQuestionsSearchDetails extends PagedQuery implements IFrequentlyAskedQuestionsSearchDetails {
    countryID?: string;
    searchText?: string | undefined;
    category?: string | undefined;
    roleName?: string | undefined;

    constructor(data?: IFrequentlyAskedQuestionsSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryID = _data["countryID"];
            this.searchText = _data["searchText"];
            this.category = _data["category"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): FrequentlyAskedQuestionsSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new FrequentlyAskedQuestionsSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["searchText"] = this.searchText;
        data["category"] = this.category;
        data["roleName"] = this.roleName;
        super.toJSON(data);
        return data;
    }
}

export interface IFrequentlyAskedQuestionsSearchDetails extends IPagedQuery {
    countryID?: string;
    searchText?: string | undefined;
    category?: string | undefined;
    roleName?: string | undefined;
}

export class GenerateDocumentResult implements IGenerateDocumentResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IGenerateDocumentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): GenerateDocumentResult {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDocumentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IGenerateDocumentResult {
    success?: boolean;
    message?: string | undefined;
}

export class GLSummary implements IGLSummary {
    currencyEnum?: CurrencyEnum;
    totalAmount?: number;
    statementSummaryDetails?: GLSummaryDetail[] | undefined;

    constructor(data?: IGLSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyEnum = _data["currencyEnum"];
            this.totalAmount = _data["totalAmount"];
            if (Array.isArray(_data["statementSummaryDetails"])) {
                this.statementSummaryDetails = [] as any;
                for (let item of _data["statementSummaryDetails"])
                    this.statementSummaryDetails!.push(GLSummaryDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GLSummary {
        data = typeof data === 'object' ? data : {};
        let result = new GLSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyEnum"] = this.currencyEnum;
        data["totalAmount"] = this.totalAmount;
        if (Array.isArray(this.statementSummaryDetails)) {
            data["statementSummaryDetails"] = [];
            for (let item of this.statementSummaryDetails)
                data["statementSummaryDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGLSummary {
    currencyEnum?: CurrencyEnum;
    totalAmount?: number;
    statementSummaryDetails?: GLSummaryDetail[] | undefined;
}

export class GLSummaryDetail implements IGLSummaryDetail {
    glAccountID?: string;
    glAccountTypeEnum?: GLAccountTypeEnum;
    amount?: number;
    name?: string | undefined;
    userDetailID?: string | undefined;

    constructor(data?: IGLSummaryDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.glAccountID = _data["glAccountID"];
            this.glAccountTypeEnum = _data["glAccountTypeEnum"];
            this.amount = _data["amount"];
            this.name = _data["name"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): GLSummaryDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GLSummaryDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["glAccountID"] = this.glAccountID;
        data["glAccountTypeEnum"] = this.glAccountTypeEnum;
        data["amount"] = this.amount;
        data["name"] = this.name;
        data["userDetailID"] = this.userDetailID;
        return data;
    }
}

export interface IGLSummaryDetail {
    glAccountID?: string;
    glAccountTypeEnum?: GLAccountTypeEnum;
    amount?: number;
    name?: string | undefined;
    userDetailID?: string | undefined;
}

export class InventoryLoaderDetails implements IInventoryLoaderDetails {
    productDocumentID?: string;
    inventoryDocumentID?: string;

    constructor(data?: IInventoryLoaderDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDocumentID = _data["productDocumentID"];
            this.inventoryDocumentID = _data["inventoryDocumentID"];
        }
    }

    static fromJS(data: any): InventoryLoaderDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryLoaderDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDocumentID"] = this.productDocumentID;
        data["inventoryDocumentID"] = this.inventoryDocumentID;
        return data;
    }
}

export interface IInventoryLoaderDetails {
    productDocumentID?: string;
    inventoryDocumentID?: string;
}

export class InvoicePaymentBatch extends EntityBase implements IInvoicePaymentBatch {
    invoicePaymentBatchID!: string;
    invoicePaymentBatchNumber!: number;
    userDetailID!: string;
    startDate!: Date;
    endDate?: Date | undefined;
    userDetail?: UserDetail | undefined;
    invoicePayments?: InvoicePayment[] | undefined;
    totalAmount?: number;
    fullName?: string | undefined;
    currencyEnum?: CurrencyEnum;

    constructor(data?: IInvoicePaymentBatch) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.invoicePaymentBatchID = _data["invoicePaymentBatchID"];
            this.invoicePaymentBatchNumber = _data["invoicePaymentBatchNumber"];
            this.userDetailID = _data["userDetailID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            if (Array.isArray(_data["invoicePayments"])) {
                this.invoicePayments = [] as any;
                for (let item of _data["invoicePayments"])
                    this.invoicePayments!.push(InvoicePayment.fromJS(item));
            }
            this.totalAmount = _data["totalAmount"];
            this.fullName = _data["fullName"];
            this.currencyEnum = _data["currencyEnum"];
        }
    }

    static fromJS(data: any): InvoicePaymentBatch {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePaymentBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoicePaymentBatchID"] = this.invoicePaymentBatchID;
        data["invoicePaymentBatchNumber"] = this.invoicePaymentBatchNumber;
        data["userDetailID"] = this.userDetailID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.invoicePayments)) {
            data["invoicePayments"] = [];
            for (let item of this.invoicePayments)
                data["invoicePayments"].push(item.toJSON());
        }
        data["totalAmount"] = this.totalAmount;
        data["fullName"] = this.fullName;
        data["currencyEnum"] = this.currencyEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicePaymentBatch extends IEntityBase {
    invoicePaymentBatchID: string;
    invoicePaymentBatchNumber: number;
    userDetailID: string;
    startDate: Date;
    endDate?: Date | undefined;
    userDetail?: UserDetail | undefined;
    invoicePayments?: InvoicePayment[] | undefined;
    totalAmount?: number;
    fullName?: string | undefined;
    currencyEnum?: CurrencyEnum;
}

export class InvoicePaymentBatchSearchDetails extends PagedQuery implements IInvoicePaymentBatchSearchDetails {
    userDetailID?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IInvoicePaymentBatchSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoicePaymentBatchSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePaymentBatchSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IInvoicePaymentBatchSearchDetails extends IPagedQuery {
    userDetailID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class RecurringPayment extends EntityBase implements IRecurringPayment {
    recurringPaymentID!: string;
    invoiceID!: string;
    userDetailID!: string;
    recurringPlanID?: string | undefined;
    cancelled!: boolean;
    currencyEnum!: CurrencyEnum;
    frequencyEnum!: FrequencyEnum;
    recurringStoreItemID!: string;
    recurringCount!: number;
    paymentProcessorID!: string;
    paymentAmount!: number;
    startPaymentDate!: Date;
    nextPaymentDate!: Date;
    recurringEmailAddress?: string | undefined;
    recurringEmailToken?: string | undefined;
    recurringSubscriptionCode?: string | undefined;
    createRecurringResult?: string | undefined;
    deleteRecurringResult?: string | undefined;
    taskItemTypeName?: string | undefined;
    taskItemDetail?: string | undefined;
    toUserDetailID?: string | undefined;
    recurringToken?: string | undefined;
    invoice?: Invoice | undefined;
    recurringStoreItem?: StoreItem | undefined;
    paymentProcessor?: PaymentProcessor | undefined;
    toUserDetail?: UserDetail | undefined;

    constructor(data?: IRecurringPayment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recurringPaymentID = _data["recurringPaymentID"];
            this.invoiceID = _data["invoiceID"];
            this.userDetailID = _data["userDetailID"];
            this.recurringPlanID = _data["recurringPlanID"];
            this.cancelled = _data["cancelled"];
            this.currencyEnum = _data["currencyEnum"];
            this.frequencyEnum = _data["frequencyEnum"];
            this.recurringStoreItemID = _data["recurringStoreItemID"];
            this.recurringCount = _data["recurringCount"];
            this.paymentProcessorID = _data["paymentProcessorID"];
            this.paymentAmount = _data["paymentAmount"];
            this.startPaymentDate = _data["startPaymentDate"] ? new Date(_data["startPaymentDate"].toString()) : <any>undefined;
            this.nextPaymentDate = _data["nextPaymentDate"] ? new Date(_data["nextPaymentDate"].toString()) : <any>undefined;
            this.recurringEmailAddress = _data["recurringEmailAddress"];
            this.recurringEmailToken = _data["recurringEmailToken"];
            this.recurringSubscriptionCode = _data["recurringSubscriptionCode"];
            this.createRecurringResult = _data["createRecurringResult"];
            this.deleteRecurringResult = _data["deleteRecurringResult"];
            this.taskItemTypeName = _data["taskItemTypeName"];
            this.taskItemDetail = _data["taskItemDetail"];
            this.toUserDetailID = _data["toUserDetailID"];
            this.recurringToken = _data["recurringToken"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.recurringStoreItem = _data["recurringStoreItem"] ? StoreItem.fromJS(_data["recurringStoreItem"]) : <any>undefined;
            this.paymentProcessor = _data["paymentProcessor"] ? PaymentProcessor.fromJS(_data["paymentProcessor"]) : <any>undefined;
            this.toUserDetail = _data["toUserDetail"] ? UserDetail.fromJS(_data["toUserDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RecurringPayment {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurringPaymentID"] = this.recurringPaymentID;
        data["invoiceID"] = this.invoiceID;
        data["userDetailID"] = this.userDetailID;
        data["recurringPlanID"] = this.recurringPlanID;
        data["cancelled"] = this.cancelled;
        data["currencyEnum"] = this.currencyEnum;
        data["frequencyEnum"] = this.frequencyEnum;
        data["recurringStoreItemID"] = this.recurringStoreItemID;
        data["recurringCount"] = this.recurringCount;
        data["paymentProcessorID"] = this.paymentProcessorID;
        data["paymentAmount"] = this.paymentAmount;
        data["startPaymentDate"] = this.startPaymentDate ? this.startPaymentDate.toISOString() : <any>undefined;
        data["nextPaymentDate"] = this.nextPaymentDate ? this.nextPaymentDate.toISOString() : <any>undefined;
        data["recurringEmailAddress"] = this.recurringEmailAddress;
        data["recurringEmailToken"] = this.recurringEmailToken;
        data["recurringSubscriptionCode"] = this.recurringSubscriptionCode;
        data["createRecurringResult"] = this.createRecurringResult;
        data["deleteRecurringResult"] = this.deleteRecurringResult;
        data["taskItemTypeName"] = this.taskItemTypeName;
        data["taskItemDetail"] = this.taskItemDetail;
        data["toUserDetailID"] = this.toUserDetailID;
        data["recurringToken"] = this.recurringToken;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["recurringStoreItem"] = this.recurringStoreItem ? this.recurringStoreItem.toJSON() : <any>undefined;
        data["paymentProcessor"] = this.paymentProcessor ? this.paymentProcessor.toJSON() : <any>undefined;
        data["toUserDetail"] = this.toUserDetail ? this.toUserDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRecurringPayment extends IEntityBase {
    recurringPaymentID: string;
    invoiceID: string;
    userDetailID: string;
    recurringPlanID?: string | undefined;
    cancelled: boolean;
    currencyEnum: CurrencyEnum;
    frequencyEnum: FrequencyEnum;
    recurringStoreItemID: string;
    recurringCount: number;
    paymentProcessorID: string;
    paymentAmount: number;
    startPaymentDate: Date;
    nextPaymentDate: Date;
    recurringEmailAddress?: string | undefined;
    recurringEmailToken?: string | undefined;
    recurringSubscriptionCode?: string | undefined;
    createRecurringResult?: string | undefined;
    deleteRecurringResult?: string | undefined;
    taskItemTypeName?: string | undefined;
    taskItemDetail?: string | undefined;
    toUserDetailID?: string | undefined;
    recurringToken?: string | undefined;
    invoice?: Invoice | undefined;
    recurringStoreItem?: StoreItem | undefined;
    paymentProcessor?: PaymentProcessor | undefined;
    toUserDetail?: UserDetail | undefined;
}

export class RecurringPatientDTO implements IRecurringPatientDTO {
    recurringPaymentID?: string;
    userDetailID?: string;
    fullName?: string | undefined;
    relationshipTypeEnum?: RelationshipTypeEnum | undefined;
    amount?: number;
    imageDetailID?: string | undefined;
    frequencyEnum?: FrequencyEnum;
    currencyEnum?: CurrencyEnum;
    startPaymentDate?: Date;
    nextPaymentDate?: Date;
    lastPaymentDate?: Date;

    constructor(data?: IRecurringPatientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recurringPaymentID = _data["recurringPaymentID"];
            this.userDetailID = _data["userDetailID"];
            this.fullName = _data["fullName"];
            this.relationshipTypeEnum = _data["relationshipTypeEnum"];
            this.amount = _data["amount"];
            this.imageDetailID = _data["imageDetailID"];
            this.frequencyEnum = _data["frequencyEnum"];
            this.currencyEnum = _data["currencyEnum"];
            this.startPaymentDate = _data["startPaymentDate"] ? new Date(_data["startPaymentDate"].toString()) : <any>undefined;
            this.nextPaymentDate = _data["nextPaymentDate"] ? new Date(_data["nextPaymentDate"].toString()) : <any>undefined;
            this.lastPaymentDate = _data["lastPaymentDate"] ? new Date(_data["lastPaymentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecurringPatientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringPatientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurringPaymentID"] = this.recurringPaymentID;
        data["userDetailID"] = this.userDetailID;
        data["fullName"] = this.fullName;
        data["relationshipTypeEnum"] = this.relationshipTypeEnum;
        data["amount"] = this.amount;
        data["imageDetailID"] = this.imageDetailID;
        data["frequencyEnum"] = this.frequencyEnum;
        data["currencyEnum"] = this.currencyEnum;
        data["startPaymentDate"] = this.startPaymentDate ? this.startPaymentDate.toISOString() : <any>undefined;
        data["nextPaymentDate"] = this.nextPaymentDate ? this.nextPaymentDate.toISOString() : <any>undefined;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecurringPatientDTO {
    recurringPaymentID?: string;
    userDetailID?: string;
    fullName?: string | undefined;
    relationshipTypeEnum?: RelationshipTypeEnum | undefined;
    amount?: number;
    imageDetailID?: string | undefined;
    frequencyEnum?: FrequencyEnum;
    currencyEnum?: CurrencyEnum;
    startPaymentDate?: Date;
    nextPaymentDate?: Date;
    lastPaymentDate?: Date;
}

export class InvoiceCommitResult implements IInvoiceCommitResult {
    committed?: boolean;
    invoiceID?: string;
    invoiceStatusEnum?: InvoiceStatusEnum;
    message?: string | undefined;

    constructor(data?: IInvoiceCommitResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.committed = _data["committed"];
            this.invoiceID = _data["invoiceID"];
            this.invoiceStatusEnum = _data["invoiceStatusEnum"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): InvoiceCommitResult {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceCommitResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["committed"] = this.committed;
        data["invoiceID"] = this.invoiceID;
        data["invoiceStatusEnum"] = this.invoiceStatusEnum;
        data["message"] = this.message;
        return data;
    }
}

export interface IInvoiceCommitResult {
    committed?: boolean;
    invoiceID?: string;
    invoiceStatusEnum?: InvoiceStatusEnum;
    message?: string | undefined;
}

export class InvoiceRefundResult implements IInvoiceRefundResult {
    originalInvoiceID?: string;
    refundedInvoiceID?: string;
    message?: string | undefined;
    refunded?: boolean;

    constructor(data?: IInvoiceRefundResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalInvoiceID = _data["originalInvoiceID"];
            this.refundedInvoiceID = _data["refundedInvoiceID"];
            this.message = _data["message"];
            this.refunded = _data["refunded"];
        }
    }

    static fromJS(data: any): InvoiceRefundResult {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceRefundResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalInvoiceID"] = this.originalInvoiceID;
        data["refundedInvoiceID"] = this.refundedInvoiceID;
        data["message"] = this.message;
        data["refunded"] = this.refunded;
        return data;
    }
}

export interface IInvoiceRefundResult {
    originalInvoiceID?: string;
    refundedInvoiceID?: string;
    message?: string | undefined;
    refunded?: boolean;
}

export class NeoPaymentResult implements INeoPaymentResult {
    success?: boolean;
    paymentReference?: string | undefined;
    message?: string | undefined;

    constructor(data?: INeoPaymentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.paymentReference = _data["paymentReference"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): NeoPaymentResult {
        data = typeof data === 'object' ? data : {};
        let result = new NeoPaymentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["paymentReference"] = this.paymentReference;
        data["message"] = this.message;
        return data;
    }
}

export interface INeoPaymentResult {
    success?: boolean;
    paymentReference?: string | undefined;
    message?: string | undefined;
}

export class NeoPaymentDetail implements INeoPaymentDetail {
    amount?: number;
    reference?: string | undefined;
    userDetailID?: string;

    constructor(data?: INeoPaymentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.reference = _data["reference"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): NeoPaymentDetail {
        data = typeof data === 'object' ? data : {};
        let result = new NeoPaymentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["reference"] = this.reference;
        data["userDetailID"] = this.userDetailID;
        return data;
    }
}

export interface INeoPaymentDetail {
    amount?: number;
    reference?: string | undefined;
    userDetailID?: string;
}

export class PaymentLinkDTO implements IPaymentLinkDTO {
    storeName?: string | undefined;
    customerName?: string | undefined;
    emailAddress?: string | undefined;
    cellPhoneNumber?: string | undefined;
    invoiceID?: string;
    invoiceDate?: Date;
    totalAmount?: number;
    totalCostAmount?: number;
    currencyEnum?: CurrencyEnum;

    constructor(data?: IPaymentLinkDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeName = _data["storeName"];
            this.customerName = _data["customerName"];
            this.emailAddress = _data["emailAddress"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.invoiceID = _data["invoiceID"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.totalAmount = _data["totalAmount"];
            this.totalCostAmount = _data["totalCostAmount"];
            this.currencyEnum = _data["currencyEnum"];
        }
    }

    static fromJS(data: any): PaymentLinkDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentLinkDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["customerName"] = this.customerName;
        data["emailAddress"] = this.emailAddress;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["invoiceID"] = this.invoiceID;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        data["totalCostAmount"] = this.totalCostAmount;
        data["currencyEnum"] = this.currencyEnum;
        return data;
    }
}

export interface IPaymentLinkDTO {
    storeName?: string | undefined;
    customerName?: string | undefined;
    emailAddress?: string | undefined;
    cellPhoneNumber?: string | undefined;
    invoiceID?: string;
    invoiceDate?: Date;
    totalAmount?: number;
    totalCostAmount?: number;
    currencyEnum?: CurrencyEnum;
}

export class InvoiceStoreItemQuantityDetail implements IInvoiceStoreItemQuantityDetail {
    invoiceStoreItemID?: string;
    quantity?: number;

    constructor(data?: IInvoiceStoreItemQuantityDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceStoreItemID = _data["invoiceStoreItemID"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): InvoiceStoreItemQuantityDetail {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStoreItemQuantityDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceStoreItemID"] = this.invoiceStoreItemID;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IInvoiceStoreItemQuantityDetail {
    invoiceStoreItemID?: string;
    quantity?: number;
}

export class KPIDTO implements IKPIDTO {
    name?: string | undefined;
    detail?: string | undefined;
    value?: number;
    associatedID?: string;
    kpiTypeEnum?: KPITypeEnum;

    constructor(data?: IKPIDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.detail = _data["detail"];
            this.value = _data["value"];
            this.associatedID = _data["associatedID"];
            this.kpiTypeEnum = _data["kpiTypeEnum"];
        }
    }

    static fromJS(data: any): KPIDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KPIDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["detail"] = this.detail;
        data["value"] = this.value;
        data["associatedID"] = this.associatedID;
        data["kpiTypeEnum"] = this.kpiTypeEnum;
        return data;
    }
}

export interface IKPIDTO {
    name?: string | undefined;
    detail?: string | undefined;
    value?: number;
    associatedID?: string;
    kpiTypeEnum?: KPITypeEnum;
}

export enum KPITypeEnum {
    NotSet = "NotSet",
    UserDetailID = "UserDetailID",
    PatientID = "PatientID",
    ProviderID = "ProviderID",
    StoreID = "StoreID",
}

export class KPIDateDTO implements IKPIDateDTO {
    startDate?: Date;
    endDate?: Date;
    name?: string | undefined;
    detail?: string | undefined;
    value?: number;
    dataType?: string | undefined;
    currencyEnum?: CurrencyEnum | undefined;
    displaySortOrder?: number;

    constructor(data?: IKPIDateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.detail = _data["detail"];
            this.value = _data["value"];
            this.dataType = _data["dataType"];
            this.currencyEnum = _data["currencyEnum"];
            this.displaySortOrder = _data["displaySortOrder"];
        }
    }

    static fromJS(data: any): KPIDateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new KPIDateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["detail"] = this.detail;
        data["value"] = this.value;
        data["dataType"] = this.dataType;
        data["currencyEnum"] = this.currencyEnum;
        data["displaySortOrder"] = this.displaySortOrder;
        return data;
    }
}

export interface IKPIDateDTO {
    startDate?: Date;
    endDate?: Date;
    name?: string | undefined;
    detail?: string | undefined;
    value?: number;
    dataType?: string | undefined;
    currencyEnum?: CurrencyEnum | undefined;
    displaySortOrder?: number;
}

export class KPIDateSearchDetails implements IKPIDateSearchDetails {
    startDate?: Date;
    endDate?: Date;
    countryID?: string | undefined;
    weekly?: boolean;

    constructor(data?: IKPIDateSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.countryID = _data["countryID"];
            this.weekly = _data["weekly"];
        }
    }

    static fromJS(data: any): KPIDateSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new KPIDateSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["countryID"] = this.countryID;
        data["weekly"] = this.weekly;
        return data;
    }
}

export interface IKPIDateSearchDetails {
    startDate?: Date;
    endDate?: Date;
    countryID?: string | undefined;
    weekly?: boolean;
}

export class Livestream extends EntityBase implements ILivestream {
    livestreamID!: string;
    roomID?: string | undefined;
    name!: string;
    title?: string | undefined;
    roomUrl?: string | undefined;
    description!: string;
    videoPrivacyTypeEnum!: VideoPrivacyTypeEnum;
    roomCreatorUserDetailID!: string;
    token?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    duration?: number | undefined;
    enabled!: boolean;
    videoStatusTypeEnum?: VideoStatusTypeEnum;
    bio?: string | undefined;
    presenters?: string | undefined;
    focusAreas?: string | undefined;
    files?: string | undefined;
    tags?: string | undefined;
    categories?: string | undefined;
    attendees?: number | undefined;
    likes?: number | undefined;
    views?: number | undefined;
    settings?: string | undefined;
    content?: string | undefined;
    contentURL?: string | undefined;
    imageURL?: string | undefined;
    thumbnailImageURL?: string | undefined;
    response?: string | undefined;
    message?: string | undefined;
    data?: string | undefined;
    roomCreatorUserDetail?: UserDetail | undefined;

    constructor(data?: ILivestream) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.livestreamID = _data["livestreamID"];
            this.roomID = _data["roomID"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.roomUrl = _data["roomUrl"];
            this.description = _data["description"];
            this.videoPrivacyTypeEnum = _data["videoPrivacyTypeEnum"];
            this.roomCreatorUserDetailID = _data["roomCreatorUserDetailID"];
            this.token = _data["token"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.enabled = _data["enabled"];
            this.videoStatusTypeEnum = _data["videoStatusTypeEnum"];
            this.bio = _data["bio"];
            this.presenters = _data["presenters"];
            this.focusAreas = _data["focusAreas"];
            this.files = _data["files"];
            this.tags = _data["tags"];
            this.categories = _data["categories"];
            this.attendees = _data["attendees"];
            this.likes = _data["likes"];
            this.views = _data["views"];
            this.settings = _data["settings"];
            this.content = _data["content"];
            this.contentURL = _data["contentURL"];
            this.imageURL = _data["imageURL"];
            this.thumbnailImageURL = _data["thumbnailImageURL"];
            this.response = _data["response"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.roomCreatorUserDetail = _data["roomCreatorUserDetail"] ? UserDetail.fromJS(_data["roomCreatorUserDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Livestream {
        data = typeof data === 'object' ? data : {};
        let result = new Livestream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["livestreamID"] = this.livestreamID;
        data["roomID"] = this.roomID;
        data["name"] = this.name;
        data["title"] = this.title;
        data["roomUrl"] = this.roomUrl;
        data["description"] = this.description;
        data["videoPrivacyTypeEnum"] = this.videoPrivacyTypeEnum;
        data["roomCreatorUserDetailID"] = this.roomCreatorUserDetailID;
        data["token"] = this.token;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["enabled"] = this.enabled;
        data["videoStatusTypeEnum"] = this.videoStatusTypeEnum;
        data["bio"] = this.bio;
        data["presenters"] = this.presenters;
        data["focusAreas"] = this.focusAreas;
        data["files"] = this.files;
        data["tags"] = this.tags;
        data["categories"] = this.categories;
        data["attendees"] = this.attendees;
        data["likes"] = this.likes;
        data["views"] = this.views;
        data["settings"] = this.settings;
        data["content"] = this.content;
        data["contentURL"] = this.contentURL;
        data["imageURL"] = this.imageURL;
        data["thumbnailImageURL"] = this.thumbnailImageURL;
        data["response"] = this.response;
        data["message"] = this.message;
        data["data"] = this.data;
        data["roomCreatorUserDetail"] = this.roomCreatorUserDetail ? this.roomCreatorUserDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILivestream extends IEntityBase {
    livestreamID: string;
    roomID?: string | undefined;
    name: string;
    title?: string | undefined;
    roomUrl?: string | undefined;
    description: string;
    videoPrivacyTypeEnum: VideoPrivacyTypeEnum;
    roomCreatorUserDetailID: string;
    token?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    duration?: number | undefined;
    enabled: boolean;
    videoStatusTypeEnum?: VideoStatusTypeEnum;
    bio?: string | undefined;
    presenters?: string | undefined;
    focusAreas?: string | undefined;
    files?: string | undefined;
    tags?: string | undefined;
    categories?: string | undefined;
    attendees?: number | undefined;
    likes?: number | undefined;
    views?: number | undefined;
    settings?: string | undefined;
    content?: string | undefined;
    contentURL?: string | undefined;
    imageURL?: string | undefined;
    thumbnailImageURL?: string | undefined;
    response?: string | undefined;
    message?: string | undefined;
    data?: string | undefined;
    roomCreatorUserDetail?: UserDetail | undefined;
}

export enum VideoPrivacyTypeEnum {
    Private = "Private",
    Public = "Public",
}

export enum VideoStatusTypeEnum {
    NotCreated = "NotCreated",
    Scheduled = "Scheduled",
    Live = "Live",
    Ended = "Ended",
}

export class CreateRoomResponseDTO implements ICreateRoomResponseDTO {
    livestreamID?: string;
    roomID?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    privacy?: string | undefined;
    roomURL?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;

    constructor(data?: ICreateRoomResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.livestreamID = _data["livestreamID"];
            this.roomID = _data["roomID"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.privacy = _data["privacy"];
            this.roomURL = _data["roomURL"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRoomResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoomResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["livestreamID"] = this.livestreamID;
        data["roomID"] = this.roomID;
        data["name"] = this.name;
        data["status"] = this.status;
        data["message"] = this.message;
        data["privacy"] = this.privacy;
        data["roomURL"] = this.roomURL;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateRoomResponseDTO {
    livestreamID?: string;
    roomID?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    privacy?: string | undefined;
    roomURL?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
}

export class CreateRoomDTO implements ICreateRoomDTO {
    name?: string | undefined;
    description?: string | undefined;
    thumbnailImageURL?: string | undefined;
    videoPrivacyTypeEnum?: VideoPrivacyTypeEnum;
    startTime?: Date;
    presenters?: string[] | undefined;
    files?: string[] | undefined;
    tags?: string[] | undefined;
    focusAreas?: string[] | undefined;

    constructor(data?: ICreateRoomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.thumbnailImageURL = _data["thumbnailImageURL"];
            this.videoPrivacyTypeEnum = _data["videoPrivacyTypeEnum"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["presenters"])) {
                this.presenters = [] as any;
                for (let item of _data["presenters"])
                    this.presenters!.push(item);
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["focusAreas"])) {
                this.focusAreas = [] as any;
                for (let item of _data["focusAreas"])
                    this.focusAreas!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["thumbnailImageURL"] = this.thumbnailImageURL;
        data["videoPrivacyTypeEnum"] = this.videoPrivacyTypeEnum;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        if (Array.isArray(this.presenters)) {
            data["presenters"] = [];
            for (let item of this.presenters)
                data["presenters"].push(item);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.focusAreas)) {
            data["focusAreas"] = [];
            for (let item of this.focusAreas)
                data["focusAreas"].push(item);
        }
        return data;
    }
}

export interface ICreateRoomDTO {
    name?: string | undefined;
    description?: string | undefined;
    thumbnailImageURL?: string | undefined;
    videoPrivacyTypeEnum?: VideoPrivacyTypeEnum;
    startTime?: Date;
    presenters?: string[] | undefined;
    files?: string[] | undefined;
    tags?: string[] | undefined;
    focusAreas?: string[] | undefined;
}

export class EndRoomDTO implements IEndRoomDTO {
    roomName?: string | undefined;
    participants?: number | undefined;

    constructor(data?: IEndRoomDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomName = _data["roomName"];
            this.participants = _data["participants"];
        }
    }

    static fromJS(data: any): EndRoomDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EndRoomDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomName"] = this.roomName;
        data["participants"] = this.participants;
        return data;
    }
}

export interface IEndRoomDTO {
    roomName?: string | undefined;
    participants?: number | undefined;
}

export class SearchLivestreamDetails implements ISearchLivestreamDetails {
    name?: string | undefined;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: ISearchLivestreamDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchLivestreamDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLivestreamDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearchLivestreamDetails {
    name?: string | undefined;
    startDate: Date;
    endDate: Date;
}

export class LiveStreamRecording implements ILiveStreamRecording {
    id?: string | undefined;
    start_Ts?: number;
    status?: string | undefined;
    max_Participants?: number;
    room_Name?: string | undefined;
    duration?: number;
    share_Token?: string | undefined;
    s3Key?: string | undefined;
    mtgSessionId?: string | undefined;

    constructor(data?: ILiveStreamRecording) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.start_Ts = _data["start_Ts"];
            this.status = _data["status"];
            this.max_Participants = _data["max_Participants"];
            this.room_Name = _data["room_Name"];
            this.duration = _data["duration"];
            this.share_Token = _data["share_Token"];
            this.s3Key = _data["s3Key"];
            this.mtgSessionId = _data["mtgSessionId"];
        }
    }

    static fromJS(data: any): LiveStreamRecording {
        data = typeof data === 'object' ? data : {};
        let result = new LiveStreamRecording();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["start_Ts"] = this.start_Ts;
        data["status"] = this.status;
        data["max_Participants"] = this.max_Participants;
        data["room_Name"] = this.room_Name;
        data["duration"] = this.duration;
        data["share_Token"] = this.share_Token;
        data["s3Key"] = this.s3Key;
        data["mtgSessionId"] = this.mtgSessionId;
        return data;
    }
}

export interface ILiveStreamRecording {
    id?: string | undefined;
    start_Ts?: number;
    status?: string | undefined;
    max_Participants?: number;
    room_Name?: string | undefined;
    duration?: number;
    share_Token?: string | undefined;
    s3Key?: string | undefined;
    mtgSessionId?: string | undefined;
}

export class LiveRecordingLink implements ILiveRecordingLink {
    link?: string | undefined;

    constructor(data?: ILiveRecordingLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): LiveRecordingLink {
        data = typeof data === 'object' ? data : {};
        let result = new LiveRecordingLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        return data;
    }
}

export interface ILiveRecordingLink {
    link?: string | undefined;
}

export class Locum extends EntityBase implements ILocum {
    locumID!: string;
    userDetailID!: string;
    name!: string;
    description!: string;
    jobDescription!: string;
    location?: string | undefined;
    pay?: string | undefined;
    duration?: string | undefined;
    enabled!: boolean;
    startDate!: Date;
    endDate?: Date | undefined;
    countryID!: string;
    country?: Country | undefined;
    locumApplications?: LocumApplication[] | undefined;

    constructor(data?: ILocum) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locumID = _data["locumID"];
            this.userDetailID = _data["userDetailID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.jobDescription = _data["jobDescription"];
            this.location = _data["location"];
            this.pay = _data["pay"];
            this.duration = _data["duration"];
            this.enabled = _data["enabled"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.countryID = _data["countryID"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["locumApplications"])) {
                this.locumApplications = [] as any;
                for (let item of _data["locumApplications"])
                    this.locumApplications!.push(LocumApplication.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Locum {
        data = typeof data === 'object' ? data : {};
        let result = new Locum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locumID"] = this.locumID;
        data["userDetailID"] = this.userDetailID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["jobDescription"] = this.jobDescription;
        data["location"] = this.location;
        data["pay"] = this.pay;
        data["duration"] = this.duration;
        data["enabled"] = this.enabled;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["countryID"] = this.countryID;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.locumApplications)) {
            data["locumApplications"] = [];
            for (let item of this.locumApplications)
                data["locumApplications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILocum extends IEntityBase {
    locumID: string;
    userDetailID: string;
    name: string;
    description: string;
    jobDescription: string;
    location?: string | undefined;
    pay?: string | undefined;
    duration?: string | undefined;
    enabled: boolean;
    startDate: Date;
    endDate?: Date | undefined;
    countryID: string;
    country?: Country | undefined;
    locumApplications?: LocumApplication[] | undefined;
}

export class LocumApplication extends EntityBase implements ILocumApplication {
    locumApplicationID!: string;
    locumID!: string;
    userDetailID!: string;
    notes?: string | undefined;
    locum?: Locum | undefined;
    userDetail?: UserDetail | undefined;

    constructor(data?: ILocumApplication) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locumApplicationID = _data["locumApplicationID"];
            this.locumID = _data["locumID"];
            this.userDetailID = _data["userDetailID"];
            this.notes = _data["notes"];
            this.locum = _data["locum"] ? Locum.fromJS(_data["locum"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocumApplication {
        data = typeof data === 'object' ? data : {};
        let result = new LocumApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locumApplicationID"] = this.locumApplicationID;
        data["locumID"] = this.locumID;
        data["userDetailID"] = this.userDetailID;
        data["notes"] = this.notes;
        data["locum"] = this.locum ? this.locum.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ILocumApplication extends IEntityBase {
    locumApplicationID: string;
    locumID: string;
    userDetailID: string;
    notes?: string | undefined;
    locum?: Locum | undefined;
    userDetail?: UserDetail | undefined;
}

export class PagedResultOfLocum implements IPagedResultOfLocum {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Locum[] | undefined;

    constructor(data?: IPagedResultOfLocum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Locum.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfLocum {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfLocum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfLocum {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Locum[] | undefined;
}

export class LocumSearchDetails extends PagedQuery implements ILocumSearchDetails {
    countryID!: string;
    searchText?: string | undefined;

    constructor(data?: ILocumSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryID = _data["countryID"];
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): LocumSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new LocumSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["searchText"] = this.searchText;
        super.toJSON(data);
        return data;
    }
}

export interface ILocumSearchDetails extends IPagedQuery {
    countryID: string;
    searchText?: string | undefined;
}

export class LocumApplicationResult implements ILocumApplicationResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: ILocumApplicationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LocumApplicationResult {
        data = typeof data === 'object' ? data : {};
        let result = new LocumApplicationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ILocumApplicationResult {
    success?: boolean;
    message?: string | undefined;
}

export class LocumApplicationDetails implements ILocumApplicationDetails {
    locumID?: string;
    userDetailID?: string;
    notes?: string | undefined;

    constructor(data?: ILocumApplicationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locumID = _data["locumID"];
            this.userDetailID = _data["userDetailID"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): LocumApplicationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new LocumApplicationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locumID"] = this.locumID;
        data["userDetailID"] = this.userDetailID;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ILocumApplicationDetails {
    locumID?: string;
    userDetailID?: string;
    notes?: string | undefined;
}

export class MailMessageAddress extends EntityBase implements IMailMessageAddress {
    mailMessageAddressID!: string;
    mailMessageID!: string;
    userDetailID!: string;
    mailMessageAddressTypeEnum!: MailMessageAddressTypeEnum;
    patientCareTeamTypeEnum!: PatientCareTeamTypeEnum;
    providerTypeName?: string | undefined;
    patientID?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    imageDetailID?: string | undefined;
    fullName?: string | undefined;

    constructor(data?: IMailMessageAddress) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mailMessageAddressID = _data["mailMessageAddressID"];
            this.mailMessageID = _data["mailMessageID"];
            this.userDetailID = _data["userDetailID"];
            this.mailMessageAddressTypeEnum = _data["mailMessageAddressTypeEnum"];
            this.patientCareTeamTypeEnum = _data["patientCareTeamTypeEnum"];
            this.providerTypeName = _data["providerTypeName"];
            this.patientID = _data["patientID"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.imageDetailID = _data["imageDetailID"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): MailMessageAddress {
        data = typeof data === 'object' ? data : {};
        let result = new MailMessageAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailMessageAddressID"] = this.mailMessageAddressID;
        data["mailMessageID"] = this.mailMessageID;
        data["userDetailID"] = this.userDetailID;
        data["mailMessageAddressTypeEnum"] = this.mailMessageAddressTypeEnum;
        data["patientCareTeamTypeEnum"] = this.patientCareTeamTypeEnum;
        data["providerTypeName"] = this.providerTypeName;
        data["patientID"] = this.patientID;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["imageDetailID"] = this.imageDetailID;
        data["fullName"] = this.fullName;
        super.toJSON(data);
        return data;
    }
}

export interface IMailMessageAddress extends IEntityBase {
    mailMessageAddressID: string;
    mailMessageID: string;
    userDetailID: string;
    mailMessageAddressTypeEnum: MailMessageAddressTypeEnum;
    patientCareTeamTypeEnum: PatientCareTeamTypeEnum;
    providerTypeName?: string | undefined;
    patientID?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    imageDetailID?: string | undefined;
    fullName?: string | undefined;
}

export enum MailMessageAddressTypeEnum {
    From = "From",
    To = "To",
}

export class MailMessage extends EntityBase implements IMailMessage {
    mailMessageID!: string;
    userDetailID!: string;
    messageDate!: Date;
    folderName!: string;
    subject!: string;
    message!: string;
    read!: boolean;
    originalMailMessageID?: string | undefined;
    allowReply!: boolean;
    mailMessageTypeEnum?: MailMessageTypeEnum;
    userDetail?: UserDetail | undefined;
    mailMessageAddresses?: MailMessageAddress[] | undefined;
    mailMessageAttachments?: MailMessageAttachment[] | undefined;
    originalMailMessage?: MailMessage | undefined;

    constructor(data?: IMailMessage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mailMessageID = _data["mailMessageID"];
            this.userDetailID = _data["userDetailID"];
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : <any>undefined;
            this.folderName = _data["folderName"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.read = _data["read"];
            this.originalMailMessageID = _data["originalMailMessageID"];
            this.allowReply = _data["allowReply"];
            this.mailMessageTypeEnum = _data["mailMessageTypeEnum"];
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            if (Array.isArray(_data["mailMessageAddresses"])) {
                this.mailMessageAddresses = [] as any;
                for (let item of _data["mailMessageAddresses"])
                    this.mailMessageAddresses!.push(MailMessageAddress.fromJS(item));
            }
            if (Array.isArray(_data["mailMessageAttachments"])) {
                this.mailMessageAttachments = [] as any;
                for (let item of _data["mailMessageAttachments"])
                    this.mailMessageAttachments!.push(MailMessageAttachment.fromJS(item));
            }
            this.originalMailMessage = _data["originalMailMessage"] ? MailMessage.fromJS(_data["originalMailMessage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MailMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailMessageID"] = this.mailMessageID;
        data["userDetailID"] = this.userDetailID;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["folderName"] = this.folderName;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["read"] = this.read;
        data["originalMailMessageID"] = this.originalMailMessageID;
        data["allowReply"] = this.allowReply;
        data["mailMessageTypeEnum"] = this.mailMessageTypeEnum;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        if (Array.isArray(this.mailMessageAddresses)) {
            data["mailMessageAddresses"] = [];
            for (let item of this.mailMessageAddresses)
                data["mailMessageAddresses"].push(item.toJSON());
        }
        if (Array.isArray(this.mailMessageAttachments)) {
            data["mailMessageAttachments"] = [];
            for (let item of this.mailMessageAttachments)
                data["mailMessageAttachments"].push(item.toJSON());
        }
        data["originalMailMessage"] = this.originalMailMessage ? this.originalMailMessage.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMailMessage extends IEntityBase {
    mailMessageID: string;
    userDetailID: string;
    messageDate: Date;
    folderName: string;
    subject: string;
    message: string;
    read: boolean;
    originalMailMessageID?: string | undefined;
    allowReply: boolean;
    mailMessageTypeEnum?: MailMessageTypeEnum;
    userDetail?: UserDetail | undefined;
    mailMessageAddresses?: MailMessageAddress[] | undefined;
    mailMessageAttachments?: MailMessageAttachment[] | undefined;
    originalMailMessage?: MailMessage | undefined;
}

export enum MailMessageTypeEnum {
    Mail = "Mail",
    Message = "Message",
    Notification = "Notification",
}

export class MailMessageAttachment extends EntityBase implements IMailMessageAttachment {
    mailMessageAttachmentID!: string;
    mailMessageID!: string;
    documentID?: string | undefined;
    phrDocumentID?: string | undefined;
    patientID?: string | undefined;
    document?: Document | undefined;
    phrDocument?: PHRDocument | undefined;

    constructor(data?: IMailMessageAttachment) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mailMessageAttachmentID = _data["mailMessageAttachmentID"];
            this.mailMessageID = _data["mailMessageID"];
            this.documentID = _data["documentID"];
            this.phrDocumentID = _data["phrDocumentID"];
            this.patientID = _data["patientID"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.phrDocument = _data["phrDocument"] ? PHRDocument.fromJS(_data["phrDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MailMessageAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new MailMessageAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailMessageAttachmentID"] = this.mailMessageAttachmentID;
        data["mailMessageID"] = this.mailMessageID;
        data["documentID"] = this.documentID;
        data["phrDocumentID"] = this.phrDocumentID;
        data["patientID"] = this.patientID;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["phrDocument"] = this.phrDocument ? this.phrDocument.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMailMessageAttachment extends IEntityBase {
    mailMessageAttachmentID: string;
    mailMessageID: string;
    documentID?: string | undefined;
    phrDocumentID?: string | undefined;
    patientID?: string | undefined;
    document?: Document | undefined;
    phrDocument?: PHRDocument | undefined;
}

export class PagedResultOfMailMessageGroup implements IPagedResultOfMailMessageGroup {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: MailMessageGroup[] | undefined;

    constructor(data?: IPagedResultOfMailMessageGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailMessageGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfMailMessageGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfMailMessageGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfMailMessageGroup {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: MailMessageGroup[] | undefined;
}

export class MailMessageGroup implements IMailMessageGroup {
    participants?: Participant[] | undefined;
    messages?: MyMessage[] | undefined;

    constructor(data?: IMailMessageGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(Participant.fromJS(item));
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MyMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailMessageGroup {
        data = typeof data === 'object' ? data : {};
        let result = new MailMessageGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailMessageGroup {
    participants?: Participant[] | undefined;
    messages?: MyMessage[] | undefined;
}

export class Participant implements IParticipant {
    type?: string | undefined;
    name?: string | undefined;

    constructor(data?: IParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Participant {
        data = typeof data === 'object' ? data : {};
        let result = new Participant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface IParticipant {
    type?: string | undefined;
    name?: string | undefined;
}

export class MyMessage implements IMyMessage {
    mailMessageID?: string;
    messageDate?: Date;
    subject?: string | undefined;
    message?: string | undefined;
    folderName?: string | undefined;
    createdBy?: string;
    mailMessageAttachments?: MailMessageAttachment[] | undefined;
    mailMessageAddresses?: MailMessageAddress[] | undefined;

    constructor(data?: IMyMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailMessageID = _data["mailMessageID"];
            this.messageDate = _data["messageDate"] ? new Date(_data["messageDate"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.folderName = _data["folderName"];
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["mailMessageAttachments"])) {
                this.mailMessageAttachments = [] as any;
                for (let item of _data["mailMessageAttachments"])
                    this.mailMessageAttachments!.push(MailMessageAttachment.fromJS(item));
            }
            if (Array.isArray(_data["mailMessageAddresses"])) {
                this.mailMessageAddresses = [] as any;
                for (let item of _data["mailMessageAddresses"])
                    this.mailMessageAddresses!.push(MailMessageAddress.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MyMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailMessageID"] = this.mailMessageID;
        data["messageDate"] = this.messageDate ? this.messageDate.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["folderName"] = this.folderName;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.mailMessageAttachments)) {
            data["mailMessageAttachments"] = [];
            for (let item of this.mailMessageAttachments)
                data["mailMessageAttachments"].push(item.toJSON());
        }
        if (Array.isArray(this.mailMessageAddresses)) {
            data["mailMessageAddresses"] = [];
            for (let item of this.mailMessageAddresses)
                data["mailMessageAddresses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMyMessage {
    mailMessageID?: string;
    messageDate?: Date;
    subject?: string | undefined;
    message?: string | undefined;
    folderName?: string | undefined;
    createdBy?: string;
    mailMessageAttachments?: MailMessageAttachment[] | undefined;
    mailMessageAddresses?: MailMessageAddress[] | undefined;
}

export class MarketingCampaignProperty extends EntityBase implements IMarketingCampaignProperty {
    marketingCampaignPropertyID!: string;
    marketingCampaignID!: string;
    marketingCampaignPropertyType!: string;
    displaySortOrder!: number;
    host?: string | undefined;
    name!: string;
    title!: string;
    value?: string | undefined;

    constructor(data?: IMarketingCampaignProperty) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marketingCampaignPropertyID = _data["marketingCampaignPropertyID"];
            this.marketingCampaignID = _data["marketingCampaignID"];
            this.marketingCampaignPropertyType = _data["marketingCampaignPropertyType"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.host = _data["host"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MarketingCampaignProperty {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingCampaignPropertyID"] = this.marketingCampaignPropertyID;
        data["marketingCampaignID"] = this.marketingCampaignID;
        data["marketingCampaignPropertyType"] = this.marketingCampaignPropertyType;
        data["displaySortOrder"] = this.displaySortOrder;
        data["host"] = this.host;
        data["name"] = this.name;
        data["title"] = this.title;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IMarketingCampaignProperty extends IEntityBase {
    marketingCampaignPropertyID: string;
    marketingCampaignID: string;
    marketingCampaignPropertyType: string;
    displaySortOrder: number;
    host?: string | undefined;
    name: string;
    title: string;
    value?: string | undefined;
}

export class MarketingCampaign extends EntityBase implements IMarketingCampaign {
    marketingCampaignID!: string;
    name!: string;
    description?: string | undefined;
    marketingCampaignTypeEnum!: MarketingCampaignTypeEnum;
    marketingCampaignTypeName!: string;
    countryID!: string;
    configurationData!: string;
    sourceRewardTypeName!: string;
    targetRewardTypeName!: string;
    targetURL?: string | undefined;
    startDate!: Date;
    endDate!: Date;
    qrCodeImageURL?: string | undefined;
    qrCodeColorR?: number | undefined;
    qrCodeColorG?: number | undefined;
    qrCodeColorB?: number | undefined;
    marketingCampaignUserDetails?: MarketingCampaignUserDetail[] | undefined;
    country?: Country | undefined;
    marketingCampaignProperties?: MarketingCampaignProperty[] | undefined;

    constructor(data?: IMarketingCampaign) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marketingCampaignID = _data["marketingCampaignID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.marketingCampaignTypeEnum = _data["marketingCampaignTypeEnum"];
            this.marketingCampaignTypeName = _data["marketingCampaignTypeName"];
            this.countryID = _data["countryID"];
            this.configurationData = _data["configurationData"];
            this.sourceRewardTypeName = _data["sourceRewardTypeName"];
            this.targetRewardTypeName = _data["targetRewardTypeName"];
            this.targetURL = _data["targetURL"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.qrCodeImageURL = _data["qrCodeImageURL"];
            this.qrCodeColorR = _data["qrCodeColorR"];
            this.qrCodeColorG = _data["qrCodeColorG"];
            this.qrCodeColorB = _data["qrCodeColorB"];
            if (Array.isArray(_data["marketingCampaignUserDetails"])) {
                this.marketingCampaignUserDetails = [] as any;
                for (let item of _data["marketingCampaignUserDetails"])
                    this.marketingCampaignUserDetails!.push(MarketingCampaignUserDetail.fromJS(item));
            }
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["marketingCampaignProperties"])) {
                this.marketingCampaignProperties = [] as any;
                for (let item of _data["marketingCampaignProperties"])
                    this.marketingCampaignProperties!.push(MarketingCampaignProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketingCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingCampaignID"] = this.marketingCampaignID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["marketingCampaignTypeEnum"] = this.marketingCampaignTypeEnum;
        data["marketingCampaignTypeName"] = this.marketingCampaignTypeName;
        data["countryID"] = this.countryID;
        data["configurationData"] = this.configurationData;
        data["sourceRewardTypeName"] = this.sourceRewardTypeName;
        data["targetRewardTypeName"] = this.targetRewardTypeName;
        data["targetURL"] = this.targetURL;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["qrCodeImageURL"] = this.qrCodeImageURL;
        data["qrCodeColorR"] = this.qrCodeColorR;
        data["qrCodeColorG"] = this.qrCodeColorG;
        data["qrCodeColorB"] = this.qrCodeColorB;
        if (Array.isArray(this.marketingCampaignUserDetails)) {
            data["marketingCampaignUserDetails"] = [];
            for (let item of this.marketingCampaignUserDetails)
                data["marketingCampaignUserDetails"].push(item.toJSON());
        }
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.marketingCampaignProperties)) {
            data["marketingCampaignProperties"] = [];
            for (let item of this.marketingCampaignProperties)
                data["marketingCampaignProperties"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMarketingCampaign extends IEntityBase {
    marketingCampaignID: string;
    name: string;
    description?: string | undefined;
    marketingCampaignTypeEnum: MarketingCampaignTypeEnum;
    marketingCampaignTypeName: string;
    countryID: string;
    configurationData: string;
    sourceRewardTypeName: string;
    targetRewardTypeName: string;
    targetURL?: string | undefined;
    startDate: Date;
    endDate: Date;
    qrCodeImageURL?: string | undefined;
    qrCodeColorR?: number | undefined;
    qrCodeColorG?: number | undefined;
    qrCodeColorB?: number | undefined;
    marketingCampaignUserDetails?: MarketingCampaignUserDetail[] | undefined;
    country?: Country | undefined;
    marketingCampaignProperties?: MarketingCampaignProperty[] | undefined;
}

export enum MarketingCampaignTypeEnum {
    FriendReferral = "FriendReferral",
}

export class MarketingCampaignUserDetail extends EntityBase implements IMarketingCampaignUserDetail {
    marketingCampaignUserDetailID!: string;
    marketingCampaignID!: string;
    userDetailID!: string;
    referralCode!: string;
    url!: string;
    message?: string | undefined;
    seed!: boolean;
    lastAcknowledgedDate?: Date | undefined;
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    paymentCycleEnum!: PaymentCycleEnum;
    paymentCycleStartDate?: Date | undefined;
    nextPaymentCycleDate?: Date | undefined;
    marketingCampaign?: MarketingCampaign | undefined;
    marketingCampaignUserDetailRewards?: MarketingCampaignUserDetailReward[] | undefined;
    userDetail?: UserDetail | undefined;

    constructor(data?: IMarketingCampaignUserDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marketingCampaignUserDetailID = _data["marketingCampaignUserDetailID"];
            this.marketingCampaignID = _data["marketingCampaignID"];
            this.userDetailID = _data["userDetailID"];
            this.referralCode = _data["referralCode"];
            this.url = _data["url"];
            this.message = _data["message"];
            this.seed = _data["seed"];
            this.lastAcknowledgedDate = _data["lastAcknowledgedDate"] ? new Date(_data["lastAcknowledgedDate"].toString()) : <any>undefined;
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
            this.paymentCycleEnum = _data["paymentCycleEnum"];
            this.paymentCycleStartDate = _data["paymentCycleStartDate"] ? new Date(_data["paymentCycleStartDate"].toString()) : <any>undefined;
            this.nextPaymentCycleDate = _data["nextPaymentCycleDate"] ? new Date(_data["nextPaymentCycleDate"].toString()) : <any>undefined;
            this.marketingCampaign = _data["marketingCampaign"] ? MarketingCampaign.fromJS(_data["marketingCampaign"]) : <any>undefined;
            if (Array.isArray(_data["marketingCampaignUserDetailRewards"])) {
                this.marketingCampaignUserDetailRewards = [] as any;
                for (let item of _data["marketingCampaignUserDetailRewards"])
                    this.marketingCampaignUserDetailRewards!.push(MarketingCampaignUserDetailReward.fromJS(item));
            }
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingCampaignUserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignUserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingCampaignUserDetailID"] = this.marketingCampaignUserDetailID;
        data["marketingCampaignID"] = this.marketingCampaignID;
        data["userDetailID"] = this.userDetailID;
        data["referralCode"] = this.referralCode;
        data["url"] = this.url;
        data["message"] = this.message;
        data["seed"] = this.seed;
        data["lastAcknowledgedDate"] = this.lastAcknowledgedDate ? this.lastAcknowledgedDate.toISOString() : <any>undefined;
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["paymentCycleEnum"] = this.paymentCycleEnum;
        data["paymentCycleStartDate"] = this.paymentCycleStartDate ? this.paymentCycleStartDate.toISOString() : <any>undefined;
        data["nextPaymentCycleDate"] = this.nextPaymentCycleDate ? this.nextPaymentCycleDate.toISOString() : <any>undefined;
        data["marketingCampaign"] = this.marketingCampaign ? this.marketingCampaign.toJSON() : <any>undefined;
        if (Array.isArray(this.marketingCampaignUserDetailRewards)) {
            data["marketingCampaignUserDetailRewards"] = [];
            for (let item of this.marketingCampaignUserDetailRewards)
                data["marketingCampaignUserDetailRewards"].push(item.toJSON());
        }
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMarketingCampaignUserDetail extends IEntityBase {
    marketingCampaignUserDetailID: string;
    marketingCampaignID: string;
    userDetailID: string;
    referralCode: string;
    url: string;
    message?: string | undefined;
    seed: boolean;
    lastAcknowledgedDate?: Date | undefined;
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    paymentCycleEnum: PaymentCycleEnum;
    paymentCycleStartDate?: Date | undefined;
    nextPaymentCycleDate?: Date | undefined;
    marketingCampaign?: MarketingCampaign | undefined;
    marketingCampaignUserDetailRewards?: MarketingCampaignUserDetailReward[] | undefined;
    userDetail?: UserDetail | undefined;
}

export enum PaymentCycleEnum {
    Weekly = "Weekly",
    BiWeekly = "BiWeekly",
    Monthly = "Monthly",
}

export class MarketingCampaignUserDetailReward extends EntityBase implements IMarketingCampaignUserDetailReward {
    marketingCampaignUserDetailRewardID!: string;
    marketingCampaignUserDetailID!: string;
    userDetailID!: string;
    rewardStateEnum!: RewardStateEnum;
    rewardTypeName!: string;
    rewardData?: string | undefined;
    rewardAppliedDate?: Date | undefined;
    message?: string | undefined;
    acknowledged!: boolean;
    targetMarketingCampaignUserDetailRewardID?: string | undefined;
    invoiceID?: string | undefined;
    amount?: number | undefined;
    marketingCampaignUserDetail?: MarketingCampaignUserDetail | undefined;
    targetMarketingCampaignUserDetailReward?: MarketingCampaignUserDetailReward | undefined;
    userDetail?: UserDetail | undefined;

    constructor(data?: IMarketingCampaignUserDetailReward) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.marketingCampaignUserDetailRewardID = _data["marketingCampaignUserDetailRewardID"];
            this.marketingCampaignUserDetailID = _data["marketingCampaignUserDetailID"];
            this.userDetailID = _data["userDetailID"];
            this.rewardStateEnum = _data["rewardStateEnum"];
            this.rewardTypeName = _data["rewardTypeName"];
            this.rewardData = _data["rewardData"];
            this.rewardAppliedDate = _data["rewardAppliedDate"] ? new Date(_data["rewardAppliedDate"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.acknowledged = _data["acknowledged"];
            this.targetMarketingCampaignUserDetailRewardID = _data["targetMarketingCampaignUserDetailRewardID"];
            this.invoiceID = _data["invoiceID"];
            this.amount = _data["amount"];
            this.marketingCampaignUserDetail = _data["marketingCampaignUserDetail"] ? MarketingCampaignUserDetail.fromJS(_data["marketingCampaignUserDetail"]) : <any>undefined;
            this.targetMarketingCampaignUserDetailReward = _data["targetMarketingCampaignUserDetailReward"] ? MarketingCampaignUserDetailReward.fromJS(_data["targetMarketingCampaignUserDetailReward"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingCampaignUserDetailReward {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignUserDetailReward();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingCampaignUserDetailRewardID"] = this.marketingCampaignUserDetailRewardID;
        data["marketingCampaignUserDetailID"] = this.marketingCampaignUserDetailID;
        data["userDetailID"] = this.userDetailID;
        data["rewardStateEnum"] = this.rewardStateEnum;
        data["rewardTypeName"] = this.rewardTypeName;
        data["rewardData"] = this.rewardData;
        data["rewardAppliedDate"] = this.rewardAppliedDate ? this.rewardAppliedDate.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["acknowledged"] = this.acknowledged;
        data["targetMarketingCampaignUserDetailRewardID"] = this.targetMarketingCampaignUserDetailRewardID;
        data["invoiceID"] = this.invoiceID;
        data["amount"] = this.amount;
        data["marketingCampaignUserDetail"] = this.marketingCampaignUserDetail ? this.marketingCampaignUserDetail.toJSON() : <any>undefined;
        data["targetMarketingCampaignUserDetailReward"] = this.targetMarketingCampaignUserDetailReward ? this.targetMarketingCampaignUserDetailReward.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IMarketingCampaignUserDetailReward extends IEntityBase {
    marketingCampaignUserDetailRewardID: string;
    marketingCampaignUserDetailID: string;
    userDetailID: string;
    rewardStateEnum: RewardStateEnum;
    rewardTypeName: string;
    rewardData?: string | undefined;
    rewardAppliedDate?: Date | undefined;
    message?: string | undefined;
    acknowledged: boolean;
    targetMarketingCampaignUserDetailRewardID?: string | undefined;
    invoiceID?: string | undefined;
    amount?: number | undefined;
    marketingCampaignUserDetail?: MarketingCampaignUserDetail | undefined;
    targetMarketingCampaignUserDetailReward?: MarketingCampaignUserDetailReward | undefined;
    userDetail?: UserDetail | undefined;
}

export enum RewardStateEnum {
    New = "New",
    Claimable = "Claimable",
    Claimed = "Claimed",
}

export class MarketingCampaignRewardSummaryResults implements IMarketingCampaignRewardSummaryResults {
    marketingCampaigns?: MarketingCampaignRewardSummary[] | undefined;

    constructor(data?: IMarketingCampaignRewardSummaryResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["marketingCampaigns"])) {
                this.marketingCampaigns = [] as any;
                for (let item of _data["marketingCampaigns"])
                    this.marketingCampaigns!.push(MarketingCampaignRewardSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketingCampaignRewardSummaryResults {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignRewardSummaryResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.marketingCampaigns)) {
            data["marketingCampaigns"] = [];
            for (let item of this.marketingCampaigns)
                data["marketingCampaigns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarketingCampaignRewardSummaryResults {
    marketingCampaigns?: MarketingCampaignRewardSummary[] | undefined;
}

export class MarketingCampaignRewardSummary implements IMarketingCampaignRewardSummary {
    marketingCampaignID?: string;
    marketingCampaignName?: string | undefined;
    currencyEnum?: CurrencyEnum;
    currencyEnumString?: string | undefined;
    sourceRewardCount?: number;
    sourceRewardAmount?: number;
    targetRewardCount?: number;
    targetRewardAmount?: number;

    constructor(data?: IMarketingCampaignRewardSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketingCampaignID = _data["marketingCampaignID"];
            this.marketingCampaignName = _data["marketingCampaignName"];
            this.currencyEnum = _data["currencyEnum"];
            this.currencyEnumString = _data["currencyEnumString"];
            this.sourceRewardCount = _data["sourceRewardCount"];
            this.sourceRewardAmount = _data["sourceRewardAmount"];
            this.targetRewardCount = _data["targetRewardCount"];
            this.targetRewardAmount = _data["targetRewardAmount"];
        }
    }

    static fromJS(data: any): MarketingCampaignRewardSummary {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignRewardSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingCampaignID"] = this.marketingCampaignID;
        data["marketingCampaignName"] = this.marketingCampaignName;
        data["currencyEnum"] = this.currencyEnum;
        data["currencyEnumString"] = this.currencyEnumString;
        data["sourceRewardCount"] = this.sourceRewardCount;
        data["sourceRewardAmount"] = this.sourceRewardAmount;
        data["targetRewardCount"] = this.targetRewardCount;
        data["targetRewardAmount"] = this.targetRewardAmount;
        return data;
    }
}

export interface IMarketingCampaignRewardSummary {
    marketingCampaignID?: string;
    marketingCampaignName?: string | undefined;
    currencyEnum?: CurrencyEnum;
    currencyEnumString?: string | undefined;
    sourceRewardCount?: number;
    sourceRewardAmount?: number;
    targetRewardCount?: number;
    targetRewardAmount?: number;
}

export class MarketingCampaignMySummaryDetails implements IMarketingCampaignMySummaryDetails {
    detailsDate?: Date;

    constructor(data?: IMarketingCampaignMySummaryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailsDate = _data["detailsDate"] ? new Date(_data["detailsDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingCampaignMySummaryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignMySummaryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailsDate"] = this.detailsDate ? this.detailsDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMarketingCampaignMySummaryDetails {
    detailsDate?: Date;
}

export class MarketingCampaignValidationResult implements IMarketingCampaignValidationResult {
    marketingCampaignID?: string;
    isValid?: boolean;
    message?: string | undefined;

    constructor(data?: IMarketingCampaignValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketingCampaignID = _data["marketingCampaignID"];
            this.isValid = _data["isValid"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MarketingCampaignValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingCampaignID"] = this.marketingCampaignID;
        data["isValid"] = this.isValid;
        data["message"] = this.message;
        return data;
    }
}

export interface IMarketingCampaignValidationResult {
    marketingCampaignID?: string;
    isValid?: boolean;
    message?: string | undefined;
}

export class EventTrackingDetail implements IEventTrackingDetail {
    eventName?: string | undefined;
    eventData?: string | undefined;
    emailAddress?: string | undefined;
    apikey?: string | undefined;

    constructor(data?: IEventTrackingDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventName = _data["eventName"];
            this.eventData = _data["eventData"];
            this.emailAddress = _data["emailAddress"];
            this.apikey = _data["apikey"];
        }
    }

    static fromJS(data: any): EventTrackingDetail {
        data = typeof data === 'object' ? data : {};
        let result = new EventTrackingDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventName"] = this.eventName;
        data["eventData"] = this.eventData;
        data["emailAddress"] = this.emailAddress;
        data["apikey"] = this.apikey;
        return data;
    }
}

export interface IEventTrackingDetail {
    eventName?: string | undefined;
    eventData?: string | undefined;
    emailAddress?: string | undefined;
    apikey?: string | undefined;
}

export class MarketingCampaignReport implements IMarketingCampaignReport {
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    currencyEnum?: CurrencyEnum;
    marketingCampaignUsers?: MarketingCampaignReportUser[] | undefined;
    runTime?: string;

    constructor(data?: IMarketingCampaignReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.currencyEnum = _data["currencyEnum"];
            if (Array.isArray(_data["marketingCampaignUsers"])) {
                this.marketingCampaignUsers = [] as any;
                for (let item of _data["marketingCampaignUsers"])
                    this.marketingCampaignUsers!.push(MarketingCampaignReportUser.fromJS(item));
            }
            this.runTime = _data["runTime"];
        }
    }

    static fromJS(data: any): MarketingCampaignReport {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["currencyEnum"] = this.currencyEnum;
        if (Array.isArray(this.marketingCampaignUsers)) {
            data["marketingCampaignUsers"] = [];
            for (let item of this.marketingCampaignUsers)
                data["marketingCampaignUsers"].push(item.toJSON());
        }
        data["runTime"] = this.runTime;
        return data;
    }
}

export interface IMarketingCampaignReport {
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    currencyEnum?: CurrencyEnum;
    marketingCampaignUsers?: MarketingCampaignReportUser[] | undefined;
    runTime?: string;
}

export class MarketingCampaignReportUser implements IMarketingCampaignReportUser {
    createdDate?: Date;
    referralCode?: string | undefined;
    url?: string | undefined;
    currencyEnum?: CurrencyEnum;
    userDetailID?: string;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number | undefined;
    seeded?: boolean;
    rewardedMarketingCampaignUser?: MarketingCampaignReportUser[] | undefined;

    constructor(data?: IMarketingCampaignReportUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.referralCode = _data["referralCode"];
            this.url = _data["url"];
            this.currencyEnum = _data["currencyEnum"];
            this.userDetailID = _data["userDetailID"];
            this.fullName = _data["fullName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.amount = _data["amount"];
            this.seeded = _data["seeded"];
            if (Array.isArray(_data["rewardedMarketingCampaignUser"])) {
                this.rewardedMarketingCampaignUser = [] as any;
                for (let item of _data["rewardedMarketingCampaignUser"])
                    this.rewardedMarketingCampaignUser!.push(MarketingCampaignReportUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarketingCampaignReportUser {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignReportUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["referralCode"] = this.referralCode;
        data["url"] = this.url;
        data["currencyEnum"] = this.currencyEnum;
        data["userDetailID"] = this.userDetailID;
        data["fullName"] = this.fullName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["amount"] = this.amount;
        data["seeded"] = this.seeded;
        if (Array.isArray(this.rewardedMarketingCampaignUser)) {
            data["rewardedMarketingCampaignUser"] = [];
            for (let item of this.rewardedMarketingCampaignUser)
                data["rewardedMarketingCampaignUser"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarketingCampaignReportUser {
    createdDate?: Date;
    referralCode?: string | undefined;
    url?: string | undefined;
    currencyEnum?: CurrencyEnum;
    userDetailID?: string;
    fullName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    amount?: number | undefined;
    seeded?: boolean;
    rewardedMarketingCampaignUser?: MarketingCampaignReportUser[] | undefined;
}

export class MarketingCampaignAddPatientsResults implements IMarketingCampaignAddPatientsResults {
    patientEmailAddresses?: string[] | undefined;
    success?: boolean;
    message?: string | undefined;
    insertedCount?: number;

    constructor(data?: IMarketingCampaignAddPatientsResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["patientEmailAddresses"])) {
                this.patientEmailAddresses = [] as any;
                for (let item of _data["patientEmailAddresses"])
                    this.patientEmailAddresses!.push(item);
            }
            this.success = _data["success"];
            this.message = _data["message"];
            this.insertedCount = _data["insertedCount"];
        }
    }

    static fromJS(data: any): MarketingCampaignAddPatientsResults {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignAddPatientsResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patientEmailAddresses)) {
            data["patientEmailAddresses"] = [];
            for (let item of this.patientEmailAddresses)
                data["patientEmailAddresses"].push(item);
        }
        data["success"] = this.success;
        data["message"] = this.message;
        data["insertedCount"] = this.insertedCount;
        return data;
    }
}

export interface IMarketingCampaignAddPatientsResults {
    patientEmailAddresses?: string[] | undefined;
    success?: boolean;
    message?: string | undefined;
    insertedCount?: number;
}

export class MarketingCampaignAddPatientsDetails implements IMarketingCampaignAddPatientsDetails {
    patientEmailAddresses?: string[] | undefined;
    marketingCampaignID?: string;
    rewardAmount?: number;

    constructor(data?: IMarketingCampaignAddPatientsDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["patientEmailAddresses"])) {
                this.patientEmailAddresses = [] as any;
                for (let item of _data["patientEmailAddresses"])
                    this.patientEmailAddresses!.push(item);
            }
            this.marketingCampaignID = _data["marketingCampaignID"];
            this.rewardAmount = _data["rewardAmount"];
        }
    }

    static fromJS(data: any): MarketingCampaignAddPatientsDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaignAddPatientsDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patientEmailAddresses)) {
            data["patientEmailAddresses"] = [];
            for (let item of this.patientEmailAddresses)
                data["patientEmailAddresses"].push(item);
        }
        data["marketingCampaignID"] = this.marketingCampaignID;
        data["rewardAmount"] = this.rewardAmount;
        return data;
    }
}

export interface IMarketingCampaignAddPatientsDetails {
    patientEmailAddresses?: string[] | undefined;
    marketingCampaignID?: string;
    rewardAmount?: number;
}

export class Medication extends EntityBase implements IMedication {
    medicationID!: string;
    countryID!: string;
    name!: string;
    description!: string;
    dosage?: string | undefined;
    form?: string | undefined;
    ndc?: string | undefined;
    enabled!: boolean;
    itemID!: string;
    upc?: string | undefined;
    medicationTypeEnum!: MedicationTypeEnum;
    size?: string | undefined;
    medicationPricingTypeEnum!: MedicationPricingTypeEnum;
    item?: Item | undefined;
    retailAmount?: number;
    quantity?: number;
    imageDetailID?: string;
    currencyEnum?: CurrencyEnum;
    storeID?: string | undefined;
    addressBookID?: string | undefined;

    constructor(data?: IMedication) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.medicationID = _data["medicationID"];
            this.countryID = _data["countryID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dosage = _data["dosage"];
            this.form = _data["form"];
            this.ndc = _data["ndc"];
            this.enabled = _data["enabled"];
            this.itemID = _data["itemID"];
            this.upc = _data["upc"];
            this.medicationTypeEnum = _data["medicationTypeEnum"];
            this.size = _data["size"];
            this.medicationPricingTypeEnum = _data["medicationPricingTypeEnum"];
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>undefined;
            this.retailAmount = _data["retailAmount"];
            this.quantity = _data["quantity"];
            this.imageDetailID = _data["imageDetailID"];
            this.currencyEnum = _data["currencyEnum"];
            this.storeID = _data["storeID"];
            this.addressBookID = _data["addressBookID"];
        }
    }

    static fromJS(data: any): Medication {
        data = typeof data === 'object' ? data : {};
        let result = new Medication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationID"] = this.medicationID;
        data["countryID"] = this.countryID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dosage"] = this.dosage;
        data["form"] = this.form;
        data["ndc"] = this.ndc;
        data["enabled"] = this.enabled;
        data["itemID"] = this.itemID;
        data["upc"] = this.upc;
        data["medicationTypeEnum"] = this.medicationTypeEnum;
        data["size"] = this.size;
        data["medicationPricingTypeEnum"] = this.medicationPricingTypeEnum;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["retailAmount"] = this.retailAmount;
        data["quantity"] = this.quantity;
        data["imageDetailID"] = this.imageDetailID;
        data["currencyEnum"] = this.currencyEnum;
        data["storeID"] = this.storeID;
        data["addressBookID"] = this.addressBookID;
        super.toJSON(data);
        return data;
    }
}

export interface IMedication extends IEntityBase {
    medicationID: string;
    countryID: string;
    name: string;
    description: string;
    dosage?: string | undefined;
    form?: string | undefined;
    ndc?: string | undefined;
    enabled: boolean;
    itemID: string;
    upc?: string | undefined;
    medicationTypeEnum: MedicationTypeEnum;
    size?: string | undefined;
    medicationPricingTypeEnum: MedicationPricingTypeEnum;
    item?: Item | undefined;
    retailAmount?: number;
    quantity?: number;
    imageDetailID?: string;
    currencyEnum?: CurrencyEnum;
    storeID?: string | undefined;
    addressBookID?: string | undefined;
}

export enum MedicationTypeEnum {
    NotSet = "NotSet",
    Medication = "Medication",
    OTC = "OTC",
}

export enum MedicationPricingTypeEnum {
    PerPill = "PerPill",
    PerPackage = "PerPackage",
}

export class PagedResultOfMedication implements IPagedResultOfMedication {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Medication[] | undefined;

    constructor(data?: IPagedResultOfMedication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Medication.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfMedication {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfMedication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfMedication {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Medication[] | undefined;
}

export class MedicationSearchDetails extends PagedQuery implements IMedicationSearchDetails {
    countryID?: string;
    searchText?: string | undefined;
    storeID?: string | undefined;

    constructor(data?: IMedicationSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryID = _data["countryID"];
            this.searchText = _data["searchText"];
            this.storeID = _data["storeID"];
        }
    }

    static fromJS(data: any): MedicationSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["searchText"] = this.searchText;
        data["storeID"] = this.storeID;
        super.toJSON(data);
        return data;
    }
}

export interface IMedicationSearchDetails extends IPagedQuery {
    countryID?: string;
    searchText?: string | undefined;
    storeID?: string | undefined;
}

export class MessageTemplate extends EntityBase implements IMessageTemplate {
    messageTemplateID!: string;
    name!: string;
    shortName!: string;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IMessageTemplate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.messageTemplateID = _data["messageTemplateID"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): MessageTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageTemplateID"] = this.messageTemplateID;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["subject"] = this.subject;
        data["body"] = this.body;
        super.toJSON(data);
        return data;
    }
}

export interface IMessageTemplate extends IEntityBase {
    messageTemplateID: string;
    name: string;
    shortName: string;
    subject?: string | undefined;
    body?: string | undefined;
}

export class MidraResponse implements IMidraResponse {
    mobile?: string | undefined;
    session?: string | undefined;
    serviceCode?: string | undefined;
    network?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    data_add?: MidraData[] | undefined;

    constructor(data?: IMidraResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobile = _data["mobile"];
            this.session = _data["session"];
            this.serviceCode = _data["serviceCode"];
            this.network = _data["network"];
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data_add"])) {
                this.data_add = [] as any;
                for (let item of _data["data_add"])
                    this.data_add!.push(MidraData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MidraResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MidraResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobile"] = this.mobile;
        data["session"] = this.session;
        data["serviceCode"] = this.serviceCode;
        data["network"] = this.network;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data_add)) {
            data["data_add"] = [];
            for (let item of this.data_add)
                data["data_add"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMidraResponse {
    mobile?: string | undefined;
    session?: string | undefined;
    serviceCode?: string | undefined;
    network?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    data_add?: MidraData[] | undefined;
}

export class MidraData implements IMidraData {
    sKey?: string | undefined;
    sVal?: string | undefined;

    constructor(data?: IMidraData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sKey = _data["sKey"];
            this.sVal = _data["sVal"];
        }
    }

    static fromJS(data: any): MidraData {
        data = typeof data === 'object' ? data : {};
        let result = new MidraData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sKey"] = this.sKey;
        data["sVal"] = this.sVal;
        return data;
    }
}

export interface IMidraData {
    sKey?: string | undefined;
    sVal?: string | undefined;
}

export class MidraRequest implements IMidraRequest {
    mobile?: string | undefined;
    session?: string | undefined;
    serviceCode?: string | undefined;
    network?: string | undefined;
    data?: MidraData[] | undefined;

    constructor(data?: IMidraRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobile = _data["mobile"];
            this.session = _data["session"];
            this.serviceCode = _data["serviceCode"];
            this.network = _data["network"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MidraData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MidraRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MidraRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobile"] = this.mobile;
        data["session"] = this.session;
        data["serviceCode"] = this.serviceCode;
        data["network"] = this.network;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMidraRequest {
    mobile?: string | undefined;
    session?: string | undefined;
    serviceCode?: string | undefined;
    network?: string | undefined;
    data?: MidraData[] | undefined;
}

export class MidraListResponse implements IMidraListResponse {
    mobile?: string | undefined;
    session?: string | undefined;
    serviceCode?: string | undefined;
    network?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    data?: string[] | undefined;

    constructor(data?: IMidraListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobile = _data["mobile"];
            this.session = _data["session"];
            this.serviceCode = _data["serviceCode"];
            this.network = _data["network"];
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): MidraListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MidraListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobile"] = this.mobile;
        data["session"] = this.session;
        data["serviceCode"] = this.serviceCode;
        data["network"] = this.network;
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IMidraListResponse {
    mobile?: string | undefined;
    session?: string | undefined;
    serviceCode?: string | undefined;
    network?: string | undefined;
    status?: string | undefined;
    message?: string | undefined;
    data?: string[] | undefined;
}

export class ResourceLibraryDTO implements IResourceLibraryDTO {
    resourceLibraryEntries?: ResourceLibraryEntry[] | undefined;

    constructor(data?: IResourceLibraryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resourceLibraryEntries"])) {
                this.resourceLibraryEntries = [] as any;
                for (let item of _data["resourceLibraryEntries"])
                    this.resourceLibraryEntries!.push(ResourceLibraryEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResourceLibraryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibraryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resourceLibraryEntries)) {
            data["resourceLibraryEntries"] = [];
            for (let item of this.resourceLibraryEntries)
                data["resourceLibraryEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResourceLibraryDTO {
    resourceLibraryEntries?: ResourceLibraryEntry[] | undefined;
}

export class ResourceLibraryEntry implements IResourceLibraryEntry {
    category?: string | undefined;
    resourceTypeEnum?: ModuleResourceDetailTypeEnum;
    name?: string | undefined;
    content?: string | undefined;
    contentURL?: string | undefined;
    url?: string | undefined;
    roleName?: string | undefined;
    description?: string | undefined;

    constructor(data?: IResourceLibraryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.resourceTypeEnum = _data["resourceTypeEnum"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.contentURL = _data["contentURL"];
            this.url = _data["url"];
            this.roleName = _data["roleName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ResourceLibraryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLibraryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["resourceTypeEnum"] = this.resourceTypeEnum;
        data["name"] = this.name;
        data["content"] = this.content;
        data["contentURL"] = this.contentURL;
        data["url"] = this.url;
        data["roleName"] = this.roleName;
        data["description"] = this.description;
        return data;
    }
}

export interface IResourceLibraryEntry {
    category?: string | undefined;
    resourceTypeEnum?: ModuleResourceDetailTypeEnum;
    name?: string | undefined;
    content?: string | undefined;
    contentURL?: string | undefined;
    url?: string | undefined;
    roleName?: string | undefined;
    description?: string | undefined;
}

export class NotificationDeviceRegistration implements INotificationDeviceRegistration {
    platform?: NotificationDevicePlatform;
    handle?: string | undefined;
    tags?: string[] | undefined;

    constructor(data?: INotificationDeviceRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platform = _data["platform"];
            this.handle = _data["handle"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): NotificationDeviceRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDeviceRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platform"] = this.platform;
        data["handle"] = this.handle;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface INotificationDeviceRegistration {
    platform?: NotificationDevicePlatform;
    handle?: string | undefined;
    tags?: string[] | undefined;
}

export enum NotificationDevicePlatform {
    Apple = "Apple",
    Android = "Android",
}

export class NotificationMessage implements INotificationMessage {
    notificationMessageData?: INotificationMessageData | undefined;
    title?: string | undefined;
    message?: string | undefined;
    silent?: boolean;
    tag?: string | undefined;
    data?: string | undefined;
    userDetailID?: string;
    taskItem?: TaskItem | undefined;

    constructor(data?: INotificationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationMessageData = _data["notificationMessageData"] ? INotificationMessageData.fromJS(_data["notificationMessageData"]) : <any>undefined;
            this.title = _data["title"];
            this.message = _data["message"];
            this.silent = _data["silent"];
            this.tag = _data["tag"];
            this.data = _data["data"];
            this.userDetailID = _data["userDetailID"];
            this.taskItem = _data["taskItem"] ? TaskItem.fromJS(_data["taskItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationMessageData"] = this.notificationMessageData ? this.notificationMessageData.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["message"] = this.message;
        data["silent"] = this.silent;
        data["tag"] = this.tag;
        data["data"] = this.data;
        data["userDetailID"] = this.userDetailID;
        data["taskItem"] = this.taskItem ? this.taskItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface INotificationMessage {
    notificationMessageData?: INotificationMessageData | undefined;
    title?: string | undefined;
    message?: string | undefined;
    silent?: boolean;
    tag?: string | undefined;
    data?: string | undefined;
    userDetailID?: string;
    taskItem?: TaskItem | undefined;
}

export abstract class INotificationMessageData implements IINotificationMessageData {
    title?: string | undefined;
    message?: string | undefined;
    notificationMessageDataType?: string | undefined;
    notificationID?: string;
    expiryDate?: Date;

    constructor(data?: IINotificationMessageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.message = _data["message"];
            this.notificationMessageDataType = _data["notificationMessageDataType"];
            this.notificationID = _data["notificationID"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): INotificationMessageData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'INotificationMessageData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["message"] = this.message;
        data["notificationMessageDataType"] = this.notificationMessageDataType;
        data["notificationID"] = this.notificationID;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IINotificationMessageData {
    title?: string | undefined;
    message?: string | undefined;
    notificationMessageDataType?: string | undefined;
    notificationID?: string;
    expiryDate?: Date;
}

export class Notification extends EntityBase implements INotification {
    notificationID!: string;
    userDetailID?: string | undefined;
    title?: string | undefined;
    badge?: number | undefined;
    tag?: string | undefined;
    data?: string | undefined;
    success!: boolean;
    response?: string | undefined;
    responseUserDetailID?: string | undefined;
    taskItemID?: string | undefined;
    expiryDate?: Date | undefined;

    constructor(data?: INotification) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationID = _data["notificationID"];
            this.userDetailID = _data["userDetailID"];
            this.title = _data["title"];
            this.badge = _data["badge"];
            this.tag = _data["tag"];
            this.data = _data["data"];
            this.success = _data["success"];
            this.response = _data["response"];
            this.responseUserDetailID = _data["responseUserDetailID"];
            this.taskItemID = _data["taskItemID"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationID"] = this.notificationID;
        data["userDetailID"] = this.userDetailID;
        data["title"] = this.title;
        data["badge"] = this.badge;
        data["tag"] = this.tag;
        data["data"] = this.data;
        data["success"] = this.success;
        data["response"] = this.response;
        data["responseUserDetailID"] = this.responseUserDetailID;
        data["taskItemID"] = this.taskItemID;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotification extends IEntityBase {
    notificationID: string;
    userDetailID?: string | undefined;
    title?: string | undefined;
    badge?: number | undefined;
    tag?: string | undefined;
    data?: string | undefined;
    success: boolean;
    response?: string | undefined;
    responseUserDetailID?: string | undefined;
    taskItemID?: string | undefined;
    expiryDate?: Date | undefined;
}

export class ApproveDenyResponse implements IApproveDenyResponse {
    notificationID?: string;
    approved?: boolean;
    message?: string | undefined;

    constructor(data?: IApproveDenyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationID = _data["notificationID"];
            this.approved = _data["approved"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ApproveDenyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveDenyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationID"] = this.notificationID;
        data["approved"] = this.approved;
        data["message"] = this.message;
        return data;
    }
}

export interface IApproveDenyResponse {
    notificationID?: string;
    approved?: boolean;
    message?: string | undefined;
}

export class NotificationSearchDetails implements INotificationSearchDetails {
    userDetailID?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: INotificationSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotificationSearchDetails {
    userDetailID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class Partner extends EntityBase implements IPartner {
    partnerID!: string;
    host!: string;
    name?: string | undefined;
    enabled!: boolean;
    partnerSettings?: PartnerSetting[] | undefined;

    constructor(data?: IPartner) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partnerID = _data["partnerID"];
            this.host = _data["host"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["partnerSettings"])) {
                this.partnerSettings = [] as any;
                for (let item of _data["partnerSettings"])
                    this.partnerSettings!.push(PartnerSetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Partner {
        data = typeof data === 'object' ? data : {};
        let result = new Partner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerID"] = this.partnerID;
        data["host"] = this.host;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.partnerSettings)) {
            data["partnerSettings"] = [];
            for (let item of this.partnerSettings)
                data["partnerSettings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPartner extends IEntityBase {
    partnerID: string;
    host: string;
    name?: string | undefined;
    enabled: boolean;
    partnerSettings?: PartnerSetting[] | undefined;
}

export class PartnerSetting extends EntityBase implements IPartnerSetting {
    partnerSettingID!: string;
    partnerID!: string;
    partnerSettingName!: string;
    description?: string | undefined;
    value!: string;

    constructor(data?: IPartnerSetting) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.partnerSettingID = _data["partnerSettingID"];
            this.partnerID = _data["partnerID"];
            this.partnerSettingName = _data["partnerSettingName"];
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PartnerSetting {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerSettingID"] = this.partnerSettingID;
        data["partnerID"] = this.partnerID;
        data["partnerSettingName"] = this.partnerSettingName;
        data["description"] = this.description;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IPartnerSetting extends IEntityBase {
    partnerSettingID: string;
    partnerID: string;
    partnerSettingName: string;
    description?: string | undefined;
    value: string;
}

export class PartnerSearchDetails implements IPartnerSearchDetails {
    host?: string | undefined;

    constructor(data?: IPartnerSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.host = _data["host"];
        }
    }

    static fromJS(data: any): PartnerSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["host"] = this.host;
        return data;
    }
}

export interface IPartnerSearchDetails {
    host?: string | undefined;
}

export class ResetPasswordEmailResult implements IResetPasswordEmailResult {
    token?: string | undefined;

    constructor(data?: IResetPasswordEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetPasswordEmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordEmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IResetPasswordEmailResult {
    token?: string | undefined;
}

export class ResetPasswordEmailDetails implements IResetPasswordEmailDetails {
    email?: string | undefined;

    constructor(data?: IResetPasswordEmailDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ResetPasswordEmailDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordEmailDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IResetPasswordEmailDetails {
    email?: string | undefined;
}

export class ResetPasswordEmailValidateResult implements IResetPasswordEmailValidateResult {
    value?: boolean;

    constructor(data?: IResetPasswordEmailValidateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ResetPasswordEmailValidateResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordEmailValidateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IResetPasswordEmailValidateResult {
    value?: boolean;
}

export class ResetPasswordEmailValidate implements IResetPasswordEmailValidate {
    email?: string | undefined;
    token?: string | undefined;

    constructor(data?: IResetPasswordEmailValidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetPasswordEmailValidate {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordEmailValidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        return data;
    }
}

export interface IResetPasswordEmailValidate {
    email?: string | undefined;
    token?: string | undefined;
}

export class ResetPasswordDetails implements IResetPasswordDetails {
    email?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IResetPasswordDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IResetPasswordDetails {
    email?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class PatientBank extends EntityBase implements IPatientBank {
    patientBankID!: string;
    patientID!: string;
    currencyEnum!: CurrencyEnum;
    bankName!: string;
    accountNumber!: string;
    sortCode!: string;

    constructor(data?: IPatientBank) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientBankID = _data["patientBankID"];
            this.patientID = _data["patientID"];
            this.currencyEnum = _data["currencyEnum"];
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
            this.sortCode = _data["sortCode"];
        }
    }

    static fromJS(data: any): PatientBank {
        data = typeof data === 'object' ? data : {};
        let result = new PatientBank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientBankID"] = this.patientBankID;
        data["patientID"] = this.patientID;
        data["currencyEnum"] = this.currencyEnum;
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["sortCode"] = this.sortCode;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientBank extends IEntityBase {
    patientBankID: string;
    patientID: string;
    currencyEnum: CurrencyEnum;
    bankName: string;
    accountNumber: string;
    sortCode: string;
}

export class PatientCareTeamDTO implements IPatientCareTeamDTO {
    providerID?: string;
    providerImageDetailID?: string | undefined;
    fullName?: string | undefined;
    storeName?: string | undefined;
    storeItemName?: string | undefined;
    lastConsultDate?: Date | undefined;
    nextAvailableAppointmentDate?: Date | undefined;
    isFavorite?: boolean;
    providerTags?: ProviderTag[] | undefined;
    providerTypeTag?: Tag | undefined;
    rating?: number;
    ratingCount?: number;

    constructor(data?: IPatientCareTeamDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.providerImageDetailID = _data["providerImageDetailID"];
            this.fullName = _data["fullName"];
            this.storeName = _data["storeName"];
            this.storeItemName = _data["storeItemName"];
            this.lastConsultDate = _data["lastConsultDate"] ? new Date(_data["lastConsultDate"].toString()) : <any>undefined;
            this.nextAvailableAppointmentDate = _data["nextAvailableAppointmentDate"] ? new Date(_data["nextAvailableAppointmentDate"].toString()) : <any>undefined;
            this.isFavorite = _data["isFavorite"];
            if (Array.isArray(_data["providerTags"])) {
                this.providerTags = [] as any;
                for (let item of _data["providerTags"])
                    this.providerTags!.push(ProviderTag.fromJS(item));
            }
            this.providerTypeTag = _data["providerTypeTag"] ? Tag.fromJS(_data["providerTypeTag"]) : <any>undefined;
            this.rating = _data["rating"];
            this.ratingCount = _data["ratingCount"];
        }
    }

    static fromJS(data: any): PatientCareTeamDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCareTeamDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["providerImageDetailID"] = this.providerImageDetailID;
        data["fullName"] = this.fullName;
        data["storeName"] = this.storeName;
        data["storeItemName"] = this.storeItemName;
        data["lastConsultDate"] = this.lastConsultDate ? this.lastConsultDate.toISOString() : <any>undefined;
        data["nextAvailableAppointmentDate"] = this.nextAvailableAppointmentDate ? this.nextAvailableAppointmentDate.toISOString() : <any>undefined;
        data["isFavorite"] = this.isFavorite;
        if (Array.isArray(this.providerTags)) {
            data["providerTags"] = [];
            for (let item of this.providerTags)
                data["providerTags"].push(item.toJSON());
        }
        data["providerTypeTag"] = this.providerTypeTag ? this.providerTypeTag.toJSON() : <any>undefined;
        data["rating"] = this.rating;
        data["ratingCount"] = this.ratingCount;
        return data;
    }
}

export interface IPatientCareTeamDTO {
    providerID?: string;
    providerImageDetailID?: string | undefined;
    fullName?: string | undefined;
    storeName?: string | undefined;
    storeItemName?: string | undefined;
    lastConsultDate?: Date | undefined;
    nextAvailableAppointmentDate?: Date | undefined;
    isFavorite?: boolean;
    providerTags?: ProviderTag[] | undefined;
    providerTypeTag?: Tag | undefined;
    rating?: number;
    ratingCount?: number;
}

export class PatientOrderSearchResults implements IPatientOrderSearchResults {
    runTime?: string;
    message?: string | undefined;
    patientOrders?: PagedResultOfPatientOrder | undefined;

    constructor(data?: IPatientOrderSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runTime = _data["runTime"];
            this.message = _data["message"];
            this.patientOrders = _data["patientOrders"] ? PagedResultOfPatientOrder.fromJS(_data["patientOrders"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientOrderSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        data["patientOrders"] = this.patientOrders ? this.patientOrders.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPatientOrderSearchResults {
    runTime?: string;
    message?: string | undefined;
    patientOrders?: PagedResultOfPatientOrder | undefined;
}

export class PagedResultOfPatientOrder implements IPagedResultOfPatientOrder {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: PatientOrder[] | undefined;

    constructor(data?: IPagedResultOfPatientOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfPatientOrder {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPatientOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfPatientOrder {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: PatientOrder[] | undefined;
}

export class PatientOrderSearchDetails extends PagedQuery implements IPatientOrderSearchDetails {
    patientID?: string | undefined;
    qrCodeOrPatientUniqueLifetimeID?: number | undefined;
    orderStatusEnum?: OrderStatusEnum | undefined;
    taskItemStatusEnums?: string[] | undefined;

    constructor(data?: IPatientOrderSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientID = _data["patientID"];
            this.qrCodeOrPatientUniqueLifetimeID = _data["qrCodeOrPatientUniqueLifetimeID"];
            this.orderStatusEnum = _data["orderStatusEnum"];
            if (Array.isArray(_data["taskItemStatusEnums"])) {
                this.taskItemStatusEnums = [] as any;
                for (let item of _data["taskItemStatusEnums"])
                    this.taskItemStatusEnums!.push(item);
            }
        }
    }

    static fromJS(data: any): PatientOrderSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["qrCodeOrPatientUniqueLifetimeID"] = this.qrCodeOrPatientUniqueLifetimeID;
        data["orderStatusEnum"] = this.orderStatusEnum;
        if (Array.isArray(this.taskItemStatusEnums)) {
            data["taskItemStatusEnums"] = [];
            for (let item of this.taskItemStatusEnums)
                data["taskItemStatusEnums"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPatientOrderSearchDetails extends IPagedQuery {
    patientID?: string | undefined;
    qrCodeOrPatientUniqueLifetimeID?: number | undefined;
    orderStatusEnum?: OrderStatusEnum | undefined;
    taskItemStatusEnums?: string[] | undefined;
}

export class PatientOrderFinalizeResults implements IPatientOrderFinalizeResults {
    patientOrderFinalizeResultDetails?: PatientOrderFinalizeResultDetail[] | undefined;

    constructor(data?: IPatientOrderFinalizeResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["patientOrderFinalizeResultDetails"])) {
                this.patientOrderFinalizeResultDetails = [] as any;
                for (let item of _data["patientOrderFinalizeResultDetails"])
                    this.patientOrderFinalizeResultDetails!.push(PatientOrderFinalizeResultDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientOrderFinalizeResults {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderFinalizeResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patientOrderFinalizeResultDetails)) {
            data["patientOrderFinalizeResultDetails"] = [];
            for (let item of this.patientOrderFinalizeResultDetails)
                data["patientOrderFinalizeResultDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientOrderFinalizeResults {
    patientOrderFinalizeResultDetails?: PatientOrderFinalizeResultDetail[] | undefined;
}

export class PatientOrderFinalizeResultDetail implements IPatientOrderFinalizeResultDetail {
    patientOrderID?: string;
    message?: string | undefined;
    invoiceID?: string;

    constructor(data?: IPatientOrderFinalizeResultDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientOrderID = _data["patientOrderID"];
            this.message = _data["message"];
            this.invoiceID = _data["invoiceID"];
        }
    }

    static fromJS(data: any): PatientOrderFinalizeResultDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderFinalizeResultDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientOrderID"] = this.patientOrderID;
        data["message"] = this.message;
        data["invoiceID"] = this.invoiceID;
        return data;
    }
}

export interface IPatientOrderFinalizeResultDetail {
    patientOrderID?: string;
    message?: string | undefined;
    invoiceID?: string;
}

export class PatientOrderFinalizeDetails implements IPatientOrderFinalizeDetails {
    patientID?: string;
    patientOrderIDs?: string[] | undefined;
    sendToEnum?: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient?: boolean;
    prepareForPayment?: boolean;

    constructor(data?: IPatientOrderFinalizeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            if (Array.isArray(_data["patientOrderIDs"])) {
                this.patientOrderIDs = [] as any;
                for (let item of _data["patientOrderIDs"])
                    this.patientOrderIDs!.push(item);
            }
            this.sendToEnum = _data["sendToEnum"];
            this.sendToID = _data["sendToID"];
            this.sendSubject = _data["sendSubject"];
            this.sendMessage = _data["sendMessage"];
            this.sendCopyToPatient = _data["sendCopyToPatient"];
            this.prepareForPayment = _data["prepareForPayment"];
        }
    }

    static fromJS(data: any): PatientOrderFinalizeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderFinalizeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        if (Array.isArray(this.patientOrderIDs)) {
            data["patientOrderIDs"] = [];
            for (let item of this.patientOrderIDs)
                data["patientOrderIDs"].push(item);
        }
        data["sendToEnum"] = this.sendToEnum;
        data["sendToID"] = this.sendToID;
        data["sendSubject"] = this.sendSubject;
        data["sendMessage"] = this.sendMessage;
        data["sendCopyToPatient"] = this.sendCopyToPatient;
        data["prepareForPayment"] = this.prepareForPayment;
        return data;
    }
}

export interface IPatientOrderFinalizeDetails {
    patientID?: string;
    patientOrderIDs?: string[] | undefined;
    sendToEnum?: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient?: boolean;
    prepareForPayment?: boolean;
}

export class SendDeliveryOptionsResult implements ISendDeliveryOptionsResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: ISendDeliveryOptionsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendDeliveryOptionsResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendDeliveryOptionsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ISendDeliveryOptionsResult {
    success?: boolean;
    message?: string | undefined;
}

export class CreatePatientOrderFromInvoiceDetails implements ICreatePatientOrderFromInvoiceDetails {
    invoiceID?: string;
    providerUserDetailID?: string;
    storeID?: string;

    constructor(data?: ICreatePatientOrderFromInvoiceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceID = _data["invoiceID"];
            this.providerUserDetailID = _data["providerUserDetailID"];
            this.storeID = _data["storeID"];
        }
    }

    static fromJS(data: any): CreatePatientOrderFromInvoiceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientOrderFromInvoiceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceID"] = this.invoiceID;
        data["providerUserDetailID"] = this.providerUserDetailID;
        data["storeID"] = this.storeID;
        return data;
    }
}

export interface ICreatePatientOrderFromInvoiceDetails {
    invoiceID?: string;
    providerUserDetailID?: string;
    storeID?: string;
}

export class PatientOrderReportDetails extends PagedQuery implements IPatientOrderReportDetails {
    userDetailID?: string | undefined;
    storeID?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IPatientOrderReportDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.storeID = _data["storeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientOrderReportDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientOrderReportDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["storeID"] = this.storeID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientOrderReportDetails extends IPagedQuery {
    userDetailID?: string | undefined;
    storeID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class PagedResultOfPatientPrescription implements IPagedResultOfPatientPrescription {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: PatientPrescription[] | undefined;

    constructor(data?: IPagedResultOfPatientPrescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientPrescription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfPatientPrescription {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPatientPrescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfPatientPrescription {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: PatientPrescription[] | undefined;
}

export class PatientPrescriptionSearchResults implements IPatientPrescriptionSearchResults {
    runTime?: string;
    message?: string | undefined;
    patientPrescriptions?: PagedResultOfPatientPrescription | undefined;

    constructor(data?: IPatientPrescriptionSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runTime = _data["runTime"];
            this.message = _data["message"];
            this.patientPrescriptions = _data["patientPrescriptions"] ? PagedResultOfPatientPrescription.fromJS(_data["patientPrescriptions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientPrescriptionSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        data["patientPrescriptions"] = this.patientPrescriptions ? this.patientPrescriptions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPatientPrescriptionSearchResults {
    runTime?: string;
    message?: string | undefined;
    patientPrescriptions?: PagedResultOfPatientPrescription | undefined;
}

export class PatientPrescriptionSearchDetails extends PagedQuery implements IPatientPrescriptionSearchDetails {
    patientID?: string | undefined;
    qrCodeOrPatientUniqueLifetimeID?: number | undefined;
    phrConsultID?: string | undefined;
    taskItemStatusEnums?: string[] | undefined;
    prescriptionStatusEnum?: PrescriptionStatusEnum | undefined;

    constructor(data?: IPatientPrescriptionSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientID = _data["patientID"];
            this.qrCodeOrPatientUniqueLifetimeID = _data["qrCodeOrPatientUniqueLifetimeID"];
            this.phrConsultID = _data["phrConsultID"];
            if (Array.isArray(_data["taskItemStatusEnums"])) {
                this.taskItemStatusEnums = [] as any;
                for (let item of _data["taskItemStatusEnums"])
                    this.taskItemStatusEnums!.push(item);
            }
            this.prescriptionStatusEnum = _data["prescriptionStatusEnum"];
        }
    }

    static fromJS(data: any): PatientPrescriptionSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["qrCodeOrPatientUniqueLifetimeID"] = this.qrCodeOrPatientUniqueLifetimeID;
        data["phrConsultID"] = this.phrConsultID;
        if (Array.isArray(this.taskItemStatusEnums)) {
            data["taskItemStatusEnums"] = [];
            for (let item of this.taskItemStatusEnums)
                data["taskItemStatusEnums"].push(item);
        }
        data["prescriptionStatusEnum"] = this.prescriptionStatusEnum;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientPrescriptionSearchDetails extends IPagedQuery {
    patientID?: string | undefined;
    qrCodeOrPatientUniqueLifetimeID?: number | undefined;
    phrConsultID?: string | undefined;
    taskItemStatusEnums?: string[] | undefined;
    prescriptionStatusEnum?: PrescriptionStatusEnum | undefined;
}

export class PatientPrescriptionFinalizeResults implements IPatientPrescriptionFinalizeResults {
    patientPrescriptionFinalizeResultDetails?: PatientPrescriptionFinalizeResultDetail[] | undefined;

    constructor(data?: IPatientPrescriptionFinalizeResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["patientPrescriptionFinalizeResultDetails"])) {
                this.patientPrescriptionFinalizeResultDetails = [] as any;
                for (let item of _data["patientPrescriptionFinalizeResultDetails"])
                    this.patientPrescriptionFinalizeResultDetails!.push(PatientPrescriptionFinalizeResultDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientPrescriptionFinalizeResults {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionFinalizeResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patientPrescriptionFinalizeResultDetails)) {
            data["patientPrescriptionFinalizeResultDetails"] = [];
            for (let item of this.patientPrescriptionFinalizeResultDetails)
                data["patientPrescriptionFinalizeResultDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientPrescriptionFinalizeResults {
    patientPrescriptionFinalizeResultDetails?: PatientPrescriptionFinalizeResultDetail[] | undefined;
}

export class PatientPrescriptionFinalizeResultDetail implements IPatientPrescriptionFinalizeResultDetail {
    patientPrescriptionID?: string;
    message?: string | undefined;

    constructor(data?: IPatientPrescriptionFinalizeResultDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientPrescriptionID = _data["patientPrescriptionID"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PatientPrescriptionFinalizeResultDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionFinalizeResultDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientPrescriptionID"] = this.patientPrescriptionID;
        data["message"] = this.message;
        return data;
    }
}

export interface IPatientPrescriptionFinalizeResultDetail {
    patientPrescriptionID?: string;
    message?: string | undefined;
}

export class PatientPrescriptionFinalizeDetails implements IPatientPrescriptionFinalizeDetails {
    patientID?: string;
    patientPrescriptionIDs?: string[] | undefined;
    sendToEnum?: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient?: boolean;

    constructor(data?: IPatientPrescriptionFinalizeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            if (Array.isArray(_data["patientPrescriptionIDs"])) {
                this.patientPrescriptionIDs = [] as any;
                for (let item of _data["patientPrescriptionIDs"])
                    this.patientPrescriptionIDs!.push(item);
            }
            this.sendToEnum = _data["sendToEnum"];
            this.sendToID = _data["sendToID"];
            this.sendSubject = _data["sendSubject"];
            this.sendMessage = _data["sendMessage"];
            this.sendCopyToPatient = _data["sendCopyToPatient"];
        }
    }

    static fromJS(data: any): PatientPrescriptionFinalizeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionFinalizeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        if (Array.isArray(this.patientPrescriptionIDs)) {
            data["patientPrescriptionIDs"] = [];
            for (let item of this.patientPrescriptionIDs)
                data["patientPrescriptionIDs"].push(item);
        }
        data["sendToEnum"] = this.sendToEnum;
        data["sendToID"] = this.sendToID;
        data["sendSubject"] = this.sendSubject;
        data["sendMessage"] = this.sendMessage;
        data["sendCopyToPatient"] = this.sendCopyToPatient;
        return data;
    }
}

export interface IPatientPrescriptionFinalizeDetails {
    patientID?: string;
    patientPrescriptionIDs?: string[] | undefined;
    sendToEnum?: SendToEnum;
    sendToID?: string | undefined;
    sendSubject?: string | undefined;
    sendMessage?: string | undefined;
    sendCopyToPatient?: boolean;
}

export class PatientPrescriptionRefillDetails implements IPatientPrescriptionRefillDetails {
    patientID!: string;
    phrConsultID!: string;
    providerID!: string;
    refillCount!: number;
    providerLocationID!: string;
    phrMedications?: PHRMedication[] | undefined;

    constructor(data?: IPatientPrescriptionRefillDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            this.phrConsultID = _data["phrConsultID"];
            this.providerID = _data["providerID"];
            this.refillCount = _data["refillCount"];
            this.providerLocationID = _data["providerLocationID"];
            if (Array.isArray(_data["phrMedications"])) {
                this.phrMedications = [] as any;
                for (let item of _data["phrMedications"])
                    this.phrMedications!.push(PHRMedication.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientPrescriptionRefillDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionRefillDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["phrConsultID"] = this.phrConsultID;
        data["providerID"] = this.providerID;
        data["refillCount"] = this.refillCount;
        data["providerLocationID"] = this.providerLocationID;
        if (Array.isArray(this.phrMedications)) {
            data["phrMedications"] = [];
            for (let item of this.phrMedications)
                data["phrMedications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientPrescriptionRefillDetails {
    patientID: string;
    phrConsultID: string;
    providerID: string;
    refillCount: number;
    providerLocationID: string;
    phrMedications?: PHRMedication[] | undefined;
}

export class PagedResultOfPatient implements IPagedResultOfPatient {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Patient[] | undefined;

    constructor(data?: IPagedResultOfPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Patient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfPatient {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfPatient {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Patient[] | undefined;
}

export class PatientsDetail extends PagedQuery implements IPatientsDetail {

    constructor(data?: IPatientsDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PatientsDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PatientsDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPatientsDetail extends IPagedQuery {
}

export class PagedResult2OfPatient implements IPagedResult2OfPatient {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Patient[] | undefined;
    totalPages?: number;
    pageNumber?: number;
    hasNextPage?: boolean;
    hasPrevPage?: boolean;

    constructor(data?: IPagedResult2OfPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Patient.fromJS(item));
            }
            this.totalPages = _data["totalPages"];
            this.pageNumber = _data["pageNumber"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPrevPage = _data["hasPrevPage"];
        }
    }

    static fromJS(data: any): PagedResult2OfPatient {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult2OfPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalPages"] = this.totalPages;
        data["pageNumber"] = this.pageNumber;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPrevPage"] = this.hasPrevPage;
        return data;
    }
}

export interface IPagedResult2OfPatient {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Patient[] | undefined;
    totalPages?: number;
    pageNumber?: number;
    hasNextPage?: boolean;
    hasPrevPage?: boolean;
}

export class BanAccessToDiscussionsDTO implements IBanAccessToDiscussionsDTO {
    userDetailID!: string;
    ban!: boolean;
    reason!: string;

    constructor(data?: IBanAccessToDiscussionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.ban = _data["ban"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): BanAccessToDiscussionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BanAccessToDiscussionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["ban"] = this.ban;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IBanAccessToDiscussionsDTO {
    userDetailID: string;
    ban: boolean;
    reason: string;
}

export class ProviderPatientsSearchDetails extends PagedQuery implements IProviderPatientsSearchDetails {
    searchText?: string | undefined;
    userDetailID?: string;
    asOfDate?: Date;

    constructor(data?: IProviderPatientsSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchText = _data["searchText"];
            this.userDetailID = _data["userDetailID"];
            this.asOfDate = _data["asOfDate"] ? new Date(_data["asOfDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderPatientsSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPatientsSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["userDetailID"] = this.userDetailID;
        data["asOfDate"] = this.asOfDate ? this.asOfDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderPatientsSearchDetails extends IPagedQuery {
    searchText?: string | undefined;
    userDetailID?: string;
    asOfDate?: Date;
}

export class PatientSearchDetails extends PagedQuery implements IPatientSearchDetails {
    searchText?: string | undefined;
    birthYear?: number | undefined;
    birthMonth?: number | undefined;
    reason?: string | undefined;
    globalSearch?: boolean;

    constructor(data?: IPatientSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchText = _data["searchText"];
            this.birthYear = _data["birthYear"];
            this.birthMonth = _data["birthMonth"];
            this.reason = _data["reason"];
            this.globalSearch = _data["globalSearch"];
        }
    }

    static fromJS(data: any): PatientSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["birthYear"] = this.birthYear;
        data["birthMonth"] = this.birthMonth;
        data["reason"] = this.reason;
        data["globalSearch"] = this.globalSearch;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientSearchDetails extends IPagedQuery {
    searchText?: string | undefined;
    birthYear?: number | undefined;
    birthMonth?: number | undefined;
    reason?: string | undefined;
    globalSearch?: boolean;
}

export class ChangeEmailAddressAdminDetails implements IChangeEmailAddressAdminDetails {
    oldEmailAddress?: string | undefined;
    newEmailAddress?: string | undefined;

    constructor(data?: IChangeEmailAddressAdminDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldEmailAddress = _data["oldEmailAddress"];
            this.newEmailAddress = _data["newEmailAddress"];
        }
    }

    static fromJS(data: any): ChangeEmailAddressAdminDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailAddressAdminDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldEmailAddress"] = this.oldEmailAddress;
        data["newEmailAddress"] = this.newEmailAddress;
        return data;
    }
}

export interface IChangeEmailAddressAdminDetails {
    oldEmailAddress?: string | undefined;
    newEmailAddress?: string | undefined;
}

export class RequiredPublicInsuranceDTO implements IRequiredPublicInsuranceDTO {
    phrInsurance?: PatientInsurance | undefined;
    patient?: Patient | undefined;

    constructor(data?: IRequiredPublicInsuranceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phrInsurance = _data["phrInsurance"] ? PatientInsurance.fromJS(_data["phrInsurance"]) : <any>undefined;
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequiredPublicInsuranceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredPublicInsuranceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phrInsurance"] = this.phrInsurance ? this.phrInsurance.toJSON() : <any>undefined;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequiredPublicInsuranceDTO {
    phrInsurance?: PatientInsurance | undefined;
    patient?: Patient | undefined;
}

export class PHRSummaryDTO implements IPHRSummaryDTO {
    displaySortOrder?: number;
    phrCategoryName?: string | undefined;
    phrCategory?: PatientAccessEnum;
    count?: number;
    phrSummaryDetails?: PHRSummaryDetailDTO[] | undefined;
    summaryStatusEnum?: PHRSummaryStatusEnum;

    constructor(data?: IPHRSummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displaySortOrder = _data["displaySortOrder"];
            this.phrCategoryName = _data["phrCategoryName"];
            this.phrCategory = _data["phrCategory"];
            this.count = _data["count"];
            if (Array.isArray(_data["phrSummaryDetails"])) {
                this.phrSummaryDetails = [] as any;
                for (let item of _data["phrSummaryDetails"])
                    this.phrSummaryDetails!.push(PHRSummaryDetailDTO.fromJS(item));
            }
            this.summaryStatusEnum = _data["summaryStatusEnum"];
        }
    }

    static fromJS(data: any): PHRSummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRSummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displaySortOrder"] = this.displaySortOrder;
        data["phrCategoryName"] = this.phrCategoryName;
        data["phrCategory"] = this.phrCategory;
        data["count"] = this.count;
        if (Array.isArray(this.phrSummaryDetails)) {
            data["phrSummaryDetails"] = [];
            for (let item of this.phrSummaryDetails)
                data["phrSummaryDetails"].push(item.toJSON());
        }
        data["summaryStatusEnum"] = this.summaryStatusEnum;
        return data;
    }
}

export interface IPHRSummaryDTO {
    displaySortOrder?: number;
    phrCategoryName?: string | undefined;
    phrCategory?: PatientAccessEnum;
    count?: number;
    phrSummaryDetails?: PHRSummaryDetailDTO[] | undefined;
    summaryStatusEnum?: PHRSummaryStatusEnum;
}

export class PHRSummaryDetailDTO implements IPHRSummaryDetailDTO {
    detailDate?: Date;
    data?: string | undefined;
    phrPrimaryKey?: string;

    constructor(data?: IPHRSummaryDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailDate = _data["detailDate"] ? new Date(_data["detailDate"].toString()) : <any>undefined;
            this.data = _data["data"];
            this.phrPrimaryKey = _data["phrPrimaryKey"];
        }
    }

    static fromJS(data: any): PHRSummaryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRSummaryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailDate"] = this.detailDate ? this.detailDate.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["phrPrimaryKey"] = this.phrPrimaryKey;
        return data;
    }
}

export interface IPHRSummaryDetailDTO {
    detailDate?: Date;
    data?: string | undefined;
    phrPrimaryKey?: string;
}

export enum PHRSummaryStatusEnum {
    Normal = "Normal",
    Abnormal = "Abnormal",
    Alert = "Alert",
}

export class CellPhoneValidateDetails implements ICellPhoneValidateDetails {
    cellPhoneNumber?: string | undefined;
    token?: string | undefined;

    constructor(data?: ICellPhoneValidateDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): CellPhoneValidateDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CellPhoneValidateDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["token"] = this.token;
        return data;
    }
}

export interface ICellPhoneValidateDetails {
    cellPhoneNumber?: string | undefined;
    token?: string | undefined;
}

export class PagedResultOfRecentPatientDTO implements IPagedResultOfRecentPatientDTO {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: RecentPatientDTO[] | undefined;

    constructor(data?: IPagedResultOfRecentPatientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RecentPatientDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfRecentPatientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfRecentPatientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfRecentPatientDTO {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: RecentPatientDTO[] | undefined;
}

export class RecentPatientDTO implements IRecentPatientDTO {
    patientID?: string;
    patient?: Patient | undefined;
    lastAccessedDate?: Date;
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;

    constructor(data?: IRecentPatientDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            this.patient = _data["patient"] ? Patient.fromJS(_data["patient"]) : <any>undefined;
            this.lastAccessedDate = _data["lastAccessedDate"] ? new Date(_data["lastAccessedDate"].toString()) : <any>undefined;
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RecentPatientDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecentPatientDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["lastAccessedDate"] = this.lastAccessedDate ? this.lastAccessedDate.toISOString() : <any>undefined;
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IRecentPatientDTO {
    patientID?: string;
    patient?: Patient | undefined;
    lastAccessedDate?: Date;
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
}

export class RecentPatientDetails extends PagedQuery implements IRecentPatientDetails {
    providerID!: string;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IRecentPatientDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerID = _data["providerID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentPatientDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RecentPatientDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRecentPatientDetails extends IPagedQuery {
    providerID: string;
    startDate: Date;
    endDate: Date;
}

export class PagedResultOfPatientNotification implements IPagedResultOfPatientNotification {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: PatientNotification[] | undefined;

    constructor(data?: IPagedResultOfPatientNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfPatientNotification {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPatientNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfPatientNotification {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: PatientNotification[] | undefined;
}

export class ProviderPatientNotificationDetails extends PagedQuery implements IProviderPatientNotificationDetails {
    providerID!: string;

    constructor(data?: IProviderPatientNotificationDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerID = _data["providerID"];
        }
    }

    static fromJS(data: any): ProviderPatientNotificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPatientNotificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderPatientNotificationDetails extends IPagedQuery {
    providerID: string;
}

export class PatientRecentHistoryDTO implements IPatientRecentHistoryDTO {
    patientID?: string;
    startDate?: Date;
    endDate?: Date;
    patientRecentHistoryDetails?: PatientRecentHistoryDetailDTO[] | undefined;

    constructor(data?: IPatientRecentHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["patientRecentHistoryDetails"])) {
                this.patientRecentHistoryDetails = [] as any;
                for (let item of _data["patientRecentHistoryDetails"])
                    this.patientRecentHistoryDetails!.push(PatientRecentHistoryDetailDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientRecentHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRecentHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.patientRecentHistoryDetails)) {
            data["patientRecentHistoryDetails"] = [];
            for (let item of this.patientRecentHistoryDetails)
                data["patientRecentHistoryDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientRecentHistoryDTO {
    patientID?: string;
    startDate?: Date;
    endDate?: Date;
    patientRecentHistoryDetails?: PatientRecentHistoryDetailDTO[] | undefined;
}

export class PatientRecentHistoryDetailDTO implements IPatientRecentHistoryDetailDTO {
    patientRecentHistoryTypeEnum?: PatientRecentHistoryTypeEnum;
    detailPrimaryKey?: string;
    detailDate?: Date;
    description?: string | undefined;
    qrCode?: number;
    totalAmount?: number | undefined;
    invoiceID?: string | undefined;
    invoiceStatusEnum?: InvoiceStatusEnum | undefined;
    currencyEnum?: CurrencyEnum | undefined;

    constructor(data?: IPatientRecentHistoryDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientRecentHistoryTypeEnum = _data["patientRecentHistoryTypeEnum"];
            this.detailPrimaryKey = _data["detailPrimaryKey"];
            this.detailDate = _data["detailDate"] ? new Date(_data["detailDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.qrCode = _data["qrCode"];
            this.totalAmount = _data["totalAmount"];
            this.invoiceID = _data["invoiceID"];
            this.invoiceStatusEnum = _data["invoiceStatusEnum"];
            this.currencyEnum = _data["currencyEnum"];
        }
    }

    static fromJS(data: any): PatientRecentHistoryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRecentHistoryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientRecentHistoryTypeEnum"] = this.patientRecentHistoryTypeEnum;
        data["detailPrimaryKey"] = this.detailPrimaryKey;
        data["detailDate"] = this.detailDate ? this.detailDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["qrCode"] = this.qrCode;
        data["totalAmount"] = this.totalAmount;
        data["invoiceID"] = this.invoiceID;
        data["invoiceStatusEnum"] = this.invoiceStatusEnum;
        data["currencyEnum"] = this.currencyEnum;
        return data;
    }
}

export interface IPatientRecentHistoryDetailDTO {
    patientRecentHistoryTypeEnum?: PatientRecentHistoryTypeEnum;
    detailPrimaryKey?: string;
    detailDate?: Date;
    description?: string | undefined;
    qrCode?: number;
    totalAmount?: number | undefined;
    invoiceID?: string | undefined;
    invoiceStatusEnum?: InvoiceStatusEnum | undefined;
    currencyEnum?: CurrencyEnum | undefined;
}

export enum PatientRecentHistoryTypeEnum {
    Prescription = "Prescription",
    Order = "Order",
    Consult = "Consult",
}

export class PatientRecentHistoryDetails implements IPatientRecentHistoryDetails {
    patientID?: string;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IPatientRecentHistoryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientRecentHistoryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRecentHistoryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientRecentHistoryDetails {
    patientID?: string;
    startDate?: Date;
    endDate?: Date;
}

export class AddFundsToWalletResponse implements IAddFundsToWalletResponse {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IAddFundsToWalletResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AddFundsToWalletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddFundsToWalletResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IAddFundsToWalletResponse {
    success?: boolean;
    message?: string | undefined;
}

export class PatientSignupsDTO implements IPatientSignupsDTO {
    userDetailID?: string;
    createdDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    country?: string | undefined;
    provinceState?: string | undefined;
    cityTown?: string | undefined;
    cellPhoneNumber?: string | undefined;
    homePhoneNumber?: string | undefined;
    gender?: string | undefined;
    vip?: boolean;
    vipNotes?: string | undefined;
    abusive?: boolean;
    abusiveNotes?: string | undefined;
    onboardPercentComplete?: number | undefined;
    lastPingDate?: Date;
    salesPersonName?: string | undefined;

    constructor(data?: IPatientSignupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.country = _data["country"];
            this.provinceState = _data["provinceState"];
            this.cityTown = _data["cityTown"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.homePhoneNumber = _data["homePhoneNumber"];
            this.gender = _data["gender"];
            this.vip = _data["vip"];
            this.vipNotes = _data["vipNotes"];
            this.abusive = _data["abusive"];
            this.abusiveNotes = _data["abusiveNotes"];
            this.onboardPercentComplete = _data["onboardPercentComplete"];
            this.lastPingDate = _data["lastPingDate"] ? new Date(_data["lastPingDate"].toString()) : <any>undefined;
            this.salesPersonName = _data["salesPersonName"];
        }
    }

    static fromJS(data: any): PatientSignupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSignupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["country"] = this.country;
        data["provinceState"] = this.provinceState;
        data["cityTown"] = this.cityTown;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["homePhoneNumber"] = this.homePhoneNumber;
        data["gender"] = this.gender;
        data["vip"] = this.vip;
        data["vipNotes"] = this.vipNotes;
        data["abusive"] = this.abusive;
        data["abusiveNotes"] = this.abusiveNotes;
        data["onboardPercentComplete"] = this.onboardPercentComplete;
        data["lastPingDate"] = this.lastPingDate ? this.lastPingDate.toISOString() : <any>undefined;
        data["salesPersonName"] = this.salesPersonName;
        return data;
    }
}

export interface IPatientSignupsDTO {
    userDetailID?: string;
    createdDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    country?: string | undefined;
    provinceState?: string | undefined;
    cityTown?: string | undefined;
    cellPhoneNumber?: string | undefined;
    homePhoneNumber?: string | undefined;
    gender?: string | undefined;
    vip?: boolean;
    vipNotes?: string | undefined;
    abusive?: boolean;
    abusiveNotes?: string | undefined;
    onboardPercentComplete?: number | undefined;
    lastPingDate?: Date;
    salesPersonName?: string | undefined;
}

export class PatientSignupDTODetails implements IPatientSignupDTODetails {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IPatientSignupDTODetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientSignupDTODetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSignupDTODetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientSignupDTODetails {
    startDate?: Date;
    endDate?: Date;
}

export class PagedResultOfPatientSignupsDTO implements IPagedResultOfPatientSignupsDTO {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: PatientSignupsDTO[] | undefined;

    constructor(data?: IPagedResultOfPatientSignupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PatientSignupsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfPatientSignupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPatientSignupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfPatientSignupsDTO {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: PatientSignupsDTO[] | undefined;
}

export class CurrencyExchangeDetails implements ICurrencyExchangeDetails {
    fromCurrencyEnum?: CurrencyEnum;
    fromAmount?: number;
    toCurrencyEnum?: CurrencyEnum;
    spread?: boolean;
    round?: boolean;

    constructor(data?: ICurrencyExchangeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromCurrencyEnum = _data["fromCurrencyEnum"];
            this.fromAmount = _data["fromAmount"];
            this.toCurrencyEnum = _data["toCurrencyEnum"];
            this.spread = _data["spread"];
            this.round = _data["round"];
        }
    }

    static fromJS(data: any): CurrencyExchangeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyExchangeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromCurrencyEnum"] = this.fromCurrencyEnum;
        data["fromAmount"] = this.fromAmount;
        data["toCurrencyEnum"] = this.toCurrencyEnum;
        data["spread"] = this.spread;
        data["round"] = this.round;
        return data;
    }
}

export interface ICurrencyExchangeDetails {
    fromCurrencyEnum?: CurrencyEnum;
    fromAmount?: number;
    toCurrencyEnum?: CurrencyEnum;
    spread?: boolean;
    round?: boolean;
}

export class PaymentIntentResponse implements IPaymentIntentResponse {
    clientSecret?: string | undefined;

    constructor(data?: IPaymentIntentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): PaymentIntentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentIntentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IPaymentIntentResponse {
    clientSecret?: string | undefined;
}

export class PaymentIntentRequest implements IPaymentIntentRequest {
    amount!: number;
    currency!: string;
    processorID!: string;
    isDonation?: boolean;

    constructor(data?: IPaymentIntentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.processorID = _data["processorID"];
            this.isDonation = _data["isDonation"];
        }
    }

    static fromJS(data: any): PaymentIntentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentIntentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["processorID"] = this.processorID;
        data["isDonation"] = this.isDonation;
        return data;
    }
}

export interface IPaymentIntentRequest {
    amount: number;
    currency: string;
    processorID: string;
    isDonation?: boolean;
}

export class WebhookLog extends EntityBase implements IWebhookLog {
    webhookID!: string;
    associatedID?: string | undefined;
    description!: string;
    response!: string;

    constructor(data?: IWebhookLog) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.webhookID = _data["webhookID"];
            this.associatedID = _data["associatedID"];
            this.description = _data["description"];
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): WebhookLog {
        data = typeof data === 'object' ? data : {};
        let result = new WebhookLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webhookID"] = this.webhookID;
        data["associatedID"] = this.associatedID;
        data["description"] = this.description;
        data["response"] = this.response;
        super.toJSON(data);
        return data;
    }
}

export interface IWebhookLog extends IEntityBase {
    webhookID: string;
    associatedID?: string | undefined;
    description: string;
    response: string;
}

export class SearchWebHookLogDetails implements ISearchWebHookLogDetails {
    startDate!: Date;
    endDate!: Date;

    constructor(data?: ISearchWebHookLogDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchWebHookLogDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SearchWebHookLogDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearchWebHookLogDetails {
    startDate: Date;
    endDate: Date;
}

export class PayoutRunResult extends EntityBase implements IPayoutRunResult {
    payoutRunResultID!: string;
    payoutRunID!: string;
    currencyEnum!: CurrencyEnum;
    amount!: number;
    paid!: boolean;
    paidDate?: Date | undefined;
    payoutRun?: PayoutRun | undefined;

    constructor(data?: IPayoutRunResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payoutRunResultID = _data["payoutRunResultID"];
            this.payoutRunID = _data["payoutRunID"];
            this.currencyEnum = _data["currencyEnum"];
            this.amount = _data["amount"];
            this.paid = _data["paid"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.payoutRun = _data["payoutRun"] ? PayoutRun.fromJS(_data["payoutRun"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayoutRunResult {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutRunResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payoutRunResultID"] = this.payoutRunResultID;
        data["payoutRunID"] = this.payoutRunID;
        data["currencyEnum"] = this.currencyEnum;
        data["amount"] = this.amount;
        data["paid"] = this.paid;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["payoutRun"] = this.payoutRun ? this.payoutRun.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPayoutRunResult extends IEntityBase {
    payoutRunResultID: string;
    payoutRunID: string;
    currencyEnum: CurrencyEnum;
    amount: number;
    paid: boolean;
    paidDate?: Date | undefined;
    payoutRun?: PayoutRun | undefined;
}

export class PayoutRun extends EntityBase implements IPayoutRun {
    payoutRunID!: string;
    payoutID!: string;
    runID!: string;
    runStartDate!: Date;
    runEndDate?: Date | undefined;
    payoutRunStatusEnum!: PayoutRunStatusEnum;
    statementID?: string | undefined;
    message?: string | undefined;
    payoutRunResults?: PayoutRunResult[] | undefined;
    payout?: Payout | undefined;

    constructor(data?: IPayoutRun) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payoutRunID = _data["payoutRunID"];
            this.payoutID = _data["payoutID"];
            this.runID = _data["runID"];
            this.runStartDate = _data["runStartDate"] ? new Date(_data["runStartDate"].toString()) : <any>undefined;
            this.runEndDate = _data["runEndDate"] ? new Date(_data["runEndDate"].toString()) : <any>undefined;
            this.payoutRunStatusEnum = _data["payoutRunStatusEnum"];
            this.statementID = _data["statementID"];
            this.message = _data["message"];
            if (Array.isArray(_data["payoutRunResults"])) {
                this.payoutRunResults = [] as any;
                for (let item of _data["payoutRunResults"])
                    this.payoutRunResults!.push(PayoutRunResult.fromJS(item));
            }
            this.payout = _data["payout"] ? Payout.fromJS(_data["payout"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PayoutRun {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutRun();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payoutRunID"] = this.payoutRunID;
        data["payoutID"] = this.payoutID;
        data["runID"] = this.runID;
        data["runStartDate"] = this.runStartDate ? this.runStartDate.toISOString() : <any>undefined;
        data["runEndDate"] = this.runEndDate ? this.runEndDate.toISOString() : <any>undefined;
        data["payoutRunStatusEnum"] = this.payoutRunStatusEnum;
        data["statementID"] = this.statementID;
        data["message"] = this.message;
        if (Array.isArray(this.payoutRunResults)) {
            data["payoutRunResults"] = [];
            for (let item of this.payoutRunResults)
                data["payoutRunResults"].push(item.toJSON());
        }
        data["payout"] = this.payout ? this.payout.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPayoutRun extends IEntityBase {
    payoutRunID: string;
    payoutID: string;
    runID: string;
    runStartDate: Date;
    runEndDate?: Date | undefined;
    payoutRunStatusEnum: PayoutRunStatusEnum;
    statementID?: string | undefined;
    message?: string | undefined;
    payoutRunResults?: PayoutRunResult[] | undefined;
    payout?: Payout | undefined;
}

export enum PayoutRunStatusEnum {
    NotRun = "NotRun",
    InProgress = "InProgress",
    Completed = "Completed",
    Failed = "Failed",
}

export class Payout extends EntityBase implements IPayout {
    payoutID!: string;
    providerID?: string | undefined;
    storeID?: string | undefined;
    organizationID?: string | undefined;
    currencyEnum!: CurrencyEnum;
    bankID?: string | undefined;
    bankName?: string | undefined;
    accountNumber!: string;
    branchNumber?: string | undefined;
    institutionNumber?: string | undefined;
    designationNumber?: string | undefined;
    paymentCycleEnum!: PaymentCycleEnum;
    paymentCycleStartDate!: Date;
    nextPaymentCycleDate!: Date;
    payoutRuns?: PayoutRun[] | undefined;
    provider?: Provider | undefined;
    store?: Store | undefined;
    organization?: Organization | undefined;

    constructor(data?: IPayout) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payoutID = _data["payoutID"];
            this.providerID = _data["providerID"];
            this.storeID = _data["storeID"];
            this.organizationID = _data["organizationID"];
            this.currencyEnum = _data["currencyEnum"];
            this.bankID = _data["bankID"];
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
            this.branchNumber = _data["branchNumber"];
            this.institutionNumber = _data["institutionNumber"];
            this.designationNumber = _data["designationNumber"];
            this.paymentCycleEnum = _data["paymentCycleEnum"];
            this.paymentCycleStartDate = _data["paymentCycleStartDate"] ? new Date(_data["paymentCycleStartDate"].toString()) : <any>undefined;
            this.nextPaymentCycleDate = _data["nextPaymentCycleDate"] ? new Date(_data["nextPaymentCycleDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["payoutRuns"])) {
                this.payoutRuns = [] as any;
                for (let item of _data["payoutRuns"])
                    this.payoutRuns!.push(PayoutRun.fromJS(item));
            }
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Payout {
        data = typeof data === 'object' ? data : {};
        let result = new Payout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payoutID"] = this.payoutID;
        data["providerID"] = this.providerID;
        data["storeID"] = this.storeID;
        data["organizationID"] = this.organizationID;
        data["currencyEnum"] = this.currencyEnum;
        data["bankID"] = this.bankID;
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["branchNumber"] = this.branchNumber;
        data["institutionNumber"] = this.institutionNumber;
        data["designationNumber"] = this.designationNumber;
        data["paymentCycleEnum"] = this.paymentCycleEnum;
        data["paymentCycleStartDate"] = this.paymentCycleStartDate ? this.paymentCycleStartDate.toISOString() : <any>undefined;
        data["nextPaymentCycleDate"] = this.nextPaymentCycleDate ? this.nextPaymentCycleDate.toISOString() : <any>undefined;
        if (Array.isArray(this.payoutRuns)) {
            data["payoutRuns"] = [];
            for (let item of this.payoutRuns)
                data["payoutRuns"].push(item.toJSON());
        }
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPayout extends IEntityBase {
    payoutID: string;
    providerID?: string | undefined;
    storeID?: string | undefined;
    organizationID?: string | undefined;
    currencyEnum: CurrencyEnum;
    bankID?: string | undefined;
    bankName?: string | undefined;
    accountNumber: string;
    branchNumber?: string | undefined;
    institutionNumber?: string | undefined;
    designationNumber?: string | undefined;
    paymentCycleEnum: PaymentCycleEnum;
    paymentCycleStartDate: Date;
    nextPaymentCycleDate: Date;
    payoutRuns?: PayoutRun[] | undefined;
    provider?: Provider | undefined;
    store?: Store | undefined;
    organization?: Organization | undefined;
}

export class BankListResponse implements IBankListResponse {
    status?: string | undefined;
    banks?: BankInfo[] | undefined;

    constructor(data?: IBankListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["banks"])) {
                this.banks = [] as any;
                for (let item of _data["banks"])
                    this.banks!.push(BankInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BankListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBankListResponse {
    status?: string | undefined;
    banks?: BankInfo[] | undefined;
}

export class BankInfo implements IBankInfo {
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IBankInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BankInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BankInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IBankInfo {
    code?: string | undefined;
    name?: string | undefined;
}

export class BankAccountDetailsResponse implements IBankAccountDetailsResponse {
    status?: string | undefined;
    account?: AccountInfo | undefined;

    constructor(data?: IBankAccountDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.account = _data["account"] ? AccountInfo.fromJS(_data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BankAccountDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBankAccountDetailsResponse {
    status?: string | undefined;
    account?: AccountInfo | undefined;
}

export class AccountInfo implements IAccountInfo {
    bankCode?: string | undefined;
    accountName?: string | undefined;
    accountNumber?: string | undefined;

    constructor(data?: IAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankCode = _data["bankCode"];
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): AccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankCode"] = this.bankCode;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IAccountInfo {
    bankCode?: string | undefined;
    accountName?: string | undefined;
    accountNumber?: string | undefined;
}

export class BankTransferResponse implements IBankTransferResponse {
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IBankTransferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BankTransferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BankTransferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IBankTransferResponse {
    status?: string | undefined;
    message?: string | undefined;
}

export class PayoutRunResultBankTransferRequest implements IPayoutRunResultBankTransferRequest {
    currencyEnum?: CurrencyEnum;
    payoutRunResultID?: string;
    code?: string | undefined;
    note?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    sourceId?: string | undefined;

    constructor(data?: IPayoutRunResultBankTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyEnum = _data["currencyEnum"];
            this.payoutRunResultID = _data["payoutRunResultID"];
            this.code = _data["code"];
            this.note = _data["note"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.sourceId = _data["sourceId"];
        }
    }

    static fromJS(data: any): PayoutRunResultBankTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutRunResultBankTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyEnum"] = this.currencyEnum;
        data["payoutRunResultID"] = this.payoutRunResultID;
        data["code"] = this.code;
        data["note"] = this.note;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["sourceId"] = this.sourceId;
        return data;
    }
}

export interface IPayoutRunResultBankTransferRequest {
    currencyEnum?: CurrencyEnum;
    payoutRunResultID?: string;
    code?: string | undefined;
    note?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    sourceId?: string | undefined;
}

export class PayoutCurrenciesResult implements IPayoutCurrenciesResult {
    currencies?: CurrencyEnum[] | undefined;

    constructor(data?: IPayoutCurrenciesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies!.push(item);
            }
        }
    }

    static fromJS(data: any): PayoutCurrenciesResult {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutCurrenciesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item);
        }
        return data;
    }
}

export interface IPayoutCurrenciesResult {
    currencies?: CurrencyEnum[] | undefined;
}

export class PayoutCurrenciesDetails implements IPayoutCurrenciesDetails {
    providerID?: string | undefined;
    storeID?: string | undefined;
    organizationID?: string | undefined;

    constructor(data?: IPayoutCurrenciesDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.storeID = _data["storeID"];
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): PayoutCurrenciesDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PayoutCurrenciesDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["storeID"] = this.storeID;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface IPayoutCurrenciesDetails {
    providerID?: string | undefined;
    storeID?: string | undefined;
    organizationID?: string | undefined;
}

export class Ping extends EntityBase implements IPing {
    pingID!: string;
    pingDate!: Date;
    userDetailID!: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    ipAddress?: string | undefined;
    userAgent?: string | undefined;
    isOnline?: boolean;

    constructor(data?: IPing) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pingID = _data["pingID"];
            this.pingDate = _data["pingDate"] ? new Date(_data["pingDate"].toString()) : <any>undefined;
            this.userDetailID = _data["userDetailID"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): Ping {
        data = typeof data === 'object' ? data : {};
        let result = new Ping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pingID"] = this.pingID;
        data["pingDate"] = this.pingDate ? this.pingDate.toISOString() : <any>undefined;
        data["userDetailID"] = this.userDetailID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        data["isOnline"] = this.isOnline;
        super.toJSON(data);
        return data;
    }
}

export interface IPing extends IEntityBase {
    pingID: string;
    pingDate: Date;
    userDetailID: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    ipAddress?: string | undefined;
    userAgent?: string | undefined;
    isOnline?: boolean;
}

export class PingDTO extends Ping implements IPingDTO {
    userDetail?: UserDetail | undefined;

    constructor(data?: IPingDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPingDTO extends IPing {
    userDetail?: UserDetail | undefined;
}

export class LastPingRequest implements ILastPingRequest {
    userDetailIDs?: string[] | undefined;

    constructor(data?: ILastPingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userDetailIDs"])) {
                this.userDetailIDs = [] as any;
                for (let item of _data["userDetailIDs"])
                    this.userDetailIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): LastPingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LastPingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userDetailIDs)) {
            data["userDetailIDs"] = [];
            for (let item of this.userDetailIDs)
                data["userDetailIDs"].push(item);
        }
        return data;
    }
}

export interface ILastPingRequest {
    userDetailIDs?: string[] | undefined;
}

export class ProviderAppointmentSearchResults implements IProviderAppointmentSearchResults {
    runTime?: string;
    message?: string | undefined;
    appointments?: ProviderAppointment[] | undefined;
    stores?: Store[] | undefined;
    providers?: ProviderDTO[] | undefined;

    constructor(data?: IProviderAppointmentSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runTime = _data["runTime"];
            this.message = _data["message"];
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(ProviderAppointment.fromJS(item));
            }
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores!.push(Store.fromJS(item));
            }
            if (Array.isArray(_data["providers"])) {
                this.providers = [] as any;
                for (let item of _data["providers"])
                    this.providers!.push(ProviderDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderAppointmentSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderAppointmentSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        if (Array.isArray(this.providers)) {
            data["providers"] = [];
            for (let item of this.providers)
                data["providers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProviderAppointmentSearchResults {
    runTime?: string;
    message?: string | undefined;
    appointments?: ProviderAppointment[] | undefined;
    stores?: Store[] | undefined;
    providers?: ProviderDTO[] | undefined;
}

export class ProviderDTO implements IProviderDTO {
    providerStoreItems?: ProviderStoreItemDTO[] | undefined;
    providerID?: string;
    imageDetailID?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    genderEnum!: GenderEnum;
    primaryLanguageID?: string | undefined;
    timeZone!: string;
    aboutMe?: string | undefined;
    primaryLanguage?: Language | undefined;
    timeZoneInfo?: TimeZoneInfo | undefined;
    country?: Country | undefined;
    nextAvailableProviderAppointment?: ProviderAppointment | undefined;
    lastConsultDate?: Date | undefined;
    isFavorite?: boolean;
    providerTags?: ProviderTag[] | undefined;
    providerTypeTag?: Tag | undefined;
    rating?: number;
    ratingCount?: number;

    constructor(data?: IProviderDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["providerStoreItems"])) {
                this.providerStoreItems = [] as any;
                for (let item of _data["providerStoreItems"])
                    this.providerStoreItems!.push(ProviderStoreItemDTO.fromJS(item));
            }
            this.providerID = _data["providerID"];
            this.imageDetailID = _data["imageDetailID"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.genderEnum = _data["genderEnum"];
            this.primaryLanguageID = _data["primaryLanguageID"];
            this.timeZone = _data["timeZone"];
            this.aboutMe = _data["aboutMe"];
            this.primaryLanguage = _data["primaryLanguage"] ? Language.fromJS(_data["primaryLanguage"]) : <any>undefined;
            this.timeZoneInfo = _data["timeZoneInfo"] ? TimeZoneInfo.fromJS(_data["timeZoneInfo"]) : <any>undefined;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.nextAvailableProviderAppointment = _data["nextAvailableProviderAppointment"] ? ProviderAppointment.fromJS(_data["nextAvailableProviderAppointment"]) : <any>undefined;
            this.lastConsultDate = _data["lastConsultDate"] ? new Date(_data["lastConsultDate"].toString()) : <any>undefined;
            this.isFavorite = _data["isFavorite"];
            if (Array.isArray(_data["providerTags"])) {
                this.providerTags = [] as any;
                for (let item of _data["providerTags"])
                    this.providerTags!.push(ProviderTag.fromJS(item));
            }
            this.providerTypeTag = _data["providerTypeTag"] ? Tag.fromJS(_data["providerTypeTag"]) : <any>undefined;
            this.rating = _data["rating"];
            this.ratingCount = _data["ratingCount"];
        }
    }

    static fromJS(data: any): ProviderDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providerStoreItems)) {
            data["providerStoreItems"] = [];
            for (let item of this.providerStoreItems)
                data["providerStoreItems"].push(item.toJSON());
        }
        data["providerID"] = this.providerID;
        data["imageDetailID"] = this.imageDetailID;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["genderEnum"] = this.genderEnum;
        data["primaryLanguageID"] = this.primaryLanguageID;
        data["timeZone"] = this.timeZone;
        data["aboutMe"] = this.aboutMe;
        data["primaryLanguage"] = this.primaryLanguage ? this.primaryLanguage.toJSON() : <any>undefined;
        data["timeZoneInfo"] = this.timeZoneInfo ? this.timeZoneInfo.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["nextAvailableProviderAppointment"] = this.nextAvailableProviderAppointment ? this.nextAvailableProviderAppointment.toJSON() : <any>undefined;
        data["lastConsultDate"] = this.lastConsultDate ? this.lastConsultDate.toISOString() : <any>undefined;
        data["isFavorite"] = this.isFavorite;
        if (Array.isArray(this.providerTags)) {
            data["providerTags"] = [];
            for (let item of this.providerTags)
                data["providerTags"].push(item.toJSON());
        }
        data["providerTypeTag"] = this.providerTypeTag ? this.providerTypeTag.toJSON() : <any>undefined;
        data["rating"] = this.rating;
        data["ratingCount"] = this.ratingCount;
        return data;
    }
}

export interface IProviderDTO {
    providerStoreItems?: ProviderStoreItemDTO[] | undefined;
    providerID?: string;
    imageDetailID?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    genderEnum: GenderEnum;
    primaryLanguageID?: string | undefined;
    timeZone: string;
    aboutMe?: string | undefined;
    primaryLanguage?: Language | undefined;
    timeZoneInfo?: TimeZoneInfo | undefined;
    country?: Country | undefined;
    nextAvailableProviderAppointment?: ProviderAppointment | undefined;
    lastConsultDate?: Date | undefined;
    isFavorite?: boolean;
    providerTags?: ProviderTag[] | undefined;
    providerTypeTag?: Tag | undefined;
    rating?: number;
    ratingCount?: number;
}

export class ProviderStoreItemDTO implements IProviderStoreItemDTO {
    providerStoreItemID?: string;
    itemID?: string;
    storeItemID?: string;
    displaySortOrder?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    currencyEnum?: CurrencyEnum;
    retailAmount?: number;
    enabled?: boolean;
    minutes?: number | undefined;

    constructor(data?: IProviderStoreItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerStoreItemID = _data["providerStoreItemID"];
            this.itemID = _data["itemID"];
            this.storeItemID = _data["storeItemID"];
            this.displaySortOrder = _data["displaySortOrder"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.currencyEnum = _data["currencyEnum"];
            this.retailAmount = _data["retailAmount"];
            this.enabled = _data["enabled"];
            this.minutes = _data["minutes"];
        }
    }

    static fromJS(data: any): ProviderStoreItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderStoreItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerStoreItemID"] = this.providerStoreItemID;
        data["itemID"] = this.itemID;
        data["storeItemID"] = this.storeItemID;
        data["displaySortOrder"] = this.displaySortOrder;
        data["name"] = this.name;
        data["description"] = this.description;
        data["currencyEnum"] = this.currencyEnum;
        data["retailAmount"] = this.retailAmount;
        data["enabled"] = this.enabled;
        data["minutes"] = this.minutes;
        return data;
    }
}

export interface IProviderStoreItemDTO {
    providerStoreItemID?: string;
    itemID?: string;
    storeItemID?: string;
    displaySortOrder?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    currencyEnum?: CurrencyEnum;
    retailAmount?: number;
    enabled?: boolean;
    minutes?: number | undefined;
}

export class TimeZoneInfo implements ITimeZoneInfo {
    id?: string;
    hasIanaId?: boolean;
    displayName?: string;
    standardName?: string;
    daylightName?: string;
    baseUtcOffset?: string;
    supportsDaylightSavingTime?: boolean;

    constructor(data?: ITimeZoneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.hasIanaId = _data["HasIanaId"];
            this.displayName = _data["DisplayName"];
            this.standardName = _data["StandardName"];
            this.daylightName = _data["DaylightName"];
            this.baseUtcOffset = _data["BaseUtcOffset"];
            this.supportsDaylightSavingTime = _data["SupportsDaylightSavingTime"];
        }
    }

    static fromJS(data: any): TimeZoneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["HasIanaId"] = this.hasIanaId;
        data["DisplayName"] = this.displayName;
        data["StandardName"] = this.standardName;
        data["DaylightName"] = this.daylightName;
        data["BaseUtcOffset"] = this.baseUtcOffset;
        data["SupportsDaylightSavingTime"] = this.supportsDaylightSavingTime;
        return data;
    }
}

export interface ITimeZoneInfo {
    id?: string;
    hasIanaId?: boolean;
    displayName?: string;
    standardName?: string;
    daylightName?: string;
    baseUtcOffset?: string;
    supportsDaylightSavingTime?: boolean;
}

export class ProviderAppointmentSearchDetails implements IProviderAppointmentSearchDetails {
    countryID!: string;
    startDate!: Date;
    endDate!: Date;
    searchTypeEnum!: ProviderAppointmentSearchTypeEnum;
    appointmentTypeEnum!: AppointmentTypeEnum;
    storeID?: string | undefined;
    providerID?: string | undefined;
    itemID?: string | undefined;
    storeItemID?: string | undefined;

    constructor(data?: IProviderAppointmentSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryID = _data["countryID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.searchTypeEnum = _data["searchTypeEnum"];
            this.appointmentTypeEnum = _data["appointmentTypeEnum"];
            this.storeID = _data["storeID"];
            this.providerID = _data["providerID"];
            this.itemID = _data["itemID"];
            this.storeItemID = _data["storeItemID"];
        }
    }

    static fromJS(data: any): ProviderAppointmentSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderAppointmentSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["searchTypeEnum"] = this.searchTypeEnum;
        data["appointmentTypeEnum"] = this.appointmentTypeEnum;
        data["storeID"] = this.storeID;
        data["providerID"] = this.providerID;
        data["itemID"] = this.itemID;
        data["storeItemID"] = this.storeItemID;
        return data;
    }
}

export interface IProviderAppointmentSearchDetails {
    countryID: string;
    startDate: Date;
    endDate: Date;
    searchTypeEnum: ProviderAppointmentSearchTypeEnum;
    appointmentTypeEnum: AppointmentTypeEnum;
    storeID?: string | undefined;
    providerID?: string | undefined;
    itemID?: string | undefined;
    storeItemID?: string | undefined;
}

export enum ProviderAppointmentSearchTypeEnum {
    Stores = "Stores",
    Providers = "Providers",
    Appointments = "Appointments",
}

export class BookProviderAppointmentDetails implements IBookProviderAppointmentDetails {
    providerAppointmentID?: string;
    consultID?: string;

    constructor(data?: IBookProviderAppointmentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerAppointmentID = _data["providerAppointmentID"];
            this.consultID = _data["consultID"];
        }
    }

    static fromJS(data: any): BookProviderAppointmentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BookProviderAppointmentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerAppointmentID"] = this.providerAppointmentID;
        data["consultID"] = this.consultID;
        return data;
    }
}

export interface IBookProviderAppointmentDetails {
    providerAppointmentID?: string;
    consultID?: string;
}

export class PatientAppointmentSearchResults implements IPatientAppointmentSearchResults {
    runTime?: string;
    message?: string | undefined;
    providerAppointments?: ProviderAppointment[] | undefined;
    storeAppointments?: StoreAppointment[] | undefined;

    constructor(data?: IPatientAppointmentSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runTime = _data["runTime"];
            this.message = _data["message"];
            if (Array.isArray(_data["providerAppointments"])) {
                this.providerAppointments = [] as any;
                for (let item of _data["providerAppointments"])
                    this.providerAppointments!.push(ProviderAppointment.fromJS(item));
            }
            if (Array.isArray(_data["storeAppointments"])) {
                this.storeAppointments = [] as any;
                for (let item of _data["storeAppointments"])
                    this.storeAppointments!.push(StoreAppointment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientAppointmentSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAppointmentSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        if (Array.isArray(this.providerAppointments)) {
            data["providerAppointments"] = [];
            for (let item of this.providerAppointments)
                data["providerAppointments"].push(item.toJSON());
        }
        if (Array.isArray(this.storeAppointments)) {
            data["storeAppointments"] = [];
            for (let item of this.storeAppointments)
                data["storeAppointments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientAppointmentSearchResults {
    runTime?: string;
    message?: string | undefined;
    providerAppointments?: ProviderAppointment[] | undefined;
    storeAppointments?: StoreAppointment[] | undefined;
}

export class AppointmentSearchDetails implements IAppointmentSearchDetails {
    userDetailID?: string | undefined;
    storeID?: string | undefined;
    startDate!: Date;
    endDate!: Date;
    recordsToSkip?: number;
    recordsToTake?: number;

    constructor(data?: IAppointmentSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.storeID = _data["storeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
        }
    }

    static fromJS(data: any): AppointmentSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["storeID"] = this.storeID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        return data;
    }
}

export interface IAppointmentSearchDetails {
    userDetailID?: string | undefined;
    storeID?: string | undefined;
    startDate: Date;
    endDate: Date;
    recordsToSkip?: number;
    recordsToTake?: number;
}

export class PatientAppointmentSearchDTOResults implements IPatientAppointmentSearchDTOResults {
    runTime?: string;
    message?: string | undefined;
    appointmentDates?: Date[] | undefined;

    constructor(data?: IPatientAppointmentSearchDTOResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runTime = _data["runTime"];
            this.message = _data["message"];
            if (Array.isArray(_data["appointmentDates"])) {
                this.appointmentDates = [] as any;
                for (let item of _data["appointmentDates"])
                    this.appointmentDates!.push(new Date(item));
            }
        }
    }

    static fromJS(data: any): PatientAppointmentSearchDTOResults {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAppointmentSearchDTOResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        if (Array.isArray(this.appointmentDates)) {
            data["appointmentDates"] = [];
            for (let item of this.appointmentDates)
                data["appointmentDates"].push(item.toISOString());
        }
        return data;
    }
}

export interface IPatientAppointmentSearchDTOResults {
    runTime?: string;
    message?: string | undefined;
    appointmentDates?: Date[] | undefined;
}

export class AppointmentSearchResults implements IAppointmentSearchResults {
    providerAppointments?: ProviderAppointmentDTO[] | undefined;
    storeAppointments?: StoreAppointmentDTO[] | undefined;
    runTime?: string;

    constructor(data?: IAppointmentSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["providerAppointments"])) {
                this.providerAppointments = [] as any;
                for (let item of _data["providerAppointments"])
                    this.providerAppointments!.push(ProviderAppointmentDTO.fromJS(item));
            }
            if (Array.isArray(_data["storeAppointments"])) {
                this.storeAppointments = [] as any;
                for (let item of _data["storeAppointments"])
                    this.storeAppointments!.push(StoreAppointmentDTO.fromJS(item));
            }
            this.runTime = _data["runTime"];
        }
    }

    static fromJS(data: any): AppointmentSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providerAppointments)) {
            data["providerAppointments"] = [];
            for (let item of this.providerAppointments)
                data["providerAppointments"].push(item.toJSON());
        }
        if (Array.isArray(this.storeAppointments)) {
            data["storeAppointments"] = [];
            for (let item of this.storeAppointments)
                data["storeAppointments"].push(item.toJSON());
        }
        data["runTime"] = this.runTime;
        return data;
    }
}

export interface IAppointmentSearchResults {
    providerAppointments?: ProviderAppointmentDTO[] | undefined;
    storeAppointments?: StoreAppointmentDTO[] | undefined;
    runTime?: string;
}

export class ProviderAppointmentDTO implements IProviderAppointmentDTO {
    appointmentTypeEnum?: AppointmentTypeEnum;
    providerAppointmentID?: string;
    consultID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    appointmentLengthInMinutes?: number;
    patientFullName?: string | undefined;
    patientImageDetailID?: string | undefined;
    storeName?: string | undefined;
    itemName?: string | undefined;
    itemDescription?: string | undefined;
    providerID?: string;

    constructor(data?: IProviderAppointmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentTypeEnum = _data["appointmentTypeEnum"];
            this.providerAppointmentID = _data["providerAppointmentID"];
            this.consultID = _data["consultID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.appointmentLengthInMinutes = _data["appointmentLengthInMinutes"];
            this.patientFullName = _data["patientFullName"];
            this.patientImageDetailID = _data["patientImageDetailID"];
            this.storeName = _data["storeName"];
            this.itemName = _data["itemName"];
            this.itemDescription = _data["itemDescription"];
            this.providerID = _data["providerID"];
        }
    }

    static fromJS(data: any): ProviderAppointmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderAppointmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentTypeEnum"] = this.appointmentTypeEnum;
        data["providerAppointmentID"] = this.providerAppointmentID;
        data["consultID"] = this.consultID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["appointmentLengthInMinutes"] = this.appointmentLengthInMinutes;
        data["patientFullName"] = this.patientFullName;
        data["patientImageDetailID"] = this.patientImageDetailID;
        data["storeName"] = this.storeName;
        data["itemName"] = this.itemName;
        data["itemDescription"] = this.itemDescription;
        data["providerID"] = this.providerID;
        return data;
    }
}

export interface IProviderAppointmentDTO {
    appointmentTypeEnum?: AppointmentTypeEnum;
    providerAppointmentID?: string;
    consultID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    appointmentLengthInMinutes?: number;
    patientFullName?: string | undefined;
    patientImageDetailID?: string | undefined;
    storeName?: string | undefined;
    itemName?: string | undefined;
    itemDescription?: string | undefined;
    providerID?: string;
}

export class StoreAppointmentDTO implements IStoreAppointmentDTO {
    appointmentTypeEnum?: AppointmentTypeEnum;
    storeAppointmentID?: string;
    consultID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    appointmentLengthInMinutes?: number;
    patientFullName?: string | undefined;
    patientImageDetailID?: string | undefined;
    storeName?: string | undefined;
    itemName?: string | undefined;
    itemDescription?: string | undefined;
    storeID?: string;

    constructor(data?: IStoreAppointmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentTypeEnum = _data["appointmentTypeEnum"];
            this.storeAppointmentID = _data["storeAppointmentID"];
            this.consultID = _data["consultID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.appointmentLengthInMinutes = _data["appointmentLengthInMinutes"];
            this.patientFullName = _data["patientFullName"];
            this.patientImageDetailID = _data["patientImageDetailID"];
            this.storeName = _data["storeName"];
            this.itemName = _data["itemName"];
            this.itemDescription = _data["itemDescription"];
            this.storeID = _data["storeID"];
        }
    }

    static fromJS(data: any): StoreAppointmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoreAppointmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentTypeEnum"] = this.appointmentTypeEnum;
        data["storeAppointmentID"] = this.storeAppointmentID;
        data["consultID"] = this.consultID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["appointmentLengthInMinutes"] = this.appointmentLengthInMinutes;
        data["patientFullName"] = this.patientFullName;
        data["patientImageDetailID"] = this.patientImageDetailID;
        data["storeName"] = this.storeName;
        data["itemName"] = this.itemName;
        data["itemDescription"] = this.itemDescription;
        data["storeID"] = this.storeID;
        return data;
    }
}

export interface IStoreAppointmentDTO {
    appointmentTypeEnum?: AppointmentTypeEnum;
    storeAppointmentID?: string;
    consultID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    appointmentLengthInMinutes?: number;
    patientFullName?: string | undefined;
    patientImageDetailID?: string | undefined;
    storeName?: string | undefined;
    itemName?: string | undefined;
    itemDescription?: string | undefined;
    storeID?: string;
}

export class NextAvailableAppointmentDetails implements INextAvailableAppointmentDetails {
    startDate!: Date;
    providerID?: string | undefined;
    storeID?: string | undefined;
    storeItemID?: string;

    constructor(data?: INextAvailableAppointmentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.providerID = _data["providerID"];
            this.storeID = _data["storeID"];
            this.storeItemID = _data["storeItemID"];
        }
    }

    static fromJS(data: any): NextAvailableAppointmentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NextAvailableAppointmentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["providerID"] = this.providerID;
        data["storeID"] = this.storeID;
        data["storeItemID"] = this.storeItemID;
        return data;
    }
}

export interface INextAvailableAppointmentDetails {
    startDate: Date;
    providerID?: string | undefined;
    storeID?: string | undefined;
    storeItemID?: string;
}

export class NotifyDailyAppointmentRemindersResponse implements INotifyDailyAppointmentRemindersResponse {
    success?: boolean;
    providers?: string[] | undefined;

    constructor(data?: INotifyDailyAppointmentRemindersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            if (Array.isArray(_data["providers"])) {
                this.providers = [] as any;
                for (let item of _data["providers"])
                    this.providers!.push(item);
            }
        }
    }

    static fromJS(data: any): NotifyDailyAppointmentRemindersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyDailyAppointmentRemindersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (Array.isArray(this.providers)) {
            data["providers"] = [];
            for (let item of this.providers)
                data["providers"].push(item);
        }
        return data;
    }
}

export interface INotifyDailyAppointmentRemindersResponse {
    success?: boolean;
    providers?: string[] | undefined;
}

export class ProviderBank extends EntityBase implements IProviderBank {
    providerBankID!: string;
    providerID!: string;
    currencyEnum!: CurrencyEnum;
    bankName!: string;
    accountNumber!: string;

    constructor(data?: IProviderBank) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerBankID = _data["providerBankID"];
            this.providerID = _data["providerID"];
            this.currencyEnum = _data["currencyEnum"];
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): ProviderBank {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderBank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerBankID"] = this.providerBankID;
        data["providerID"] = this.providerID;
        data["currencyEnum"] = this.currencyEnum;
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderBank extends IEntityBase {
    providerBankID: string;
    providerID: string;
    currencyEnum: CurrencyEnum;
    bankName: string;
    accountNumber: string;
}

export class ProviderDetail extends EntityBase implements IProviderDetail {
    providerDetailID!: string;
    speciality?: string | undefined;
    role?: string | undefined;
    fieldsOfInterest?: string | undefined;
    jobTitle?: string | undefined;
    nationalRegistrationNumber?: string | undefined;
    localLicense?: string | undefined;
    otherRegistrationNumbers?: string | undefined;
    socialMedia?: string | undefined;
    website?: string | undefined;
    neighbourhood?: string | undefined;
    precision?: string | undefined;
    postalAddress?: string | undefined;
    personStatusEnum?: number;
    dispenses?: string | undefined;
    dispensingLicenseNumber?: string | undefined;
    passportNumber?: string | undefined;
    sector?: string | undefined;
    workPlaces?: string | undefined;
    recordStatus?: string | undefined;
    salesTerritory?: string | undefined;
    facilityTypeEnum?: number;
    legalName?: string | undefined;
    practiceNumber?: string | undefined;
    companyRegistrationNumber?: string | undefined;
    vatOrTIN?: string | undefined;
    universityAttended?: string | undefined;
    servicesOffered?: string | undefined;
    yearOfGraduation?: string | undefined;
    contractSigned?: string | undefined;
    contractRenewalDate?: Date | undefined;
    providerLicenseRenewalDate?: Date | undefined;
    lga?: string | undefined;
    primaryBankName?: string | undefined;
    primaryBankAccount?: string | undefined;
    awardsAndRecognitions?: string | undefined;
    hoursOfOperation?: string | undefined;
    offersClinicalTrial?: boolean;
    providerClusterType?: string | undefined;
    providerID!: string;
    marketingKey?: string | undefined;
    marketingQRCode?: string | undefined;
    marketingUrl?: string | undefined;
    marketingCount?: number;
    degreeLocation?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    provider?: Provider | undefined;

    constructor(data?: IProviderDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerDetailID = _data["providerDetailID"];
            this.speciality = _data["speciality"];
            this.role = _data["role"];
            this.fieldsOfInterest = _data["fieldsOfInterest"];
            this.jobTitle = _data["jobTitle"];
            this.nationalRegistrationNumber = _data["nationalRegistrationNumber"];
            this.localLicense = _data["localLicense"];
            this.otherRegistrationNumbers = _data["otherRegistrationNumbers"];
            this.socialMedia = _data["socialMedia"];
            this.website = _data["website"];
            this.neighbourhood = _data["neighbourhood"];
            this.precision = _data["precision"];
            this.postalAddress = _data["postalAddress"];
            this.personStatusEnum = _data["personStatusEnum"];
            this.dispenses = _data["dispenses"];
            this.dispensingLicenseNumber = _data["dispensingLicenseNumber"];
            this.passportNumber = _data["passportNumber"];
            this.sector = _data["sector"];
            this.workPlaces = _data["workPlaces"];
            this.recordStatus = _data["recordStatus"];
            this.salesTerritory = _data["salesTerritory"];
            this.facilityTypeEnum = _data["facilityTypeEnum"];
            this.legalName = _data["legalName"];
            this.practiceNumber = _data["practiceNumber"];
            this.companyRegistrationNumber = _data["companyRegistrationNumber"];
            this.vatOrTIN = _data["vatOrTIN"];
            this.universityAttended = _data["universityAttended"];
            this.servicesOffered = _data["servicesOffered"];
            this.yearOfGraduation = _data["yearOfGraduation"];
            this.contractSigned = _data["contractSigned"];
            this.contractRenewalDate = _data["contractRenewalDate"] ? new Date(_data["contractRenewalDate"].toString()) : <any>undefined;
            this.providerLicenseRenewalDate = _data["providerLicenseRenewalDate"] ? new Date(_data["providerLicenseRenewalDate"].toString()) : <any>undefined;
            this.lga = _data["lga"];
            this.primaryBankName = _data["primaryBankName"];
            this.primaryBankAccount = _data["primaryBankAccount"];
            this.awardsAndRecognitions = _data["awardsAndRecognitions"];
            this.hoursOfOperation = _data["hoursOfOperation"];
            this.offersClinicalTrial = _data["offersClinicalTrial"];
            this.providerClusterType = _data["providerClusterType"];
            this.providerID = _data["providerID"];
            this.marketingKey = _data["marketingKey"];
            this.marketingQRCode = _data["marketingQRCode"];
            this.marketingUrl = _data["marketingUrl"];
            this.marketingCount = _data["marketingCount"];
            this.degreeLocation = _data["degreeLocation"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerDetailID"] = this.providerDetailID;
        data["speciality"] = this.speciality;
        data["role"] = this.role;
        data["fieldsOfInterest"] = this.fieldsOfInterest;
        data["jobTitle"] = this.jobTitle;
        data["nationalRegistrationNumber"] = this.nationalRegistrationNumber;
        data["localLicense"] = this.localLicense;
        data["otherRegistrationNumbers"] = this.otherRegistrationNumbers;
        data["socialMedia"] = this.socialMedia;
        data["website"] = this.website;
        data["neighbourhood"] = this.neighbourhood;
        data["precision"] = this.precision;
        data["postalAddress"] = this.postalAddress;
        data["personStatusEnum"] = this.personStatusEnum;
        data["dispenses"] = this.dispenses;
        data["dispensingLicenseNumber"] = this.dispensingLicenseNumber;
        data["passportNumber"] = this.passportNumber;
        data["sector"] = this.sector;
        data["workPlaces"] = this.workPlaces;
        data["recordStatus"] = this.recordStatus;
        data["salesTerritory"] = this.salesTerritory;
        data["facilityTypeEnum"] = this.facilityTypeEnum;
        data["legalName"] = this.legalName;
        data["practiceNumber"] = this.practiceNumber;
        data["companyRegistrationNumber"] = this.companyRegistrationNumber;
        data["vatOrTIN"] = this.vatOrTIN;
        data["universityAttended"] = this.universityAttended;
        data["servicesOffered"] = this.servicesOffered;
        data["yearOfGraduation"] = this.yearOfGraduation;
        data["contractSigned"] = this.contractSigned;
        data["contractRenewalDate"] = this.contractRenewalDate ? this.contractRenewalDate.toISOString() : <any>undefined;
        data["providerLicenseRenewalDate"] = this.providerLicenseRenewalDate ? this.providerLicenseRenewalDate.toISOString() : <any>undefined;
        data["lga"] = this.lga;
        data["primaryBankName"] = this.primaryBankName;
        data["primaryBankAccount"] = this.primaryBankAccount;
        data["awardsAndRecognitions"] = this.awardsAndRecognitions;
        data["hoursOfOperation"] = this.hoursOfOperation;
        data["offersClinicalTrial"] = this.offersClinicalTrial;
        data["providerClusterType"] = this.providerClusterType;
        data["providerID"] = this.providerID;
        data["marketingKey"] = this.marketingKey;
        data["marketingQRCode"] = this.marketingQRCode;
        data["marketingUrl"] = this.marketingUrl;
        data["marketingCount"] = this.marketingCount;
        data["degreeLocation"] = this.degreeLocation;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderDetail extends IEntityBase {
    providerDetailID: string;
    speciality?: string | undefined;
    role?: string | undefined;
    fieldsOfInterest?: string | undefined;
    jobTitle?: string | undefined;
    nationalRegistrationNumber?: string | undefined;
    localLicense?: string | undefined;
    otherRegistrationNumbers?: string | undefined;
    socialMedia?: string | undefined;
    website?: string | undefined;
    neighbourhood?: string | undefined;
    precision?: string | undefined;
    postalAddress?: string | undefined;
    personStatusEnum?: number;
    dispenses?: string | undefined;
    dispensingLicenseNumber?: string | undefined;
    passportNumber?: string | undefined;
    sector?: string | undefined;
    workPlaces?: string | undefined;
    recordStatus?: string | undefined;
    salesTerritory?: string | undefined;
    facilityTypeEnum?: number;
    legalName?: string | undefined;
    practiceNumber?: string | undefined;
    companyRegistrationNumber?: string | undefined;
    vatOrTIN?: string | undefined;
    universityAttended?: string | undefined;
    servicesOffered?: string | undefined;
    yearOfGraduation?: string | undefined;
    contractSigned?: string | undefined;
    contractRenewalDate?: Date | undefined;
    providerLicenseRenewalDate?: Date | undefined;
    lga?: string | undefined;
    primaryBankName?: string | undefined;
    primaryBankAccount?: string | undefined;
    awardsAndRecognitions?: string | undefined;
    hoursOfOperation?: string | undefined;
    offersClinicalTrial?: boolean;
    providerClusterType?: string | undefined;
    providerID: string;
    marketingKey?: string | undefined;
    marketingQRCode?: string | undefined;
    marketingUrl?: string | undefined;
    marketingCount?: number;
    degreeLocation?: string | undefined;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    provider?: Provider | undefined;
}

export class ProviderHub extends EntityBase implements IProviderHub {
    providerHubID!: string;
    hubName?: string | undefined;
    hubCode?: string | undefined;
    providerDetailID!: string;
    providerDetail?: ProviderDetail | undefined;

    constructor(data?: IProviderHub) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerHubID = _data["providerHubID"];
            this.hubName = _data["hubName"];
            this.hubCode = _data["hubCode"];
            this.providerDetailID = _data["providerDetailID"];
            this.providerDetail = _data["providerDetail"] ? ProviderDetail.fromJS(_data["providerDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderHub {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderHub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerHubID"] = this.providerHubID;
        data["hubName"] = this.hubName;
        data["hubCode"] = this.hubCode;
        data["providerDetailID"] = this.providerDetailID;
        data["providerDetail"] = this.providerDetail ? this.providerDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderHub extends IEntityBase {
    providerHubID: string;
    hubName?: string | undefined;
    hubCode?: string | undefined;
    providerDetailID: string;
    providerDetail?: ProviderDetail | undefined;
}

export class ProviderOnboardingDTO implements IProviderOnboardingDTO {
    provider?: Provider | undefined;
    providerOnboarding?: ProviderOnboarding | undefined;

    constructor(data?: IProviderOnboardingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.providerOnboarding = _data["providerOnboarding"] ? ProviderOnboarding.fromJS(_data["providerOnboarding"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderOnboardingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderOnboardingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["providerOnboarding"] = this.providerOnboarding ? this.providerOnboarding.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProviderOnboardingDTO {
    provider?: Provider | undefined;
    providerOnboarding?: ProviderOnboarding | undefined;
}

export class ProviderPublication extends EntityBase implements IProviderPublication {
    providerPublicationID!: string;
    title?: string | undefined;
    year?: string | undefined;
    providerDetailID!: string;
    providerDetail?: ProviderDetail | undefined;

    constructor(data?: IProviderPublication) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.providerPublicationID = _data["providerPublicationID"];
            this.title = _data["title"];
            this.year = _data["year"];
            this.providerDetailID = _data["providerDetailID"];
            this.providerDetail = _data["providerDetail"] ? ProviderDetail.fromJS(_data["providerDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderPublication {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderPublication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerPublicationID"] = this.providerPublicationID;
        data["title"] = this.title;
        data["year"] = this.year;
        data["providerDetailID"] = this.providerDetailID;
        data["providerDetail"] = this.providerDetail ? this.providerDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderPublication extends IEntityBase {
    providerPublicationID: string;
    title?: string | undefined;
    year?: string | undefined;
    providerDetailID: string;
    providerDetail?: ProviderDetail | undefined;
}

export class ProviderQueueResult implements IProviderQueueResult {
    enabled?: boolean;
    allowSMS?: boolean;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IProviderQueueResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.allowSMS = _data["allowSMS"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ProviderQueueResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderQueueResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["allowSMS"] = this.allowSMS;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IProviderQueueResult {
    enabled?: boolean;
    allowSMS?: boolean;
    success?: boolean;
    message?: string | undefined;
}

export class CurrentProviderQueueResult implements ICurrentProviderQueueResult {
    providerQueueID?: string;
    consultID?: string;

    constructor(data?: ICurrentProviderQueueResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerQueueID = _data["providerQueueID"];
            this.consultID = _data["consultID"];
        }
    }

    static fromJS(data: any): CurrentProviderQueueResult {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentProviderQueueResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerQueueID"] = this.providerQueueID;
        data["consultID"] = this.consultID;
        return data;
    }
}

export interface ICurrentProviderQueueResult {
    providerQueueID?: string;
    consultID?: string;
}

export class ProviderScheduleSearchDetails implements IProviderScheduleSearchDetails {
    providerID?: string;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IProviderScheduleSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderScheduleSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderScheduleSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProviderScheduleSearchDetails {
    providerID?: string;
    startDate?: Date;
    endDate?: Date;
}

export class CreateProviderScheduleResult implements ICreateProviderScheduleResult {
    success?: boolean;
    providerScheduleID?: string;
    recurringID?: string;
    existingProviderSchedules?: ProviderSchedule[] | undefined;
    providerAppointmentsCreated?: number;
    runTime?: string;
    message?: string | undefined;

    constructor(data?: ICreateProviderScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.providerScheduleID = _data["providerScheduleID"];
            this.recurringID = _data["recurringID"];
            if (Array.isArray(_data["existingProviderSchedules"])) {
                this.existingProviderSchedules = [] as any;
                for (let item of _data["existingProviderSchedules"])
                    this.existingProviderSchedules!.push(ProviderSchedule.fromJS(item));
            }
            this.providerAppointmentsCreated = _data["providerAppointmentsCreated"];
            this.runTime = _data["runTime"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateProviderScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProviderScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["providerScheduleID"] = this.providerScheduleID;
        data["recurringID"] = this.recurringID;
        if (Array.isArray(this.existingProviderSchedules)) {
            data["existingProviderSchedules"] = [];
            for (let item of this.existingProviderSchedules)
                data["existingProviderSchedules"].push(item.toJSON());
        }
        data["providerAppointmentsCreated"] = this.providerAppointmentsCreated;
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateProviderScheduleResult {
    success?: boolean;
    providerScheduleID?: string;
    recurringID?: string;
    existingProviderSchedules?: ProviderSchedule[] | undefined;
    providerAppointmentsCreated?: number;
    runTime?: string;
    message?: string | undefined;
}

export class ProviderScheduleDeleteRecurringResults implements IProviderScheduleDeleteRecurringResults {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IProviderScheduleDeleteRecurringResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ProviderScheduleDeleteRecurringResults {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderScheduleDeleteRecurringResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IProviderScheduleDeleteRecurringResults {
    success?: boolean;
    message?: string | undefined;
}

export class PagedResult2OfProvider implements IPagedResult2OfProvider {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Provider[] | undefined;
    totalPages?: number;
    pageNumber?: number;
    hasNextPage?: boolean;
    hasPrevPage?: boolean;

    constructor(data?: IPagedResult2OfProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Provider.fromJS(item));
            }
            this.totalPages = _data["totalPages"];
            this.pageNumber = _data["pageNumber"];
            this.hasNextPage = _data["hasNextPage"];
            this.hasPrevPage = _data["hasPrevPage"];
        }
    }

    static fromJS(data: any): PagedResult2OfProvider {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResult2OfProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalPages"] = this.totalPages;
        data["pageNumber"] = this.pageNumber;
        data["hasNextPage"] = this.hasNextPage;
        data["hasPrevPage"] = this.hasPrevPage;
        return data;
    }
}

export interface IPagedResult2OfProvider {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Provider[] | undefined;
    totalPages?: number;
    pageNumber?: number;
    hasNextPage?: boolean;
    hasPrevPage?: boolean;
}

export class ProvidersDetail extends PagedQuery implements IProvidersDetail {

    constructor(data?: IProvidersDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ProvidersDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IProvidersDetail extends IPagedQuery {
}

export class ProviderSearchDetails extends PagedQuery implements IProviderSearchDetails {
    searchText?: string | undefined;
    providerSettingEnum?: ProviderSettingEnum | undefined;
    providerSettingValue?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    countryID?: string | undefined;
    provinceStateID?: string | undefined;
    provinceState?: string | undefined;
    city?: string | undefined;
    gender?: GenderEnum | undefined;
    languageID?: string | undefined;
    organizationID?: string | undefined;
    departmentID?: string | undefined;

    constructor(data?: IProviderSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchText = _data["searchText"];
            this.providerSettingEnum = _data["providerSettingEnum"];
            this.providerSettingValue = _data["providerSettingValue"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.countryID = _data["countryID"];
            this.provinceStateID = _data["provinceStateID"];
            this.provinceState = _data["provinceState"];
            this.city = _data["city"];
            this.gender = _data["gender"];
            this.languageID = _data["languageID"];
            this.organizationID = _data["organizationID"];
            this.departmentID = _data["departmentID"];
        }
    }

    static fromJS(data: any): ProviderSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["providerSettingEnum"] = this.providerSettingEnum;
        data["providerSettingValue"] = this.providerSettingValue;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["countryID"] = this.countryID;
        data["provinceStateID"] = this.provinceStateID;
        data["provinceState"] = this.provinceState;
        data["city"] = this.city;
        data["gender"] = this.gender;
        data["languageID"] = this.languageID;
        data["organizationID"] = this.organizationID;
        data["departmentID"] = this.departmentID;
        super.toJSON(data);
        return data;
    }
}

export interface IProviderSearchDetails extends IPagedQuery {
    searchText?: string | undefined;
    providerSettingEnum?: ProviderSettingEnum | undefined;
    providerSettingValue?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    countryID?: string | undefined;
    provinceStateID?: string | undefined;
    provinceState?: string | undefined;
    city?: string | undefined;
    gender?: GenderEnum | undefined;
    languageID?: string | undefined;
    organizationID?: string | undefined;
    departmentID?: string | undefined;
}

export class ProviderSignupsDTO implements IProviderSignupsDTO {
    userDetailID?: string;
    createdDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    country?: string | undefined;
    provinceState?: string | undefined;
    cityTown?: string | undefined;
    cellPhoneNumber?: string | undefined;
    profession?: string | undefined;
    profession_Specializations?: string | undefined;
    gender?: string | undefined;
    organization?: string | undefined;
    clinics?: string | undefined;
    cardViews?: number;
    impressions?: number;
    vip?: boolean;
    vipNotes?: string | undefined;
    abusive?: boolean;
    abusiveNotes?: string | undefined;
    approved?: boolean;
    salesPersonName?: string | undefined;

    constructor(data?: IProviderSignupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.country = _data["country"];
            this.provinceState = _data["provinceState"];
            this.cityTown = _data["cityTown"];
            this.cellPhoneNumber = _data["cellPhoneNumber"];
            this.profession = _data["profession"];
            this.profession_Specializations = _data["profession_Specializations"];
            this.gender = _data["gender"];
            this.organization = _data["organization"];
            this.clinics = _data["clinics"];
            this.cardViews = _data["cardViews"];
            this.impressions = _data["impressions"];
            this.vip = _data["vip"];
            this.vipNotes = _data["vipNotes"];
            this.abusive = _data["abusive"];
            this.abusiveNotes = _data["abusiveNotes"];
            this.approved = _data["approved"];
            this.salesPersonName = _data["salesPersonName"];
        }
    }

    static fromJS(data: any): ProviderSignupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSignupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["country"] = this.country;
        data["provinceState"] = this.provinceState;
        data["cityTown"] = this.cityTown;
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        data["profession"] = this.profession;
        data["profession_Specializations"] = this.profession_Specializations;
        data["gender"] = this.gender;
        data["organization"] = this.organization;
        data["clinics"] = this.clinics;
        data["cardViews"] = this.cardViews;
        data["impressions"] = this.impressions;
        data["vip"] = this.vip;
        data["vipNotes"] = this.vipNotes;
        data["abusive"] = this.abusive;
        data["abusiveNotes"] = this.abusiveNotes;
        data["approved"] = this.approved;
        data["salesPersonName"] = this.salesPersonName;
        return data;
    }
}

export interface IProviderSignupsDTO {
    userDetailID?: string;
    createdDate?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    country?: string | undefined;
    provinceState?: string | undefined;
    cityTown?: string | undefined;
    cellPhoneNumber?: string | undefined;
    profession?: string | undefined;
    profession_Specializations?: string | undefined;
    gender?: string | undefined;
    organization?: string | undefined;
    clinics?: string | undefined;
    cardViews?: number;
    impressions?: number;
    vip?: boolean;
    vipNotes?: string | undefined;
    abusive?: boolean;
    abusiveNotes?: string | undefined;
    approved?: boolean;
    salesPersonName?: string | undefined;
}

export class ProviderSignupDTODetails implements IProviderSignupDTODetails {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IProviderSignupDTODetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProviderSignupDTODetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSignupDTODetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProviderSignupDTODetails {
    startDate?: Date;
    endDate?: Date;
}

export class PagedResultOfProviderSignupsDTO implements IPagedResultOfProviderSignupsDTO {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ProviderSignupsDTO[] | undefined;

    constructor(data?: IPagedResultOfProviderSignupsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProviderSignupsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfProviderSignupsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfProviderSignupsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfProviderSignupsDTO {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ProviderSignupsDTO[] | undefined;
}

export class ProviderWalkInAvailabilityResult implements IProviderWalkInAvailabilityResult {
    walkInStatusEnum?: WalkInStatusEnum;
    message?: string | undefined;

    constructor(data?: IProviderWalkInAvailabilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walkInStatusEnum = _data["walkInStatusEnum"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ProviderWalkInAvailabilityResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderWalkInAvailabilityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walkInStatusEnum"] = this.walkInStatusEnum;
        data["message"] = this.message;
        return data;
    }
}

export interface IProviderWalkInAvailabilityResult {
    walkInStatusEnum?: WalkInStatusEnum;
    message?: string | undefined;
}

export class ProviderWalkInAvailabilityDetail implements IProviderWalkInAvailabilityDetail {
    providerID?: string;
    walkInStatusEnum?: WalkInStatusEnum;

    constructor(data?: IProviderWalkInAvailabilityDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.walkInStatusEnum = _data["walkInStatusEnum"];
        }
    }

    static fromJS(data: any): ProviderWalkInAvailabilityDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderWalkInAvailabilityDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["walkInStatusEnum"] = this.walkInStatusEnum;
        return data;
    }
}

export interface IProviderWalkInAvailabilityDetail {
    providerID?: string;
    walkInStatusEnum?: WalkInStatusEnum;
}

export class QualityOfService extends EntityBase implements IQualityOfService {
    qualityOfServiceID!: string;
    qualityOfServiceTypeEnum!: QualityOfServiceTypeEnum;
    primaryKeyID?: string | undefined;
    data!: string;

    constructor(data?: IQualityOfService) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualityOfServiceID = _data["qualityOfServiceID"];
            this.qualityOfServiceTypeEnum = _data["qualityOfServiceTypeEnum"];
            this.primaryKeyID = _data["primaryKeyID"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): QualityOfService {
        data = typeof data === 'object' ? data : {};
        let result = new QualityOfService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityOfServiceID"] = this.qualityOfServiceID;
        data["qualityOfServiceTypeEnum"] = this.qualityOfServiceTypeEnum;
        data["primaryKeyID"] = this.primaryKeyID;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IQualityOfService extends IEntityBase {
    qualityOfServiceID: string;
    qualityOfServiceTypeEnum: QualityOfServiceTypeEnum;
    primaryKeyID?: string | undefined;
    data: string;
}

export enum QualityOfServiceTypeEnum {
    Consult = "Consult",
}

export class PatientSubscriptionSearchDetails extends PagedQuery implements IPatientSubscriptionSearchDetails {
    searchText?: string | undefined;

    constructor(data?: IPatientSubscriptionSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): PatientSubscriptionSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSubscriptionSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        super.toJSON(data);
        return data;
    }
}

export interface IPatientSubscriptionSearchDetails extends IPagedQuery {
    searchText?: string | undefined;
}

export class ReferralCenterInvite extends EntityBase implements IReferralCenterInvite {
    referralCenterInviteID!: string;
    userDetailID!: string;
    referralCenterInviteStatusEnum!: ReferralCenterInviteStatusEnum;
    name?: string | undefined;
    smsNumber?: string | undefined;
    sentDate?: Date | undefined;
    smsid?: string | undefined;
    referralCenterAppEnum?: ReferralCenterAppEnum | undefined;
    toUserDetailID?: string | undefined;
    emailAddress?: string | undefined;
    specialtyTagID?: string | undefined;
    formattedSMSNumber?: string | undefined;
    specialtyTag?: Tag | undefined;

    constructor(data?: IReferralCenterInvite) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referralCenterInviteID = _data["referralCenterInviteID"];
            this.userDetailID = _data["userDetailID"];
            this.referralCenterInviteStatusEnum = _data["referralCenterInviteStatusEnum"];
            this.name = _data["name"];
            this.smsNumber = _data["smsNumber"];
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.smsid = _data["smsid"];
            this.referralCenterAppEnum = _data["referralCenterAppEnum"];
            this.toUserDetailID = _data["toUserDetailID"];
            this.emailAddress = _data["emailAddress"];
            this.specialtyTagID = _data["specialtyTagID"];
            this.formattedSMSNumber = _data["formattedSMSNumber"];
            this.specialtyTag = _data["specialtyTag"] ? Tag.fromJS(_data["specialtyTag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReferralCenterInvite {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralCenterInvite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralCenterInviteID"] = this.referralCenterInviteID;
        data["userDetailID"] = this.userDetailID;
        data["referralCenterInviteStatusEnum"] = this.referralCenterInviteStatusEnum;
        data["name"] = this.name;
        data["smsNumber"] = this.smsNumber;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["smsid"] = this.smsid;
        data["referralCenterAppEnum"] = this.referralCenterAppEnum;
        data["toUserDetailID"] = this.toUserDetailID;
        data["emailAddress"] = this.emailAddress;
        data["specialtyTagID"] = this.specialtyTagID;
        data["formattedSMSNumber"] = this.formattedSMSNumber;
        data["specialtyTag"] = this.specialtyTag ? this.specialtyTag.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IReferralCenterInvite extends IEntityBase {
    referralCenterInviteID: string;
    userDetailID: string;
    referralCenterInviteStatusEnum: ReferralCenterInviteStatusEnum;
    name?: string | undefined;
    smsNumber?: string | undefined;
    sentDate?: Date | undefined;
    smsid?: string | undefined;
    referralCenterAppEnum?: ReferralCenterAppEnum | undefined;
    toUserDetailID?: string | undefined;
    emailAddress?: string | undefined;
    specialtyTagID?: string | undefined;
    formattedSMSNumber?: string | undefined;
    specialtyTag?: Tag | undefined;
}

export enum ReferralCenterInviteStatusEnum {
    Queued = "Queued",
    Pending = "Pending",
    Completed = "Completed",
}

export enum ReferralCenterAppEnum {
    Sentinel = "Sentinel",
}

export class PagedResultOfReferralCenterInvite implements IPagedResultOfReferralCenterInvite {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ReferralCenterInvite[] | undefined;

    constructor(data?: IPagedResultOfReferralCenterInvite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReferralCenterInvite.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfReferralCenterInvite {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfReferralCenterInvite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfReferralCenterInvite {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ReferralCenterInvite[] | undefined;
}

export class ReferralCenterInviteDetails extends PagedQuery implements IReferralCenterInviteDetails {
    userDetailID?: string;

    constructor(data?: IReferralCenterInviteDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): ReferralCenterInviteDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralCenterInviteDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IReferralCenterInviteDetails extends IPagedQuery {
    userDetailID?: string;
}

export class RestrictedEmail extends EntityBase implements IRestrictedEmail {
    restrictedEmailID!: string;
    email!: string;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IRestrictedEmail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.restrictedEmailID = _data["restrictedEmailID"];
            this.email = _data["email"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RestrictedEmail {
        data = typeof data === 'object' ? data : {};
        let result = new RestrictedEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["restrictedEmailID"] = this.restrictedEmailID;
        data["email"] = this.email;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRestrictedEmail extends IEntityBase {
    restrictedEmailID: string;
    email: string;
    startDate: Date;
    endDate: Date;
}

export class ConsultProviderSearchResults implements IConsultProviderSearchResults {
    runTime?: string;
    message?: string | undefined;
    specialities?: PagedResultOfConsultProviderSearchProviderResult | undefined;
    organizations?: PagedResultOfConsultProviderSearchOrganizationResult | undefined;
    providers?: PagedResultOfConsultProviderSearchProviderResult | undefined;
    clinics?: PagedResultOfConsultProviderSearchStoreResult | undefined;
    labs?: PagedResultOfConsultProviderSearchStoreResult | undefined;
    pharmacies?: PagedResultOfConsultProviderSearchStoreResult | undefined;

    constructor(data?: IConsultProviderSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runTime = _data["runTime"];
            this.message = _data["message"];
            this.specialities = _data["specialities"] ? PagedResultOfConsultProviderSearchProviderResult.fromJS(_data["specialities"]) : <any>undefined;
            this.organizations = _data["organizations"] ? PagedResultOfConsultProviderSearchOrganizationResult.fromJS(_data["organizations"]) : <any>undefined;
            this.providers = _data["providers"] ? PagedResultOfConsultProviderSearchProviderResult.fromJS(_data["providers"]) : <any>undefined;
            this.clinics = _data["clinics"] ? PagedResultOfConsultProviderSearchStoreResult.fromJS(_data["clinics"]) : <any>undefined;
            this.labs = _data["labs"] ? PagedResultOfConsultProviderSearchStoreResult.fromJS(_data["labs"]) : <any>undefined;
            this.pharmacies = _data["pharmacies"] ? PagedResultOfConsultProviderSearchStoreResult.fromJS(_data["pharmacies"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultProviderSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        data["specialities"] = this.specialities ? this.specialities.toJSON() : <any>undefined;
        data["organizations"] = this.organizations ? this.organizations.toJSON() : <any>undefined;
        data["providers"] = this.providers ? this.providers.toJSON() : <any>undefined;
        data["clinics"] = this.clinics ? this.clinics.toJSON() : <any>undefined;
        data["labs"] = this.labs ? this.labs.toJSON() : <any>undefined;
        data["pharmacies"] = this.pharmacies ? this.pharmacies.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConsultProviderSearchResults {
    runTime?: string;
    message?: string | undefined;
    specialities?: PagedResultOfConsultProviderSearchProviderResult | undefined;
    organizations?: PagedResultOfConsultProviderSearchOrganizationResult | undefined;
    providers?: PagedResultOfConsultProviderSearchProviderResult | undefined;
    clinics?: PagedResultOfConsultProviderSearchStoreResult | undefined;
    labs?: PagedResultOfConsultProviderSearchStoreResult | undefined;
    pharmacies?: PagedResultOfConsultProviderSearchStoreResult | undefined;
}

export class PagedResultOfConsultProviderSearchProviderResult implements IPagedResultOfConsultProviderSearchProviderResult {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ConsultProviderSearchProviderResult[] | undefined;

    constructor(data?: IPagedResultOfConsultProviderSearchProviderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConsultProviderSearchProviderResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfConsultProviderSearchProviderResult {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfConsultProviderSearchProviderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfConsultProviderSearchProviderResult {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ConsultProviderSearchProviderResult[] | undefined;
}

export class ConsultProviderSearchProviderResult implements IConsultProviderSearchProviderResult {
    providerID?: string;
    fullName?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    imageDetailID?: string | undefined;
    genderEnum?: GenderEnum;
    rating?: number;
    providerTags?: Tag[] | undefined;
    nextAvailableAppointmentDate?: Date | undefined;
    primaryProviderConditionTag?: Tag | undefined;
    isFavorite?: boolean;
    providerTypeTag?: Tag | undefined;
    publicPage?: boolean;
    publicTag?: string | undefined;
    providerImages?: ProviderImage[] | undefined;
    fullAddress?: string | undefined;
    country?: Country | undefined;
    notPrimaryProviderTags?: string[] | undefined;
    ratingCount?: number;
    latitude?: number | undefined;
    longitude?: number | undefined;
    distance?: number | undefined;
    consultProviderSearchProviderAppointmentsResults?: ConsultProviderSearchProviderAppointmentsResult[] | undefined;
    yearsOfExperience?: number | undefined;
    professionalStatement?: string | undefined;

    constructor(data?: IConsultProviderSearchProviderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.fullName = _data["fullName"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.imageDetailID = _data["imageDetailID"];
            this.genderEnum = _data["genderEnum"];
            this.rating = _data["rating"];
            if (Array.isArray(_data["providerTags"])) {
                this.providerTags = [] as any;
                for (let item of _data["providerTags"])
                    this.providerTags!.push(Tag.fromJS(item));
            }
            this.nextAvailableAppointmentDate = _data["nextAvailableAppointmentDate"] ? new Date(_data["nextAvailableAppointmentDate"].toString()) : <any>undefined;
            this.primaryProviderConditionTag = _data["primaryProviderConditionTag"] ? Tag.fromJS(_data["primaryProviderConditionTag"]) : <any>undefined;
            this.isFavorite = _data["isFavorite"];
            this.providerTypeTag = _data["providerTypeTag"] ? Tag.fromJS(_data["providerTypeTag"]) : <any>undefined;
            this.publicPage = _data["publicPage"];
            this.publicTag = _data["publicTag"];
            if (Array.isArray(_data["providerImages"])) {
                this.providerImages = [] as any;
                for (let item of _data["providerImages"])
                    this.providerImages!.push(ProviderImage.fromJS(item));
            }
            this.fullAddress = _data["fullAddress"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["notPrimaryProviderTags"])) {
                this.notPrimaryProviderTags = [] as any;
                for (let item of _data["notPrimaryProviderTags"])
                    this.notPrimaryProviderTags!.push(item);
            }
            this.ratingCount = _data["ratingCount"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.distance = _data["distance"];
            if (Array.isArray(_data["consultProviderSearchProviderAppointmentsResults"])) {
                this.consultProviderSearchProviderAppointmentsResults = [] as any;
                for (let item of _data["consultProviderSearchProviderAppointmentsResults"])
                    this.consultProviderSearchProviderAppointmentsResults!.push(ConsultProviderSearchProviderAppointmentsResult.fromJS(item));
            }
            this.yearsOfExperience = _data["yearsOfExperience"];
            this.professionalStatement = _data["professionalStatement"];
        }
    }

    static fromJS(data: any): ConsultProviderSearchProviderResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchProviderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["fullName"] = this.fullName;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["imageDetailID"] = this.imageDetailID;
        data["genderEnum"] = this.genderEnum;
        data["rating"] = this.rating;
        if (Array.isArray(this.providerTags)) {
            data["providerTags"] = [];
            for (let item of this.providerTags)
                data["providerTags"].push(item.toJSON());
        }
        data["nextAvailableAppointmentDate"] = this.nextAvailableAppointmentDate ? this.nextAvailableAppointmentDate.toISOString() : <any>undefined;
        data["primaryProviderConditionTag"] = this.primaryProviderConditionTag ? this.primaryProviderConditionTag.toJSON() : <any>undefined;
        data["isFavorite"] = this.isFavorite;
        data["providerTypeTag"] = this.providerTypeTag ? this.providerTypeTag.toJSON() : <any>undefined;
        data["publicPage"] = this.publicPage;
        data["publicTag"] = this.publicTag;
        if (Array.isArray(this.providerImages)) {
            data["providerImages"] = [];
            for (let item of this.providerImages)
                data["providerImages"].push(item.toJSON());
        }
        data["fullAddress"] = this.fullAddress;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.notPrimaryProviderTags)) {
            data["notPrimaryProviderTags"] = [];
            for (let item of this.notPrimaryProviderTags)
                data["notPrimaryProviderTags"].push(item);
        }
        data["ratingCount"] = this.ratingCount;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["distance"] = this.distance;
        if (Array.isArray(this.consultProviderSearchProviderAppointmentsResults)) {
            data["consultProviderSearchProviderAppointmentsResults"] = [];
            for (let item of this.consultProviderSearchProviderAppointmentsResults)
                data["consultProviderSearchProviderAppointmentsResults"].push(item.toJSON());
        }
        data["yearsOfExperience"] = this.yearsOfExperience;
        data["professionalStatement"] = this.professionalStatement;
        return data;
    }
}

export interface IConsultProviderSearchProviderResult {
    providerID?: string;
    fullName?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    imageDetailID?: string | undefined;
    genderEnum?: GenderEnum;
    rating?: number;
    providerTags?: Tag[] | undefined;
    nextAvailableAppointmentDate?: Date | undefined;
    primaryProviderConditionTag?: Tag | undefined;
    isFavorite?: boolean;
    providerTypeTag?: Tag | undefined;
    publicPage?: boolean;
    publicTag?: string | undefined;
    providerImages?: ProviderImage[] | undefined;
    fullAddress?: string | undefined;
    country?: Country | undefined;
    notPrimaryProviderTags?: string[] | undefined;
    ratingCount?: number;
    latitude?: number | undefined;
    longitude?: number | undefined;
    distance?: number | undefined;
    consultProviderSearchProviderAppointmentsResults?: ConsultProviderSearchProviderAppointmentsResult[] | undefined;
    yearsOfExperience?: number | undefined;
    professionalStatement?: string | undefined;
}

export class ConsultProviderSearchProviderAppointmentsResult implements IConsultProviderSearchProviderAppointmentsResult {
    storeName?: string | undefined;
    storeID?: string;
    storeItemName?: string | undefined;
    storeItemID?: string;
    appointments?: ProviderAppointment[] | undefined;

    constructor(data?: IConsultProviderSearchProviderAppointmentsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeName = _data["storeName"];
            this.storeID = _data["storeID"];
            this.storeItemName = _data["storeItemName"];
            this.storeItemID = _data["storeItemID"];
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(ProviderAppointment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsultProviderSearchProviderAppointmentsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchProviderAppointmentsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["storeID"] = this.storeID;
        data["storeItemName"] = this.storeItemName;
        data["storeItemID"] = this.storeItemID;
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConsultProviderSearchProviderAppointmentsResult {
    storeName?: string | undefined;
    storeID?: string;
    storeItemName?: string | undefined;
    storeItemID?: string;
    appointments?: ProviderAppointment[] | undefined;
}

export class PagedResultOfConsultProviderSearchOrganizationResult implements IPagedResultOfConsultProviderSearchOrganizationResult {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ConsultProviderSearchOrganizationResult[] | undefined;

    constructor(data?: IPagedResultOfConsultProviderSearchOrganizationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConsultProviderSearchOrganizationResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfConsultProviderSearchOrganizationResult {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfConsultProviderSearchOrganizationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfConsultProviderSearchOrganizationResult {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ConsultProviderSearchOrganizationResult[] | undefined;
}

export class ConsultProviderSearchOrganizationResult implements IConsultProviderSearchOrganizationResult {
    organizationID?: string;
    name?: string | undefined;
    description?: string | undefined;
    imageDetailID?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    provinceState?: ProvinceState | undefined;
    cityTown?: CityTown | undefined;
    postCode?: string | undefined;
    publicTag?: string | undefined;
    country?: Country | undefined;
    fullAddress?: string | undefined;
    rating?: number;
    ratingCount?: number;
    latitude?: number | undefined;
    longitude?: number | undefined;
    organizationImages?: OrganizationImage[] | undefined;
    distance?: number | undefined;

    constructor(data?: IConsultProviderSearchOrganizationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationID = _data["organizationID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.imageDetailID = _data["imageDetailID"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.provinceState = _data["provinceState"] ? ProvinceState.fromJS(_data["provinceState"]) : <any>undefined;
            this.cityTown = _data["cityTown"] ? CityTown.fromJS(_data["cityTown"]) : <any>undefined;
            this.postCode = _data["postCode"];
            this.publicTag = _data["publicTag"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.fullAddress = _data["fullAddress"];
            this.rating = _data["rating"];
            this.ratingCount = _data["ratingCount"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            if (Array.isArray(_data["organizationImages"])) {
                this.organizationImages = [] as any;
                for (let item of _data["organizationImages"])
                    this.organizationImages!.push(OrganizationImage.fromJS(item));
            }
            this.distance = _data["distance"];
        }
    }

    static fromJS(data: any): ConsultProviderSearchOrganizationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchOrganizationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationID"] = this.organizationID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["imageDetailID"] = this.imageDetailID;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["provinceState"] = this.provinceState ? this.provinceState.toJSON() : <any>undefined;
        data["cityTown"] = this.cityTown ? this.cityTown.toJSON() : <any>undefined;
        data["postCode"] = this.postCode;
        data["publicTag"] = this.publicTag;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["fullAddress"] = this.fullAddress;
        data["rating"] = this.rating;
        data["ratingCount"] = this.ratingCount;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        if (Array.isArray(this.organizationImages)) {
            data["organizationImages"] = [];
            for (let item of this.organizationImages)
                data["organizationImages"].push(item.toJSON());
        }
        data["distance"] = this.distance;
        return data;
    }
}

export interface IConsultProviderSearchOrganizationResult {
    organizationID?: string;
    name?: string | undefined;
    description?: string | undefined;
    imageDetailID?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    provinceState?: ProvinceState | undefined;
    cityTown?: CityTown | undefined;
    postCode?: string | undefined;
    publicTag?: string | undefined;
    country?: Country | undefined;
    fullAddress?: string | undefined;
    rating?: number;
    ratingCount?: number;
    latitude?: number | undefined;
    longitude?: number | undefined;
    organizationImages?: OrganizationImage[] | undefined;
    distance?: number | undefined;
}

export class PagedResultOfConsultProviderSearchStoreResult implements IPagedResultOfConsultProviderSearchStoreResult {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ConsultProviderSearchStoreResult[] | undefined;

    constructor(data?: IPagedResultOfConsultProviderSearchStoreResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConsultProviderSearchStoreResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfConsultProviderSearchStoreResult {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfConsultProviderSearchStoreResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfConsultProviderSearchStoreResult {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: ConsultProviderSearchStoreResult[] | undefined;
}

export class ConsultProviderSearchDetails extends PagedQuery implements IConsultProviderSearchDetails {
    countryID?: string;
    provinceStateID?: string | undefined;
    cityTownID?: string | undefined;
    storeItemTypeEnum?: StoreItemTypeEnum;
    searchText?: string | undefined;
    consultProviderSearchBrowseEnum?: ConsultProviderSearchBrowseEnum | undefined;
    browseOrganizationID?: string | undefined;
    browseStoreID?: string | undefined;
    careTypeTagsIDs?: string[] | undefined;
    specialityTagIDs?: string[] | undefined;
    symptomTagIDs?: string[] | undefined;
    homeCareServiceTagIDs?: string[] | undefined;
    spokenLanguageTagID?: string | undefined;
    prescriptionRefill?: boolean;
    currentLatitude?: number | undefined;
    currentLongitude?: number | undefined;
    withinKMs?: number | undefined;
    publicFacingPagesOnly?: boolean;
    genderEnum?: GenderEnum | undefined;
    appointmentStartDate?: Date | undefined;
    appointmentEndDate?: Date | undefined;
    searchText1?: string | undefined;
    serviceDescription?: string | undefined;

    constructor(data?: IConsultProviderSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryID = _data["countryID"];
            this.provinceStateID = _data["provinceStateID"];
            this.cityTownID = _data["cityTownID"];
            this.storeItemTypeEnum = _data["storeItemTypeEnum"];
            this.searchText = _data["searchText"];
            this.consultProviderSearchBrowseEnum = _data["consultProviderSearchBrowseEnum"];
            this.browseOrganizationID = _data["browseOrganizationID"];
            this.browseStoreID = _data["browseStoreID"];
            if (Array.isArray(_data["careTypeTagsIDs"])) {
                this.careTypeTagsIDs = [] as any;
                for (let item of _data["careTypeTagsIDs"])
                    this.careTypeTagsIDs!.push(item);
            }
            if (Array.isArray(_data["specialityTagIDs"])) {
                this.specialityTagIDs = [] as any;
                for (let item of _data["specialityTagIDs"])
                    this.specialityTagIDs!.push(item);
            }
            if (Array.isArray(_data["symptomTagIDs"])) {
                this.symptomTagIDs = [] as any;
                for (let item of _data["symptomTagIDs"])
                    this.symptomTagIDs!.push(item);
            }
            if (Array.isArray(_data["homeCareServiceTagIDs"])) {
                this.homeCareServiceTagIDs = [] as any;
                for (let item of _data["homeCareServiceTagIDs"])
                    this.homeCareServiceTagIDs!.push(item);
            }
            this.spokenLanguageTagID = _data["spokenLanguageTagID"];
            this.prescriptionRefill = _data["prescriptionRefill"];
            this.currentLatitude = _data["currentLatitude"];
            this.currentLongitude = _data["currentLongitude"];
            this.withinKMs = _data["withinKMs"];
            this.publicFacingPagesOnly = _data["publicFacingPagesOnly"];
            this.genderEnum = _data["genderEnum"];
            this.appointmentStartDate = _data["appointmentStartDate"] ? new Date(_data["appointmentStartDate"].toString()) : <any>undefined;
            this.appointmentEndDate = _data["appointmentEndDate"] ? new Date(_data["appointmentEndDate"].toString()) : <any>undefined;
            this.searchText1 = _data["searchText1"];
            this.serviceDescription = _data["serviceDescription"];
        }
    }

    static fromJS(data: any): ConsultProviderSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultProviderSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["provinceStateID"] = this.provinceStateID;
        data["cityTownID"] = this.cityTownID;
        data["storeItemTypeEnum"] = this.storeItemTypeEnum;
        data["searchText"] = this.searchText;
        data["consultProviderSearchBrowseEnum"] = this.consultProviderSearchBrowseEnum;
        data["browseOrganizationID"] = this.browseOrganizationID;
        data["browseStoreID"] = this.browseStoreID;
        if (Array.isArray(this.careTypeTagsIDs)) {
            data["careTypeTagsIDs"] = [];
            for (let item of this.careTypeTagsIDs)
                data["careTypeTagsIDs"].push(item);
        }
        if (Array.isArray(this.specialityTagIDs)) {
            data["specialityTagIDs"] = [];
            for (let item of this.specialityTagIDs)
                data["specialityTagIDs"].push(item);
        }
        if (Array.isArray(this.symptomTagIDs)) {
            data["symptomTagIDs"] = [];
            for (let item of this.symptomTagIDs)
                data["symptomTagIDs"].push(item);
        }
        if (Array.isArray(this.homeCareServiceTagIDs)) {
            data["homeCareServiceTagIDs"] = [];
            for (let item of this.homeCareServiceTagIDs)
                data["homeCareServiceTagIDs"].push(item);
        }
        data["spokenLanguageTagID"] = this.spokenLanguageTagID;
        data["prescriptionRefill"] = this.prescriptionRefill;
        data["currentLatitude"] = this.currentLatitude;
        data["currentLongitude"] = this.currentLongitude;
        data["withinKMs"] = this.withinKMs;
        data["publicFacingPagesOnly"] = this.publicFacingPagesOnly;
        data["genderEnum"] = this.genderEnum;
        data["appointmentStartDate"] = this.appointmentStartDate ? this.appointmentStartDate.toISOString() : <any>undefined;
        data["appointmentEndDate"] = this.appointmentEndDate ? this.appointmentEndDate.toISOString() : <any>undefined;
        data["searchText1"] = this.searchText1;
        data["serviceDescription"] = this.serviceDescription;
        super.toJSON(data);
        return data;
    }
}

export interface IConsultProviderSearchDetails extends IPagedQuery {
    countryID?: string;
    provinceStateID?: string | undefined;
    cityTownID?: string | undefined;
    storeItemTypeEnum?: StoreItemTypeEnum;
    searchText?: string | undefined;
    consultProviderSearchBrowseEnum?: ConsultProviderSearchBrowseEnum | undefined;
    browseOrganizationID?: string | undefined;
    browseStoreID?: string | undefined;
    careTypeTagsIDs?: string[] | undefined;
    specialityTagIDs?: string[] | undefined;
    symptomTagIDs?: string[] | undefined;
    homeCareServiceTagIDs?: string[] | undefined;
    spokenLanguageTagID?: string | undefined;
    prescriptionRefill?: boolean;
    currentLatitude?: number | undefined;
    currentLongitude?: number | undefined;
    withinKMs?: number | undefined;
    publicFacingPagesOnly?: boolean;
    genderEnum?: GenderEnum | undefined;
    appointmentStartDate?: Date | undefined;
    appointmentEndDate?: Date | undefined;
    searchText1?: string | undefined;
    serviceDescription?: string | undefined;
}

export enum ConsultProviderSearchBrowseEnum {
    Organization = "Organization",
    StoreByOrganizationClinic = "StoreByOrganizationClinic",
    StoreByOrganizationLab = "StoreByOrganizationLab",
    StoreByOrganizationPharmacy = "StoreByOrganizationPharmacy",
    ProviderByStore = "ProviderByStore",
    Provider = "Provider",
    StoreClinic = "StoreClinic",
    StoreLab = "StoreLab",
    StorePharmacy = "StorePharmacy",
    Speciality = "Speciality",
}

export class ProcessSearchResult implements IProcessSearchResult {
    success?: boolean;
    message?: string | undefined;
    searchesProcessed?: number;
    providersUpdated?: number;
    storesUpdated?: number;
    organizationsUpdated?: number;

    constructor(data?: IProcessSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.searchesProcessed = _data["searchesProcessed"];
            this.providersUpdated = _data["providersUpdated"];
            this.storesUpdated = _data["storesUpdated"];
            this.organizationsUpdated = _data["organizationsUpdated"];
        }
    }

    static fromJS(data: any): ProcessSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["searchesProcessed"] = this.searchesProcessed;
        data["providersUpdated"] = this.providersUpdated;
        data["storesUpdated"] = this.storesUpdated;
        data["organizationsUpdated"] = this.organizationsUpdated;
        return data;
    }
}

export interface IProcessSearchResult {
    success?: boolean;
    message?: string | undefined;
    searchesProcessed?: number;
    providersUpdated?: number;
    storesUpdated?: number;
    organizationsUpdated?: number;
}

export class PublicTagResult implements IPublicTagResult {
    provider?: Provider | undefined;
    store?: Store | undefined;
    storeProviders?: Provider[] | undefined;
    organization?: Organization | undefined;
    organizationStores?: Store[] | undefined;

    constructor(data?: IPublicTagResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provider = _data["provider"] ? Provider.fromJS(_data["provider"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            if (Array.isArray(_data["storeProviders"])) {
                this.storeProviders = [] as any;
                for (let item of _data["storeProviders"])
                    this.storeProviders!.push(Provider.fromJS(item));
            }
            this.organization = _data["organization"] ? Organization.fromJS(_data["organization"]) : <any>undefined;
            if (Array.isArray(_data["organizationStores"])) {
                this.organizationStores = [] as any;
                for (let item of _data["organizationStores"])
                    this.organizationStores!.push(Store.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicTagResult {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTagResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider ? this.provider.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (Array.isArray(this.storeProviders)) {
            data["storeProviders"] = [];
            for (let item of this.storeProviders)
                data["storeProviders"].push(item.toJSON());
        }
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        if (Array.isArray(this.organizationStores)) {
            data["organizationStores"] = [];
            for (let item of this.organizationStores)
                data["organizationStores"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPublicTagResult {
    provider?: Provider | undefined;
    store?: Store | undefined;
    storeProviders?: Provider[] | undefined;
    organization?: Organization | undefined;
    organizationStores?: Store[] | undefined;
}

export class SearchLog extends EntityBase implements ISearchLog {
    searchLogID!: string;
    logDate!: Date;
    userAgent?: string | undefined;
    identity?: string | undefined;
    ipAddress?: string | undefined;
    searchText?: string | undefined;
    resultSummary?: string | undefined;
    runTimeInMilliseconds!: number;
    processedDate?: Date | undefined;

    constructor(data?: ISearchLog) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchLogID = _data["searchLogID"];
            this.logDate = _data["logDate"] ? new Date(_data["logDate"].toString()) : <any>undefined;
            this.userAgent = _data["userAgent"];
            this.identity = _data["identity"];
            this.ipAddress = _data["ipAddress"];
            this.searchText = _data["searchText"];
            this.resultSummary = _data["resultSummary"];
            this.runTimeInMilliseconds = _data["runTimeInMilliseconds"];
            this.processedDate = _data["processedDate"] ? new Date(_data["processedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchLog {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchLogID"] = this.searchLogID;
        data["logDate"] = this.logDate ? this.logDate.toISOString() : <any>undefined;
        data["userAgent"] = this.userAgent;
        data["identity"] = this.identity;
        data["ipAddress"] = this.ipAddress;
        data["searchText"] = this.searchText;
        data["resultSummary"] = this.resultSummary;
        data["runTimeInMilliseconds"] = this.runTimeInMilliseconds;
        data["processedDate"] = this.processedDate ? this.processedDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISearchLog extends IEntityBase {
    searchLogID: string;
    logDate: Date;
    userAgent?: string | undefined;
    identity?: string | undefined;
    ipAddress?: string | undefined;
    searchText?: string | undefined;
    resultSummary?: string | undefined;
    runTimeInMilliseconds: number;
    processedDate?: Date | undefined;
}

export class SearchLogDetails implements ISearchLogDetails {
    startDate!: Date;
    endDate!: Date;

    constructor(data?: ISearchLogDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchLogDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLogDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearchLogDetails {
    startDate: Date;
    endDate: Date;
}

export class SecurityAudit extends EntityBase implements ISecurityAudit {
    securityAuditID!: string;
    ipAddress!: string;
    userAgent?: string | undefined;
    email!: string;
    securityAuditActionEnum!: SecurityAuditActionEnum;
    loggedDate!: Date;
    successful!: boolean;
    message?: string | undefined;
    platformTypeEnum!: PlatformTypeEnum;

    constructor(data?: ISecurityAudit) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.securityAuditID = _data["securityAuditID"];
            this.ipAddress = _data["ipAddress"];
            this.userAgent = _data["userAgent"];
            this.email = _data["email"];
            this.securityAuditActionEnum = _data["securityAuditActionEnum"];
            this.loggedDate = _data["loggedDate"] ? new Date(_data["loggedDate"].toString()) : <any>undefined;
            this.successful = _data["successful"];
            this.message = _data["message"];
            this.platformTypeEnum = _data["platformTypeEnum"];
        }
    }

    static fromJS(data: any): SecurityAudit {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAudit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["securityAuditID"] = this.securityAuditID;
        data["ipAddress"] = this.ipAddress;
        data["userAgent"] = this.userAgent;
        data["email"] = this.email;
        data["securityAuditActionEnum"] = this.securityAuditActionEnum;
        data["loggedDate"] = this.loggedDate ? this.loggedDate.toISOString() : <any>undefined;
        data["successful"] = this.successful;
        data["message"] = this.message;
        data["platformTypeEnum"] = this.platformTypeEnum;
        super.toJSON(data);
        return data;
    }
}

export interface ISecurityAudit extends IEntityBase {
    securityAuditID: string;
    ipAddress: string;
    userAgent?: string | undefined;
    email: string;
    securityAuditActionEnum: SecurityAuditActionEnum;
    loggedDate: Date;
    successful: boolean;
    message?: string | undefined;
    platformTypeEnum: PlatformTypeEnum;
}

export enum SecurityAuditActionEnum {
    SignIn = "SignIn",
    ResetPassword = "ResetPassword",
    DeleteUser = "DeleteUser",
    DependantSignIn = "DependantSignIn",
    Delegation = "Delegation",
    USSDWalletSignIn = "USSDWalletSignIn",
    USSDSignIn = "USSDSignIn",
    PhoneNumberSignIn = "PhoneNumberSignIn",
    WalletCardSignIn = "WalletCardSignIn",
    UniqueLifetimeIDSignIn = "UniqueLifetimeIDSignIn",
    CommunitySignIn = "CommunitySignIn",
}

export enum PlatformTypeEnum {
    NotSet = "NotSet",
    Mobile = "Mobile",
    Desktop = "Desktop",
}

export class SecurityAuditSearchDetails implements ISecurityAuditSearchDetails {
    email?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: ISecurityAuditSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SecurityAuditSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityAuditSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISecurityAuditSearchDetails {
    email?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class UserSignInResult implements IUserSignInResult {
    token?: string | undefined;
    expires?: Date;
    roles?: string[] | undefined;
    language?: Language | undefined;
    version?: string | undefined;
    appFeatures?: AppFeatureDetail[] | undefined;
    notificationTags?: string[] | undefined;
    webViewID?: string;
    userDetailID?: string;

    constructor(data?: IUserSignInResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.version = _data["version"];
            if (Array.isArray(_data["appFeatures"])) {
                this.appFeatures = [] as any;
                for (let item of _data["appFeatures"])
                    this.appFeatures!.push(AppFeatureDetail.fromJS(item));
            }
            if (Array.isArray(_data["notificationTags"])) {
                this.notificationTags = [] as any;
                for (let item of _data["notificationTags"])
                    this.notificationTags!.push(item);
            }
            this.webViewID = _data["webViewID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): UserSignInResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserSignInResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["version"] = this.version;
        if (Array.isArray(this.appFeatures)) {
            data["appFeatures"] = [];
            for (let item of this.appFeatures)
                data["appFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationTags)) {
            data["notificationTags"] = [];
            for (let item of this.notificationTags)
                data["notificationTags"].push(item);
        }
        data["webViewID"] = this.webViewID;
        data["userDetailID"] = this.userDetailID;
        return data;
    }
}

export interface IUserSignInResult {
    token?: string | undefined;
    expires?: Date;
    roles?: string[] | undefined;
    language?: Language | undefined;
    version?: string | undefined;
    appFeatures?: AppFeatureDetail[] | undefined;
    notificationTags?: string[] | undefined;
    webViewID?: string;
    userDetailID?: string;
}

export class AppFeatureDetail implements IAppFeatureDetail {
    name?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    roles?: string | undefined;

    constructor(data?: IAppFeatureDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.enabled = _data["enabled"];
            this.roles = _data["roles"];
        }
    }

    static fromJS(data: any): AppFeatureDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AppFeatureDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["enabled"] = this.enabled;
        data["roles"] = this.roles;
        return data;
    }
}

export interface IAppFeatureDetail {
    name?: string | undefined;
    description?: string | undefined;
    enabled?: boolean;
    roles?: string | undefined;
}

export class UserSignInDetails implements IUserSignInDetails {
    emailOrUniqueLifetimeID?: string | undefined;
    passwordOrPIN?: string | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;

    constructor(data?: IUserSignInDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOrUniqueLifetimeID = _data["emailOrUniqueLifetimeID"];
            this.passwordOrPIN = _data["passwordOrPIN"];
            this.subscriptionUserID = _data["subscriptionUserID"];
            this.subscriptionPIN = _data["subscriptionPIN"];
        }
    }

    static fromJS(data: any): UserSignInDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserSignInDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOrUniqueLifetimeID"] = this.emailOrUniqueLifetimeID;
        data["passwordOrPIN"] = this.passwordOrPIN;
        data["subscriptionUserID"] = this.subscriptionUserID;
        data["subscriptionPIN"] = this.subscriptionPIN;
        return data;
    }
}

export interface IUserSignInDetails {
    emailOrUniqueLifetimeID?: string | undefined;
    passwordOrPIN?: string | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
}

export class IdentityError implements IIdentityError {
    code?: string;
    description?: string;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IIdentityError {
    code?: string;
    description?: string;
}

export class UserExistsResult implements IUserExistsResult {
    isValid?: boolean;

    constructor(data?: IUserExistsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): UserExistsResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserExistsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IUserExistsResult {
    isValid?: boolean;
}

export class UserExistsDetails implements IUserExistsDetails {
    email?: string | undefined;
    phoneNumber?: string | undefined;
    apiKey?: string | undefined;

    constructor(data?: IUserExistsDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): UserExistsDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserExistsDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IUserExistsDetails {
    email?: string | undefined;
    phoneNumber?: string | undefined;
    apiKey?: string | undefined;
}

export class UserExistsResult2 implements IUserExistsResult2 {
    isValid?: boolean;
    userType?: string | undefined;

    constructor(data?: IUserExistsResult2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.userType = _data["userType"];
        }
    }

    static fromJS(data: any): UserExistsResult2 {
        data = typeof data === 'object' ? data : {};
        let result = new UserExistsResult2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["userType"] = this.userType;
        return data;
    }
}

export interface IUserExistsResult2 {
    isValid?: boolean;
    userType?: string | undefined;
}

export class SignUpEmailDetailsResults implements ISignUpEmailDetailsResults {
    token?: string | undefined;

    constructor(data?: ISignUpEmailDetailsResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignUpEmailDetailsResults {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpEmailDetailsResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface ISignUpEmailDetailsResults {
    token?: string | undefined;
}

export class SignUpEmailDetails implements ISignUpEmailDetails {
    email?: string | undefined;
    smsNumber?: string | undefined;

    constructor(data?: ISignUpEmailDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.smsNumber = _data["smsNumber"];
        }
    }

    static fromJS(data: any): SignUpEmailDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpEmailDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["smsNumber"] = this.smsNumber;
        return data;
    }
}

export interface ISignUpEmailDetails {
    email?: string | undefined;
    smsNumber?: string | undefined;
}

export class SignUpSMSDetailsResults implements ISignUpSMSDetailsResults {
    token?: string | undefined;

    constructor(data?: ISignUpSMSDetailsResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignUpSMSDetailsResults {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpSMSDetailsResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface ISignUpSMSDetailsResults {
    token?: string | undefined;
}

export class SignUpSMSDetails implements ISignUpSMSDetails {
    smsNumber?: string | undefined;

    constructor(data?: ISignUpSMSDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsNumber = _data["smsNumber"];
        }
    }

    static fromJS(data: any): SignUpSMSDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpSMSDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsNumber"] = this.smsNumber;
        return data;
    }
}

export interface ISignUpSMSDetails {
    smsNumber?: string | undefined;
}

export class VerifyPhoneDetails implements IVerifyPhoneDetails {
    cellPhoneNumber?: string | undefined;

    constructor(data?: IVerifyPhoneDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cellPhoneNumber = _data["cellPhoneNumber"];
        }
    }

    static fromJS(data: any): VerifyPhoneDetails {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPhoneDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cellPhoneNumber"] = this.cellPhoneNumber;
        return data;
    }
}

export interface IVerifyPhoneDetails {
    cellPhoneNumber?: string | undefined;
}

export class SignUpEmailValidateResult implements ISignUpEmailValidateResult {
    isValid?: boolean;

    constructor(data?: ISignUpEmailValidateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): SignUpEmailValidateResult {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpEmailValidateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface ISignUpEmailValidateResult {
    isValid?: boolean;
}

export class SignUpEmailValidate implements ISignUpEmailValidate {
    email?: string | undefined;
    token?: string | undefined;

    constructor(data?: ISignUpEmailValidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignUpEmailValidate {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpEmailValidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        return data;
    }
}

export interface ISignUpEmailValidate {
    email?: string | undefined;
    token?: string | undefined;
}

export class SignUpSMSValidateResult implements ISignUpSMSValidateResult {
    isValid?: boolean;

    constructor(data?: ISignUpSMSValidateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): SignUpSMSValidateResult {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpSMSValidateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface ISignUpSMSValidateResult {
    isValid?: boolean;
}

export class SignUpSMSValidate implements ISignUpSMSValidate {
    smsNumber?: string | undefined;
    token?: string | undefined;

    constructor(data?: ISignUpSMSValidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsNumber = _data["smsNumber"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignUpSMSValidate {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpSMSValidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsNumber"] = this.smsNumber;
        data["token"] = this.token;
        return data;
    }
}

export interface ISignUpSMSValidate {
    smsNumber?: string | undefined;
    token?: string | undefined;
}

export class SignUpProvider implements ISignUpProvider {
    email?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    genderEnum?: GenderEnum;
    countryID?: string;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    timeZone?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    language?: Language | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    smsNumber?: string | undefined;
    accountTypeEnum?: AccountTypeEnum | undefined;
    appTypeEnum?: AppTypeEnum;

    constructor(data?: ISignUpProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.genderEnum = _data["genderEnum"];
            this.countryID = _data["countryID"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.timeZone = _data["timeZone"];
            this.hasAgreedToTC = _data["hasAgreedToTC"];
            this.hasReadPCP = _data["hasReadPCP"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.subscriptionUserID = _data["subscriptionUserID"];
            this.subscriptionPIN = _data["subscriptionPIN"];
            this.smsNumber = _data["smsNumber"];
            this.accountTypeEnum = _data["accountTypeEnum"];
            this.appTypeEnum = _data["appTypeEnum"];
        }
    }

    static fromJS(data: any): SignUpProvider {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["genderEnum"] = this.genderEnum;
        data["countryID"] = this.countryID;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["timeZone"] = this.timeZone;
        data["hasAgreedToTC"] = this.hasAgreedToTC;
        data["hasReadPCP"] = this.hasReadPCP;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["subscriptionUserID"] = this.subscriptionUserID;
        data["subscriptionPIN"] = this.subscriptionPIN;
        data["smsNumber"] = this.smsNumber;
        data["accountTypeEnum"] = this.accountTypeEnum;
        data["appTypeEnum"] = this.appTypeEnum;
        return data;
    }
}

export interface ISignUpProvider {
    email?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    genderEnum?: GenderEnum;
    countryID?: string;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    timeZone?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    language?: Language | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    smsNumber?: string | undefined;
    accountTypeEnum?: AccountTypeEnum | undefined;
    appTypeEnum?: AppTypeEnum;
}

export class SignUpProvider2 implements ISignUpProvider2 {
    email?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    genderEnum?: GenderEnum;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    countryID?: string;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    timeZone?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    language?: Language | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    smsNumber?: string | undefined;
    accountTypeEnum?: AccountTypeEnum | undefined;
    providerTypeEnum?: ProviderTypeEnum | undefined;
    providerRole?: string | undefined;
    speciality?: string | undefined;
    subSpeciality?: ProviderSpecialtyDto[] | undefined;
    providerDegreeLocation?: string | undefined;
    providerDegreeSchool?: string | undefined;
    providerDegreeYear?: string | undefined;
    appTypeEnum?: AppTypeEnum;

    constructor(data?: ISignUpProvider2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.genderEnum = _data["genderEnum"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.countryID = _data["countryID"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.timeZone = _data["timeZone"];
            this.hasAgreedToTC = _data["hasAgreedToTC"];
            this.hasReadPCP = _data["hasReadPCP"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.subscriptionUserID = _data["subscriptionUserID"];
            this.subscriptionPIN = _data["subscriptionPIN"];
            this.smsNumber = _data["smsNumber"];
            this.accountTypeEnum = _data["accountTypeEnum"];
            this.providerTypeEnum = _data["providerTypeEnum"];
            this.providerRole = _data["providerRole"];
            this.speciality = _data["speciality"];
            if (Array.isArray(_data["subSpeciality"])) {
                this.subSpeciality = [] as any;
                for (let item of _data["subSpeciality"])
                    this.subSpeciality!.push(ProviderSpecialtyDto.fromJS(item));
            }
            this.providerDegreeLocation = _data["providerDegreeLocation"];
            this.providerDegreeSchool = _data["providerDegreeSchool"];
            this.providerDegreeYear = _data["providerDegreeYear"];
            this.appTypeEnum = _data["appTypeEnum"];
        }
    }

    static fromJS(data: any): SignUpProvider2 {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpProvider2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["genderEnum"] = this.genderEnum;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["countryID"] = this.countryID;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["timeZone"] = this.timeZone;
        data["hasAgreedToTC"] = this.hasAgreedToTC;
        data["hasReadPCP"] = this.hasReadPCP;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["subscriptionUserID"] = this.subscriptionUserID;
        data["subscriptionPIN"] = this.subscriptionPIN;
        data["smsNumber"] = this.smsNumber;
        data["accountTypeEnum"] = this.accountTypeEnum;
        data["providerTypeEnum"] = this.providerTypeEnum;
        data["providerRole"] = this.providerRole;
        data["speciality"] = this.speciality;
        if (Array.isArray(this.subSpeciality)) {
            data["subSpeciality"] = [];
            for (let item of this.subSpeciality)
                data["subSpeciality"].push(item.toJSON());
        }
        data["providerDegreeLocation"] = this.providerDegreeLocation;
        data["providerDegreeSchool"] = this.providerDegreeSchool;
        data["providerDegreeYear"] = this.providerDegreeYear;
        data["appTypeEnum"] = this.appTypeEnum;
        return data;
    }
}

export interface ISignUpProvider2 {
    email?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    genderEnum?: GenderEnum;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    countryID?: string;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    timeZone?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    language?: Language | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    smsNumber?: string | undefined;
    accountTypeEnum?: AccountTypeEnum | undefined;
    providerTypeEnum?: ProviderTypeEnum | undefined;
    providerRole?: string | undefined;
    speciality?: string | undefined;
    subSpeciality?: ProviderSpecialtyDto[] | undefined;
    providerDegreeLocation?: string | undefined;
    providerDegreeSchool?: string | undefined;
    providerDegreeYear?: string | undefined;
    appTypeEnum?: AppTypeEnum;
}

export class ProviderSpecialtyDto implements IProviderSpecialtyDto {
    name?: string | undefined;
    id?: string;
    isPrimary?: boolean;

    constructor(data?: IProviderSpecialtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): ProviderSpecialtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderSpecialtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IProviderSpecialtyDto {
    name?: string | undefined;
    id?: string;
    isPrimary?: boolean;
}

export class UpdateProviderDto implements IUpdateProviderDto {
    userdetailID?: string;
    email?: string | undefined;
    genderEnum?: GenderEnum;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    smsNumber?: string | undefined;
    accountTypeEnum?: AccountTypeEnum | undefined;
    providerTypeEnum?: ProviderTypeEnum | undefined;
    providerRole?: string | undefined;
    speciality?: string | undefined;
    subSpeciality?: ProviderSpecialtyDto[] | undefined;
    providerDegreeLocation?: string | undefined;
    providerDegreeSchool?: string | undefined;
    providerDegreeYear?: string | undefined;
    appTypeEnum?: AppTypeEnum;

    constructor(data?: IUpdateProviderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userdetailID = _data["userdetailID"];
            this.email = _data["email"];
            this.genderEnum = _data["genderEnum"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.hasAgreedToTC = _data["hasAgreedToTC"];
            this.hasReadPCP = _data["hasReadPCP"];
            this.smsNumber = _data["smsNumber"];
            this.accountTypeEnum = _data["accountTypeEnum"];
            this.providerTypeEnum = _data["providerTypeEnum"];
            this.providerRole = _data["providerRole"];
            this.speciality = _data["speciality"];
            if (Array.isArray(_data["subSpeciality"])) {
                this.subSpeciality = [] as any;
                for (let item of _data["subSpeciality"])
                    this.subSpeciality!.push(ProviderSpecialtyDto.fromJS(item));
            }
            this.providerDegreeLocation = _data["providerDegreeLocation"];
            this.providerDegreeSchool = _data["providerDegreeSchool"];
            this.providerDegreeYear = _data["providerDegreeYear"];
            this.appTypeEnum = _data["appTypeEnum"];
        }
    }

    static fromJS(data: any): UpdateProviderDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProviderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userdetailID"] = this.userdetailID;
        data["email"] = this.email;
        data["genderEnum"] = this.genderEnum;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["hasAgreedToTC"] = this.hasAgreedToTC;
        data["hasReadPCP"] = this.hasReadPCP;
        data["smsNumber"] = this.smsNumber;
        data["accountTypeEnum"] = this.accountTypeEnum;
        data["providerTypeEnum"] = this.providerTypeEnum;
        data["providerRole"] = this.providerRole;
        data["speciality"] = this.speciality;
        if (Array.isArray(this.subSpeciality)) {
            data["subSpeciality"] = [];
            for (let item of this.subSpeciality)
                data["subSpeciality"].push(item.toJSON());
        }
        data["providerDegreeLocation"] = this.providerDegreeLocation;
        data["providerDegreeSchool"] = this.providerDegreeSchool;
        data["providerDegreeYear"] = this.providerDegreeYear;
        data["appTypeEnum"] = this.appTypeEnum;
        return data;
    }
}

export interface IUpdateProviderDto {
    userdetailID?: string;
    email?: string | undefined;
    genderEnum?: GenderEnum;
    country?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    smsNumber?: string | undefined;
    accountTypeEnum?: AccountTypeEnum | undefined;
    providerTypeEnum?: ProviderTypeEnum | undefined;
    providerRole?: string | undefined;
    speciality?: string | undefined;
    subSpeciality?: ProviderSpecialtyDto[] | undefined;
    providerDegreeLocation?: string | undefined;
    providerDegreeSchool?: string | undefined;
    providerDegreeYear?: string | undefined;
    appTypeEnum?: AppTypeEnum;
}

export class SignUpPatient implements ISignUpPatient {
    email?: string | undefined;
    confirmEmail?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    genderEnum?: GenderEnum;
    countryID?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    timeZone?: string | undefined;
    birthDateString?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    language?: Language | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    smsNumber?: string | undefined;
    marketingCampaignReferralCode?: string | undefined;
    host?: string | undefined;
    appTypeEnum?: AppTypeEnum;

    constructor(data?: ISignUpPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.confirmEmail = _data["confirmEmail"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.genderEnum = _data["genderEnum"];
            this.countryID = _data["countryID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.timeZone = _data["timeZone"];
            this.birthDateString = _data["birthDateString"];
            this.hasAgreedToTC = _data["hasAgreedToTC"];
            this.hasReadPCP = _data["hasReadPCP"];
            this.language = _data["language"] ? Language.fromJS(_data["language"]) : <any>undefined;
            this.subscriptionUserID = _data["subscriptionUserID"];
            this.subscriptionPIN = _data["subscriptionPIN"];
            this.smsNumber = _data["smsNumber"];
            this.marketingCampaignReferralCode = _data["marketingCampaignReferralCode"];
            this.host = _data["host"];
            this.appTypeEnum = _data["appTypeEnum"];
        }
    }

    static fromJS(data: any): SignUpPatient {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["confirmEmail"] = this.confirmEmail;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["genderEnum"] = this.genderEnum;
        data["countryID"] = this.countryID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["timeZone"] = this.timeZone;
        data["birthDateString"] = this.birthDateString;
        data["hasAgreedToTC"] = this.hasAgreedToTC;
        data["hasReadPCP"] = this.hasReadPCP;
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["subscriptionUserID"] = this.subscriptionUserID;
        data["subscriptionPIN"] = this.subscriptionPIN;
        data["smsNumber"] = this.smsNumber;
        data["marketingCampaignReferralCode"] = this.marketingCampaignReferralCode;
        data["host"] = this.host;
        data["appTypeEnum"] = this.appTypeEnum;
        return data;
    }
}

export interface ISignUpPatient {
    email?: string | undefined;
    confirmEmail?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    genderEnum?: GenderEnum;
    countryID?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    timeZone?: string | undefined;
    birthDateString?: string | undefined;
    hasAgreedToTC?: boolean;
    hasReadPCP?: boolean;
    language?: Language | undefined;
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    smsNumber?: string | undefined;
    marketingCampaignReferralCode?: string | undefined;
    host?: string | undefined;
    appTypeEnum?: AppTypeEnum;
}

export class CreateIdentitiesResult implements ICreateIdentitiesResult {
    usersCreated?: number;
    runTime?: string;

    constructor(data?: ICreateIdentitiesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersCreated = _data["usersCreated"];
            this.runTime = _data["runTime"];
        }
    }

    static fromJS(data: any): CreateIdentitiesResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIdentitiesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersCreated"] = this.usersCreated;
        data["runTime"] = this.runTime;
        return data;
    }
}

export interface ICreateIdentitiesResult {
    usersCreated?: number;
    runTime?: string;
}

export class CreateIdentitiesDetails implements ICreateIdentitiesDetails {
    usersToCreate?: number;
    countryID?: string;
    timeZoneID?: string | undefined;
    subscriptionID?: string | undefined;

    constructor(data?: ICreateIdentitiesDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersToCreate = _data["usersToCreate"];
            this.countryID = _data["countryID"];
            this.timeZoneID = _data["timeZoneID"];
            this.subscriptionID = _data["subscriptionID"];
        }
    }

    static fromJS(data: any): CreateIdentitiesDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIdentitiesDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersToCreate"] = this.usersToCreate;
        data["countryID"] = this.countryID;
        data["timeZoneID"] = this.timeZoneID;
        data["subscriptionID"] = this.subscriptionID;
        return data;
    }
}

export interface ICreateIdentitiesDetails {
    usersToCreate?: number;
    countryID?: string;
    timeZoneID?: string | undefined;
    subscriptionID?: string | undefined;
}

export class ChangePasswordResult implements IChangePasswordResult {
    success?: boolean;

    constructor(data?: IChangePasswordResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ChangePasswordResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IChangePasswordResult {
    success?: boolean;
}

export class ChangePasswordDetails implements IChangePasswordDetails {
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordDetails {
    newPassword?: string | undefined;
}

export class ResetPasswordAdminDetails implements IResetPasswordAdminDetails {
    emailOrUniqueLifetimeID?: string | undefined;
    password?: string | undefined;

    constructor(data?: IResetPasswordAdminDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOrUniqueLifetimeID = _data["emailOrUniqueLifetimeID"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordAdminDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordAdminDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOrUniqueLifetimeID"] = this.emailOrUniqueLifetimeID;
        data["password"] = this.password;
        return data;
    }
}

export interface IResetPasswordAdminDetails {
    emailOrUniqueLifetimeID?: string | undefined;
    password?: string | undefined;
}

export class ChangeExternalIDAdminDetails implements IChangeExternalIDAdminDetails {
    userDetailID?: string;
    externalID?: string | undefined;

    constructor(data?: IChangeExternalIDAdminDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.externalID = _data["externalID"];
        }
    }

    static fromJS(data: any): ChangeExternalIDAdminDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeExternalIDAdminDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["externalID"] = this.externalID;
        return data;
    }
}

export interface IChangeExternalIDAdminDetails {
    userDetailID?: string;
    externalID?: string | undefined;
}

export class AssignProviderTypeDetails implements IAssignProviderTypeDetails {
    providerID?: string;
    providerTypeEnum?: ProviderTypeEnum;

    constructor(data?: IAssignProviderTypeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.providerTypeEnum = _data["providerTypeEnum"];
        }
    }

    static fromJS(data: any): AssignProviderTypeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AssignProviderTypeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["providerTypeEnum"] = this.providerTypeEnum;
        return data;
    }
}

export interface IAssignProviderTypeDetails {
    providerID?: string;
    providerTypeEnum?: ProviderTypeEnum;
}

export class ChangeWalletPINDetails implements IChangeWalletPINDetails {
    pin?: string | undefined;

    constructor(data?: IChangeWalletPINDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): ChangeWalletPINDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeWalletPINDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        return data;
    }
}

export interface IChangeWalletPINDetails {
    pin?: string | undefined;
}

export class OneTimePasswordDetails implements IOneTimePasswordDetails {
    email?: string | undefined;
    smsNumber?: string | undefined;

    constructor(data?: IOneTimePasswordDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.smsNumber = _data["smsNumber"];
        }
    }

    static fromJS(data: any): OneTimePasswordDetails {
        data = typeof data === 'object' ? data : {};
        let result = new OneTimePasswordDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["smsNumber"] = this.smsNumber;
        return data;
    }
}

export interface IOneTimePasswordDetails {
    email?: string | undefined;
    smsNumber?: string | undefined;
}

export class OneTimePasswordValidate implements IOneTimePasswordValidate {
    email?: string | undefined;
    smsNumber?: string | undefined;
    token?: string | undefined;

    constructor(data?: IOneTimePasswordValidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.smsNumber = _data["smsNumber"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): OneTimePasswordValidate {
        data = typeof data === 'object' ? data : {};
        let result = new OneTimePasswordValidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["smsNumber"] = this.smsNumber;
        data["token"] = this.token;
        return data;
    }
}

export interface IOneTimePasswordValidate {
    email?: string | undefined;
    smsNumber?: string | undefined;
    token?: string | undefined;
}

export class Session extends EntityBase implements ISession {
    sessionID!: string;
    data!: string;

    constructor(data?: ISession) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sessionID = _data["sessionID"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): Session {
        data = typeof data === 'object' ? data : {};
        let result = new Session();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionID"] = this.sessionID;
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface ISession extends IEntityBase {
    sessionID: string;
    data: string;
}

export class ShoppingCartDetails implements IShoppingCartDetails {
    userDetailID?: string;
    currencyEnum?: CurrencyEnum;

    constructor(data?: IShoppingCartDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.currencyEnum = _data["currencyEnum"];
        }
    }

    static fromJS(data: any): ShoppingCartDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCartDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["currencyEnum"] = this.currencyEnum;
        return data;
    }
}

export interface IShoppingCartDetails {
    userDetailID?: string;
    currencyEnum?: CurrencyEnum;
}

export class SignUpDetail extends EntityBase implements ISignUpDetail {
    signUpDetailID!: string;
    email!: string;
    code!: string;

    constructor(data?: ISignUpDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.signUpDetailID = _data["signUpDetailID"];
            this.email = _data["email"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): SignUpDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SignUpDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signUpDetailID"] = this.signUpDetailID;
        data["email"] = this.email;
        data["code"] = this.code;
        super.toJSON(data);
        return data;
    }
}

export interface ISignUpDetail extends IEntityBase {
    signUpDetailID: string;
    email: string;
    code: string;
}

export class SMSSearchDetails implements ISMSSearchDetails {
    startDate?: Date;
    endDate?: Date;

    constructor(data?: ISMSSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SMSSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SMSSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISMSSearchDetails {
    startDate?: Date;
    endDate?: Date;
}

export class Statement extends EntityBase implements IStatement {
    statementID!: string;
    userDetailID!: string;
    providerID?: string | undefined;
    storeID?: string | undefined;
    organizationID?: string | undefined;
    qrCode!: number;
    startDate!: Date;
    endDate!: Date;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    fileDetailID?: string | undefined;

    constructor(data?: IStatement) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.statementID = _data["statementID"];
            this.userDetailID = _data["userDetailID"];
            this.providerID = _data["providerID"];
            this.storeID = _data["storeID"];
            this.organizationID = _data["organizationID"];
            this.qrCode = _data["qrCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            this.fileDetailID = _data["fileDetailID"];
        }
    }

    static fromJS(data: any): Statement {
        data = typeof data === 'object' ? data : {};
        let result = new Statement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statementID"] = this.statementID;
        data["userDetailID"] = this.userDetailID;
        data["providerID"] = this.providerID;
        data["storeID"] = this.storeID;
        data["organizationID"] = this.organizationID;
        data["qrCode"] = this.qrCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["province"] = this.province;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["fileDetailID"] = this.fileDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IStatement extends IEntityBase {
    statementID: string;
    userDetailID: string;
    providerID?: string | undefined;
    storeID?: string | undefined;
    organizationID?: string | undefined;
    qrCode: number;
    startDate: Date;
    endDate: Date;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    fileDetailID?: string | undefined;
}

export class StatementDTO implements IStatementDTO {
    storeID?: string | undefined;
    organizationID?: string | undefined;
    providerID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    currencySummaries?: StatementCurrencySummaryDTO[] | undefined;
    statementID?: string;
    qrCode?: number;

    constructor(data?: IStatementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeID = _data["storeID"];
            this.organizationID = _data["organizationID"];
            this.providerID = _data["providerID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.province = _data["province"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            if (Array.isArray(_data["currencySummaries"])) {
                this.currencySummaries = [] as any;
                for (let item of _data["currencySummaries"])
                    this.currencySummaries!.push(StatementCurrencySummaryDTO.fromJS(item));
            }
            this.statementID = _data["statementID"];
            this.qrCode = _data["qrCode"];
        }
    }

    static fromJS(data: any): StatementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeID"] = this.storeID;
        data["organizationID"] = this.organizationID;
        data["providerID"] = this.providerID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["province"] = this.province;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        if (Array.isArray(this.currencySummaries)) {
            data["currencySummaries"] = [];
            for (let item of this.currencySummaries)
                data["currencySummaries"].push(item.toJSON());
        }
        data["statementID"] = this.statementID;
        data["qrCode"] = this.qrCode;
        return data;
    }
}

export interface IStatementDTO {
    storeID?: string | undefined;
    organizationID?: string | undefined;
    providerID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    province?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    currencySummaries?: StatementCurrencySummaryDTO[] | undefined;
    statementID?: string;
    qrCode?: number;
}

export class StatementCurrencySummaryDTO implements IStatementCurrencySummaryDTO {
    totalAmount?: number;
    totalTaxAmount?: number;
    currencyEnum?: CurrencyEnum;
    invoices?: StatementInvoiceDTO[] | undefined;
    taxes?: StatementTaxDTO[] | undefined;
    affiliateSummary?: StatementAffiliateDTO | undefined;

    constructor(data?: IStatementCurrencySummaryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.totalTaxAmount = _data["totalTaxAmount"];
            this.currencyEnum = _data["currencyEnum"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(StatementInvoiceDTO.fromJS(item));
            }
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(StatementTaxDTO.fromJS(item));
            }
            this.affiliateSummary = _data["affiliateSummary"] ? StatementAffiliateDTO.fromJS(_data["affiliateSummary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StatementCurrencySummaryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatementCurrencySummaryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["currencyEnum"] = this.currencyEnum;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item.toJSON());
        }
        data["affiliateSummary"] = this.affiliateSummary ? this.affiliateSummary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStatementCurrencySummaryDTO {
    totalAmount?: number;
    totalTaxAmount?: number;
    currencyEnum?: CurrencyEnum;
    invoices?: StatementInvoiceDTO[] | undefined;
    taxes?: StatementTaxDTO[] | undefined;
    affiliateSummary?: StatementAffiliateDTO | undefined;
}

export class StatementInvoiceDTO implements IStatementInvoiceDTO {
    invoiceID?: string;
    invoiceNo?: number;
    currencyEnum?: CurrencyEnum;
    invoiceTypeEnum?: InvoiceTypeEnum;
    refundedInvoiceID?: string | undefined;
    paymentQRCode?: number;
    invoiceDate?: Date;
    amount?: number;
    taxAmount?: number;
    invoiceItemsDescription?: string | undefined;
    hasConsult?: boolean;
    hasPrescription?: boolean;
    hasOrder?: boolean;
    hasMedication?: boolean;
    hasCustom?: boolean;
    hasNeoPayment?: boolean;
    interactionDate?: Date;
    patientName?: string | undefined;
    qrCode?: number;
    qrCodeDescription?: string | undefined;
    hasPaymentLink?: boolean;

    constructor(data?: IStatementInvoiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceID = _data["invoiceID"];
            this.invoiceNo = _data["invoiceNo"];
            this.currencyEnum = _data["currencyEnum"];
            this.invoiceTypeEnum = _data["invoiceTypeEnum"];
            this.refundedInvoiceID = _data["refundedInvoiceID"];
            this.paymentQRCode = _data["paymentQRCode"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            this.invoiceItemsDescription = _data["invoiceItemsDescription"];
            this.hasConsult = _data["hasConsult"];
            this.hasPrescription = _data["hasPrescription"];
            this.hasOrder = _data["hasOrder"];
            this.hasMedication = _data["hasMedication"];
            this.hasCustom = _data["hasCustom"];
            this.hasNeoPayment = _data["hasNeoPayment"];
            this.interactionDate = _data["interactionDate"] ? new Date(_data["interactionDate"].toString()) : <any>undefined;
            this.patientName = _data["patientName"];
            this.qrCode = _data["qrCode"];
            this.qrCodeDescription = _data["qrCodeDescription"];
            this.hasPaymentLink = _data["hasPaymentLink"];
        }
    }

    static fromJS(data: any): StatementInvoiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatementInvoiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceID"] = this.invoiceID;
        data["invoiceNo"] = this.invoiceNo;
        data["currencyEnum"] = this.currencyEnum;
        data["invoiceTypeEnum"] = this.invoiceTypeEnum;
        data["refundedInvoiceID"] = this.refundedInvoiceID;
        data["paymentQRCode"] = this.paymentQRCode;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["invoiceItemsDescription"] = this.invoiceItemsDescription;
        data["hasConsult"] = this.hasConsult;
        data["hasPrescription"] = this.hasPrescription;
        data["hasOrder"] = this.hasOrder;
        data["hasMedication"] = this.hasMedication;
        data["hasCustom"] = this.hasCustom;
        data["hasNeoPayment"] = this.hasNeoPayment;
        data["interactionDate"] = this.interactionDate ? this.interactionDate.toISOString() : <any>undefined;
        data["patientName"] = this.patientName;
        data["qrCode"] = this.qrCode;
        data["qrCodeDescription"] = this.qrCodeDescription;
        data["hasPaymentLink"] = this.hasPaymentLink;
        return data;
    }
}

export interface IStatementInvoiceDTO {
    invoiceID?: string;
    invoiceNo?: number;
    currencyEnum?: CurrencyEnum;
    invoiceTypeEnum?: InvoiceTypeEnum;
    refundedInvoiceID?: string | undefined;
    paymentQRCode?: number;
    invoiceDate?: Date;
    amount?: number;
    taxAmount?: number;
    invoiceItemsDescription?: string | undefined;
    hasConsult?: boolean;
    hasPrescription?: boolean;
    hasOrder?: boolean;
    hasMedication?: boolean;
    hasCustom?: boolean;
    hasNeoPayment?: boolean;
    interactionDate?: Date;
    patientName?: string | undefined;
    qrCode?: number;
    qrCodeDescription?: string | undefined;
    hasPaymentLink?: boolean;
}

export class StatementTaxDTO implements IStatementTaxDTO {
    tax?: Tax | undefined;
    totalTaxAmount?: number;

    constructor(data?: IStatementTaxDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tax = _data["tax"] ? Tax.fromJS(_data["tax"]) : <any>undefined;
            this.totalTaxAmount = _data["totalTaxAmount"];
        }
    }

    static fromJS(data: any): StatementTaxDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatementTaxDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        data["totalTaxAmount"] = this.totalTaxAmount;
        return data;
    }
}

export interface IStatementTaxDTO {
    tax?: Tax | undefined;
    totalTaxAmount?: number;
}

export class StatementAffiliateDTO implements IStatementAffiliateDTO {
    currencyEnum?: CurrencyEnum;
    totalAmount?: number;
    affiliateCount?: number;

    constructor(data?: IStatementAffiliateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyEnum = _data["currencyEnum"];
            this.totalAmount = _data["totalAmount"];
            this.affiliateCount = _data["affiliateCount"];
        }
    }

    static fromJS(data: any): StatementAffiliateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StatementAffiliateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyEnum"] = this.currencyEnum;
        data["totalAmount"] = this.totalAmount;
        data["affiliateCount"] = this.affiliateCount;
        return data;
    }
}

export interface IStatementAffiliateDTO {
    currencyEnum?: CurrencyEnum;
    totalAmount?: number;
    affiliateCount?: number;
}

export class StatementSearchDetails implements IStatementSearchDetails {
    providerID?: string | undefined;
    organizationID?: string | undefined;
    storeID?: string | undefined;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IStatementSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.organizationID = _data["organizationID"];
            this.storeID = _data["storeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StatementSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new StatementSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["organizationID"] = this.organizationID;
        data["storeID"] = this.storeID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStatementSearchDetails {
    providerID?: string | undefined;
    organizationID?: string | undefined;
    storeID?: string | undefined;
    startDate?: Date;
    endDate?: Date;
}

export class StatementsAllByIDDetails implements IStatementsAllByIDDetails {
    providerID?: string | undefined;
    organizationID?: string | undefined;
    storeID?: string | undefined;

    constructor(data?: IStatementsAllByIDDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.organizationID = _data["organizationID"];
            this.storeID = _data["storeID"];
        }
    }

    static fromJS(data: any): StatementsAllByIDDetails {
        data = typeof data === 'object' ? data : {};
        let result = new StatementsAllByIDDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["organizationID"] = this.organizationID;
        data["storeID"] = this.storeID;
        return data;
    }
}

export interface IStatementsAllByIDDetails {
    providerID?: string | undefined;
    organizationID?: string | undefined;
    storeID?: string | undefined;
}

export class StatementGenerateDetails implements IStatementGenerateDetails {
    providerID?: string | undefined;
    organizationID?: string | undefined;
    storeID?: string | undefined;

    constructor(data?: IStatementGenerateDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerID = _data["providerID"];
            this.organizationID = _data["organizationID"];
            this.storeID = _data["storeID"];
        }
    }

    static fromJS(data: any): StatementGenerateDetails {
        data = typeof data === 'object' ? data : {};
        let result = new StatementGenerateDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerID"] = this.providerID;
        data["organizationID"] = this.organizationID;
        data["storeID"] = this.storeID;
        return data;
    }
}

export interface IStatementGenerateDetails {
    providerID?: string | undefined;
    organizationID?: string | undefined;
    storeID?: string | undefined;
}

export class StoreAppointmentSearchResults implements IStoreAppointmentSearchResults {
    runTime?: string;
    message?: string | undefined;
    appointments?: StoreAppointment[] | undefined;
    stores?: Store[] | undefined;

    constructor(data?: IStoreAppointmentSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runTime = _data["runTime"];
            this.message = _data["message"];
            if (Array.isArray(_data["appointments"])) {
                this.appointments = [] as any;
                for (let item of _data["appointments"])
                    this.appointments!.push(StoreAppointment.fromJS(item));
            }
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores!.push(Store.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreAppointmentSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new StoreAppointmentSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        if (Array.isArray(this.appointments)) {
            data["appointments"] = [];
            for (let item of this.appointments)
                data["appointments"].push(item.toJSON());
        }
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStoreAppointmentSearchResults {
    runTime?: string;
    message?: string | undefined;
    appointments?: StoreAppointment[] | undefined;
    stores?: Store[] | undefined;
}

export class StoreAppointmentSearchDetails implements IStoreAppointmentSearchDetails {
    countryID!: string;
    startDate!: Date;
    endDate!: Date;
    searchTypeEnum!: StoreAppointmentSearchTypeEnum;
    appointmentTypeEnum!: AppointmentTypeEnum;
    storeID?: string | undefined;
    providerID?: string | undefined;
    itemID?: string | undefined;
    storeItemID?: string | undefined;

    constructor(data?: IStoreAppointmentSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryID = _data["countryID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.searchTypeEnum = _data["searchTypeEnum"];
            this.appointmentTypeEnum = _data["appointmentTypeEnum"];
            this.storeID = _data["storeID"];
            this.providerID = _data["providerID"];
            this.itemID = _data["itemID"];
            this.storeItemID = _data["storeItemID"];
        }
    }

    static fromJS(data: any): StoreAppointmentSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new StoreAppointmentSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["searchTypeEnum"] = this.searchTypeEnum;
        data["appointmentTypeEnum"] = this.appointmentTypeEnum;
        data["storeID"] = this.storeID;
        data["providerID"] = this.providerID;
        data["itemID"] = this.itemID;
        data["storeItemID"] = this.storeItemID;
        return data;
    }
}

export interface IStoreAppointmentSearchDetails {
    countryID: string;
    startDate: Date;
    endDate: Date;
    searchTypeEnum: StoreAppointmentSearchTypeEnum;
    appointmentTypeEnum: AppointmentTypeEnum;
    storeID?: string | undefined;
    providerID?: string | undefined;
    itemID?: string | undefined;
    storeItemID?: string | undefined;
}

export enum StoreAppointmentSearchTypeEnum {
    Stores = "Stores",
    Providers = "Providers",
    Appointments = "Appointments",
}

export class BookStoreAppointmentResults implements IBookStoreAppointmentResults {
    success?: boolean;
    bookedDate?: Date;
    storeAppointmentID?: string;

    constructor(data?: IBookStoreAppointmentResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.bookedDate = _data["bookedDate"] ? new Date(_data["bookedDate"].toString()) : <any>undefined;
            this.storeAppointmentID = _data["storeAppointmentID"];
        }
    }

    static fromJS(data: any): BookStoreAppointmentResults {
        data = typeof data === 'object' ? data : {};
        let result = new BookStoreAppointmentResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["bookedDate"] = this.bookedDate ? this.bookedDate.toISOString() : <any>undefined;
        data["storeAppointmentID"] = this.storeAppointmentID;
        return data;
    }
}

export interface IBookStoreAppointmentResults {
    success?: boolean;
    bookedDate?: Date;
    storeAppointmentID?: string;
}

export class BookStoreAppointmentDetails implements IBookStoreAppointmentDetails {
    storeAppointmentID?: string;
    consultID?: string;

    constructor(data?: IBookStoreAppointmentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeAppointmentID = _data["storeAppointmentID"];
            this.consultID = _data["consultID"];
        }
    }

    static fromJS(data: any): BookStoreAppointmentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BookStoreAppointmentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeAppointmentID"] = this.storeAppointmentID;
        data["consultID"] = this.consultID;
        return data;
    }
}

export interface IBookStoreAppointmentDetails {
    storeAppointmentID?: string;
    consultID?: string;
}

export class PagedResultOfStoreItem implements IPagedResultOfStoreItem {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: StoreItem[] | undefined;

    constructor(data?: IPagedResultOfStoreItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StoreItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfStoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfStoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfStoreItem {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: StoreItem[] | undefined;
}

export class StoreItemSearchDetails extends PagedQuery implements IStoreItemSearchDetails {
    storeID?: string;
    searchText?: string | undefined;
    eStore?: boolean | undefined;
    storeItemTypeEnums?: StoreItemTypeEnum[] | undefined;

    constructor(data?: IStoreItemSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeID = _data["storeID"];
            this.searchText = _data["searchText"];
            this.eStore = _data["eStore"];
            if (Array.isArray(_data["storeItemTypeEnums"])) {
                this.storeItemTypeEnums = [] as any;
                for (let item of _data["storeItemTypeEnums"])
                    this.storeItemTypeEnums!.push(item);
            }
        }
    }

    static fromJS(data: any): StoreItemSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new StoreItemSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeID"] = this.storeID;
        data["searchText"] = this.searchText;
        data["eStore"] = this.eStore;
        if (Array.isArray(this.storeItemTypeEnums)) {
            data["storeItemTypeEnums"] = [];
            for (let item of this.storeItemTypeEnums)
                data["storeItemTypeEnums"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStoreItemSearchDetails extends IPagedQuery {
    storeID?: string;
    searchText?: string | undefined;
    eStore?: boolean | undefined;
    storeItemTypeEnums?: StoreItemTypeEnum[] | undefined;
}

export class StoreScheduleSearchDetails implements IStoreScheduleSearchDetails {
    storeID?: string;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: IStoreScheduleSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeID = _data["storeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreScheduleSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new StoreScheduleSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeID"] = this.storeID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStoreScheduleSearchDetails {
    storeID?: string;
    startDate?: Date;
    endDate?: Date;
}

export class CreateStoreScheduleResult implements ICreateStoreScheduleResult {
    success?: boolean;
    storeScheduleID?: string;
    recurringID?: string;
    existingStoreSchedules?: StoreSchedule[] | undefined;
    storeAppointmentsCreated?: number;
    runTime?: string;
    message?: string | undefined;

    constructor(data?: ICreateStoreScheduleResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.storeScheduleID = _data["storeScheduleID"];
            this.recurringID = _data["recurringID"];
            if (Array.isArray(_data["existingStoreSchedules"])) {
                this.existingStoreSchedules = [] as any;
                for (let item of _data["existingStoreSchedules"])
                    this.existingStoreSchedules!.push(StoreSchedule.fromJS(item));
            }
            this.storeAppointmentsCreated = _data["storeAppointmentsCreated"];
            this.runTime = _data["runTime"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateStoreScheduleResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStoreScheduleResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["storeScheduleID"] = this.storeScheduleID;
        data["recurringID"] = this.recurringID;
        if (Array.isArray(this.existingStoreSchedules)) {
            data["existingStoreSchedules"] = [];
            for (let item of this.existingStoreSchedules)
                data["existingStoreSchedules"].push(item.toJSON());
        }
        data["storeAppointmentsCreated"] = this.storeAppointmentsCreated;
        data["runTime"] = this.runTime;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateStoreScheduleResult {
    success?: boolean;
    storeScheduleID?: string;
    recurringID?: string;
    existingStoreSchedules?: StoreSchedule[] | undefined;
    storeAppointmentsCreated?: number;
    runTime?: string;
    message?: string | undefined;
}

export class StoreScheduleDeleteRecurringResults implements IStoreScheduleDeleteRecurringResults {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IStoreScheduleDeleteRecurringResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): StoreScheduleDeleteRecurringResults {
        data = typeof data === 'object' ? data : {};
        let result = new StoreScheduleDeleteRecurringResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IStoreScheduleDeleteRecurringResults {
    success?: boolean;
    message?: string | undefined;
}

export class SearchStoreAvailabilityDetails implements ISearchStoreAvailabilityDetails {
    storeTypeEnum?: StoreTypeEnum | undefined;
    countryID?: string;
    tagID?: string | undefined;
    organizationID?: string | undefined;
    genderEnum?: GenderEnum | undefined;
    languageTagID?: string | undefined;

    constructor(data?: ISearchStoreAvailabilityDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeTypeEnum = _data["storeTypeEnum"];
            this.countryID = _data["countryID"];
            this.tagID = _data["tagID"];
            this.organizationID = _data["organizationID"];
            this.genderEnum = _data["genderEnum"];
            this.languageTagID = _data["languageTagID"];
        }
    }

    static fromJS(data: any): SearchStoreAvailabilityDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStoreAvailabilityDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeTypeEnum"] = this.storeTypeEnum;
        data["countryID"] = this.countryID;
        data["tagID"] = this.tagID;
        data["organizationID"] = this.organizationID;
        data["genderEnum"] = this.genderEnum;
        data["languageTagID"] = this.languageTagID;
        return data;
    }
}

export interface ISearchStoreAvailabilityDetails {
    storeTypeEnum?: StoreTypeEnum | undefined;
    countryID?: string;
    tagID?: string | undefined;
    organizationID?: string | undefined;
    genderEnum?: GenderEnum | undefined;
    languageTagID?: string | undefined;
}

export class SearchStoreDetails implements ISearchStoreDetails {
    countryID?: string;
    storeTypeEnum?: StoreTypeEnum;
    tagID?: string | undefined;
    organizationID?: string | undefined;

    constructor(data?: ISearchStoreDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryID = _data["countryID"];
            this.storeTypeEnum = _data["storeTypeEnum"];
            this.tagID = _data["tagID"];
            this.organizationID = _data["organizationID"];
        }
    }

    static fromJS(data: any): SearchStoreDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStoreDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["storeTypeEnum"] = this.storeTypeEnum;
        data["tagID"] = this.tagID;
        data["organizationID"] = this.organizationID;
        return data;
    }
}

export interface ISearchStoreDetails {
    countryID?: string;
    storeTypeEnum?: StoreTypeEnum;
    tagID?: string | undefined;
    organizationID?: string | undefined;
}

export class CountryDefaultStoreDetails implements ICountryDefaultStoreDetails {
    countryID?: string;
    storeTypeEnum?: StoreTypeEnum;

    constructor(data?: ICountryDefaultStoreDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryID = _data["countryID"];
            this.storeTypeEnum = _data["storeTypeEnum"];
        }
    }

    static fromJS(data: any): CountryDefaultStoreDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDefaultStoreDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["storeTypeEnum"] = this.storeTypeEnum;
        return data;
    }
}

export interface ICountryDefaultStoreDetails {
    countryID?: string;
    storeTypeEnum?: StoreTypeEnum;
}

export class SubscriptionInvoice extends EntityBase implements ISubscriptionInvoice {
    subscriptionInvoiceID!: string;
    subscriptionID!: string;
    userDetailID!: string;
    invoiceID!: string;
    comments?: string | undefined;
    invoice?: Invoice | undefined;

    constructor(data?: ISubscriptionInvoice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionInvoiceID = _data["subscriptionInvoiceID"];
            this.subscriptionID = _data["subscriptionID"];
            this.userDetailID = _data["userDetailID"];
            this.invoiceID = _data["invoiceID"];
            this.comments = _data["comments"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionInvoiceID"] = this.subscriptionInvoiceID;
        data["subscriptionID"] = this.subscriptionID;
        data["userDetailID"] = this.userDetailID;
        data["invoiceID"] = this.invoiceID;
        data["comments"] = this.comments;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionInvoice extends IEntityBase {
    subscriptionInvoiceID: string;
    subscriptionID: string;
    userDetailID: string;
    invoiceID: string;
    comments?: string | undefined;
    invoice?: Invoice | undefined;
}

export class Subscription extends EntityBase implements ISubscription {
    subscriptionID!: string;
    userDetailID!: string;
    subscriptionTypeEnum!: SubscriptionTypeEnum;
    subscriptionStatusEnum!: SubscriptionStatusEnum;
    name!: string;
    shortName!: string;
    description?: string | undefined;
    startDate!: Date;
    endDate?: Date | undefined;
    countryID!: string;
    details?: string | undefined;
    numberOfUserDetails!: number;
    logoURL?: string | undefined;
    recurring!: boolean;
    frequencyEnum?: FrequencyEnum | undefined;
    storeItemID?: string | undefined;
    recurringMonthlyStoreItemID?: string | undefined;
    recurringMonthlyCount?: number | undefined;
    recurringYearlyStoreItemID?: string | undefined;
    recurringYearlyCount?: number | undefined;
    customerName?: string | undefined;
    customerEmailAddress?: string | undefined;
    customerAddressLine1?: string | undefined;
    customerAddressLine2?: string | undefined;
    customerCity?: string | undefined;
    customerProvince?: string | undefined;
    customerPostCode?: string | undefined;
    customerCountry?: string | undefined;
    customerPhone?: string | undefined;
    currencyEnum!: CurrencyEnum;
    welcomeTitle?: string | undefined;
    welcomeMessage?: string | undefined;
    welcomeImageURL?: string | undefined;
    country?: Country | undefined;
    storeItem?: StoreItem | undefined;
    recurringMonthlyStoreItem?: StoreItem | undefined;
    recurringYearlyStoreItem?: StoreItem | undefined;
    subscriptionStoreItems?: SubscriptionStoreItem[] | undefined;
    subscriptionInvoices?: SubscriptionInvoice[] | undefined;
    subscriptionEventInvoices?: SubscriptionEventInvoice[] | undefined;
    subscriptionRoles?: SubscriptionRole[] | undefined;
    subscriptionUserDetails?: SubscriptionUserDetail[] | undefined;

    constructor(data?: ISubscription) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionID = _data["subscriptionID"];
            this.userDetailID = _data["userDetailID"];
            this.subscriptionTypeEnum = _data["subscriptionTypeEnum"];
            this.subscriptionStatusEnum = _data["subscriptionStatusEnum"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.countryID = _data["countryID"];
            this.details = _data["details"];
            this.numberOfUserDetails = _data["numberOfUserDetails"];
            this.logoURL = _data["logoURL"];
            this.recurring = _data["recurring"];
            this.frequencyEnum = _data["frequencyEnum"];
            this.storeItemID = _data["storeItemID"];
            this.recurringMonthlyStoreItemID = _data["recurringMonthlyStoreItemID"];
            this.recurringMonthlyCount = _data["recurringMonthlyCount"];
            this.recurringYearlyStoreItemID = _data["recurringYearlyStoreItemID"];
            this.recurringYearlyCount = _data["recurringYearlyCount"];
            this.customerName = _data["customerName"];
            this.customerEmailAddress = _data["customerEmailAddress"];
            this.customerAddressLine1 = _data["customerAddressLine1"];
            this.customerAddressLine2 = _data["customerAddressLine2"];
            this.customerCity = _data["customerCity"];
            this.customerProvince = _data["customerProvince"];
            this.customerPostCode = _data["customerPostCode"];
            this.customerCountry = _data["customerCountry"];
            this.customerPhone = _data["customerPhone"];
            this.currencyEnum = _data["currencyEnum"];
            this.welcomeTitle = _data["welcomeTitle"];
            this.welcomeMessage = _data["welcomeMessage"];
            this.welcomeImageURL = _data["welcomeImageURL"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.recurringMonthlyStoreItem = _data["recurringMonthlyStoreItem"] ? StoreItem.fromJS(_data["recurringMonthlyStoreItem"]) : <any>undefined;
            this.recurringYearlyStoreItem = _data["recurringYearlyStoreItem"] ? StoreItem.fromJS(_data["recurringYearlyStoreItem"]) : <any>undefined;
            if (Array.isArray(_data["subscriptionStoreItems"])) {
                this.subscriptionStoreItems = [] as any;
                for (let item of _data["subscriptionStoreItems"])
                    this.subscriptionStoreItems!.push(SubscriptionStoreItem.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionInvoices"])) {
                this.subscriptionInvoices = [] as any;
                for (let item of _data["subscriptionInvoices"])
                    this.subscriptionInvoices!.push(SubscriptionInvoice.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionEventInvoices"])) {
                this.subscriptionEventInvoices = [] as any;
                for (let item of _data["subscriptionEventInvoices"])
                    this.subscriptionEventInvoices!.push(SubscriptionEventInvoice.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionRoles"])) {
                this.subscriptionRoles = [] as any;
                for (let item of _data["subscriptionRoles"])
                    this.subscriptionRoles!.push(SubscriptionRole.fromJS(item));
            }
            if (Array.isArray(_data["subscriptionUserDetails"])) {
                this.subscriptionUserDetails = [] as any;
                for (let item of _data["subscriptionUserDetails"])
                    this.subscriptionUserDetails!.push(SubscriptionUserDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionID"] = this.subscriptionID;
        data["userDetailID"] = this.userDetailID;
        data["subscriptionTypeEnum"] = this.subscriptionTypeEnum;
        data["subscriptionStatusEnum"] = this.subscriptionStatusEnum;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["countryID"] = this.countryID;
        data["details"] = this.details;
        data["numberOfUserDetails"] = this.numberOfUserDetails;
        data["logoURL"] = this.logoURL;
        data["recurring"] = this.recurring;
        data["frequencyEnum"] = this.frequencyEnum;
        data["storeItemID"] = this.storeItemID;
        data["recurringMonthlyStoreItemID"] = this.recurringMonthlyStoreItemID;
        data["recurringMonthlyCount"] = this.recurringMonthlyCount;
        data["recurringYearlyStoreItemID"] = this.recurringYearlyStoreItemID;
        data["recurringYearlyCount"] = this.recurringYearlyCount;
        data["customerName"] = this.customerName;
        data["customerEmailAddress"] = this.customerEmailAddress;
        data["customerAddressLine1"] = this.customerAddressLine1;
        data["customerAddressLine2"] = this.customerAddressLine2;
        data["customerCity"] = this.customerCity;
        data["customerProvince"] = this.customerProvince;
        data["customerPostCode"] = this.customerPostCode;
        data["customerCountry"] = this.customerCountry;
        data["customerPhone"] = this.customerPhone;
        data["currencyEnum"] = this.currencyEnum;
        data["welcomeTitle"] = this.welcomeTitle;
        data["welcomeMessage"] = this.welcomeMessage;
        data["welcomeImageURL"] = this.welcomeImageURL;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["recurringMonthlyStoreItem"] = this.recurringMonthlyStoreItem ? this.recurringMonthlyStoreItem.toJSON() : <any>undefined;
        data["recurringYearlyStoreItem"] = this.recurringYearlyStoreItem ? this.recurringYearlyStoreItem.toJSON() : <any>undefined;
        if (Array.isArray(this.subscriptionStoreItems)) {
            data["subscriptionStoreItems"] = [];
            for (let item of this.subscriptionStoreItems)
                data["subscriptionStoreItems"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionInvoices)) {
            data["subscriptionInvoices"] = [];
            for (let item of this.subscriptionInvoices)
                data["subscriptionInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionEventInvoices)) {
            data["subscriptionEventInvoices"] = [];
            for (let item of this.subscriptionEventInvoices)
                data["subscriptionEventInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionRoles)) {
            data["subscriptionRoles"] = [];
            for (let item of this.subscriptionRoles)
                data["subscriptionRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.subscriptionUserDetails)) {
            data["subscriptionUserDetails"] = [];
            for (let item of this.subscriptionUserDetails)
                data["subscriptionUserDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISubscription extends IEntityBase {
    subscriptionID: string;
    userDetailID: string;
    subscriptionTypeEnum: SubscriptionTypeEnum;
    subscriptionStatusEnum: SubscriptionStatusEnum;
    name: string;
    shortName: string;
    description?: string | undefined;
    startDate: Date;
    endDate?: Date | undefined;
    countryID: string;
    details?: string | undefined;
    numberOfUserDetails: number;
    logoURL?: string | undefined;
    recurring: boolean;
    frequencyEnum?: FrequencyEnum | undefined;
    storeItemID?: string | undefined;
    recurringMonthlyStoreItemID?: string | undefined;
    recurringMonthlyCount?: number | undefined;
    recurringYearlyStoreItemID?: string | undefined;
    recurringYearlyCount?: number | undefined;
    customerName?: string | undefined;
    customerEmailAddress?: string | undefined;
    customerAddressLine1?: string | undefined;
    customerAddressLine2?: string | undefined;
    customerCity?: string | undefined;
    customerProvince?: string | undefined;
    customerPostCode?: string | undefined;
    customerCountry?: string | undefined;
    customerPhone?: string | undefined;
    currencyEnum: CurrencyEnum;
    welcomeTitle?: string | undefined;
    welcomeMessage?: string | undefined;
    welcomeImageURL?: string | undefined;
    country?: Country | undefined;
    storeItem?: StoreItem | undefined;
    recurringMonthlyStoreItem?: StoreItem | undefined;
    recurringYearlyStoreItem?: StoreItem | undefined;
    subscriptionStoreItems?: SubscriptionStoreItem[] | undefined;
    subscriptionInvoices?: SubscriptionInvoice[] | undefined;
    subscriptionEventInvoices?: SubscriptionEventInvoice[] | undefined;
    subscriptionRoles?: SubscriptionRole[] | undefined;
    subscriptionUserDetails?: SubscriptionUserDetail[] | undefined;
}

export enum SubscriptionTypeEnum {
    NormalSubscription = "NormalSubscription",
    HealthCareSponsorship = "HealthCareSponsorship",
}

export enum SubscriptionStatusEnum {
    Draft = "Draft",
    Active = "Active",
    Expired = "Expired",
    CancelledBySubscriber = "CancelledBySubscriber",
    CancelledForNonPayment = "CancelledForNonPayment",
}

export class SubscriptionStoreItem extends EntityBase implements ISubscriptionStoreItem {
    subscriptionStoreItemID!: string;
    subscriptionID!: string;
    storeItemID!: string;
    negateStoreItemID!: string;
    taxID!: string;
    glAccountID!: string;
    quantity!: number;
    retailAmount!: number;
    overrideRetailAmount?: number | undefined;
    quantityPerSubscriber!: number;
    description?: string | undefined;
    storeItemDiscount!: number;
    glAccount?: GLAccount | undefined;
    storeItem?: StoreItem | undefined;
    negateStoreItem?: StoreItem | undefined;
    tax?: Tax | undefined;

    constructor(data?: ISubscriptionStoreItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionStoreItemID = _data["subscriptionStoreItemID"];
            this.subscriptionID = _data["subscriptionID"];
            this.storeItemID = _data["storeItemID"];
            this.negateStoreItemID = _data["negateStoreItemID"];
            this.taxID = _data["taxID"];
            this.glAccountID = _data["glAccountID"];
            this.quantity = _data["quantity"];
            this.retailAmount = _data["retailAmount"];
            this.overrideRetailAmount = _data["overrideRetailAmount"];
            this.quantityPerSubscriber = _data["quantityPerSubscriber"];
            this.description = _data["description"];
            this.storeItemDiscount = _data["storeItemDiscount"];
            this.glAccount = _data["glAccount"] ? GLAccount.fromJS(_data["glAccount"]) : <any>undefined;
            this.storeItem = _data["storeItem"] ? StoreItem.fromJS(_data["storeItem"]) : <any>undefined;
            this.negateStoreItem = _data["negateStoreItem"] ? StoreItem.fromJS(_data["negateStoreItem"]) : <any>undefined;
            this.tax = _data["tax"] ? Tax.fromJS(_data["tax"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionStoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionStoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionStoreItemID"] = this.subscriptionStoreItemID;
        data["subscriptionID"] = this.subscriptionID;
        data["storeItemID"] = this.storeItemID;
        data["negateStoreItemID"] = this.negateStoreItemID;
        data["taxID"] = this.taxID;
        data["glAccountID"] = this.glAccountID;
        data["quantity"] = this.quantity;
        data["retailAmount"] = this.retailAmount;
        data["overrideRetailAmount"] = this.overrideRetailAmount;
        data["quantityPerSubscriber"] = this.quantityPerSubscriber;
        data["description"] = this.description;
        data["storeItemDiscount"] = this.storeItemDiscount;
        data["glAccount"] = this.glAccount ? this.glAccount.toJSON() : <any>undefined;
        data["storeItem"] = this.storeItem ? this.storeItem.toJSON() : <any>undefined;
        data["negateStoreItem"] = this.negateStoreItem ? this.negateStoreItem.toJSON() : <any>undefined;
        data["tax"] = this.tax ? this.tax.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionStoreItem extends IEntityBase {
    subscriptionStoreItemID: string;
    subscriptionID: string;
    storeItemID: string;
    negateStoreItemID: string;
    taxID: string;
    glAccountID: string;
    quantity: number;
    retailAmount: number;
    overrideRetailAmount?: number | undefined;
    quantityPerSubscriber: number;
    description?: string | undefined;
    storeItemDiscount: number;
    glAccount?: GLAccount | undefined;
    storeItem?: StoreItem | undefined;
    negateStoreItem?: StoreItem | undefined;
    tax?: Tax | undefined;
}

export class SubscriptionEventInvoice extends EntityBase implements ISubscriptionEventInvoice {
    subscriptionEventInvoiceID!: string;
    subscriptionID!: string;
    invoiceID!: string;
    subscriptionUserDetailID!: string;
    comments?: string | undefined;
    invoice?: Invoice | undefined;
    subscriptionUserDetail?: SubscriptionUserDetail | undefined;

    constructor(data?: ISubscriptionEventInvoice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionEventInvoiceID = _data["subscriptionEventInvoiceID"];
            this.subscriptionID = _data["subscriptionID"];
            this.invoiceID = _data["invoiceID"];
            this.subscriptionUserDetailID = _data["subscriptionUserDetailID"];
            this.comments = _data["comments"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.subscriptionUserDetail = _data["subscriptionUserDetail"] ? SubscriptionUserDetail.fromJS(_data["subscriptionUserDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionEventInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionEventInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionEventInvoiceID"] = this.subscriptionEventInvoiceID;
        data["subscriptionID"] = this.subscriptionID;
        data["invoiceID"] = this.invoiceID;
        data["subscriptionUserDetailID"] = this.subscriptionUserDetailID;
        data["comments"] = this.comments;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["subscriptionUserDetail"] = this.subscriptionUserDetail ? this.subscriptionUserDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionEventInvoice extends IEntityBase {
    subscriptionEventInvoiceID: string;
    subscriptionID: string;
    invoiceID: string;
    subscriptionUserDetailID: string;
    comments?: string | undefined;
    invoice?: Invoice | undefined;
    subscriptionUserDetail?: SubscriptionUserDetail | undefined;
}

export class SubscriptionUserDetail extends EntityBase implements ISubscriptionUserDetail {
    subscriptionUserDetailID!: string;
    subscriptionID!: string;
    userDetailID?: string | undefined;
    subscriptionUserSeed!: number;
    subscriptionUserID!: number;
    subscriptionUserPIN!: number;
    comments?: string | undefined;
    onboarded!: boolean;
    recurring!: boolean;
    frequencyEnum!: FrequencyEnum;
    recurringCount?: number | undefined;
    subscriptionStartDate!: Date;
    subscriptionEndDate?: Date | undefined;
    nextPaymentDate?: Date | undefined;
    recurringPlanID?: string | undefined;
    recurringEmailAddress?: string | undefined;
    recurringEmailToken?: string | undefined;
    recurringSubscriptionCode?: string | undefined;
    paymentProcessorID?: string | undefined;
    recurringSuccess!: boolean;
    recurringMessage?: string | undefined;
    recurringCancelSuccess!: boolean;
    recurringCancelMessage?: string | undefined;
    userDetail?: UserDetail | undefined;
    subscription?: Subscription | undefined;
    subscriptionUserDetailStoreItems?: SubscriptionUserDetailStoreItem[] | undefined;

    constructor(data?: ISubscriptionUserDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionUserDetailID = _data["subscriptionUserDetailID"];
            this.subscriptionID = _data["subscriptionID"];
            this.userDetailID = _data["userDetailID"];
            this.subscriptionUserSeed = _data["subscriptionUserSeed"];
            this.subscriptionUserID = _data["subscriptionUserID"];
            this.subscriptionUserPIN = _data["subscriptionUserPIN"];
            this.comments = _data["comments"];
            this.onboarded = _data["onboarded"];
            this.recurring = _data["recurring"];
            this.frequencyEnum = _data["frequencyEnum"];
            this.recurringCount = _data["recurringCount"];
            this.subscriptionStartDate = _data["subscriptionStartDate"] ? new Date(_data["subscriptionStartDate"].toString()) : <any>undefined;
            this.subscriptionEndDate = _data["subscriptionEndDate"] ? new Date(_data["subscriptionEndDate"].toString()) : <any>undefined;
            this.nextPaymentDate = _data["nextPaymentDate"] ? new Date(_data["nextPaymentDate"].toString()) : <any>undefined;
            this.recurringPlanID = _data["recurringPlanID"];
            this.recurringEmailAddress = _data["recurringEmailAddress"];
            this.recurringEmailToken = _data["recurringEmailToken"];
            this.recurringSubscriptionCode = _data["recurringSubscriptionCode"];
            this.paymentProcessorID = _data["paymentProcessorID"];
            this.recurringSuccess = _data["recurringSuccess"];
            this.recurringMessage = _data["recurringMessage"];
            this.recurringCancelSuccess = _data["recurringCancelSuccess"];
            this.recurringCancelMessage = _data["recurringCancelMessage"];
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
            if (Array.isArray(_data["subscriptionUserDetailStoreItems"])) {
                this.subscriptionUserDetailStoreItems = [] as any;
                for (let item of _data["subscriptionUserDetailStoreItems"])
                    this.subscriptionUserDetailStoreItems!.push(SubscriptionUserDetailStoreItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionUserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionUserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionUserDetailID"] = this.subscriptionUserDetailID;
        data["subscriptionID"] = this.subscriptionID;
        data["userDetailID"] = this.userDetailID;
        data["subscriptionUserSeed"] = this.subscriptionUserSeed;
        data["subscriptionUserID"] = this.subscriptionUserID;
        data["subscriptionUserPIN"] = this.subscriptionUserPIN;
        data["comments"] = this.comments;
        data["onboarded"] = this.onboarded;
        data["recurring"] = this.recurring;
        data["frequencyEnum"] = this.frequencyEnum;
        data["recurringCount"] = this.recurringCount;
        data["subscriptionStartDate"] = this.subscriptionStartDate ? this.subscriptionStartDate.toISOString() : <any>undefined;
        data["subscriptionEndDate"] = this.subscriptionEndDate ? this.subscriptionEndDate.toISOString() : <any>undefined;
        data["nextPaymentDate"] = this.nextPaymentDate ? this.nextPaymentDate.toISOString() : <any>undefined;
        data["recurringPlanID"] = this.recurringPlanID;
        data["recurringEmailAddress"] = this.recurringEmailAddress;
        data["recurringEmailToken"] = this.recurringEmailToken;
        data["recurringSubscriptionCode"] = this.recurringSubscriptionCode;
        data["paymentProcessorID"] = this.paymentProcessorID;
        data["recurringSuccess"] = this.recurringSuccess;
        data["recurringMessage"] = this.recurringMessage;
        data["recurringCancelSuccess"] = this.recurringCancelSuccess;
        data["recurringCancelMessage"] = this.recurringCancelMessage;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        if (Array.isArray(this.subscriptionUserDetailStoreItems)) {
            data["subscriptionUserDetailStoreItems"] = [];
            for (let item of this.subscriptionUserDetailStoreItems)
                data["subscriptionUserDetailStoreItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionUserDetail extends IEntityBase {
    subscriptionUserDetailID: string;
    subscriptionID: string;
    userDetailID?: string | undefined;
    subscriptionUserSeed: number;
    subscriptionUserID: number;
    subscriptionUserPIN: number;
    comments?: string | undefined;
    onboarded: boolean;
    recurring: boolean;
    frequencyEnum: FrequencyEnum;
    recurringCount?: number | undefined;
    subscriptionStartDate: Date;
    subscriptionEndDate?: Date | undefined;
    nextPaymentDate?: Date | undefined;
    recurringPlanID?: string | undefined;
    recurringEmailAddress?: string | undefined;
    recurringEmailToken?: string | undefined;
    recurringSubscriptionCode?: string | undefined;
    paymentProcessorID?: string | undefined;
    recurringSuccess: boolean;
    recurringMessage?: string | undefined;
    recurringCancelSuccess: boolean;
    recurringCancelMessage?: string | undefined;
    userDetail?: UserDetail | undefined;
    subscription?: Subscription | undefined;
    subscriptionUserDetailStoreItems?: SubscriptionUserDetailStoreItem[] | undefined;
}

export class SubscriptionUserDetailStoreItem extends EntityBase implements ISubscriptionUserDetailStoreItem {
    subscriptionUserDetailStoreItemID!: string;
    subscriptionUserDetailID!: string;
    subscriptionStoreItemID!: string;
    quantityRemaining!: number;
    subscriptionStoreItem?: SubscriptionStoreItem | undefined;
    subscriptionUserDetail?: SubscriptionUserDetail | undefined;

    constructor(data?: ISubscriptionUserDetailStoreItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionUserDetailStoreItemID = _data["subscriptionUserDetailStoreItemID"];
            this.subscriptionUserDetailID = _data["subscriptionUserDetailID"];
            this.subscriptionStoreItemID = _data["subscriptionStoreItemID"];
            this.quantityRemaining = _data["quantityRemaining"];
            this.subscriptionStoreItem = _data["subscriptionStoreItem"] ? SubscriptionStoreItem.fromJS(_data["subscriptionStoreItem"]) : <any>undefined;
            this.subscriptionUserDetail = _data["subscriptionUserDetail"] ? SubscriptionUserDetail.fromJS(_data["subscriptionUserDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionUserDetailStoreItem {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionUserDetailStoreItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionUserDetailStoreItemID"] = this.subscriptionUserDetailStoreItemID;
        data["subscriptionUserDetailID"] = this.subscriptionUserDetailID;
        data["subscriptionStoreItemID"] = this.subscriptionStoreItemID;
        data["quantityRemaining"] = this.quantityRemaining;
        data["subscriptionStoreItem"] = this.subscriptionStoreItem ? this.subscriptionStoreItem.toJSON() : <any>undefined;
        data["subscriptionUserDetail"] = this.subscriptionUserDetail ? this.subscriptionUserDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionUserDetailStoreItem extends IEntityBase {
    subscriptionUserDetailStoreItemID: string;
    subscriptionUserDetailID: string;
    subscriptionStoreItemID: string;
    quantityRemaining: number;
    subscriptionStoreItem?: SubscriptionStoreItem | undefined;
    subscriptionUserDetail?: SubscriptionUserDetail | undefined;
}

export class SubscriptionRole extends EntityBase implements ISubscriptionRole {
    subscriptionRoleID!: string;
    subscriptionID!: string;
    roleName!: string;

    constructor(data?: ISubscriptionRole) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subscriptionRoleID = _data["subscriptionRoleID"];
            this.subscriptionID = _data["subscriptionID"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): SubscriptionRole {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionRoleID"] = this.subscriptionRoleID;
        data["subscriptionID"] = this.subscriptionID;
        data["roleName"] = this.roleName;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscriptionRole extends IEntityBase {
    subscriptionRoleID: string;
    subscriptionID: string;
    roleName: string;
}

export class SubscriptionAddUserResults implements ISubscriptionAddUserResults {
    message?: string | undefined;
    success?: boolean;

    constructor(data?: ISubscriptionAddUserResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SubscriptionAddUserResults {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionAddUserResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        return data;
    }
}

export interface ISubscriptionAddUserResults {
    message?: string | undefined;
    success?: boolean;
}

export class SubscriptionAddUserDetails implements ISubscriptionAddUserDetails {
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    subscriptionID?: string | undefined;
    userDetailID?: string | undefined;

    constructor(data?: ISubscriptionAddUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionUserID = _data["subscriptionUserID"];
            this.subscriptionPIN = _data["subscriptionPIN"];
            this.subscriptionID = _data["subscriptionID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): SubscriptionAddUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionAddUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionUserID"] = this.subscriptionUserID;
        data["subscriptionPIN"] = this.subscriptionPIN;
        data["subscriptionID"] = this.subscriptionID;
        data["userDetailID"] = this.userDetailID;
        return data;
    }
}

export interface ISubscriptionAddUserDetails {
    subscriptionUserID?: number;
    subscriptionPIN?: number;
    subscriptionID?: string | undefined;
    userDetailID?: string | undefined;
}

export class CreateSubscriptionInvoiceDetails implements ICreateSubscriptionInvoiceDetails {
    userDetailID?: string;
    subscriptionID?: string;
    storeItemID?: string;

    constructor(data?: ICreateSubscriptionInvoiceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.subscriptionID = _data["subscriptionID"];
            this.storeItemID = _data["storeItemID"];
        }
    }

    static fromJS(data: any): CreateSubscriptionInvoiceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionInvoiceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["subscriptionID"] = this.subscriptionID;
        data["storeItemID"] = this.storeItemID;
        return data;
    }
}

export interface ICreateSubscriptionInvoiceDetails {
    userDetailID?: string;
    subscriptionID?: string;
    storeItemID?: string;
}

export class SubscriptionCommitResults implements ISubscriptionCommitResults {
    message?: string | undefined;
    success?: boolean;

    constructor(data?: ISubscriptionCommitResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SubscriptionCommitResults {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCommitResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        return data;
    }
}

export interface ISubscriptionCommitResults {
    message?: string | undefined;
    success?: boolean;
}

export class SubscriptionCommitDetails implements ISubscriptionCommitDetails {
    subscriptionID?: string;
    invoiceID?: string;

    constructor(data?: ISubscriptionCommitDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionID = _data["subscriptionID"];
            this.invoiceID = _data["invoiceID"];
        }
    }

    static fromJS(data: any): SubscriptionCommitDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCommitDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionID"] = this.subscriptionID;
        data["invoiceID"] = this.invoiceID;
        return data;
    }
}

export interface ISubscriptionCommitDetails {
    subscriptionID?: string;
    invoiceID?: string;
}

export class PagedResultOfSubscription implements IPagedResultOfSubscription {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Subscription[] | undefined;

    constructor(data?: IPagedResultOfSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Subscription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfSubscription {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: Subscription[] | undefined;
}

export class AvailableSubscriptionDetails extends PagedQuery implements IAvailableSubscriptionDetails {
    countryID?: string;
    userDetailID?: string;

    constructor(data?: IAvailableSubscriptionDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryID = _data["countryID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): AvailableSubscriptionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableSubscriptionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryID"] = this.countryID;
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface IAvailableSubscriptionDetails extends IPagedQuery {
    countryID?: string;
    userDetailID?: string;
}

export class PagedResultOfSubscriptionUserDetail implements IPagedResultOfSubscriptionUserDetail {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: SubscriptionUserDetail[] | undefined;

    constructor(data?: IPagedResultOfSubscriptionUserDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionUserDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfSubscriptionUserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfSubscriptionUserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfSubscriptionUserDetail {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: SubscriptionUserDetail[] | undefined;
}

export class SubscribedSubscriptionDetails extends PagedQuery implements ISubscribedSubscriptionDetails {
    userDetailID?: string;

    constructor(data?: ISubscribedSubscriptionDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): SubscribedSubscriptionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribedSubscriptionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        super.toJSON(data);
        return data;
    }
}

export interface ISubscribedSubscriptionDetails extends IPagedQuery {
    userDetailID?: string;
}

export class CancelSubscribedSubscriptionResult implements ICancelSubscribedSubscriptionResult {
    success?: boolean;
    message?: string | undefined;
    cancelledDate?: Date;

    constructor(data?: ICancelSubscribedSubscriptionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.cancelledDate = _data["cancelledDate"] ? new Date(_data["cancelledDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelSubscribedSubscriptionResult {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSubscribedSubscriptionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["cancelledDate"] = this.cancelledDate ? this.cancelledDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICancelSubscribedSubscriptionResult {
    success?: boolean;
    message?: string | undefined;
    cancelledDate?: Date;
}

export class CancelSubscribedSubscriptionDetails implements ICancelSubscribedSubscriptionDetails {
    subscriptionID?: string;
    userDetailID?: string;

    constructor(data?: ICancelSubscribedSubscriptionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionID = _data["subscriptionID"];
            this.userDetailID = _data["userDetailID"];
        }
    }

    static fromJS(data: any): CancelSubscribedSubscriptionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSubscribedSubscriptionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionID"] = this.subscriptionID;
        data["userDetailID"] = this.userDetailID;
        return data;
    }
}

export interface ICancelSubscribedSubscriptionDetails {
    subscriptionID?: string;
    userDetailID?: string;
}

export class SubscriptionEventDTO implements ISubscriptionEventDTO {
    eventDate?: Date;
    providerName?: string | undefined;
    visitType?: string | undefined;
    imageDetailID?: string | undefined;
    providerID?: string;
    consultID?: string;

    constructor(data?: ISubscriptionEventDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.providerName = _data["providerName"];
            this.visitType = _data["visitType"];
            this.imageDetailID = _data["imageDetailID"];
            this.providerID = _data["providerID"];
            this.consultID = _data["consultID"];
        }
    }

    static fromJS(data: any): SubscriptionEventDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionEventDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["providerName"] = this.providerName;
        data["visitType"] = this.visitType;
        data["imageDetailID"] = this.imageDetailID;
        data["providerID"] = this.providerID;
        data["consultID"] = this.consultID;
        return data;
    }
}

export interface ISubscriptionEventDTO {
    eventDate?: Date;
    providerName?: string | undefined;
    visitType?: string | undefined;
    imageDetailID?: string | undefined;
    providerID?: string;
    consultID?: string;
}

export class SupportRequestResult implements ISupportRequestResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: ISupportRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SupportRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new SupportRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ISupportRequestResult {
    success?: boolean;
    message?: string | undefined;
}

export class SupportRequestDetails implements ISupportRequestDetails {
    emailAddress!: string;
    subject!: string;
    message!: string;

    constructor(data?: ISupportRequestDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.subject = _data["subject"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SupportRequestDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SupportRequestDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["subject"] = this.subject;
        data["message"] = this.message;
        return data;
    }
}

export interface ISupportRequestDetails {
    emailAddress: string;
    subject: string;
    message: string;
}

export class SystemMessage extends EntityBase implements ISystemMessage {
    systemMessageID!: string;
    name!: string;
    value!: string;
    startDate!: Date;
    endDate!: Date;
    messageType!: string;

    constructor(data?: ISystemMessage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemMessageID = _data["systemMessageID"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.messageType = _data["messageType"];
        }
    }

    static fromJS(data: any): SystemMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SystemMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemMessageID"] = this.systemMessageID;
        data["name"] = this.name;
        data["value"] = this.value;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["messageType"] = this.messageType;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemMessage extends IEntityBase {
    systemMessageID: string;
    name: string;
    value: string;
    startDate: Date;
    endDate: Date;
    messageType: string;
}

export class SystemSetting extends EntityBase implements ISystemSetting {
    systemSettingID!: string;
    name!: string;
    value!: string;

    constructor(data?: ISystemSetting) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systemSettingID = _data["systemSettingID"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SystemSetting {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemSettingID"] = this.systemSettingID;
        data["name"] = this.name;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface ISystemSetting extends IEntityBase {
    systemSettingID: string;
    name: string;
    value: string;
}

export class SystemSettingResult implements ISystemSettingResult {
    value?: string | undefined;

    constructor(data?: ISystemSettingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SystemSettingResult {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSettingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface ISystemSettingResult {
    value?: string | undefined;
}

export class TagSearchDetails implements ITagSearchDetails {
    tagTypeEnum?: TagTypeEnum;
    searchText?: string | undefined;

    constructor(data?: ITagSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagTypeEnum = _data["tagTypeEnum"];
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): TagSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TagSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagTypeEnum"] = this.tagTypeEnum;
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface ITagSearchDetails {
    tagTypeEnum?: TagTypeEnum;
    searchText?: string | undefined;
}

export class PagedResultOfTaskItem implements IPagedResultOfTaskItem {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: TaskItem[] | undefined;

    constructor(data?: IPagedResultOfTaskItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfTaskItem {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfTaskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultOfTaskItem {
    recordsToSkip?: number;
    recordsToTake?: number;
    totalCount?: number;
    items?: TaskItem[] | undefined;
}

export class TaskItemSearchDetails extends PagedQuery implements ITaskItemSearchDetails {
    taskItemTypeEnum?: TaskItemTypeEnum | undefined;
    taskItemStatusEnums?: string[] | undefined;
    userDetailID?: string | undefined;
    storeID?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    startDueDate?: Date | undefined;
    endDueDate?: Date | undefined;

    constructor(data?: ITaskItemSearchDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskItemTypeEnum = _data["taskItemTypeEnum"];
            if (Array.isArray(_data["taskItemStatusEnums"])) {
                this.taskItemStatusEnums = [] as any;
                for (let item of _data["taskItemStatusEnums"])
                    this.taskItemStatusEnums!.push(item);
            }
            this.userDetailID = _data["userDetailID"];
            this.storeID = _data["storeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.startDueDate = _data["startDueDate"] ? new Date(_data["startDueDate"].toString()) : <any>undefined;
            this.endDueDate = _data["endDueDate"] ? new Date(_data["endDueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskItemSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskItemTypeEnum"] = this.taskItemTypeEnum;
        if (Array.isArray(this.taskItemStatusEnums)) {
            data["taskItemStatusEnums"] = [];
            for (let item of this.taskItemStatusEnums)
                data["taskItemStatusEnums"].push(item);
        }
        data["userDetailID"] = this.userDetailID;
        data["storeID"] = this.storeID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startDueDate"] = this.startDueDate ? this.startDueDate.toISOString() : <any>undefined;
        data["endDueDate"] = this.endDueDate ? this.endDueDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITaskItemSearchDetails extends IPagedQuery {
    taskItemTypeEnum?: TaskItemTypeEnum | undefined;
    taskItemStatusEnums?: string[] | undefined;
    userDetailID?: string | undefined;
    storeID?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    startDueDate?: Date | undefined;
    endDueDate?: Date | undefined;
}

export class TaskItemTemplate extends EntityBase implements ITaskItemTemplate {
    taskItemTemplateID!: string;
    taskItemTemplateTypeEnum!: TaskItemTemplateTypeEnum;
    taskItemTypeEnum!: TaskItemTypeEnum;
    name!: string;
    shortName!: string;
    description?: string | undefined;
    taskItemName!: string;
    taskItemDescription?: string | undefined;
    taskItemTypeName!: string;
    taskItemPriorityEnum!: TaskItemPriorityEnum;
    taskItemDetail?: string | undefined;
    taskItemResult?: string | undefined;
    taskItemMessage?: string | undefined;
    sortOrder!: number;
    enabled!: boolean;
    nextTaskItemTemplateID?: string | undefined;

    constructor(data?: ITaskItemTemplate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskItemTemplateID = _data["taskItemTemplateID"];
            this.taskItemTemplateTypeEnum = _data["taskItemTemplateTypeEnum"];
            this.taskItemTypeEnum = _data["taskItemTypeEnum"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.taskItemName = _data["taskItemName"];
            this.taskItemDescription = _data["taskItemDescription"];
            this.taskItemTypeName = _data["taskItemTypeName"];
            this.taskItemPriorityEnum = _data["taskItemPriorityEnum"];
            this.taskItemDetail = _data["taskItemDetail"];
            this.taskItemResult = _data["taskItemResult"];
            this.taskItemMessage = _data["taskItemMessage"];
            this.sortOrder = _data["sortOrder"];
            this.enabled = _data["enabled"];
            this.nextTaskItemTemplateID = _data["nextTaskItemTemplateID"];
        }
    }

    static fromJS(data: any): TaskItemTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskItemTemplateID"] = this.taskItemTemplateID;
        data["taskItemTemplateTypeEnum"] = this.taskItemTemplateTypeEnum;
        data["taskItemTypeEnum"] = this.taskItemTypeEnum;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["taskItemName"] = this.taskItemName;
        data["taskItemDescription"] = this.taskItemDescription;
        data["taskItemTypeName"] = this.taskItemTypeName;
        data["taskItemPriorityEnum"] = this.taskItemPriorityEnum;
        data["taskItemDetail"] = this.taskItemDetail;
        data["taskItemResult"] = this.taskItemResult;
        data["taskItemMessage"] = this.taskItemMessage;
        data["sortOrder"] = this.sortOrder;
        data["enabled"] = this.enabled;
        data["nextTaskItemTemplateID"] = this.nextTaskItemTemplateID;
        super.toJSON(data);
        return data;
    }
}

export interface ITaskItemTemplate extends IEntityBase {
    taskItemTemplateID: string;
    taskItemTemplateTypeEnum: TaskItemTemplateTypeEnum;
    taskItemTypeEnum: TaskItemTypeEnum;
    name: string;
    shortName: string;
    description?: string | undefined;
    taskItemName: string;
    taskItemDescription?: string | undefined;
    taskItemTypeName: string;
    taskItemPriorityEnum: TaskItemPriorityEnum;
    taskItemDetail?: string | undefined;
    taskItemResult?: string | undefined;
    taskItemMessage?: string | undefined;
    sortOrder: number;
    enabled: boolean;
    nextTaskItemTemplateID?: string | undefined;
}

export enum TaskItemTemplateTypeEnum {
    NotSet = "NotSet",
}

export class TenantNumber extends EntityBase implements ITenantNumber {
    tenantNumberID!: string;
    tenantID!: string;
    tenantNumberTypeEnum!: TenantNumberTypeEnum;
    number?: string | undefined;
    enabled!: boolean;

    constructor(data?: ITenantNumber) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantNumberID = _data["tenantNumberID"];
            this.tenantID = _data["tenantID"];
            this.tenantNumberTypeEnum = _data["tenantNumberTypeEnum"];
            this.number = _data["number"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): TenantNumber {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantNumberID"] = this.tenantNumberID;
        data["tenantID"] = this.tenantID;
        data["tenantNumberTypeEnum"] = this.tenantNumberTypeEnum;
        data["number"] = this.number;
        data["enabled"] = this.enabled;
        super.toJSON(data);
        return data;
    }
}

export interface ITenantNumber extends IEntityBase {
    tenantNumberID: string;
    tenantID: string;
    tenantNumberTypeEnum: TenantNumberTypeEnum;
    number?: string | undefined;
    enabled: boolean;
}

export enum TenantNumberTypeEnum {
    FaxNumber = "FaxNumber",
    SMSNumber = "SMSNumber",
}

export class Tenant extends EntityBase implements ITenant {
    tenantID!: string;
    name!: string;
    enabled!: boolean;
    tenantNumbers?: TenantNumber[] | undefined;

    constructor(data?: ITenant) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantID = _data["tenantID"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
            if (Array.isArray(_data["tenantNumbers"])) {
                this.tenantNumbers = [] as any;
                for (let item of _data["tenantNumbers"])
                    this.tenantNumbers!.push(TenantNumber.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantID"] = this.tenantID;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        if (Array.isArray(this.tenantNumbers)) {
            data["tenantNumbers"] = [];
            for (let item of this.tenantNumbers)
                data["tenantNumbers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITenant extends IEntityBase {
    tenantID: string;
    name: string;
    enabled: boolean;
    tenantNumbers?: TenantNumber[] | undefined;
}

export class TestData extends EntityBase implements ITestData {
    testDataID!: string;
    testVarchar?: string | undefined;
    testBit!: boolean;
    testInteger?: number | undefined;
    genderEnum!: GenderEnum;
    testMoney?: number | undefined;
    testDecimal?: number | undefined;
    testVarcharMax?: string | undefined;

    constructor(data?: ITestData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.testDataID = _data["testDataID"];
            this.testVarchar = _data["testVarchar"];
            this.testBit = _data["testBit"];
            this.testInteger = _data["testInteger"];
            this.genderEnum = _data["genderEnum"];
            this.testMoney = _data["testMoney"];
            this.testDecimal = _data["testDecimal"];
            this.testVarcharMax = _data["testVarcharMax"];
        }
    }

    static fromJS(data: any): TestData {
        data = typeof data === 'object' ? data : {};
        let result = new TestData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testDataID"] = this.testDataID;
        data["testVarchar"] = this.testVarchar;
        data["testBit"] = this.testBit;
        data["testInteger"] = this.testInteger;
        data["genderEnum"] = this.genderEnum;
        data["testMoney"] = this.testMoney;
        data["testDecimal"] = this.testDecimal;
        data["testVarcharMax"] = this.testVarcharMax;
        super.toJSON(data);
        return data;
    }
}

export interface ITestData extends IEntityBase {
    testDataID: string;
    testVarchar?: string | undefined;
    testBit: boolean;
    testInteger?: number | undefined;
    genderEnum: GenderEnum;
    testMoney?: number | undefined;
    testDecimal?: number | undefined;
    testVarcharMax?: string | undefined;
}

export abstract class SqlCommandEntityBase implements ISqlCommandEntityBase {

    constructor(data?: ISqlCommandEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SqlCommandEntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SqlCommandEntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISqlCommandEntityBase {
}

export class TestCommandEntity extends SqlCommandEntityBase implements ITestCommandEntity {
    message?: string | undefined;

    constructor(data?: ITestCommandEntity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TestCommandEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TestCommandEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
}

export interface ITestCommandEntity extends ISqlCommandEntityBase {
    message?: string | undefined;
}

export class TimeZone implements ITimeZone {
    timeZoneID?: string | undefined;
    description?: string | undefined;
    utcOffSetMinutes?: number;
    standardName?: string | undefined;
    supportsDaylightSavingTime?: boolean;
    country?: string | undefined;
    displaySortOrder?: number;

    constructor(data?: ITimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneID = _data["timeZoneID"];
            this.description = _data["description"];
            this.utcOffSetMinutes = _data["utcOffSetMinutes"];
            this.standardName = _data["standardName"];
            this.supportsDaylightSavingTime = _data["supportsDaylightSavingTime"];
            this.country = _data["country"];
            this.displaySortOrder = _data["displaySortOrder"];
        }
    }

    static fromJS(data: any): TimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneID"] = this.timeZoneID;
        data["description"] = this.description;
        data["utcOffSetMinutes"] = this.utcOffSetMinutes;
        data["standardName"] = this.standardName;
        data["supportsDaylightSavingTime"] = this.supportsDaylightSavingTime;
        data["country"] = this.country;
        data["displaySortOrder"] = this.displaySortOrder;
        return data;
    }
}

export interface ITimeZone {
    timeZoneID?: string | undefined;
    description?: string | undefined;
    utcOffSetMinutes?: number;
    standardName?: string | undefined;
    supportsDaylightSavingTime?: boolean;
    country?: string | undefined;
    displaySortOrder?: number;
}

export class IANALookupDetails implements IIANALookupDetails {
    ianaTimezoneID?: string | undefined;

    constructor(data?: IIANALookupDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ianaTimezoneID = _data["ianaTimezoneID"];
        }
    }

    static fromJS(data: any): IANALookupDetails {
        data = typeof data === 'object' ? data : {};
        let result = new IANALookupDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ianaTimezoneID"] = this.ianaTimezoneID;
        return data;
    }
}

export interface IIANALookupDetails {
    ianaTimezoneID?: string | undefined;
}

export class TimeZoneCountry extends EntityBase implements ITimeZoneCountry {
    timeZoneCountryID!: string;
    timeZoneID!: string;
    countryName!: string;
    displaySortOrder!: number;

    constructor(data?: ITimeZoneCountry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.timeZoneCountryID = _data["timeZoneCountryID"];
            this.timeZoneID = _data["timeZoneID"];
            this.countryName = _data["countryName"];
            this.displaySortOrder = _data["displaySortOrder"];
        }
    }

    static fromJS(data: any): TimeZoneCountry {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneCountryID"] = this.timeZoneCountryID;
        data["timeZoneID"] = this.timeZoneID;
        data["countryName"] = this.countryName;
        data["displaySortOrder"] = this.displaySortOrder;
        super.toJSON(data);
        return data;
    }
}

export interface ITimeZoneCountry extends IEntityBase {
    timeZoneCountryID: string;
    timeZoneID: string;
    countryName: string;
    displaySortOrder: number;
}

export class UserDetailAffiliate extends EntityBase implements IUserDetailAffiliate {
    userDetailAffiliateID!: string;
    userDetailID!: string;
    affiliateID!: string;
    userDetail?: UserDetail | undefined;
    affiliate?: Affiliate | undefined;

    constructor(data?: IUserDetailAffiliate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailAffiliateID = _data["userDetailAffiliateID"];
            this.userDetailID = _data["userDetailID"];
            this.affiliateID = _data["affiliateID"];
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
            this.affiliate = _data["affiliate"] ? Affiliate.fromJS(_data["affiliate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDetailAffiliate {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailAffiliate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailAffiliateID"] = this.userDetailAffiliateID;
        data["userDetailID"] = this.userDetailID;
        data["affiliateID"] = this.affiliateID;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        data["affiliate"] = this.affiliate ? this.affiliate.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDetailAffiliate extends IEntityBase {
    userDetailAffiliateID: string;
    userDetailID: string;
    affiliateID: string;
    userDetail?: UserDetail | undefined;
    affiliate?: Affiliate | undefined;
}

export class UserDetailSearchDetails implements IUserDetailSearchDetails {
    searchText?: string | undefined;

    constructor(data?: IUserDetailSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): UserDetailSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface IUserDetailSearchDetails {
    searchText?: string | undefined;
}

export class UserDetailSettingSearchDetails implements IUserDetailSettingSearchDetails {
    userDetailSettingEnum?: UserDetailSettingEnum;
    patientID?: string | undefined;

    constructor(data?: IUserDetailSettingSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailSettingEnum = _data["userDetailSettingEnum"];
            this.patientID = _data["patientID"];
        }
    }

    static fromJS(data: any): UserDetailSettingSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailSettingSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailSettingEnum"] = this.userDetailSettingEnum;
        data["patientID"] = this.patientID;
        return data;
    }
}

export interface IUserDetailSettingSearchDetails {
    userDetailSettingEnum?: UserDetailSettingEnum;
    patientID?: string | undefined;
}

export class UserDetailBvnDTO implements IUserDetailBvnDTO {
    userDetailID?: string;
    currency?: CurrencyEnum;
    bvn?: string | undefined;
    nin?: string | undefined;
    dob!: Date;
    phoneNumber!: string;
    image!: string;
    photoid_image?: string | undefined;
    governmentIdType?: GovernmentIdTypeEnum;

    constructor(data?: IUserDetailBvnDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.currency = _data["currency"];
            this.bvn = _data["bvn"];
            this.nin = _data["nin"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.image = _data["image"];
            this.photoid_image = _data["photoid_image"];
            this.governmentIdType = _data["governmentIdType"];
        }
    }

    static fromJS(data: any): UserDetailBvnDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailBvnDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["currency"] = this.currency;
        data["bvn"] = this.bvn;
        data["nin"] = this.nin;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["image"] = this.image;
        data["photoid_image"] = this.photoid_image;
        data["governmentIdType"] = this.governmentIdType;
        return data;
    }
}

export interface IUserDetailBvnDTO {
    userDetailID?: string;
    currency?: CurrencyEnum;
    bvn?: string | undefined;
    nin?: string | undefined;
    dob: Date;
    phoneNumber: string;
    image: string;
    photoid_image?: string | undefined;
    governmentIdType?: GovernmentIdTypeEnum;
}

export enum GovernmentIdTypeEnum {
    NotSet = "NotSet",
    Passport = "Passport",
    DriversLicense = "DriversLicense",
    NationalID = "NationalID",
    VoterCard = "VoterCard",
    Others = "Others",
}

export class UserDetailRelationshipDetails implements IUserDetailRelationshipDetails {
    userDetailRelationshipID?: string;
    token?: string | undefined;

    constructor(data?: IUserDetailRelationshipDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailRelationshipID = _data["userDetailRelationshipID"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): UserDetailRelationshipDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailRelationshipDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailRelationshipID"] = this.userDetailRelationshipID;
        data["token"] = this.token;
        return data;
    }
}

export interface IUserDetailRelationshipDetails {
    userDetailRelationshipID?: string;
    token?: string | undefined;
}

export class UserDetailRelationshipResult implements IUserDetailRelationshipResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IUserDetailRelationshipResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UserDetailRelationshipResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailRelationshipResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IUserDetailRelationshipResult {
    success?: boolean;
    message?: string | undefined;
}

export class UserDetailTag extends EntityBase implements IUserDetailTag {
    userDetailTagID!: string;
    userDetailID!: string;
    tagID!: string;
    tag?: Tag | undefined;
    userDetail?: UserDetail | undefined;

    constructor(data?: IUserDetailTag) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userDetailTagID = _data["userDetailTagID"];
            this.userDetailID = _data["userDetailID"];
            this.tagID = _data["tagID"];
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : <any>undefined;
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDetailTag {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailTagID"] = this.userDetailTagID;
        data["userDetailID"] = this.userDetailID;
        data["tagID"] = this.tagID;
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserDetailTag extends IEntityBase {
    userDetailTagID: string;
    userDetailID: string;
    tagID: string;
    tag?: Tag | undefined;
    userDetail?: UserDetail | undefined;
}

export class BVNLookupResponse implements IBVNLookupResponse {
    entity?: BVNResponse | undefined;
    message?: string | undefined;

    constructor(data?: IBVNLookupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? BVNResponse.fromJS(_data["entity"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BVNLookupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BVNLookupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IBVNLookupResponse {
    entity?: BVNResponse | undefined;
    message?: string | undefined;
}

export class BVNResponse implements IBVNResponse {
    bvn?: string | undefined;
    first_Name?: string | undefined;
    last_Name?: string | undefined;
    middle_Name?: string | undefined;
    gender?: string | undefined;
    date_of_Birth?: string | undefined;
    phone_Number1?: string | undefined;
    image?: string | undefined;
    level_of_Account?: string | undefined;
    lga_of_Origin?: string | undefined;
    lga_of_Residence?: string | undefined;
    marital_Status?: string | undefined;
    name_on_Card?: string | undefined;
    nationality?: string | undefined;
    nin?: string | undefined;
    phone_Number2?: string | undefined;
    reference?: string | undefined;
    registration_Date?: string | undefined;
    residential_Address?: string | undefined;
    state_of_Origin?: string | undefined;
    state_of_Residence?: string | undefined;
    title?: string | undefined;
    watch_Listed?: string | undefined;

    constructor(data?: IBVNResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bvn = _data["bvn"];
            this.first_Name = _data["first_Name"];
            this.last_Name = _data["last_Name"];
            this.middle_Name = _data["middle_Name"];
            this.gender = _data["gender"];
            this.date_of_Birth = _data["date_of_Birth"];
            this.phone_Number1 = _data["phone_Number1"];
            this.image = _data["image"];
            this.level_of_Account = _data["level_of_Account"];
            this.lga_of_Origin = _data["lga_of_Origin"];
            this.lga_of_Residence = _data["lga_of_Residence"];
            this.marital_Status = _data["marital_Status"];
            this.name_on_Card = _data["name_on_Card"];
            this.nationality = _data["nationality"];
            this.nin = _data["nin"];
            this.phone_Number2 = _data["phone_Number2"];
            this.reference = _data["reference"];
            this.registration_Date = _data["registration_Date"];
            this.residential_Address = _data["residential_Address"];
            this.state_of_Origin = _data["state_of_Origin"];
            this.state_of_Residence = _data["state_of_Residence"];
            this.title = _data["title"];
            this.watch_Listed = _data["watch_Listed"];
        }
    }

    static fromJS(data: any): BVNResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BVNResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bvn"] = this.bvn;
        data["first_Name"] = this.first_Name;
        data["last_Name"] = this.last_Name;
        data["middle_Name"] = this.middle_Name;
        data["gender"] = this.gender;
        data["date_of_Birth"] = this.date_of_Birth;
        data["phone_Number1"] = this.phone_Number1;
        data["image"] = this.image;
        data["level_of_Account"] = this.level_of_Account;
        data["lga_of_Origin"] = this.lga_of_Origin;
        data["lga_of_Residence"] = this.lga_of_Residence;
        data["marital_Status"] = this.marital_Status;
        data["name_on_Card"] = this.name_on_Card;
        data["nationality"] = this.nationality;
        data["nin"] = this.nin;
        data["phone_Number2"] = this.phone_Number2;
        data["reference"] = this.reference;
        data["registration_Date"] = this.registration_Date;
        data["residential_Address"] = this.residential_Address;
        data["state_of_Origin"] = this.state_of_Origin;
        data["state_of_Residence"] = this.state_of_Residence;
        data["title"] = this.title;
        data["watch_Listed"] = this.watch_Listed;
        return data;
    }
}

export interface IBVNResponse {
    bvn?: string | undefined;
    first_Name?: string | undefined;
    last_Name?: string | undefined;
    middle_Name?: string | undefined;
    gender?: string | undefined;
    date_of_Birth?: string | undefined;
    phone_Number1?: string | undefined;
    image?: string | undefined;
    level_of_Account?: string | undefined;
    lga_of_Origin?: string | undefined;
    lga_of_Residence?: string | undefined;
    marital_Status?: string | undefined;
    name_on_Card?: string | undefined;
    nationality?: string | undefined;
    nin?: string | undefined;
    phone_Number2?: string | undefined;
    reference?: string | undefined;
    registration_Date?: string | undefined;
    residential_Address?: string | undefined;
    state_of_Origin?: string | undefined;
    state_of_Residence?: string | undefined;
    title?: string | undefined;
    watch_Listed?: string | undefined;
}

export class BVNSelfieResponse implements IBVNSelfieResponse {
    entity?: BVNSelfie | undefined;
    status?: boolean;
    message?: string | undefined;

    constructor(data?: IBVNSelfieResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? BVNSelfie.fromJS(_data["entity"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BVNSelfieResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BVNSelfieResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IBVNSelfieResponse {
    entity?: BVNSelfie | undefined;
    status?: boolean;
    message?: string | undefined;
}

export class BVNSelfie implements IBVNSelfie {
    bvn?: string | undefined;
    first_name?: string | undefined;
    middle_name?: string | undefined;
    last_name?: string | undefined;
    date_of_birth?: string | undefined;
    phone_number1?: string | undefined;
    phone_number2?: string | undefined;
    gender?: string | undefined;
    enrollment_bank?: string | undefined;
    enrollment_branch?: string | undefined;
    email?: string | undefined;
    lga_of_origin?: string | undefined;
    lga_of_residence?: string | undefined;
    marital_status?: string | undefined;
    nin?: string | undefined;
    name_on_card?: string | undefined;
    residential_address?: string | undefined;
    state_of_origin?: string | undefined;
    state_of_residence?: string | undefined;
    watch_listed?: string | undefined;
    level_of_account?: string | undefined;
    registration_date?: string | undefined;
    image?: string | undefined;
    selfie_verification?: SelfieVerification | undefined;

    constructor(data?: IBVNSelfie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bvn = _data["bvn"];
            this.first_name = _data["first_name"];
            this.middle_name = _data["middle_name"];
            this.last_name = _data["last_name"];
            this.date_of_birth = _data["date_of_birth"];
            this.phone_number1 = _data["phone_number1"];
            this.phone_number2 = _data["phone_number2"];
            this.gender = _data["gender"];
            this.enrollment_bank = _data["enrollment_bank"];
            this.enrollment_branch = _data["enrollment_branch"];
            this.email = _data["email"];
            this.lga_of_origin = _data["lga_of_origin"];
            this.lga_of_residence = _data["lga_of_residence"];
            this.marital_status = _data["marital_status"];
            this.nin = _data["nin"];
            this.name_on_card = _data["name_on_card"];
            this.residential_address = _data["residential_address"];
            this.state_of_origin = _data["state_of_origin"];
            this.state_of_residence = _data["state_of_residence"];
            this.watch_listed = _data["watch_listed"];
            this.level_of_account = _data["level_of_account"];
            this.registration_date = _data["registration_date"];
            this.image = _data["image"];
            this.selfie_verification = _data["selfie_verification"] ? SelfieVerification.fromJS(_data["selfie_verification"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BVNSelfie {
        data = typeof data === 'object' ? data : {};
        let result = new BVNSelfie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bvn"] = this.bvn;
        data["first_name"] = this.first_name;
        data["middle_name"] = this.middle_name;
        data["last_name"] = this.last_name;
        data["date_of_birth"] = this.date_of_birth;
        data["phone_number1"] = this.phone_number1;
        data["phone_number2"] = this.phone_number2;
        data["gender"] = this.gender;
        data["enrollment_bank"] = this.enrollment_bank;
        data["enrollment_branch"] = this.enrollment_branch;
        data["email"] = this.email;
        data["lga_of_origin"] = this.lga_of_origin;
        data["lga_of_residence"] = this.lga_of_residence;
        data["marital_status"] = this.marital_status;
        data["nin"] = this.nin;
        data["name_on_card"] = this.name_on_card;
        data["residential_address"] = this.residential_address;
        data["state_of_origin"] = this.state_of_origin;
        data["state_of_residence"] = this.state_of_residence;
        data["watch_listed"] = this.watch_listed;
        data["level_of_account"] = this.level_of_account;
        data["registration_date"] = this.registration_date;
        data["image"] = this.image;
        data["selfie_verification"] = this.selfie_verification ? this.selfie_verification.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBVNSelfie {
    bvn?: string | undefined;
    first_name?: string | undefined;
    middle_name?: string | undefined;
    last_name?: string | undefined;
    date_of_birth?: string | undefined;
    phone_number1?: string | undefined;
    phone_number2?: string | undefined;
    gender?: string | undefined;
    enrollment_bank?: string | undefined;
    enrollment_branch?: string | undefined;
    email?: string | undefined;
    lga_of_origin?: string | undefined;
    lga_of_residence?: string | undefined;
    marital_status?: string | undefined;
    nin?: string | undefined;
    name_on_card?: string | undefined;
    residential_address?: string | undefined;
    state_of_origin?: string | undefined;
    state_of_residence?: string | undefined;
    watch_listed?: string | undefined;
    level_of_account?: string | undefined;
    registration_date?: string | undefined;
    image?: string | undefined;
    selfie_verification?: SelfieVerification | undefined;
}

export class SelfieVerification implements ISelfieVerification {
    confidence_value?: number;
    match?: boolean;

    constructor(data?: ISelfieVerification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confidence_value = _data["confidence_value"];
            this.match = _data["match"];
        }
    }

    static fromJS(data: any): SelfieVerification {
        data = typeof data === 'object' ? data : {};
        let result = new SelfieVerification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confidence_value"] = this.confidence_value;
        data["match"] = this.match;
        return data;
    }
}

export interface ISelfieVerification {
    confidence_value?: number;
    match?: boolean;
}

export class BVNSelfieFHIRResponse implements IBVNSelfieFHIRResponse {
    status?: boolean;
    message?: string | undefined;

    constructor(data?: IBVNSelfieFHIRResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BVNSelfieFHIRResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BVNSelfieFHIRResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IBVNSelfieFHIRResponse {
    status?: boolean;
    message?: string | undefined;
}

export class UserDetailBvnFHIRDTO implements IUserDetailBvnFHIRDTO {
    userDetailID?: string;
    currency?: CurrencyEnum;
    bvn?: string | undefined;
    nin?: string | undefined;
    dob!: Date;
    phoneNumber!: string;
    image!: string;

    constructor(data?: IUserDetailBvnFHIRDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.currency = _data["currency"];
            this.bvn = _data["bvn"];
            this.nin = _data["nin"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): UserDetailBvnFHIRDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailBvnFHIRDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["currency"] = this.currency;
        data["bvn"] = this.bvn;
        data["nin"] = this.nin;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["image"] = this.image;
        return data;
    }
}

export interface IUserDetailBvnFHIRDTO {
    userDetailID?: string;
    currency?: CurrencyEnum;
    bvn?: string | undefined;
    nin?: string | undefined;
    dob: Date;
    phoneNumber: string;
    image: string;
}

export class WalletBalanceResponse implements IWalletBalanceResponse {
    entity?: Balance | undefined;
    message?: string | undefined;

    constructor(data?: IWalletBalanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? Balance.fromJS(_data["entity"]) : <any>undefined;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletBalanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletBalanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletBalanceResponse {
    entity?: Balance | undefined;
    message?: string | undefined;
}

export class Balance implements IBalance {
    wallet_Balance?: string | undefined;

    constructor(data?: IBalance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wallet_Balance = _data["wallet_Balance"];
        }
    }

    static fromJS(data: any): Balance {
        data = typeof data === 'object' ? data : {};
        let result = new Balance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wallet_Balance"] = this.wallet_Balance;
        return data;
    }
}

export interface IBalance {
    wallet_Balance?: string | undefined;
}

export class Verification extends EntityBase implements IVerification {
    verificationID!: string;
    userDetailID!: string;
    associatedID?: string | undefined;
    bvn?: string | undefined;
    nin?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: string | undefined;
    birthDate?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    response?: string | undefined;
    message?: string | undefined;
    verificationImageDetailID?: string;
    uploadedImageDetailID?: string;
    watchList?: string | undefined;
    data?: string | undefined;
    attempts?: number;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;

    constructor(data?: IVerification) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.verificationID = _data["verificationID"];
            this.userDetailID = _data["userDetailID"];
            this.associatedID = _data["associatedID"];
            this.bvn = _data["bvn"];
            this.nin = _data["nin"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.suffix = _data["suffix"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.description = _data["description"];
            this.response = _data["response"];
            this.message = _data["message"];
            this.verificationImageDetailID = _data["verificationImageDetailID"];
            this.uploadedImageDetailID = _data["uploadedImageDetailID"];
            this.watchList = _data["watchList"];
            this.data = _data["data"];
            this.attempts = _data["attempts"];
            this.verified = _data["verified"];
            this.verifiedByUserDetailID = _data["verifiedByUserDetailID"];
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Verification {
        data = typeof data === 'object' ? data : {};
        let result = new Verification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationID"] = this.verificationID;
        data["userDetailID"] = this.userDetailID;
        data["associatedID"] = this.associatedID;
        data["bvn"] = this.bvn;
        data["nin"] = this.nin;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["suffix"] = this.suffix;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["description"] = this.description;
        data["response"] = this.response;
        data["message"] = this.message;
        data["verificationImageDetailID"] = this.verificationImageDetailID;
        data["uploadedImageDetailID"] = this.uploadedImageDetailID;
        data["watchList"] = this.watchList;
        data["data"] = this.data;
        data["attempts"] = this.attempts;
        data["verified"] = this.verified;
        data["verifiedByUserDetailID"] = this.verifiedByUserDetailID;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IVerification extends IEntityBase {
    verificationID: string;
    userDetailID: string;
    associatedID?: string | undefined;
    bvn?: string | undefined;
    nin?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    suffix?: string | undefined;
    gender?: string | undefined;
    birthDate?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    description?: string | undefined;
    response?: string | undefined;
    message?: string | undefined;
    verificationImageDetailID?: string;
    uploadedImageDetailID?: string;
    watchList?: string | undefined;
    data?: string | undefined;
    attempts?: number;
    verified?: boolean | undefined;
    verifiedByUserDetailID?: string | undefined;
    verifiedDate?: Date | undefined;
}

export class SearchVerificationDetails implements ISearchVerificationDetails {
    startDate!: Date;
    endDate!: Date;

    constructor(data?: ISearchVerificationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchVerificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SearchVerificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearchVerificationDetails {
    startDate: Date;
    endDate: Date;
}

export class ErrorResult implements IErrorResult {
    validationMessage?: string | undefined;
    message?: string | undefined;
    errorDate?: Date;
    error?: string | undefined;

    constructor(data?: IErrorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationMessage = _data["validationMessage"];
            this.message = _data["message"];
            this.errorDate = _data["errorDate"] ? new Date(_data["errorDate"].toString()) : <any>undefined;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationMessage"] = this.validationMessage;
        data["message"] = this.message;
        data["errorDate"] = this.errorDate ? this.errorDate.toISOString() : <any>undefined;
        data["error"] = this.error;
        return data;
    }
}

export interface IErrorResult {
    validationMessage?: string | undefined;
    message?: string | undefined;
    errorDate?: Date;
    error?: string | undefined;
}

export class VideoDetail extends EntityBase implements IVideoDetail {
    videoDetailID!: string;
    name!: string;
    description?: string | undefined;
    videoURL?: string | undefined;
    data?: string | undefined;
    fileDetailID!: string;
    fileDetail?: FileDetail | undefined;

    constructor(data?: IVideoDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.videoDetailID = _data["videoDetailID"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.videoURL = _data["videoURL"];
            this.data = _data["data"];
            this.fileDetailID = _data["fileDetailID"];
            this.fileDetail = _data["fileDetail"] ? FileDetail.fromJS(_data["fileDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VideoDetail {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoDetailID"] = this.videoDetailID;
        data["name"] = this.name;
        data["description"] = this.description;
        data["videoURL"] = this.videoURL;
        data["data"] = this.data;
        data["fileDetailID"] = this.fileDetailID;
        data["fileDetail"] = this.fileDetail ? this.fileDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IVideoDetail extends IEntityBase {
    videoDetailID: string;
    name: string;
    description?: string | undefined;
    videoURL?: string | undefined;
    data?: string | undefined;
    fileDetailID: string;
    fileDetail?: FileDetail | undefined;
}

export enum WalletKYCRequirementsEnum {
    NotSet = "NotSet",
    PhoneNumber = "PhoneNumber",
    BVN = "BVN",
}

export class CustomersResponse implements ICustomersResponse {
    data?: Data2[] | undefined;
    meta?: Meta | undefined;

    constructor(data?: ICustomersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Data2.fromJS(item));
            }
            this.meta = _data["meta"] ? Meta.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomersResponse {
    data?: Data2[] | undefined;
    meta?: Meta | undefined;
}

export class Data2 implements IData2 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    email?: string | undefined;
    userInfo?: UserInfoFV | undefined;
    wallet?: WalletFV | undefined;

    constructor(data?: IData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.userInfo = _data["userInfo"] ? UserInfoFV.fromJS(_data["userInfo"]) : <any>undefined;
            this.wallet = _data["wallet"] ? WalletFV.fromJS(_data["wallet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Data2 {
        data = typeof data === 'object' ? data : {};
        let result = new Data2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        data["wallet"] = this.wallet ? this.wallet.toJSON() : <any>undefined;
        return data;
    }
}

export interface IData2 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    email?: string | undefined;
    userInfo?: UserInfoFV | undefined;
    wallet?: WalletFV | undefined;
}

export class UserInfoFV implements IUserInfoFV {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    userType?: string | undefined;
    twoFA?: boolean;

    constructor(data?: IUserInfoFV) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.userType = _data["userType"];
            this.twoFA = _data["twoFA"];
        }
    }

    static fromJS(data: any): UserInfoFV {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoFV();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["userType"] = this.userType;
        data["twoFA"] = this.twoFA;
        return data;
    }
}

export interface IUserInfoFV {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    userType?: string | undefined;
    twoFA?: boolean;
}

export class WalletFV implements IWalletFV {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    merchant?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    isFrozen?: boolean;
    status?: string | undefined;
    fundMethod?: string | undefined;

    constructor(data?: IWalletFV) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.merchant = _data["merchant"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.isFrozen = _data["isFrozen"];
            this.status = _data["status"];
            this.fundMethod = _data["fundMethod"];
        }
    }

    static fromJS(data: any): WalletFV {
        data = typeof data === 'object' ? data : {};
        let result = new WalletFV();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["merchant"] = this.merchant;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["isFrozen"] = this.isFrozen;
        data["status"] = this.status;
        data["fundMethod"] = this.fundMethod;
        return data;
    }
}

export interface IWalletFV {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    merchant?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    isFrozen?: boolean;
    status?: string | undefined;
    fundMethod?: string | undefined;
}

export class Meta implements IMeta {
    itemCount?: number;
    pageCount?: number | undefined;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemCount = _data["itemCount"];
            this.pageCount = _data["pageCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): Meta {
        data = typeof data === 'object' ? data : {};
        let result = new Meta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCount"] = this.itemCount;
        data["pageCount"] = this.pageCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IMeta {
    itemCount?: number;
    pageCount?: number | undefined;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class CustomerResponse implements ICustomerResponse {
    status?: string | undefined;
    message?: string | undefined;
    data?: Data3 | undefined;

    constructor(data?: ICustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? Data3.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerResponse {
    status?: string | undefined;
    message?: string | undefined;
    data?: Data3 | undefined;
}

export class Data3 implements IData3 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    email?: string | undefined;
    userInfo?: UserInfoFV | undefined;
    wallet?: WalletFV | undefined;

    constructor(data?: IData3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.userInfo = _data["userInfo"] ? UserInfoFV.fromJS(_data["userInfo"]) : <any>undefined;
            this.wallet = _data["wallet"] ? WalletFV.fromJS(_data["wallet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Data3 {
        data = typeof data === 'object' ? data : {};
        let result = new Data3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        data["wallet"] = this.wallet ? this.wallet.toJSON() : <any>undefined;
        return data;
    }
}

export interface IData3 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    email?: string | undefined;
    userInfo?: UserInfoFV | undefined;
    wallet?: WalletFV | undefined;
}

export class FreezeResponse implements IFreezeResponse {
    data?: Data4 | undefined;
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IFreezeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Data4.fromJS(_data["data"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): FreezeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FreezeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IFreezeResponse {
    data?: Data4 | undefined;
    status?: string | undefined;
    message?: string | undefined;
}

export class Data4 implements IData4 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    merchant?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    isFrozen?: boolean;
    status?: string | undefined;
    fundMethod?: string | undefined;
    customer?: UserInfoFV | undefined;

    constructor(data?: IData4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.merchant = _data["merchant"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.isFrozen = _data["isFrozen"];
            this.status = _data["status"];
            this.fundMethod = _data["fundMethod"];
            this.customer = _data["customer"] ? UserInfoFV.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Data4 {
        data = typeof data === 'object' ? data : {};
        let result = new Data4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["merchant"] = this.merchant;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["isFrozen"] = this.isFrozen;
        data["status"] = this.status;
        data["fundMethod"] = this.fundMethod;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IData4 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    merchant?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    isFrozen?: boolean;
    status?: string | undefined;
    fundMethod?: string | undefined;
    customer?: UserInfoFV | undefined;
}

export class FreezeRequest implements IFreezeRequest {
    walletId?: string | undefined;
    isFrozen?: boolean;
    reason?: string | undefined;

    constructor(data?: IFreezeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walletId = _data["walletId"];
            this.isFrozen = _data["isFrozen"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): FreezeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FreezeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletId"] = this.walletId;
        data["isFrozen"] = this.isFrozen;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IFreezeRequest {
    walletId?: string | undefined;
    isFrozen?: boolean;
    reason?: string | undefined;
}

export class WalletTransactionResponse implements IWalletTransactionResponse {
    data?: Data5 | undefined;
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IWalletTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Data5.fromJS(_data["data"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletTransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletTransactionResponse {
    data?: Data5 | undefined;
    status?: string | undefined;
    message?: string | undefined;
}

export class Data5 implements IData5 {
    data?: Transaction[] | undefined;
    meta?: Meta2 | undefined;

    constructor(data?: IData5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Transaction.fromJS(item));
            }
            this.meta = _data["meta"] ? Meta2.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Data5 {
        data = typeof data === 'object' ? data : {};
        let result = new Data5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IData5 {
    data?: Transaction[] | undefined;
    meta?: Meta2 | undefined;
}

export class Transaction implements ITransaction {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    amount?: string | undefined;
    transType?: string | undefined;
    entry?: string | undefined;
    reference?: string | undefined;
    isRefundable?: boolean;
    source?: string | undefined;
    destination?: string | undefined;
    narration?: string | undefined;
    status?: string | undefined;
    recipientDetails?: string | undefined;
    senderDetails?: string | undefined;
    senderBank?: string | undefined;
    receiverBank?: string | undefined;
    customer?: UserInfoFV | undefined;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.transType = _data["transType"];
            this.entry = _data["entry"];
            this.reference = _data["reference"];
            this.isRefundable = _data["isRefundable"];
            this.source = _data["source"];
            this.destination = _data["destination"];
            this.narration = _data["narration"];
            this.status = _data["status"];
            this.recipientDetails = _data["recipientDetails"];
            this.senderDetails = _data["senderDetails"];
            this.senderBank = _data["senderBank"];
            this.receiverBank = _data["receiverBank"];
            this.customer = _data["customer"] ? UserInfoFV.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["transType"] = this.transType;
        data["entry"] = this.entry;
        data["reference"] = this.reference;
        data["isRefundable"] = this.isRefundable;
        data["source"] = this.source;
        data["destination"] = this.destination;
        data["narration"] = this.narration;
        data["status"] = this.status;
        data["recipientDetails"] = this.recipientDetails;
        data["senderDetails"] = this.senderDetails;
        data["senderBank"] = this.senderBank;
        data["receiverBank"] = this.receiverBank;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITransaction {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    amount?: string | undefined;
    transType?: string | undefined;
    entry?: string | undefined;
    reference?: string | undefined;
    isRefundable?: boolean;
    source?: string | undefined;
    destination?: string | undefined;
    narration?: string | undefined;
    status?: string | undefined;
    recipientDetails?: string | undefined;
    senderDetails?: string | undefined;
    senderBank?: string | undefined;
    receiverBank?: string | undefined;
    customer?: UserInfoFV | undefined;
}

export class Meta2 implements IMeta2 {
    page?: string | undefined;
    take?: string | undefined;
    itemCount?: number;
    pageCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IMeta2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.take = _data["take"];
            this.itemCount = _data["itemCount"];
            this.pageCount = _data["pageCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): Meta2 {
        data = typeof data === 'object' ? data : {};
        let result = new Meta2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["take"] = this.take;
        data["itemCount"] = this.itemCount;
        data["pageCount"] = this.pageCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IMeta2 {
    page?: string | undefined;
    take?: string | undefined;
    itemCount?: number;
    pageCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class WalletTransactionRequest implements IWalletTransactionRequest {
    customerId!: string;
    take?: number;
    page?: number;
    order?: string | undefined;

    constructor(data?: IWalletTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.take = _data["take"];
            this.page = _data["page"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): WalletTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["take"] = this.take;
        data["page"] = this.page;
        data["order"] = this.order;
        return data;
    }
}

export interface IWalletTransactionRequest {
    customerId: string;
    take?: number;
    page?: number;
    order?: string | undefined;
}

export class TransactionResponse implements ITransactionResponse {
    data?: Data6 | undefined;
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: ITransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Data6.fromJS(_data["data"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface ITransactionResponse {
    data?: Data6 | undefined;
    status?: string | undefined;
    message?: string | undefined;
}

export class Data6 implements IData6 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    amount?: string | undefined;
    transType?: string | undefined;
    entry?: string | undefined;
    reference?: string | undefined;
    isRefundable?: boolean;
    source?: string | undefined;
    destination?: string | undefined;
    narration?: string | undefined;
    status?: string | undefined;
    recipientDetails?: string | undefined;
    senderDetails?: string | undefined;
    senderBank?: string | undefined;
    receiverBank?: string | undefined;
    customer?: UserInfoFV | undefined;
    merchant?: MerchantFV | undefined;

    constructor(data?: IData6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.transType = _data["transType"];
            this.entry = _data["entry"];
            this.reference = _data["reference"];
            this.isRefundable = _data["isRefundable"];
            this.source = _data["source"];
            this.destination = _data["destination"];
            this.narration = _data["narration"];
            this.status = _data["status"];
            this.recipientDetails = _data["recipientDetails"];
            this.senderDetails = _data["senderDetails"];
            this.senderBank = _data["senderBank"];
            this.receiverBank = _data["receiverBank"];
            this.customer = _data["customer"] ? UserInfoFV.fromJS(_data["customer"]) : <any>undefined;
            this.merchant = _data["merchant"] ? MerchantFV.fromJS(_data["merchant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Data6 {
        data = typeof data === 'object' ? data : {};
        let result = new Data6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["transType"] = this.transType;
        data["entry"] = this.entry;
        data["reference"] = this.reference;
        data["isRefundable"] = this.isRefundable;
        data["source"] = this.source;
        data["destination"] = this.destination;
        data["narration"] = this.narration;
        data["status"] = this.status;
        data["recipientDetails"] = this.recipientDetails;
        data["senderDetails"] = this.senderDetails;
        data["senderBank"] = this.senderBank;
        data["receiverBank"] = this.receiverBank;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["merchant"] = this.merchant ? this.merchant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IData6 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    amount?: string | undefined;
    transType?: string | undefined;
    entry?: string | undefined;
    reference?: string | undefined;
    isRefundable?: boolean;
    source?: string | undefined;
    destination?: string | undefined;
    narration?: string | undefined;
    status?: string | undefined;
    recipientDetails?: string | undefined;
    senderDetails?: string | undefined;
    senderBank?: string | undefined;
    receiverBank?: string | undefined;
    customer?: UserInfoFV | undefined;
    merchant?: MerchantFV | undefined;
}

export class MerchantFV implements IMerchantFV {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    businessEmail?: string | undefined;
    businessName?: string | undefined;
    status?: string | undefined;
    redirectUrl?: any | undefined;

    constructor(data?: IMerchantFV) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.businessEmail = _data["businessEmail"];
            this.businessName = _data["businessName"];
            this.status = _data["status"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): MerchantFV {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantFV();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["businessEmail"] = this.businessEmail;
        data["businessName"] = this.businessName;
        data["status"] = this.status;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IMerchantFV {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    businessEmail?: string | undefined;
    businessName?: string | undefined;
    status?: string | undefined;
    redirectUrl?: any | undefined;
}

export class MerchantTransactionResponse implements IMerchantTransactionResponse {
    data?: Transaction[] | undefined;
    meta?: MetaData | undefined;
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IMerchantTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Transaction.fromJS(item));
            }
            this.meta = _data["meta"] ? MetaData.fromJS(_data["meta"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MerchantTransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IMerchantTransactionResponse {
    data?: Transaction[] | undefined;
    meta?: MetaData | undefined;
    status?: string | undefined;
    message?: string | undefined;
}

export class MetaData implements IMetaData {
    page?: string | undefined;
    take?: string | undefined;
    itemCount?: number;
    pageCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.take = _data["take"];
            this.itemCount = _data["itemCount"];
            this.pageCount = _data["pageCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): MetaData {
        data = typeof data === 'object' ? data : {};
        let result = new MetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["take"] = this.take;
        data["itemCount"] = this.itemCount;
        data["pageCount"] = this.pageCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IMetaData {
    page?: string | undefined;
    take?: string | undefined;
    itemCount?: number;
    pageCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class MerchantTransactionRequest implements IMerchantTransactionRequest {
    take?: number;
    page?: number;
    order?: string | undefined;

    constructor(data?: IMerchantTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.take = _data["take"];
            this.page = _data["page"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): MerchantTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MerchantTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["take"] = this.take;
        data["page"] = this.page;
        data["order"] = this.order;
        return data;
    }
}

export interface IMerchantTransactionRequest {
    take?: number;
    page?: number;
    order?: string | undefined;
}

export class WalletBalanceResponse2 implements IWalletBalanceResponse2 {
    data?: WalletBalanceData | undefined;
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IWalletBalanceResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? WalletBalanceData.fromJS(_data["data"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletBalanceResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new WalletBalanceResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletBalanceResponse2 {
    data?: WalletBalanceData | undefined;
    status?: string | undefined;
    message?: string | undefined;
}

export class WalletBalanceData implements IWalletBalanceData {
    balance?: BalanceData | undefined;

    constructor(data?: IWalletBalanceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"] ? BalanceData.fromJS(_data["balance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WalletBalanceData {
        data = typeof data === 'object' ? data : {};
        let result = new WalletBalanceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance ? this.balance.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWalletBalanceData {
    balance?: BalanceData | undefined;
}

export class BalanceData implements IBalanceData {
    bookedBalance?: number;
    availableBalance?: number;

    constructor(data?: IBalanceData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookedBalance = _data["bookedBalance"];
            this.availableBalance = _data["availableBalance"];
        }
    }

    static fromJS(data: any): BalanceData {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookedBalance"] = this.bookedBalance;
        data["availableBalance"] = this.availableBalance;
        return data;
    }
}

export interface IBalanceData {
    bookedBalance?: number;
    availableBalance?: number;
}

export class WalletDetailResponse implements IWalletDetailResponse {
    data?: Data7 | undefined;
    status?: string | undefined;
    message?: string | undefined;

    constructor(data?: IWalletDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Data7.fromJS(_data["data"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WalletDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletDetailResponse {
    data?: Data7 | undefined;
    status?: string | undefined;
    message?: string | undefined;
}

export class Data7 implements IData7 {
    accountNumber?: string | undefined;
    accountName?: string | undefined;

    constructor(data?: IData7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): Data7 {
        data = typeof data === 'object' ? data : {};
        let result = new Data7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        return data;
    }
}

export interface IData7 {
    accountNumber?: string | undefined;
    accountName?: string | undefined;
}

export class VirtualWalletRequest implements IVirtualWalletRequest {
    customerName?: string | undefined;
    expireTimeInMin?: number;
    merchantReference?: string | undefined;
    description?: string | undefined;
    amount?: number;
    phone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IVirtualWalletRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.expireTimeInMin = _data["expireTimeInMin"];
            this.merchantReference = _data["merchantReference"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): VirtualWalletRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualWalletRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["expireTimeInMin"] = this.expireTimeInMin;
        data["merchantReference"] = this.merchantReference;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface IVirtualWalletRequest {
    customerName?: string | undefined;
    expireTimeInMin?: number;
    merchantReference?: string | undefined;
    description?: string | undefined;
    amount?: number;
    phone?: string | undefined;
    email?: string | undefined;
}

export class VirtualWalletDetailResponse implements IVirtualWalletDetailResponse {
    data?: Data8 | undefined;
    status?: number;
    message?: string | undefined;

    constructor(data?: IVirtualWalletDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Data8.fromJS(_data["data"]) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): VirtualWalletDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualWalletDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IVirtualWalletDetailResponse {
    data?: Data8 | undefined;
    status?: number;
    message?: string | undefined;
}

export class Data8 implements IData8 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    customerName?: string | undefined;
    merchantReference?: string | undefined;
    reference?: string | undefined;
    expireTimeInMin?: number;
    description?: string | undefined;
    metadata?: any | undefined;
    amount?: string | undefined;
    amountPaid?: number;
    phone?: string | undefined;
    email?: string | undefined;
    webhookUrl?: any | undefined;
    bank?: string | undefined;
    virtualAcctName?: string | undefined;
    virtualAcctNo?: string | undefined;
    redirectUrl?: string | undefined;
    requestTime?: Date;
    status?: string | undefined;
    paymentStatus?: string | undefined;
    jobId?: string | undefined;
    sessionId?: string | undefined;
    merchant?: Merchant2 | undefined;

    constructor(data?: IData8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.merchantReference = _data["merchantReference"];
            this.reference = _data["reference"];
            this.expireTimeInMin = _data["expireTimeInMin"];
            this.description = _data["description"];
            this.metadata = _data["metadata"];
            this.amount = _data["amount"];
            this.amountPaid = _data["amountPaid"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.webhookUrl = _data["webhookUrl"];
            this.bank = _data["bank"];
            this.virtualAcctName = _data["virtualAcctName"];
            this.virtualAcctNo = _data["virtualAcctNo"];
            this.redirectUrl = _data["redirectUrl"];
            this.requestTime = _data["requestTime"] ? new Date(_data["requestTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.jobId = _data["jobId"];
            this.sessionId = _data["sessionId"];
            this.merchant = _data["merchant"] ? Merchant2.fromJS(_data["merchant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Data8 {
        data = typeof data === 'object' ? data : {};
        let result = new Data8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["merchantReference"] = this.merchantReference;
        data["reference"] = this.reference;
        data["expireTimeInMin"] = this.expireTimeInMin;
        data["description"] = this.description;
        data["metadata"] = this.metadata;
        data["amount"] = this.amount;
        data["amountPaid"] = this.amountPaid;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["webhookUrl"] = this.webhookUrl;
        data["bank"] = this.bank;
        data["virtualAcctName"] = this.virtualAcctName;
        data["virtualAcctNo"] = this.virtualAcctNo;
        data["redirectUrl"] = this.redirectUrl;
        data["requestTime"] = this.requestTime ? this.requestTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["jobId"] = this.jobId;
        data["sessionId"] = this.sessionId;
        data["merchant"] = this.merchant ? this.merchant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IData8 {
    id?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    customerName?: string | undefined;
    merchantReference?: string | undefined;
    reference?: string | undefined;
    expireTimeInMin?: number;
    description?: string | undefined;
    metadata?: any | undefined;
    amount?: string | undefined;
    amountPaid?: number;
    phone?: string | undefined;
    email?: string | undefined;
    webhookUrl?: any | undefined;
    bank?: string | undefined;
    virtualAcctName?: string | undefined;
    virtualAcctNo?: string | undefined;
    redirectUrl?: string | undefined;
    requestTime?: Date;
    status?: string | undefined;
    paymentStatus?: string | undefined;
    jobId?: string | undefined;
    sessionId?: string | undefined;
    merchant?: Merchant2 | undefined;
}

export class Merchant2 implements IMerchant2 {
    businessEmail?: string | undefined;
    businessName?: string | undefined;
    callbackUrl?: any | undefined;

    constructor(data?: IMerchant2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessEmail = _data["businessEmail"];
            this.businessName = _data["businessName"];
            this.callbackUrl = _data["callbackUrl"];
        }
    }

    static fromJS(data: any): Merchant2 {
        data = typeof data === 'object' ? data : {};
        let result = new Merchant2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessEmail"] = this.businessEmail;
        data["businessName"] = this.businessName;
        data["callbackUrl"] = this.callbackUrl;
        return data;
    }
}

export interface IMerchant2 {
    businessEmail?: string | undefined;
    businessName?: string | undefined;
    callbackUrl?: any | undefined;
}

export class WalletCardPinValidateResults implements IWalletCardPinValidateResults {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IWalletCardPinValidateResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletCardPinValidateResults {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardPinValidateResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletCardPinValidateResults {
    success?: boolean;
    message?: string | undefined;
}

export class WalletCardPinValidateDetails implements IWalletCardPinValidateDetails {
    walletCardNumber?: number;
    walletCardPinNumber?: number;

    constructor(data?: IWalletCardPinValidateDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walletCardNumber = _data["walletCardNumber"];
            this.walletCardPinNumber = _data["walletCardPinNumber"];
        }
    }

    static fromJS(data: any): WalletCardPinValidateDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardPinValidateDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletCardNumber"] = this.walletCardNumber;
        data["walletCardPinNumber"] = this.walletCardPinNumber;
        return data;
    }
}

export interface IWalletCardPinValidateDetails {
    walletCardNumber?: number;
    walletCardPinNumber?: number;
}

export class ResetWalletCardPinResults implements IResetWalletCardPinResults {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IResetWalletCardPinResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResetWalletCardPinResults {
        data = typeof data === 'object' ? data : {};
        let result = new ResetWalletCardPinResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IResetWalletCardPinResults {
    success?: boolean;
    message?: string | undefined;
}

export class ResetWalletCardPinDetails implements IResetWalletCardPinDetails {
    emailOrUniqueLifetimeID?: string | undefined;
    passwordOrPIN?: string | undefined;
    walletCardID?: string;
    pin?: number;

    constructor(data?: IResetWalletCardPinDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailOrUniqueLifetimeID = _data["emailOrUniqueLifetimeID"];
            this.passwordOrPIN = _data["passwordOrPIN"];
            this.walletCardID = _data["walletCardID"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): ResetWalletCardPinDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ResetWalletCardPinDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailOrUniqueLifetimeID"] = this.emailOrUniqueLifetimeID;
        data["passwordOrPIN"] = this.passwordOrPIN;
        data["walletCardID"] = this.walletCardID;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IResetWalletCardPinDetails {
    emailOrUniqueLifetimeID?: string | undefined;
    passwordOrPIN?: string | undefined;
    walletCardID?: string;
    pin?: number;
}

export class ChangeWalletCardPinResults implements IChangeWalletCardPinResults {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IChangeWalletCardPinResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ChangeWalletCardPinResults {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeWalletCardPinResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IChangeWalletCardPinResults {
    success?: boolean;
    message?: string | undefined;
}

export class ChangeWalletCardPinDetails implements IChangeWalletCardPinDetails {
    walletCardID?: string;
    currentPIN?: number;
    pin?: number;

    constructor(data?: IChangeWalletCardPinDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walletCardID = _data["walletCardID"];
            this.currentPIN = _data["currentPIN"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): ChangeWalletCardPinDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeWalletCardPinDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletCardID"] = this.walletCardID;
        data["currentPIN"] = this.currentPIN;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IChangeWalletCardPinDetails {
    walletCardID?: string;
    currentPIN?: number;
    pin?: number;
}

export class WalletCardResults implements IWalletCardResults {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IWalletCardResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletCardResults {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletCardResults {
    success?: boolean;
    message?: string | undefined;
}

export class WalletCardDetails implements IWalletCardDetails {
    userDetailID?: string;
    walletCardID?: string;
    pin?: number;

    constructor(data?: IWalletCardDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.walletCardID = _data["walletCardID"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): WalletCardDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["walletCardID"] = this.walletCardID;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IWalletCardDetails {
    userDetailID?: string;
    walletCardID?: string;
    pin?: number;
}

export class WalletCard extends EntityBase implements IWalletCard {
    walletCardID!: string;
    userDetailID?: string | undefined;
    cardNumber!: number;
    cardTypeEnum!: CardTypeEnum;
    cardStatusEnum!: CardStatusEnum;
    userDetail?: UserDetail | undefined;

    constructor(data?: IWalletCard) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.walletCardID = _data["walletCardID"];
            this.userDetailID = _data["userDetailID"];
            this.cardNumber = _data["cardNumber"];
            this.cardTypeEnum = _data["cardTypeEnum"];
            this.cardStatusEnum = _data["cardStatusEnum"];
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WalletCard {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletCardID"] = this.walletCardID;
        data["userDetailID"] = this.userDetailID;
        data["cardNumber"] = this.cardNumber;
        data["cardTypeEnum"] = this.cardTypeEnum;
        data["cardStatusEnum"] = this.cardStatusEnum;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWalletCard extends IEntityBase {
    walletCardID: string;
    userDetailID?: string | undefined;
    cardNumber: number;
    cardTypeEnum: CardTypeEnum;
    cardStatusEnum: CardStatusEnum;
    userDetail?: UserDetail | undefined;
}

export enum CardTypeEnum {
    NotSet = "NotSet",
    NeoPhysical = "NeoPhysical",
    NeoVirtual = "NeoVirtual",
}

export enum CardStatusEnum {
    NotSet = "NotSet",
    Available = "Available",
    Active = "Active",
    Locked = "Locked",
    Lost = "Lost",
    Deactivated = "Deactivated",
}

export class WalletCardSearchResults implements IWalletCardSearchResults {
    userDetailID?: string;
    walletCardID?: string;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IWalletCardSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.walletCardID = _data["walletCardID"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletCardSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["walletCardID"] = this.walletCardID;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletCardSearchResults {
    userDetailID?: string;
    walletCardID?: string;
    success?: boolean;
    message?: string | undefined;
}

export class WalletCardSearchDetails implements IWalletCardSearchDetails {
    cardNumber?: number;
    pin?: number;
    notificationID?: string | undefined;

    constructor(data?: IWalletCardSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"];
            this.pin = _data["pin"];
            this.notificationID = _data["notificationID"];
        }
    }

    static fromJS(data: any): WalletCardSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber;
        data["pin"] = this.pin;
        data["notificationID"] = this.notificationID;
        return data;
    }
}

export interface IWalletCardSearchDetails {
    cardNumber?: number;
    pin?: number;
    notificationID?: string | undefined;
}

export class WalletCardPatientSearchResults implements IWalletCardPatientSearchResults {
    patients?: WalletCardPatientSearchDTO[] | undefined;

    constructor(data?: IWalletCardPatientSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["patients"])) {
                this.patients = [] as any;
                for (let item of _data["patients"])
                    this.patients!.push(WalletCardPatientSearchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WalletCardPatientSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardPatientSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patients)) {
            data["patients"] = [];
            for (let item of this.patients)
                data["patients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWalletCardPatientSearchResults {
    patients?: WalletCardPatientSearchDTO[] | undefined;
}

export class WalletCardPatientSearchDTO implements IWalletCardPatientSearchDTO {
    userDetailID?: string;
    fullName?: string | undefined;

    constructor(data?: IWalletCardPatientSearchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): WalletCardPatientSearchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardPatientSearchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IWalletCardPatientSearchDTO {
    userDetailID?: string;
    fullName?: string | undefined;
}

export class WalletCardPatientSearchDetails implements IWalletCardPatientSearchDetails {
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;

    constructor(data?: IWalletCardPatientSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.smsNumber = _data["smsNumber"];
        }
    }

    static fromJS(data: any): WalletCardPatientSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardPatientSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["smsNumber"] = this.smsNumber;
        return data;
    }
}

export interface IWalletCardPatientSearchDetails {
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;
}

export class WalletCardCheckedResult implements IWalletCardCheckedResult {
    walletCardID?: string | undefined;
    userDetailID?: string | undefined;
    isUsed?: boolean;

    constructor(data?: IWalletCardCheckedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walletCardID = _data["walletCardID"];
            this.userDetailID = _data["userDetailID"];
            this.isUsed = _data["isUsed"];
        }
    }

    static fromJS(data: any): WalletCardCheckedResult {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCardCheckedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletCardID"] = this.walletCardID;
        data["userDetailID"] = this.userDetailID;
        data["isUsed"] = this.isUsed;
        return data;
    }
}

export interface IWalletCardCheckedResult {
    walletCardID?: string | undefined;
    userDetailID?: string | undefined;
    isUsed?: boolean;
}

export class WalletDump extends EntityBase implements IWalletDump {
    walletDumpID!: string;
    userDetailID!: string;
    currencyEnum!: CurrencyEnum;
    walletTypeEnum!: WalletTypeEnum;
    balance!: number;
    walletAPICustomerID?: string | undefined;
    walletAPIWalletID?: string | undefined;
    walletBankName?: string | undefined;
    walletBankCode?: string | undefined;
    walletAccountName?: string | undefined;
    walletAccountNumber?: string | undefined;
    walletAccountReference?: string | undefined;
    userDetail?: UserDetail | undefined;

    constructor(data?: IWalletDump) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.walletDumpID = _data["walletDumpID"];
            this.userDetailID = _data["userDetailID"];
            this.currencyEnum = _data["currencyEnum"];
            this.walletTypeEnum = _data["walletTypeEnum"];
            this.balance = _data["balance"];
            this.walletAPICustomerID = _data["walletAPICustomerID"];
            this.walletAPIWalletID = _data["walletAPIWalletID"];
            this.walletBankName = _data["walletBankName"];
            this.walletBankCode = _data["walletBankCode"];
            this.walletAccountName = _data["walletAccountName"];
            this.walletAccountNumber = _data["walletAccountNumber"];
            this.walletAccountReference = _data["walletAccountReference"];
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WalletDump {
        data = typeof data === 'object' ? data : {};
        let result = new WalletDump();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletDumpID"] = this.walletDumpID;
        data["userDetailID"] = this.userDetailID;
        data["currencyEnum"] = this.currencyEnum;
        data["walletTypeEnum"] = this.walletTypeEnum;
        data["balance"] = this.balance;
        data["walletAPICustomerID"] = this.walletAPICustomerID;
        data["walletAPIWalletID"] = this.walletAPIWalletID;
        data["walletBankName"] = this.walletBankName;
        data["walletBankCode"] = this.walletBankCode;
        data["walletAccountName"] = this.walletAccountName;
        data["walletAccountNumber"] = this.walletAccountNumber;
        data["walletAccountReference"] = this.walletAccountReference;
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWalletDump extends IEntityBase {
    walletDumpID: string;
    userDetailID: string;
    currencyEnum: CurrencyEnum;
    walletTypeEnum: WalletTypeEnum;
    balance: number;
    walletAPICustomerID?: string | undefined;
    walletAPIWalletID?: string | undefined;
    walletBankName?: string | undefined;
    walletBankCode?: string | undefined;
    walletAccountName?: string | undefined;
    walletAccountNumber?: string | undefined;
    walletAccountReference?: string | undefined;
    userDetail?: UserDetail | undefined;
}

export class Wallet extends EntityBase implements IWallet {
    walletID!: string;
    userDetailID!: string;
    currencyEnum!: CurrencyEnum;
    walletTypeEnum!: WalletTypeEnum;
    balance!: number;
    walletAPICustomerID?: string | undefined;
    walletAPIWalletID?: string | undefined;
    walletBankName?: string | undefined;
    walletBankCode?: string | undefined;
    walletAccountName?: string | undefined;
    walletAccountNumber?: string | undefined;
    walletAccountReference?: string | undefined;
    walletDetails?: WalletDetail[] | undefined;
    userDetail?: UserDetail | undefined;

    constructor(data?: IWallet) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.walletID = _data["walletID"];
            this.userDetailID = _data["userDetailID"];
            this.currencyEnum = _data["currencyEnum"];
            this.walletTypeEnum = _data["walletTypeEnum"];
            this.balance = _data["balance"];
            this.walletAPICustomerID = _data["walletAPICustomerID"];
            this.walletAPIWalletID = _data["walletAPIWalletID"];
            this.walletBankName = _data["walletBankName"];
            this.walletBankCode = _data["walletBankCode"];
            this.walletAccountName = _data["walletAccountName"];
            this.walletAccountNumber = _data["walletAccountNumber"];
            this.walletAccountReference = _data["walletAccountReference"];
            if (Array.isArray(_data["walletDetails"])) {
                this.walletDetails = [] as any;
                for (let item of _data["walletDetails"])
                    this.walletDetails!.push(WalletDetail.fromJS(item));
            }
            this.userDetail = _data["userDetail"] ? UserDetail.fromJS(_data["userDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Wallet {
        data = typeof data === 'object' ? data : {};
        let result = new Wallet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletID"] = this.walletID;
        data["userDetailID"] = this.userDetailID;
        data["currencyEnum"] = this.currencyEnum;
        data["walletTypeEnum"] = this.walletTypeEnum;
        data["balance"] = this.balance;
        data["walletAPICustomerID"] = this.walletAPICustomerID;
        data["walletAPIWalletID"] = this.walletAPIWalletID;
        data["walletBankName"] = this.walletBankName;
        data["walletBankCode"] = this.walletBankCode;
        data["walletAccountName"] = this.walletAccountName;
        data["walletAccountNumber"] = this.walletAccountNumber;
        data["walletAccountReference"] = this.walletAccountReference;
        if (Array.isArray(this.walletDetails)) {
            data["walletDetails"] = [];
            for (let item of this.walletDetails)
                data["walletDetails"].push(item.toJSON());
        }
        data["userDetail"] = this.userDetail ? this.userDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWallet extends IEntityBase {
    walletID: string;
    userDetailID: string;
    currencyEnum: CurrencyEnum;
    walletTypeEnum: WalletTypeEnum;
    balance: number;
    walletAPICustomerID?: string | undefined;
    walletAPIWalletID?: string | undefined;
    walletBankName?: string | undefined;
    walletBankCode?: string | undefined;
    walletAccountName?: string | undefined;
    walletAccountNumber?: string | undefined;
    walletAccountReference?: string | undefined;
    walletDetails?: WalletDetail[] | undefined;
    userDetail?: UserDetail | undefined;
}

export class WalletDetail extends EntityBase implements IWalletDetail {
    walletDetailID!: string;
    walletID!: string;
    invoiceID?: string | undefined;
    amount!: number;
    fromUserDetailID?: string | undefined;
    toUserDetailID?: string | undefined;
    detailDate!: Date;
    walletDetailStatusEnum!: WalletDetailStatusEnum;
    walletTransactionTypeEnum!: WalletTransactionTypeEnum;
    walletTransferID?: string | undefined;
    message?: string | undefined;
    walletAPIReference?: string | undefined;
    invoice?: Invoice | undefined;
    wallet?: Wallet | undefined;
    toUserDetailRelationshipID?: string | undefined;
    currencyEnum?: CurrencyEnum | undefined;
    walletTypeEnum?: WalletTypeEnum | undefined;
    toUserFullName?: string | undefined;
    fromUserFullName?: string | undefined;
    fromUserDetail?: UserDetail | undefined;
    toUserDetail?: UserDetail | undefined;

    constructor(data?: IWalletDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.walletDetailID = _data["walletDetailID"];
            this.walletID = _data["walletID"];
            this.invoiceID = _data["invoiceID"];
            this.amount = _data["amount"];
            this.fromUserDetailID = _data["fromUserDetailID"];
            this.toUserDetailID = _data["toUserDetailID"];
            this.detailDate = _data["detailDate"] ? new Date(_data["detailDate"].toString()) : <any>undefined;
            this.walletDetailStatusEnum = _data["walletDetailStatusEnum"];
            this.walletTransactionTypeEnum = _data["walletTransactionTypeEnum"];
            this.walletTransferID = _data["walletTransferID"];
            this.message = _data["message"];
            this.walletAPIReference = _data["walletAPIReference"];
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.wallet = _data["wallet"] ? Wallet.fromJS(_data["wallet"]) : <any>undefined;
            this.toUserDetailRelationshipID = _data["toUserDetailRelationshipID"];
            this.currencyEnum = _data["currencyEnum"];
            this.walletTypeEnum = _data["walletTypeEnum"];
            this.toUserFullName = _data["toUserFullName"];
            this.fromUserFullName = _data["fromUserFullName"];
            this.fromUserDetail = _data["fromUserDetail"] ? UserDetail.fromJS(_data["fromUserDetail"]) : <any>undefined;
            this.toUserDetail = _data["toUserDetail"] ? UserDetail.fromJS(_data["toUserDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WalletDetail {
        data = typeof data === 'object' ? data : {};
        let result = new WalletDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletDetailID"] = this.walletDetailID;
        data["walletID"] = this.walletID;
        data["invoiceID"] = this.invoiceID;
        data["amount"] = this.amount;
        data["fromUserDetailID"] = this.fromUserDetailID;
        data["toUserDetailID"] = this.toUserDetailID;
        data["detailDate"] = this.detailDate ? this.detailDate.toISOString() : <any>undefined;
        data["walletDetailStatusEnum"] = this.walletDetailStatusEnum;
        data["walletTransactionTypeEnum"] = this.walletTransactionTypeEnum;
        data["walletTransferID"] = this.walletTransferID;
        data["message"] = this.message;
        data["walletAPIReference"] = this.walletAPIReference;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["wallet"] = this.wallet ? this.wallet.toJSON() : <any>undefined;
        data["toUserDetailRelationshipID"] = this.toUserDetailRelationshipID;
        data["currencyEnum"] = this.currencyEnum;
        data["walletTypeEnum"] = this.walletTypeEnum;
        data["toUserFullName"] = this.toUserFullName;
        data["fromUserFullName"] = this.fromUserFullName;
        data["fromUserDetail"] = this.fromUserDetail ? this.fromUserDetail.toJSON() : <any>undefined;
        data["toUserDetail"] = this.toUserDetail ? this.toUserDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWalletDetail extends IEntityBase {
    walletDetailID: string;
    walletID: string;
    invoiceID?: string | undefined;
    amount: number;
    fromUserDetailID?: string | undefined;
    toUserDetailID?: string | undefined;
    detailDate: Date;
    walletDetailStatusEnum: WalletDetailStatusEnum;
    walletTransactionTypeEnum: WalletTransactionTypeEnum;
    walletTransferID?: string | undefined;
    message?: string | undefined;
    walletAPIReference?: string | undefined;
    invoice?: Invoice | undefined;
    wallet?: Wallet | undefined;
    toUserDetailRelationshipID?: string | undefined;
    currencyEnum?: CurrencyEnum | undefined;
    walletTypeEnum?: WalletTypeEnum | undefined;
    toUserFullName?: string | undefined;
    fromUserFullName?: string | undefined;
    fromUserDetail?: UserDetail | undefined;
    toUserDetail?: UserDetail | undefined;
}

export enum WalletDetailStatusEnum {
    Draft = "Draft",
    Paid = "Paid",
    Refunded = "Refunded",
}

export enum WalletTransactionTypeEnum {
    NotSet = "NotSet",
    FundWallet = "FundWallet",
    Purchase = "Purchase",
    SendFunds = "SendFunds",
    ReceivedFunds = "ReceivedFunds",
    Transfer = "Transfer",
    Refund = "Refund",
    Adjustment = "Adjustment",
    Withdrawal = "Withdrawal",
}

export class WalletsAggregatesDTO implements IWalletsAggregatesDTO {
    wallets?: Wallet[] | undefined;
    aggregates?: WalletsAggregates[] | undefined;

    constructor(data?: IWalletsAggregatesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["wallets"])) {
                this.wallets = [] as any;
                for (let item of _data["wallets"])
                    this.wallets!.push(Wallet.fromJS(item));
            }
            if (Array.isArray(_data["aggregates"])) {
                this.aggregates = [] as any;
                for (let item of _data["aggregates"])
                    this.aggregates!.push(WalletsAggregates.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WalletsAggregatesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WalletsAggregatesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.wallets)) {
            data["wallets"] = [];
            for (let item of this.wallets)
                data["wallets"].push(item.toJSON());
        }
        if (Array.isArray(this.aggregates)) {
            data["aggregates"] = [];
            for (let item of this.aggregates)
                data["aggregates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWalletsAggregatesDTO {
    wallets?: Wallet[] | undefined;
    aggregates?: WalletsAggregates[] | undefined;
}

export class WalletsAggregates implements IWalletsAggregates {
    currency?: CurrencyEnum;
    totalBalance?: number;
    totalSpending?: number;
    totalSaving?: number;

    constructor(data?: IWalletsAggregates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.totalBalance = _data["totalBalance"];
            this.totalSpending = _data["totalSpending"];
            this.totalSaving = _data["totalSaving"];
        }
    }

    static fromJS(data: any): WalletsAggregates {
        data = typeof data === 'object' ? data : {};
        let result = new WalletsAggregates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["totalBalance"] = this.totalBalance;
        data["totalSpending"] = this.totalSpending;
        data["totalSaving"] = this.totalSaving;
        return data;
    }
}

export interface IWalletsAggregates {
    currency?: CurrencyEnum;
    totalBalance?: number;
    totalSpending?: number;
    totalSaving?: number;
}

export class WalletTransferFundsResult implements IWalletTransferFundsResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IWalletTransferFundsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletTransferFundsResult {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferFundsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletTransferFundsResult {
    success?: boolean;
    message?: string | undefined;
}

export class WalletTransferFundsDetails implements IWalletTransferFundsDetails {
    fromWalletID?: string;
    toWalletID?: string;
    amount?: number;

    constructor(data?: IWalletTransferFundsDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromWalletID = _data["fromWalletID"];
            this.toWalletID = _data["toWalletID"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): WalletTransferFundsDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletTransferFundsDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromWalletID"] = this.fromWalletID;
        data["toWalletID"] = this.toWalletID;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IWalletTransferFundsDetails {
    fromWalletID?: string;
    toWalletID?: string;
    amount?: number;
}

export class WalletWithdrawFundsResult implements IWalletWithdrawFundsResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IWalletWithdrawFundsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletWithdrawFundsResult {
        data = typeof data === 'object' ? data : {};
        let result = new WalletWithdrawFundsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletWithdrawFundsResult {
    success?: boolean;
    message?: string | undefined;
}

export class WalletWithdrawFundsDetails implements IWalletWithdrawFundsDetails {
    fromWalletID?: string;
    patientBankID?: string;
    amount?: number;
    walletTransferID?: string;
    message?: string | undefined;

    constructor(data?: IWalletWithdrawFundsDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromWalletID = _data["fromWalletID"];
            this.patientBankID = _data["patientBankID"];
            this.amount = _data["amount"];
            this.walletTransferID = _data["walletTransferID"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletWithdrawFundsDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletWithdrawFundsDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromWalletID"] = this.fromWalletID;
        data["patientBankID"] = this.patientBankID;
        data["amount"] = this.amount;
        data["walletTransferID"] = this.walletTransferID;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletWithdrawFundsDetails {
    fromWalletID?: string;
    patientBankID?: string;
    amount?: number;
    walletTransferID?: string;
    message?: string | undefined;
}

export class WalletRefundResults implements IWalletRefundResults {
    message?: string | undefined;
    success?: boolean;

    constructor(data?: IWalletRefundResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): WalletRefundResults {
        data = typeof data === 'object' ? data : {};
        let result = new WalletRefundResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        return data;
    }
}

export interface IWalletRefundResults {
    message?: string | undefined;
    success?: boolean;
}

export class WalletRefundDetails implements IWalletRefundDetails {
    toUserDetailRelationshipID?: string | undefined;
    currencyEnum?: CurrencyEnum | undefined;
    invoiceID?: string;
    walletID?: string;

    constructor(data?: IWalletRefundDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toUserDetailRelationshipID = _data["toUserDetailRelationshipID"];
            this.currencyEnum = _data["currencyEnum"];
            this.invoiceID = _data["invoiceID"];
            this.walletID = _data["walletID"];
        }
    }

    static fromJS(data: any): WalletRefundDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletRefundDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toUserDetailRelationshipID"] = this.toUserDetailRelationshipID;
        data["currencyEnum"] = this.currencyEnum;
        data["invoiceID"] = this.invoiceID;
        data["walletID"] = this.walletID;
        return data;
    }
}

export interface IWalletRefundDetails {
    toUserDetailRelationshipID?: string | undefined;
    currencyEnum?: CurrencyEnum | undefined;
    invoiceID?: string;
    walletID?: string;
}

export class WalletPayeeDetailDTO implements IWalletPayeeDetailDTO {
    userDetailID?: string;
    fullName?: string | undefined;
    detailDate?: Date;
    amount?: number;
    currencyEnum?: CurrencyEnum;
    invoiceID?: string | undefined;
    walletTransactionTypeEnum?: WalletTransactionTypeEnum;

    constructor(data?: IWalletPayeeDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDetailID = _data["userDetailID"];
            this.fullName = _data["fullName"];
            this.detailDate = _data["detailDate"] ? new Date(_data["detailDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.currencyEnum = _data["currencyEnum"];
            this.invoiceID = _data["invoiceID"];
            this.walletTransactionTypeEnum = _data["walletTransactionTypeEnum"];
        }
    }

    static fromJS(data: any): WalletPayeeDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WalletPayeeDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDetailID"] = this.userDetailID;
        data["fullName"] = this.fullName;
        data["detailDate"] = this.detailDate ? this.detailDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["currencyEnum"] = this.currencyEnum;
        data["invoiceID"] = this.invoiceID;
        data["walletTransactionTypeEnum"] = this.walletTransactionTypeEnum;
        return data;
    }
}

export interface IWalletPayeeDetailDTO {
    userDetailID?: string;
    fullName?: string | undefined;
    detailDate?: Date;
    amount?: number;
    currencyEnum?: CurrencyEnum;
    invoiceID?: string | undefined;
    walletTransactionTypeEnum?: WalletTransactionTypeEnum;
}

export class WalletAdjustmentResult implements IWalletAdjustmentResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IWalletAdjustmentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WalletAdjustmentResult {
        data = typeof data === 'object' ? data : {};
        let result = new WalletAdjustmentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IWalletAdjustmentResult {
    success?: boolean;
    message?: string | undefined;
}

export class WalletUserSearchDetails implements IWalletUserSearchDetails {
    currencyEnum?: CurrencyEnum;
    startDate?: Date;
    endDate?: Date;
    includeZeroBalance?: boolean;

    constructor(data?: IWalletUserSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyEnum = _data["currencyEnum"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.includeZeroBalance = _data["includeZeroBalance"];
        }
    }

    static fromJS(data: any): WalletUserSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new WalletUserSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyEnum"] = this.currencyEnum;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["includeZeroBalance"] = this.includeZeroBalance;
        return data;
    }
}

export interface IWalletUserSearchDetails {
    currencyEnum?: CurrencyEnum;
    startDate?: Date;
    endDate?: Date;
    includeZeroBalance?: boolean;
}

export class WebflowItem implements IWebflowItem {
    _archived?: string | undefined;
    _draft?: string | undefined;
    color?: string | undefined;
    postingDate?: Date;
    name?: string | undefined;
    postBody?: string | undefined;
    postSummary?: string | undefined;
    slug?: string | undefined;
    mainImage?: WebflowImage | undefined;
    thumbnailImage?: WebflowImage | undefined;
    label2?: string | undefined;
    author2?: string | undefined;
    category2?: string[] | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    publishedOn?: Date | undefined;
    publishedBy?: string | undefined;
    _cid?: string | undefined;
    _id?: string | undefined;
    authorName?: string | undefined;

    constructor(data?: IWebflowItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._archived = _data["_archived"];
            this._draft = _data["_draft"];
            this.color = _data["color"];
            this.postingDate = _data["posting-date"] ? new Date(_data["posting-date"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.postBody = _data["post-body"];
            this.postSummary = _data["post-summary"];
            this.slug = _data["slug"];
            this.mainImage = _data["main-image"] ? WebflowImage.fromJS(_data["main-image"]) : <any>undefined;
            this.thumbnailImage = _data["thumbnail-image"] ? WebflowImage.fromJS(_data["thumbnail-image"]) : <any>undefined;
            this.label2 = _data["label-2"];
            this.author2 = _data["author-2"];
            if (Array.isArray(_data["category-2"])) {
                this.category2 = [] as any;
                for (let item of _data["category-2"])
                    this.category2!.push(item);
            }
            this.updatedOn = _data["updated-on"] ? new Date(_data["updated-on"].toString()) : <any>undefined;
            this.updatedBy = _data["updated-by"];
            this.createdOn = _data["created-on"] ? new Date(_data["created-on"].toString()) : <any>undefined;
            this.createdBy = _data["created-by"];
            this.publishedOn = _data["published-on"] ? new Date(_data["published-on"].toString()) : <any>undefined;
            this.publishedBy = _data["published-by"];
            this._cid = _data["_cid"];
            this._id = _data["_id"];
            this.authorName = _data["authorName"];
        }
    }

    static fromJS(data: any): WebflowItem {
        data = typeof data === 'object' ? data : {};
        let result = new WebflowItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_archived"] = this._archived;
        data["_draft"] = this._draft;
        data["color"] = this.color;
        data["posting-date"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["post-body"] = this.postBody;
        data["post-summary"] = this.postSummary;
        data["slug"] = this.slug;
        data["main-image"] = this.mainImage ? this.mainImage.toJSON() : <any>undefined;
        data["thumbnail-image"] = this.thumbnailImage ? this.thumbnailImage.toJSON() : <any>undefined;
        data["label-2"] = this.label2;
        data["author-2"] = this.author2;
        if (Array.isArray(this.category2)) {
            data["category-2"] = [];
            for (let item of this.category2)
                data["category-2"].push(item);
        }
        data["updated-on"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updated-by"] = this.updatedBy;
        data["created-on"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["created-by"] = this.createdBy;
        data["published-on"] = this.publishedOn ? this.publishedOn.toISOString() : <any>undefined;
        data["published-by"] = this.publishedBy;
        data["_cid"] = this._cid;
        data["_id"] = this._id;
        data["authorName"] = this.authorName;
        return data;
    }
}

export interface IWebflowItem {
    _archived?: string | undefined;
    _draft?: string | undefined;
    color?: string | undefined;
    postingDate?: Date;
    name?: string | undefined;
    postBody?: string | undefined;
    postSummary?: string | undefined;
    slug?: string | undefined;
    mainImage?: WebflowImage | undefined;
    thumbnailImage?: WebflowImage | undefined;
    label2?: string | undefined;
    author2?: string | undefined;
    category2?: string[] | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    publishedOn?: Date | undefined;
    publishedBy?: string | undefined;
    _cid?: string | undefined;
    _id?: string | undefined;
    authorName?: string | undefined;
}

export class WebflowImage implements IWebflowImage {
    fileId?: string | undefined;
    url?: string | undefined;
    alt?: string | undefined;

    constructor(data?: IWebflowImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.url = _data["url"];
            this.alt = _data["alt"];
        }
    }

    static fromJS(data: any): WebflowImage {
        data = typeof data === 'object' ? data : {};
        let result = new WebflowImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["url"] = this.url;
        data["alt"] = this.alt;
        return data;
    }
}

export interface IWebflowImage {
    fileId?: string | undefined;
    url?: string | undefined;
    alt?: string | undefined;
}

export class WebflowBlogItemsDTO implements IWebflowBlogItemsDTO {
    webflowItems?: WebflowItem[] | undefined;
    totalCount?: number | undefined;
    recordsToSkip?: number | undefined;
    recordsToTake?: number | undefined;

    constructor(data?: IWebflowBlogItemsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["webflowItems"])) {
                this.webflowItems = [] as any;
                for (let item of _data["webflowItems"])
                    this.webflowItems!.push(WebflowItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
        }
    }

    static fromJS(data: any): WebflowBlogItemsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WebflowBlogItemsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.webflowItems)) {
            data["webflowItems"] = [];
            for (let item of this.webflowItems)
                data["webflowItems"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        return data;
    }
}

export interface IWebflowBlogItemsDTO {
    webflowItems?: WebflowItem[] | undefined;
    totalCount?: number | undefined;
    recordsToSkip?: number | undefined;
    recordsToTake?: number | undefined;
}

export class WebflowAuthor implements IWebflowAuthor {
    _archived?: string | undefined;
    _draft?: string | undefined;
    slug?: string | undefined;
    name?: string | undefined;
    bioSummary?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    publishedOn?: Date;
    publishedBy?: string | undefined;
    _cid?: string | undefined;
    _id?: string | undefined;

    constructor(data?: IWebflowAuthor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this._archived = _data["_archived"];
            this._draft = _data["_draft"];
            this.slug = _data["slug"];
            this.name = _data["name"];
            this.bioSummary = _data["bio-summary"];
            this.updatedOn = _data["updated-on"] ? new Date(_data["updated-on"].toString()) : <any>undefined;
            this.updatedBy = _data["updated-by"];
            this.createdOn = _data["created-on"] ? new Date(_data["created-on"].toString()) : <any>undefined;
            this.createdBy = _data["created-by"];
            this.publishedOn = _data["published-on"] ? new Date(_data["published-on"].toString()) : <any>undefined;
            this.publishedBy = _data["published-by"];
            this._cid = _data["_cid"];
            this._id = _data["_id"];
        }
    }

    static fromJS(data: any): WebflowAuthor {
        data = typeof data === 'object' ? data : {};
        let result = new WebflowAuthor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_archived"] = this._archived;
        data["_draft"] = this._draft;
        data["slug"] = this.slug;
        data["name"] = this.name;
        data["bio-summary"] = this.bioSummary;
        data["updated-on"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        data["updated-by"] = this.updatedBy;
        data["created-on"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["created-by"] = this.createdBy;
        data["published-on"] = this.publishedOn ? this.publishedOn.toISOString() : <any>undefined;
        data["published-by"] = this.publishedBy;
        data["_cid"] = this._cid;
        data["_id"] = this._id;
        return data;
    }
}

export interface IWebflowAuthor {
    _archived?: string | undefined;
    _draft?: string | undefined;
    slug?: string | undefined;
    name?: string | undefined;
    bioSummary?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    publishedOn?: Date;
    publishedBy?: string | undefined;
    _cid?: string | undefined;
    _id?: string | undefined;
}

export class TermsAndCondition extends EntityBase implements ITermsAndCondition {
    termsAndConditionID!: string;
    name!: string;
    language!: string;
    value!: string;

    constructor(data?: ITermsAndCondition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.termsAndConditionID = _data["termsAndConditionID"];
            this.name = _data["name"];
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TermsAndCondition {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termsAndConditionID"] = this.termsAndConditionID;
        data["name"] = this.name;
        data["language"] = this.language;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface ITermsAndCondition extends IEntityBase {
    termsAndConditionID: string;
    name: string;
    language: string;
    value: string;
}

export class GenerateContractDetails implements IGenerateContractDetails {
    contractName?: string | undefined;
    providerOnboardingID?: string;

    constructor(data?: IGenerateContractDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractName = _data["contractName"];
            this.providerOnboardingID = _data["providerOnboardingID"];
        }
    }

    static fromJS(data: any): GenerateContractDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateContractDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractName"] = this.contractName;
        data["providerOnboardingID"] = this.providerOnboardingID;
        return data;
    }
}

export interface IGenerateContractDetails {
    contractName?: string | undefined;
    providerOnboardingID?: string;
}

export class University extends EntityBase implements IUniversity {
    universityID!: string;
    name!: string;
    code?: string | undefined;
    description?: string | undefined;
    website!: string;
    rank?: number;
    universityTypeEnum?: number;
    contactPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    countryID!: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    country?: Country | undefined;

    constructor(data?: IUniversity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.universityID = _data["universityID"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.website = _data["website"];
            this.rank = _data["rank"];
            this.universityTypeEnum = _data["universityTypeEnum"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.countryID = _data["countryID"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): University {
        data = typeof data === 'object' ? data : {};
        let result = new University();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityID"] = this.universityID;
        data["name"] = this.name;
        data["code"] = this.code;
        data["description"] = this.description;
        data["website"] = this.website;
        data["rank"] = this.rank;
        data["universityTypeEnum"] = this.universityTypeEnum;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["countryID"] = this.countryID;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUniversity extends IEntityBase {
    universityID: string;
    name: string;
    code?: string | undefined;
    description?: string | undefined;
    website: string;
    rank?: number;
    universityTypeEnum?: number;
    contactPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    countryID: string;
    latitude?: number | undefined;
    longitude?: number | undefined;
    country?: Country | undefined;
}

export class TagModel implements ITagModel {
    tagId?: string;
    name?: string | undefined;
    tagType?: TagTypeEnums;

    constructor(data?: ITagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.name = _data["name"];
            this.tagType = _data["tagType"];
        }
    }

    static fromJS(data: any): TagModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["name"] = this.name;
        data["tagType"] = this.tagType;
        return data;
    }
}

export interface ITagModel {
    tagId?: string;
    name?: string | undefined;
    tagType?: TagTypeEnums;
}

export enum TagTypeEnums {
    Condition = "Condition",
    Symptom = "Symptom",
    Treatment = "Treatment",
    SideEffect = "SideEffect",
    Provider = "Provider",
    Specialty = "Specialty",
    Surgery = "Surgery",
    CareFundCampaign = "CareFundCampaign",
    Livestream = "Livestream",
}

export class CreateTagPayload implements ICreateTagPayload {
    tagId?: string;
    name?: string | undefined;
    tagType?: TagTypeEnums;

    constructor(data?: ICreateTagPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.name = _data["name"];
            this.tagType = _data["tagType"];
        }
    }

    static fromJS(data: any): CreateTagPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["name"] = this.name;
        data["tagType"] = this.tagType;
        return data;
    }
}

export interface ICreateTagPayload {
    tagId?: string;
    name?: string | undefined;
    tagType?: TagTypeEnums;
}

export class CreateTagsPayload implements ICreateTagsPayload {
    tags?: CreateTagPayload[] | undefined;

    constructor(data?: ICreateTagsPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(CreateTagPayload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTagsPayload {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagsPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateTagsPayload {
    tags?: CreateTagPayload[] | undefined;
}

export class PaginatedOfTagModel implements IPaginatedOfTagModel {
    result?: TagModel[] | undefined;
    totalCount?: number;
    recordsToSkip?: number;
    recordsToTake?: number;

    constructor(data?: IPaginatedOfTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TagModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
        }
    }

    static fromJS(data: any): PaginatedOfTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedOfTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        return data;
    }
}

export interface IPaginatedOfTagModel {
    result?: TagModel[] | undefined;
    totalCount?: number;
    recordsToSkip?: number;
    recordsToTake?: number;
}

export class TagSearchModel implements ITagSearchModel {
    tag?: TagModel | undefined;
    sideEffects?: PaginatedOfTagModel | undefined;
    symptoms?: PaginatedOfTagModel | undefined;
    conditions?: PaginatedOfTagModel | undefined;
    providers?: PaginatedOfTagModel | undefined;
    treatments?: PaginatedOfTagModel | undefined;
    specialties?: PaginatedOfTagModel | undefined;
    surgeries?: PaginatedOfTagModel | undefined;
    careFundCampaigns?: PaginatedOfTagModel | undefined;
    livestreams?: PaginatedOfTagModel | undefined;
    blogs?: PaginatedOfTagModel | undefined;

    constructor(data?: ITagSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"] ? TagModel.fromJS(_data["tag"]) : <any>undefined;
            this.sideEffects = _data["sideEffects"] ? PaginatedOfTagModel.fromJS(_data["sideEffects"]) : <any>undefined;
            this.symptoms = _data["symptoms"] ? PaginatedOfTagModel.fromJS(_data["symptoms"]) : <any>undefined;
            this.conditions = _data["conditions"] ? PaginatedOfTagModel.fromJS(_data["conditions"]) : <any>undefined;
            this.providers = _data["providers"] ? PaginatedOfTagModel.fromJS(_data["providers"]) : <any>undefined;
            this.treatments = _data["treatments"] ? PaginatedOfTagModel.fromJS(_data["treatments"]) : <any>undefined;
            this.specialties = _data["specialties"] ? PaginatedOfTagModel.fromJS(_data["specialties"]) : <any>undefined;
            this.surgeries = _data["surgeries"] ? PaginatedOfTagModel.fromJS(_data["surgeries"]) : <any>undefined;
            this.careFundCampaigns = _data["careFundCampaigns"] ? PaginatedOfTagModel.fromJS(_data["careFundCampaigns"]) : <any>undefined;
            this.livestreams = _data["livestreams"] ? PaginatedOfTagModel.fromJS(_data["livestreams"]) : <any>undefined;
            this.blogs = _data["blogs"] ? PaginatedOfTagModel.fromJS(_data["blogs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TagSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["sideEffects"] = this.sideEffects ? this.sideEffects.toJSON() : <any>undefined;
        data["symptoms"] = this.symptoms ? this.symptoms.toJSON() : <any>undefined;
        data["conditions"] = this.conditions ? this.conditions.toJSON() : <any>undefined;
        data["providers"] = this.providers ? this.providers.toJSON() : <any>undefined;
        data["treatments"] = this.treatments ? this.treatments.toJSON() : <any>undefined;
        data["specialties"] = this.specialties ? this.specialties.toJSON() : <any>undefined;
        data["surgeries"] = this.surgeries ? this.surgeries.toJSON() : <any>undefined;
        data["careFundCampaigns"] = this.careFundCampaigns ? this.careFundCampaigns.toJSON() : <any>undefined;
        data["livestreams"] = this.livestreams ? this.livestreams.toJSON() : <any>undefined;
        data["blogs"] = this.blogs ? this.blogs.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITagSearchModel {
    tag?: TagModel | undefined;
    sideEffects?: PaginatedOfTagModel | undefined;
    symptoms?: PaginatedOfTagModel | undefined;
    conditions?: PaginatedOfTagModel | undefined;
    providers?: PaginatedOfTagModel | undefined;
    treatments?: PaginatedOfTagModel | undefined;
    specialties?: PaginatedOfTagModel | undefined;
    surgeries?: PaginatedOfTagModel | undefined;
    careFundCampaigns?: PaginatedOfTagModel | undefined;
    livestreams?: PaginatedOfTagModel | undefined;
    blogs?: PaginatedOfTagModel | undefined;
}

export class PaginatedOfTagCategoryModel implements IPaginatedOfTagCategoryModel {
    result?: TagCategoryModel[] | undefined;
    totalCount?: number;
    recordsToSkip?: number;
    recordsToTake?: number;

    constructor(data?: IPaginatedOfTagCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(TagCategoryModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
        }
    }

    static fromJS(data: any): PaginatedOfTagCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedOfTagCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        return data;
    }
}

export interface IPaginatedOfTagCategoryModel {
    result?: TagCategoryModel[] | undefined;
    totalCount?: number;
    recordsToSkip?: number;
    recordsToTake?: number;
}

export class TagCategoryModel implements ITagCategoryModel {
    categoryId?: string;
    name?: string | undefined;

    constructor(data?: ITagCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITagCategoryModel {
    categoryId?: string;
    name?: string | undefined;
}

export class PHRConsultDTO implements IPHRConsultDTO {
    consultDate?: Date;
    providerName?: string | undefined;
    consultReason?: string | undefined;
    consultTypeEnum?: ConsultTypeEnum;
    consultStatusEnum?: ConsultStatusEnum;

    constructor(data?: IPHRConsultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultDate = _data["consultDate"] ? new Date(_data["consultDate"].toString()) : <any>undefined;
            this.providerName = _data["providerName"];
            this.consultReason = _data["consultReason"];
            this.consultTypeEnum = _data["consultTypeEnum"];
            this.consultStatusEnum = _data["consultStatusEnum"];
        }
    }

    static fromJS(data: any): PHRConsultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRConsultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultDate"] = this.consultDate ? this.consultDate.toISOString() : <any>undefined;
        data["providerName"] = this.providerName;
        data["consultReason"] = this.consultReason;
        data["consultTypeEnum"] = this.consultTypeEnum;
        data["consultStatusEnum"] = this.consultStatusEnum;
        return data;
    }
}

export interface IPHRConsultDTO {
    consultDate?: Date;
    providerName?: string | undefined;
    consultReason?: string | undefined;
    consultTypeEnum?: ConsultTypeEnum;
    consultStatusEnum?: ConsultStatusEnum;
}

export class PHRPreviousConsultDetails implements IPHRPreviousConsultDetails {
    patientID?: string;
    previousThanConsultID?: string;
    take?: number;

    constructor(data?: IPHRPreviousConsultDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            this.previousThanConsultID = _data["previousThanConsultID"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): PHRPreviousConsultDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PHRPreviousConsultDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["previousThanConsultID"] = this.previousThanConsultID;
        data["take"] = this.take;
        return data;
    }
}

export interface IPHRPreviousConsultDetails {
    patientID?: string;
    previousThanConsultID?: string;
    take?: number;
}

export class PHRConsultSearchResults implements IPHRConsultSearchResults {
    phrConsults?: PHRConsult[] | undefined;
    runTime?: string;

    constructor(data?: IPHRConsultSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phrConsults"])) {
                this.phrConsults = [] as any;
                for (let item of _data["phrConsults"])
                    this.phrConsults!.push(PHRConsult.fromJS(item));
            }
            this.runTime = _data["runTime"];
        }
    }

    static fromJS(data: any): PHRConsultSearchResults {
        data = typeof data === 'object' ? data : {};
        let result = new PHRConsultSearchResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phrConsults)) {
            data["phrConsults"] = [];
            for (let item of this.phrConsults)
                data["phrConsults"].push(item.toJSON());
        }
        data["runTime"] = this.runTime;
        return data;
    }
}

export interface IPHRConsultSearchResults {
    phrConsults?: PHRConsult[] | undefined;
    runTime?: string;
}

export class PHRConsultSearchDetails implements IPHRConsultSearchDetails {
    startDate?: Date;
    endDate?: Date;
    providerID?: string;

    constructor(data?: IPHRConsultSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.providerID = _data["providerID"];
        }
    }

    static fromJS(data: any): PHRConsultSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PHRConsultSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["providerID"] = this.providerID;
        return data;
    }
}

export interface IPHRConsultSearchDetails {
    startDate?: Date;
    endDate?: Date;
    providerID?: string;
}

export class PHRDocumentUploadDetails implements IPHRDocumentUploadDetails {
    fileDetail?: FileDetail | undefined;
    patientID?: string;
    phrDocumentCategoryEnum?: PHRDocumentCategoryEnum;
    phrHealthJournalID?: string | undefined;
    associatedID?: string | undefined;
    phrConsultID?: string | undefined;
    documentTypeTagID?: string | undefined;

    constructor(data?: IPHRDocumentUploadDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileDetail = _data["fileDetail"] ? FileDetail.fromJS(_data["fileDetail"]) : <any>undefined;
            this.patientID = _data["patientID"];
            this.phrDocumentCategoryEnum = _data["phrDocumentCategoryEnum"];
            this.phrHealthJournalID = _data["phrHealthJournalID"];
            this.associatedID = _data["associatedID"];
            this.phrConsultID = _data["phrConsultID"];
            this.documentTypeTagID = _data["documentTypeTagID"];
        }
    }

    static fromJS(data: any): PHRDocumentUploadDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PHRDocumentUploadDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileDetail"] = this.fileDetail ? this.fileDetail.toJSON() : <any>undefined;
        data["patientID"] = this.patientID;
        data["phrDocumentCategoryEnum"] = this.phrDocumentCategoryEnum;
        data["phrHealthJournalID"] = this.phrHealthJournalID;
        data["associatedID"] = this.associatedID;
        data["phrConsultID"] = this.phrConsultID;
        data["documentTypeTagID"] = this.documentTypeTagID;
        return data;
    }
}

export interface IPHRDocumentUploadDetails {
    fileDetail?: FileDetail | undefined;
    patientID?: string;
    phrDocumentCategoryEnum?: PHRDocumentCategoryEnum;
    phrHealthJournalID?: string | undefined;
    associatedID?: string | undefined;
    phrConsultID?: string | undefined;
    documentTypeTagID?: string | undefined;
}

export class ScoreFormResult implements IScoreFormResult {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IScoreFormResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ScoreFormResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreFormResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IScoreFormResult {
    success?: boolean;
    message?: string | undefined;
}

export class PHRTrackerSearchDetails implements IPHRTrackerSearchDetails {
    patientID!: string;
    startDate!: Date;
    endDate!: Date;
    recordsToSkip?: number;
    recordsToTake?: number;

    constructor(data?: IPHRTrackerSearchDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientID = _data["patientID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.recordsToSkip = _data["recordsToSkip"];
            this.recordsToTake = _data["recordsToTake"];
        }
    }

    static fromJS(data: any): PHRTrackerSearchDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerSearchDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientID"] = this.patientID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["recordsToSkip"] = this.recordsToSkip;
        data["recordsToTake"] = this.recordsToTake;
        return data;
    }
}

export interface IPHRTrackerSearchDetails {
    patientID: string;
    startDate: Date;
    endDate: Date;
    recordsToSkip?: number;
    recordsToTake?: number;
}

export class PHRTrackerStepCounterDTO extends PHRTrackerBase implements IPHRTrackerStepCounterDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    stepCount?: number;

    constructor(data?: IPHRTrackerStepCounterDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.stepCount = _data["stepCount"];
        }
    }

    static fromJS(data: any): PHRTrackerStepCounterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerStepCounterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["stepCount"] = this.stepCount;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerStepCounterDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    stepCount?: number;
}

export class PHRTrackerHemoglobinDTO extends PHRTrackerBase implements IPHRTrackerHemoglobinDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    hemoglobin?: number;

    constructor(data?: IPHRTrackerHemoglobinDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.hemoglobin = _data["hemoglobin"];
        }
    }

    static fromJS(data: any): PHRTrackerHemoglobinDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerHemoglobinDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["hemoglobin"] = this.hemoglobin;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerHemoglobinDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    hemoglobin?: number;
}

export class PHRTrackerCholesterolDTO extends PHRTrackerBase implements IPHRTrackerCholesterolDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    cholesterol?: number;

    constructor(data?: IPHRTrackerCholesterolDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.cholesterol = _data["cholesterol"];
        }
    }

    static fromJS(data: any): PHRTrackerCholesterolDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerCholesterolDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["cholesterol"] = this.cholesterol;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerCholesterolDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    cholesterol?: number;
}

export class PHRTrackerUricAcidDTO extends PHRTrackerBase implements IPHRTrackerUricAcidDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    uricAcid?: number;

    constructor(data?: IPHRTrackerUricAcidDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.uricAcid = _data["uricAcid"];
        }
    }

    static fromJS(data: any): PHRTrackerUricAcidDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerUricAcidDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["uricAcid"] = this.uricAcid;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerUricAcidDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    uricAcid?: number;
}

export class PHRTrackerHCVDTO extends PHRTrackerBase implements IPHRTrackerHCVDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    hcv?: TrackerPositiveNegativeEnum;

    constructor(data?: IPHRTrackerHCVDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.hcv = _data["hcv"];
        }
    }

    static fromJS(data: any): PHRTrackerHCVDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerHCVDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["hcv"] = this.hcv;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerHCVDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    hcv?: TrackerPositiveNegativeEnum;
}

export enum TrackerPositiveNegativeEnum {
    Positive = "Positive",
    Negative = "Negative",
    Invalid = "Invalid",
}

export class PHRTrackerFetalDopplerDTO extends PHRTrackerBase implements IPHRTrackerFetalDopplerDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    heartRate?: number;

    constructor(data?: IPHRTrackerFetalDopplerDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.heartRate = _data["heartRate"];
        }
    }

    static fromJS(data: any): PHRTrackerFetalDopplerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerFetalDopplerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["heartRate"] = this.heartRate;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerFetalDopplerDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    heartRate?: number;
}

export class PHRTrackerRapidPregnancyDTO extends PHRTrackerBase implements IPHRTrackerRapidPregnancyDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    rapidPregnancy?: TrackerPositiveNegativeEnum;

    constructor(data?: IPHRTrackerRapidPregnancyDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.rapidPregnancy = _data["rapidPregnancy"];
        }
    }

    static fromJS(data: any): PHRTrackerRapidPregnancyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerRapidPregnancyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["rapidPregnancy"] = this.rapidPregnancy;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerRapidPregnancyDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    rapidPregnancy?: TrackerPositiveNegativeEnum;
}

export class PHRTrackerHIVDTO extends PHRTrackerBase implements IPHRTrackerHIVDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    hiv?: TrackerPositiveNegativeEnum;

    constructor(data?: IPHRTrackerHIVDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.hiv = _data["hiv"];
        }
    }

    static fromJS(data: any): PHRTrackerHIVDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerHIVDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["hiv"] = this.hiv;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerHIVDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    hiv?: TrackerPositiveNegativeEnum;
}

export class PHRTrackerTroponinDTO extends PHRTrackerBase implements IPHRTrackerTroponinDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    troponin?: TrackerPositiveNegativeEnum;

    constructor(data?: IPHRTrackerTroponinDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.troponin = _data["troponin"];
        }
    }

    static fromJS(data: any): PHRTrackerTroponinDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerTroponinDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["troponin"] = this.troponin;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerTroponinDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    troponin?: TrackerPositiveNegativeEnum;
}

export class PHRTrackerSyphilisDTO extends PHRTrackerBase implements IPHRTrackerSyphilisDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    syphilis?: TrackerPositiveNegativeEnum;

    constructor(data?: IPHRTrackerSyphilisDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.syphilis = _data["syphilis"];
        }
    }

    static fromJS(data: any): PHRTrackerSyphilisDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerSyphilisDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["syphilis"] = this.syphilis;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerSyphilisDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    syphilis?: TrackerPositiveNegativeEnum;
}

export class PHRTrackerChinkunguniaDTO extends PHRTrackerBase implements IPHRTrackerChinkunguniaDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    chikungunya?: TrackerPositiveNegativeEnum;

    constructor(data?: IPHRTrackerChinkunguniaDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.chikungunya = _data["chikungunya"];
        }
    }

    static fromJS(data: any): PHRTrackerChinkunguniaDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerChinkunguniaDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["chikungunya"] = this.chikungunya;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerChinkunguniaDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    chikungunya?: TrackerPositiveNegativeEnum;
}

export class PHRTrackerMalariaDTO extends PHRTrackerBase implements IPHRTrackerMalariaDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    malaria?: TrackerPositive1Positive2NegativeEnum;

    constructor(data?: IPHRTrackerMalariaDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.malaria = _data["malaria"];
        }
    }

    static fromJS(data: any): PHRTrackerMalariaDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerMalariaDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["malaria"] = this.malaria;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerMalariaDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    malaria?: TrackerPositive1Positive2NegativeEnum;
}

export enum TrackerPositive1Positive2NegativeEnum {
    Positive1 = "Positive1",
    Positive2 = "Positive2",
    Negative = "Negative",
    Invalid = "Invalid",
}

export class PHRTrackerTyphoidDTO extends PHRTrackerBase implements IPHRTrackerTyphoidDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    typhoid?: TrackerPositive1Positive2NegativeEnum;

    constructor(data?: IPHRTrackerTyphoidDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.typhoid = _data["typhoid"];
        }
    }

    static fromJS(data: any): PHRTrackerTyphoidDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerTyphoidDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["typhoid"] = this.typhoid;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerTyphoidDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    typhoid?: TrackerPositive1Positive2NegativeEnum;
}

export class PHRTrackerDengueDTO extends PHRTrackerBase implements IPHRTrackerDengueDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    dengue?: TrackerPositive1Positive2NegativeEnum;

    constructor(data?: IPHRTrackerDengueDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.dengue = _data["dengue"];
        }
    }

    static fromJS(data: any): PHRTrackerDengueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerDengueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["dengue"] = this.dengue;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerDengueDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    dengue?: TrackerPositive1Positive2NegativeEnum;
}

export class PHRTrackerWaistCircumferenceDTO extends PHRTrackerBase implements IPHRTrackerWaistCircumferenceDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    waistCircumference?: number;

    constructor(data?: IPHRTrackerWaistCircumferenceDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.waistCircumference = _data["waistCircumference"];
        }
    }

    static fromJS(data: any): PHRTrackerWaistCircumferenceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerWaistCircumferenceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["waistCircumference"] = this.waistCircumference;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerWaistCircumferenceDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    waistCircumference?: number;
}

export class PHRTrackerMoodDTO extends PHRTrackerBase implements IPHRTrackerMoodDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    moodValue?: number;

    constructor(data?: IPHRTrackerMoodDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.moodValue = _data["moodValue"];
        }
    }

    static fromJS(data: any): PHRTrackerMoodDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerMoodDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["moodValue"] = this.moodValue;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerMoodDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    moodValue?: number;
}

export class PHRTrackerStressDTO extends PHRTrackerBase implements IPHRTrackerStressDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    stressValue?: number;

    constructor(data?: IPHRTrackerStressDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.stressValue = _data["stressValue"];
        }
    }

    static fromJS(data: any): PHRTrackerStressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerStressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["stressValue"] = this.stressValue;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerStressDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    stressValue?: number;
}

export class PHRTrackerAnxietyDTO extends PHRTrackerBase implements IPHRTrackerAnxietyDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    anxietyValue?: number;

    constructor(data?: IPHRTrackerAnxietyDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.anxietyValue = _data["anxietyValue"];
        }
    }

    static fromJS(data: any): PHRTrackerAnxietyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerAnxietyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["anxietyValue"] = this.anxietyValue;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerAnxietyDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    anxietyValue?: number;
}

export class PHRTrackerExerciseDTO extends PHRTrackerBase implements IPHRTrackerExerciseDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    exerciseValue?: number;

    constructor(data?: IPHRTrackerExerciseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.exerciseValue = _data["exerciseValue"];
        }
    }

    static fromJS(data: any): PHRTrackerExerciseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerExerciseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["exerciseValue"] = this.exerciseValue;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerExerciseDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    exerciseValue?: number;
}

export class PHRTrackerSleepDTO extends PHRTrackerBase implements IPHRTrackerSleepDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    sleepValue?: number;

    constructor(data?: IPHRTrackerSleepDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.sleepValue = _data["sleepValue"];
        }
    }

    static fromJS(data: any): PHRTrackerSleepDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerSleepDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["sleepValue"] = this.sleepValue;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerSleepDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    sleepValue?: number;
}

export class PHRTrackerCovidDTO extends PHRTrackerBase implements IPHRTrackerCovidDTO {
    trackerTypeEnum?: TrackerTypeEnum;
    testResult?: boolean;
    city?: string | undefined;
    countryID?: string;
    testType?: string | undefined;
    covidTestTypeTagID?: string;
    covidTestTypeTag?: Tag | undefined;
    covidTestBrandTypeTagID?: string;
    covidTestBrandTypeTag?: Tag | undefined;
    serialNumber?: string | undefined;
    passport?: string | undefined;

    constructor(data?: IPHRTrackerCovidDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerTypeEnum = _data["trackerTypeEnum"];
            this.testResult = _data["testResult"];
            this.city = _data["city"];
            this.countryID = _data["countryID"];
            this.testType = _data["testType"];
            this.covidTestTypeTagID = _data["covidTestTypeTagID"];
            this.covidTestTypeTag = _data["covidTestTypeTag"] ? Tag.fromJS(_data["covidTestTypeTag"]) : <any>undefined;
            this.covidTestBrandTypeTagID = _data["covidTestBrandTypeTagID"];
            this.covidTestBrandTypeTag = _data["covidTestBrandTypeTag"] ? Tag.fromJS(_data["covidTestBrandTypeTag"]) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.passport = _data["passport"];
        }
    }

    static fromJS(data: any): PHRTrackerCovidDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PHRTrackerCovidDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerTypeEnum"] = this.trackerTypeEnum;
        data["testResult"] = this.testResult;
        data["city"] = this.city;
        data["countryID"] = this.countryID;
        data["testType"] = this.testType;
        data["covidTestTypeTagID"] = this.covidTestTypeTagID;
        data["covidTestTypeTag"] = this.covidTestTypeTag ? this.covidTestTypeTag.toJSON() : <any>undefined;
        data["covidTestBrandTypeTagID"] = this.covidTestBrandTypeTagID;
        data["covidTestBrandTypeTag"] = this.covidTestBrandTypeTag ? this.covidTestBrandTypeTag.toJSON() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["passport"] = this.passport;
        super.toJSON(data);
        return data;
    }
}

export interface IPHRTrackerCovidDTO extends IPHRTrackerBase {
    trackerTypeEnum?: TrackerTypeEnum;
    testResult?: boolean;
    city?: string | undefined;
    countryID?: string;
    testType?: string | undefined;
    covidTestTypeTagID?: string;
    covidTestTypeTag?: Tag | undefined;
    covidTestBrandTypeTagID?: string;
    covidTestBrandTypeTag?: Tag | undefined;
    serialNumber?: string | undefined;
    passport?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}